var JE = Object.defineProperty;
var eP = (e, t, r) => t in e ? JE(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r;
var fe = (e, t, r) => (eP(e, typeof t != "symbol" ? t + "" : t, r), r);
import * as Sr from "react";
import B, { createContext as A1, useState as De, useEffect as Ie, useContext as xt, useRef as ge, useId as E7, useLayoutEffect as sC, useMemo as dr, useReducer as tP, Fragment as rP, isValidElement as Vr, Children as K1, PureComponent as Cr, forwardRef as lC, useImperativeHandle as nP, useCallback as aP, cloneElement as Bt, createElement as cC, Component as uC } from "react";
import P7, { unstable_batchedUpdates as iP } from "react-dom";
var $i = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function qe(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function oP(e) {
  if (e.__esModule)
    return e;
  var t = e.default;
  if (typeof t == "function") {
    var r = function n() {
      return this instanceof n ? Reflect.construct(t, arguments, this.constructor) : t.apply(this, arguments);
    };
    r.prototype = t.prototype;
  } else
    r = {};
  return Object.defineProperty(r, "__esModule", { value: !0 }), Object.keys(e).forEach(function(n) {
    var a = Object.getOwnPropertyDescriptor(e, n);
    Object.defineProperty(r, n, a.get ? a : {
      enumerable: !0,
      get: function() {
        return e[n];
      }
    });
  }), r;
}
var I4 = { exports: {} }, ui = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Jf;
function sP() {
  if (Jf)
    return ui;
  Jf = 1;
  var e = B, t = Symbol.for("react.element"), r = Symbol.for("react.fragment"), n = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, i = { key: !0, ref: !0, __self: !0, __source: !0 };
  function o(s, c, u) {
    var d, h = {}, A = null, p = null;
    u !== void 0 && (A = "" + u), c.key !== void 0 && (A = "" + c.key), c.ref !== void 0 && (p = c.ref);
    for (d in c)
      n.call(c, d) && !i.hasOwnProperty(d) && (h[d] = c[d]);
    if (s && s.defaultProps)
      for (d in c = s.defaultProps, c)
        h[d] === void 0 && (h[d] = c[d]);
    return { $$typeof: t, type: s, key: A, ref: p, props: h, _owner: a.current };
  }
  return ui.Fragment = r, ui.jsx = o, ui.jsxs = o, ui;
}
var fi = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ed;
function lP() {
  return ed || (ed = 1, process.env.NODE_ENV !== "production" && function() {
    var e = B, t = Symbol.for("react.element"), r = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), o = Symbol.for("react.provider"), s = Symbol.for("react.context"), c = Symbol.for("react.forward_ref"), u = Symbol.for("react.suspense"), d = Symbol.for("react.suspense_list"), h = Symbol.for("react.memo"), A = Symbol.for("react.lazy"), p = Symbol.for("react.offscreen"), m = Symbol.iterator, g = "@@iterator";
    function v(G) {
      if (G === null || typeof G != "object")
        return null;
      var oe = m && G[m] || G[g];
      return typeof oe == "function" ? oe : null;
    }
    var C = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(G) {
      {
        for (var oe = arguments.length, ue = new Array(oe > 1 ? oe - 1 : 0), xe = 1; xe < oe; xe++)
          ue[xe - 1] = arguments[xe];
        w("error", G, ue);
      }
    }
    function w(G, oe, ue) {
      {
        var xe = C.ReactDebugCurrentFrame, Re = xe.getStackAddendum();
        Re !== "" && (oe += "%s", ue = ue.concat([Re]));
        var Ge = ue.map(function(_e) {
          return String(_e);
        });
        Ge.unshift("Warning: " + oe), Function.prototype.apply.call(console[G], console, Ge);
      }
    }
    var O = !1, b = !1, D = !1, M = !1, j = !1, P;
    P = Symbol.for("react.module.reference");
    function H(G) {
      return !!(typeof G == "string" || typeof G == "function" || G === n || G === i || j || G === a || G === u || G === d || M || G === p || O || b || D || typeof G == "object" && G !== null && (G.$$typeof === A || G.$$typeof === h || G.$$typeof === o || G.$$typeof === s || G.$$typeof === c || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      G.$$typeof === P || G.getModuleId !== void 0));
    }
    function F(G, oe, ue) {
      var xe = G.displayName;
      if (xe)
        return xe;
      var Re = oe.displayName || oe.name || "";
      return Re !== "" ? ue + "(" + Re + ")" : ue;
    }
    function R(G) {
      return G.displayName || "Context";
    }
    function N(G) {
      if (G == null)
        return null;
      if (typeof G.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof G == "function")
        return G.displayName || G.name || null;
      if (typeof G == "string")
        return G;
      switch (G) {
        case n:
          return "Fragment";
        case r:
          return "Portal";
        case i:
          return "Profiler";
        case a:
          return "StrictMode";
        case u:
          return "Suspense";
        case d:
          return "SuspenseList";
      }
      if (typeof G == "object")
        switch (G.$$typeof) {
          case s:
            var oe = G;
            return R(oe) + ".Consumer";
          case o:
            var ue = G;
            return R(ue._context) + ".Provider";
          case c:
            return F(G, G.render, "ForwardRef");
          case h:
            var xe = G.displayName || null;
            return xe !== null ? xe : N(G.type) || "Memo";
          case A: {
            var Re = G, Ge = Re._payload, _e = Re._init;
            try {
              return N(_e(Ge));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var z = Object.assign, q = 0, J, W, te, S, I, T, E;
    function x() {
    }
    x.__reactDisabledLog = !0;
    function $() {
      {
        if (q === 0) {
          J = console.log, W = console.info, te = console.warn, S = console.error, I = console.group, T = console.groupCollapsed, E = console.groupEnd;
          var G = {
            configurable: !0,
            enumerable: !0,
            value: x,
            writable: !0
          };
          Object.defineProperties(console, {
            info: G,
            log: G,
            warn: G,
            error: G,
            group: G,
            groupCollapsed: G,
            groupEnd: G
          });
        }
        q++;
      }
    }
    function _() {
      {
        if (q--, q === 0) {
          var G = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: z({}, G, {
              value: J
            }),
            info: z({}, G, {
              value: W
            }),
            warn: z({}, G, {
              value: te
            }),
            error: z({}, G, {
              value: S
            }),
            group: z({}, G, {
              value: I
            }),
            groupCollapsed: z({}, G, {
              value: T
            }),
            groupEnd: z({}, G, {
              value: E
            })
          });
        }
        q < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Q = C.ReactCurrentDispatcher, Z;
    function X(G, oe, ue) {
      {
        if (Z === void 0)
          try {
            throw Error();
          } catch (Re) {
            var xe = Re.stack.trim().match(/\n( *(at )?)/);
            Z = xe && xe[1] || "";
          }
        return `
` + Z + G;
      }
    }
    var Y = !1, U;
    {
      var k = typeof WeakMap == "function" ? WeakMap : Map;
      U = new k();
    }
    function L(G, oe) {
      if (!G || Y)
        return "";
      {
        var ue = U.get(G);
        if (ue !== void 0)
          return ue;
      }
      var xe;
      Y = !0;
      var Re = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var Ge;
      Ge = Q.current, Q.current = null, $();
      try {
        if (oe) {
          var _e = function() {
            throw Error();
          };
          if (Object.defineProperty(_e.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(_e, []);
            } catch (lr) {
              xe = lr;
            }
            Reflect.construct(G, [], _e);
          } else {
            try {
              _e.call();
            } catch (lr) {
              xe = lr;
            }
            G.call(_e.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (lr) {
            xe = lr;
          }
          G();
        }
      } catch (lr) {
        if (lr && xe && typeof lr.stack == "string") {
          for (var Be = lr.stack.split(`
`), jt = xe.stack.split(`
`), dt = Be.length - 1, mt = jt.length - 1; dt >= 1 && mt >= 0 && Be[dt] !== jt[mt]; )
            mt--;
          for (; dt >= 1 && mt >= 0; dt--, mt--)
            if (Be[dt] !== jt[mt]) {
              if (dt !== 1 || mt !== 1)
                do
                  if (dt--, mt--, mt < 0 || Be[dt] !== jt[mt]) {
                    var Wt = `
` + Be[dt].replace(" at new ", " at ");
                    return G.displayName && Wt.includes("<anonymous>") && (Wt = Wt.replace("<anonymous>", G.displayName)), typeof G == "function" && U.set(G, Wt), Wt;
                  }
                while (dt >= 1 && mt >= 0);
              break;
            }
        }
      } finally {
        Y = !1, Q.current = Ge, _(), Error.prepareStackTrace = Re;
      }
      var Jr = G ? G.displayName || G.name : "", Oa = Jr ? X(Jr) : "";
      return typeof G == "function" && U.set(G, Oa), Oa;
    }
    function ee(G, oe, ue) {
      return L(G, !1);
    }
    function V(G) {
      var oe = G.prototype;
      return !!(oe && oe.isReactComponent);
    }
    function ne(G, oe, ue) {
      if (G == null)
        return "";
      if (typeof G == "function")
        return L(G, V(G));
      if (typeof G == "string")
        return X(G);
      switch (G) {
        case u:
          return X("Suspense");
        case d:
          return X("SuspenseList");
      }
      if (typeof G == "object")
        switch (G.$$typeof) {
          case c:
            return ee(G.render);
          case h:
            return ne(G.type, oe, ue);
          case A: {
            var xe = G, Re = xe._payload, Ge = xe._init;
            try {
              return ne(Ge(Re), oe, ue);
            } catch {
            }
          }
        }
      return "";
    }
    var ie = Object.prototype.hasOwnProperty, le = {}, de = C.ReactDebugCurrentFrame;
    function ve(G) {
      if (G) {
        var oe = G._owner, ue = ne(G.type, G._source, oe ? oe.type : null);
        de.setExtraStackFrame(ue);
      } else
        de.setExtraStackFrame(null);
    }
    function Ee(G, oe, ue, xe, Re) {
      {
        var Ge = Function.call.bind(ie);
        for (var _e in G)
          if (Ge(G, _e)) {
            var Be = void 0;
            try {
              if (typeof G[_e] != "function") {
                var jt = Error((xe || "React class") + ": " + ue + " type `" + _e + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof G[_e] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw jt.name = "Invariant Violation", jt;
              }
              Be = G[_e](oe, _e, xe, ue, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (dt) {
              Be = dt;
            }
            Be && !(Be instanceof Error) && (ve(Re), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", xe || "React class", ue, _e, typeof Be), ve(null)), Be instanceof Error && !(Be.message in le) && (le[Be.message] = !0, ve(Re), y("Failed %s type: %s", ue, Be.message), ve(null));
          }
      }
    }
    var Ne = Array.isArray;
    function je(G) {
      return Ne(G);
    }
    function $e(G) {
      {
        var oe = typeof Symbol == "function" && Symbol.toStringTag, ue = oe && G[Symbol.toStringTag] || G.constructor.name || "Object";
        return ue;
      }
    }
    function ft(G) {
      try {
        return yt(G), !1;
      } catch {
        return !0;
      }
    }
    function yt(G) {
      return "" + G;
    }
    function sr(G) {
      if (ft(G))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", $e(G)), yt(G);
    }
    var zt = C.ReactCurrentOwner, Z2 = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, va, ga, x1;
    x1 = {};
    function z2(G) {
      if (ie.call(G, "ref")) {
        var oe = Object.getOwnPropertyDescriptor(G, "ref").get;
        if (oe && oe.isReactWarning)
          return !1;
      }
      return G.ref !== void 0;
    }
    function K2(G) {
      if (ie.call(G, "key")) {
        var oe = Object.getOwnPropertyDescriptor(G, "key").get;
        if (oe && oe.isReactWarning)
          return !1;
      }
      return G.key !== void 0;
    }
    function q2(G, oe) {
      if (typeof G.ref == "string" && zt.current && oe && zt.current.stateNode !== oe) {
        var ue = N(zt.current.type);
        x1[ue] || (y('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', N(zt.current.type), G.ref), x1[ue] = !0);
      }
    }
    function X2(G, oe) {
      {
        var ue = function() {
          va || (va = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", oe));
        };
        ue.isReactWarning = !0, Object.defineProperty(G, "key", {
          get: ue,
          configurable: !0
        });
      }
    }
    function J2(G, oe) {
      {
        var ue = function() {
          ga || (ga = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", oe));
        };
        ue.isReactWarning = !0, Object.defineProperty(G, "ref", {
          get: ue,
          configurable: !0
        });
      }
    }
    var ei = function(G, oe, ue, xe, Re, Ge, _e) {
      var Be = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: t,
        // Built-in properties that belong on the element
        type: G,
        key: oe,
        ref: ue,
        props: _e,
        // Record the component responsible for creating this element.
        _owner: Ge
      };
      return Be._store = {}, Object.defineProperty(Be._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(Be, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: xe
      }), Object.defineProperty(Be, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: Re
      }), Object.freeze && (Object.freeze(Be.props), Object.freeze(Be)), Be;
    };
    function ti(G, oe, ue, xe, Re) {
      {
        var Ge, _e = {}, Be = null, jt = null;
        ue !== void 0 && (sr(ue), Be = "" + ue), K2(oe) && (sr(oe.key), Be = "" + oe.key), z2(oe) && (jt = oe.ref, q2(oe, Re));
        for (Ge in oe)
          ie.call(oe, Ge) && !Z2.hasOwnProperty(Ge) && (_e[Ge] = oe[Ge]);
        if (G && G.defaultProps) {
          var dt = G.defaultProps;
          for (Ge in dt)
            _e[Ge] === void 0 && (_e[Ge] = dt[Ge]);
        }
        if (Be || jt) {
          var mt = typeof G == "function" ? G.displayName || G.name || "Unknown" : G;
          Be && X2(_e, mt), jt && J2(_e, mt);
        }
        return ei(G, Be, jt, Re, xe, zt.current, _e);
      }
    }
    var O1 = C.ReactCurrentOwner, ma = C.ReactDebugCurrentFrame;
    function Xr(G) {
      if (G) {
        var oe = G._owner, ue = ne(G.type, G._source, oe ? oe.type : null);
        ma.setExtraStackFrame(ue);
      } else
        ma.setExtraStackFrame(null);
    }
    var D1;
    D1 = !1;
    function M1(G) {
      return typeof G == "object" && G !== null && G.$$typeof === t;
    }
    function Ca() {
      {
        if (O1.current) {
          var G = N(O1.current.type);
          if (G)
            return `

Check the render method of \`` + G + "`.";
        }
        return "";
      }
    }
    function ri(G) {
      {
        if (G !== void 0) {
          var oe = G.fileName.replace(/^.*[\\\/]/, ""), ue = G.lineNumber;
          return `

Check your code at ` + oe + ":" + ue + ".";
        }
        return "";
      }
    }
    var ba = {};
    function ni(G) {
      {
        var oe = Ca();
        if (!oe) {
          var ue = typeof G == "string" ? G : G.displayName || G.name;
          ue && (oe = `

Check the top-level render call using <` + ue + ">.");
        }
        return oe;
      }
    }
    function ya(G, oe) {
      {
        if (!G._store || G._store.validated || G.key != null)
          return;
        G._store.validated = !0;
        var ue = ni(oe);
        if (ba[ue])
          return;
        ba[ue] = !0;
        var xe = "";
        G && G._owner && G._owner !== O1.current && (xe = " It was passed a child from " + N(G._owner.type) + "."), Xr(G), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', ue, xe), Xr(null);
      }
    }
    function wa(G, oe) {
      {
        if (typeof G != "object")
          return;
        if (je(G))
          for (var ue = 0; ue < G.length; ue++) {
            var xe = G[ue];
            M1(xe) && ya(xe, oe);
          }
        else if (M1(G))
          G._store && (G._store.validated = !0);
        else if (G) {
          var Re = v(G);
          if (typeof Re == "function" && Re !== G.entries)
            for (var Ge = Re.call(G), _e; !(_e = Ge.next()).done; )
              M1(_e.value) && ya(_e.value, oe);
        }
      }
    }
    function ai(G) {
      {
        var oe = G.type;
        if (oe == null || typeof oe == "string")
          return;
        var ue;
        if (typeof oe == "function")
          ue = oe.propTypes;
        else if (typeof oe == "object" && (oe.$$typeof === c || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        oe.$$typeof === h))
          ue = oe.propTypes;
        else
          return;
        if (ue) {
          var xe = N(oe);
          Ee(ue, G.props, "prop", xe, G);
        } else if (oe.PropTypes !== void 0 && !D1) {
          D1 = !0;
          var Re = N(oe);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", Re || "Unknown");
        }
        typeof oe.getDefaultProps == "function" && !oe.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function ii(G) {
      {
        for (var oe = Object.keys(G.props), ue = 0; ue < oe.length; ue++) {
          var xe = oe[ue];
          if (xe !== "children" && xe !== "key") {
            Xr(G), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", xe), Xr(null);
            break;
          }
        }
        G.ref !== null && (Xr(G), y("Invalid attribute `ref` supplied to `React.Fragment`."), Xr(null));
      }
    }
    function xa(G, oe, ue, xe, Re, Ge) {
      {
        var _e = H(G);
        if (!_e) {
          var Be = "";
          (G === void 0 || typeof G == "object" && G !== null && Object.keys(G).length === 0) && (Be += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var jt = ri(Re);
          jt ? Be += jt : Be += Ca();
          var dt;
          G === null ? dt = "null" : je(G) ? dt = "array" : G !== void 0 && G.$$typeof === t ? (dt = "<" + (N(G.type) || "Unknown") + " />", Be = " Did you accidentally export a JSX literal instead of a component?") : dt = typeof G, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", dt, Be);
        }
        var mt = ti(G, oe, ue, Re, Ge);
        if (mt == null)
          return mt;
        if (_e) {
          var Wt = oe.children;
          if (Wt !== void 0)
            if (xe)
              if (je(Wt)) {
                for (var Jr = 0; Jr < Wt.length; Jr++)
                  wa(Wt[Jr], G);
                Object.freeze && Object.freeze(Wt);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              wa(Wt, G);
        }
        return G === n ? ii(mt) : ai(mt), mt;
      }
    }
    function oi(G, oe, ue) {
      return xa(G, oe, ue, !0);
    }
    function si(G, oe, ue) {
      return xa(G, oe, ue, !1);
    }
    var li = si, ci = oi;
    fi.Fragment = n, fi.jsx = li, fi.jsxs = ci;
  }()), fi;
}
process.env.NODE_ENV === "production" ? I4.exports = sP() : I4.exports = lP();
var f = I4.exports;
const Qa = B.forwardRef((e, t) => {
  const {
    image: r,
    size: n = "sm"
  } = e, a = {
    xs: "h-[24px] w-[24px] min-w-[24px]",
    sm: "h-[28px] w-[28px] min-w-[28px]",
    md: "h-[150px] w-[150px] min-w-[150px] m-10"
  };
  return /* @__PURE__ */ f.jsx("div", { ref: t, className: `${a[n]} flex items-center justify-center aspect-square rounded-full bg-secondary-200 border border-white overflow-hidden `, children: r.length > 2 ? /* @__PURE__ */ f.jsx(
    "img",
    {
      src: r,
      className: "h-full w-full object-cover bg-secondary-200 text-secondary-100",
      alt: ""
    }
  ) : r.length === 2 ? /* @__PURE__ */ f.jsx("span", { className: "text-secondary-500 font-bold leading-none text-xs", children: r }) : null });
});
Qa.displayName = "Avatar";
const cP = {
  light: "300",
  normal: "normal",
  medium: "500",
  semibold: "600",
  bold: "700",
  black: "900"
}, fC = {
  DEFAULT: "0.25rem",
  0: "0",
  xs: "0.25rem",
  md: "0.5rem",
  lg: "1rem",
  xl: "2rem",
  full: "100%"
}, gt = {
  "Marca-900": "#205591",
  "Marca-800": "#2874b4",
  "Marca-700": "#2b85c8",
  "Marca-600": "#3098dc",
  "Marca-500": "#34a6eb",
  "Marca-400": "#42b3ee",
  "Marca-300": "#5cc0f1",
  "Marca-200": "#86d2f6",
  "Marca-100": "#b5e4fa",
  "Marca-50": "#e2f5fd",
  "Acento-900": "#b23b29",
  "Acento-800": "#c24333",
  "Acento-700": "#cf4939",
  "Acento-600": "#e2523f",
  "Acento-500": "#ef5a40",
  "Acento-400": "#ec6658",
  "Acento-300": "#e2807a",
  "Acento-200": "#eca29f",
  "Acento-100": "#fdd2d4",
  "Acento-50": "#feedef",
  "Neutros-900": "#141a22",
  "Neutros-800": "#343a43",
  "Neutros-700": "#525962",
  "Neutros-600": "#666c76",
  "Neutros-500": "#8d949f",
  "Neutros-400": "#adb4bf",
  "Neutros-300": "#d1d8e4",
  "Neutros-200": "#e1e9f4",
  "Neutros-100": "#ebf2fe",
  "Neutros-50": "#f2f9ff",
  "Activos-900": "#005d00",
  "Activos-800": "#217c17",
  "Activos-700": "#2e8c22",
  "Activos-600": "#3a9e2e",
  "Activos-500": "#44ad36",
  "Activos-400": "#61b956",
  "Activos-300": "#7dc674",
  "Activos-200": "#a3d59c",
  "Activos-100": "#c7e5c3",
  "Activos-50": "#e8f5e6",
  "Error-900": "#b00020",
  "Error-800": "#bf152c",
  "Error-700": "#cc1d33",
  "Error-600": "#de2839",
  "Error-500": "#ed323b",
  "Error-400": "#e84853",
  "Error-300": "#de6c74",
  "Error-200": "#ea959b",
  "Error-100": "#fbcad2",
  "Error-50": "#fdeaee",
  "Información-900": "#194185",
  "Información-800": "#245da4",
  "Información-700": "#2b6eb6",
  "Información-600": "#337fc8",
  "Información-500": "#398cd5",
  "Información-400": "#509cdb",
  "Información-300": "#6bade0",
  "Información-200": "#92c4ea",
  "Información-100": "#bbdaf2",
  "Información-50": "#e3f0f9",
  "Negros-900": "#000000",
  "Negros-800": "#262626",
  "Negros-700": "#434343",
  "Negros-600": "#555555",
  "Negros-500": "#7b7b7b",
  "Negros-400": "#9d9d9d",
  "Negros-300": "#C4C4C4",
  "Negros-200": "#D9D9D9",
  "Negros-100": "#e9e9e9",
  "Negros-50": "#f5f5f5",
  "yellow-900": "#FEED01",
  "opacity-30": "#2055914D",
  "approved-200": "#12B76A",
  "pending-200": "#FF0000",
  "status-100": "#FEED01",
  transparent: "rgba(255, 255, 255, 0.08)",
  DEFAULT: "#E6E6E6",
  white: "#FFFFFF",
  "neutral-100": "#FFFFFF",
  "neutral-200": "#F5F5F5",
  "neutral-300": "#E6E6E6",
  "neutral-400": "#A3A3A3",
  "neutral-500": "#525252",
  "neutral-600": "#292929",
  "primary-100": "#FEF2F0",
  "primary-200": "#FDE5E1",
  "primary-300": "#FCD8D1",
  "primary-400": "#FBCBC2",
  "primary-500": "#F3765F",
  "primary-600": "#F15C41",
  "primary-700": "#CE4D37",
  "primary-800": "#A53C2B",
  "primary-850": "#7B2A1F",
  "primary-900": "#521913",
  "primary-950": "#280706",
  "secondary-100": "#EEF4F9",
  "secondary-200": "#DDE9F3",
  "secondary-300": "#CBDEED",
  "secondary-400": "#BAD3E7",
  "secondary-500": "#4A8BC0",
  "secondary-600": "#2875B4",
  "secondary-700": "#22629B",
  "secondary-800": "#165892",
  "secondary-850": "#104D85;",
  "secondary-900": "#0A4379",
  "secondary-950": "#03386C",
  "accent-100": "#FDEEF3",
  "accent-200": "#FBDEE7",
  "accent-300": "#F9CDDB",
  "accent-400": "#F7BCD0",
  "accent-500": "#E94F83",
  "accent-600": "#E52E6B",
  "accent-700": "#C4275B",
  "accent-800": "#9D1E47",
  "accent-850": "#761534",
  "accent-900": "#4F0C21",
  "accent-950": "#27040E",
  "info-50": "#EEF5FD",
  "info-100": "#DEEBFB",
  "info-200": "#CDE1F9",
  "info-300": "#BCD7F7",
  "info-400": "#4F96E9",
  "info-500": "#2E82E5",
  "info-600": "#276EC4",
  "info-700": "#0F2D59",
  "info-800": "#0B2348",
  "info-900": "#071938",
  "info-950": "#040F27",
  "success-50": "#EEFBF1",
  "success-100": "#DDF7E2",
  "success-200": "#CCF3D4",
  "success-300": "#BAEFC6",
  "success-400": "#4BD469",
  "success-500": "#29CC4D",
  "success-600": "#22AF42",
  "success-700": "#0D5120",
  "success-800": "#0A421B",
  "success-900": "#073415",
  "success-950": "#032510",
  "warning-50": "#FDF7EE",
  "warning-100": "#FBEFDE",
  "warning-200": "#F9E7CD",
  "warning-300": "#F7DFBC",
  "warning-400": "#E9AC4F",
  "warning-500": "#E59C2E",
  "warning-600": "#C48427",
  "warning-700": "#59350F",
  "warning-800": "#48290B",
  "warning-900": "#381C07",
  "warning-950": "#271004",
  "error-50": "#FDEEEE",
  "error-100": "#FBDEDE",
  "error-200": "#F9CDCD",
  "error-300": "#F7BCBC",
  "error-400": "#E94F4F",
  "error-500": "#E52E2E",
  "error-600": "#C42727",
  "error-700": "#590F10",
  "error-800": "#480B0C",
  "error-900": "#380709",
  "error-950": "#270405"
}, uP = B.forwardRef((e, t) => {
  const {
    mb: r,
    mt: n,
    bg: a,
    color: i,
    rounded: o,
    isHidden: s,
    spacing: c,
    spacingX: u,
    spacingY: d,
    spacingTop: h,
    spacingBottom: A,
    textAlign: p,
    border: m,
    borderTop: g,
    borderBottom: v,
    borderColor: C,
    borderStart: y,
    // Nueva propiedad
    children: w,
    className: O,
    ...b
  } = e, D = {
    textAlign: p,
    marginBottom: r !== void 0 ? `${r / 4}rem` : void 0,
    marginTop: n !== void 0 ? `${n / 4}rem` : void 0,
    backgroundColor: a !== void 0 ? gt[a] : void 0,
    color: i !== void 0 ? gt[i] : void 0,
    borderRadius: o !== void 0 ? fC[o] : void 0,
    borderColor: C !== void 0 ? gt[C] : void 0,
    padding: c !== void 0 ? `${c / 4}rem` : void 0
  };
  return m !== void 0 ? D.borderWidth = m : (D.borderTopWidth = g, D.borderBottomWidth = v), u !== void 0 && (D.paddingLeft = `${u / 4}rem`, D.paddingRight = `${u / 4}rem`), d !== void 0 && (D.paddingTop = `${d / 4}rem`, D.paddingBottom = `${d / 4}rem`), h !== void 0 && (D.paddingTop = `${h / 4}rem`), A !== void 0 && (D.paddingBottom = `${A / 4}rem`), y !== void 0 && (D.borderLeftWidth = y, D.borderLeftColor = C !== void 0 ? gt[C] : void 0, D.borderLeftStyle = "solid"), /* @__PURE__ */ f.jsx(
    "div",
    {
      ref: t,
      className: `${s === !0 ? "hidden" : "block"}`,
      style: D,
      ...b,
      children: w
    }
  );
});
uP.displayName = "Box";
const fP = B.forwardRef((e, t) => {
  const {
    text: r,
    variant: n,
    minHeight: a = "60vh",
    minHeigthDesktop: i = "40vh"
  } = e, o = {
    "--ck-min-h-box-status": typeof a == "number" ? `${a}px` : a,
    "--ck-min-h-box-status-desktop": typeof i == "number" ? `${i}px` : i
  }, c = r ?? {
    loading: "Cargando...",
    empty: ""
  }[n];
  return /* @__PURE__ */ f.jsxs(
    "div",
    {
      ref: t,
      style: o,
      className: "bg-Marca-800 flex items-center justify-center p-5 rounded-md h-full w-full min-h-[var(--ck-min-h-box-status)] m:min-h-[var(--ck-min-h-box-status-desktop)]",
      children: [
        n === "loading" && /* @__PURE__ */ f.jsxs("div", { className: "flex flex-col items-center justify-center w-full text-center animate-pulse", children: [
          /* @__PURE__ */ f.jsx("div", { className: "bg-white flex justify-center items-center w-[64px] h-[64px] rounded-md mb-4", children: /* @__PURE__ */ f.jsxs("svg", { width: "40", height: "40", viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
            /* @__PURE__ */ f.jsxs("g", { clipPath: "url(#clip0_57_290)", children: [
              /* @__PURE__ */ f.jsx("path", { d: "M22.5565 4.17673C20.8792 3.90792 19.1218 3.90792 17.4445 4.17673L16.816 0.25121C18.9077 -0.0840621 21.0933 -0.0840621 23.185 0.25121L22.5565 4.17673Z", fill: "#141A22" }),
              /* @__PURE__ */ f.jsx("path", { d: "M9.87513 7.57442L7.36798 4.48855C8.19002 3.81996 9.07558 3.211 10.0002 2.6773C10.9239 2.1436 11.8945 1.68126 12.8847 1.30396L14.303 5.01834C13.5093 5.32135 12.7303 5.69279 11.9884 6.12092C11.2455 6.55003 10.5349 7.03877 9.87611 7.57442H9.87513Z", fill: "#141A22" }),
              /* @__PURE__ */ f.jsx("path", { d: "M5.02016 14.3014L1.30587 12.883C1.68414 11.8929 2.14647 10.9222 2.67918 9.99853C3.21286 9.07483 3.82181 8.18924 4.49038 7.36719L7.57618 9.8744C7.04054 10.5342 6.55084 11.2448 6.12272 11.9867C5.69362 12.7286 5.32317 13.5076 5.02016 14.3014Z", fill: "#141A22" }),
              /* @__PURE__ */ f.jsx("path", { d: "M0.252181 23.1846C0.0850377 22.1387 0 21.0674 0 20C0 18.9326 0.0850377 17.8613 0.252181 16.8154L4.1776 17.4439C4.04369 18.2826 3.97527 19.1428 3.97527 20C3.97527 20.8573 4.04369 21.7174 4.1776 22.5561L0.252181 23.1846Z", fill: "#141A22" }),
              /* @__PURE__ */ f.jsx("path", { d: "M4.49038 32.6319C3.82279 31.8098 3.21286 30.9242 2.67918 30.0005C2.14549 29.0768 1.68316 28.1062 1.30587 27.116L5.02016 25.6977C5.32317 26.4914 5.6946 27.2704 6.12272 28.0123C6.55182 28.7552 7.04054 29.4658 7.57618 30.1247L4.49038 32.6319Z", fill: "#141A22" }),
              /* @__PURE__ */ f.jsx("path", { d: "M12.8837 38.6941C11.8936 38.3158 10.9239 37.8535 9.99927 37.3208C9.07558 36.7871 8.19002 36.1781 7.36701 35.5095L9.87416 32.4236C10.5339 32.9593 11.2445 33.448 11.9864 33.8771C12.7293 34.3063 13.5073 34.6767 14.301 34.9797L12.8827 38.6941H12.8837Z", fill: "#141A22" }),
              /* @__PURE__ */ f.jsx("path", { d: "M20.0005 40C18.9331 40 17.8618 39.9149 16.816 39.7478L17.4445 35.8223C19.1218 36.0911 20.8792 36.0911 22.5565 35.8223L23.185 39.7478C22.1391 39.9149 21.0679 40 20.0005 40Z", fill: "#141A22" }),
              /* @__PURE__ */ f.jsx("path", { d: "M27.1163 38.6941L25.698 34.9797C26.4917 34.6767 27.2707 34.3053 28.0126 33.8771C28.7555 33.448 29.4661 32.9593 30.1249 32.4236L32.632 35.5095C31.81 36.1781 30.9244 36.7871 29.9998 37.3208C29.0761 37.8545 28.1055 38.3168 27.1153 38.6941H27.1163Z", fill: "#141A22" }),
              /* @__PURE__ */ f.jsx("path", { d: "M35.5096 32.6319L32.4238 30.1247C32.9595 29.4649 33.4482 28.7542 33.8773 28.0123C34.3064 27.2704 34.6768 26.4914 34.9798 25.6977L38.6941 27.116C38.3159 28.1062 37.8535 29.0768 37.3208 30.0005C36.7871 30.9242 36.1782 31.8098 35.5096 32.6319Z", fill: "#141A22" }),
              /* @__PURE__ */ f.jsx("path", { d: "M39.7478 23.1836L35.8224 22.5551C35.9563 21.7165 36.0247 20.8563 36.0247 19.999C36.0247 19.1418 35.9563 18.2816 35.8224 17.443L39.7478 16.8145C39.915 17.8603 40 18.9317 40 19.999C40 21.0664 39.915 22.1377 39.7478 23.1836Z", fill: "#141A22" }),
              /* @__PURE__ */ f.jsx("path", { d: "M34.9808 14.3023C34.6778 13.5086 34.3064 12.7296 33.8783 11.9877C33.4492 11.2448 32.9604 10.5342 32.4248 9.87537L35.5106 7.36816C36.1792 8.19022 36.7881 9.0758 37.3218 10.0005C37.8555 10.9242 38.3178 11.8948 38.6951 12.885L34.9808 14.3033V14.3023Z", fill: "#141A22" }),
              /* @__PURE__ */ f.jsx("path", { d: "M30.1249 7.57442C29.4651 7.03877 28.7545 6.55003 28.0126 6.12092C27.2707 5.69181 26.4917 5.32135 25.698 5.01834L27.1163 1.30396C28.1064 1.68224 29.077 2.14458 30.0007 2.6773C30.9244 3.211 31.81 3.81996 32.632 4.48855L30.1249 7.57442Z", fill: "#141A22" })
            ] }),
            /* @__PURE__ */ f.jsx("defs", { children: /* @__PURE__ */ f.jsx("clipPath", { id: "clip0_57_290", children: /* @__PURE__ */ f.jsx("rect", { width: "40", height: "40", fill: "white" }) }) })
          ] }) }),
          c !== "" && /* @__PURE__ */ f.jsx(a1, { variant: "description-3", children: c })
        ] }),
        n === "empty" && /* @__PURE__ */ f.jsxs("div", { className: "flex flex-col items-center justify-center w-full max-w-[300px] gap-4 text-center", children: [
          /* @__PURE__ */ f.jsx("div", { className: "flex justify-center select-none", children: /* @__PURE__ */ f.jsxs("svg", { width: "40", height: "40", viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
            /* @__PURE__ */ f.jsx("path", { d: "M29.6452 29.6428C26.8698 31.7582 23.4903 32.9299 20.0011 32.9867C8.63586 32.9867 2.14081 19.9987 2.14081 19.9987C4.16063 16.235 6.96202 12.9468 10.357 10.3546M16.5909 7.4004C17.7087 7.13878 18.8531 7.00802 20.0011 7.01078C31.3664 7.01078 37.8614 19.9987 37.8614 19.9987C36.876 21.8422 35.7007 23.5778 34.3549 25.1772M23.437 23.4389C22.9899 23.9126 22.4523 24.2918 21.856 24.554C21.2598 24.8162 20.617 24.9562 19.9656 24.9655C19.3143 24.9749 18.6678 24.8536 18.0642 24.6086C17.4606 24.3637 16.9123 24.0002 16.4517 23.5396C15.9911 23.079 15.6276 22.5307 15.3827 21.9271C15.1377 21.3235 15.0164 20.677 15.0258 20.0257C15.0351 19.3743 15.1751 18.7315 15.4373 18.1353C15.6995 17.539 16.0787 17.0014 16.5524 16.5543", stroke: "#141A22", strokeWidth: "3", strokeLinecap: "round", "stroke-linejoin": "round" }),
            /* @__PURE__ */ f.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M0.627013 0.627013C1.46303 -0.209004 2.81848 -0.209004 3.6545 0.627013L39.373 36.3455C40.209 37.1815 40.209 38.537 39.373 39.373C38.537 40.209 37.1815 40.209 36.3455 39.373L0.627013 3.6545C-0.209004 2.81848 -0.209004 1.46303 0.627013 0.627013Z", fill: "#141A22" })
          ] }) }),
          c !== "" && /* @__PURE__ */ f.jsx(a1, { variant: "description-3", children: c })
        ] })
      ]
    }
  );
});
fP.displayName = "BoxStatus";
function Ye(e) {
  return `${e.filter((t) => t !== void 0).join(" ").trim()}`;
}
const dP = B.forwardRef((e, t) => {
  const {
    items: r = [],
    className: n
  } = e;
  return /* @__PURE__ */ f.jsx(
    "ul",
    {
      ref: t,
      className: Ye(["hidden m:flex flex-wrap gap-2", n]),
      children: r.map((a, i) => /* @__PURE__ */ f.jsxs(
        "li",
        {
          className: "text-neutral-400 flex gap-2 items-center",
          children: [
            /* @__PURE__ */ f.jsx(
              "div",
              {
                className: `hover:text-secondary-600 ${i + 1 === r.length ? "pointer-events-none" : "cursor-pointer"}`,
                onClick: () => {
                  i + 1 !== r.length && a.onClick !== void 0 && a.onClick();
                },
                children: /* @__PURE__ */ f.jsx(kr, { variant: "title-3", children: a.description })
              }
            ),
            i + 1 !== r.length && /* @__PURE__ */ f.jsx("span", { className: "w-[14px] min-w-[14px] -rotate-90", children: /* @__PURE__ */ f.jsx(Me, { variant: "arrow-down", width: 14 }) })
          ]
        },
        a.description
      ))
    }
  );
});
dP.displayName = "Breadcrumb";
const hP = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 15 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        d: "M14.043.71a.999.999 0 00-1.42 0l-4.58 4.58a1 1 0 01-1.42 0L2.043.71a1 1 0 10-1.42 1.41l4.59 4.59a3 3 0 004.24 0l4.59-4.59a1 1 0 000-1.41z",
        fill: "currentColor"
      }
    )
  }
), AP = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        d: "M6.70937 3.29018C6.61564 3.38315 6.54125 3.49375 6.49048 3.61561C6.43971 3.73747 6.41357 3.86817 6.41357 4.00018C6.41357 4.1322 6.43971 4.2629 6.49048 4.38476C6.54125 4.50662 6.61564 4.61722 6.70937 4.71018L11.2894 9.29018C11.3831 9.38315 11.4575 9.49375 11.5083 9.61561C11.559 9.73747 11.5852 9.86817 11.5852 10.0002C11.5852 10.1322 11.559 10.2629 11.5083 10.3848C11.4575 10.5066 11.3831 10.6172 11.2894 10.7102L6.70937 15.2902C6.61564 15.3831 6.54125 15.4937 6.49048 15.6156C6.43971 15.7375 6.41357 15.8682 6.41357 16.0002C6.41357 16.1322 6.43971 16.2629 6.49048 16.3848C6.54125 16.5066 6.61564 16.6172 6.70937 16.7102C6.89673 16.8964 7.15019 17.001 7.41437 17.001C7.67856 17.001 7.93201 16.8964 8.11937 16.7102L12.7094 12.1202C13.2712 11.5577 13.5867 10.7952 13.5867 10.0002C13.5867 9.20518 13.2712 8.44269 12.7094 7.88018L8.11937 3.29018C7.93201 3.10393 7.67856 2.99939 7.41437 2.99939C7.15019 2.99939 6.89673 3.10393 6.70937 3.29018Z",
        fill: "currentColor"
      }
    )
  }
), pP = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        d: "M16 9.005H6l3.29-3.29a1 1 0 10-1.41-1.42l-4.29 4.3a2 2 0 00-.59 1.41 2 2 0 00.59 1.4l4.29 4.3a1 1 0 001.628-1.096 1 1 0 00-.218-.324L6 11.005h10a1 1 0 000-2z",
        fill: "currentColor"
      }
    )
  }
), vP = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 16 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        d: "M13.426.2L15.2 2l-7.32 7.21a2.503 2.503 0 01-1.777.734 2.528 2.528 0 01-1.79-.74L.8 5.799 2.56 3.982l3.53 3.42 7.339-7.2L13.426.2z",
        fill: "currentColor"
      }
    )
  }
), gP = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsx("g", { clipPath: "url(#clip0_2127_36415)", children: /* @__PURE__ */ f.jsx(
      "path",
      {
        d: "M14.0817 6.90667L15.2517 8.09417L10.4242 12.85C10.1017 13.1725 9.6775 13.3333 9.25167 13.3333C8.82583 13.3333 8.3975 13.1708 8.07167 12.8458L5.75333 10.5992L6.91417 9.40167L9.24167 11.6575L14.0817 6.90667ZM20.5 10C20.5 15.5142 16.0142 20 10.5 20C4.98583 20 0.5 15.5142 0.5 10C0.5 4.48583 4.98583 0 10.5 0C16.0142 0 20.5 4.48583 20.5 10ZM18.8333 10C18.8333 5.405 15.095 1.66667 10.5 1.66667C5.905 1.66667 2.16667 5.405 2.16667 10C2.16667 14.595 5.905 18.3333 10.5 18.3333C15.095 18.3333 18.8333 14.595 18.8333 10Z",
        fill: "currentColor"
      }
    ) })
  }
), mP = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        d: "M10 0C8.02219 0 6.08879 0.58649 4.4443 1.6853C2.79981 2.78412 1.51809 4.3459 0.761209 6.17316C0.00433286 8.00043 -0.1937 10.0111 0.192152 11.9509C0.578004 13.8907 1.53041 15.6725 2.92894 17.0711C4.32746 18.4696 6.10929 19.422 8.0491 19.8078C9.98891 20.1937 11.9996 19.9957 13.8268 19.2388C15.6541 18.4819 17.2159 17.2002 18.3147 15.5557C19.4135 13.9112 20 11.9778 20 10C19.9971 7.34871 18.9426 4.80684 17.0679 2.9321C15.1932 1.05736 12.6513 0.00286757 10 0ZM10 18.3333C8.35183 18.3333 6.74066 17.8446 5.37025 16.9289C3.99984 16.0132 2.93174 14.7117 2.30101 13.189C1.67028 11.6663 1.50525 9.99075 1.82679 8.37425C2.14834 6.75774 2.94201 5.27288 4.10745 4.10744C5.27288 2.94201 6.75774 2.14833 8.37425 1.82679C9.99076 1.50525 11.6663 1.67027 13.189 2.301C14.7117 2.93173 16.0132 3.99984 16.9289 5.37025C17.8446 6.74066 18.3333 8.35182 18.3333 10C18.3309 12.2094 17.4522 14.3276 15.8899 15.8899C14.3276 17.4522 12.2094 18.3309 10 18.3333ZM10.8333 9.16667H14.1667V10.8333H10.8333V14.1667H9.16667V10.8333H5.83334V9.16667H9.16667V5.83333H10.8333V9.16667Z",
        fill: "currentColor"
      }
    )
  }
), CP = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        d: "M12.9998 0.999818C12.8123 0.812347 12.558 0.707031 12.2928 0.707031C12.0277 0.707031 11.7733 0.812347 11.5858 0.999818L6.99982 5.58582L2.41382 0.999818C2.22629 0.812347 1.97198 0.707031 1.70682 0.707031C1.44165 0.707031 1.18735 0.812347 0.999818 0.999818C0.812347 1.18735 0.707031 1.44165 0.707031 1.70682C0.707031 1.97198 0.812347 2.22629 0.999818 2.41382L5.58582 6.99982L0.999818 11.5858C0.812347 11.7733 0.707031 12.0277 0.707031 12.2928C0.707031 12.558 0.812347 12.8123 0.999818 12.9998C1.18735 13.1873 1.44165 13.2926 1.70682 13.2926C1.97198 13.2926 2.22629 13.1873 2.41382 12.9998L6.99982 8.41382L11.5858 12.9998C11.7733 13.1873 12.0277 13.2926 12.2928 13.2926C12.558 13.2926 12.8123 13.1873 12.9998 12.9998C13.1873 12.8123 13.2926 12.558 13.2926 12.2928C13.2926 12.0277 13.1873 11.7733 12.9998 11.5858L8.41382 6.99982L12.9998 2.41382C13.1873 2.22629 13.2926 1.97198 13.2926 1.70682C13.2926 1.44165 13.1873 1.18735 12.9998 0.999818Z",
        fill: "currentColor"
      }
    )
  }
), bP = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 20 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsxs("g", { clipPath: "url(#clip0_1902_296)", children: [
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M0.83 6.16504H19.16C19.62 6.16504 19.99 6.53504 19.99 6.99504C19.99 7.45504 19.62 7.82504 19.16 7.82504H0.83C0.37 7.83504 0 7.46504 0 7.00504C0 6.54504 0.37 6.16504 0.83 6.16504Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M9.83977 0.334961H19.1698C19.6298 0.334961 19.9998 0.704961 19.9998 1.16496C19.9998 1.62496 19.6298 1.99496 19.1698 1.99496H9.83977C9.37977 1.99496 9.00977 1.62496 9.00977 1.16496C9.00977 0.704961 9.37977 0.334961 9.83977 0.334961Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M9.83977 12.0049H19.1698C19.6298 12.0049 19.9998 12.3749 19.9998 12.8349C19.9998 13.2949 19.6298 13.6649 19.1698 13.6649H9.83977C9.37977 13.6649 9.00977 13.2949 9.00977 12.8349C9.00977 12.3749 9.37977 12.0049 9.83977 12.0049Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M2.17982 7.6749C1.80982 7.3049 1.79982 6.7049 2.17982 6.3249L6.54982 1.9649C6.91982 1.5949 6.92982 0.994902 6.54982 0.614902C6.17982 0.244902 5.57982 0.244902 5.20982 0.614902L0.839824 4.9849C-0.270176 6.1049 -0.270176 7.9049 0.839824 9.0249L5.20982 13.3949C5.38982 13.5749 5.62982 13.6749 5.87982 13.6749C6.12982 13.6749 6.37982 13.5749 6.55982 13.3949C6.92982 13.0249 6.93982 12.4249 6.55982 12.0449L2.17982 7.6749Z",
          fill: "currentColor"
        }
      )
    ] })
  }
), yP = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        d: "M15.8333 1.6665H4.16667C1.86917 1.6665 0 3.53567 0 5.83317V14.1665C0 16.464 1.86917 18.3332 4.16667 18.3332H15.8333C18.1308 18.3332 20 16.464 20 14.1665V5.83317C20 3.53567 18.1308 1.6665 15.8333 1.6665ZM4.16667 3.33317H15.8333C17.2117 3.33317 18.3333 4.45484 18.3333 5.83317H1.66667C1.66667 4.45484 2.78833 3.33317 4.16667 3.33317ZM1.66667 14.1665V7.49984H9.16667V16.6665H4.16667C2.78833 16.6665 1.66667 15.5448 1.66667 14.1665ZM15.8333 16.6665H10.8333V7.49984H18.3333V14.1665C18.3333 15.5448 17.2117 16.6665 15.8333 16.6665Z",
        fill: "currentColor"
      }
    )
  }
), wP = () => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M9.99984 6.6665C9.34057 6.6665 8.6961 6.862 8.14794 7.22827C7.59977 7.59454 7.17253 8.11514 6.92024 8.72423C6.66795 9.33331 6.60194 10.0035 6.73055 10.6501C6.85917 11.2967 7.17664 11.8907 7.64282 12.3569C8.10899 12.823 8.70293 13.1405 9.34954 13.2691C9.99614 13.3977 10.6664 13.3317 11.2755 13.0794C11.8845 12.8271 12.4051 12.3999 12.7714 11.8517C13.1377 11.3036 13.3332 10.6591 13.3332 9.99984C13.3332 9.11578 12.982 8.26794 12.3569 7.64281C11.7317 7.01769 10.8839 6.6665 9.99984 6.6665ZM9.99984 11.6665C9.6702 11.6665 9.34797 11.5688 9.07389 11.3856C8.79981 11.2025 8.58619 10.9422 8.46004 10.6376C8.33389 10.3331 8.30089 9.99799 8.3652 9.67469C8.42951 9.35139 8.58824 9.05441 8.82133 8.82133C9.05442 8.58824 9.35139 8.4295 9.67469 8.36519C9.99799 8.30089 10.3331 8.33389 10.6376 8.46004C10.9422 8.58618 11.2025 8.79981 11.3856 9.07389C11.5688 9.34797 11.6665 9.6702 11.6665 9.99984C11.6665 10.4419 11.4909 10.8658 11.1783 11.1783C10.8658 11.4909 10.4419 11.6665 9.99984 11.6665Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M17.7452 11.5833L17.3752 11.37C17.5417 10.4637 17.5417 9.53463 17.3752 8.62833L17.7452 8.415C18.0297 8.25085 18.2791 8.03226 18.4792 7.77172C18.6792 7.51118 18.826 7.21378 18.9111 6.89651C18.9962 6.57925 19.018 6.24832 18.9753 5.92263C18.9325 5.59694 18.826 5.28286 18.6618 4.99833C18.4977 4.7138 18.2791 4.46439 18.0185 4.26434C17.758 4.06428 17.4606 3.91751 17.1433 3.83239C16.8261 3.74726 16.4951 3.72547 16.1695 3.76824C15.8438 3.81101 15.5297 3.91751 15.2452 4.08167L14.8743 4.29583C14.1739 3.69743 13.369 3.23354 12.5002 2.9275V2.5C12.5002 1.83696 12.2368 1.20107 11.7679 0.732233C11.2991 0.263392 10.6632 0 10.0002 0C9.33712 0 8.70123 0.263392 8.23239 0.732233C7.76355 1.20107 7.50016 1.83696 7.50016 2.5V2.9275C6.63131 3.23464 5.8267 3.69967 5.12682 4.29917L4.75432 4.08333C4.17969 3.75181 3.49689 3.66214 2.85614 3.83405C2.21539 4.00596 1.66918 4.42536 1.33766 5C1.00614 5.57464 0.916468 6.25743 1.08838 6.89818C1.26028 7.53893 1.67969 8.08515 2.25432 8.41667L2.62432 8.63C2.45775 9.5363 2.45775 10.4654 2.62432 11.3717L2.25432 11.585C1.67969 11.9165 1.26028 12.4627 1.08838 13.1035C0.916468 13.7442 1.00614 14.427 1.33766 15.0017C1.66918 15.5763 2.21539 15.9957 2.85614 16.1676C3.49689 16.3395 4.17969 16.2499 4.75432 15.9183L5.12516 15.7042C5.8258 16.3027 6.63097 16.7666 7.50016 17.0725V17.5C7.50016 18.163 7.76355 18.7989 8.23239 19.2678C8.70123 19.7366 9.33712 20 10.0002 20C10.6632 20 11.2991 19.7366 11.7679 19.2678C12.2368 18.7989 12.5002 18.163 12.5002 17.5V17.0725C13.369 16.7654 14.1736 16.3003 14.8735 15.7008L15.246 15.9158C15.8206 16.2474 16.5034 16.337 17.1442 16.1651C17.7849 15.9932 18.3311 15.5738 18.6627 14.9992C18.9942 14.4245 19.0838 13.7417 18.9119 13.101C18.74 12.4602 18.3206 11.914 17.746 11.5825L17.7452 11.5833ZM15.6218 8.43667C15.904 9.45922 15.904 10.5391 15.6218 11.5617C15.5725 11.7396 15.5838 11.9289 15.6538 12.0998C15.7238 12.2707 15.8485 12.4135 16.0085 12.5058L16.9118 13.0275C17.1033 13.138 17.2431 13.3201 17.3004 13.5336C17.3577 13.7472 17.3277 13.9747 17.2172 14.1663C17.1067 14.3578 16.9247 14.4975 16.7111 14.5548C16.4976 14.6121 16.27 14.5822 16.0785 14.4717L15.1735 13.9483C15.0134 13.8556 14.827 13.8188 14.6437 13.8437C14.4604 13.8686 14.2906 13.9538 14.161 14.0858C13.4193 14.843 12.4848 15.3833 11.4585 15.6483C11.2794 15.6944 11.1206 15.7987 11.0073 15.9449C10.894 16.0911 10.8326 16.2709 10.8327 16.4558V17.5C10.8327 17.721 10.7449 17.933 10.5886 18.0893C10.4323 18.2455 10.2203 18.3333 9.99932 18.3333C9.77831 18.3333 9.56635 18.2455 9.41007 18.0893C9.25379 17.933 9.16599 17.721 9.16599 17.5V16.4567C9.16608 16.2717 9.10464 16.092 8.99133 15.9458C8.87802 15.7996 8.7193 15.6952 8.54016 15.6492C7.51378 15.3831 6.5796 14.8416 5.83849 14.0833C5.70893 13.9513 5.53911 13.8661 5.35579 13.8412C5.17247 13.8163 4.98608 13.8531 4.82599 13.9458L3.92266 14.4683C3.82785 14.5239 3.72298 14.5602 3.6141 14.5751C3.50521 14.59 3.39445 14.5832 3.2882 14.5551C3.18195 14.527 3.08231 14.4782 2.99501 14.4114C2.90771 14.3446 2.83447 14.2613 2.77952 14.1661C2.72457 14.0709 2.68899 13.9658 2.67482 13.8568C2.66066 13.7479 2.66819 13.6372 2.69698 13.5311C2.72578 13.425 2.77527 13.3257 2.8426 13.2389C2.90994 13.152 2.99379 13.0793 3.08932 13.025L3.99266 12.5033C4.15262 12.411 4.27739 12.2682 4.34737 12.0973C4.41736 11.9264 4.4286 11.7371 4.37932 11.5592C4.09712 10.5366 4.09712 9.45672 4.37932 8.43417C4.42771 8.25657 4.41594 8.06795 4.34584 7.89774C4.27574 7.72754 4.15125 7.58534 3.99182 7.49333L3.08849 6.97167C2.89698 6.86116 2.75722 6.6791 2.69994 6.46555C2.64266 6.25199 2.67257 6.02442 2.78307 5.83292C2.89358 5.64141 3.07564 5.50164 3.2892 5.44437C3.50275 5.38709 3.73032 5.41699 3.92182 5.5275L4.82682 6.05083C4.98647 6.14376 5.17247 6.18101 5.3556 6.15672C5.53872 6.13244 5.70858 6.048 5.83849 5.91667C6.58023 5.15945 7.51468 4.61918 8.54099 4.35417C8.72068 4.30797 8.87982 4.20313 8.99319 4.05625C9.10655 3.90938 9.16766 3.72887 9.16682 3.54333V2.5C9.16682 2.27899 9.25462 2.06702 9.4109 1.91074C9.56718 1.75446 9.77914 1.66667 10.0002 1.66667C10.2212 1.66667 10.4331 1.75446 10.5894 1.91074C10.7457 2.06702 10.8335 2.27899 10.8335 2.5V3.54333C10.8334 3.7283 10.8948 3.90804 11.0082 4.05423C11.1215 4.20043 11.2802 4.30478 11.4593 4.35083C12.486 4.61679 13.4205 5.15824 14.1618 5.91667C14.2914 6.04872 14.4612 6.13391 14.6445 6.15881C14.8278 6.1837 15.0142 6.14689 15.1743 6.05417L16.0777 5.53167C16.1725 5.47609 16.2773 5.43981 16.3862 5.42492C16.4951 5.41003 16.6059 5.41683 16.7121 5.44492C16.8184 5.47301 16.918 5.52184 17.0053 5.58859C17.0926 5.65535 17.1658 5.73872 17.2208 5.83389C17.2757 5.92907 17.3113 6.03417 17.3255 6.14316C17.3397 6.25214 17.3321 6.36285 17.3033 6.46891C17.2745 6.57497 17.225 6.67429 17.1577 6.76114C17.0904 6.848 17.0065 6.92068 16.911 6.975L16.0077 7.49667C15.8485 7.58892 15.7244 7.73123 15.6546 7.90141C15.5848 8.07159 15.5733 8.26008 15.6218 8.4375V8.43667Z",
          fill: "currentColor"
        }
      )
    ]
  }
), xP = () => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ f.jsxs("g", { clipPath: "url(#clip0_842_3882)", children: [
        /* @__PURE__ */ f.jsx(
          "path",
          {
            d: "M5.83333 0H3.33333C2.44928 0 1.60143 0.35119 0.976311 0.976311C0.35119 1.60143 0 2.44928 0 3.33333L0 5.83333C0 6.71739 0.35119 7.56524 0.976311 8.19036C1.60143 8.81548 2.44928 9.16667 3.33333 9.16667H5.83333C6.71739 9.16667 7.56524 8.81548 8.19036 8.19036C8.81548 7.56524 9.16667 6.71739 9.16667 5.83333V3.33333C9.16667 2.44928 8.81548 1.60143 8.19036 0.976311C7.56524 0.35119 6.71739 0 5.83333 0ZM7.5 5.83333C7.5 6.27536 7.32441 6.69928 7.01185 7.01185C6.69928 7.32441 6.27536 7.5 5.83333 7.5H3.33333C2.89131 7.5 2.46738 7.32441 2.15482 7.01185C1.84226 6.69928 1.66667 6.27536 1.66667 5.83333V3.33333C1.66667 2.89131 1.84226 2.46738 2.15482 2.15482C2.46738 1.84226 2.89131 1.66667 3.33333 1.66667H5.83333C6.27536 1.66667 6.69928 1.84226 7.01185 2.15482C7.32441 2.46738 7.5 2.89131 7.5 3.33333V5.83333Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ f.jsx(
          "path",
          {
            d: "M16.6668 0H14.1668C13.2828 0 12.4349 0.35119 11.8098 0.976311C11.1847 1.60143 10.8335 2.44928 10.8335 3.33333V5.83333C10.8335 6.71739 11.1847 7.56524 11.8098 8.19036C12.4349 8.81548 13.2828 9.16667 14.1668 9.16667H16.6668C17.5509 9.16667 18.3987 8.81548 19.0239 8.19036C19.649 7.56524 20.0002 6.71739 20.0002 5.83333V3.33333C20.0002 2.44928 19.649 1.60143 19.0239 0.976311C18.3987 0.35119 17.5509 0 16.6668 0ZM18.3335 5.83333C18.3335 6.27536 18.1579 6.69928 17.8453 7.01185C17.5328 7.32441 17.1089 7.5 16.6668 7.5H14.1668C13.7248 7.5 13.3009 7.32441 12.9883 7.01185C12.6758 6.69928 12.5002 6.27536 12.5002 5.83333V3.33333C12.5002 2.89131 12.6758 2.46738 12.9883 2.15482C13.3009 1.84226 13.7248 1.66667 14.1668 1.66667H16.6668C17.1089 1.66667 17.5328 1.84226 17.8453 2.15482C18.1579 2.46738 18.3335 2.89131 18.3335 3.33333V5.83333Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ f.jsx(
          "path",
          {
            d: "M5.83333 10.8335H3.33333C2.44928 10.8335 1.60143 11.1847 0.976311 11.8098C0.35119 12.4349 0 13.2828 0 14.1668L0 16.6668C0 17.5509 0.35119 18.3987 0.976311 19.0239C1.60143 19.649 2.44928 20.0002 3.33333 20.0002H5.83333C6.71739 20.0002 7.56524 19.649 8.19036 19.0239C8.81548 18.3987 9.16667 17.5509 9.16667 16.6668V14.1668C9.16667 13.2828 8.81548 12.4349 8.19036 11.8098C7.56524 11.1847 6.71739 10.8335 5.83333 10.8335ZM7.5 16.6668C7.5 17.1089 7.32441 17.5328 7.01185 17.8453C6.69928 18.1579 6.27536 18.3335 5.83333 18.3335H3.33333C2.89131 18.3335 2.46738 18.1579 2.15482 17.8453C1.84226 17.5328 1.66667 17.1089 1.66667 16.6668V14.1668C1.66667 13.7248 1.84226 13.3009 2.15482 12.9883C2.46738 12.6758 2.89131 12.5002 3.33333 12.5002H5.83333C6.27536 12.5002 6.69928 12.6758 7.01185 12.9883C7.32441 13.3009 7.5 13.7248 7.5 14.1668V16.6668Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ f.jsx(
          "path",
          {
            d: "M16.6668 10.8335H14.1668C13.2828 10.8335 12.4349 11.1847 11.8098 11.8098C11.1847 12.4349 10.8335 13.2828 10.8335 14.1668V16.6668C10.8335 17.5509 11.1847 18.3987 11.8098 19.0239C12.4349 19.649 13.2828 20.0002 14.1668 20.0002H16.6668C17.5509 20.0002 18.3987 19.649 19.0239 19.0239C19.649 18.3987 20.0002 17.5509 20.0002 16.6668V14.1668C20.0002 13.2828 19.649 12.4349 19.0239 11.8098C18.3987 11.1847 17.5509 10.8335 16.6668 10.8335ZM18.3335 16.6668C18.3335 17.1089 18.1579 17.5328 17.8453 17.8453C17.5328 18.1579 17.1089 18.3335 16.6668 18.3335H14.1668C13.7248 18.3335 13.3009 18.1579 12.9883 17.8453C12.6758 17.5328 12.5002 17.1089 12.5002 16.6668V14.1668C12.5002 13.7248 12.6758 13.3009 12.9883 12.9883C13.3009 12.6758 13.7248 12.5002 14.1668 12.5002H16.6668C17.1089 12.5002 17.5328 12.6758 17.8453 12.9883C18.1579 13.3009 18.3335 13.7248 18.3335 14.1668V16.6668Z",
            fill: "currentColor"
          }
        )
      ] }),
      /* @__PURE__ */ f.jsx("defs", { children: /* @__PURE__ */ f.jsx("clipPath", { id: "clip0_842_3882", children: /* @__PURE__ */ f.jsx("rect", { width: 20, height: 20, fill: "white" }) }) })
    ]
  }
), OP = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsx("g", { clipPath: "url(#clip0_2127_30852)", children: /* @__PURE__ */ f.jsx(
      "path",
      {
        d: "M10 14.1666V17.4999C10 17.9583 9.625 18.3333 9.16667 18.3333H5.83333C5.375 18.3333 5 17.9583 5 17.4999C5 17.0416 5.375 16.6666 5.83333 16.6666H8.33333V14.9999H4.16667C1.86667 14.9999 0 13.1333 0 10.8333V4.99992C0 2.69992 1.86667 0.833252 4.16667 0.833252H14.1667C16.4667 0.833252 18.3333 2.69992 18.3333 4.99992C18.3333 5.45825 17.9583 5.83325 17.5 5.83325C17.0417 5.83325 16.6667 5.45825 16.6667 4.99992C16.6667 3.62492 15.5417 2.49992 14.1667 2.49992H4.16667C2.79167 2.49992 1.66667 3.62492 1.66667 4.99992V10.8333C1.66667 12.2083 2.79167 13.3333 4.16667 13.3333H9.16667C9.625 13.3333 10 13.7083 10 14.1666ZM20 10.8333V16.6666C20 18.5083 18.5083 19.9999 16.6667 19.9999H15C13.1583 19.9999 11.6667 18.5083 11.6667 16.6666V10.8333C11.6667 8.99158 13.1583 7.49992 15 7.49992H16.6667C18.5083 7.49992 20 8.99158 20 10.8333ZM18.3333 10.8333C18.3333 9.91658 17.5833 9.16658 16.6667 9.16658H15C14.0833 9.16658 13.3333 9.91658 13.3333 10.8333V16.6666C13.3333 17.5833 14.0833 18.3333 15 18.3333H16.6667C17.5833 18.3333 18.3333 17.5833 18.3333 16.6666V10.8333Z",
        fill: "currentColor"
      }
    ) })
  }
), DP = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsx("g", { clipPath: "url(#clip0_2656_4445)", children: /* @__PURE__ */ f.jsx(
      "path",
      {
        d: "M13.3333 19.1667C13.3333 19.6267 12.9608 20 12.4999 20H4.99992C2.70242 20 0.833252 18.1308 0.833252 15.8333V4.16667C0.833252 1.86917 2.70242 0 4.99992 0H8.76242C10.3199 0 11.7849 0.606667 12.8874 1.70833L15.7908 4.61333C16.0166 4.83917 16.2266 5.08667 16.4141 5.34917C16.6816 5.72333 16.5949 6.24417 16.2208 6.51167C15.8466 6.77833 15.3249 6.6925 15.0583 6.3175C14.9241 6.13 14.7741 5.9525 14.6133 5.7925L11.7091 2.8875C11.4441 2.6225 11.1499 2.39833 10.8333 2.21667V5.83333C10.8333 6.2925 11.2066 6.66667 11.6666 6.66667H14.1666C14.6274 6.66667 14.9999 7.04 14.9999 7.5C14.9999 7.96 14.6274 8.33333 14.1666 8.33333H11.6666C10.2883 8.33333 9.16659 7.21167 9.16659 5.83333V1.68583C9.03325 1.67333 8.89825 1.66667 8.76242 1.66667H4.99992C3.62159 1.66667 2.49992 2.78833 2.49992 4.16667V15.8333C2.49992 17.2117 3.62159 18.3333 4.99992 18.3333H12.4999C12.9608 18.3333 13.3333 18.7067 13.3333 19.1667ZM18.0708 13.5558L15.5366 13.1333C15.2258 13.0817 14.9999 12.815 14.9999 12.5C14.9999 12.0408 15.3733 11.6667 15.8333 11.6667H17.7233C18.0199 11.6667 18.2966 11.8267 18.4458 12.0833C18.6749 12.4817 19.1833 12.6175 19.5841 12.3875C19.9824 12.1567 20.1191 11.6475 19.8874 11.2492C19.4424 10.4783 18.6124 9.99917 17.7224 9.99917H17.4991V9.16583C17.4991 8.70583 17.1266 8.3325 16.6658 8.3325C16.2049 8.3325 15.8324 8.70583 15.8324 9.16583V9.99917C14.4541 9.99917 13.3324 11.1208 13.3324 12.4992C13.3324 13.6325 14.1441 14.5908 15.2616 14.7767L17.7958 15.1992C18.1066 15.2508 18.3324 15.5175 18.3324 15.8325C18.3324 16.2917 17.9591 16.6658 17.4991 16.6658H15.6091C15.3124 16.6658 15.0358 16.5058 14.8866 16.2492C14.6574 15.85 14.1483 15.7142 13.7483 15.945C13.3499 16.1758 13.2133 16.685 13.4449 17.0833C13.8899 17.8542 14.7199 18.3325 15.6099 18.3325H15.8333V19.1658C15.8333 19.6258 16.2058 19.9992 16.6666 19.9992C17.1274 19.9992 17.4999 19.6258 17.4999 19.1658V18.3325C18.8783 18.3325 19.9999 17.2108 19.9999 15.8325C19.9999 14.6992 19.1883 13.7417 18.0708 13.5558ZM6.24992 12.5H10.8333C11.2941 12.5 11.6666 12.1267 11.6666 11.6667C11.6666 11.2067 11.2941 10.8333 10.8333 10.8333H6.24992C5.10159 10.8333 4.16659 11.7683 4.16659 12.9167V14.5833C4.16659 15.7317 5.10159 16.6667 6.24992 16.6667H10.8333C11.2941 16.6667 11.6666 16.2933 11.6666 15.8333C11.6666 15.3733 11.2941 15 10.8333 15H6.24992C6.01992 15 5.83325 14.8133 5.83325 14.5833V12.9167C5.83325 12.6867 6.01992 12.5 6.24992 12.5ZM4.99992 9.16667H6.66659C7.12659 9.16667 7.49992 8.79333 7.49992 8.33333C7.49992 7.87333 7.12659 7.5 6.66659 7.5H4.99992C4.53992 7.5 4.16659 7.87333 4.16659 8.33333C4.16659 8.79333 4.53992 9.16667 4.99992 9.16667ZM4.99992 5.83333H6.66659C7.12659 5.83333 7.49992 5.46 7.49992 5C7.49992 4.54 7.12659 4.16667 6.66659 4.16667H4.99992C4.53992 4.16667 4.16659 4.54 4.16659 5C4.16659 5.46 4.53992 5.83333 4.99992 5.83333Z",
        fill: "currentColor"
      }
    ) })
  }
), MP = () => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M7.33366 3.33333C8.25413 3.33333 9.00033 2.58714 9.00033 1.66667C9.00033 0.746192 8.25413 0 7.33366 0C6.41318 0 5.66699 0.746192 5.66699 1.66667C5.66699 2.58714 6.41318 3.33333 7.33366 3.33333Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M7.33366 11.6668C8.25413 11.6668 9.00033 10.9206 9.00033 10.0002C9.00033 9.07969 8.25413 8.3335 7.33366 8.3335C6.41318 8.3335 5.66699 9.07969 5.66699 10.0002C5.66699 10.9206 6.41318 11.6668 7.33366 11.6668Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M7.33366 19.9998C8.25413 19.9998 9.00033 19.2536 9.00033 18.3332C9.00033 17.4127 8.25413 16.6665 7.33366 16.6665C6.41318 16.6665 5.66699 17.4127 5.66699 18.3332C5.66699 19.2536 6.41318 19.9998 7.33366 19.9998Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M12.6667 3.33333C13.5871 3.33333 14.3333 2.58714 14.3333 1.66667C14.3333 0.746192 13.5871 0 12.6667 0C11.7462 0 11 0.746192 11 1.66667C11 2.58714 11.7462 3.33333 12.6667 3.33333Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M12.6667 11.6668C13.5871 11.6668 14.3333 10.9206 14.3333 10.0002C14.3333 9.07969 13.5871 8.3335 12.6667 8.3335C11.7462 8.3335 11 9.07969 11 10.0002C11 10.9206 11.7462 11.6668 12.6667 11.6668Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M12.6667 19.9998C13.5871 19.9998 14.3333 19.2536 14.3333 18.3332C14.3333 17.4127 13.5871 16.6665 12.6667 16.6665C11.7462 16.6665 11 17.4127 11 18.3332C11 19.2536 11.7462 19.9998 12.6667 19.9998Z",
          fill: "currentColor"
        }
      )
    ]
  }
), EP = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsx("g", { clipPath: "url(#clip0_2127_32960)", children: /* @__PURE__ */ f.jsx(
      "path",
      {
        d: "M10.8333 4.99954H4.16667C1.86667 4.99954 0 6.86621 0 9.16621V15.8329C0 18.1329 1.86667 19.9995 4.16667 19.9995H10.8333C13.1333 19.9995 15 18.1329 15 15.8329V9.16621C15 6.86621 13.1333 4.99954 10.8333 4.99954ZM4.16667 6.66621H10.8333C12.2083 6.66621 13.3333 7.79121 13.3333 9.16621H1.66667C1.66667 7.79121 2.79167 6.66621 4.16667 6.66621ZM10.8333 18.3329H4.16667C2.79167 18.3329 1.66667 17.2079 1.66667 15.8329V10.8329H13.3333V15.8329C13.3333 17.2079 12.2083 18.3329 10.8333 18.3329ZM20 4.16621V11.2829C20 12.7662 19.2 14.1495 17.9167 14.8912C17.7833 14.9662 17.6417 14.9995 17.5 14.9995C17.2083 14.9995 16.9333 14.8495 16.775 14.5829C16.5417 14.1829 16.6833 13.6745 17.075 13.4412C17.85 12.9912 18.325 12.1662 18.325 11.2745V4.16621C18.325 2.79121 17.2 1.66621 15.825 1.66621H8.71667C7.825 1.66621 7 2.14954 6.55 2.91621C6.31667 3.31621 5.80833 3.44954 5.40833 3.21621C5.00833 2.98288 4.875 2.47454 5.10833 2.07454C5.85 0.791211 7.23333 -0.00878906 8.71667 -0.00878906H15.8333C18.1333 -0.00878906 20 1.85788 20 4.15788V4.16621Z",
        fill: "currentColor"
      }
    ) })
  }
), PP = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsxs("g", { clipPath: "url(#clip0_2341_562)", children: [
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M15.5468 0.775223L5.38676 10.9352C4.99872 11.3212 4.69108 11.7803 4.48167 12.2859C4.27225 12.7916 4.16522 13.3338 4.16676 13.8811V15.0002C4.16676 15.2212 4.25456 15.4332 4.41084 15.5895C4.56712 15.7458 4.77908 15.8336 5.0001 15.8336H6.11926C6.66657 15.8351 7.20874 15.7281 7.71439 15.5187C8.22005 15.3092 8.67914 15.0016 9.0651 14.6136L19.2251 4.45356C19.7121 3.96536 19.9856 3.30395 19.9856 2.61439C19.9856 1.92483 19.7121 1.26341 19.2251 0.775223C18.7298 0.301801 18.0711 0.0375977 17.3859 0.0375977C16.7008 0.0375977 16.042 0.301801 15.5468 0.775223ZM18.0468 3.27522L7.88676 13.4352C7.41687 13.9022 6.78177 14.1652 6.11926 14.1669H5.83343V13.8811C5.83517 13.2186 6.09807 12.5835 6.5651 12.1136L16.7251 1.95356C16.9031 1.78352 17.1398 1.68863 17.3859 1.68863C17.6321 1.68863 17.8688 1.78352 18.0468 1.95356C18.2217 2.12899 18.32 2.36663 18.32 2.61439C18.32 2.86215 18.2217 3.09979 18.0468 3.27522Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M19.1667 7.4825C18.9457 7.4825 18.7337 7.5703 18.5774 7.72658C18.4211 7.88286 18.3333 8.09482 18.3333 8.31583V12.5H15C14.337 12.5 13.7011 12.7634 13.2322 13.2322C12.7634 13.7011 12.5 14.337 12.5 15V18.3333H4.16667C3.50363 18.3333 2.86774 18.0699 2.3989 17.6011C1.93006 17.1323 1.66667 16.4964 1.66667 15.8333V4.16667C1.66667 3.50363 1.93006 2.86774 2.3989 2.3989C2.86774 1.93006 3.50363 1.66667 4.16667 1.66667H11.7017C11.9227 1.66667 12.1346 1.57887 12.2909 1.42259C12.4472 1.26631 12.535 1.05435 12.535 0.833333C12.535 0.61232 12.4472 0.400358 12.2909 0.244078C12.1346 0.0877974 11.9227 0 11.7017 0L4.16667 0C3.062 0.00132321 2.00296 0.440735 1.22185 1.22185C0.440735 2.00296 0.00132321 3.062 0 4.16667L0 15.8333C0.00132321 16.938 0.440735 17.997 1.22185 18.7782C2.00296 19.5593 3.062 19.9987 4.16667 20H13.6192C14.1666 20.0016 14.7089 19.8945 15.2147 19.6851C15.7205 19.4757 16.1797 19.1681 16.5658 18.78L18.7792 16.565C19.1673 16.1791 19.475 15.72 19.6846 15.2143C19.8941 14.7087 20.0013 14.1665 20 13.6192V8.31583C20 8.09482 19.9122 7.88286 19.7559 7.72658C19.5996 7.5703 19.3877 7.4825 19.1667 7.4825ZM15.3875 17.6017C15.0525 17.9358 14.6289 18.1672 14.1667 18.2683V15C14.1667 14.779 14.2545 14.567 14.4107 14.4107C14.567 14.2545 14.779 14.1667 15 14.1667H18.2708C18.1677 14.6279 17.9367 15.0508 17.6042 15.3867L15.3875 17.6017Z",
          fill: "currentColor"
        }
      )
    ] })
  }
), jP = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsx("g", { clipPath: "url(#clip0_2462_9634)", children: /* @__PURE__ */ f.jsx(
      "path",
      {
        d: "M15.55 17.4167C15.2083 17.1083 14.675 17.1417 14.375 17.4917C13.9 18.0333 13.2167 18.3417 12.5 18.3417H4.16667C2.79167 18.3417 1.66667 17.2167 1.66667 15.8417V4.16667C1.66667 2.79167 2.79167 1.66667 4.16667 1.66667H7.925C8.05833 1.66667 8.2 1.66667 8.33333 1.68333V5.83333C8.33333 7.20833 9.45833 8.33333 10.8333 8.33333H15.675C15.9333 8.33333 16.175 8.21667 16.3333 8.00833C16.4917 7.8 16.5417 7.54167 16.4833 7.29167C16.225 6.275 15.7 5.35 14.9583 4.60833L12.0583 1.70833C10.9583 0.608333 9.49167 0 7.93333 0H4.16667C1.86667 0 0 1.86667 0 4.16667V15.8333C0 18.1333 1.86667 20 4.16667 20H12.5C13.6917 20 14.8333 19.4833 15.625 18.5917C15.9333 18.25 15.9 17.7167 15.55 17.4167ZM10 2.21667C10.3167 2.4 10.6083 2.625 10.875 2.89167L13.775 5.79167C14.0333 6.05 14.2583 6.35 14.4417 6.66667H10.825C10.3667 6.66667 9.99167 6.29167 9.99167 5.83333V2.21667H10ZM19.275 15.075L17.9333 16.4167C17.7667 16.5833 17.5583 16.6583 17.3417 16.6583C17.125 16.6583 16.9167 16.575 16.75 16.4167C16.425 16.0917 16.425 15.5667 16.75 15.2417L17.825 14.1667H11.6583C11.2 14.1667 10.825 13.7917 10.825 13.3333C10.825 12.875 11.2 12.5 11.6583 12.5H17.825L16.75 11.425C16.425 11.1 16.425 10.575 16.75 10.25C17.075 9.925 17.6 9.925 17.925 10.25L19.2667 11.5917C20.225 12.55 20.225 14.1167 19.2667 15.0833L19.275 15.075Z",
        fill: "currentColor"
      }
    ) })
  }
), SP = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsxs("g", { clipPath: "url(#clip0_842_5289)", fill: "currentColor", children: [
      /* @__PURE__ */ f.jsx("path", { d: "M19.392 7.85C18.1 5.745 15.16 2.213 10 2.213c-5.16 0-8.1 3.532-9.393 5.637a4.09 4.09 0 000 4.301C1.9 14.256 4.84 17.788 10 17.788c5.16 0 8.1-3.532 9.392-5.637a4.09 4.09 0 000-4.301zm-1.42 3.429c-1.11 1.805-3.623 4.842-7.972 4.842-4.35 0-6.862-3.037-7.972-4.842a2.431 2.431 0 010-2.557C3.138 6.917 5.651 3.88 10 3.88s6.861 3.034 7.971 4.842a2.432 2.432 0 010 2.557z" }),
      /* @__PURE__ */ f.jsx("path", { d: "M10 5.833a4.167 4.167 0 100 8.333 4.167 4.167 0 000-8.333zm0 6.667A2.5 2.5 0 1110 7.5a2.5 2.5 0 010 4.999z" })
    ] })
  }
), IP = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsx("g", { clipPath: "url(#clip0_842_5318)", children: /* @__PURE__ */ f.jsx(
      "path",
      {
        d: "M19.392 7.849a13.22 13.22 0 00-2.809-3.258l2.334-2.333a.833.833 0 00-1.179-1.178l-2.537 2.54A10.045 10.045 0 0010 2.212c-5.16 0-8.1 3.532-9.393 5.637a4.09 4.09 0 000 4.301 13.222 13.222 0 002.81 3.258l-2.334 2.333a.833.833 0 101.178 1.179l2.544-2.544A10.044 10.044 0 0010 17.787c5.159 0 8.099-3.531 9.392-5.636a4.09 4.09 0 000-4.302zM2.027 11.278a2.432 2.432 0 010-2.557C3.14 6.916 5.651 3.88 10 3.88a8.417 8.417 0 013.972.97l-1.678 1.678a4.16 4.16 0 00-5.767 5.767l-1.925 1.925a11.435 11.435 0 01-2.575-2.941zM12.5 10a2.5 2.5 0 01-2.5 2.5 2.458 2.458 0 01-1.071-.25l3.32-3.321c.164.333.25.7.25 1.07zm-5 0A2.5 2.5 0 0110 7.5a2.46 2.46 0 011.07.25l-3.32 3.32A2.46 2.46 0 017.5 10zm10.472 1.278C16.861 13.083 14.348 16.12 10 16.12a8.417 8.417 0 01-3.972-.97l1.678-1.678a4.16 4.16 0 005.766-5.767l1.925-1.925c1.021.826 1.892 1.82 2.575 2.941a2.431 2.431 0 010 2.557z",
        fill: "currentColor"
      }
    ) })
  }
), BP = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsxs("g", { clipPath: "url(#clip0_2127_51729)", children: [
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M1.2474 4.58208H3.5274C3.70626 5.24019 4.09671 5.82116 4.6385 6.23536C5.1803 6.64956 5.84333 6.87397 6.52531 6.87397C7.2073 6.87397 7.87033 6.64956 8.41212 6.23536C8.95392 5.82116 9.34437 5.24019 9.52323 4.58208H19.5807C19.8017 4.58208 20.0137 4.49429 20.17 4.33801C20.3263 4.18173 20.4141 3.96976 20.4141 3.74875C20.4141 3.52774 20.3263 3.31578 20.17 3.1595C20.0137 3.00321 19.8017 2.91542 19.5807 2.91542H9.52323C9.34437 2.25731 8.95392 1.67634 8.41212 1.26214C7.87033 0.847944 7.2073 0.623535 6.52531 0.623535C5.84333 0.623535 5.1803 0.847944 4.6385 1.26214C4.09671 1.67634 3.70626 2.25731 3.5274 2.91542H1.2474C1.02638 2.91542 0.81442 3.00321 0.65814 3.1595C0.50186 3.31578 0.414063 3.52774 0.414062 3.74875C0.414063 3.96976 0.50186 4.18173 0.65814 4.33801C0.81442 4.49429 1.02638 4.58208 1.2474 4.58208ZM6.5249 2.29042C6.81333 2.29042 7.09528 2.37595 7.3351 2.53619C7.57492 2.69643 7.76184 2.9242 7.87222 3.19067C7.9826 3.45715 8.01148 3.75037 7.95521 4.03326C7.89894 4.31615 7.76004 4.576 7.55609 4.77995C7.35214 4.9839 7.09229 5.12279 6.8094 5.17906C6.52651 5.23533 6.23329 5.20645 5.96682 5.09608C5.70034 4.9857 5.47258 4.79878 5.31234 4.55896C5.15209 4.31914 5.06656 4.03718 5.06656 3.74875C5.067 3.36211 5.22079 2.99144 5.49419 2.71804C5.76758 2.44465 6.13826 2.29086 6.5249 2.29042Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M19.5807 10.1667H17.3007C17.1222 9.50846 16.7319 8.92728 16.1901 8.51291C15.6484 8.09854 14.9853 7.87402 14.3032 7.87402C13.6212 7.87402 12.9581 8.09854 12.4163 8.51291C11.8746 8.92728 11.4843 9.50846 11.3057 10.1667H1.2474C1.02638 10.1667 0.81442 10.2545 0.65814 10.4108C0.50186 10.5671 0.414063 10.779 0.414062 11.0001C0.414063 11.2211 0.50186 11.433 0.65814 11.5893C0.81442 11.7456 1.02638 11.8334 1.2474 11.8334H11.3057C11.4843 12.4916 11.8746 13.0728 12.4163 13.4872C12.9581 13.9016 13.6212 14.1261 14.3032 14.1261C14.9853 14.1261 15.6484 13.9016 16.1901 13.4872C16.7319 13.0728 17.1222 12.4916 17.3007 11.8334H19.5807C19.8017 11.8334 20.0137 11.7456 20.17 11.5893C20.3263 11.433 20.4141 11.2211 20.4141 11.0001C20.4141 10.779 20.3263 10.5671 20.17 10.4108C20.0137 10.2545 19.8017 10.1667 19.5807 10.1667ZM14.3032 12.4584C14.0148 12.4584 13.7328 12.3729 13.493 12.2126C13.2532 12.0524 13.0663 11.8246 12.9559 11.5581C12.8455 11.2917 12.8166 10.9984 12.8729 10.7155C12.9292 10.4327 13.0681 10.1728 13.272 9.96885C13.476 9.7649 13.7358 9.62601 14.0187 9.56974C14.3016 9.51347 14.5948 9.54235 14.8613 9.65273C15.1278 9.76311 15.3555 9.95002 15.5158 10.1898C15.676 10.4297 15.7616 10.7116 15.7616 11.0001C15.7611 11.3867 15.6073 11.7574 15.3339 12.0308C15.0605 12.3042 14.6899 12.4579 14.3032 12.4584Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M19.5807 17.4179H9.52323C9.34437 16.7597 8.95392 16.1788 8.41212 15.7646C7.87033 15.3504 7.2073 15.126 6.52531 15.126C5.84333 15.126 5.1803 15.3504 4.6385 15.7646C4.09671 16.1788 3.70626 16.7597 3.5274 17.4179H1.2474C1.02638 17.4179 0.81442 17.5057 0.65814 17.6619C0.50186 17.8182 0.414063 18.0302 0.414062 18.2512C0.414063 18.4722 0.50186 18.6842 0.65814 18.8404C0.81442 18.9967 1.02638 19.0845 1.2474 19.0845H3.5274C3.70626 19.7426 4.09671 20.3236 4.6385 20.7378C5.1803 21.152 5.84333 21.3764 6.52531 21.3764C7.2073 21.3764 7.87033 21.152 8.41212 20.7378C8.95392 20.3236 9.34437 19.7426 9.52323 19.0845H19.5807C19.8017 19.0845 20.0137 18.9967 20.17 18.8404C20.3263 18.6842 20.4141 18.4722 20.4141 18.2512C20.4141 18.0302 20.3263 17.8182 20.17 17.6619C20.0137 17.5057 19.8017 17.4179 19.5807 17.4179ZM6.5249 19.7095C6.23646 19.7095 5.95451 19.624 5.71469 19.4638C5.47487 19.3035 5.28795 19.0757 5.17757 18.8093C5.06719 18.5428 5.03831 18.2496 5.09458 17.9667C5.15085 17.6838 5.28975 17.4239 5.4937 17.22C5.69765 17.016 5.9575 16.8772 6.24039 16.8209C6.52328 16.7646 6.8165 16.7935 7.08298 16.9039C7.34945 17.0142 7.57721 17.2012 7.73746 17.441C7.8977 17.6808 7.98323 17.9628 7.98323 18.2512C7.98257 18.6378 7.82871 19.0083 7.55536 19.2817C7.28202 19.555 6.91147 19.7089 6.5249 19.7095Z",
          fill: "currentColor"
        }
      )
    ] })
  }
), NP = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsxs("g", { clipPath: "url(#clip0_2656_4413)", children: [
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M15.8333 0H4.16667C1.86667 0 0 1.86667 0 4.16667V15.8333C0 18.1333 1.86667 20 4.16667 20H8.69167C9.15 20 9.525 19.625 9.525 19.1667C9.525 18.7083 9.15 18.3333 8.69167 18.3333H4.16667C2.78333 18.3333 1.66667 17.2167 1.66667 15.8333V4.16667C1.66667 2.78333 2.78333 1.66667 4.16667 1.66667H15.8333C17.2167 1.66667 18.3333 2.78333 18.3333 4.16667V7.78333C18.3333 8.24167 18.7083 8.61667 19.1667 8.61667C19.625 8.61667 20 8.24167 20 7.78333V4.16667C20 1.86667 18.1333 0 15.8333 0Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M9.67511 9.6333C9.67511 10.9416 8.60844 12.0083 7.30011 12.0083V12.8C7.30011 13.2416 6.94178 13.5916 6.50844 13.5916C6.07511 13.5916 5.71678 13.2333 5.71678 12.8V12.0083H5.50844C4.65844 12.0083 3.87511 11.55 3.45011 10.8166C3.23344 10.4333 3.35844 9.94997 3.74178 9.7333C4.12511 9.5083 4.60844 9.64163 4.82511 10.025C4.96678 10.2666 5.23344 10.425 5.50844 10.425H7.30844C7.75011 10.425 8.10011 10.0666 8.10011 9.6333C8.10011 9.3333 7.88344 9.0833 7.59178 9.0333L5.18344 8.6333C4.11678 8.4583 3.35011 7.54163 3.35011 6.46663C3.35011 5.1583 4.41678 4.09163 5.72511 4.09163V3.29997C5.72511 2.8583 6.08344 2.5083 6.51678 2.5083C6.95011 2.5083 7.30844 2.86663 7.30844 3.29997V4.09163H7.51678C8.36678 4.09163 9.15011 4.54997 9.57511 5.2833C9.79178 5.6583 9.66678 6.14997 9.28344 6.36663C8.90011 6.5833 8.41678 6.4583 8.20011 6.07497C8.05844 5.8333 7.79178 5.67497 7.51678 5.67497H5.71678C5.27511 5.67497 4.92511 6.0333 4.92511 6.46663C4.92511 6.76663 5.14178 7.01663 5.43344 7.06663L7.84178 7.46663C8.90844 7.64163 9.67511 8.5583 9.67511 9.6333Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M19.8916 11.2499C19.6583 10.8499 19.15 10.7166 18.75 10.9416L17.9416 11.4083C17.35 10.7499 16.575 10.2583 15.675 10.0833V9.16659C15.675 8.70825 15.3 8.33325 14.8416 8.33325C14.3833 8.33325 14.0083 8.70825 14.0083 9.16659V10.0833C13.1083 10.2666 12.325 10.7499 11.7416 11.4083L10.9333 10.9416C10.5333 10.7083 10.025 10.8499 9.79164 11.2499C9.55831 11.6499 9.69997 12.1583 10.1 12.3916L10.9083 12.8583C10.7666 13.2749 10.675 13.7083 10.675 14.1666C10.675 14.6249 10.7666 15.0583 10.9083 15.4749L10.1 15.9416C9.69997 16.1749 9.56664 16.6833 9.79164 17.0833C9.94997 17.3499 10.225 17.4999 10.5166 17.4999C10.6583 17.4999 10.8 17.4666 10.9333 17.3916L11.7416 16.9249C12.3333 17.5833 13.1083 18.0749 14.0083 18.2499V19.1666C14.0083 19.6249 14.3833 19.9999 14.8416 19.9999C15.3 19.9999 15.675 19.6249 15.675 19.1666V18.2499C16.575 18.0666 17.3583 17.5833 17.9416 16.9249L18.75 17.3916C18.8833 17.4666 19.025 17.4999 19.1666 17.4999C19.4583 17.4999 19.7333 17.3499 19.8916 17.0833C20.125 16.6833 19.9833 16.1749 19.5833 15.9416L18.775 15.4749C18.9166 15.0583 19.0083 14.6249 19.0083 14.1666C19.0083 13.7083 18.9166 13.2666 18.775 12.8583L19.5833 12.3916C19.9833 12.1583 20.1166 11.6499 19.8916 11.2499ZM14.8416 16.6666C13.4666 16.6666 12.3416 15.5416 12.3416 14.1666C12.3416 12.7916 13.4666 11.6666 14.8416 11.6666C16.2166 11.6666 17.3416 12.7916 17.3416 14.1666C17.3416 15.5416 16.2166 16.6666 14.8416 16.6666Z",
          fill: "currentColor"
        }
      )
    ] })
  }
), _P = () => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 65 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M50.072 28.858A14.429 14.429 0 1164.5 14.428c-.01 7.965-6.463 14.42-14.428 14.429v.002zm0-26.358A11.928 11.928 0 1062 14.43C61.992 7.844 56.657 2.507 50.072 2.5z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M50.071 18.817c-.69 0-1.25-.56-1.25-1.25v-.087a5.753 5.753 0 012.729-4.855 2.766 2.766 0 10-4.245-2.338 1.25 1.25 0 11-2.5 0 5.288 5.288 0 011.673-3.85 5.22 5.22 0 013.965-1.402 5.267 5.267 0 012.445 9.705 3.258 3.258 0 00-1.567 2.742v.087c0 .69-.56 1.25-1.25 1.25v-.002zM50.072 23.837a1.19 1.19 0 01-.477-.095 1.195 1.195 0 01-.218-.117 1.208 1.208 0 01-.46-.561 1.26 1.26 0 01-.072-.727 1.26 1.26 0 01.982-.982 1.206 1.206 0 01.723.072 1.326 1.326 0 01.405.27 1.218 1.218 0 01.27.407 1.26 1.26 0 01.072.726 1.05 1.05 0 01-.072.234c-.032.075-.07.148-.114.216a1.277 1.277 0 01-1.038.557h-.002zM53.625 64H6.36A5.866 5.866 0 01.5 58.14V31.658a5.879 5.879 0 012.392-4.723l5.033-3.698a1.251 1.251 0 011.482 2.015L4.375 28.95A3.378 3.378 0 003 31.66V58.14a3.363 3.363 0 003.36 3.36h47.265a3.363 3.363 0 003.36-3.36V31.658a3.374 3.374 0 00-1.375-2.708L54 27.765a1.25 1.25 0 011.476-2.015l1.612 1.185a5.885 5.885 0 012.392 4.724V58.14A5.866 5.866 0 0153.625 64z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M56.663 62.85c-.266 0-.526-.085-.74-.243L35.938 47.923a1.25 1.25 0 111.48-2.015l19.987 14.684a1.25 1.25 0 01-.74 2.258h-.002zM3.317 62.85a1.252 1.252 0 01-.742-2.258l19.987-14.684a1.25 1.25 0 111.48 2.015L4.055 62.607a1.24 1.24 0 01-.738.243z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M29.99 52.278a5.852 5.852 0 01-3.707-1.313L1.401 30.653a1.253 1.253 0 01-.205-1.78c.214-.261.524-.426.86-.454.337-.03.67.078.925.298l24.882 20.31a3.376 3.376 0 004.25 0L57 28.717a1.251 1.251 0 111.581 1.937l-24.875 20.31a5.852 5.852 0 01-3.716 1.314z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M51.313 36.22c-.69 0-1.25-.56-1.25-1.25V27.55a1.25 1.25 0 112.5 0v7.421c0 .69-.56 1.25-1.25 1.25zM8.665 36.22c-.69 0-1.25-.56-1.25-1.25V10.875a5.869 5.869 0 015.862-5.86H39.72a1.25 1.25 0 010 2.5H13.277a3.365 3.365 0 00-3.362 3.36V34.97c0 .69-.56 1.25-1.25 1.25z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M28.106 13.797H15.555a1.25 1.25 0 010-2.5h12.551a1.25 1.25 0 010 2.5zM37.885 20.698H15.557a1.25 1.25 0 010-2.5h22.328a1.25 1.25 0 010 2.5zM44.423 27.602H15.557a1.25 1.25 0 010-2.5h28.868a1.25 1.25 0 010 2.5h-.002zM44.423 34.5H15.557a1.25 1.25 0 010-2.5h28.868a1.25 1.25 0 010 2.5h-.002zM44.423 41.408H15.557a1.25 1.25 0 010-2.5h28.868a1.25 1.25 0 010 2.5h-.002z",
          fill: "currentColor"
        }
      )
    ]
  }
), LP = () => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ f.jsx("path", { d: "M10 25.7719L22.3062 11.6425C23.0758 10.7589 24.4367 10.7232 25.2516 11.5653L39 25.7719", stroke: "black", strokeLinecap: "round" }),
      /* @__PURE__ */ f.jsx("path", { d: "M13.0527 22.2105V34.9649C13.0527 36.0695 13.9481 36.9649 15.0527 36.9649H33.4386C34.5432 36.9649 35.4386 36.0695 35.4386 34.9649V22.2105", stroke: "black", strokeLinecap: "round" }),
      /* @__PURE__ */ f.jsx("rect", { x: "21.286", y: "23.0836", width: "6.19064", height: "6.19064", rx: "1.5", stroke: "black" })
    ]
  }
), TP = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        d: "M15.8333 21.0018H4.16667C1.86917 21.0018 0 19.1326 0 16.8351V9.10513C0 7.71763 0.686667 6.42596 1.83667 5.65096L7.66917 1.7143C9.085 0.759297 10.915 0.759297 12.3308 1.7143L18.1642 5.65096C19.3133 6.42596 20 7.7168 20 9.10513V16.8351C20 19.1326 18.1308 21.0018 15.8333 21.0018ZM10 2.66596C9.51333 2.66596 9.02667 2.8093 8.60167 3.0968L2.76833 7.03263C2.07833 7.49763 1.66667 8.2718 1.66667 9.1043V16.8343C1.66667 18.2126 2.78833 19.3343 4.16667 19.3343H15.8333C17.2117 19.3343 18.3333 18.2126 18.3333 16.8343V9.10513C18.3333 8.27263 17.9217 7.49763 17.2325 7.03346L11.3983 3.0968C10.9733 2.8093 10.4867 2.66596 10 2.66596Z",
        fill: "currentColor"
      }
    )
  }
), RP = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsxs("g", { clipPath: "url(#clip0_2127_30847)", children: [
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M15.8334 7.02V5.83333C15.8334 4.28624 15.2188 2.80251 14.1249 1.70854C13.0309 0.614582 11.5472 0 10.0001 0C8.45298 0 6.96925 0.614582 5.87529 1.70854C4.78133 2.80251 4.16675 4.28624 4.16675 5.83333V7.02C3.42455 7.34392 2.79283 7.8771 2.34883 8.55434C1.90484 9.23158 1.66781 10.0235 1.66675 10.8333V15.8333C1.66807 16.938 2.10748 17.997 2.8886 18.7782C3.66971 19.5593 4.72875 19.9987 5.83341 20H14.1667C15.2714 19.9987 16.3305 19.5593 17.1116 18.7782C17.8927 17.997 18.3321 16.938 18.3334 15.8333V10.8333C18.3323 10.0235 18.0953 9.23158 17.6513 8.55434C17.2073 7.8771 16.5756 7.34392 15.8334 7.02ZM5.83341 5.83333C5.83341 4.72826 6.2724 3.66846 7.0538 2.88705C7.8352 2.10565 8.89501 1.66667 10.0001 1.66667C11.1052 1.66667 12.165 2.10565 12.9464 2.88705C13.7278 3.66846 14.1667 4.72826 14.1667 5.83333V6.66667H5.83341V5.83333ZM16.6667 15.8333C16.6667 16.4964 16.4034 17.1323 15.9345 17.6011C15.4657 18.0699 14.8298 18.3333 14.1667 18.3333H5.83341C5.17037 18.3333 4.53449 18.0699 4.06565 17.6011C3.59681 17.1323 3.33341 16.4964 3.33341 15.8333V10.8333C3.33341 10.1703 3.59681 9.53441 4.06565 9.06557C4.53449 8.59672 5.17037 8.33333 5.83341 8.33333H14.1667C14.8298 8.33333 15.4657 8.59672 15.9345 9.06557C16.4034 9.53441 16.6667 10.1703 16.6667 10.8333V15.8333Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M10.0001 11.6667C9.77907 11.6667 9.56711 11.7545 9.41083 11.9108C9.25455 12.0671 9.16675 12.2791 9.16675 12.5001V14.1667C9.16675 14.3878 9.25455 14.5997 9.41083 14.756C9.56711 14.9123 9.77907 15.0001 10.0001 15.0001C10.2211 15.0001 10.4331 14.9123 10.5893 14.756C10.7456 14.5997 10.8334 14.3878 10.8334 14.1667V12.5001C10.8334 12.2791 10.7456 12.0671 10.5893 11.9108C10.4331 11.7545 10.2211 11.6667 10.0001 11.6667Z",
          fill: "currentColor"
        }
      )
    ] })
  }
), $P = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsxs("g", { clipPath: "url(#clip0_2127_30861)", children: [
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M9.56333 12.5C9.34232 12.5 9.13036 12.5878 8.97408 12.7441C8.8178 12.9004 8.73 13.1123 8.73 13.3333V15.8333C8.73 16.4964 8.46661 17.1323 7.99777 17.6011C7.52893 18.0699 6.89304 18.3333 6.23 18.3333H4.16667C3.50363 18.3333 2.86774 18.0699 2.3989 17.6011C1.93006 17.1323 1.66667 16.4964 1.66667 15.8333V4.16667C1.66667 3.50363 1.93006 2.86774 2.3989 2.3989C2.86774 1.93006 3.50363 1.66667 4.16667 1.66667H6.23C6.89304 1.66667 7.52893 1.93006 7.99777 2.3989C8.46661 2.86774 8.73 3.50363 8.73 4.16667V6.66667C8.73 6.88768 8.8178 7.09964 8.97408 7.25592C9.13036 7.4122 9.34232 7.5 9.56333 7.5C9.78435 7.5 9.99631 7.4122 10.1526 7.25592C10.3089 7.09964 10.3967 6.88768 10.3967 6.66667V4.16667C10.3953 3.062 9.95593 2.00296 9.17482 1.22185C8.3937 0.440735 7.33466 0.00132321 6.23 0H4.16667C3.062 0.00132321 2.00296 0.440735 1.22185 1.22185C0.440735 2.00296 0.00132321 3.062 0 4.16667L0 15.8333C0.00132321 16.938 0.440735 17.997 1.22185 18.7782C2.00296 19.5593 3.062 19.9987 4.16667 20H6.23C7.33466 19.9987 8.3937 19.5593 9.17482 18.7782C9.95593 17.997 10.3953 16.938 10.3967 15.8333V13.3333C10.3967 13.1123 10.3089 12.9004 10.1526 12.7441C9.99631 12.5878 9.78435 12.5 9.56333 12.5Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M19.0557 8.23232L15.234 4.41066C15.1571 4.33107 15.0652 4.26758 14.9635 4.22391C14.8618 4.18023 14.7525 4.15724 14.6418 4.15628C14.5312 4.15532 14.4215 4.1764 14.319 4.21831C14.2166 4.26021 14.1236 4.32208 14.0453 4.40033C13.9671 4.47857 13.9052 4.57161 13.8633 4.67403C13.8214 4.77644 13.8003 4.88618 13.8013 4.99682C13.8023 5.10747 13.8252 5.21682 13.8689 5.31849C13.9126 5.42016 13.9761 5.51212 14.0557 5.58899L17.6073 9.14149L4.99984 9.16649C4.77882 9.16649 4.56686 9.25429 4.41058 9.41057C4.2543 9.56685 4.1665 9.77881 4.1665 9.99982C4.1665 10.2208 4.2543 10.4328 4.41058 10.5891C4.56686 10.7454 4.77882 10.8332 4.99984 10.8332L17.6565 10.8073L14.054 14.4107C13.9744 14.4875 13.9109 14.5795 13.8673 14.6812C13.8236 14.7828 13.8006 14.8922 13.7996 15.0028C13.7987 15.1135 13.8198 15.2232 13.8617 15.3256C13.9036 15.428 13.9654 15.5211 14.0437 15.5993C14.1219 15.6776 14.215 15.7394 14.3174 15.7813C14.4198 15.8232 14.5295 15.8443 14.6402 15.8434C14.7508 15.8424 14.8602 15.8194 14.9618 15.7757C15.0635 15.7321 15.1555 15.6686 15.2323 15.589L19.054 11.7673C19.5229 11.2987 19.7865 10.6631 19.7868 10.0002C19.7871 9.33726 19.5241 8.70136 19.0557 8.23232Z",
          fill: "currentColor"
        }
      )
    ] })
  }
), FP = () => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 20 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M19.1667 6.16699H0.833333C0.373096 6.16699 0 6.54009 0 7.00033C0 7.46056 0.373096 7.83366 0.833333 7.83366H19.1667C19.6269 7.83366 20 7.46056 20 7.00033C20 6.54009 19.6269 6.16699 19.1667 6.16699Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M19.1667 0.333496H0.833333C0.373096 0.333496 0 0.706592 0 1.16683C0 1.62707 0.373096 2.00016 0.833333 2.00016H19.1667C19.6269 2.00016 20 1.62707 20 1.16683C20 0.706592 19.6269 0.333496 19.1667 0.333496Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M19.1667 12H0.833333C0.373096 12 0 12.3731 0 12.8333C0 13.2936 0.373096 13.6667 0.833333 13.6667H19.1667C19.6269 13.6667 20 13.2936 20 12.8333C20 12.3731 19.6269 12 19.1667 12Z",
          fill: "currentColor"
        }
      )
    ]
  }
), HP = () => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M9.99992 3.33333C10.9204 3.33333 11.6666 2.58714 11.6666 1.66667C11.6666 0.746192 10.9204 0 9.99992 0C9.07944 0 8.33325 0.746192 8.33325 1.66667C8.33325 2.58714 9.07944 3.33333 9.99992 3.33333Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M9.99992 11.6668C10.9204 11.6668 11.6666 10.9206 11.6666 10.0002C11.6666 9.07969 10.9204 8.3335 9.99992 8.3335C9.07944 8.3335 8.33325 9.07969 8.33325 10.0002C8.33325 10.9206 9.07944 11.6668 9.99992 11.6668Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M9.99992 19.9998C10.9204 19.9998 11.6666 19.2536 11.6666 18.3332C11.6666 17.4127 10.9204 16.6665 9.99992 16.6665C9.07944 16.6665 8.33325 17.4127 8.33325 18.3332C8.33325 19.2536 9.07944 19.9998 9.99992 19.9998Z",
          fill: "currentColor"
        }
      )
    ]
  }
), YP = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        d: "M18.91 11.382l-1.583-5.696a7.767 7.767 0 00-15.065.395l-1.225 5.512a4.166 4.166 0 004.067 5.07h.928a4.166 4.166 0 008.166 0h.698a4.166 4.166 0 004.014-5.281zm-8.795 6.947a2.5 2.5 0 01-2.346-1.666h4.692a2.5 2.5 0 01-2.346 1.666zm6.77-4.32a2.48 2.48 0 01-1.99.987H5.104a2.5 2.5 0 01-2.44-3.042L3.89 6.442a6.1 6.1 0 0111.832-.31l1.583 5.696a2.48 2.48 0 01-.418 2.181z",
        fill: "currentColor"
      }
    )
  }
), VP = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        d: "M15.4374 6.63908L7.48643 0.805027C6.86542 0.350291 6.13061 0.0764315 5.36347 0.0138145C4.59632 -0.0488024 3.82682 0.10227 3.1403 0.45028C2.45377 0.798291 1.87704 1.32964 1.47406 1.98541C1.07108 2.64118 0.857591 3.39575 0.857269 4.16544V15.8336C0.857407 16.6036 1.07091 17.3585 1.47407 18.0146C1.87724 18.6707 2.45431 19.2022 3.14124 19.5502C3.82816 19.8982 4.59807 20.049 5.36553 19.986C6.13299 19.923 6.86798 19.6485 7.48892 19.1931L15.4399 13.3591C15.9677 12.972 16.3969 12.4661 16.6927 11.8823C16.9886 11.2985 17.1427 10.6532 17.1427 9.99867C17.1427 9.34417 16.9886 8.69887 16.6927 8.11505C16.3969 7.53123 15.9677 7.0253 15.4399 6.63825L15.4374 6.63908ZM14.4506 12.0148L6.49964 17.8488C6.1271 18.121 5.68651 18.2849 5.22662 18.3222C4.76673 18.3595 4.30549 18.2688 3.89395 18.0602C3.48241 17.8516 3.13662 17.5331 2.89486 17.1402C2.6531 16.7472 2.52479 16.295 2.52414 15.8336V4.16544C2.51952 3.70318 2.6454 3.24898 2.88734 2.85505C3.12927 2.46112 3.47743 2.14343 3.89181 1.9385C4.24427 1.75922 4.63402 1.66557 5.02945 1.66513C5.55943 1.66716 6.07476 1.83923 6.49964 2.15603L14.4506 7.99008C14.7669 8.22236 15.0241 8.52582 15.2013 8.87592C15.3786 9.22602 15.471 9.61292 15.471 10.0053C15.471 10.3977 15.3786 10.7847 15.2013 11.1348C15.0241 11.4848 14.7669 11.7883 14.4506 12.0206V12.0148Z",
        fill: "currentColor"
      }
    )
  }
), kP = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        d: "M15.8333 8.83333H11.1667V4.16667C11.1667 3.85725 11.0437 3.5605 10.825 3.34171C10.6062 3.12292 10.3094 3 10 3C9.69058 3 9.39383 3.12292 9.17504 3.34171C8.95625 3.5605 8.83333 3.85725 8.83333 4.16667V8.83333H4.16667C3.85725 8.83333 3.5605 8.95625 3.34171 9.17504C3.12292 9.39383 3 9.69058 3 10C3 10.3094 3.12292 10.6062 3.34171 10.825C3.5605 11.0437 3.85725 11.1667 4.16667 11.1667H8.83333V15.8333C8.83333 16.1428 8.95625 16.4395 9.17504 16.6583C9.39383 16.8771 9.69058 17 10 17C10.3094 17 10.6062 16.8771 10.825 16.6583C11.0437 16.4395 11.1667 16.1428 11.1667 15.8333V11.1667H15.8333C16.1428 11.1667 16.4395 11.0437 16.6583 10.825C16.8771 10.6062 17 10.3094 17 10C17 9.69058 16.8771 9.39383 16.6583 9.17504C16.4395 8.95625 16.1428 8.83333 15.8333 8.83333Z",
        fill: "currentColor"
      }
    )
  }
), GP = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsx("g", { clipPath: "url(#clip0_842_3889)", children: /* @__PURE__ */ f.jsx(
      "path",
      {
        d: "M15.8333 3.33333H14.9167C14.7233 2.39284 14.2115 1.54779 13.4677 0.940598C12.7239 0.333408 11.7935 0.0012121 10.8333 0L9.16667 0C8.2065 0.0012121 7.2761 0.333408 6.53229 0.940598C5.78848 1.54779 5.27675 2.39284 5.08333 3.33333H4.16667C3.062 3.33466 2.00296 3.77407 1.22185 4.55518C0.440735 5.3363 0.00132321 6.39534 0 7.5L0 15.8333C0.00132321 16.938 0.440735 17.997 1.22185 18.7782C2.00296 19.5593 3.062 19.9987 4.16667 20H15.8333C16.938 19.9987 17.997 19.5593 18.7782 18.7782C19.5593 17.997 19.9987 16.938 20 15.8333V7.5C19.9987 6.39534 19.5593 5.3363 18.7782 4.55518C17.997 3.77407 16.938 3.33466 15.8333 3.33333ZM9.16667 1.66667H10.8333C11.3485 1.6688 11.8505 1.83007 12.2706 2.12841C12.6906 2.42674 13.0083 2.84758 13.18 3.33333H6.82C6.99174 2.84758 7.30936 2.42674 7.72942 2.12841C8.14948 1.83007 8.65145 1.6688 9.16667 1.66667ZM4.16667 5H15.8333C16.4964 5 17.1323 5.26339 17.6011 5.73223C18.0699 6.20107 18.3333 6.83696 18.3333 7.5V10H1.66667V7.5C1.66667 6.83696 1.93006 6.20107 2.3989 5.73223C2.86774 5.26339 3.50363 5 4.16667 5ZM15.8333 18.3333H4.16667C3.50363 18.3333 2.86774 18.0699 2.3989 17.6011C1.93006 17.1323 1.66667 16.4964 1.66667 15.8333V11.6667H9.16667V12.5C9.16667 12.721 9.25446 12.933 9.41074 13.0893C9.56702 13.2455 9.77899 13.3333 10 13.3333C10.221 13.3333 10.433 13.2455 10.5893 13.0893C10.7455 12.933 10.8333 12.721 10.8333 12.5V11.6667H18.3333V15.8333C18.3333 16.4964 18.0699 17.1323 17.6011 17.6011C17.1323 18.0699 16.4964 18.3333 15.8333 18.3333Z",
        fill: "currentColor"
      }
    ) })
  }
), WP = () => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M10 0C8.02219 0 6.08879 0.58649 4.4443 1.6853C2.79981 2.78412 1.51809 4.3459 0.761209 6.17316C0.00433286 8.00043 -0.1937 10.0111 0.192152 11.9509C0.578004 13.8907 1.53041 15.6725 2.92894 17.0711C4.32746 18.4696 6.10929 19.422 8.0491 19.8078C9.98891 20.1937 11.9996 19.9957 13.8268 19.2388C15.6541 18.4819 17.2159 17.2002 18.3147 15.5557C19.4135 13.9112 20 11.9778 20 10C19.9971 7.34871 18.9426 4.80684 17.0679 2.9321C15.1932 1.05736 12.6513 0.00286757 10 0ZM10 18.3333C8.35183 18.3333 6.74066 17.8446 5.37025 16.9289C3.99984 16.0132 2.93174 14.7117 2.30101 13.189C1.67028 11.6663 1.50525 9.99075 1.82679 8.37425C2.14834 6.75774 2.94201 5.27288 4.10745 4.10744C5.27288 2.94201 6.75774 2.14833 8.37425 1.82679C9.99076 1.50525 11.6663 1.67027 13.189 2.301C14.7117 2.93173 16.0132 3.99984 16.9289 5.37025C17.8446 6.74066 18.3333 8.35182 18.3333 10C18.3309 12.2094 17.4522 14.3276 15.8899 15.8899C14.3276 17.4522 12.2094 18.3309 10 18.3333Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M10.5978 4.21903C10.1173 4.13147 9.62333 4.1506 9.15099 4.27506C8.67864 4.39952 8.23942 4.62628 7.8644 4.93928C7.48939 5.25228 7.18775 5.64388 6.98083 6.08636C6.77392 6.52884 6.66677 7.01139 6.66699 7.49986C6.66699 7.72087 6.75479 7.93284 6.91107 8.08912C7.06735 8.2454 7.27931 8.33319 7.50033 8.33319C7.72134 8.33319 7.9333 8.2454 8.08958 8.08912C8.24586 7.93284 8.33366 7.72087 8.33366 7.49986C8.33345 7.25467 8.38734 7.01246 8.49149 6.79049C8.59563 6.56852 8.74747 6.37227 8.93617 6.21572C9.12488 6.05917 9.3458 5.94618 9.58318 5.88481C9.82056 5.82345 10.0686 5.81521 10.3095 5.86069C10.6387 5.9246 10.9414 6.08518 11.1789 6.32193C11.4164 6.55869 11.5779 6.86086 11.6428 7.18986C11.7084 7.5352 11.6631 7.89242 11.5135 8.21047C11.3638 8.52852 11.1174 8.79111 10.8095 8.96069C10.2996 9.25608 9.87831 9.68279 9.58943 10.1964C9.30055 10.7099 9.15467 11.2916 9.16699 11.8807V12.4999C9.16699 12.7209 9.25479 12.9328 9.41107 13.0891C9.56735 13.2454 9.77931 13.3332 10.0003 13.3332C10.2213 13.3332 10.4333 13.2454 10.5896 13.0891C10.7459 12.9328 10.8337 12.7209 10.8337 12.4999V11.8807C10.8232 11.5907 10.8893 11.3031 11.0254 11.0468C11.1614 10.7905 11.3626 10.5745 11.6087 10.4207C12.2124 10.0891 12.6986 9.57857 13.0004 8.95936C13.3022 8.34015 13.4047 7.64266 13.2939 6.9628C13.1831 6.28294 12.8644 5.6541 12.3816 5.16277C11.8988 4.67144 11.2756 4.34175 10.5978 4.21903Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M10.8337 14.9998C10.8337 14.5396 10.4606 14.1665 10.0003 14.1665C9.54009 14.1665 9.16699 14.5396 9.16699 14.9998C9.16699 15.4601 9.54009 15.8332 10.0003 15.8332C10.4606 15.8332 10.8337 15.4601 10.8337 14.9998Z",
          fill: "currentColor"
        }
      )
    ]
  }
), QP = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsx("g", { clipPath: "url(#clip0_1353_11649)", children: /* @__PURE__ */ f.jsx("path", { d: "M19.7561 18.5773L14.782 13.6032C16.1375 11.9453 16.804 9.8299 16.6435 7.69445C16.4831 5.55901 15.508 3.56693 13.92 2.13025C12.3319 0.693577 10.2525 -0.0777715 8.11167 -0.024245C5.97088 0.0292815 3.93256 0.903588 2.41832 2.41783C0.904076 3.93207 0.0297698 5.97039 -0.0237567 8.11119C-0.0772832 10.252 0.694065 12.3314 2.13074 13.9195C3.56742 15.5075 5.5595 16.4826 7.69494 16.643C9.83038 16.8035 11.9458 16.137 13.6036 14.7815L18.5778 19.7557C18.735 19.9075 18.9455 19.9914 19.164 19.9895C19.3825 19.9876 19.5915 19.9 19.746 19.7455C19.9005 19.591 19.9881 19.382 19.99 19.1635C19.9919 18.945 19.9079 18.7345 19.7561 18.5773ZM8.33364 14.9998C7.0151 14.9998 5.72617 14.6088 4.62984 13.8763C3.53351 13.1437 2.67903 12.1025 2.17444 10.8844C1.66986 9.6662 1.53784 8.32576 1.79507 7.03255C2.05231 5.73934 2.68724 4.55146 3.61959 3.61911C4.55194 2.68676 5.73983 2.05182 7.03304 1.79458C8.32624 1.53735 9.66669 1.66937 10.8849 2.17395C12.103 2.67854 13.1442 3.53302 13.8768 4.62935C14.6093 5.72568 15.0003 7.01461 15.0003 8.33315C14.9983 10.1007 14.2953 11.7952 13.0455 13.045C11.7957 14.2948 10.1011 14.9978 8.33364 14.9998Z", fill: "currentColor" }) })
  }
), UP = () => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M16.743 10L8.25505 10C8.1049 9.9994 7.95831 9.95665 7.83381 9.87715C7.70931 9.79765 7.6125 9.68497 7.55561 9.55336C7.49873 9.42176 7.48433 9.27713 7.51423 9.13777C7.54413 8.99841 7.61699 8.87057 7.7236 8.77043L11.96 4.75815C12.0306 4.69075 12.1145 4.63726 12.207 4.60075C12.2996 4.56425 12.3988 4.54545 12.499 4.54545C12.5992 4.54545 12.6985 4.56425 12.791 4.60075C12.8835 4.63726 12.9675 4.69075 13.0381 4.75815L17.2744 8.77043C17.3811 8.87057 17.4539 8.99841 17.4838 9.13777C17.5137 9.27713 17.4993 9.42176 17.4424 9.55337C17.3855 9.68497 17.2887 9.79765 17.1642 9.87715C17.0397 9.95665 16.8931 9.9994 16.743 10Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M8.25505 14H16.743C16.8931 14.0006 17.0397 14.0433 17.1642 14.1228C17.2887 14.2023 17.3855 14.315 17.4424 14.4466C17.4993 14.5782 17.5137 14.7229 17.4838 14.8622C17.4539 15.0016 17.3811 15.1294 17.2744 15.2296L13.0381 19.2419C12.9675 19.3092 12.8835 19.3627 12.791 19.3992C12.6985 19.4358 12.5992 19.4545 12.499 19.4545C12.3988 19.4545 12.2996 19.4358 12.207 19.3992C12.1145 19.3627 12.0306 19.3092 11.96 19.2419L7.7236 15.2296C7.61699 15.1294 7.54413 15.0016 7.51423 14.8622C7.48433 14.7229 7.49873 14.5782 7.55561 14.4466C7.6125 14.315 7.70931 14.2023 7.83381 14.1228C7.95831 14.0433 8.1049 14.0006 8.25505 14Z",
          fill: "currentColor"
        }
      )
    ]
  }
), ZP = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 97 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsxs("g", { clipPath: "url(#clip0_1300_12843)", fill: "currentColor", children: [
      /* @__PURE__ */ f.jsx("path", { d: "M67.225 43.186c-.387 0-.778-.113-1.11-.34a29.453 29.453 0 00-7.388-3.625 1.96 1.96 0 01-1.356-1.861V20.11c0-4.326-3.537-7.845-7.885-7.845s-7.885 3.518-7.885 7.844v17.25a1.96 1.96 0 01-1.356 1.862 29.545 29.545 0 00-7.388 3.624 1.978 1.978 0 01-2.03.114 1.959 1.959 0 01-1.05-1.734V20.106C29.776 9.296 38.618.5 49.484.5 60.35.5 69.194 9.296 69.194 20.11v21.117a1.972 1.972 0 01-1.972 1.962l.003-.003zm-5.913-7.214c1.35.508 2.67 1.102 3.941 1.779V20.109c0-8.651-7.073-15.688-15.767-15.688-8.694 0-15.767 7.037-15.767 15.688v17.642a33.676 33.676 0 013.94-1.779V20.106c0-6.487 5.306-11.764 11.827-11.764s11.826 5.277 11.826 11.764v15.866z" }),
      /* @__PURE__ */ f.jsx("path", { d: "M49.486 100.5c-18.476 0-33.51-14.952-33.51-33.332 0-18.38 15.032-33.332 33.51-33.332 18.478 0 33.507 14.953 33.507 33.332 0 18.38-15.031 33.332-33.507 33.332zm0-62.744c-16.303 0-29.565 13.194-29.565 29.412 0 16.218 13.262 29.412 29.565 29.412s29.565-13.194 29.565-29.412c0-16.218-13.262-29.412-29.565-29.412z" }),
      /* @__PURE__ */ f.jsx("path", { d: "M53.427 88.736h-7.885a1.967 1.967 0 01-1.972-1.962v-2.966a17.763 17.763 0 01-1.732-.716l-2.109 2.098a1.979 1.979 0 01-2.789 0l-5.575-5.547a1.959 1.959 0 010-2.775l2.108-2.097c-.27-.564-.51-1.138-.72-1.726h-2.981a1.967 1.967 0 01-1.972-1.962V63.24c0-1.082.881-1.962 1.972-1.962h2.982c.209-.585.449-1.162.72-1.725l-2.11-2.098a1.964 1.964 0 01-.577-1.388c0-.521.21-1.018.578-1.387l5.575-5.546a1.979 1.979 0 012.79 0l2.108 2.097c.566-.269 1.144-.508 1.732-.716v-2.966c0-1.082.882-1.962 1.972-1.962h7.885c1.088 0 1.972.877 1.972 1.962v2.966c.589.208 1.169.447 1.735.716l2.109-2.097a1.977 1.977 0 012.786 0l5.575 5.546c.77.766.77 2.006 0 2.772l-2.108 2.098c.27.563.51 1.137.72 1.726h2.981c1.088 0 1.972.876 1.972 1.961v7.844a1.967 1.967 0 01-1.972 1.962h-2.981c-.21.586-.45 1.163-.72 1.723l2.109 2.098c.77.766.77 2.006 0 2.775l-5.576 5.543a1.977 1.977 0 01-2.786 0l-2.11-2.097c-.565.269-1.143.507-1.734.716v2.966a1.965 1.965 0 01-1.972 1.962v.008zm-5.913-3.92h3.944v-2.457c0-.896.608-1.675 1.478-1.897 1.244-.32 2.44-.813 3.556-1.468a1.978 1.978 0 012.396.302l1.746 1.737 2.79-2.775-1.75-1.736a1.953 1.953 0 01-.303-2.384c.658-1.11 1.154-2.3 1.475-3.538a1.97 1.97 0 011.908-1.47h2.468v-3.92h-2.468a1.968 1.968 0 01-1.908-1.471 13.609 13.609 0 00-1.475-3.538 1.953 1.953 0 01.304-2.384l1.749-1.737-2.79-2.771-1.746 1.736a1.979 1.979 0 01-2.396.303 13.76 13.76 0 00-3.556-1.468 1.961 1.961 0 01-1.478-1.898v-2.455h-3.944v2.455c0 .896-.608 1.676-1.481 1.898-1.244.32-2.44.813-3.556 1.468a1.975 1.975 0 01-2.396-.303l-1.746-1.736-2.787 2.771 1.746 1.737c.636.633.762 1.615.305 2.384a13.646 13.646 0 00-1.476 3.538 1.968 1.968 0 01-1.908 1.47h-2.468v3.92h2.468c.901 0 1.685.606 1.908 1.471.32 1.238.817 2.428 1.476 3.538.457.771.331 1.751-.305 2.384l-1.746 1.736 2.787 2.775 1.746-1.737a1.98 1.98 0 012.396-.302 13.796 13.796 0 003.556 1.468 1.96 1.96 0 011.481 1.897v2.456z" }),
      /* @__PURE__ */ f.jsx("path", { d: "M49.483 77.287c-1.632 0-3.3-.374-4.892-1.143-1.584-.766-3.361-2.53-4.13-4.11-2.043-4.18-1.326-8.903 1.82-12.033 3.147-3.13 7.894-3.84 12.097-1.812 1.584.766 3.361 2.533 4.13 4.11 2.043 4.178 1.326 8.904-1.82 12.03-1.956 1.946-4.527 2.956-7.205 2.956v.002zm.011-16.334a6.296 6.296 0 00-4.426 1.82c-1.545 1.537-2.636 4.326-1.063 7.547.388.794 1.51 1.91 2.307 2.295 3.235 1.565 6.041.48 7.584-1.057 1.545-1.538 2.635-4.326 1.062-7.548-.387-.793-1.509-1.909-2.306-2.294-1.116-.538-2.179-.763-3.158-.763zM92.847 52.46a2.949 2.949 0 01-2.957 2.94 2.95 2.95 0 01-2.956-2.94 2.95 2.95 0 012.956-2.942 2.95 2.95 0 012.957 2.941zM6.122 25.01a2.949 2.949 0 01-2.956 2.94 2.949 2.949 0 01-2.957-2.94 2.949 2.949 0 012.957-2.942 2.949 2.949 0 012.956 2.941zM14.005 87.754a2.949 2.949 0 01-2.957 2.94 2.95 2.95 0 01-2.956-2.94 2.95 2.95 0 012.956-2.942 2.95 2.95 0 012.957 2.942zM21.89 8.345a1.967 1.967 0 01-1.972 1.961 1.965 1.965 0 01-1.972-1.961c0-1.085.881-1.962 1.972-1.962 1.09 0 1.972.877 1.972 1.962zM21.89 37.754a1.967 1.967 0 01-1.972 1.961 1.965 1.965 0 01-1.972-1.962c0-1.084.881-1.961 1.972-1.961 1.09 0 1.972.877 1.972 1.962zM92.847 86.774a1.967 1.967 0 01-1.972 1.962 1.965 1.965 0 01-1.972-1.962c0-1.085.881-1.962 1.972-1.962 1.09 0 1.972.877 1.972 1.962zM81.02 35.795c-8.696 0-15.77-7.037-15.77-15.689 0-8.651 7.074-15.685 15.77-15.685 8.697 0 15.768 7.037 15.768 15.686 0 8.648-7.074 15.688-15.768 15.688zm0-27.45c-6.52 0-11.826 5.277-11.826 11.764 0 6.487 5.305 11.765 11.826 11.765 6.522 0 11.827-5.277 11.827-11.765 0-6.487-5.305-11.764-11.827-11.764z" }),
      /* @__PURE__ */ f.jsx("path", { d: "M79.288 25.992c-.504 0-1.01-.192-1.394-.575l-2.62-2.605a1.956 1.956 0 010-2.775 1.98 1.98 0 012.79 0l1.224 1.218 5.576-5.546a1.977 1.977 0 012.786 0c.77.765.77 2.006 0 2.774l-6.967 6.931c-.385.383-.89.575-1.395.575v.003z" })
    ] })
  }
), zP = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsxs("g", { clipPath: "url(#clip0_2648_4382)", children: [
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M4.16667 18.3333C2.78333 18.3333 1.66667 17.2167 1.66667 15.8333V5.83333H7.5C7.5 7.21667 8.61667 8.33333 10 8.33333C11.3833 8.33333 12.5 7.21667 12.5 5.83333H18.3333V7.96667C18.3333 8.425 18.7083 8.8 19.1667 8.8C19.625 8.8 20 8.425 20 7.96667V4.16667C20 1.86667 18.1333 0 15.8333 0H4.16667C1.86667 0 0 1.86667 0 4.16667V15.8333C0 18.1333 1.86667 20 4.16667 20H9.30833C9.76667 20 10.1417 19.625 10.1417 19.1667C10.1417 18.7083 9.76667 18.3333 9.30833 18.3333H4.16667ZM12.5 1.66667H15.8333C17.2167 1.66667 18.3333 2.78333 18.3333 4.16667H12.5V1.66667ZM9.16667 1.66667H10.8333V5.83333C10.8333 6.29167 10.4583 6.66667 10 6.66667C9.54167 6.66667 9.16667 6.29167 9.16667 5.83333V1.66667ZM4.16667 1.66667H7.5V4.16667H1.66667C1.66667 2.78333 2.78333 1.66667 4.16667 1.66667Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M19.5833 15.9499L18.775 15.4832C18.9166 15.0666 19.0083 14.6332 19.0083 14.1749C19.0083 13.7166 18.9166 13.2749 18.775 12.8666L19.5833 12.3999C19.9833 12.1666 20.1166 11.6582 19.8916 11.2582C19.6583 10.8582 19.15 10.7249 18.75 10.9499L17.9416 11.4166C17.35 10.7582 16.575 10.2666 15.675 10.0916V9.17489C15.675 8.71655 15.3 8.34155 14.8416 8.34155C14.3833 8.34155 14.0083 8.71655 14.0083 9.17489V10.0916C13.1083 10.2749 12.325 10.7582 11.7416 11.4166L10.9333 10.9499C10.5333 10.7166 10.025 10.8582 9.79164 11.2582C9.55831 11.6582 9.69997 12.1666 10.1 12.3999L10.9083 12.8666C10.7666 13.2832 10.675 13.7166 10.675 14.1749C10.675 14.6332 10.7666 15.0666 10.9083 15.4832L10.1 15.9499C9.69997 16.1832 9.56664 16.6916 9.79164 17.0916C9.94997 17.3582 10.225 17.5082 10.5166 17.5082C10.6583 17.5082 10.8 17.4749 10.9333 17.3999L11.7416 16.9332C12.3333 17.5916 13.1083 18.0832 14.0083 18.2582V19.1749C14.0083 19.6332 14.3833 20.0082 14.8416 20.0082C15.3 20.0082 15.675 19.6332 15.675 19.1749V18.2582C16.575 18.0749 17.3583 17.5916 17.9416 16.9332L18.75 17.3999C18.8833 17.4749 19.025 17.5082 19.1666 17.5082C19.4583 17.5082 19.7333 17.3582 19.8916 17.0916C20.125 16.6916 19.9833 16.1832 19.5833 15.9499ZM14.8333 16.6749C13.4583 16.6749 12.3333 15.5499 12.3333 14.1749C12.3333 12.7999 13.4583 11.6749 14.8333 11.6749C16.2083 11.6749 17.3333 12.7999 17.3333 14.1749C17.3333 15.5499 16.2083 16.6749 14.8333 16.6749Z",
          fill: "currentColor"
        }
      )
    ] })
  }
), KP = () => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M15.8333 3.33333H13.25C13.0566 2.39284 12.5448 1.54779 11.801 0.940598C11.0572 0.333408 10.1268 0.0012121 9.16667 0L7.5 0C6.53983 0.0012121 5.60943 0.333408 4.86562 0.940598C4.12182 1.54779 3.61008 2.39284 3.41667 3.33333H0.833333C0.61232 3.33333 0.400358 3.42113 0.244078 3.57741C0.0877973 3.73369 0 3.94565 0 4.16667C0 4.38768 0.0877973 4.59964 0.244078 4.75592C0.400358 4.9122 0.61232 5 0.833333 5H1.66667V15.8333C1.66799 16.938 2.1074 17.997 2.88852 18.7782C3.66963 19.5593 4.72867 19.9987 5.83333 20H10.8333C11.938 19.9987 12.997 19.5593 13.7782 18.7782C14.5593 17.997 14.9987 16.938 15 15.8333V5H15.8333C16.0543 5 16.2663 4.9122 16.4226 4.75592C16.5789 4.59964 16.6667 4.38768 16.6667 4.16667C16.6667 3.94565 16.5789 3.73369 16.4226 3.57741C16.2663 3.42113 16.0543 3.33333 15.8333 3.33333ZM7.5 1.66667H9.16667C9.68356 1.6673 10.1876 1.82781 10.6097 2.1262C11.0317 2.42459 11.3512 2.84624 11.5242 3.33333H5.1425C5.31549 2.84624 5.63492 2.42459 6.05699 2.1262C6.47906 1.82781 6.9831 1.6673 7.5 1.66667ZM13.3333 15.8333C13.3333 16.4964 13.0699 17.1323 12.6011 17.6011C12.1323 18.0699 11.4964 18.3333 10.8333 18.3333H5.83333C5.17029 18.3333 4.53441 18.0699 4.06557 17.6011C3.59673 17.1323 3.33333 16.4964 3.33333 15.8333V5H13.3333V15.8333Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M6.66683 15.0002C6.88784 15.0002 7.0998 14.9124 7.25608 14.7561C7.41237 14.5998 7.50016 14.3878 7.50016 14.1668V9.16683C7.50016 8.94582 7.41237 8.73385 7.25608 8.57757C7.0998 8.42129 6.88784 8.3335 6.66683 8.3335C6.44582 8.3335 6.23385 8.42129 6.07757 8.57757C5.92129 8.73385 5.8335 8.94582 5.8335 9.16683V14.1668C5.8335 14.3878 5.92129 14.5998 6.07757 14.7561C6.23385 14.9124 6.44582 15.0002 6.66683 15.0002Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M9.99984 15.0002C10.2209 15.0002 10.4328 14.9124 10.5891 14.7561C10.7454 14.5998 10.8332 14.3878 10.8332 14.1668V9.16683C10.8332 8.94582 10.7454 8.73385 10.5891 8.57757C10.4328 8.42129 10.2209 8.3335 9.99984 8.3335C9.77882 8.3335 9.56686 8.42129 9.41058 8.57757C9.2543 8.73385 9.1665 8.94582 9.1665 9.16683V14.1668C9.1665 14.3878 9.2543 14.5998 9.41058 14.7561C9.56686 14.9124 9.77882 15.0002 9.99984 15.0002Z",
          fill: "currentColor"
        }
      )
    ]
  }
), qP = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsxs("g", { clipPath: "url(#clip0_2127_30842)", children: [
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M10 10C10.9889 10 11.9556 9.70676 12.7779 9.15735C13.6001 8.60794 14.241 7.82705 14.6194 6.91342C14.9978 5.99979 15.0969 4.99446 14.9039 4.02455C14.711 3.05465 14.2348 2.16373 13.5355 1.46447C12.8363 0.765206 11.9454 0.289002 10.9755 0.0960758C10.0055 -0.0968503 9.00021 0.00216643 8.08658 0.380605C7.17295 0.759043 6.39206 1.39991 5.84265 2.22215C5.29324 3.0444 5 4.0111 5 5C5.00132 6.32568 5.52853 7.59668 6.46593 8.53407C7.40332 9.47147 8.67432 9.99868 10 10ZM10 1.66667C10.6593 1.66667 11.3037 1.86217 11.8519 2.22844C12.4001 2.59471 12.8273 3.1153 13.0796 3.72439C13.3319 4.33348 13.3979 5.0037 13.2693 5.6503C13.1407 6.29691 12.8232 6.89085 12.357 7.35703C11.8908 7.8232 11.2969 8.14067 10.6503 8.26929C10.0037 8.3979 9.33348 8.33189 8.72439 8.0796C8.1153 7.82731 7.59471 7.40007 7.22843 6.8519C6.86216 6.30374 6.66667 5.65927 6.66667 5C6.66667 4.11595 7.01786 3.2681 7.64298 2.64298C8.2681 2.01786 9.11594 1.66667 10 1.66667Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M10 11.6667C8.01155 11.669 6.10518 12.4598 4.69914 13.8659C3.29309 15.2719 2.50221 17.1783 2.5 19.1667C2.5 19.3878 2.5878 19.5997 2.74408 19.756C2.90036 19.9123 3.11232 20.0001 3.33333 20.0001C3.55435 20.0001 3.76631 19.9123 3.92259 19.756C4.07887 19.5997 4.16667 19.3878 4.16667 19.1667C4.16667 17.6197 4.78125 16.1359 5.87521 15.042C6.96917 13.948 8.4529 13.3334 10 13.3334C11.5471 13.3334 13.0308 13.948 14.1248 15.042C15.2188 16.1359 15.8333 17.6197 15.8333 19.1667C15.8333 19.3878 15.9211 19.5997 16.0774 19.756C16.2337 19.9123 16.4457 20.0001 16.6667 20.0001C16.8877 20.0001 17.0996 19.9123 17.2559 19.756C17.4122 19.5997 17.5 19.3878 17.5 19.1667C17.4978 17.1783 16.7069 15.2719 15.3009 13.8659C13.8948 12.4598 11.9884 11.669 10 11.6667Z",
          fill: "currentColor"
        }
      )
    ] })
  }
), XP = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsx("g", { clipPath: "url(#clip0_2127_30857)", children: /* @__PURE__ */ f.jsx(
      "path",
      {
        d: "M5.83333 11.6667C7.675 11.6667 9.16667 10.175 9.16667 8.33333C9.16667 6.49167 7.675 5 5.83333 5C3.99167 5 2.5 6.49167 2.5 8.33333C2.5 10.175 3.99167 11.6667 5.83333 11.6667ZM5.83333 6.66667C6.75 6.66667 7.5 7.41667 7.5 8.33333C7.5 9.25 6.75 10 5.83333 10C4.91667 10 4.16667 9.25 4.16667 8.33333C4.16667 7.41667 4.91667 6.66667 5.83333 6.66667ZM11.6667 19.1667C11.6667 19.625 11.2917 20 10.8333 20C10.375 20 10 19.625 10 19.1667C10 16.8667 8.13333 15 5.83333 15C3.53333 15 1.66667 16.8667 1.66667 19.1667C1.66667 19.625 1.29167 20 0.833333 20C0.375 20 0 19.625 0 19.1667C0 15.95 2.61667 13.3333 5.83333 13.3333C9.05 13.3333 11.6667 15.95 11.6667 19.1667ZM20 4.16667V10.8333C20 13.1333 18.1333 15 15.8333 15H12.5C12.0417 15 11.6667 14.625 11.6667 14.1667C11.6667 13.7083 12.0417 13.3333 12.5 13.3333H15.8333C17.2083 13.3333 18.3333 12.2083 18.3333 10.8333V4.16667C18.3333 2.79167 17.2083 1.66667 15.8333 1.66667H7.88333C6.99167 1.66667 6.16667 2.15 5.71667 2.91667C5.48333 3.31667 4.975 3.45 4.575 3.225C4.175 2.99167 4.04167 2.48333 4.275 2.08333C5.025 0.8 6.40833 0 7.88333 0H15.8333C18.1333 0 20 1.86667 20 4.16667ZM11.3917 9.1L13.825 6.66667H12.5C12.0417 6.66667 11.6667 6.29167 11.6667 5.83333C11.6667 5.375 12.0417 5 12.5 5H15C15.9167 5 16.6667 5.75 16.6667 6.66667V9.16667C16.6667 9.625 16.2917 10 15.8333 10C15.375 10 15 9.625 15 9.16667V7.84167L12.5667 10.275C12.1833 10.6583 11.6667 10.8667 11.1417 10.8667C10.9583 10.8667 10.775 10.8417 10.5917 10.7917C10.15 10.6667 9.89167 10.2083 10.0167 9.76667C10.1417 9.325 10.6 9.06667 11.05 9.19167C11.15 9.21667 11.2833 9.20833 11.3917 9.1Z",
        fill: "currentColor"
      }
    ) })
  }
), JP = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsx("g", { clipPath: "url(#clip0_2656_4398)", children: /* @__PURE__ */ f.jsx(
      "path",
      {
        d: "M12.4999 5C12.4999 2.2425 10.2574 0 7.49986 0C4.74236 0 2.49986 2.2425 2.49986 5C2.49986 7.7575 4.74236 10 7.49986 10C10.2574 10 12.4999 7.7575 12.4999 5ZM7.49986 8.33333C5.66152 8.33333 4.16652 6.83833 4.16652 5C4.16652 3.16167 5.66152 1.66667 7.49986 1.66667C9.33819 1.66667 10.8332 3.16167 10.8332 5C10.8332 6.83833 9.33819 8.33333 7.49986 8.33333ZM7.49319 12.4483C7.54986 12.905 7.22652 13.3208 6.76902 13.3783C3.85986 13.7417 1.66569 16.2292 1.66569 19.1667C1.66569 19.6267 1.29236 20 0.832357 20C0.372357 20 -0.000976562 19.6267 -0.000976562 19.1667C-0.000976562 15.3908 2.82069 12.1917 6.56236 11.725C7.01402 11.6675 7.43486 11.9917 7.49236 12.4492L7.49319 12.4483ZM18.9132 15.9442L18.1015 15.4758C18.2399 15.0617 18.3332 14.6267 18.3332 14.1658C18.3332 13.705 18.2407 13.27 18.1015 12.8558L18.9132 12.3875C19.3115 12.1575 19.4482 11.6475 19.2182 11.2492C18.9874 10.85 18.479 10.7125 18.0799 10.9442L17.269 11.4125C16.6815 10.7508 15.899 10.2667 14.9999 10.0842V9.16667C14.9999 8.70667 14.6265 8.33333 14.1665 8.33333C13.7065 8.33333 13.3332 8.70667 13.3332 9.16667V10.0842C12.434 10.2675 11.6515 10.7517 11.064 11.4125L10.2532 10.9442C9.85319 10.7133 9.34486 10.85 9.11486 11.2492C8.88486 11.6483 9.02152 12.1575 9.41986 12.3875L10.2315 12.8558C10.0932 13.27 9.99986 13.705 9.99986 14.1658C9.99986 14.6267 10.0924 15.0617 10.2315 15.4758L9.41986 15.9442C9.02152 16.1742 8.88486 16.6842 9.11486 17.0825C9.26986 17.35 9.54902 17.4992 9.83736 17.4992C9.97819 17.4992 10.1215 17.4633 10.2532 17.3875L11.064 16.9192C11.6515 17.5808 12.434 18.065 13.3332 18.2475V19.165C13.3332 19.625 13.7065 19.9983 14.1665 19.9983C14.6265 19.9983 14.9999 19.625 14.9999 19.165V18.2475C15.899 18.0642 16.6815 17.58 17.269 16.9192L18.0799 17.3875C18.2115 17.4633 18.3549 17.4992 18.4957 17.4992C18.784 17.4992 19.064 17.35 19.2182 17.0825C19.4482 16.6833 19.3115 16.1742 18.9132 15.9442ZM14.1665 16.6658C12.7882 16.6658 11.6665 15.5442 11.6665 14.1658C11.6665 12.7875 12.7882 11.6658 14.1665 11.6658C15.5449 11.6658 16.6665 12.7875 16.6665 14.1658C16.6665 15.5442 15.5449 16.6658 14.1665 16.6658Z",
        fill: "currentColor"
      }
    ) })
  }
), ej = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsx("g", { clipPath: "url(#clip0_2127_42419)", children: /* @__PURE__ */ f.jsx(
      "path",
      {
        d: "M9.13972 12.5022C9.25472 12.9481 8.98639 13.4022 8.54055 13.5164C5.96472 14.1797 4.16555 16.5022 4.16555 19.1664C4.16555 19.6264 3.79222 19.9997 3.33222 19.9997C2.87222 19.9997 2.49889 19.6264 2.49889 19.1664C2.49889 15.7422 4.81222 12.7556 8.12389 11.9031C8.57305 11.7889 9.02389 12.0564 9.13889 12.5022H9.13972ZM19.7556 19.7556C19.5931 19.9181 19.3797 19.9997 19.1664 19.9997C18.9531 19.9997 18.7397 19.9181 18.5772 19.7556L0.243887 1.42222C-0.0819466 1.09639 -0.0819466 0.56972 0.243887 0.243887C0.56972 -0.0819466 1.09639 -0.0819466 1.42222 0.243887L5.11555 3.93722C5.60472 1.68972 7.60722 -0.000279957 9.99972 -0.000279957C12.7572 -0.000279957 14.9997 2.24222 14.9997 4.99972C14.9997 7.39222 13.3097 9.39472 11.0622 9.88389L19.7556 18.5772C20.0814 18.9031 20.0814 19.4297 19.7556 19.7556ZM6.72055 5.54222L9.45722 8.27889C9.63639 8.30805 9.81722 8.33305 9.99972 8.33305C11.8381 8.33305 13.3331 6.83805 13.3331 4.99972C13.3331 3.16139 11.8381 1.66639 9.99972 1.66639C8.16139 1.66639 6.66639 3.16139 6.66639 4.99972C6.66639 5.18139 6.69139 5.36305 6.72055 5.54222Z",
        fill: "currentColor"
      }
    ) })
  }
), tj = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsxs("g", { clipPath: "url(#clip0_2364_27217)", children: [
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M19.8333 9.1665H18.1667V7.49984C18.1667 7.27882 18.0789 7.06686 17.9226 6.91058C17.7663 6.7543 17.5543 6.6665 17.3333 6.6665C17.1123 6.6665 16.9004 6.7543 16.7441 6.91058C16.5878 7.06686 16.5 7.27882 16.5 7.49984V9.1665H14.8333C14.6123 9.1665 14.4004 9.2543 14.2441 9.41058C14.0878 9.56686 14 9.77882 14 9.99984C14 10.2209 14.0878 10.4328 14.2441 10.5891C14.4004 10.7454 14.6123 10.8332 14.8333 10.8332H16.5V12.4998C16.5 12.7209 16.5878 12.9328 16.7441 13.0891C16.9004 13.2454 17.1123 13.3332 17.3333 13.3332C17.5543 13.3332 17.7663 13.2454 17.9226 13.0891C18.0789 12.9328 18.1667 12.7209 18.1667 12.4998V10.8332H19.8333C20.0543 10.8332 20.2663 10.7454 20.4226 10.5891C20.5789 10.4328 20.6667 10.2209 20.6667 9.99984C20.6667 9.77882 20.5789 9.56686 20.4226 9.41058C20.2663 9.2543 20.0543 9.1665 19.8333 9.1665Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M8.16699 10C9.1559 10 10.1226 9.70676 10.9448 9.15735C11.7671 8.60794 12.408 7.82705 12.7864 6.91342C13.1648 5.99979 13.2638 4.99446 13.0709 4.02455C12.878 3.05465 12.4018 2.16373 11.7025 1.46447C11.0033 0.765206 10.1123 0.289002 9.14244 0.0960758C8.17254 -0.0968503 7.16721 0.00216643 6.25358 0.380605C5.33994 0.759043 4.55905 1.39991 4.00964 2.22215C3.46024 3.0444 3.16699 4.0111 3.16699 5C3.16832 6.32568 3.69553 7.59668 4.63292 8.53407C5.57032 9.47147 6.84132 9.99868 8.16699 10ZM8.16699 1.66667C8.82626 1.66667 9.47073 1.86217 10.0189 2.22844C10.5671 2.59471 10.9943 3.1153 11.2466 3.72439C11.4989 4.33348 11.5649 5.0037 11.4363 5.6503C11.3077 6.29691 10.9902 6.89085 10.524 7.35703C10.0578 7.8232 9.4639 8.14067 8.81729 8.26929C8.17069 8.3979 7.50047 8.33189 6.89138 8.0796C6.28229 7.82731 5.7617 7.40007 5.39543 6.8519C5.02916 6.30374 4.83366 5.65927 4.83366 5C4.83366 4.11595 5.18485 3.2681 5.80997 2.64298C6.43509 2.01786 7.28294 1.66667 8.16699 1.66667Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M8.16699 11.6665C6.17855 11.6687 4.27217 12.4596 2.86613 13.8656C1.46008 15.2717 0.669198 17.1781 0.666992 19.1665C0.666992 19.3875 0.75479 19.5995 0.91107 19.7558C1.06735 19.912 1.27931 19.9998 1.50033 19.9998C1.72134 19.9998 1.9333 19.912 2.08958 19.7558C2.24586 19.5995 2.33366 19.3875 2.33366 19.1665C2.33366 17.6194 2.94824 16.1357 4.0422 15.0417C5.13616 13.9478 6.6199 13.3332 8.16699 13.3332C9.71409 13.3332 11.1978 13.9478 12.2918 15.0417C13.3857 16.1357 14.0003 17.6194 14.0003 19.1665C14.0003 19.3875 14.0881 19.5995 14.2444 19.7558C14.4007 19.912 14.6126 19.9998 14.8337 19.9998C15.0547 19.9998 15.2666 19.912 15.4229 19.7558C15.5792 19.5995 15.667 19.3875 15.667 19.1665C15.6648 17.1781 14.8739 15.2717 13.4679 13.8656C12.0618 12.4596 10.1554 11.6687 8.16699 11.6665Z",
          fill: "currentColor"
        }
      )
    ] })
  }
), rj = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsx("g", { clipPath: "url(#clip0_842_3895)", children: /* @__PURE__ */ f.jsx(
      "path",
      {
        d: "M10 13.3333C9.34073 13.3333 8.69626 13.1378 8.1481 12.7716C7.59994 12.4053 7.17269 11.8847 6.9204 11.2756C6.66811 10.6665 6.6021 9.9963 6.73072 9.3497C6.85933 8.7031 7.1768 8.10915 7.64298 7.64298C8.10915 7.1768 8.7031 6.85933 9.3497 6.73072C9.9963 6.6021 10.6665 6.66811 11.2756 6.9204C11.8847 7.1727 12.4053 7.59994 12.7716 8.1481C13.1378 8.69627 13.3333 9.34073 13.3333 10C13.3333 10.8841 12.9821 11.7319 12.357 12.357C11.7319 12.9821 10.8841 13.3333 10 13.3333ZM10 8.33333C9.67036 8.33333 9.34813 8.43108 9.07405 8.61422C8.79997 8.79735 8.58635 9.05765 8.4602 9.3622C8.33405 9.66674 8.30105 10.0019 8.36536 10.3252C8.42967 10.6485 8.5884 10.9454 8.82149 11.1785C9.05458 11.4116 9.35155 11.5703 9.67485 11.6346C9.99815 11.699 10.3333 11.6659 10.6378 11.5398C10.9423 11.4137 11.2026 11.2 11.3858 10.926C11.5689 10.6519 11.6667 10.3296 11.6667 10C11.6667 9.55797 11.4911 9.13405 11.1785 8.82149C10.8659 8.50893 10.442 8.33333 10 8.33333ZM15 19.1667C15 17.8406 14.4732 16.5688 13.5355 15.6311C12.5979 14.6935 11.3261 14.1667 10 14.1667C8.67392 14.1667 7.40215 14.6935 6.46447 15.6311C5.52678 16.5688 5 17.8406 5 19.1667C5 19.3877 5.0878 19.5996 5.24408 19.7559C5.40036 19.9122 5.61232 20 5.83333 20C6.05435 20 6.26631 19.9122 6.42259 19.7559C6.57887 19.5996 6.66667 19.3877 6.66667 19.1667C6.66667 18.2826 7.01786 17.4348 7.64298 16.8096C8.2681 16.1845 9.11594 15.8333 10 15.8333C10.8841 15.8333 11.7319 16.1845 12.357 16.8096C12.9821 17.4348 13.3333 18.2826 13.3333 19.1667C13.3333 19.3877 13.4211 19.5996 13.5774 19.7559C13.7337 19.9122 13.9457 20 14.1667 20C14.3877 20 14.5996 19.9122 14.7559 19.7559C14.9122 19.5996 15 19.3877 15 19.1667ZM15 6.66667C14.3407 6.66667 13.6963 6.47117 13.1481 6.1049C12.5999 5.73863 12.1727 5.21803 11.9204 4.60895C11.6681 3.99986 11.6021 3.32964 11.7307 2.68303C11.8593 2.03643 12.1768 1.44249 12.643 0.976312C13.1092 0.510137 13.7031 0.192668 14.3497 0.0640506C14.9963 -0.0645668 15.6665 0.00144427 16.2756 0.253736C16.8847 0.506029 17.4053 0.93327 17.7716 1.48143C18.1378 2.0296 18.3333 2.67406 18.3333 3.33334C18.3333 4.21739 17.9821 5.06524 17.357 5.69036C16.7319 6.31548 15.8841 6.66667 15 6.66667ZM15 1.66667C14.6704 1.66667 14.3481 1.76442 14.074 1.94755C13.8 2.13069 13.5863 2.39099 13.4602 2.69553C13.3341 3.00007 13.301 3.33518 13.3654 3.65849C13.4297 3.98179 13.5884 4.27876 13.8215 4.51185C14.0546 4.74493 14.3515 4.90367 14.6748 4.96798C14.9982 5.03229 15.3333 4.99928 15.6378 4.87313C15.9423 4.74699 16.2026 4.53337 16.3858 4.25929C16.5689 3.9852 16.6667 3.66297 16.6667 3.33334C16.6667 2.89131 16.4911 2.46738 16.1785 2.15482C15.8659 1.84226 15.442 1.66667 15 1.66667ZM20 12.5C19.9987 11.1743 19.4715 9.90333 18.5341 8.96593C17.5967 8.02853 16.3257 7.50133 15 7.5C14.779 7.5 14.567 7.5878 14.4107 7.74408C14.2545 7.90036 14.1667 8.11232 14.1667 8.33333C14.1667 8.55435 14.2545 8.76631 14.4107 8.92259C14.567 9.07887 14.779 9.16667 15 9.16667C15.8841 9.16667 16.7319 9.51786 17.357 10.143C17.9821 10.7681 18.3333 11.6159 18.3333 12.5C18.3333 12.721 18.4211 12.933 18.5774 13.0893C18.7337 13.2455 18.9457 13.3333 19.1667 13.3333C19.3877 13.3333 19.5996 13.2455 19.7559 13.0893C19.9122 12.933 20 12.721 20 12.5ZM5 6.66667C4.34073 6.66667 3.69626 6.47117 3.1481 6.1049C2.59994 5.73863 2.17269 5.21803 1.9204 4.60895C1.66811 3.99986 1.6021 3.32964 1.73072 2.68303C1.85933 2.03643 2.1768 1.44249 2.64298 0.976312C3.10915 0.510137 3.7031 0.192668 4.3497 0.0640506C4.9963 -0.0645668 5.66652 0.00144427 6.27561 0.253736C6.8847 0.506029 7.40529 0.93327 7.77156 1.48143C8.13784 2.0296 8.33333 2.67406 8.33333 3.33334C8.33333 4.21739 7.98214 5.06524 7.35702 5.69036C6.7319 6.31548 5.88405 6.66667 5 6.66667ZM5 1.66667C4.67036 1.66667 4.34813 1.76442 4.07405 1.94755C3.79997 2.13069 3.58635 2.39099 3.4602 2.69553C3.33405 3.00007 3.30105 3.33518 3.36536 3.65849C3.42967 3.98179 3.5884 4.27876 3.82149 4.51185C4.05458 4.74493 4.35155 4.90367 4.67485 4.96798C4.99815 5.03229 5.33326 4.99928 5.63781 4.87313C5.94235 4.74699 6.20265 4.53337 6.38578 4.25929C6.56892 3.9852 6.66667 3.66297 6.66667 3.33334C6.66667 2.89131 6.49107 2.46738 6.17851 2.15482C5.86595 1.84226 5.44203 1.66667 5 1.66667ZM1.66667 12.5C1.66667 11.6159 2.01786 10.7681 2.64298 10.143C3.2681 9.51786 4.11594 9.16667 5 9.16667C5.22101 9.16667 5.43297 9.07887 5.58926 8.92259C5.74554 8.76631 5.83333 8.55435 5.83333 8.33333C5.83333 8.11232 5.74554 7.90036 5.58926 7.74408C5.43297 7.5878 5.22101 7.5 5 7.5C3.67432 7.50133 2.40332 8.02853 1.46593 8.96593C0.528533 9.90333 0.00132369 11.1743 0 12.5C0 12.721 0.0877974 12.933 0.244078 13.0893C0.400358 13.2455 0.61232 13.3333 0.833333 13.3333C1.05435 13.3333 1.26631 13.2455 1.42259 13.0893C1.57887 12.933 1.66667 12.721 1.66667 12.5Z",
        fill: "currentColor"
      }
    ) })
  }
), nj = () => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M19.3925 6.34919C18.1 4.24419 15.16 0.712524 10 0.712524C4.84 0.712524 1.9 4.24419 0.607497 6.34919C0.207937 6.99545 -0.00370789 7.74023 -0.00370789 8.50002C-0.00370789 9.25982 0.207937 10.0046 0.607497 10.6509C1.9 12.7559 4.84 16.2875 10 16.2875C15.16 16.2875 18.1 12.7559 19.3925 10.6509C19.7921 10.0046 20.0037 9.25982 20.0037 8.50002C20.0037 7.74023 19.7921 6.99545 19.3925 6.34919ZM17.9717 9.77836C16.8617 11.5834 14.3492 14.6209 10 14.6209C5.65083 14.6209 3.13833 11.5834 2.02833 9.77836C1.79094 9.39423 1.66521 8.95159 1.66521 8.50002C1.66521 8.04846 1.79094 7.60582 2.02833 7.22169C3.13833 5.41669 5.65083 2.37919 10 2.37919C14.3492 2.37919 16.8617 5.41336 17.9717 7.22169C18.2091 7.60582 18.3348 8.04846 18.3348 8.50002C18.3348 8.95159 18.2091 9.39423 17.9717 9.77836Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M10 4.33331C9.17591 4.33331 8.37033 4.57768 7.68512 5.03552C6.99992 5.49336 6.46586 6.14411 6.1505 6.90547C5.83513 7.66682 5.75262 8.5046 5.91339 9.31286C6.07416 10.1211 6.471 10.8635 7.05372 11.4463C7.63644 12.029 8.37887 12.4258 9.18712 12.5866C9.99537 12.7474 10.8332 12.6648 11.5945 12.3495C12.3559 12.0341 13.0066 11.5001 13.4645 10.8149C13.9223 10.1297 14.1667 9.32407 14.1667 8.49998C14.1653 7.39532 13.7259 6.33628 12.9448 5.55516C12.1637 4.77405 11.1047 4.33464 10 4.33331ZM10 11C9.50554 11 9.02219 10.8534 8.61107 10.5787C8.19995 10.304 7.87952 9.9135 7.6903 9.45669C7.50108 8.99987 7.45157 8.49721 7.54803 8.01225C7.6445 7.5273 7.8826 7.08184 8.23223 6.73221C8.58186 6.38258 9.02732 6.14448 9.51227 6.04802C9.99722 5.95155 10.4999 6.00106 10.9567 6.19028C11.4135 6.3795 11.804 6.69993 12.0787 7.11105C12.3534 7.52218 12.5 8.00553 12.5 8.49998C12.5 9.16302 12.2366 9.79891 11.7678 10.2677C11.2989 10.7366 10.663 11 10 11Z",
          fill: "currentColor"
        }
      )
    ]
  }
), aj = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        d: "M19.275 10.741L14.7667 6.08268C14.45 5.74935 13.9167 5.74102 13.5917 6.06602C13.2583 6.38268 13.25 6.91602 13.575 7.24102L17.8583 11.6577H4.16667C2.79167 11.6577 1.66667 10.5327 1.66667 9.15768V2.49935C1.66667 2.04102 1.29167 1.66602 0.833333 1.66602C0.375 1.66602 0 2.04102 0 2.49935V9.16602C0 11.466 1.86667 13.3327 4.16667 13.3327H17.85L13.5667 17.7493C13.25 18.0827 13.2583 18.6077 13.5833 18.9243C13.7417 19.0827 13.95 19.1577 14.1667 19.1577C14.3833 19.1577 14.6 19.0744 14.7667 18.9077L19.2667 14.2577C20.2417 13.2827 20.2417 11.6993 19.275 10.7327V10.741Z",
        fill: "currentColor"
      }
    )
  }
), ij = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        d: "M16.6667 38.3333C16.6667 39.255 15.9217 40 15 40H8.33333C3.73833 40 0 36.2617 0 31.6667V8.33333C0 3.73833 3.73833 0 8.33333 0H21.6667C26.2617 0 30 3.73833 30 8.33333V11.6667C30 12.5883 29.255 13.3333 28.3333 13.3333C27.4117 13.3333 26.6667 12.5883 26.6667 11.6667V8.33333C26.6667 5.57667 24.4233 3.33333 21.6667 3.33333H8.33333C5.57667 3.33333 3.33333 5.57667 3.33333 8.33333V31.6667C3.33333 34.4233 5.57667 36.6667 8.33333 36.6667H15C15.9217 36.6667 16.6667 37.4117 16.6667 38.3333ZM23.3333 10C23.3333 9.07833 22.5883 8.33333 21.6667 8.33333H8.33333C7.41167 8.33333 6.66667 9.07833 6.66667 10C6.66667 10.9217 7.41167 11.6667 8.33333 11.6667H21.6667C22.5883 11.6667 23.3333 10.9217 23.3333 10ZM16.6667 18.3333C16.6667 17.4117 15.9217 16.6667 15 16.6667H8.33333C7.41167 16.6667 6.66667 17.4117 6.66667 18.3333C6.66667 19.255 7.41167 20 8.33333 20H15C15.9217 20 16.6667 19.255 16.6667 18.3333ZM8.33333 25C7.41167 25 6.66667 25.745 6.66667 26.6667C6.66667 27.5883 7.41167 28.3333 8.33333 28.3333H11.6667C12.5883 28.3333 13.3333 27.5883 13.3333 26.6667C13.3333 25.745 12.5883 25 11.6667 25H8.33333ZM40 28.3333C40 34.765 34.765 40 28.3333 40C21.9017 40 16.6667 34.765 16.6667 28.3333C16.6667 21.9017 21.9017 16.6667 28.3333 16.6667C34.765 16.6667 40 21.9017 40 28.3333ZM36.6667 28.3333C36.6667 23.7383 32.9283 20 28.3333 20C23.7383 20 20 23.7383 20 28.3333C20 32.9283 23.7383 36.6667 28.3333 36.6667C32.9283 36.6667 36.6667 32.9283 36.6667 28.3333ZM31.3467 26.265L27.6417 29.8217C27.4017 30.0567 27.01 30.0617 26.7717 29.825L24.8867 27.9783C24.2267 27.3317 23.1733 27.3417 22.53 28.0017C21.885 28.66 21.895 29.7133 22.5533 30.3583L24.44 32.2067C25.2067 32.955 26.21 33.33 27.2117 33.33C28.2133 33.33 29.2133 32.955 29.9667 32.2117L33.655 28.6717C34.3183 28.0333 34.34 26.9783 33.7033 26.315C33.065 25.6483 32.0083 25.63 31.3467 26.2667V26.265Z",
        fill: "currentColor"
      }
    )
  }
), oj = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        d: "M20 0C16.0444 0 12.1776 1.17298 8.8886 3.3706C5.59962 5.56824 3.03618 8.6918 1.52242 12.3463C0.00866604 16.0009 -0.387402 20.0222 0.384304 23.9018C1.15601 27.7814 3.06082 31.345 5.85788 34.1422C8.65492 36.9392 12.2186 38.844 16.0982 39.6158C19.9778 40.3874 23.9992 39.9914 27.6536 38.4776C31.3082 36.9638 34.4318 34.4004 36.6294 31.1114C38.827 27.8224 40 23.9556 40 20C39.9942 14.6974 37.8852 9.61368 34.1358 5.8642C30.3864 2.11472 25.3026 0.00573514 20 0ZM20 3.33334C23.8442 3.33026 27.5698 4.66292 30.54 7.10334L7.10334 30.54C5.10428 28.0998 3.83944 25.1418 3.45604 22.0108C3.07264 18.8796 3.58644 15.7039 4.93766 12.8534C6.28886 10.0029 8.4219 7.5948 11.0885 5.9094C13.755 4.22402 16.8455 3.33066 20 3.33334ZM20 36.6666C16.1559 36.6698 12.4301 35.337 9.46 32.8966L32.8966 9.46C34.8958 11.9003 36.1606 14.8581 36.544 17.9893C36.9274 21.1204 36.4136 24.2962 35.0624 27.1466C33.7112 29.9972 31.5782 32.4052 28.9116 34.0906C26.245 35.776 23.1546 36.6694 20 36.6666Z",
        fill: "currentColor"
      }
    )
  }
), sj = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsxs("g", { clipPath: "url(#clip0_16_25)", children: [
      /* @__PURE__ */ f.jsx("path", { d: "M20 0C16.0444 0 12.1776 1.17298 8.8886 3.37061C5.59962 5.56824 3.03617 8.69181 1.52242 12.3463C0.00866572 16.0009 -0.387401 20.0222 0.384303 23.9018C1.15601 27.7814 3.06082 31.3451 5.85787 34.1421C8.65492 36.9392 12.2186 38.844 16.0982 39.6157C19.9778 40.3874 23.9992 39.9913 27.6537 38.4776C31.3082 36.9638 34.4318 34.4004 36.6294 31.1114C38.827 27.8224 40 23.9556 40 20C39.9943 14.6974 37.8853 9.61368 34.1358 5.8642C30.3863 2.11471 25.3026 0.00573514 20 0ZM20 36.6667C16.7037 36.6667 13.4813 35.6892 10.7405 33.8578C7.99969 32.0265 5.86348 29.4235 4.60202 26.3781C3.34056 23.3326 3.0105 19.9815 3.65359 16.7485C4.29667 13.5155 5.88402 10.5458 8.2149 8.21489C10.5458 5.88401 13.5155 4.29667 16.7485 3.65358C19.9815 3.01049 23.3326 3.34055 26.3781 4.60201C29.4235 5.86347 32.0265 7.99968 33.8578 10.7405C35.6892 13.4813 36.6667 16.7036 36.6667 20C36.6618 24.4188 34.9043 28.6552 31.7798 31.7798C28.6552 34.9043 24.4188 36.6618 20 36.6667Z", fill: "currentColor" }),
      /* @__PURE__ */ f.jsx("path", { d: "M20 8.33331C19.558 8.33331 19.134 8.50891 18.8215 8.82147C18.5089 9.13403 18.3333 9.55795 18.3333 9.99998V23.3333C18.3333 23.7753 18.5089 24.1993 18.8215 24.5118C19.134 24.8244 19.558 25 20 25C20.442 25 20.8659 24.8244 21.1785 24.5118C21.4911 24.1993 21.6666 23.7753 21.6666 23.3333V9.99998C21.6666 9.55795 21.4911 9.13403 21.1785 8.82147C20.8659 8.50891 20.442 8.33331 20 8.33331Z", fill: "currentColor" }),
      /* @__PURE__ */ f.jsx("path", { d: "M21.6666 30C21.6666 29.0795 20.9205 28.3333 20 28.3333C19.0795 28.3333 18.3333 29.0795 18.3333 30C18.3333 30.9205 19.0795 31.6666 20 31.6666C20.9205 31.6666 21.6666 30.9205 21.6666 30Z", fill: "currentColor" })
    ] })
  }
), lj = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 40 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsx("path", { d: "M18.3295 20.0111V10.0055C18.3295 9.08836 19.0799 8.33794 19.9971 8.33794C20.9142 8.33794 21.6647 9.08836 21.6647 10.0055V20.0111C21.6647 20.9282 20.9142 21.6787 19.9971 21.6787C19.0799 21.6787 18.3295 20.9282 18.3295 20.0111ZM19.9971 23.3462C18.613 23.3462 17.4957 24.4635 17.4957 25.8476C17.4957 27.2317 18.613 28.349 19.9971 28.349C21.3812 28.349 22.4984 27.2317 22.4984 25.8476C22.4984 24.4635 21.3812 23.3462 19.9971 23.3462ZM39.3077 31.4841C38.1404 33.7353 35.6891 35.0194 32.6207 35.0194H7.39009C4.30505 35.0194 1.87037 33.7353 0.703061 31.4841C-0.480927 29.2162 -0.147409 26.3145 1.53686 23.8799L14.9443 2.66814C16.1283 0.967201 17.996 0 19.9971 0C21.9982 0 23.8659 0.967201 24.9998 2.61811L38.4739 23.9132C40.1582 26.3479 40.4751 29.2328 39.2911 31.4841H39.3077ZM35.7224 25.7809C35.7224 25.7809 35.6891 25.7476 35.6891 25.7142L22.2316 4.45246C21.748 3.76875 20.9142 3.33518 19.9971 3.33518C19.0799 3.33518 18.2461 3.76875 17.7291 4.51917L4.30505 25.7142C3.27115 27.1817 3.03769 28.7826 3.63802 29.9332C4.22167 31.0672 5.55574 31.6842 7.37342 31.6842H32.5874C34.405 31.6842 35.7391 31.0672 36.3228 29.9332C36.9231 28.7826 36.6896 27.1817 35.7057 25.7809H35.7224Z", fill: "currentColor" })
  }
), cj = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsxs("g", { clipPath: "url(#clip0_16_33)", children: [
      /* @__PURE__ */ f.jsx("path", { d: "M20 16.6667C18.6814 16.6667 17.3925 17.0577 16.2962 17.7902C15.1999 18.5228 14.3454 19.564 13.8408 20.7821C13.3362 22.0003 13.2042 23.3407 13.4614 24.634C13.7186 25.9272 14.3536 27.115 15.2859 28.0474C16.2183 28.9797 17.4062 29.6147 18.6994 29.8719C19.9926 30.1292 21.333 29.9971 22.5512 29.4926C23.7694 28.988 24.8106 28.1335 25.5431 27.0372C26.2757 25.9408 26.6666 24.6519 26.6666 23.3334C26.6666 21.5652 25.9643 19.8696 24.714 18.6193C23.4638 17.3691 21.7681 16.6667 20 16.6667ZM20 26.6667C19.3407 26.6667 18.6962 26.4712 18.1481 26.1049C17.5999 25.7386 17.1727 25.2181 16.9204 24.609C16.6681 23.9999 16.6021 23.3297 16.7307 22.6831C16.8593 22.0364 17.1768 21.4425 17.643 20.9763C18.1091 20.5102 18.7031 20.1927 19.3497 20.0641C19.9963 19.9355 20.6665 20.0015 21.2756 20.2538C21.8847 20.506 22.4053 20.9333 22.7715 21.4815C23.1378 22.0296 23.3333 22.6741 23.3333 23.3334C23.3333 24.2174 22.9821 25.0653 22.357 25.6904C21.7319 26.3155 20.884 26.6667 20 26.6667Z", fill: "currentColor" }),
      /* @__PURE__ */ f.jsx("path", { d: "M37.56 6.87003L33.13 2.44003C32.3581 1.66394 31.4399 1.04867 30.4286 0.629836C29.4173 0.211008 28.3329 -0.0030576 27.2383 3.29938e-05H8.33333C6.12401 0.00267942 4.00593 0.881503 2.4437 2.44373C0.88147 4.00596 0.00264643 6.12404 0 8.33337L0 31.6667C0.00264643 33.876 0.88147 35.9941 2.4437 37.5563C4.00593 39.1186 6.12401 39.9974 8.33333 40H31.6667C33.876 39.9974 35.9941 39.1186 37.5563 37.5563C39.1185 35.9941 39.9974 33.876 40 31.6667V12.7617C40.0031 11.6671 39.789 10.5828 39.3702 9.57144C38.9514 8.56013 38.3361 7.64194 37.56 6.87003ZM28.3333 3.4667V5.00003C28.3333 6.32612 27.8066 7.59789 26.8689 8.53557C25.9312 9.47325 24.6594 10 23.3333 10H16.6667C15.3406 10 14.0688 9.47325 13.1311 8.53557C12.1935 7.59789 11.6667 6.32612 11.6667 5.00003V3.33337H27.2383C27.6072 3.33664 27.9745 3.38136 28.3333 3.4667ZM36.6667 31.6667C36.6667 32.9928 36.1399 34.2646 35.2022 35.2022C34.2645 36.1399 32.9928 36.6667 31.6667 36.6667H8.33333C7.00725 36.6667 5.73548 36.1399 4.7978 35.2022C3.86012 34.2646 3.33333 32.9928 3.33333 31.6667V8.33337C3.33333 7.00728 3.86012 5.73551 4.7978 4.79783C5.73548 3.86015 7.00725 3.33337 8.33333 3.33337V5.00003C8.33598 7.20936 9.2148 9.32744 10.777 10.8897C12.3393 12.4519 14.4573 13.3307 16.6667 13.3334H23.3333C25.4292 13.3269 27.4453 12.5295 28.9785 11.1006C30.5118 9.67181 31.4492 7.71685 31.6033 5.6267L35.2033 9.2267C36.1374 10.1665 36.6632 11.4367 36.6667 12.7617V31.6667Z", fill: "currentColor" })
    ] })
  }
), uj = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsxs("g", { clipPath: "url(#clip0_16_33)", children: [
      /* @__PURE__ */ f.jsx("path", { d: "M31.6667 3.33333H30V1.66667C30 1.22464 29.8244 0.800716 29.5118 0.488155C29.1993 0.175595 28.7754 0 28.3333 0C27.8913 0 27.4674 0.175595 27.1548 0.488155C26.8423 0.800716 26.6667 1.22464 26.6667 1.66667V3.33333H13.3333V1.66667C13.3333 1.22464 13.1577 0.800716 12.8452 0.488155C12.5326 0.175595 12.1087 0 11.6667 0C11.2246 0 10.8007 0.175595 10.4882 0.488155C10.1756 0.800716 10 1.22464 10 1.66667V3.33333H8.33333C6.12401 3.33598 4.00593 4.2148 2.4437 5.77703C0.88147 7.33926 0.00264643 9.45734 0 11.6667V31.6667C0.00264643 33.876 0.88147 35.9941 2.4437 37.5563C4.00593 39.1185 6.12401 39.9974 8.33333 40H31.6667C33.876 39.9974 35.9941 39.1185 37.5563 37.5563C39.1185 35.9941 39.9974 33.876 40 31.6667V11.6667C39.9974 9.45734 39.1185 7.33926 37.5563 5.77703C35.9941 4.2148 33.876 3.33598 31.6667 3.33333ZM3.33333 11.6667C3.33333 10.3406 3.86012 9.06881 4.7978 8.13113C5.73548 7.19345 7.00725 6.66667 8.33333 6.66667H31.6667C32.9927 6.66667 34.2645 7.19345 35.2022 8.13113C36.1399 9.06881 36.6667 10.3406 36.6667 11.6667V13.3333H3.33333V11.6667ZM31.6667 36.6667H8.33333C7.00725 36.6667 5.73548 36.1399 4.7978 35.2022C3.86012 34.2645 3.33333 32.9927 3.33333 31.6667V16.6667H36.6667V31.6667C36.6667 32.9927 36.1399 34.2645 35.2022 35.2022C34.2645 36.1399 32.9927 36.6667 31.6667 36.6667Z", fill: "currentColor" }),
      /* @__PURE__ */ f.jsx("path", { d: "M20 27.5C21.3807 27.5 22.5 26.3807 22.5 25C22.5 23.6193 21.3807 22.5 20 22.5C18.6193 22.5 17.5 23.6193 17.5 25C17.5 26.3807 18.6193 27.5 20 27.5Z", fill: "currentColor" }),
      /* @__PURE__ */ f.jsx("path", { d: "M11.6667 27.5C13.0474 27.5 14.1667 26.3807 14.1667 25C14.1667 23.6193 13.0474 22.5 11.6667 22.5C10.286 22.5 9.16667 23.6193 9.16667 25C9.16667 26.3807 10.286 27.5 11.6667 27.5Z", fill: "currentColor" }),
      /* @__PURE__ */ f.jsx("path", { d: "M28.3333 27.5C29.714 27.5 30.8333 26.3807 30.8333 25C30.8333 23.6193 29.714 22.5 28.3333 22.5C26.9526 22.5 25.8333 23.6193 25.8333 25C25.8333 26.3807 26.9526 27.5 28.3333 27.5Z", fill: "currentColor" })
    ] })
  }
), fj = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 40 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsx("path", { d: "M36.201 13.7825L38.1094 8.62045C38.1094 8.62045 38.1125 8.61375 38.1135 8.60974C38.1156 8.60439 38.1177 8.59903 38.1187 8.59368L39.274 5.4673C39.8333 3.95095 39.2531 2.08128 37.9771 1.29968L36.4062 0.341422C35.7646 -0.0520521 35.026 -0.108263 34.3802 0.187512C33.7938 0.455182 33.3302 0.983829 33.074 1.67709L30.4063 8.89615C28.9156 8.22831 27.3573 7.88971 25.7646 7.88971H14.2333C10.4458 7.88971 6.875 9.79953 4.18021 13.2659C1.48438 16.7335 0 21.324 0 26.1943V26.9545C0 32.1995 1.75833 37.1781 4.83229 40.6685L4.52708 47.8822C4.50417 48.443 4.68958 48.7401 4.85 48.8913C4.95417 48.989 5.10833 49.0827 5.31875 49.0827C5.43854 49.0827 5.57708 49.0533 5.73438 48.977C5.75625 48.9663 5.77708 48.9543 5.79792 48.9409L11.2854 45.3139C11.3146 45.2952 11.3469 45.2738 11.3687 45.2591C11.3896 45.2591 11.4177 45.2591 11.4427 45.2591H17.5281C17.8521 45.2591 18.1135 44.9218 18.1135 44.5069C18.1135 44.092 17.851 43.7548 17.5281 43.7548H11.4469C11.1312 43.7508 11.0427 43.7815 10.75 43.9756L5.725 47.2974L6.01146 40.5133C6.06354 40.1158 5.9 39.8669 5.79479 39.7504C2.85625 36.5357 1.17083 31.8716 1.17083 26.9545V26.1943C1.17083 16.9316 7.03021 9.39535 14.2333 9.39535H25.7646C27.1823 9.39535 28.5708 9.68711 29.901 10.2653L27.924 15.6133C27.7854 15.9894 27.9094 16.4377 28.2021 16.6171C28.4948 16.7951 28.8438 16.6358 28.9833 16.2597L32.7219 6.14584L36.8062 8.6432L29.7073 27.8485L25.6229 25.3511L27.8385 19.358C27.9771 18.9819 27.8531 18.5336 27.5604 18.3543C27.2677 18.1763 26.9188 18.3355 26.7792 18.7116L24.3125 25.3846C24.2812 25.4703 24.2625 25.5639 24.2573 25.659L23.8406 33.9286H8.98542C8.66146 33.9286 8.4 34.2659 8.4 34.6808C8.4 35.0957 8.66146 35.4329 8.98542 35.4329H24C24.0771 35.5574 24.1729 35.6578 24.2885 35.7287C24.401 35.7969 24.5208 35.8317 24.6406 35.8317C24.8396 35.8317 25.0406 35.7394 25.2187 35.5614C25.2312 35.5494 25.2437 35.5346 25.2563 35.5212L30.3833 29.4037C30.4375 29.3394 30.4813 29.2605 30.5135 29.1748L35.6573 15.2587C37.7073 18.3154 38.8281 22.1578 38.8281 26.1943V26.9545C38.8281 36.2172 32.9688 43.7534 25.7656 43.7534H20.1292C19.8052 43.7534 19.5437 44.0907 19.5437 44.5056C19.5437 44.9205 19.8062 45.2577 20.1292 45.2577H25.7656C29.5521 45.2577 33.1219 43.3479 35.8188 39.8816C38.5156 36.4139 40 31.8234 40 26.9531V26.193C40 21.573 38.6542 17.1859 36.2031 13.7811L36.201 13.7825ZM33.2229 4.78474L34.1323 2.32352C34.2542 1.99428 34.4813 1.74 34.7719 1.60616C35.1271 1.44422 35.5385 1.47768 35.9021 1.69985L37.474 2.65944C38.1667 3.0837 38.499 4.054 38.2156 4.82087L37.3063 7.28076L33.2219 4.7834L33.2229 4.78474ZM25.0229 33.7412L25.1437 31.3523L26.3875 32.1125L25.0229 33.7412ZM27.3115 31.0097L25.225 29.7329L25.3698 26.8621L28.9521 29.053L27.3125 31.0097H27.3115Z", fill: "currentColor" })
  }
), dj = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 40 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsx("path", { d: "M5.57407 17.7786C5.57407 17.4105 5.81724 17.113 6.11806 17.113H22.4116C22.7114 17.113 22.9556 17.4118 22.9556 17.7786C22.9556 18.1454 22.7124 18.4442 22.4116 18.4442H6.11806C5.81724 18.4442 5.57407 18.1466 5.57407 17.7786ZM14.4708 22.725H6.11806C5.81724 22.725 5.57407 23.0225 5.57407 23.3906C5.57407 23.7586 5.81724 24.0562 6.11806 24.0562H14.4708C14.7716 24.0562 15.0148 23.7586 15.0148 23.3906C15.0148 23.0225 14.7716 22.725 14.4708 22.725ZM14.4708 28.337H6.11806C5.81724 28.337 5.57407 28.6345 5.57407 29.0026C5.57407 29.3706 5.81724 29.6682 6.11806 29.6682H14.4708C14.7716 29.6682 15.0148 29.3706 15.0148 29.0026C15.0148 28.6345 14.7716 28.337 14.4708 28.337ZM14.4708 33.949H6.11806C5.81724 33.949 5.57407 34.2465 5.57407 34.6146C5.57407 34.9826 5.81724 35.2802 6.11806 35.2802H14.4708C14.7716 35.2802 15.0148 34.9826 15.0148 34.6146C15.0148 34.2465 14.7716 33.949 14.4708 33.949ZM39.879 33.477C39.7333 33.8682 39.4723 34.1644 39.1443 34.3132L37.4494 35.0839C37.3006 35.1506 37.1475 35.1852 36.9935 35.1852C36.8069 35.1852 36.6214 35.1365 36.4463 35.0378C36.3227 34.9685 36.2147 34.8723 36.1172 34.7646C36.0753 35.234 35.9306 35.6841 35.678 36.0227C35.3311 36.4869 34.8636 36.669 34.3647 36.5498C34.3521 36.8563 34.2861 37.1654 34.1593 37.4539C33.7872 38.3042 33.0126 38.7235 32.2757 38.5491C32.2621 38.8543 32.1929 39.1531 32.0724 39.4289C32.0032 39.5892 31.9131 39.729 31.8156 39.8598V41.7604C31.8156 44.1021 30.2905 46.013 28.3913 46.0912C27.9689 47.9097 26.6031 49.246 24.9837 49.246H3.5459C1.59109 49.246 0 47.3005 0 44.9088V7.48565C0 5.1439 1.52611 3.23305 3.42536 3.15482C3.85405 1.3222 5.24181 0 6.8329 0H28.2718C30.2266 0 31.8166 1.94676 31.8166 4.33724V25.0475C31.89 25.0834 31.9602 25.1206 32.0305 25.1565C32.5713 25.4335 32.912 25.5848 33.1813 25.5707C33.1216 25.2347 33.1478 24.8859 33.2673 24.5666C33.414 24.1767 33.674 23.8792 34.002 23.7304L35.698 22.9597C36.026 22.8109 36.3824 22.8276 36.701 23.0058C37.0197 23.1841 37.2628 23.5047 37.3844 23.9048L39.9178 32.2497C40.0394 32.6511 40.0258 33.0872 39.879 33.477ZM31.6102 26.3825C30.5861 25.858 29.5264 25.3155 28.0538 26.5595C27.7414 26.8237 27.4207 27.1571 27.0989 27.5534C26.905 27.7919 26.7069 28.0318 26.513 28.2639C26.1189 28.7371 25.6525 29.2988 25.4009 29.681C26.144 30.6287 26.9186 30.3402 28.1397 29.7785C29.1344 29.3206 30.2591 28.8012 31.2548 29.7297C31.5284 29.9208 31.9319 30.1645 32.3585 30.4222C33.5723 31.1545 34.5942 31.8022 35.2525 32.4562L33.5492 26.8442C33.4203 26.8801 33.2903 26.9019 33.1625 26.9019C32.6269 26.9019 32.0986 26.6313 31.6102 26.3812V26.3825ZM4.57833 3.14713H24.9837C26.9385 3.14713 28.5286 5.09388 28.5286 7.48437V24.7564C29.3535 24.3832 30.0851 24.4178 30.7276 24.6012V4.33724C30.7276 2.67903 29.625 1.3299 28.2697 1.3299H6.8329C5.8403 1.3299 4.9609 2.07244 4.57833 3.14585V3.14713ZM17.2044 10.8033L20.1381 8.38336C20.3216 8.23204 20.5626 8.23204 20.7461 8.38336L23.3696 10.5469V4.47831H17.2044V10.8033ZM27.4417 44.9088V43.2801C27.3274 43.3147 27.2132 43.3339 27.0989 43.3339C26.8327 43.3339 26.5717 43.2467 26.339 43.0941C25.9575 42.844 25.6388 42.4106 25.469 41.9053C25.4586 41.9091 25.447 41.9143 25.4355 41.9181C24.9995 42.0797 24.5404 42.0245 24.14 41.7629C23.8434 41.5821 23.5991 41.282 23.4409 40.9063C23.3644 40.9499 23.2857 40.987 23.204 41.0178C22.768 41.1781 22.3078 41.1243 21.9085 40.8627C21.5269 40.6292 21.2345 40.2035 21.0962 39.6713C21.0228 39.3866 20.9987 39.0877 21.0238 38.7966C20.7765 38.7838 20.527 38.7056 20.2943 38.5517C19.9138 38.3196 19.6204 37.8938 19.482 37.3616C19.3405 36.8178 19.3824 36.2253 19.5962 35.7354L19.7922 35.2878C19.679 35.3263 19.5638 35.3507 19.4474 35.3507C19.3122 35.3507 19.1759 35.325 19.0449 35.2725L17.3239 34.594C16.6363 34.3222 16.2568 33.4155 16.478 32.5742L18.7127 24.101C18.8196 23.6945 19.0512 23.3624 19.3636 23.1674C19.6759 22.9712 20.0312 22.9366 20.3635 23.0674L22.0856 23.7471C22.5269 23.9215 22.8392 24.3588 22.9482 24.8705C23.3476 24.8872 23.7459 24.791 24.1892 24.6833C25.1179 24.4576 26.1545 24.2075 27.4438 24.9859V7.48565C27.4438 5.82745 26.3411 4.47831 24.9858 4.47831H24.4586V11.7972C24.4586 12.0435 24.3475 12.2692 24.1704 12.3846C23.9922 12.5 23.7784 12.4859 23.6107 12.3487L20.4442 9.73635L17.2033 12.409C17.1132 12.4834 17.0073 12.5231 16.8994 12.5231H16.6635C16.3627 12.5231 16.1195 12.2256 16.1195 11.8575V4.47703H3.54904C2.19378 4.47703 1.09113 5.82616 1.09113 7.48437V44.9075C1.09113 46.5657 2.19378 47.9136 3.54904 47.9136H24.9869C26.3421 47.9136 27.4448 46.5644 27.4448 44.9075L27.4417 44.9088ZM29.0516 39.8803C29.1344 40.3035 29.0652 40.7229 28.9615 41.0717L29.017 41.1063C29.3556 41.3192 29.5285 40.9986 29.5726 40.8947C29.6218 40.778 29.7371 40.3997 29.365 40.0855L29.0527 39.879L29.0516 39.8803ZM28.5129 42.2874L28.4709 42.2605C28.4668 42.2695 28.4615 42.2785 28.4573 42.2874H28.5129ZM26.7593 40.1842L26.4784 40.8267C26.2992 41.2371 26.5759 41.7398 26.8516 41.9207C26.9553 41.9899 27.2719 42.1951 27.5601 41.5359L27.7645 41.0691C27.7645 41.0691 27.7645 41.0691 27.7645 41.0678C28.1502 40.1855 28.0381 40.0573 27.6282 39.7892C27.4521 39.6738 27.2624 39.7277 27.166 39.77C26.991 39.8457 26.8421 39.997 26.7604 40.1855L26.7593 40.1842ZM25.8631 37.8181C25.5665 37.6232 25.1934 37.7604 25.033 38.1259C25.033 38.1259 25.033 38.1272 25.033 38.1285L24.401 39.5738C24.3245 39.7495 24.3119 39.9662 24.3643 40.1688C24.3926 40.2766 24.4649 40.4741 24.6389 40.5805C24.7961 40.6831 24.9617 40.7023 25.119 40.6434C25.2762 40.5856 25.4061 40.4561 25.4827 40.2817L25.5194 40.1971C25.5194 40.1971 25.5194 40.1958 25.5204 40.1945L25.7971 39.5597C25.7971 39.5597 25.7971 39.5571 25.7971 39.5558L26.1137 38.8325C26.273 38.467 26.1598 38.0118 25.861 37.8156L25.8631 37.8181ZM24.2752 36.5703C24.228 36.3766 24.1222 36.2189 23.9796 36.1253C23.6819 35.9304 23.3088 36.0689 23.1484 36.4331C23.1484 36.4331 23.1484 36.4331 23.1484 36.4344L22.595 37.7014L22.1695 38.6735C22.0929 38.8492 22.0804 39.0659 22.1328 39.2686C22.1611 39.3763 22.2344 39.5751 22.4084 39.6802C22.7208 39.8841 23.0929 39.7444 23.2522 39.3814L23.443 38.9454C23.443 38.9454 23.443 38.9454 23.444 38.9428L24.075 37.5001C24.075 37.5001 24.075 37.5001 24.075 37.4988L24.2312 37.141C24.3087 36.9653 24.3245 36.7627 24.2762 36.569L24.2752 36.5703ZM22.0772 34.394C21.941 34.3145 21.7848 34.3004 21.637 34.3555C21.4798 34.4132 21.3509 34.5427 21.2733 34.7184L21.0406 35.2507L20.5543 36.3638C20.4777 36.5395 20.4641 36.7563 20.5176 36.9589C20.5459 37.0666 20.6182 37.2641 20.7932 37.3705C21.1035 37.5745 21.4766 37.4372 21.6359 37.0717C21.6359 37.0717 21.637 37.0692 21.637 37.0679L22.1894 35.8034L22.355 35.4238C22.4168 35.2814 22.6044 34.8518 22.0762 34.3914L22.0772 34.394ZM21.8938 25.3579C21.9305 25.2168 21.8655 25.059 21.7491 25.0142L20.027 24.3345C20.0029 24.3255 19.9809 24.3216 19.96 24.3216C19.9149 24.3216 19.8771 24.3396 19.8562 24.3524C19.8258 24.3716 19.7692 24.4191 19.7451 24.5102L17.5104 32.9833C17.4737 33.1244 17.5398 33.2821 17.6551 33.327L19.3772 34.0067C19.4526 34.0362 19.5166 34.008 19.547 33.9887C19.5784 33.9695 19.634 33.922 19.6581 33.8297L20.0459 32.3562C20.0595 32.2972 20.0721 32.2369 20.0868 32.1779C20.0931 32.1574 20.1004 32.1394 20.1077 32.1202L21.8917 25.3553L21.8938 25.3579ZM30.7297 41.7617V40.542C30.7297 40.542 30.7224 40.5446 30.7182 40.5446C30.7276 40.8845 30.6626 41.2205 30.5358 41.5141C30.2633 42.1515 29.7623 42.5068 29.2298 42.5068C28.9971 42.5068 28.7592 42.4375 28.5307 42.2964V44.751C29.7654 44.592 30.7297 43.3121 30.7297 41.7604V41.7617ZM34.9192 33.9246C34.5471 33.2321 32.9413 32.2613 31.8774 31.6188C31.3984 31.3302 30.9844 31.0801 30.6794 30.8634C30.6574 30.848 30.6354 30.8288 30.6144 30.8095C30.1176 30.3286 29.496 30.5787 28.5234 31.0276C27.3075 31.588 25.642 32.3536 24.2941 30.1363C24.1809 29.949 24.1547 29.7028 24.228 29.4861C24.4094 28.9461 24.9251 28.31 25.751 27.3161C25.9407 27.0879 26.1357 26.8545 26.3254 26.6198C26.4805 26.4287 26.6356 26.2492 26.7908 26.0812C25.9103 25.6195 25.1986 25.7926 24.3978 25.9875C23.8947 26.1106 23.3769 26.2338 22.8141 26.1914L21.0878 32.7396C21.049 32.9063 21.0175 33.0756 20.9987 33.2449C21.0993 33.1782 21.2073 33.1231 21.3205 33.082C21.7565 32.9192 22.2166 32.9756 22.616 33.2372C22.6411 33.2526 22.6642 33.2718 22.6872 33.2924C23.1359 33.6784 23.4115 34.1811 23.4954 34.7197C23.8276 34.6736 24.1746 34.7441 24.4922 34.9518C24.8915 35.2135 25.185 35.6508 25.316 36.1843C25.3349 36.2612 25.3506 36.3382 25.3621 36.4164C25.6996 36.3625 26.0539 36.4344 26.3767 36.6447C26.7719 36.9037 27.0476 37.3282 27.1817 37.8117C27.3368 37.5373 27.6366 37.4424 27.884 37.604L29.6879 38.7889C29.7182 38.8005 29.7497 38.8159 29.779 38.8351C29.779 38.8351 29.7801 38.8351 29.7811 38.8351L30.2318 39.1301C30.3849 39.2301 30.561 39.2506 30.7287 39.1891C30.8964 39.1262 31.0337 38.9903 31.1144 38.803C31.1961 38.6158 31.214 38.4003 31.1626 38.1952C31.1123 37.9912 31.0001 37.8232 30.8482 37.7232H30.8471C30.8282 37.7104 30.8125 37.6937 30.7957 37.6796L28.712 36.3164C28.4468 36.1432 28.3473 35.7406 28.4888 35.4161C28.6303 35.0916 28.9604 34.9685 29.2246 35.1429L31.3628 36.5421C31.3817 36.5536 31.3963 36.569 31.4131 36.5831L32.2988 37.1628C32.6227 37.3731 33.0273 37.2243 33.2002 36.8281C33.3679 36.4459 33.2568 35.9727 32.957 35.7495L30.0201 33.7989C29.756 33.6232 29.6585 33.2193 29.8011 32.8961C29.9446 32.5729 30.2748 32.4536 30.5389 32.6281L33.413 34.5363C33.4214 34.5415 33.4308 34.544 33.4392 34.5504L34.3322 35.134C34.6907 35.3674 34.8238 35.1917 34.8731 35.125C35.0617 34.8711 35.1215 34.3029 34.916 33.922L34.9192 33.9246ZM38.899 32.7153L36.3656 24.3704C36.3373 24.278 36.2807 24.2344 36.2482 24.2178C36.2283 24.2062 36.1948 24.1921 36.1539 24.1921C36.1308 24.1921 36.1057 24.1972 36.0784 24.2088L34.3825 24.9795C34.3081 25.0129 34.2725 25.0834 34.2578 25.1232C34.2431 25.1616 34.2232 25.2411 34.2505 25.3309L36.7838 33.6771C36.8111 33.7681 36.8687 33.8117 36.9002 33.831C36.9316 33.8477 36.9966 33.872 37.071 33.84L38.7669 33.0692C38.8414 33.0359 38.877 32.9653 38.8917 32.9269C38.9063 32.8884 38.9263 32.8089 38.899 32.7178V32.7153Z", fill: "currentColor" })
  }
), hj = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 33 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsx("path", { d: "M5.44355 49.8668H23.4943C26.359 49.8642 28.6809 47.5423 28.6835 44.6762V34.1782H29.9731C31.5924 34.1756 32.904 32.864 32.9066 31.2447V18.0663C32.9066 17.8858 32.8352 17.7144 32.708 17.5858L28.6848 13.5718V5.18926C28.6822 2.32452 26.3603 0.00259723 23.4956 0H5.44485C2.5788 0.00259723 0.258182 2.32452 0.255585 5.18926V44.6762C0.258182 47.541 2.5801 49.8629 5.44485 49.8668H5.44355ZM29.9744 32.8251H26.3382V22.0648C26.3382 21.8842 26.2668 21.7128 26.1396 21.5856L20.4399 15.8963C20.4399 15.8963 20.4373 15.8937 20.436 15.8924C20.3088 15.7613 20.1348 15.686 19.9517 15.686C19.9335 15.686 19.9153 15.6873 19.8984 15.6886C19.8802 15.6873 19.8621 15.686 19.8452 15.686H16.9155V14.6198C16.9155 13.7484 17.6232 13.042 18.4946 13.0407H25.8435V15.8197C25.8461 17.4391 27.1577 18.7507 28.777 18.7533H31.5561V31.2434C31.5548 32.1147 30.8483 32.8212 29.977 32.8225L29.9744 32.8251ZM19.2712 17.0417V19.8207C19.2725 21.4401 20.5854 22.7517 22.2048 22.7543H24.9838V35.2444C24.9838 36.1158 24.276 36.8222 23.4047 36.8235H11.9223C11.051 36.8222 10.3445 36.1158 10.3432 35.2444V18.6208C10.3432 17.7482 11.051 17.0417 11.9223 17.0404H19.2712V17.0417ZM24.0371 21.3999H22.2061C21.3334 21.3986 20.6282 20.6921 20.6269 19.8207V17.9975L24.0384 21.4012L24.0371 21.3999ZM27.3317 14.1328V14.1964H27.3953L30.6068 17.4001H28.7757C27.9044 17.4001 27.1966 16.6924 27.1966 15.821V13.9978L27.333 14.1341L27.3317 14.1328ZM5.44355 1.35445H23.4943C25.6123 1.35705 27.3278 3.07252 27.3304 5.19056V6.76967H25.7513C25.3773 6.76967 25.0747 7.07355 25.0747 7.44625C25.0747 7.81895 25.3786 8.12283 25.7513 8.12283H27.3304V12.2213L27.007 11.8992C27.007 11.8992 27.0044 11.8966 27.0018 11.8953C26.8746 11.7641 26.6993 11.6888 26.5175 11.6888C26.4993 11.6888 26.4811 11.6888 26.4642 11.6914C26.446 11.6888 26.4291 11.6888 26.411 11.6888H18.492C16.8727 11.6914 15.5611 13.003 15.5585 14.6224V15.6886H11.9223C10.303 15.6899 8.99136 17.0028 8.98876 18.6221V35.2457C8.99006 36.8651 10.303 38.1767 11.9223 38.1793H23.4047C25.024 38.178 26.3356 36.8651 26.3382 35.2457V34.1795H27.3317V40.3908H1.60874V8.12283H19.9984C20.3724 8.12283 20.675 7.81895 20.675 7.44625C20.675 7.07355 20.3724 6.76967 19.9984 6.76967H1.60874V5.19056C1.61134 3.07252 3.3281 1.35705 5.44485 1.35445H5.44355ZM1.60744 41.7439H27.3304V44.6775C27.3278 46.7956 25.6123 48.511 23.4943 48.5136H5.44355C3.32551 48.511 1.61004 46.7956 1.60744 44.6775V41.7439Z", fill: "currentColor" })
  }
), Aj = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsx("path", { d: "M20.0001 20C21.3186 20 22.6076 19.609 23.7039 18.8765C24.8002 18.1439 25.6547 17.1027 26.1593 15.8846C26.6639 14.6664 26.7959 13.3259 26.5387 12.0327C26.2814 10.7395 25.6465 9.55164 24.7141 8.61929C23.7818 7.68694 22.5939 7.052 21.3007 6.79476C20.0075 6.53753 18.667 6.66955 17.4489 7.17414C16.2307 7.67872 15.1895 8.5332 14.457 9.62953C13.7244 10.7259 13.3334 12.0148 13.3334 13.3333C13.3334 15.1014 14.0358 16.7971 15.286 18.0474C16.5363 19.2976 18.232 20 20.0001 20ZM20.0001 10C20.6594 10 21.3038 10.1955 21.852 10.5618C22.4002 10.928 22.8274 11.4486 23.0797 12.0577C23.332 12.6668 23.398 13.337 23.2694 13.9836C23.1408 14.6302 22.8233 15.2242 22.3571 15.6904C21.8909 16.1565 21.297 16.474 20.6504 16.6026C20.0038 16.7312 19.3336 16.6652 18.7245 16.4129C18.1154 16.1606 17.5948 15.7334 17.2285 15.1852C16.8623 14.6371 16.6668 13.9926 16.6668 13.3333C16.6668 12.4493 17.0179 11.6014 17.6431 10.9763C18.2682 10.3512 19.116 10 20.0001 10ZM34.4334 15.2617L33.2351 14.8633C33.4507 12.9965 33.2693 11.1052 32.7028 9.31347C32.1362 7.52171 31.1973 5.86994 29.9476 4.46649C28.6979 3.06303 27.1656 1.9396 25.4513 1.16986C23.737 0.400112 21.8793 0.0014458 20.0001 0C18.0964 0.000734949 16.2149 0.40949 14.4825 1.19872C12.75 1.98796 11.2069 3.13934 9.95696 4.57529C8.70706 6.01124 7.77944 7.69841 7.23661 9.52312C6.69378 11.3478 6.54834 13.2677 6.81009 15.1533C5.21515 15.4507 3.7403 16.2032 2.56343 17.32C1.74872 18.0946 1.10104 19.0276 0.660223 20.0617C0.219405 21.0958 -0.00524229 22.2092 9.28451e-05 23.3333V30.125C0.0035955 31.9272 0.589746 33.68 1.67108 35.1218C2.75241 36.5635 4.27095 37.617 6.00009 38.125L10.7834 39.625C11.5869 39.875 12.4236 40.0015 13.2651 40C14.0284 39.999 14.7881 39.8947 15.5234 39.69L25.1568 36.84C26.015 36.6058 26.9202 36.6058 27.7784 36.84L31.7568 38.1733C32.7373 38.412 33.7591 38.4249 34.7454 38.2112C35.7316 37.9975 36.6564 37.5627 37.4502 36.9395C38.2439 36.3164 38.8858 35.5212 39.3275 34.6139C39.7692 33.7065 39.9992 32.7108 40.0001 31.7017V23.12C39.9963 21.3957 39.4593 19.7147 38.4627 18.3076C37.4661 16.9004 36.0587 15.8376 34.4334 15.2617ZM12.9301 6.27C13.8572 5.33915 14.959 4.60054 16.1722 4.09655C17.3855 3.59257 18.6863 3.33313 20.0001 3.33313C21.3139 3.33313 22.6147 3.59257 23.828 4.09655C25.0412 4.60054 26.143 5.33915 27.0701 6.27C28.9404 8.1519 29.9916 10.6964 29.9951 13.3496C29.9985 16.0028 28.9538 18.5499 27.0884 20.4367L21.1668 26.195C20.8577 26.498 20.4421 26.6678 20.0093 26.6678C19.5764 26.6678 19.1608 26.498 18.8518 26.195L12.9301 20.4617C11.0559 18.5756 10.0039 16.0247 10.0039 13.3658C10.0039 10.7069 11.0559 8.15602 12.9301 6.27ZM36.6668 31.7017C36.6678 32.2065 36.5536 32.7048 36.333 33.1589C36.1123 33.6129 35.791 34.0106 35.3934 34.3217C35.0178 34.6237 34.5802 34.8392 34.1118 34.953C33.6435 35.0668 33.1558 35.076 32.6834 34.98L28.7751 33.6667C27.2968 33.242 25.73 33.2327 24.2468 33.64L14.6068 36.4867C13.6806 36.7422 12.7003 36.7254 11.7834 36.4383L6.96009 34.9383C5.91618 34.6365 4.99836 34.0041 4.34442 33.1362C3.69049 32.2683 3.33574 31.2117 3.33343 30.125V23.3333C3.32968 22.6596 3.46377 21.9923 3.72746 21.3723C3.99115 20.7524 4.37886 20.1929 4.86676 19.7283C5.63052 19.0004 6.60346 18.5306 7.64843 18.385C8.32027 20.0503 9.32073 21.5632 10.5901 22.8333L16.5351 28.5883C17.4643 29.4982 18.713 30.0077 20.0134 30.0077C21.3139 30.0077 22.5626 29.4982 23.4918 28.5883L29.4301 22.8167C30.7597 21.4817 31.7897 19.879 32.4518 18.115L33.3468 18.4117C34.3174 18.7595 35.1571 19.3983 35.7512 20.2409C36.3454 21.0835 36.6651 22.089 36.6668 23.12V31.7017Z", fill: "currentColor" })
  }
), pj = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsx("path", { d: "M21.6667 1.66664C21.6667 1.22462 21.8423 0.800692 22.1548 0.488131C22.4674 0.175571 22.8913 -2.39338e-05 23.3333 -2.39338e-05C27.7521 0.00482873 31.9885 1.76233 35.1131 4.88689C38.2376 8.01145 39.9951 12.2479 40 16.6666C40 17.1087 39.8244 17.5326 39.5118 17.8452C39.1993 18.1577 38.7754 18.3333 38.3333 18.3333C37.8913 18.3333 37.4674 18.1577 37.1548 17.8452C36.8423 17.5326 36.6667 17.1087 36.6667 16.6666C36.6627 13.1316 35.2567 9.74256 32.757 7.24294C30.2574 4.74331 26.8683 3.33728 23.3333 3.33331C22.8913 3.33331 22.4674 3.15771 22.1548 2.84515C21.8423 2.53259 21.6667 2.10867 21.6667 1.66664ZM23.3333 9.99998C25.1014 9.99998 26.7971 10.7024 28.0474 11.9526C29.2976 13.2028 30 14.8985 30 16.6666C30 17.1087 30.1756 17.5326 30.4881 17.8452C30.8007 18.1577 31.2246 18.3333 31.6667 18.3333C32.1087 18.3333 32.5326 18.1577 32.8452 17.8452C33.1577 17.5326 33.3333 17.1087 33.3333 16.6666C33.3307 14.0153 32.2763 11.4733 30.4015 9.5985C28.5267 7.72371 25.9847 6.66929 23.3333 6.66664C22.8913 6.66664 22.4674 6.84224 22.1548 7.1548C21.8423 7.46736 21.6667 7.89128 21.6667 8.33331C21.6667 8.77534 21.8423 9.19926 22.1548 9.51182C22.4674 9.82438 22.8913 9.99998 23.3333 9.99998ZM38.4883 27.8983C39.4542 28.8668 39.9966 30.1788 39.9966 31.5466C39.9966 32.9145 39.4542 34.2265 38.4883 35.195L36.9717 36.9433C23.3217 50.0116 -9.895 16.8033 2.97166 3.10998L4.88833 1.44331C5.85794 0.504438 7.15822 -0.0149421 8.50784 -0.00246586C9.85746 0.0100104 11.1479 0.55334 12.1 1.50998C12.1517 1.56164 15.24 5.57331 15.24 5.57331C16.1564 6.53602 16.6665 7.81486 16.6643 9.14398C16.6622 10.4731 16.1479 11.7503 15.2283 12.71L13.2983 15.1366C14.3664 17.7318 15.9368 20.0904 17.9192 22.0768C19.9016 24.0632 22.257 25.6383 24.85 26.7116L27.2917 24.77C28.2515 23.8512 29.5284 23.3375 30.8572 23.3356C32.1859 23.3337 33.4642 23.8439 34.4267 24.76C34.4267 24.76 38.4367 27.8466 38.4883 27.8983ZM36.195 30.3216C36.195 30.3216 32.2067 27.2533 32.155 27.2016C31.8116 26.8612 31.3477 26.6702 30.8642 26.6702C30.3806 26.6702 29.9167 26.8612 29.5733 27.2016C29.5283 27.2483 26.1667 29.9266 26.1667 29.9266C25.9401 30.107 25.6705 30.2252 25.3844 30.2696C25.0983 30.314 24.8055 30.2831 24.535 30.18C21.1758 28.9293 18.1246 26.9712 15.5881 24.4384C13.0516 21.9057 11.089 18.8574 9.83333 15.5C9.72199 15.2257 9.6857 14.9268 9.72817 14.6339C9.77064 14.341 9.89035 14.0646 10.075 13.8333C10.075 13.8333 12.7533 10.47 12.7983 10.4266C13.1388 10.0833 13.3298 9.61934 13.3298 9.13581C13.3298 8.65228 13.1388 8.18833 12.7983 7.84498C12.7467 7.79498 9.67833 3.80331 9.67833 3.80331C9.32983 3.49082 8.875 3.32347 8.40708 3.33555C7.93915 3.34764 7.49357 3.53825 7.16166 3.86831L5.245 5.53498C-4.15834 16.8416 24.6267 44.03 34.535 34.6666L36.0533 32.9166C36.4091 32.5871 36.6228 32.1321 36.6493 31.6478C36.6757 31.1635 36.5128 30.688 36.195 30.3216Z", fill: "currentColor" })
  }
), vj = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 40 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsx("path", { d: "M31.6667 0H8.33333C6.12401 0.00264643 4.00593 0.88147 2.4437 2.4437C0.88147 4.00593 0.00264643 6.12401 0 8.33333L0 28.3333C0.00264643 30.5427 0.88147 32.6607 2.4437 34.223C4.00593 35.7852 6.12401 36.664 8.33333 36.6667H31.6667C33.876 36.664 35.9941 35.7852 37.5563 34.223C39.1185 32.6607 39.9974 30.5427 40 28.3333V8.33333C39.9974 6.12401 39.1185 4.00593 37.5563 2.4437C35.9941 0.88147 33.876 0.00264643 31.6667 0ZM8.33333 3.33333H31.6667C32.6646 3.3353 33.6392 3.63586 34.4649 4.19634C35.2906 4.75682 35.9298 5.55158 36.3 6.47833L23.5367 19.2433C22.5974 20.1789 21.3257 20.7041 20 20.7041C18.6743 20.7041 17.4026 20.1789 16.4633 19.2433L3.7 6.47833C4.07025 5.55158 4.70936 4.75682 5.53508 4.19634C6.3608 3.63586 7.33536 3.3353 8.33333 3.33333ZM31.6667 33.3333H8.33333C7.00725 33.3333 5.73548 32.8066 4.7978 31.8689C3.86012 30.9312 3.33333 29.6594 3.33333 28.3333V10.8333L14.1067 21.6C15.671 23.1604 17.7904 24.0367 20 24.0367C22.2096 24.0367 24.329 23.1604 25.8933 21.6L36.6667 10.8333V28.3333C36.6667 29.6594 36.1399 30.9312 35.2022 31.8689C34.2645 32.8066 32.9927 33.3333 31.6667 33.3333Z", fill: "currentColor" })
  }
), gj = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsx("path", { d: "M34.1737 5.81333C30.4124 2.06667 25.4118 0.00166667 20.0846 0C9.10697 0 0.172493 8.89 0.167469 19.82C0.165794 23.3133 1.08353 26.7233 2.82688 29.73L0 40L10.5573 37.2433C13.4662 38.8233 16.7419 39.655 20.0745 39.6567H20.0829C31.0588 39.6567 39.995 30.765 40 19.835C40.0033 14.54 37.9334 9.55833 34.1737 5.81333ZM20.0846 36.3083H20.0779C17.107 36.3083 14.1947 35.5133 11.6525 34.0117L11.0479 33.655L4.78292 35.29L6.45593 29.21L6.06238 28.5867C4.40444 25.9633 3.53025 22.9317 3.53192 19.82C3.53527 10.7367 10.9625 3.34667 20.0929 3.34667C24.5141 3.34667 28.6707 5.06333 31.7957 8.17667C34.9207 11.2917 36.6406 15.43 36.6389 19.8317C36.6339 28.9183 29.2083 36.3083 20.0846 36.3083ZM29.1647 23.97C28.6674 23.7217 26.2206 22.5233 25.7634 22.3583C25.3079 22.1933 24.9763 22.11 24.6431 22.605C24.3098 23.1 23.3586 24.2167 23.0672 24.5483C22.7775 24.8783 22.4861 24.92 21.9887 24.6717C21.4913 24.4233 19.887 23.9017 17.9862 22.2133C16.5074 20.9 15.5076 19.2783 15.2179 18.7817C14.9282 18.285 15.1878 18.0183 15.4356 17.7717C15.66 17.55 15.933 17.1933 16.1825 16.9033C16.4337 16.6167 16.5158 16.41 16.6833 16.0783C16.8491 15.7483 16.767 15.4583 16.6414 15.21C16.5158 14.9633 15.521 12.525 15.1074 11.5333C14.7038 10.5667 14.2935 10.6983 13.987 10.6833C13.6973 10.6683 13.3657 10.6667 13.0324 10.6667C12.7009 10.6667 12.1616 10.79 11.7061 11.2867C11.2506 11.7833 9.96441 12.9817 9.96441 15.4183C9.96441 17.8567 11.748 20.2117 11.9958 20.5417C12.2437 20.8717 15.5043 25.875 20.4965 28.02C21.6839 28.53 22.6117 28.835 23.3335 29.0633C24.5259 29.44 25.6111 29.3867 26.4685 29.26C27.4247 29.1183 29.4126 28.0617 29.8279 26.905C30.2432 25.7483 30.2432 24.755 30.1176 24.55C29.9937 24.3417 29.6621 24.2183 29.1647 23.97Z", fill: "currentColor" })
  }
), mj = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 40 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsx("path", { d: "M31.6667 4H20.7867C20.53 4 20.27 3.94 20.0417 3.825L14.7867 1.19834C14.095 0.851669 13.3217 0.668336 12.5467 0.668336H8.33333C3.73833 0.666669 0 4.405 0 9V29C0 33.595 3.73833 37.3333 8.33333 37.3333H13.3333C14.2533 37.3333 15 36.5883 15 35.6667C15 34.745 14.2533 34 13.3333 34H8.33333C5.57667 34 3.33333 31.7567 3.33333 29V14H36.6667V29C36.6667 31.7567 34.4233 34 31.6667 34H26.6667C25.7467 34 25 34.745 25 35.6667C25 36.5883 25.7467 37.3333 26.6667 37.3333H31.6667C36.2617 37.3333 40 33.595 40 29V12.3333C40 7.73834 36.2617 4 31.6667 4ZM3.33333 9C3.33333 6.24333 5.57667 4 8.33333 4H12.5467C12.8033 4 13.06 4.06 13.2917 4.17667L18.5517 6.805C19.2433 7.15 20.015 7.33167 20.7867 7.33167H31.6667C33.8367 7.33167 35.67 8.73 36.36 10.665H3.33333V9ZM23.8217 25.4933L21.6667 23.3383V35.6667C21.6667 36.5883 20.92 37.3333 20 37.3333C19.08 37.3333 18.3333 36.5883 18.3333 35.6667V23.3383L16.1783 25.4933C15.8533 25.8183 15.4267 25.9817 15 25.9817C14.5733 25.9817 14.1467 25.8183 13.8217 25.4933C13.17 24.8417 13.17 23.7883 13.8217 23.1367L16.51 20.4483C18.3733 18.5833 21.625 18.5833 23.49 20.4483L26.1783 23.1367C26.83 23.7883 26.83 24.8417 26.1783 25.4933C25.5267 26.145 24.4733 26.145 23.8217 25.4933Z", fill: "currentColor" })
  }
), Cj = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 34 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsx("path", { d: "M32.2017 5.43333L28.2333 1.465C27.29 0.52 26.0333 0 24.6983 0H17C12.9767 0 9.60834 2.86833 8.835 6.66667H8.66667C4.07167 6.66667 0.333336 10.405 0.333336 15V31.6667C0.333336 36.2617 4.07167 40 8.66667 40H18.6667C23.2617 40 27 36.2617 27 31.6667V31.4983C30.7983 30.7233 33.6667 27.3567 33.6667 23.3333V8.96833C33.6667 7.63333 33.1467 6.37667 32.2017 5.43333ZM18.6667 36.6667H8.66667C5.91 36.6667 3.66667 34.4233 3.66667 31.6667V15C3.66667 12.2433 5.91 10 8.66667 10V23.3333C8.66667 27.9283 12.405 31.6667 17 31.6667H23.6667C23.6667 34.4233 21.4233 36.6667 18.6667 36.6667ZM25.3333 28.3333H17C14.2433 28.3333 12 26.09 12 23.3333V8.33333C12 5.57667 14.2433 3.33333 17 3.33333H23.6667V6.66667C23.6667 8.50833 25.1583 10 27 10H30.3333V23.3333C30.3333 26.09 28.09 28.3333 25.3333 28.3333ZM27 18.3333C27 19.2533 26.2533 20 25.3333 20H22.8333V22.5C22.8333 23.42 22.0867 24.1667 21.1667 24.1667C20.2467 24.1667 19.5 23.42 19.5 22.5V20H17C16.08 20 15.3333 19.2533 15.3333 18.3333C15.3333 17.4133 16.08 16.6667 17 16.6667H19.5V14.1667C19.5 13.2467 20.2467 12.5 21.1667 12.5C22.0867 12.5 22.8333 13.2467 22.8333 14.1667V16.6667H25.3333C26.2533 16.6667 27 17.4133 27 18.3333Z", fill: "currentColor" })
  }
), bj = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsx("path", { d: "M39.9999 21.8038C40.0013 21.6889 39.9929 21.6735 39.8598 21.6693C39.4801 21.6539 39.078 21.6581 38.7235 21.8879C38.5106 22.0252 38.2836 22.1386 38.0651 22.2479C37.9656 22.297 37.8675 22.3474 37.7695 22.3992C37.6518 22.4609 37.4542 22.566 37.2231 22.4693C36.8126 22.2956 36.3867 22.1975 35.9341 22.091C35.6539 22.0252 35.3625 21.9579 35.0795 21.8711C35.0641 21.8669 35.0473 21.8627 35.0305 21.8598C34.9366 21.8402 34.7405 21.7996 34.6872 21.5782C34.6326 21.3485 34.7993 21.221 34.8792 21.1593C34.8918 21.1495 34.903 21.1411 34.9142 21.1327C35.3037 20.8021 35.5979 20.4168 35.8151 19.9559C36.1723 19.1951 36.1569 18.391 36.1023 17.4929C36.0154 16.0597 34.9212 14.7497 33.5538 14.4443C33.4908 14.4303 33.4025 14.4303 33.3171 14.4303C33.0915 14.4317 32.7861 14.4317 32.66 14.1445C32.5479 13.8909 32.6978 13.6317 32.8183 13.4258C32.8603 13.3543 32.8996 13.2871 32.9248 13.2268C33.0116 13.0307 32.9892 12.962 32.8785 12.8542C32.1374 12.1285 31.3935 11.3803 30.6972 10.6756C30.5963 10.5719 30.5655 10.5775 30.473 10.642C30.2839 10.7737 30.0891 10.8984 29.9 11.0189C29.7501 11.1141 29.5946 11.2136 29.4461 11.3131C29.2093 11.4742 28.9655 11.4882 28.7218 11.3565C28.3575 11.159 27.9652 10.9964 27.5589 10.8731C27.2591 10.7835 27.0798 10.5845 27.0251 10.2791C26.9831 10.0494 26.9313 9.81679 26.8808 9.58982C26.85 9.44692 26.8192 9.30682 26.7884 9.16392C26.7631 9.03923 26.7309 9 26.5824 9H26.574C25.6003 9.00841 24.5664 9.00981 23.4119 9.0014C23.2718 9 23.2452 9.03503 23.2228 9.1443C23.2032 9.23817 23.1808 9.33344 23.1612 9.42731C23.1149 9.63045 23.0715 9.82239 23.0463 10.0185C22.979 10.5313 22.7226 10.8283 22.2393 10.953C21.9913 11.0175 21.7531 11.1323 21.501 11.2556C21.4337 11.2892 21.3637 11.3229 21.295 11.3551C21.0246 11.4826 20.778 11.4658 20.5427 11.3019C20.404 11.2066 20.2597 11.1155 20.1182 11.0259C19.9416 10.9138 19.7581 10.7975 19.583 10.67C19.4541 10.5761 19.4037 10.5719 19.2678 10.712C18.8783 11.1155 18.4734 11.5176 18.0825 11.9071C17.9102 12.078 17.7379 12.2503 17.5669 12.4213C17.2699 12.7183 17.1088 12.8794 17.0836 13.0139C17.0584 13.1456 17.1396 13.3459 17.3119 13.7522C17.3722 13.8951 17.4212 14.0576 17.3344 14.2005C17.2475 14.342 17.0822 14.3743 16.9155 14.3855C15.9894 14.4555 15.2118 14.8828 14.5352 15.6912C14.0308 16.295 13.7674 17.5966 13.9117 18.786C14.0378 19.8284 14.4399 20.648 15.0451 21.0935C15.0563 21.1019 15.0689 21.1103 15.0815 21.1187C15.1754 21.1832 15.3702 21.3191 15.3239 21.56C15.2763 21.8066 15.0619 21.8458 14.9583 21.8641C14.933 21.8683 14.9008 21.8739 14.8882 21.8809C14.1765 22.1989 13.5166 22.1064 12.924 21.6063C12.868 21.5586 12.7937 21.5208 12.7152 21.4788C12.6438 21.4423 12.5709 21.4031 12.4981 21.3527C11.7275 20.8119 11.0564 20.6073 10.3195 20.69C10.0099 20.725 9.99869 20.7559 10.0001 20.9954C10.0141 22.1316 10.0113 23.2861 10.0099 24.4027C10.0085 24.8202 10.0085 25.2391 10.0085 25.6566V26.5967C10.0085 27.8506 10.0085 29.1031 10.0071 30.3556V30.3822C10.0071 30.5895 10.0197 30.6077 10.1136 30.6386C10.6656 30.8193 11.2148 31.0028 11.7654 31.1864C12.7096 31.5002 13.6847 31.8252 14.6486 32.1306C15.0549 32.2595 15.3169 32.2525 15.471 32.111C15.7947 31.8126 16.03 31.9163 16.243 32.0494C16.484 32.1993 16.7333 32.3492 16.9827 32.4949C17.1424 32.5888 17.3133 32.7191 17.361 32.9824C17.4605 33.5386 17.7869 33.8903 18.3585 34.0584C18.5504 34.1145 18.7578 34.2139 18.8376 34.5264C18.9693 35.0475 19.3028 35.3852 19.831 35.5295C20.1588 35.6191 20.2611 35.8363 20.3171 36.0366C20.4502 36.5074 20.7374 36.8128 21.1703 36.9487C21.5948 37.0804 21.7461 37.3662 21.8386 37.6268C21.9605 37.9714 22.2043 38.2446 22.5251 38.3959C22.8319 38.5416 23.1766 38.5571 23.4946 38.4422C23.6291 38.3931 23.751 38.3693 23.8659 38.3693C24.0844 38.3693 24.275 38.459 24.4655 38.6439C24.8031 38.9718 25.3481 39.0852 25.8525 38.9339C26.3232 38.7924 26.6511 38.4492 26.7533 37.9897C26.8094 37.7291 26.9663 37.5693 27.2297 37.5007C27.7396 37.3676 28.0689 37.0566 28.2062 36.5774C28.2958 36.2622 28.4682 36.0913 28.7792 36.0058C29.2387 35.8783 29.5483 35.5645 29.6744 35.1008C29.7767 34.7211 30.0219 34.5992 30.2474 34.5292C30.7868 34.3624 31.1007 33.9996 31.1777 33.4504C31.2296 33.0875 31.3977 32.869 31.7269 32.7443C31.8138 32.7107 31.9006 32.6644 31.9917 32.6154C32.0393 32.5902 32.0856 32.5649 32.1332 32.5411L33.2008 32.0073C35.3877 30.9146 37.5733 29.8218 39.7617 28.729C39.9536 28.6337 39.9915 28.5931 39.9901 28.4796C39.9943 26.3627 39.9943 24.1799 39.9999 21.8038ZM33.1601 15.0622C34.3412 15.2401 35.3177 16.2866 35.3835 17.4439C35.4144 17.9791 35.4144 18.4512 35.3863 18.8883C35.3345 19.6785 34.9296 20.3243 34.1843 20.8105C34.0064 20.9254 33.9489 21.0277 33.9545 21.2126C33.9629 21.4872 33.9601 21.6973 33.9573 21.8669C33.9545 22.0644 33.9531 22.2507 33.9811 22.2886C34.0064 22.3222 34.1857 22.3628 34.358 22.402C34.5275 22.4399 34.7377 22.4889 35.0137 22.566C35.235 22.6276 35.4634 22.685 35.6834 22.7397C35.7884 22.7663 35.8921 22.7929 35.9972 22.8181L36.1065 22.8462L36.2143 23.2104L35.6259 23.5228C35.2883 23.7008 34.952 23.8801 34.6158 24.058L34.0918 24.334C33.2316 24.788 32.37 25.2419 31.5084 25.693C31.3234 25.7897 31.1735 25.8681 31.0446 25.8681C30.9914 25.8681 30.9423 25.8555 30.8947 25.8261C30.728 25.7224 30.7336 25.5039 30.7392 25.2027C30.7546 24.5106 30.7322 23.7848 30.2727 23.188C30.1788 23.0661 30.1494 22.9484 30.1886 22.8406C30.2474 22.6724 30.4338 22.629 30.5122 22.6094C30.6481 22.5772 30.7826 22.5421 30.9185 22.5071C31.1119 22.4581 31.3122 22.4062 31.5126 22.3628C31.6989 22.3222 31.7143 22.2647 31.7045 22.1429C31.6919 22.0084 31.6933 21.8767 31.7059 21.752C31.7535 21.2602 31.6863 20.8932 31.2043 20.5863C30.5963 20.1997 30.2531 19.5034 30.2643 18.6754C30.2657 18.5269 30.2615 18.3727 30.2573 18.2256C30.2432 17.7241 30.2278 17.2071 30.4324 16.6929C30.8737 15.5749 32.0197 14.8912 33.1601 15.0622ZM23.8813 22.0098C23.8687 21.9299 23.8687 21.843 23.8799 21.759C23.9555 21.1972 23.8084 20.8637 23.3587 20.5667C22.7521 20.1674 22.4242 19.4879 22.434 18.6529C22.4368 18.5016 22.4354 18.3503 22.4354 18.2004C22.434 17.9721 22.4326 17.7367 22.441 17.5041C22.4887 16.1704 23.6039 15.0678 24.9278 15.0467C24.9404 15.0467 24.953 15.0453 24.9657 15.0453C26.2812 15.0453 27.4636 16.1241 27.5603 17.4187C27.5729 17.598 27.5701 17.7773 27.5659 17.951C27.5645 18.0239 27.5631 18.0981 27.5631 18.171C27.7018 19.3492 27.2577 20.2641 26.2448 20.8904C26.1439 20.952 26.1439 20.9814 26.1439 20.9996L26.1425 21.0234C26.1397 21.4283 26.1355 21.8458 26.1439 22.2563C26.1453 22.297 26.1453 22.3054 26.2994 22.3404C26.3204 22.3446 26.34 22.3502 26.3597 22.3544C26.6244 22.4217 26.8892 22.4875 27.1526 22.5519C27.671 22.6808 28.2076 22.8139 28.733 22.954C29.5988 23.1866 30.0079 23.719 30.0205 24.6324C30.0247 25.0121 30.0247 25.4156 30.0205 25.899C30.0191 26.1231 29.9939 26.3487 29.8257 26.4776C29.7417 26.542 29.6408 26.5644 29.5357 26.5644C29.4293 26.5644 29.3186 26.5406 29.2149 26.514C28.9109 26.4355 28.6069 26.3459 28.3127 26.2604C28.0367 26.1792 27.7509 26.0965 27.4679 26.0222C25.9323 25.6159 24.4291 25.2125 22.9062 24.7641C22.158 24.5442 21.3567 24.6156 20.6015 24.7277C20.4026 24.7571 20.2022 24.7641 20.0803 24.6268C19.9585 24.4895 19.9907 24.2976 20.0425 24.1099C20.2022 23.5313 20.5917 23.1418 21.1689 22.9877C21.9353 22.7817 22.7549 22.5646 23.5871 22.3824C23.8757 22.3194 23.9107 22.2199 23.8813 22.0098ZM29.086 22.2465C28.7428 22.3082 28.4345 22.2087 28.1361 22.1106C28.0128 22.07 27.8952 22.0322 27.7803 22.007C27.2801 21.8963 27.0041 21.836 26.9355 21.6091C26.8682 21.3849 27.0475 21.1972 27.4048 20.8245C27.8685 20.3426 28.1473 19.7681 28.2328 19.1209C28.4724 17.3108 28.1235 16.0891 27.1036 15.1644C26.3078 14.4429 25.1856 14.1949 24.0998 14.5004C23.0168 14.8044 22.1889 15.6015 21.8862 16.6327C21.7433 17.1174 21.6887 17.6078 21.7223 18.0911L21.7237 18.1037V18.1164C21.6579 19.4109 22.0558 20.4014 22.9412 21.1467C23.0126 21.207 23.206 21.3695 23.1569 21.5796C23.1079 21.7912 22.8599 21.8514 22.7661 21.8739C22.5713 21.9215 22.3752 21.9733 22.1847 22.0252C21.8988 22.1008 21.6046 22.1807 21.3104 22.2451C21.232 22.2633 21.1549 22.2703 21.0793 22.2703C20.8481 22.2703 20.6337 22.2003 20.439 22.1358C20.3157 22.0952 20.198 22.0574 20.0817 22.0364C20.0243 22.0266 19.9599 22.0182 19.8954 22.0098C19.5844 21.9691 19.2327 21.9243 19.1066 21.6483C18.9441 21.2924 19.2537 21.0767 19.4387 20.9464C19.5129 20.8946 19.59 20.8413 19.6306 20.7923C20.114 20.2081 20.3816 19.5888 20.4474 18.9023C20.5189 18.1626 20.5441 17.2968 20.1994 16.4744C20.1028 16.2446 20.1224 16.0345 20.2583 15.8145C21.3749 14.01 22.9888 13.1021 25.0497 13.1106C27.0489 13.1204 28.6265 14.017 29.7403 15.7781C29.9042 16.0373 29.844 16.2572 29.7893 16.452C29.3354 18.0841 29.4489 19.3619 30.1494 20.4714C30.2909 20.6956 30.4884 20.9114 30.7728 21.1495C30.8443 21.2098 31.0362 21.3695 30.9886 21.5768C30.9424 21.7814 30.7084 21.843 30.6327 21.8627C30.4926 21.8991 30.3525 21.9383 30.211 21.9775C29.844 22.0728 29.4685 22.1779 29.086 22.2465ZM18.1343 12.8149C18.5126 12.4633 18.8783 12.0864 19.1851 11.7628C19.314 11.6283 19.4415 11.561 19.576 11.5582C19.7007 11.5554 19.8226 11.6101 19.936 11.7194C20.5749 12.333 21.1773 12.3708 21.8918 11.8454C22.2547 11.5779 22.696 11.477 23.1233 11.3803L23.2578 11.3495C23.4315 11.3089 23.5002 11.2374 23.5282 11.0637C23.5548 10.8984 23.5927 10.7344 23.6277 10.5761C23.6571 10.443 23.6865 10.3071 23.7103 10.174C23.786 9.74954 24.076 9.66688 24.31 9.67108C24.7191 9.67949 25.1688 9.67949 25.7222 9.67248H25.7348C26.0458 9.67248 26.242 9.8364 26.2994 10.1474C26.3274 10.2973 26.3611 10.4486 26.3933 10.5971C26.4311 10.7653 26.4689 10.939 26.4998 11.1127C26.5278 11.2654 26.5894 11.3075 26.6931 11.3313C27.4524 11.5064 28.2062 11.8202 28.9978 12.2924C29.0706 12.3358 29.1154 12.34 29.2205 12.2686C29.341 12.1887 29.4643 12.1116 29.5834 12.036C29.7585 11.9253 29.9392 11.8118 30.1073 11.6927C30.3651 11.5078 30.5935 11.526 30.8079 11.7474C31.0656 12.015 31.3332 12.2826 31.5924 12.5417C31.7017 12.6482 31.8096 12.7561 31.916 12.864L31.9413 12.8892C32.0183 12.9635 32.178 13.119 32.1024 13.3361C32.0758 13.4118 32.0505 13.4888 32.0267 13.5659C31.909 13.9329 31.7858 14.3112 31.4957 14.6096C31.3402 14.7693 31.1525 14.8828 30.9704 14.9935C30.8723 15.0524 30.7798 15.1084 30.6944 15.1686C30.5963 15.2401 30.508 15.2667 30.4296 15.2667C30.2334 15.2667 30.1059 15.0916 30.0485 15.0103L30.0401 14.9991C29.4026 14.1151 28.5774 13.4384 27.5883 12.9845C26.7071 12.5796 25.8301 12.4058 24.6644 12.4058H24.6322C22.8123 12.4815 21.1675 13.395 19.9977 14.9795C19.6895 15.397 19.4415 15.2555 19.2019 15.1168L19.1739 15.1014C18.5813 14.7623 18.1876 14.265 17.9718 13.5855C17.8934 13.3347 17.8583 13.0699 18.1343 12.8149ZM15.2104 22.5604C15.2623 22.5351 15.3015 22.5169 15.3323 22.5015C15.3884 22.4749 15.4248 22.4567 15.4696 22.4427C15.74 22.36 15.9348 22.2984 15.9894 22.2283C16.0412 22.1625 16.0482 21.9901 16.0608 21.7029L16.0637 21.6259C16.0861 21.1243 15.9684 20.8707 15.5971 20.6228C14.94 20.1842 14.5898 19.4711 14.6122 18.6151C14.6164 18.4358 14.615 18.2523 14.615 18.0743C14.6136 17.916 14.6122 17.7535 14.6164 17.591C14.6416 16.2012 15.7134 15.0832 17.0584 15.0481C17.0822 15.0467 17.1046 15.0467 17.1284 15.0467C18.4818 15.0467 19.6446 16.1157 19.7385 17.4607C19.7707 17.9272 19.7735 18.3882 19.7455 18.8281C19.6937 19.6659 19.2804 20.337 18.5182 20.8231C18.3543 20.9282 18.3011 21.0206 18.3095 21.1902C18.3263 21.5152 18.3207 21.8444 18.3123 22.1527C18.3095 22.2787 18.3361 22.311 18.4594 22.339C18.6457 22.381 18.8334 22.4315 19.0128 22.4791C19.1697 22.5211 19.3336 22.566 19.4933 22.6024C19.5648 22.6192 19.7567 22.6626 19.8198 22.8321C19.8814 23.0003 19.7665 23.1544 19.7301 23.2062C19.4373 23.6069 19.2888 24.065 19.2748 24.6072C19.2692 24.8734 19.1655 25.0359 18.9665 25.0864C18.6107 25.1788 18.2576 25.2573 17.9144 25.3231C17.8836 25.3287 17.8555 25.3315 17.8303 25.3315C17.7042 25.3315 17.6244 25.2727 17.5865 25.2321C17.4997 25.1424 17.4661 25.0023 17.4983 24.8552C17.6076 24.3592 17.368 24.1421 16.858 23.8941C16.4699 23.705 16.1057 23.478 15.7204 23.2384C15.5495 23.132 15.373 23.0213 15.1894 22.912L14.8644 22.7173L15.2104 22.5604ZM12.9198 30.7254C12.8609 30.7562 12.8007 30.7675 12.7419 30.7675C12.6522 30.7675 12.5667 30.7408 12.5009 30.7156C12.0722 30.5517 11.6239 30.413 11.205 30.2869C10.8421 30.1776 10.674 29.9437 10.6796 29.5486C10.6908 28.6267 10.688 27.6894 10.6866 26.783C10.6866 26.4439 10.6852 26.1049 10.6852 25.7673L10.6838 24.6885C10.6838 23.8115 10.6824 22.9358 10.6852 22.0602C10.6866 21.8318 10.7118 21.5824 10.9037 21.4732C11.0957 21.3625 11.3296 21.4662 11.5328 21.5839C11.9265 21.8108 12.3188 22.0406 12.7124 22.2703C13.2855 22.6052 13.8781 22.9512 14.4637 23.2833C14.8308 23.4906 14.8055 23.7862 14.7537 23.9908C14.3124 25.7378 13.7324 28.0411 13.1524 30.371C13.1215 30.4943 13.0669 30.6484 12.9198 30.7254ZM15.1194 30.9398C15.0787 31.0855 15.0213 31.2844 14.8406 31.3699C14.7887 31.3951 14.7341 31.4063 14.6739 31.4063C14.5968 31.4063 14.5141 31.3867 14.4217 31.3461C14.381 31.3279 14.3278 31.3139 14.2704 31.2998C14.0742 31.2494 13.6637 31.1429 13.8038 30.5909C14.2493 28.8229 14.7355 26.8769 15.3337 24.4643C15.3631 24.3438 15.422 24.1771 15.5831 24.1141C15.761 24.044 15.9362 24.1561 15.9936 24.1939C16.1043 24.2654 16.2192 24.3298 16.341 24.3985C16.4055 24.4349 16.4685 24.4699 16.5316 24.5078C16.76 24.6408 16.837 24.844 16.7754 25.1438L16.7712 25.1592L15.9418 28.0579C15.6714 29.0008 15.3912 29.9773 15.1194 30.9398ZM18.9553 33.3607C18.8783 33.4084 18.7984 33.4098 18.755 33.4112L18.7396 33.4126H18.7228C18.4552 33.4098 18.2254 33.2739 18.1077 33.0497C17.9928 32.8311 18.0111 32.572 18.1554 32.3576C18.4538 31.9163 18.8489 31.58 19.1599 31.3363C19.4121 31.1387 19.7133 31.1429 19.9823 31.3489C20.2387 31.5436 20.3157 31.8672 20.1714 32.1334C19.9136 32.6112 19.5143 33.0119 18.9553 33.3607ZM20.177 34.8766C19.9963 34.8766 19.8212 34.7996 19.6811 34.6468C19.4219 34.3624 19.4485 33.9772 19.7511 33.6661C19.9921 33.4196 20.2765 33.1296 20.5721 32.8564C20.7977 32.6476 21.0807 32.607 21.3468 32.7443C21.5976 32.8732 21.6957 33.0931 21.7041 33.2416V33.2472C21.7125 33.519 21.6481 33.711 21.494 33.8693C21.4351 33.9281 21.3791 33.987 21.3216 34.0472C21.1241 34.2518 20.9209 34.4633 20.7038 34.6581C20.5385 34.8024 20.3549 34.8766 20.177 34.8766ZM22.1622 36.1263C21.9997 36.2748 21.8204 36.3477 21.6439 36.3477C21.4659 36.3477 21.2922 36.2706 21.1465 36.1179C20.8719 35.8321 20.8929 35.4664 21.2025 35.1428C21.4547 34.878 21.7209 34.6132 22.0137 34.3316C22.2197 34.1369 22.4901 34.092 22.7773 34.2055C22.9398 34.27 23.1359 34.4255 23.1471 34.7982V34.8024C23.1499 35.0153 23.0799 35.2016 22.9468 35.3389L22.8207 35.4692C22.6106 35.6906 22.392 35.9162 22.1622 36.1263ZM23.475 37.6982C23.3629 37.7809 23.2382 37.8215 23.1135 37.8215C22.9524 37.8215 22.7899 37.7557 22.6456 37.6254C22.4074 37.4082 22.357 37.072 22.5251 36.8254C22.8375 36.3673 23.227 35.982 23.6823 35.6794C23.758 35.629 23.8406 35.6191 23.8911 35.6121L23.9317 35.6037L23.9527 35.6051C24.2161 35.6093 24.4529 35.7494 24.5692 35.968C24.6798 36.1753 24.6686 36.4191 24.5369 36.6223C24.2918 37.0005 23.9443 37.3536 23.475 37.6982ZM26.1187 37.701C26.0949 37.9182 25.9716 38.2867 25.3986 38.3105H25.3846L25.3705 38.3091C25.0427 38.2769 24.7877 38.0919 24.656 37.7893C24.6014 37.6632 24.6826 37.5469 24.7219 37.4909C24.7261 37.4839 25.1996 36.8632 25.4406 36.8786C25.6241 36.8899 25.8007 37.0664 25.8889 37.1715C25.966 37.2611 26.1397 37.4923 26.1187 37.701ZM30.3147 33.6928C30.0401 33.9856 29.6394 33.9926 29.2948 33.7138C28.9487 33.4336 28.6027 33.145 28.2678 32.8662C28.1333 32.7541 27.9988 32.6406 27.8629 32.5285C27.7719 32.4529 27.6794 32.3786 27.5883 32.303C27.3656 32.1222 27.1372 31.9345 26.9187 31.737C26.8388 31.6655 26.8052 31.6641 26.8038 31.6641C26.8038 31.6641 26.7772 31.6725 26.7267 31.7412C26.7169 31.7566 26.7043 31.7706 26.6917 31.7832C26.546 31.9471 26.3989 32.111 26.3919 32.1643C26.4073 32.2077 26.5754 32.3478 26.7379 32.4809L26.7463 32.4879C27.3936 33.0217 28.0339 33.5583 28.6881 34.1047C29.0804 34.4325 29.1547 34.7743 28.9095 35.119C28.8072 35.2619 28.6545 35.3544 28.478 35.3782C28.2552 35.4076 28.0198 35.3319 27.8125 35.1638C27.084 34.5726 26.3036 33.9337 25.5303 33.2697C25.407 33.1632 25.3551 33.1562 25.3383 33.1576C25.3257 33.159 25.2767 33.173 25.1814 33.2963L25.1394 33.3509C25.0441 33.4742 24.953 33.5933 24.9278 33.6465C24.9572 33.6816 25.0371 33.7502 25.0973 33.8006C25.8203 34.4115 26.532 35.0083 27.2143 35.5743C27.6934 35.9708 27.6094 36.3267 27.4566 36.5536C27.3558 36.7049 27.2143 36.8002 27.0504 36.8324C27.0097 36.8394 26.9691 36.8436 26.9285 36.8436C26.7673 36.8436 26.5964 36.7862 26.4367 36.6783C25.9057 36.3168 25.4378 35.9806 25.0861 35.4973C24.9488 35.3095 24.7443 35.2086 24.5271 35.1008C24.3548 35.0153 24.1769 34.927 24.0284 34.7926C23.8701 34.6482 23.7902 34.4493 23.7132 34.2574C23.6249 34.0402 23.5506 33.8511 23.3839 33.7754C22.7296 33.4756 22.3262 33.0721 22.074 32.4627C21.9703 32.2119 21.6411 32.0844 21.3833 32.0228C21.0835 31.9499 20.9714 31.7524 20.9013 31.5688C20.6842 30.9958 20.3143 30.6246 19.8604 30.5223C19.398 30.4186 18.8965 30.6007 18.4426 31.0378C18.4019 31.0771 18.3613 31.1149 18.3207 31.1541C18.1694 31.297 18.0265 31.4315 17.9018 31.5814C17.6314 31.9023 17.326 31.9443 16.9939 31.7075C16.7361 31.524 16.4503 31.3643 16.2052 31.2326C15.8451 31.0393 15.8815 30.7506 15.9404 30.5503C16.2248 29.571 16.505 28.5735 16.7768 27.6082L17.0373 26.6807C17.0976 26.4692 17.2237 26.1778 17.6258 26.0923C18.0209 26.0096 18.4201 25.9186 18.8068 25.8303C19.5059 25.672 20.2288 25.5067 20.9504 25.3834C21.8232 25.2349 22.717 25.3512 23.8476 25.7589L24.2834 25.9158L23.8701 26.1245C23.6081 26.2576 23.3531 26.3837 23.1051 26.507C22.5615 26.7774 22.0488 27.0324 21.5444 27.3042C20.7906 27.7105 20.5273 28.6421 20.9448 29.4239C21.1297 29.7699 21.4309 30.0207 21.7938 30.1314C22.179 30.2477 22.6036 30.1986 22.9888 29.9927C23.3125 29.819 23.6333 29.6228 23.9457 29.4323L24.0676 29.358C25.4616 28.5062 25.6437 28.5244 26.8528 29.6326C27.5673 30.2883 28.3015 30.9468 29.0104 31.5828C29.3466 31.8841 29.6814 32.1839 30.0163 32.4865C30.0709 32.5355 30.1242 32.5874 30.1774 32.6378L30.2208 32.6812C30.5613 33.0049 30.5963 33.3929 30.3147 33.6928ZM38.8945 28.4082C36.3026 29.6957 33.7598 30.9664 31.3402 32.1853C31.224 32.2441 31.1189 32.2693 31.025 32.2693C30.8247 32.2693 30.6692 32.1601 30.5277 32.0326L30.3161 31.842C29.1407 30.7759 27.9246 29.6719 26.7141 28.6043C25.9478 27.929 25.2388 27.8674 24.3422 28.3983C24.1293 28.5258 23.9163 28.6519 23.7033 28.7808C23.4077 28.9588 23.1135 29.1353 22.8151 29.3104C22.5349 29.4743 22.2463 29.5248 21.9997 29.4533C21.7994 29.3959 21.6397 29.2614 21.5402 29.068C21.4281 28.8523 21.4071 28.6239 21.4757 28.4096C21.5542 28.17 21.7461 27.964 22.0165 27.8281C22.2771 27.6964 22.5405 27.5676 22.8039 27.4373C23.3335 27.1767 23.8813 26.9063 24.4109 26.6261C25.0441 26.2912 25.7306 26.2338 26.511 26.451C27.2927 26.6681 28.1235 26.9077 29.0552 27.1851C29.5483 27.3308 29.9574 27.2958 30.3833 27.0688C32.3307 26.032 34.316 24.9883 36.2354 23.9796C37.0073 23.5733 37.7807 23.1684 38.5526 22.7607C38.809 22.6262 38.9925 22.5295 39.1593 22.629C39.3246 22.7285 39.3246 22.94 39.326 23.209C39.3274 23.7246 39.3274 24.2416 39.3274 24.7571V25.4198C39.3274 25.6286 39.326 25.8387 39.326 26.0475C39.3246 26.5784 39.3218 27.1276 39.3316 27.6656C39.34 28.0257 39.2041 28.254 38.8945 28.4082Z", fill: "currentColor" })
  }
), yj = () => /* @__PURE__ */ f.jsxs("svg", { viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ f.jsx("path", { d: "M28.7281 10.2004C28.711 9.48568 28.2491 9.0316 27.5225 9.01713C26.3972 8.99475 25.2232 8.99475 23.9307 9.01449C23.2463 9.02634 22.7159 9.53438 22.6685 10.2241C22.6185 10.9532 23.0094 11.4244 23.7662 11.5547C23.7938 11.5587 23.8201 11.5639 23.8504 11.5692L24.2124 11.6337L23.4727 12.3444C22.8396 12.9538 22.2407 13.5276 21.6392 14.116C21.4905 14.2607 21.3629 14.2371 21.2154 14.1581C20.8825 13.9778 20.5337 13.7948 20.1441 13.6C19.8269 13.4408 19.565 13.3592 19.3241 13.3592C18.9714 13.3592 18.6647 13.5342 18.2975 13.9028C16.0587 16.1574 13.8199 18.4106 11.5837 20.6666C11.4455 20.8061 11.3126 20.9456 11.2086 21.0969C10.8677 21.6023 10.9533 22.3131 11.4021 22.7171C11.5363 22.8382 11.6785 22.929 11.8272 22.9909C11.9746 23.0528 12.1286 23.0844 12.2826 23.0844C12.5511 23.0844 12.8183 22.9856 13.0539 22.7974C13.1921 22.6882 13.3184 22.5605 13.4421 22.4368L14.3253 21.5484C15.9679 19.8953 17.667 18.1869 19.3346 16.4956C19.5558 16.2705 19.7334 16.2455 19.9875 16.4022C20.2612 16.5693 20.5547 16.7141 20.8403 16.8549L20.9825 16.926C21.659 17.2616 22.1368 17.1905 22.683 16.672C23.0633 16.3113 23.445 15.9415 23.8162 15.5835C23.9912 15.4137 24.1676 15.2439 24.344 15.0741L26.1208 13.3658L26.1827 13.7119C26.209 13.858 26.2314 13.9791 26.259 14.1002C26.4235 14.7977 26.8829 15.1571 27.5515 15.111C28.2175 15.0636 28.7124 14.5569 28.7281 13.9067C28.7571 12.6669 28.7571 11.4205 28.7281 10.2004ZM27.483 14.3621C27.2817 14.3687 27.1566 14.2923 27.0869 14.2265C26.9776 14.1226 26.9171 13.962 26.9131 13.7646C26.9039 13.3737 26.9066 12.9762 26.9105 12.5905C26.9118 12.3694 26.896 12.1944 26.6815 12.1062C26.4735 12.0206 26.3393 12.1272 26.1721 12.2878C24.877 13.5342 23.5806 14.7793 22.2868 16.0271C21.8301 16.4667 21.7472 16.4785 21.1878 16.1942C20.8101 16.0007 20.4073 15.7954 20.0059 15.5861C19.5057 15.3255 19.4544 15.3334 19.0701 15.7204C17.0142 17.7907 14.961 19.8611 12.9051 21.9314C12.7103 22.1288 12.4748 22.3262 12.2365 22.3262C12.1286 22.3262 12.0207 22.2854 11.9154 22.1854C11.7996 22.0762 11.743 21.963 11.7403 21.8379C11.7377 21.6484 11.8601 21.4405 12.1378 21.1614C14.3582 18.9253 16.5786 16.6878 18.799 14.4516C19.0161 14.2331 19.1464 14.1015 19.3478 14.1015C19.4939 14.1015 19.6321 14.1739 19.8598 14.291C20.0177 14.3726 20.1757 14.4542 20.3336 14.5358C20.635 14.6898 20.9456 14.8491 21.2457 15.0123C21.4853 15.1413 21.6708 15.1149 21.8683 14.9241C22.6316 14.1844 23.399 13.4474 24.1413 12.734C24.5467 12.3431 24.9521 11.9535 25.3574 11.5626C25.4943 11.431 25.6101 11.2954 25.5299 11.0888C25.4377 10.8571 25.2403 10.8255 25.0587 10.8255L24.6783 10.8242C24.4532 10.8229 24.2282 10.8229 24.0044 10.8242C23.474 10.8163 23.4095 10.457 23.4069 10.3017C23.4042 10.1477 23.4529 10.0122 23.549 9.91475C23.653 9.80814 23.807 9.7476 23.9833 9.74628C24.9915 9.73707 26.0971 9.73707 27.462 9.74497C27.7963 9.7476 27.9871 9.94371 27.9845 10.2846C27.9819 10.6979 27.9819 11.1112 27.9832 11.5257L27.9845 12.1588L27.9832 12.5603C27.9819 12.9538 27.9819 13.3618 27.9858 13.7606C27.9964 14.1331 27.8095 14.3529 27.483 14.3621Z", fill: "#141A22" }),
  /* @__PURE__ */ f.jsx("path", { d: "M17.5855 34.098C17.2723 33.7769 16.8419 33.5913 16.4049 33.5887H16.3931C15.4981 33.5887 14.7637 34.3218 14.7545 35.2286C14.7492 35.684 14.919 36.1078 15.2309 36.425C15.5389 36.737 15.9522 36.9094 16.397 36.912H16.4036C17.3012 36.912 18.0436 36.1776 18.0607 35.276C18.0699 34.839 17.9014 34.4205 17.5855 34.098ZM16.3997 36.1592H16.3891C15.8798 36.1552 15.4836 35.7551 15.4849 35.2484C15.4876 34.7416 15.8864 34.3429 16.3944 34.3389C16.6484 34.3389 16.8919 34.4416 17.0683 34.6219C17.2433 34.8009 17.3368 35.0312 17.3289 35.2734C17.3157 35.7617 16.8998 36.1592 16.3997 36.1592Z", fill: "#141A22" }),
  /* @__PURE__ */ f.jsx("path", { d: "M37.7702 25.2245C37.3504 24.3847 36.6028 23.9846 35.6617 24.0978C35.3669 24.1333 35.1023 24.2597 34.8233 24.3939C34.772 24.419 34.7193 24.444 34.6654 24.469L34.3982 24.594V22.3539C34.3982 20.785 34.3982 19.2135 34.3969 17.6446V17.5762C34.3982 17.4709 34.3982 17.3643 34.3837 17.2642C34.3548 17.0616 34.2245 16.9457 34.027 16.9457C33.823 16.9457 33.6993 17.0589 33.6756 17.2629C33.6598 17.3998 33.6598 17.538 33.6598 17.6841C33.6585 20.0545 33.6585 22.4263 33.6611 24.7967C33.6611 24.981 33.6611 25.1915 33.4334 25.3626L33.3518 25.4232C32.6082 25.9799 31.8396 26.5538 31.0327 27.0487C31.0104 27.0618 30.988 27.0776 30.9656 27.0947C30.8735 27.1605 30.7485 27.25 30.6155 27.1829C30.476 27.1105 30.4957 26.9565 30.5102 26.8552C30.5142 26.821 30.5194 26.7907 30.5181 26.7657C30.5155 23.2726 30.5155 19.7795 30.5155 16.2877V14.8056C30.5155 13.9922 30.6089 13.5961 30.859 13.3473C31.1078 13.1025 31.5184 13.0091 32.3292 13.0183C33.1584 13.0262 33.6295 13.4842 33.6572 14.3068C33.6651 14.5411 33.6638 14.7793 33.6625 15.0096C33.6611 15.1426 33.6611 15.2729 33.6611 15.4019C33.6625 15.5703 33.6993 15.6914 33.773 15.7638C33.8336 15.8217 33.9152 15.8507 34.0376 15.8494C34.2758 15.8467 34.3969 15.7033 34.3942 15.4242C34.3929 15.2847 34.3956 15.1439 34.3969 15.0044C34.4008 14.6438 34.4048 14.27 34.3561 13.912C34.2534 13.146 33.7835 12.6129 32.9978 12.3681C32.7267 12.2839 32.4397 12.2865 32.162 12.2891C32.112 12.2891 32.062 12.2904 32.0133 12.2904C31.2631 12.2904 30.6998 12.476 30.3339 12.8432C29.968 13.2091 29.7824 13.7751 29.7824 14.5253V27.1487C29.7824 27.2948 29.7653 27.5041 29.6231 27.6317C29.5086 27.737 29.3323 27.7739 29.0677 27.7475C28.9637 27.737 28.8887 27.7015 28.8453 27.6423C28.7755 27.5449 28.8045 27.4198 28.8295 27.3079C28.84 27.2619 28.8505 27.2145 28.8505 27.1829C28.8374 24.4321 28.8387 21.6971 28.8426 18.662C28.844 17.7091 28.4912 17.0892 27.7344 16.7115C27.3356 16.5127 26.8868 16.5153 26.4525 16.518H26.3893C24.9942 16.5246 24.2242 17.2893 24.2202 18.6686L24.2189 19.2122C24.2163 20.3138 24.2137 21.4536 24.2268 22.5763C24.2308 22.879 24.1242 23.0515 23.8701 23.1528C23.778 23.1896 23.6859 23.237 23.5793 23.2923L23.5608 23.3015L23.2858 23.445L23.2884 22.8619C23.291 22.5539 23.2923 22.2617 23.2844 21.9735C23.2502 20.8284 22.5737 20.1598 21.4273 20.1361C21.2286 20.1322 21.0272 20.1335 20.8311 20.1348L20.6468 20.1361C19.3333 20.1401 18.666 20.8034 18.6634 22.1078C18.6607 22.9764 18.6621 23.8451 18.6621 24.7138L18.6634 25.5851C18.6647 25.7417 18.666 25.9194 18.4436 26.0365L18.3514 26.0852C17.6697 26.4419 17.0287 26.7775 16.2864 26.9657C15.1624 27.2514 14.0634 27.5817 13.1381 27.866C11.8575 28.2595 11.0059 29.5217 11.1994 30.7405C11.2862 31.2801 11.4323 31.8171 11.5745 32.3357L11.5797 32.3555C11.6179 32.4963 11.6574 32.6384 11.6943 32.7806C11.7377 32.9464 11.8048 33.057 11.8943 33.1083C11.9667 33.1491 12.0549 33.1557 12.1641 33.1254C12.405 33.0596 12.48 32.8898 12.3997 32.5897C12.3537 32.4173 12.3142 32.2396 12.2747 32.0685C12.2049 31.7619 12.1352 31.4526 12.0325 31.1577C11.843 30.6089 11.8838 30.0377 12.1483 29.5494C12.43 29.0269 12.9433 28.6504 13.5935 28.4886C14.6899 28.2148 15.7428 27.8976 16.6286 27.6225C16.9747 27.5146 17.134 27.5909 17.2564 27.9226C17.7302 29.2059 18.2159 30.5049 18.6871 31.7632L18.7042 31.8066C19.0845 32.8227 19.4781 33.873 19.8611 34.9075C20.0427 35.3958 19.9967 35.9618 19.7361 36.458C19.4649 36.9739 19.0003 37.3477 18.462 37.4833C17.5789 37.7057 16.6549 37.9137 15.7165 38.1005C14.6583 38.3125 13.7554 37.7412 13.4698 36.6791C13.379 36.3435 13.2908 36.0026 13.2065 35.6709L13.2 35.6419C13.1223 35.3379 13.042 35.0233 12.9591 34.7154C12.8907 34.4574 12.7946 34.285 12.5656 34.285C12.5392 34.285 12.5116 34.2876 12.4813 34.2915C12.3879 34.306 12.3168 34.3495 12.2707 34.4179C12.1997 34.5245 12.1891 34.693 12.2378 34.8944L12.3155 35.2155C12.4524 35.7722 12.5919 36.3435 12.7525 36.8949C13.1091 38.1111 14.1015 38.8981 15.2795 38.8981C15.4059 38.8981 15.5335 38.8889 15.6612 38.8705C16.6194 38.7323 17.6486 38.498 18.8082 38.1558C20.0664 37.7833 20.8008 36.7396 20.7232 35.434C20.7034 35.1102 20.8061 34.9733 21.1299 34.8957C22.3565 34.5995 23.6043 34.2942 24.8112 33.998L24.8441 33.9901C26.3235 33.6282 27.8516 33.2531 29.3573 32.8925C30.5023 32.6187 31.7027 32.2818 32.6885 31.4394C33.2794 30.9353 33.8915 30.4365 34.4837 29.9534C34.822 29.6784 35.1589 29.4046 35.4932 29.1282C35.6578 28.9913 35.8236 28.8571 35.9894 28.7228C36.4514 28.3464 36.9305 27.9581 37.3714 27.5449C38.0348 26.9157 38.1822 26.051 37.7702 25.2245ZM24.9613 19.9124V19.8308C24.9613 19.3701 24.9613 18.9108 24.9626 18.4514C24.9639 18.3514 24.9784 18.2408 25.0086 18.125C25.2298 17.284 26.0642 17.2103 26.8526 17.2485C27.1869 17.2656 27.4686 17.3682 27.6778 17.5433C27.8871 17.7183 28.024 17.9658 28.0714 18.2685C28.0964 18.4304 28.099 18.5923 28.099 18.7463C28.099 19.532 28.099 20.3191 28.0977 21.1048V21.1246C28.0964 23.1383 28.0964 25.2205 28.1095 27.2671C28.1108 27.4211 28.0964 27.5949 27.9898 27.6988C27.8989 27.787 27.7634 27.8068 27.6225 27.8068C27.6002 27.8068 27.5765 27.8055 27.5541 27.8055C27.2632 27.7949 26.9447 27.791 26.5525 27.791C26.3222 27.791 26.0905 27.7923 25.851 27.7936H25.8365C25.6694 27.7949 25.5009 27.7962 25.3285 27.7962L24.8981 27.7976L25.1903 27.4804C25.364 27.2935 25.539 27.1592 25.7088 27.0302C25.7773 26.9776 25.8457 26.9263 25.9102 26.8723C26.6446 26.2682 27.1224 25.4758 27.3317 24.519C27.4686 23.8846 27.3277 23.2923 26.9421 22.8922C26.5564 22.4934 25.9694 22.3289 25.3311 22.4447C25.2021 22.4671 25.1179 22.4592 25.0586 22.4197L25.0415 22.4092L25.0284 22.3947C24.977 22.342 24.956 22.2644 24.956 22.1249C24.9613 21.3773 24.9613 20.5981 24.9613 19.9124ZM19.4004 21.8235C19.4254 21.3049 19.8005 20.9245 20.3099 20.9008C20.7311 20.8798 21.1707 20.8798 21.605 20.8995C22.1486 20.9232 22.5092 21.297 22.525 21.8498C22.5369 22.2696 22.5342 22.6921 22.5329 23.1015L22.5316 23.1436C22.5316 23.2857 22.5303 23.4279 22.5303 23.57V23.5937C22.5303 23.703 22.5316 23.8517 22.371 23.9359C21.6735 24.3058 20.9759 24.6769 20.2533 25.0639L19.3939 25.5219V22.883C19.3939 22.783 19.3925 22.6829 19.3925 22.5816C19.3899 22.3328 19.3886 22.0775 19.4004 21.8235ZM36.7186 27.1421C35.1247 28.4662 33.444 29.8363 31.7237 31.2143C31.138 31.6829 30.4181 31.8579 29.7232 32.0291L28.2754 32.3831C25.8681 32.9714 23.3779 33.5782 20.9325 34.1889C20.8403 34.2126 20.76 34.2244 20.6903 34.2244C20.4692 34.2244 20.3481 34.1033 20.2428 33.8151C19.4768 31.704 18.6713 29.5836 17.9171 27.6054C17.8052 27.3132 17.8645 27.1645 18.1488 27.0158C19.8321 26.1313 21.5405 25.2218 23.1923 24.3439L23.3253 24.2729C23.8978 23.9675 24.4716 23.6622 25.0455 23.3581C25.2771 23.2357 25.5035 23.1252 25.7457 23.1252C25.897 23.1252 26.0379 23.1673 26.18 23.2541C26.5564 23.4858 26.7183 23.8648 26.6249 24.2965C26.434 25.1744 26.0129 25.8575 25.3377 26.3866C25.1797 26.5103 24.9718 26.6762 24.7651 26.8526C24.3808 27.1842 24.261 27.5541 24.4111 27.9516C24.5546 28.3319 24.8625 28.5294 25.3285 28.5359C25.7812 28.5425 26.2537 28.5412 26.6696 28.5399C26.8605 28.5386 27.0513 28.5386 27.2422 28.5386C27.3962 28.5373 27.5515 28.5373 27.7055 28.5373C28.507 28.5399 29.3336 28.5412 30.1206 28.278C30.6826 28.0898 31.2289 27.8055 31.7922 27.4093L32.4016 26.9789C33.29 26.3511 34.2087 25.7035 35.1155 25.0744C35.4551 24.8388 35.8394 24.7493 36.1974 24.8243C36.5422 24.8954 36.845 25.1139 37.049 25.4416C37.3977 26.0023 37.2661 26.6867 36.7186 27.1421Z", fill: "#141A22" })
] }), wj = () => /* @__PURE__ */ f.jsxs("svg", { viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ f.jsx("path", { d: "M28.3468 14.9442C28.3031 15.1227 28.1894 15.2189 28.0072 15.2313C27.9734 15.2338 27.9385 15.2338 27.9048 15.2338H21.4462C19.9692 15.2338 18.4935 15.2338 17.0165 15.2351C17.0165 15.2351 17.0165 15.2351 17.0152 15.2351C16.9141 15.2351 16.8392 15.2226 16.7743 15.1964C16.6532 15.1477 16.5683 15.0166 16.5683 14.8793C16.567 14.7631 16.6569 14.6445 16.7805 14.5983C16.8654 14.5659 16.9591 14.5621 17.0477 14.5621H17.0489C18.7382 14.5634 20.4287 14.5634 22.1179 14.5634H24.1904C25.4327 14.5634 26.6737 14.5634 27.9148 14.5621C27.9148 14.5621 27.9148 14.5621 27.916 14.5621C28.0346 14.5621 28.1195 14.5796 28.1894 14.6208C28.3031 14.6882 28.3742 14.8331 28.3468 14.9442Z", fill: "#141A22" }),
  /* @__PURE__ */ f.jsx("path", { d: "M28.3489 17.9668C28.3102 18.1504 28.1953 18.2515 28.0118 18.2665C27.9793 18.269 27.9431 18.269 27.9044 18.269H21.4745C19.9888 18.269 18.5043 18.269 17.0186 18.2702C17.0186 18.2702 17.0186 18.2702 17.0173 18.2702C16.9075 18.2702 16.8288 18.2565 16.7626 18.2265C16.679 18.1891 16.5804 18.1179 16.5691 17.9081C16.5629 17.8033 16.6465 17.6884 16.7639 17.641C16.8351 17.611 16.9187 17.5985 17.0348 17.5985C17.0361 17.5985 17.0361 17.5985 17.0361 17.5985C18.5131 17.5998 19.9901 17.5998 21.4671 17.5998H23.627C25.054 17.5998 26.4798 17.5998 27.9069 17.5985H27.9081C28.0317 17.5985 28.1141 17.616 28.1853 17.6547C28.3027 17.7196 28.3688 17.8732 28.3489 17.9668Z", fill: "#141A22" }),
  /* @__PURE__ */ f.jsx("path", { d: "M28.3205 21.0969C28.2643 21.2192 28.1682 21.2792 28.0009 21.3004C27.9747 21.3029 27.9435 21.3029 27.911 21.3029C27.896 21.3016 27.881 21.3016 27.8661 21.3016H21.4674C19.9842 21.3016 18.501 21.3016 17.0165 21.3029C16.9166 21.3041 16.8404 21.2917 16.7743 21.2642C16.6519 21.2155 16.5683 21.0857 16.5683 20.9483C16.5695 20.8272 16.6569 20.7123 16.7793 20.6662C16.8467 20.6424 16.9141 20.6299 16.9865 20.6299C19.1477 20.6312 21.3101 20.6312 23.4725 20.6312H27.951C28.1495 20.6312 28.2306 20.7086 28.2743 20.7648C28.3605 20.8771 28.3742 20.9795 28.3205 21.0969Z", fill: "#141A22" }),
  /* @__PURE__ */ f.jsx("path", { d: "M28.3206 24.132C28.2645 24.2543 28.1683 24.3143 28.001 24.3355C27.9748 24.338 27.9436 24.338 27.9111 24.338C27.8961 24.3367 27.8812 24.3367 27.8662 24.3367H21.4938C20.0018 24.3367 18.5086 24.3367 17.0153 24.338H17.0141C16.913 24.338 16.8381 24.3268 16.7731 24.2993C16.6508 24.2506 16.5671 24.1207 16.5671 23.9834C16.5684 23.8636 16.6558 23.7474 16.7781 23.7012C16.8455 23.6775 16.913 23.665 16.9854 23.665C19.179 23.6663 21.3714 23.6663 23.565 23.6663H27.9511C28.1496 23.6663 28.2307 23.7437 28.2744 23.7999C28.3606 23.9122 28.3743 24.0146 28.3206 24.132Z", fill: "#141A22" }),
  /* @__PURE__ */ f.jsx("path", { d: "M21.084 27.3281C21.0154 27.3593 20.9392 27.3718 20.8506 27.3731C20.5122 27.3718 20.1739 27.3718 19.8343 27.3718H18.3548C17.8903 27.3731 17.4271 27.3731 16.9627 27.3706C16.7542 27.3693 16.6331 27.2857 16.5819 27.1034C16.5432 26.9623 16.6106 26.8137 16.7442 26.7513C16.8166 26.7176 16.884 26.7014 16.954 26.7014H17.8005C18.8317 26.7001 19.8618 26.7001 20.893 26.7026C21.0691 26.7026 21.1952 26.785 21.2501 26.9349C21.3063 27.0872 21.2339 27.2595 21.084 27.3281Z", fill: "#141A22" }),
  /* @__PURE__ */ f.jsx("path", { d: "M37.3259 21.5238C37.075 21.0232 36.6854 20.761 36.1673 20.7448C35.6479 20.7285 35.2384 20.9545 34.9562 21.4152C34.8214 21.6337 34.6903 21.8597 34.563 22.0794C34.5093 22.1718 34.4556 22.2642 34.4019 22.3554C34.2633 22.5913 34.126 22.8273 33.9861 23.0658L33.6128 23.705L33.4605 23.4353C33.4068 23.3417 33.4118 23.2555 33.4156 23.2044C33.4168 23.1969 33.4168 23.1881 33.4168 23.1806C33.4156 19.927 33.4156 16.6721 33.4156 13.4197V10.9801C33.4156 10.643 33.2907 10.5169 32.9561 10.5169H32.453C31.4304 10.5169 30.4079 10.5157 29.3854 10.5194C29.3841 10.5194 29.3841 10.5194 29.3841 10.5194C29.2305 10.5194 29.1082 10.4683 29.0008 10.3584L28.841 10.1973C28.4727 9.82527 28.0932 9.43948 27.6961 9.08864C27.6275 9.02747 27.55 9 27.4489 9C24.7471 9.00125 22.0441 9.00125 19.3423 9.00125L12.9549 9.0025C12.6553 9.0025 12.5217 9.13609 12.5204 9.43698V9.71165C12.5192 10.07 12.5192 10.442 12.5229 10.8054C12.5254 10.9814 12.4355 11.095 12.2657 11.1312C12.1621 11.1537 12.0585 11.2086 11.9698 11.2598C11.0859 11.7667 10.755 12.8105 11.1982 13.6869C11.4342 14.1539 11.8013 14.471 12.2882 14.632C12.4468 14.6845 12.5254 14.7944 12.5229 14.9592C12.5167 15.2238 12.5167 15.516 12.5217 15.8781C12.5242 16.0978 12.3768 16.1615 12.2882 16.1802C12.1721 16.2052 12.0585 16.2651 11.9611 16.32C11.0884 16.8082 10.7588 17.8457 11.1933 18.7309C11.4217 19.1979 11.7888 19.5187 12.2857 19.6873L12.3007 19.6923C12.3556 19.7098 12.5267 19.7647 12.5229 19.9782C12.5179 20.2953 12.5192 20.6074 12.5217 20.9533C12.5229 21.0919 12.4493 21.1892 12.3157 21.2292C11.8537 21.3678 11.4966 21.6524 11.2544 22.0744C10.9436 22.6138 10.9173 23.1781 11.177 23.75C11.398 24.2369 11.7688 24.569 12.282 24.74C12.453 24.7975 12.5329 24.9148 12.5229 25.0921C12.5154 25.2057 12.5154 25.3293 12.5217 25.4841C12.5292 25.6439 12.443 25.7551 12.2857 25.7888C12.1671 25.815 12.0547 25.8737 11.9611 25.9286C11.0884 26.4343 10.7588 27.4718 11.1945 28.3407C11.433 28.8189 11.7913 29.1298 12.2882 29.2946C12.4468 29.347 12.5267 29.4582 12.5229 29.6217C12.5192 29.829 12.5192 30.04 12.5204 30.246C12.5217 30.3246 12.5217 30.4045 12.5217 30.4832V31.0637C12.5204 31.5519 12.5204 32.0388 12.5229 32.5258C12.5242 32.7904 12.6665 32.9315 12.9337 32.934C12.9599 32.934 12.9861 32.9353 13.0123 32.9353C13.0823 32.9365 13.1497 32.9378 13.2134 32.9328C13.2508 32.9303 13.3632 32.9203 13.4506 33.0014C13.5292 33.0739 13.538 33.1737 13.5355 33.2424C13.5317 33.6232 13.5317 34.0402 13.5342 34.5558C13.5355 34.7818 13.6378 34.9104 13.8463 34.9491C13.8888 34.9566 13.9387 34.9566 13.9924 34.9566H18.1662C20.9279 34.9566 23.6896 34.9579 26.4526 34.9579C26.4663 34.9579 26.4813 34.9554 26.4975 34.9541C26.52 34.9516 26.55 34.9479 26.5837 34.9479C26.6636 34.9479 26.7597 34.9679 26.8159 35.0677C26.9008 35.2188 26.8022 35.3549 26.7547 35.4186C26.746 35.4311 26.736 35.4435 26.7298 35.456C26.7073 35.4935 26.6848 35.5309 26.6624 35.5684C26.5787 35.7057 26.5 35.8343 26.4726 35.9767C26.4414 36.1377 26.4127 36.3 26.3839 36.4611L26.3802 36.4823C26.344 36.6771 26.3215 36.8806 26.2978 37.0778C26.2691 37.3176 26.2404 37.5648 26.1904 37.8095C26.1367 38.0742 26.0743 38.3726 26.0668 38.6622C26.0631 38.7908 26.1167 38.8794 26.2416 38.9531C26.3527 39.018 26.4526 39.0155 26.565 38.9456C26.6286 38.9057 26.6873 38.8657 26.7398 38.8233C27.2504 38.4275 27.7598 38.0305 28.2679 37.6322L28.3503 37.5685C28.6175 37.36 28.871 37.164 29.0258 36.8569C29.2243 36.4598 29.4565 36.0753 29.6813 35.7032C29.7899 35.5234 29.9022 35.3362 30.0084 35.1526C30.0858 35.019 30.1919 34.9566 30.3417 34.9566H30.3442C31.0721 34.9591 31.8 34.9591 32.5291 34.9591H32.9561C33.2845 34.9591 33.4131 34.8318 33.4131 34.5047V33.5333C33.4143 32.2423 33.4143 30.9077 33.4106 29.5955C33.4093 29.4282 33.4518 29.2746 33.5392 29.1273C33.9337 28.4544 34.3282 27.7814 34.7215 27.1085L35.402 25.9461C36.0162 24.8986 36.6305 23.8498 37.246 22.8023C37.5082 22.3591 37.5332 21.9409 37.3259 21.5238ZM12.3806 13.8829C12.3581 13.8917 12.3307 13.8992 12.3007 13.8992C12.247 13.8992 12.1833 13.8767 12.1197 13.8068L12.1134 13.8005C11.6502 13.4247 11.5903 12.8067 11.7726 12.3947C11.8462 12.2287 11.9611 12.0801 12.1346 11.9303C12.2095 11.8603 12.2882 11.8391 12.3681 11.8641C12.4056 11.8766 12.5292 11.929 12.5192 12.1026V13.0377C12.5192 13.2325 12.5192 13.4285 12.5179 13.6232L12.5192 13.6295C12.5354 13.798 12.4393 13.8605 12.3806 13.8829ZM12.3806 18.9407C12.3581 18.9494 12.3307 18.9569 12.3007 18.9569C12.247 18.9569 12.1833 18.9344 12.1197 18.8645L12.1134 18.8583C11.6502 18.4825 11.5903 17.8657 11.7726 17.4524C11.8462 17.2864 11.9611 17.1391 12.1346 16.988C12.2095 16.9181 12.287 16.8969 12.3681 16.9231C12.4056 16.9356 12.5292 16.9867 12.5192 17.1603V18.0954C12.5192 18.2902 12.5192 18.4862 12.5179 18.681L12.5192 18.6872C12.5354 18.8558 12.4393 18.9182 12.3806 18.9407ZM12.3981 23.9909C12.3744 24.0034 12.3394 24.0146 12.2994 24.0146C12.2445 24.0146 12.1796 23.9922 12.1147 23.9173L12.1109 23.9135C11.6515 23.5365 11.5928 22.9247 11.7726 22.5164C11.8475 22.3466 11.9611 22.198 12.1334 22.0495C12.2458 21.9446 12.3456 21.9671 12.3956 21.9908C12.4468 22.0145 12.5304 22.0757 12.5204 22.2243V23.1494C12.5204 23.3442 12.5204 23.5402 12.5192 23.735L12.5204 23.7412C12.5354 23.891 12.4617 23.9597 12.3981 23.9909ZM12.5204 27.729C12.5204 27.9237 12.5204 28.1198 12.5192 28.3145C12.5254 28.4806 12.4205 28.5368 12.3756 28.5542C12.3556 28.5617 12.3307 28.5667 12.3032 28.5667C12.2595 28.5667 12.2058 28.5517 12.1521 28.5043C11.7076 28.1622 11.5566 27.5604 11.7838 27.0423C11.8675 26.8488 12.0035 26.7152 12.1359 26.5978C12.2358 26.5054 12.3257 26.5154 12.3831 26.5379C12.4268 26.5554 12.5292 26.6128 12.5192 26.7726V27.729H12.5204ZM30.147 11.306C30.1707 11.2561 30.2344 11.1724 30.3829 11.1874H31.0596C31.5266 11.1874 31.9923 11.1874 32.4592 11.1849C32.4929 11.1849 32.5953 11.1849 32.6715 11.2611C32.7476 11.3385 32.7464 11.4408 32.7464 11.4746C32.7439 11.7043 32.7439 11.9378 32.7439 12.1625V14.491C32.7439 17.8832 32.7439 21.3928 32.7489 24.8436C32.7489 25.0809 32.6927 25.2869 32.5728 25.4891C32.3793 25.8112 32.1883 26.1434 32.0023 26.463C31.9248 26.5953 31.8487 26.7277 31.7713 26.86C31.7663 26.8687 31.7613 26.8762 31.7538 26.8875L31.569 27.1759L31.4317 26.885C31.3867 26.7876 31.3892 26.7089 31.393 26.6577C31.393 26.649 31.3942 26.6415 31.3942 26.634L31.393 25.3605C31.3917 21.3253 31.3917 17.154 31.3967 13.0514C31.3967 12.8279 31.3318 12.6719 31.1795 12.5271C30.9398 12.2986 30.7025 12.0601 30.4741 11.8291C30.3917 11.7467 30.3093 11.6643 30.2269 11.5819C30.0833 11.4721 30.1282 11.3422 30.147 11.306ZM27.8534 11.0213V10.3921L28.047 10.4096C28.1506 10.4183 28.2055 10.4795 28.2267 10.502C28.7748 11.0513 29.3204 11.5982 29.866 12.145C30.0021 12.2499 29.9709 12.3685 29.9509 12.4147C29.9335 12.4559 29.881 12.542 29.7449 12.542C29.7325 12.542 29.7175 12.5408 29.7025 12.5395L29.695 12.5383C29.3554 12.5395 29.0108 12.5395 28.665 12.5395L28.1319 12.5408C28.0832 12.5408 27.9933 12.542 27.9221 12.4709C27.8747 12.4234 27.8497 12.3585 27.8497 12.2811C27.8534 11.8616 27.8534 11.4421 27.8534 11.0213ZM13.5617 32.2648L13.5242 32.2636C13.5055 32.2623 13.4868 32.2623 13.468 32.2636C13.3632 32.2711 13.2995 32.2311 13.2645 32.1974C13.2283 32.1624 13.1871 32.1 13.1909 31.9951C13.1934 31.9365 13.1921 31.8778 13.1921 31.8203V31.2136C13.1934 30.683 13.1934 30.1523 13.1896 29.6217C13.1884 29.402 13.3257 29.3271 13.4293 29.2909C14.0773 29.0649 14.4719 28.6391 14.6379 27.9924C14.6754 27.8451 14.6179 27.7115 14.4806 27.6266C14.3807 27.5642 14.2222 27.5742 14.1335 27.6466C14.0661 27.7015 14.0186 27.7752 13.9949 27.8626C13.9288 28.0998 13.7989 28.2983 13.5966 28.4693L13.5929 28.4731C13.493 28.5805 13.3944 28.573 13.3307 28.5467C13.272 28.5243 13.1759 28.4606 13.1946 28.292L13.1959 28.2833C13.1946 27.6378 13.1946 26.9886 13.1946 26.3406V25.8212C13.1946 25.7488 13.1946 25.6764 13.1959 25.604C13.1971 25.428 13.1971 25.2457 13.1934 25.0671C13.1871 24.8249 13.3682 24.7612 13.4281 24.74C14.0798 24.5128 14.4781 24.0858 14.6417 23.4353C14.6779 23.2905 14.6179 23.1544 14.4806 23.072C14.3807 23.0121 14.2209 23.0221 14.1335 23.0957C14.0648 23.1532 14.0174 23.2293 13.9912 23.323C13.93 23.5489 13.7977 23.7462 13.5867 23.9272C13.4718 24.0434 13.3657 24.0146 13.3107 23.9872C13.262 23.9622 13.1821 23.8998 13.1934 23.7549V22.655C13.1934 21.7636 13.1934 20.8721 13.1921 19.9807C13.1909 19.8334 13.267 19.7347 13.4169 19.6885C13.945 19.5212 14.3195 19.1804 14.5617 18.646C14.6167 18.5249 14.6441 18.415 14.6466 18.3102C14.6491 18.1616 14.5568 18.0305 14.4219 17.9918C14.2671 17.9481 14.1435 17.9943 14.0549 18.1316C14.0186 18.1866 13.9912 18.254 13.9637 18.3451C13.8913 18.5936 13.714 18.7546 13.5717 18.8845C13.4631 18.9831 13.3632 18.9569 13.3257 18.9407C13.2883 18.9244 13.2009 18.872 13.1959 18.7272C13.1946 18.7047 13.1946 18.6835 13.1946 18.6623V17.8295C13.1946 16.8919 13.1959 15.923 13.1921 14.9704C13.1909 14.7394 13.327 14.662 13.4456 14.6196C14.0886 14.3911 14.4793 13.9653 14.6417 13.3211C14.6779 13.1763 14.6179 13.0402 14.4806 12.9578C14.3807 12.8966 14.2209 12.9079 14.1335 12.9815C14.0648 13.0389 14.0174 13.1151 13.9912 13.21C13.93 13.436 13.7977 13.6332 13.5867 13.813C13.473 13.9291 13.3657 13.9004 13.312 13.873C13.2633 13.848 13.1834 13.7856 13.1946 13.6407V12.5221C13.1946 11.6643 13.1946 10.8054 13.1934 9.94762C13.1934 9.85398 13.2221 9.78157 13.2783 9.73038C13.3332 9.68044 13.4069 9.66046 13.4968 9.67045C13.5018 9.67045 13.508 9.6692 13.5142 9.6692C13.523 9.6692 13.5317 9.66796 13.5392 9.66796H26.8421C27.1068 9.66796 27.1867 9.74786 27.1867 10.01V10.6056C27.1867 11.321 27.1867 12.0351 27.1855 12.7505C27.1855 12.8404 27.1942 12.9116 27.2154 12.974C27.2654 13.1238 27.394 13.2075 27.5775 13.2087C27.9209 13.21 28.2629 13.21 28.6063 13.21H30.4104C30.6464 13.21 30.7263 13.2899 30.7263 13.5271V22.3504C30.7263 24.3792 30.7263 26.408 30.7275 28.4369C30.7275 28.5717 30.6951 28.6928 30.6289 28.8064L30.3942 29.206C29.8598 30.1161 29.3067 31.0575 28.7711 31.9889C28.6587 32.1849 28.5114 32.2686 28.2804 32.2686H28.2792C24.038 32.2648 19.7269 32.2648 15.5556 32.2648H13.5617ZM14.5156 34.2874C14.4981 34.2874 14.4793 34.2874 14.4619 34.2887C14.3682 34.2924 14.3083 34.255 14.2758 34.2237C14.2421 34.1913 14.2022 34.1313 14.2022 34.034C14.2034 33.753 14.2034 33.4734 14.2022 33.1925C14.2009 33.0938 14.2421 33.0339 14.2758 33.0027C14.3095 32.9702 14.3707 32.934 14.4619 32.9378C14.4793 32.939 14.4968 32.939 14.5143 32.9378H27.7548C27.7698 32.939 27.7848 32.939 27.7997 32.9378C27.9308 32.9303 27.9933 32.989 28.022 33.0389C28.052 33.0888 28.0732 33.1725 28.0045 33.2861C27.9221 33.4222 27.841 33.5595 27.761 33.6956L27.6936 33.8092C27.6774 33.8367 27.6612 33.8629 27.6449 33.8904C27.6012 33.9628 27.5613 34.0302 27.5251 34.1001C27.4627 34.2237 27.359 34.2912 27.2292 34.2912C27.2167 34.2912 27.203 34.2899 27.1892 34.2887C27.183 34.2874 27.1755 34.2887 27.1693 34.2887L27.1443 34.2899L14.5156 34.2874ZM27.7061 37.2339C27.6612 37.2676 27.6162 37.3038 27.5713 37.3388C27.4577 37.4287 27.3403 37.5223 27.203 37.6097L26.8871 37.8095L26.947 37.2888C26.9645 37.144 26.9795 37.0092 26.9957 36.8743C27.0119 36.7432 27.0781 36.6858 27.1318 36.6608C27.1842 36.6371 27.2716 36.6221 27.3802 36.6946C27.4402 36.7358 27.5039 36.7732 27.57 36.8132C27.6037 36.8331 27.6374 36.8531 27.6699 36.8743C27.7036 36.8931 27.7898 36.9443 27.796 37.0529C27.7997 37.0928 27.791 37.1702 27.7061 37.2339ZM32.6665 34.2113C32.5978 34.2799 32.5091 34.2899 32.438 34.2899H32.4292C32.0822 34.2862 31.7276 34.2874 31.3855 34.2874C31.2494 34.2887 31.1133 34.2887 30.9785 34.2887C30.8798 34.2887 30.7675 34.2887 30.7063 34.1825C30.6451 34.0777 30.7025 33.979 30.7487 33.9016C31.0409 33.3997 31.3355 32.8978 31.6289 32.3972L32.2257 31.3759C32.2619 31.3135 32.2957 31.2523 32.3331 31.1874L32.5179 30.8577L32.6827 31.0712C32.7526 31.1624 32.7464 31.251 32.7439 31.2935L32.7426 31.3035C32.7439 31.5844 32.7439 31.864 32.7439 32.1437C32.7439 32.7542 32.7439 33.366 32.7464 33.9778C32.7464 34.0427 32.7389 34.1388 32.6665 34.2113ZM35.1048 25.1658C34.965 25.4005 34.8251 25.6377 34.6878 25.8737L34.0111 27.0285C33.4256 28.0274 32.84 29.0262 32.2557 30.025L28.7261 36.0503C28.6737 36.139 28.6213 36.2276 28.5663 36.315C28.5426 36.3537 28.4814 36.4561 28.3379 36.4561H28.3341L28.2967 36.4548L28.2555 36.4374C28.238 36.4299 28.2168 36.4199 28.1968 36.4086L27.9558 36.2676C27.806 36.1802 27.6574 36.0915 27.5076 36.0054C27.4789 35.9879 27.3902 35.938 27.364 35.8331C27.3365 35.7282 27.3877 35.6383 27.4052 35.6096C27.7835 34.9654 28.1606 34.3211 28.5364 33.6769L29.4041 32.1912C30.132 30.9464 30.8611 29.7004 31.5902 28.4544C32.1296 27.5342 32.669 26.614 33.2096 25.6926L33.8064 24.6739C33.8226 24.6464 33.8388 24.6202 33.855 24.5927C33.8813 24.549 33.9087 24.5053 33.9325 24.4616C33.9762 24.3805 34.0348 24.3293 34.1072 24.3105C34.2184 24.2818 34.3108 24.3392 34.342 24.358C34.5917 24.5128 34.7964 24.6339 34.9862 24.7363C35.0199 24.755 35.1198 24.8099 35.151 24.9223C35.1785 25.0234 35.1373 25.1096 35.1048 25.1658ZM35.8751 23.8398C35.824 23.9222 35.7753 24.0096 35.7266 24.0945C35.7103 24.122 35.6641 24.2057 35.563 24.2331C35.543 24.2381 35.5243 24.2406 35.5043 24.2406C35.4556 24.2406 35.4045 24.2256 35.3533 24.1944C35.1398 24.0658 34.9213 23.9385 34.709 23.8161L34.6404 23.7774C34.6141 23.7612 34.533 23.715 34.508 23.6189C34.4968 23.5764 34.493 23.509 34.5392 23.4328L34.6141 23.3042C34.6553 23.2356 34.6953 23.1669 34.7365 23.0982C34.8064 22.9796 34.9163 22.9759 34.9587 22.9796L35.0024 22.9834L35.0499 23.0146C35.0549 23.0171 35.0611 23.0221 35.0661 23.0258L35.2559 23.1407C35.4257 23.2431 35.6017 23.3504 35.7753 23.4503C35.804 23.4678 35.8926 23.519 35.9188 23.6239C35.9376 23.6925 35.9226 23.7649 35.8751 23.8398ZM36.7891 22.1394C36.7866 22.248 36.7304 22.3741 36.6842 22.4602C36.643 22.5351 36.5993 22.6088 36.5556 22.68C36.5331 22.7174 36.5106 22.7536 36.4882 22.7911C36.4719 22.8186 36.4257 22.8985 36.3271 22.9234C36.3084 22.9284 36.2896 22.9309 36.2709 22.9309C36.2235 22.9309 36.1748 22.9159 36.1261 22.8872C35.9201 22.7636 35.6991 22.635 35.4107 22.4715C35.2771 22.3966 35.2359 22.2605 35.3058 22.1244C35.3832 21.9758 35.4669 21.8185 35.578 21.6737C35.764 21.4327 36.0649 21.3478 36.3633 21.4527C36.6155 21.5426 36.7903 21.8235 36.7891 22.1356V22.1394Z", fill: "#141A22" })
] }), xj = () => /* @__PURE__ */ f.jsxs("svg", { viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ f.jsx("path", { d: "M31.6917 3.11086C31.664 3.21547 31.5783 3.31253 31.4434 3.38942C30.4199 3.97553 29.3687 4.55408 28.3515 5.11499L28.0452 5.28389C28.0087 5.3028 27.9469 5.31792 27.894 5.33053C27.8851 5.33305 27.875 5.33431 27.8662 5.33683C27.604 5.29649 27.5536 5.19692 27.5246 5.09734C27.4553 4.86163 27.5637 4.75828 27.6645 4.69399C27.9872 4.49106 28.3313 4.29947 28.6628 4.11418L28.8469 4.01082C29.5527 3.6163 30.2913 3.20665 31.0426 2.79322C31.1422 2.73902 31.2606 2.69238 31.3703 2.69238C31.4749 2.69238 31.572 2.73398 31.6426 2.84868C31.6968 2.93943 31.7144 3.02767 31.6917 3.11086Z", fill: "#141A22" }),
  /* @__PURE__ */ f.jsx("path", { d: "M25.5155 0.447463C25.3113 1.25416 25.092 2.03564 24.8449 2.90158C24.8172 2.9999 24.7567 3.10325 24.5197 3.13855C24.4151 3.13602 24.313 3.08813 24.2449 3.00746C24.2033 2.95956 24.1592 2.87889 24.1781 2.77805C24.3231 2.00539 24.5348 1.19618 24.8487 0.229404C24.9004 0.0705857 25.0315 0 25.1562 0C25.189 0 25.2205 0.00504168 25.252 0.0138649C25.4222 0.0655438 25.5684 0.243269 25.5155 0.447463Z", fill: "#141A22" }),
  /* @__PURE__ */ f.jsx("path", { d: "M30.8624 9.70555C30.846 9.78622 30.7868 9.86815 30.7074 9.91857C30.667 9.94504 30.5864 9.98412 30.4943 9.96269C29.5654 9.74211 28.7272 9.51648 27.9306 9.27448C27.773 9.22658 27.7175 9.09045 27.768 8.86987C27.7894 8.77786 27.8171 8.65307 28.1335 8.61652L28.6024 8.73752C29.0788 8.86105 29.578 8.98961 30.0784 9.1207L30.1654 9.14339C30.3317 9.18624 30.4893 9.22658 30.6267 9.28834C30.8838 9.40682 30.8926 9.55808 30.8624 9.70555Z", fill: "#141A22" }),
  /* @__PURE__ */ f.jsx("path", { d: "M6.18255 19.9657C6.1586 20.0552 6.08676 20.1359 5.9771 20.1976C5.8208 20.2859 5.66954 20.3829 5.52333 20.4762C5.06957 20.7661 4.64101 21.0396 4.15069 21.0106L4.14061 21.0094H4.12422C3.54315 21.0094 3.11711 20.7888 2.78309 20.3161C2.69864 20.1964 2.59024 19.9657 2.82216 19.7691C2.90788 19.696 3.03896 19.5863 3.32761 19.8535C3.93893 20.4207 4.14061 20.4422 4.86663 20.0199C4.93218 19.9821 4.99646 19.9443 5.062 19.9052C5.24981 19.7943 5.42754 19.6884 5.61282 19.5977C5.71996 19.5447 5.98592 19.4502 6.13844 19.7136C6.17373 19.7729 6.20902 19.8661 6.18255 19.9657Z", fill: "#141A22" }),
  /* @__PURE__ */ f.jsx("path", { d: "M8.38073 18.6195C8.38199 18.6964 8.3467 18.7771 8.28242 18.8426C8.21183 18.9145 8.11982 18.9561 8.02906 18.9561C8.02906 18.9561 8.02906 18.9561 8.0278 18.9561C7.84756 18.9561 7.67487 18.7897 7.67361 18.6119C7.67235 18.5325 7.71143 18.4481 7.77949 18.3788C7.85008 18.3082 7.94083 18.2653 8.02528 18.2653H8.02654C8.11478 18.2653 8.20175 18.3094 8.26855 18.375C8.33409 18.4418 8.37947 18.53 8.38073 18.6195Z", fill: "#141A22" }),
  /* @__PURE__ */ f.jsx("path", { d: "M25.7411 14.7462C25.5029 14.3365 25.2659 13.9269 25.029 13.5172C24.6697 12.8945 24.2992 12.2517 23.9273 11.6227C23.7332 11.2938 23.7408 11.0013 23.9487 10.7001C24.1139 10.4631 24.2765 10.2135 24.4328 9.97279C24.608 9.70557 24.7882 9.42827 24.976 9.16105C25.155 8.90644 25.1676 8.70855 25.0189 8.45393C24.6584 7.83757 24.2752 7.18213 23.9021 6.52039C23.7761 6.29729 23.6236 6.21284 23.374 6.22796C23.19 6.23931 23.0047 6.24813 22.8206 6.25695C22.4148 6.27586 21.995 6.29476 21.5917 6.34266C21.1266 6.39812 20.8178 6.24435 20.5934 5.84478C20.3615 5.43261 20.1157 5.01666 19.8787 4.61457C19.4703 3.92258 19.0468 3.20664 18.6737 2.47431C18.3674 1.87181 17.8506 1.49493 17.2582 1.44073C16.6595 1.38653 16.0671 1.68148 15.631 2.25121C13.8436 4.59188 11.9895 6.94264 10.1971 9.21525C9.38791 10.2413 8.55096 11.3026 7.73166 12.3488C7.54512 12.587 7.32958 12.7735 7.0737 12.921C5.94433 13.5689 4.79731 14.2319 3.68811 14.8722C3.20283 15.152 2.71755 15.4318 2.23228 15.7129C0.782746 16.5486 0.0126046 17.7763 0 18.559C0.00252092 20.3653 0.678128 21.9081 1.85666 22.7942C2.82973 23.5265 4.02591 23.7408 5.22209 23.3954C5.34687 23.3589 5.45653 23.3438 5.55359 23.3438C5.93929 23.3438 6.12206 23.5958 6.26449 23.8429C6.4712 24.2009 6.6754 24.5588 6.88085 24.9181C7.66234 26.2844 8.47155 27.6974 9.31354 29.0562C9.59589 29.5124 10.0585 29.8288 10.6143 29.9486C11.2168 30.0784 11.8508 29.9599 12.3525 29.6234C13.3747 28.9389 13.6432 27.7062 13.0206 26.5567C12.4899 25.5773 11.9252 24.6181 11.3933 23.7282C11.3126 23.5933 11.2118 23.3866 11.2761 23.161C11.3391 22.9391 11.5244 22.8207 11.6605 22.7501C11.987 22.5799 12.3134 22.3883 12.6298 22.203L12.6701 22.1791C13.1491 21.8967 13.1806 21.7833 12.9122 21.3081C12.8743 21.2413 12.8378 21.1758 12.8012 21.1077C12.6954 20.9161 12.5945 20.7346 12.4811 20.5619C12.4206 20.4686 12.258 20.2216 12.3676 19.9657C12.4786 19.7073 12.7722 19.6531 12.897 19.6304C13.6672 19.4867 14.4487 19.3304 15.2062 19.1805C15.6297 19.096 16.0545 19.0103 16.4793 18.9284C17.2191 18.7834 17.959 18.6385 18.6989 18.491C20.5921 18.1166 22.5509 17.7309 24.4832 17.3793C25.1537 17.257 25.6718 16.8978 25.9037 16.3948C26.1319 15.9033 26.0739 15.3159 25.7411 14.7462ZM21.7127 7.26784C21.8665 7.00945 22.2043 7.02583 22.3139 7.03087C22.3694 7.0334 22.4274 7.03339 22.5005 7.03213C22.5282 7.03213 22.5559 7.03214 22.5862 7.03087C22.8988 6.95651 23.4219 6.96533 23.7446 7.69766C23.7609 7.73421 23.7874 7.77707 23.8151 7.8237C23.8265 7.84261 23.8378 7.86152 23.8492 7.88042C24.3685 8.74888 24.3584 8.90392 23.7345 9.727L23.7282 9.73582C23.6689 9.81397 23.5152 10.0156 23.2744 10.0156C23.2643 10.0156 23.2542 10.0156 23.2442 10.0144C22.987 9.99674 22.8585 9.76607 22.803 9.66776C22.5143 9.15097 22.1702 8.54217 21.8047 7.93841C21.7316 7.81614 21.5564 7.52876 21.7127 7.26784ZM5.67333 22.4488C5.18049 22.7299 4.6511 22.7904 4.22506 22.8396L4.2049 22.8421H4.18473C2.64066 22.8295 1.23777 21.7896 0.850811 20.3703C0.414691 18.7733 1.03736 17.2582 2.47428 16.415C3.27216 15.9474 4.08767 15.4785 4.87546 15.0272C5.23973 14.818 5.60275 14.61 5.96576 14.4008C6.05651 14.3478 6.14853 14.2962 6.24054 14.2445C6.4586 14.121 6.68422 13.9924 6.89598 13.8588C7.03211 13.7731 7.24009 13.6659 7.47327 13.7239C7.73545 13.7895 7.8741 14.0315 7.91821 14.1096C8.70348 15.4898 9.54547 16.9457 10.6458 18.83C10.7164 18.9523 10.8059 19.1389 10.7492 19.3481C10.6937 19.5561 10.5274 19.672 10.4064 19.7401C9.5795 20.2115 8.74129 20.693 7.92956 21.1581C7.17958 21.5879 6.42709 22.0203 5.67333 22.4488ZM11.6895 25.6844L12.4344 26.9764C12.5756 27.2209 12.6437 27.4743 12.6311 27.7112C12.6273 28.4045 12.1937 29.0133 11.5761 29.1935C11.4147 29.2402 11.2547 29.2629 11.0996 29.2629C10.5564 29.2629 10.0686 28.9805 9.76731 28.4688C9.37152 27.797 8.97574 27.11 8.59382 26.4457C8.46525 26.2239 8.33921 26.0021 8.21064 25.7802C8.06821 25.5332 7.92704 25.2874 7.78712 25.0403C7.48966 24.5198 7.1821 23.9828 6.87077 23.4597C6.7775 23.3047 6.68044 23.0967 6.74472 22.8723C6.80901 22.6455 7.00312 22.5245 7.14303 22.4526C7.64343 22.1955 8.12241 21.9005 8.56609 21.6207C8.63541 21.5778 8.84339 21.4455 9.08036 21.5047C9.29338 21.5577 9.41186 21.7278 9.48244 21.8526C10.216 23.132 10.9647 24.4303 11.6895 25.6844ZM11.5521 21.9837C11.1147 22.2761 10.9685 22.285 10.9131 22.2875C10.9068 22.2887 10.8992 22.2887 10.8916 22.2887C10.7404 22.2887 10.6257 22.1942 10.5425 22.1098C10.4643 22.0316 9.9526 21.4342 9.97402 21.0938C9.98159 20.969 10.027 20.8317 10.4795 20.5216C10.9206 20.2191 11.0719 20.2165 11.1286 20.2153H11.1349C11.2912 20.2153 11.3971 20.3186 11.4374 20.3577C11.5546 20.4712 12.0538 21.1001 12.0576 21.3976C12.0613 21.5589 11.9832 21.6951 11.5521 21.9837ZM22.8988 16.7251C22.7942 16.957 22.5383 17.0074 22.4412 17.0263C19.8182 17.5393 17.1952 18.0536 14.5722 18.5679L12.1887 19.0355C12.166 19.0393 12.142 19.0431 12.1193 19.0468L12.0853 19.0519C12.05 19.0569 12.016 19.0594 11.9832 19.0594C11.5962 19.0594 11.4299 18.7494 11.3467 18.5931C11.3353 18.5704 11.324 18.549 11.3114 18.5275C10.729 17.5255 10.1417 16.5045 9.5732 15.5176L9.00221 14.5268C8.95809 14.4499 8.91272 14.3731 8.8686 14.2962C8.79297 14.1663 8.71861 14.0378 8.64424 13.9067C8.57491 13.7844 8.51315 13.6848 8.46399 13.6042C8.15392 13.0949 8.16652 12.945 8.55979 12.4597C8.61273 12.3941 8.67575 12.3172 8.7476 12.2252C10.3169 10.2135 11.9202 8.17285 13.4705 6.20023C13.952 5.58765 14.4335 4.9738 14.915 4.36122C15.1154 4.10787 15.2566 3.92384 15.5062 3.94149C15.7545 3.95913 15.873 4.16333 16.0368 4.44693C16.7919 5.75277 17.5456 7.05734 18.3006 8.36318C19.7754 10.9156 21.3005 13.555 22.8043 16.149C22.8711 16.26 23.0047 16.4906 22.8988 16.7251ZM25.3075 15.7986L25.3063 15.8075C25.2508 16.2146 24.9974 16.4957 24.5966 16.6003C24.5223 16.6192 24.4416 16.6331 24.3559 16.6331C24.1189 16.6331 23.8542 16.5322 23.6513 16.178C22.0883 13.4567 20.4926 10.6925 18.9498 8.02034L18.6157 7.44178C17.8658 6.14225 17.1284 4.87171 16.4251 3.66292C16.2801 3.41335 16.1238 3.08689 16.2095 2.77178C16.265 2.56632 16.4087 2.4012 16.6494 2.26633C17.1423 1.98903 17.6389 2.1718 17.9779 2.75539C19.2019 4.8654 20.4548 7.03213 21.7026 9.19382C22.3038 10.2375 22.9051 11.2811 23.5063 12.3248C24.037 13.2475 24.5676 14.1689 25.0996 15.0915L25.1109 15.1117C25.213 15.2881 25.339 15.5062 25.3075 15.7986Z", fill: "#141A22" })
] }), Oj = () => /* @__PURE__ */ f.jsxs("svg", { viewBox: "0 0 48 48", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ f.jsx("path", { d: "M41.1987 27.8366C41.2028 27.7443 41.1675 27.6846 41.0806 27.633C41.0575 27.6194 41.0304 27.6085 40.9964 27.6085C40.9611 27.6085 40.9177 27.6207 40.862 27.656C40.7547 27.7226 40.6611 27.8135 40.5728 27.9018C40.3732 28.1014 40.1736 28.3009 39.9727 28.5005C39.5328 28.9404 39.0916 29.3803 38.653 29.8216C38.5743 29.9017 38.4942 29.9804 38.4127 30.0578C38.1941 30.271 37.9877 30.4719 37.8045 30.6986C37.7583 30.7557 37.7298 30.8113 37.7162 30.8697C37.704 30.9227 37.7203 30.9607 37.7651 30.9865C37.818 31.0177 37.8791 31.0313 37.9769 31.0313H37.9823C38.0434 31.034 38.1222 30.9892 38.2172 30.8942L39.0535 30.0565C39.6957 29.4143 40.3366 28.7734 40.9774 28.1312C41.0684 28.0389 41.1295 27.9656 41.1743 27.8909C41.196 27.8624 41.1987 27.8475 41.1987 27.8366Z", fill: "#141A22" }),
  /* @__PURE__ */ f.jsx("path", { d: "M37.3414 28.2398C37.4107 28.3729 37.4921 28.3946 37.5301 28.4C37.5858 28.396 37.6306 28.3797 37.6808 28.3471C37.7772 28.2846 37.8709 28.2045 37.9877 28.0891C38.114 27.9629 38.2416 27.8366 38.3692 27.7117C38.7032 27.3831 39.0494 27.0423 39.3671 26.692C39.397 26.6595 39.4282 26.6282 39.4581 26.597C39.5409 26.5128 39.6115 26.4409 39.6495 26.3526C39.6848 26.2725 39.6644 26.1911 39.5966 26.13C39.5423 26.0824 39.4961 26.0675 39.4567 26.0675C39.4119 26.0675 39.3807 26.0865 39.3657 26.096C39.2816 26.1476 39.2069 26.2169 39.139 26.2847L38.5267 26.8971C38.1818 27.2419 37.8356 27.5881 37.4908 27.9343C37.4473 27.9791 37.4107 28.0185 37.3808 28.0579C37.302 28.1638 37.3278 28.2127 37.3414 28.2398Z", fill: "#141A22" }),
  /* @__PURE__ */ f.jsx("path", { d: "M37.0062 25.8978H37.0198C37.0293 25.8978 37.0605 25.9005 37.1026 25.8611C37.1434 25.8218 37.1854 25.7824 37.2275 25.743C37.2954 25.6792 37.3647 25.6154 37.4312 25.5489C37.5113 25.4688 37.5914 25.3887 37.6729 25.3086C37.9403 25.0438 38.2173 24.7695 38.4671 24.4831C38.5486 24.3894 38.5391 24.3419 38.4834 24.2672C38.4481 24.2197 38.3952 24.1613 38.3368 24.1532C38.3313 24.1518 38.3273 24.1518 38.3218 24.1518C38.2675 24.1518 38.2064 24.1898 38.163 24.2224C38.1413 24.24 38.1195 24.2577 38.0978 24.2767C37.7937 24.551 37.5031 24.8524 37.2221 25.1429C37.0931 25.276 36.9641 25.409 36.8338 25.5407C36.7605 25.6154 36.7442 25.6819 36.7768 25.7715C36.8148 25.8761 36.9234 25.8978 37.0062 25.8978Z", fill: "#141A22" }),
  /* @__PURE__ */ f.jsx("path", { d: "M41.0806 27.633C41.0575 27.6194 41.0304 27.6085 40.9964 27.6085C40.9611 27.6085 40.9177 27.6207 40.862 27.656C40.7547 27.7226 40.6611 27.8135 40.5728 27.9018C40.3732 28.1014 40.1736 28.3009 39.9727 28.5005C39.5328 28.9404 39.0916 29.3803 38.653 29.8216C38.5743 29.9017 38.4942 29.9804 38.4127 30.0578C38.1941 30.271 37.9877 30.4719 37.8045 30.6986C37.7583 30.7557 37.7298 30.8113 37.7162 30.8697C37.704 30.9227 37.7203 30.9607 37.7651 30.9865C37.818 31.0177 37.8791 31.0313 37.9769 31.0313H37.9823C38.0434 31.034 38.1222 30.9892 38.2172 30.8942L39.0535 30.0565C39.6957 29.4143 40.3366 28.7734 40.9774 28.1312C41.0684 28.0389 41.1295 27.9656 41.1743 27.8909C41.1919 27.8624 41.1946 27.8475 41.1946 27.8353C41.2028 27.7429 41.1675 27.6846 41.0806 27.633Z", fill: "#141A22" }),
  /* @__PURE__ */ f.jsx("path", { d: "M37.681 28.3471C37.7774 28.2846 37.8711 28.2045 37.9878 28.0891C38.1141 27.9629 38.2417 27.8366 38.3693 27.7117C38.7033 27.3831 39.0496 27.0423 39.3673 26.692C39.3971 26.6595 39.4284 26.6282 39.4582 26.597C39.541 26.5128 39.6116 26.4409 39.6497 26.3526C39.685 26.2725 39.6646 26.1911 39.5967 26.13C39.5424 26.0824 39.4962 26.0675 39.4569 26.0675C39.4121 26.0675 39.3808 26.0865 39.3659 26.096C39.2817 26.1476 39.207 26.2169 39.1392 26.2847L38.5268 26.8971C38.182 27.2419 37.8358 27.5881 37.4909 27.9343C37.4475 27.9791 37.4108 28.0185 37.3809 28.0579C37.2995 28.1638 37.3253 28.2127 37.3402 28.2398C37.4095 28.3729 37.4909 28.3946 37.5289 28.4C37.5846 28.396 37.6308 28.3797 37.681 28.3471Z", fill: "#141A22" }),
  /* @__PURE__ */ f.jsx("path", { d: "M37.0198 25.8992C37.0293 25.8992 37.0605 25.9019 37.1026 25.8625C37.1434 25.8232 37.1854 25.7838 37.2275 25.7444C37.2954 25.6806 37.3647 25.6168 37.4312 25.5503C37.5113 25.4702 37.5914 25.3901 37.6729 25.31C37.9403 25.0452 38.2173 24.7709 38.4671 24.4845C38.5486 24.3908 38.5391 24.3433 38.4834 24.2686C38.4481 24.2211 38.3952 24.1627 38.3368 24.1546C38.3313 24.1532 38.3273 24.1532 38.3218 24.1532C38.2675 24.1532 38.2064 24.1912 38.163 24.2238C38.1413 24.2414 38.1195 24.2591 38.0978 24.2781C37.7937 24.5524 37.5031 24.8538 37.2221 25.1443C37.0931 25.2774 36.9641 25.4104 36.8338 25.5421C36.7605 25.6168 36.7442 25.6833 36.7768 25.7729C36.8148 25.8748 36.922 25.8965 37.0062 25.8965L37.0198 25.8992Z", fill: "#141A22" }),
  /* @__PURE__ */ f.jsx("path", { d: "M22.7965 9.60136V9.59457V9.58779C22.7965 9.57964 22.7965 9.55113 22.7761 9.51583C22.7422 9.4588 22.6933 9.42215 22.6363 9.41128C22.624 9.40857 22.6132 9.40857 22.601 9.40857C22.5548 9.40857 22.5073 9.42622 22.4652 9.4588C22.324 9.56878 22.1977 9.6964 22.0633 9.83217C22.028 9.86883 21.9927 9.90413 21.956 9.93943C21.7823 10.1119 21.6085 10.2843 21.4361 10.4567C20.7939 11.0948 20.1299 11.7533 19.4918 12.4172C19.4348 12.4756 19.3791 12.5408 19.3479 12.6141C19.3289 12.6603 19.314 12.7186 19.3954 12.8205C19.4348 12.8693 19.4782 12.8965 19.5706 12.8734C19.648 12.8544 19.7145 12.7987 19.8027 12.7105C20.2168 12.295 20.6309 11.8809 21.045 11.4668L21.7497 10.7622C22.0633 10.4486 22.3756 10.1363 22.6892 9.82267C22.7693 9.73985 22.7992 9.68011 22.7965 9.60136Z", fill: "#141A22" }),
  /* @__PURE__ */ f.jsx("path", { d: "M24.0565 11.5347C24.0877 11.4994 24.1216 11.4655 24.1556 11.4315C24.2194 11.3677 24.2805 11.3066 24.3198 11.2401C24.3497 11.1899 24.3701 11.1261 24.2913 11.0229C24.2479 10.9658 24.1922 10.936 24.1338 10.936C24.1189 10.936 24.1053 10.9373 24.0904 10.9414C24.0307 10.9563 23.9791 10.9971 23.9098 11.0636C23.7971 11.1695 23.6844 11.2822 23.5758 11.3922C23.4876 11.4818 23.3993 11.5714 23.3084 11.6583C23.0599 11.8972 22.8128 12.1457 22.5725 12.386L22.5413 12.4172C22.377 12.5815 22.2154 12.7539 22.0579 12.9304C22.0172 12.9766 21.986 13.035 22.0376 13.1463C22.0715 13.2183 22.1136 13.2576 22.2371 13.259H22.2412C22.286 13.2549 22.3417 13.2495 22.358 13.2305C22.4381 13.1382 22.525 13.0608 22.6092 12.9861C22.6635 12.9372 22.7151 12.8911 22.7639 12.8435C22.8848 12.7227 23.0056 12.6032 23.1278 12.4838C23.4387 12.1783 23.7605 11.8619 24.0565 11.5347Z", fill: "#141A22" }),
  /* @__PURE__ */ f.jsx("path", { d: "M24.6649 13.836C24.7341 13.8496 24.8183 13.8197 24.8957 13.7518C25.2093 13.4762 25.5026 13.1843 25.8447 12.8299C25.8691 12.8041 25.8949 12.7783 25.9207 12.7525C26.0293 12.6426 26.1325 12.5394 26.2045 12.4185C26.2683 12.3126 26.2452 12.242 26.2167 12.1918C26.1936 12.1497 26.1542 12.1063 26.0361 12.0832L26.0103 12.0873C25.9357 12.0995 25.8746 12.1497 25.7877 12.2366C25.4306 12.5923 25.0735 12.9494 24.7178 13.3078C24.6594 13.3662 24.6119 13.4165 24.5725 13.468C24.4775 13.5902 24.4924 13.6473 24.5169 13.6989C24.5413 13.7532 24.5875 13.8197 24.6649 13.836Z", fill: "#141A22" }),
  /* @__PURE__ */ f.jsx("path", { d: "M26.9579 37.7057C26.9023 37.6174 26.7325 37.5305 26.5832 37.5916C26.5153 37.6188 26.4515 37.6582 26.3877 37.7084C26.3089 37.7709 26.2316 37.8347 26.1542 37.8985C25.9614 38.0573 25.7631 38.2216 25.5432 38.3628C25.2011 38.5828 24.844 38.7294 24.4788 38.7986C24.1298 38.8652 23.7687 38.8421 23.3763 38.7294L23.3044 38.709C23.1455 38.6642 22.9812 38.6181 22.8224 38.5352C22.5956 38.4171 22.5155 38.2325 22.5875 37.9881C22.654 37.7613 22.7205 37.5346 22.7884 37.3079L23.0396 36.4607C23.1509 36.0859 23.2609 35.7112 23.3736 35.3365C23.4781 34.9876 23.5813 34.6386 23.6859 34.2897C23.8053 33.8878 23.9262 33.4873 24.0457 33.0854C24.271 32.3306 24.5005 31.5567 24.7245 30.7936C24.7476 30.7149 24.772 30.6361 24.7965 30.5574C24.8548 30.3728 24.9092 30.1976 24.9458 30.017C24.9974 29.7604 24.9594 29.6667 24.7422 29.5201C24.6756 29.4753 24.6077 29.4305 24.5399 29.3884C24.3172 29.2513 24.0932 29.1155 23.8692 28.9798C23.5026 28.7584 23.1224 28.529 22.7545 28.2928C22.5793 28.1801 22.4762 28.0144 22.4531 27.8121C22.4273 27.5786 22.4368 27.3464 22.449 27.1469C22.4599 26.9785 22.4531 26.8115 22.4463 26.6336C22.4422 26.5345 22.4381 26.4354 22.4381 26.3363C22.4341 25.8842 22.4354 25.4267 22.4368 24.9827C22.4368 24.7804 22.4381 24.5781 22.4381 24.3758V24.3459C22.4381 24.24 22.4381 24.1301 22.4341 24.0255C22.4246 23.7879 22.3621 23.7214 22.1286 23.6956C21.9344 23.6752 21.7539 23.6657 21.5774 23.6671C21.4158 23.6684 21.2637 23.6603 21.1565 23.5544C21.0492 23.4471 21.0397 23.2924 21.0384 23.1294C21.037 22.8348 21.0356 22.5402 21.037 22.2456C21.037 22.1885 21.0316 22.1302 21.0221 22.0691C20.9976 21.9197 20.9284 21.8437 20.7831 21.8084C20.7084 21.7907 20.6256 21.7826 20.5482 21.7812C20.2169 21.7826 19.8857 21.7839 19.5544 21.7826C19.2896 21.7812 19.1213 21.636 19.0833 21.3739C19.0724 21.2993 19.0683 21.2341 19.071 21.1716C19.0778 20.9965 19.0751 20.8159 19.0738 20.6408C19.0724 20.5484 19.071 20.4561 19.071 20.3638C19.071 20.2891 19.0588 20.2104 19.0303 20.1004C19.0059 20.0054 18.9556 19.9538 18.8565 19.9212C18.7153 19.875 18.5578 19.871 18.4207 19.8696C18.0826 19.8669 17.7446 19.8669 17.4052 19.8682C17.1771 19.8682 16.949 19.8682 16.7209 19.8682C16.4412 19.8669 16.3 19.7298 16.2878 19.4473C16.2864 19.4229 16.2864 19.3998 16.2864 19.3754V19.355L16.285 17.9715C16.285 17.8249 16.2851 17.6796 16.2864 17.533C16.2878 17.2044 16.2878 16.865 16.2837 16.5324C16.2796 16.1671 16.1452 16.0925 15.9293 16.0884C15.3672 16.0775 14.7739 16.0775 14.0611 16.087C13.8453 16.0898 13.7489 16.1794 13.719 16.4061C13.6986 16.5622 13.6891 16.7007 13.6878 16.8297C13.6851 17.4271 13.6864 18.0258 13.6864 18.6232V19.3292C13.6864 19.3835 13.6878 19.4406 13.6837 19.5003C13.6701 19.708 13.5316 19.8492 13.3212 19.8669C13.2913 19.8696 13.2601 19.8696 13.2289 19.8696H13.199C12.9668 19.8723 12.7306 19.871 12.5025 19.8696C12.1156 19.8669 11.715 19.8642 11.324 19.8845C11.0742 19.8967 10.9995 19.9796 10.9602 20.1085C10.933 20.1968 10.9194 20.2891 10.9194 20.3814C10.9181 20.5131 10.9181 20.6448 10.9181 20.7765C10.9181 20.9422 10.9167 21.1078 10.9167 21.2721C10.9167 21.3305 10.9099 21.3916 10.8991 21.4527C10.8705 21.6142 10.7606 21.7283 10.5963 21.7636C10.5338 21.7772 10.4741 21.7812 10.4062 21.7826H9.98804C9.79932 21.7826 9.6106 21.7826 9.42188 21.7826C9.35128 21.7826 9.27254 21.7921 9.18836 21.8125C9.08382 21.8383 9.02544 21.8912 8.99285 21.989C8.9657 22.0745 8.95212 22.1532 8.95076 22.2333V22.3637C8.9494 22.6094 8.94805 22.8633 8.93583 23.1159C8.91818 23.4689 8.74846 23.644 8.39954 23.6657C8.36288 23.6684 8.32622 23.6684 8.29092 23.6684C8.26648 23.6684 8.23933 23.6684 8.21489 23.6698L8.19724 23.6712C8.04518 23.6793 7.90262 23.6861 7.76413 23.7146C7.66095 23.7363 7.60936 23.7811 7.58356 23.8707C7.56184 23.9468 7.55097 24.0337 7.55097 24.1409C7.5469 24.608 7.54962 25.0818 7.55097 25.5407C7.55369 26.2616 7.55641 27.0084 7.53875 27.7429C7.53332 27.9927 7.42471 28.1814 7.2197 28.3036L6.7703 28.5738C6.25709 28.882 5.72758 29.1997 5.22252 29.5364C5.05552 29.6477 5.00257 29.7781 5.04738 29.9695C5.07996 30.1094 5.12069 30.2506 5.16007 30.389L5.2361 30.6511C5.37866 31.1412 5.51986 31.63 5.66513 32.1188C5.76288 32.4487 5.862 32.7786 5.96247 33.1072C6.04936 33.3936 6.13625 33.6815 6.22179 33.9693C6.30461 34.2449 6.38471 34.5219 6.46617 34.7975C6.57207 35.1573 6.67797 35.5184 6.78659 35.8782C6.83547 36.0425 6.8857 36.2054 6.93594 36.3697C7.07714 36.834 7.22377 37.3147 7.35547 37.7912C7.37312 37.8523 7.38669 37.9202 7.40027 37.9976C7.41928 38.113 7.37312 38.1863 7.34325 38.2203C7.30659 38.261 7.2387 38.3085 7.1233 38.3031C7.01197 38.2963 6.91014 38.2746 6.83275 38.2542C6.58837 38.1931 6.33312 38.1632 6.05751 38.1632C5.96382 38.1632 5.86743 38.1673 5.76832 38.1741C5.29176 38.208 4.80707 38.3601 4.32372 38.6262C3.92456 38.8461 3.52947 39.1408 3.08007 39.5522C2.98232 39.6418 2.98639 39.8631 3.02712 39.9445C3.09501 40.0844 3.29866 40.1414 3.45344 40.0667C3.55527 40.0165 3.65981 39.9486 3.76978 39.8576C4.14994 39.5467 4.48258 39.3281 4.81521 39.1693C5.60675 38.7932 6.39557 38.7688 7.1586 39.1C7.27265 39.1489 7.38126 39.2059 7.4858 39.2602C7.57134 39.3051 7.6528 39.3471 7.73698 39.3865C8.06962 39.5386 8.45113 39.6404 8.90732 39.6974C9.26711 39.7422 9.58616 39.7368 9.8835 39.6811C10.3302 39.597 10.7456 39.4137 11.0566 39.2643C11.1231 39.2317 11.1882 39.2005 11.2548 39.1679C11.5603 39.0172 11.8752 38.8611 12.2201 38.766C12.7564 38.6181 13.2099 38.5977 13.6498 38.7036C13.9661 38.7796 14.2594 38.9127 14.5037 39.0322C14.5662 39.0634 14.6287 39.0933 14.6911 39.1245C14.9708 39.263 15.2586 39.4069 15.5533 39.5169C16.0067 39.6866 16.4317 39.7735 16.8539 39.783C17.3617 39.7938 17.8885 39.6676 18.4628 39.3987C18.6067 39.3308 18.7506 39.2548 18.8905 39.1815C19.0914 39.0756 19.2978 38.967 19.5137 38.876C20.069 38.6425 20.6365 38.5828 21.2013 38.6968C21.6059 38.7796 21.9765 38.9412 22.3227 39.1C23.0369 39.4286 23.6492 39.5617 24.248 39.5196C24.472 39.5046 24.6661 39.4734 24.8426 39.4245C25.5853 39.2222 26.2682 38.7932 26.9308 38.113C27.0204 38.0125 27.0353 37.8279 26.9579 37.7057ZM21.299 24.331C21.6276 24.331 21.8027 24.5034 21.8041 24.8306C21.8055 25.056 21.8041 25.28 21.8041 25.5054C21.8041 25.8435 21.8027 26.1938 21.8068 26.5373C21.8068 26.5929 21.8095 26.6499 21.8109 26.7056C21.8163 26.8604 21.8217 27.0192 21.8027 27.1835C21.7959 27.2405 21.7797 27.3912 21.652 27.4618C21.6099 27.4849 21.5665 27.4944 21.5258 27.4944C21.4457 27.4944 21.3764 27.4605 21.3425 27.4456C21.1796 27.3682 21.0288 27.2731 20.8836 27.1822C20.8306 27.1482 20.7777 27.1156 20.7234 27.083C19.7282 26.4829 18.9611 26.0173 18.2374 25.5746C18.1125 25.4986 17.9862 25.4226 17.86 25.3479C17.5776 25.1782 17.2843 25.0031 17.0033 24.817C16.9666 24.7926 16.9313 24.7668 16.8947 24.7397L16.6326 24.5523L16.8363 24.3934C16.9232 24.3256 17.0073 24.3296 17.0386 24.331C18.4601 24.331 19.8802 24.331 21.299 24.331ZM14.4141 17.0266C14.4589 16.827 14.6409 16.698 14.8472 16.7184C14.9178 16.7252 14.9912 16.7224 15.0699 16.7184L15.1093 16.717C15.2953 16.7089 15.4066 16.7768 15.4677 16.8351C15.5288 16.8935 15.6035 17.0035 15.6035 17.1895C15.6048 17.4556 15.6048 17.7204 15.6048 17.9865V18.1589V18.5431C15.6048 18.8228 15.6048 19.1025 15.6048 19.3822C15.6048 19.4338 15.6048 19.4908 15.5926 19.5519C15.5546 19.7501 15.4161 19.8642 15.2138 19.8669C15.1473 19.8682 15.0808 19.8682 15.0142 19.8682C14.9518 19.8682 14.8893 19.8682 14.8269 19.8669C14.5472 19.8642 14.4033 19.7216 14.4033 19.4433C14.4019 19.1989 14.4019 18.9559 14.4033 18.7115C14.4033 18.4644 14.4033 18.2159 14.4033 17.9688C14.4033 17.9036 14.4033 17.8371 14.4046 17.7719C14.406 17.5941 14.4074 17.4271 14.3951 17.2574C14.3843 17.1691 14.3992 17.0877 14.4141 17.0266ZM11.6051 20.9408C11.6173 20.7087 11.7653 20.5566 12.0015 20.5335C12.045 20.5294 12.087 20.5294 12.1223 20.5294H12.9207C14.4888 20.5294 16.0583 20.5294 17.6265 20.5308C17.6265 20.5308 17.6265 20.5308 17.6278 20.5308C17.6631 20.5308 17.6984 20.5281 17.7337 20.5254C17.8125 20.5199 17.9034 20.5131 17.9998 20.5294C18.2524 20.5715 18.3868 20.7209 18.399 20.9693C18.4058 21.0874 18.4058 21.2137 18.399 21.3536C18.3908 21.5599 18.2591 21.7106 18.0501 21.7582C17.9727 21.7758 17.898 21.7772 17.8355 21.7772H17.8342H12.1074C12.0667 21.7772 12.0219 21.7772 11.9716 21.769C11.7463 21.7324 11.6159 21.5898 11.6051 21.3658C11.5969 21.2259 11.5969 21.082 11.6051 20.9408ZM8.61134 24.331C10.0532 24.331 11.4937 24.331 12.9356 24.331C12.9763 24.3296 13.0469 24.3283 13.1284 24.3758L13.3524 24.5075L13.1623 24.684C13.0931 24.7492 13.0198 24.7899 12.956 24.8266C12.937 24.8374 12.9166 24.8483 12.8976 24.8605C12.4536 25.1334 12.0164 25.4022 11.5956 25.6561C11.0946 25.9589 10.5936 26.2616 10.0926 26.5644L9.22773 27.0871C9.04716 27.1971 8.86658 27.3071 8.68465 27.4143C8.6317 27.4456 8.54617 27.4958 8.45384 27.4958C8.41447 27.4958 8.37374 27.4863 8.33437 27.4646C8.1986 27.3872 8.1986 27.2229 8.1986 27.1333C8.1986 26.3363 8.1986 25.5393 8.1986 24.7424C8.19995 24.4654 8.33437 24.331 8.61134 24.331ZM14.539 38.0886C14.4236 38.1795 14.277 38.1429 14.2132 38.1279L14.1127 38.1035C13.8683 38.0437 13.6375 37.9854 13.3972 37.9569C12.9967 37.9093 12.5867 37.9378 12.1441 38.0451C11.6784 38.1592 11.2059 38.3547 10.6981 38.6425C10.3818 38.8231 10.0817 38.9385 9.78167 38.9982C9.61739 39.0308 9.44904 39.0471 9.27661 39.0471C9.12319 39.0471 8.96705 39.0335 8.80956 39.0077C8.55703 38.9656 8.37917 38.8095 8.29228 38.5556C8.16873 38.1917 8.06147 37.8184 7.95693 37.4586C7.92027 37.3323 7.88361 37.2074 7.84695 37.0811C7.76821 36.815 7.6881 36.5489 7.60935 36.2828C7.4668 35.8063 7.32017 35.3148 7.17896 34.8287C7.05406 34.3983 6.92236 33.9611 6.79474 33.5389C6.65625 33.08 6.51369 32.6062 6.37928 32.1378C6.23536 31.6341 6.09281 31.1426 5.93803 30.6592C5.91223 30.5791 5.89187 30.4977 5.87286 30.4203C5.86471 30.389 5.85792 30.3578 5.84978 30.3279C5.80769 30.1664 5.85249 30.013 5.97604 29.8962C6.05072 29.8242 6.13489 29.774 6.20957 29.7292L7.28758 29.0775C8.13886 28.5629 8.99014 28.0484 9.84141 27.5338C10.5759 27.0898 11.3091 26.6459 12.0436 26.2005L12.8867 25.69C13.2805 25.4511 13.6742 25.2135 14.0666 24.9745C14.0842 24.9637 14.1019 24.9515 14.1195 24.9392C14.1453 24.9202 14.1711 24.9026 14.1996 24.8863C14.3015 24.8252 14.4128 24.8198 14.5037 24.87C14.5947 24.9202 14.649 25.0166 14.6517 25.1347C14.6545 25.2352 14.6531 25.337 14.6531 25.4375C14.6531 25.485 14.6517 25.5326 14.6517 25.5814V31.296L14.6531 31.4901V37.7817C14.6545 37.8442 14.6545 37.9976 14.539 38.0886ZM14.2526 23.6657C13.0306 23.6657 11.8087 23.6657 10.5854 23.6657H10.5841C10.4307 23.6657 10.2664 23.6739 10.0804 23.6915C10.0614 23.6929 10.0424 23.6942 10.0247 23.6942C9.82376 23.6942 9.69207 23.5815 9.64862 23.3738C9.59703 23.1267 9.6011 22.9013 9.6622 22.6882C9.7165 22.4954 9.83327 22.4126 10.0261 22.4166C10.1048 22.418 10.1822 22.418 10.2609 22.418H10.3709C12.4523 22.418 14.5336 22.4166 16.615 22.4166H19.7377C19.8246 22.4166 19.902 22.4221 19.9739 22.4329C20.1898 22.4655 20.3337 22.6149 20.3486 22.8226C20.3595 22.9719 20.3677 23.1688 20.331 23.3697C20.2984 23.5449 20.1789 23.6521 20.0011 23.6644C19.9766 23.6657 19.9508 23.6657 19.925 23.6657H19.9128H14.2526ZM22.1612 37.0268C22.1367 37.111 22.1164 37.1979 22.0946 37.2889C22.0784 37.3622 22.0607 37.4341 22.0417 37.5075C21.9453 37.8632 21.7484 38.0098 21.3818 37.9989C21.3072 37.9962 21.2339 37.9881 21.1605 37.9745C20.7016 37.8863 20.2224 37.9229 19.6915 38.0858C19.3127 38.2026 18.9285 38.3655 18.5171 38.5855C18.1546 38.7783 17.8423 38.9249 17.4948 39.005C17.2979 39.0512 17.097 39.0742 16.8947 39.0742C16.6177 39.0742 16.3353 39.0308 16.0529 38.9439L16.0284 38.9371C15.8981 38.8977 15.7515 38.8529 15.6171 38.7606C15.4745 38.6629 15.3863 38.5271 15.3537 38.3587C15.3333 38.246 15.3116 38.0967 15.336 37.9365V25.6113C15.3374 25.462 15.3374 25.3208 15.3238 25.1809C15.3048 24.9827 15.4243 24.8958 15.4772 24.8686C15.5845 24.8116 15.7094 24.8211 15.8194 24.8958C16.1004 25.0886 16.4005 25.2678 16.691 25.4402C16.8186 25.5163 16.9462 25.5909 17.0725 25.6683C17.4825 25.9181 17.8926 26.168 18.3039 26.4164L19.4173 27.0912C20.0744 27.489 20.7315 27.8882 21.3886 28.286C21.9657 28.6349 22.544 28.9838 23.1224 29.3314L23.7999 29.7387C24.1095 29.9247 24.1909 30.1352 24.0945 30.4909C23.899 31.2077 23.6818 31.93 23.47 32.6279C23.3519 33.0189 23.2338 33.4099 23.1197 33.8009C22.9323 34.4404 22.7382 35.088 22.5508 35.7153C22.4218 36.1525 22.2902 36.5897 22.1612 37.0268Z", fill: "#141A22" }),
  /* @__PURE__ */ f.jsx("path", { d: "M21.9453 30.5452C22.001 30.476 22.0132 30.404 21.986 30.3117C21.9494 30.1882 21.872 30.0918 21.7389 30.0103C20.942 29.5188 20.1463 29.0273 19.3494 28.5372C19.2923 28.5019 19.2353 28.4652 19.1783 28.4286C19.0385 28.339 18.9068 28.2548 18.7669 28.1869C18.7113 28.1598 18.6529 28.1462 18.5986 28.1462C18.5402 28.1462 18.4859 28.1611 18.437 28.1923C18.3406 28.2534 18.2849 28.3648 18.2849 28.4992V28.5073C18.2822 28.5711 18.2958 28.654 18.4261 28.7381C18.7099 28.9214 18.9665 29.0844 19.2109 29.2378C19.8653 29.6478 20.536 30.0551 21.1836 30.4502L21.4877 30.6348C21.5516 30.6729 21.7471 30.7923 21.9453 30.5452Z", fill: "#141A22" }),
  /* @__PURE__ */ f.jsx("path", { d: "M17.3005 27.4795C17.2978 27.3804 17.2557 27.2827 17.1865 27.2188C17.1308 27.1673 17.0643 27.1428 16.9882 27.1455C16.8063 27.1523 16.6841 27.2799 16.6855 27.4619C16.6855 27.5623 16.7235 27.656 16.7887 27.7198C16.8253 27.7565 16.8878 27.7999 16.976 27.7986C17.0629 27.7972 17.1498 27.7579 17.215 27.6913C17.272 27.6289 17.3032 27.5542 17.3005 27.4795Z", fill: "#141A22" }),
  /* @__PURE__ */ f.jsx("path", { d: "M11.8073 28.1638C11.772 28.1462 11.7272 28.1299 11.6715 28.1299C11.6104 28.1299 11.533 28.1489 11.4353 28.2046C11.1678 28.358 10.9519 28.487 10.7551 28.6092C10.5894 28.7137 10.4252 28.8196 10.2609 28.9255C10.0179 29.0816 9.76804 29.2432 9.5155 29.3966C9.24532 29.5609 8.9765 29.7401 8.71582 29.9125C8.63707 29.9641 8.55968 30.0171 8.48094 30.0687C8.27185 30.2058 8.28679 30.3497 8.29086 30.3972C8.30172 30.5126 8.36553 30.6077 8.466 30.6606C8.57055 30.7149 8.69138 30.7136 8.79864 30.6538C8.89504 30.6009 8.99007 30.5412 9.08104 30.4828L9.43947 30.2574C9.95811 29.9302 10.4781 29.603 10.9954 29.2731C11.0714 29.2242 11.1475 29.1767 11.2235 29.1305C11.4312 29.0015 11.6444 28.8685 11.8399 28.7218C11.9322 28.6526 11.9729 28.5671 11.9729 28.4449C11.9675 28.3064 11.9173 28.2195 11.8073 28.1638Z", fill: "#141A22" }),
  /* @__PURE__ */ f.jsx("path", { d: "M13.6036 27.4307C13.6036 27.3587 13.5683 27.2827 13.5059 27.2216C13.438 27.1537 13.3484 27.117 13.2628 27.1143C13.0972 27.1157 12.9519 27.2569 12.9533 27.4184C12.9546 27.5977 13.0999 27.7429 13.2778 27.7429H13.2791C13.4448 27.7416 13.6036 27.5909 13.6036 27.4307Z", fill: "#141A22" }),
  /* @__PURE__ */ f.jsx("path", { d: "M43.2842 7.82277C43.086 7.31227 42.6759 7.0258 42.1301 7.01358H42.122C42.1016 7.01358 42.0731 7.01222 42.0392 7.00679L42.0039 7L41.9577 7.00815C41.9007 7.01901 41.8464 7.02715 41.7921 7.03666C41.6848 7.05431 41.583 7.07196 41.4879 7.0964C41.0643 7.20637 40.6502 7.38287 40.2579 7.62183C39.4528 8.11196 38.6829 8.72292 37.9036 9.49002C37.6226 9.76699 37.351 10.0426 37.0971 10.3114C36.8908 10.53 36.6396 10.5952 36.3504 10.5042C36.0056 10.397 35.6512 10.2924 35.3091 10.192L34.9316 10.0806C34.8637 10.0603 34.7958 10.0412 34.728 10.0209C34.4931 9.95299 34.25 9.88239 34.0125 9.79414C33.7558 9.69775 33.6757 9.53211 33.7586 9.27279C33.8088 9.11665 33.8278 8.96866 33.8183 8.82067C33.7911 8.42423 33.5984 8.1554 33.2304 7.99927C32.8842 7.85263 32.5407 7.90694 32.2108 8.16083C32.0818 8.25994 31.965 8.37399 31.8361 8.50297C31.8089 8.53013 31.7831 8.55728 31.756 8.58308C31.6867 8.65368 31.6148 8.72564 31.5401 8.79488C31.3609 8.95916 31.0703 8.97545 30.8775 8.83018C30.6807 8.68219 30.735 8.51519 30.7676 8.44866C30.8382 8.30475 30.8531 8.13775 30.8164 7.90423C30.7662 7.58653 30.587 7.33671 30.3114 7.19958C30.029 7.05974 29.6923 7.06788 29.4099 7.2213C29.1763 7.34757 28.993 7.53765 28.7772 7.77253C28.6916 7.86621 28.431 8.15133 28.0114 8.00741C27.9843 7.99791 27.9517 7.98976 27.9164 7.98162C27.8838 7.97347 27.8499 7.96532 27.8173 7.95582L26.8139 7.65441C26.1989 7.46976 25.5839 7.28512 24.9688 7.10183C24.7462 7.0353 24.5832 7.07332 24.4393 7.22538C24.2954 7.37744 24.1447 7.52543 23.9994 7.66935C23.941 7.72773 23.8813 7.78611 23.8229 7.84449C23.7578 7.90966 23.698 7.98433 23.641 8.07258C23.5704 8.1812 23.5799 8.22057 23.6478 8.30068C23.7578 8.43237 23.899 8.53827 24.0497 8.6496L24.1135 8.69712C24.4095 8.91843 24.7136 9.13973 25.0082 9.35425C25.1508 9.45743 25.2933 9.56062 25.4345 9.66516L26.5465 10.4784C27.0271 10.8301 27.5077 11.1831 27.9897 11.5347C28.3074 11.7669 28.6265 11.999 28.9442 12.2312C29.4465 12.5978 29.9502 12.9644 30.4512 13.3323C30.5938 13.4369 30.7363 13.5428 30.8789 13.6473C31.2672 13.9338 31.6704 14.2311 32.0696 14.5149C32.094 14.5325 32.1185 14.5488 32.1429 14.5665C32.2488 14.6398 32.3574 14.7158 32.4579 14.8122C32.6113 14.9629 32.6222 15.1448 32.4864 15.3132C32.3194 15.5196 32.1415 15.7205 31.9691 15.9146C31.8877 16.007 31.8048 16.0993 31.7234 16.193C31.5428 16.4007 31.3609 16.6071 31.1803 16.8148C30.9916 17.0293 30.8042 17.2438 30.6168 17.4597C30.2489 17.8833 29.881 18.3096 29.5239 18.7264C29.2524 19.0428 28.9822 19.3605 28.7106 19.6782C28.5111 19.9117 28.3115 20.1466 28.1119 20.3801C28.0562 20.4453 28.0019 20.5091 27.9476 20.5743C27.8051 20.7453 27.6571 20.9205 27.4982 21.0861C27.3706 21.2192 27.2145 21.2762 27.0339 21.2599C26.8886 21.2463 26.7596 21.1961 26.6469 21.1527L26.2383 20.9952C25.7305 20.7997 25.2037 20.596 24.6891 20.3923C24.6131 20.3625 24.5452 20.3462 24.4814 20.3462C24.366 20.3462 24.2669 20.3964 24.1637 20.5023C24.1216 20.5458 24.0809 20.5892 24.0402 20.6327C23.9601 20.7182 23.8759 20.8078 23.7849 20.892L23.7754 20.9001C23.5717 21.0888 23.379 21.2667 23.2228 21.4785C23.1427 21.5871 23.14 21.6536 23.2133 21.765C23.2826 21.8695 23.3708 21.9741 23.4998 22.103C24.9294 23.5354 26.3618 24.9678 27.7928 26.3988L28.4065 27.0125C28.4812 27.0872 28.5694 27.1523 28.6862 27.2202C28.7568 27.2609 28.8111 27.2596 28.8817 27.2161C28.9482 27.1754 29.0107 27.1265 29.0664 27.0695C29.1492 26.9853 29.232 26.8998 29.3148 26.8156C29.4927 26.6323 29.6773 26.4422 29.8674 26.2617C30.0561 26.0811 30.0873 25.9141 29.9842 25.6453C29.7167 24.9529 29.4452 24.2455 29.179 23.5436C29.0894 23.3073 29.1397 23.0833 29.3216 22.9149C29.4153 22.8281 29.513 22.7439 29.6081 22.6638C29.6461 22.6312 29.6855 22.5986 29.7235 22.566C30.033 22.2999 30.3412 22.0338 30.6494 21.7677L31.3717 21.1445C31.6297 20.9218 31.8877 20.7005 32.1443 20.4779C32.5448 20.1317 32.9467 19.7841 33.3472 19.4365L33.8251 19.0224C34.06 18.8188 34.2949 18.6138 34.5297 18.4101L34.5732 18.3721C34.7497 18.22 34.9316 18.0612 35.1149 17.9105C35.2778 17.7761 35.4557 17.7883 35.605 17.9458C35.6661 18.0096 35.7137 18.0775 35.7598 18.1426C35.7761 18.1644 35.791 18.1874 35.8073 18.2092C35.8426 18.2567 35.8766 18.3056 35.9119 18.3544C36.0178 18.5024 36.1169 18.6436 36.2391 18.7617C36.3382 18.8581 36.4522 18.8011 36.497 18.7726C36.5907 18.7129 36.5839 18.6219 36.5622 18.5567C36.5296 18.4563 36.478 18.3558 36.4047 18.2513C36.2975 18.0965 36.1793 17.9431 36.0639 17.7951L35.9947 17.7068C35.8467 17.5154 35.8481 17.3362 35.9947 17.1407C36.0218 17.104 36.0531 17.0701 36.0857 17.0402C36.1658 16.9669 36.2472 16.8949 36.3273 16.8216C36.4156 16.7415 36.5038 16.6627 36.5921 16.5826L36.8147 16.379C37.1718 16.0545 37.5275 15.73 37.8833 15.4042C38.0652 15.2372 38.2458 15.0702 38.425 14.9018C38.5635 14.7728 38.7019 14.6438 38.8418 14.5162C38.9287 14.4361 39.0034 14.3723 39.0767 14.3153C39.1581 14.2528 39.2423 14.2297 39.3251 14.2474C39.4093 14.265 39.4772 14.3207 39.5261 14.4144C39.5736 14.5026 39.6007 14.595 39.6252 14.6764L39.7257 15.0159C39.7895 15.2304 39.8533 15.4449 39.9171 15.6594L40.285 16.8895C40.4167 17.3307 40.5498 17.772 40.6815 18.2132C40.8267 18.7006 40.972 19.1894 41.1173 19.6768L41.6821 21.5668C41.7948 21.9415 41.9061 22.3162 42.0174 22.6909C42.2347 23.42 42.4506 24.1505 42.6651 24.8795C42.7139 25.0452 42.7574 25.2108 42.794 25.3737C42.8511 25.6222 42.7438 25.8367 42.4736 26.0078C42.3474 26.0879 42.1641 26.1381 42.0025 25.9168C41.5246 25.2611 41.0467 24.6066 40.5688 23.9509L40.08 23.2815C39.3156 22.2347 38.5526 21.1893 37.7869 20.1439L37.7665 20.1167C37.6633 19.9755 37.5655 19.8411 37.4366 19.7529C37.3225 19.6741 37.2967 19.6795 37.1908 19.7488C37.1433 19.78 37.0944 19.8248 37.1324 19.9592C37.1582 20.0516 37.2221 20.1385 37.2832 20.224C37.9104 21.0861 38.539 21.9469 39.169 22.8077C39.9062 23.8151 40.6448 24.8225 41.3834 25.8286L41.7459 26.3228C41.8355 26.445 41.9265 26.5712 42.0215 26.6907C42.1627 26.8713 42.2713 26.8007 42.3121 26.7749C42.4288 26.7002 42.5429 26.6038 42.6515 26.4898L42.6841 26.4545C42.8036 26.3282 42.9285 26.1965 43.0642 26.077C43.3018 25.8679 43.3697 25.6711 43.2883 25.4145C43.1715 25.0479 43.0615 24.6745 42.9556 24.312C42.9149 24.1749 42.8755 24.0391 42.8348 23.902C42.7343 23.5626 42.6338 23.2231 42.5347 22.8837L42.3895 22.3909C42.2808 22.0229 42.4424 21.7962 42.5985 21.6699C42.7588 21.5396 42.8891 21.3794 43.0276 21.2083L43.0507 21.1798C43.2597 20.9232 43.3358 20.672 43.291 20.3896C43.2448 20.095 43.0669 19.8398 42.8049 19.6904C42.5429 19.5411 42.2333 19.5166 41.9563 19.6252C41.7581 19.7026 41.6115 19.6456 41.5192 19.4542C41.4893 19.3917 41.4771 19.332 41.4703 19.2858C41.435 19.0414 41.5966 18.8853 41.6577 18.8269C41.8667 18.6246 42.0609 18.402 42.2428 18.1902C42.403 18.0028 42.4831 17.7801 42.4804 17.5276C42.4777 17.2466 42.3664 17.009 42.1519 16.8202C41.9373 16.6315 41.6997 16.5541 41.4241 16.584C41.363 16.5908 41.2979 16.6098 41.23 16.6288C41.1675 16.6465 41.1037 16.6655 41.0331 16.6777C40.8512 16.7103 40.71 16.6369 40.634 16.4713C40.6027 16.4021 40.5742 16.3274 40.5525 16.2514C40.4792 16.0015 40.4059 15.7531 40.3325 15.5033C40.19 15.0145 40.042 14.5094 39.8926 14.0152C39.8139 13.7546 39.8723 13.5305 40.0637 13.35C40.19 13.2305 40.304 13.1232 40.4154 13.0132C40.7752 12.6589 41.0888 12.3303 41.3739 12.0113C41.9903 11.3216 42.4791 10.6522 42.8701 9.96386C43.0995 9.5579 43.3371 9.06778 43.3561 8.50161C43.3575 8.46224 43.3656 8.42694 43.3806 8.39436C43.3751 8.37263 43.3711 8.34684 43.3697 8.31833C43.367 8.11331 43.3371 7.95989 43.2842 7.82277ZM41.9238 20.2172C42.0107 20.0964 42.1627 20.023 42.3338 20.0217H42.3365C42.5076 20.0217 42.6651 20.1127 42.7587 20.2634C42.8511 20.4127 42.8619 20.5933 42.7873 20.744C42.7112 20.8974 42.6135 21.0332 42.4981 21.1459C42.4234 21.2192 42.3474 21.2355 42.2944 21.2355C42.2903 21.2355 42.2863 21.2355 42.2836 21.2355C42.2292 21.2328 42.1505 21.2124 42.0772 21.1269C42.0283 21.0698 41.9903 21.0047 41.9631 20.9341C41.9373 20.8648 41.9224 20.7997 41.9075 20.7358C41.898 20.6924 41.8885 20.6503 41.8762 20.6136C41.826 20.4684 41.8437 20.3285 41.9238 20.2172ZM41.4241 17.0728C41.6753 17.0212 41.9468 17.1841 42.0161 17.4285C42.046 17.5344 42.0337 17.6457 41.9794 17.7489C41.883 17.9335 41.7568 18.0978 41.6047 18.235C41.5477 18.2866 41.4812 18.3123 41.4146 18.3123C41.3454 18.3123 41.2761 18.2852 41.2178 18.2295C41.1132 18.1318 41.0494 18.0014 41.0209 17.8317C41.0114 17.772 41.006 17.7136 41.0005 17.6579C40.9978 17.6349 40.9965 17.6118 40.9937 17.5887V17.586C40.9571 17.1692 41.3087 17.0958 41.4241 17.0728ZM32.2094 8.75686C32.3384 8.63195 32.4823 8.53963 32.6181 8.45545C32.7756 8.35906 32.9684 8.35906 33.1218 8.4541C33.2752 8.54913 33.358 8.71477 33.3472 8.90078C33.3526 9.01075 33.3214 9.12208 33.2549 9.23206C33.1802 9.35561 33.0661 9.42485 32.9399 9.42485C32.9358 9.42485 32.9317 9.42485 32.9277 9.42485C32.7376 9.41806 32.4783 9.40856 32.2502 9.24835C32.2013 9.21305 32.0981 9.14109 32.0872 9.01347C32.0777 8.88584 32.1701 8.79488 32.2094 8.75686ZM29.342 7.8377C29.4397 7.74945 29.5483 7.67613 29.6651 7.61775C29.8375 7.53086 30.0235 7.55123 30.1756 7.6707C30.3195 7.78475 30.3888 7.95446 30.3711 8.14997C30.3684 8.18527 30.3589 8.21514 30.3521 8.23415L30.3494 8.24365C30.2869 8.45681 30.1634 8.54506 29.9285 8.54506C29.9231 8.54506 29.9176 8.54506 29.9122 8.54506H29.9041C29.8036 8.53963 29.6882 8.52334 29.5877 8.50161C29.5266 8.48804 29.4655 8.46496 29.4112 8.43509C29.361 8.40793 29.2076 8.3224 29.1885 8.15676C29.1723 7.99112 29.2999 7.87572 29.342 7.8377ZM31.9121 13.8482C31.8293 13.7871 31.7465 13.726 31.6636 13.6649C30.6236 12.9033 29.5836 12.1416 28.545 11.3799L27.1221 10.3372C26.3129 9.74391 25.5038 9.15059 24.6932 8.55728C24.6362 8.51519 24.5764 8.47718 24.5126 8.43509L24.4868 8.4188C24.3348 8.31968 24.29 8.15269 24.3742 7.99519C24.4122 7.92324 24.4597 7.83498 24.5371 7.76031C24.7041 7.60146 24.8833 7.5553 25.0869 7.6164C26.5315 8.0495 28.0006 8.48668 29.4207 8.90892L35.3036 10.6576C35.5127 10.7201 35.7218 10.7812 35.9295 10.845C35.9879 10.8627 36.144 10.9102 36.1861 11.0609C36.2269 11.2102 36.1196 11.3297 36.0789 11.3745C35.8861 11.5877 35.6906 11.8008 35.4964 12.0126L33.8672 13.7994C33.6852 13.9989 33.502 14.1972 33.3187 14.3954C33.2128 14.5108 33.096 14.5339 33.0173 14.5312C33.0132 14.5312 33.0078 14.5312 33.0037 14.5312C32.8788 14.5312 32.7878 14.4701 32.7254 14.428L32.7104 14.4185C32.4375 14.2365 32.1714 14.0383 31.9121 13.8482ZM25.4997 23.291C25.497 23.291 25.4956 23.291 25.4929 23.291C25.3639 23.291 25.2716 23.2001 25.1901 23.1186C24.7896 22.7208 24.3918 22.3216 23.994 21.9225C23.7998 21.727 23.7958 21.5491 23.9845 21.3454C24.0049 21.3237 24.0239 21.302 24.0429 21.2803C24.1135 21.2002 24.1936 21.1092 24.2981 21.0372C24.3728 20.9857 24.4841 20.9069 24.6484 20.9151L24.662 20.9164C24.8086 20.9341 24.9403 20.9857 25.0693 21.0359C25.0978 21.0468 25.1277 21.059 25.1575 21.0698C25.4685 21.1852 25.778 21.302 26.0889 21.4188L26.4541 21.5559C26.4732 21.5627 26.4922 21.5695 26.5112 21.579C26.5886 21.6129 26.6945 21.674 26.727 21.7989C26.7623 21.9388 26.6741 22.0555 26.6442 22.0949C26.374 22.4506 26.0916 22.7914 25.8025 23.1064C25.7223 23.1906 25.6327 23.2883 25.4997 23.291ZM29.399 25.3887C29.4058 25.4063 29.4139 25.4253 29.4207 25.443C29.4574 25.5339 29.5035 25.648 29.4995 25.7851C29.5076 25.91 29.4696 26.0227 29.3908 26.1042C29.3555 26.1408 29.3216 26.1802 29.2863 26.2182C29.1981 26.316 29.1071 26.4165 28.9985 26.5074C28.936 26.559 28.8668 26.5848 28.7975 26.5848C28.7269 26.5848 28.655 26.5577 28.5898 26.5033C28.4486 26.3852 28.321 26.2535 28.1974 26.1286C28.1418 26.0716 28.0861 26.0146 28.0304 25.9589C27.858 25.7892 27.6869 25.6181 27.5159 25.4471L27.2946 25.2257C27.2728 25.204 27.2511 25.1823 27.2307 25.1606C27.2009 25.1266 27.1113 25.0235 27.1208 24.8863C27.1316 24.7492 27.2362 24.6609 27.2701 24.6324C27.3326 24.5795 27.3977 24.5279 27.4616 24.4763C27.5227 24.4274 27.5838 24.3785 27.6435 24.327C27.7888 24.2061 27.9327 24.0839 28.0766 23.9617L28.2775 23.7907C28.2925 23.7784 28.3074 23.7649 28.3223 23.754C28.359 23.7255 28.469 23.64 28.6034 23.6753C28.6916 23.6983 28.7595 23.7635 28.8057 23.8721C28.8817 24.0473 28.9482 24.2197 29.0216 24.4125C29.1505 24.7343 29.2754 25.0615 29.399 25.3887ZM42.7262 9.31216C42.5198 9.75884 42.2469 10.2069 41.8654 10.7228C41.435 11.3039 41.0508 11.7574 40.6557 12.147L40.524 12.276C40.1099 12.686 39.6808 13.1083 39.2477 13.5142C39.0943 13.6582 38.9423 13.8034 38.7902 13.9487C38.6857 14.0492 38.5825 14.1483 38.4766 14.2488C37.9511 14.747 37.4176 15.2412 36.8908 15.7178L36.5663 16.0124C36.2622 16.288 35.9472 16.5745 35.6349 16.8528C35.0769 17.3484 34.5216 17.8372 34.0029 18.2906C33.5834 18.6586 33.149 19.036 32.6751 19.4447C32.3194 19.7515 31.9623 20.057 31.6053 20.3611L31.3717 20.5607C30.8952 20.968 30.4173 21.3753 29.9394 21.7826C29.733 21.9578 29.5266 22.1316 29.3202 22.3067C29.1614 22.4398 29.0039 22.5742 28.8451 22.7086C28.3074 23.1648 27.7698 23.6196 27.2321 24.0771C27.1601 24.1382 27.0882 24.202 27.0176 24.2659L26.9293 24.3446C26.8479 24.4166 26.7664 24.4532 26.6822 24.4532C26.6116 24.4532 26.5397 24.4274 26.4664 24.3758C26.3034 24.2618 26.1202 24.1138 25.9993 23.8884C25.9056 23.7133 25.9844 23.5843 26.0414 23.5232C26.2491 23.2951 26.4514 23.0534 26.6469 22.8186C26.7338 22.7154 26.8207 22.6108 26.9076 22.5076C27.1018 22.2782 27.2959 22.0487 27.4887 21.8179C27.6489 21.6278 27.8091 21.4364 27.9693 21.2463C28.4988 20.6204 29.0283 19.9959 29.5592 19.3727L29.5972 19.3279C30.0276 18.8228 30.4716 18.3001 30.9128 17.7896C31.3595 17.2737 31.8415 16.7198 32.4307 16.0504C32.8978 15.5182 33.4802 14.8556 34.0478 14.2297C34.4578 13.7776 34.8977 13.2984 35.3932 12.7607C35.5494 12.5924 35.7096 12.4254 35.8657 12.2638C36.0585 12.0642 36.2567 11.8578 36.4455 11.6501C36.7591 11.3025 37.0904 10.9672 37.4121 10.6413C37.5778 10.473 37.7434 10.306 37.9077 10.1363C38.463 9.56062 38.9871 9.08271 39.5084 8.67812C40.0447 8.2613 40.5796 7.93817 41.1417 7.69107C41.4459 7.55666 41.7296 7.48741 42.0093 7.47927H42.0107C42.1152 7.47655 42.2211 7.49013 42.3229 7.51864C42.7194 7.62997 42.9461 7.9436 42.9434 8.38214C42.942 8.68762 42.8687 9.00261 42.7262 9.31216Z", fill: "#141A22" })
] }), Dj = () => /* @__PURE__ */ f.jsxs("svg", { viewBox: "0 0 48 48", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ f.jsx("path", { d: "M38.258 35.2232L38.106 35.0699C35.7244 32.6833 33.2605 30.2156 30.8257 27.8023C30.4533 27.4337 30.4089 27.0853 30.6775 26.6356C32.4649 23.6422 32.8387 20.4334 31.7885 17.1005C30.2607 12.26 25.6382 8.93597 20.5495 9.01198L20.5368 9.01324L20.5241 9.01198C19.5006 8.94864 18.3212 9.13739 17.1165 9.55796C13.1704 10.9362 10.6001 13.6155 9.47771 17.5223C8.49721 20.9325 9.02799 24.1894 11.0523 27.2044C14.4993 32.3349 21.359 33.8449 26.6694 30.6425C26.8607 30.5272 27.0329 30.4689 27.1976 30.4689C27.4193 30.4689 27.6233 30.5741 27.8361 30.7882C30.0365 33.0076 32.2851 35.2523 34.4589 37.4224L35.2012 38.1634C35.3773 38.3395 35.542 38.4827 35.7029 38.6018C36.5972 39.2618 37.8843 39.0831 38.5709 38.2014C39.2904 37.2792 39.1701 36.1378 38.258 35.2232ZM20.7243 31.6838H20.7129C17.6891 31.6293 14.8945 30.4626 12.8423 28.399C10.799 26.343 9.67786 23.5877 9.68419 20.6411C9.69179 17.654 10.8332 14.8772 12.9006 12.8225C14.9591 10.7754 17.7144 9.64917 20.6622 9.64917H20.7015C23.6949 9.65931 26.4743 10.8032 28.5278 12.8719C30.585 14.9456 31.7112 17.7288 31.6973 20.707C31.6846 23.6739 30.5331 26.4342 28.4568 28.4801C26.4084 30.4955 23.6633 31.6344 20.7243 31.6838ZM29.9377 31.7345C29.716 31.7345 29.5425 31.5964 29.436 31.4836C29.0611 31.0821 28.657 30.6906 28.301 30.3448C28.2453 30.2903 28.073 30.1231 28.0818 29.8862C28.0907 29.6481 28.2706 29.4973 28.3301 29.4479C28.7418 29.1033 29.1333 28.7119 29.4943 28.2837C29.5425 28.2254 29.6894 28.0532 29.9212 28.0443C30.1505 28.0367 30.3101 28.1963 30.3608 28.2482C30.637 28.5295 30.922 28.8145 31.1969 29.0881C31.3185 29.2097 31.4414 29.3314 31.563 29.4517C31.6441 29.5328 31.7885 29.6772 31.7923 29.9293L31.7948 30.0319L31.7378 30.1168C31.7264 30.1332 31.7163 30.151 31.7049 30.1687C31.6694 30.2244 31.6263 30.2941 31.5693 30.3613C31.1868 30.8034 30.7776 31.1923 30.4267 31.5128C30.2468 31.6749 30.0821 31.7345 29.9377 31.7345ZM38.3961 36.9309C38.3302 37.5199 38.0667 37.9392 37.6119 38.1761C37.3852 38.2952 37.1546 38.3535 36.9253 38.3535C36.6365 38.3535 36.3515 38.2597 36.0766 38.0748C35.9499 37.9886 35.8448 37.8835 35.7523 37.791L35.7333 37.772C35.281 37.321 34.8301 36.8688 34.3791 36.4165C33.2567 35.2929 32.0963 34.1312 30.9461 32.9975C30.7978 32.8505 30.6294 32.6504 30.6458 32.3894C30.6623 32.1322 30.8523 31.9612 30.9929 31.8535C31.3134 31.6116 31.6162 31.3076 31.9456 30.8984C32.0444 30.7742 32.204 30.6083 32.4409 30.5956C32.6803 30.5829 32.8564 30.7324 32.9679 30.8464C34.5045 32.397 36.0766 33.9653 37.5967 35.4816L37.8868 35.7705C38.1858 36.0694 38.353 36.4254 38.3973 36.8612L38.4011 36.8954L38.3961 36.9309Z", fill: "#141A22" }),
  /* @__PURE__ */ f.jsx("path", { d: "M20.6939 11.3986H20.6914C15.5887 11.3986 11.4362 15.5474 11.4349 20.6488C11.4336 25.7527 15.5836 29.9065 20.685 29.9077H20.6876C25.7902 29.9077 29.9428 25.759 29.944 20.6576C29.944 15.5537 25.794 11.3999 20.6939 11.3986ZM26.7023 26.8687C25.115 28.4015 22.9564 29.2718 20.7572 29.2718C20.7066 29.2718 20.6546 29.2705 20.6039 29.2705C18.1578 29.2249 15.9345 28.2508 14.3447 26.5254C12.8575 24.914 12.029 22.7377 12.0683 20.5575C12.1126 18.1329 13.0893 15.9185 14.821 14.3224C16.5388 12.7389 18.8342 11.9142 21.1221 12.0561C23.3491 12.1511 25.4241 13.0949 26.9633 14.7164C28.5125 16.3467 29.3448 18.4813 29.3081 20.7273C29.2676 23.1051 28.3428 25.2865 26.7023 26.8687Z", fill: "#141A22" }),
  /* @__PURE__ */ f.jsx("path", { d: "M26.9304 18.594C26.848 18.6282 26.6555 18.7105 26.4604 18.271C25.6813 16.5165 24.3753 15.3193 22.5751 14.7138C22.0963 14.5529 21.6073 14.4947 21.1361 14.4376C21.036 14.4262 20.9372 14.4136 20.8358 14.4009C20.6129 14.3718 20.3507 14.2907 20.3735 14.0639C20.3811 13.9816 20.4013 13.789 20.8662 13.7878H21.1006C23.5772 13.8397 26.1298 15.65 27.0393 17.9986C27.2243 18.4711 27.0026 18.5636 26.9304 18.594Z", fill: "#141A22" }),
  /* @__PURE__ */ f.jsx("path", { d: "M27.5497 20.6475C27.5522 20.8147 27.4154 20.9655 27.2596 20.968C27.1899 20.9693 27.1177 20.9389 27.0607 20.8831C26.9987 20.8223 26.9619 20.7413 26.9606 20.6577C26.9581 20.4904 27.0949 20.3397 27.2507 20.3372H27.2558C27.3242 20.3372 27.3926 20.3663 27.4496 20.4208C27.513 20.4816 27.5484 20.5639 27.5497 20.6475Z", fill: "#141A22" })
] }), Mj = () => /* @__PURE__ */ f.jsxs("svg", { viewBox: "0 0 48 48", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ f.jsx("path", { d: "M25.0696 24.2991V19.5497C25.5154 19.5625 25.9797 19.6396 26.4628 19.7819C26.9906 19.9374 27.4714 20.1757 27.9055 20.4967L27.9972 20.5645L28.0524 20.4648L28.2902 20.0361L28.3326 19.9597L28.2624 19.9075C27.8397 19.5926 27.3273 19.3446 26.7272 19.162C26.184 18.984 25.6314 18.8877 25.0696 18.8734V17.1298V17.0298H24.9696H24.5576H24.4576V17.1298V18.8851C23.7762 18.9263 23.1971 19.0616 22.7233 19.2942C22.1499 19.5653 21.7214 19.9264 21.4451 20.3802C21.1717 20.8295 21.0343 21.3131 21.0343 21.8294C21.0343 22.425 21.1587 22.922 21.4152 23.3131L21.4152 23.3132L21.4171 23.3159C21.6805 23.6897 22.0259 23.9859 22.4516 24.2046L22.4516 24.2046L22.4543 24.2059C22.8827 24.4098 23.3478 24.5811 23.8494 24.72L23.8494 24.7201L23.8518 24.7207C24.0554 24.7717 24.2574 24.8218 24.4576 24.8711V29.6283C23.8239 29.5963 23.226 29.4637 22.6632 29.2312C22.0177 28.9495 21.5241 28.613 21.1772 28.2246L21.0958 28.1335L21.0226 28.2313L20.7373 28.6123L20.6893 28.6764L20.7414 28.7373C21.1348 29.1971 21.699 29.5756 22.4275 29.8761L22.4291 29.8767C23.0732 30.1293 23.7496 30.2719 24.4576 30.3049V32.054V32.154L26.9665 29.8154M25.0696 24.2991C25.3566 24.3716 25.6435 24.4476 25.9305 24.5271C26.433 24.6557 26.8939 24.8274 27.3129 25.0426C27.7487 25.261 28.0947 25.5572 28.348 25.9317C28.6168 26.3027 28.7465 26.7852 28.7465 27.3704C28.7465 27.8871 28.6035 28.3711 28.3194 28.8203C28.0424 29.2749 27.6025 29.6357 27.0083 29.9063M25.0696 24.2991V24.4023C25.0363 24.3938 25.003 24.3854 24.9696 24.3771M27.0083 29.9063C27.0082 29.9063 27.0081 29.9064 27.008 29.9064L26.9665 29.8154M27.0083 29.9063C27.0084 29.9062 27.0085 29.9062 27.0086 29.9061L26.9665 29.8154M27.0083 29.9063C26.485 30.1489 25.8376 30.2813 25.0696 30.3075V30.2074C25.8271 30.1813 26.4594 30.0506 26.9665 29.8154", fill: "#141A22", stroke: "black", strokeWidth: "0.2" }),
  /* @__PURE__ */ f.jsx("path", { d: "M24.1203 35.824C30.1895 35.824 35.1076 30.849 35.1076 24.7143C35.1076 18.5797 30.1895 13.6047 24.1203 13.6047C18.0511 13.6047 13.1329 18.5797 13.1329 24.7143C13.1329 30.849 18.0511 35.824 24.1203 35.824ZM34.57 24.7143C34.57 30.5521 29.8905 35.2826 24.1203 35.2826C18.3501 35.2826 13.6705 30.5521 13.6705 24.7143C13.6705 18.8766 18.3501 14.146 24.1203 14.146C29.8905 14.146 34.57 18.8766 34.57 24.7143Z", fill: "#141A22", stroke: "black", strokeWidth: "0.2" }),
  /* @__PURE__ */ f.jsxs("mask", { id: "path-3-outside-1_961_14670", maskUnits: "userSpaceOnUse", x: "-0.449754", y: "-0.0832603", width: "49.4975", height: "49.4975", fill: "black", children: [
    /* @__PURE__ */ f.jsx("rect", { fill: "white", x: "-0.449754", y: "-0.0832603", width: "49.4975", height: "49.4975" }),
    /* @__PURE__ */ f.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.6082 12.5084C14.9227 10.2135 17.8619 8.65017 21.0597 8.01409C24.2805 7.37343 27.619 7.70224 30.653 8.95895C33.687 10.2157 36.2801 12.3438 38.1046 15.0743C39.9291 17.8048 40.9029 21.015 40.9029 24.299C40.9029 27.5829 39.9291 30.7931 38.1046 33.5236C36.2801 36.2541 33.687 38.3823 30.653 39.639C27.619 40.8957 24.2805 41.2245 21.0597 40.5839C17.8619 39.9478 14.9227 38.3844 12.6082 36.0895C12.5998 36.0812 12.5914 36.0729 12.5831 36.0645C12.583 36.0645 12.583 36.0645 12.583 36.0644C12.5692 36.0509 12.5471 36.0509 12.5334 36.0645C12.5197 36.0782 12.5197 36.1005 12.5334 36.1141C12.5335 36.1142 12.5335 36.1142 12.5335 36.1142C12.5419 36.1226 12.5504 36.131 12.5588 36.1393C14.8831 38.444 17.8347 40.0139 21.046 40.6527C24.2805 41.2961 27.6331 40.9659 30.6799 39.7038C33.7266 38.4418 36.3308 36.3046 38.163 33.5626C39.9951 30.8206 40.973 27.5968 40.973 24.299C40.973 21.0012 39.9951 17.7774 38.163 15.0353C36.3308 12.2933 33.7266 10.1561 30.6799 8.89412C27.6331 7.6321 24.2805 7.3019 21.046 7.94527C17.8347 8.58404 14.8831 10.154 12.5588 12.4586C12.5504 12.467 12.5419 12.4753 12.5335 12.4837C12.5335 12.4837 12.5335 12.4838 12.5334 12.4838C12.5197 12.4975 12.5197 12.5197 12.5334 12.5334C12.5471 12.5471 12.5692 12.5471 12.583 12.5335C12.583 12.5335 12.583 12.5335 12.5831 12.5334C12.5914 12.5251 12.5998 12.5168 12.6082 12.5084ZM12.5935 36.0539C12.5935 36.0539 12.5935 36.0539 12.5936 36.054C12.5935 36.0539 12.5935 36.0539 12.5935 36.0539ZM12.5936 12.544C12.5935 12.544 12.5935 12.5441 12.5935 12.5441L12.5936 12.544ZM12.4734 12.4235C14.8134 10.0933 17.79 8.5062 21.0294 7.86183C24.2804 7.21518 27.6501 7.54706 30.7124 8.81553C33.7747 10.084 36.3922 12.2321 38.2337 14.9881C40.0752 17.7441 41.0581 20.9843 41.0581 24.299C41.0581 27.6136 40.0752 30.8538 38.2337 33.6099C36.3922 36.3659 33.7747 38.514 30.7124 39.7824C27.6501 41.0509 24.2804 41.3828 21.0294 40.7361C17.79 40.0918 14.8134 38.5046 12.4734 36.1744C12.4263 36.1275 12.4263 36.0513 12.4732 36.0044C12.5202 35.9574 12.5962 35.9576 12.6431 36.0042C14.9495 38.301 17.8834 39.8653 21.0763 40.5004C24.2806 41.1378 27.602 40.8107 30.6204 39.5604C33.6389 38.3101 36.2188 36.1929 38.0339 33.4764C39.849 30.7598 40.8178 27.5661 40.8178 24.299C40.8178 21.0319 39.849 17.8381 38.0339 15.1216C36.2188 12.4051 33.6389 10.2878 30.6204 9.03755C27.602 7.78728 24.2806 7.46015 21.0763 8.09753C17.8834 8.73264 14.9495 10.297 12.6431 12.5937C12.5962 12.6404 12.5202 12.6406 12.4732 12.5936C12.4263 12.5466 12.4263 12.4704 12.4734 12.4235Z" })
  ] }),
  /* @__PURE__ */ f.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.6082 12.5084C14.9227 10.2135 17.8619 8.65017 21.0597 8.01409C24.2805 7.37343 27.619 7.70224 30.653 8.95895C33.687 10.2157 36.2801 12.3438 38.1046 15.0743C39.9291 17.8048 40.9029 21.015 40.9029 24.299C40.9029 27.5829 39.9291 30.7931 38.1046 33.5236C36.2801 36.2541 33.687 38.3823 30.653 39.639C27.619 40.8957 24.2805 41.2245 21.0597 40.5839C17.8619 39.9478 14.9227 38.3844 12.6082 36.0895C12.5998 36.0812 12.5914 36.0729 12.5831 36.0645C12.583 36.0645 12.583 36.0645 12.583 36.0644C12.5692 36.0509 12.5471 36.0509 12.5334 36.0645C12.5197 36.0782 12.5197 36.1005 12.5334 36.1141C12.5335 36.1142 12.5335 36.1142 12.5335 36.1142C12.5419 36.1226 12.5504 36.131 12.5588 36.1393C14.8831 38.444 17.8347 40.0139 21.046 40.6527C24.2805 41.2961 27.6331 40.9659 30.6799 39.7038C33.7266 38.4418 36.3308 36.3046 38.163 33.5626C39.9951 30.8206 40.973 27.5968 40.973 24.299C40.973 21.0012 39.9951 17.7774 38.163 15.0353C36.3308 12.2933 33.7266 10.1561 30.6799 8.89412C27.6331 7.6321 24.2805 7.3019 21.046 7.94527C17.8347 8.58404 14.8831 10.154 12.5588 12.4586C12.5504 12.467 12.5419 12.4753 12.5335 12.4837C12.5335 12.4837 12.5335 12.4838 12.5334 12.4838C12.5197 12.4975 12.5197 12.5197 12.5334 12.5334C12.5471 12.5471 12.5692 12.5471 12.583 12.5335C12.583 12.5335 12.583 12.5335 12.5831 12.5334C12.5914 12.5251 12.5998 12.5168 12.6082 12.5084ZM12.5935 36.0539C12.5935 36.0539 12.5935 36.0539 12.5936 36.054C12.5935 36.0539 12.5935 36.0539 12.5935 36.0539ZM12.5936 12.544C12.5935 12.544 12.5935 12.5441 12.5935 12.5441L12.5936 12.544ZM12.4734 12.4235C14.8134 10.0933 17.79 8.5062 21.0294 7.86183C24.2804 7.21518 27.6501 7.54706 30.7124 8.81553C33.7747 10.084 36.3922 12.2321 38.2337 14.9881C40.0752 17.7441 41.0581 20.9843 41.0581 24.299C41.0581 27.6136 40.0752 30.8538 38.2337 33.6099C36.3922 36.3659 33.7747 38.514 30.7124 39.7824C27.6501 41.0509 24.2804 41.3828 21.0294 40.7361C17.79 40.0918 14.8134 38.5046 12.4734 36.1744C12.4263 36.1275 12.4263 36.0513 12.4732 36.0044C12.5202 35.9574 12.5962 35.9576 12.6431 36.0042C14.9495 38.301 17.8834 39.8653 21.0763 40.5004C24.2806 41.1378 27.602 40.8107 30.6204 39.5604C33.6389 38.3101 36.2188 36.1929 38.0339 33.4764C39.849 30.7598 40.8178 27.5661 40.8178 24.299C40.8178 21.0319 39.849 17.8381 38.0339 15.1216C36.2188 12.4051 33.6389 10.2878 30.6204 9.03755C27.602 7.78728 24.2806 7.46015 21.0763 8.09753C17.8834 8.73264 14.9495 10.297 12.6431 12.5937C12.5962 12.6404 12.5202 12.6406 12.4732 12.5936C12.4263 12.5466 12.4263 12.4704 12.4734 12.4235Z", fill: "#141A22" }),
  /* @__PURE__ */ f.jsx("path", { d: "M12.6642 12.6148L12.6643 12.6147L12.5229 12.4733L12.5228 12.4734L12.6642 12.6148ZM21.0597 8.01409L21.0987 8.21025L21.0597 8.01409ZM12.6082 12.5084L12.4674 12.3664L12.4674 12.3664L12.6082 12.5084ZM30.653 8.95895L30.7295 8.77418L30.653 8.95895ZM38.1046 15.0743L37.9383 15.1854L38.1046 15.0743ZM40.9029 24.299L41.1029 24.299L40.9029 24.299ZM38.1046 33.5236L38.2709 33.6347L38.2709 33.6347L38.1046 33.5236ZM30.653 39.639L30.5765 39.4542L30.653 39.639ZM21.0597 40.5839L21.0987 40.3877L21.0597 40.5839ZM12.6082 36.0895L12.749 35.9475L12.6082 36.0895ZM12.5831 36.0645L12.7242 35.9228L12.7242 35.9228L12.5831 36.0645ZM12.583 36.0644L12.4424 36.2067L12.4424 36.2067L12.583 36.0644ZM12.5334 36.1141L12.3923 36.2559L12.3923 36.2559L12.5334 36.1141ZM12.5335 36.1142L12.6747 35.9725L12.6747 35.9725L12.5335 36.1142ZM12.5588 36.1393L12.418 36.2814L12.5588 36.1393ZM21.046 40.6527L21.085 40.4565L21.046 40.6527ZM30.6799 39.7038L30.6033 39.5191L30.6799 39.7038ZM38.163 33.5626L38.3293 33.6737L38.3293 33.6737L38.163 33.5626ZM40.973 24.299L40.773 24.299L40.973 24.299ZM30.6799 8.89412L30.6033 9.0789L30.6799 8.89412ZM21.046 7.94527L21.007 7.74911L21.046 7.94527ZM12.5588 12.4586L12.418 12.3166L12.418 12.3166L12.5588 12.4586ZM12.5335 12.4837L12.3924 12.342L12.3921 12.3423L12.5335 12.4837ZM12.5334 12.4838L12.6746 12.6255L12.6749 12.6252L12.5334 12.4838ZM12.583 12.5335L12.7235 12.6758L12.7244 12.675L12.583 12.5335ZM12.5831 12.5334L12.4419 12.3917L12.4416 12.392L12.5831 12.5334ZM12.5936 36.054L12.4524 36.1957L12.7351 35.9127L12.5936 36.054ZM21.0294 7.86183L21.0684 8.05799L21.0294 7.86183ZM12.4734 12.4235L12.6145 12.5653L12.4734 12.4235ZM30.7124 8.81553L30.7889 8.63075L30.7124 8.81553ZM38.2337 14.9881L38.4 14.877L38.2337 14.9881ZM41.0581 24.299L41.2581 24.299L41.0581 24.299ZM38.2337 33.6099L38.0674 33.4988L38.2337 33.6099ZM30.7124 39.7824L30.7889 39.9672L30.7124 39.7824ZM21.0294 40.7361L20.9904 40.9323L21.0294 40.7361ZM12.4734 36.1744L12.6145 36.0327L12.4734 36.1744ZM12.6431 36.0042L12.502 36.146L12.6431 36.0042ZM21.0763 40.5004L21.0373 40.6966L21.0763 40.5004ZM30.6204 39.5604L30.697 39.7452L30.6204 39.5604ZM38.0339 33.4764L38.2002 33.5875L38.0339 33.4764ZM40.8178 24.299L41.0178 24.299L40.8178 24.299ZM38.0339 15.1216L38.2002 15.0105L38.0339 15.1216ZM30.6204 9.03755L30.697 8.85277L30.697 8.85277L30.6204 9.03755ZM21.0763 8.09753L21.1153 8.29369L21.0763 8.09753ZM12.6431 12.5937L12.7842 12.7354L12.6431 12.5937ZM21.0207 7.81794C17.7844 8.46168 14.8098 10.0439 12.4674 12.3664L12.749 12.6505C15.0356 10.3832 17.9394 8.83867 21.0987 8.21025L21.0207 7.81794ZM30.7295 8.77418C27.659 7.50233 24.2803 7.16956 21.0207 7.81794L21.0987 8.21025C24.2808 7.5773 27.579 7.90216 30.5765 9.14373L30.7295 8.77418ZM38.2709 14.9632C36.4245 12.1998 33.8001 10.046 30.7295 8.77418L30.5765 9.14373C33.5739 10.3853 36.1358 12.4878 37.9383 15.1854L38.2709 14.9632ZM41.1029 24.299C41.1029 20.9755 40.1173 17.7266 38.2709 14.9632L37.9383 15.1854C39.7408 17.8831 40.7029 21.0546 40.7029 24.299L41.1029 24.299ZM38.2709 33.6347C40.1173 30.8713 41.1029 27.6225 41.1029 24.299L40.7029 24.299C40.7029 27.5434 39.7408 30.7149 37.9383 33.4125L38.2709 33.6347ZM30.7295 39.8238C33.8001 38.5519 36.4245 36.3981 38.2709 33.6347L37.9383 33.4125C36.1358 36.1101 33.5739 38.2127 30.5765 39.4542L30.7295 39.8238ZM21.0207 40.78C24.2803 41.4284 27.659 41.0956 30.7295 39.8238L30.5765 39.4542C27.579 40.6958 24.2808 41.0207 21.0987 40.3877L21.0207 40.78ZM12.4674 36.2315C14.8098 38.5541 17.7844 40.1363 21.0207 40.78L21.0987 40.3877C17.9394 39.7593 15.0356 38.2148 12.749 35.9475L12.4674 36.2315ZM12.4419 36.2062C12.4504 36.2147 12.4589 36.2231 12.4674 36.2315L12.749 35.9475C12.7407 35.9393 12.7325 35.931 12.7242 35.9228L12.4419 36.2062ZM12.4424 36.2067L12.4419 36.2063L12.7242 35.9228C12.724 35.9226 12.7237 35.9224 12.7235 35.9221L12.4424 36.2067ZM12.6748 36.206C12.6104 36.2704 12.5066 36.2701 12.4424 36.2067L12.7235 35.9221C12.6318 35.8316 12.4837 35.8313 12.392 35.9231L12.6748 36.206ZM12.6746 35.9724C12.7393 36.0369 12.7393 36.1415 12.6748 36.206L12.392 35.9231C12.3001 36.015 12.3001 36.1641 12.3923 36.2559L12.6746 35.9724ZM12.6747 35.9725C12.6746 35.9725 12.6746 35.9725 12.6746 35.9724L12.3923 36.2559C12.3923 36.2559 12.3924 36.2559 12.3924 36.256L12.6747 35.9725ZM12.6996 35.9973C12.6913 35.9891 12.683 35.9808 12.6747 35.9725L12.3924 36.256C12.4009 36.2644 12.4094 36.2729 12.418 36.2814L12.6996 35.9973ZM21.085 40.4565C17.9122 39.8254 14.996 38.2743 12.6996 35.9973L12.418 36.2814C14.7701 38.6136 17.7572 40.2024 21.007 40.8488L21.085 40.4565ZM30.6033 39.5191C27.5931 40.7659 24.2807 41.0922 21.085 40.4565L21.007 40.8488C24.2802 41.4999 27.6731 41.1658 30.7564 39.8886L30.6033 39.5191ZM37.9967 33.4515C36.1865 36.1606 33.6136 38.2722 30.6033 39.5191L30.7564 39.8886C33.8397 38.6114 36.4751 36.4487 38.3293 33.6737L37.9967 33.4515ZM40.773 24.299C40.773 27.5572 39.8069 30.7423 37.9967 33.4515L38.3293 33.6737C40.1834 30.8988 41.173 27.6364 41.173 24.299L40.773 24.299ZM37.9967 15.1465C39.8069 17.8556 40.773 21.0407 40.773 24.299L41.173 24.299C41.173 20.9616 40.1834 17.6992 38.3292 14.9242L37.9967 15.1465ZM30.6033 9.0789C33.6136 10.3258 36.1865 12.4373 37.9967 15.1465L38.3292 14.9242C36.4751 12.1493 33.8397 9.98651 30.7564 8.70935L30.6033 9.0789ZM21.085 8.14143C24.2807 7.50577 27.5931 7.83201 30.6033 9.0789L30.7564 8.70935C27.6731 7.43219 24.2802 7.09802 21.007 7.74911L21.085 8.14143ZM12.6996 12.6006C14.996 10.3237 17.9122 8.77253 21.085 8.14143L21.007 7.74911C17.7572 8.39554 14.7701 9.98434 12.418 12.3166L12.6996 12.6006ZM12.6747 12.6254C12.683 12.6172 12.6913 12.6089 12.6996 12.6006L12.418 12.3166C12.4094 12.3251 12.4009 12.3335 12.3924 12.342L12.6747 12.6254ZM12.6749 12.6252C12.6749 12.6252 12.6749 12.6252 12.6749 12.6252C12.6749 12.6252 12.6749 12.6252 12.6749 12.6252C12.6749 12.6252 12.6749 12.6252 12.6749 12.6252C12.6749 12.6252 12.6749 12.6252 12.6749 12.6252L12.6749 12.6252C12.6749 12.6252 12.6749 12.6252 12.6749 12.6252C12.6749 12.6252 12.6749 12.6252 12.6749 12.6252C12.6749 12.6252 12.6749 12.6252 12.6749 12.6252C12.6749 12.6252 12.6749 12.6252 12.6749 12.6252L12.6749 12.6252C12.6749 12.6252 12.6749 12.6252 12.6749 12.6252C12.6749 12.6252 12.6749 12.6252 12.6749 12.6252C12.6749 12.6252 12.6749 12.6252 12.6749 12.6252C12.6749 12.6252 12.6749 12.6252 12.6749 12.6252L12.6749 12.6252C12.6749 12.6252 12.6749 12.6252 12.6749 12.6252C12.6749 12.6252 12.6749 12.6252 12.6749 12.6252C12.6749 12.6252 12.6749 12.6252 12.6749 12.6252C12.6749 12.6252 12.6749 12.6252 12.6749 12.6252L12.6749 12.6252C12.6749 12.6252 12.6749 12.6252 12.6749 12.6252C12.6749 12.6252 12.6749 12.6252 12.6749 12.6252C12.6749 12.6252 12.6749 12.6252 12.6749 12.6252C12.6749 12.6252 12.6749 12.6252 12.6749 12.6252L12.6749 12.6252C12.6749 12.6252 12.6749 12.6252 12.6749 12.6252C12.6749 12.6252 12.6749 12.6252 12.6749 12.6252C12.6749 12.6252 12.6749 12.6252 12.6749 12.6252C12.6749 12.6252 12.6749 12.6252 12.6749 12.6252L12.6749 12.6252C12.6749 12.6252 12.6749 12.6252 12.6749 12.6252C12.6749 12.6252 12.6749 12.6252 12.6749 12.6252C12.6749 12.6252 12.6749 12.6252 12.6749 12.6252C12.6749 12.6252 12.6749 12.6252 12.6749 12.6252L12.6749 12.6252C12.6749 12.6252 12.6749 12.6252 12.6749 12.6252C12.6749 12.6252 12.6749 12.6252 12.6749 12.6252C12.6749 12.6252 12.6749 12.6252 12.6749 12.6252C12.6749 12.6252 12.6749 12.6252 12.6749 12.6252L12.6749 12.6252C12.6749 12.6252 12.6749 12.6252 12.6749 12.6252C12.6749 12.6252 12.6749 12.6252 12.6749 12.6252C12.6749 12.6252 12.6749 12.6252 12.6749 12.6252C12.6749 12.6252 12.6749 12.6252 12.6749 12.6252L12.6749 12.6252C12.6749 12.6252 12.6749 12.6252 12.6749 12.6252C12.6749 12.6252 12.6749 12.6252 12.6749 12.6252C12.6749 12.6252 12.6749 12.6252 12.6749 12.6252C12.6749 12.6252 12.6749 12.6252 12.6749 12.6252L12.6749 12.6252C12.6749 12.6252 12.6749 12.6252 12.6749 12.6252C12.6749 12.6252 12.6749 12.6252 12.6749 12.6252C12.6749 12.6252 12.6749 12.6252 12.6749 12.6252C12.6749 12.6252 12.6749 12.6252 12.6749 12.6252L12.6749 12.6252C12.6749 12.6252 12.6749 12.6252 12.6749 12.6252C12.6749 12.6252 12.6749 12.6252 12.6749 12.6252C12.6749 12.6252 12.6749 12.6252 12.6749 12.6252C12.6749 12.6252 12.6749 12.6252 12.6749 12.6252L12.6749 12.6252C12.6749 12.6252 12.6749 12.6252 12.6749 12.6252C12.6749 12.6252 12.6749 12.6252 12.6749 12.6252C12.6749 12.6251 12.6749 12.6251 12.6749 12.6251C12.6749 12.6251 12.6749 12.6251 12.6749 12.6251L12.6749 12.6251C12.6749 12.6251 12.6749 12.6251 12.6749 12.6251C12.6749 12.6251 12.6749 12.6251 12.6749 12.6251C12.6749 12.6251 12.6749 12.6251 12.6749 12.6251C12.6749 12.6251 12.6749 12.6251 12.675 12.6251L12.675 12.6251C12.675 12.6251 12.675 12.6251 12.675 12.6251C12.675 12.6251 12.675 12.6251 12.675 12.6251C12.675 12.6251 12.675 12.6251 12.675 12.6251C12.675 12.6251 12.675 12.6251 12.675 12.6251L12.675 12.6251C12.675 12.6251 12.675 12.6251 12.675 12.6251L12.675 12.6251L12.3921 12.3423L12.3921 12.3423C12.3921 12.3423 12.3921 12.3423 12.3921 12.3423L12.3921 12.3423C12.3921 12.3423 12.3921 12.3423 12.3921 12.3423C12.3921 12.3423 12.3921 12.3423 12.3921 12.3423C12.3921 12.3423 12.3921 12.3423 12.3921 12.3423C12.3921 12.3423 12.3921 12.3423 12.3921 12.3423L12.3921 12.3423C12.3921 12.3423 12.3921 12.3423 12.3921 12.3423C12.3921 12.3423 12.3921 12.3423 12.3921 12.3423C12.3921 12.3423 12.3921 12.3423 12.3921 12.3423C12.3921 12.3423 12.3921 12.3423 12.3921 12.3423L12.3921 12.3423C12.3921 12.3423 12.3921 12.3423 12.3921 12.3423C12.3921 12.3423 12.3921 12.3423 12.3921 12.3423C12.3921 12.3423 12.3921 12.3423 12.3921 12.3423C12.3921 12.3423 12.3921 12.3423 12.3921 12.3423L12.3921 12.3423C12.3921 12.3423 12.3921 12.3423 12.3921 12.3423C12.3921 12.3423 12.3921 12.3423 12.3921 12.3423C12.3921 12.3423 12.3921 12.3423 12.3921 12.3423C12.3921 12.3423 12.3921 12.3423 12.3921 12.3423L12.3921 12.3423C12.3921 12.3423 12.3921 12.3423 12.3921 12.3423C12.3921 12.3423 12.3921 12.3423 12.3921 12.3423C12.3921 12.3423 12.3921 12.3423 12.3921 12.3423C12.3921 12.3423 12.3921 12.3423 12.3921 12.3423L12.3921 12.3423C12.3921 12.3423 12.3921 12.3423 12.3921 12.3423C12.3921 12.3423 12.3921 12.3423 12.3921 12.3423C12.3921 12.3423 12.3921 12.3423 12.3921 12.3423C12.3921 12.3423 12.3921 12.3423 12.3921 12.3423L12.3921 12.3423C12.3921 12.3423 12.3921 12.3423 12.3921 12.3423C12.3921 12.3423 12.3921 12.3423 12.3921 12.3423C12.3921 12.3423 12.3921 12.3423 12.3921 12.3423C12.3921 12.3423 12.3921 12.3423 12.3921 12.3423L12.3921 12.3423C12.3921 12.3423 12.3921 12.3423 12.3921 12.3423C12.3921 12.3423 12.3921 12.3423 12.3921 12.3423C12.3921 12.3423 12.3921 12.3423 12.3921 12.3423C12.3921 12.3423 12.3921 12.3423 12.3921 12.3423L12.3921 12.3423C12.3921 12.3423 12.3921 12.3423 12.3921 12.3423C12.3921 12.3423 12.3921 12.3423 12.3921 12.3424C12.3921 12.3424 12.3921 12.3424 12.3921 12.3424C12.3921 12.3424 12.3921 12.3424 12.3921 12.3424L12.3921 12.3424C12.3921 12.3424 12.3921 12.3424 12.3921 12.3424C12.3921 12.3424 12.3921 12.3424 12.3921 12.3424C12.3921 12.3424 12.3921 12.3424 12.3921 12.3424C12.3921 12.3424 12.3921 12.3424 12.3921 12.3424L12.392 12.3424C12.392 12.3424 12.392 12.3424 12.392 12.3424C12.392 12.3424 12.392 12.3424 12.392 12.3424C12.392 12.3424 12.392 12.3424 12.392 12.3424C12.392 12.3424 12.392 12.3424 12.392 12.3424L12.392 12.3424C12.392 12.3424 12.392 12.3424 12.392 12.3424C12.392 12.3424 12.392 12.3424 12.392 12.3424C12.392 12.3424 12.392 12.3424 12.392 12.3424C12.392 12.3424 12.392 12.3424 12.392 12.3424L12.392 12.3424C12.392 12.3424 12.392 12.3424 12.392 12.3424C12.392 12.3424 12.392 12.3424 12.392 12.3424C12.392 12.3424 12.392 12.3424 12.392 12.3424C12.392 12.3424 12.392 12.3424 12.392 12.3424L12.392 12.3424C12.392 12.3424 12.392 12.3424 12.392 12.3424C12.392 12.3424 12.392 12.3424 12.392 12.3424C12.392 12.3424 12.392 12.3424 12.392 12.3424C12.392 12.3424 12.392 12.3424 12.392 12.3424L12.392 12.3424C12.392 12.3424 12.392 12.3424 12.392 12.3424C12.392 12.3424 12.392 12.3424 12.392 12.3424C12.392 12.3424 12.392 12.3424 12.392 12.3424C12.392 12.3424 12.392 12.3424 12.392 12.3424L12.6749 12.6252ZM12.6748 12.392C12.7393 12.4565 12.7393 12.5611 12.6746 12.6255L12.3923 12.3421C12.3001 12.4339 12.3001 12.583 12.392 12.6748L12.6748 12.392ZM12.4424 12.3912C12.5066 12.3279 12.6104 12.3276 12.6748 12.392L12.392 12.6748C12.4837 12.7666 12.6318 12.7664 12.7235 12.6758L12.4424 12.3912ZM12.4416 12.392L12.4416 12.392C12.4416 12.392 12.4416 12.392 12.4416 12.392C12.4416 12.392 12.4416 12.392 12.4416 12.392C12.4416 12.392 12.4416 12.392 12.4416 12.392C12.4416 12.392 12.4416 12.392 12.4416 12.392L12.4416 12.392C12.4416 12.392 12.4416 12.392 12.4416 12.392L12.4416 12.392C12.4416 12.392 12.4416 12.392 12.4416 12.392C12.4416 12.392 12.4416 12.392 12.4416 12.392L12.4416 12.392C12.4416 12.392 12.4416 12.392 12.4416 12.392L12.4416 12.392C12.4416 12.392 12.4416 12.392 12.4416 12.392C12.4416 12.392 12.4416 12.392 12.4416 12.392L12.4416 12.392C12.4416 12.392 12.4416 12.392 12.4416 12.392L12.4416 12.392C12.4416 12.392 12.4416 12.392 12.4416 12.392C12.4416 12.392 12.4416 12.392 12.4416 12.392L12.4416 12.392C12.4416 12.392 12.4416 12.392 12.4416 12.392L12.4416 12.392C12.4416 12.392 12.4416 12.392 12.4416 12.392C12.4416 12.392 12.4416 12.392 12.4416 12.392L12.4416 12.392C12.4416 12.392 12.4416 12.392 12.4416 12.392L12.4416 12.392C12.4416 12.3921 12.4416 12.3921 12.4416 12.3921C12.4416 12.3921 12.4416 12.3921 12.4416 12.3921L12.4416 12.3921C12.4416 12.3921 12.4416 12.3921 12.4416 12.3921L12.4416 12.3921C12.4416 12.3921 12.4416 12.3921 12.4416 12.3921C12.4416 12.3921 12.4416 12.3921 12.4416 12.3921L12.4416 12.3921C12.4416 12.3921 12.4416 12.3921 12.4416 12.3921L12.4416 12.3921C12.4416 12.3921 12.4416 12.3921 12.4416 12.3921C12.4416 12.3921 12.4416 12.3921 12.4416 12.3921L12.4416 12.3921C12.4416 12.3921 12.4416 12.3921 12.4416 12.3921L12.4416 12.3921C12.4416 12.3921 12.4416 12.3921 12.4416 12.3921C12.4416 12.3921 12.4416 12.3921 12.4416 12.3921L12.4416 12.3921C12.4416 12.3921 12.4416 12.3921 12.4416 12.3921L12.4416 12.3921C12.4416 12.3921 12.4416 12.3921 12.4416 12.3921C12.4416 12.3921 12.4416 12.3921 12.4416 12.3921L12.4416 12.3921C12.4416 12.3921 12.4416 12.3921 12.4416 12.3921L12.4416 12.3921C12.4416 12.3921 12.4416 12.3921 12.4416 12.3921C12.4416 12.3921 12.4416 12.3921 12.4416 12.3921L12.4416 12.3921C12.4416 12.3921 12.4416 12.3921 12.4416 12.3921L12.4416 12.3921C12.4416 12.3921 12.4416 12.3921 12.4416 12.3921C12.4416 12.3921 12.4416 12.3921 12.4416 12.3921L12.4416 12.3921C12.4416 12.3921 12.4416 12.3921 12.4416 12.3921L12.4416 12.3921C12.4415 12.3921 12.4415 12.3921 12.4415 12.3921C12.4415 12.3921 12.4415 12.3921 12.4415 12.3921L12.4415 12.3921C12.4415 12.3921 12.4415 12.3921 12.4415 12.3921L12.4415 12.3921C12.4415 12.3921 12.4415 12.3921 12.4415 12.3921C12.4415 12.3921 12.4415 12.3921 12.4415 12.3921L12.4415 12.3921C12.4415 12.3921 12.4415 12.3921 12.4415 12.3921L12.4415 12.3921C12.4415 12.3921 12.4415 12.3921 12.4415 12.3921C12.4415 12.3921 12.4415 12.3921 12.4415 12.3921L12.4415 12.3921C12.4415 12.3921 12.4415 12.3921 12.4415 12.3921L12.4415 12.3921L12.7244 12.675L12.7244 12.675C12.7244 12.675 12.7244 12.675 12.7244 12.675L12.7244 12.675C12.7244 12.675 12.7244 12.675 12.7244 12.675C12.7244 12.675 12.7244 12.675 12.7244 12.675L12.7244 12.675C12.7244 12.675 12.7244 12.675 12.7244 12.6749L12.7244 12.6749C12.7244 12.6749 12.7244 12.6749 12.7244 12.6749C12.7244 12.6749 12.7244 12.6749 12.7244 12.6749L12.7244 12.6749C12.7244 12.6749 12.7244 12.6749 12.7244 12.6749L12.7244 12.6749C12.7244 12.6749 12.7244 12.6749 12.7244 12.6749C12.7244 12.6749 12.7244 12.6749 12.7244 12.6749L12.7244 12.6749C12.7244 12.6749 12.7244 12.6749 12.7244 12.6749L12.7244 12.6749C12.7244 12.6749 12.7244 12.6749 12.7244 12.6749C12.7244 12.6749 12.7244 12.6749 12.7244 12.6749L12.7244 12.6749C12.7244 12.6749 12.7244 12.6749 12.7244 12.6749L12.7244 12.6749C12.7244 12.6749 12.7244 12.6749 12.7244 12.6749C12.7244 12.6749 12.7244 12.6749 12.7244 12.6749L12.7244 12.6749C12.7244 12.6749 12.7244 12.6749 12.7244 12.6749L12.7244 12.6749C12.7244 12.6749 12.7244 12.6749 12.7244 12.6749C12.7244 12.6749 12.7244 12.6749 12.7244 12.6749L12.7244 12.6749C12.7244 12.6749 12.7244 12.6749 12.7244 12.6749L12.7244 12.6749C12.7244 12.6749 12.7244 12.6749 12.7244 12.6749C12.7244 12.6749 12.7244 12.6749 12.7244 12.6749L12.7244 12.6749C12.7244 12.6749 12.7244 12.6749 12.7244 12.6749L12.7244 12.6749C12.7244 12.6749 12.7244 12.6749 12.7244 12.6749C12.7244 12.6749 12.7244 12.6749 12.7244 12.6749L12.7244 12.6749C12.7244 12.6749 12.7244 12.6749 12.7244 12.6749L12.7244 12.6749C12.7244 12.6749 12.7244 12.6749 12.7244 12.6749C12.7244 12.6749 12.7244 12.6749 12.7244 12.6749L12.7244 12.6749C12.7244 12.6749 12.7244 12.6749 12.7244 12.6749L12.7244 12.6749C12.7244 12.6749 12.7244 12.6749 12.7244 12.6749C12.7244 12.6749 12.7244 12.6749 12.7244 12.6749L12.7244 12.6749C12.7244 12.6749 12.7244 12.6749 12.7244 12.6749L12.7244 12.6749C12.7244 12.6749 12.7244 12.6749 12.7244 12.6749C12.7244 12.6749 12.7244 12.6749 12.7244 12.6749L12.7244 12.6749C12.7244 12.6749 12.7244 12.6749 12.7244 12.6749L12.7244 12.6749C12.7245 12.6749 12.7245 12.6749 12.7245 12.6749C12.7245 12.6749 12.7245 12.6749 12.7245 12.6749L12.7245 12.6749C12.7245 12.6749 12.7245 12.6749 12.7245 12.6749L12.7245 12.6749C12.7245 12.6749 12.7245 12.6749 12.7245 12.6749C12.7245 12.6749 12.7245 12.6749 12.7245 12.6749L12.7245 12.6749C12.7245 12.6749 12.7245 12.6749 12.7245 12.6749L12.7245 12.6749C12.7245 12.6749 12.7245 12.6749 12.7245 12.6749C12.7245 12.6749 12.7245 12.6749 12.7245 12.6749L12.7245 12.6749C12.7245 12.6749 12.7245 12.6749 12.7245 12.6749L12.7245 12.6749C12.7245 12.6749 12.7245 12.6749 12.7245 12.6749C12.7245 12.6749 12.7245 12.6749 12.7245 12.6749C12.7245 12.6749 12.7245 12.6749 12.7245 12.6749C12.7245 12.6749 12.7245 12.6749 12.7245 12.6749L12.7245 12.6749L12.4416 12.392ZM12.4674 12.3664C12.4589 12.3749 12.4504 12.3833 12.4419 12.3917L12.7242 12.6752C12.7325 12.6669 12.7407 12.6587 12.749 12.6505L12.4674 12.3664ZM12.4523 36.1956L12.452 36.1953L12.7351 35.9127L12.7346 35.9122L12.4523 36.1956ZM12.7347 35.9123C12.7347 35.9122 12.7346 35.9122 12.7346 35.9122C12.7346 35.9122 12.7346 35.9122 12.7346 35.9122L12.4523 36.1956C12.4524 36.1956 12.4524 36.1956 12.4524 36.1956C12.4524 36.1957 12.4524 36.1957 12.4524 36.1957L12.7347 35.9123ZM12.4521 12.4026L12.4521 12.4026C12.4521 12.4026 12.4521 12.4026 12.4521 12.4026L12.4521 12.4026C12.4521 12.4026 12.4521 12.4026 12.4521 12.4026C12.4521 12.4026 12.4521 12.4026 12.4521 12.4026L12.4521 12.4026C12.4521 12.4026 12.4521 12.4026 12.4521 12.4026C12.4521 12.4026 12.4521 12.4026 12.4521 12.4026C12.4521 12.4026 12.4521 12.4026 12.4521 12.4026C12.4521 12.4026 12.4521 12.4026 12.4521 12.4026L12.4521 12.4026C12.4521 12.4026 12.4521 12.4026 12.4521 12.4026C12.4521 12.4026 12.4521 12.4026 12.4521 12.4026L12.4521 12.4026C12.4521 12.4026 12.4521 12.4026 12.4521 12.4026C12.4521 12.4026 12.4521 12.4026 12.4521 12.4026L12.4521 12.4026C12.4521 12.4026 12.4521 12.4026 12.4521 12.4026C12.4521 12.4026 12.4521 12.4026 12.4521 12.4026L12.4521 12.4026C12.4521 12.4026 12.4521 12.4026 12.4521 12.4026C12.4521 12.4026 12.4521 12.4026 12.4521 12.4026L12.4521 12.4026C12.4521 12.4026 12.4521 12.4026 12.4521 12.4026C12.4521 12.4026 12.4521 12.4026 12.4521 12.4026L12.4521 12.4026C12.4521 12.4026 12.4521 12.4026 12.4521 12.4026C12.4521 12.4026 12.4521 12.4026 12.4521 12.4026L12.4521 12.4026C12.4521 12.4026 12.4521 12.4026 12.4521 12.4026C12.4521 12.4026 12.4521 12.4026 12.4521 12.4026L12.4521 12.4026C12.4521 12.4026 12.4521 12.4026 12.4521 12.4026C12.4521 12.4026 12.4521 12.4026 12.4521 12.4026L12.4521 12.4026C12.4521 12.4026 12.4521 12.4026 12.4521 12.4026C12.4521 12.4026 12.4521 12.4026 12.4521 12.4026C12.4521 12.4026 12.4521 12.4026 12.4521 12.4026L12.4521 12.4026C12.4521 12.4026 12.4521 12.4026 12.4521 12.4026C12.4521 12.4026 12.4521 12.4026 12.4521 12.4026L12.4521 12.4026C12.4521 12.4026 12.4521 12.4026 12.4521 12.4026C12.4521 12.4026 12.4521 12.4026 12.4521 12.4026L12.4521 12.4026C12.4521 12.4026 12.4521 12.4026 12.4521 12.4026C12.4521 12.4026 12.4521 12.4026 12.4521 12.4026L12.4521 12.4026C12.4521 12.4026 12.4521 12.4026 12.4521 12.4026C12.4521 12.4026 12.4521 12.4026 12.4521 12.4026L12.4521 12.4026C12.4521 12.4026 12.4521 12.4026 12.4521 12.4026C12.4521 12.4026 12.4521 12.4026 12.4521 12.4026L12.4521 12.4026C12.4521 12.4026 12.4521 12.4026 12.4521 12.4026C12.4521 12.4026 12.4521 12.4026 12.4521 12.4026L12.4521 12.4026C12.4521 12.4026 12.4521 12.4026 12.4521 12.4026C12.4521 12.4026 12.4521 12.4026 12.4521 12.4027L12.4521 12.4027C12.4521 12.4027 12.4521 12.4027 12.4521 12.4027C12.4521 12.4027 12.4521 12.4027 12.4521 12.4027L12.4521 12.4027C12.4521 12.4027 12.4521 12.4027 12.4521 12.4027C12.4521 12.4027 12.4521 12.4027 12.4521 12.4027L12.4521 12.4027C12.4521 12.4027 12.4521 12.4027 12.4521 12.4027C12.4521 12.4027 12.4521 12.4027 12.4521 12.4027L12.4521 12.4027C12.4521 12.4027 12.4521 12.4027 12.4521 12.4027C12.4521 12.4027 12.4521 12.4027 12.4521 12.4027L12.4521 12.4027C12.4521 12.4027 12.4521 12.4027 12.4521 12.4027L12.452 12.4027C12.452 12.4027 12.452 12.4027 12.452 12.4027C12.452 12.4027 12.452 12.4027 12.452 12.4027L12.452 12.4027L12.7349 12.6855L12.7349 12.6855C12.7349 12.6855 12.7349 12.6855 12.7349 12.6855C12.7349 12.6855 12.7349 12.6855 12.7349 12.6855L12.7349 12.6855C12.7349 12.6855 12.7349 12.6855 12.7349 12.6855L12.7349 12.6855C12.7349 12.6855 12.7349 12.6855 12.7349 12.6855C12.7349 12.6855 12.7349 12.6855 12.7349 12.6855L12.7349 12.6855C12.7349 12.6855 12.7349 12.6855 12.7349 12.6855C12.7349 12.6855 12.7349 12.6855 12.7349 12.6855L12.7349 12.6855C12.7349 12.6855 12.7349 12.6855 12.7349 12.6855C12.7349 12.6855 12.7349 12.6855 12.7349 12.6855L12.7349 12.6855C12.7349 12.6855 12.7349 12.6855 12.7349 12.6855C12.7349 12.6855 12.7349 12.6855 12.7349 12.6855L12.7349 12.6855C12.7349 12.6855 12.7349 12.6855 12.7349 12.6855C12.7349 12.6855 12.7349 12.6855 12.7349 12.6855L12.7349 12.6855C12.7349 12.6855 12.7349 12.6855 12.7349 12.6855C12.7349 12.6855 12.7349 12.6855 12.7349 12.6855L12.7349 12.6855C12.7349 12.6855 12.7349 12.6855 12.7349 12.6855C12.7349 12.6855 12.7349 12.6855 12.7349 12.6855L12.7349 12.6855C12.7349 12.6855 12.7349 12.6855 12.7349 12.6855C12.7349 12.6855 12.7349 12.6855 12.7349 12.6855L12.7349 12.6855C12.7349 12.6855 12.7349 12.6855 12.7349 12.6855C12.7349 12.6855 12.7349 12.6855 12.7349 12.6855L12.7349 12.6855C12.7349 12.6855 12.7349 12.6855 12.7349 12.6855C12.7349 12.6855 12.7349 12.6855 12.7349 12.6855L12.7349 12.6855C12.7349 12.6855 12.7349 12.6855 12.7349 12.6855C12.7349 12.6855 12.7349 12.6855 12.7349 12.6855L12.7349 12.6855C12.7349 12.6855 12.7349 12.6855 12.7349 12.6855C12.7349 12.6855 12.7349 12.6855 12.7349 12.6855C12.7349 12.6855 12.7349 12.6855 12.7349 12.6855L12.7349 12.6855C12.7349 12.6855 12.7349 12.6855 12.7349 12.6855C12.7349 12.6855 12.7349 12.6855 12.7349 12.6855L12.7349 12.6855C12.7349 12.6855 12.7349 12.6855 12.7349 12.6855C12.7349 12.6855 12.7349 12.6855 12.735 12.6855L12.735 12.6854C12.735 12.6854 12.735 12.6854 12.735 12.6854C12.735 12.6854 12.735 12.6854 12.735 12.6854L12.735 12.6854C12.735 12.6854 12.735 12.6854 12.735 12.6854C12.735 12.6854 12.735 12.6854 12.735 12.6854L12.735 12.6854C12.735 12.6854 12.735 12.6854 12.735 12.6854C12.735 12.6854 12.735 12.6854 12.735 12.6854L12.735 12.6854C12.735 12.6854 12.735 12.6854 12.735 12.6854C12.735 12.6854 12.735 12.6854 12.735 12.6854L12.735 12.6854C12.735 12.6854 12.735 12.6854 12.735 12.6854C12.735 12.6854 12.735 12.6854 12.735 12.6854L12.735 12.6854C12.735 12.6854 12.735 12.6854 12.735 12.6854C12.735 12.6854 12.735 12.6854 12.735 12.6854L12.735 12.6854C12.735 12.6854 12.735 12.6854 12.735 12.6854C12.735 12.6854 12.735 12.6854 12.735 12.6854C12.735 12.6854 12.735 12.6854 12.735 12.6854C12.735 12.6854 12.735 12.6854 12.735 12.6854L12.735 12.6854C12.735 12.6854 12.735 12.6854 12.735 12.6854C12.735 12.6854 12.735 12.6854 12.735 12.6854L12.735 12.6854C12.735 12.6854 12.735 12.6854 12.735 12.6854L12.735 12.6854L12.4521 12.4026ZM20.9904 7.66568C17.7123 8.31773 14.7002 9.9238 12.3323 12.2818L12.6145 12.5653C14.9266 10.2629 17.8677 8.69466 21.0684 8.05799L20.9904 7.66568ZM30.7889 8.63075C27.6901 7.34715 24.2801 7.0113 20.9904 7.66568L21.0684 8.05799C24.2806 7.41905 27.6101 7.74698 30.6359 9.0003L30.7889 8.63075ZM38.4 14.877C36.5365 12.088 33.8878 9.91435 30.7889 8.63075L30.6359 9.0003C33.6617 10.2536 36.2479 12.3761 38.0674 15.0992L38.4 14.877ZM41.2581 24.299C41.2581 20.9448 40.2635 17.6659 38.4 14.877L38.0674 15.0992C39.8869 17.8223 40.8581 21.0239 40.8581 24.299L41.2581 24.299ZM38.4 33.721C40.2635 30.9321 41.2581 27.6532 41.2581 24.299L40.8581 24.299C40.8581 27.5741 39.8869 30.7756 38.0674 33.4988L38.4 33.721ZM30.7889 39.9672C33.8878 38.6836 36.5365 36.5099 38.4 33.721L38.0674 33.4988C36.2479 36.2219 33.6617 38.3443 30.6359 39.5977L30.7889 39.9672ZM20.9904 40.9323C24.2801 41.5867 27.6901 41.2508 30.7889 39.9672L30.6359 39.5977C27.6101 40.851 24.2806 41.1789 21.0684 40.54L20.9904 40.9323ZM12.3323 36.3161C14.7002 38.6742 17.7123 40.2802 20.9904 40.9323L21.0684 40.54C17.8677 39.9033 14.9266 38.3351 12.6145 36.0327L12.3323 36.3161ZM12.3318 35.863C12.2068 35.988 12.2067 36.1911 12.3323 36.3161L12.6145 36.0327C12.6459 36.064 12.6458 36.1146 12.6147 36.1458L12.3318 35.863ZM12.7842 35.8625C12.6596 35.7384 12.4572 35.7376 12.3318 35.863L12.6147 36.1458C12.5833 36.1772 12.5329 36.1768 12.502 36.146L12.7842 35.8625ZM21.1153 40.3043C17.961 39.6768 15.0627 38.1314 12.7842 35.8625L12.502 36.146C14.8363 38.4705 17.8057 40.0538 21.0373 40.6966L21.1153 40.3043ZM30.5439 39.3756C27.562 40.6108 24.2808 40.9339 21.1153 40.3043L21.0373 40.6966C24.2804 41.3417 27.642 41.0106 30.697 39.7452L30.5439 39.3756ZM37.8676 33.3652C36.0744 36.0489 33.5258 38.1405 30.5439 39.3756L30.697 39.7452C33.752 38.4798 36.3631 36.3369 38.2002 33.5875L37.8676 33.3652ZM40.6178 24.299C40.6178 27.5265 39.6607 30.6816 37.8676 33.3652L38.2002 33.5875C40.0373 30.8381 41.0178 27.6057 41.0178 24.299L40.6178 24.299ZM37.8676 15.2327C39.6607 17.9163 40.6178 21.0714 40.6178 24.299L41.0178 24.299C41.0178 20.9923 40.0373 17.7599 38.2002 15.0105L37.8676 15.2327ZM30.5439 9.22232C33.5258 10.4575 36.0744 12.5491 37.8676 15.2327L38.2002 15.0105C36.3631 12.2611 33.752 10.1182 30.697 8.85277L30.5439 9.22232ZM21.1153 8.29369C24.2808 7.66402 27.562 7.98719 30.5439 9.22232L30.697 8.85277C27.642 7.58736 24.2804 7.25627 21.0373 7.90138L21.1153 8.29369ZM12.7842 12.7354C15.0627 10.4665 17.961 8.92111 21.1153 8.29369L21.0373 7.90138C17.8057 8.54418 14.8363 10.1275 12.502 12.452L12.7842 12.7354ZM12.3318 12.735C12.4572 12.8604 12.6596 12.8595 12.7842 12.7354L12.502 12.452C12.5329 12.4212 12.5833 12.4208 12.6147 12.4522L12.3318 12.735ZM12.3323 12.2818C12.2067 12.4069 12.2068 12.6099 12.3318 12.735L12.6147 12.4522C12.6458 12.4833 12.6459 12.534 12.6145 12.5653L12.3323 12.2818Z", fill: "black", mask: "url(#path-3-outside-1_961_14670)" }),
  /* @__PURE__ */ f.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15.5301 12.6042C15.5407 12.7216 15.4551 12.8197 15.3389 12.8232L12.0712 12.9215C11.9161 12.9262 11.785 12.7896 11.7953 12.634L12.01 9.37564C12.0177 9.25905 12.1183 9.1766 12.2347 9.19148C12.3511 9.20636 12.4393 9.31292 12.4316 9.42951L12.2299 12.4902L15.3006 12.3978C15.4168 12.3943 15.5195 12.4867 15.5301 12.6042ZM12.0331 12.4961C12.033 12.4961 12.033 12.4961 12.0329 12.4961L12.0482 12.6663L12.0329 12.4961L12.0331 12.4961Z", fill: "#141A22" }),
  /* @__PURE__ */ f.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15.6493 12.5934C15.6659 12.7777 15.5293 12.9372 15.3425 12.9428L12.0748 13.0412C11.8484 13.048 11.661 12.8516 11.6759 12.6261L11.8906 9.36774C11.9028 9.18175 12.0656 9.04916 12.2499 9.07271C12.4286 9.09555 12.5629 9.25718 12.551 9.43735L12.358 12.3666L15.297 12.2781C15.478 12.2727 15.6332 12.4143 15.6493 12.5934ZM15.3006 12.3978C15.4168 12.3943 15.5195 12.4867 15.5301 12.6041C15.5407 12.7216 15.4551 12.8197 15.3389 12.8232L12.0712 12.9215C11.9161 12.9262 11.785 12.7896 11.7953 12.6339L12.01 9.37561C12.0177 9.25903 12.1183 9.17658 12.2347 9.19146C12.3511 9.20633 12.4393 9.3129 12.4316 9.42948L12.2299 12.4902L15.3006 12.3978Z", fill: "#141A22" })
] }), Ej = () => /* @__PURE__ */ f.jsxs("svg", { viewBox: "0 0 48 48", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ f.jsx("path", { d: "M31.2782 13.0392H30.3233C26.4811 13.0392 22.6389 13.0392 18.7967 13.0392C18.766 13.0392 18.7339 13.0392 18.7032 13.0392C18.6725 13.0392 18.6418 13.0392 18.6124 13.0392C18.5389 13.0392 18.4668 13.0405 18.3974 13.0485C18.169 13.0739 18.0835 13.1821 18.1022 13.4238C18.1223 13.6655 18.2304 13.7323 18.6057 13.7323C18.607 13.7323 18.6084 13.7323 18.6097 13.7323C20.1976 13.731 21.7868 13.731 23.3747 13.731H26.8898C28.4069 13.731 29.924 13.731 31.4424 13.7283C31.8711 13.727 31.9112 13.5507 31.9139 13.3851C31.9179 13.2101 31.8858 13.0525 31.4558 13.0419C31.397 13.0392 31.3369 13.0392 31.2782 13.0392Z", fill: "#141A22" }),
  /* @__PURE__ */ f.jsx("path", { d: "M31.4559 15.0611C31.3971 15.0598 31.337 15.0598 31.2782 15.0598H30.2539C26.4344 15.0598 22.6149 15.0598 18.7954 15.0598C18.7647 15.0585 18.7326 15.0598 18.7006 15.0598C18.6699 15.0598 18.6392 15.0598 18.6098 15.0598C18.5363 15.0598 18.4642 15.0611 18.3948 15.0691C18.1664 15.0945 18.0809 15.2027 18.101 15.4444C18.121 15.6861 18.2292 15.7516 18.6044 15.7516C18.6058 15.7516 18.6071 15.7516 18.6084 15.7516C20.1937 15.7502 21.7776 15.7502 23.3628 15.7502H26.8818C28.4016 15.7502 29.9227 15.7502 31.4425 15.7476C31.8699 15.7462 31.9099 15.57 31.9139 15.403C31.9179 15.2307 31.8859 15.0732 31.4559 15.0611Z", fill: "#141A22" }),
  /* @__PURE__ */ f.jsx("path", { d: "M18.4296 17.7681C18.5043 17.7735 18.5805 17.7735 18.6619 17.7721H18.7127H19.1467C23.1959 17.7721 27.2451 17.7721 31.2943 17.7708H31.3317C31.4666 17.7708 31.5935 17.7708 31.7003 17.7401C31.8085 17.7094 31.93 17.6399 31.9153 17.3822C31.9047 17.2086 31.8299 17.1231 31.6669 17.0977C31.5668 17.0817 31.4586 17.0817 31.3451 17.083H31.2783C29.5729 17.0817 27.8688 17.0817 26.1634 17.083H23.7715C22.1222 17.083 20.4729 17.083 18.8235 17.083H18.7354C18.7073 17.083 18.6793 17.083 18.6512 17.083C18.5711 17.083 18.4937 17.0844 18.4175 17.0897C18.1972 17.1057 18.1064 17.2019 18.1037 17.4196C18.097 17.6506 18.1918 17.7521 18.4296 17.7681Z", fill: "#141A22" }),
  /* @__PURE__ */ f.jsx("path", { d: "M31.4586 19.1036C31.3985 19.1023 31.3384 19.1023 31.2796 19.1023H31.2115C27.0742 19.1023 22.9368 19.1023 18.7981 19.1023C18.7674 19.1023 18.7354 19.1023 18.7047 19.1023C18.6739 19.1023 18.6432 19.1023 18.6139 19.1023C18.5391 19.1023 18.4683 19.1036 18.3975 19.1116C18.1678 19.1357 18.0823 19.2439 18.101 19.4856C18.1184 19.7046 18.1918 19.7954 18.6032 19.7954C18.6045 19.7954 18.6058 19.7954 18.6072 19.7954C20.1951 19.7941 21.7843 19.7941 23.3722 19.7941H26.8725C28.395 19.7941 29.9174 19.7941 31.4399 19.7914C31.8686 19.7901 31.91 19.6138 31.914 19.4495C31.9193 19.2746 31.8873 19.1157 31.4586 19.1036Z", fill: "#141A22" }),
  /* @__PURE__ */ f.jsx("path", { d: "M36.4907 21.1336C36.1181 21.1042 35.9552 20.9253 35.9605 20.554C35.9672 20.16 35.9659 19.7594 35.9646 19.3721C35.9632 19.0796 35.9632 18.7858 35.9646 18.4933C35.9726 17.4076 35.4611 16.6423 34.4448 16.2163C34.0802 16.0641 33.9333 15.841 33.9373 15.4484C33.952 14.1263 33.9466 12.7881 33.9413 11.494C33.9399 11.0947 33.8745 11.0279 33.4779 11.0213L33.3363 11.0186C33.0692 11.0133 32.7928 11.0066 32.527 11.0239C32.316 11.0373 32.1624 10.9932 32.0569 10.8891C31.9153 10.7475 31.91 10.5445 31.9194 10.4043C31.934 10.1599 31.93 9.90613 31.9247 9.66174L31.922 9.49346C31.9153 9.0621 31.8566 9.002 31.4359 9.002C25.9911 8.99933 20.3099 8.99933 14.554 9.002C14.1119 9.002 14.0558 9.06076 14.0545 9.52017C14.0505 10.4724 14.0478 11.4874 14.0558 12.5063C14.0585 12.8362 13.929 13.0298 13.6231 13.154C12.5347 13.5948 12.0152 14.3506 12.0366 15.4644C12.0446 15.8824 11.863 16.0721 11.4476 16.0828C9.91581 16.1188 9.001 17.0497 9.001 18.5721C8.99967 24.479 8.99967 30.3859 9.001 36.2927V38.3174C9.001 38.9744 9.02638 38.9998 9.68878 38.9998C12.6829 38.9998 15.6758 38.9998 18.67 38.9998H21.8137C22.185 38.9998 22.5562 38.9998 22.9275 38.9998C23.8276 38.9998 24.7277 38.9998 25.6265 38.9998C28.383 38.9998 31.1394 39.0011 33.8959 38.9971C35.0831 38.9958 35.9926 38.2492 36.2143 37.0954C36.448 35.8734 36.6764 34.6274 36.8967 33.4241C37.0156 32.7737 37.1358 32.122 37.256 31.4716C37.4069 30.6623 37.5578 29.8517 37.71 29.0424C38.0265 27.3597 38.3537 25.6182 38.6582 23.9034C38.7784 23.225 38.6235 22.5652 38.2229 22.0457C37.8102 21.5129 37.1972 21.191 36.4907 21.1336ZM34.1656 16.9989C34.3767 16.9281 34.5289 17.0697 34.621 17.1552C34.6371 17.1699 34.6531 17.1859 34.6691 17.1992C35.0417 17.5077 35.2421 17.9578 35.2634 18.5361C35.2781 18.922 35.2754 19.3133 35.2728 19.6926C35.2714 19.9904 35.2688 20.2989 35.2754 20.6021C35.2794 20.7797 35.2367 20.9092 35.1472 21C35.0164 21.1323 34.8361 21.1296 34.6918 21.1269C34.6624 21.1269 34.6331 21.1256 34.6037 21.1269L34.5796 21.1283C34.5463 21.1296 34.5129 21.1296 34.4782 21.1296C34.3326 21.1296 34.183 21.1109 34.0682 20.9974C33.9733 20.9026 33.9319 20.7663 33.9386 20.5807C33.952 20.2121 33.9493 19.8342 33.9453 19.4696C33.944 19.3093 33.9426 19.1491 33.9426 18.9888L33.9413 18.6349C33.9399 18.2676 33.9386 17.8884 33.944 17.5131C33.944 17.4984 33.9413 17.473 33.9386 17.4503C33.9293 17.3488 33.9012 17.0871 34.1656 16.9989ZM32.543 11.701C32.7367 11.6997 32.9517 11.7184 33.0973 11.864C33.2442 12.0109 33.2615 12.2326 33.2602 12.4088C33.2428 15.0411 33.2428 17.7455 33.2602 20.4472C33.2615 20.6154 33.2442 20.8278 33.1026 20.9707C32.9624 21.1109 32.7554 21.1309 32.5684 21.1309C32.5671 21.1309 32.5644 21.1309 32.5631 21.1309C27.5002 21.1202 22.416 21.1202 17.4493 21.1309C17.4466 21.1309 17.4453 21.1309 17.444 21.1309C17.2597 21.1309 17.0527 21.1109 16.9124 20.9707C16.7709 20.8278 16.7535 20.6141 16.7535 20.4445C16.7695 17.8536 16.7695 15.1346 16.7549 12.3634C16.7535 12.2005 16.7709 11.9948 16.9098 11.8559C17.0487 11.7171 17.2517 11.6997 17.4306 11.701C19.3551 11.7117 21.3129 11.7104 23.2053 11.709C23.8196 11.709 24.4353 11.7077 25.0496 11.7077C25.0549 11.7077 25.0603 11.7077 25.0656 11.7077C25.6839 11.7077 26.3023 11.7077 26.9219 11.709C28.7636 11.7117 30.6693 11.713 32.543 11.701ZM14.8959 9.84203C15.0414 9.69646 15.2538 9.67643 15.4447 9.6791C17.3398 9.69245 19.2683 9.68978 21.1326 9.68845C21.7616 9.68845 22.3893 9.68711 23.0183 9.68711H24.9414C26.8111 9.68711 28.6808 9.68711 30.5505 9.68711C30.8162 9.68711 31.0513 9.81532 31.1808 10.0317C31.3157 10.2574 31.317 10.5418 31.1822 10.7929C31.1314 10.8891 31.0259 11.0039 30.8162 11.0119C30.6867 11.0159 30.5572 11.0159 30.4303 11.0159H16.7535C16.0711 11.0159 16.0711 11.0159 16.0711 11.689C16.0711 13.3223 16.0711 14.9556 16.0711 16.5889V20.3577C16.0711 20.5927 16.0444 20.8825 15.84 21.0455C15.7292 21.1336 15.593 21.163 15.4541 21.163C15.3299 21.163 15.2044 21.1403 15.0908 21.1136C14.7262 21.0294 14.7369 20.733 14.7409 20.5901C14.7423 20.57 14.7423 20.5513 14.7423 20.5326C14.7396 19.7941 14.7396 19.0542 14.7396 18.3157V17.6293C14.7396 17.0176 14.7396 16.4046 14.7409 15.7916C14.7423 14.0221 14.7436 12.1912 14.7316 10.3922C14.7303 10.2026 14.749 9.98893 14.8959 9.84203ZM9.68878 32.1901V31.3074C9.68878 27.1473 9.68744 22.9886 9.68878 18.8285C9.68878 17.4223 10.3458 16.7652 11.7561 16.7612C12.2262 16.7599 12.5374 16.7585 12.6269 16.6677C12.7177 16.5742 12.719 16.2537 12.7203 15.7663C12.7217 15.2387 12.7991 14.5737 13.3881 14.1116C13.4001 14.1022 13.4108 14.0929 13.4228 14.0822C13.4989 14.0168 13.6752 13.8645 13.8956 13.9941C14.0759 14.1009 14.0598 14.2905 14.0518 14.3827C14.0505 14.3987 14.0492 14.4147 14.0492 14.4308C14.0505 15.1519 14.0505 15.8744 14.0505 16.5956C14.0505 17.899 14.0505 19.2479 14.0545 20.574C14.0558 20.9052 13.9156 21.0882 13.6004 21.1683C12.5481 21.4368 11.9444 22.0871 11.7534 23.1569C11.3568 25.3751 10.9495 27.6294 10.5555 29.8089L10.2697 31.3915C10.2256 31.6332 10.1762 31.8763 10.1295 32.1113L10.1161 32.1781C10.1041 32.2382 10.0707 32.2796 10.052 32.3023L10.044 32.3103L9.79962 32.6776L9.68878 32.1901ZM37.9117 23.6203C37.8796 24.2159 37.7594 24.8022 37.6433 25.3684C37.5979 25.5915 37.5498 25.8225 37.5097 26.0495C37.1157 28.2371 36.7017 30.458 36.3024 32.6055C36.1315 33.5229 35.9605 34.4404 35.7909 35.3579C35.7549 35.5556 35.7202 35.7519 35.6868 35.9495C35.6334 36.2594 35.5786 36.5785 35.5145 36.8924C35.3329 37.7738 34.6251 38.3 33.6221 38.3013C32.499 38.3027 31.3758 38.3027 30.2527 38.3027C29.5796 38.3027 28.9065 38.3027 28.2321 38.3027H10.5889C10.2564 38.3027 10.0734 38.3027 9.95588 38.1624C9.83835 38.0222 9.87174 37.8339 9.9265 37.5227C10.2657 35.621 10.6063 33.7206 10.9481 31.8189C11.1845 30.5034 11.4196 29.1879 11.6546 27.8738C11.7855 27.1406 11.915 26.4074 12.0446 25.6729C12.1861 24.8743 12.3277 24.0743 12.4706 23.2757C12.6175 22.4531 13.2746 21.8801 14.1426 21.8174C14.2348 21.8107 14.3256 21.812 14.4124 21.812H14.4925H16.0457C22.6724 21.812 29.2991 21.812 35.9245 21.8134C36.1248 21.8134 36.3372 21.8174 36.5482 21.8601C37.4763 22.0551 37.9611 22.6788 37.9117 23.6203Z", fill: "#141A22" })
] }), Pj = () => /* @__PURE__ */ f.jsx("svg", { viewBox: "0 0 48 48", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ f.jsx("path", { d: "M29 13L19.5706 23.8438C19.2434 24.2201 19.2434 24.7799 19.5706 25.1562L29 36", stroke: "black" }) }), jj = () => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ f.jsx("path", { fill: "#21a366", d: "M28 15h16v9H28z" }),
      /* @__PURE__ */ f.jsx("path", { fill: "#185c37", d: "M44 24H12v16a2 2 0 0 0 2 2h28a2 2 0 0 0 2-2V24z" }),
      /* @__PURE__ */ f.jsx("path", { fill: "#107c42", d: "M28 24h16v9H28z" }),
      /* @__PURE__ */ f.jsx("path", { fill: "#3fa071", d: "M12 15h16v9H12z" }),
      /* @__PURE__ */ f.jsx("path", { fill: "#33c481", d: "M42 6H28v9h16V8a2 2 0 0 0-2-2z" }),
      /* @__PURE__ */ f.jsx("path", { fill: "#21a366", d: "M14 6h14v9H12V8a2 2 0 0 1 2-2z" }),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M22.319 13H12v24h10.319A3.68 3.68 0 0 0 26 33.319V16.681A3.68 3.68 0 0 0 22.319 13z",
          opacity: 0.05
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M22.213 36H12V13.333h10.213a3.12 3.12 0 0 1 3.121 3.121v16.425A3.122 3.122 0 0 1 22.213 36z",
          opacity: 0.07
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M22.106 35H12V13.667h10.106a2.56 2.56 0 0 1 2.56 2.56V32.44a2.56 2.56 0 0 1-2.56 2.56z",
          opacity: 0.09
        }
      ),
      /* @__PURE__ */ f.jsxs(
        "linearGradient",
        {
          id: "a",
          x1: 4.725,
          x2: 23.055,
          y1: 14.725,
          y2: 33.055,
          gradientUnits: "userSpaceOnUse",
          children: [
            /* @__PURE__ */ f.jsx("stop", { offset: 0, stopColor: "#18884f" }),
            /* @__PURE__ */ f.jsx("stop", { offset: 1, stopColor: "#0b6731" })
          ]
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "url(#a)",
          d: "M22 34H6a2 2 0 0 1-2-2V16a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2z"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "#fff",
          d: "M9.807 19h2.386l1.936 3.754L16.175 19h2.229l-3.071 5 3.141 5h-2.351l-2.11-3.93L11.912 29H9.526l3.193-5.018L9.807 19z"
        }
      )
    ]
  }
), Sj = () => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ f.jsxs(
        "linearGradient",
        {
          id: "a",
          x1: 28,
          x2: 28,
          y1: 14.966,
          y2: 6.45,
          gradientUnits: "userSpaceOnUse",
          children: [
            /* @__PURE__ */ f.jsx("stop", { offset: 0, stopColor: "#42a3f2" }),
            /* @__PURE__ */ f.jsx("stop", { offset: 1, stopColor: "#42a4eb" })
          ]
        }
      ),
      /* @__PURE__ */ f.jsx("path", { fill: "url(#a)", d: "M42 6H14a2 2 0 0 0-2 2v7.003h32V8a2 2 0 0 0-2-2z" }),
      /* @__PURE__ */ f.jsxs(
        "linearGradient",
        {
          id: "b",
          x1: 28,
          x2: 28,
          y1: 42,
          y2: 33.054,
          gradientUnits: "userSpaceOnUse",
          children: [
            /* @__PURE__ */ f.jsx("stop", { offset: 0, stopColor: "#11408a" }),
            /* @__PURE__ */ f.jsx("stop", { offset: 1, stopColor: "#103f8f" })
          ]
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "url(#b)",
          d: "M12 33.054V40a2 2 0 0 0 2 2h28a2 2 0 0 0 2-2v-6.946H12z"
        }
      ),
      /* @__PURE__ */ f.jsxs(
        "linearGradient",
        {
          id: "c",
          x1: 28,
          x2: 28,
          y1: -15.46,
          y2: -15.521,
          gradientUnits: "userSpaceOnUse",
          children: [
            /* @__PURE__ */ f.jsx("stop", { offset: 0, stopColor: "#3079d6" }),
            /* @__PURE__ */ f.jsx("stop", { offset: 1, stopColor: "#297cd2" })
          ]
        }
      ),
      /* @__PURE__ */ f.jsx("path", { fill: "url(#c)", d: "M12 15.003h32v9.002H12v-9.002z" }),
      /* @__PURE__ */ f.jsxs(
        "linearGradient",
        {
          id: "d",
          x1: 12,
          x2: 44,
          y1: 28.53,
          y2: 28.53,
          gradientUnits: "userSpaceOnUse",
          children: [
            /* @__PURE__ */ f.jsx("stop", { offset: 0, stopColor: "#1d59b3" }),
            /* @__PURE__ */ f.jsx("stop", { offset: 1, stopColor: "#195bbc" })
          ]
        }
      ),
      /* @__PURE__ */ f.jsx("path", { fill: "url(#d)", d: "M12 24.005h32v9.05H12v-9.05z" }),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M22.319 13H12v24h10.319A3.68 3.68 0 0 0 26 33.319V16.681A3.68 3.68 0 0 0 22.319 13z",
          opacity: 0.05
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M22.213 36H12V13.333h10.213a3.12 3.12 0 0 1 3.121 3.121v16.425A3.122 3.122 0 0 1 22.213 36z",
          opacity: 0.07
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M22.106 35H12V13.667h10.106a2.56 2.56 0 0 1 2.56 2.56V32.44a2.56 2.56 0 0 1-2.56 2.56z",
          opacity: 0.09
        }
      ),
      /* @__PURE__ */ f.jsxs(
        "linearGradient",
        {
          id: "e",
          x1: 4.744,
          x2: 23.494,
          y1: 14.744,
          y2: 33.493,
          gradientUnits: "userSpaceOnUse",
          children: [
            /* @__PURE__ */ f.jsx("stop", { offset: 0, stopColor: "#256ac2" }),
            /* @__PURE__ */ f.jsx("stop", { offset: 1, stopColor: "#1247ad" })
          ]
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "url(#e)",
          d: "M22 34H6a2 2 0 0 1-2-2V16a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2z"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "#fff",
          d: "m18.403 19-1.546 7.264L15.144 19h-2.187l-1.767 7.489L9.597 19H7.641l2.344 10h2.352l1.713-7.689L15.764 29h2.251l2.344-10h-1.956z"
        }
      ),
      " "
    ]
  }
), Ij = () => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 16 16",
    fill: "#9aa1ab",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ f.jsx(
        "path",
        {
          "fill-rule": "evenodd",
          d: "M4.406 1.342A5.53 5.53 0 0 1 8 0c2.69 0 4.923 2 5.166 4.579C14.758 4.804 16 6.137 16 7.773 16 9.569 14.502 11 12.687 11H10a.5.5 0 0 1 0-1h2.688C13.979 10 15 8.988 15 7.773c0-1.216-1.02-2.228-2.313-2.228h-.5v-.5C12.188 2.825 10.328 1 8 1a4.53 4.53 0 0 0-2.941 1.1c-.757.652-1.153 1.438-1.153 2.055v.448l-.445.049C2.064 4.805 1 5.952 1 7.318 1 8.785 2.23 10 3.781 10H6a.5.5 0 0 1 0 1H3.781C1.708 11 0 9.366 0 7.318c0-1.763 1.266-3.223 2.942-3.593.143-.863.698-1.723 1.464-2.383"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          "fill-rule": "evenodd",
          d: "M7.646 4.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 5.707V14.5a.5.5 0 0 1-1 0V5.707L5.354 7.854a.5.5 0 1 1-.708-.708z"
        }
      )
    ]
  }
), Bj = () => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    className: "w-full",
    viewBox: "4 4 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M17.4165 22C19.9478 22 21.9999 19.948 21.9999 17.4167C21.9999 14.8854 19.9478 12.8334 17.4165 12.8334C14.8852 12.8334 12.8332 14.8854 12.8332 17.4167C12.8332 19.948 14.8852 22 17.4165 22Z",
          stroke: "white",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M17.4167 15.6201V17.4166L18.6667 18.6666",
          stroke: "white",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M18.6667 7V8.66667",
          stroke: "white",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M10.3333 7V8.66667",
          stroke: "white",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M11.1922 22C10.6879 22 9.93149 22 8.92291 22C8.25427 22 8.01181 21.9348 7.76737 21.8125C7.52292 21.6902 7.33108 21.5107 7.20035 21.282C7.06962 21.0532 7 20.8264 7 20.2007V10.4658C7 9.84022 7.06962 9.61335 7.20035 9.38463C7.33108 9.15591 7.52292 8.97641 7.76737 8.85409C8.01181 8.73177 8.25427 8.66663 8.92291 8.66663H20.0771C20.7457 8.66663 20.9882 8.73177 21.2326 8.85409C21.4771 8.97641 21.6689 9.15591 21.7997 9.38463C21.9304 9.61335 22 10.5389 22 11.1645",
          stroke: "white",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      )
    ]
  }
), Nj = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 32 32",
    width: 20,
    height: 20,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M.13 31.978c0-.016.866-1.73 1.926-3.807a308.631 308.631 0 0 0 1.926-3.81c0-.019-.178-.319-.396-.667a15.211 15.211 0 0 1-2.337-8.148A15.413 15.413 0 0 1 4.603 5.91c.487-.616 1.747-1.886 2.33-2.347 2.31-1.83 4.817-2.9 7.736-3.305.889-.124 3.09-.105 4.007.034 6.824 1.03 12.03 6.256 13.053 13.102.138.923.158 3.134.036 4.022-.4 2.916-1.476 5.452-3.294 7.763-.46.586-1.724 1.85-2.339 2.34-2.763 2.199-6.096 3.368-9.599 3.366a15.074 15.074 0 0 1-8.119-2.346c-.347-.219-.646-.397-.664-.397-.018 0-1.726.87-3.796 1.933A332.966 332.966 0 0 1 .16 32.009a.03.03 0 0 1-.03-.03zm18.38-3.023c2.807-.414 5.266-1.618 7.329-3.586 2.877-2.747 4.356-6.362 4.22-10.321-.081-2.397-.72-4.544-1.954-6.58-1.074-1.77-2.757-3.458-4.52-4.537a13.489 13.489 0 0 0-10.896-1.418C8.162 3.863 4.592 7.61 3.422 12.24c-.366 1.45-.479 3.525-.275 5.083.3 2.291 1.246 4.58 2.679 6.475l.274.363-.936 1.845c-.515 1.014-.926 1.855-.913 1.867.013.013.85-.4 1.861-.916l1.838-.94.361.277c.548.418 1.48 1.01 2.08 1.32 1.213.63 2.942 1.179 4.293 1.363.993.136 2.834.126 3.826-.021zM8.27 17.336a1.876 1.876 0 0 1-1.351-1.95c.079-.99.865-1.72 1.858-1.726.772-.004 1.408.425 1.737 1.171.18.406.147 1.117-.069 1.546-.39.773-1.346 1.195-2.175.96zm7.701 0c-1.675-.476-1.852-2.789-.268-3.517.91-.418 2.013-.01 2.459.91.432.89-.01 2.106-.91 2.505-.355.158-.923.203-1.28.101zm7.677-.007c-.396-.125-.615-.26-.856-.528-.292-.325-.392-.527-.47-.945-.235-1.28.886-2.407 2.163-2.17.435.08.72.23 1.008.53.436.453.624 1.12.483 1.714-.247 1.049-1.348 1.71-2.328 1.4z",
        strokeWidth: "1"
      }
    )
  }
), _j = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    strokeWidth: 1.5,
    stroke: "currentColor",
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M15.666 3.888A2.25 2.25 0 0 0 13.5 2.25h-3c-1.03 0-1.9.693-2.166 1.638m7.332 0c.055.194.084.4.084.612v0a.75.75 0 0 1-.75.75H9a.75.75 0 0 1-.75-.75v0c0-.212.03-.418.084-.612m7.332 0c.646.049 1.288.11 1.927.184 1.1.128 1.907 1.077 1.907 2.185V19.5a2.25 2.25 0 0 1-2.25 2.25H6.75A2.25 2.25 0 0 1 4.5 19.5V6.257c0-1.108.806-2.057 1.907-2.185a48.208 48.208 0 0 1 1.927-.184"
      }
    )
  }
), Lj = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    strokeWidth: 1.5,
    stroke: "currentColor",
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M6.72 13.829c-.24.03-.48.062-.72.096m.72-.096a42.415 42.415 0 0 1 10.56 0m-10.56 0L6.34 18m10.94-4.171c.24.03.48.062.72.096m-.72-.096L17.66 18m0 0 .229 2.523a1.125 1.125 0 0 1-1.12 1.227H7.231c-.662 0-1.18-.568-1.12-1.227L6.34 18m11.318 0h1.091A2.25 2.25 0 0 0 21 15.75V9.456c0-1.081-.768-2.015-1.837-2.175a48.055 48.055 0 0 0-1.913-.247M6.34 18H5.25A2.25 2.25 0 0 1 3 15.75V9.456c0-1.081.768-2.015 1.837-2.175a48.041 48.041 0 0 1 1.913-.247m10.5 0a48.536 48.536 0 0 0-10.5 0m10.5 0V3.375c0-.621-.504-1.125-1.125-1.125h-8.25c-.621 0-1.125.504-1.125 1.125v3.659M18 10.5h.008v.008H18V10.5Zm-3 0h.008v.008H15V10.5Z"
      }
    )
  }
), Tj = () => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    className: "w-full",
    viewBox: "0 0 56 56",
    fill: "none",
    children: [
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M36.985 0H7.963C7.155 0 6.5.655 6.5 1.926V55c0 .345.655 1 1.463 1h40.074c.808 0 1.463-.655 1.463-1V12.978c0-.696-.093-.92-.257-1.085L37.607.257A.884.884 0 0 0 36.985 0z",
          style: {
            fill: "#e9e9e0"
          }
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M37.5.151V12h11.849z",
          style: {
            fill: "#d9d7ca"
          }
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M19.514 33.324c-.348 0-.682-.113-.967-.326-1.041-.781-1.181-1.65-1.115-2.242.182-1.628 2.195-3.332 5.985-5.068 1.504-3.296 2.935-7.357 3.788-10.75-.998-2.172-1.968-4.99-1.261-6.643.248-.579.557-1.023 1.134-1.215a4.91 4.91 0 0 1 1.016-.172c.504 0 .947.649 1.261 1.049.295.376.964 1.173-.373 6.802 1.348 2.784 3.258 5.62 5.088 7.562 1.311-.237 2.439-.358 3.358-.358 1.566 0 2.515.365 2.902 1.117.32.622.189 1.349-.39 2.16-.557.779-1.325 1.191-2.22 1.191-1.216 0-2.632-.768-4.211-2.285-2.837.593-6.15 1.651-8.828 2.822-.836 1.774-1.637 3.203-2.383 4.251-1.025 1.435-1.909 2.105-2.784 2.105zm2.662-5.126c-2.137 1.201-3.008 2.188-3.071 2.744-.01.092-.037.334.431.692.149-.047 1.019-.444 2.64-3.436zm13.637-4.442c.815.627 1.014.944 1.547.944.234 0 .901-.01 1.21-.441.149-.209.207-.343.23-.415-.123-.065-.286-.197-1.175-.197-.505.001-1.14.023-1.812.109zm-7.47-6.582a71.291 71.291 0 0 1-2.674 7.564 49.966 49.966 0 0 1 6.496-2.02c-1.35-1.568-2.699-3.526-3.822-5.544zm-.607-8.462c-.098.033-1.33 1.757.096 3.216.949-2.115-.053-3.23-.096-3.216zM48.037 56H7.963A1.463 1.463 0 0 1 6.5 54.537V39h43v15.537c0 .808-.655 1.463-1.463 1.463z",
          style: {
            fill: "#cc4b4c"
          }
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M17.385 53h-1.641V42.924h2.898c.428 0 .852.068 1.271.205.419.137.795.342 1.128.615.333.273.602.604.807.991s.308.822.308 1.306c0 .511-.087.973-.26 1.388a2.9 2.9 0 0 1-.725 1.046c-.31.282-.684.501-1.121.656s-.921.232-1.449.232h-1.217V53zm0-8.832v3.992h1.504c.2 0 .398-.034.595-.103.196-.068.376-.18.54-.335.164-.155.296-.371.396-.649.1-.278.15-.622.15-1.032 0-.164-.023-.354-.068-.567a1.637 1.637 0 0 0-.28-.615 1.657 1.657 0 0 0-.595-.492c-.255-.132-.593-.198-1.012-.198h-1.23zM32.219 47.682c0 .829-.089 1.538-.267 2.126s-.403 1.08-.677 1.477-.581.709-.923.937-.672.398-.991.513a4.094 4.094 0 0 1-.875.219c-.264.03-.46.046-.588.046h-3.814V42.924h3.035c.848 0 1.593.135 2.235.403s1.176.627 1.6 1.073.74.955.95 1.524c.21.57.315 1.156.315 1.758zm-4.867 4.115c1.112 0 1.914-.355 2.406-1.066s.738-1.741.738-3.09c0-.419-.05-.834-.15-1.244-.101-.41-.294-.781-.581-1.114s-.677-.602-1.169-.807-1.13-.308-1.914-.308h-.957v7.629h1.627zM36.266 44.168v3.172h4.211v1.121h-4.211V53h-1.668V42.924H40.9v1.244h-4.634z",
          style: {
            fill: "#fff"
          }
        }
      )
    ]
  }
), Rj = () => /* @__PURE__ */ f.jsxs("svg", { className: "w-full", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ f.jsx("g", { clipPath: "url(#clip0_1441_2226)", children: /* @__PURE__ */ f.jsx("path", { d: "M16.4808 2.685C14.75 0.954167 12.4475 0 10 0C7.5525 0 5.25 0.954167 3.51833 2.685C-0.055837 6.25917 -0.055837 12.0742 3.54166 15.6717L6.82666 18.7067C7.68 19.5408 8.8075 20.0008 10 20.0008C11.1925 20.0008 12.3192 19.5408 13.155 18.7233L16.4808 15.65C20.055 12.0758 20.055 6.26 16.4808 2.68583V2.685ZM15.3258 14.4475L12.0067 17.515C10.9275 18.5717 9.09 18.5875 7.975 17.4983L4.69583 14.47C1.77166 11.545 1.77166 6.7875 4.69583 3.8625C6.1125 2.44667 7.99666 1.66583 9.99916 1.66583C12.0017 1.66583 13.885 2.44667 15.3017 3.8625C18.2258 6.7875 18.2258 11.545 15.325 14.4467L15.3258 14.4475ZM9.16583 9.58333V5C9.16583 4.53917 9.53833 4.16667 9.99916 4.16667C10.46 4.16667 10.8325 4.53917 10.8325 5V9.58333C10.8325 10.0442 10.46 10.4167 9.99916 10.4167C9.53833 10.4167 9.16583 10.0442 9.16583 9.58333ZM11.2492 12.9167C11.2492 13.6067 10.6892 14.1667 9.99916 14.1667C9.30916 14.1667 8.74916 13.6067 8.74916 12.9167C8.74916 12.2267 9.30916 11.6667 9.99916 11.6667C10.6892 11.6667 11.2492 12.2267 11.2492 12.9167Z", fill: "currentColor" }) }),
  /* @__PURE__ */ f.jsx("defs", { children: /* @__PURE__ */ f.jsx("clipPath", { id: "clip0_1441_2226", children: /* @__PURE__ */ f.jsx("rect", { width: "20", height: "20", fill: "currentColor" }) }) })
] }), $j = () => /* @__PURE__ */ f.jsxs("svg", { viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ f.jsx(
    "path",
    {
      d: "M8.021 11.9 3.453 8.62a.72.72 0 0 1 0-1.238L8.021 4.1a.716.716 0 0 1 1.079.619V6c1.5 0 6 0 7 8-2.5-4.5-7-4-7-4v1.281c0 .56-.606.898-1.079.62z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ f.jsx(
    "path",
    {
      d: "M5.232 4.293a.5.5 0 0 1-.106.7L1.114 7.945l-.042.028a.147.147 0 0 0 0 .252l.042.028 4.012 2.954a.5.5 0 1 1-.593.805L.539 9.073a1.147 1.147 0 0 1 0-1.946l3.994-2.94a.5.5 0 0 1 .699.106",
      fill: "currentColor"
    }
  )
] }), Fj = () => /* @__PURE__ */ f.jsx("svg", { className: "w-full", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ f.jsx("path", { d: "M13.29063 3.29018C13.38436 3.38315 13.45875 3.49375 13.50952 3.61561C13.56029 3.73747 13.58643 3.86817 13.58643 4.00018C13.58643 4.1322 13.56029 4.2629 13.50952 4.38476C13.45875 4.50662 13.38436 4.61722 13.29063 4.71018L8.71063 9.29018C8.61689 9.38315 8.5425 9.49375 8.49173 9.61561C8.44096 9.73747 8.41482 9.86817 8.41482 10.0002C8.41482 10.1322 8.44096 10.2629 8.49173 10.3848C8.5425 10.5066 8.61689 10.6172 8.71063 10.7102L13.29063 15.2902C13.38436 15.3831 13.45875 15.4937 13.50952 15.6156C13.56029 15.7375 13.58643 15.8682 13.58643 16.0002C13.58643 16.1322 13.56029 16.2629 13.50952 16.3848C13.45875 16.5066 13.38436 16.6172 13.29063 16.7102C13.1033 16.8964 12.8498 17.001 12.5856 17.001C12.3214 17.001 12.0679 16.8964 11.8806 16.7102L7.29063 12.1202C6.72882 11.5577 6.41329 10.7952 6.41329 10.0002C6.41329 9.20518 6.72882 8.44269 7.29063 7.88018L11.8806 3.29018C12.0679 3.10393 12.3214 2.99939 12.5856 2.99939C12.8498 2.99939 13.1033 3.10393 13.29063 3.29018Z", fill: "currentColor" }) }), Hj = () => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ f.jsx(
        "rect",
        {
          x: "2",
          y: "2",
          width: "20",
          height: "20",
          stroke: "currentColor",
          strokeWidth: "2"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M12 16V8M12 8l-4 4M12 8l4 4",
          stroke: "currentColor",
          strokeWidth: "2",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      )
    ]
  }
), Yj = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        d: "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.418 0-8-3.582-8-8s3.582-8 8-8 8 3.582 8 8-3.582 8-8 8zm-.5-13h-1v6h4v-1.5h-2.5z",
        fill: "currentColor"
      }
    )
  }
), Vj = () => /* @__PURE__ */ f.jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", width: "20", height: "20", fill: "currentColor", className: "bi bi-window-stack", viewBox: "0 0 16 16", children: [
  /* @__PURE__ */ f.jsx("path", { d: "M4.5 6a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1M6 6a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1m2-.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0" }),
  /* @__PURE__ */ f.jsx("path", { d: "M12 1a2 2 0 0 1 2 2 2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2 2 2 0 0 1-2-2V3a2 2 0 0 1 2-2zM2 12V5a2 2 0 0 1 2-2h9a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1m1-4v5a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V8zm12-1V5a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v2z" })
] }), kj = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        d: "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.418 0-8-3.582-8-8s3.582-8 8-8 8 3.582 8 8-3.582 8-8 8zm-2.5-5l5-3-5-3v6z",
        fill: "currentColor"
      }
    )
  }
), Gj = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        d: "M11.0833 1.16669H5.83333C4.22333 1.16669 2.91667 2.47335 2.91667 4.08335V7.58335C2.91667 9.19335 4.22333 10.5 5.83333 10.5H11.0833C12.6933 10.5 14 9.19335 14 7.58335V4.08335C14 2.47335 12.6933 1.16669 11.0833 1.16669ZM5.83333 2.33335H11.0833C11.8417 2.33335 12.4833 2.82335 12.7283 3.50002H4.18833C4.4275 2.82335 5.06917 2.33335 5.83333 2.33335ZM11.0833 9.33335H5.83333C4.87083 9.33335 4.08333 8.54585 4.08333 7.58335V4.66669H12.8333V7.58335C12.8333 8.54585 12.0458 9.33335 11.0833 9.33335ZM9.91667 12.25C9.91667 12.5709 9.65417 12.8334 9.33333 12.8334H2.91667C1.30667 12.8334 0 11.5267 0 9.91669V5.62919C0 4.91752 0.256667 4.23502 0.729167 3.69835C0.945 3.45919 1.3125 3.43585 1.55167 3.64585C1.79667 3.86169 1.81417 4.22919 1.60417 4.46835C1.32417 4.78919 1.16667 5.19752 1.16667 5.62335V9.91085C1.16667 10.8734 1.95417 11.6609 2.91667 11.6609H9.33333C9.65417 11.6609 9.91667 11.9234 9.91667 12.2442V12.25Z",
        fill: "currentColor"
      }
    )
  }
), Wj = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsxs("g", { id: "Vector", children: [
      /* @__PURE__ */ f.jsx("path", { d: "M23.71 20.3C23.52 20.11 23.27 20.01 23 20.01C22.73 20.01 22.48 20.12 22.29 20.3C22.1 20.48 22 20.74 22 21.01C22 21.28 21.63 21.69 21 21.89V23.28C21 23.52 20.95 23.75 20.86 23.96C22.62 23.72 24 22.47 24 21.01C24 20.74 23.89 20.49 23.71 20.3Z", fill: "currentColor" }),
      /* @__PURE__ */ f.jsx("path", { d: "M15 23.28V21.99C14.92 21.99 14.83 22.01 14.75 22.01C13.66 22.01 13 21.32 13 21.01V11.39L14.99 12.04C15.83 11.4 16.87 11 18 11C18.71 11 19.39 11.15 20 11.42V9C20 7.94 19.58 6.92 18.83 6.17C18.08 5.42 17.06 5 16 5V4C16 2.94 15.58 1.92 14.83 1.17C14.08 0.42 13.06 0 12 0C10.94 0 9.92 0.42 9.17 1.17C8.42 1.92 8 2.94 8 4V5C6.94 5 5.92 5.42 5.17 6.17C4.42 6.92 4 7.94 4 9V11.57C3.32 11.8 2.75 12.27 2.39 12.89C2.03 13.51 1.9 14.24 2.03 14.94C2.47 17.27 3.58 19.42 5.22 21.12C5.27 21.18 5.31 21.24 5.35 21.31C5.15 21.54 4.91 21.72 4.63 21.83C4.35 21.95 4.05 22 3.75 21.99C2.66 21.99 2 21.3 2 20.99C2 20.72 1.89 20.47 1.71 20.28C1.52 20.09 1.27 19.99 1 19.99C0.73 19.99 0.48 20.1 0.29 20.28C0.1 20.47 0 20.72 0 20.99C0 22.62 1.72 23.99 3.75 23.99C4.76 23.99 5.74 23.64 6.51 22.99C7.28 23.63 8.25 23.99 9.25 23.99C10.25 23.99 11.22 23.65 12 23.01C12.78 23.65 13.75 23.99 14.75 23.99C14.88 23.99 15.01 23.97 15.15 23.95C15.06 23.74 15 23.5 15 23.26V23.28ZM10 4.01C10 3.48 10.21 2.97 10.59 2.6C10.97 2.22 11.47 2.01 12 2.01C12.53 2.01 13.04 2.22 13.41 2.6C13.79 2.98 14 3.48 14 4.01V5.01H10V4.01ZM11 21.01C11 21.35 10.32 22.01 9.25 22.01C8.92 22.03 8.58 21.96 8.28 21.81C7.98 21.66 7.72 21.44 7.54 21.16C7.33 20.66 7.05 20.2 6.69 19.79C5.31 18.36 4.38 16.57 4 14.62C3.95 14.38 4 14.13 4.12 13.92C4.24 13.71 4.44 13.55 4.67 13.47L11.01 11.4V21.02L11 21.01ZM11.06 9.27L6 10.92V9.01C6 8.48 6.21 7.97 6.59 7.6C6.97 7.22 7.47 7.01 8 7.01H16C16.53 7.01 17.04 7.22 17.41 7.6C17.79 7.98 18 8.48 18 9.01V10.93L12.95 9.27C12.34 9.07 11.67 9.07 11.06 9.27Z", fill: "currentColor" }),
      /* @__PURE__ */ f.jsx("path", { d: "M18 12.01C15.79 12.01 14 13.8 14 16.01C14 17.49 14.81 18.78 16 19.47V23.28C16 23.92 16.78 24.24 17.23 23.79L18 23.02L18.77 23.79C19.22 24.24 20 23.92 20 23.28V19.47C21.19 18.78 22 17.48 22 16.01C22 13.8 20.21 12.01 18 12.01ZM18 18.01C16.9 18.01 16 17.11 16 16.01C16 14.91 16.9 14.01 18 14.01C19.1 14.01 20 14.91 20 16.01C20 17.11 19.1 18.01 18 18.01Z", fill: "currentColor" })
    ] })
  }
), Qj = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        d: "M19.5 0H12.5C10.019 0 8 2.019 8 4.5V15.5C8 17.43 9.57 19 11.5 19H19.5C21.981 19 24 16.981 24 14.5V4.5C24 2.019 21.981 0 19.5 0ZM12.5 2H19.5C20.878 2 22 3.121 22 4.5V12H11.5C10.964 12 10.455 12.122 10 12.338V4.5C10 3.121 11.122 2 12.5 2ZM19.5 17H11.5C10.673 17 10 16.327 10 15.5C10 14.673 10.673 14 11.5 14H22V14.5C22 15.879 20.878 17 19.5 17ZM14.663 21.3C15.05 21.695 15.044 22.327 14.649 22.714C13.803 23.543 12.685 24 11.5 24H3.5C1.57 24 0 22.43 0 20.5V9.5C0 7.019 2.019 5 4.5 5H5C5.552 5 6 5.447 6 6C6 6.553 5.552 7 5 7H4.5C3.122 7 2 8.121 2 9.5V17.338C2.455 17.121 2.964 17 3.5 17H5C5.552 17 6 17.447 6 18C6 18.553 5.552 19 5 19H3.5C2.673 19 2 19.673 2 20.5C2 21.327 2.673 22 3.5 22H11.5C12.158 22 12.78 21.746 13.249 21.286C13.644 20.898 14.276 20.906 14.663 21.3Z",
        fill: "currentColor"
      }
    )
  }
), Uj = () => /* @__PURE__ */ f.jsx("svg", { className: "w-full", viewBox: "0 0 24 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ f.jsx(
  "path",
  {
    d: "M22.61 16.1623C21.46 15.7473 20.019 15.2563 18.385 14.7613L21.462 3.22227C21.664 2.46527 21.506 1.67527 21.029 1.05427C20.551 0.434271 19.83 0.0772705 19.047 0.0772705H18.749C17.34 0.0772705 15.994 0.75027 15.149 1.87827L9.298 9.67827C8.124 11.2433 6.342 12.0773 5.506 12.0773H1C0.447 12.0773 0 12.5243 0 13.0773C0 13.6303 0.447 14.0773 1 14.0773H3.008C9.909 14.0773 17.826 16.5613 21.932 18.0433C21.961 18.0543 22.001 18.0683 22 18.1393C22 18.2103 21.96 18.2243 21.931 18.2343C17.827 19.6703 9.91 22.0783 3.008 22.0783H1C0.447 22.0783 0 22.5253 0 23.0783C0 23.6313 0.447 24.0783 1 24.0783H3.008C10.204 24.0783 18.366 21.5993 22.591 20.1223C23.444 19.8243 23.996 19.0503 24 18.1493C24.004 17.2483 23.459 16.4683 22.61 16.1633V16.1623ZM10.899 10.8773L16.75 3.07727C17.22 2.45127 17.968 2.07727 18.75 2.07727H19.048C19.262 2.07727 19.388 2.19927 19.444 2.27227C19.5 2.34527 19.586 2.49927 19.531 2.70627L16.465 14.2043C14.219 13.5823 11.72 12.9983 9.173 12.6003C9.796 12.1313 10.392 11.5563 10.9 10.8783L10.899 10.8773ZM8 19.0773C7.447 19.0773 7 18.6303 7 18.0773C7 17.5243 7.447 17.0773 8 17.0773H13C13.553 17.0773 14 17.5243 14 18.0773C14 18.6303 13.553 19.0773 13 19.0773H8Z",
    fill: "currentColor"
  }
) }), Zj = () => /* @__PURE__ */ f.jsx("svg", { className: "w-full", viewBox: "0 0 24 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ f.jsx(
  "path",
  {
    d: "M21 24.0773C19.346 24.0773 18 22.7313 18 21.0773V13.0773C18 12.5263 17.552 12.0773 17 12.0773H7C6.448 12.0773 6 12.5263 6 13.0773V21.0773C6 22.7313 4.654 24.0773 3 24.0773C1.346 24.0773 0 22.7313 0 21.0773V9.80125C0 8.13625 0.824 6.58725 2.203 5.65625L9.203 0.932254C10.902 -0.213746 13.098 -0.213746 14.797 0.932254L21.797 5.65625C23.176 6.58725 24 8.13625 24 9.80125V21.0773C24 22.7313 22.654 24.0773 21 24.0773ZM7 10.0773H17C18.654 10.0773 20 11.4233 20 13.0773V21.0773C20 21.6283 20.448 22.0773 21 22.0773C21.552 22.0773 22 21.6283 22 21.0773V9.80125C22 8.80225 21.506 7.87225 20.678 7.31425L13.678 2.59025C12.658 1.90225 11.342 1.90225 10.323 2.59025L3.322 7.31425C2.494 7.87225 2 8.80225 2 9.80125V21.0773C2 21.6283 2.448 22.0773 3 22.0773C3.552 22.0773 4 21.6283 4 21.0773V13.0773C4 11.4233 5.346 10.0773 7 10.0773ZM11 23.0773V21.0773C11 20.5253 10.553 20.0773 10 20.0773H9C8.447 20.0773 8 20.5253 8 21.0773V23.0773C8 23.6293 8.447 24.0773 9 24.0773H10C10.553 24.0773 11 23.6293 11 23.0773ZM11 17.0773V15.0773C11 14.5253 10.553 14.0773 10 14.0773H9C8.447 14.0773 8 14.5253 8 15.0773V17.0773C8 17.6293 8.447 18.0773 9 18.0773H10C10.553 18.0773 11 17.6293 11 17.0773ZM16 23.0773V21.0773C16 20.5253 15.553 20.0773 15 20.0773H14C13.447 20.0773 13 20.5253 13 21.0773V23.0773C13 23.6293 13.447 24.0773 14 24.0773H15C15.553 24.0773 16 23.6293 16 23.0773Z",
    fill: "currentColor"
  }
) }), zj = () => /* @__PURE__ */ f.jsx("svg", { className: "w-full", viewBox: "0 0 14 12", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ f.jsx(
  "path",
  {
    d: "M1 5.00513H11L7.71 1.71513C7.61627 1.62216 7.54188 1.51156 7.49111 1.3897C7.44034 1.26784 7.4142 1.13714 7.4142 1.00513C7.4142 0.873114 7.44034 0.742408 7.49111 0.620549C7.54188 0.49869 7.61627 0.388089 7.71 0.295126C7.89736 0.108875 8.15081 0.0043335 8.415 0.0043335C8.67919 0.0043335 8.93264 0.108875 9.12 0.295126L13.41 4.59513C13.7856 4.96848 13.9978 5.47555 14 6.00513C13.9951 6.53123 13.7832 7.03423 13.41 7.40513L9.12 11.7051C9.02676 11.7977 8.9162 11.871 8.79463 11.9209C8.67306 11.9707 8.54286 11.9961 8.41146 11.9957C8.28007 11.9952 8.15005 11.9689 8.02884 11.9182C7.90762 11.8675 7.79758 11.7934 7.705 11.7001C7.61242 11.6069 7.53911 11.4963 7.48925 11.3748C7.4394 11.2532 7.41398 11.123 7.41444 10.9916C7.41491 10.8602 7.44125 10.7302 7.49196 10.609C7.54267 10.4877 7.61676 10.3777 7.71 10.2851L11 7.00513H1C0.734783 7.00513 0.480429 6.89977 0.292892 6.71223C0.105356 6.5247 0 6.27034 0 6.00513C0 5.73991 0.105356 5.48556 0.292892 5.29802C0.480429 5.11048 0.734783 5.00513 1 5.00513Z",
    fill: "currentColor"
  }
) }), Kj = () => /* @__PURE__ */ f.jsx("svg", { className: "w-full", viewBox: "0 0 20 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ f.jsx(
  "path",
  {
    d: "M17.949 5.536L14.465 2.05C13.142 0.728 11.384 0 9.515 0H5C2.243 0 0 2.243 0 5V19C0 21.757 2.243 24 5 24H15C17.757 24 20 21.757 20 19V10.485C20 8.614 19.271 6.858 17.949 5.536ZM16.535 6.951C16.853 7.268 17.122 7.621 17.34 8.001H12.999C12.447 8.001 11.999 7.552 11.999 7.001V2.659C12.379 2.877 12.732 3.146 13.05 3.464L16.535 6.951ZM18 19.001C18 20.655 16.654 22.001 15 22.001H5C3.346 22.001 2 20.655 2 19.001V5C2 3.346 3.346 2 5 2H9.515C9.678 2 9.84 2.008 10 2.023V7C10 8.654 11.346 10 13 10H17.977C17.992 10.16 18 10.322 18 10.485V19.001ZM13.707 16.106C14.098 16.496 14.098 17.129 13.707 17.52L12.094 19.134C11.517 19.711 10.758 20 10 20C9.242 20 8.483 19.711 7.906 19.134L6.293 17.52C5.902 17.129 5.902 16.496 6.293 16.106C6.684 15.715 7.316 15.715 7.707 16.106L9 17.399V13.001C9 12.449 9.447 12.001 10 12.001C10.553 12.001 11 12.449 11 13.001V17.399L12.293 16.106C12.684 15.715 13.316 15.715 13.707 16.106Z",
    fill: "currentColor"
  }
) }), qj = () => /* @__PURE__ */ f.jsx("svg", { className: "w-full", viewBox: "0 0 25 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ f.jsx(
  "path",
  {
    d: "M18.86 5.14152C18.528 5.07552 18.257 4.86852 18.118 4.57252C16.566 1.30152 12.975 -0.527481 9.38301 0.134519C6.11101 0.734519 3.54601 3.34652 2.99901 6.63552C2.83701 7.60652 2.84901 8.57852 3.03201 9.52552C3.09201 9.83452 2.95901 10.1785 2.68601 10.4265C1.54101 11.4675 0.88501 12.9505 0.88501 14.4965C0.88501 17.5285 3.35201 19.9965 6.38501 19.9965H17.385C21.521 19.9965 24.885 16.6325 24.885 12.4965C24.885 8.93152 22.351 5.83852 18.859 5.14252L18.86 5.14152ZM17.386 17.9955H6.38601C4.45601 17.9955 2.88601 16.4255 2.88601 14.4955C2.88601 13.5125 3.30401 12.5675 4.03201 11.9055C4.81801 11.1905 5.18701 10.1325 4.99501 9.14252C4.85701 8.43052 4.84901 7.69752 4.97101 6.96152C5.37401 4.53952 7.33601 2.54052 9.74201 2.09952C10.127 2.02952 10.51 1.99552 10.887 1.99552C13.199 1.99552 15.293 3.28452 16.309 5.42952C16.723 6.30152 17.509 6.91052 18.467 7.10252C21.026 7.61352 22.884 9.88052 22.884 12.4965C22.884 15.5285 20.417 17.9965 17.384 17.9965L17.386 17.9955ZM16.007 11.2885C16.398 11.6795 16.398 12.3115 16.007 12.7025L13.3 15.4095C12.913 15.7965 12.404 15.9915 11.895 15.9935L11.886 15.9955L11.877 15.9935C11.368 15.9915 10.859 15.7965 10.472 15.4095L7.76501 12.7025C7.37401 12.3115 7.37401 11.6795 7.76501 11.2885C8.15601 10.8975 8.78801 10.8975 9.17901 11.2885L10.886 12.9955V7.99552C10.886 7.44252 11.334 6.99552 11.886 6.99552C12.438 6.99552 12.886 7.44252 12.886 7.99552V12.9955L14.593 11.2885C14.984 10.8975 15.616 10.8975 16.007 11.2885Z",
    fill: "currentColor"
  }
) }), Xj = () => /* @__PURE__ */ f.jsxs("svg", { className: "w-full", viewBox: "0 0 25 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ f.jsx(
    "path",
    {
      d: "M16.885 8C16.6975 7.81253 16.4432 7.70721 16.178 7.70721C15.9128 7.70721 15.6585 7.81253 15.471 8L12.885 10.586L10.299 8C10.1104 7.81784 9.85781 7.71705 9.59561 7.71933C9.33341 7.7216 9.0826 7.82677 8.89719 8.01218C8.71178 8.19759 8.60661 8.4484 8.60434 8.7106C8.60206 8.9728 8.70285 9.2254 8.88501 9.414L11.471 12L8.88501 14.586C8.70285 14.7746 8.60206 15.0272 8.60434 15.2894C8.60661 15.5516 8.71178 15.8024 8.89719 15.9878C9.0826 16.1732 9.33341 16.2784 9.59561 16.2807C9.85781 16.283 10.1104 16.1822 10.299 16L12.885 13.414L15.471 16C15.6596 16.1822 15.9122 16.283 16.1744 16.2807C16.4366 16.2784 16.6874 16.1732 16.8728 15.9878C17.0582 15.8024 17.1634 15.5516 17.1657 15.2894C17.168 15.0272 17.0672 14.7746 16.885 14.586L14.299 12L16.885 9.414C17.0725 9.22647 17.1778 8.97216 17.1778 8.707C17.1778 8.44184 17.0725 8.18753 16.885 8Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ f.jsx(
    "path",
    {
      d: "M12.885 0C10.5116 0 8.19156 0.703788 6.21817 2.02236C4.24478 3.34094 2.70671 5.21509 1.79846 7.4078C0.890209 9.60051 0.652569 12.0133 1.11559 14.3411C1.57861 16.6689 2.7215 18.8071 4.39973 20.4853C6.07796 22.1635 8.21616 23.3064 10.5439 23.7694C12.8717 24.2324 15.2845 23.9948 17.4772 23.0866C19.6699 22.1783 21.5441 20.6402 22.8626 18.6668C24.1812 16.6935 24.885 14.3734 24.885 12C24.8816 8.81846 23.6162 5.76821 21.3665 3.51852C19.1168 1.26883 16.0666 0.00344108 12.885 0ZM12.885 22C10.9072 22 8.9738 21.4135 7.32931 20.3147C5.68482 19.2159 4.4031 17.6541 3.64622 15.8268C2.88934 13.9996 2.69131 11.9889 3.07716 10.0491C3.46301 8.10929 4.41542 6.32746 5.81395 4.92893C7.21247 3.53041 8.9943 2.578 10.9341 2.19215C12.8739 1.8063 14.8846 2.00433 16.7119 2.7612C18.5391 3.51808 20.1009 4.79981 21.1997 6.4443C22.2985 8.08879 22.885 10.0222 22.885 12C22.8821 14.6513 21.8276 17.1931 19.9529 19.0679C18.0781 20.9426 15.5363 21.9971 12.885 22Z",
      fill: "currentColor"
    }
  )
] }), Jj = () => /* @__PURE__ */ f.jsx("svg", { className: "w-full", viewBox: "0 0 25 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ f.jsx(
  "path",
  {
    d: "M4.88501 14V21C4.88501 21.552 4.43701 22 3.88501 22C3.33301 22 2.88501 21.552 2.88501 21V14C2.88501 13.448 3.33301 13 3.88501 13C4.43701 13 4.88501 13.448 4.88501 14ZM18.885 13C18.333 13 17.885 13.448 17.885 14V21C17.885 21.552 18.333 22 18.885 22C19.437 22 19.885 21.552 19.885 21V14C19.885 13.448 19.437 13 18.885 13ZM10.885 13C10.333 13 9.88501 13.448 9.88501 14V21C9.88501 21.552 10.333 22 10.885 22C11.437 22 11.885 21.552 11.885 21V14C11.885 13.448 11.437 13 10.885 13ZM7.38501 13C6.55601 13 5.88501 13.671 5.88501 14.5V20.5C5.88501 21.329 6.55601 22 7.38501 22C8.21401 22 8.88501 21.329 8.88501 20.5V14.5C8.88501 13.671 8.21401 13 7.38501 13ZM15.385 13C14.556 13 13.885 13.671 13.885 14.5V20.5C13.885 21.329 14.556 22 15.385 22C16.214 22 16.885 21.329 16.885 20.5V14.5C16.885 13.671 16.214 13 15.385 13ZM21.885 13C21.333 13 20.885 13.448 20.885 14V21C20.885 21.552 21.333 22 21.885 22C22.437 22 22.885 21.552 22.885 21V14C22.885 13.448 22.437 13 21.885 13ZM23.885 9H22.885V1C22.885 0.448 22.437 0 21.885 0C21.333 0 20.885 0.448 20.885 1V9H19.885V1C19.885 0.448 19.437 0 18.885 0C18.333 0 17.885 0.448 17.885 1V9H16.885V1.5C16.885 0.671 16.214 0 15.385 0C14.556 0 13.885 0.671 13.885 1.5V9H11.885V1C11.885 0.448 11.437 0 10.885 0C10.333 0 9.88501 0.448 9.88501 1V9H8.88501V1.5C8.88501 0.671 8.21401 0 7.38501 0C6.55601 0 5.88501 0.671 5.88501 1.5V9H4.88501V1C4.88501 0.448 4.43701 0 3.88501 0C3.33301 0 2.88501 0.448 2.88501 1V9H1.88501C1.33301 9 0.88501 9.448 0.88501 10C0.88501 10.552 1.33301 11 1.88501 11H23.885C24.437 11 24.885 10.552 24.885 10C24.885 9.448 24.437 9 23.885 9Z",
    fill: "currentColor"
  }
) }), eS = () => /* @__PURE__ */ f.jsxs("svg", { className: "w-full", viewBox: "0 0 25 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ f.jsx("path", { d: "M18.885 19C19.0828 19 19.2761 18.9413 19.4405 18.8314C19.6049 18.7215 19.733 18.5654 19.8087 18.3827C19.8844 18.2 19.9042 17.9989 19.8656 17.805C19.827 17.611 19.7318 17.4328 19.592 17.293L13.42 11.122C12.4824 10.1846 11.2108 9.65807 9.88501 9.65807C8.55919 9.65807 7.28765 10.1846 6.35001 11.122L4.17801 13.293C3.99585 13.4816 3.89506 13.7342 3.89734 13.9964C3.89961 14.2586 4.00478 14.5094 4.19019 14.6948C4.3756 14.8802 4.62641 14.9854 4.88861 14.9877C5.15081 14.99 5.40341 14.8892 5.59201 14.707L7.76401 12.536C8.33523 11.9901 9.09491 11.6855 9.88501 11.6855C10.6751 11.6855 11.4348 11.9901 12.006 12.536L18.178 18.707C18.3655 18.8946 18.6198 18.9999 18.885 19Z", fill: "currentColor" }),
  /* @__PURE__ */ f.jsx("path", { d: "M16.885 10.5C17.5772 10.5 18.2539 10.2947 18.8295 9.91014C19.4051 9.52556 19.8537 8.97893 20.1186 8.33939C20.3835 7.69985 20.4528 6.99612 20.3178 6.31718C20.1827 5.63825 19.8494 5.01461 19.3599 4.52513C18.8704 4.03564 18.2468 3.7023 17.5678 3.56725C16.8889 3.4322 16.1852 3.50151 15.5456 3.76642C14.9061 4.03133 14.3595 4.47993 13.9749 5.0555C13.5903 5.63108 13.385 6.30777 13.385 7C13.385 7.92826 13.7538 8.8185 14.4101 9.47487C15.0665 10.1313 15.9568 10.5 16.885 10.5ZM16.885 5.5C17.1817 5.5 17.4717 5.58797 17.7184 5.7528C17.965 5.91762 18.1573 6.15189 18.2708 6.42597C18.3844 6.70006 18.4141 7.00166 18.3562 7.29264C18.2983 7.58361 18.1554 7.85088 17.9457 8.06066C17.7359 8.27044 17.4686 8.4133 17.1776 8.47118C16.8867 8.52906 16.5851 8.49935 16.311 8.38582C16.0369 8.27229 15.8026 8.08003 15.6378 7.83335C15.473 7.58668 15.385 7.29667 15.385 7C15.385 6.60218 15.543 6.22064 15.8243 5.93934C16.1057 5.65804 16.4872 5.5 16.885 5.5Z", fill: "currentColor" }),
  /* @__PURE__ */ f.jsx("path", { d: "M23.885 16C23.6198 16 23.3654 16.1054 23.1779 16.2929C22.9904 16.4804 22.885 16.7348 22.885 17V19C22.885 19.7957 22.5689 20.5587 22.0063 21.1213C21.4437 21.6839 20.6807 22 19.885 22H17.885C17.6198 22 17.3654 22.1054 17.1779 22.2929C16.9904 22.4804 16.885 22.7348 16.885 23C16.885 23.2652 16.9904 23.5196 17.1779 23.7071C17.3654 23.8946 17.6198 24 17.885 24H19.885C21.2106 23.9984 22.4815 23.4711 23.4188 22.5338C24.3561 21.5964 24.8834 20.3256 24.885 19V17C24.885 16.7348 24.7797 16.4804 24.5921 16.2929C24.4046 16.1054 24.1502 16 23.885 16Z", fill: "currentColor" }),
  /* @__PURE__ */ f.jsx("path", { d: "M1.88501 8C2.15023 8 2.40458 7.89464 2.59212 7.70711C2.77965 7.51957 2.88501 7.26522 2.88501 7V5C2.88501 4.20435 3.20108 3.44129 3.76369 2.87868C4.3263 2.31607 5.08936 2 5.88501 2H7.88501C8.15023 2 8.40458 1.89464 8.59212 1.70711C8.77965 1.51957 8.88501 1.26522 8.88501 1C8.88501 0.734784 8.77965 0.48043 8.59212 0.292893C8.40458 0.105357 8.15023 0 7.88501 0H5.88501C4.55941 0.00158786 3.28857 0.528882 2.35123 1.46622C1.41389 2.40356 0.886598 3.67441 0.88501 5V7C0.88501 7.26522 0.990367 7.51957 1.1779 7.70711C1.36544 7.89464 1.61979 8 1.88501 8Z", fill: "currentColor" }),
  /* @__PURE__ */ f.jsx("path", { d: "M7.88501 22H5.88501C5.08936 22 4.3263 21.6839 3.76369 21.1213C3.20108 20.5587 2.88501 19.7957 2.88501 19V17C2.88501 16.7348 2.77965 16.4804 2.59212 16.2929C2.40458 16.1054 2.15023 16 1.88501 16C1.61979 16 1.36544 16.1054 1.1779 16.2929C0.990367 16.4804 0.88501 16.7348 0.88501 17V19C0.886598 20.3256 1.41389 21.5964 2.35123 22.5338C3.28857 23.4711 4.55941 23.9984 5.88501 24H7.88501C8.15023 24 8.40458 23.8946 8.59212 23.7071C8.77965 23.5196 8.88501 23.2652 8.88501 23C8.88501 22.7348 8.77965 22.4804 8.59212 22.2929C8.40458 22.1054 8.15023 22 7.88501 22Z", fill: "currentColor" }),
  /* @__PURE__ */ f.jsx("path", { d: "M19.885 0H17.885C17.6198 0 17.3654 0.105357 17.1779 0.292893C16.9904 0.48043 16.885 0.734784 16.885 1C16.885 1.26522 16.9904 1.51957 17.1779 1.70711C17.3654 1.89464 17.6198 2 17.885 2H19.885C20.6807 2 21.4437 2.31607 22.0063 2.87868C22.5689 3.44129 22.885 4.20435 22.885 5V7C22.885 7.26522 22.9904 7.51957 23.1779 7.70711C23.3654 7.89464 23.6198 8 23.885 8C24.1502 8 24.4046 7.89464 24.5921 7.70711C24.7797 7.51957 24.885 7.26522 24.885 7V5C24.8834 3.67441 24.3561 2.40356 23.4188 1.46622C22.4815 0.528882 21.2106 0.00158786 19.885 0Z", fill: "currentColor" })
] }), tS = () => /* @__PURE__ */ f.jsx("svg", { className: "w-full", viewBox: "0 0 25 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ f.jsx(
  "path",
  {
    d: "M24.3294 22.7398L21.8994 15.5698C21.5834 14.6528 20.7924 14.0608 19.8814 14.0608C18.9704 14.0608 18.1794 14.6538 17.8634 15.5738L15.4344 22.7398C15.2574 23.2628 15.5374 23.8308 16.0604 24.0088C16.5844 24.1868 17.1504 23.9048 17.3284 23.3828L17.7974 21.9998H21.9654L22.4344 23.3828C22.5764 23.7988 22.9644 24.0618 23.3814 24.0618C23.4874 24.0618 23.5964 24.0448 23.7024 24.0088C24.2254 23.8308 24.5064 23.2638 24.3284 22.7398H24.3294ZM18.4754 19.9998L19.7564 16.2208C19.8314 15.9998 19.9334 16.0038 20.0064 16.2168L21.2884 19.9998H18.4754ZM16.5404 9.55077C16.0344 8.59677 15.0504 8.00377 13.9714 8.00377L10.1384 8.00077L11.3434 2.77377C11.6524 1.69577 11.2044 0.601772 10.2794 0.173772C9.3994 -0.233228 8.4144 0.087772 7.8064 0.999772L1.3874 11.4608C0.781404 12.3548 0.719404 13.5028 1.2244 14.4568C1.7294 15.4108 2.7144 16.0038 3.7944 16.0038H7.6244L6.4204 21.2298C6.1114 22.3088 6.5594 23.4018 7.4844 23.8298C7.7374 23.9468 7.9994 24.0038 8.2574 24.0038C8.8994 24.0038 9.5244 23.6538 9.9564 23.0038L16.3764 12.5468C16.9824 11.6528 17.0444 10.5048 16.5394 9.55177L16.5404 9.55077ZM14.6974 11.4608L8.3334 21.8258C8.3384 21.7968 9.8554 15.2278 9.8554 15.2278C9.9234 14.9308 9.8534 14.6198 9.6634 14.3798C9.4734 14.1418 9.1854 14.0028 8.8804 14.0028H3.7944C3.3004 14.0028 3.0684 13.6648 2.9914 13.5198C2.9144 13.3738 2.7644 12.9918 3.0664 12.5448L9.4304 2.17677C9.4254 2.20577 7.9084 8.77577 7.9084 8.77577C7.8404 9.07277 7.9104 9.38377 8.1004 9.62277C8.2904 9.86177 8.5784 10.0008 8.8824 10.0008L13.9704 10.0048C14.4644 10.0048 14.6964 10.3428 14.7734 10.4878C14.8504 10.6328 14.9994 11.0138 14.6974 11.4608Z",
    fill: "currentColor"
  }
) }), rS = () => /* @__PURE__ */ f.jsxs("svg", { className: "w-full", viewBox: "0 0 25 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ f.jsx("path", { d: "M12.3361 2.00028C13.6626 2.00463 14.9751 2.27201 16.1976 2.78696C17.4201 3.30191 18.5283 4.05419 19.4581 5.00028H16.3361C16.0709 5.00028 15.8166 5.10563 15.629 5.29317C15.4415 5.48071 15.3361 5.73506 15.3361 6.00028C15.3361 6.26549 15.4415 6.51985 15.629 6.70738C15.8166 6.89492 16.0709 7.00028 16.3361 7.00028H20.4791C20.9716 7.00001 21.4437 6.80428 21.7919 6.45608C22.1401 6.10788 22.3359 5.6357 22.3361 5.14328V1.00028C22.3361 0.735059 22.2308 0.480706 22.0432 0.293169C21.8557 0.105633 21.6014 0.000275954 21.3361 0.000275954C21.0709 0.000275954 20.8166 0.105633 20.629 0.293169C20.4415 0.480706 20.3361 0.735059 20.3361 1.00028V3.07828C18.6833 1.58973 16.6487 0.590686 14.4602 0.193025C12.2717 -0.204636 10.0158 0.0147879 7.94493 0.826723C5.87408 1.63866 4.07016 3.01105 2.73515 4.7902C1.40015 6.56935 0.586782 8.68502 0.38614 10.9003C0.373223 11.0395 0.389456 11.18 0.433803 11.3126C0.47815 11.4452 0.54964 11.5672 0.643716 11.6707C0.737793 11.7741 0.852394 11.8569 0.980218 11.9136C1.10804 11.9704 1.24629 11.9999 1.38614 12.0003C1.63073 12.0034 1.86767 11.9151 2.0506 11.7527C2.23352 11.5903 2.34925 11.3655 2.37514 11.1223C2.59775 8.63302 3.74311 6.31698 5.58622 4.62911C7.42933 2.94125 9.83696 2.00357 12.3361 2.00028Z", fill: "currentColor" }),
  /* @__PURE__ */ f.jsx("path", { d: "M23.2869 12.0003C23.0423 11.9972 22.8054 12.0855 22.6225 12.2479C22.4396 12.4103 22.3238 12.6351 22.2979 12.8783C22.1326 14.7816 21.4249 16.5974 20.2586 18.1105C19.0923 19.6236 17.5165 20.7704 15.7181 21.4149C13.9197 22.0593 11.9741 22.1744 10.1123 21.7464C8.25044 21.3184 6.55043 20.3654 5.21394 19.0003H8.33594C8.60115 19.0003 8.85551 18.895 9.04305 18.7074C9.23058 18.5199 9.33594 18.2655 9.33594 18.0003C9.33594 17.7351 9.23058 17.4808 9.04305 17.2932C8.85551 17.1057 8.60115 17.0003 8.33594 17.0003H4.19294C3.94904 17.0002 3.7075 17.0481 3.48214 17.1414C3.25678 17.2347 3.05201 17.3715 2.87955 17.5439C2.70708 17.7164 2.5703 17.9212 2.47703 18.1465C2.38375 18.3719 2.33581 18.6134 2.33594 18.8573V23.0003C2.33594 23.2655 2.44129 23.5199 2.62883 23.7074C2.81637 23.895 3.07072 24.0003 3.33594 24.0003C3.60115 24.0003 3.85551 23.895 4.04304 23.7074C4.23058 23.5199 4.33594 23.2655 4.33594 23.0003V20.9223C5.98877 22.4109 8.02335 23.4099 10.2118 23.8076C12.4003 24.2052 14.6563 23.9858 16.7272 23.1739C18.798 22.3619 20.6019 20.9896 21.9369 19.2104C23.2719 17.4312 24.0853 15.3156 24.2859 13.1003C24.2989 12.9611 24.2826 12.8206 24.2383 12.688C24.1939 12.5554 24.1224 12.4334 24.0284 12.3299C23.9343 12.2265 23.8197 12.1437 23.6919 12.087C23.564 12.0302 23.4268 12.0007 23.2869 12.0003Z", fill: "currentColor" }),
  /* @__PURE__ */ f.jsx("path", { d: "M12.3359 11.167C11.4151 11.167 10.6693 11.9128 10.6693 12.8336C10.6693 13.7545 11.4151 14.5003 12.3359 14.5003C13.2568 14.5003 14.0026 13.7545 14.0026 12.8336C14.0026 11.9128 13.2568 11.167 12.3359 11.167ZM14.8359 17.0003H9.83594C8.4576 17.0003 7.33594 15.8786 7.33594 14.5003V11.167C7.33594 9.80114 8.43677 8.68864 9.79677 8.6678L10.3768 7.76531C10.6834 7.28697 11.2076 7.00031 11.7784 7.00031H12.8934C13.4643 7.00031 13.9876 7.28697 14.2959 7.76614L14.8751 8.6678C16.2359 8.68864 17.3359 9.80114 17.3359 11.167V14.5003C17.3359 15.8786 16.2143 17.0003 14.8359 17.0003ZM15.6693 11.167C15.6693 10.707 15.2959 10.3336 14.8359 10.3336H9.83594C9.37594 10.3336 9.0026 10.707 9.0026 11.167V14.5003C9.0026 14.9603 9.37594 15.3336 9.83594 15.3336H14.8359C15.2959 15.3336 15.6693 14.9603 15.6693 14.5003V11.167Z", fill: "currentColor" })
] }), nS = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        d: "M33.1018 6.06516C29.5133 2.47661 24.7418 0.5 19.667 0.5C14.5922 0.5 9.8207 2.47661 6.23215 6.06516C2.6436 9.65371 0.666992 14.4252 0.666992 19.5C0.666992 22.492 1.34323 25.3563 2.67527 28.0122C3.94602 30.5445 5.80619 32.801 8.0535 34.5386C8.16484 34.6244 8.29764 34.6663 8.42839 34.6663C8.61124 34.6663 8.79307 34.5846 8.91361 34.4283C9.12097 34.1606 9.07194 33.7755 8.80328 33.5682C4.57425 30.2983 2.0828 25.4206 1.90404 20.1129H17.4493C17.718 21.0854 18.6108 21.8015 19.668 21.8015C20.7253 21.8015 21.617 21.0854 21.8857 20.1129H37.43C37.2553 25.2664 34.8803 30.0501 30.8504 33.3159C30.5879 33.5294 30.547 33.9155 30.7605 34.178C30.974 34.4405 31.3591 34.4814 31.6227 34.2679C36.0999 30.6395 38.668 25.2562 38.668 19.5C38.668 14.4252 36.6914 9.65371 33.1029 6.06516H33.1018ZM37.4289 18.8871H30.9526C30.8658 17.2752 30.4408 15.7521 29.7462 14.3884L35.3532 11.1512C36.5933 13.4721 37.3339 16.0994 37.4289 18.8871ZM34.7383 10.0899L29.1302 13.3281C28.2722 12.0165 27.1495 10.8938 25.8379 10.0358L29.0761 4.42769C31.3653 5.86188 33.3051 7.80172 34.7393 10.0899H34.7383ZM14.5544 9.42081L11.3172 3.81376C13.6381 2.57366 16.2654 1.83306 19.0531 1.73806V8.21339C17.4411 8.30022 15.9181 8.72618 14.5544 9.42081ZM20.2799 1.73704C23.0676 1.83204 25.6949 2.57263 28.0158 3.81274L24.7776 9.42081C23.4139 8.72618 21.8908 8.30022 20.2789 8.21339V1.73704H20.2799ZM10.2569 4.42769L13.494 10.0358C12.1824 10.8938 11.0598 12.0165 10.2017 13.3281L4.59366 10.0899C6.02785 7.80172 7.96769 5.86188 10.2559 4.42769H10.2569ZM9.5878 14.3884C8.89318 15.7521 8.46721 17.2762 8.3814 18.8871H1.90404C1.99904 16.0994 2.73963 13.4721 3.97973 11.1512L9.58678 14.3884H9.5878ZM17.4493 18.8871H9.60925C9.92694 13.6151 14.3163 9.42285 19.668 9.42285C25.0197 9.42285 29.4081 13.6151 29.7258 18.8871H21.8857C21.8346 18.7022 21.7611 18.5275 21.6691 18.3651L24.1831 15.8512C24.4221 15.6122 24.4221 15.224 24.1831 14.9849C23.944 14.7459 23.5559 14.7459 23.3168 14.9849L20.8029 17.4989C20.4679 17.3078 20.0807 17.1985 19.669 17.1985C18.6118 17.1985 17.72 17.9146 17.4503 18.8871H17.4493ZM19.668 20.5756C19.0745 20.5756 18.5924 20.0925 18.5924 19.5C18.5924 18.9075 19.0745 18.4244 19.668 18.4244C20.2615 18.4244 20.7437 18.9065 20.7437 19.5C20.7437 20.0935 20.2615 20.5756 19.668 20.5756ZM18.4963 28.5475H15.7618C15.4237 28.5475 15.1489 28.8212 15.1489 29.1604V37.8871C15.1489 38.2252 15.4237 38.5 15.7618 38.5H18.4963C18.8345 38.5 19.1092 38.2252 19.1092 37.8871V29.1604C19.1092 28.8212 18.8345 28.5475 18.4963 28.5475ZM17.8834 37.2742H16.3747V29.7733H17.8834V37.2742ZM23.5732 29.6865H20.8397C20.5005 29.6865 20.2268 29.9612 20.2268 30.2994V37.8871C20.2268 38.2252 20.5005 38.5 20.8397 38.5H23.5732C23.9113 38.5 24.1861 38.2252 24.1861 37.8871V30.2994C24.1861 29.9612 23.9113 29.6865 23.5732 29.6865ZM22.9603 37.2742H21.4526V30.9123H22.9603V37.2742ZM28.6501 24.961H25.9155C25.5774 24.961 25.3026 25.2358 25.3026 25.5739V37.8871C25.3026 38.2252 25.5774 38.5 25.9155 38.5H28.6501C28.9893 38.5 29.263 38.2252 29.263 37.8871V25.5739C29.263 25.2358 28.9893 24.961 28.6501 24.961ZM28.0372 37.2742H26.5284V26.1868H28.0372V37.2742ZM13.4195 31.9327H10.6849C10.3468 31.9327 10.072 32.2075 10.072 32.5456V37.8871C10.072 38.2252 10.3468 38.5 10.6849 38.5H13.4195C13.7586 38.5 14.0324 38.2252 14.0324 37.8871V32.5456C14.0324 32.2075 13.7586 31.9327 13.4195 31.9327ZM12.8066 37.2742H11.2978V33.1585H12.8066V37.2742ZM22.0216 25.7608L25.652 22.0997C25.3261 22.111 25.0483 21.8689 25.0197 21.542C24.9901 21.2049 25.2393 20.9066 25.5764 20.878L27.2292 20.733C27.412 20.7166 27.5929 20.784 27.7216 20.9158C27.8493 21.0476 27.9126 21.2294 27.8922 21.4123L27.7083 23.061C27.6736 23.3746 27.408 23.6054 27.1005 23.6054C27.078 23.6054 27.0545 23.6044 27.031 23.6013C26.7205 23.5666 26.4906 23.3041 26.4866 22.9997L22.6273 26.8926C22.4649 27.0571 22.2228 27.1153 22.0032 27.0438L17.2501 25.5024L12.4296 29.2554C12.3173 29.3422 12.1855 29.3851 12.0537 29.3851C11.8709 29.3851 11.6901 29.3044 11.5695 29.1491C11.3622 28.8815 11.4091 28.4964 11.6768 28.289L16.7537 24.3358C16.914 24.2112 17.1255 24.1734 17.3196 24.2367L22.0226 25.7628L22.0216 25.7608Z",
        fill: "currentColor"
      }
    )
  }
), aS = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 34 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsxs("g", { "clip-path": "url(#clip0_2383_69933)", children: [
      /* @__PURE__ */ f.jsx("path", { d: "M30.0156 7.9375C27.8143 7.9375 26.0312 9.72051 26.0312 11.9219V13.25H21.2294C22.8298 10.5134 23.6406 8.46078 23.6406 7.14062C23.6406 3.47898 20.6616 0.5 17 0.5C13.3384 0.5 10.3594 3.47898 10.3594 7.14062C10.3594 8.46078 11.1702 10.5134 12.7706 13.25H7.96875V11.9219C7.96875 9.72449 6.18176 7.9375 3.98438 7.9375C1.78699 7.9375 0 9.72051 0 11.9219V15.6406C0 16.0072 0.2975 16.3047 0.664062 16.3047C1.03062 16.3047 1.32812 16.0072 1.32812 15.6406V11.9219C1.32812 10.455 2.5168 9.26562 3.98438 9.26562C5.45195 9.26562 6.64062 10.4576 6.64062 11.9219V27.5486C5.93539 26.9164 5.00371 26.5312 3.98438 26.5312C2.96504 26.5312 2.03336 26.9171 1.32812 27.5493V20.9531C1.32812 20.5866 1.03062 20.2891 0.664062 20.2891C0.2975 20.2891 0 20.5866 0 20.9531V30.5156C0 32.794 1.96695 34.5 4.17363 34.5H30.0156C32.213 34.5 34 32.713 34 30.5156V11.9219C34 9.72449 32.213 7.9375 30.0156 7.9375ZM27.3594 11.9219C27.3594 10.455 28.548 9.26562 30.0156 9.26562C31.4832 9.26562 32.6719 10.4576 32.6719 11.9219V27.53C32.215 27.1236 31.6658 26.8208 31.0662 26.6667C29.7354 26.3227 28.3661 26.6468 27.3594 27.5453V11.9219ZM26.0312 21.2188H17.5312C15.306 19.0997 11.0553 15.0516 10.5586 14.5781H13.5754C15.0251 16.8944 16.4535 18.8075 16.4681 18.8275C16.5936 18.9948 16.7908 19.0938 17 19.0938C17.2092 19.0938 17.4064 18.9955 17.5319 18.8275C17.5465 18.8075 18.9749 16.8937 20.4246 14.5781H26.0312V21.2188ZM17 1.82812C19.9292 1.82812 22.3125 4.21145 22.3125 7.14062C22.3125 9.60629 18.4231 15.3079 17 17.3001C15.5543 15.2761 11.6875 9.58371 11.6875 7.14062C11.6875 4.21145 14.0708 1.82812 17 1.82812ZM1.32812 30.5156C1.32812 29.0514 2.51945 27.8594 3.98438 27.8594C5.4493 27.8594 6.64062 29.0514 6.64062 30.5156C6.64062 30.8822 6.93813 31.1797 7.30469 31.1797C7.67125 31.1797 7.96875 30.8822 7.96875 30.5156V19.4477L14.709 25.8672L7.03906 33.1719H4.17363C2.68414 33.1719 1.32812 32.0589 1.32812 30.5156ZM16.1294 26.348C16.2609 26.2225 16.3359 26.0485 16.3359 25.8672C16.3359 25.6859 16.2616 25.5113 16.1294 25.3864L7.96875 17.6142V14.5781H8.63281C8.67797 14.6213 16.4913 22.0628 16.8074 22.3636C16.9309 22.4811 17.095 22.5469 17.265 22.5469H26.0306V25.2031H20.9837C20.8077 25.2031 20.6384 25.2729 20.5142 25.3977L12.7394 33.1719H8.96418L16.1287 26.348H16.1294ZM30.0156 33.1719H14.6187L21.2593 26.5312H26.0312V30.5156C26.0312 30.8822 26.3288 31.1797 26.6953 31.1797C27.0619 31.1797 27.3594 30.8822 27.3594 30.5156C27.3594 28.7984 28.9677 27.4961 30.7341 27.9523C31.8126 28.2312 32.6719 29.2267 32.6719 30.5156C32.6719 31.9805 31.4799 33.1719 30.0156 33.1719Z", fill: "currentColor" }),
      /* @__PURE__ */ f.jsx("path", { d: "M17 10.4609C18.8308 10.4609 20.3203 8.97145 20.3203 7.14062C20.3203 5.3098 18.8308 3.82031 17 3.82031C15.1692 3.82031 13.6797 5.3098 13.6797 7.14062C13.6797 8.97145 15.1692 10.4609 17 10.4609ZM17 5.14844C18.0984 5.14844 18.9922 6.04227 18.9922 7.14062C18.9922 8.23898 18.0984 9.13281 17 9.13281C15.9016 9.13281 15.0078 8.23898 15.0078 7.14062C15.0078 6.04227 15.9016 5.14844 17 5.14844Z", fill: "currentColor" }),
      /* @__PURE__ */ f.jsx("path", { d: "M0.664062 18.9609C1.03062 18.9609 1.32812 18.6634 1.32812 18.2969C1.32812 17.9303 1.03062 17.6328 0.664062 17.6328C0.2975 17.6328 0 17.9303 0 18.2969C0 18.6634 0.2975 18.9609 0.664062 18.9609Z", fill: "currentColor" })
    ] })
  }
), iS = () => /* @__PURE__ */ f.jsx("svg", { viewBox: "0 0 40 41", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ f.jsxs("g", { "clip-path": "url(#clip0_106_18)", children: [
  /* @__PURE__ */ f.jsx("path", { d: "M13.75 24.3719C13.94 26.8166 15.825 28.7205 19.205 28.946V30.75H20.705V28.9332C24.205 28.6821 26.25 26.7653 26.25 23.9824C26.25 21.4533 24.685 20.1489 21.8875 19.4724L20.705 19.1854V14.2731C22.205 14.4474 23.16 15.2879 23.39 16.4513H26.02C25.83 14.0963 23.86 12.2539 20.705 12.054V10.25H19.205V12.0924C16.2175 12.3922 14.18 14.2347 14.18 16.8408C14.18 19.147 15.695 20.6128 18.2125 21.2149L19.205 21.4661V26.6782C17.6675 26.4399 16.65 25.5763 16.42 24.3719H13.75ZM19.1925 18.8216C17.7175 18.4705 16.9175 17.7556 16.9175 16.6793C16.9175 15.4749 17.78 14.5729 19.205 14.309V18.819L19.1925 18.8216ZM20.9225 21.8786C22.715 22.304 23.5425 22.9933 23.5425 24.2105C23.5425 25.5994 22.5125 26.5526 20.705 26.7269V21.8274L20.9225 21.8786Z", fill: "currentColor" }),
  /* @__PURE__ */ f.jsx("path", { d: "M20 38.4375C15.3587 38.4375 10.9075 36.5477 7.62563 33.1837C4.34374 29.8198 2.5 25.2573 2.5 20.5C2.5 15.7427 4.34374 11.1802 7.62563 7.81627C10.9075 4.45234 15.3587 2.5625 20 2.5625C24.6413 2.5625 29.0925 4.45234 32.3744 7.81627C35.6563 11.1802 37.5 15.7427 37.5 20.5C37.5 25.2573 35.6563 29.8198 32.3744 33.1837C29.0925 36.5477 24.6413 38.4375 20 38.4375ZM20 41C25.3043 41 30.3914 38.8402 34.1421 34.9957C37.8929 31.1512 40 25.9369 40 20.5C40 15.0631 37.8929 9.84881 34.1421 6.00431C30.3914 2.15982 25.3043 0 20 0C14.6957 0 9.60859 2.15982 5.85786 6.00431C2.10714 9.84881 0 15.0631 0 20.5C0 25.9369 2.10714 31.1512 5.85786 34.9957C9.60859 38.8402 14.6957 41 20 41Z", fill: "currentColor" }),
  /* @__PURE__ */ f.jsx("path", { d: "M20 34.5938C16.3533 34.5938 12.8559 33.1089 10.2773 30.4658C7.69866 27.8227 6.25 24.2379 6.25 20.5C6.25 16.7621 7.69866 13.1773 10.2773 10.5342C12.8559 7.89112 16.3533 6.40625 20 6.40625C23.6467 6.40625 27.1441 7.89112 29.7227 10.5342C32.3013 13.1773 33.75 16.7621 33.75 20.5C33.75 24.2379 32.3013 27.8227 29.7227 30.4658C27.1441 33.1089 23.6467 34.5938 20 34.5938ZM20 35.875C21.9698 35.875 23.9204 35.4773 25.7403 34.7046C27.5601 33.932 29.2137 32.7995 30.6066 31.3718C31.9995 29.9441 33.1044 28.2491 33.8582 26.3838C34.612 24.5184 35 22.5191 35 20.5C35 18.4809 34.612 16.4816 33.8582 14.6162C33.1044 12.7509 31.9995 11.0559 30.6066 9.62823C29.2137 8.20053 27.5601 7.06802 25.7403 6.29535C23.9204 5.52269 21.9698 5.125 20 5.125C16.0218 5.125 12.2064 6.74486 9.3934 9.62823C6.58035 12.5116 5 16.4223 5 20.5C5 24.5777 6.58035 28.4884 9.3934 31.3718C12.2064 34.2551 16.0218 35.875 20 35.875Z", fill: "currentColor" })
] }) }), oS = () => /* @__PURE__ */ f.jsxs("svg", { viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ f.jsx("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M39.6339 0.366153C39.9874 0.719731 40.0963 1.25 39.9106 1.71427L32.9106 19.2143C32.6542 19.8553 31.9267 20.167 31.2857 19.9106C30.6448 19.6542 30.333 18.9268 30.5894 18.2858L35.3277 6.44013L16.5929 25.1749L20.0318 30.5789C20.4025 31.1614 20.2308 31.934 19.6484 32.3046C19.0659 32.6752 18.2933 32.5036 17.9227 31.9211L14.0945 25.9055L1.6077 17.9593C0.318659 17.139 0.499343 15.204 1.91798 14.6365L38.2857 0.0894406C38.75 -0.0962678 39.2803 0.0125747 39.6339 0.366153ZM14.8251 23.4071L33.5599 4.67237L3.97869 16.5048L14.8251 23.4071Z", fill: "currentColor" }),
  /* @__PURE__ */ f.jsx("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M31.25 40C36.0825 40 40 36.0825 40 31.25C40 26.4175 36.0825 22.5 31.25 22.5C26.4175 22.5 22.5 26.4175 22.5 31.25C22.5 36.0825 26.4175 40 31.25 40ZM32.1339 26.6161C31.893 26.3752 31.5642 26.2431 31.2236 26.2503C30.8829 26.2575 30.56 26.4034 30.3295 26.6543L27.4584 29.7793C26.9914 30.2877 27.0248 31.0784 27.5332 31.5455C28.0416 32.0126 28.8323 31.9791 29.2994 31.4707L30 30.7081V35C30 35.6904 30.5596 36.25 31.25 36.25C31.9404 36.25 32.5 35.6904 32.5 35V30.5178L33.4911 31.5089C33.9793 31.997 34.7707 31.997 35.2589 31.5089C35.747 31.0207 35.747 30.2293 35.2589 29.7411L32.1339 26.6161Z", fill: "currentColor" })
] }), sS = () => /* @__PURE__ */ f.jsx("svg", { viewBox: "0 0 25 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ f.jsx("path", { d: "M7.78684 24.0628C5.97659 24.0616 4.22784 23.4057 2.86329 22.2162C1.49874 21.0267 0.610474 19.3837 0.362401 17.5906C0.114327 15.7974 0.523189 13.975 1.51354 12.4597C2.50389 10.9443 4.00889 9.83835 5.75084 9.34576C7.01696 8.98319 8.35713 8.96661 9.63184 9.29776L17.5398 1.39176C17.9596 0.969046 18.4592 0.633898 19.0096 0.405759C19.5599 0.177621 20.1501 0.0610343 20.7458 0.0627631C21.6834 0.0635575 22.5823 0.436354 23.2453 1.09931C23.9082 1.76227 24.281 2.6612 24.2818 3.59876C24.2834 4.19455 24.1668 4.78474 23.9389 5.3352C23.7109 5.88567 23.3761 6.38549 22.9538 6.80576L22.2818 7.47776C21.9058 7.8512 21.3978 8.06139 20.8678 8.06276H19.2818V9.06276C19.2818 9.5932 19.0711 10.1019 18.6961 10.477C18.321 10.852 17.8123 11.0628 17.2818 11.0628H16.2818V12.6488C16.2825 12.9115 16.2311 13.1718 16.1305 13.4145C16.0299 13.6572 15.8822 13.8776 15.6958 14.0628L15.0458 14.7128C15.3788 15.9869 15.3626 17.3271 14.9988 18.5928C14.5896 20.0348 13.7591 21.3218 12.614 22.289C11.4688 23.2562 10.061 23.8595 8.57084 24.0218C8.31038 24.0488 8.0487 24.0625 7.78684 24.0628ZM7.78684 11.0628C6.76299 11.0618 5.75918 11.3466 4.88842 11.8851C4.01767 12.4237 3.31452 13.1946 2.85814 14.1111C2.40176 15.0277 2.21027 16.0534 2.30521 17.0728C2.40016 18.0922 2.77778 19.0649 3.39556 19.8814C4.01334 20.6979 4.84676 21.3257 5.80199 21.6942C6.75723 22.0627 7.79637 22.1572 8.80243 21.9672C9.80848 21.7771 10.7415 21.31 11.4965 20.6185C12.2515 19.9269 12.7985 19.0383 13.0758 18.0528C13.3878 16.9693 13.3529 15.8153 12.9758 14.7528C12.9143 14.5753 12.904 14.3841 12.9461 14.2011C12.9882 14.018 13.081 13.8505 13.2138 13.7178L14.2818 12.6488V11.0628C14.2818 10.5323 14.4926 10.0236 14.8676 9.64855C15.2427 9.27348 15.7514 9.06276 16.2818 9.06276H17.2818V8.06276C17.2818 7.53233 17.4926 7.02362 17.8676 6.64855C18.2427 6.27348 18.7514 6.06276 19.2818 6.06276H20.8678L21.5398 5.39076C21.7758 5.15592 21.9629 4.87663 22.0902 4.56904C22.2176 4.26145 22.2827 3.93167 22.2818 3.59876C22.2816 3.19164 22.1198 2.80126 21.832 2.51329C21.5442 2.22532 21.154 2.06329 20.7468 2.06276C20.4137 2.06194 20.0837 2.12719 19.7759 2.25472C19.4682 2.38226 19.1888 2.56955 18.9538 2.80576L10.6228 11.1358C10.4899 11.2686 10.3222 11.3614 10.1389 11.4033C9.95569 11.4452 9.76434 11.4346 9.58684 11.3728C9.00691 11.1686 8.39666 11.0638 7.78184 11.0628H7.78684ZM5.28184 18.0628C5.28184 18.2605 5.34049 18.4539 5.45037 18.6183C5.56025 18.7828 5.71643 18.911 5.89915 18.9866C6.08188 19.0623 6.28295 19.0821 6.47693 19.0435C6.67091 19.005 6.84909 18.9097 6.98894 18.7699C7.1288 18.63 7.22404 18.4518 7.26262 18.2579C7.30121 18.0639 7.2814 17.8628 7.20572 17.6801C7.13003 17.4974 7.00186 17.3412 6.83741 17.2313C6.67296 17.1214 6.47962 17.0628 6.28184 17.0628C6.01662 17.0628 5.76227 17.1681 5.57473 17.3557C5.3872 17.5432 5.28184 17.7975 5.28184 18.0628Z", fill: "currentColor" }) }), lS = () => /* @__PURE__ */ f.jsxs("svg", { viewBox: "0 0 25 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ f.jsx("path", { d: "M16.1462 0.0727539H9.82088C4.94887 0.0727539 0.984497 4.02038 0.984497 8.87182C0.984497 13.7233 4.94887 17.6709 9.82088 17.6709H10.8279C11.4486 17.6709 11.9531 17.1686 11.9531 16.5505V8.94091C11.9531 8.32281 11.4486 7.82049 10.8279 7.82049H7.07545C6.45473 7.82049 5.95027 8.32281 5.95027 8.94091C5.95027 9.55901 6.45473 10.0613 7.07545 10.0613H9.70273V15.43C6.12467 15.3665 3.23485 12.4497 3.23485 8.87182C3.23485 5.29393 6.19031 2.3136 9.82088 2.3136H16.1462C19.7787 2.3136 22.7323 5.25658 22.7323 8.87182C22.7323 12.4871 19.8424 15.3647 16.2663 15.43V10.0613H18.8935C19.5143 10.0613 20.0187 9.55901 20.0187 8.94091C20.0187 8.32281 19.5143 7.82049 18.8935 7.82049H15.1411C14.5204 7.82049 14.0159 8.32281 14.0159 8.94091V16.5505C14.0159 17.1686 14.5204 17.6709 15.1411 17.6709H16.1444C21.0164 17.6709 24.9807 13.7233 24.9807 8.87182C24.9807 4.02038 21.0201 0.0727539 16.1462 0.0727539Z", fill: "currentColor" }),
  /* @__PURE__ */ f.jsx("path", { d: "M10.8279 7.82236H7.07545C6.45473 7.82236 5.95027 8.32468 5.95027 8.94278C5.95027 9.56088 6.45473 10.0632 7.07545 10.0632H9.70273V12.6383C10.4266 12.8437 11.1786 12.9838 11.9531 13.0491V8.94091C11.9531 8.32281 11.4486 7.82049 10.8279 7.82049V7.82236Z", fill: "currentColor" }),
  /* @__PURE__ */ f.jsx("path", { d: "M18.8954 7.82236H15.143C14.5222 7.82236 14.0178 8.32468 14.0178 8.94278V13.0529C14.7904 12.9875 15.5424 12.8512 16.2681 12.6476V10.0632H18.8954C19.5161 10.0632 20.0206 9.56088 20.0206 8.94278C20.0206 8.32468 19.5161 7.82236 18.8954 7.82236Z", fill: "currentColor" }),
  /* @__PURE__ */ f.jsx("path", { d: "M16.1462 0.0727539H9.82088C6.21844 0.0727539 3.11295 2.23331 1.74024 5.32008C2.1228 6.33966 2.64226 7.29389 3.27611 8.15848C3.63429 4.87564 6.4341 2.3136 9.82275 2.3136H16.1481C19.5518 2.3136 22.3591 4.89618 22.7004 8.1977C23.338 7.3331 23.8612 6.37888 24.2475 5.35742C22.8804 2.25011 19.7656 0.0727539 16.1462 0.0727539Z", fill: "currentColor" })
] }), cS = () => /* @__PURE__ */ f.jsx("svg", { viewBox: "0 0 25 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ f.jsx("path", { d: "M12.9835 24.0728C11.3665 24.0728 9.84748 23.3648 8.80748 22.1528C7.22048 22.2768 5.64148 21.7018 4.49748 20.5578C3.35348 19.4128 2.78048 17.8388 2.90248 16.2478C1.69048 15.2088 0.982483 13.6898 0.982483 12.0728C0.982483 10.4558 1.69048 8.93675 2.90248 7.89775C2.78048 6.30675 3.35348 4.73175 4.49748 3.58775C5.64148 2.44475 7.22048 1.87575 8.80748 1.99275C9.84748 0.780754 11.3665 0.0727539 12.9835 0.0727539C14.6005 0.0727539 16.1195 0.780754 17.1595 1.99275C18.7465 1.87375 20.3265 2.44475 21.4695 3.58775C22.6135 4.73275 23.1865 6.30675 23.0645 7.89775C24.2765 8.93675 24.9845 10.4558 24.9845 12.0728C24.9845 13.6898 24.2765 15.2088 23.0645 16.2478C23.1865 17.8388 22.6135 19.4138 21.4695 20.5578C20.3265 21.7018 18.7475 22.2768 17.1595 22.1528C16.1195 23.3648 14.6005 24.0728 12.9835 24.0728ZM9.70948 19.9778L10.0795 20.5268C10.7325 21.4948 11.8185 22.0728 12.9835 22.0728C14.1485 22.0728 15.2345 21.4948 15.8875 20.5268L16.2575 19.9778L16.9065 20.1038C18.0545 20.3268 19.2295 19.9678 20.0535 19.1438C20.8775 18.3188 21.2365 17.1428 21.0135 15.9978L20.8865 15.3478L21.4365 14.9778C22.4045 14.3248 22.9825 13.2388 22.9825 12.0738C22.9825 10.9088 22.4045 9.82275 21.4365 9.16975L20.8865 8.79975L21.0135 8.14975C21.2365 7.00475 20.8775 5.82775 20.0535 5.00375C19.2295 4.17975 18.0535 3.82175 16.9065 4.04375L16.2575 4.16975L15.8875 3.62075C15.2345 2.65275 14.1485 2.07475 12.9835 2.07475C11.8185 2.07475 10.7325 2.65275 10.0795 3.62075L9.70948 4.16975L9.06048 4.04375C7.91348 3.82375 6.73748 4.17975 5.91348 5.00375C5.08948 5.82875 4.73048 7.00475 4.95348 8.14975L5.08048 8.79975L4.53048 9.16975C3.56248 9.82275 2.98448 10.9088 2.98448 12.0738C2.98448 13.2388 3.56248 14.3248 4.53048 14.9778L5.08048 15.3478L4.95348 15.9978C4.73048 17.1428 5.08948 18.3198 5.91348 19.1438C6.73748 19.9668 7.91148 20.3258 9.06048 20.1038L9.70948 19.9778ZM12.8935 15.4928L18.6865 9.78575L17.2825 8.36075L11.4735 14.0618L8.68048 11.3548L7.28748 12.7918L10.0695 15.4878C10.4605 15.8788 10.9725 16.0728 11.4855 16.0728C11.9985 16.0728 12.5075 15.8798 12.8935 15.4928Z", fill: "currentColor" }) }), uS = () => /* @__PURE__ */ f.jsx("svg", { viewBox: "0 0 24 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ f.jsx("g", { "clip-path": "url(#clip0_135_74)", children: /* @__PURE__ */ f.jsx("path", { d: "M22.853 1.22522C22.1732 0.546421 21.2517 0.165161 20.291 0.165161C19.3303 0.165161 18.4089 0.546421 17.729 1.22522L1.46502 17.4892C0.999266 17.9524 0.629977 18.5032 0.378513 19.11C0.127049 19.7168 -0.00159798 20.3674 1.49812e-05 21.0242V23.0772C1.49812e-05 23.3424 0.105372 23.5968 0.292908 23.7843C0.480445 23.9719 0.734799 24.0772 1.00002 24.0772H3.05301C3.70978 24.0791 4.36038 23.9506 4.96717 23.6993C5.57396 23.448 6.12487 23.0789 6.58801 22.6132L22.853 6.34822C23.5315 5.66842 23.9126 4.74719 23.9126 3.78672C23.9126 2.82626 23.5315 1.90503 22.853 1.22522ZM5.17401 21.1992C4.61002 21.7595 3.84798 22.0749 3.05301 22.0772H2.00002V21.0242C1.999 20.6301 2.07617 20.2397 2.22705 19.8757C2.37793 19.5116 2.59953 19.1811 2.87901 18.9032L15.222 6.56022L17.522 8.86022L5.17401 21.1992ZM21.438 4.93422L18.932 7.44122L16.632 5.14622L19.139 2.63922C19.29 2.48853 19.4693 2.36906 19.6664 2.28763C19.8636 2.20621 20.0749 2.16441 20.2883 2.16465C20.5016 2.16488 20.7128 2.20713 20.9098 2.28899C21.1069 2.37084 21.2858 2.4907 21.4365 2.64172C21.5872 2.79274 21.7067 2.97197 21.7881 3.16916C21.8695 3.36635 21.9113 3.57765 21.9111 3.79099C21.9109 4.00433 21.8686 4.21554 21.7868 4.41256C21.7049 4.60957 21.585 4.78853 21.434 4.93922L21.438 4.93422Z", fill: "currentColor" }) }) }), fS = () => /* @__PURE__ */ f.jsxs("svg", { viewBox: "0 0 41 41", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ f.jsx("path", { d: "M2.74817 40.0772H33.0565C38.8752 40.0772 42.676 34.2334 40.0703 29.2671L36.3479 22.1537C27.8843 31.5075 16.1097 38.0421 2.74817 40.0772Z", fill: "#204585" }),
  /* @__PURE__ */ f.jsx("path", { d: "M26.7877 3.95137L25.5338 1.56156C24.4955 -0.417493 21.5371 -0.417493 20.4988 1.56156L5.21725 30.706C15.209 24.3767 22.889 14.9855 26.7877 3.95137Z", fill: "#F15C41" }),
  /* @__PURE__ */ f.jsx("path", { d: "M35.6623 20.8473L27.6885 5.64966C23.2803 17.1506 14.8363 26.8032 4.0021 33.0577L0.906616 38.9762C14.7971 37.2772 27.0811 30.5932 35.6819 20.866L35.6623 20.8473Z", fill: "#2875B4" })
] }), dS = () => /* @__PURE__ */ f.jsx("svg", { viewBox: "0 0 79 61", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ f.jsxs("g", { children: [
  /* @__PURE__ */ f.jsx("path", { d: "M58.1699 46.1411H39.6543V57.0898H58.1699V46.1411Z", fill: "#293939" }),
  /* @__PURE__ */ f.jsx("path", { d: "M25.459 61.0001H2.31445C1.03533 61.0001 0 59.9506 0 58.6539V7.03854C0 5.7419 1.03533 4.69238 2.31445 4.69238H25.459C26.7366 4.69238 27.7734 5.7419 27.7734 7.03854V58.6539C27.7734 59.9506 26.7366 61.0001 25.459 61.0001Z", fill: "#3E5959" }),
  /* @__PURE__ */ f.jsx("path", { d: "M27.7734 7.03854V58.6539C27.7734 59.949 26.7366 61.0001 25.459 61.0001H13.8867V4.69238H25.459C26.7366 4.69238 27.7734 5.74346 27.7734 7.03854Z", fill: "#293939" }),
  /* @__PURE__ */ f.jsx("path", { d: "M27.7734 16.4231H0V25.8077H27.7734V16.4231Z", fill: "#547983" }),
  /* @__PURE__ */ f.jsx("path", { d: "M27.7734 16.4231H13.8867V25.8077H27.7734V16.4231Z", fill: "#3E5959" }),
  /* @__PURE__ */ f.jsx("path", { d: "M16.2012 54.4309C16.2012 55.7275 15.1658 56.777 13.8867 56.777C12.6076 56.777 11.5723 55.7275 11.5723 54.4309C11.5723 53.1342 12.6076 52.0847 13.8867 52.0847C15.1658 52.0847 16.2012 53.1342 16.2012 54.4309Z", fill: "#81E885" }),
  /* @__PURE__ */ f.jsx("mask", { id: "mask0_168_181", maskUnits: "userSpaceOnUse", x: "0", y: "0", width: "79", height: "61", children: /* @__PURE__ */ f.jsx("path", { d: "M79 0H0V61H79V0Z", fill: "white" }) }),
  /* @__PURE__ */ f.jsxs("g", { mask: "url(#mask0_168_181)", children: [
    /* @__PURE__ */ f.jsx("path", { d: "M16.2012 54.4309C16.2012 55.7259 15.1643 56.777 13.8867 56.777V52.0847C15.1643 52.0847 16.2012 53.1358 16.2012 54.4309Z", fill: "#5DC983" }),
    /* @__PURE__ */ f.jsx("path", { d: "M74.3711 46.9231H23.4531C20.9011 46.9231 18.8242 44.8178 18.8242 42.2308V4.69231C18.8242 2.10528 20.9011 0 23.4531 0H74.3711C76.9232 0 79 2.10528 79 4.69231V42.2308C79 44.8178 76.9232 46.9231 74.3711 46.9231Z", fill: "#547983" })
  ] }),
  /* @__PURE__ */ f.jsx("path", { d: "M74.3711 4.69238H23.4531V42.2308H74.3711V4.69238Z", fill: "#F3765F" }),
  /* @__PURE__ */ f.jsx("path", { d: "M62.7988 60.9999H35.0254C33.7463 60.9999 32.7109 59.9504 32.7109 58.6538C32.7109 57.3571 33.7463 56.3076 35.0254 56.3076H62.7988C64.0779 56.3076 65.1133 57.3571 65.1133 58.6538C65.1133 59.9504 64.0779 60.9999 62.7988 60.9999Z", fill: "#547983" }),
  /* @__PURE__ */ f.jsx("path", { opacity: "0.15", d: "M54.9991 42.2308H51.3747L31.5984 4.69238H35.2229L54.9991 42.2308Z", fill: "white" }),
  /* @__PURE__ */ f.jsx("path", { opacity: "0.15", d: "M62.7989 42.2308H59.1744L39.3982 4.69238H43.0226L62.7989 42.2308Z", fill: "white" })
] }) }), hS = () => /* @__PURE__ */ f.jsx("svg", { viewBox: "0 0 42 42", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ f.jsx("path", { d: "M21 0C9.40202 0 0 9.40202 0 21C0 32.598 9.40202 42 21 42C32.598 42 42 32.598 42 21C42 9.40202 32.598 0 21 0ZM5.3561 11.3562C6.20942 14.844 12.0011 18.0215 15.1108 19.7276C16.3725 20.4198 17.1927 20.8698 17.0625 21C16.8507 21.2119 16.6365 21.4157 16.4266 21.6155C15.3363 22.6534 14.3626 23.5803 14.4375 24.9375C14.5294 26.6027 16.0592 27.0996 17.6248 27.6081C19.1402 28.1004 20.6891 28.6035 21 30.1875C21.2151 31.2833 20.8043 32.7813 20.4218 34.1768C19.8586 36.2308 19.3564 38.0625 21 38.0625C24.9375 36.75 30.9708 29.7003 31.5 24.9375C31.8624 21.6756 26.25 19.6875 22.3125 18.375C21.0578 17.9568 20.3293 18.5878 19.713 19.1217C19.2611 19.5131 18.8695 19.8524 18.375 19.6875C17.2061 19.2979 11.8125 14.4375 14.4375 13.125C16.487 12.1003 16.9363 12.6757 17.6596 13.602C17.8626 13.8621 18.0873 14.1498 18.375 14.4375C19.9723 15.2362 20.1117 14.0909 20.2717 12.7761C20.3746 11.9301 20.4861 11.0139 21 10.5C22.1383 9.36176 24.3201 8.42297 26.3227 7.56133C28.1932 6.75649 29.9073 6.01896 30.4683 5.24905C35.8054 8.46421 39.375 14.3152 39.375 21C39.375 31.1482 31.1482 39.375 21 39.375C10.8518 39.375 2.625 31.1482 2.625 21C2.625 17.463 3.62435 14.1594 5.3561 11.3562Z", fill: "currentColor" }) }), AS = () => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 54 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ f.jsx("path", { d: "M46.5542 12.7677L44.7664 13.0693C43.8107 13.2328 42.8286 13.1168 41.9394 12.7338L41.8089 12.6774C40.0076 11.8991 37.9453 11.9857 36.2097 12.9139L29.9367 16.2493L17.5845 15.6324C17.4547 15.6257 17.3246 15.6543 17.2093 15.7156L14.0342 17.4039C13.777 17.5406 13.6281 17.8172 13.6552 18.1056C13.6823 18.3941 13.8819 18.6368 14.1593 18.7218L21.2433 20.8717L13.5902 24.941L4.81596 20.2326C4.60383 20.1196 4.34881 20.12 4.13607 20.2331L1.59598 21.5837C1.39171 21.6923 1.25227 21.8922 1.2201 22.1202C1.18743 22.3499 1.26833 22.5786 1.43546 22.7372L7.29022 28.2921L6.8637 28.5188C6.03499 28.9595 5.5939 29.8917 5.78195 30.8071C5.96951 31.7241 6.7398 32.4042 7.67434 32.4792L8.96799 32.5837L8.61643 36.0588C8.58938 36.3219 8.71 36.5769 8.92936 36.7239C9.14872 36.8709 9.43194 36.8853 9.6664 36.762L10.9364 36.0867C11.074 36.0135 11.1839 35.8983 11.2502 35.7576L14.3128 29.2618C14.445 28.982 14.3826 28.6501 14.1585 28.438C13.9344 28.2259 13.5996 28.1809 13.3265 28.3261L9.51636 30.3519C9.30468 30.4645 9.16175 30.6757 9.13787 30.9142L9.11299 31.1559L7.79455 31.0457C7.49819 31.0194 7.25361 30.802 7.19431 30.5117C7.13445 30.2204 7.27326 29.9249 7.53567 29.7826L36.8833 14.1782C37.6887 13.75 38.5954 13.5478 39.5057 13.5951L39.3437 13.6812C38.4664 14.1477 38.1322 15.2326 38.5969 16.1064C39.0615 16.9802 40.1477 17.3099 41.0251 16.8434L45.6459 14.3864C45.6544 14.3819 45.6606 14.3732 45.6675 14.3682L46.7882 14.1779C47.0934 14.1265 47.3974 14.2745 47.541 14.547L47.5808 14.6218C47.7254 14.8937 47.6796 15.229 47.4657 15.4523L46.3304 16.6414C45.5309 17.4816 44.5996 18.1863 43.5751 18.731L34.0074 23.8183L34.1105 23.6012C34.2427 23.3213 34.1803 22.9895 33.9562 22.7774C33.7321 22.5653 33.3973 22.5202 33.1242 22.6654L26.139 26.3795C25.9612 26.4741 25.83 26.6385 25.7804 26.8338L25.3689 28.4114L21.5419 30.4463C19.7151 31.4176 17.6501 31.8463 15.5909 31.6784L15.0488 31.6341C14.8587 31.6189 14.6705 31.6784 14.5244 31.802C14.3794 31.9251 14.2882 32.1007 14.2722 32.2903C14.2563 32.48 14.3154 32.6676 14.4388 32.8129C14.5622 32.9582 14.7373 33.0476 14.9274 33.0628L15.4695 33.1072C17.8041 33.2977 20.1458 32.8124 22.2154 31.7106L24.8783 30.2947L22.8319 38.1349C22.7596 38.41 22.8575 38.7013 23.0813 38.8771C23.3051 39.0528 23.6111 39.0794 23.8636 38.9465L27.6737 36.9206C27.8113 36.8475 27.9211 36.7323 27.9875 36.5916L32.9897 25.9818L44.2497 19.9948C45.4097 19.378 46.4641 18.578 47.3704 17.627L48.5051 16.4369C49.1468 15.7645 49.2867 14.7612 48.8524 13.9443L48.8126 13.8695C48.3777 13.0542 47.4683 12.6103 46.5558 12.7656L46.5542 12.7677ZM10.5286 31.4362L12.094 30.6039L10.2075 34.6084L10.5286 31.4362ZM8.6285 27.5791L3.14908 22.3803L4.46887 21.6786L12.065 25.7519L8.62956 27.5786L8.6285 27.5791ZM23.0393 19.9168L16.2403 17.8533L17.7072 17.0733L27.4697 17.5611L23.0393 19.9168ZM39.8669 15.4311C39.7739 15.2561 39.8406 15.0395 40.0163 14.9461L41.57 14.12C41.8879 14.243 42.2138 14.3401 42.5466 14.4119L40.3525 15.5785C40.1769 15.6719 39.9599 15.6061 39.8669 15.4311ZM26.7879 35.7705L24.632 36.9168L27.0904 27.4975L31.8912 24.9448L26.7869 35.7711L26.7879 35.7705Z", fill: "currentColor" }),
      /* @__PURE__ */ f.jsx("path", { d: "M36.5617 18.406L36.2255 17.7735C36.0399 17.4246 35.6045 17.2925 35.2542 17.4788C34.9038 17.665 34.7699 18.0999 34.9554 18.4488L35.2917 19.0813C35.4772 19.4302 35.9126 19.5623 36.263 19.376C36.6133 19.1898 36.7472 18.7549 36.5617 18.406Z", fill: "currentColor" }),
      /* @__PURE__ */ f.jsx("path", { d: "M33.722 20.7256C34.0723 20.5394 34.2062 20.1045 34.0207 19.7556L33.6844 19.1231C33.4989 18.7743 33.0635 18.6421 32.7131 18.8284C32.3628 19.0146 32.2289 19.4496 32.4144 19.7984L32.7507 20.4309C32.9362 20.7798 33.3716 20.9119 33.722 20.7256Z", fill: "currentColor" }),
      /* @__PURE__ */ f.jsx("path", { d: "M31.4807 21.1071L31.1444 20.4747C30.9589 20.1258 30.5234 19.9937 30.1731 20.1799C29.8228 20.3662 29.6888 20.8011 29.8744 21.15L30.2106 21.7824C30.3961 22.1313 30.8316 22.2635 31.1819 22.0772C31.5322 21.8909 31.6662 21.456 31.4807 21.1071Z", fill: "currentColor" }),
      /* @__PURE__ */ f.jsx("path", { d: "M28.9406 22.4567L28.6044 21.8243C28.4189 21.4754 27.9834 21.3433 27.6331 21.5295C27.2827 21.7158 27.1488 22.1507 27.3343 22.4996L27.6706 23.132C27.8561 23.4809 28.2916 23.6131 28.6419 23.4268C28.9922 23.2406 29.1261 22.8056 28.9406 22.4567Z", fill: "currentColor" }),
      /* @__PURE__ */ f.jsx("path", { d: "M26.4006 23.8083L26.0643 23.1759C25.8788 22.827 25.4434 22.6948 25.093 22.8811C24.7427 23.0674 24.6088 23.5023 24.7943 23.8512L25.1305 24.4836C25.3161 24.8325 25.7515 24.9647 26.1018 24.7784C26.4522 24.5921 26.5861 24.1572 26.4006 23.8083Z", fill: "currentColor" }),
      /* @__PURE__ */ f.jsx("path", { d: "M23.8606 25.1579L23.5243 24.5255C23.3388 24.1766 22.9033 24.0444 22.553 24.2307C22.2027 24.417 22.0687 24.8519 22.2542 25.2008L22.5905 25.8332C22.776 26.1821 23.2115 26.3143 23.5618 26.128C23.9121 25.9417 24.0461 25.5068 23.8606 25.1579Z", fill: "currentColor" }),
      /* @__PURE__ */ f.jsx("path", { d: "M21.3205 26.5095L20.9842 25.8771C20.7987 25.5282 20.3633 25.396 20.013 25.5823C19.6626 25.7685 19.5287 26.2035 19.7142 26.5523L20.0505 27.1848C20.236 27.5337 20.6714 27.6658 21.0218 27.4796C21.3721 27.2933 21.506 26.8584 21.3205 26.5095Z", fill: "currentColor" }),
      /* @__PURE__ */ f.jsx("path", { d: "M18.7805 27.8591L18.4442 27.2267C18.2587 26.8778 17.8232 26.7456 17.4729 26.9319C17.1226 27.1182 16.9887 27.5531 17.1742 27.902L17.5104 28.5344C17.6959 28.8833 18.1314 29.0154 18.4817 28.8292C18.832 28.6429 18.966 28.208 18.7805 27.8591Z", fill: "currentColor" })
    ]
  }
), pS = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsxs("g", { "clip-path": "url(#clip0_2676_51189)", children: [
      /* @__PURE__ */ f.jsx("path", { d: "M23.3023 19.6547C23.3023 19.6547 27.8473 22.4595 27.8501 22.4609C28.1771 22.6627 28.6165 22.5587 28.8176 22.2317C29.0187 21.9047 28.9161 21.466 28.5891 21.2642C28.5891 21.2642 24.0469 18.4615 24.0413 18.458C23.7143 18.2562 23.2742 18.3624 23.0731 18.6872C22.8713 19.0121 22.9782 19.4551 23.3023 19.6547Z", fill: "currentColor" }),
      /* @__PURE__ */ f.jsx("path", { d: "M20.9115 18.1735C21.0198 18.2424 21.1456 18.2832 21.2771 18.2832C21.5232 18.2832 21.7475 18.1588 21.8762 17.9492C22.1504 17.5027 21.8059 16.877 21.2785 16.877C20.8292 16.877 20.491 17.3045 20.5937 17.7411C20.6345 17.9155 20.754 18.0737 20.9115 18.1735Z", fill: "currentColor" }),
      /* @__PURE__ */ f.jsx("path", { d: "M8.88406 22.5684C9.01625 22.572 9.14774 22.5417 9.25813 22.4721C9.25813 22.4721 13.7757 19.6231 13.7785 19.6209C14.1034 19.4156 14.2025 18.9769 13.9979 18.6513C13.7996 18.3356 13.3426 18.233 13.0283 18.432C13.0283 18.432 8.51563 21.2775 8.50789 21.2824C8.18305 21.4877 8.0832 21.9265 8.28852 22.252C8.41156 22.4475 8.64922 22.5621 8.88477 22.5684H8.88406Z", fill: "currentColor" }),
      /* @__PURE__ */ f.jsx("path", { d: "M15.7823 18.2285C16.1079 18.2285 16.3961 17.9993 16.4679 17.6808C16.5663 17.2448 16.2267 16.8223 15.7809 16.8223C15.4547 16.8223 15.1685 17.0515 15.0961 17.37C14.9976 17.8031 15.3408 18.2285 15.7823 18.2285Z", fill: "currentColor" }),
      /* @__PURE__ */ f.jsx("path", { d: "M36.162 32.5251C35.9075 32.2319 35.4631 32.2009 35.1699 32.4562C34.4204 33.108 33.7264 33.7837 32.7428 34.0558C31.6494 34.3581 30.6102 34.1198 29.6202 33.6248L33.2821 21.3046C33.3735 20.998 33.2462 20.669 32.9727 20.503L29.585 18.4499V12.4558C29.585 12.0677 29.27 11.7527 28.8819 11.7527H27.4756V9.64328C27.4756 9.25516 27.1606 8.94016 26.7725 8.94016H24.5577V6.83078C24.5577 6.44266 24.2427 6.12766 23.8545 6.12766H20.4444V1.20508C20.4444 0.816953 20.1294 0.501953 19.7413 0.501953H16.9288C16.5406 0.501953 16.2256 0.816953 16.2256 1.20508V6.12695H12.8155C12.4274 6.12695 12.1124 6.44195 12.1124 6.83008V8.93945H9.89752C9.50939 8.93945 9.19439 9.25445 9.19439 9.64258V11.752H7.78814C7.40002 11.752 7.08502 12.067 7.08502 12.4551V18.4492L3.69736 20.5016C3.42385 20.6676 3.29658 20.9966 3.38799 21.3032C3.38799 21.3032 7.04072 33.5931 7.04213 33.5988C6.97955 33.3892 5.85455 33.2507 5.65557 33.2247C3.60807 32.9596 2.05135 33.9855 0.576894 35.2673C0.283691 35.5218 0.252754 35.9662 0.507285 36.2594C0.750566 36.5392 1.20338 36.5863 1.49939 36.3283C3.01885 35.0078 4.73166 34.0009 6.74189 35.0057C8.56017 35.9148 10.4431 36.3051 12.3374 35.308C13.8646 34.5044 15.3383 33.8097 17.0434 34.6218L18.7963 35.4564C20.296 36.1708 22.0074 36.1539 23.4931 35.4114C24.4086 34.9537 25.3388 34.3448 26.3844 34.273C27.4095 34.2027 28.3995 34.5845 29.3003 35.0345C30.4899 35.6294 31.8828 35.7482 33.1597 35.384C34.336 35.0486 35.1924 34.2991 36.0938 33.5158C36.387 33.2612 36.418 32.8169 36.1635 32.5237L36.162 32.5251ZM28.3208 33.0609C28.3285 32.8436 26.3492 32.845 26.217 32.8591C24.9964 32.9884 23.941 33.6163 22.8638 34.1549C21.5912 34.7912 20.282 34.6084 19.0388 34.0157V13.7031L31.7802 21.4234L28.3215 33.0609H28.3208ZM28.1788 17.5977L20.8522 13.1589H28.1788V17.5977ZM17.6312 1.9082H19.0374V6.12695H17.6312V1.9082ZM13.5179 7.5332H23.1507V8.93945H13.5179V7.5332ZM10.5999 10.3457H26.0687V11.752H10.5999V10.3457ZM8.49057 13.1582H15.8171L8.49057 17.597V13.1582ZM17.6312 13.7031V33.3456C17.6312 33.2205 16.6285 32.9905 16.4978 32.9617C15.2743 32.6966 13.9602 32.8647 12.8506 33.449C12.0456 33.8723 11.2693 34.3666 10.3482 34.4854C10.3468 34.4854 10.3447 34.4854 10.3433 34.4854C9.80541 34.5508 9.25486 34.5114 8.73455 34.3595L4.88916 21.4227L17.6305 13.7024L17.6312 13.7031Z", fill: "currentColor" })
    ] })
  }
), vS = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 38 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsxs("g", { "clip-path": "url(#clip0_2383_69953)", children: [
      /* @__PURE__ */ f.jsx("path", { d: "M26.8439 29.5664C25.492 29.5664 24.3926 30.6658 24.3926 32.0177C24.3926 33.3695 25.492 34.4689 26.8439 34.4689C28.1958 34.4689 29.2952 33.3695 29.2952 32.0177C29.2952 30.6658 28.1958 29.5664 26.8439 29.5664ZM26.8439 33.384C26.0904 33.384 25.4766 32.7711 25.4766 32.0167C25.4766 31.2622 26.0894 30.6494 26.8439 30.6494C27.5984 30.6494 28.2112 31.2622 28.2112 32.0167C28.2112 32.7711 27.5984 33.384 26.8439 33.384Z", fill: "currentColor" }),
      /* @__PURE__ */ f.jsx("path", { d: "M20.7339 23.437C21.0336 23.437 21.2754 23.1942 21.2754 22.8955V5.2251C21.2754 4.92544 21.0326 4.68359 20.7339 4.68359C20.4352 4.68359 20.1924 4.92641 20.1924 5.2251V22.8945C20.1924 23.1942 20.4352 23.436 20.7339 23.436V23.437Z", fill: "currentColor" }),
      /* @__PURE__ */ f.jsx("path", { d: "M23.3628 23.437C23.6615 23.437 23.9053 23.1942 23.9053 22.8955V5.2251C23.9053 4.92544 23.6625 4.68359 23.3628 4.68359C23.0631 4.68359 22.8213 4.92641 22.8213 5.2251V22.8945C22.8213 23.1942 23.0641 23.436 23.3628 23.436V23.437Z", fill: "currentColor" }),
      /* @__PURE__ */ f.jsx("path", { d: "M25.9907 23.437C26.2904 23.437 26.5323 23.1942 26.5323 22.8955V5.2251C26.5323 4.92544 26.2894 4.68359 25.9907 4.68359C25.692 4.68359 25.4492 4.92641 25.4492 5.2251V22.8945C25.4492 23.1942 25.692 23.436 25.9907 23.436V23.437Z", fill: "currentColor" }),
      /* @__PURE__ */ f.jsx("path", { d: "M28.6196 23.437C28.9193 23.437 29.1612 23.1942 29.1612 22.8955V5.2251C29.1612 4.92544 28.9184 4.68359 28.6196 4.68359C28.3209 4.68359 28.0781 4.92641 28.0781 5.2251V22.8945C28.0781 23.1942 28.3209 23.436 28.6196 23.436V23.437Z", fill: "currentColor" }),
      /* @__PURE__ */ f.jsx("path", { d: "M31.2466 23.437C31.5463 23.437 31.7881 23.1942 31.7881 22.8955V5.2251C31.7881 4.92544 31.5453 4.68359 31.2466 4.68359C30.9479 4.68359 30.7051 4.92641 30.7051 5.2251V22.8945C30.7051 23.1942 30.9479 23.436 31.2466 23.436V23.437Z", fill: "currentColor" }),
      /* @__PURE__ */ f.jsx("path", { d: "M33.8745 23.437C34.1742 23.437 34.4161 23.1942 34.4161 22.8955V5.2251C34.4161 4.92544 34.1732 4.68359 33.8745 4.68359C33.5758 4.68359 33.333 4.92641 33.333 5.2251V22.8945C33.333 23.1942 33.5758 23.436 33.8745 23.436V23.437Z", fill: "currentColor" }),
      /* @__PURE__ */ f.jsx("path", { d: "M16.0483 18.9138C15.8884 18.6614 15.553 18.5862 15.3006 18.7462L11.8279 20.9459C11.5754 21.1059 11.5003 21.4412 11.6602 21.6936C11.8202 21.9461 12.1555 22.0222 12.4079 21.8613L15.8806 19.6615C16.1331 19.5016 16.2083 19.1663 16.0483 18.9138Z", fill: "currentColor" }),
      /* @__PURE__ */ f.jsx("path", { d: "M15.3004 23.4497L13.9543 24.3024C13.7018 24.4624 13.6257 24.7977 13.7866 25.0501C13.9466 25.3036 14.2819 25.3778 14.5343 25.2178L15.8805 24.3651C16.1329 24.2051 16.209 23.8698 16.0481 23.6174C15.8882 23.3649 15.5528 23.2888 15.3004 23.4497Z", fill: "currentColor" }),
      /* @__PURE__ */ f.jsx("path", { d: "M16.0484 21.2654C15.8885 21.0129 15.5531 20.9378 15.3007 21.0977L12.8908 22.624C12.6384 22.7839 12.5622 23.1192 12.7231 23.3717C12.8831 23.6241 13.2184 23.6993 13.4709 23.5393L15.8808 22.0131C16.1332 21.8531 16.2084 21.5178 16.0484 21.2654Z", fill: "currentColor" }),
      /* @__PURE__ */ f.jsx("path", { d: "M2.17802 19.7725L7.35045 20.1387C8.10589 20.1917 8.60212 19.3678 8.20802 18.7261L7.60098 17.7366L12.943 14.4547C13.3882 14.1811 13.5279 13.5991 13.2542 13.154L12.2984 11.5988C12.0247 11.1546 11.4408 11.0149 10.9976 11.2885L5.65554 14.5704L5.04753 13.5808C4.6515 12.9372 3.69275 13.0104 3.39983 13.707L1.38886 18.4862C1.14219 19.072 1.54496 19.7282 2.17899 19.7735L2.17802 19.7725ZM4.28053 14.4056L4.8683 15.3624C5.1063 15.7488 5.61025 15.8682 5.99568 15.6312L11.4456 12.2829L12.2569 13.603L6.807 16.9513C6.42157 17.1873 6.30113 17.6932 6.5372 18.0786L7.12594 19.0354L2.47095 18.7068L4.28149 14.4056H4.28053Z", fill: "currentColor" }),
      /* @__PURE__ */ f.jsx("path", { d: "M36.2076 0H28.5703C28.2707 0 28.0288 0.242812 28.0288 0.54151C28.0288 0.840208 28.2716 1.08302 28.5703 1.08302H36.0842V2.62469H17.8372V1.08398H26.041C26.3407 1.08398 26.5825 0.841172 26.5825 0.542474C26.5825 0.243776 26.3397 0.000963542 26.041 0.000963542H17.7138C17.1839 0.000963542 16.7532 0.431667 16.7532 0.961614V2.74995C16.7532 3.18547 17.0451 3.55354 17.4431 3.67109V24.4508C17.1752 24.5298 16.9565 24.7226 16.8418 24.9721L13.8827 26.8472L12.79 25.1224C12.6301 24.87 12.2947 24.7948 12.0423 24.9548C11.7898 25.1147 11.7147 25.45 11.8746 25.7025L12.9673 27.4272C11.9989 28.041 7.66287 30.789 6.95947 31.2342L3.52146 25.8056L5.15375 24.7717L6.49599 26.8915C6.73978 27.2769 7.25143 27.3916 7.63686 27.1478L8.98489 26.2941C9.37031 26.0503 9.48498 25.5387 9.24119 25.1533L7.89895 23.0335L9.53123 21.9996L10.5227 23.5653C10.6827 23.8178 11.018 23.8929 11.2705 23.733C11.5229 23.573 11.599 23.2377 11.4381 22.9853L10.4042 21.3521C10.1074 20.8828 9.4869 20.7441 9.01765 21.0409L2.87491 24.9316C2.40662 25.2284 2.26786 25.8499 2.56368 26.3182L6.04504 31.8142L0.609564 35.2589C-0.185378 35.7628 0.170178 37 1.11447 37H3.51279C3.77199 37 4.02348 36.9268 4.24317 36.788L17.922 28.12H18.1195V31.2929C18.1195 31.9915 18.688 32.559 19.3866 32.559H21.8957C22.1665 35.0527 24.2834 36.999 26.8475 36.999C29.4115 36.999 31.5285 35.0527 31.7993 32.559H35.9041C36.6026 32.559 37.1702 31.9915 37.1702 31.2929V0.960651C37.1702 0.430703 36.7395 0 36.2095 0H36.2076ZM6.9797 23.6135L8.18416 25.5155L7.27166 26.0937L6.06721 24.1916C6.62704 23.8371 6.41987 23.9681 6.9797 23.6135ZM3.65925 35.8727C3.61397 35.9016 3.56193 35.916 3.50894 35.916H1.59433C2.30159 35.468 16.1442 26.6949 16.7522 26.3105V27.1593C16.7522 27.2827 16.7792 27.4176 16.8264 27.5284L3.66022 35.8717L3.65925 35.8727ZM21.8909 31.477H19.3818C19.2816 31.477 19.1997 31.3951 19.1997 31.2949V28.1219H23.7438C22.681 28.9689 22.0297 30.1935 21.8899 31.4779L21.8909 31.477ZM26.8436 35.917C24.6949 35.917 22.946 34.1681 22.946 32.0195C22.946 29.8708 24.6949 28.1219 26.8436 28.1219C28.9924 28.1219 30.7413 29.8698 30.7413 32.0195C30.7413 34.1691 28.9934 35.917 26.8436 35.917ZM36.0833 31.2949C36.0833 31.3951 36.0014 31.477 35.9012 31.477H31.7973C31.6547 30.1646 30.9822 28.9477 29.9434 28.121H36.0833V31.2949ZM36.0833 27.037H17.8362V25.4953H36.0833V27.037ZM36.0833 24.4113H18.5261V3.70964H36.0833V24.4104V24.4113Z", fill: "currentColor" })
    ] })
  }
), gS = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 34 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsxs("g", { "clip-path": "url(#clip0_2383_69969)", children: [
      /* @__PURE__ */ f.jsx("path", { d: "M2.15098 30.25H15.351C15.6552 30.25 15.901 30.0034 15.901 29.7C15.901 29.3966 15.6552 29.15 15.351 29.15H2.15098C1.84676 29.15 1.60098 28.9042 1.60098 28.6V8.8H7.65098C8.56277 8.8 9.30098 8.0618 9.30098 7.15V1.1H24.151C24.4543 1.1 24.701 1.34578 24.701 1.65V14.85C24.701 15.1542 24.9468 15.4 25.251 15.4C25.5552 15.4 25.801 15.1542 25.801 14.85V1.65C25.801 0.739063 25.0628 0 24.151 0H8.75098C8.60574 0 8.46566 0.0584375 8.36254 0.161563L0.662539 7.86156C0.559414 7.96469 0.500977 8.10477 0.500977 8.25V28.6C0.500977 29.5109 1.24004 30.25 2.15098 30.25ZM7.65098 7.7H2.37871L8.20098 1.87773V7.15C8.20098 7.45422 7.95434 7.7 7.65098 7.7Z", fill: "currentColor" }),
      /* @__PURE__ */ f.jsx("path", { d: "M3.25117 24.1992C2.94695 24.1992 2.70117 24.445 2.70117 24.7492V27.4992C2.70117 27.8034 2.94695 28.0492 3.25117 28.0492H6.00117C6.30539 28.0492 6.55117 27.8034 6.55117 27.4992C6.55117 27.195 6.30539 26.9492 6.00117 26.9492H3.80117V24.7492C3.80117 24.445 3.55539 24.1992 3.25117 24.1992Z", fill: "currentColor" }),
      /* @__PURE__ */ f.jsx("path", { d: "M23.601 5.49922V2.74922C23.601 2.445 23.3543 2.19922 23.051 2.19922H20.301C19.9976 2.19922 19.751 2.445 19.751 2.74922C19.751 3.05344 19.9976 3.29922 20.301 3.29922H22.501V5.49922C22.501 5.80344 22.7476 6.04922 23.051 6.04922C23.3543 6.04922 23.601 5.80344 23.601 5.49922Z", fill: "currentColor" }),
      /* @__PURE__ */ f.jsx("path", { d: "M31.301 16.5H19.201C17.9858 16.5 17.001 17.4848 17.001 18.7V30.8C17.001 32.0152 17.9858 33 19.201 33H31.301C32.5161 33 33.501 32.0152 33.501 30.8V18.7C33.501 17.4848 32.5161 16.5 31.301 16.5ZM28.551 17.6V22.8937C28.551 22.9668 28.5149 23.0347 28.4547 23.0759C28.3946 23.1172 28.3181 23.1249 28.2502 23.0983L25.7417 22.0945C25.4271 21.9691 25.0757 21.9691 24.7611 22.0945L22.2535 23.1009C22.1856 23.1284 22.1082 23.1198 22.0472 23.0785C21.9871 23.0373 21.951 22.9677 21.9518 22.8946V17.6009H28.5518L28.551 17.6ZM32.401 30.8C32.401 31.4076 31.9086 31.9 31.301 31.9H19.201C18.5934 31.9 18.101 31.4076 18.101 30.8V18.7C18.101 18.0924 18.5934 17.6 19.201 17.6H20.851V22.8937C20.851 23.332 21.0684 23.7411 21.4311 23.9869C21.7937 24.2327 22.2552 24.2816 22.6617 24.1192L25.1693 23.1155C25.2226 23.094 25.2811 23.094 25.3343 23.1155L27.8429 24.1192C28.2493 24.2816 28.71 24.2309 29.0718 23.986C29.4336 23.7402 29.651 23.3312 29.651 22.8937V17.6H31.301C31.9086 17.6 32.401 18.0924 32.401 18.7V30.8Z", fill: "currentColor" }),
      /* @__PURE__ */ f.jsx("path", { d: "M22.501 29.1504H20.301C19.9976 29.1504 19.751 29.397 19.751 29.7004C19.751 30.0037 19.9976 30.2504 20.301 30.2504H22.501C22.8043 30.2504 23.051 30.0037 23.051 29.7004C23.051 29.397 22.8052 29.1504 22.501 29.1504Z", fill: "currentColor" }),
      /* @__PURE__ */ f.jsx("path", { d: "M12.051 10.4492H3.80098C3.49762 10.4492 3.25098 10.695 3.25098 10.9992C3.25098 11.3034 3.49762 11.5492 3.80098 11.5492H12.051C12.3552 11.5492 12.601 11.3034 12.601 10.9992C12.601 10.695 12.3543 10.4492 12.051 10.4492Z", fill: "currentColor" }),
      /* @__PURE__ */ f.jsx("path", { d: "M22.5012 10.4492H14.2512C13.947 10.4492 13.7012 10.695 13.7012 10.9992C13.7012 11.3034 13.947 11.5492 14.2512 11.5492H22.5012C22.8045 11.5492 23.0512 11.3034 23.0512 10.9992C23.0512 10.695 22.8054 10.4492 22.5012 10.4492Z", fill: "currentColor" }),
      /* @__PURE__ */ f.jsx("path", { d: "M12.051 12.6504H3.80098C3.49762 12.6504 3.25098 12.897 3.25098 13.2004C3.25098 13.5038 3.49762 13.7504 3.80098 13.7504H12.051C12.3552 13.7504 12.601 13.5038 12.601 13.2004C12.601 12.897 12.3543 12.6504 12.051 12.6504Z", fill: "currentColor" }),
      /* @__PURE__ */ f.jsx("path", { d: "M22.5012 12.6504H14.2512C13.947 12.6504 13.7012 12.897 13.7012 13.2004C13.7012 13.5038 13.947 13.7504 14.2512 13.7504H22.5012C22.8045 13.7504 23.0512 13.5038 23.0512 13.2004C23.0512 12.897 22.8054 12.6504 22.5012 12.6504Z", fill: "currentColor" }),
      /* @__PURE__ */ f.jsx("path", { d: "M12.051 14.8496H3.80098C3.49762 14.8496 3.25098 15.0954 3.25098 15.3996C3.25098 15.7038 3.49762 15.9496 3.80098 15.9496H12.051C12.3552 15.9496 12.601 15.703 12.601 15.3996C12.601 15.0962 12.3543 14.8496 12.051 14.8496Z", fill: "currentColor" }),
      /* @__PURE__ */ f.jsx("path", { d: "M12.051 17.0508H3.80098C3.49762 17.0508 3.25098 17.2974 3.25098 17.6008C3.25098 17.9041 3.49762 18.1508 3.80098 18.1508H12.051C12.3552 18.1508 12.601 17.905 12.601 17.6008C12.601 17.2966 12.3543 17.0508 12.051 17.0508Z", fill: "currentColor" }),
      /* @__PURE__ */ f.jsx("path", { d: "M12.051 19.25H3.80098C3.49762 19.25 3.25098 19.4966 3.25098 19.8C3.25098 20.1034 3.49762 20.35 3.80098 20.35H12.051C12.3552 20.35 12.601 20.1034 12.601 19.8C12.601 19.4966 12.3543 19.25 12.051 19.25Z", fill: "currentColor" }),
      /* @__PURE__ */ f.jsx("path", { d: "M12.601 21.9992C12.601 21.695 12.3543 21.4492 12.051 21.4492H3.80098C3.49762 21.4492 3.25098 21.695 3.25098 21.9992C3.25098 22.3034 3.49762 22.5492 3.80098 22.5492H12.051C12.3552 22.5492 12.601 22.3034 12.601 21.9992Z", fill: "currentColor" })
    ] })
  }
), mS = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsx("path", { d: "M0.525597 18.8546C0.654764 19.4617 1.18435 19.875 1.79143 19.875C2.83768 19.875 4.87851 18.7383 6.00226 17.6663C7.46185 19.0225 9.11518 19.875 10.8331 19.875C16.1806 19.875 18.5831 15.3412 18.5831 12.125C18.5831 9.99375 16.8393 8.25 14.7081 8.25C12.5768 8.25 10.8331 9.99375 10.8331 12.125C10.8331 13.6233 11.621 15.4317 12.8739 16.9171C12.2927 17.1496 11.621 17.2917 10.8331 17.2917C9.79976 17.2917 8.70185 16.6717 7.66851 15.6771C9.73518 12.6546 10.8331 8.65042 10.8331 5.66667C10.8331 2.68292 8.52101 0.5 5.66643 0.5C2.81185 0.5 0.499764 2.81208 0.499764 5.66667C0.499764 8.52125 1.9981 12.7192 4.28435 15.7417C3.4706 16.5425 2.5406 17.0979 1.52018 17.3175C0.82268 17.4596 0.370597 18.1442 0.525597 18.8417V18.8546ZM14.7081 10.8333C15.4185 10.8333 15.9998 11.4146 15.9998 12.125C15.9998 12.9646 15.6898 14.2433 14.9018 15.3154C13.9331 14.1917 13.4164 12.9129 13.4164 12.125C13.4164 11.4146 13.9977 10.8333 14.7081 10.8333ZM3.0831 5.66667C3.0831 4.24583 4.2456 3.08333 5.66643 3.08333C7.08726 3.08333 8.24976 4.24583 8.24976 5.66667C8.24976 8.03042 7.41018 11.1692 5.93768 13.6104C4.28435 11.195 3.0831 8.05625 3.0831 5.66667ZM18.906 5.48583C19.3839 4.95625 20.1977 4.90458 20.7273 5.3825C21.4377 6.02833 22.0448 6.76458 22.5356 7.60417C22.8973 8.22417 22.6777 9.01208 22.0706 9.37375C21.8639 9.49 21.6443 9.54167 21.4248 9.54167C20.9727 9.54167 20.5464 9.30917 20.301 8.89583C19.9523 8.30167 19.526 7.77208 19.0093 7.30708C18.4798 6.82917 18.4281 6.01542 18.906 5.48583ZM28.9164 19.2808V17.2917C28.9164 14.4371 26.6043 12.125 23.7498 12.125C20.8952 12.125 18.5831 14.4371 18.5831 17.2917V19.2808C17.046 20.1721 15.9998 21.8512 15.9998 23.75V26.3333C15.9998 29.1879 18.3118 31.5 21.1664 31.5H26.3331C29.1877 31.5 31.4998 29.1879 31.4998 26.3333V23.75C31.4998 21.8383 30.4535 20.1721 28.9164 19.2808ZM21.1664 17.2917C21.1664 15.8708 22.3289 14.7083 23.7498 14.7083C25.1706 14.7083 26.3331 15.8708 26.3331 17.2917V18.5833H21.1664V17.2917ZM28.9164 26.3333C28.9164 27.7542 27.7539 28.9167 26.3331 28.9167H21.1664C19.7456 28.9167 18.5831 27.7542 18.5831 26.3333V23.75C18.5831 22.3292 19.7456 21.1667 21.1664 21.1667H26.3331C27.7539 21.1667 28.9164 22.3292 28.9164 23.75V26.3333ZM13.4164 23.75C13.4164 24.4604 12.8352 25.0417 12.1248 25.0417H1.79143C1.08101 25.0417 0.499764 24.4604 0.499764 23.75C0.499764 23.0396 1.08101 22.4583 1.79143 22.4583H12.1248C12.8352 22.4583 13.4164 23.0396 13.4164 23.75ZM25.6873 25.0417C25.6873 26.1137 24.8218 26.9792 23.7498 26.9792C22.6777 26.9792 21.8123 26.1137 21.8123 25.0417C21.8123 23.9696 22.6777 23.1042 23.7498 23.1042C24.8218 23.1042 25.6873 23.9696 25.6873 25.0417Z", fill: "currentColor" })
  }
), CS = () => /* @__PURE__ */ f.jsxs("svg", { className: "w-full", viewBox: "0 0 24 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ f.jsx("path", { d: "M11.9543 2.06241C13.2808 2.06676 14.5933 2.33415 15.8158 2.8491C17.0383 3.36404 18.1465 4.11633 19.0763 5.06241H15.9543C15.6891 5.06241 15.4347 5.16777 15.2472 5.3553C15.0597 5.54284 14.9543 5.79719 14.9543 6.06241C14.9543 6.32763 15.0597 6.58198 15.2472 6.76952C15.4347 6.95705 15.6891 7.06241 15.9543 7.06241H20.0973C20.5897 7.06214 21.0619 6.86641 21.4101 6.51821C21.7583 6.17002 21.954 5.69784 21.9543 5.20541V1.06241C21.9543 0.797193 21.8489 0.542839 21.6614 0.355303C21.4739 0.167767 21.2195 0.0624097 20.9543 0.0624097C20.6891 0.0624097 20.4347 0.167767 20.2472 0.355303C20.0597 0.542839 19.9543 0.797193 19.9543 1.06241V3.14041C18.3015 1.65186 16.2669 0.652819 14.0784 0.255159C11.8899 -0.142502 9.63393 0.0769217 7.56309 0.888857C5.49225 1.70079 3.68832 3.07318 2.35332 4.85233C1.01831 6.63149 0.204946 8.74715 0.00430406 10.9624C-0.00861256 11.1017 0.00761984 11.2421 0.051967 11.3747C0.0963141 11.5074 0.167804 11.6293 0.26188 11.7328C0.355957 11.8363 0.470558 11.919 0.598382 11.9758C0.726206 12.0325 0.864449 12.062 1.0043 12.0624C1.24889 12.0655 1.48584 11.9772 1.66876 11.8149C1.85169 11.6525 1.96742 11.4276 1.9933 11.1844C2.21592 8.69516 3.36128 6.37911 5.20438 4.69125C7.04749 3.00338 9.45512 2.0657 11.9543 2.06241Z", fill: "currentColor" }),
  /* @__PURE__ */ f.jsx("path", { d: "M22.9051 12.0625C22.6605 12.0593 22.4236 12.1476 22.2406 12.31C22.0577 12.4724 21.942 12.6972 21.9161 12.9405C21.7508 14.8437 21.043 16.6596 19.8768 18.1727C18.7105 19.6858 17.1347 20.8326 15.3362 21.477C13.5378 22.1215 11.5923 22.2365 9.73045 21.8086C7.86861 21.3806 6.1686 20.4275 4.8321 19.0625H7.9541C8.21932 19.0625 8.47367 18.9571 8.66121 18.7696C8.84875 18.582 8.9541 18.3277 8.9541 18.0625C8.9541 17.7972 8.84875 17.5429 8.66121 17.3554C8.47367 17.1678 8.21932 17.0625 7.9541 17.0625H3.8111C3.5672 17.0623 3.32566 17.1103 3.1003 17.2035C2.87494 17.2968 2.67018 17.4336 2.49771 17.6061C2.32525 17.7785 2.18847 17.9833 2.09519 18.2087C2.00191 18.434 1.95397 18.6756 1.9541 18.9195V23.0625C1.9541 23.3277 2.05946 23.582 2.24699 23.7696C2.43453 23.9571 2.68889 24.0625 2.9541 24.0625C3.21932 24.0625 3.47367 23.9571 3.66121 23.7696C3.84875 23.582 3.9541 23.3277 3.9541 23.0625V20.9845C5.60693 22.473 7.64151 23.472 9.83 23.8697C12.0185 24.2674 14.2745 24.0479 16.3453 23.236C18.4162 22.4241 20.2201 21.0517 21.5551 19.2725C22.8901 17.4934 23.7035 15.3777 23.9041 13.1625C23.917 13.0232 23.9008 12.8828 23.8564 12.7501C23.8121 12.6175 23.7406 12.4956 23.6465 12.3921C23.5524 12.2886 23.4378 12.2058 23.31 12.1491C23.1822 12.0923 23.045 12.0628 22.9051 12.0625Z", fill: "currentColor" })
] }), bS = () => /* @__PURE__ */ f.jsxs("svg", { viewBox: "0 0 41 41", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ f.jsx("path", { d: "M20.5 41C31.8218 41 41 31.8218 41 20.5C41 9.17816 31.8218 0 20.5 0C9.17816 0 0 9.17816 0 20.5C0 31.8218 9.17816 41 20.5 41Z", fill: "#77B3D4" }),
  /* @__PURE__ */ f.jsx("path", { opacity: "0.2", d: "M7.6875 16.0156V32.0312C7.6875 33.4406 8.84062 34.5938 10.25 34.5938H30.75C32.1594 34.5938 33.3125 33.4406 33.3125 32.0312V16.0156H7.6875Z", fill: "#007AFF" }),
  /* @__PURE__ */ f.jsx("path", { d: "M7.6875 14.7344V30.75C7.6875 32.1594 8.84062 33.3125 10.25 33.3125H30.75C32.1594 33.3125 33.3125 32.1594 33.3125 30.75V14.7344H7.6875Z", fill: "white" }),
  /* @__PURE__ */ f.jsx("path", { opacity: "0.2", d: "M30.75 8.96875H10.25C8.84062 8.96875 7.6875 10.1219 7.6875 11.5312V16.0156H33.3125V11.5312C33.3125 10.1219 32.1594 8.96875 30.75 8.96875Z", fill: "#007AFF" }),
  /* @__PURE__ */ f.jsx("path", { d: "M30.75 7.6875H10.25C8.84062 7.6875 7.6875 8.84062 7.6875 10.25V14.7344H33.3125V10.25C33.3125 8.84062 32.1594 7.6875 30.75 7.6875Z", fill: "#C75C5C" }),
  /* @__PURE__ */ f.jsx("path", { d: "M20.5 30.75C19.7953 30.75 19.2188 30.1734 19.2188 29.4688C19.2188 25.9453 20.3719 23.3828 21.4609 21.7812H17.2969C16.5922 21.7812 16.0156 21.2047 16.0156 20.5C16.0156 19.7953 16.5922 19.2188 17.2969 19.2188H24.3438C24.9203 19.2188 25.3688 19.6031 25.5609 20.1156C25.7531 20.6281 25.5609 21.2047 25.1125 21.525C24.9844 21.6531 21.7812 24.0234 21.7812 29.4688C21.7812 30.1734 21.2047 30.75 20.5 30.75Z", fill: "white", "fill-opacity": "0.3" }),
  /* @__PURE__ */ f.jsx("path", { opacity: "0.2", d: "M12.8125 13.4531C12.1078 13.4531 11.5312 12.8766 11.5312 12.1719V7.6875C11.5312 6.98281 12.1078 6.40625 12.8125 6.40625C13.5172 6.40625 14.0938 6.98281 14.0938 7.6875V12.1719C14.0938 12.8766 13.5172 13.4531 12.8125 13.4531Z", fill: "#007AFF" }),
  /* @__PURE__ */ f.jsx("path", { opacity: "0.2", d: "M28.8281 13.4531C28.1234 13.4531 27.5469 12.8766 27.5469 12.1719V7.6875C27.5469 6.98281 28.1234 6.40625 28.8281 6.40625C29.5328 6.40625 30.1094 6.98281 30.1094 7.6875V12.1719C30.1094 12.8766 29.5328 13.4531 28.8281 13.4531Z", fill: "#007AFF" }),
  /* @__PURE__ */ f.jsx("path", { d: "M12.8125 12.1719C12.1078 12.1719 11.5312 11.5953 11.5312 10.8906V6.40625C11.5312 5.70156 12.1078 5.125 12.8125 5.125C13.5172 5.125 14.0938 5.70156 14.0938 6.40625V10.8906C14.0938 11.5953 13.5172 12.1719 12.8125 12.1719Z", fill: "#E0E0D1" }),
  /* @__PURE__ */ f.jsx("path", { d: "M28.8281 12.1719C28.1234 12.1719 27.5469 11.5953 27.5469 10.8906V6.40625C27.5469 5.70156 28.1234 5.125 28.8281 5.125C29.5328 5.125 30.1094 5.70156 30.1094 6.40625V10.8906C30.1094 11.5953 29.5328 12.1719 28.8281 12.1719Z", fill: "#E0E0D1" })
] }), yS = () => /* @__PURE__ */ f.jsxs("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ f.jsx("g", { "clip-path": "url(#clip0_280_423)", children: /* @__PURE__ */ f.jsx("path", { d: "M19 2H18V1C18 0.448 17.553 0 17 0C16.447 0 16 0.448 16 1V2H8V1C8 0.448 7.553 0 7 0C6.447 0 6 0.448 6 1V2H5C2.243 2 0 4.243 0 7V19C0 21.757 2.243 24 5 24H19C21.757 24 24 21.757 24 19V7C24 4.243 21.757 2 19 2ZM5 4H19C20.654 4 22 5.346 22 7V8H2V7C2 5.346 3.346 4 5 4ZM19 22H5C3.346 22 2 20.654 2 19V10H22V19C22 20.654 20.654 22 19 22ZM17.832 13.152C18.216 13.549 18.204 14.183 17.807 14.566L13.067 19.134C12.514 19.687 11.76 20 10.959 20C10.158 20 9.404 19.688 8.838 19.121L6.586 17.029C6.182 16.653 6.158 16.02 6.534 15.616C6.912 15.211 7.544 15.189 7.947 15.564L10.225 17.681C10.658 18.111 11.288 18.083 11.664 17.707L16.418 13.125C16.816 12.742 17.448 12.754 17.832 13.151V13.152Z", fill: "currentColor" }) }),
  /* @__PURE__ */ f.jsx("defs", { children: /* @__PURE__ */ f.jsx("clipPath", { id: "clip0_280_423", children: /* @__PURE__ */ f.jsx("rect", { width: "24", height: "24", fill: "currentColor" }) }) })
] }), wS = () => /* @__PURE__ */ f.jsxs("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ f.jsx("g", { "clip-path": "url(#clip0_280_421)", children: /* @__PURE__ */ f.jsx("path", { d: "M15.707 13.707L13.414 16L15.707 18.293C16.098 18.684 16.098 19.316 15.707 19.707C15.512 19.902 15.256 20 15 20C14.744 20 14.488 19.902 14.293 19.707L12 17.414L9.707 19.707C9.512 19.902 9.256 20 9 20C8.744 20 8.488 19.902 8.293 19.707C7.902 19.316 7.902 18.684 8.293 18.293L10.586 16L8.293 13.707C7.902 13.316 7.902 12.684 8.293 12.293C8.684 11.902 9.316 11.902 9.707 12.293L12 14.586L14.293 12.293C14.684 11.902 15.316 11.902 15.707 12.293C16.098 12.684 16.098 13.316 15.707 13.707ZM24 7V19C24 21.757 21.757 24 19 24H5C2.243 24 0 21.757 0 19V7C0 4.243 2.243 2 5 2H6V1C6 0.447 6.448 0 7 0C7.552 0 8 0.447 8 1V2H16V1C16 0.447 16.448 0 17 0C17.552 0 18 0.447 18 1V2H19C21.757 2 24 4.243 24 7ZM2 7V8H22V7C22 5.346 20.654 4 19 4H5C3.346 4 2 5.346 2 7ZM22 19V10H2V19C2 20.654 3.346 22 5 22H19C20.654 22 22 20.654 22 19Z", fill: "currentColor" }) }),
  /* @__PURE__ */ f.jsx("defs", { children: /* @__PURE__ */ f.jsx("clipPath", { id: "clip0_280_421", children: /* @__PURE__ */ f.jsx("rect", { width: "24", height: "24", fill: "currentColor" }) }) })
] }), xS = () => /* @__PURE__ */ f.jsxs("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ f.jsx("g", { "clip-path": "url(#clip0_280_419)", children: /* @__PURE__ */ f.jsx("path", { d: "M19 2H18V1C18 0.448 17.552 0 17 0C16.448 0 16 0.448 16 1V2H8V1C8 0.448 7.552 0 7 0C6.448 0 6 0.448 6 1V2H5C2.243 2 0 4.243 0 7V19C0 21.757 2.243 24 5 24H19C21.757 24 24 21.757 24 19V7C24 4.243 21.757 2 19 2ZM19 22H5C3.346 22 2 20.654 2 19V10H8C8.552 10 9 9.552 9 9C9 8.448 8.552 8 8 8H2V7C2 5.346 3.346 4 5 4H19C20.654 4 22 5.346 22 7V8H16C15.448 8 15 8.448 15 9C15 9.552 15.448 10 16 10H22V19C22 20.654 20.654 22 19 22ZM13 9V16C13 16.552 12.552 17 12 17C11.448 17 11 16.552 11 16V9C11 8.448 11.448 8 12 8C12.552 8 13 8.448 13 9ZM13 19C13 19.552 12.552 20 12 20C11.448 20 11 19.552 11 19C11 18.448 11.448 18 12 18C12.552 18 13 18.448 13 19Z", fill: "currentColor" }) }),
  /* @__PURE__ */ f.jsx("defs", { children: /* @__PURE__ */ f.jsx("clipPath", { id: "clip0_280_419", children: /* @__PURE__ */ f.jsx("rect", { width: "24", height: "24", fill: "currentColor" }) }) })
] }), OS = () => /* @__PURE__ */ f.jsxs("svg", { className: "w-full", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ f.jsxs("g", { children: [
    /* @__PURE__ */ f.jsx("path", { d: "M19.1666 13.3334C18.9456 13.3334 18.7337 13.4212 18.5774 13.5775C18.4211 13.7337 18.3333 13.9457 18.3333 14.1667V15.8334C18.3333 16.4964 18.0699 17.1323 17.6011 17.6011C17.1322 18.07 16.4964 18.3334 15.8333 18.3334H14.1666C13.9456 18.3334 13.7337 18.4212 13.5774 18.5775C13.4211 18.7337 13.3333 18.9457 13.3333 19.1667C13.3333 19.3877 13.4211 19.5997 13.5774 19.756C13.7337 19.9122 13.9456 20 14.1666 20H15.8333C16.938 19.9987 17.997 19.5593 18.7781 18.7782C19.5592 17.9971 19.9987 16.938 20 15.8334V14.1667C20 13.9457 19.9122 13.7337 19.7559 13.5775C19.5996 13.4212 19.3877 13.3334 19.1666 13.3334Z", fill: "currentColor" }),
    /* @__PURE__ */ f.jsx("path", { d: "M0.833333 6.66667C1.05435 6.66667 1.26631 6.57887 1.42259 6.42259C1.57887 6.26631 1.66667 6.05435 1.66667 5.83333V4.16667C1.66667 3.50363 1.93006 2.86774 2.3989 2.3989C2.86774 1.93006 3.50363 1.66667 4.16667 1.66667H5.83333C6.05435 1.66667 6.26631 1.57887 6.42259 1.42259C6.57887 1.26631 6.66667 1.05435 6.66667 0.833333C6.66667 0.61232 6.57887 0.400358 6.42259 0.244078C6.26631 0.0877974 6.05435 0 5.83333 0L4.16667 0C3.062 0.00132321 2.00296 0.440735 1.22185 1.22185C0.440735 2.00296 0.00132321 3.062 0 4.16667L0 5.83333C0 6.05435 0.0877974 6.26631 0.244078 6.42259C0.400358 6.57887 0.61232 6.66667 0.833333 6.66667Z", fill: "currentColor" }),
    /* @__PURE__ */ f.jsx("path", { d: "M5.83333 18.3334H4.16667C3.50363 18.3334 2.86774 18.07 2.3989 17.6011C1.93006 17.1323 1.66667 16.4964 1.66667 15.8334V14.1667C1.66667 13.9457 1.57887 13.7337 1.42259 13.5775C1.26631 13.4212 1.05435 13.3334 0.833333 13.3334C0.61232 13.3334 0.400358 13.4212 0.244078 13.5775C0.0877974 13.7337 0 13.9457 0 14.1667L0 15.8334C0.00132321 16.938 0.440735 17.9971 1.22185 18.7782C2.00296 19.5593 3.062 19.9987 4.16667 20H5.83333C6.05435 20 6.26631 19.9122 6.42259 19.756C6.57887 19.5997 6.66667 19.3877 6.66667 19.1667C6.66667 18.9457 6.57887 18.7337 6.42259 18.5775C6.26631 18.4212 6.05435 18.3334 5.83333 18.3334Z", fill: "currentColor" }),
    /* @__PURE__ */ f.jsx("path", { d: "M15.8333 0H14.1666C13.9456 0 13.7337 0.0877974 13.5774 0.244078C13.4211 0.400358 13.3333 0.61232 13.3333 0.833333C13.3333 1.05435 13.4211 1.26631 13.5774 1.42259C13.7337 1.57887 13.9456 1.66667 14.1666 1.66667H15.8333C16.4964 1.66667 17.1322 1.93006 17.6011 2.3989C18.0699 2.86774 18.3333 3.50363 18.3333 4.16667V5.83333C18.3333 6.05435 18.4211 6.26631 18.5774 6.42259C18.7337 6.57887 18.9456 6.66667 19.1666 6.66667C19.3877 6.66667 19.5996 6.57887 19.7559 6.42259C19.9122 6.26631 20 6.05435 20 5.83333V4.16667C19.9987 3.062 19.5592 2.00296 18.7781 1.22185C17.997 0.440735 16.938 0.00132321 15.8333 0Z", fill: "currentColor" }),
    /* @__PURE__ */ f.jsx("path", { d: "M10 9.16667C10.6593 9.16667 11.3038 8.97117 11.8519 8.6049C12.4001 8.23863 12.8273 7.71803 13.0796 7.10895C13.3319 6.49986 13.3979 5.82964 13.2693 5.18303C13.1407 4.53643 12.8232 3.94249 12.357 3.47631C11.8909 3.01014 11.2969 2.69267 10.6503 2.56405C10.0037 2.43543 9.3335 2.50144 8.72441 2.75374C8.11532 3.00603 7.59473 3.43327 7.22846 3.98143C6.86218 4.5296 6.66669 5.17406 6.66669 5.83334C6.66669 6.71739 7.01788 7.56524 7.643 8.19036C8.26812 8.81548 9.11597 9.16667 10 9.16667ZM10 4.16667C10.3297 4.16667 10.6519 4.26442 10.926 4.44755C11.2001 4.63069 11.4137 4.89099 11.5398 5.19553C11.666 5.50007 11.699 5.83518 11.6347 6.15849C11.5704 6.48179 11.4116 6.77876 11.1785 7.01185C10.9454 7.24493 10.6485 7.40367 10.3252 7.46798C10.0019 7.53229 9.66676 7.49928 9.36222 7.37313C9.05767 7.24699 8.79737 7.03337 8.61424 6.75929C8.4311 6.4852 8.33335 6.16297 8.33335 5.83334C8.33335 5.39131 8.50895 4.96738 8.82151 4.65482C9.13407 4.34226 9.55799 4.16667 10 4.16667Z", fill: "currentColor" }),
    /* @__PURE__ */ f.jsx("path", { d: "M15 16.6667C15.221 16.6667 15.433 16.5789 15.5893 16.4226C15.7456 16.2664 15.8334 16.0544 15.8334 15.8334C15.832 14.5077 15.3048 13.2367 14.3674 12.2993C13.43 11.3619 12.159 10.8347 10.8334 10.8334H9.16669C7.84101 10.8347 6.57001 11.3619 5.63262 12.2993C4.69522 13.2367 4.16801 14.5077 4.16669 15.8334C4.16669 16.0544 4.25448 16.2664 4.41076 16.4226C4.56705 16.5789 4.77901 16.6667 5.00002 16.6667C5.22103 16.6667 5.433 16.5789 5.58928 16.4226C5.74556 16.2664 5.83335 16.0544 5.83335 15.8334C5.83335 14.9493 6.18454 14.1015 6.80966 13.4764C7.43479 12.8512 8.28263 12.5 9.16669 12.5H10.8334C11.7174 12.5 12.5653 12.8512 13.1904 13.4764C13.8155 14.1015 14.1667 14.9493 14.1667 15.8334C14.1667 16.0544 14.2545 16.2664 14.4108 16.4226C14.567 16.5789 14.779 16.6667 15 16.6667Z", fill: "currentColor" })
  ] }),
  /* @__PURE__ */ f.jsx("defs", { children: /* @__PURE__ */ f.jsx("clipPath", { id: "clip0_213_175", children: /* @__PURE__ */ f.jsx("rect", { width: "20", height: "20", fill: "currentColor" }) }) })
] }), DS = () => /* @__PURE__ */ f.jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "currentColor", viewBox: "0 0 16 16", children: [
  /* @__PURE__ */ f.jsx("path", { d: "M10.854 6.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7.5 8.793l2.646-2.647a.5.5 0 0 1 .708 0" }),
  /* @__PURE__ */ f.jsx("path", { d: "M3 0h10a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-1h1v1a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v1H1V2a2 2 0 0 1 2-2" }),
  /* @__PURE__ */ f.jsx("path", { d: "M1 5v-.5a.5.5 0 0 1 1 0V5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1zm0 3v-.5a.5.5 0 0 1 1 0V8h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1zm0 3v-.5a.5.5 0 0 1 1 0v.5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1z" })
] }), MS = () => /* @__PURE__ */ f.jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16", children: [
  /* @__PURE__ */ f.jsx("path", { d: "M10.854 7.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7.5 9.793l2.646-2.647a.5.5 0 0 1 .708 0z", fill: "currentColor" }),
  /* @__PURE__ */ f.jsx("path", { d: "M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1h1a1 1 0 0 1 1 1V14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3.5a1 1 0 0 1 1-1h1z", fill: "currentColor" }),
  /* @__PURE__ */ f.jsx("path", { d: "M9.5 1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5zm-3-1A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0z", fill: "currentColor" })
] }), ES = () => /* @__PURE__ */ f.jsx("svg", { viewBox: "0 0 11 11", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ f.jsx(
  "path",
  {
    d: "M5.5 10.3125C2.84213 10.3125 0.6875 8.15787 0.6875 5.5C0.6875 2.84213 2.84213 0.6875 5.5 0.6875C8.15787 0.6875 10.3125 2.84213 10.3125 5.5C10.3125 8.15787 8.15787 10.3125 5.5 10.3125ZM5.5 11C8.53757 11 11 8.53757 11 5.5C11 2.46243 8.53757 0 5.5 0C2.46243 0 0 2.46243 0 5.5C0 8.53757 2.46243 11 5.5 11Z",
    fill: "currentColor"
  }
) }), PS = () => /* @__PURE__ */ f.jsx("svg", { width: "21", height: "21", viewBox: "0 0 21 21", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ f.jsx(
  "path",
  {
    d: "M11.8773 0.570516C11.1167 -0.190171 9.88334 -0.190173 9.12265 0.570515L0.570516 9.12265C-0.190171 9.88334 -0.190173 11.1167 0.570515 11.8773L9.12265 20.4295C9.88334 21.1902 11.1167 21.1902 11.8773 20.4295L20.4295 11.8773C21.1902 11.1167 21.1902 9.88334 20.4295 9.12265L11.8773 0.570516ZM10.5 5.24996C11.2027 5.24996 11.7518 5.85671 11.6819 6.55595L11.2215 11.1595C11.1845 11.5302 10.8725 11.8125 10.5 11.8125C10.1275 11.8125 9.81552 11.5302 9.77845 11.1595L9.3181 6.55595C9.24817 5.85671 9.79727 5.24996 10.5 5.24996ZM10.502 13.125C11.2269 13.125 11.8145 13.7126 11.8145 14.4375C11.8145 15.1623 11.2269 15.75 10.502 15.75C9.77715 15.75 9.18952 15.1623 9.18952 14.4375C9.18952 13.7126 9.77715 13.125 10.502 13.125Z",
    fill: "#E52E2E"
  }
) }), jS = () => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 16 16",
    children: [
      /* @__PURE__ */ f.jsx("path", { d: "M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v4.5a.5.5 0 0 1-1 0V5.383l-7 4.2-1.326-.795-5.64 3.47A1 1 0 0 0 2 13h5.5a.5.5 0 0 1 0 1H2a2 2 0 0 1-2-1.99zm1 7.105 4.708-2.897L1 5.383zM1 4v.217l7 4.2 7-4.2V4a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1" }),
      /* @__PURE__ */ f.jsx("path", { d: "M12.5 16a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7m.354-5.354 1.25 1.25a.5.5 0 0 1-.708.708L13 12.207V14a.5.5 0 0 1-1 0v-1.717l-.28.305a.5.5 0 0 1-.737-.676l1.149-1.25a.5.5 0 0 1 .722-.016" })
    ]
  }
), SS = () => /* @__PURE__ */ f.jsx("svg", { fill: "none", viewBox: "0 0 25 25", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ f.jsx(
  "path",
  {
    d: "M10.5426 23.0627C10.5426 23.6157 10.0956 24.0627 9.54257 24.0627H5.54257C2.78557 24.0627 0.542572 21.8197 0.542572 19.0627V5.06274C0.542572 2.30574 2.78557 0.0627441 5.54257 0.0627441H13.5426C16.2996 0.0627441 18.5426 2.30574 18.5426 5.06274V7.06274C18.5426 7.61574 18.0956 8.06274 17.5426 8.06274C16.9896 8.06274 16.5426 7.61574 16.5426 7.06274V5.06274C16.5426 3.40874 15.1966 2.06274 13.5426 2.06274H5.54257C3.88857 2.06274 2.54257 3.40874 2.54257 5.06274V19.0627C2.54257 20.7167 3.88857 22.0627 5.54257 22.0627H9.54257C10.0956 22.0627 10.5426 22.5097 10.5426 23.0627ZM14.5426 6.06274C14.5426 5.50974 14.0956 5.06274 13.5426 5.06274H5.54257C4.98957 5.06274 4.54257 5.50974 4.54257 6.06274C4.54257 6.61574 4.98957 7.06274 5.54257 7.06274H13.5426C14.0956 7.06274 14.5426 6.61574 14.5426 6.06274ZM10.5426 11.0627C10.5426 10.5097 10.0956 10.0627 9.54257 10.0627H5.54257C4.98957 10.0627 4.54257 10.5097 4.54257 11.0627C4.54257 11.6157 4.98957 12.0627 5.54257 12.0627H9.54257C10.0956 12.0627 10.5426 11.6157 10.5426 11.0627ZM5.54257 15.0627C4.98957 15.0627 4.54257 15.5097 4.54257 16.0627C4.54257 16.6157 4.98957 17.0627 5.54257 17.0627H7.54257C8.09557 17.0627 8.54257 16.6157 8.54257 16.0627C8.54257 15.5097 8.09557 15.0627 7.54257 15.0627H5.54257ZM24.5426 17.0627C24.5426 20.9217 21.4016 24.0627 17.5426 24.0627C13.6836 24.0627 10.5426 20.9217 10.5426 17.0627C10.5426 13.2037 13.6836 10.0627 17.5426 10.0627C21.4016 10.0627 24.5426 13.2037 24.5426 17.0627ZM22.5426 17.0627C22.5426 14.3057 20.2996 12.0627 17.5426 12.0627C14.7856 12.0627 12.5426 14.3057 12.5426 17.0627C12.5426 19.8197 14.7856 22.0627 17.5426 22.0627C20.2996 22.0627 22.5426 19.8197 22.5426 17.0627ZM19.3506 15.8217L17.1276 17.9557C16.9836 18.0967 16.7486 18.0997 16.6056 17.9577L15.4746 16.8497C15.0786 16.4617 14.4466 16.4677 14.0606 16.8637C13.6736 17.2587 13.6796 17.8907 14.0746 18.2777L15.2066 19.3867C15.6666 19.8357 16.2686 20.0607 16.8696 20.0607C17.4706 20.0607 18.0706 19.8357 18.5226 19.3897L20.7356 17.2657C21.1336 16.8827 21.1466 16.2497 20.7646 15.8517C20.3816 15.4517 19.7476 15.4407 19.3506 15.8227V15.8217Z",
    fill: "currentColor"
  }
) }), IS = () => /* @__PURE__ */ f.jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", children: [
  /* @__PURE__ */ f.jsx("path", { d: "M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z", fill: "currentColor" }),
  /* @__PURE__ */ f.jsx("path", { d: "M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5z", fill: "currentColor" })
] }), BS = () => /* @__PURE__ */ f.jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", children: [
  /* @__PURE__ */ f.jsx("path", { d: "M2.5 8a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1", fill: "currentColor" }),
  /* @__PURE__ */ f.jsx("path", { d: "M5 1a2 2 0 0 0-2 2v2H2a2 2 0 0 0-2 2v3a2 2 0 0 0 2 2h1v1a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-1h1a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-1V3a2 2 0 0 0-2-2zM4 3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2H4zm1 5a2 2 0 0 0-2 2v1H2a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-1v-1a2 2 0 0 0-2-2zm7 2v3a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1", fill: "currentColor" })
] }), NS = () => /* @__PURE__ */ f.jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", children: [
  /* @__PURE__ */ f.jsx("path", { d: "M10.854 7.854a.5.5 0 0 0-.708-.708L7.5 9.793 6.354 8.646a.5.5 0 1 0-.708.708l1.5 1.5a.5.5 0 0 0 .708 0z", fill: "currentColor" }),
  /* @__PURE__ */ f.jsx("path", { d: "M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2M9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5z", fill: "currentColor" })
] }), _S = () => /* @__PURE__ */ f.jsxs("svg", { className: "w-full", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ f.jsxs("g", { children: [
    /* @__PURE__ */ f.jsx("path", { d: "M19.1666 13.3334C18.9456 13.3334 18.7337 13.4212 18.5774 13.5775C18.4211 13.7337 18.3333 13.9457 18.3333 14.1667V15.8334C18.3333 16.4964 18.0699 17.1323 17.6011 17.6011C17.1322 18.07 16.4964 18.3334 15.8333 18.3334H14.1666C13.9456 18.3334 13.7337 18.4212 13.5774 18.5775C13.4211 18.7337 13.3333 18.9457 13.3333 19.1667C13.3333 19.3877 13.4211 19.5997 13.5774 19.756C13.7337 19.9122 13.9456 20 14.1666 20H15.8333C16.938 19.9987 17.997 19.5593 18.7781 18.7782C19.5592 17.9971 19.9987 16.938 20 15.8334V14.1667C20 13.9457 19.9122 13.7337 19.7559 13.5775C19.5996 13.4212 19.3877 13.3334 19.1666 13.3334Z", fill: "currentColor" }),
    /* @__PURE__ */ f.jsx("path", { d: "M0.833333 6.66667C1.05435 6.66667 1.26631 6.57887 1.42259 6.42259C1.57887 6.26631 1.66667 6.05435 1.66667 5.83333V4.16667C1.66667 3.50363 1.93006 2.86774 2.3989 2.3989C2.86774 1.93006 3.50363 1.66667 4.16667 1.66667H5.83333C6.05435 1.66667 6.26631 1.57887 6.42259 1.42259C6.57887 1.26631 6.66667 1.05435 6.66667 0.833333C6.66667 0.61232 6.57887 0.400358 6.42259 0.244078C6.26631 0.0877974 6.05435 0 5.83333 0L4.16667 0C3.062 0.00132321 2.00296 0.440735 1.22185 1.22185C0.440735 2.00296 0.00132321 3.062 0 4.16667L0 5.83333C0 6.05435 0.0877974 6.26631 0.244078 6.42259C0.400358 6.57887 0.61232 6.66667 0.833333 6.66667Z", fill: "currentColor" }),
    /* @__PURE__ */ f.jsx("path", { d: "M5.83333 18.3334H4.16667C3.50363 18.3334 2.86774 18.07 2.3989 17.6011C1.93006 17.1323 1.66667 16.4964 1.66667 15.8334V14.1667C1.66667 13.9457 1.57887 13.7337 1.42259 13.5775C1.26631 13.4212 1.05435 13.3334 0.833333 13.3334C0.61232 13.3334 0.400358 13.4212 0.244078 13.5775C0.0877974 13.7337 0 13.9457 0 14.1667L0 15.8334C0.00132321 16.938 0.440735 17.9971 1.22185 18.7782C2.00296 19.5593 3.062 19.9987 4.16667 20H5.83333C6.05435 20 6.26631 19.9122 6.42259 19.756C6.57887 19.5997 6.66667 19.3877 6.66667 19.1667C6.66667 18.9457 6.57887 18.7337 6.42259 18.5775C6.26631 18.4212 6.05435 18.3334 5.83333 18.3334Z", fill: "currentColor" }),
    /* @__PURE__ */ f.jsx("path", { d: "M15.8333 0H14.1666C13.9456 0 13.7337 0.0877974 13.5774 0.244078C13.4211 0.400358 13.3333 0.61232 13.3333 0.833333C13.3333 1.05435 13.4211 1.26631 13.5774 1.42259C13.7337 1.57887 13.9456 1.66667 14.1666 1.66667H15.8333C16.4964 1.66667 17.1322 1.93006 17.6011 2.3989C18.0699 2.86774 18.3333 3.50363 18.3333 4.16667V5.83333C18.3333 6.05435 18.4211 6.26631 18.5774 6.42259C18.7337 6.57887 18.9456 6.66667 19.1666 6.66667C19.3877 6.66667 19.5996 6.57887 19.7559 6.42259C19.9122 6.26631 20 6.05435 20 5.83333V4.16667C19.9987 3.062 19.5592 2.00296 18.7781 1.22185C17.997 0.440735 16.938 0.00132321 15.8333 0Z", fill: "currentColor" }),
    /* @__PURE__ */ f.jsx("path", { d: "M10 9.16667C10.6593 9.16667 11.3038 8.97117 11.8519 8.6049C12.4001 8.23863 12.8273 7.71803 13.0796 7.10895C13.3319 6.49986 13.3979 5.82964 13.2693 5.18303C13.1407 4.53643 12.8232 3.94249 12.357 3.47631C11.8909 3.01014 11.2969 2.69267 10.6503 2.56405C10.0037 2.43543 9.3335 2.50144 8.72441 2.75374C8.11532 3.00603 7.59473 3.43327 7.22846 3.98143C6.86218 4.5296 6.66669 5.17406 6.66669 5.83334C6.66669 6.71739 7.01788 7.56524 7.643 8.19036C8.26812 8.81548 9.11597 9.16667 10 9.16667ZM10 4.16667C10.3297 4.16667 10.6519 4.26442 10.926 4.44755C11.2001 4.63069 11.4137 4.89099 11.5398 5.19553C11.666 5.50007 11.699 5.83518 11.6347 6.15849C11.5704 6.48179 11.4116 6.77876 11.1785 7.01185C10.9454 7.24493 10.6485 7.40367 10.3252 7.46798C10.0019 7.53229 9.66676 7.49928 9.36222 7.37313C9.05767 7.24699 8.79737 7.03337 8.61424 6.75929C8.4311 6.4852 8.33335 6.16297 8.33335 5.83334C8.33335 5.39131 8.50895 4.96738 8.82151 4.65482C9.13407 4.34226 9.55799 4.16667 10 4.16667Z", fill: "currentColor" }),
    /* @__PURE__ */ f.jsx("path", { d: "M15 16.6667C15.221 16.6667 15.433 16.5789 15.5893 16.4226C15.7456 16.2664 15.8334 16.0544 15.8334 15.8334C15.832 14.5077 15.3048 13.2367 14.3674 12.2993C13.43 11.3619 12.159 10.8347 10.8334 10.8334H9.16669C7.84101 10.8347 6.57001 11.3619 5.63262 12.2993C4.69522 13.2367 4.16801 14.5077 4.16669 15.8334C4.16669 16.0544 4.25448 16.2664 4.41076 16.4226C4.56705 16.5789 4.77901 16.6667 5.00002 16.6667C5.22103 16.6667 5.433 16.5789 5.58928 16.4226C5.74556 16.2664 5.83335 16.0544 5.83335 15.8334C5.83335 14.9493 6.18454 14.1015 6.80966 13.4764C7.43479 12.8512 8.28263 12.5 9.16669 12.5H10.8334C11.7174 12.5 12.5653 12.8512 13.1904 13.4764C13.8155 14.1015 14.1667 14.9493 14.1667 15.8334C14.1667 16.0544 14.2545 16.2664 14.4108 16.4226C14.567 16.5789 14.779 16.6667 15 16.6667Z", fill: "currentColor" })
  ] }),
  /* @__PURE__ */ f.jsx("defs", { children: /* @__PURE__ */ f.jsx("clipPath", { id: "clip0_213_175", children: /* @__PURE__ */ f.jsx("rect", { width: "20", height: "20", fill: "currentColor" }) }) })
] }), LS = () => /* @__PURE__ */ f.jsx("svg", { viewBox: "0 0 25 20", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ f.jsx(
  "path",
  {
    d: "M10 1.25C11.3807 1.25 12.5 2.36929 12.5 3.75V6.25H7.50002V3.75C7.50002 2.36929 8.6193 1.25 10 1.25ZM13.75 6.25V3.75C13.75 1.67893 12.0711 0 10 0C7.92895 0 6.25002 1.67893 6.25002 3.75V6.25H4.2015C3.27338 6.25 2.48492 6.92901 2.34724 7.84686L1.06256 16.4114C0.77915 18.3008 2.24246 20 4.15298 20H15.847C17.7576 20 19.2209 18.3008 18.9375 16.4114L17.6528 7.84686C17.5151 6.92901 16.7266 6.25 15.7985 6.25H13.75ZM12.5 7.5V9.375C12.5 9.72018 12.7798 10 13.125 10C13.4702 10 13.75 9.72018 13.75 9.375V7.5H15.7985C16.1079 7.5 16.3707 7.72634 16.4166 8.03229L17.7013 16.5969C17.8713 17.7305 16.9934 18.75 15.847 18.75H4.15298C3.00667 18.75 2.12868 17.7305 2.29873 16.5969L3.58342 8.03229C3.62931 7.72634 3.89213 7.5 4.2015 7.5H6.25002V9.375C6.25002 9.72018 6.52984 10 6.87502 10C7.22019 10 7.50002 9.72018 7.50002 9.375V7.5H12.5Z",
    fill: "currentColor"
  }
) }), TS = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    className: "w-full",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        d: "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.418 0-8-3.582-8-8s3.582-8 8-8 8 3.582 8 8-3.582 8-8 8zm-.5-13h-1v6h4v-1.5h-2.5z",
        fill: "currentColor"
      }
    )
  }
), RS = () => /* @__PURE__ */ f.jsx("svg", { viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ f.jsx("path", { d: "M27.5 32.5C34.4036 32.5 40 26.9036 40 20C40 13.0964 34.4036 7.5 27.5 7.5C21.0183 7.5 15.6889 12.4333 15.0617 18.75H10C10 16.6789 8.32107 15 6.25 15H3.75C1.67893 15 0 16.6789 0 18.75V21.25C0 23.3211 1.67893 25 3.75 25H6.25C8.32107 25 10 23.3211 10 21.25H15.0617C15.6889 27.5667 21.0183 32.5 27.5 32.5ZM28.75 13.75V18.75H33.75C34.4404 18.75 35 19.3096 35 20C35 20.6904 34.4404 21.25 33.75 21.25H28.75V26.25C28.75 26.9404 28.1904 27.5 27.5 27.5C26.8096 27.5 26.25 26.9404 26.25 26.25V21.25H21.25C20.5596 21.25 20 20.6904 20 20C20 19.3096 20.5596 18.75 21.25 18.75H26.25V13.75C26.25 13.0596 26.8096 12.5 27.5 12.5C28.1904 12.5 28.75 13.0596 28.75 13.75Z", fill: "currentColor" }) }), $S = () => /* @__PURE__ */ f.jsxs("svg", { viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ f.jsx(
    "path",
    {
      d: "M6 12.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5M3 8.062C3 6.76 4.235 5.765 5.53 5.886a26.6 26.6 0 0 0 4.94 0C11.765 5.765 13 6.76 13 8.062v1.157a.93.93 0 0 1-.765.935c-.845.147-2.34.346-4.235.346s-3.39-.2-4.235-.346A.93.93 0 0 1 3 9.219zm4.542-.827a.25.25 0 0 0-.217.068l-.92.9a25 25 0 0 1-1.871-.183.25.25 0 0 0-.068.495c.55.076 1.232.149 2.02.193a.25.25 0 0 0 .189-.071l.754-.736.847 1.71a.25.25 0 0 0 .404.062l.932-.97a25 25 0 0 0 1.922-.188.25.25 0 0 0-.068-.495c-.538.074-1.207.145-1.98.189a.25.25 0 0 0-.166.076l-.754.785-.842-1.7a.25.25 0 0 0-.182-.135",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ f.jsx(
    "path",
    {
      d: "M8.5 1.866a1 1 0 1 0-1 0V3h-2A4.5 4.5 0 0 0 1 7.5V8a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1v1a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-1a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1v-.5A4.5 4.5 0 0 0 10.5 3h-2zM14 7.5V13a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V7.5A3.5 3.5 0 0 1 5.5 4h5A3.5 3.5 0 0 1 14 7.5",
      fill: "currentColor"
    }
  )
] }), FS = () => /* @__PURE__ */ f.jsx("svg", { viewBox: "0 0 42 43", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ f.jsx(
  "path",
  {
    d: "M39.3165 20.6978H38.0635V20.3025C38.0635 19.4986 37.424 18.8445 36.6378 18.8445H35.7683C34.9823 18.8445 34.3428 19.4986 34.3428 20.3025V20.6978H31.0829V20.3025C31.0829 19.5536 30.5277 18.9353 29.8163 18.8542V1.15577C29.8163 0.793593 29.5296 0.5 29.1761 0.5H1.39019C1.03662 0.5 0.75 0.793593 0.75 1.15577V41.8442C0.75 42.2064 1.03662 42.5 1.39019 42.5H39.3165C40.6583 42.5 41.75 41.4526 41.75 40.1654V23.0301C41.7499 21.744 40.6583 20.6978 39.3165 20.6978ZM35.6231 20.3024C35.6231 20.223 35.6896 20.1559 35.7683 20.1559H36.6378C36.7165 20.1559 36.7831 20.223 36.7831 20.3024V22.8905C36.7831 22.9699 36.7165 23.037 36.6378 23.037H35.7683C35.6897 23.037 35.6231 22.9699 35.6231 22.8905V20.3024ZM34.3427 22.0093V22.8905C34.3427 23.6944 34.9821 24.3485 35.7682 24.3485H36.6377C37.4238 24.3485 38.0634 23.6944 38.0634 22.8905V22.0093H39.3164C39.9522 22.0093 40.4695 22.4672 40.4695 23.0301V25.4321H18.3318V23.0301C18.3318 22.4672 18.8491 22.0093 19.485 22.0093H20.3816V22.8905C20.3816 23.6944 21.0212 24.3485 21.8073 24.3485H22.6767C23.4628 24.3485 24.1023 23.6944 24.1023 22.8905V22.0093H27.3621V22.8905C27.3621 23.6944 28.0016 24.3485 28.7878 24.3485H29.6571C30.4432 24.3485 31.0829 23.6944 31.0829 22.8905V22.0093H34.3427ZM21.6621 22.8905V20.3024C21.6621 20.223 21.7285 20.1559 21.8073 20.1559H22.6767C22.7554 20.1559 22.8219 20.223 22.8219 20.3024V22.8905C22.8219 22.9699 22.7555 23.037 22.6767 23.037H21.8073C21.7285 23.037 21.6621 22.9699 21.6621 22.8905ZM29.6571 20.156C29.7359 20.156 29.8024 20.2231 29.8024 20.3025V22.8906C29.8024 22.97 29.7359 23.037 29.6571 23.037H28.7878C28.7091 23.037 28.6426 22.97 28.6426 22.8906V20.3025C28.6426 20.2231 28.7091 20.156 28.7878 20.156H29.6571ZM2.03038 1.81153H28.5358V18.8687C27.8697 18.991 27.3622 19.5866 27.3622 20.3025V20.6978H24.1024V20.3025C24.1024 19.4986 23.4629 18.8445 22.6768 18.8445H21.8073C21.0213 18.8445 20.3817 19.4986 20.3817 20.3025V20.6978H19.4851C18.1432 20.6978 17.0514 21.744 17.0514 23.0301V40.1654C17.0514 40.5322 17.1403 40.8794 17.2981 41.1886H2.03038V1.81153ZM39.3165 41.1885H19.485C18.8599 41.1885 18.3318 40.72 18.3318 40.1654V26.7437H40.4696V40.1654C40.4695 40.7295 39.9523 41.1885 39.3165 41.1885ZM24.9264 28.7549H21.6392C21.2857 28.7549 20.9991 29.0485 20.9991 29.4107V32.7755C20.9991 33.1377 21.2857 33.4313 21.6392 33.4313H24.9264C25.2799 33.4313 25.5665 33.1377 25.5665 32.7755V29.4107C25.5665 29.0486 25.2799 28.7549 24.9264 28.7549ZM24.2862 32.1197H22.2794V30.0665H24.2862V32.1197ZM30.9875 28.7549H27.7026C27.349 28.7549 27.0624 29.0485 27.0624 29.4107V32.7755C27.0624 33.1377 27.349 33.4313 27.7026 33.4313H30.9875C31.3411 33.4313 31.6277 33.1377 31.6277 32.7755V29.4107C31.6277 29.0486 31.3411 28.7549 30.9875 28.7549ZM30.3473 32.1197H28.3429V30.0665H30.3473V32.1197ZM24.9264 34.5008H21.6392C21.2857 34.5008 20.9991 34.7944 20.9991 35.1566V38.5214C20.9991 38.8835 21.2857 39.1771 21.6392 39.1771H24.9264C25.2799 39.1771 25.5665 38.8835 25.5665 38.5214V35.1566C25.5665 34.7944 25.2799 34.5008 24.9264 34.5008ZM24.2862 37.8656H22.2794V35.8124H24.2862V37.8656ZM30.9875 34.5008H27.7026C27.349 34.5008 27.0624 34.7944 27.0624 35.1566V38.5214C27.0624 38.8835 27.349 39.1771 27.7026 39.1771H30.9875C31.3411 39.1771 31.6277 38.8835 31.6277 38.5214V35.1566C31.6277 34.7944 31.3411 34.5008 30.9875 34.5008ZM30.3473 37.8656H28.3429V35.8124H30.3473V37.8656ZM37.1644 28.7549H33.8774C33.5238 28.7549 33.2372 29.0485 33.2372 29.4107V32.7755C33.2372 33.1377 33.5238 33.4313 33.8774 33.4313H37.1644C37.518 33.4313 37.8046 33.1377 37.8046 32.7755V29.4107C37.8046 29.0486 37.518 28.7549 37.1644 28.7549ZM36.5242 32.1197H34.5176V30.0665H36.5242V32.1197ZM37.1644 34.5008H33.8774C33.5238 34.5008 33.2372 34.7944 33.2372 35.1566V38.5214C33.2372 38.8835 33.5238 39.1771 33.8774 39.1771H37.1644C37.518 39.1771 37.8046 38.8835 37.8046 38.5214V35.1566C37.8046 34.7944 37.518 34.5008 37.1644 34.5008ZM36.5242 37.8656H34.5176V35.8124H36.5242V37.8656ZM4.67938 12.2289V5.18084C4.67938 4.81867 4.966 4.52507 5.31957 4.52507H12.7588C13.1123 4.52507 13.399 4.81867 13.399 5.18084C13.399 5.54301 13.1123 5.83661 12.7588 5.83661H5.95976V11.5732H12.1185V9.57752L10.9279 10.6845C10.8056 10.7982 10.6515 10.8548 10.4977 10.8548C10.3337 10.8548 10.1699 10.7905 10.0453 10.6631L8.58562 9.17015C8.33544 8.91429 8.33512 8.49904 8.58498 8.24277C8.8346 7.98651 9.24006 7.98618 9.49032 8.24204L10.5187 9.29377L13.6087 6.42076C13.8705 6.17737 14.2752 6.1973 14.513 6.46555C14.7506 6.73371 14.7311 7.14838 14.4693 7.39185L13.399 8.38699V12.2289C13.399 12.5911 13.1123 12.8846 12.7588 12.8846H5.31957C4.966 12.8846 4.67938 12.5911 4.67938 12.2289ZM4.67938 25.0229V17.9771C4.67938 17.615 4.966 17.3214 5.31957 17.3214H12.7588C13.1123 17.3214 13.399 17.615 13.399 17.9771C13.399 18.3393 13.1123 18.6329 12.7588 18.6329H5.95976V24.3671H12.1185V22.3737L10.9279 23.4808C10.8056 23.5945 10.6515 23.651 10.4977 23.651C10.3335 23.651 10.1696 23.5867 10.045 23.4588L8.5853 21.9636C8.33528 21.7075 8.33528 21.2924 8.5853 21.0363C8.83524 20.7802 9.2407 20.7802 9.49065 21.0363L10.519 22.0896L13.6087 19.217C13.8705 18.9735 14.2752 18.9935 14.513 19.2618C14.7506 19.5299 14.7311 19.9446 14.4693 20.1881L13.399 21.1832V25.0229C13.399 25.385 13.1123 25.6786 12.7588 25.6786H5.31957C4.966 25.6786 4.67938 25.385 4.67938 25.0229ZM14.5132 32.0583C14.7507 32.3265 14.731 32.7412 14.469 32.9845L13.399 33.9787V37.8191C13.399 38.1813 13.1123 38.4748 12.7588 38.4748H5.31957C4.966 38.4748 4.67938 38.1813 4.67938 37.8191V30.7733C4.67938 30.4112 4.966 30.1176 5.31957 30.1176H12.7588C13.1123 30.1176 13.399 30.4112 13.399 30.7733C13.399 31.1355 13.1123 31.4291 12.7588 31.4291H5.95976V37.1632H12.1185V35.1683L10.9277 36.2747C10.8055 36.3884 10.6515 36.4448 10.4977 36.4448C10.3337 36.4448 10.1699 36.3806 10.0453 36.253L8.58562 34.7601C8.33544 34.5042 8.33512 34.089 8.58498 33.8327C8.8346 33.5765 9.24006 33.5761 9.49032 33.8321L10.5188 34.884L13.6089 32.0129C13.8707 31.7697 14.2755 31.7899 14.5132 32.0583ZM17.0513 5.18084C17.0513 4.81867 17.338 4.52507 17.6915 4.52507H26.016C26.3695 4.52507 26.6562 4.81867 26.6562 5.18084C26.6562 5.54301 26.3695 5.83661 26.016 5.83661H17.6915C17.338 5.83661 17.0513 5.54301 17.0513 5.18084ZM17.0513 8.70371C17.0513 8.34154 17.338 8.04795 17.6915 8.04795H26.016C26.3695 8.04795 26.6562 8.34154 26.6562 8.70371C26.6562 9.06589 26.3695 9.35948 26.016 9.35948H17.6915C17.338 9.35948 17.0513 9.06589 17.0513 8.70371Z",
    fill: "currentColor"
  }
) }), HS = () => /* @__PURE__ */ f.jsxs("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ f.jsx("path", { d: "M11 23C11 23.55 10.55 24 10 24H6C3.24 24 1 21.76 1 19V5C1 2.24 3.24 0 6 0H14C16.76 0 19 2.24 19 5V8C19 8.55 18.55 9 18 9C17.45 9 17 8.55 17 8V5C17 3.35 15.65 2 14 2H6C4.35 2 3 3.35 3 5V19C3 20.65 4.35 22 6 22H10C10.55 22 11 22.45 11 23Z", fill: "currentColor" }),
  /* @__PURE__ */ f.jsx("path", { d: "M15 6C15 5.45 14.55 5 14 5H6C5.45 5 5 5.45 5 6C5 6.55 5.45 7 6 7H14C14.55 7 15 6.55 15 6Z", fill: "currentColor" }),
  /* @__PURE__ */ f.jsx("path", { d: "M10 11C10 10.45 9.55 10 9 10H6C5.45 10 5 10.45 5 11C5 11.55 5.45 12 6 12H9C9.55 12 10 11.55 10 11Z", fill: "currentColor" }),
  /* @__PURE__ */ f.jsx("path", { d: "M6 15C5.45 15 5 15.45 5 16C5 16.55 5.45 17 6 17H8C8.55 17 9 16.55 9 16C9 15.45 8.55 15 8 15H6Z", fill: "currentColor" }),
  /* @__PURE__ */ f.jsx("path", { d: "M18.74 24C17.84 24 16.96 23.63 16.32 22.99L15.64 22.31H14.32C13.95 22.31 13.59 22.22 13.26 22.06C12.76 21.81 12.37 21.42 12.13 20.94C11.96 20.59 11.87 20.22 11.87 19.86V18.53L11.19 17.85C10.66 17.32 10.32 16.63 10.22 15.89C10.1 14.98 10.33 14.08 10.88 13.36C11.43 12.63 12.24 12.16 13.14 12.04L20.83 10.42C21.63 10.23 22.51 10.48 23.1 11.08C23.71 11.68 23.95 12.57 23.75 13.4L22.12 21.14C21.95 22.36 21.07 23.41 19.83 23.82C19.48 23.94 19.11 24 18.74 24ZM15.86 20.31C16.26 20.31 16.63 20.46 16.91 20.74L17.74 21.57C18.12 21.95 18.69 22.09 19.2 21.92C19.72 21.75 20.08 21.32 20.15 20.79L21.8 12.95C21.85 12.76 21.8 12.6 21.69 12.49C21.58 12.37 21.43 12.33 21.28 12.36L13.49 14C13.04 14.06 12.71 14.26 12.48 14.56C12.25 14.86 12.15 15.24 12.2 15.61C12.24 15.92 12.39 16.2 12.6 16.42L13.43 17.25C13.71 17.53 13.87 17.9 13.87 18.3V19.84C13.87 19.9 13.89 19.97 13.91 20.02C13.96 20.12 14.03 20.19 14.12 20.23C14.19 20.27 14.26 20.28 14.32 20.28H15.85L15.86 20.31Z", fill: "currentColor" }),
  /* @__PURE__ */ f.jsx("path", { d: "M21.6975 11.0789L12.5409 20.1086L13.9452 21.5327L23.1019 12.503L21.6975 11.0789Z", fill: "currentColor" })
] }), YS = () => /* @__PURE__ */ f.jsx("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ f.jsx("g", { children: /* @__PURE__ */ f.jsx("path", { d: "M23.61 10.836L21.892 7.24396C21.674 6.78896 21.15 6.56596 20.673 6.72696L11.996 9.62296L3.30701 6.72796C2.83001 6.56896 2.30601 6.78996 2.08801 7.24596L0.436012 10.719C-0.0409879 11.511 -0.130988 12.462 0.189012 13.328C0.499012 14.168 1.15301 14.819 1.99001 15.123L1.98401 17.438C1.98401 19.595 3.35701 21.503 5.40301 22.185L9.76801 23.641C10.482 23.878 11.232 23.997 11.982 23.997C12.732 23.997 13.482 23.878 14.196 23.64L18.565 22.184C20.609 21.502 21.983 19.598 21.984 17.446L21.99 15.124C22.836 14.828 23.498 14.179 23.809 13.336C24.125 12.478 24.036 11.536 23.61 10.836ZM2.19401 11.666L3.51201 8.90296L10.577 11.257L8.95701 14.513C8.71501 14.919 8.22801 15.097 7.78301 14.949L2.70201 13.254C2.40401 13.155 2.17201 12.93 2.06301 12.636C1.95501 12.343 1.98601 12.02 2.19401 11.666ZM6.03601 20.289C4.80801 19.879 3.98301 18.734 3.98401 17.441L3.98801 15.791L7.15201 16.846C8.49801 17.292 9.94501 16.756 10.711 15.474L10.988 14.919L10.984 21.898C10.787 21.858 10.593 21.807 10.402 21.744L6.03701 20.289H6.03601ZM17.932 20.287L13.563 21.743C13.373 21.806 13.179 21.858 12.983 21.898L12.987 14.903L13.306 15.543C13.863 16.471 14.838 17.003 15.868 17.003C16.186 17.003 16.511 16.952 16.828 16.846L19.988 15.793L19.984 17.444C19.984 18.736 19.159 19.878 17.932 20.287ZM21.932 12.642C21.827 12.927 21.601 13.146 21.313 13.243L16.195 14.948C15.757 15.095 15.26 14.912 15.059 14.583L13.405 11.261L20.469 8.90396L21.851 11.784C22.007 12.045 22.038 12.357 21.932 12.642ZM5.21401 5.89596C4.82301 5.50496 4.82301 4.87296 5.21401 4.48196L9.11101 0.585959C9.89001 -0.193041 11.16 -0.193041 11.939 0.585959L13.535 2.18196C14.288 1.79696 15.273 1.91196 15.888 2.52696L18.143 4.78196C18.534 5.17296 18.534 5.80496 18.143 6.19596C17.752 6.58696 17.12 6.58696 16.729 6.19596L14.474 3.94096L11.323 7.09196C11.128 7.28696 10.872 7.38496 10.616 7.38496C10.36 7.38496 10.104 7.28696 9.90901 7.09196C9.51801 6.70096 9.51801 6.06896 9.90901 5.67796L12.056 3.53096L10.526 2.00096L6.62901 5.89696C6.43401 6.09196 6.17801 6.18996 5.92201 6.18996C5.66601 6.18996 5.41001 6.09196 5.21501 5.89696L5.21401 5.89596Z", fill: "currentColor" }) }) }), VS = () => /* @__PURE__ */ f.jsx("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ f.jsxs("g", { children: [
  /* @__PURE__ */ f.jsx("path", { d: "M16 0H8C6.67441 0.00158786 5.40356 0.528882 4.46622 1.46622C3.52888 2.40356 3.00159 3.67441 3 5V23C3.00014 23.1819 3.04989 23.3603 3.14388 23.516C3.23788 23.6717 3.37256 23.7989 3.53344 23.8837C3.69431 23.9686 3.87529 24.008 4.05688 23.9976C4.23847 23.9873 4.4138 23.9276 4.564 23.825L6.67 22.386L8.776 23.825C8.94239 23.9389 9.13934 23.9999 9.341 23.9999C9.54266 23.9999 9.73961 23.9389 9.906 23.825L12.006 22.386L14.106 23.825C14.2725 23.9392 14.4696 24.0003 14.6715 24.0003C14.8734 24.0003 15.0705 23.9392 15.237 23.825L17.337 22.387L19.437 23.824C19.5871 23.9263 19.7623 23.9857 19.9436 23.996C20.125 24.0062 20.3057 23.9669 20.4664 23.8821C20.627 23.7974 20.7616 23.6706 20.8556 23.5151C20.9496 23.3597 20.9996 23.1816 21 23V5C20.9984 3.67441 20.4711 2.40356 19.5338 1.46622C18.5964 0.528882 17.3256 0.00158786 16 0ZM19 21.1L17.9 20.348C17.7334 20.2336 17.5361 20.1724 17.334 20.1724C17.1319 20.1724 16.9346 20.2336 16.768 20.348L14.668 21.787L12.568 20.348C12.4015 20.2338 12.2044 20.1727 12.0025 20.1727C11.8006 20.1727 11.6035 20.2338 11.437 20.348L9.337 21.787L7.237 20.348C7.07071 20.2343 6.87396 20.1734 6.6725 20.1734C6.47105 20.1734 6.27429 20.2343 6.108 20.348L5 21.1V5C5 4.20435 5.31607 3.44129 5.87868 2.87868C6.44129 2.31607 7.20435 2 8 2H16C16.7956 2 17.5587 2.31607 18.1213 2.87868C18.6839 3.44129 19 4.20435 19 5V21.1Z", fill: "currentColor" }),
  /* @__PURE__ */ f.jsx("path", { d: "M16 8H8C7.44772 8 7 8.44772 7 9C7 9.55228 7.44772 10 8 10H16C16.5523 10 17 9.55228 17 9C17 8.44772 16.5523 8 16 8Z", fill: "currentColor" }),
  /* @__PURE__ */ f.jsx("path", { d: "M14 12H8C7.44772 12 7 12.4477 7 13C7 13.5523 7.44772 14 8 14H14C14.5523 14 15 13.5523 15 13C15 12.4477 14.5523 12 14 12Z", fill: "currentColor" })
] }) }), kS = () => /* @__PURE__ */ f.jsx("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ f.jsx("g", { children: /* @__PURE__ */ f.jsx("path", { d: "M19 2H5C2.24 2 0 4.24 0 7V17C0 19.76 2.24 22 5 22H12C12.55 22 13 21.55 13 21C13 20.45 12.55 20 12 20H5C3.35 20 2 18.65 2 17V9H22V14C22 14.55 22.45 15 23 15C23.55 15 24 14.55 24 14V7C24 4.24 21.76 2 19 2ZM2 7C2 5.35 3.35 4 5 4H19C20.65 4 22 5.35 22 7H2ZM16.41 12.17C15.65 11.41 14.65 11 13.58 11H11.99C11.44 11 10.99 11.45 10.99 12V13.59C10.99 14.66 11.41 15.66 12.16 16.42L18.87 23.13C19.44 23.7 20.19 24.01 20.99 24.01C21.79 24.01 22.54 23.7 23.11 23.13C23.68 22.56 23.99 21.81 23.99 21.01C23.99 20.21 23.68 19.46 23.11 18.89L16.4 12.18L16.41 12.17ZM21.7 21.71C21.32 22.09 20.66 22.09 20.29 21.71L13.58 15C13.2 14.62 12.99 14.12 12.99 13.59V13H13.58C14.11 13 14.62 13.21 14.99 13.59L21.7 20.3C21.89 20.49 21.99 20.74 21.99 21.01C21.99 21.28 21.89 21.53 21.7 21.72V21.71Z", fill: "currentColor" }) }) }), GS = () => /* @__PURE__ */ f.jsx("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ f.jsx("g", { children: /* @__PURE__ */ f.jsx("path", { d: "M21 15H10.26C9.46 15 8.71 14.69 8.14 14.12L6.72 12.71C6.53 12.52 6.43 12.27 6.43 12C6.43 11.73 6.54 11.48 6.72 11.29L8.14 9.88C8.71 9.31 9.46 9 10.26 9H21C22.65 9 24 10.35 24 12C24 13.65 22.65 15 21 15ZM8.85 12L9.56 12.71C9.75 12.9 10 13 10.27 13H21.01C21.56 13 22.01 12.55 22.01 12C22.01 11.45 21.56 11 21.01 11H10.26C10 11 9.74 11.11 9.55 11.29L8.84 12H8.85ZM18 6H10.26C9.46 6 8.71 5.69 8.14 5.12L6.72 3.71C6.53 3.52 6.43 3.27 6.43 3C6.43 2.73 6.54 2.48 6.72 2.29L8.14 0.88C8.71 0.31 9.46 0 10.26 0H18C19.65 0 21 1.35 21 3C21 4.65 19.65 6 18 6ZM8.85 3L9.56 3.71C9.75 3.9 10 4 10.27 4H18.01C18.56 4 19.01 3.55 19.01 3C19.01 2.45 18.56 2 18.01 2H10.27C10.01 2 9.75 2.11 9.56 2.29L8.85 3ZM16 24H10.26C9.46 24 8.71 23.69 8.14 23.12L6.72 21.71C6.53 21.52 6.43 21.27 6.43 21C6.43 20.73 6.54 20.48 6.72 20.29L8.14 18.88C8.71 18.31 9.46 18 10.26 18H16C17.65 18 19 19.35 19 21C19 22.65 17.65 24 16 24ZM8.85 21L9.56 21.71C9.75 21.9 10 22 10.27 22H16.01C16.56 22 17.01 21.55 17.01 21C17.01 20.45 16.56 20 16.01 20H10.27C10.01 20 9.75 20.11 9.56 20.29L8.85 21ZM2 19C0.9 19 0 19.9 0 21C0 22.1 0.9 23 2 23C3.1 23 4 22.1 4 21C4 19.9 3.1 19 2 19ZM2 10C0.9 10 0 10.9 0 12C0 13.1 0.9 14 2 14C3.1 14 4 13.1 4 12C4 10.9 3.1 10 2 10ZM2 1C0.9 1 0 1.9 0 3C0 4.1 0.9 5 2 5C3.1 5 4 4.1 4 3C4 1.9 3.1 1 2 1Z", fill: "currentColor" }) }) }), WS = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 16 16",
    children: /* @__PURE__ */ f.jsx("path", { d: "M8 0c-.787 0-1.292.592-1.572 1.151A4.35 4.35 0 0 0 6 3v3.691l-2 1V7.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1.191l-1.17.585A1.5 1.5 0 0 0 0 10.618V12a.5.5 0 0 0 .582.493l1.631-.272.313.937a.5.5 0 0 0 .948 0l.405-1.214 2.21-.369.375 2.253-1.318 1.318A.5.5 0 0 0 5.5 16h5a.5.5 0 0 0 .354-.854l-1.318-1.318.375-2.253 2.21.369.405 1.214a.5.5 0 0 0 .948 0l.313-.937 1.63.272A.5.5 0 0 0 16 12v-1.382a1.5 1.5 0 0 0-.83-1.342L14 8.691V7.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v.191l-2-1V3c0-.568-.14-1.271-.428-1.849C9.292.591 8.787 0 8 0M7 3c0-.432.11-.979.322-1.401C7.542 1.159 7.787 1 8 1s.458.158.678.599C8.889 2.02 9 2.569 9 3v4a.5.5 0 0 0 .276.447l5.448 2.724a.5.5 0 0 1 .276.447v.792l-5.418-.903a.5.5 0 0 0-.575.41l-.5 3a.5.5 0 0 0 .14.437l.646.646H6.707l.647-.646a.5.5 0 0 0 .14-.436l-.5-3a.5.5 0 0 0-.576-.411L1 11.41v-.792a.5.5 0 0 1 .276-.447l5.448-2.724A.5.5 0 0 0 7 7z" })
  }
), QS = () => /* @__PURE__ */ f.jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "currentColor", viewBox: "0 0 16 16", children: [
  /* @__PURE__ */ f.jsx("path", { "fill-rule": "evenodd", d: "M6 8V1h1v6.117L8.743 6.07a.5.5 0 0 1 .514 0L11 7.117V1h1v7a.5.5 0 0 1-.757.429L9 7.083 6.757 8.43A.5.5 0 0 1 6 8" }),
  /* @__PURE__ */ f.jsx("path", { d: "M3 0h10a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-1h1v1a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v1H1V2a2 2 0 0 1 2-2" }),
  /* @__PURE__ */ f.jsx("path", { d: "M1 5v-.5a.5.5 0 0 1 1 0V5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1zm0 3v-.5a.5.5 0 0 1 1 0V8h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1zm0 3v-.5a.5.5 0 0 1 1 0v.5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1z" })
] }), US = () => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 16 16",
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        "fill-rule": "evenodd",
        d: "M14.5 1.5a.5.5 0 0 1 .5.5v4.8a2.5 2.5 0 0 1-2.5 2.5H2.707l3.347 3.346a.5.5 0 0 1-.708.708l-4.2-4.2a.5.5 0 0 1 0-.708l4-4a.5.5 0 1 1 .708.708L2.707 8.3H12.5A1.5 1.5 0 0 0 14 6.8V2a.5.5 0 0 1 .5-.5"
      }
    )
  }
), ZS = () => /* @__PURE__ */ f.jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "currentColor", viewBox: "0 0 16 16", children: [
  /* @__PURE__ */ f.jsx("path", { d: "M14.5 3a.5.5 0 0 1 .5.5v9a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5v-9a.5.5 0 0 1 .5-.5zm-13-1A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h13a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 14.5 2z" }),
  /* @__PURE__ */ f.jsx("path", { d: "M7 5.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5m-1.496-.854a.5.5 0 0 1 0 .708l-1.5 1.5a.5.5 0 0 1-.708 0l-.5-.5a.5.5 0 1 1 .708-.708l.146.147 1.146-1.147a.5.5 0 0 1 .708 0M7 9.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5m-1.496-.854a.5.5 0 0 1 0 .708l-1.5 1.5a.5.5 0 0 1-.708 0l-.5-.5a.5.5 0 0 1 .708-.708l.146.147 1.146-1.147a.5.5 0 0 1 .708 0" })
] }), zS = () => /* @__PURE__ */ f.jsx("svg", { viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ f.jsx(
  "path",
  {
    "fill-rule": "evenodd",
    fill: "currentColor",
    d: "M1 11.5a.5.5 0 0 0 .5.5h11.793l-3.147 3.146a.5.5 0 0 0 .708.708l4-4a.5.5 0 0 0 0-.708l-4-4a.5.5 0 0 0-.708.708L13.293 11H1.5a.5.5 0 0 0-.5.5m14-7a.5.5 0 0 1-.5.5H2.707l3.147 3.146a.5.5 0 1 1-.708.708l-4-4a.5.5 0 0 1 0-.708l4-4a.5.5 0 1 1 .708.708L2.707 4H14.5a.5.5 0 0 1 .5.5"
  }
) }), KS = () => /* @__PURE__ */ f.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "currentColor", viewBox: "0 0 16 16", children: /* @__PURE__ */ f.jsx("path", { d: "M1 2.828c.885-.37 2.154-.769 3.388-.893 1.33-.134 2.458.063 3.112.752v9.746c-.935-.53-2.12-.603-3.213-.493-1.18.12-2.37.461-3.287.811zm7.5-.141c.654-.689 1.782-.886 3.112-.752 1.234.124 2.503.523 3.388.893v9.923c-.918-.35-2.107-.692-3.287-.81-1.094-.111-2.278-.039-3.213.492zM8 1.783C7.015.936 5.587.81 4.287.94c-1.514.153-3.042.672-3.994 1.105A.5.5 0 0 0 0 2.5v11a.5.5 0 0 0 .707.455c.882-.4 2.303-.881 3.68-1.02 1.409-.142 2.59.087 3.223.877a.5.5 0 0 0 .78 0c.633-.79 1.814-1.019 3.222-.877 1.378.139 2.8.62 3.681 1.02A.5.5 0 0 0 16 13.5v-11a.5.5 0 0 0-.293-.455c-.952-.433-2.48-.952-3.994-1.105C10.413.809 8.985.936 8 1.783" }) }), qS = () => /* @__PURE__ */ f.jsxs("svg", { viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ f.jsx(
    "path",
    {
      d: "M8.515 1.019A7 7 0 0 0 8 1V0a8 8 0 0 1 .589.022zm2.004.45a7 7 0 0 0-.985-.299l.219-.976q.576.129 1.126.342zm1.37.71a7 7 0 0 0-.439-.27l.493-.87a8 8 0 0 1 .979.654l-.615.789a7 7 0 0 0-.418-.302zm1.834 1.79a7 7 0 0 0-.653-.796l.724-.69q.406.429.747.91zm.744 1.352a7 7 0 0 0-.214-.468l.893-.45a8 8 0 0 1 .45 1.088l-.95.313a7 7 0 0 0-.179-.483m.53 2.507a7 7 0 0 0-.1-1.025l.985-.17q.1.58.116 1.17zm-.131 1.538q.05-.254.081-.51l.993.123a8 8 0 0 1-.23 1.155l-.964-.267q.069-.247.12-.501m-.952 2.379q.276-.436.486-.908l.914.405q-.24.54-.555 1.038zm-.964 1.205q.183-.183.35-.378l.758.653a8 8 0 0 1-.401.432z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ f.jsx(
    "path",
    {
      d: "M8 1a7 7 0 1 0 4.95 11.95l.707.707A8.001 8.001 0 1 1 8 0z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ f.jsx(
    "path",
    {
      d: "M7.5 3a.5.5 0 0 1 .5.5v5.21l3.248 1.856a.5.5 0 0 1-.496.868l-3.5-2A.5.5 0 0 1 7 9V3.5a.5.5 0 0 1 .5-.5",
      fill: "currentColor"
    }
  )
] }), XS = () => /* @__PURE__ */ f.jsxs("svg", { viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ f.jsx(
    "path",
    {
      "fill-rule": "evenodd",
      fill: "currentColor",
      d: "M12.5 16a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7m.5-5v1h1a.5.5 0 0 1 0 1h-1v1a.5.5 0 0 1-1 0v-1h-1a.5.5 0 0 1 0-1h1v-1a.5.5 0 0 1 1 0M8 1c-1.573 0-3.022.289-4.096.777C2.875 2.245 2 2.993 2 4s.875 1.755 1.904 2.223C4.978 6.711 6.427 7 8 7s3.022-.289 4.096-.777C13.125 5.755 14 5.007 14 4s-.875-1.755-1.904-2.223C11.022 1.289 9.573 1 8 1"
    }
  ),
  /* @__PURE__ */ f.jsx(
    "path",
    {
      "fill-rule": "evenodd",
      fill: "currentColor",
      d: "M2 7v-.839c.457.432 1.004.751 1.49.972C4.722 7.693 6.318 8 8 8s3.278-.307 4.51-.867c.486-.22 1.033-.54 1.49-.972V7c0 .424-.155.802-.411 1.133a4.51 4.51 0 0 0-4.815 1.843A12 12 0 0 1 8 10c-1.573 0-3.022-.289-4.096-.777C2.875 8.755 2 8.007 2 7m6.257 3.998L8 11c-1.682 0-3.278-.307-4.51-.867-.486-.22-1.033-.54-1.49-.972V10c0 1.007.875 1.755 1.904 2.223C4.978 12.711 6.427 13 8 13h.027a4.55 4.55 0 0 1 .23-2.002m-.002 3L8 14c-1.682 0-3.278-.307-4.51-.867-.486-.22-1.033-.54-1.49-.972V13c0 1.007.875 1.755 1.904 2.223C4.978 15.711 6.427 16 8 16c.536 0 1.058-.034 1.555-.097a4.5 4.5 0 0 1-1.3-1.905"
    }
  )
] }), JS = () => /* @__PURE__ */ f.jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 1024 1024", width: "512", height: "512", children: [
  " ",
  /* @__PURE__ */ f.jsx("circle", { cx: "512", cy: "512", r: "512", fill: "#1E7BC4" }),
  " ",
  /* @__PURE__ */ f.jsxs("g", { transform: "translate(0,1024) scale(0.1,-0.1)", fill: "#7B3F1E", stroke: "none", children: [
    " ",
    /* @__PURE__ */ f.jsx("path", { d: `M4910 10094 c-299 -20 -523 -49 -749 -94 -1837 -373 -3284 -1780-3724 -3620 -105 -436 -143 -801 -134 -1295 7 -447 46 -751 147 -1151 139-557 367 -1079 661 -1515 54 -81 99 -150 99 -153 0 -4 -25 -42 -55 -86 -65-92 -126 -218 -150 -310 -9 -36 -19 -113 -22 -172 -15 -277 117 -534 354 -689 94 -61 114 -64 36 -5 -88 68 -171 170 -226 281 -105 211 -114 437 -28 662 26 66 114 230 137 252 2 3 15 -8 28 -23 l23 -29 37 68 c57 101 203 290 327 422 60 64 109 120 109 125 0 4 7 4 17 1 12 -5 14 -3 8 7 -5 8 -4 11 3 6 6 -3 13-2 17 4 4 6 11 8 16 4 6 -3 10 0 8 7 -3 26 1 40 10 34 6 -3 14 3 20 12 23 39 9 -2 -20 -60 -39 -80 -111 -174 -237 -312 -55 -60 -99 -111 -97 -113 3 -3 59 36 217 151 87 63 177 161 240 262 53 85 56 70 6 -30 -64 -127 -143 -216 -288-324 -145 -107 -265 -227 -306 -306 -105 -199 -149 -470 -110 -670 8 -38 13-71 11 -73 -5 -6 -35 80 -30 88 3 4 -1 11 -7 13 -9 4 -9 6 1 6 12 1 12 3 -2 13 -9 8 -23 47 -33 98 -19 96 -15 250 9 335 8 28 17 61 21 75 5 20 5 21 -3 8-6 -9 -21 -56 -33 -105 -17 -70 -21 -116 -21 -228 1 -169 28 -288 97 -432 59-121 106 -190 233 -337 58 -66 118 -140 135 -164 120 -172 75 -382 -96 -447-57 -22 -145 -16 -203 13 -55 29 -130 114 -144 165 -24 90 -29 82 -26 -43 3-107 7 -134 30 -188 27 -65 97 -170 139 -210 l25 -22 458 2 459 3 28 165 c66 385 193 978 269 1257 75 274 181 525 274 648 93 124 175 169 834 460 59 26 77 39 87 64 7 18 40 69 73 114 32 45 84 132 114 193 33 65 69 122 86 137 30 25 32 25 69 10 20 -8 40 -17 44 -19 4 -3 0 -24 -8 -47 -39 -109 49 -343 212 -560 61 -81 363 -397 381 -397 4 0 42 -47 83 -105 77 -106 107 -129 106 -77 -1 27-12 42 -31 42 -5 0 -3 -5 5 -10 12 -8 10 -10 -9 -10 -20 0 -22 2 -10 16 7 8 21 13 30 11 10 -3 17 0 16 6 -1 6 8 12 21 13 24 1 31 -22 8 -28 -8 -2 -11 -10-6 -22 5 -16 9 -14 28 18 12 20 27 35 34 34 7 -2 12 4 10 12 -1 9 5 7 17 -8 12 -13 22 -18 26 -12 9 14 35 12 69 -5 33 -17 39 -19 31 -6 -3 5 0 13 6 17 8 4 9 3 5 -4 -4 -7 -2 -12 3 -12 6 0 11 -6 11 -14 0 -8 6 -21 13 -28 8 -7 17-27 21 -43 7 -29 7 -29 -13 -11 -12 11 -21 14 -21 8 0 -7 4 -12 9 -12 5 0 9-10 9 -22 0 -13 1 -27 2 -33 5 -20 0 -36 -9 -30 -6 3 -9 -3 -8 -13 1 -19 -72-174 -97 -207 -9 -11 -16 -15 -15 -10 3 23 -2 36 -11 30 -6 -4 -4 -17 5 -36 12 -22 13 -29 3 -29 -10 0 -9 -3 1 -9 8 -5 11 -15 8 -23 -3 -8 -1 -21 3 -29 7-11 10 -9 16 6 49 141 240 503 297 565 20 23 35 46 31 51 -3 5 -2 8 3 7 12 -4 278 273 360 375 177 222 279 472 238 590 -8 22 -12 44 -9 48 2 4 24 14 48 22 l44 15 30 -31 c17 -18 53 -77 80 -132 27 -55 79 -141 115 -191 37 -51 69 -103 72 -116 5 -21 37 -39 203 -113 108 -49 247 -110 307 -138 175 -78 291 -145 353 -202 156 -144 295 -496 427 -1078 61 -271 115 -532 164 -802 l48 -260 566-3 566 -2 52 62 c89 107 139 245 139 383 l-1 60 -30 -62 c-50 -103 -150 -173-249 -173 -61 0 -139 29 -181 67 -58 53 -81 104 -81 180 0 90 38 162 153 288\r
246 270 331 429 370 697 16 111 6 301 -21 403 -23 85 -86 242 -102 251 -5 3 0-12 11 -34 43 -85 72 -211 78 -342 6 -129 -10 -300 -29 -300 -5 0 -7 -4 -3 -9 3 -5 2 -12 -2 -14 -5 -3 -9 54 -9 126 -2 230 -64 416 -188 571 -14 17 -15 17-37 -3 -13 -12 -25 -21 -28 -21 -3 0 -34 24 -69 53 -34 30 -69 54 -77 54 -16 0 -14 -4 37 -65 16 -18 28 -38 28 -45 0 -7 -4 -6 -10 3 -9 13 -10 13 -10 0 0-8 -18 6 -41 32 -26 31 -49 48 -63 48 -13 0 -26 3 -30 7 -3 4 -17 8 -29 10-12 2 -23 8 -25 13 -2 6 -10 10 -17 10 -8 0 -17 9 -20 20 -3 11 -13 20 -21 20-8 0 -14 5 -14 12 0 7 -11 24 -25 38 -18 19 -21 27 -11 27 8 0 13 -3 11 -6 -2-4 12 -12 32 -18 34 -10 34 -9 -31 56 -36 37 -66 70 -66 75 0 4 30 -13 66 -39 36 -26 68 -44 72 -40 4 4 1 10 -5 12 -21 8 -14 22 7 16 15 -4 19 -2 14 10 -4 12 -1 14 15 10 33 -8 25 2 -31 39 -29 19 -84 66 -123 103 -38 37 -63 62 -54 56 9 -6 20 -7 24 -3 5 4 5 2 1 -5 -3 -6 -2 -14 4 -18 5 -3 10 -1 10 5 0 7 17-1 38 -18 20 -16 71 -48 112 -72 118 -68 189 -118 269 -189 64 -57 72 -61 55-32 -10 18 -79 97 -152 174 -173 182 -251 286 -245 321 l5 26 28 -38 c44 -59 108 -123 201 -200 78 -64 174 -170 224 -246 11 -17 21 -23 25 -16 9 14 114-97 179 -191 187 -266 230 -561 119 -827 -52 -126 -140 -240 -263 -341 -30-25 -32 -29 -10 -16 330 193 478 537 386 900 -41 158 -131 307 -280 461 l-80 83 73 118 c267 430 465 893 587 1370 251 986 215 1987 -106 2948 -235 702-672 1399 -1196 1910 -784 764 -1810 1233 -2919 1335 -122 11 -518 20 -610 14z m560 -624 c612 -91 1220 -402 1650 -846 139 -143 212 -233 316 -390 43 -66 78-120 79 -121 0 -1 25 5 55 13 200 52 412 -56 514 -262 51 -103 76 -207 76-316 0 -48 2 -88 3 -88 2 0 30 9 62 20 84 29 121 27 139 -8 38 -74 55 -190 73-502 6 -109 -9 -183 -45 -211 -23 -18 -36 -20 -87 -16 -55 6 -161 35 -153 42 2 2 35 -5 73 -16 81 -22 124 -24 149 -6 44 32 -6 76 -131 114 -260 80 -305 95-301 98 2 2 23 -1 47 -6 24 -5 45 -8 46 -7 2 2 5 16 7 33 3 31 -6 39 -80 66-18 6 -31 16 -29 22 2 6 30 18 63 27 89 26 134 47 134 64 0 22 -49 21 -130 -3 l-66 -18 -16 56 -17 55 47 44 c26 24 82 67 126 95 l78 52 -6 76 c-10 148 -86 319 -178 404 -39 36 -40 37 -12 5 18 -19 39 -50 48 -68 l17 -33 -26 17 c-24 16 -25 16 -19 -2 6 -15 1 -14 -22 7 -111 98 -252 105 -389 18 -28 -18 -45 -24-42 -16 4 11 0 13 -15 9 -23 -6 -38 12 -38 48 0 17 -3 21 -9 12 -5 -8 -7 2 -6 25 2 48 15 102 26 109 14 8 10 26 -3 19 -7 -4 -5 0 5 8 16 14 16 15 -8 15 -14 0 -25 -5 -25 -10 0 -5 -4 -7 -10 -3 -5 3 -6 13 -3 22 4 10 2 14 -4 10 -14 -9-86 90 -77 105 4 6 3 8 -3 5 -6 -4 -41 33 -79 81 -79 99 -210 245 -227 251 -6 2 3 -14 21 -36 37 -47 42 -63 10 -34 -11 11 -25 18 -29 15 -4 -2 -32 26 -62 64 -54 67 -159 167 -286 271 -210 173 -535 339 -817 418 -55 15 -100 31 -102 35 -2 4 -10 4 -19 1 -11 -4 -14 -2 -9 5 4 7 2 12 -5 12 -7 0 -10 3 -6 6 15 16 306 -68 472 -135 54 -23 100 -39 102 -37 6 5 -168 82 -272 120 -199 71 -422 123 -627 145 -124 14 -403 14 -505 1 -298 -40 -555 -126 -727 -244 -37 -26-70 -45 -73 -42 -3 3 23 33 58 66 35 34 63 67 61 74 -2 15 144 89 241 122 94 32 273 71 387 83 52 6 111 13 130 15 76 9 352 -5 480 -24z` }),
    " ",
    /* @__PURE__ */ f.jsx("path", { d: `M3470 6773 c-280 -29 -470 -89 -571 -180 -47 -43 -92 -126 -108 -201-13 -61 -14 -207 -1 -157 6 25 8 20 9 -27 2 -90 29 -276 55 -380 26 -104 85-248 117 -288 l20 -25 -3 25 c-2 17 4 28 22 37 14 7 19 13 11 13 -11 0 -10 4 4 14 11 8 25 12 32 9 6 -3 18 -1 25 3 22 14 111 13 132 -2 11 -8 32 -14 46-15 28 0 24 -2 -47 -29 -18 -7 -33 -15 -33 -19 0 -3 35 -6 78 -7 42 -1 88 -6 101 -11 24 -10 23 -10 -19 -24 -75 -24 -58 -34 63 -34 118 -1 206 -16 471 -81 155 -38 205 -41 298 -20 98 23 117 25 124 15 3 -5 10 -7 15 -4 20 13 8 -9 -18-32 l-28 -25 43 23 c50 27 136 99 179 149 79 92 155 254 194 413 27 110 42 403 24 464 -78 260 -448 406 -1015 401 -102 0 -201 -3 -220 -5z m585 -178 c170 -45 330 -192 396 -365 14 -37 16 -51 7 -48 -8 4 -13 -3 -13 -17 0 -14 5-21 13 -18 6 3 12 0 12 -6 0 -6 -4 -11 -10 -11 -5 0 -10 -7 -10 -15 0 -8 5-15 10 -15 6 0 10 5 10 12 0 6 3 9 6 6 3 -4 1 -15 -5 -27 -7 -13 -8 -22 -1\r
-26 5 -3 10 2 11 12 0 10 5 5 10 -12 5 -17 5 -31 0 -35 -5 -3 -3 -29 5 -60 8-30 14 -66 13 -80 0 -14 -7 4 -14 39 -38 172 -104 292 -218 397 -134 122 -282 176 -475 173 -106 -2 -114 -1 -135 21 l-22 22 27 -17 c20 -13 38 -15 68 -10 41 7 41 7 23 28 -10 11 -12 17 -6 13 7 -4 18 -2 25 4 60 50 60 50 137 50 42 0 103 -7 136 -15z m-50 -260 c78 -16 201 -73 231 -106 l19 -21 -35 20 c-49 28-135 52 -190 52 -104 0 -229 -51 -306 -126 -97 -94 -137 -200 -132 -344 3 -87 6 -103 40 -172 28 -56 55 -92 105 -139 38 -35 59 -60 48 -55 -34 13 -217 56-268 62 -100 14 -167 141 -167 316 0 344 308 586 655 513z m252 -220 c31 -35 38 -69 22 -106 -12 -31 -61 -69 -87 -69 -32 0 -81 34 -97 66 -22 46 -12 86 28 120 26 22 38 25 71 21 27 -4 49 -15 63 -32z` }),
    " ",
    /* @__PURE__ */ f.jsx("path", { d: "M6247 6765 c-303 -37 -506 -112 -620 -228 -53 -55 -77 -97 -101 -176-17 -59 -22 -124 -6 -86 5 12 6 -9 3 -51 -10 -134 26 -334 88 -492 41 -104 90-182 161 -258 54 -57 154 -134 175 -134 4 0 4 4 -2 8 -5 4 -16 15 -24 25 -13 16 -12 17 12 8 20 -8 25 -7 21 3 -4 9 13 8 68 -6 97 -25 195 -20 368 21 263 63 370 81 467 81 95 0 118 13 48 26 -83 15 -27 38 90 36 64 -1 68 0 50 14 -11 8 -32 18 -48 21 -31 6 -47 23 -22 23 8 0 18 7 21 15 4 8 10 13 14 10 5 -3 11-2 14 3 8 14 90 4 102 -13 6 -8 21 -15 33 -15 12 0 21 -6 21 -15 0 -8 7 -15 15 -15 9 0 18 -7 21 -15 4 -8 13 -15 20 -15 12 0 12 -5 4 -22 -10 -21 -10 -21 11 2 33 38 94 174 123 275 29 103 56 290 57 403 1 60 3 71 9 48 5 -16 6 -34 3-40 -3 -6 0 -5 7 1 11 10 12 31 2 110 -16 137 -34 184 -99 254 -94 101 -254 161 -518 194 -145 18 -437 18 -588 0z m992 -145 c54 -27 154 -140 124 -140-15 0 -180 53 -205 66 l-28 14 28 40 c15 21 31 39 35 40 4 0 25 -9 46 -20z m-868 -27 c9 -10 29 -28 45 -40 15 -13 24 -23 19 -23 -20 0 21 -20 45 -21 14-1 -29 -5 -95 -9 -138 -9 -213 -31 -318 -92 -168 -98 -285 -270 -326 -479 -8-38 -8 -34 -6 31 2 41 5 77 6 80 0 3 1 14 0 25 -2 16 0 17 8 5 8 -11 14 -4 30 34 22 50 28 82 11 56 -8 -13 -10 -12 -11 5 -3 40 4 61 39 133 90 184 281 309 472 311 50 1 69 -3 81 -16z m-93 -205 c54 -54 43 -130 -23 -161 -100 -48 -193 87 -114 166 42 42 92 40 137 -5z" }),
    " ",
    /* @__PURE__ */ f.jsx("path", { d: "M3180 4943 c-100 -6 -293 -33 -309 -44 -12 -7 -9 -9 14 -5 17 3 93 11 170 17 331 28 789 -24 1102 -126 56 -18 105 -30 108 -27 11 11 4 30 -12 35-10 2 -79 23 -153 46 -269 82 -624 122 -920 104z" }),
    " ",
    /* @__PURE__ */ f.jsx("path", { d: "M6675 4939 c-171 -16 -395 -57 -534 -99 -143 -44 -171 -55 -171 -70 0 -16 28 -12 129 21 360 115 877 158 1261 104 29 -4 31 -4 13 4 -80 36 -495 59 -698 40z" }),
    " ",
    /* @__PURE__ */ f.jsx("path", { d: "M5620 1133 c-78 -12 -90 -15 -90 -25 0 -10 125 -148 141 -156 3 -1 4 11 1 28 -7 52 28 72 96 54 26 -7 38 -44 23 -72 -8 -15 -7 -23 4 -32 19 -15 20-40 2 -40 -8 0 -24 11 -37 25 -29 31 -40 32 -40 3 0 -14 23 -47 61 -85 34 -35 63 -63 65 -63 2 0 4 76 4 169 0 208 4 202 -118 200 -48 -1 -98 -3 -112 -6z" }),
    " ",
    /* @__PURE__ */ f.jsx("path", { d: "M6658 955 c-9 -19 -8 -29 6 -50 22 -33 60 -33 82 0 15 23 15 27 0 50-23 35 -72 35 -88 0z m66 -1 c19 -19 4 -57 -21 -52 -26 5 -39 34 -24 52 17 20 26 20 45 0z" }),
    " ",
    /* @__PURE__ */ f.jsx("path", { d: "M3286 390 c2 -176 10 -248 39 -367 4 -17 12 -22 30 -21 17 2 24 7 20 17 -20 53 -58 288 -64 401 l-8 135 -3 -90 -4 -90 -7 105 c-4 73 -5 46 -3 -90z" }),
    " ",
    /* @__PURE__ */ f.jsx("path", { d: "M6961 475 l-4 -60 -8 50 c-6 43 -7 39 -5 -27 2 -43 -1 -78 -6 -78 -4 0 -8 -15 -8 -32 0 -29 -37 -229 -55 -298 -5 -21 -2 -25 18 -26 23 -2 26 4 41 80 27 139 37 247 34 351 -3 78 -5 87 -7 40z" }),
    " "
  ] }),
  " "
] }), eI = {
  "arrow-down": /* @__PURE__ */ f.jsx(hP, {}),
  "arrow-right": /* @__PURE__ */ f.jsx(AP, {}),
  "back-arrow": /* @__PURE__ */ f.jsx(pP, {}),
  "check-mark": /* @__PURE__ */ f.jsx(vP, {}),
  "circle-check": /* @__PURE__ */ f.jsx(gP, {}),
  "circle-plus": /* @__PURE__ */ f.jsx(mP, {}),
  close: /* @__PURE__ */ f.jsx(CP, {}),
  "collect-menu": /* @__PURE__ */ f.jsx(bP, {}),
  "column-actions": /* @__PURE__ */ f.jsx(yP, {}),
  config: /* @__PURE__ */ f.jsx(wP, {}),
  dashboard: /* @__PURE__ */ f.jsx(xP, {}),
  "devices-linked": /* @__PURE__ */ f.jsx(OP, {}),
  "doc-config": /* @__PURE__ */ f.jsx(DP, {}),
  drag: /* @__PURE__ */ f.jsx(MP, {}),
  duplicate: /* @__PURE__ */ f.jsx(EP, {}),
  edit: /* @__PURE__ */ f.jsx(PP, {}),
  export: /* @__PURE__ */ f.jsx(jP, {}),
  eye: /* @__PURE__ */ f.jsx(SP, {}),
  "eye-hide": /* @__PURE__ */ f.jsx(IP, {}),
  filter: /* @__PURE__ */ f.jsx(BP, {}),
  "financing-config": /* @__PURE__ */ f.jsx(NP, {}),
  "help-card": /* @__PURE__ */ f.jsx(_P, {}),
  home: /* @__PURE__ */ f.jsx(LP, {}),
  "home-2": /* @__PURE__ */ f.jsx(TP, {}),
  lock: /* @__PURE__ */ f.jsx(RP, {}),
  logout: /* @__PURE__ */ f.jsx($P, {}),
  menu: /* @__PURE__ */ f.jsx(FP, {}),
  "menu-context": /* @__PURE__ */ f.jsx(HP, {}),
  notification: /* @__PURE__ */ f.jsx(YP, {}),
  play: /* @__PURE__ */ f.jsx(VP, {}),
  plus: /* @__PURE__ */ f.jsx(kP, {}),
  projects: /* @__PURE__ */ f.jsx(GP, {}),
  question: /* @__PURE__ */ f.jsx(WP, {}),
  search: /* @__PURE__ */ f.jsx(QP, {}),
  sort: /* @__PURE__ */ f.jsx(UP, {}),
  "success-password": /* @__PURE__ */ f.jsx(ZP, {}),
  "traffic-config": /* @__PURE__ */ f.jsx(zP, {}),
  trash: /* @__PURE__ */ f.jsx(KP, {}),
  user: /* @__PURE__ */ f.jsx(qP, {}),
  "user-change": /* @__PURE__ */ f.jsx(XP, {}),
  "user-config": /* @__PURE__ */ f.jsx(JP, {}),
  "user-inactive": /* @__PURE__ */ f.jsx(ej, {}),
  "user-plus": /* @__PURE__ */ f.jsx(tj, {}),
  "user-team": /* @__PURE__ */ f.jsx(rj, {}),
  view: /* @__PURE__ */ f.jsx(nj, {}),
  "arrow-turn-down-right": /* @__PURE__ */ f.jsx(aj, {}),
  "memo-circle-check": /* @__PURE__ */ f.jsx(ij, {}),
  "circle-forbidden": /* @__PURE__ */ f.jsx(oj, {}),
  "circle-exclamation": /* @__PURE__ */ f.jsx(sj, {}),
  "triangle-exclamation": /* @__PURE__ */ f.jsx(lj, {}),
  "floppy-disk": /* @__PURE__ */ f.jsx(cj, {}),
  calendar: /* @__PURE__ */ f.jsx(uj, {}),
  "comment-pen": /* @__PURE__ */ f.jsx(fj, {}),
  "files-client": /* @__PURE__ */ f.jsx(dj, {}),
  "files-included": /* @__PURE__ */ f.jsx(hj, {}),
  "map-location": /* @__PURE__ */ f.jsx(Aj, {}),
  "phone-volume": /* @__PURE__ */ f.jsx(pj, {}),
  envelope: /* @__PURE__ */ f.jsx(vj, {}),
  whatsapp: /* @__PURE__ */ f.jsx(gj, {}),
  "folder-arrow-up": /* @__PURE__ */ f.jsx(mj, {}),
  "files-plus": /* @__PURE__ */ f.jsx(Cj, {}),
  pricing: /* @__PURE__ */ f.jsx(bj, {}),
  sale: /* @__PURE__ */ f.jsx(yj, {}),
  gan: /* @__PURE__ */ f.jsx(wj, {}),
  marketing: /* @__PURE__ */ f.jsx(xj, {}),
  operations: /* @__PURE__ */ f.jsx(Oj, {}),
  audit: /* @__PURE__ */ f.jsx(Dj, {}),
  "cash-flow": /* @__PURE__ */ f.jsx(Mj, {}),
  administrative: /* @__PURE__ */ f.jsx(Ej, {}),
  "right-arrow": /* @__PURE__ */ f.jsx(Pj, {}),
  excel: /* @__PURE__ */ f.jsx(jj, {}),
  word: /* @__PURE__ */ f.jsx(Sj, {}),
  uploadCLoud: /* @__PURE__ */ f.jsx(Ij, {}),
  task: /* @__PURE__ */ f.jsx(Bj, {}),
  dialog: /* @__PURE__ */ f.jsx(Nj, {}),
  copy: /* @__PURE__ */ f.jsx(_j, {}),
  print: /* @__PURE__ */ f.jsx(Lj, {}),
  pdf: /* @__PURE__ */ f.jsx(Tj, {}),
  alert: /* @__PURE__ */ f.jsx(Rj, {}),
  AccessAlarm: /* @__PURE__ */ f.jsx(TS, {}),
  "arrow-left": /* @__PURE__ */ f.jsx(Fj, {}),
  "ArrowUpInBox ": /* @__PURE__ */ f.jsx(Hj, {}),
  clock: /* @__PURE__ */ f.jsx(Yj, {}),
  "column-order": /* @__PURE__ */ f.jsx(Vj, {}),
  SiacoLogo: /* @__PURE__ */ f.jsx(_S, {}),
  "user-profile": /* @__PURE__ */ f.jsx(OS, {}),
  viewvalue: /* @__PURE__ */ f.jsx(Gj, {}),
  boat: /* @__PURE__ */ f.jsx(Wj, {}),
  clone: /* @__PURE__ */ f.jsx(Qj, {}),
  plane: /* @__PURE__ */ f.jsx(Uj, {}),
  deposit: /* @__PURE__ */ f.jsx(Zj, {}),
  "in-arrow": /* @__PURE__ */ f.jsx(zj, {}),
  "file-donwload": /* @__PURE__ */ f.jsx(Kj, {}),
  "cloud-donwload": /* @__PURE__ */ f.jsx(qj, {}),
  "circle-close": /* @__PURE__ */ f.jsx(Xj, {}),
  "bar-code": /* @__PURE__ */ f.jsx(Jj, {}),
  camera: /* @__PURE__ */ f.jsx(eS, {}),
  flash: /* @__PURE__ */ f.jsx(tS, {}),
  "camera-circle": /* @__PURE__ */ f.jsx(rS, {}),
  indicator: /* @__PURE__ */ f.jsx(nS, {}),
  airplane: /* @__PURE__ */ f.jsx(AS, {}),
  "boat-front": /* @__PURE__ */ f.jsx(pS, {}),
  "lower-limit": /* @__PURE__ */ f.jsx(vS, {}),
  "upper-limit": /* @__PURE__ */ f.jsx(gS, {}),
  signature: /* @__PURE__ */ f.jsx(mS, {}),
  map: /* @__PURE__ */ f.jsx(aS, {}),
  coin: /* @__PURE__ */ f.jsx(iS, {}),
  "send-arrow-up": /* @__PURE__ */ f.jsx(oS, {}),
  key: /* @__PURE__ */ f.jsx(sS, {}),
  genio: /* @__PURE__ */ f.jsx(lS, {}),
  "patch-check": /* @__PURE__ */ f.jsx(cS, {}),
  pencil: /* @__PURE__ */ f.jsx(uS, {}),
  cima: /* @__PURE__ */ f.jsx(fS, {}),
  computer: /* @__PURE__ */ f.jsx(dS, {}),
  world: /* @__PURE__ */ f.jsx(hS, {}),
  "refresh-circle": /* @__PURE__ */ f.jsx(CS, {}),
  "calendar-icon": /* @__PURE__ */ f.jsx(bS, {}),
  "calendar-check": /* @__PURE__ */ f.jsx(yS, {}),
  "calendar-close": /* @__PURE__ */ f.jsx(wS, {}),
  "calendar-exclamation": /* @__PURE__ */ f.jsx(xS, {}),
  "journal-check": /* @__PURE__ */ f.jsx(DS, {}),
  "clipboard-check": /* @__PURE__ */ f.jsx(MS, {}),
  circle: /* @__PURE__ */ f.jsx(ES, {}),
  "exclamation-diamond-fill": /* @__PURE__ */ f.jsx(PS, {}),
  "envelope-arrow-up": /* @__PURE__ */ f.jsx(jS, {}),
  "file-text-check": /* @__PURE__ */ f.jsx(SS, {}),
  "pencil-square": /* @__PURE__ */ f.jsx(IS, {}),
  printer: /* @__PURE__ */ f.jsx(BS, {}),
  "file-earmark-check": /* @__PURE__ */ f.jsx(NS, {}),
  "hand-bag": /* @__PURE__ */ f.jsx(LS, {}),
  "node-fill-plus": /* @__PURE__ */ f.jsx(RS, {}),
  "robot-icon": /* @__PURE__ */ f.jsx($S, {}),
  "list-calendar": /* @__PURE__ */ f.jsx(FS, {}),
  "file-send": /* @__PURE__ */ f.jsx(HS, {}),
  "box-open": /* @__PURE__ */ f.jsx(YS, {}),
  invoice: /* @__PURE__ */ f.jsx(VS, {}),
  register: /* @__PURE__ */ f.jsx(kS, {}),
  list: /* @__PURE__ */ f.jsx(GS, {}),
  "airplane-engines": /* @__PURE__ */ f.jsx(WS, {}),
  "journal-bookmark": /* @__PURE__ */ f.jsx(QS, {}),
  "arrow-return-left": /* @__PURE__ */ f.jsx(US, {}),
  "card-checklist": /* @__PURE__ */ f.jsx(ZS, {}),
  ReturnArrowIcon: /* @__PURE__ */ f.jsx($j, {}),
  ArrowLeftRight: /* @__PURE__ */ f.jsx(zS, {}),
  DatabaseFillAdd: /* @__PURE__ */ f.jsx(XS, {}),
  ClockHistory: /* @__PURE__ */ f.jsx(qS, {}),
  book: /* @__PURE__ */ f.jsx(KS, {}),
  PlayCircleOutline: /* @__PURE__ */ f.jsx(kj, {}),
  "castor-ai": /* @__PURE__ */ f.jsx(JS, {})
}, dC = B.forwardRef((e, t) => {
  const {
    color: r,
    width: n = 20,
    widthFull: a = !1,
    isContain: i = !1,
    variant: o
  } = e, s = {
    width: a || i ? "100%" : n,
    height: i ? "100%" : void 0,
    color: r !== void 0 ? gt[r] : void 0
  };
  return /* @__PURE__ */ f.jsx("i", { ref: t, className: `block pointer-events-none ${i ? "codeicon-contain" : ""}`, style: s, children: eI[o] });
});
dC.displayName = "CodeIcon";
const Me = dC, Qr = B.forwardRef((e, t) => {
  const {
    variant: r,
    size: n,
    icon: a,
    children: i,
    isFull: o = !1,
    asSpan: s = !1,
    isLoading: c = !1,
    onlyIcon: u = !1,
    onlyIconMobile: d = !1,
    hideIconDesktop: h = !1,
    unroundedRight: A = !1,
    unroundedLeft: p = !1,
    minWidth: m,
    active: g = !1,
    inactive: v = !1,
    tooltip: C,
    tooltipDirection: y = "top",
    ...w
  } = e, O = "bg-neutral-200 hover:bg-neutral-300 text-neutral-600", b = {
    primary: "bg-primary-100 text-primary-600 hover:bg-primary-300",
    "primary-bold": g ? "bg-primary-500 text-white " : "bg-primary-600 text-white hover:bg-primary-500",
    secondary: g ? "bg-secondary-600 text-white" : "bg-secondary-100 text-secondary-600 hover:bg-secondary-200",
    "secondary-light": g ? "bg-secondary-600 text-white" : "bg-secondary-200 text-secondary-600 hover:bg-secondary-300",
    "secondary-light-bold": "bg-secondary-300 text-secondary-600 hover:bg-secondary-400",
    "secondary-bold": "bg-secondary-600 text-white hover:bg-secondary-500",
    terciary: "bg-secondary-800 text-white hover:bg-secondary-700",
    accent: "bg-accent-600 text-white hover:bg-accent-500",
    info: "bg-info-500 text-white hover:bg-info-400",
    warning: "bg-warning-500 text-white hover:bg-warning-400",
    success: "bg-success-500 text-white hover:bg-success-400",
    error: "bg-error-500 text-white hover:bg-error-400",
    "error-light": g ? "bg-error-100 text-error-500" : "bg-error-50 text-error-500 hover:bg-error-100",
    "error-light-bold": "bg-error-200 text-error-500 hover:bg-error-300",
    "white-secondary": "bg-white text-secondary-600 hover:bg-secondary-100"
  }, D = `h-[3rem] ${d ? "px-0 m:px-[1rem]" : `${u ? "px-0" : "px-[1rem]"}`}`, M = "fill-neutral-200", j = {
    primary: "fill-primary-100",
    "primary-bold": "fill-primary-600",
    secondary: "fill-secondary-100",
    "secondary-light": "fill-secondary-200",
    "secondary-light-bold": "fill-secondary-300",
    "secondary-bold": "fill-secondary-600",
    terciary: "fill-secondary-800",
    accent: "fill-accent-600",
    info: "fill-info-500",
    warning: "fill-warning-500",
    success: "fill-success-500",
    error: "fill-error-500",
    "error-light": "fill-error-50",
    "error-light-bold": "fill-error-200",
    "white-secondary": "fill-white"
  }, P = {
    s: `h-[32px] ${d ? "px-0 m:px-[1rem]" : `${u ? "px-0" : "px-[1rem]"}`}`,
    m: `h-10 ${d ? "px-0 m:px-[1rem]" : `${u ? "px-0" : "px-[1rem]"}`}`,
    l: `h-10 ${d ? "px-0 m:px-[1.25rem]" : `${u ? "px-0" : "px-[1.25rem]"}`}`,
    "2l": `h-10 ${d ? "px-0 m:px-[1.5rem]" : `${u ? "px-0" : "px-[1.5rem]"}`}`,
    xl: `h-[64px] ${d ? "px-0 m:px-[1.5rem]" : `${u ? "px-0" : "px-[1.5rem]"}`}`
  }, H = {
    top: "after:left-1/2 after:-translate-x-1/2 after:bottom-[calc(100%+15px)] before:left-1/2 before:-translate-x-1/2 before:bottom-[calc(100%+6px)] before:border-t-info-500 before:border-t-[9px] before:border-x-transparent before:border-x-[6px]",
    bottom: "after:left-1/2 after:-translate-x-1/2 after:top-[calc(100%+15px)] before:left-1/2 before:-translate-x-1/2 before:top-[calc(100%+6px)] before:border-b-info-500 before:border-b-[9px] before:border-x-transparent before:border-x-[6px]",
    left: "after:left-0 after:-translate-x-[calc(100%+15px)] after:top-1/2 after:-translate-y-1/2 before:left-0 before:-translate-x-[calc(100%+6px)] before:top-1/2 before:-translate-y-1/2 before:border-l-info-500 before:border-l-[9px] before:border-y-transparent before:border-y-[6px]",
    right: "after:right-0 after:translate-x-[calc(100%+15px)] after:top-1/2 after:-translate-y-1/2 before:right-0 before:translate-x-[calc(100%+6px)] before:top-1/2 before:-translate-y-1/2 before:border-r-info-500 before:border-r-[9px] before:border-y-transparent before:border-y-[6px]"
  }, F = Ye([
    "cursor-pointer border border-transparent flex items-center font-bold relative leading-[100%]",
    "disabled:opacity-50 disabled:pointer-events-none",
    p ? void 0 : "rounded-l-md",
    A ? void 0 : "rounded-r-md",
    r !== void 0 ? v ? "bg-neutral-300 text-neutral-400 pointer-events-none" : b[r] : O,
    a !== void 0 ? u ? "aspect-square justify-center" : d ? h ? "gap-[10px] justify-center aspect-square m:aspect-auto" : "gap-[10px] justify-center m:max-w-[fit-content] aspect-square m:aspect-auto" : "gap-[10px] justify-center max-w-[fit-content]" : "justify-center",
    n !== void 0 ? P[n] : D,
    c ? "pointer-events-none" : void 0,
    o ? "w-full max-w-full" : void 0,
    m !== void 0 ? d ? "m:w-[var(--ck-button-min-width)]" : "w-[var(--ck-button-min-width)]" : void 0,
    C !== void 0 && !g ? `${H[y]} relative after:content-[attr(data-title)] after:w-[max-content] after:absolute after:z-[10] after:bg-info-500 after:h-8 after:px-4 after:rounded-md after:text-s after:leading-[120%] after:text-white after:justify-center after:items-center after:hidden hover:after:flex before:absolute before:z-[10] before:hidden hover:before:block` : void 0
  ]), R = {};
  return m !== void 0 && (R["--ck-button-min-width"] = `${m}px`), s ? /* @__PURE__ */ f.jsxs(
    "span",
    {
      ref: t,
      className: F,
      style: R,
      "data-title": C,
      ...w,
      children: [
        a !== void 0 && /* @__PURE__ */ f.jsx("span", { className: `${a === "close" ? "w-[14px]" : "w-5"} aspect-square ${h ? "block m:hidden" : "block"}`, children: /* @__PURE__ */ f.jsx(Me, { variant: a, isContain: !0 }) }),
        /* @__PURE__ */ f.jsx("p", { className: `${d ? "hidden m:block" : "block"}`, children: i })
      ]
    }
  ) : /* @__PURE__ */ f.jsxs(
    "button",
    {
      ref: t,
      className: F,
      style: R,
      "data-title": C,
      ...w,
      children: [
        a !== void 0 && /* @__PURE__ */ f.jsx("span", { className: `${a === "close" ? "w-[14px]" : "w-5"} aspect-square ${h ? "block m:hidden" : "block"}`, children: /* @__PURE__ */ f.jsx(Me, { variant: a, isContain: !0 }) }),
        /* @__PURE__ */ f.jsx("p", { className: `${d ? "hidden m:block" : "block"}`, children: i }),
        c && /* @__PURE__ */ f.jsxs("div", { className: `absolute top-0 left-0 w-full h-full flex items-center justify-center ${r !== void 0 ? b[r] : O}`, children: [
          /* @__PURE__ */ f.jsxs(
            "svg",
            {
              "aria-hidden": "true",
              className: `h-[65%] aspect-square animate-spin ${r !== void 0 ? j[r] : M}`,
              viewBox: "0 0 100 101",
              fill: "none",
              xmlns: "http://www.w3.org/2000/svg",
              children: [
                /* @__PURE__ */ f.jsx("path", { d: "M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z", fill: "currentColor" }),
                /* @__PURE__ */ f.jsx("path", { d: "M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z", fill: "currentFill" })
              ]
            }
          ),
          /* @__PURE__ */ f.jsx("span", { className: "sr-only", children: "Loading..." })
        ] })
      ]
    }
  );
});
Qr.displayName = "Button";
const Ur = A1(null), tI = ({ children: e }) => {
  const [t, r] = De(() => ({
    isCollapsedMenu: window.localStorage.getItem("castor-is-collapsed-menu") === "true",
    isOpenMenuUser: !1,
    isOpenNotifications: !1,
    isOpenMenu: !1
  })), n = () => {
    r((d) => ({
      ...d,
      isOpenMenu: !1,
      isOpenNotifications: !d.isOpenNotifications
    }));
  }, a = () => {
    r((d) => ({
      ...d,
      isOpenNotifications: !1
    }));
  }, i = () => {
    r((d) => ({
      ...d,
      isOpenNotifications: !1,
      isOpenMenu: !d.isOpenMenu
    }));
  }, o = () => {
    r((d) => ({
      ...d,
      isOpenMenu: !1
    }));
  }, s = () => {
    r((d) => {
      const h = !d.isCollapsedMenu;
      return window.localStorage.setItem("castor-is-collapsed-menu", h ? "true" : "false"), {
        ...d,
        isCollapsedMenu: h
      };
    });
  }, c = () => {
    r((d) => ({
      ...d,
      isOpenMenuUser: !d.isOpenMenuUser
    }));
  }, u = () => {
    r((d) => ({
      ...d,
      isOpenMenuUser: !1
    }));
  };
  return Ie(() => {
    t.isOpenMenu ? document.body.classList.add("overflow-y-hidden-dashboard") : document.body.classList.remove("overflow-y-hidden-dashboard");
  }, [t.isOpenMenu]), /* @__PURE__ */ f.jsx(
    Ur.Provider,
    {
      value: {
        isOpenMenu: t.isOpenMenu,
        isCollapsedMenu: t.isCollapsedMenu,
        isOpenNotifications: t.isOpenNotifications,
        isOpenMenuUser: t.isOpenMenuUser,
        toggleOpenMenu: i,
        closeMenu: o,
        toggleCollapsedMenu: s,
        toggleOpenNotifications: n,
        closeNotifications: a,
        toggleOpenMenuUser: c,
        closeMenuUser: u
      },
      children: e
    }
  );
};
tI.displayName = "Dashboard";
const rI = B.forwardRef((e, t) => {
  const {
    isPadding: r = !1,
    children: n,
    ...a
  } = e, i = xt(Ur), o = (i == null ? void 0 : i.isCollapsedMenu) ?? !1;
  return /* @__PURE__ */ f.jsx("main", { ref: t, className: `${r ? "px-4 py-4" : "px-0"} bg-Neutros-50 pb-[4.5rem] 2s:pb-4 2s:pt-[4.5rem] l:pt-[5rem] ${o ? "l:ml-[130px]" : "l:ml-72"}`, ...a, children: n });
});
rI.displayName = "DashboardMain";
const qye = () => {
  const e = new CustomEvent("codekit:closeDropdown");
  document.dispatchEvent(e);
}, nI = {
  actions: "bg-white w-full min-w-[148px] max-w-[240px] p-4 shadow-l",
  box: "bg-white w-[287px] p-8 shadow-l text-center",
  "box-danger": "bg-error-100 w-[287px] p-8 text-center"
}, hC = B.forwardRef((e, t) => {
  const {
    button: r,
    variant: n = "box",
    children: a
  } = e, [i, o] = De(!1), s = ge(null), c = ge(null), u = () => B.Children.map(r, (A) => B.cloneElement(A, {
    ref: s,
    active: i,
    onClick: () => {
      o((p) => !p);
    }
  })), d = () => B.Children.map(a, (A) => B.cloneElement(A, {
    closeDropdown: () => {
      o(!1);
    }
  })), h = (A) => {
    if (s.current !== null && !s.current.contains(A.target)) {
      if (c.current !== null) {
        if (c.current.contains(A.target))
          return;
        o(!1);
        return;
      }
      o(!1);
    }
  };
  return Ie(() => {
    const A = () => {
      o(!1);
    };
    return document.addEventListener("codekit:closeDropdown", A, !0), () => {
      document.removeEventListener("codekit:closeDropdown", A, !0);
    };
  }, []), Ie(() => (document.addEventListener("click", h, !0), () => {
    document.removeEventListener("click", h, !0);
  }), []), /* @__PURE__ */ f.jsxs("div", { ref: t, className: "relative max-w-[fit-content]", children: [
    u(),
    i && /* @__PURE__ */ f.jsx("div", { ref: c, className: "w-[max-content] absolute top-[calc(100%+5px)] z-[2] right-0 pb-[80px] pointer-events-none", children: /* @__PURE__ */ f.jsx(
      "div",
      {
        className: Ye([
          nI[n],
          "rounded-md pointer-events-auto"
        ]),
        children: d()
      }
    ) })
  ] });
});
hC.displayName = "Dropdown";
const B4 = B.forwardRef((e, t) => {
  const {
    icon: r,
    children: n,
    onClick: a,
    closeDropdown: i,
    ...o
  } = e, s = (c) => {
    i !== void 0 && i(), a !== void 0 && a(c);
  };
  return /* @__PURE__ */ f.jsxs(
    "button",
    {
      ref: t,
      onClick: s,
      className: "text-secondary-600 gap-2 px-2 py-[10px] flex items-center hover:bg-secondary-200 w-full outline-none shadow-transparent rounded-md",
      ...o,
      children: [
        /* @__PURE__ */ f.jsx("span", { className: `${r === "close" ? "w-[14px]" : "w-5"} aspect-square block`, children: /* @__PURE__ */ f.jsx(Me, { variant: r, isContain: !0 }) }),
        /* @__PURE__ */ f.jsx("div", { className: "flex-grow", children: /* @__PURE__ */ f.jsx("p", { className: "leading-[120%] font-bold text-left", children: n }) })
      ]
    }
  );
});
B4.displayName = "DropdownAction";
const aI = B.forwardRef((e, t) => {
  const {
    children: r
  } = e, n = "px-4 py-2 min-h-[40px] h-full leading-[120%] font-bold text-neutral-400 flex items-center";
  return /* @__PURE__ */ f.jsxs("div", { ref: t, className: "grid gap-2", children: [
    /* @__PURE__ */ f.jsxs("div", { className: "hidden m:grid grid-cols-export-table", children: [
      /* @__PURE__ */ f.jsx("div", { className: n, style: { gridArea: "name" }, children: "Nombre" }),
      /* @__PURE__ */ f.jsx("div", { className: n, style: { gridArea: "date" }, children: "Fecha de creación" }),
      /* @__PURE__ */ f.jsx("div", { className: n, style: { gridArea: "type" }, children: "Tipo de plantilla" }),
      /* @__PURE__ */ f.jsx("div", { className: n, style: { gridArea: "user" }, children: "Usuario" }),
      /* @__PURE__ */ f.jsx("div", { className: n, style: { gridArea: "actions" }, children: "Acciones" })
    ] }),
    r
  ] });
});
aI.displayName = "ExportTable";
const iI = B.forwardRef((e, t) => {
  const {
    name: r,
    date: n,
    type: a,
    user: i,
    children: o
  } = e, s = "m:border-r m:border-white m:h-full m:flex m:items-center m:px-4 m:py-2 m:min-h-[48px]";
  return /* @__PURE__ */ f.jsxs("div", { ref: t, className: "grid grid-cols-export-table items-center p-4 m:p-0 rounded-md bg-secondary-100 border border-neutral-100 leading-[120%]", children: [
    /* @__PURE__ */ f.jsx("div", { style: { gridArea: "name" }, className: `font-bold pr-3 ${s}`, children: r }),
    /* @__PURE__ */ f.jsx("div", { style: { gridArea: "date" }, className: `mt-2 m:mt-0 ${s}`, children: n }),
    /* @__PURE__ */ f.jsx("div", { style: { gridArea: "type" }, className: `mt-2 m:mt-0 ${s}`, children: a }),
    /* @__PURE__ */ f.jsx(
      "div",
      {
        style: { gridArea: "user" },
        className: `mt-3 pt-3 border-t border-secondary-200 m:mt-0 m:border-r-none ${s}`,
        children: /* @__PURE__ */ f.jsxs("div", { className: "flex gap-2 items-center", children: [
          /* @__PURE__ */ f.jsx("div", { className: "w-[14px] min-w-[24px]", children: /* @__PURE__ */ f.jsx(Qa, { size: "xs", image: i.image }) }),
          /* @__PURE__ */ f.jsx("div", { className: "flex-grow", children: /* @__PURE__ */ f.jsx("p", { children: i.name }) })
        ] })
      }
    ),
    /* @__PURE__ */ f.jsx("div", { style: { gridArea: "actions" }, className: "s:flex s:px-4 s:h-full s:items-center s:justify-center", children: /* @__PURE__ */ f.jsx("div", { className: "flex gap-2 items-center", children: o }) })
  ] });
});
iI.displayName = "ExportTableCol";
const oI = {
  normal: "normal",
  start: "flex-start",
  end: "flex-end",
  center: "center",
  between: "space-between",
  around: "space-around",
  evenly: "space-evenly",
  stretch: "stretch"
}, sI = {
  start: "flex-start",
  end: "flex-end",
  center: "center",
  baseline: "baseline",
  stretch: "stretch"
}, q3 = B.forwardRef((e, t) => {
  const {
    direction: r = "row",
    gap: n,
    gapY: a,
    gapX: i,
    justifyContent: o,
    alignItems: s,
    wrap: c = !1,
    minHeight: u,
    children: d,
    ...h
  } = e, A = {
    justifyContent: o !== void 0 ? oI[o] : void 0,
    alignItems: s !== void 0 ? sI[s] : void 0,
    flexWrap: c ? "wrap" : void 0,
    flexDirection: r,
    minHeight: u
  };
  return n !== void 0 ? A.gap = n !== void 0 ? `${n / 4}rem` : void 0 : (A.columnGap = i !== void 0 ? `${i / 4}rem` : void 0, A.rowGap = a !== void 0 ? `${a / 4}rem` : void 0), /* @__PURE__ */ f.jsx(
    "div",
    {
      ref: t,
      className: "flex",
      style: A,
      ...h,
      children: d
    }
  );
});
q3.displayName = "Flexbox";
const lI = B.forwardRef((e, t) => {
  const {
    grow: r = !1,
    minWidth: n,
    children: a,
    ...i
  } = e, o = {
    flexGrow: r ? 1 : void 0
  };
  return n !== void 0 && (o.minWidth = `${n}px`), /* @__PURE__ */ f.jsx(
    "div",
    {
      ref: t,
      className: "block",
      style: o,
      ...i,
      children: a
    }
  );
});
lI.displayName = "FlexboxRow";
function AC(e, t = 500) {
  const [r, n] = De(e);
  return Ie(() => {
    const a = setTimeout(() => {
      n(e);
    }, t);
    return () => {
      clearTimeout(a);
    };
  }, [e, t]), r;
}
const N4 = B.forwardRef((e, t) => {
  const {
    icon: r,
    variant: n = "default",
    isInvalid: a = !1,
    isSuccess: i = !1,
    selected: o = null,
    placeholder: s = "Search...",
    textLoading: c = "Cargando...",
    textNoResults: u = "No hay resultados",
    minLengthToSearch: d = 5,
    searchResults: h = [],
    disabled: A,
    readOnly: p,
    onChangeSearch: m,
    onItemClick: g,
    onResetSelected: v
  } = e, [C, y] = De(""), [w, O] = De(!1), [b, D] = De(!1), M = ge(!0), j = AC(C), P = () => {
    D(!1);
  };
  return Ie(() => {
    if (M.current) {
      M.current = !1;
      return;
    }
    if (!(A === !0 || p === !0)) {
      if (j.trim().length < d) {
        O(!1);
        return;
      }
      O(!0), m(j.trim(), P);
    }
  }, [j]), /* @__PURE__ */ f.jsxs(
    "div",
    {
      className: Ye([
        "relative flex w-full text-neutral-600 h-10"
      ]),
      children: [
        /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
          o === null ? /* @__PURE__ */ f.jsx(
            "input",
            {
              ref: t,
              type: "text",
              placeholder: s,
              value: C,
              onChange: (H) => {
                y(H.target.value), D(!0);
              },
              className: Ye([
                "w-full h-full flex items-center border rounded-md outline-none shadow-transparent placeholder:text-neutral-400",
                p === !0 || A === !0 ? "cursor-default pointer-events-none" : "hover:border-secondary-400 focus:border-secondary-600",
                A === !0 ? "bg-neutral-300" : n === "default" ? "bg-neutral-200" : "bg-white",
                A === !0 ? "border-neutral-300" : a ? "border-error-500" : i ? "border-success-500" : n === "default" ? "border-neutral-300" : "border-secondary-300",
                r !== void 0 ? "pl-4 pr-[2.75rem]" : "px-4"
              ])
            }
          ) : /* @__PURE__ */ f.jsx(
            "div",
            {
              className: Ye([
                "w-full h-full flex items-center border rounded-md",
                p === !0 || A === !0 ? "cursor-default pointer-events-none" : "hover:border-secondary-400",
                A === !0 ? "bg-neutral-300 border-neutral-300" : n === "default" ? "bg-neutral-200 border-neutral-300" : "bg-white border-secondary-300",
                r !== void 0 ? "pl-4 pr-[2.75rem]" : "px-4"
              ]),
              children: /* @__PURE__ */ f.jsxs(
                "div",
                {
                  className: Ye([
                    "h-8 flex gap-2 items-center pr-2 overflow-hidden rounded-[24px] border",
                    p === !0 || A === !0 ? "pl-2" : "pl-4",
                    A === !0 ? "border-neutral-400 text-neutral-400" : p === !0 ? "border-secondary-400 text-secondary-400" : "border-secondary-600 text-secondary-600"
                  ]),
                  children: [
                    /* @__PURE__ */ f.jsx("div", { className: "flex-grow cursor-default overflow-hidden", children: /* @__PURE__ */ f.jsx("p", { className: "font-bold leading-[120%] text-ellipsis overflow-hidden whitespace-nowrap", children: o }) }),
                    p !== !0 && A !== !0 && /* @__PURE__ */ f.jsx("div", { className: "w-[20px] min-w-[20px] h-[20px]", children: /* @__PURE__ */ f.jsx(
                      "button",
                      {
                        type: "button",
                        className: "w-full h-full rounded-full bg-secondary-600 flex items-center justify-center text-white",
                        onClick: () => {
                          y(""), D(!1), O(!1), v();
                        },
                        children: /* @__PURE__ */ f.jsx(Me, { variant: "close", width: 10 })
                      }
                    ) })
                  ]
                }
              )
            }
          ),
          r !== void 0 && /* @__PURE__ */ f.jsx("span", { className: "absolute right-[1rem] top-1/2 -translate-y-1/2 z-[1]", children: /* @__PURE__ */ f.jsx(Me, { variant: r, width: 18 }) })
        ] }),
        w && /* @__PURE__ */ f.jsx("div", { className: "absolute top-[calc(100%+4px)] left-0 w-full pointer-events-none min-w-[280px] z-[1] pb-[80px]", children: /* @__PURE__ */ f.jsx("div", { className: "bg-white rounded-lg p-4 shadow-l w-full pointer-events-auto", children: /* @__PURE__ */ f.jsx(f.Fragment, { children: b ? /* @__PURE__ */ f.jsxs("div", { className: "p-4 flex flex-col gap-4 items-center justify-center", children: [
          /* @__PURE__ */ f.jsxs(
            "svg",
            {
              "aria-hidden": "true",
              className: "w-[45px] aspect-square animate-spin fill-white text-secondary-600",
              viewBox: "0 0 100 101",
              fill: "none",
              xmlns: "http://www.w3.org/2000/svg",
              children: [
                /* @__PURE__ */ f.jsx("path", { d: "M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z", fill: "currentColor" }),
                /* @__PURE__ */ f.jsx("path", { d: "M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z", fill: "currentFill" })
              ]
            }
          ),
          /* @__PURE__ */ f.jsx("span", { children: c })
        ] }) : /* @__PURE__ */ f.jsx(f.Fragment, { children: h.length > 0 ? /* @__PURE__ */ f.jsx("ul", { children: h.map((H) => /* @__PURE__ */ f.jsxs(
          "li",
          {
            className: "flex gap-2 items-center cursor-pointer p-4 rounded-md hover:bg-secondary-100",
            onClick: () => {
              O(!1), g({ item: H });
            },
            children: [
              H.image !== void 0 && /* @__PURE__ */ f.jsx(Qa, { size: "md", image: H.image }),
              /* @__PURE__ */ f.jsx("div", { className: "flex-grow", children: /* @__PURE__ */ f.jsx("p", { className: "leading-[120%] font-bold", children: H.label }) })
            ]
          },
          H.id
        )) }) : /* @__PURE__ */ f.jsxs("div", { className: "flex flex-col gap-4 items-center justify-center p-4", children: [
          /* @__PURE__ */ f.jsx(Me, { variant: "search", width: 45, color: "secondary-600" }),
          /* @__PURE__ */ f.jsx("span", { className: "block mx-auto text-center w-[90%] max-w-[500px]", children: u })
        ] }) }) }) }) })
      ]
    }
  );
});
N4.displayName = "Autocomplete";
const p0 = B.forwardRef((e, t) => {
  const {
    disabled: r,
    readOnly: n,
    checked: a = !1,
    type: i = "default",
    variant: o = "default",
    isBold: s = !1,
    variantSize: c = "sm",
    children: u,
    onChange: d,
    ...h
  } = e, A = (p) => {
    n === !0 || r === !0 || d !== void 0 && d(p);
  };
  return /* @__PURE__ */ f.jsxs("label", { className: `flex items-center ${c === "sm" ? "gap-4" : "gap-2"} select-none`, children: [
    /* @__PURE__ */ f.jsx("input", { ref: t, type: "checkbox", className: "hidden", checked: a, onChange: A, ...h }),
    i === "default" && /* @__PURE__ */ f.jsx(
      "span",
      {
        className: Ye([
          "flex w-6 min-w-[24px] h-6 justify-center items-center border text-white overflow-hidden rounded-xs transition-colors",
          n === !0 || r === !0 ? "cursor-default pointer-events-none" : "cursor-pointer hover:border-secondary-400",
          r === !0 ? a ? "bg-neutral-400 border-neutral-400" : "bg-neutral-300 border-neutral-300" : a ? "bg-Activos-600 border-secondary-600 hover:border-secondary-600" : o === "default" ? "bg-neutral-200 border-neutral-300" : "bg-white border-secondary-300"
        ]),
        children: a && /* @__PURE__ */ f.jsx(Me, { variant: "check-mark", width: 16 })
      }
    ),
    i === "switch" && /* @__PURE__ */ f.jsx(
      "div",
      {
        className: Ye([
          "relative border rounded-[200px]",
          c === "xs" ? "h-5 w-[37px] min-w-[37px]" : "h-6 w-[54px] min-w-[54px]",
          n === !0 || r === !0 ? "cursor-default pointer-events-none" : "cursor-pointer",
          r === !0 ? a ? "bg-neutral-400 border-neutral-400" : "bg-neutral-300 border-neutral-300" : a ? "bg-secondary-600 border-secondary-600" : o === "white" ? "bg-white border-secondary-300 hover:border-secondary-400" : "bg-neutral-200 border-neutral-300 hover:border-secondary-400"
        ]),
        children: /* @__PURE__ */ f.jsx(
          "span",
          {
            className: Ye([
              "block absolute transition-all rounded-full top-1/2 -translate-y-1/2",
              c === "sm" ? "w-5 h-5" : "w-4 h-4",
              a ? c === "sm" ? "left-[31px]" : "left-[17px]" : "left-[2px]",
              o === "default" || a || r === !0 ? "bg-white" : "bg-secondary-400"
            ])
          }
        )
      }
    ),
    /* @__PURE__ */ f.jsx("span", { className: "flex-grow", children: s ? /* @__PURE__ */ f.jsx(kr, { variant: "title-2", children: u }) : /* @__PURE__ */ f.jsx(a1, { variant: "description-2", children: u }) })
  ] });
});
p0.displayName = "Checkbox";
const cI = B.forwardRef((e, t) => {
  const {
    children: r,
    ...n
  } = e;
  return /* @__PURE__ */ f.jsx("span", { ref: t, ...n, className: "block text-s mt-1.5 leading-[120%] text-error-500", children: r });
});
cI.displayName = "FieldError";
const zn = B.forwardRef((e, t) => {
  const {
    variant: r = "default",
    type: n = "text",
    isInvalid: a = !1,
    isSuccess: i = !1,
    isOtp: o = !1,
    iconLeft: s,
    iconRight: c,
    ...u
  } = e, [d, h] = De(!1);
  return /* @__PURE__ */ f.jsxs(
    "div",
    {
      className: `relative w-full block text-neutral-600 ${o ? "h-[4.9rem]" : "h-10"}`,
      children: [
        /* @__PURE__ */ f.jsx(
          "input",
          {
            ref: t,
            type: n === "password" ? d ? "text" : "password" : n,
            className: Ye([
              ` flex items-center w-full h-full outline-none shadow-transparent
            border rounded-md text-neutral-600 leading-none
            hover:border-primary-600
            focus:border-primary-600
            placeholder:text-neutral-400
            disabled:text-neutral-400 disabled:bg-neutral-300 disabled:pointer-events-none
            read-only:hover:border-neutral-300 read-only:focus:border-neutral-300 read-only:text-neutral-400
          `,
              r === "white" ? "bg-white" : "bg-neutral-200",
              a ? "border-error-500" : i ? "border-success-500" : r === "white" ? "border-secondary-300" : "border-neutral-300",
              o ? "text-center" : void 0,
              n === "password" ? "pl-[1rem] pr-[2.75rem]" : o ? "px-4" : `${c !== void 0 ? "pr-[2.75rem]" : "pr-4"} ${s !== void 0 ? "pl-[2.75rem]" : "pl-4"}`
            ]),
            ...u
          }
        ),
        n === "password" ? /* @__PURE__ */ f.jsx(
          "button",
          {
            onClick: () => {
              h((A) => !A);
            },
            type: "button",
            className: "absolute right-[1rem] top-1/2 -translate-y-1/2 z-[1]",
            children: d ? /* @__PURE__ */ f.jsx(Me, { variant: "eye-hide" }) : /* @__PURE__ */ f.jsx(Me, { variant: "eye" })
          }
        ) : c !== void 0 ? /* @__PURE__ */ f.jsx("span", { className: "absolute right-[1rem] top-1/2 -translate-y-1/2 z-[1]", children: /* @__PURE__ */ f.jsx(Me, { variant: c, width: 18 }) }) : s !== void 0 ? /* @__PURE__ */ f.jsx("span", { className: "absolute left-[1rem] top-1/2 -translate-y-1/2 z-[1]", children: /* @__PURE__ */ f.jsx(Me, { variant: s, width: 18 }) }) : null
      ]
    }
  );
});
zn.displayName = "Input";
const uI = B.forwardRef((e, t) => {
  const {
    alignment: r,
    children: n,
    weight: a = "bold",
    ...i
  } = e, o = {
    textAlign: r,
    fontWeight: a !== void 0 ? cP[a] : void 0
  };
  return /* @__PURE__ */ f.jsx("label", { ref: t, ...i, className: "block text-[1rem] mb-2 leading-[120%]", style: o, children: n });
});
uI.displayName = "Label";
const fI = B.forwardRef((e, t) => {
  const {
    value: r,
    readOnly: n,
    disabled: a,
    checked: i = !1,
    isBold: o = !1,
    variant: s = "default",
    children: c,
    onChange: u,
    ...d
  } = e, h = (A) => {
    n === !0 || a === !0 || u !== void 0 && u(A);
  };
  return /* @__PURE__ */ f.jsxs("label", { className: "flex items-center gap-3 select-none", children: [
    /* @__PURE__ */ f.jsx("input", { ref: t, type: "radio", className: "hidden", checked: i, onChange: h, ...d }),
    /* @__PURE__ */ f.jsx(
      "span",
      {
        className: Ye([
          "flex w-6 min-w-[24px] h-6 justify-center items-center overflow-hidden rounded-full border",
          n === !0 || a === !0 ? "cursor-default pointer-events-none" : "cursor-pointer",
          a === !0 ? `${i ? "bg-white" : "bg-neutral-300"} border-neutral-300` : s === "white" ? `bg-white ${i ? "border-secondary-600" : "border-secondary-300"}` : `bg-neutral-200 ${i ? "border-secondary-600" : "border-neutral-300"}`,
          i ? void 0 : "hover:border-secondary-400"
        ]),
        children: /* @__PURE__ */ f.jsx("span", { className: `block w-[18px] h-[18px] overflow-hidden ${a === !0 ? "bg-neutral-300" : "bg-secondary-600"} rounded-full transition-opacity ${i ? "opacity-100" : "opacity-0"}` })
      }
    ),
    /* @__PURE__ */ f.jsx("span", { className: "flex-grow", children: o ? /* @__PURE__ */ f.jsx(kr, { variant: "title-2", children: c }) : /* @__PURE__ */ f.jsx(a1, { variant: "description-2", children: c }) })
  ] });
});
fI.displayName = "Radio";
const dI = B.forwardRef((e, t) => {
  const {
    options: r = [],
    value: n = "",
    variant: a = "default",
    readOnly: i = !1,
    disabled: o = !1,
    isInvalid: s = !1,
    isSuccess: c = !1,
    placeholder: u = "Seleccione una opción",
    onChangeValue: d,
    onLoadOptions: h
    // Agregamos esta prop
  } = e, [A, p] = De(!1), [m, g] = De(!1), v = ge(null), C = ge(null), y = r.find((D) => D.value === n), w = (y == null ? void 0 : y.text) ?? u, O = (D) => {
    if (v.current !== null && !v.current.contains(D.target)) {
      if (C.current !== null) {
        if (C.current.contains(D.target))
          return;
        p(!1);
        return;
      }
      p(!1);
    }
  };
  Ie(() => (document.addEventListener("click", O, !0), () => {
    document.removeEventListener("click", O, !0);
  }), []);
  const b = () => {
    p((D) => !D), !m && h && (h(), g(!0));
  };
  return /* @__PURE__ */ f.jsx("div", { ref: t, className: `w-full block text-neutral-600 ${a === "no-border" ? "h-[38px]" : "h-10"}`, children: /* @__PURE__ */ f.jsxs("div", { className: "relative w-full h-full", children: [
    /* @__PURE__ */ f.jsxs(
      "div",
      {
        ref: v,
        onClick: b,
        className: Ye([
          "rounded-md flex items-center w-full gap-3 h-full px-4 leading-none",
          i ? "" : "cursor-pointer select-none",
          o ? "bg-neutral-300 text-neutral-400 pointer-events-none" : a === "white" ? "bg-white text-neutral-600" : "bg-neutral-200 text-neutral-600",
          A ? "border-secondary-600" : i ? "" : "hover:border-secondary-400",
          o ? "border border-neutral-300" : a !== "no-border" ? s ? A ? "border border-secondary-600" : "border border-error-500" : c ? A ? "border border-secondary-600" : "border border-success-500" : a === "white" ? "border border-secondary-300" : "border border-neutral-300" : void 0
        ]),
        children: [
          /* @__PURE__ */ f.jsx("div", { className: "flex-grow overflow-hidden", children: /* @__PURE__ */ f.jsx("div", { className: "w-full pointer-events-none text-clamp-1 leading-[32px] break-all", children: w }) }),
          r.length > 0 && /* @__PURE__ */ f.jsx("span", { className: `w-[14px] min-w-[14px] ${A ? "rotate-180" : ""}`, children: /* @__PURE__ */ f.jsx(Me, { variant: "arrow-down", width: 14 }) })
        ]
      }
    ),
    A && r.length > 0 && !i && !o && /* @__PURE__ */ f.jsxs("div", { ref: C, className: "absolute top-[calc(100%+8px)] left-0 w-full min-w-[250px] z-[1500] pb-[80px] pointer-events-none", children: [
      " ",
      /* @__PURE__ */ f.jsx(
        "ul",
        {
          className: `bg-white shadow-l rounded-md p-4 pointer-events-auto ${r.length > 6 ? "max-h-[350px] overflow-y-auto" : ""}`,
          children: r.map((D) => /* @__PURE__ */ f.jsx(
            "li",
            {
              className: `font-bold leading-[120%] p-4 cursor-pointer rounded-md ${n === D.value ? "bg-secondary-600 text-white" : "bg-white hover:bg-secondary-100"}`,
              onClick: () => {
                p(!1), n !== D.value && d !== void 0 && d({ option: D });
              },
              children: D.text
            },
            D.value
          ))
        }
      )
    ] })
  ] }) });
});
dI.displayName = "Select";
const Xye = ({
  options: e = [],
  selectedOptions: t = [],
  variant: r = "default",
  readOnly: n = !1,
  disabled: a = !1,
  isInvalid: i = !1,
  isSuccess: o = !1,
  placeholder: s = "Seleccione una opción",
  onChangeSelectedOptions: c,
  // Cambiamos el nombre de la función de cambio
  onLoadOptions: u
}) => {
  const [d, h] = De(!1), [A, p] = De(!1), m = ge(null), g = ge(null), v = (w) => {
    if (m.current !== null && !m.current.contains(w.target)) {
      if (g.current !== null) {
        if (g.current.contains(w.target))
          return;
        h(!1);
        return;
      }
      h(!1);
    }
  };
  Ie(() => (document.addEventListener("click", v, !0), () => {
    document.removeEventListener("click", v, !0);
  }), []);
  const C = () => {
    h((w) => !w), !A && u && (u(), p(!0));
  }, y = (w) => {
    const O = t.some(
      (D) => D.value === w.value
    );
    let b = [];
    O ? b = t.filter(
      (D) => D.value !== w.value
    ) : b = [...t, w], c && c(b);
  };
  return /* @__PURE__ */ f.jsx(
    "div",
    {
      className: `w-full block text-neutral-600 ${r === "no-border" ? "h-[38px]" : "h-10"}`,
      children: /* @__PURE__ */ f.jsxs("div", { className: "relative w-full h-full", children: [
        /* @__PURE__ */ f.jsxs(
          "div",
          {
            ref: m,
            onClick: C,
            className: Ye([
              "rounded-md flex items-center w-full gap-3 h-full px-4 leading-none",
              n ? "" : "cursor-pointer select-none",
              a ? "bg-neutral-300 text-neutral-400 pointer-events-none" : r === "white" ? "bg-white text-neutral-600" : "bg-neutral-200 text-neutral-600",
              d ? "border-secondary-600" : n ? "" : "hover:border-secondary-400",
              a ? "border border-neutral-300" : r !== "no-border" ? i ? d ? "border border-secondary-600" : "border border-error-500" : o ? d ? "border border-secondary-600" : "border border-success-500" : r === "white" ? "border border-secondary-300" : "border border-neutral-300" : void 0
            ]),
            children: [
              /* @__PURE__ */ f.jsx("div", { className: "flex-grow overflow-hidden", children: /* @__PURE__ */ f.jsx("div", { className: "w-full pointer-events-none text-clamp-1 leading-[32px] break-all", children: t.length === 0 ? s : t.map((w) => w.text).join(", ") }) }),
              e.length > 0 && /* @__PURE__ */ f.jsx(
                "span",
                {
                  className: `w-[14px] min-w-[14px] ${d ? "rotate-180" : ""}`,
                  children: /* @__PURE__ */ f.jsx(Me, { variant: "arrow-down", width: 14 })
                }
              )
            ]
          }
        ),
        d && e.length > 0 && !n && !a && /* @__PURE__ */ f.jsx(
          "div",
          {
            ref: g,
            className: "absolute top-[calc(100%+8px)] left-0 w-full min-w-[250px] z-[1500] pb-[80px] pointer-events-none",
            children: /* @__PURE__ */ f.jsx("ul", { className: "bg-white shadow-l rounded-md p-4 pointer-events-auto", children: e.map((w) => {
              const O = t.some(
                (b) => b.value === w.value
              );
              return /* @__PURE__ */ f.jsx(
                "li",
                {
                  className: `font-bold leading-[120%] p-4 cursor-pointer rounded-md ${O ? "bg-secondary-600 text-white" : "bg-white hover:bg-secondary-100"}`,
                  onClick: () => y(w),
                  children: w.text
                },
                w.value
              );
            }) })
          }
        )
      ] })
    }
  );
};
var _4 = { exports: {} }, h6, td;
function hI() {
  if (td)
    return h6;
  td = 1;
  function e(S) {
    return S && typeof S == "object" && "default" in S ? S.default : S;
  }
  var t = e(B), r = P7;
  function n(S, I) {
    for (var T = Object.getOwnPropertyNames(I), E = 0; E < T.length; E++) {
      var x = T[E], $ = Object.getOwnPropertyDescriptor(I, x);
      $ && $.configurable && S[x] === void 0 && Object.defineProperty(S, x, $);
    }
    return S;
  }
  function a() {
    return (a = Object.assign || function(S) {
      for (var I = 1; I < arguments.length; I++) {
        var T = arguments[I];
        for (var E in T)
          Object.prototype.hasOwnProperty.call(T, E) && (S[E] = T[E]);
      }
      return S;
    }).apply(this, arguments);
  }
  function i(S, I) {
    S.prototype = Object.create(I.prototype), n(S.prototype.constructor = S, I);
  }
  function o(S, I) {
    if (S == null)
      return {};
    var T, E, x = {}, $ = Object.keys(S);
    for (E = 0; E < $.length; E++)
      T = $[E], 0 <= I.indexOf(T) || (x[T] = S[T]);
    return x;
  }
  function s(S) {
    if (S === void 0)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return S;
  }
  var c = function(S, I, T, E, x, $, _, Q) {
    if (!S) {
      var Z;
      if (I === void 0)
        Z = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
      else {
        var X = [T, E, x, $, _, Q], Y = 0;
        (Z = new Error(I.replace(/%s/g, function() {
          return X[Y++];
        }))).name = "Invariant Violation";
      }
      throw Z.framesToPop = 1, Z;
    }
  }, u = c;
  function d(S, I, T) {
    if ("selectionStart" in S && "selectionEnd" in S)
      S.selectionStart = I, S.selectionEnd = T;
    else {
      var E = S.createTextRange();
      E.collapse(!0), E.moveStart("character", I), E.moveEnd("character", T - I), E.select();
    }
  }
  function h(S) {
    var I = 0, T = 0;
    if ("selectionStart" in S && "selectionEnd" in S)
      I = S.selectionStart, T = S.selectionEnd;
    else {
      var E = document.selection.createRange();
      E.parentElement() === S && (I = -E.moveStart("character", -S.value.length), T = -E.moveEnd("character", -S.value.length));
    }
    return { start: I, end: T, length: T - I };
  }
  var A = { 9: "[0-9]", a: "[A-Za-z]", "*": "[A-Za-z0-9]" }, p = "_";
  function m(S, I, T) {
    var E = "", x = "", $ = null, _ = [];
    if (I === void 0 && (I = p), T == null && (T = A), !S || typeof S != "string")
      return { maskChar: I, formatChars: T, mask: null, prefix: null, lastEditablePosition: null, permanents: [] };
    var Q = !1;
    return S.split("").forEach(function(Z) {
      Q = !Q && Z === "\\" || (Q || !T[Z] ? (_.push(E.length), E.length === _.length - 1 && (x += Z)) : $ = E.length + 1, E += Z, !1);
    }), { maskChar: I, formatChars: T, prefix: x, mask: E, lastEditablePosition: $, permanents: _ };
  }
  function g(S, I) {
    return S.permanents.indexOf(I) !== -1;
  }
  function v(S, I, T) {
    var E = S.mask, x = S.formatChars;
    if (!T)
      return !1;
    if (g(S, I))
      return E[I] === T;
    var $ = x[E[I]];
    return new RegExp($).test(T);
  }
  function C(S, I) {
    return I.split("").every(function(T, E) {
      return g(S, E) || !v(S, E, T);
    });
  }
  function y(S, I) {
    var T = S.maskChar, E = S.prefix;
    if (!T) {
      for (; I.length > E.length && g(S, I.length - 1); )
        I = I.slice(0, I.length - 1);
      return I.length;
    }
    for (var x = E.length, $ = I.length; $ >= E.length; $--) {
      var _ = I[$];
      if (!g(S, $) && v(S, $, _)) {
        x = $ + 1;
        break;
      }
    }
    return x;
  }
  function w(S, I) {
    return y(S, I) === S.mask.length;
  }
  function O(S, I) {
    var T = S.maskChar, E = S.mask, x = S.prefix;
    if (!T) {
      for ((I = D(S, "", I, 0)).length < x.length && (I = x); I.length < E.length && g(S, I.length); )
        I += E[I.length];
      return I;
    }
    if (I)
      return D(S, O(S, ""), I, 0);
    for (var $ = 0; $ < E.length; $++)
      g(S, $) ? I += E[$] : I += T;
    return I;
  }
  function b(S, I, T, E) {
    var x = T + E, $ = S.maskChar, _ = S.mask, Q = S.prefix, Z = I.split("");
    if ($)
      return Z.map(function(Y, U) {
        return U < T || x <= U ? Y : g(S, U) ? _[U] : $;
      }).join("");
    for (var X = x; X < Z.length; X++)
      g(S, X) && (Z[X] = "");
    return T = Math.max(Q.length, T), Z.splice(T, x - T), I = Z.join(""), O(S, I);
  }
  function D(S, I, T, E) {
    var x = S.mask, $ = S.maskChar, _ = S.prefix, Q = T.split(""), Z = w(S, I);
    return !$ && E > I.length && (I += x.slice(I.length, E)), Q.every(function(X) {
      for (; L = X, g(S, k = E) && L !== x[k]; ) {
        if (E >= I.length && (I += x[E]), Y = X, U = E, $ && g(S, U) && Y === $)
          return !0;
        if (++E >= x.length)
          return !1;
      }
      var Y, U, k, L;
      return !v(S, E, X) && X !== $ || (E < I.length ? I = $ || Z || E < _.length ? I.slice(0, E) + X + I.slice(E + 1) : (I = I.slice(0, E) + X + I.slice(E), O(S, I)) : $ || (I += X), ++E < x.length);
    }), I;
  }
  function M(S, I, T, E) {
    var x = S.mask, $ = S.maskChar, _ = T.split(""), Q = E;
    return _.every(function(Z) {
      for (; Y = Z, g(S, X = E) && Y !== x[X]; )
        if (++E >= x.length)
          return !1;
      var X, Y;
      return (v(S, E, Z) || Z === $) && E++, E < x.length;
    }), E - Q;
  }
  function j(S, I) {
    for (var T = I; 0 <= T; --T)
      if (!g(S, T))
        return T;
    return null;
  }
  function P(S, I) {
    for (var T = S.mask, E = I; E < T.length; ++E)
      if (!g(S, E))
        return E;
    return null;
  }
  function H(S) {
    return S || S === 0 ? S + "" : "";
  }
  function F(S, I, T, E, x) {
    var $ = S.mask, _ = S.prefix, Q = S.lastEditablePosition, Z = I, X = "", Y = 0, U = 0, k = Math.min(x.start, T.start);
    return T.end > x.start ? U = (Y = M(S, E, X = Z.slice(x.start, T.end), k)) ? x.length : 0 : Z.length < E.length && (U = E.length - Z.length), Z = E, U && (U === 1 && !x.length && (k = x.start === T.start ? P(S, T.start) : j(S, T.start)), Z = b(S, Z, k, U)), Z = D(S, Z, X, k), (k += Y) >= $.length ? k = $.length : k < _.length && !Y ? k = _.length : k >= _.length && k < Q && Y && (k = P(S, k)), X || (X = null), { value: Z = O(S, Z), enteredString: X, selection: { start: k, end: k } };
  }
  function R() {
    var S = new RegExp("windows", "i"), I = new RegExp("phone", "i"), T = navigator.userAgent;
    return S.test(T) && I.test(T);
  }
  function N(S) {
    return typeof S == "function";
  }
  function z() {
    return window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame;
  }
  function q() {
    return window.cancelAnimationFrame || window.webkitCancelRequestAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame;
  }
  function J(S) {
    return (q() ? z() : function() {
      return setTimeout(S, 1e3 / 60);
    })(S);
  }
  function W(S) {
    (q() || clearTimeout)(S);
  }
  var te = function(S) {
    function I(E) {
      var x = S.call(this, E) || this;
      x.focused = !1, x.mounted = !1, x.previousSelection = null, x.selectionDeferId = null, x.saveSelectionLoopDeferId = null, x.saveSelectionLoop = function() {
        x.previousSelection = x.getSelection(), x.saveSelectionLoopDeferId = J(x.saveSelectionLoop);
      }, x.runSaveSelectionLoop = function() {
        x.saveSelectionLoopDeferId === null && x.saveSelectionLoop();
      }, x.stopSaveSelectionLoop = function() {
        x.saveSelectionLoopDeferId !== null && (W(x.saveSelectionLoopDeferId), x.saveSelectionLoopDeferId = null, x.previousSelection = null);
      }, x.getInputDOMNode = function() {
        if (!x.mounted)
          return null;
        var ee = r.findDOMNode(s(s(x))), V = typeof window < "u" && ee instanceof window.Element;
        if (ee && !V)
          return null;
        if (ee.nodeName !== "INPUT" && (ee = ee.querySelector("input")), !ee)
          throw new Error("react-input-mask: inputComponent doesn't contain input node");
        return ee;
      }, x.getInputValue = function() {
        var ee = x.getInputDOMNode();
        return ee ? ee.value : null;
      }, x.setInputValue = function(ee) {
        var V = x.getInputDOMNode();
        V && (x.value = ee, V.value = ee);
      }, x.setCursorToEnd = function() {
        var ee = y(x.maskOptions, x.value), V = P(x.maskOptions, ee);
        V !== null && x.setCursorPosition(V);
      }, x.setSelection = function(ee, V, ne) {
        ne === void 0 && (ne = {});
        var ie = x.getInputDOMNode(), le = x.isFocused();
        ie && le && (ne.deferred || d(ie, ee, V), x.selectionDeferId !== null && W(x.selectionDeferId), x.selectionDeferId = J(function() {
          x.selectionDeferId = null, d(ie, ee, V);
        }), x.previousSelection = { start: ee, end: V, length: Math.abs(V - ee) });
      }, x.getSelection = function() {
        return h(x.getInputDOMNode());
      }, x.getCursorPosition = function() {
        return x.getSelection().start;
      }, x.setCursorPosition = function(ee) {
        x.setSelection(ee, ee);
      }, x.isFocused = function() {
        return x.focused;
      }, x.getBeforeMaskedValueChangeConfig = function() {
        var ee = x.maskOptions, V = ee.mask, ne = ee.maskChar, ie = ee.permanents, le = ee.formatChars;
        return { mask: V, maskChar: ne, permanents: ie, alwaysShowMask: !!x.props.alwaysShowMask, formatChars: le };
      }, x.isInputAutofilled = function(ee, V, ne, ie) {
        var le = x.getInputDOMNode();
        try {
          if (le.matches(":-webkit-autofill"))
            return !0;
        } catch {
        }
        return !x.focused || ie.end < ne.length && V.end === ee.length;
      }, x.onChange = function(ee) {
        var V = s(s(x)).beforePasteState, ne = s(s(x)).previousSelection, ie = x.props.beforeMaskedValueChange, le = x.getInputValue(), de = x.value, ve = x.getSelection();
        x.isInputAutofilled(le, ve, de, ne) && (de = O(x.maskOptions, ""), ne = { start: 0, end: 0, length: 0 }), V && (ne = V.selection, de = V.value, ve = { start: ne.start + le.length, end: ne.start + le.length, length: 0 }, le = de.slice(0, ne.start) + le + de.slice(ne.end), x.beforePasteState = null);
        var Ee = F(x.maskOptions, le, ve, de, ne), Ne = Ee.enteredString, je = Ee.selection, $e = Ee.value;
        if (N(ie)) {
          var ft = ie({ value: $e, selection: je }, { value: de, selection: ne }, Ne, x.getBeforeMaskedValueChangeConfig());
          $e = ft.value, je = ft.selection;
        }
        x.setInputValue($e), N(x.props.onChange) && x.props.onChange(ee), x.isWindowsPhoneBrowser ? x.setSelection(je.start, je.end, { deferred: !0 }) : x.setSelection(je.start, je.end);
      }, x.onFocus = function(ee) {
        var V = x.props.beforeMaskedValueChange, ne = x.maskOptions, ie = ne.mask, le = ne.prefix;
        if (x.focused = !0, x.mounted = !0, ie) {
          if (x.value)
            y(x.maskOptions, x.value) < x.maskOptions.mask.length && x.setCursorToEnd();
          else {
            var de = O(x.maskOptions, le), ve = O(x.maskOptions, de), Ee = y(x.maskOptions, ve), Ne = P(x.maskOptions, Ee), je = { start: Ne, end: Ne };
            if (N(V)) {
              var $e = V({ value: ve, selection: je }, { value: x.value, selection: null }, null, x.getBeforeMaskedValueChangeConfig());
              ve = $e.value, je = $e.selection;
            }
            var ft = ve !== x.getInputValue();
            ft && x.setInputValue(ve), ft && N(x.props.onChange) && x.props.onChange(ee), x.setSelection(je.start, je.end);
          }
          x.runSaveSelectionLoop();
        }
        N(x.props.onFocus) && x.props.onFocus(ee);
      }, x.onBlur = function(ee) {
        var V = x.props.beforeMaskedValueChange, ne = x.maskOptions.mask;
        if (x.stopSaveSelectionLoop(), x.focused = !1, ne && !x.props.alwaysShowMask && C(x.maskOptions, x.value)) {
          var ie = "";
          N(V) && (ie = V({ value: ie, selection: null }, { value: x.value, selection: x.previousSelection }, null, x.getBeforeMaskedValueChangeConfig()).value);
          var le = ie !== x.getInputValue();
          le && x.setInputValue(ie), le && N(x.props.onChange) && x.props.onChange(ee);
        }
        N(x.props.onBlur) && x.props.onBlur(ee);
      }, x.onMouseDown = function(ee) {
        if (!x.focused && document.addEventListener) {
          x.mouseDownX = ee.clientX, x.mouseDownY = ee.clientY, x.mouseDownTime = (/* @__PURE__ */ new Date()).getTime();
          var V = function ne(ie) {
            if (document.removeEventListener("mouseup", ne), x.focused) {
              var le = Math.abs(ie.clientX - x.mouseDownX), de = Math.abs(ie.clientY - x.mouseDownY), ve = Math.max(le, de), Ee = (/* @__PURE__ */ new Date()).getTime() - x.mouseDownTime;
              (ve <= 10 && Ee <= 200 || ve <= 5 && Ee <= 300) && x.setCursorToEnd();
            }
          };
          document.addEventListener("mouseup", V);
        }
        N(x.props.onMouseDown) && x.props.onMouseDown(ee);
      }, x.onPaste = function(ee) {
        N(x.props.onPaste) && x.props.onPaste(ee), ee.defaultPrevented || (x.beforePasteState = { value: x.getInputValue(), selection: x.getSelection() }, x.setInputValue(""));
      }, x.handleRef = function(ee) {
        x.props.children == null && N(x.props.inputRef) && x.props.inputRef(ee);
      };
      var $ = E.mask, _ = E.maskChar, Q = E.formatChars, Z = E.alwaysShowMask, X = E.beforeMaskedValueChange, Y = E.defaultValue, U = E.value;
      x.maskOptions = m($, _, Q), Y == null && (Y = ""), U == null && (U = Y);
      var k = H(U);
      if (x.maskOptions.mask && (Z || k) && (k = O(x.maskOptions, k), N(X))) {
        var L = E.value;
        E.value == null && (L = Y), k = X({ value: k, selection: null }, { value: L = H(L), selection: null }, null, x.getBeforeMaskedValueChangeConfig()).value;
      }
      return x.value = k, x;
    }
    i(I, S);
    var T = I.prototype;
    return T.componentDidMount = function() {
      this.mounted = !0, this.getInputDOMNode() && (this.isWindowsPhoneBrowser = R(), this.maskOptions.mask && this.getInputValue() !== this.value && this.setInputValue(this.value));
    }, T.componentDidUpdate = function() {
      var E = this.previousSelection, x = this.props, $ = x.beforeMaskedValueChange, _ = x.alwaysShowMask, Q = x.mask, Z = x.maskChar, X = x.formatChars, Y = this.maskOptions, U = _ || this.isFocused(), k = this.props.value != null, L = k ? H(this.props.value) : this.value, ee = E ? E.start : null;
      if (this.maskOptions = m(Q, Z, X), this.maskOptions.mask) {
        !Y.mask && this.isFocused() && this.runSaveSelectionLoop();
        var V = this.maskOptions.mask && this.maskOptions.mask !== Y.mask;
        if (Y.mask || k || (L = this.getInputValue()), (V || this.maskOptions.mask && (L || U)) && (L = O(this.maskOptions, L)), V) {
          var ne = y(this.maskOptions, L);
          (ee === null || ne < ee) && (ee = w(this.maskOptions, L) ? ne : P(this.maskOptions, ne));
        }
        !this.maskOptions.mask || !C(this.maskOptions, L) || U || k && this.props.value || (L = "");
        var ie = { start: ee, end: ee };
        if (N($)) {
          var le = $({ value: L, selection: ie }, { value: this.value, selection: this.previousSelection }, null, this.getBeforeMaskedValueChangeConfig());
          L = le.value, ie = le.selection;
        }
        this.value = L;
        var de = this.getInputValue() !== this.value;
        de ? (this.setInputValue(this.value), this.forceUpdate()) : V && this.forceUpdate();
        var ve = !1;
        ie.start != null && ie.end != null && (ve = !E || E.start !== ie.start || E.end !== ie.end), (ve || de) && this.setSelection(ie.start, ie.end);
      } else
        Y.mask && (this.stopSaveSelectionLoop(), this.forceUpdate());
    }, T.componentWillUnmount = function() {
      this.mounted = !1, this.selectionDeferId !== null && W(this.selectionDeferId), this.stopSaveSelectionLoop();
    }, T.render = function() {
      var E, x = this.props, $ = (x.mask, x.alwaysShowMask, x.maskChar, x.formatChars, x.inputRef, x.beforeMaskedValueChange, x.children), _ = o(x, ["mask", "alwaysShowMask", "maskChar", "formatChars", "inputRef", "beforeMaskedValueChange", "children"]);
      if ($) {
        N($) || u(!1);
        var Q = ["onChange", "onPaste", "onMouseDown", "onFocus", "onBlur", "value", "disabled", "readOnly"], Z = a({}, _);
        Q.forEach(function(Y) {
          return delete Z[Y];
        }), E = $(Z), Q.filter(function(Y) {
          return E.props[Y] != null && E.props[Y] !== _[Y];
        }).length && u(!1);
      } else
        E = t.createElement("input", a({ ref: this.handleRef }, _));
      var X = { onFocus: this.onFocus, onBlur: this.onBlur };
      return this.maskOptions.mask && (_.disabled || _.readOnly || (X.onChange = this.onChange, X.onPaste = this.onPaste, X.onMouseDown = this.onMouseDown), _.value != null && (X.value = this.value)), E = t.cloneElement(E, X);
    }, I;
  }(t.Component);
  return h6 = te, h6;
}
var A6, rd;
function AI() {
  if (rd)
    return A6;
  rd = 1;
  var e = function(t, r, n, a, i, o, s, c) {
    if (process.env.NODE_ENV !== "production" && r === void 0)
      throw new Error("invariant requires an error message argument");
    if (!t) {
      var u;
      if (r === void 0)
        u = new Error(
          "Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings."
        );
      else {
        var d = [n, a, i, o, s, c], h = 0;
        u = new Error(
          r.replace(/%s/g, function() {
            return d[h++];
          })
        ), u.name = "Invariant Violation";
      }
      throw u.framesToPop = 1, u;
    }
  };
  return A6 = e, A6;
}
var p6, nd;
function pI() {
  if (nd)
    return p6;
  nd = 1;
  var e = process.env.NODE_ENV !== "production", t = function() {
  };
  if (e) {
    var r = function(a, i) {
      var o = arguments.length;
      i = new Array(o > 1 ? o - 1 : 0);
      for (var s = 1; s < o; s++)
        i[s - 1] = arguments[s];
      var c = 0, u = "Warning: " + a.replace(/%s/g, function() {
        return i[c++];
      });
      typeof console < "u" && console.error(u);
      try {
        throw new Error(u);
      } catch {
      }
    };
    t = function(n, a, i) {
      var o = arguments.length;
      i = new Array(o > 2 ? o - 2 : 0);
      for (var s = 2; s < o; s++)
        i[s - 2] = arguments[s];
      if (a === void 0)
        throw new Error(
          "`warning(condition, format, ...args)` requires a warning message argument"
        );
      n || r.apply(null, [a].concat(i));
    };
  }
  return p6 = t, p6;
}
var v6, ad;
function vI() {
  if (ad)
    return v6;
  ad = 1;
  function e(S) {
    return S && typeof S == "object" && "default" in S ? S.default : S;
  }
  var t = e(B), r = P7, n = e(AI()), a = e(pI());
  function i(S, I) {
    for (var T = Object.getOwnPropertyNames(I), E = 0; E < T.length; E++) {
      var x = T[E], $ = Object.getOwnPropertyDescriptor(I, x);
      $ && $.configurable && S[x] === void 0 && Object.defineProperty(S, x, $);
    }
    return S;
  }
  function o() {
    return o = Object.assign || function(S) {
      for (var I = 1; I < arguments.length; I++) {
        var T = arguments[I];
        for (var E in T)
          Object.prototype.hasOwnProperty.call(T, E) && (S[E] = T[E]);
      }
      return S;
    }, o.apply(this, arguments);
  }
  function s(S, I) {
    S.prototype = Object.create(I.prototype), S.prototype.constructor = S, i(S, I);
  }
  function c(S, I) {
    if (S == null)
      return {};
    var T = {}, E = Object.keys(S), x, $;
    for ($ = 0; $ < E.length; $++)
      x = E[$], !(I.indexOf(x) >= 0) && (T[x] = S[x]);
    return T;
  }
  function u(S) {
    if (S === void 0)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return S;
  }
  function d(S, I, T) {
    if ("selectionStart" in S && "selectionEnd" in S)
      S.selectionStart = I, S.selectionEnd = T;
    else {
      var E = S.createTextRange();
      E.collapse(!0), E.moveStart("character", I), E.moveEnd("character", T - I), E.select();
    }
  }
  function h(S) {
    var I = 0, T = 0;
    if ("selectionStart" in S && "selectionEnd" in S)
      I = S.selectionStart, T = S.selectionEnd;
    else {
      var E = document.selection.createRange();
      E.parentElement() === S && (I = -E.moveStart("character", -S.value.length), T = -E.moveEnd("character", -S.value.length));
    }
    return {
      start: I,
      end: T,
      length: T - I
    };
  }
  var A = {
    9: "[0-9]",
    a: "[A-Za-z]",
    "*": "[A-Za-z0-9]"
  }, p = "_";
  function m(S, I, T) {
    var E = "", x = "", $ = null, _ = [];
    if (I === void 0 && (I = p), T == null && (T = A), !S || typeof S != "string")
      return {
        maskChar: I,
        formatChars: T,
        mask: null,
        prefix: null,
        lastEditablePosition: null,
        permanents: []
      };
    var Q = !1;
    return S.split("").forEach(function(Z) {
      !Q && Z === "\\" ? Q = !0 : (Q || !T[Z] ? (_.push(E.length), E.length === _.length - 1 && (x += Z)) : $ = E.length + 1, E += Z, Q = !1);
    }), {
      maskChar: I,
      formatChars: T,
      prefix: x,
      mask: E,
      lastEditablePosition: $,
      permanents: _
    };
  }
  function g(S, I) {
    return S.permanents.indexOf(I) !== -1;
  }
  function v(S, I, T) {
    var E = S.mask, x = S.formatChars;
    if (!T)
      return !1;
    if (g(S, I))
      return E[I] === T;
    var $ = E[I], _ = x[$];
    return new RegExp(_).test(T);
  }
  function C(S, I) {
    return I.split("").every(function(T, E) {
      return g(S, E) || !v(S, E, T);
    });
  }
  function y(S, I) {
    var T = S.maskChar, E = S.prefix;
    if (!T) {
      for (; I.length > E.length && g(S, I.length - 1); )
        I = I.slice(0, I.length - 1);
      return I.length;
    }
    for (var x = E.length, $ = I.length; $ >= E.length; $--) {
      var _ = I[$], Q = !g(S, $) && v(S, $, _);
      if (Q) {
        x = $ + 1;
        break;
      }
    }
    return x;
  }
  function w(S, I) {
    return y(S, I) === S.mask.length;
  }
  function O(S, I) {
    var T = S.maskChar, E = S.mask, x = S.prefix;
    if (!T) {
      for (I = D(S, "", I, 0), I.length < x.length && (I = x); I.length < E.length && g(S, I.length); )
        I += E[I.length];
      return I;
    }
    if (I) {
      var $ = O(S, "");
      return D(S, $, I, 0);
    }
    for (var _ = 0; _ < E.length; _++)
      g(S, _) ? I += E[_] : I += T;
    return I;
  }
  function b(S, I, T, E) {
    var x = T + E, $ = S.maskChar, _ = S.mask, Q = S.prefix, Z = I.split("");
    if (!$) {
      for (var X = x; X < Z.length; X++)
        g(S, X) && (Z[X] = "");
      return T = Math.max(Q.length, T), Z.splice(T, x - T), I = Z.join(""), O(S, I);
    }
    return Z.map(function(Y, U) {
      return U < T || U >= x ? Y : g(S, U) ? _[U] : $;
    }).join("");
  }
  function D(S, I, T, E) {
    var x = S.mask, $ = S.maskChar, _ = S.prefix, Q = T.split(""), Z = w(S, I), X = function(k, L) {
      return !g(S, k) || L === x[k];
    }, Y = function(k, L) {
      return !$ || !g(S, L) || k !== $;
    };
    return !$ && E > I.length && (I += x.slice(I.length, E)), Q.every(function(U) {
      for (; !X(E, U); ) {
        if (E >= I.length && (I += x[E]), !Y(U, E))
          return !0;
        if (E++, E >= x.length)
          return !1;
      }
      var k = v(S, E, U) || U === $;
      return k ? (E < I.length ? $ || Z || E < _.length ? I = I.slice(0, E) + U + I.slice(E + 1) : (I = I.slice(0, E) + U + I.slice(E), I = O(S, I)) : $ || (I += U), E++, E < x.length) : !0;
    }), I;
  }
  function M(S, I, T, E) {
    var x = S.mask, $ = S.maskChar, _ = T.split(""), Q = E, Z = function(Y, U) {
      return !g(S, Y) || U === x[Y];
    };
    return _.every(function(X) {
      for (; !Z(E, X); )
        if (E++, E >= x.length)
          return !1;
      var Y = v(S, E, X) || X === $;
      return Y && E++, E < x.length;
    }), E - Q;
  }
  function j(S, I) {
    for (var T = I; T >= 0; --T)
      if (!g(S, T))
        return T;
    return null;
  }
  function P(S, I) {
    for (var T = S.mask, E = I; E < T.length; ++E)
      if (!g(S, E))
        return E;
    return null;
  }
  function H(S) {
    return !S && S !== 0 ? "" : S + "";
  }
  function F(S, I, T, E, x) {
    var $ = S.mask, _ = S.prefix, Q = S.lastEditablePosition, Z = I, X = "", Y = 0, U = 0, k = Math.min(x.start, T.start);
    if (T.end > x.start ? (X = Z.slice(x.start, T.end), Y = M(S, E, X, k), Y ? U = x.length : U = 0) : Z.length < E.length && (U = E.length - Z.length), Z = E, U) {
      if (U === 1 && !x.length) {
        var L = x.start === T.start;
        k = L ? P(S, T.start) : j(S, T.start);
      }
      Z = b(S, Z, k, U);
    }
    return Z = D(S, Z, X, k), k = k + Y, k >= $.length ? k = $.length : k < _.length && !Y ? k = _.length : k >= _.length && k < Q && Y && (k = P(S, k)), Z = O(S, Z), X || (X = null), {
      value: Z,
      enteredString: X,
      selection: {
        start: k,
        end: k
      }
    };
  }
  function R() {
    var S = new RegExp("windows", "i"), I = new RegExp("phone", "i"), T = navigator.userAgent;
    return S.test(T) && I.test(T);
  }
  function N(S) {
    return typeof S == "function";
  }
  function z() {
    return window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame;
  }
  function q() {
    return window.cancelAnimationFrame || window.webkitCancelRequestAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame;
  }
  function J(S) {
    var I = !!q(), T;
    return I ? T = z() : T = function() {
      return setTimeout(S, 1e3 / 60);
    }, T(S);
  }
  function W(S) {
    var I = q() || clearTimeout;
    I(S);
  }
  var te = /* @__PURE__ */ function(S) {
    s(I, S);
    function I(E) {
      var x;
      x = S.call(this, E) || this, x.focused = !1, x.mounted = !1, x.previousSelection = null, x.selectionDeferId = null, x.saveSelectionLoopDeferId = null, x.saveSelectionLoop = function() {
        x.previousSelection = x.getSelection(), x.saveSelectionLoopDeferId = J(x.saveSelectionLoop);
      }, x.runSaveSelectionLoop = function() {
        x.saveSelectionLoopDeferId === null && x.saveSelectionLoop();
      }, x.stopSaveSelectionLoop = function() {
        x.saveSelectionLoopDeferId !== null && (W(x.saveSelectionLoopDeferId), x.saveSelectionLoopDeferId = null, x.previousSelection = null);
      }, x.getInputDOMNode = function() {
        if (!x.mounted)
          return null;
        var V = r.findDOMNode(u(u(x))), ne = typeof window < "u" && V instanceof window.Element;
        if (V && !ne)
          return null;
        if (V.nodeName !== "INPUT" && (V = V.querySelector("input")), !V)
          throw new Error("react-input-mask: inputComponent doesn't contain input node");
        return V;
      }, x.getInputValue = function() {
        var V = x.getInputDOMNode();
        return V ? V.value : null;
      }, x.setInputValue = function(V) {
        var ne = x.getInputDOMNode();
        ne && (x.value = V, ne.value = V);
      }, x.setCursorToEnd = function() {
        var V = y(x.maskOptions, x.value), ne = P(x.maskOptions, V);
        ne !== null && x.setCursorPosition(ne);
      }, x.setSelection = function(V, ne, ie) {
        ie === void 0 && (ie = {});
        var le = x.getInputDOMNode(), de = x.isFocused();
        if (!(!le || !de)) {
          var ve = ie, Ee = ve.deferred;
          Ee || d(le, V, ne), x.selectionDeferId !== null && W(x.selectionDeferId), x.selectionDeferId = J(function() {
            x.selectionDeferId = null, d(le, V, ne);
          }), x.previousSelection = {
            start: V,
            end: ne,
            length: Math.abs(ne - V)
          };
        }
      }, x.getSelection = function() {
        var V = x.getInputDOMNode();
        return h(V);
      }, x.getCursorPosition = function() {
        return x.getSelection().start;
      }, x.setCursorPosition = function(V) {
        x.setSelection(V, V);
      }, x.isFocused = function() {
        return x.focused;
      }, x.getBeforeMaskedValueChangeConfig = function() {
        var V = x.maskOptions, ne = V.mask, ie = V.maskChar, le = V.permanents, de = V.formatChars, ve = x.props.alwaysShowMask;
        return {
          mask: ne,
          maskChar: ie,
          permanents: le,
          alwaysShowMask: !!ve,
          formatChars: de
        };
      }, x.isInputAutofilled = function(V, ne, ie, le) {
        var de = x.getInputDOMNode();
        try {
          if (de.matches(":-webkit-autofill"))
            return !0;
        } catch {
        }
        return x.focused ? le.end < ie.length && ne.end === V.length : !0;
      }, x.onChange = function(V) {
        var ne = u(u(x)), ie = ne.beforePasteState, le = u(u(x)), de = le.previousSelection, ve = x.props.beforeMaskedValueChange, Ee = x.getInputValue(), Ne = x.value, je = x.getSelection();
        x.isInputAutofilled(Ee, je, Ne, de) && (Ne = O(x.maskOptions, ""), de = {
          start: 0,
          end: 0,
          length: 0
        }), ie && (de = ie.selection, Ne = ie.value, je = {
          start: de.start + Ee.length,
          end: de.start + Ee.length,
          length: 0
        }, Ee = Ne.slice(0, de.start) + Ee + Ne.slice(de.end), x.beforePasteState = null);
        var $e = F(x.maskOptions, Ee, je, Ne, de), ft = $e.enteredString, yt = $e.selection, sr = $e.value;
        if (N(ve)) {
          var zt = ve({
            value: sr,
            selection: yt
          }, {
            value: Ne,
            selection: de
          }, ft, x.getBeforeMaskedValueChangeConfig());
          sr = zt.value, yt = zt.selection;
        }
        x.setInputValue(sr), N(x.props.onChange) && x.props.onChange(V), x.isWindowsPhoneBrowser ? x.setSelection(yt.start, yt.end, {
          deferred: !0
        }) : x.setSelection(yt.start, yt.end);
      }, x.onFocus = function(V) {
        var ne = x.props.beforeMaskedValueChange, ie = x.maskOptions, le = ie.mask, de = ie.prefix;
        if (x.focused = !0, x.mounted = !0, le) {
          if (x.value)
            y(x.maskOptions, x.value) < x.maskOptions.mask.length && x.setCursorToEnd();
          else {
            var ve = O(x.maskOptions, de), Ee = O(x.maskOptions, ve), Ne = y(x.maskOptions, Ee), je = P(x.maskOptions, Ne), $e = {
              start: je,
              end: je
            };
            if (N(ne)) {
              var ft = ne({
                value: Ee,
                selection: $e
              }, {
                value: x.value,
                selection: null
              }, null, x.getBeforeMaskedValueChangeConfig());
              Ee = ft.value, $e = ft.selection;
            }
            var yt = Ee !== x.getInputValue();
            yt && x.setInputValue(Ee), yt && N(x.props.onChange) && x.props.onChange(V), x.setSelection($e.start, $e.end);
          }
          x.runSaveSelectionLoop();
        }
        N(x.props.onFocus) && x.props.onFocus(V);
      }, x.onBlur = function(V) {
        var ne = x.props.beforeMaskedValueChange, ie = x.maskOptions.mask;
        if (x.stopSaveSelectionLoop(), x.focused = !1, ie && !x.props.alwaysShowMask && C(x.maskOptions, x.value)) {
          var le = "";
          if (N(ne)) {
            var de = ne({
              value: le,
              selection: null
            }, {
              value: x.value,
              selection: x.previousSelection
            }, null, x.getBeforeMaskedValueChangeConfig());
            le = de.value;
          }
          var ve = le !== x.getInputValue();
          ve && x.setInputValue(le), ve && N(x.props.onChange) && x.props.onChange(V);
        }
        N(x.props.onBlur) && x.props.onBlur(V);
      }, x.onMouseDown = function(V) {
        if (!x.focused && document.addEventListener) {
          x.mouseDownX = V.clientX, x.mouseDownY = V.clientY, x.mouseDownTime = (/* @__PURE__ */ new Date()).getTime();
          var ne = function ie(le) {
            if (document.removeEventListener("mouseup", ie), !!x.focused) {
              var de = Math.abs(le.clientX - x.mouseDownX), ve = Math.abs(le.clientY - x.mouseDownY), Ee = Math.max(de, ve), Ne = (/* @__PURE__ */ new Date()).getTime() - x.mouseDownTime;
              (Ee <= 10 && Ne <= 200 || Ee <= 5 && Ne <= 300) && x.setCursorToEnd();
            }
          };
          document.addEventListener("mouseup", ne);
        }
        N(x.props.onMouseDown) && x.props.onMouseDown(V);
      }, x.onPaste = function(V) {
        N(x.props.onPaste) && x.props.onPaste(V), V.defaultPrevented || (x.beforePasteState = {
          value: x.getInputValue(),
          selection: x.getSelection()
        }, x.setInputValue(""));
      }, x.handleRef = function(V) {
        x.props.children == null && N(x.props.inputRef) && x.props.inputRef(V);
      };
      var $ = E.mask, _ = E.maskChar, Q = E.formatChars, Z = E.alwaysShowMask, X = E.beforeMaskedValueChange, Y = E.defaultValue, U = E.value;
      x.maskOptions = m($, _, Q), Y == null && (Y = ""), U == null && (U = Y);
      var k = H(U);
      if (x.maskOptions.mask && (Z || k) && (k = O(x.maskOptions, k), N(X))) {
        var L = E.value;
        E.value == null && (L = Y), L = H(L);
        var ee = X({
          value: k,
          selection: null
        }, {
          value: L,
          selection: null
        }, null, x.getBeforeMaskedValueChangeConfig());
        k = ee.value;
      }
      return x.value = k, x;
    }
    var T = I.prototype;
    return T.componentDidMount = function() {
      this.mounted = !0, this.getInputDOMNode() && (this.isWindowsPhoneBrowser = R(), this.maskOptions.mask && this.getInputValue() !== this.value && this.setInputValue(this.value));
    }, T.componentDidUpdate = function() {
      var x = this.previousSelection, $ = this.props, _ = $.beforeMaskedValueChange, Q = $.alwaysShowMask, Z = $.mask, X = $.maskChar, Y = $.formatChars, U = this.maskOptions, k = Q || this.isFocused(), L = this.props.value != null, ee = L ? H(this.props.value) : this.value, V = x ? x.start : null;
      if (this.maskOptions = m(Z, X, Y), this.maskOptions.mask)
        !U.mask && this.isFocused() && this.runSaveSelectionLoop();
      else {
        U.mask && (this.stopSaveSelectionLoop(), this.forceUpdate());
        return;
      }
      var ne = this.maskOptions.mask && this.maskOptions.mask !== U.mask;
      if (!U.mask && !L && (ee = this.getInputValue()), (ne || this.maskOptions.mask && (ee || k)) && (ee = O(this.maskOptions, ee)), ne) {
        var ie = y(this.maskOptions, ee);
        (V === null || ie < V) && (w(this.maskOptions, ee) ? V = ie : V = P(this.maskOptions, ie));
      }
      this.maskOptions.mask && C(this.maskOptions, ee) && !k && (!L || !this.props.value) && (ee = "");
      var le = {
        start: V,
        end: V
      };
      if (N(_)) {
        var de = _({
          value: ee,
          selection: le
        }, {
          value: this.value,
          selection: this.previousSelection
        }, null, this.getBeforeMaskedValueChangeConfig());
        ee = de.value, le = de.selection;
      }
      this.value = ee;
      var ve = this.getInputValue() !== this.value;
      ve ? (this.setInputValue(this.value), this.forceUpdate()) : ne && this.forceUpdate();
      var Ee = !1;
      le.start != null && le.end != null && (Ee = !x || x.start !== le.start || x.end !== le.end), (Ee || ve) && this.setSelection(le.start, le.end);
    }, T.componentWillUnmount = function() {
      this.mounted = !1, this.selectionDeferId !== null && W(this.selectionDeferId), this.stopSaveSelectionLoop();
    }, T.render = function() {
      var x = this.props, $ = x.mask;
      x.alwaysShowMask;
      var _ = x.maskChar, Q = x.formatChars, Z = x.inputRef;
      x.beforeMaskedValueChange;
      var X = x.children, Y = c(x, ["mask", "alwaysShowMask", "maskChar", "formatChars", "inputRef", "beforeMaskedValueChange", "children"]), U;
      if (process.env.NODE_ENV !== "production" && a(
        // parse mask to test against actual mask prop as this.maskOptions
        // will be updated later in componentDidUpdate
        !Y.maxLength || !m($, _, Q).mask,
        "react-input-mask: maxLength property shouldn't be passed to the masked input. It breaks masking and unnecessary because length is limited by the mask length."
      ), X) {
        N(X) || (process.env.NODE_ENV !== "production" ? n(!1, "react-input-mask: children must be a function") : n(!1));
        var k = ["onChange", "onPaste", "onMouseDown", "onFocus", "onBlur", "value", "disabled", "readOnly"], L = o({}, Y);
        k.forEach(function(ne) {
          return delete L[ne];
        }), U = X(L);
        var ee = k.filter(function(ne) {
          return U.props[ne] != null && U.props[ne] !== Y[ne];
        });
        ee.length && (process.env.NODE_ENV !== "production" ? n(!1, "react-input-mask: the following props should be passed to the react-input-mask's component and should not be altered in children's function: " + ee.join(", ")) : n(!1)), process.env.NODE_ENV !== "production" && a(!Z, "react-input-mask: inputRef is ignored when children is passed, attach ref to the children instead");
      } else
        U = t.createElement("input", o({
          ref: this.handleRef
        }, Y));
      var V = {
        onFocus: this.onFocus,
        onBlur: this.onBlur
      };
      return this.maskOptions.mask && (!Y.disabled && !Y.readOnly && (V.onChange = this.onChange, V.onPaste = this.onPaste, V.onMouseDown = this.onMouseDown), Y.value != null && (V.value = this.value)), U = t.cloneElement(U, V), U;
    }, I;
  }(t.Component);
  return v6 = te, v6;
}
process.env.NODE_ENV === "production" ? _4.exports = hI() : _4.exports = vI();
var gI = _4.exports;
const mI = /* @__PURE__ */ qe(gI), CI = B.forwardRef((e, t) => {
  const {
    variant: r = "default",
    mask: n = "",
    maskChar: a = "",
    isInvalid: i = !1,
    isSuccess: o = !1,
    ...s
  } = e, c = ge(null);
  return /* @__PURE__ */ f.jsx("div", { className: "relative w-full block text-neutral-600 h-10", ref: t, children: /* @__PURE__ */ f.jsx(
    mI,
    {
      mask: n,
      maskChar: a,
      ...s,
      children: (u) => /* @__PURE__ */ f.jsx(
        "input",
        {
          ...u,
          ref: c,
          className: Ye([
            `
            flex items-center w-full h-full outline-none shadow-transparent
            border rounded-md text-neutral-600 leading-none
            hover:border-secondary-400
            focus:border-secondary-600
            placeholder:text-neutral-400
            disabled:text-neutral-400 disabled:bg-neutral-300 disabled:pointer-events-none
            read-only:hover:border-neutral-300 read-only:focus:border-neutral-300 read-only:text-neutral-400 pl-4
          `,
            r === "white" ? "bg-white" : "bg-neutral-200",
            i ? "border-error-500" : o ? "border-success-500" : r === "white" ? "border-secondary-300" : "border-neutral-300"
          ])
        }
      )
    }
  ) });
});
CI.displayName = "InputMask";
const bI = B.forwardRef((e, t) => {
  const {
    variant: r = "default",
    isInvalid: n = !1,
    isSuccess: a = !1,
    ...i
  } = e;
  return /* @__PURE__ */ f.jsx(
    "div",
    {
      className: "relative w-full block text-neutral-600",
      children: /* @__PURE__ */ f.jsx(
        "textarea",
        {
          ref: t,
          className: Ye([
            `
            flex items-center w-full h-full outline-none shadow-transparent
            border rounded-md text-neutral-600 leading-none
            hover:border-secondary-400
            focus:border-secondary-600
            placeholder:text-neutral-400
            disabled:text-neutral-400 disabled:bg-neutral-300 disabled:pointer-events-none
            read-only:hover:border-neutral-300 read-only:focus:border-neutral-300 read-only:text-neutral-400
            p-2 resize-none
          `,
            r === "white" ? "bg-white" : "bg-neutral-200",
            n ? "border-error-500" : a ? "border-success-500" : r === "white" ? "border-secondary-300" : "border-neutral-300"
          ]),
          ...i,
          style: { height: "100px" }
        }
      )
    }
  );
});
bI.displayName = "Textarea";
const Jye = ({
  options: e,
  selectedOption: t = null,
  onChangeSelectedOption: r,
  disabled: n = !1,
  readOnly: a = !1,
  placeholder: i = "Seleccione.."
}) => {
  const [o, s] = De(!1), [c, u] = De(""), [d, h] = De(e), A = (g) => {
    const v = g.target.value;
    u(v), h(
      e.filter(
        (C) => C.label.toLowerCase().includes(v.toLowerCase())
      )
    );
  }, p = () => {
    !n && !a && (s(!o), u(""), h(e));
  }, m = (g) => {
    !a && !n && r && (r(g), s(!1));
  };
  return /* @__PURE__ */ f.jsxs(
    "div",
    {
      className: `relative ${n ? "cursor-not-allowed opacity-50" : "cursor-pointer"}`,
      children: [
        /* @__PURE__ */ f.jsx(
          "div",
          {
            className: "border rounded-md border-gray-300 rounded px-4 py-2 bg-white",
            onClick: p,
            children: t && t.label ? t.label : i
          }
        ),
        o && /* @__PURE__ */ f.jsxs("div", { className: "absolute mt-1 w-full max-h-60 border  border-gray-300 bg-white rounded shadow-l z-100", children: [
          /* @__PURE__ */ f.jsx(
            "input",
            {
              type: "text",
              value: c,
              onChange: A,
              placeholder: "Filtrar...",
              className: "w-full px-4 py-2 border-b border-gray-300 focus:outline-none"
            }
          ),
          /* @__PURE__ */ f.jsx("ul", { className: "overflow-y-auto max-h-48 relative z-50", children: d.length > 0 ? d.map((g) => /* @__PURE__ */ f.jsx(
            "li",
            {
              className: `px-4 py-2 hover:bg-gray-100 ${t && t.value === g.value ? "bg-secondary-600 text-white" : "bg-white hover:bg-secondary-100"}`,
              onClick: () => m(g),
              children: g.label
            },
            g.value
          )) : /* @__PURE__ */ f.jsx("li", { className: "px-4 py-2 text-gray-500", children: "No se encuentran resultados" }) })
        ] })
      ]
    }
  );
}, yI = "data:image/png;base64,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", wI = B.forwardRef((e, t) => {
  const {
    children: r,
    ...n
  } = e;
  return /* @__PURE__ */ f.jsxs("div", { ref: t, ...n, className: "flex gap-16 flex-grow items-center", children: [
    /* @__PURE__ */ f.jsx(
      "img",
      {
        src: yI,
        alt: "Castor Logo",
        style: { width: "16%" }
      }
    ),
    r
  ] });
});
wI.displayName = "HedaerBoxLeft";
const xI = B.forwardRef((e, t) => {
  const {
    children: r,
    ...n
  } = e, a = xt(Ur), i = (a == null ? void 0 : a.isOpenMenu) ?? !1;
  return /* @__PURE__ */ f.jsxs("div", { ref: t, ...n, className: "flex gap-4 items-center", children: [
    r,
    /* @__PURE__ */ f.jsx(
      "button",
      {
        type: "button",
        className: "l:hidden flex items-center justify-center rounded-[0.5rem] bg-secondary-800 hover:bg-primary-600 min-w-[40px] aspect-square text-white",
        children: /* @__PURE__ */ f.jsx(Me, { variant: "search", width: 18 })
      }
    ),
    /* @__PURE__ */ f.jsx(
      "button",
      {
        type: "button",
        onClick: a == null ? void 0 : a.toggleOpenMenu,
        className: `l:hidden flex items-center justify-center rounded-[0.5rem] ${i ? "bg-primary-600" : "bg-secondary-800"} hover:bg-primary-600 min-w-[40px] aspect-square text-white`,
        children: i ? /* @__PURE__ */ f.jsx(Me, { variant: "close", width: 14 }) : /* @__PURE__ */ f.jsx(Me, { variant: "menu" })
      }
    )
  ] });
});
xI.displayName = "HeaderBoxRight";
const OI = B.forwardRef((e, t) => {
  const {
    image: r,
    children: n,
    onClick: a,
    ...i
  } = e, o = xt(Ur), s = (c) => {
    a !== void 0 && a(c), o == null || o.closeNotifications();
  };
  return /* @__PURE__ */ f.jsxs(
    "div",
    {
      ref: t,
      className: "flex items-start gap-2 cursor-pointer select-none p-4 rounded-md hover:bg-secondary-100",
      onClick: s,
      ...i,
      children: [
        /* @__PURE__ */ f.jsx(Qa, { size: "sm", image: r }),
        /* @__PURE__ */ f.jsx("div", { children: n })
      ]
    }
  );
});
OI.displayName = "HeaderNotificationItem";
const DI = B.forwardRef((e, t) => {
  const {
    children: r,
    quantity: n,
    ...a
  } = e, i = xt(Ur), o = (i == null ? void 0 : i.isOpenNotifications) ?? !1, s = ge(null), c = ge(null), u = (d) => {
    if (s.current !== null && !s.current.contains(d.target)) {
      if (c.current !== null) {
        if (c.current.contains(d.target))
          return;
        i == null || i.closeNotifications();
        return;
      }
      i == null || i.closeNotifications();
    }
  };
  return Ie(() => (document.addEventListener("click", u, !0), () => {
    document.removeEventListener("click", u, !0);
  }), []), /* @__PURE__ */ f.jsxs("div", { ref: t, className: "relative", ...a, children: [
    /* @__PURE__ */ f.jsx(
      "button",
      {
        ref: s,
        type: "button",
        className: "flex items-center justify-center rounded-[0.5rem] min-w-[40px] aspect-square text-white",
        onClick: i == null ? void 0 : i.toggleOpenNotifications,
        children: /* @__PURE__ */ f.jsxs("div", { className: "relative", children: [
          /* @__PURE__ */ f.jsx("div", { className: "absolute top-0 right-0 bg-error-500 w-[19px] aspect-square rounded-full overflow-hidden inline-flex items-center justify-center text-xs translate-x-1/2 -translate-y-1/2", children: n }),
          /* @__PURE__ */ f.jsx(Me, { variant: "notification", width: 18 })
        ] })
      }
    ),
    /* @__PURE__ */ f.jsxs(
      "div",
      {
        ref: c,
        className: `fixed 2s:absolute w-[calc(100%-1.8rem)] max-w-[450px] 2s:w-[290px] z-[1] bottom-[5.5rem] 2s:bottom-auto 2s:top-[calc(100%+9px)]
         2s:left-1/2 right-[0.9rem] 2s:right-auto 2s:-translate-x-full bg-white shadow-l rounded-md overflow-hidden  ${o ? "block" : "hidden"}`,
        children: [
          /* @__PURE__ */ f.jsx("div", { className: "pt-6 px-4 pb-4 border-b border-neutral-200", children: /* @__PURE__ */ f.jsx(Vi, { variant: "heading-6", children: "Notificaciones" }) }),
          /* @__PURE__ */ f.jsx("div", { className: "px-4 pt-4 pb-6 mb-10 l:mb-0", children: r })
        ]
      }
    )
  ] });
});
DI.displayName = "HeaderNotifications";
const MI = B.forwardRef((e, t) => {
  const {
    ...r
  } = e;
  return /* @__PURE__ */ f.jsxs(
    "button",
    {
      type: "button",
      ref: t,
      className: "hidden l:flex h-10 items-center justify-between w-[240px] rounded-md bg-secondary-800 hover:bg-primary-600 text-white px-4",
      ...r,
      children: [
        /* @__PURE__ */ f.jsx("p", { className: "font-semibold", children: "Plataforma tradicional" }),
        /* @__PURE__ */ f.jsx("span", { className: "rotate-180", children: /* @__PURE__ */ f.jsx(Me, { variant: "back-arrow" }) })
      ]
    }
  );
});
MI.displayName = "HeaderOldButton";
const EI = B.forwardRef((e, t) => {
  const {
    ...r
  } = e, n = E7();
  return /* @__PURE__ */ f.jsx("form", { ref: t, ...r, className: "hidden w-full max-w-[416px] l:block", children: /* @__PURE__ */ f.jsxs("div", { className: "h-10 bg-Neutros-50 rounded-md relative", children: [
    /* @__PURE__ */ f.jsx(
      "input",
      {
        id: n,
        type: "text",
        className: "h-full pl-4 pr-12 w-full outline-none rounded-md border ",
        style: { textTransform: "none" }
      }
    ),
    /* @__PURE__ */ f.jsx("label", { htmlFor: n, className: "absolute top-1/2 right-4 cursor-pointer -translate-y-1/2", children: /* @__PURE__ */ f.jsx(Me, { variant: "search", className: "bg-secondary-800" }) })
  ] }) });
});
EI.displayName = "HeaderSearch";
const PI = B.forwardRef((e, t) => {
  const {
    image: r,
    name: n,
    cargo: a,
    email: i,
    isInsideMenu: o = !1,
    children: s,
    ...c
  } = e, u = xt(Ur), d = (u == null ? void 0 : u.isOpenMenuUser) ?? !1, h = ge(null), A = ge(null), p = (m) => {
    if (!o && !(window.innerWidth < 1280) && h.current !== null && !h.current.contains(m.target)) {
      if (A.current !== null) {
        if (A.current.contains(m.target))
          return;
        u == null || u.closeMenuUser();
        return;
      }
      u == null || u.closeMenuUser();
    }
  };
  return Ie(() => (document.addEventListener("click", p, !0), () => {
    document.removeEventListener("click", p, !0);
  }), []), /* @__PURE__ */ f.jsxs("div", { ref: t, className: `w-full relative ${o ? "block l:hidden max-w-none px-4" : "hidden l:block w-[350px]"}`, ...c, children: [
    /* @__PURE__ */ f.jsxs(
      "div",
      {
        ref: h,
        className: "h-10 w-full cursor-pointer flex gap-2 items-center rounded-md text-white px-2 select-none",
        onClick: u == null ? void 0 : u.toggleOpenMenuUser,
        children: [
          /* @__PURE__ */ f.jsx(Qa, { size: "sm", image: r }),
          /* @__PURE__ */ f.jsx("span", { className: `flex-shrink ${d ? "-rotate-180" : ""}`, children: /* @__PURE__ */ f.jsx(Me, { variant: "arrow-down", width: 14 }) })
        ]
      }
    ),
    /* @__PURE__ */ f.jsx("div", { className: `fixed 2s:absolute w-[calc(100%-1.8rem)] max-w-[450px] 2s:w-[290px] z-[1] bottom-[5.5rem] 2s:bottom-auto 2s:top-[calc(100%+9px)]
       2s:left-1/2 right-[0.9rem] 2s:right-auto 2s:-translate-x-full bg-white shadow-l rounded-md overflow-hidden  ${d ? "block" : "hidden"}`, children: /* @__PURE__ */ f.jsxs("ul", { className: "bg-secondary-800 text-center l:bg-white px-10 py-3 rounded-md l:shadow-l", children: [
      /* @__PURE__ */ f.jsx(Qa, { size: "md", image: r }),
      /* @__PURE__ */ f.jsxs("p", { className: "text-s font-bold leading-none text-ellipsis whitespace-nowrap overflow-hidden w-full", children: [
        " ¡Hola, ",
        n,
        "!"
      ] }),
      /* @__PURE__ */ f.jsx("p", { className: "text-xs leading-none text-ellipsis whitespace-nowrap overflow-hidden w-full", children: a }),
      s,
      /* @__PURE__ */ f.jsx("p", { className: "text-s leading-none text-ellipsis whitespace-nowrap overflow-hidden w-full m-3", children: i })
    ] }) })
  ] });
});
PI.displayName = "HeaderUser";
const jI = B.forwardRef((e, t) => {
  const {
    icon: r,
    children: n,
    onClick: a,
    ...i
  } = e, o = xt(Ur), s = (c) => {
    o == null || o.closeMenu(), o == null || o.closeMenuUser(), a !== void 0 && a(c);
  };
  return /* @__PURE__ */ f.jsxs(
    "li",
    {
      ref: t,
      onClick: s,
      className: "flex justify-between gap-2 items-center my-3 bg-Neutros-50 text-black  l:text-black p-2 cursor-pointer rounded-md hover:bg-secondary-600 l:hover:bg-secondary-200",
      ...i,
      children: [
        /* @__PURE__ */ f.jsx("span", { className: "w-[20px] min-w-[20px]", children: /* @__PURE__ */ f.jsx(Me, { variant: r, width: 20 }) }),
        /* @__PURE__ */ f.jsx("span", { className: "flex-grow font-bold", children: n })
      ]
    }
  );
});
jI.displayName = "HeaderUserItem";
const SI = B.forwardRef((e, t) => {
  const {
    children: r,
    ...n
  } = e;
  return /* @__PURE__ */ f.jsx("header", { ref: t, ...n, className: "w-full bg-Marca-800 px-6 flex items-center justify-between gap-4 fixed bottom-0 2s:top-0 h-[4.5rem] l:h-[5rem] z-[1600]", children: r });
});
SI.displayName = "HeaderWrapper";
const II = "data:image/png;base64,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", pC = ({ width: e = 210 }) => /* @__PURE__ */ f.jsx(
  "img",
  {
    src: II,
    alt: "Castor Logo",
    style: { width: `${e}px` }
  }
), BI = "data:image/png;base64,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", NI = ({ width: e = 160 }) => /* @__PURE__ */ f.jsx(
  "img",
  {
    src: BI,
    alt: "Map Logo",
    style: { width: `${e}px` }
  }
);
function L4(e, t) {
  return L4 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, n) {
    return r.__proto__ = n, r;
  }, L4(e, t);
}
function vC(e, t) {
  e.prototype = Object.create(t.prototype), e.prototype.constructor = e, L4(e, t);
}
function we() {
  return we = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        ({}).hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, we.apply(null, arguments);
}
function Xi(e) {
  "@babel/helpers - typeof";
  return Xi = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Xi(e);
}
function _I(e, t) {
  if (Xi(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (Xi(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function LI(e) {
  var t = _I(e, "string");
  return Xi(t) == "symbol" ? t : t + "";
}
function TI(e, t, r) {
  return (t = LI(t)) in e ? Object.defineProperty(e, t, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = r, e;
}
function id(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function od(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? id(Object(r), !0).forEach(function(n) {
      TI(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : id(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function ar(e) {
  return "Minified Redux error #" + e + "; visit https://redux.js.org/Errors?code=" + e + " for the full message or use the non-minified dev environment for full errors. ";
}
var sd = function() {
  return typeof Symbol == "function" && Symbol.observable || "@@observable";
}(), g6 = function() {
  return Math.random().toString(36).substring(7).split("").join(".");
}, ld = {
  INIT: "@@redux/INIT" + g6(),
  REPLACE: "@@redux/REPLACE" + g6(),
  PROBE_UNKNOWN_ACTION: function() {
    return "@@redux/PROBE_UNKNOWN_ACTION" + g6();
  }
};
function RI(e) {
  if (typeof e != "object" || e === null)
    return !1;
  for (var t = e; Object.getPrototypeOf(t) !== null; )
    t = Object.getPrototypeOf(t);
  return Object.getPrototypeOf(e) === t;
}
function $I(e) {
  if (e === void 0)
    return "undefined";
  if (e === null)
    return "null";
  var t = typeof e;
  switch (t) {
    case "boolean":
    case "string":
    case "number":
    case "symbol":
    case "function":
      return t;
  }
  if (Array.isArray(e))
    return "array";
  if (YI(e))
    return "date";
  if (HI(e))
    return "error";
  var r = FI(e);
  switch (r) {
    case "Symbol":
    case "Promise":
    case "WeakMap":
    case "WeakSet":
    case "Map":
    case "Set":
      return r;
  }
  return t.slice(8, -1).toLowerCase().replace(/\s/g, "");
}
function FI(e) {
  return typeof e.constructor == "function" ? e.constructor.name : null;
}
function HI(e) {
  return e instanceof Error || typeof e.message == "string" && e.constructor && typeof e.constructor.stackTraceLimit == "number";
}
function YI(e) {
  return e instanceof Date ? !0 : typeof e.toDateString == "function" && typeof e.getDate == "function" && typeof e.setDate == "function";
}
function T1(e) {
  var t = typeof e;
  return process.env.NODE_ENV !== "production" && (t = $I(e)), t;
}
function gC(e, t, r) {
  var n;
  if (typeof t == "function" && typeof r == "function" || typeof r == "function" && typeof arguments[3] == "function")
    throw new Error(process.env.NODE_ENV === "production" ? ar(0) : "It looks like you are passing several store enhancers to createStore(). This is not supported. Instead, compose them together to a single function. See https://redux.js.org/tutorials/fundamentals/part-4-store#creating-a-store-with-enhancers for an example.");
  if (typeof t == "function" && typeof r > "u" && (r = t, t = void 0), typeof r < "u") {
    if (typeof r != "function")
      throw new Error(process.env.NODE_ENV === "production" ? ar(1) : "Expected the enhancer to be a function. Instead, received: '" + T1(r) + "'");
    return r(gC)(e, t);
  }
  if (typeof e != "function")
    throw new Error(process.env.NODE_ENV === "production" ? ar(2) : "Expected the root reducer to be a function. Instead, received: '" + T1(e) + "'");
  var a = e, i = t, o = [], s = o, c = !1;
  function u() {
    s === o && (s = o.slice());
  }
  function d() {
    if (c)
      throw new Error(process.env.NODE_ENV === "production" ? ar(3) : "You may not call store.getState() while the reducer is executing. The reducer has already received the state as an argument. Pass it down from the top reducer instead of reading it from the store.");
    return i;
  }
  function h(g) {
    if (typeof g != "function")
      throw new Error(process.env.NODE_ENV === "production" ? ar(4) : "Expected the listener to be a function. Instead, received: '" + T1(g) + "'");
    if (c)
      throw new Error(process.env.NODE_ENV === "production" ? ar(5) : "You may not call store.subscribe() while the reducer is executing. If you would like to be notified after the store has been updated, subscribe from a component and invoke store.getState() in the callback to access the latest state. See https://redux.js.org/api/store#subscribelistener for more details.");
    var v = !0;
    return u(), s.push(g), function() {
      if (v) {
        if (c)
          throw new Error(process.env.NODE_ENV === "production" ? ar(6) : "You may not unsubscribe from a store listener while the reducer is executing. See https://redux.js.org/api/store#subscribelistener for more details.");
        v = !1, u();
        var y = s.indexOf(g);
        s.splice(y, 1), o = null;
      }
    };
  }
  function A(g) {
    if (!RI(g))
      throw new Error(process.env.NODE_ENV === "production" ? ar(7) : "Actions must be plain objects. Instead, the actual type was: '" + T1(g) + "'. You may need to add middleware to your store setup to handle dispatching other values, such as 'redux-thunk' to handle dispatching functions. See https://redux.js.org/tutorials/fundamentals/part-4-store#middleware and https://redux.js.org/tutorials/fundamentals/part-6-async-logic#using-the-redux-thunk-middleware for examples.");
    if (typeof g.type > "u")
      throw new Error(process.env.NODE_ENV === "production" ? ar(8) : 'Actions may not have an undefined "type" property. You may have misspelled an action type string constant.');
    if (c)
      throw new Error(process.env.NODE_ENV === "production" ? ar(9) : "Reducers may not dispatch actions.");
    try {
      c = !0, i = a(i, g);
    } finally {
      c = !1;
    }
    for (var v = o = s, C = 0; C < v.length; C++) {
      var y = v[C];
      y();
    }
    return g;
  }
  function p(g) {
    if (typeof g != "function")
      throw new Error(process.env.NODE_ENV === "production" ? ar(10) : "Expected the nextReducer to be a function. Instead, received: '" + T1(g));
    a = g, A({
      type: ld.REPLACE
    });
  }
  function m() {
    var g, v = h;
    return g = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function(y) {
        if (typeof y != "object" || y === null)
          throw new Error(process.env.NODE_ENV === "production" ? ar(11) : "Expected the observer to be an object. Instead, received: '" + T1(y) + "'");
        function w() {
          y.next && y.next(d());
        }
        w();
        var O = v(w);
        return {
          unsubscribe: O
        };
      }
    }, g[sd] = function() {
      return this;
    }, g;
  }
  return A({
    type: ld.INIT
  }), n = {
    dispatch: A,
    subscribe: h,
    getState: d,
    replaceReducer: p
  }, n[sd] = m, n;
}
function cd(e, t) {
  return function() {
    return t(e.apply(this, arguments));
  };
}
function ud(e, t) {
  if (typeof e == "function")
    return cd(e, t);
  if (typeof e != "object" || e === null)
    throw new Error(process.env.NODE_ENV === "production" ? ar(16) : "bindActionCreators expected an object or a function, but instead received: '" + T1(e) + `'. Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?`);
  var r = {};
  for (var n in e) {
    var a = e[n];
    typeof a == "function" && (r[n] = cd(a, t));
  }
  return r;
}
function mC() {
  for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++)
    t[r] = arguments[r];
  return t.length === 0 ? function(n) {
    return n;
  } : t.length === 1 ? t[0] : t.reduce(function(n, a) {
    return function() {
      return n(a.apply(void 0, arguments));
    };
  });
}
function VI() {
  for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++)
    t[r] = arguments[r];
  return function(n) {
    return function() {
      var a = n.apply(void 0, arguments), i = function() {
        throw new Error(process.env.NODE_ENV === "production" ? ar(15) : "Dispatching while constructing your middleware is not allowed. Other middleware would not be applied to this dispatch.");
      }, o = {
        getState: a.getState,
        dispatch: function() {
          return i.apply(void 0, arguments);
        }
      }, s = t.map(function(c) {
        return c(o);
      });
      return i = mC.apply(void 0, s)(a.dispatch), od(od({}, a), {}, {
        dispatch: i
      });
    };
  };
}
var T4 = { exports: {} }, m3 = { exports: {} }, We = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var fd;
function kI() {
  if (fd)
    return We;
  fd = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, r = e ? Symbol.for("react.portal") : 60106, n = e ? Symbol.for("react.fragment") : 60107, a = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, o = e ? Symbol.for("react.provider") : 60109, s = e ? Symbol.for("react.context") : 60110, c = e ? Symbol.for("react.async_mode") : 60111, u = e ? Symbol.for("react.concurrent_mode") : 60111, d = e ? Symbol.for("react.forward_ref") : 60112, h = e ? Symbol.for("react.suspense") : 60113, A = e ? Symbol.for("react.suspense_list") : 60120, p = e ? Symbol.for("react.memo") : 60115, m = e ? Symbol.for("react.lazy") : 60116, g = e ? Symbol.for("react.block") : 60121, v = e ? Symbol.for("react.fundamental") : 60117, C = e ? Symbol.for("react.responder") : 60118, y = e ? Symbol.for("react.scope") : 60119;
  function w(b) {
    if (typeof b == "object" && b !== null) {
      var D = b.$$typeof;
      switch (D) {
        case t:
          switch (b = b.type, b) {
            case c:
            case u:
            case n:
            case i:
            case a:
            case h:
              return b;
            default:
              switch (b = b && b.$$typeof, b) {
                case s:
                case d:
                case m:
                case p:
                case o:
                  return b;
                default:
                  return D;
              }
          }
        case r:
          return D;
      }
    }
  }
  function O(b) {
    return w(b) === u;
  }
  return We.AsyncMode = c, We.ConcurrentMode = u, We.ContextConsumer = s, We.ContextProvider = o, We.Element = t, We.ForwardRef = d, We.Fragment = n, We.Lazy = m, We.Memo = p, We.Portal = r, We.Profiler = i, We.StrictMode = a, We.Suspense = h, We.isAsyncMode = function(b) {
    return O(b) || w(b) === c;
  }, We.isConcurrentMode = O, We.isContextConsumer = function(b) {
    return w(b) === s;
  }, We.isContextProvider = function(b) {
    return w(b) === o;
  }, We.isElement = function(b) {
    return typeof b == "object" && b !== null && b.$$typeof === t;
  }, We.isForwardRef = function(b) {
    return w(b) === d;
  }, We.isFragment = function(b) {
    return w(b) === n;
  }, We.isLazy = function(b) {
    return w(b) === m;
  }, We.isMemo = function(b) {
    return w(b) === p;
  }, We.isPortal = function(b) {
    return w(b) === r;
  }, We.isProfiler = function(b) {
    return w(b) === i;
  }, We.isStrictMode = function(b) {
    return w(b) === a;
  }, We.isSuspense = function(b) {
    return w(b) === h;
  }, We.isValidElementType = function(b) {
    return typeof b == "string" || typeof b == "function" || b === n || b === u || b === i || b === a || b === h || b === A || typeof b == "object" && b !== null && (b.$$typeof === m || b.$$typeof === p || b.$$typeof === o || b.$$typeof === s || b.$$typeof === d || b.$$typeof === v || b.$$typeof === C || b.$$typeof === y || b.$$typeof === g);
  }, We.typeOf = w, We;
}
var Qe = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var dd;
function GI() {
  return dd || (dd = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, r = e ? Symbol.for("react.portal") : 60106, n = e ? Symbol.for("react.fragment") : 60107, a = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, o = e ? Symbol.for("react.provider") : 60109, s = e ? Symbol.for("react.context") : 60110, c = e ? Symbol.for("react.async_mode") : 60111, u = e ? Symbol.for("react.concurrent_mode") : 60111, d = e ? Symbol.for("react.forward_ref") : 60112, h = e ? Symbol.for("react.suspense") : 60113, A = e ? Symbol.for("react.suspense_list") : 60120, p = e ? Symbol.for("react.memo") : 60115, m = e ? Symbol.for("react.lazy") : 60116, g = e ? Symbol.for("react.block") : 60121, v = e ? Symbol.for("react.fundamental") : 60117, C = e ? Symbol.for("react.responder") : 60118, y = e ? Symbol.for("react.scope") : 60119;
    function w(L) {
      return typeof L == "string" || typeof L == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      L === n || L === u || L === i || L === a || L === h || L === A || typeof L == "object" && L !== null && (L.$$typeof === m || L.$$typeof === p || L.$$typeof === o || L.$$typeof === s || L.$$typeof === d || L.$$typeof === v || L.$$typeof === C || L.$$typeof === y || L.$$typeof === g);
    }
    function O(L) {
      if (typeof L == "object" && L !== null) {
        var ee = L.$$typeof;
        switch (ee) {
          case t:
            var V = L.type;
            switch (V) {
              case c:
              case u:
              case n:
              case i:
              case a:
              case h:
                return V;
              default:
                var ne = V && V.$$typeof;
                switch (ne) {
                  case s:
                  case d:
                  case m:
                  case p:
                  case o:
                    return ne;
                  default:
                    return ee;
                }
            }
          case r:
            return ee;
        }
      }
    }
    var b = c, D = u, M = s, j = o, P = t, H = d, F = n, R = m, N = p, z = r, q = i, J = a, W = h, te = !1;
    function S(L) {
      return te || (te = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), I(L) || O(L) === c;
    }
    function I(L) {
      return O(L) === u;
    }
    function T(L) {
      return O(L) === s;
    }
    function E(L) {
      return O(L) === o;
    }
    function x(L) {
      return typeof L == "object" && L !== null && L.$$typeof === t;
    }
    function $(L) {
      return O(L) === d;
    }
    function _(L) {
      return O(L) === n;
    }
    function Q(L) {
      return O(L) === m;
    }
    function Z(L) {
      return O(L) === p;
    }
    function X(L) {
      return O(L) === r;
    }
    function Y(L) {
      return O(L) === i;
    }
    function U(L) {
      return O(L) === a;
    }
    function k(L) {
      return O(L) === h;
    }
    Qe.AsyncMode = b, Qe.ConcurrentMode = D, Qe.ContextConsumer = M, Qe.ContextProvider = j, Qe.Element = P, Qe.ForwardRef = H, Qe.Fragment = F, Qe.Lazy = R, Qe.Memo = N, Qe.Portal = z, Qe.Profiler = q, Qe.StrictMode = J, Qe.Suspense = W, Qe.isAsyncMode = S, Qe.isConcurrentMode = I, Qe.isContextConsumer = T, Qe.isContextProvider = E, Qe.isElement = x, Qe.isForwardRef = $, Qe.isFragment = _, Qe.isLazy = Q, Qe.isMemo = Z, Qe.isPortal = X, Qe.isProfiler = Y, Qe.isStrictMode = U, Qe.isSuspense = k, Qe.isValidElementType = w, Qe.typeOf = O;
  }()), Qe;
}
var hd;
function CC() {
  return hd || (hd = 1, process.env.NODE_ENV === "production" ? m3.exports = kI() : m3.exports = GI()), m3.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var m6, Ad;
function WI() {
  if (Ad)
    return m6;
  Ad = 1;
  var e = Object.getOwnPropertySymbols, t = Object.prototype.hasOwnProperty, r = Object.prototype.propertyIsEnumerable;
  function n(i) {
    if (i == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(i);
  }
  function a() {
    try {
      if (!Object.assign)
        return !1;
      var i = new String("abc");
      if (i[5] = "de", Object.getOwnPropertyNames(i)[0] === "5")
        return !1;
      for (var o = {}, s = 0; s < 10; s++)
        o["_" + String.fromCharCode(s)] = s;
      var c = Object.getOwnPropertyNames(o).map(function(d) {
        return o[d];
      });
      if (c.join("") !== "0123456789")
        return !1;
      var u = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(d) {
        u[d] = d;
      }), Object.keys(Object.assign({}, u)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return m6 = a() ? Object.assign : function(i, o) {
    for (var s, c = n(i), u, d = 1; d < arguments.length; d++) {
      s = Object(arguments[d]);
      for (var h in s)
        t.call(s, h) && (c[h] = s[h]);
      if (e) {
        u = e(s);
        for (var A = 0; A < u.length; A++)
          r.call(s, u[A]) && (c[u[A]] = s[u[A]]);
      }
    }
    return c;
  }, m6;
}
var C6, pd;
function j7() {
  if (pd)
    return C6;
  pd = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return C6 = e, C6;
}
var b6, vd;
function bC() {
  return vd || (vd = 1, b6 = Function.call.bind(Object.prototype.hasOwnProperty)), b6;
}
var y6, gd;
function QI() {
  if (gd)
    return y6;
  gd = 1;
  var e = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var t = j7(), r = {}, n = bC();
    e = function(i) {
      var o = "Warning: " + i;
      typeof console < "u" && console.error(o);
      try {
        throw new Error(o);
      } catch {
      }
    };
  }
  function a(i, o, s, c, u) {
    if (process.env.NODE_ENV !== "production") {
      for (var d in i)
        if (n(i, d)) {
          var h;
          try {
            if (typeof i[d] != "function") {
              var A = Error(
                (c || "React class") + ": " + s + " type `" + d + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof i[d] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw A.name = "Invariant Violation", A;
            }
            h = i[d](o, d, c, s, null, t);
          } catch (m) {
            h = m;
          }
          if (h && !(h instanceof Error) && e(
            (c || "React class") + ": type specification of " + s + " `" + d + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof h + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), h instanceof Error && !(h.message in r)) {
            r[h.message] = !0;
            var p = u ? u() : "";
            e(
              "Failed " + s + " type: " + h.message + (p ?? "")
            );
          }
        }
    }
  }
  return a.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (r = {});
  }, y6 = a, y6;
}
var w6, md;
function UI() {
  if (md)
    return w6;
  md = 1;
  var e = CC(), t = WI(), r = j7(), n = bC(), a = QI(), i = function() {
  };
  process.env.NODE_ENV !== "production" && (i = function(s) {
    var c = "Warning: " + s;
    typeof console < "u" && console.error(c);
    try {
      throw new Error(c);
    } catch {
    }
  });
  function o() {
    return null;
  }
  return w6 = function(s, c) {
    var u = typeof Symbol == "function" && Symbol.iterator, d = "@@iterator";
    function h(I) {
      var T = I && (u && I[u] || I[d]);
      if (typeof T == "function")
        return T;
    }
    var A = "<<anonymous>>", p = {
      array: C("array"),
      bigint: C("bigint"),
      bool: C("boolean"),
      func: C("function"),
      number: C("number"),
      object: C("object"),
      string: C("string"),
      symbol: C("symbol"),
      any: y(),
      arrayOf: w,
      element: O(),
      elementType: b(),
      instanceOf: D,
      node: H(),
      objectOf: j,
      oneOf: M,
      oneOfType: P,
      shape: R,
      exact: N
    };
    function m(I, T) {
      return I === T ? I !== 0 || 1 / I === 1 / T : I !== I && T !== T;
    }
    function g(I, T) {
      this.message = I, this.data = T && typeof T == "object" ? T : {}, this.stack = "";
    }
    g.prototype = Error.prototype;
    function v(I) {
      if (process.env.NODE_ENV !== "production")
        var T = {}, E = 0;
      function x(_, Q, Z, X, Y, U, k) {
        if (X = X || A, U = U || Z, k !== r) {
          if (c) {
            var L = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw L.name = "Invariant Violation", L;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var ee = X + ":" + Z;
            !T[ee] && // Avoid spamming the console because they are often not actionable except for lib authors
            E < 3 && (i(
              "You are manually calling a React.PropTypes validation function for the `" + U + "` prop on `" + X + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), T[ee] = !0, E++);
          }
        }
        return Q[Z] == null ? _ ? Q[Z] === null ? new g("The " + Y + " `" + U + "` is marked as required " + ("in `" + X + "`, but its value is `null`.")) : new g("The " + Y + " `" + U + "` is marked as required in " + ("`" + X + "`, but its value is `undefined`.")) : null : I(Q, Z, X, Y, U);
      }
      var $ = x.bind(null, !1);
      return $.isRequired = x.bind(null, !0), $;
    }
    function C(I) {
      function T(E, x, $, _, Q, Z) {
        var X = E[x], Y = J(X);
        if (Y !== I) {
          var U = W(X);
          return new g(
            "Invalid " + _ + " `" + Q + "` of type " + ("`" + U + "` supplied to `" + $ + "`, expected ") + ("`" + I + "`."),
            { expectedType: I }
          );
        }
        return null;
      }
      return v(T);
    }
    function y() {
      return v(o);
    }
    function w(I) {
      function T(E, x, $, _, Q) {
        if (typeof I != "function")
          return new g("Property `" + Q + "` of component `" + $ + "` has invalid PropType notation inside arrayOf.");
        var Z = E[x];
        if (!Array.isArray(Z)) {
          var X = J(Z);
          return new g("Invalid " + _ + " `" + Q + "` of type " + ("`" + X + "` supplied to `" + $ + "`, expected an array."));
        }
        for (var Y = 0; Y < Z.length; Y++) {
          var U = I(Z, Y, $, _, Q + "[" + Y + "]", r);
          if (U instanceof Error)
            return U;
        }
        return null;
      }
      return v(T);
    }
    function O() {
      function I(T, E, x, $, _) {
        var Q = T[E];
        if (!s(Q)) {
          var Z = J(Q);
          return new g("Invalid " + $ + " `" + _ + "` of type " + ("`" + Z + "` supplied to `" + x + "`, expected a single ReactElement."));
        }
        return null;
      }
      return v(I);
    }
    function b() {
      function I(T, E, x, $, _) {
        var Q = T[E];
        if (!e.isValidElementType(Q)) {
          var Z = J(Q);
          return new g("Invalid " + $ + " `" + _ + "` of type " + ("`" + Z + "` supplied to `" + x + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return v(I);
    }
    function D(I) {
      function T(E, x, $, _, Q) {
        if (!(E[x] instanceof I)) {
          var Z = I.name || A, X = S(E[x]);
          return new g("Invalid " + _ + " `" + Q + "` of type " + ("`" + X + "` supplied to `" + $ + "`, expected ") + ("instance of `" + Z + "`."));
        }
        return null;
      }
      return v(T);
    }
    function M(I) {
      if (!Array.isArray(I))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? i(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : i("Invalid argument supplied to oneOf, expected an array.")), o;
      function T(E, x, $, _, Q) {
        for (var Z = E[x], X = 0; X < I.length; X++)
          if (m(Z, I[X]))
            return null;
        var Y = JSON.stringify(I, function(k, L) {
          var ee = W(L);
          return ee === "symbol" ? String(L) : L;
        });
        return new g("Invalid " + _ + " `" + Q + "` of value `" + String(Z) + "` " + ("supplied to `" + $ + "`, expected one of " + Y + "."));
      }
      return v(T);
    }
    function j(I) {
      function T(E, x, $, _, Q) {
        if (typeof I != "function")
          return new g("Property `" + Q + "` of component `" + $ + "` has invalid PropType notation inside objectOf.");
        var Z = E[x], X = J(Z);
        if (X !== "object")
          return new g("Invalid " + _ + " `" + Q + "` of type " + ("`" + X + "` supplied to `" + $ + "`, expected an object."));
        for (var Y in Z)
          if (n(Z, Y)) {
            var U = I(Z, Y, $, _, Q + "." + Y, r);
            if (U instanceof Error)
              return U;
          }
        return null;
      }
      return v(T);
    }
    function P(I) {
      if (!Array.isArray(I))
        return process.env.NODE_ENV !== "production" && i("Invalid argument supplied to oneOfType, expected an instance of array."), o;
      for (var T = 0; T < I.length; T++) {
        var E = I[T];
        if (typeof E != "function")
          return i(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + te(E) + " at index " + T + "."
          ), o;
      }
      function x($, _, Q, Z, X) {
        for (var Y = [], U = 0; U < I.length; U++) {
          var k = I[U], L = k($, _, Q, Z, X, r);
          if (L == null)
            return null;
          L.data && n(L.data, "expectedType") && Y.push(L.data.expectedType);
        }
        var ee = Y.length > 0 ? ", expected one of type [" + Y.join(", ") + "]" : "";
        return new g("Invalid " + Z + " `" + X + "` supplied to " + ("`" + Q + "`" + ee + "."));
      }
      return v(x);
    }
    function H() {
      function I(T, E, x, $, _) {
        return z(T[E]) ? null : new g("Invalid " + $ + " `" + _ + "` supplied to " + ("`" + x + "`, expected a ReactNode."));
      }
      return v(I);
    }
    function F(I, T, E, x, $) {
      return new g(
        (I || "React class") + ": " + T + " type `" + E + "." + x + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + $ + "`."
      );
    }
    function R(I) {
      function T(E, x, $, _, Q) {
        var Z = E[x], X = J(Z);
        if (X !== "object")
          return new g("Invalid " + _ + " `" + Q + "` of type `" + X + "` " + ("supplied to `" + $ + "`, expected `object`."));
        for (var Y in I) {
          var U = I[Y];
          if (typeof U != "function")
            return F($, _, Q, Y, W(U));
          var k = U(Z, Y, $, _, Q + "." + Y, r);
          if (k)
            return k;
        }
        return null;
      }
      return v(T);
    }
    function N(I) {
      function T(E, x, $, _, Q) {
        var Z = E[x], X = J(Z);
        if (X !== "object")
          return new g("Invalid " + _ + " `" + Q + "` of type `" + X + "` " + ("supplied to `" + $ + "`, expected `object`."));
        var Y = t({}, E[x], I);
        for (var U in Y) {
          var k = I[U];
          if (n(I, U) && typeof k != "function")
            return F($, _, Q, U, W(k));
          if (!k)
            return new g(
              "Invalid " + _ + " `" + Q + "` key `" + U + "` supplied to `" + $ + "`.\nBad object: " + JSON.stringify(E[x], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(I), null, "  ")
            );
          var L = k(Z, U, $, _, Q + "." + U, r);
          if (L)
            return L;
        }
        return null;
      }
      return v(T);
    }
    function z(I) {
      switch (typeof I) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !I;
        case "object":
          if (Array.isArray(I))
            return I.every(z);
          if (I === null || s(I))
            return !0;
          var T = h(I);
          if (T) {
            var E = T.call(I), x;
            if (T !== I.entries) {
              for (; !(x = E.next()).done; )
                if (!z(x.value))
                  return !1;
            } else
              for (; !(x = E.next()).done; ) {
                var $ = x.value;
                if ($ && !z($[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function q(I, T) {
      return I === "symbol" ? !0 : T ? T["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && T instanceof Symbol : !1;
    }
    function J(I) {
      var T = typeof I;
      return Array.isArray(I) ? "array" : I instanceof RegExp ? "object" : q(T, I) ? "symbol" : T;
    }
    function W(I) {
      if (typeof I > "u" || I === null)
        return "" + I;
      var T = J(I);
      if (T === "object") {
        if (I instanceof Date)
          return "date";
        if (I instanceof RegExp)
          return "regexp";
      }
      return T;
    }
    function te(I) {
      var T = W(I);
      switch (T) {
        case "array":
        case "object":
          return "an " + T;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + T;
        default:
          return T;
      }
    }
    function S(I) {
      return !I.constructor || !I.constructor.name ? A : I.constructor.name;
    }
    return p.checkPropTypes = a, p.resetWarningCache = a.resetWarningCache, p.PropTypes = p, p;
  }, w6;
}
var x6, Cd;
function ZI() {
  if (Cd)
    return x6;
  Cd = 1;
  var e = j7();
  function t() {
  }
  function r() {
  }
  return r.resetWarningCache = t, x6 = function() {
    function n(o, s, c, u, d, h) {
      if (h !== e) {
        var A = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw A.name = "Invariant Violation", A;
      }
    }
    n.isRequired = n;
    function a() {
      return n;
    }
    var i = {
      array: n,
      bigint: n,
      bool: n,
      func: n,
      number: n,
      object: n,
      string: n,
      symbol: n,
      any: n,
      arrayOf: a,
      element: n,
      elementType: n,
      instanceOf: a,
      node: n,
      objectOf: a,
      oneOf: a,
      oneOfType: a,
      shape: a,
      exact: a,
      checkPropTypes: r,
      resetWarningCache: t
    };
    return i.PropTypes = i, i;
  }, x6;
}
if (process.env.NODE_ENV !== "production") {
  var zI = CC(), KI = !0;
  T4.exports = UI()(zI.isElement, KI);
} else
  T4.exports = ZI()();
var un = T4.exports;
const Te = /* @__PURE__ */ qe(un);
var S7 = /* @__PURE__ */ B.createContext(null);
process.env.NODE_ENV !== "production" && (S7.displayName = "ReactRedux");
function qI(e) {
  e();
}
var yC = qI, XI = function(t) {
  return yC = t;
}, JI = function() {
  return yC;
};
function eB() {
  var e = JI(), t = null, r = null;
  return {
    clear: function() {
      t = null, r = null;
    },
    notify: function() {
      e(function() {
        for (var a = t; a; )
          a.callback(), a = a.next;
      });
    },
    get: function() {
      for (var a = [], i = t; i; )
        a.push(i), i = i.next;
      return a;
    },
    subscribe: function(a) {
      var i = !0, o = r = {
        callback: a,
        next: null,
        prev: r
      };
      return o.prev ? o.prev.next = o : t = o, function() {
        !i || t === null || (i = !1, o.next ? o.next.prev = o.prev : r = o.prev, o.prev ? o.prev.next = o.next : t = o.next);
      };
    }
  };
}
var bd = {
  notify: function() {
  },
  get: function() {
    return [];
  }
};
function wC(e, t) {
  var r, n = bd;
  function a(h) {
    return c(), n.subscribe(h);
  }
  function i() {
    n.notify();
  }
  function o() {
    d.onStateChange && d.onStateChange();
  }
  function s() {
    return !!r;
  }
  function c() {
    r || (r = t ? t.addNestedSub(o) : e.subscribe(o), n = eB());
  }
  function u() {
    r && (r(), r = void 0, n.clear(), n = bd);
  }
  var d = {
    addNestedSub: a,
    notifyNestedSubs: i,
    handleChangeWrapper: o,
    isSubscribed: s,
    trySubscribe: c,
    tryUnsubscribe: u,
    getListeners: function() {
      return n;
    }
  };
  return d;
}
var xC = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u" ? sC : Ie;
function OC(e) {
  var t = e.store, r = e.context, n = e.children, a = dr(function() {
    var s = wC(t);
    return {
      store: t,
      subscription: s
    };
  }, [t]), i = dr(function() {
    return t.getState();
  }, [t]);
  xC(function() {
    var s = a.subscription;
    return s.onStateChange = s.notifyNestedSubs, s.trySubscribe(), i !== t.getState() && s.notifyNestedSubs(), function() {
      s.tryUnsubscribe(), s.onStateChange = null;
    };
  }, [a, i]);
  var o = r || S7;
  return /* @__PURE__ */ B.createElement(o.Provider, {
    value: a
  }, n);
}
process.env.NODE_ENV !== "production" && (OC.propTypes = {
  store: Te.shape({
    subscribe: Te.func.isRequired,
    dispatch: Te.func.isRequired,
    getState: Te.func.isRequired
  }),
  context: Te.object,
  children: Te.any
});
function X3(e, t) {
  if (e == null)
    return {};
  var r = {};
  for (var n in e)
    if ({}.hasOwnProperty.call(e, n)) {
      if (t.indexOf(n) !== -1)
        continue;
      r[n] = e[n];
    }
  return r;
}
var R4 = { exports: {} }, Ue = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var yd;
function tB() {
  if (yd)
    return Ue;
  yd = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, r = e ? Symbol.for("react.portal") : 60106, n = e ? Symbol.for("react.fragment") : 60107, a = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, o = e ? Symbol.for("react.provider") : 60109, s = e ? Symbol.for("react.context") : 60110, c = e ? Symbol.for("react.async_mode") : 60111, u = e ? Symbol.for("react.concurrent_mode") : 60111, d = e ? Symbol.for("react.forward_ref") : 60112, h = e ? Symbol.for("react.suspense") : 60113, A = e ? Symbol.for("react.suspense_list") : 60120, p = e ? Symbol.for("react.memo") : 60115, m = e ? Symbol.for("react.lazy") : 60116, g = e ? Symbol.for("react.block") : 60121, v = e ? Symbol.for("react.fundamental") : 60117, C = e ? Symbol.for("react.responder") : 60118, y = e ? Symbol.for("react.scope") : 60119;
  function w(b) {
    if (typeof b == "object" && b !== null) {
      var D = b.$$typeof;
      switch (D) {
        case t:
          switch (b = b.type, b) {
            case c:
            case u:
            case n:
            case i:
            case a:
            case h:
              return b;
            default:
              switch (b = b && b.$$typeof, b) {
                case s:
                case d:
                case m:
                case p:
                case o:
                  return b;
                default:
                  return D;
              }
          }
        case r:
          return D;
      }
    }
  }
  function O(b) {
    return w(b) === u;
  }
  return Ue.AsyncMode = c, Ue.ConcurrentMode = u, Ue.ContextConsumer = s, Ue.ContextProvider = o, Ue.Element = t, Ue.ForwardRef = d, Ue.Fragment = n, Ue.Lazy = m, Ue.Memo = p, Ue.Portal = r, Ue.Profiler = i, Ue.StrictMode = a, Ue.Suspense = h, Ue.isAsyncMode = function(b) {
    return O(b) || w(b) === c;
  }, Ue.isConcurrentMode = O, Ue.isContextConsumer = function(b) {
    return w(b) === s;
  }, Ue.isContextProvider = function(b) {
    return w(b) === o;
  }, Ue.isElement = function(b) {
    return typeof b == "object" && b !== null && b.$$typeof === t;
  }, Ue.isForwardRef = function(b) {
    return w(b) === d;
  }, Ue.isFragment = function(b) {
    return w(b) === n;
  }, Ue.isLazy = function(b) {
    return w(b) === m;
  }, Ue.isMemo = function(b) {
    return w(b) === p;
  }, Ue.isPortal = function(b) {
    return w(b) === r;
  }, Ue.isProfiler = function(b) {
    return w(b) === i;
  }, Ue.isStrictMode = function(b) {
    return w(b) === a;
  }, Ue.isSuspense = function(b) {
    return w(b) === h;
  }, Ue.isValidElementType = function(b) {
    return typeof b == "string" || typeof b == "function" || b === n || b === u || b === i || b === a || b === h || b === A || typeof b == "object" && b !== null && (b.$$typeof === m || b.$$typeof === p || b.$$typeof === o || b.$$typeof === s || b.$$typeof === d || b.$$typeof === v || b.$$typeof === C || b.$$typeof === y || b.$$typeof === g);
  }, Ue.typeOf = w, Ue;
}
var Ze = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var wd;
function rB() {
  return wd || (wd = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, r = e ? Symbol.for("react.portal") : 60106, n = e ? Symbol.for("react.fragment") : 60107, a = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, o = e ? Symbol.for("react.provider") : 60109, s = e ? Symbol.for("react.context") : 60110, c = e ? Symbol.for("react.async_mode") : 60111, u = e ? Symbol.for("react.concurrent_mode") : 60111, d = e ? Symbol.for("react.forward_ref") : 60112, h = e ? Symbol.for("react.suspense") : 60113, A = e ? Symbol.for("react.suspense_list") : 60120, p = e ? Symbol.for("react.memo") : 60115, m = e ? Symbol.for("react.lazy") : 60116, g = e ? Symbol.for("react.block") : 60121, v = e ? Symbol.for("react.fundamental") : 60117, C = e ? Symbol.for("react.responder") : 60118, y = e ? Symbol.for("react.scope") : 60119;
    function w(L) {
      return typeof L == "string" || typeof L == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      L === n || L === u || L === i || L === a || L === h || L === A || typeof L == "object" && L !== null && (L.$$typeof === m || L.$$typeof === p || L.$$typeof === o || L.$$typeof === s || L.$$typeof === d || L.$$typeof === v || L.$$typeof === C || L.$$typeof === y || L.$$typeof === g);
    }
    function O(L) {
      if (typeof L == "object" && L !== null) {
        var ee = L.$$typeof;
        switch (ee) {
          case t:
            var V = L.type;
            switch (V) {
              case c:
              case u:
              case n:
              case i:
              case a:
              case h:
                return V;
              default:
                var ne = V && V.$$typeof;
                switch (ne) {
                  case s:
                  case d:
                  case m:
                  case p:
                  case o:
                    return ne;
                  default:
                    return ee;
                }
            }
          case r:
            return ee;
        }
      }
    }
    var b = c, D = u, M = s, j = o, P = t, H = d, F = n, R = m, N = p, z = r, q = i, J = a, W = h, te = !1;
    function S(L) {
      return te || (te = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), I(L) || O(L) === c;
    }
    function I(L) {
      return O(L) === u;
    }
    function T(L) {
      return O(L) === s;
    }
    function E(L) {
      return O(L) === o;
    }
    function x(L) {
      return typeof L == "object" && L !== null && L.$$typeof === t;
    }
    function $(L) {
      return O(L) === d;
    }
    function _(L) {
      return O(L) === n;
    }
    function Q(L) {
      return O(L) === m;
    }
    function Z(L) {
      return O(L) === p;
    }
    function X(L) {
      return O(L) === r;
    }
    function Y(L) {
      return O(L) === i;
    }
    function U(L) {
      return O(L) === a;
    }
    function k(L) {
      return O(L) === h;
    }
    Ze.AsyncMode = b, Ze.ConcurrentMode = D, Ze.ContextConsumer = M, Ze.ContextProvider = j, Ze.Element = P, Ze.ForwardRef = H, Ze.Fragment = F, Ze.Lazy = R, Ze.Memo = N, Ze.Portal = z, Ze.Profiler = q, Ze.StrictMode = J, Ze.Suspense = W, Ze.isAsyncMode = S, Ze.isConcurrentMode = I, Ze.isContextConsumer = T, Ze.isContextProvider = E, Ze.isElement = x, Ze.isForwardRef = $, Ze.isFragment = _, Ze.isLazy = Q, Ze.isMemo = Z, Ze.isPortal = X, Ze.isProfiler = Y, Ze.isStrictMode = U, Ze.isSuspense = k, Ze.isValidElementType = w, Ze.typeOf = O;
  }()), Ze;
}
process.env.NODE_ENV === "production" ? R4.exports = tB() : R4.exports = rB();
var nB = R4.exports, I7 = nB, aB = {
  childContextTypes: !0,
  contextType: !0,
  contextTypes: !0,
  defaultProps: !0,
  displayName: !0,
  getDefaultProps: !0,
  getDerivedStateFromError: !0,
  getDerivedStateFromProps: !0,
  mixins: !0,
  propTypes: !0,
  type: !0
}, iB = {
  name: !0,
  length: !0,
  prototype: !0,
  caller: !0,
  callee: !0,
  arguments: !0,
  arity: !0
}, oB = {
  $$typeof: !0,
  render: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0
}, DC = {
  $$typeof: !0,
  compare: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0,
  type: !0
}, B7 = {};
B7[I7.ForwardRef] = oB;
B7[I7.Memo] = DC;
function xd(e) {
  return I7.isMemo(e) ? DC : B7[e.$$typeof] || aB;
}
var sB = Object.defineProperty, lB = Object.getOwnPropertyNames, Od = Object.getOwnPropertySymbols, cB = Object.getOwnPropertyDescriptor, uB = Object.getPrototypeOf, Dd = Object.prototype;
function MC(e, t, r) {
  if (typeof t != "string") {
    if (Dd) {
      var n = uB(t);
      n && n !== Dd && MC(e, n, r);
    }
    var a = lB(t);
    Od && (a = a.concat(Od(t)));
    for (var i = xd(e), o = xd(t), s = 0; s < a.length; ++s) {
      var c = a[s];
      if (!iB[c] && !(r && r[c]) && !(o && o[c]) && !(i && i[c])) {
        var u = cB(t, c);
        try {
          sB(e, c, u);
        } catch {
        }
      }
    }
  }
  return e;
}
var fB = MC;
const Md = /* @__PURE__ */ qe(fB);
var $4 = { exports: {} }, et = {};
/** @license React v17.0.2
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ed;
function dB() {
  if (Ed)
    return et;
  Ed = 1;
  var e = 60103, t = 60106, r = 60107, n = 60108, a = 60114, i = 60109, o = 60110, s = 60112, c = 60113, u = 60120, d = 60115, h = 60116, A = 60121, p = 60122, m = 60117, g = 60129, v = 60131;
  if (typeof Symbol == "function" && Symbol.for) {
    var C = Symbol.for;
    e = C("react.element"), t = C("react.portal"), r = C("react.fragment"), n = C("react.strict_mode"), a = C("react.profiler"), i = C("react.provider"), o = C("react.context"), s = C("react.forward_ref"), c = C("react.suspense"), u = C("react.suspense_list"), d = C("react.memo"), h = C("react.lazy"), A = C("react.block"), p = C("react.server.block"), m = C("react.fundamental"), g = C("react.debug_trace_mode"), v = C("react.legacy_hidden");
  }
  function y(N) {
    if (typeof N == "object" && N !== null) {
      var z = N.$$typeof;
      switch (z) {
        case e:
          switch (N = N.type, N) {
            case r:
            case a:
            case n:
            case c:
            case u:
              return N;
            default:
              switch (N = N && N.$$typeof, N) {
                case o:
                case s:
                case h:
                case d:
                case i:
                  return N;
                default:
                  return z;
              }
          }
        case t:
          return z;
      }
    }
  }
  var w = i, O = e, b = s, D = r, M = h, j = d, P = t, H = a, F = n, R = c;
  return et.ContextConsumer = o, et.ContextProvider = w, et.Element = O, et.ForwardRef = b, et.Fragment = D, et.Lazy = M, et.Memo = j, et.Portal = P, et.Profiler = H, et.StrictMode = F, et.Suspense = R, et.isAsyncMode = function() {
    return !1;
  }, et.isConcurrentMode = function() {
    return !1;
  }, et.isContextConsumer = function(N) {
    return y(N) === o;
  }, et.isContextProvider = function(N) {
    return y(N) === i;
  }, et.isElement = function(N) {
    return typeof N == "object" && N !== null && N.$$typeof === e;
  }, et.isForwardRef = function(N) {
    return y(N) === s;
  }, et.isFragment = function(N) {
    return y(N) === r;
  }, et.isLazy = function(N) {
    return y(N) === h;
  }, et.isMemo = function(N) {
    return y(N) === d;
  }, et.isPortal = function(N) {
    return y(N) === t;
  }, et.isProfiler = function(N) {
    return y(N) === a;
  }, et.isStrictMode = function(N) {
    return y(N) === n;
  }, et.isSuspense = function(N) {
    return y(N) === c;
  }, et.isValidElementType = function(N) {
    return typeof N == "string" || typeof N == "function" || N === r || N === a || N === g || N === n || N === c || N === u || N === v || typeof N == "object" && N !== null && (N.$$typeof === h || N.$$typeof === d || N.$$typeof === i || N.$$typeof === o || N.$$typeof === s || N.$$typeof === m || N.$$typeof === A || N[0] === p);
  }, et.typeOf = y, et;
}
var tt = {};
/** @license React v17.0.2
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Pd;
function hB() {
  return Pd || (Pd = 1, process.env.NODE_ENV !== "production" && function() {
    var e = 60103, t = 60106, r = 60107, n = 60108, a = 60114, i = 60109, o = 60110, s = 60112, c = 60113, u = 60120, d = 60115, h = 60116, A = 60121, p = 60122, m = 60117, g = 60129, v = 60131;
    if (typeof Symbol == "function" && Symbol.for) {
      var C = Symbol.for;
      e = C("react.element"), t = C("react.portal"), r = C("react.fragment"), n = C("react.strict_mode"), a = C("react.profiler"), i = C("react.provider"), o = C("react.context"), s = C("react.forward_ref"), c = C("react.suspense"), u = C("react.suspense_list"), d = C("react.memo"), h = C("react.lazy"), A = C("react.block"), p = C("react.server.block"), m = C("react.fundamental"), C("react.scope"), C("react.opaque.id"), g = C("react.debug_trace_mode"), C("react.offscreen"), v = C("react.legacy_hidden");
    }
    var y = !1;
    function w(k) {
      return !!(typeof k == "string" || typeof k == "function" || k === r || k === a || k === g || k === n || k === c || k === u || k === v || y || typeof k == "object" && k !== null && (k.$$typeof === h || k.$$typeof === d || k.$$typeof === i || k.$$typeof === o || k.$$typeof === s || k.$$typeof === m || k.$$typeof === A || k[0] === p));
    }
    function O(k) {
      if (typeof k == "object" && k !== null) {
        var L = k.$$typeof;
        switch (L) {
          case e:
            var ee = k.type;
            switch (ee) {
              case r:
              case a:
              case n:
              case c:
              case u:
                return ee;
              default:
                var V = ee && ee.$$typeof;
                switch (V) {
                  case o:
                  case s:
                  case h:
                  case d:
                  case i:
                    return V;
                  default:
                    return L;
                }
            }
          case t:
            return L;
        }
      }
    }
    var b = o, D = i, M = e, j = s, P = r, H = h, F = d, R = t, N = a, z = n, q = c, J = !1, W = !1;
    function te(k) {
      return J || (J = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function S(k) {
      return W || (W = !0, console.warn("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function I(k) {
      return O(k) === o;
    }
    function T(k) {
      return O(k) === i;
    }
    function E(k) {
      return typeof k == "object" && k !== null && k.$$typeof === e;
    }
    function x(k) {
      return O(k) === s;
    }
    function $(k) {
      return O(k) === r;
    }
    function _(k) {
      return O(k) === h;
    }
    function Q(k) {
      return O(k) === d;
    }
    function Z(k) {
      return O(k) === t;
    }
    function X(k) {
      return O(k) === a;
    }
    function Y(k) {
      return O(k) === n;
    }
    function U(k) {
      return O(k) === c;
    }
    tt.ContextConsumer = b, tt.ContextProvider = D, tt.Element = M, tt.ForwardRef = j, tt.Fragment = P, tt.Lazy = H, tt.Memo = F, tt.Portal = R, tt.Profiler = N, tt.StrictMode = z, tt.Suspense = q, tt.isAsyncMode = te, tt.isConcurrentMode = S, tt.isContextConsumer = I, tt.isContextProvider = T, tt.isElement = E, tt.isForwardRef = x, tt.isFragment = $, tt.isLazy = _, tt.isMemo = Q, tt.isPortal = Z, tt.isProfiler = X, tt.isStrictMode = Y, tt.isSuspense = U, tt.isValidElementType = w, tt.typeOf = O;
  }()), tt;
}
process.env.NODE_ENV === "production" ? $4.exports = dB() : $4.exports = hB();
var jd = $4.exports, AB = ["getDisplayName", "methodName", "renderCountProp", "shouldHandleStateChanges", "storeKey", "withRef", "forwardRef", "context"], pB = ["reactReduxForwardedRef"], vB = [], gB = [null, null], mB = function(t) {
  try {
    return JSON.stringify(t);
  } catch {
    return String(t);
  }
};
function CB(e, t) {
  var r = e[1];
  return [t.payload, r + 1];
}
function Sd(e, t, r) {
  xC(function() {
    return e.apply(void 0, t);
  }, r);
}
function bB(e, t, r, n, a, i, o) {
  e.current = n, t.current = a, r.current = !1, i.current && (i.current = null, o());
}
function yB(e, t, r, n, a, i, o, s, c, u) {
  if (e) {
    var d = !1, h = null, A = function() {
      if (!d) {
        var g = t.getState(), v, C;
        try {
          v = n(g, a.current);
        } catch (y) {
          C = y, h = y;
        }
        C || (h = null), v === i.current ? o.current || c() : (i.current = v, s.current = v, o.current = !0, u({
          type: "STORE_UPDATED",
          payload: {
            error: C
          }
        }));
      }
    };
    r.onStateChange = A, r.trySubscribe(), A();
    var p = function() {
      if (d = !0, r.tryUnsubscribe(), r.onStateChange = null, h)
        throw h;
    };
    return p;
  }
}
var wB = function() {
  return [null, 0];
};
function xB(e, t) {
  t === void 0 && (t = {});
  var r = t, n = r.getDisplayName, a = n === void 0 ? function(D) {
    return "ConnectAdvanced(" + D + ")";
  } : n, i = r.methodName, o = i === void 0 ? "connectAdvanced" : i, s = r.renderCountProp, c = s === void 0 ? void 0 : s, u = r.shouldHandleStateChanges, d = u === void 0 ? !0 : u, h = r.storeKey, A = h === void 0 ? "store" : h, p = r.withRef, m = p === void 0 ? !1 : p, g = r.forwardRef, v = g === void 0 ? !1 : g, C = r.context, y = C === void 0 ? S7 : C, w = X3(r, AB);
  if (process.env.NODE_ENV !== "production") {
    if (c !== void 0)
      throw new Error("renderCountProp is removed. render counting is built into the latest React Dev Tools profiling extension");
    if (m)
      throw new Error("withRef is removed. To access the wrapped instance, use a ref on the connected component");
    var O = "To use a custom Redux store for specific components, create a custom React context with React.createContext(), and pass the context object to React Redux's Provider and specific components like: <Provider context={MyContext}><ConnectedComponent context={MyContext} /></Provider>. You may also pass a {context : MyContext} option to connect";
    if (A !== "store")
      throw new Error("storeKey has been removed and does not do anything. " + O);
  }
  var b = y;
  return function(M) {
    if (process.env.NODE_ENV !== "production" && !jd.isValidElementType(M))
      throw new Error("You must pass a component to the function returned by " + (o + ". Instead received " + mB(M)));
    var j = M.displayName || M.name || "Component", P = a(j), H = we({}, w, {
      getDisplayName: a,
      methodName: o,
      renderCountProp: c,
      shouldHandleStateChanges: d,
      storeKey: A,
      displayName: P,
      wrappedComponentName: j,
      WrappedComponent: M
    }), F = w.pure;
    function R(W) {
      return e(W.dispatch, H);
    }
    var N = F ? dr : function(W) {
      return W();
    };
    function z(W) {
      var te = dr(function() {
        var $e = W.reactReduxForwardedRef, ft = X3(W, pB);
        return [W.context, $e, ft];
      }, [W]), S = te[0], I = te[1], T = te[2], E = dr(function() {
        return S && S.Consumer && jd.isContextConsumer(/* @__PURE__ */ B.createElement(S.Consumer, null)) ? S : b;
      }, [S, b]), x = xt(E), $ = !!W.store && !!W.store.getState && !!W.store.dispatch, _ = !!x && !!x.store;
      if (process.env.NODE_ENV !== "production" && !$ && !_)
        throw new Error('Could not find "store" in the context of ' + ('"' + P + '". Either wrap the root component in a <Provider>, ') + "or pass a custom React context provider to <Provider> and the corresponding " + ("React context consumer to " + P + " in connect options."));
      var Q = $ ? W.store : x.store, Z = dr(function() {
        return R(Q);
      }, [Q]), X = dr(function() {
        if (!d)
          return gB;
        var $e = wC(Q, $ ? null : x.subscription), ft = $e.notifyNestedSubs.bind($e);
        return [$e, ft];
      }, [Q, $, x]), Y = X[0], U = X[1], k = dr(function() {
        return $ ? x : we({}, x, {
          subscription: Y
        });
      }, [$, x, Y]), L = tP(CB, vB, wB), ee = L[0], V = ee[0], ne = L[1];
      if (V && V.error)
        throw V.error;
      var ie = ge(), le = ge(T), de = ge(), ve = ge(!1), Ee = N(function() {
        return de.current && T === le.current ? de.current : Z(Q.getState(), T);
      }, [Q, V, T]);
      Sd(bB, [le, ie, ve, T, Ee, de, U]), Sd(yB, [d, Q, Y, Z, le, ie, ve, de, U, ne], [Q, Y, Z]);
      var Ne = dr(function() {
        return /* @__PURE__ */ B.createElement(M, we({}, Ee, {
          ref: I
        }));
      }, [I, M, Ee]), je = dr(function() {
        return d ? /* @__PURE__ */ B.createElement(E.Provider, {
          value: k
        }, Ne) : Ne;
      }, [E, Ne, k]);
      return je;
    }
    var q = F ? B.memo(z) : z;
    if (q.WrappedComponent = M, q.displayName = z.displayName = P, v) {
      var J = B.forwardRef(function(te, S) {
        return /* @__PURE__ */ B.createElement(q, we({}, te, {
          reactReduxForwardedRef: S
        }));
      });
      return J.displayName = P, J.WrappedComponent = M, Md(J, M);
    }
    return Md(q, M);
  };
}
function Id(e, t) {
  return e === t ? e !== 0 || t !== 0 || 1 / e === 1 / t : e !== e && t !== t;
}
function O6(e, t) {
  if (Id(e, t))
    return !0;
  if (typeof e != "object" || e === null || typeof t != "object" || t === null)
    return !1;
  var r = Object.keys(e), n = Object.keys(t);
  if (r.length !== n.length)
    return !1;
  for (var a = 0; a < r.length; a++)
    if (!Object.prototype.hasOwnProperty.call(t, r[a]) || !Id(e[r[a]], t[r[a]]))
      return !1;
  return !0;
}
function OB(e, t) {
  var r = {}, n = function(o) {
    var s = e[o];
    typeof s == "function" && (r[o] = function() {
      return t(s.apply(void 0, arguments));
    });
  };
  for (var a in e)
    n(a);
  return r;
}
function DB(e) {
  if (typeof e != "object" || e === null)
    return !1;
  var t = Object.getPrototypeOf(e);
  if (t === null)
    return !0;
  for (var r = t; Object.getPrototypeOf(r) !== null; )
    r = Object.getPrototypeOf(r);
  return t === r;
}
function EC(e) {
  typeof console < "u" && typeof console.error == "function" && console.error(e);
  try {
    throw new Error(e);
  } catch {
  }
}
function PC(e, t, r) {
  DB(e) || EC(r + "() in " + t + " must return a plain object. Instead received " + e + ".");
}
function N7(e) {
  return function(r, n) {
    var a = e(r, n);
    function i() {
      return a;
    }
    return i.dependsOnOwnProps = !1, i;
  };
}
function Bd(e) {
  return e.dependsOnOwnProps !== null && e.dependsOnOwnProps !== void 0 ? !!e.dependsOnOwnProps : e.length !== 1;
}
function jC(e, t) {
  return function(n, a) {
    var i = a.displayName, o = function(c, u) {
      return o.dependsOnOwnProps ? o.mapToProps(c, u) : o.mapToProps(c);
    };
    return o.dependsOnOwnProps = !0, o.mapToProps = function(c, u) {
      o.mapToProps = e, o.dependsOnOwnProps = Bd(e);
      var d = o(c, u);
      return typeof d == "function" && (o.mapToProps = d, o.dependsOnOwnProps = Bd(d), d = o(c, u)), process.env.NODE_ENV !== "production" && PC(d, i, t), d;
    }, o;
  };
}
function MB(e) {
  return typeof e == "function" ? jC(e, "mapDispatchToProps") : void 0;
}
function EB(e) {
  return e ? void 0 : N7(function(t) {
    return {
      dispatch: t
    };
  });
}
function PB(e) {
  return e && typeof e == "object" ? N7(function(t) {
    return OB(e, t);
  }) : void 0;
}
const jB = [MB, EB, PB];
function SB(e) {
  return typeof e == "function" ? jC(e, "mapStateToProps") : void 0;
}
function IB(e) {
  return e ? void 0 : N7(function() {
    return {};
  });
}
const BB = [SB, IB];
function NB(e, t, r) {
  return we({}, r, e, t);
}
function _B(e) {
  return function(r, n) {
    var a = n.displayName, i = n.pure, o = n.areMergedPropsEqual, s = !1, c;
    return function(d, h, A) {
      var p = e(d, h, A);
      return s ? (!i || !o(p, c)) && (c = p) : (s = !0, c = p, process.env.NODE_ENV !== "production" && PC(c, a, "mergeProps")), c;
    };
  };
}
function LB(e) {
  return typeof e == "function" ? _B(e) : void 0;
}
function TB(e) {
  return e ? void 0 : function() {
    return NB;
  };
}
const RB = [LB, TB];
function D6(e, t, r) {
  if (e)
    (t === "mapStateToProps" || t === "mapDispatchToProps") && (Object.prototype.hasOwnProperty.call(e, "dependsOnOwnProps") || EC("The selector for " + t + " of " + r + " did not specify a value for dependsOnOwnProps."));
  else
    throw new Error("Unexpected value for " + t + " in " + r + ".");
}
function $B(e, t, r, n) {
  D6(e, "mapStateToProps", n), D6(t, "mapDispatchToProps", n), D6(r, "mergeProps", n);
}
var FB = ["initMapStateToProps", "initMapDispatchToProps", "initMergeProps"];
function HB(e, t, r, n) {
  return function(i, o) {
    return r(e(i, o), t(n, o), o);
  };
}
function YB(e, t, r, n, a) {
  var i = a.areStatesEqual, o = a.areOwnPropsEqual, s = a.areStatePropsEqual, c = !1, u, d, h, A, p;
  function m(w, O) {
    return u = w, d = O, h = e(u, d), A = t(n, d), p = r(h, A, d), c = !0, p;
  }
  function g() {
    return h = e(u, d), t.dependsOnOwnProps && (A = t(n, d)), p = r(h, A, d), p;
  }
  function v() {
    return e.dependsOnOwnProps && (h = e(u, d)), t.dependsOnOwnProps && (A = t(n, d)), p = r(h, A, d), p;
  }
  function C() {
    var w = e(u, d), O = !s(w, h);
    return h = w, O && (p = r(h, A, d)), p;
  }
  function y(w, O) {
    var b = !o(O, d), D = !i(w, u, O, d);
    return u = w, d = O, b && D ? g() : b ? v() : D ? C() : p;
  }
  return function(O, b) {
    return c ? y(O, b) : m(O, b);
  };
}
function VB(e, t) {
  var r = t.initMapStateToProps, n = t.initMapDispatchToProps, a = t.initMergeProps, i = X3(t, FB), o = r(e, i), s = n(e, i), c = a(e, i);
  process.env.NODE_ENV !== "production" && $B(o, s, c, i.displayName);
  var u = i.pure ? YB : HB;
  return u(o, s, c, e, i);
}
var kB = ["pure", "areStatesEqual", "areOwnPropsEqual", "areStatePropsEqual", "areMergedPropsEqual"];
function M6(e, t, r) {
  for (var n = t.length - 1; n >= 0; n--) {
    var a = t[n](e);
    if (a)
      return a;
  }
  return function(i, o) {
    throw new Error("Invalid value of type " + typeof e + " for " + r + " argument when connecting component " + o.wrappedComponentName + ".");
  };
}
function GB(e, t) {
  return e === t;
}
function WB(e) {
  var t = e === void 0 ? {} : e, r = t.connectHOC, n = r === void 0 ? xB : r, a = t.mapStateToPropsFactories, i = a === void 0 ? BB : a, o = t.mapDispatchToPropsFactories, s = o === void 0 ? jB : o, c = t.mergePropsFactories, u = c === void 0 ? RB : c, d = t.selectorFactory, h = d === void 0 ? VB : d;
  return function(p, m, g, v) {
    v === void 0 && (v = {});
    var C = v, y = C.pure, w = y === void 0 ? !0 : y, O = C.areStatesEqual, b = O === void 0 ? GB : O, D = C.areOwnPropsEqual, M = D === void 0 ? O6 : D, j = C.areStatePropsEqual, P = j === void 0 ? O6 : j, H = C.areMergedPropsEqual, F = H === void 0 ? O6 : H, R = X3(C, kB), N = M6(p, i, "mapStateToProps"), z = M6(m, s, "mapDispatchToProps"), q = M6(g, u, "mergeProps");
    return n(h, we({
      // used in error messages
      methodName: "connect",
      // used to compute Connect's displayName from the wrapped component's displayName.
      getDisplayName: function(W) {
        return "Connect(" + W + ")";
      },
      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
      shouldHandleStateChanges: !!p,
      // passed through to selectorFactory
      initMapStateToProps: N,
      initMapDispatchToProps: z,
      initMergeProps: q,
      pure: w,
      areStatesEqual: b,
      areOwnPropsEqual: M,
      areStatePropsEqual: P,
      areMergedPropsEqual: F
    }, R));
  };
}
const SC = /* @__PURE__ */ WB();
XI(iP);
function QB(e, t) {
  if (e.length !== t.length)
    return !1;
  for (var r = 0; r < e.length; r++)
    if (e[r] !== t[r])
      return !1;
  return !0;
}
function IC(e, t) {
  var r = De(function() {
    return {
      inputs: t,
      result: e()
    };
  })[0], n = ge(!0), a = ge(r), i = n.current || !!(t && a.current.inputs && QB(t, a.current.inputs)), o = i ? a.current : {
    inputs: t,
    result: e()
  };
  return Ie(function() {
    n.current = !1, a.current = o;
  }, [o]), o.result;
}
function UB(e, t) {
  return IC(function() {
    return e;
  }, t);
}
var He = IC, pe = UB, ZB = process.env.NODE_ENV === "production", E6 = "Invariant failed";
function Zt(e, t) {
  if (!e) {
    if (ZB)
      throw new Error(E6);
    var r = typeof t == "function" ? t() : t, n = r ? "".concat(E6, ": ").concat(r) : E6;
    throw new Error(n);
  }
}
var Yr = function(t) {
  var r = t.top, n = t.right, a = t.bottom, i = t.left, o = n - i, s = a - r, c = {
    top: r,
    right: n,
    bottom: a,
    left: i,
    width: o,
    height: s,
    x: i,
    y: r,
    center: {
      x: (n + i) / 2,
      y: (a + r) / 2
    }
  };
  return c;
}, _7 = function(t, r) {
  return {
    top: t.top - r.top,
    left: t.left - r.left,
    bottom: t.bottom + r.bottom,
    right: t.right + r.right
  };
}, Nd = function(t, r) {
  return {
    top: t.top + r.top,
    left: t.left + r.left,
    bottom: t.bottom - r.bottom,
    right: t.right - r.right
  };
}, zB = function(t, r) {
  return {
    top: t.top + r.y,
    left: t.left + r.x,
    bottom: t.bottom + r.y,
    right: t.right + r.x
  };
}, P6 = {
  top: 0,
  right: 0,
  bottom: 0,
  left: 0
}, L7 = function(t) {
  var r = t.borderBox, n = t.margin, a = n === void 0 ? P6 : n, i = t.border, o = i === void 0 ? P6 : i, s = t.padding, c = s === void 0 ? P6 : s, u = Yr(_7(r, a)), d = Yr(Nd(r, o)), h = Yr(Nd(d, c));
  return {
    marginBox: u,
    borderBox: Yr(r),
    paddingBox: d,
    contentBox: h,
    margin: a,
    border: o,
    padding: c
  };
}, br = function(t) {
  var r = t.slice(0, -2), n = t.slice(-2);
  if (n !== "px")
    return 0;
  var a = Number(r);
  return isNaN(a) && (process.env.NODE_ENV !== "production" ? Zt(!1, "Could not parse value [raw: " + t + ", without suffix: " + r + "]") : Zt(!1)), a;
}, KB = function() {
  return {
    x: window.pageXOffset,
    y: window.pageYOffset
  };
}, J3 = function(t, r) {
  var n = t.borderBox, a = t.border, i = t.margin, o = t.padding, s = zB(n, r);
  return L7({
    borderBox: s,
    border: a,
    margin: i,
    padding: o
  });
}, es = function(t, r) {
  return r === void 0 && (r = KB()), J3(t, r);
}, BC = function(t, r) {
  var n = {
    top: br(r.marginTop),
    right: br(r.marginRight),
    bottom: br(r.marginBottom),
    left: br(r.marginLeft)
  }, a = {
    top: br(r.paddingTop),
    right: br(r.paddingRight),
    bottom: br(r.paddingBottom),
    left: br(r.paddingLeft)
  }, i = {
    top: br(r.borderTopWidth),
    right: br(r.borderRightWidth),
    bottom: br(r.borderBottomWidth),
    left: br(r.borderLeftWidth)
  };
  return L7({
    borderBox: t,
    margin: n,
    padding: a,
    border: i
  });
}, NC = function(t) {
  var r = t.getBoundingClientRect(), n = window.getComputedStyle(t);
  return BC(r, n);
}, _d = Number.isNaN || function(t) {
  return typeof t == "number" && t !== t;
};
function qB(e, t) {
  return !!(e === t || _d(e) && _d(t));
}
function XB(e, t) {
  if (e.length !== t.length)
    return !1;
  for (var r = 0; r < e.length; r++)
    if (!qB(e[r], t[r]))
      return !1;
  return !0;
}
function Ft(e, t) {
  t === void 0 && (t = XB);
  var r, n = [], a, i = !1;
  function o() {
    for (var s = [], c = 0; c < arguments.length; c++)
      s[c] = arguments[c];
    return i && r === this && t(s, n) || (a = e.apply(this, s), i = !0, r = this, n = s), a;
  }
  return o;
}
var JB = function(t) {
  var r = [], n = null, a = function() {
    for (var o = arguments.length, s = new Array(o), c = 0; c < o; c++)
      s[c] = arguments[c];
    r = s, !n && (n = requestAnimationFrame(function() {
      n = null, t.apply(void 0, r);
    }));
  };
  return a.cancel = function() {
    n && (cancelAnimationFrame(n), n = null);
  }, a;
};
const Ji = JB;
var eN = process.env.NODE_ENV === "production", tN = /[ \t]{2,}/g, rN = /^[ \t]*/gm, Ld = function(t) {
  return t.replace(tN, " ").replace(rN, "").trim();
}, nN = function(t) {
  return Ld(`
  %creact-beautiful-dnd

  %c` + Ld(t) + `

  %c👷‍ This is a development only message. It will be removed in production builds.
`);
}, aN = function(t) {
  return [nN(t), "color: #00C584; font-size: 1.2em; font-weight: bold;", "line-height: 1.5", "color: #723874;"];
}, iN = "__react-beautiful-dnd-disable-dev-warnings";
function _C(e, t) {
  var r;
  eN || typeof window < "u" && window[iN] || (r = console)[e].apply(r, aN(t));
}
var ut = _C.bind(null, "warn"), F4 = _C.bind(null, "error");
function t1() {
}
function oN(e, t) {
  return we({}, e, {}, t);
}
function Pr(e, t, r) {
  var n = t.map(function(a) {
    var i = oN(r, a.options);
    return e.addEventListener(a.eventName, a.fn, i), function() {
      e.removeEventListener(a.eventName, a.fn, i);
    };
  });
  return function() {
    n.forEach(function(i) {
      i();
    });
  };
}
var sN = process.env.NODE_ENV === "production", Td = "Invariant failed";
function eo(e) {
  this.message = e;
}
eo.prototype.toString = function() {
  return this.message;
};
function K(e, t) {
  if (!e)
    throw sN ? new eo(Td) : new eo(Td + ": " + (t || ""));
}
var lN = function(e) {
  vC(t, e);
  function t() {
    for (var n, a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return n = e.call.apply(e, [this].concat(i)) || this, n.callbacks = null, n.unbind = t1, n.onWindowError = function(s) {
      var c = n.getCallbacks();
      c.isDragging() && (c.tryAbort(), process.env.NODE_ENV !== "production" && ut(`
        An error was caught by our window 'error' event listener while a drag was occurring.
        The active drag has been aborted.
      `));
      var u = s.error;
      u instanceof eo && (s.preventDefault(), process.env.NODE_ENV !== "production" && F4(u.message));
    }, n.getCallbacks = function() {
      if (!n.callbacks)
        throw new Error("Unable to find AppCallbacks in <ErrorBoundary/>");
      return n.callbacks;
    }, n.setCallbacks = function(s) {
      n.callbacks = s;
    }, n;
  }
  var r = t.prototype;
  return r.componentDidMount = function() {
    this.unbind = Pr(window, [{
      eventName: "error",
      fn: this.onWindowError
    }]);
  }, r.componentDidCatch = function(a) {
    if (a instanceof eo) {
      process.env.NODE_ENV !== "production" && F4(a.message), this.setState({});
      return;
    }
    throw a;
  }, r.componentWillUnmount = function() {
    this.unbind();
  }, r.render = function() {
    return this.props.children(this.setCallbacks);
  }, t;
}(B.Component), cN = `
  Press space bar to start a drag.
  When dragging you can use the arrow keys to move the item around and escape to cancel.
  Some screen readers may require you to be in focus mode or to use your pass through key
`, ts = function(t) {
  return t + 1;
}, uN = function(t) {
  return `
  You have lifted an item in position ` + ts(t.source.index) + `
`;
}, LC = function(t, r) {
  var n = t.droppableId === r.droppableId, a = ts(t.index), i = ts(r.index);
  return n ? `
      You have moved the item from position ` + a + `
      to position ` + i + `
    ` : `
    You have moved the item from position ` + a + `
    in list ` + t.droppableId + `
    to list ` + r.droppableId + `
    in position ` + i + `
  `;
}, TC = function(t, r, n) {
  var a = r.droppableId === n.droppableId;
  return a ? `
      The item ` + t + `
      has been combined with ` + n.draggableId : `
      The item ` + t + `
      in list ` + r.droppableId + `
      has been combined with ` + n.draggableId + `
      in list ` + n.droppableId + `
    `;
}, fN = function(t) {
  var r = t.destination;
  if (r)
    return LC(t.source, r);
  var n = t.combine;
  return n ? TC(t.draggableId, t.source, n) : "You are over an area that cannot be dropped on";
}, Rd = function(t) {
  return `
  The item has returned to its starting position
  of ` + ts(t.index) + `
`;
}, dN = function(t) {
  if (t.reason === "CANCEL")
    return `
      Movement cancelled.
      ` + Rd(t.source) + `
    `;
  var r = t.destination, n = t.combine;
  return r ? `
      You have dropped the item.
      ` + LC(t.source, r) + `
    ` : n ? `
      You have dropped the item.
      ` + TC(t.draggableId, t.source, n) + `
    ` : `
    The item has been dropped while not over a drop area.
    ` + Rd(t.source) + `
  `;
}, Z3 = {
  dragHandleUsageInstructions: cN,
  onDragStart: uN,
  onDragUpdate: fN,
  onDragEnd: dN
}, Ht = {
  x: 0,
  y: 0
}, kt = function(t, r) {
  return {
    x: t.x + r.x,
    y: t.y + r.y
  };
}, pr = function(t, r) {
  return {
    x: t.x - r.x,
    y: t.y - r.y
  };
}, r1 = function(t, r) {
  return t.x === r.x && t.y === r.y;
}, E2 = function(t) {
  return {
    x: t.x !== 0 ? -t.x : 0,
    y: t.y !== 0 ? -t.y : 0
  };
}, J1 = function(t, r, n) {
  var a;
  return n === void 0 && (n = 0), a = {}, a[t] = r, a[t === "x" ? "y" : "x"] = n, a;
}, to = function(t, r) {
  return Math.sqrt(Math.pow(r.x - t.x, 2) + Math.pow(r.y - t.y, 2));
}, $d = function(t, r) {
  return Math.min.apply(Math, r.map(function(n) {
    return to(t, n);
  }));
}, RC = function(t) {
  return function(r) {
    return {
      x: t(r.x),
      y: t(r.y)
    };
  };
}, hN = function(e, t) {
  var r = Yr({
    top: Math.max(t.top, e.top),
    right: Math.min(t.right, e.right),
    bottom: Math.min(t.bottom, e.bottom),
    left: Math.max(t.left, e.left)
  });
  return r.width <= 0 || r.height <= 0 ? null : r;
}, Vo = function(t, r) {
  return {
    top: t.top + r.y,
    left: t.left + r.x,
    bottom: t.bottom + r.y,
    right: t.right + r.x
  };
}, Fd = function(t) {
  return [{
    x: t.left,
    y: t.top
  }, {
    x: t.right,
    y: t.top
  }, {
    x: t.left,
    y: t.bottom
  }, {
    x: t.right,
    y: t.bottom
  }];
}, AN = {
  top: 0,
  right: 0,
  bottom: 0,
  left: 0
}, pN = function(t, r) {
  return r ? Vo(t, r.scroll.diff.displacement) : t;
}, vN = function(t, r, n) {
  if (n && n.increasedBy) {
    var a;
    return we({}, t, (a = {}, a[r.end] = t[r.end] + n.increasedBy[r.line], a));
  }
  return t;
}, gN = function(t, r) {
  return r && r.shouldClipSubject ? hN(r.pageMarginBox, t) : Yr(t);
}, Ua = function(e) {
  var t = e.page, r = e.withPlaceholder, n = e.axis, a = e.frame, i = pN(t.marginBox, a), o = vN(i, n, r), s = gN(o, a);
  return {
    page: t,
    withPlaceholder: r,
    active: s
  };
}, T7 = function(e, t) {
  e.frame || (process.env.NODE_ENV, K(!1));
  var r = e.frame, n = pr(t, r.scroll.initial), a = E2(n), i = we({}, r, {
    scroll: {
      initial: r.scroll.initial,
      current: t,
      diff: {
        value: n,
        displacement: a
      },
      max: r.scroll.max
    }
  }), o = Ua({
    page: e.subject.page,
    withPlaceholder: e.subject.withPlaceholder,
    axis: e.axis,
    frame: i
  }), s = we({}, e, {
    frame: i,
    subject: o
  });
  return s;
};
function mN(e) {
  return Number.isInteger ? Number.isInteger(e) : typeof e == "number" && isFinite(e) && Math.floor(e) === e;
}
function rs(e) {
  return Object.values ? Object.values(e) : Object.keys(e).map(function(t) {
    return e[t];
  });
}
function R7(e, t) {
  if (e.findIndex)
    return e.findIndex(t);
  for (var r = 0; r < e.length; r++)
    if (t(e[r]))
      return r;
  return -1;
}
function p1(e, t) {
  if (e.find)
    return e.find(t);
  var r = R7(e, t);
  if (r !== -1)
    return e[r];
}
function $C(e) {
  return Array.prototype.slice.call(e);
}
var FC = Ft(function(e) {
  return e.reduce(function(t, r) {
    return t[r.descriptor.id] = r, t;
  }, {});
}), HC = Ft(function(e) {
  return e.reduce(function(t, r) {
    return t[r.descriptor.id] = r, t;
  }, {});
}), v0 = Ft(function(e) {
  return rs(e);
}), CN = Ft(function(e) {
  return rs(e);
}), aa = Ft(function(e, t) {
  var r = CN(t).filter(function(n) {
    return e === n.descriptor.droppableId;
  }).sort(function(n, a) {
    return n.descriptor.index - a.descriptor.index;
  });
  return r;
});
function $7(e) {
  return e.at && e.at.type === "REORDER" ? e.at.destination : null;
}
function g0(e) {
  return e.at && e.at.type === "COMBINE" ? e.at.combine : null;
}
var m0 = Ft(function(e, t) {
  return t.filter(function(r) {
    return r.descriptor.id !== e.descriptor.id;
  });
}), bN = function(e) {
  var t = e.isMovingForward, r = e.draggable, n = e.destination, a = e.insideDestination, i = e.previousImpact;
  if (!n.isCombineEnabled)
    return null;
  var o = $7(i);
  if (!o)
    return null;
  function s(g) {
    var v = {
      type: "COMBINE",
      combine: {
        draggableId: g,
        droppableId: n.descriptor.id
      }
    };
    return we({}, i, {
      at: v
    });
  }
  var c = i.displaced.all, u = c.length ? c[0] : null;
  if (t)
    return u ? s(u) : null;
  var d = m0(r, a);
  if (!u) {
    if (!d.length)
      return null;
    var h = d[d.length - 1];
    return s(h.descriptor.id);
  }
  var A = R7(d, function(g) {
    return g.descriptor.id === u;
  });
  A === -1 && (process.env.NODE_ENV !== "production" ? K(!1, "Could not find displaced item in set") : K(!1));
  var p = A - 1;
  if (p < 0)
    return null;
  var m = d[p];
  return s(m.descriptor.id);
}, P2 = function(e, t) {
  return e.descriptor.droppableId === t.descriptor.id;
}, YC = {
  point: Ht,
  value: 0
}, ro = {
  invisible: {},
  visible: {},
  all: []
}, yN = {
  displaced: ro,
  displacedBy: YC,
  at: null
}, Ir = function(e, t) {
  return function(r) {
    return e <= r && r <= t;
  };
}, VC = function(e) {
  var t = Ir(e.top, e.bottom), r = Ir(e.left, e.right);
  return function(n) {
    var a = t(n.top) && t(n.bottom) && r(n.left) && r(n.right);
    if (a)
      return !0;
    var i = t(n.top) || t(n.bottom), o = r(n.left) || r(n.right), s = i && o;
    if (s)
      return !0;
    var c = n.top < e.top && n.bottom > e.bottom, u = n.left < e.left && n.right > e.right, d = c && u;
    if (d)
      return !0;
    var h = c && o || u && i;
    return h;
  };
}, wN = function(e) {
  var t = Ir(e.top, e.bottom), r = Ir(e.left, e.right);
  return function(n) {
    var a = t(n.top) && t(n.bottom) && r(n.left) && r(n.right);
    return a;
  };
}, F7 = {
  direction: "vertical",
  line: "y",
  crossAxisLine: "x",
  start: "top",
  end: "bottom",
  size: "height",
  crossAxisStart: "left",
  crossAxisEnd: "right",
  crossAxisSize: "width"
}, kC = {
  direction: "horizontal",
  line: "x",
  crossAxisLine: "y",
  start: "left",
  end: "right",
  size: "width",
  crossAxisStart: "top",
  crossAxisEnd: "bottom",
  crossAxisSize: "height"
}, xN = function(e) {
  return function(t) {
    var r = Ir(t.top, t.bottom), n = Ir(t.left, t.right);
    return function(a) {
      return e === F7 ? r(a.top) && r(a.bottom) : n(a.left) && n(a.right);
    };
  };
}, ON = function(t, r) {
  var n = r.frame ? r.frame.scroll.diff.displacement : Ht;
  return Vo(t, n);
}, DN = function(t, r, n) {
  return r.subject.active ? n(r.subject.active)(t) : !1;
}, MN = function(t, r, n) {
  return n(r)(t);
}, H7 = function(t) {
  var r = t.target, n = t.destination, a = t.viewport, i = t.withDroppableDisplacement, o = t.isVisibleThroughFrameFn, s = i ? ON(r, n) : r;
  return DN(s, n, o) && MN(s, a, o);
}, EN = function(t) {
  return H7(we({}, t, {
    isVisibleThroughFrameFn: VC
  }));
}, GC = function(t) {
  return H7(we({}, t, {
    isVisibleThroughFrameFn: wN
  }));
}, PN = function(t) {
  return H7(we({}, t, {
    isVisibleThroughFrameFn: xN(t.destination.axis)
  }));
}, jN = function(t, r, n) {
  if (typeof n == "boolean")
    return n;
  if (!r)
    return !0;
  var a = r.invisible, i = r.visible;
  if (a[t])
    return !1;
  var o = i[t];
  return o ? o.shouldAnimate : !0;
};
function SN(e, t) {
  var r = e.page.marginBox, n = {
    top: t.point.y,
    right: 0,
    bottom: 0,
    left: t.point.x
  };
  return Yr(_7(r, n));
}
function no(e) {
  var t = e.afterDragging, r = e.destination, n = e.displacedBy, a = e.viewport, i = e.forceShouldAnimate, o = e.last;
  return t.reduce(function(c, u) {
    var d = SN(u, n), h = u.descriptor.id;
    c.all.push(h);
    var A = EN({
      target: d,
      destination: r,
      viewport: a,
      withDroppableDisplacement: !0
    });
    if (!A)
      return c.invisible[u.descriptor.id] = !0, c;
    var p = jN(h, o, i), m = {
      draggableId: h,
      shouldAnimate: p
    };
    return c.visible[h] = m, c;
  }, {
    all: [],
    visible: {},
    invisible: {}
  });
}
function IN(e, t) {
  if (!e.length)
    return 0;
  var r = e[e.length - 1].descriptor.index;
  return t.inHomeList ? r : r + 1;
}
function Hd(e) {
  var t = e.insideDestination, r = e.inHomeList, n = e.displacedBy, a = e.destination, i = IN(t, {
    inHomeList: r
  });
  return {
    displaced: ro,
    displacedBy: n,
    at: {
      type: "REORDER",
      destination: {
        droppableId: a.descriptor.id,
        index: i
      }
    }
  };
}
function ns(e) {
  var t = e.draggable, r = e.insideDestination, n = e.destination, a = e.viewport, i = e.displacedBy, o = e.last, s = e.index, c = e.forceShouldAnimate, u = P2(t, n);
  if (s == null)
    return Hd({
      insideDestination: r,
      inHomeList: u,
      displacedBy: i,
      destination: n
    });
  var d = p1(r, function(g) {
    return g.descriptor.index === s;
  });
  if (!d)
    return Hd({
      insideDestination: r,
      inHomeList: u,
      displacedBy: i,
      destination: n
    });
  var h = m0(t, r), A = r.indexOf(d), p = h.slice(A), m = no({
    afterDragging: p,
    destination: n,
    displacedBy: i,
    last: o,
    viewport: a.frame,
    forceShouldAnimate: c
  });
  return {
    displaced: m,
    displacedBy: i,
    at: {
      type: "REORDER",
      destination: {
        droppableId: n.descriptor.id,
        index: s
      }
    }
  };
}
function l1(e, t) {
  return !!t.effected[e];
}
var BN = function(e) {
  var t = e.isMovingForward, r = e.destination, n = e.draggables, a = e.combine, i = e.afterCritical;
  if (!r.isCombineEnabled)
    return null;
  var o = a.draggableId, s = n[o], c = s.descriptor.index, u = l1(o, i);
  return u ? t ? c : c - 1 : t ? c + 1 : c;
}, NN = function(e) {
  var t = e.isMovingForward, r = e.isInHomeList, n = e.insideDestination, a = e.location;
  if (!n.length)
    return null;
  var i = a.index, o = t ? i + 1 : i - 1, s = n[0].descriptor.index, c = n[n.length - 1].descriptor.index, u = r ? c : c + 1;
  return o < s || o > u ? null : o;
}, _N = function(e) {
  var t = e.isMovingForward, r = e.isInHomeList, n = e.draggable, a = e.draggables, i = e.destination, o = e.insideDestination, s = e.previousImpact, c = e.viewport, u = e.afterCritical, d = s.at;
  if (d || (process.env.NODE_ENV !== "production" ? K(!1, "Cannot move in direction without previous impact location") : K(!1)), d.type === "REORDER") {
    var h = NN({
      isMovingForward: t,
      isInHomeList: r,
      location: d.destination,
      insideDestination: o
    });
    return h == null ? null : ns({
      draggable: n,
      insideDestination: o,
      destination: i,
      viewport: c,
      last: s.displaced,
      displacedBy: s.displacedBy,
      index: h
    });
  }
  var A = BN({
    isMovingForward: t,
    destination: i,
    displaced: s.displaced,
    draggables: a,
    combine: d.combine,
    afterCritical: u
  });
  return A == null ? null : ns({
    draggable: n,
    insideDestination: o,
    destination: i,
    viewport: c,
    last: s.displaced,
    displacedBy: s.displacedBy,
    index: A
  });
}, LN = function(e) {
  var t = e.displaced, r = e.afterCritical, n = e.combineWith, a = e.displacedBy, i = !!(t.visible[n] || t.invisible[n]);
  return l1(n, r) ? i ? Ht : E2(a.point) : i ? a.point : Ht;
}, TN = function(e) {
  var t = e.afterCritical, r = e.impact, n = e.draggables, a = g0(r);
  a || (process.env.NODE_ENV, K(!1));
  var i = a.draggableId, o = n[i].page.borderBox.center, s = LN({
    displaced: r.displaced,
    afterCritical: t,
    combineWith: i,
    displacedBy: r.displacedBy
  });
  return kt(o, s);
}, WC = function(t, r) {
  return r.margin[t.start] + r.borderBox[t.size] / 2;
}, RN = function(t, r) {
  return r.margin[t.end] + r.borderBox[t.size] / 2;
}, Y7 = function(t, r, n) {
  return r[t.crossAxisStart] + n.margin[t.crossAxisStart] + n.borderBox[t.crossAxisSize] / 2;
}, Yd = function(t) {
  var r = t.axis, n = t.moveRelativeTo, a = t.isMoving;
  return J1(r.line, n.marginBox[r.end] + WC(r, a), Y7(r, n.marginBox, a));
}, Vd = function(t) {
  var r = t.axis, n = t.moveRelativeTo, a = t.isMoving;
  return J1(r.line, n.marginBox[r.start] - RN(r, a), Y7(r, n.marginBox, a));
}, $N = function(t) {
  var r = t.axis, n = t.moveInto, a = t.isMoving;
  return J1(r.line, n.contentBox[r.start] + WC(r, a), Y7(r, n.contentBox, a));
}, FN = function(e) {
  var t = e.impact, r = e.draggable, n = e.draggables, a = e.droppable, i = e.afterCritical, o = aa(a.descriptor.id, n), s = r.page, c = a.axis;
  if (!o.length)
    return $N({
      axis: c,
      moveInto: a.page,
      isMoving: s
    });
  var u = t.displaced, d = t.displacedBy, h = u.all[0];
  if (h) {
    var A = n[h];
    if (l1(h, i))
      return Vd({
        axis: c,
        moveRelativeTo: A.page,
        isMoving: s
      });
    var p = J3(A.page, d.point);
    return Vd({
      axis: c,
      moveRelativeTo: p,
      isMoving: s
    });
  }
  var m = o[o.length - 1];
  if (m.descriptor.id === r.descriptor.id)
    return s.borderBox.center;
  if (l1(m.descriptor.id, i)) {
    var g = J3(m.page, E2(i.displacedBy.point));
    return Yd({
      axis: c,
      moveRelativeTo: g,
      isMoving: s
    });
  }
  return Yd({
    axis: c,
    moveRelativeTo: m.page,
    isMoving: s
  });
}, H4 = function(e, t) {
  var r = e.frame;
  return r ? kt(t, r.scroll.diff.displacement) : t;
}, HN = function(t) {
  var r = t.impact, n = t.draggable, a = t.droppable, i = t.draggables, o = t.afterCritical, s = n.page.borderBox.center, c = r.at;
  return !a || !c ? s : c.type === "REORDER" ? FN({
    impact: r,
    draggable: n,
    draggables: i,
    droppable: a,
    afterCritical: o
  }) : TN({
    impact: r,
    draggables: i,
    afterCritical: o
  });
}, C0 = function(e) {
  var t = HN(e), r = e.droppable, n = r ? H4(r, t) : t;
  return n;
}, QC = function(e, t) {
  var r = pr(t, e.scroll.initial), n = E2(r), a = Yr({
    top: t.y,
    bottom: t.y + e.frame.height,
    left: t.x,
    right: t.x + e.frame.width
  }), i = {
    frame: a,
    scroll: {
      initial: e.scroll.initial,
      max: e.scroll.max,
      current: t,
      diff: {
        value: r,
        displacement: n
      }
    }
  };
  return i;
};
function kd(e, t) {
  return e.map(function(r) {
    return t[r];
  });
}
function YN(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r].visible[e];
    if (n)
      return n;
  }
  return null;
}
var VN = function(e) {
  var t = e.impact, r = e.viewport, n = e.destination, a = e.draggables, i = e.maxScrollChange, o = QC(r, kt(r.scroll.current, i)), s = n.frame ? T7(n, kt(n.frame.scroll.current, i)) : n, c = t.displaced, u = no({
    afterDragging: kd(c.all, a),
    destination: n,
    displacedBy: t.displacedBy,
    viewport: o.frame,
    last: c,
    forceShouldAnimate: !1
  }), d = no({
    afterDragging: kd(c.all, a),
    destination: s,
    displacedBy: t.displacedBy,
    viewport: r.frame,
    last: c,
    forceShouldAnimate: !1
  }), h = {}, A = {}, p = [c, u, d];
  c.all.forEach(function(g) {
    var v = YN(g, p);
    if (v) {
      A[g] = v;
      return;
    }
    h[g] = !0;
  });
  var m = we({}, t, {
    displaced: {
      all: c.all,
      invisible: h,
      visible: A
    }
  });
  return m;
}, kN = function(e, t) {
  return kt(e.scroll.diff.displacement, t);
}, V7 = function(e) {
  var t = e.pageBorderBoxCenter, r = e.draggable, n = e.viewport, a = kN(n, t), i = pr(a, r.page.borderBox.center);
  return kt(r.client.borderBox.center, i);
}, UC = function(e) {
  var t = e.draggable, r = e.destination, n = e.newPageBorderBoxCenter, a = e.viewport, i = e.withDroppableDisplacement, o = e.onlyOnMainAxis, s = o === void 0 ? !1 : o, c = pr(n, t.page.borderBox.center), u = Vo(t.page.borderBox, c), d = {
    target: u,
    destination: r,
    withDroppableDisplacement: i,
    viewport: a
  };
  return s ? PN(d) : GC(d);
}, GN = function(e) {
  var t = e.isMovingForward, r = e.draggable, n = e.destination, a = e.draggables, i = e.previousImpact, o = e.viewport, s = e.previousPageBorderBoxCenter, c = e.previousClientSelection, u = e.afterCritical;
  if (!n.isEnabled)
    return null;
  var d = aa(n.descriptor.id, a), h = P2(r, n), A = bN({
    isMovingForward: t,
    draggable: r,
    destination: n,
    insideDestination: d,
    previousImpact: i
  }) || _N({
    isMovingForward: t,
    isInHomeList: h,
    draggable: r,
    draggables: a,
    destination: n,
    insideDestination: d,
    previousImpact: i,
    viewport: o,
    afterCritical: u
  });
  if (!A)
    return null;
  var p = C0({
    impact: A,
    draggable: r,
    droppable: n,
    draggables: a,
    afterCritical: u
  }), m = UC({
    draggable: r,
    destination: n,
    newPageBorderBoxCenter: p,
    viewport: o.frame,
    withDroppableDisplacement: !1,
    onlyOnMainAxis: !0
  });
  if (m) {
    var g = V7({
      pageBorderBoxCenter: p,
      draggable: r,
      viewport: o
    });
    return {
      clientSelection: g,
      impact: A,
      scrollJumpRequest: null
    };
  }
  var v = pr(p, s), C = VN({
    impact: A,
    viewport: o,
    destination: n,
    draggables: a,
    maxScrollChange: v
  });
  return {
    clientSelection: c,
    impact: C,
    scrollJumpRequest: v
  };
}, Kt = function(t) {
  var r = t.subject.active;
  return r || (process.env.NODE_ENV !== "production" ? K(!1, "Cannot get clipped area from droppable") : K(!1)), r;
}, WN = function(e) {
  var t = e.isMovingForward, r = e.pageBorderBoxCenter, n = e.source, a = e.droppables, i = e.viewport, o = n.subject.active;
  if (!o)
    return null;
  var s = n.axis, c = Ir(o[s.start], o[s.end]), u = v0(a).filter(function(h) {
    return h !== n;
  }).filter(function(h) {
    return h.isEnabled;
  }).filter(function(h) {
    return !!h.subject.active;
  }).filter(function(h) {
    return VC(i.frame)(Kt(h));
  }).filter(function(h) {
    var A = Kt(h);
    return t ? o[s.crossAxisEnd] < A[s.crossAxisEnd] : A[s.crossAxisStart] < o[s.crossAxisStart];
  }).filter(function(h) {
    var A = Kt(h), p = Ir(A[s.start], A[s.end]);
    return c(A[s.start]) || c(A[s.end]) || p(o[s.start]) || p(o[s.end]);
  }).sort(function(h, A) {
    var p = Kt(h)[s.crossAxisStart], m = Kt(A)[s.crossAxisStart];
    return t ? p - m : m - p;
  }).filter(function(h, A, p) {
    return Kt(h)[s.crossAxisStart] === Kt(p[0])[s.crossAxisStart];
  });
  if (!u.length)
    return null;
  if (u.length === 1)
    return u[0];
  var d = u.filter(function(h) {
    var A = Ir(Kt(h)[s.start], Kt(h)[s.end]);
    return A(r[s.line]);
  });
  return d.length === 1 ? d[0] : d.length > 1 ? d.sort(function(h, A) {
    return Kt(h)[s.start] - Kt(A)[s.start];
  })[0] : u.sort(function(h, A) {
    var p = $d(r, Fd(Kt(h))), m = $d(r, Fd(Kt(A)));
    return p !== m ? p - m : Kt(h)[s.start] - Kt(A)[s.start];
  })[0];
}, Gd = function(t, r) {
  var n = t.page.borderBox.center;
  return l1(t.descriptor.id, r) ? pr(n, r.displacedBy.point) : n;
}, QN = function(t, r) {
  var n = t.page.borderBox;
  return l1(t.descriptor.id, r) ? Vo(n, E2(r.displacedBy.point)) : n;
}, UN = function(e) {
  var t = e.pageBorderBoxCenter, r = e.viewport, n = e.destination, a = e.insideDestination, i = e.afterCritical, o = a.filter(function(s) {
    return GC({
      target: QN(s, i),
      destination: n,
      viewport: r.frame,
      withDroppableDisplacement: !0
    });
  }).sort(function(s, c) {
    var u = to(t, H4(n, Gd(s, i))), d = to(t, H4(n, Gd(c, i)));
    return u < d ? -1 : d < u ? 1 : s.descriptor.index - c.descriptor.index;
  });
  return o[0] || null;
}, ko = Ft(function(t, r) {
  var n = r[t.line];
  return {
    value: n,
    point: J1(t.line, n)
  };
}), ZN = function(t, r, n) {
  var a = t.axis;
  if (t.descriptor.mode === "virtual")
    return J1(a.line, r[a.line]);
  var i = t.subject.page.contentBox[a.size], o = aa(t.descriptor.id, n), s = o.reduce(function(d, h) {
    return d + h.client.marginBox[a.size];
  }, 0), c = s + r[a.line], u = c - i;
  return u <= 0 ? null : J1(a.line, u);
}, ZC = function(t, r) {
  return we({}, t, {
    scroll: we({}, t.scroll, {
      max: r
    })
  });
}, zC = function(t, r, n) {
  var a = t.frame;
  P2(r, t) && (process.env.NODE_ENV !== "production" ? K(!1, "Should not add placeholder space to home list") : K(!1)), t.subject.withPlaceholder && (process.env.NODE_ENV !== "production" ? K(!1, "Cannot add placeholder size to a subject when it already has one") : K(!1));
  var i = ko(t.axis, r.displaceBy).point, o = ZN(t, i, n), s = {
    placeholderSize: i,
    increasedBy: o,
    oldFrameMaxScroll: t.frame ? t.frame.scroll.max : null
  };
  if (!a) {
    var c = Ua({
      page: t.subject.page,
      withPlaceholder: s,
      axis: t.axis,
      frame: t.frame
    });
    return we({}, t, {
      subject: c
    });
  }
  var u = o ? kt(a.scroll.max, o) : a.scroll.max, d = ZC(a, u), h = Ua({
    page: t.subject.page,
    withPlaceholder: s,
    axis: t.axis,
    frame: d
  });
  return we({}, t, {
    subject: h,
    frame: d
  });
}, zN = function(t) {
  var r = t.subject.withPlaceholder;
  r || (process.env.NODE_ENV !== "production" ? K(!1, "Cannot remove placeholder form subject when there was none") : K(!1));
  var n = t.frame;
  if (!n) {
    var a = Ua({
      page: t.subject.page,
      axis: t.axis,
      frame: null,
      withPlaceholder: null
    });
    return we({}, t, {
      subject: a
    });
  }
  var i = r.oldFrameMaxScroll;
  i || (process.env.NODE_ENV !== "production" ? K(!1, "Expected droppable with frame to have old max frame scroll when removing placeholder") : K(!1));
  var o = ZC(n, i), s = Ua({
    page: t.subject.page,
    axis: t.axis,
    frame: o,
    withPlaceholder: null
  });
  return we({}, t, {
    subject: s,
    frame: o
  });
}, KN = function(e) {
  var t = e.previousPageBorderBoxCenter, r = e.moveRelativeTo, n = e.insideDestination, a = e.draggable, i = e.draggables, o = e.destination, s = e.viewport, c = e.afterCritical;
  if (!r) {
    if (n.length)
      return null;
    var u = {
      displaced: ro,
      displacedBy: YC,
      at: {
        type: "REORDER",
        destination: {
          droppableId: o.descriptor.id,
          index: 0
        }
      }
    }, d = C0({
      impact: u,
      draggable: a,
      droppable: o,
      draggables: i,
      afterCritical: c
    }), h = P2(a, o) ? o : zC(o, a, i), A = UC({
      draggable: a,
      destination: h,
      newPageBorderBoxCenter: d,
      viewport: s.frame,
      withDroppableDisplacement: !1,
      onlyOnMainAxis: !0
    });
    return A ? u : null;
  }
  var p = t[o.axis.line] <= r.page.borderBox.center[o.axis.line], m = function() {
    var v = r.descriptor.index;
    return r.descriptor.id === a.descriptor.id || p ? v : v + 1;
  }(), g = ko(o.axis, a.displaceBy);
  return ns({
    draggable: a,
    insideDestination: n,
    destination: o,
    viewport: s,
    displacedBy: g,
    last: ro,
    index: m
  });
}, qN = function(e) {
  var t = e.isMovingForward, r = e.previousPageBorderBoxCenter, n = e.draggable, a = e.isOver, i = e.draggables, o = e.droppables, s = e.viewport, c = e.afterCritical, u = WN({
    isMovingForward: t,
    pageBorderBoxCenter: r,
    source: a,
    droppables: o,
    viewport: s
  });
  if (!u)
    return null;
  var d = aa(u.descriptor.id, i), h = UN({
    pageBorderBoxCenter: r,
    viewport: s,
    destination: u,
    insideDestination: d,
    afterCritical: c
  }), A = KN({
    previousPageBorderBoxCenter: r,
    destination: u,
    draggable: n,
    draggables: i,
    moveRelativeTo: h,
    insideDestination: d,
    viewport: s,
    afterCritical: c
  });
  if (!A)
    return null;
  var p = C0({
    impact: A,
    draggable: n,
    droppable: u,
    draggables: i,
    afterCritical: c
  }), m = V7({
    pageBorderBoxCenter: p,
    draggable: n,
    viewport: s
  });
  return {
    clientSelection: m,
    impact: A,
    scrollJumpRequest: null
  };
}, vr = function(e) {
  var t = e.at;
  return t ? t.type === "REORDER" ? t.destination.droppableId : t.combine.droppableId : null;
}, XN = function(t, r) {
  var n = vr(t);
  return n ? r[n] : null;
}, JN = function(e) {
  var t = e.state, r = e.type, n = XN(t.impact, t.dimensions.droppables), a = !!n, i = t.dimensions.droppables[t.critical.droppable.id], o = n || i, s = o.axis.direction, c = s === "vertical" && (r === "MOVE_UP" || r === "MOVE_DOWN") || s === "horizontal" && (r === "MOVE_LEFT" || r === "MOVE_RIGHT");
  if (c && !a)
    return null;
  var u = r === "MOVE_DOWN" || r === "MOVE_RIGHT", d = t.dimensions.draggables[t.critical.draggable.id], h = t.current.page.borderBoxCenter, A = t.dimensions, p = A.draggables, m = A.droppables;
  return c ? GN({
    isMovingForward: u,
    previousPageBorderBoxCenter: h,
    draggable: d,
    destination: o,
    draggables: p,
    viewport: t.viewport,
    previousClientSelection: t.current.client.selection,
    previousImpact: t.impact,
    afterCritical: t.afterCritical
  }) : qN({
    isMovingForward: u,
    previousPageBorderBoxCenter: h,
    draggable: d,
    isOver: o,
    draggables: p,
    droppables: m,
    viewport: t.viewport,
    afterCritical: t.afterCritical
  });
};
function R1(e) {
  return e.phase === "DRAGGING" || e.phase === "COLLECTING";
}
function KC(e) {
  var t = Ir(e.top, e.bottom), r = Ir(e.left, e.right);
  return function(a) {
    return t(a.y) && r(a.x);
  };
}
function e_(e, t) {
  return e.left < t.right && e.right > t.left && e.top < t.bottom && e.bottom > t.top;
}
function t_(e) {
  var t = e.pageBorderBox, r = e.draggable, n = e.candidates, a = r.page.borderBox.center, i = n.map(function(o) {
    var s = o.axis, c = J1(o.axis.line, t.center[s.line], o.page.borderBox.center[s.crossAxisLine]);
    return {
      id: o.descriptor.id,
      distance: to(a, c)
    };
  }).sort(function(o, s) {
    return s.distance - o.distance;
  });
  return i[0] ? i[0].id : null;
}
function r_(e) {
  var t = e.pageBorderBox, r = e.draggable, n = e.droppables, a = v0(n).filter(function(i) {
    if (!i.isEnabled)
      return !1;
    var o = i.subject.active;
    if (!o || !e_(t, o))
      return !1;
    if (KC(o)(t.center))
      return !0;
    var s = i.axis, c = o.center[s.crossAxisLine], u = t[s.crossAxisStart], d = t[s.crossAxisEnd], h = Ir(o[s.crossAxisStart], o[s.crossAxisEnd]), A = h(u), p = h(d);
    return !A && !p ? !0 : A ? u < c : d > c;
  });
  return a.length ? a.length === 1 ? a[0].descriptor.id : t_({
    pageBorderBox: t,
    draggable: r,
    candidates: a
  }) : null;
}
var qC = function(t, r) {
  return Yr(Vo(t, r));
}, n_ = function(e, t) {
  var r = e.frame;
  return r ? qC(t, r.scroll.diff.value) : t;
};
function XC(e) {
  var t = e.displaced, r = e.id;
  return !!(t.visible[r] || t.invisible[r]);
}
function a_(e) {
  var t = e.draggable, r = e.closest, n = e.inHomeList;
  return r ? n && r.descriptor.index > t.descriptor.index ? r.descriptor.index - 1 : r.descriptor.index : null;
}
var i_ = function(e) {
  var t = e.pageBorderBoxWithDroppableScroll, r = e.draggable, n = e.destination, a = e.insideDestination, i = e.last, o = e.viewport, s = e.afterCritical, c = n.axis, u = ko(n.axis, r.displaceBy), d = u.value, h = t[c.start], A = t[c.end], p = m0(r, a), m = p1(p, function(v) {
    var C = v.descriptor.id, y = v.page.borderBox.center[c.line], w = l1(C, s), O = XC({
      displaced: i,
      id: C
    });
    return w ? O ? A <= y : h < y - d : O ? A <= y + d : h < y;
  }), g = a_({
    draggable: r,
    closest: m,
    inHomeList: P2(r, n)
  });
  return ns({
    draggable: r,
    insideDestination: a,
    destination: n,
    viewport: o,
    last: i,
    displacedBy: u,
    index: g
  });
}, o_ = 4, s_ = function(e) {
  var t = e.draggable, r = e.pageBorderBoxWithDroppableScroll, n = e.previousImpact, a = e.destination, i = e.insideDestination, o = e.afterCritical;
  if (!a.isCombineEnabled)
    return null;
  var s = a.axis, c = ko(a.axis, t.displaceBy), u = c.value, d = r[s.start], h = r[s.end], A = m0(t, i), p = p1(A, function(g) {
    var v = g.descriptor.id, C = g.page.borderBox, y = C[s.size], w = y / o_, O = l1(v, o), b = XC({
      displaced: n.displaced,
      id: v
    });
    return O ? b ? h > C[s.start] + w && h < C[s.end] - w : d > C[s.start] - u + w && d < C[s.end] - u - w : b ? h > C[s.start] + u + w && h < C[s.end] + u - w : d > C[s.start] + w && d < C[s.end] - w;
  });
  if (!p)
    return null;
  var m = {
    displacedBy: c,
    displaced: n.displaced,
    at: {
      type: "COMBINE",
      combine: {
        draggableId: p.descriptor.id,
        droppableId: a.descriptor.id
      }
    }
  };
  return m;
}, JC = function(e) {
  var t = e.pageOffset, r = e.draggable, n = e.draggables, a = e.droppables, i = e.previousImpact, o = e.viewport, s = e.afterCritical, c = qC(r.page.borderBox, t), u = r_({
    pageBorderBox: c,
    draggable: r,
    droppables: a
  });
  if (!u)
    return yN;
  var d = a[u], h = aa(d.descriptor.id, n), A = n_(d, c);
  return s_({
    pageBorderBoxWithDroppableScroll: A,
    draggable: r,
    previousImpact: i,
    destination: d,
    insideDestination: h,
    afterCritical: s
  }) || i_({
    pageBorderBoxWithDroppableScroll: A,
    draggable: r,
    destination: d,
    insideDestination: h,
    last: i.displaced,
    viewport: o,
    afterCritical: s
  });
}, k7 = function(e, t) {
  var r;
  return we({}, e, (r = {}, r[t.descriptor.id] = t, r));
}, l_ = function(t) {
  var r = t.previousImpact, n = t.impact, a = t.droppables, i = vr(r), o = vr(n);
  if (!i || i === o)
    return a;
  var s = a[i];
  if (!s.subject.withPlaceholder)
    return a;
  var c = zN(s);
  return k7(a, c);
}, c_ = function(e) {
  var t = e.draggable, r = e.draggables, n = e.droppables, a = e.previousImpact, i = e.impact, o = l_({
    previousImpact: a,
    impact: i,
    droppables: n
  }), s = vr(i);
  if (!s)
    return o;
  var c = n[s];
  if (P2(t, c) || c.subject.withPlaceholder)
    return o;
  var u = zC(c, t, r);
  return k7(o, u);
}, Hi = function(e) {
  var t = e.state, r = e.clientSelection, n = e.dimensions, a = e.viewport, i = e.impact, o = e.scrollJumpRequest, s = a || t.viewport, c = n || t.dimensions, u = r || t.current.client.selection, d = pr(u, t.initial.client.selection), h = {
    offset: d,
    selection: u,
    borderBoxCenter: kt(t.initial.client.borderBoxCenter, d)
  }, A = {
    selection: kt(h.selection, s.scroll.current),
    borderBoxCenter: kt(h.borderBoxCenter, s.scroll.current),
    offset: kt(h.offset, s.scroll.diff.value)
  }, p = {
    client: h,
    page: A
  };
  if (t.phase === "COLLECTING")
    return we({
      phase: "COLLECTING"
    }, t, {
      dimensions: c,
      viewport: s,
      current: p
    });
  var m = c.draggables[t.critical.draggable.id], g = i || JC({
    pageOffset: A.offset,
    draggable: m,
    draggables: c.draggables,
    droppables: c.droppables,
    previousImpact: t.impact,
    viewport: s,
    afterCritical: t.afterCritical
  }), v = c_({
    draggable: m,
    impact: g,
    previousImpact: t.impact,
    draggables: c.draggables,
    droppables: c.droppables
  }), C = we({}, t, {
    current: p,
    dimensions: {
      draggables: c.draggables,
      droppables: v
    },
    impact: g,
    viewport: s,
    scrollJumpRequest: o || null,
    forceShouldAnimate: o ? !1 : null
  });
  return C;
};
function u_(e, t) {
  return e.map(function(r) {
    return t[r];
  });
}
var eb = function(e) {
  var t = e.impact, r = e.viewport, n = e.draggables, a = e.destination, i = e.forceShouldAnimate, o = t.displaced, s = u_(o.all, n), c = no({
    afterDragging: s,
    destination: a,
    displacedBy: t.displacedBy,
    viewport: r.frame,
    forceShouldAnimate: i,
    last: o
  });
  return we({}, t, {
    displaced: c
  });
}, tb = function(e) {
  var t = e.impact, r = e.draggable, n = e.droppable, a = e.draggables, i = e.viewport, o = e.afterCritical, s = C0({
    impact: t,
    draggable: r,
    draggables: a,
    droppable: n,
    afterCritical: o
  });
  return V7({
    pageBorderBoxCenter: s,
    draggable: r,
    viewport: i
  });
}, rb = function(e) {
  var t = e.state, r = e.dimensions, n = e.viewport;
  t.movementMode !== "SNAP" && (process.env.NODE_ENV, K(!1));
  var a = t.impact, i = n || t.viewport, o = r || t.dimensions, s = o.draggables, c = o.droppables, u = s[t.critical.draggable.id], d = vr(a);
  d || (process.env.NODE_ENV !== "production" ? K(!1, "Must be over a destination in SNAP movement mode") : K(!1));
  var h = c[d], A = eb({
    impact: a,
    viewport: i,
    destination: h,
    draggables: s
  }), p = tb({
    impact: A,
    draggable: u,
    droppable: h,
    draggables: s,
    viewport: i,
    afterCritical: t.afterCritical
  });
  return Hi({
    impact: A,
    clientSelection: p,
    state: t,
    dimensions: o,
    viewport: i
  });
}, f_ = function(e) {
  return {
    index: e.index,
    droppableId: e.droppableId
  };
}, nb = function(e) {
  var t = e.draggable, r = e.home, n = e.draggables, a = e.viewport, i = ko(r.axis, t.displaceBy), o = aa(r.descriptor.id, n), s = o.indexOf(t);
  s === -1 && (process.env.NODE_ENV !== "production" ? K(!1, "Expected draggable to be inside home list") : K(!1));
  var c = o.slice(s + 1), u = c.reduce(function(p, m) {
    return p[m.descriptor.id] = !0, p;
  }, {}), d = {
    inVirtualList: r.descriptor.mode === "virtual",
    displacedBy: i,
    effected: u
  }, h = no({
    afterDragging: c,
    destination: r,
    displacedBy: i,
    last: null,
    viewport: a.frame,
    forceShouldAnimate: !1
  }), A = {
    displaced: h,
    displacedBy: i,
    at: {
      type: "REORDER",
      destination: f_(t.descriptor)
    }
  };
  return {
    impact: A,
    afterCritical: d
  };
}, d_ = function(e, t) {
  return {
    draggables: e.draggables,
    droppables: k7(e.droppables, t)
  };
}, Go = function(t) {
  process.env.NODE_ENV;
}, Wo = function(t) {
  process.env.NODE_ENV;
}, h_ = function(e) {
  var t = e.draggable, r = e.offset, n = e.initialWindowScroll, a = J3(t.client, r), i = es(a, n), o = we({}, t, {
    placeholder: we({}, t.placeholder, {
      client: a
    }),
    client: a,
    page: i
  });
  return o;
}, A_ = function(e) {
  var t = e.frame;
  return t || (process.env.NODE_ENV !== "production" ? K(!1, "Expected Droppable to have a frame") : K(!1)), t;
}, p_ = function(e) {
  var t = e.additions, r = e.updatedDroppables, n = e.viewport, a = n.scroll.diff.value;
  return t.map(function(i) {
    var o = i.descriptor.droppableId, s = r[o], c = A_(s), u = c.scroll.diff.value, d = kt(a, u), h = h_({
      draggable: i,
      offset: d,
      initialWindowScroll: n.scroll.initial
    });
    return h;
  });
}, v_ = function(e) {
  var t = e.state, r = e.published;
  Go();
  var n = r.modified.map(function(w) {
    var O = t.dimensions.droppables[w.droppableId], b = T7(O, w.scroll);
    return b;
  }), a = we({}, t.dimensions.droppables, {}, FC(n)), i = HC(p_({
    additions: r.additions,
    updatedDroppables: a,
    viewport: t.viewport
  })), o = we({}, t.dimensions.draggables, {}, i);
  r.removals.forEach(function(w) {
    delete o[w];
  });
  var s = {
    droppables: a,
    draggables: o
  }, c = vr(t.impact), u = c ? s.droppables[c] : null, d = s.draggables[t.critical.draggable.id], h = s.droppables[t.critical.droppable.id], A = nb({
    draggable: d,
    home: h,
    draggables: o,
    viewport: t.viewport
  }), p = A.impact, m = A.afterCritical, g = u && u.isCombineEnabled ? t.impact : p, v = JC({
    pageOffset: t.current.page.offset,
    draggable: s.draggables[t.critical.draggable.id],
    draggables: s.draggables,
    droppables: s.droppables,
    previousImpact: g,
    viewport: t.viewport,
    afterCritical: m
  });
  Wo();
  var C = we({
    phase: "DRAGGING"
  }, t, {
    phase: "DRAGGING",
    impact: v,
    onLiftImpact: p,
    dimensions: s,
    afterCritical: m,
    forceShouldAnimate: !1
  });
  if (t.phase === "COLLECTING")
    return C;
  var y = we({
    phase: "DROP_PENDING"
  }, C, {
    phase: "DROP_PENDING",
    reason: t.reason,
    isWaiting: !1
  });
  return y;
}, Y4 = function(t) {
  return t.movementMode === "SNAP";
}, j6 = function(t, r, n) {
  var a = d_(t.dimensions, r);
  return !Y4(t) || n ? Hi({
    state: t,
    dimensions: a
  }) : rb({
    state: t,
    dimensions: a
  });
};
function S6(e) {
  return e.isDragging && e.movementMode === "SNAP" ? we({
    phase: "DRAGGING"
  }, e, {
    scrollJumpRequest: null
  }) : e;
}
var Wd = {
  phase: "IDLE",
  completed: null,
  shouldFlush: !1
}, g_ = function(e, t) {
  if (e === void 0 && (e = Wd), t.type === "FLUSH")
    return we({}, Wd, {
      shouldFlush: !0
    });
  if (t.type === "INITIAL_PUBLISH") {
    e.phase !== "IDLE" && (process.env.NODE_ENV !== "production" ? K(!1, "INITIAL_PUBLISH must come after a IDLE phase") : K(!1));
    var r = t.payload, n = r.critical, a = r.clientSelection, i = r.viewport, o = r.dimensions, s = r.movementMode, c = o.draggables[n.draggable.id], u = o.droppables[n.droppable.id], d = {
      selection: a,
      borderBoxCenter: c.client.borderBox.center,
      offset: Ht
    }, h = {
      client: d,
      page: {
        selection: kt(d.selection, i.scroll.initial),
        borderBoxCenter: kt(d.selection, i.scroll.initial),
        offset: kt(d.selection, i.scroll.diff.value)
      }
    }, A = v0(o.droppables).every(function(k) {
      return !k.isFixedOnPage;
    }), p = nb({
      draggable: c,
      home: u,
      draggables: o.draggables,
      viewport: i
    }), m = p.impact, g = p.afterCritical, v = {
      phase: "DRAGGING",
      isDragging: !0,
      critical: n,
      movementMode: s,
      dimensions: o,
      initial: h,
      current: h,
      isWindowScrollAllowed: A,
      impact: m,
      afterCritical: g,
      onLiftImpact: m,
      viewport: i,
      scrollJumpRequest: null,
      forceShouldAnimate: null
    };
    return v;
  }
  if (t.type === "COLLECTION_STARTING") {
    if (e.phase === "COLLECTING" || e.phase === "DROP_PENDING")
      return e;
    e.phase !== "DRAGGING" && (process.env.NODE_ENV !== "production" ? K(!1, "Collection cannot start from phase " + e.phase) : K(!1));
    var C = we({
      phase: "COLLECTING"
    }, e, {
      phase: "COLLECTING"
    });
    return C;
  }
  if (t.type === "PUBLISH_WHILE_DRAGGING")
    return e.phase === "COLLECTING" || e.phase === "DROP_PENDING" || (process.env.NODE_ENV !== "production" ? K(!1, "Unexpected " + t.type + " received in phase " + e.phase) : K(!1)), v_({
      state: e,
      published: t.payload
    });
  if (t.type === "MOVE") {
    if (e.phase === "DROP_PENDING")
      return e;
    R1(e) || (process.env.NODE_ENV !== "production" ? K(!1, t.type + " not permitted in phase " + e.phase) : K(!1));
    var y = t.payload.client;
    return r1(y, e.current.client.selection) ? e : Hi({
      state: e,
      clientSelection: y,
      impact: Y4(e) ? e.impact : null
    });
  }
  if (t.type === "UPDATE_DROPPABLE_SCROLL") {
    if (e.phase === "DROP_PENDING" || e.phase === "COLLECTING")
      return S6(e);
    R1(e) || (process.env.NODE_ENV !== "production" ? K(!1, t.type + " not permitted in phase " + e.phase) : K(!1));
    var w = t.payload, O = w.id, b = w.newScroll, D = e.dimensions.droppables[O];
    if (!D)
      return e;
    var M = T7(D, b);
    return j6(e, M, !1);
  }
  if (t.type === "UPDATE_DROPPABLE_IS_ENABLED") {
    if (e.phase === "DROP_PENDING")
      return e;
    R1(e) || (process.env.NODE_ENV !== "production" ? K(!1, "Attempting to move in an unsupported phase " + e.phase) : K(!1));
    var j = t.payload, P = j.id, H = j.isEnabled, F = e.dimensions.droppables[P];
    F || (process.env.NODE_ENV !== "production" ? K(!1, "Cannot find Droppable[id: " + P + "] to toggle its enabled state") : K(!1)), F.isEnabled === H && (process.env.NODE_ENV !== "production" ? K(!1, "Trying to set droppable isEnabled to " + String(H) + `
      but it is already ` + String(F.isEnabled)) : K(!1));
    var R = we({}, F, {
      isEnabled: H
    });
    return j6(e, R, !0);
  }
  if (t.type === "UPDATE_DROPPABLE_IS_COMBINE_ENABLED") {
    if (e.phase === "DROP_PENDING")
      return e;
    R1(e) || (process.env.NODE_ENV !== "production" ? K(!1, "Attempting to move in an unsupported phase " + e.phase) : K(!1));
    var N = t.payload, z = N.id, q = N.isCombineEnabled, J = e.dimensions.droppables[z];
    J || (process.env.NODE_ENV !== "production" ? K(!1, "Cannot find Droppable[id: " + z + "] to toggle its isCombineEnabled state") : K(!1)), J.isCombineEnabled === q && (process.env.NODE_ENV !== "production" ? K(!1, "Trying to set droppable isCombineEnabled to " + String(q) + `
      but it is already ` + String(J.isCombineEnabled)) : K(!1));
    var W = we({}, J, {
      isCombineEnabled: q
    });
    return j6(e, W, !0);
  }
  if (t.type === "MOVE_BY_WINDOW_SCROLL") {
    if (e.phase === "DROP_PENDING" || e.phase === "DROP_ANIMATING")
      return e;
    R1(e) || (process.env.NODE_ENV !== "production" ? K(!1, "Cannot move by window in phase " + e.phase) : K(!1)), e.isWindowScrollAllowed || (process.env.NODE_ENV !== "production" ? K(!1, "Window scrolling is currently not supported for fixed lists") : K(!1));
    var te = t.payload.newScroll;
    if (r1(e.viewport.scroll.current, te))
      return S6(e);
    var S = QC(e.viewport, te);
    return Y4(e) ? rb({
      state: e,
      viewport: S
    }) : Hi({
      state: e,
      viewport: S
    });
  }
  if (t.type === "UPDATE_VIEWPORT_MAX_SCROLL") {
    if (!R1(e))
      return e;
    var I = t.payload.maxScroll;
    if (r1(I, e.viewport.scroll.max))
      return e;
    var T = we({}, e.viewport, {
      scroll: we({}, e.viewport.scroll, {
        max: I
      })
    });
    return we({
      phase: "DRAGGING"
    }, e, {
      viewport: T
    });
  }
  if (t.type === "MOVE_UP" || t.type === "MOVE_DOWN" || t.type === "MOVE_LEFT" || t.type === "MOVE_RIGHT") {
    if (e.phase === "COLLECTING" || e.phase === "DROP_PENDING")
      return e;
    e.phase !== "DRAGGING" && (process.env.NODE_ENV !== "production" ? K(!1, t.type + " received while not in DRAGGING phase") : K(!1));
    var E = JN({
      state: e,
      type: t.type
    });
    return E ? Hi({
      state: e,
      impact: E.impact,
      clientSelection: E.clientSelection,
      scrollJumpRequest: E.scrollJumpRequest
    }) : e;
  }
  if (t.type === "DROP_PENDING") {
    var x = t.payload.reason;
    e.phase !== "COLLECTING" && (process.env.NODE_ENV !== "production" ? K(!1, "Can only move into the DROP_PENDING phase from the COLLECTING phase") : K(!1));
    var $ = we({
      phase: "DROP_PENDING"
    }, e, {
      phase: "DROP_PENDING",
      isWaiting: !0,
      reason: x
    });
    return $;
  }
  if (t.type === "DROP_ANIMATE") {
    var _ = t.payload, Q = _.completed, Z = _.dropDuration, X = _.newHomeClientOffset;
    e.phase === "DRAGGING" || e.phase === "DROP_PENDING" || (process.env.NODE_ENV !== "production" ? K(!1, "Cannot animate drop from phase " + e.phase) : K(!1));
    var Y = {
      phase: "DROP_ANIMATING",
      completed: Q,
      dropDuration: Z,
      newHomeClientOffset: X,
      dimensions: e.dimensions
    };
    return Y;
  }
  if (t.type === "DROP_COMPLETE") {
    var U = t.payload.completed;
    return {
      phase: "IDLE",
      completed: U,
      shouldFlush: !1
    };
  }
  return e;
}, m_ = function(t) {
  return {
    type: "BEFORE_INITIAL_CAPTURE",
    payload: t
  };
}, C_ = function(t) {
  return {
    type: "LIFT",
    payload: t
  };
}, b_ = function(t) {
  return {
    type: "INITIAL_PUBLISH",
    payload: t
  };
}, y_ = function(t) {
  return {
    type: "PUBLISH_WHILE_DRAGGING",
    payload: t
  };
}, w_ = function() {
  return {
    type: "COLLECTION_STARTING",
    payload: null
  };
}, x_ = function(t) {
  return {
    type: "UPDATE_DROPPABLE_SCROLL",
    payload: t
  };
}, O_ = function(t) {
  return {
    type: "UPDATE_DROPPABLE_IS_ENABLED",
    payload: t
  };
}, D_ = function(t) {
  return {
    type: "UPDATE_DROPPABLE_IS_COMBINE_ENABLED",
    payload: t
  };
}, ab = function(t) {
  return {
    type: "MOVE",
    payload: t
  };
}, M_ = function(t) {
  return {
    type: "MOVE_BY_WINDOW_SCROLL",
    payload: t
  };
}, E_ = function(t) {
  return {
    type: "UPDATE_VIEWPORT_MAX_SCROLL",
    payload: t
  };
}, P_ = function() {
  return {
    type: "MOVE_UP",
    payload: null
  };
}, j_ = function() {
  return {
    type: "MOVE_DOWN",
    payload: null
  };
}, S_ = function() {
  return {
    type: "MOVE_RIGHT",
    payload: null
  };
}, I_ = function() {
  return {
    type: "MOVE_LEFT",
    payload: null
  };
}, G7 = function() {
  return {
    type: "FLUSH",
    payload: null
  };
}, B_ = function(t) {
  return {
    type: "DROP_ANIMATE",
    payload: t
  };
}, W7 = function(t) {
  return {
    type: "DROP_COMPLETE",
    payload: t
  };
}, ib = function(t) {
  return {
    type: "DROP",
    payload: t
  };
}, N_ = function(t) {
  return {
    type: "DROP_PENDING",
    payload: t
  };
}, ob = function() {
  return {
    type: "DROP_ANIMATION_FINISHED",
    payload: null
  };
};
function __(e) {
  if (!(e.length <= 1)) {
    for (var t = e.map(function(s) {
      return s.descriptor.index;
    }), r = {}, n = 1; n < t.length; n++) {
      var a = t[n], i = t[n - 1];
      a !== i + 1 && (r[a] = !0);
    }
    if (Object.keys(r).length) {
      var o = t.map(function(s) {
        var c = !!r[s];
        return c ? "[🔥" + s + "]" : "" + s;
      }).join(", ");
      process.env.NODE_ENV !== "production" && ut(`
    Detected non-consecutive <Draggable /> indexes.

    (This can cause unexpected bugs)

    ` + o + `
  `);
    }
  }
}
function L_(e, t) {
  if (process.env.NODE_ENV !== "production") {
    var r = aa(e.droppable.id, t.draggables);
    __(r);
  }
}
var T_ = function(e) {
  return function(t) {
    var r = t.getState, n = t.dispatch;
    return function(a) {
      return function(i) {
        if (i.type !== "LIFT") {
          a(i);
          return;
        }
        var o = i.payload, s = o.id, c = o.clientSelection, u = o.movementMode, d = r();
        d.phase === "DROP_ANIMATING" && n(W7({
          completed: d.completed
        })), r().phase !== "IDLE" && (process.env.NODE_ENV !== "production" ? K(!1, "Unexpected phase to start a drag") : K(!1)), n(G7()), n(m_({
          draggableId: s,
          movementMode: u
        }));
        var h = {
          shouldPublishImmediately: u === "SNAP"
        }, A = {
          draggableId: s,
          scrollOptions: h
        }, p = e.startPublishing(A), m = p.critical, g = p.dimensions, v = p.viewport;
        L_(m, g), n(b_({
          critical: m,
          dimensions: g,
          clientSelection: c,
          movementMode: u,
          viewport: v
        }));
      };
    };
  };
}, R_ = function(e) {
  return function() {
    return function(t) {
      return function(r) {
        r.type === "INITIAL_PUBLISH" && e.dragging(), r.type === "DROP_ANIMATE" && e.dropping(r.payload.completed.result.reason), (r.type === "FLUSH" || r.type === "DROP_COMPLETE") && e.resting(), t(r);
      };
    };
  };
}, Q7 = {
  outOfTheWay: "cubic-bezier(0.2, 0, 0, 1)",
  drop: "cubic-bezier(.2,1,.1,1)"
}, ao = {
  opacity: {
    drop: 0,
    combining: 0.7
  },
  scale: {
    drop: 0.75
  }
}, U7 = {
  outOfTheWay: 0.2,
  minDropTime: 0.33,
  maxDropTime: 0.55
}, E1 = U7.outOfTheWay + "s " + Q7.outOfTheWay, Yi = {
  fluid: "opacity " + E1,
  snap: "transform " + E1 + ", opacity " + E1,
  drop: function(t) {
    var r = t + "s " + Q7.drop;
    return "transform " + r + ", opacity " + r;
  },
  outOfTheWay: "transform " + E1,
  placeholder: "height " + E1 + ", width " + E1 + ", margin " + E1
}, Qd = function(t) {
  return r1(t, Ht) ? null : "translate(" + t.x + "px, " + t.y + "px)";
}, V4 = {
  moveTo: Qd,
  drop: function(t, r) {
    var n = Qd(t);
    return n ? r ? n + " scale(" + ao.scale.drop + ")" : n : null;
  }
}, k4 = U7.minDropTime, sb = U7.maxDropTime, $_ = sb - k4, Ud = 1500, F_ = 0.6, H_ = function(e) {
  var t = e.current, r = e.destination, n = e.reason, a = to(t, r);
  if (a <= 0)
    return k4;
  if (a >= Ud)
    return sb;
  var i = a / Ud, o = k4 + $_ * i, s = n === "CANCEL" ? o * F_ : o;
  return Number(s.toFixed(2));
}, Y_ = function(e) {
  var t = e.impact, r = e.draggable, n = e.dimensions, a = e.viewport, i = e.afterCritical, o = n.draggables, s = n.droppables, c = vr(t), u = c ? s[c] : null, d = s[r.descriptor.droppableId], h = tb({
    impact: t,
    draggable: r,
    draggables: o,
    afterCritical: i,
    droppable: u || d,
    viewport: a
  }), A = pr(h, r.client.borderBox.center);
  return A;
}, V_ = function(e) {
  var t = e.draggables, r = e.reason, n = e.lastImpact, a = e.home, i = e.viewport, o = e.onLiftImpact;
  if (!n.at || r !== "DROP") {
    var s = eb({
      draggables: t,
      impact: o,
      destination: a,
      viewport: i,
      forceShouldAnimate: !0
    });
    return {
      impact: s,
      didDropInsideDroppable: !1
    };
  }
  if (n.at.type === "REORDER")
    return {
      impact: n,
      didDropInsideDroppable: !0
    };
  var c = we({}, n, {
    displaced: ro
  });
  return {
    impact: c,
    didDropInsideDroppable: !0
  };
}, k_ = function(e) {
  var t = e.getState, r = e.dispatch;
  return function(n) {
    return function(a) {
      if (a.type !== "DROP") {
        n(a);
        return;
      }
      var i = t(), o = a.payload.reason;
      if (i.phase === "COLLECTING") {
        r(N_({
          reason: o
        }));
        return;
      }
      if (i.phase !== "IDLE") {
        var s = i.phase === "DROP_PENDING" && i.isWaiting;
        s && (process.env.NODE_ENV !== "production" ? K(!1, "A DROP action occurred while DROP_PENDING and still waiting") : K(!1)), i.phase === "DRAGGING" || i.phase === "DROP_PENDING" || (process.env.NODE_ENV !== "production" ? K(!1, "Cannot drop in phase: " + i.phase) : K(!1));
        var c = i.critical, u = i.dimensions, d = u.draggables[i.critical.draggable.id], h = V_({
          reason: o,
          lastImpact: i.impact,
          afterCritical: i.afterCritical,
          onLiftImpact: i.onLiftImpact,
          home: i.dimensions.droppables[i.critical.droppable.id],
          viewport: i.viewport,
          draggables: i.dimensions.draggables
        }), A = h.impact, p = h.didDropInsideDroppable, m = p ? $7(A) : null, g = p ? g0(A) : null, v = {
          index: c.draggable.index,
          droppableId: c.droppable.id
        }, C = {
          draggableId: d.descriptor.id,
          type: d.descriptor.type,
          source: v,
          reason: o,
          mode: i.movementMode,
          destination: m,
          combine: g
        }, y = Y_({
          impact: A,
          draggable: d,
          dimensions: u,
          viewport: i.viewport,
          afterCritical: i.afterCritical
        }), w = {
          critical: i.critical,
          afterCritical: i.afterCritical,
          result: C,
          impact: A
        }, O = !r1(i.current.client.offset, y) || !!C.combine;
        if (!O) {
          r(W7({
            completed: w
          }));
          return;
        }
        var b = H_({
          current: i.current.client.offset,
          destination: y,
          reason: o
        }), D = {
          newHomeClientOffset: y,
          dropDuration: b,
          completed: w
        };
        r(B_(D));
      }
    };
  };
}, lb = function() {
  return {
    x: window.pageXOffset,
    y: window.pageYOffset
  };
};
function G_(e) {
  return {
    eventName: "scroll",
    options: {
      passive: !0,
      capture: !1
    },
    fn: function(r) {
      r.target !== window && r.target !== window.document || e();
    }
  };
}
function W_(e) {
  var t = e.onWindowScroll;
  function r() {
    t(lb());
  }
  var n = Ji(r), a = G_(n), i = t1;
  function o() {
    return i !== t1;
  }
  function s() {
    o() && (process.env.NODE_ENV !== "production" ? K(!1, "Cannot start scroll listener when already active") : K(!1)), i = Pr(window, [a]);
  }
  function c() {
    o() || (process.env.NODE_ENV !== "production" ? K(!1, "Cannot stop scroll listener when not active") : K(!1)), n.cancel(), i(), i = t1;
  }
  return {
    start: s,
    stop: c,
    isActive: o
  };
}
var Q_ = function(t) {
  return t.type === "DROP_COMPLETE" || t.type === "DROP_ANIMATE" || t.type === "FLUSH";
}, U_ = function(e) {
  var t = W_({
    onWindowScroll: function(n) {
      e.dispatch(M_({
        newScroll: n
      }));
    }
  });
  return function(r) {
    return function(n) {
      !t.isActive() && n.type === "INITIAL_PUBLISH" && t.start(), t.isActive() && Q_(n) && t.stop(), r(n);
    };
  };
}, Z_ = function(e) {
  var t = !1, r = !1, n = setTimeout(function() {
    r = !0;
  }), a = function(o) {
    if (t) {
      process.env.NODE_ENV !== "production" && ut("Announcement already made. Not making a second announcement");
      return;
    }
    if (r) {
      process.env.NODE_ENV !== "production" && ut(`
        Announcements cannot be made asynchronously.
        Default message has already been announced.
      `);
      return;
    }
    t = !0, e(o), clearTimeout(n);
  };
  return a.wasCalled = function() {
    return t;
  }, a;
}, z_ = function() {
  var e = [], t = function(i) {
    var o = R7(e, function(u) {
      return u.timerId === i;
    });
    o === -1 && (process.env.NODE_ENV !== "production" ? K(!1, "Could not find timer") : K(!1));
    var s = e.splice(o, 1), c = s[0];
    c.callback();
  }, r = function(i) {
    var o = setTimeout(function() {
      return t(o);
    }), s = {
      timerId: o,
      callback: i
    };
    e.push(s);
  }, n = function() {
    if (e.length) {
      var i = [].concat(e);
      e.length = 0, i.forEach(function(o) {
        clearTimeout(o.timerId), o.callback();
      });
    }
  };
  return {
    add: r,
    flush: n
  };
}, K_ = function(t, r) {
  return t == null && r == null ? !0 : t == null || r == null ? !1 : t.droppableId === r.droppableId && t.index === r.index;
}, q_ = function(t, r) {
  return t == null && r == null ? !0 : t == null || r == null ? !1 : t.draggableId === r.draggableId && t.droppableId === r.droppableId;
}, X_ = function(t, r) {
  if (t === r)
    return !0;
  var n = t.draggable.id === r.draggable.id && t.draggable.droppableId === r.draggable.droppableId && t.draggable.type === r.draggable.type && t.draggable.index === r.draggable.index, a = t.droppable.id === r.droppable.id && t.droppable.type === r.droppable.type;
  return n && a;
}, di = function(t, r) {
  Go(), r(), Wo();
}, C3 = function(t, r) {
  return {
    draggableId: t.draggable.id,
    type: t.droppable.type,
    source: {
      droppableId: t.droppable.id,
      index: t.draggable.index
    },
    mode: r
  };
}, I6 = function(t, r, n, a) {
  if (!t) {
    n(a(r));
    return;
  }
  var i = Z_(n), o = {
    announce: i
  };
  t(r, o), i.wasCalled() || n(a(r));
}, J_ = function(e, t) {
  var r = z_(), n = null, a = function(A, p) {
    n && (process.env.NODE_ENV !== "production" ? K(!1, "Cannot fire onBeforeCapture as a drag start has already been published") : K(!1)), di("onBeforeCapture", function() {
      var m = e().onBeforeCapture;
      if (m) {
        var g = {
          draggableId: A,
          mode: p
        };
        m(g);
      }
    });
  }, i = function(A, p) {
    n && (process.env.NODE_ENV !== "production" ? K(!1, "Cannot fire onBeforeDragStart as a drag start has already been published") : K(!1)), di("onBeforeDragStart", function() {
      var m = e().onBeforeDragStart;
      m && m(C3(A, p));
    });
  }, o = function(A, p) {
    n && (process.env.NODE_ENV !== "production" ? K(!1, "Cannot fire onBeforeDragStart as a drag start has already been published") : K(!1));
    var m = C3(A, p);
    n = {
      mode: p,
      lastCritical: A,
      lastLocation: m.source,
      lastCombine: null
    }, r.add(function() {
      di("onDragStart", function() {
        return I6(e().onDragStart, m, t, Z3.onDragStart);
      });
    });
  }, s = function(A, p) {
    var m = $7(p), g = g0(p);
    n || (process.env.NODE_ENV !== "production" ? K(!1, "Cannot fire onDragMove when onDragStart has not been called") : K(!1));
    var v = !X_(A, n.lastCritical);
    v && (n.lastCritical = A);
    var C = !K_(n.lastLocation, m);
    C && (n.lastLocation = m);
    var y = !q_(n.lastCombine, g);
    if (y && (n.lastCombine = g), !(!v && !C && !y)) {
      var w = we({}, C3(A, n.mode), {
        combine: g,
        destination: m
      });
      r.add(function() {
        di("onDragUpdate", function() {
          return I6(e().onDragUpdate, w, t, Z3.onDragUpdate);
        });
      });
    }
  }, c = function() {
    n || (process.env.NODE_ENV !== "production" ? K(!1, "Can only flush responders while dragging") : K(!1)), r.flush();
  }, u = function(A) {
    n || (process.env.NODE_ENV !== "production" ? K(!1, "Cannot fire onDragEnd when there is no matching onDragStart") : K(!1)), n = null, di("onDragEnd", function() {
      return I6(e().onDragEnd, A, t, Z3.onDragEnd);
    });
  }, d = function() {
    if (n) {
      var A = we({}, C3(n.lastCritical, n.mode), {
        combine: null,
        destination: null,
        reason: "CANCEL"
      });
      u(A);
    }
  };
  return {
    beforeCapture: a,
    beforeStart: i,
    start: o,
    update: s,
    flush: c,
    drop: u,
    abort: d
  };
}, eL = function(e, t) {
  var r = J_(e, t);
  return function(n) {
    return function(a) {
      return function(i) {
        if (i.type === "BEFORE_INITIAL_CAPTURE") {
          r.beforeCapture(i.payload.draggableId, i.payload.movementMode);
          return;
        }
        if (i.type === "INITIAL_PUBLISH") {
          var o = i.payload.critical;
          r.beforeStart(o, i.payload.movementMode), a(i), r.start(o, i.payload.movementMode);
          return;
        }
        if (i.type === "DROP_COMPLETE") {
          var s = i.payload.completed.result;
          r.flush(), a(i), r.drop(s);
          return;
        }
        if (a(i), i.type === "FLUSH") {
          r.abort();
          return;
        }
        var c = n.getState();
        c.phase === "DRAGGING" && r.update(c.critical, c.impact);
      };
    };
  };
}, tL = function(e) {
  return function(t) {
    return function(r) {
      if (r.type !== "DROP_ANIMATION_FINISHED") {
        t(r);
        return;
      }
      var n = e.getState();
      n.phase !== "DROP_ANIMATING" && (process.env.NODE_ENV !== "production" ? K(!1, "Cannot finish a drop animating when no drop is occurring") : K(!1)), e.dispatch(W7({
        completed: n.completed
      }));
    };
  };
}, rL = function(e) {
  var t = null, r = null;
  function n() {
    r && (cancelAnimationFrame(r), r = null), t && (t(), t = null);
  }
  return function(a) {
    return function(i) {
      if ((i.type === "FLUSH" || i.type === "DROP_COMPLETE" || i.type === "DROP_ANIMATION_FINISHED") && n(), a(i), i.type === "DROP_ANIMATE") {
        var o = {
          eventName: "scroll",
          options: {
            capture: !0,
            passive: !1,
            once: !0
          },
          fn: function() {
            var c = e.getState();
            c.phase === "DROP_ANIMATING" && e.dispatch(ob());
          }
        };
        r = requestAnimationFrame(function() {
          r = null, t = Pr(window, [o]);
        });
      }
    };
  };
}, nL = function(e) {
  return function() {
    return function(t) {
      return function(r) {
        (r.type === "DROP_COMPLETE" || r.type === "FLUSH" || r.type === "DROP_ANIMATE") && e.stopPublishing(), t(r);
      };
    };
  };
}, aL = function(e) {
  var t = !1;
  return function() {
    return function(r) {
      return function(n) {
        if (n.type === "INITIAL_PUBLISH") {
          t = !0, e.tryRecordFocus(n.payload.critical.draggable.id), r(n), e.tryRestoreFocusRecorded();
          return;
        }
        if (r(n), !!t) {
          if (n.type === "FLUSH") {
            t = !1, e.tryRestoreFocusRecorded();
            return;
          }
          if (n.type === "DROP_COMPLETE") {
            t = !1;
            var a = n.payload.completed.result;
            a.combine && e.tryShiftRecord(a.draggableId, a.combine.draggableId), e.tryRestoreFocusRecorded();
          }
        }
      };
    };
  };
}, iL = function(t) {
  return t.type === "DROP_COMPLETE" || t.type === "DROP_ANIMATE" || t.type === "FLUSH";
}, oL = function(e) {
  return function(t) {
    return function(r) {
      return function(n) {
        if (iL(n)) {
          e.stop(), r(n);
          return;
        }
        if (n.type === "INITIAL_PUBLISH") {
          r(n);
          var a = t.getState();
          a.phase !== "DRAGGING" && (process.env.NODE_ENV !== "production" ? K(!1, "Expected phase to be DRAGGING after INITIAL_PUBLISH") : K(!1)), e.start(a);
          return;
        }
        r(n), e.scroll(t.getState());
      };
    };
  };
}, sL = function(e) {
  return function(t) {
    return function(r) {
      if (t(r), r.type === "PUBLISH_WHILE_DRAGGING") {
        var n = e.getState();
        n.phase === "DROP_PENDING" && (n.isWaiting || e.dispatch(ib({
          reason: n.reason
        })));
      }
    };
  };
}, lL = process.env.NODE_ENV !== "production" && typeof window < "u" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
  name: "react-beautiful-dnd"
}) : mC, cL = function(e) {
  var t = e.dimensionMarshal, r = e.focusMarshal, n = e.styleMarshal, a = e.getResponders, i = e.announce, o = e.autoScroller;
  return gC(g_, lL(VI(R_(n), nL(t), T_(t), k_, tL, rL, sL, oL(o), U_, aL(r), eL(a, i))));
}, B6 = function() {
  return {
    additions: {},
    removals: {},
    modified: {}
  };
};
function uL(e) {
  var t = e.registry, r = e.callbacks, n = B6(), a = null, i = function() {
    a || (r.collectionStarting(), a = requestAnimationFrame(function() {
      a = null, Go();
      var d = n, h = d.additions, A = d.removals, p = d.modified, m = Object.keys(h).map(function(C) {
        return t.draggable.getById(C).getDimension(Ht);
      }).sort(function(C, y) {
        return C.descriptor.index - y.descriptor.index;
      }), g = Object.keys(p).map(function(C) {
        var y = t.droppable.getById(C), w = y.callbacks.getScrollWhileDragging();
        return {
          droppableId: C,
          scroll: w
        };
      }), v = {
        additions: m,
        removals: Object.keys(A),
        modified: g
      };
      n = B6(), Wo(), r.publish(v);
    }));
  }, o = function(d) {
    var h = d.descriptor.id;
    n.additions[h] = d, n.modified[d.descriptor.droppableId] = !0, n.removals[h] && delete n.removals[h], i();
  }, s = function(d) {
    var h = d.descriptor;
    n.removals[h.id] = !0, n.modified[h.droppableId] = !0, n.additions[h.id] && delete n.additions[h.id], i();
  }, c = function() {
    a && (cancelAnimationFrame(a), a = null, n = B6());
  };
  return {
    add: o,
    remove: s,
    stop: c
  };
}
var cb = function(e) {
  var t = e.scrollHeight, r = e.scrollWidth, n = e.height, a = e.width, i = pr({
    x: r,
    y: t
  }, {
    x: a,
    y: n
  }), o = {
    x: Math.max(0, i.x),
    y: Math.max(0, i.y)
  };
  return o;
}, ub = function() {
  var e = document.documentElement;
  return e || (process.env.NODE_ENV !== "production" ? K(!1, "Cannot find document.documentElement") : K(!1)), e;
}, fb = function() {
  var e = ub(), t = cb({
    scrollHeight: e.scrollHeight,
    scrollWidth: e.scrollWidth,
    width: e.clientWidth,
    height: e.clientHeight
  });
  return t;
}, fL = function() {
  var e = lb(), t = fb(), r = e.y, n = e.x, a = ub(), i = a.clientWidth, o = a.clientHeight, s = n + i, c = r + o, u = Yr({
    top: r,
    left: n,
    right: s,
    bottom: c
  }), d = {
    frame: u,
    scroll: {
      initial: e,
      current: e,
      max: t,
      diff: {
        value: Ht,
        displacement: Ht
      }
    }
  };
  return d;
}, dL = function(e) {
  var t = e.critical, r = e.scrollOptions, n = e.registry;
  Go();
  var a = fL(), i = a.scroll.current, o = t.droppable, s = n.droppable.getAllByType(o.type).map(function(h) {
    return h.callbacks.getDimensionAndWatchScroll(i, r);
  }), c = n.draggable.getAllByType(t.draggable.type).map(function(h) {
    return h.getDimension(i);
  }), u = {
    draggables: HC(c),
    droppables: FC(s)
  };
  Wo();
  var d = {
    dimensions: u,
    critical: t,
    viewport: a
  };
  return d;
};
function Zd(e, t, r) {
  if (r.descriptor.id === t.id || r.descriptor.type !== t.type)
    return !1;
  var n = e.droppable.getById(r.descriptor.droppableId);
  return n.descriptor.mode !== "virtual" ? (process.env.NODE_ENV !== "production" && ut(`
      You are attempting to add or remove a Draggable [id: ` + r.descriptor.id + `]
      while a drag is occurring. This is only supported for virtual lists.

      See https://github.com/atlassian/react-beautiful-dnd/blob/master/docs/patterns/virtual-lists.md
    `), !1) : !0;
}
var hL = function(e, t) {
  var r = null, n = uL({
    callbacks: {
      publish: t.publishWhileDragging,
      collectionStarting: t.collectionStarting
    },
    registry: e
  }), a = function(p, m) {
    e.droppable.exists(p) || (process.env.NODE_ENV !== "production" ? K(!1, "Cannot update is enabled flag of Droppable " + p + " as it is not registered") : K(!1)), r && t.updateDroppableIsEnabled({
      id: p,
      isEnabled: m
    });
  }, i = function(p, m) {
    r && (e.droppable.exists(p) || (process.env.NODE_ENV !== "production" ? K(!1, "Cannot update isCombineEnabled flag of Droppable " + p + " as it is not registered") : K(!1)), t.updateDroppableIsCombineEnabled({
      id: p,
      isCombineEnabled: m
    }));
  }, o = function(p, m) {
    r && (e.droppable.exists(p) || (process.env.NODE_ENV !== "production" ? K(!1, "Cannot update the scroll on Droppable " + p + " as it is not registered") : K(!1)), t.updateDroppableScroll({
      id: p,
      newScroll: m
    }));
  }, s = function(p, m) {
    r && e.droppable.getById(p).callbacks.scroll(m);
  }, c = function() {
    if (r) {
      n.stop();
      var p = r.critical.droppable;
      e.droppable.getAllByType(p.type).forEach(function(m) {
        return m.callbacks.dragStopped();
      }), r.unsubscribe(), r = null;
    }
  }, u = function(p) {
    r || (process.env.NODE_ENV !== "production" ? K(!1, "Should only be subscribed when a collection is occurring") : K(!1));
    var m = r.critical.draggable;
    p.type === "ADDITION" && Zd(e, m, p.value) && n.add(p.value), p.type === "REMOVAL" && Zd(e, m, p.value) && n.remove(p.value);
  }, d = function(p) {
    r && (process.env.NODE_ENV !== "production" ? K(!1, "Cannot start capturing critical dimensions as there is already a collection") : K(!1));
    var m = e.draggable.getById(p.draggableId), g = e.droppable.getById(m.descriptor.droppableId), v = {
      draggable: m.descriptor,
      droppable: g.descriptor
    }, C = e.subscribe(u);
    return r = {
      critical: v,
      unsubscribe: C
    }, dL({
      critical: v,
      registry: e,
      scrollOptions: p.scrollOptions
    });
  }, h = {
    updateDroppableIsEnabled: a,
    updateDroppableIsCombineEnabled: i,
    scrollDroppable: s,
    updateDroppableScroll: o,
    startPublishing: d,
    stopPublishing: c
  };
  return h;
}, db = function(e, t) {
  return e.phase === "IDLE" ? !0 : e.phase !== "DROP_ANIMATING" || e.completed.result.draggableId === t ? !1 : e.completed.result.reason === "DROP";
}, AL = function(e) {
  window.scrollBy(e.x, e.y);
}, pL = Ft(function(e) {
  return v0(e).filter(function(t) {
    return !(!t.isEnabled || !t.frame);
  });
}), vL = function(t, r) {
  var n = p1(pL(r), function(a) {
    return a.frame || (process.env.NODE_ENV !== "production" ? K(!1, "Invalid result") : K(!1)), KC(a.frame.pageMarginBox)(t);
  });
  return n;
}, gL = function(e) {
  var t = e.center, r = e.destination, n = e.droppables;
  if (r) {
    var a = n[r];
    return a.frame ? a : null;
  }
  var i = vL(t, n);
  return i;
}, n1 = {
  startFromPercentage: 0.25,
  maxScrollAtPercentage: 0.05,
  maxPixelScroll: 28,
  ease: function(t) {
    return Math.pow(t, 2);
  },
  durationDampening: {
    stopDampeningAt: 1200,
    accelerateAt: 360
  }
}, mL = function(e, t) {
  var r = e[t.size] * n1.startFromPercentage, n = e[t.size] * n1.maxScrollAtPercentage, a = {
    startScrollingFrom: r,
    maxScrollValueAt: n
  };
  return a;
}, hb = function(e) {
  var t = e.startOfRange, r = e.endOfRange, n = e.current, a = r - t;
  if (a === 0)
    return process.env.NODE_ENV !== "production" && ut(`
      Detected distance range of 0 in the fluid auto scroller
      This is unexpected and would cause a divide by 0 issue.
      Not allowing an auto scroll
    `), 0;
  var i = n - t, o = i / a;
  return o;
}, Z7 = 1, CL = function(e, t) {
  if (e > t.startScrollingFrom)
    return 0;
  if (e <= t.maxScrollValueAt)
    return n1.maxPixelScroll;
  if (e === t.startScrollingFrom)
    return Z7;
  var r = hb({
    startOfRange: t.maxScrollValueAt,
    endOfRange: t.startScrollingFrom,
    current: e
  }), n = 1 - r, a = n1.maxPixelScroll * n1.ease(n);
  return Math.ceil(a);
}, zd = n1.durationDampening.accelerateAt, Kd = n1.durationDampening.stopDampeningAt, bL = function(e, t) {
  var r = t, n = Kd, a = Date.now(), i = a - r;
  if (i >= Kd)
    return e;
  if (i < zd)
    return Z7;
  var o = hb({
    startOfRange: zd,
    endOfRange: n,
    current: i
  }), s = e * n1.ease(o);
  return Math.ceil(s);
}, qd = function(e) {
  var t = e.distanceToEdge, r = e.thresholds, n = e.dragStartTime, a = e.shouldUseTimeDampening, i = CL(t, r);
  return i === 0 ? 0 : a ? Math.max(bL(i, n), Z7) : i;
}, Xd = function(e) {
  var t = e.container, r = e.distanceToEdges, n = e.dragStartTime, a = e.axis, i = e.shouldUseTimeDampening, o = mL(t, a), s = r[a.end] < r[a.start];
  return s ? qd({
    distanceToEdge: r[a.end],
    thresholds: o,
    dragStartTime: n,
    shouldUseTimeDampening: i
  }) : -1 * qd({
    distanceToEdge: r[a.start],
    thresholds: o,
    dragStartTime: n,
    shouldUseTimeDampening: i
  });
}, yL = function(e) {
  var t = e.container, r = e.subject, n = e.proposedScroll, a = r.height > t.height, i = r.width > t.width;
  return !i && !a ? n : i && a ? null : {
    x: i ? 0 : n.x,
    y: a ? 0 : n.y
  };
}, wL = RC(function(e) {
  return e === 0 ? 0 : e;
}), Ab = function(e) {
  var t = e.dragStartTime, r = e.container, n = e.subject, a = e.center, i = e.shouldUseTimeDampening, o = {
    top: a.y - r.top,
    right: r.right - a.x,
    bottom: r.bottom - a.y,
    left: a.x - r.left
  }, s = Xd({
    container: r,
    distanceToEdges: o,
    dragStartTime: t,
    axis: F7,
    shouldUseTimeDampening: i
  }), c = Xd({
    container: r,
    distanceToEdges: o,
    dragStartTime: t,
    axis: kC,
    shouldUseTimeDampening: i
  }), u = wL({
    x: c,
    y: s
  });
  if (r1(u, Ht))
    return null;
  var d = yL({
    container: r,
    subject: n,
    proposedScroll: u
  });
  return d ? r1(d, Ht) ? null : d : null;
}, xL = RC(function(e) {
  return e === 0 ? 0 : e > 0 ? 1 : -1;
}), z7 = function() {
  var e = function(r, n) {
    return r < 0 ? r : r > n ? r - n : 0;
  };
  return function(t) {
    var r = t.current, n = t.max, a = t.change, i = kt(r, a), o = {
      x: e(i.x, n.x),
      y: e(i.y, n.y)
    };
    return r1(o, Ht) ? null : o;
  };
}(), pb = function(t) {
  var r = t.max, n = t.current, a = t.change, i = {
    x: Math.max(n.x, r.x),
    y: Math.max(n.y, r.y)
  }, o = xL(a), s = z7({
    max: i,
    current: n,
    change: o
  });
  return !s || o.x !== 0 && s.x === 0 || o.y !== 0 && s.y === 0;
}, K7 = function(t, r) {
  return pb({
    current: t.scroll.current,
    max: t.scroll.max,
    change: r
  });
}, OL = function(t, r) {
  if (!K7(t, r))
    return null;
  var n = t.scroll.max, a = t.scroll.current;
  return z7({
    current: a,
    max: n,
    change: r
  });
}, q7 = function(t, r) {
  var n = t.frame;
  return n ? pb({
    current: n.scroll.current,
    max: n.scroll.max,
    change: r
  }) : !1;
}, DL = function(t, r) {
  var n = t.frame;
  return !n || !q7(t, r) ? null : z7({
    current: n.scroll.current,
    max: n.scroll.max,
    change: r
  });
}, ML = function(e) {
  var t = e.viewport, r = e.subject, n = e.center, a = e.dragStartTime, i = e.shouldUseTimeDampening, o = Ab({
    dragStartTime: a,
    container: t.frame,
    subject: r,
    center: n,
    shouldUseTimeDampening: i
  });
  return o && K7(t, o) ? o : null;
}, EL = function(e) {
  var t = e.droppable, r = e.subject, n = e.center, a = e.dragStartTime, i = e.shouldUseTimeDampening, o = t.frame;
  if (!o)
    return null;
  var s = Ab({
    dragStartTime: a,
    container: o.pageMarginBox,
    subject: r,
    center: n,
    shouldUseTimeDampening: i
  });
  return s && q7(t, s) ? s : null;
}, Jd = function(e) {
  var t = e.state, r = e.dragStartTime, n = e.shouldUseTimeDampening, a = e.scrollWindow, i = e.scrollDroppable, o = t.current.page.borderBoxCenter, s = t.dimensions.draggables[t.critical.draggable.id], c = s.page.marginBox;
  if (t.isWindowScrollAllowed) {
    var u = t.viewport, d = ML({
      dragStartTime: r,
      viewport: u,
      subject: c,
      center: o,
      shouldUseTimeDampening: n
    });
    if (d) {
      a(d);
      return;
    }
  }
  var h = gL({
    center: o,
    destination: vr(t.impact),
    droppables: t.dimensions.droppables
  });
  if (h) {
    var A = EL({
      dragStartTime: r,
      droppable: h,
      subject: c,
      center: o,
      shouldUseTimeDampening: n
    });
    A && i(h.descriptor.id, A);
  }
}, PL = function(e) {
  var t = e.scrollWindow, r = e.scrollDroppable, n = Ji(t), a = Ji(r), i = null, o = function(d) {
    i || (process.env.NODE_ENV !== "production" ? K(!1, "Cannot fluid scroll if not dragging") : K(!1));
    var h = i, A = h.shouldUseTimeDampening, p = h.dragStartTime;
    Jd({
      state: d,
      scrollWindow: n,
      scrollDroppable: a,
      dragStartTime: p,
      shouldUseTimeDampening: A
    });
  }, s = function(d) {
    Go(), i && (process.env.NODE_ENV !== "production" ? K(!1, "Cannot start auto scrolling when already started") : K(!1));
    var h = Date.now(), A = !1, p = function() {
      A = !0;
    };
    Jd({
      state: d,
      dragStartTime: 0,
      shouldUseTimeDampening: !1,
      scrollWindow: p,
      scrollDroppable: p
    }), i = {
      dragStartTime: h,
      shouldUseTimeDampening: A
    }, Wo(), A && o(d);
  }, c = function() {
    i && (n.cancel(), a.cancel(), i = null);
  };
  return {
    start: s,
    stop: c,
    scroll: o
  };
}, jL = function(e) {
  var t = e.move, r = e.scrollDroppable, n = e.scrollWindow, a = function(u, d) {
    var h = kt(u.current.client.selection, d);
    t({
      client: h
    });
  }, i = function(u, d) {
    if (!q7(u, d))
      return d;
    var h = DL(u, d);
    if (!h)
      return r(u.descriptor.id, d), null;
    var A = pr(d, h);
    r(u.descriptor.id, A);
    var p = pr(d, A);
    return p;
  }, o = function(u, d, h) {
    if (!u || !K7(d, h))
      return h;
    var A = OL(d, h);
    if (!A)
      return n(h), null;
    var p = pr(h, A);
    n(p);
    var m = pr(h, p);
    return m;
  }, s = function(u) {
    var d = u.scrollJumpRequest;
    if (d) {
      var h = vr(u.impact);
      h || (process.env.NODE_ENV !== "production" ? K(!1, "Cannot perform a jump scroll when there is no destination") : K(!1));
      var A = i(u.dimensions.droppables[h], d);
      if (A) {
        var p = u.viewport, m = o(u.isWindowScrollAllowed, p, A);
        m && a(u, m);
      }
    }
  };
  return s;
}, SL = function(e) {
  var t = e.scrollDroppable, r = e.scrollWindow, n = e.move, a = PL({
    scrollWindow: r,
    scrollDroppable: t
  }), i = jL({
    move: n,
    scrollWindow: r,
    scrollDroppable: t
  }), o = function(u) {
    if (u.phase === "DRAGGING") {
      if (u.movementMode === "FLUID") {
        a.scroll(u);
        return;
      }
      u.scrollJumpRequest && i(u);
    }
  }, s = {
    scroll: o,
    start: a.start,
    stop: a.stop
  };
  return s;
}, Za = "data-rbd", za = function() {
  var e = Za + "-drag-handle";
  return {
    base: e,
    draggableId: e + "-draggable-id",
    contextId: e + "-context-id"
  };
}(), G4 = function() {
  var e = Za + "-draggable";
  return {
    base: e,
    contextId: e + "-context-id",
    id: e + "-id"
  };
}(), IL = function() {
  var e = Za + "-droppable";
  return {
    base: e,
    contextId: e + "-context-id",
    id: e + "-id"
  };
}(), eh = {
  contextId: Za + "-scroll-container-context-id"
}, BL = function(t) {
  return function(r) {
    return "[" + r + '="' + t + '"]';
  };
}, hi = function(t, r) {
  return t.map(function(n) {
    var a = n.styles[r];
    return a ? n.selector + " { " + a + " }" : "";
  }).join(" ");
}, NL = "pointer-events: none;", _L = function(e) {
  var t = BL(e), r = function() {
    var s = `
      cursor: -webkit-grab;
      cursor: grab;
    `;
    return {
      selector: t(za.contextId),
      styles: {
        always: `
          -webkit-touch-callout: none;
          -webkit-tap-highlight-color: rgba(0,0,0,0);
          touch-action: manipulation;
        `,
        resting: s,
        dragging: NL,
        dropAnimating: s
      }
    };
  }(), n = function() {
    var s = `
      transition: ` + Yi.outOfTheWay + `;
    `;
    return {
      selector: t(G4.contextId),
      styles: {
        dragging: s,
        dropAnimating: s,
        userCancel: s
      }
    };
  }(), a = {
    selector: t(IL.contextId),
    styles: {
      always: "overflow-anchor: none;"
    }
  }, i = {
    selector: "body",
    styles: {
      dragging: `
        cursor: grabbing;
        cursor: -webkit-grabbing;
        user-select: none;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        overflow-anchor: none;
      `
    }
  }, o = [n, r, a, i];
  return {
    always: hi(o, "always"),
    resting: hi(o, "resting"),
    dragging: hi(o, "dragging"),
    dropAnimating: hi(o, "dropAnimating"),
    userCancel: hi(o, "userCancel")
  };
}, gr = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u" ? sC : Ie, N6 = function() {
  var t = document.querySelector("head");
  return t || (process.env.NODE_ENV !== "production" ? K(!1, "Cannot find the head to append a style to") : K(!1)), t;
}, th = function(t) {
  var r = document.createElement("style");
  return t && r.setAttribute("nonce", t), r.type = "text/css", r;
};
function LL(e, t) {
  var r = He(function() {
    return _L(e);
  }, [e]), n = ge(null), a = ge(null), i = pe(Ft(function(h) {
    var A = a.current;
    A || (process.env.NODE_ENV !== "production" ? K(!1, "Cannot set dynamic style element if it is not set") : K(!1)), A.textContent = h;
  }), []), o = pe(function(h) {
    var A = n.current;
    A || (process.env.NODE_ENV !== "production" ? K(!1, "Cannot set dynamic style element if it is not set") : K(!1)), A.textContent = h;
  }, []);
  gr(function() {
    !n.current && !a.current || (process.env.NODE_ENV !== "production" ? K(!1, "style elements already mounted") : K(!1));
    var h = th(t), A = th(t);
    return n.current = h, a.current = A, h.setAttribute(Za + "-always", e), A.setAttribute(Za + "-dynamic", e), N6().appendChild(h), N6().appendChild(A), o(r.always), i(r.resting), function() {
      var p = function(g) {
        var v = g.current;
        v || (process.env.NODE_ENV !== "production" ? K(!1, "Cannot unmount ref as it is not set") : K(!1)), N6().removeChild(v), g.current = null;
      };
      p(n), p(a);
    };
  }, [t, o, i, r.always, r.resting, e]);
  var s = pe(function() {
    return i(r.dragging);
  }, [i, r.dragging]), c = pe(function(h) {
    if (h === "DROP") {
      i(r.dropAnimating);
      return;
    }
    i(r.userCancel);
  }, [i, r.dropAnimating, r.userCancel]), u = pe(function() {
    a.current && i(r.resting);
  }, [i, r.resting]), d = He(function() {
    return {
      dragging: s,
      dropping: c,
      resting: u
    };
  }, [s, c, u]);
  return d;
}
var vb = function(e) {
  return e && e.ownerDocument ? e.ownerDocument.defaultView : window;
};
function Qo(e) {
  return e instanceof vb(e).HTMLElement;
}
function gb(e, t) {
  var r = "[" + za.contextId + '="' + e + '"]', n = $C(document.querySelectorAll(r));
  if (!n.length)
    return process.env.NODE_ENV !== "production" && ut('Unable to find any drag handles in the context "' + e + '"'), null;
  var a = p1(n, function(i) {
    return i.getAttribute(za.draggableId) === t;
  });
  return a ? Qo(a) ? a : (process.env.NODE_ENV !== "production" && ut("drag handle needs to be a HTMLElement"), null) : (process.env.NODE_ENV !== "production" && ut('Unable to find drag handle with id "' + t + '" as no handle with a matching id was found'), null);
}
function TL(e) {
  var t = ge({}), r = ge(null), n = ge(null), a = ge(!1), i = pe(function(A, p) {
    var m = {
      id: A,
      focus: p
    };
    return t.current[A] = m, function() {
      var v = t.current, C = v[A];
      C !== m && delete v[A];
    };
  }, []), o = pe(function(A) {
    var p = gb(e, A);
    p && p !== document.activeElement && p.focus();
  }, [e]), s = pe(function(A, p) {
    r.current === A && (r.current = p);
  }, []), c = pe(function() {
    n.current || a.current && (n.current = requestAnimationFrame(function() {
      n.current = null;
      var A = r.current;
      A && o(A);
    }));
  }, [o]), u = pe(function(A) {
    r.current = null;
    var p = document.activeElement;
    p && p.getAttribute(za.draggableId) === A && (r.current = A);
  }, []);
  gr(function() {
    return a.current = !0, function() {
      a.current = !1;
      var A = n.current;
      A && cancelAnimationFrame(A);
    };
  }, []);
  var d = He(function() {
    return {
      register: i,
      tryRecordFocus: u,
      tryRestoreFocusRecorded: c,
      tryShiftRecord: s
    };
  }, [i, u, c, s]);
  return d;
}
function RL() {
  var e = {
    draggables: {},
    droppables: {}
  }, t = [];
  function r(h) {
    return t.push(h), function() {
      var p = t.indexOf(h);
      p !== -1 && t.splice(p, 1);
    };
  }
  function n(h) {
    t.length && t.forEach(function(A) {
      return A(h);
    });
  }
  function a(h) {
    return e.draggables[h] || null;
  }
  function i(h) {
    var A = a(h);
    return A || (process.env.NODE_ENV !== "production" ? K(!1, "Cannot find draggable entry with id [" + h + "]") : K(!1)), A;
  }
  var o = {
    register: function(A) {
      e.draggables[A.descriptor.id] = A, n({
        type: "ADDITION",
        value: A
      });
    },
    update: function(A, p) {
      var m = e.draggables[p.descriptor.id];
      m && m.uniqueId === A.uniqueId && (delete e.draggables[p.descriptor.id], e.draggables[A.descriptor.id] = A);
    },
    unregister: function(A) {
      var p = A.descriptor.id, m = a(p);
      m && A.uniqueId === m.uniqueId && (delete e.draggables[p], n({
        type: "REMOVAL",
        value: A
      }));
    },
    getById: i,
    findById: a,
    exists: function(A) {
      return !!a(A);
    },
    getAllByType: function(A) {
      return rs(e.draggables).filter(function(p) {
        return p.descriptor.type === A;
      });
    }
  };
  function s(h) {
    return e.droppables[h] || null;
  }
  function c(h) {
    var A = s(h);
    return A || (process.env.NODE_ENV !== "production" ? K(!1, "Cannot find droppable entry with id [" + h + "]") : K(!1)), A;
  }
  var u = {
    register: function(A) {
      e.droppables[A.descriptor.id] = A;
    },
    unregister: function(A) {
      var p = s(A.descriptor.id);
      p && A.uniqueId === p.uniqueId && delete e.droppables[A.descriptor.id];
    },
    getById: c,
    findById: s,
    exists: function(A) {
      return !!s(A);
    },
    getAllByType: function(A) {
      return rs(e.droppables).filter(function(p) {
        return p.descriptor.type === A;
      });
    }
  };
  function d() {
    e.draggables = {}, e.droppables = {}, t.length = 0;
  }
  return {
    draggable: o,
    droppable: u,
    subscribe: r,
    clean: d
  };
}
function $L() {
  var e = He(RL, []);
  return Ie(function() {
    return function() {
      requestAnimationFrame(e.clean);
    };
  }, [e]), e;
}
var X7 = B.createContext(null), io = function() {
  var e = document.body;
  return e || (process.env.NODE_ENV !== "production" ? K(!1, "Cannot find document.body") : K(!1)), e;
}, FL = {
  position: "absolute",
  width: "1px",
  height: "1px",
  margin: "-1px",
  border: "0",
  padding: "0",
  overflow: "hidden",
  clip: "rect(0 0 0 0)",
  "clip-path": "inset(100%)"
}, HL = function(t) {
  return "rbd-announcement-" + t;
};
function YL(e) {
  var t = He(function() {
    return HL(e);
  }, [e]), r = ge(null);
  Ie(function() {
    var i = document.createElement("div");
    return r.current = i, i.id = t, i.setAttribute("aria-live", "assertive"), i.setAttribute("aria-atomic", "true"), we(i.style, FL), io().appendChild(i), function() {
      setTimeout(function() {
        var c = io();
        c.contains(i) && c.removeChild(i), i === r.current && (r.current = null);
      });
    };
  }, [t]);
  var n = pe(function(a) {
    var i = r.current;
    if (i) {
      i.textContent = a;
      return;
    }
    process.env.NODE_ENV !== "production" && ut(`
      A screen reader message was trying to be announced but it was unable to do so.
      This can occur if you unmount your <DragDropContext /> in your onDragEnd.
      Consider calling provided.announce() before the unmount so that the instruction will
      not be lost for users relying on a screen reader.

      Message not passed to screen reader:

      "` + a + `"
    `);
  }, []);
  return n;
}
var VL = 0, kL = {
  separator: "::"
};
function J7(e, t) {
  return t === void 0 && (t = kL), He(function() {
    return "" + e + t.separator + VL++;
  }, [t.separator, e]);
}
function GL(e) {
  var t = e.contextId, r = e.uniqueId;
  return "rbd-hidden-text-" + t + "-" + r;
}
function WL(e) {
  var t = e.contextId, r = e.text, n = J7("hidden-text", {
    separator: "-"
  }), a = He(function() {
    return GL({
      contextId: t,
      uniqueId: n
    });
  }, [n, t]);
  return Ie(function() {
    var o = document.createElement("div");
    return o.id = a, o.textContent = r, o.style.display = "none", io().appendChild(o), function() {
      var c = io();
      c.contains(o) && c.removeChild(o);
    };
  }, [a, r]), a;
}
var b0 = B.createContext(null), QL = {
  react: "^16.8.5 || ^17.0.0 || ^18.0.0",
  "react-dom": "^16.8.5 || ^17.0.0 || ^18.0.0"
}, UL = /(\d+)\.(\d+)\.(\d+)/, rh = function(t) {
  var r = UL.exec(t);
  r == null && (process.env.NODE_ENV !== "production" ? K(!1, "Unable to parse React version " + t) : K(!1));
  var n = Number(r[1]), a = Number(r[2]), i = Number(r[3]);
  return {
    major: n,
    minor: a,
    patch: i,
    raw: t
  };
}, ZL = function(t, r) {
  return r.major > t.major ? !0 : r.major < t.major ? !1 : r.minor > t.minor ? !0 : r.minor < t.minor ? !1 : r.patch >= t.patch;
}, zL = function(e, t) {
  var r = rh(e), n = rh(t);
  ZL(r, n) || process.env.NODE_ENV !== "production" && ut(`
    React version: [` + n.raw + `]
    does not satisfy expected peer dependency version: [` + r.raw + `]

    This can result in run time bugs, and even fatal crashes
  `);
}, _6 = `
  We expect a html5 doctype: <!doctype html>
  This is to ensure consistent browser layout and measurement

  More information: https://github.com/atlassian/react-beautiful-dnd/blob/master/docs/guides/doctype.md
`, KL = function(e) {
  var t = e.doctype;
  if (!t) {
    process.env.NODE_ENV !== "production" && ut(`
      No <!doctype html> found.

      ` + _6 + `
    `);
    return;
  }
  t.name.toLowerCase() !== "html" && process.env.NODE_ENV !== "production" && ut(`
      Unexpected <!doctype> found: (` + t.name + `)

      ` + _6 + `
    `), t.publicId !== "" && process.env.NODE_ENV !== "production" && ut(`
      Unexpected <!doctype> publicId found: (` + t.publicId + `)
      A html5 doctype does not have a publicId

      ` + _6 + `
    `);
};
function e9(e) {
  process.env.NODE_ENV !== "production" && e();
}
function Uo(e, t) {
  e9(function() {
    Ie(function() {
      try {
        e();
      } catch (r) {
        F4(`
          A setup problem was encountered.

          > ` + r.message + `
        `);
      }
    }, t);
  });
}
function qL() {
  Uo(function() {
    zL(QL.react, B.version), KL(document);
  }, []);
}
function t9(e) {
  var t = ge(e);
  return Ie(function() {
    t.current = e;
  }), t;
}
function XL() {
  var e = null;
  function t() {
    return !!e;
  }
  function r(o) {
    return o === e;
  }
  function n(o) {
    e && (process.env.NODE_ENV !== "production" ? K(!1, "Cannot claim lock as it is already claimed") : K(!1));
    var s = {
      abandon: o
    };
    return e = s, s;
  }
  function a() {
    e || (process.env.NODE_ENV !== "production" ? K(!1, "Cannot release lock when there is no lock") : K(!1)), e = null;
  }
  function i() {
    e && (e.abandon(), a());
  }
  return {
    isClaimed: t,
    isActive: r,
    claim: n,
    release: a,
    tryAbandon: i
  };
}
var JL = 9, eT = 13, r9 = 27, mb = 32, tT = 33, rT = 34, nT = 35, aT = 36, iT = 37, oT = 38, sT = 39, lT = 40, b3, cT = (b3 = {}, b3[eT] = !0, b3[JL] = !0, b3), Cb = function(e) {
  cT[e.keyCode] && e.preventDefault();
}, y0 = function() {
  var e = "visibilitychange";
  if (typeof document > "u")
    return e;
  var t = [e, "ms" + e, "webkit" + e, "moz" + e, "o" + e], r = p1(t, function(n) {
    return "on" + n in document;
  });
  return r || e;
}(), bb = 0, nh = 5;
function uT(e, t) {
  return Math.abs(t.x - e.x) >= nh || Math.abs(t.y - e.y) >= nh;
}
var ah = {
  type: "IDLE"
};
function fT(e) {
  var t = e.cancel, r = e.completed, n = e.getPhase, a = e.setPhase;
  return [{
    eventName: "mousemove",
    fn: function(o) {
      var s = o.button, c = o.clientX, u = o.clientY;
      if (s === bb) {
        var d = {
          x: c,
          y: u
        }, h = n();
        if (h.type === "DRAGGING") {
          o.preventDefault(), h.actions.move(d);
          return;
        }
        h.type !== "PENDING" && (process.env.NODE_ENV !== "production" ? K(!1, "Cannot be IDLE") : K(!1));
        var A = h.point;
        if (uT(A, d)) {
          o.preventDefault();
          var p = h.actions.fluidLift(d);
          a({
            type: "DRAGGING",
            actions: p
          });
        }
      }
    }
  }, {
    eventName: "mouseup",
    fn: function(o) {
      var s = n();
      if (s.type !== "DRAGGING") {
        t();
        return;
      }
      o.preventDefault(), s.actions.drop({
        shouldBlockNextClick: !0
      }), r();
    }
  }, {
    eventName: "mousedown",
    fn: function(o) {
      n().type === "DRAGGING" && o.preventDefault(), t();
    }
  }, {
    eventName: "keydown",
    fn: function(o) {
      var s = n();
      if (s.type === "PENDING") {
        t();
        return;
      }
      if (o.keyCode === r9) {
        o.preventDefault(), t();
        return;
      }
      Cb(o);
    }
  }, {
    eventName: "resize",
    fn: t
  }, {
    eventName: "scroll",
    options: {
      passive: !0,
      capture: !1
    },
    fn: function() {
      n().type === "PENDING" && t();
    }
  }, {
    eventName: "webkitmouseforcedown",
    fn: function(o) {
      var s = n();
      if (s.type === "IDLE" && (process.env.NODE_ENV !== "production" ? K(!1, "Unexpected phase") : K(!1)), s.actions.shouldRespectForcePress()) {
        t();
        return;
      }
      o.preventDefault();
    }
  }, {
    eventName: y0,
    fn: t
  }];
}
function dT(e) {
  var t = ge(ah), r = ge(t1), n = He(function() {
    return {
      eventName: "mousedown",
      fn: function(h) {
        if (!h.defaultPrevented && h.button === bb && !(h.ctrlKey || h.metaKey || h.shiftKey || h.altKey)) {
          var A = e.findClosestDraggableId(h);
          if (A) {
            var p = e.tryGetLock(A, o, {
              sourceEvent: h
            });
            if (p) {
              h.preventDefault();
              var m = {
                x: h.clientX,
                y: h.clientY
              };
              r.current(), u(p, m);
            }
          }
        }
      }
    };
  }, [e]), a = He(function() {
    return {
      eventName: "webkitmouseforcewillbegin",
      fn: function(h) {
        if (!h.defaultPrevented) {
          var A = e.findClosestDraggableId(h);
          if (A) {
            var p = e.findOptionsForDraggable(A);
            p && (p.shouldRespectForcePress || e.canGetLock(A) && h.preventDefault());
          }
        }
      }
    };
  }, [e]), i = pe(function() {
    var h = {
      passive: !1,
      capture: !0
    };
    r.current = Pr(window, [a, n], h);
  }, [a, n]), o = pe(function() {
    var d = t.current;
    d.type !== "IDLE" && (t.current = ah, r.current(), i());
  }, [i]), s = pe(function() {
    var d = t.current;
    o(), d.type === "DRAGGING" && d.actions.cancel({
      shouldBlockNextClick: !0
    }), d.type === "PENDING" && d.actions.abort();
  }, [o]), c = pe(function() {
    var h = {
      capture: !0,
      passive: !1
    }, A = fT({
      cancel: s,
      completed: o,
      getPhase: function() {
        return t.current;
      },
      setPhase: function(m) {
        t.current = m;
      }
    });
    r.current = Pr(window, A, h);
  }, [s, o]), u = pe(function(h, A) {
    t.current.type !== "IDLE" && (process.env.NODE_ENV !== "production" ? K(!1, "Expected to move from IDLE to PENDING drag") : K(!1)), t.current = {
      type: "PENDING",
      point: A,
      actions: h
    }, c();
  }, [c]);
  gr(function() {
    return i(), function() {
      r.current();
    };
  }, [i]);
}
var Da;
function hT() {
}
var AT = (Da = {}, Da[rT] = !0, Da[tT] = !0, Da[aT] = !0, Da[nT] = !0, Da);
function pT(e, t) {
  function r() {
    t(), e.cancel();
  }
  function n() {
    t(), e.drop();
  }
  return [{
    eventName: "keydown",
    fn: function(i) {
      if (i.keyCode === r9) {
        i.preventDefault(), r();
        return;
      }
      if (i.keyCode === mb) {
        i.preventDefault(), n();
        return;
      }
      if (i.keyCode === lT) {
        i.preventDefault(), e.moveDown();
        return;
      }
      if (i.keyCode === oT) {
        i.preventDefault(), e.moveUp();
        return;
      }
      if (i.keyCode === sT) {
        i.preventDefault(), e.moveRight();
        return;
      }
      if (i.keyCode === iT) {
        i.preventDefault(), e.moveLeft();
        return;
      }
      if (AT[i.keyCode]) {
        i.preventDefault();
        return;
      }
      Cb(i);
    }
  }, {
    eventName: "mousedown",
    fn: r
  }, {
    eventName: "mouseup",
    fn: r
  }, {
    eventName: "click",
    fn: r
  }, {
    eventName: "touchstart",
    fn: r
  }, {
    eventName: "resize",
    fn: r
  }, {
    eventName: "wheel",
    fn: r,
    options: {
      passive: !0
    }
  }, {
    eventName: y0,
    fn: r
  }];
}
function vT(e) {
  var t = ge(hT), r = He(function() {
    return {
      eventName: "keydown",
      fn: function(i) {
        if (i.defaultPrevented || i.keyCode !== mb)
          return;
        var o = e.findClosestDraggableId(i);
        if (!o)
          return;
        var s = e.tryGetLock(o, d, {
          sourceEvent: i
        });
        if (!s)
          return;
        i.preventDefault();
        var c = !0, u = s.snapLift();
        t.current();
        function d() {
          c || (process.env.NODE_ENV !== "production" ? K(!1, "Cannot stop capturing a keyboard drag when not capturing") : K(!1)), c = !1, t.current(), n();
        }
        t.current = Pr(window, pT(u, d), {
          capture: !0,
          passive: !1
        });
      }
    };
  }, [e]), n = pe(function() {
    var i = {
      passive: !1,
      capture: !0
    };
    t.current = Pr(window, [r], i);
  }, [r]);
  gr(function() {
    return n(), function() {
      t.current();
    };
  }, [n]);
}
var L6 = {
  type: "IDLE"
}, gT = 120, mT = 0.15;
function CT(e) {
  var t = e.cancel, r = e.getPhase;
  return [{
    eventName: "orientationchange",
    fn: t
  }, {
    eventName: "resize",
    fn: t
  }, {
    eventName: "contextmenu",
    fn: function(a) {
      a.preventDefault();
    }
  }, {
    eventName: "keydown",
    fn: function(a) {
      if (r().type !== "DRAGGING") {
        t();
        return;
      }
      a.keyCode === r9 && a.preventDefault(), t();
    }
  }, {
    eventName: y0,
    fn: t
  }];
}
function bT(e) {
  var t = e.cancel, r = e.completed, n = e.getPhase;
  return [{
    eventName: "touchmove",
    options: {
      capture: !1
    },
    fn: function(i) {
      var o = n();
      if (o.type !== "DRAGGING") {
        t();
        return;
      }
      o.hasMoved = !0;
      var s = i.touches[0], c = s.clientX, u = s.clientY, d = {
        x: c,
        y: u
      };
      i.preventDefault(), o.actions.move(d);
    }
  }, {
    eventName: "touchend",
    fn: function(i) {
      var o = n();
      if (o.type !== "DRAGGING") {
        t();
        return;
      }
      i.preventDefault(), o.actions.drop({
        shouldBlockNextClick: !0
      }), r();
    }
  }, {
    eventName: "touchcancel",
    fn: function(i) {
      if (n().type !== "DRAGGING") {
        t();
        return;
      }
      i.preventDefault(), t();
    }
  }, {
    eventName: "touchforcechange",
    fn: function(i) {
      var o = n();
      o.type === "IDLE" && (process.env.NODE_ENV, K(!1));
      var s = i.touches[0];
      if (s) {
        var c = s.force >= mT;
        if (c) {
          var u = o.actions.shouldRespectForcePress();
          if (o.type === "PENDING") {
            u && t();
            return;
          }
          if (u) {
            if (o.hasMoved) {
              i.preventDefault();
              return;
            }
            t();
            return;
          }
          i.preventDefault();
        }
      }
    }
  }, {
    eventName: y0,
    fn: t
  }];
}
function yT(e) {
  var t = ge(L6), r = ge(t1), n = pe(function() {
    return t.current;
  }, []), a = pe(function(p) {
    t.current = p;
  }, []), i = He(function() {
    return {
      eventName: "touchstart",
      fn: function(p) {
        if (!p.defaultPrevented) {
          var m = e.findClosestDraggableId(p);
          if (m) {
            var g = e.tryGetLock(m, s, {
              sourceEvent: p
            });
            if (g) {
              var v = p.touches[0], C = v.clientX, y = v.clientY, w = {
                x: C,
                y
              };
              r.current(), h(g, w);
            }
          }
        }
      }
    };
  }, [e]), o = pe(function() {
    var p = {
      capture: !0,
      passive: !1
    };
    r.current = Pr(window, [i], p);
  }, [i]), s = pe(function() {
    var A = t.current;
    A.type !== "IDLE" && (A.type === "PENDING" && clearTimeout(A.longPressTimerId), a(L6), r.current(), o());
  }, [o, a]), c = pe(function() {
    var A = t.current;
    s(), A.type === "DRAGGING" && A.actions.cancel({
      shouldBlockNextClick: !0
    }), A.type === "PENDING" && A.actions.abort();
  }, [s]), u = pe(function() {
    var p = {
      capture: !0,
      passive: !1
    }, m = {
      cancel: c,
      completed: s,
      getPhase: n
    }, g = Pr(window, bT(m), p), v = Pr(window, CT(m), p);
    r.current = function() {
      g(), v();
    };
  }, [c, n, s]), d = pe(function() {
    var p = n();
    p.type !== "PENDING" && (process.env.NODE_ENV !== "production" ? K(!1, "Cannot start dragging from phase " + p.type) : K(!1));
    var m = p.actions.fluidLift(p.point);
    a({
      type: "DRAGGING",
      actions: m,
      hasMoved: !1
    });
  }, [n, a]), h = pe(function(p, m) {
    n().type !== "IDLE" && (process.env.NODE_ENV !== "production" ? K(!1, "Expected to move from IDLE to PENDING drag") : K(!1));
    var g = setTimeout(d, gT);
    a({
      type: "PENDING",
      point: m,
      actions: p,
      longPressTimerId: g
    }), u();
  }, [u, n, a, d]);
  gr(function() {
    return o(), function() {
      r.current();
      var m = n();
      m.type === "PENDING" && (clearTimeout(m.longPressTimerId), a(L6));
    };
  }, [n, o, a]), gr(function() {
    var p = Pr(window, [{
      eventName: "touchmove",
      fn: function() {
      },
      options: {
        capture: !1,
        passive: !1
      }
    }]);
    return p;
  }, []);
}
function wT(e) {
  e9(function() {
    var t = t9(e);
    Uo(function() {
      t.current.length !== e.length && (process.env.NODE_ENV !== "production" ? K(!1, "Cannot change the amount of sensor hooks after mounting") : K(!1));
    });
  });
}
var xT = {
  input: !0,
  button: !0,
  textarea: !0,
  select: !0,
  option: !0,
  optgroup: !0,
  video: !0,
  audio: !0
};
function yb(e, t) {
  if (t == null)
    return !1;
  var r = !!xT[t.tagName.toLowerCase()];
  if (r)
    return !0;
  var n = t.getAttribute("contenteditable");
  return n === "true" || n === "" ? !0 : t === e ? !1 : yb(e, t.parentElement);
}
function OT(e, t) {
  var r = t.target;
  return Qo(r) ? yb(e, r) : !1;
}
var DT = function(e) {
  return Yr(e.getBoundingClientRect()).center;
};
function MT(e) {
  return e instanceof vb(e).Element;
}
var ET = function() {
  var e = "matches";
  if (typeof document > "u")
    return e;
  var t = [e, "msMatchesSelector", "webkitMatchesSelector"], r = p1(t, function(n) {
    return n in Element.prototype;
  });
  return r || e;
}();
function wb(e, t) {
  return e == null ? null : e[ET](t) ? e : wb(e.parentElement, t);
}
function PT(e, t) {
  return e.closest ? e.closest(t) : wb(e, t);
}
function jT(e) {
  return "[" + za.contextId + '="' + e + '"]';
}
function ST(e, t) {
  var r = t.target;
  if (!MT(r))
    return process.env.NODE_ENV !== "production" && ut("event.target must be a Element"), null;
  var n = jT(e), a = PT(r, n);
  return a ? Qo(a) ? a : (process.env.NODE_ENV !== "production" && ut("drag handle must be a HTMLElement"), null) : null;
}
function IT(e, t) {
  var r = ST(e, t);
  return r ? r.getAttribute(za.draggableId) : null;
}
function BT(e, t) {
  var r = "[" + G4.contextId + '="' + e + '"]', n = $C(document.querySelectorAll(r)), a = p1(n, function(i) {
    return i.getAttribute(G4.id) === t;
  });
  return a ? Qo(a) ? a : (process.env.NODE_ENV !== "production" && ut("Draggable element is not a HTMLElement"), null) : null;
}
function NT(e) {
  e.preventDefault();
}
function y3(e) {
  var t = e.expected, r = e.phase, n = e.isLockActive, a = e.shouldWarn;
  return n() ? t !== r ? (a && process.env.NODE_ENV !== "production" && ut(`
        Cannot perform action.
        The actions you used belong to an outdated phase

        Current phase: ` + t + `
        You called an action from outdated phase: ` + r + `

        Tips:

        - Do not use preDragActions actions after calling preDragActions.lift()
      `), !1) : !0 : (a && process.env.NODE_ENV !== "production" && ut(`
        Cannot perform action.
        The sensor no longer has an action lock.

        Tips:

        - Throw away your action handlers when forceStop() is called
        - Check actions.isActive() if you really need to
      `), !1);
}
function xb(e) {
  var t = e.lockAPI, r = e.store, n = e.registry, a = e.draggableId;
  if (t.isClaimed())
    return !1;
  var i = n.draggable.findById(a);
  return i ? !(!i.options.isEnabled || !db(r.getState(), a)) : (process.env.NODE_ENV !== "production" && ut("Unable to find draggable with id: " + a), !1);
}
function _T(e) {
  var t = e.lockAPI, r = e.contextId, n = e.store, a = e.registry, i = e.draggableId, o = e.forceSensorStop, s = e.sourceEvent, c = xb({
    lockAPI: t,
    store: n,
    registry: a,
    draggableId: i
  });
  if (!c)
    return null;
  var u = a.draggable.getById(i), d = BT(r, u.descriptor.id);
  if (!d)
    return process.env.NODE_ENV !== "production" && ut("Unable to find draggable element with id: " + i), null;
  if (s && !u.options.canDragInteractiveElements && OT(d, s))
    return null;
  var h = t.claim(o || t1), A = "PRE_DRAG";
  function p() {
    return u.options.shouldRespectForcePress;
  }
  function m() {
    return t.isActive(h);
  }
  function g(D, M) {
    y3({
      expected: D,
      phase: A,
      isLockActive: m,
      shouldWarn: !0
    }) && n.dispatch(M());
  }
  var v = g.bind(null, "DRAGGING");
  function C(D) {
    function M() {
      t.release(), A = "COMPLETED";
    }
    A !== "PRE_DRAG" && (M(), A !== "PRE_DRAG" && (process.env.NODE_ENV !== "production" ? K(!1, "Cannot lift in phase " + A) : K(!1))), n.dispatch(C_(D.liftActionArgs)), A = "DRAGGING";
    function j(P, H) {
      if (H === void 0 && (H = {
        shouldBlockNextClick: !1
      }), D.cleanup(), H.shouldBlockNextClick) {
        var F = Pr(window, [{
          eventName: "click",
          fn: NT,
          options: {
            once: !0,
            passive: !1,
            capture: !0
          }
        }]);
        setTimeout(F);
      }
      M(), n.dispatch(ib({
        reason: P
      }));
    }
    return we({
      isActive: function() {
        return y3({
          expected: "DRAGGING",
          phase: A,
          isLockActive: m,
          shouldWarn: !1
        });
      },
      shouldRespectForcePress: p,
      drop: function(H) {
        return j("DROP", H);
      },
      cancel: function(H) {
        return j("CANCEL", H);
      }
    }, D.actions);
  }
  function y(D) {
    var M = Ji(function(P) {
      v(function() {
        return ab({
          client: P
        });
      });
    }), j = C({
      liftActionArgs: {
        id: i,
        clientSelection: D,
        movementMode: "FLUID"
      },
      cleanup: function() {
        return M.cancel();
      },
      actions: {
        move: M
      }
    });
    return we({}, j, {
      move: M
    });
  }
  function w() {
    var D = {
      moveUp: function() {
        return v(P_);
      },
      moveRight: function() {
        return v(S_);
      },
      moveDown: function() {
        return v(j_);
      },
      moveLeft: function() {
        return v(I_);
      }
    };
    return C({
      liftActionArgs: {
        id: i,
        clientSelection: DT(d),
        movementMode: "SNAP"
      },
      cleanup: t1,
      actions: D
    });
  }
  function O() {
    var D = y3({
      expected: "PRE_DRAG",
      phase: A,
      isLockActive: m,
      shouldWarn: !0
    });
    D && t.release();
  }
  var b = {
    isActive: function() {
      return y3({
        expected: "PRE_DRAG",
        phase: A,
        isLockActive: m,
        shouldWarn: !1
      });
    },
    shouldRespectForcePress: p,
    fluidLift: y,
    snapLift: w,
    abort: O
  };
  return b;
}
var LT = [dT, vT, yT];
function TT(e) {
  var t = e.contextId, r = e.store, n = e.registry, a = e.customSensors, i = e.enableDefaultSensors, o = [].concat(i ? LT : [], a || []), s = De(function() {
    return XL();
  })[0], c = pe(function(y, w) {
    y.isDragging && !w.isDragging && s.tryAbandon();
  }, [s]);
  gr(function() {
    var y = r.getState(), w = r.subscribe(function() {
      var O = r.getState();
      c(y, O), y = O;
    });
    return w;
  }, [s, r, c]), gr(function() {
    return s.tryAbandon;
  }, [s.tryAbandon]);
  var u = pe(function(C) {
    return xb({
      lockAPI: s,
      registry: n,
      store: r,
      draggableId: C
    });
  }, [s, n, r]), d = pe(function(C, y, w) {
    return _T({
      lockAPI: s,
      registry: n,
      contextId: t,
      store: r,
      draggableId: C,
      forceSensorStop: y,
      sourceEvent: w && w.sourceEvent ? w.sourceEvent : null
    });
  }, [t, s, n, r]), h = pe(function(C) {
    return IT(t, C);
  }, [t]), A = pe(function(C) {
    var y = n.draggable.findById(C);
    return y ? y.options : null;
  }, [n.draggable]), p = pe(function() {
    s.isClaimed() && (s.tryAbandon(), r.getState().phase !== "IDLE" && r.dispatch(G7()));
  }, [s, r]), m = pe(s.isClaimed, [s]), g = He(function() {
    return {
      canGetLock: u,
      tryGetLock: d,
      findClosestDraggableId: h,
      findOptionsForDraggable: A,
      tryReleaseLock: p,
      isLockClaimed: m
    };
  }, [u, d, h, A, p, m]);
  wT(o);
  for (var v = 0; v < o.length; v++)
    o[v](g);
}
var RT = function(t) {
  return {
    onBeforeCapture: t.onBeforeCapture,
    onBeforeDragStart: t.onBeforeDragStart,
    onDragStart: t.onDragStart,
    onDragEnd: t.onDragEnd,
    onDragUpdate: t.onDragUpdate
  };
};
function Ai(e) {
  return e.current || (process.env.NODE_ENV !== "production" ? K(!1, "Could not find store from lazy ref") : K(!1)), e.current;
}
function $T(e) {
  var t = e.contextId, r = e.setCallbacks, n = e.sensors, a = e.nonce, i = e.dragHandleUsageInstructions, o = ge(null);
  qL();
  var s = t9(e), c = pe(function() {
    return RT(s.current);
  }, [s]), u = YL(t), d = WL({
    contextId: t,
    text: i
  }), h = LL(t, a), A = pe(function(P) {
    Ai(o).dispatch(P);
  }, []), p = He(function() {
    return ud({
      publishWhileDragging: y_,
      updateDroppableScroll: x_,
      updateDroppableIsEnabled: O_,
      updateDroppableIsCombineEnabled: D_,
      collectionStarting: w_
    }, A);
  }, [A]), m = $L(), g = He(function() {
    return hL(m, p);
  }, [m, p]), v = He(function() {
    return SL(we({
      scrollWindow: AL,
      scrollDroppable: g.scrollDroppable
    }, ud({
      move: ab
    }, A)));
  }, [g.scrollDroppable, A]), C = TL(t), y = He(function() {
    return cL({
      announce: u,
      autoScroller: v,
      dimensionMarshal: g,
      focusMarshal: C,
      getResponders: c,
      styleMarshal: h
    });
  }, [u, v, g, C, c, h]);
  process.env.NODE_ENV !== "production" && o.current && o.current !== y && process.env.NODE_ENV !== "production" && ut("unexpected store change"), o.current = y;
  var w = pe(function() {
    var P = Ai(o), H = P.getState();
    H.phase !== "IDLE" && P.dispatch(G7());
  }, []), O = pe(function() {
    var P = Ai(o).getState();
    return P.isDragging || P.phase === "DROP_ANIMATING";
  }, []), b = He(function() {
    return {
      isDragging: O,
      tryAbort: w
    };
  }, [O, w]);
  r(b);
  var D = pe(function(P) {
    return db(Ai(o).getState(), P);
  }, []), M = pe(function() {
    return R1(Ai(o).getState());
  }, []), j = He(function() {
    return {
      marshal: g,
      focus: C,
      contextId: t,
      canLift: D,
      isMovementAllowed: M,
      dragHandleUsageInstructionsId: d,
      registry: m
    };
  }, [t, g, d, C, D, M, m]);
  return TT({
    contextId: t,
    store: y,
    registry: m,
    customSensors: n,
    enableDefaultSensors: e.enableDefaultSensors !== !1
  }), Ie(function() {
    return w;
  }, [w]), B.createElement(b0.Provider, {
    value: j
  }, B.createElement(OC, {
    context: X7,
    store: y
  }, e.children));
}
var FT = 0;
function HT() {
  return He(function() {
    return "" + FT++;
  }, []);
}
function YT(e) {
  var t = HT(), r = e.dragHandleUsageInstructions || Z3.dragHandleUsageInstructions;
  return B.createElement(lN, null, function(n) {
    return B.createElement($T, {
      nonce: e.nonce,
      contextId: t,
      setCallbacks: n,
      dragHandleUsageInstructions: r,
      enableDefaultSensors: e.enableDefaultSensors,
      sensors: e.sensors,
      onBeforeCapture: e.onBeforeCapture,
      onBeforeDragStart: e.onBeforeDragStart,
      onDragStart: e.onDragStart,
      onDragUpdate: e.onDragUpdate,
      onDragEnd: e.onDragEnd
    }, e.children);
  });
}
var n9 = function(t) {
  return function(r) {
    return t === r;
  };
}, VT = n9("scroll"), kT = n9("auto"), GT = n9("visible"), ih = function(t, r) {
  return r(t.overflowX) || r(t.overflowY);
}, WT = function(t, r) {
  return r(t.overflowX) && r(t.overflowY);
}, Ob = function(t) {
  var r = window.getComputedStyle(t), n = {
    overflowX: r.overflowX,
    overflowY: r.overflowY
  };
  return ih(n, VT) || ih(n, kT);
}, QT = function() {
  if (process.env.NODE_ENV === "production")
    return !1;
  var t = io(), r = document.documentElement;
  if (r || (process.env.NODE_ENV, K(!1)), !Ob(t))
    return !1;
  var n = window.getComputedStyle(r), a = {
    overflowX: n.overflowX,
    overflowY: n.overflowY
  };
  return WT(a, GT) || process.env.NODE_ENV !== "production" && ut(`
    We have detected that your <body> element might be a scroll container.
    We have found no reliable way of detecting whether the <body> element is a scroll container.
    Under most circumstances a <body> scroll bar will be on the <html> element (document.documentElement)

    Because we cannot determine if the <body> is a scroll container, and generally it is not one,
    we will be treating the <body> as *not* a scroll container

    More information: https://github.com/atlassian/react-beautiful-dnd/blob/master/docs/guides/how-we-detect-scroll-containers.md
  `), !1;
}, Db = function e(t) {
  return t == null ? null : t === document.body ? QT() ? t : null : t === document.documentElement ? null : Ob(t) ? t : e(t.parentElement);
}, UT = function(e) {
  if (e) {
    var t = Db(e.parentElement);
    t && process.env.NODE_ENV !== "production" && ut(`
    Droppable: unsupported nested scroll container detected.
    A Droppable can only have one scroll parent (which can be itself)
    Nested scroll containers are currently not supported.

    We hope to support nested scroll containers soon: https://github.com/atlassian/react-beautiful-dnd/issues/131
  `);
  }
}, W4 = function(e) {
  return {
    x: e.scrollLeft,
    y: e.scrollTop
  };
}, ZT = function e(t) {
  if (!t)
    return !1;
  var r = window.getComputedStyle(t);
  return r.position === "fixed" ? !0 : e(t.parentElement);
}, zT = function(e) {
  var t = Db(e), r = ZT(e);
  return {
    closestScrollable: t,
    isFixedOnPage: r
  };
}, KT = function(e) {
  var t = e.descriptor, r = e.isEnabled, n = e.isCombineEnabled, a = e.isFixedOnPage, i = e.direction, o = e.client, s = e.page, c = e.closest, u = function() {
    if (!c)
      return null;
    var p = c.scrollSize, m = c.client, g = cb({
      scrollHeight: p.scrollHeight,
      scrollWidth: p.scrollWidth,
      height: m.paddingBox.height,
      width: m.paddingBox.width
    });
    return {
      pageMarginBox: c.page.marginBox,
      frameClient: m,
      scrollSize: p,
      shouldClipSubject: c.shouldClipSubject,
      scroll: {
        initial: c.scroll,
        current: c.scroll,
        max: g,
        diff: {
          value: Ht,
          displacement: Ht
        }
      }
    };
  }(), d = i === "vertical" ? F7 : kC, h = Ua({
    page: s,
    withPlaceholder: null,
    axis: d,
    frame: u
  }), A = {
    descriptor: t,
    isCombineEnabled: n,
    isFixedOnPage: a,
    axis: d,
    isEnabled: r,
    client: o,
    page: s,
    frame: u,
    subject: h
  };
  return A;
}, qT = function(t, r) {
  var n = NC(t);
  if (!r || t !== r)
    return n;
  var a = n.paddingBox.top - r.scrollTop, i = n.paddingBox.left - r.scrollLeft, o = a + r.scrollHeight, s = i + r.scrollWidth, c = {
    top: a,
    right: s,
    bottom: o,
    left: i
  }, u = _7(c, n.border), d = L7({
    borderBox: u,
    margin: n.margin,
    border: n.border,
    padding: n.padding
  });
  return d;
}, XT = function(e) {
  var t = e.ref, r = e.descriptor, n = e.env, a = e.windowScroll, i = e.direction, o = e.isDropDisabled, s = e.isCombineEnabled, c = e.shouldClipSubject, u = n.closestScrollable, d = qT(t, u), h = es(d, a), A = function() {
    if (!u)
      return null;
    var m = NC(u), g = {
      scrollHeight: u.scrollHeight,
      scrollWidth: u.scrollWidth
    };
    return {
      client: m,
      page: es(m, a),
      scroll: W4(u),
      scrollSize: g,
      shouldClipSubject: c
    };
  }(), p = KT({
    descriptor: r,
    isEnabled: !o,
    isCombineEnabled: s,
    isFixedOnPage: n.isFixedOnPage,
    direction: i,
    client: d,
    page: h,
    closest: A
  });
  return p;
}, JT = {
  passive: !1
}, eR = {
  passive: !0
}, oh = function(e) {
  return e.shouldPublishImmediately ? JT : eR;
};
function as(e) {
  var t = xt(e);
  return t || (process.env.NODE_ENV !== "production" ? K(!1, "Could not find required context") : K(!1)), t;
}
var w3 = function(t) {
  return t && t.env.closestScrollable || null;
};
function tR(e) {
  var t = ge(null), r = as(b0), n = J7("droppable"), a = r.registry, i = r.marshal, o = t9(e), s = He(function() {
    return {
      id: e.droppableId,
      type: e.type,
      mode: e.mode
    };
  }, [e.droppableId, e.mode, e.type]), c = ge(s), u = He(function() {
    return Ft(function(O, b) {
      t.current || (process.env.NODE_ENV !== "production" ? K(!1, "Can only update scroll when dragging") : K(!1));
      var D = {
        x: O,
        y: b
      };
      i.updateDroppableScroll(s.id, D);
    });
  }, [s.id, i]), d = pe(function() {
    var O = t.current;
    return !O || !O.env.closestScrollable ? Ht : W4(O.env.closestScrollable);
  }, []), h = pe(function() {
    var O = d();
    u(O.x, O.y);
  }, [d, u]), A = He(function() {
    return Ji(h);
  }, [h]), p = pe(function() {
    var O = t.current, b = w3(O);
    O && b || (process.env.NODE_ENV !== "production" ? K(!1, "Could not find scroll options while scrolling") : K(!1));
    var D = O.scrollOptions;
    if (D.shouldPublishImmediately) {
      h();
      return;
    }
    A();
  }, [A, h]), m = pe(function(O, b) {
    t.current && (process.env.NODE_ENV !== "production" ? K(!1, "Cannot collect a droppable while a drag is occurring") : K(!1));
    var D = o.current, M = D.getDroppableRef();
    M || (process.env.NODE_ENV !== "production" ? K(!1, "Cannot collect without a droppable ref") : K(!1));
    var j = zT(M), P = {
      ref: M,
      descriptor: s,
      env: j,
      scrollOptions: b
    };
    t.current = P;
    var H = XT({
      ref: M,
      descriptor: s,
      env: j,
      windowScroll: O,
      direction: D.direction,
      isDropDisabled: D.isDropDisabled,
      isCombineEnabled: D.isCombineEnabled,
      shouldClipSubject: !D.ignoreContainerClipping
    }), F = j.closestScrollable;
    return F && (F.setAttribute(eh.contextId, r.contextId), F.addEventListener("scroll", p, oh(P.scrollOptions)), process.env.NODE_ENV !== "production" && UT(F)), H;
  }, [r.contextId, s, p, o]), g = pe(function() {
    var O = t.current, b = w3(O);
    return O && b || (process.env.NODE_ENV !== "production" ? K(!1, "Can only recollect Droppable client for Droppables that have a scroll container") : K(!1)), W4(b);
  }, []), v = pe(function() {
    var O = t.current;
    O || (process.env.NODE_ENV !== "production" ? K(!1, "Cannot stop drag when no active drag") : K(!1));
    var b = w3(O);
    t.current = null, b && (A.cancel(), b.removeAttribute(eh.contextId), b.removeEventListener("scroll", p, oh(O.scrollOptions)));
  }, [p, A]), C = pe(function(O) {
    var b = t.current;
    b || (process.env.NODE_ENV !== "production" ? K(!1, "Cannot scroll when there is no drag") : K(!1));
    var D = w3(b);
    D || (process.env.NODE_ENV !== "production" ? K(!1, "Cannot scroll a droppable with no closest scrollable") : K(!1)), D.scrollTop += O.y, D.scrollLeft += O.x;
  }, []), y = He(function() {
    return {
      getDimensionAndWatchScroll: m,
      getScrollWhileDragging: g,
      dragStopped: v,
      scroll: C
    };
  }, [v, m, g, C]), w = He(function() {
    return {
      uniqueId: n,
      descriptor: s,
      callbacks: y
    };
  }, [y, s, n]);
  gr(function() {
    return c.current = w.descriptor, a.droppable.register(w), function() {
      t.current && (process.env.NODE_ENV !== "production" && ut("Unsupported: changing the droppableId or type of a Droppable during a drag"), v()), a.droppable.unregister(w);
    };
  }, [y, s, v, w, i, a.droppable]), gr(function() {
    t.current && i.updateDroppableIsEnabled(c.current.id, !e.isDropDisabled);
  }, [e.isDropDisabled, i]), gr(function() {
    t.current && i.updateDroppableIsCombineEnabled(c.current.id, e.isCombineEnabled);
  }, [e.isCombineEnabled, i]);
}
function T6() {
}
var sh = {
  width: 0,
  height: 0,
  margin: AN
}, rR = function(t) {
  var r = t.isAnimatingOpenOnMount, n = t.placeholder, a = t.animate;
  return r || a === "close" ? sh : {
    height: n.client.borderBox.height,
    width: n.client.borderBox.width,
    margin: n.client.margin
  };
}, nR = function(t) {
  var r = t.isAnimatingOpenOnMount, n = t.placeholder, a = t.animate, i = rR({
    isAnimatingOpenOnMount: r,
    placeholder: n,
    animate: a
  });
  return {
    display: n.display,
    boxSizing: "border-box",
    width: i.width,
    height: i.height,
    marginTop: i.margin.top,
    marginRight: i.margin.right,
    marginBottom: i.margin.bottom,
    marginLeft: i.margin.left,
    flexShrink: "0",
    flexGrow: "0",
    pointerEvents: "none",
    transition: a !== "none" ? Yi.placeholder : null
  };
};
function aR(e) {
  var t = ge(null), r = pe(function() {
    t.current && (clearTimeout(t.current), t.current = null);
  }, []), n = e.animate, a = e.onTransitionEnd, i = e.onClose, o = e.contextId, s = De(e.animate === "open"), c = s[0], u = s[1];
  Ie(function() {
    return c ? n !== "open" ? (r(), u(!1), T6) : t.current ? T6 : (t.current = setTimeout(function() {
      t.current = null, u(!1);
    }), r) : T6;
  }, [n, c, r]);
  var d = pe(function(A) {
    A.propertyName === "height" && (a(), n === "close" && i());
  }, [n, i, a]), h = nR({
    isAnimatingOpenOnMount: c,
    animate: e.animate,
    placeholder: e.placeholder
  });
  return B.createElement(e.placeholder.tagName, {
    style: h,
    "data-rbd-placeholder-context-id": o,
    onTransitionEnd: d,
    ref: e.innerRef
  });
}
var iR = B.memo(aR), a9 = B.createContext(null);
function Mb(e) {
  e && Qo(e) || (process.env.NODE_ENV !== "production" ? K(!1, `
    provided.innerRef has not been provided with a HTMLElement.

    You can find a guide on using the innerRef callback functions at:
    https://github.com/atlassian/react-beautiful-dnd/blob/master/docs/guides/using-inner-ref.md
  `) : K(!1));
}
function R6(e) {
  return typeof e == "boolean";
}
function $6(e, t) {
  t.forEach(function(r) {
    return r(e);
  });
}
var oR = [function(t) {
  var r = t.props;
  r.droppableId || (process.env.NODE_ENV !== "production" ? K(!1, "A Droppable requires a droppableId prop") : K(!1)), typeof r.droppableId != "string" && (process.env.NODE_ENV !== "production" ? K(!1, "A Droppable requires a [string] droppableId. Provided: [" + typeof r.droppableId + "]") : K(!1));
}, function(t) {
  var r = t.props;
  R6(r.isDropDisabled) || (process.env.NODE_ENV !== "production" ? K(!1, "isDropDisabled must be a boolean") : K(!1)), R6(r.isCombineEnabled) || (process.env.NODE_ENV !== "production" ? K(!1, "isCombineEnabled must be a boolean") : K(!1)), R6(r.ignoreContainerClipping) || (process.env.NODE_ENV !== "production" ? K(!1, "ignoreContainerClipping must be a boolean") : K(!1));
}, function(t) {
  var r = t.getDroppableRef;
  Mb(r());
}], sR = [function(t) {
  var r = t.props, n = t.getPlaceholderRef;
  if (r.placeholder) {
    var a = n();
    a || process.env.NODE_ENV !== "production" && ut(`
      Droppable setup issue [droppableId: "` + r.droppableId + `"]:
      DroppableProvided > placeholder could not be found.

      Please be sure to add the {provided.placeholder} React Node as a child of your Droppable.
      More information: https://github.com/atlassian/react-beautiful-dnd/blob/master/docs/api/droppable.md
    `);
  }
}], lR = [function(t) {
  var r = t.props;
  r.renderClone || (process.env.NODE_ENV !== "production" ? K(!1, "Must provide a clone render function (renderClone) for virtual lists") : K(!1));
}, function(t) {
  var r = t.getPlaceholderRef;
  r() && (process.env.NODE_ENV !== "production" ? K(!1, "Expected virtual list to not have a placeholder") : K(!1));
}];
function cR(e) {
  Uo(function() {
    $6(e, oR), e.props.mode === "standard" && $6(e, sR), e.props.mode === "virtual" && $6(e, lR);
  });
}
var uR = function(e) {
  vC(t, e);
  function t() {
    for (var n, a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return n = e.call.apply(e, [this].concat(i)) || this, n.state = {
      isVisible: !!n.props.on,
      data: n.props.on,
      animate: n.props.shouldAnimate && n.props.on ? "open" : "none"
    }, n.onClose = function() {
      n.state.animate === "close" && n.setState({
        isVisible: !1
      });
    }, n;
  }
  t.getDerivedStateFromProps = function(a, i) {
    return a.shouldAnimate ? a.on ? {
      isVisible: !0,
      data: a.on,
      animate: "open"
    } : i.isVisible ? {
      isVisible: !0,
      data: i.data,
      animate: "close"
    } : {
      isVisible: !1,
      animate: "close",
      data: null
    } : {
      isVisible: !!a.on,
      data: a.on,
      animate: "none"
    };
  };
  var r = t.prototype;
  return r.render = function() {
    if (!this.state.isVisible)
      return null;
    var a = {
      onClose: this.onClose,
      data: this.state.data,
      animate: this.state.animate
    };
    return this.props.children(a);
  }, t;
}(B.PureComponent), lh = {
  dragging: 5e3,
  dropAnimating: 4500
}, fR = function(t, r) {
  return r ? Yi.drop(r.duration) : t ? Yi.snap : Yi.fluid;
}, dR = function(t, r) {
  return t ? r ? ao.opacity.drop : ao.opacity.combining : null;
}, hR = function(t) {
  return t.forceShouldAnimate != null ? t.forceShouldAnimate : t.mode === "SNAP";
};
function AR(e) {
  var t = e.dimension, r = t.client, n = e.offset, a = e.combineWith, i = e.dropping, o = !!a, s = hR(e), c = !!i, u = c ? V4.drop(n, o) : V4.moveTo(n), d = {
    position: "fixed",
    top: r.marginBox.top,
    left: r.marginBox.left,
    boxSizing: "border-box",
    width: r.borderBox.width,
    height: r.borderBox.height,
    transition: fR(s, i),
    transform: u,
    opacity: dR(o, c),
    zIndex: c ? lh.dropAnimating : lh.dragging,
    pointerEvents: "none"
  };
  return d;
}
function pR(e) {
  return {
    transform: V4.moveTo(e.offset),
    transition: e.shouldAnimateDisplacement ? null : "none"
  };
}
function vR(e) {
  return e.type === "DRAGGING" ? AR(e) : pR(e);
}
function gR(e, t, r) {
  r === void 0 && (r = Ht);
  var n = window.getComputedStyle(t), a = t.getBoundingClientRect(), i = BC(a, n), o = es(i, r), s = {
    client: i,
    tagName: t.tagName.toLowerCase(),
    display: n.display
  }, c = {
    x: i.marginBox.width,
    y: i.marginBox.height
  }, u = {
    descriptor: e,
    placeholder: s,
    displaceBy: c,
    client: i,
    page: o
  };
  return u;
}
function mR(e) {
  var t = J7("draggable"), r = e.descriptor, n = e.registry, a = e.getDraggableRef, i = e.canDragInteractiveElements, o = e.shouldRespectForcePress, s = e.isEnabled, c = He(function() {
    return {
      canDragInteractiveElements: i,
      shouldRespectForcePress: o,
      isEnabled: s
    };
  }, [i, s, o]), u = pe(function(p) {
    var m = a();
    return m || (process.env.NODE_ENV !== "production" ? K(!1, "Cannot get dimension when no ref is set") : K(!1)), gR(r, m, p);
  }, [r, a]), d = He(function() {
    return {
      uniqueId: t,
      descriptor: r,
      options: c,
      getDimension: u
    };
  }, [r, u, c, t]), h = ge(d), A = ge(!0);
  gr(function() {
    return n.draggable.register(h.current), function() {
      return n.draggable.unregister(h.current);
    };
  }, [n.draggable]), gr(function() {
    if (A.current) {
      A.current = !1;
      return;
    }
    var p = h.current;
    h.current = d, n.draggable.update(d, p);
  }, [d, n.draggable]);
}
function CR(e, t, r) {
  Uo(function() {
    function n(i) {
      return "Draggable[id: " + i + "]: ";
    }
    var a = e.draggableId;
    a || (process.env.NODE_ENV !== "production" ? K(!1, "Draggable requires a draggableId") : K(!1)), typeof a != "string" && (process.env.NODE_ENV !== "production" ? K(!1, `Draggable requires a [string] draggableId.
      Provided: [type: ` + typeof a + "] (value: " + a + ")") : K(!1)), mN(e.index) || (process.env.NODE_ENV !== "production" ? K(!1, n(a) + " requires an integer index prop") : K(!1)), e.mapped.type !== "DRAGGING" && (Mb(r()), e.isEnabled && (gb(t, a) || (process.env.NODE_ENV !== "production" ? K(!1, n(a) + " Unable to find drag handle") : K(!1))));
  });
}
function bR(e) {
  e9(function() {
    var t = ge(e);
    Uo(function() {
      e !== t.current && (process.env.NODE_ENV !== "production" ? K(!1, "Draggable isClone prop value changed during component life") : K(!1));
    }, [e]);
  });
}
function yR(e) {
  e.preventDefault();
}
function wR(e) {
  var t = ge(null), r = pe(function(P) {
    t.current = P;
  }, []), n = pe(function() {
    return t.current;
  }, []), a = as(b0), i = a.contextId, o = a.dragHandleUsageInstructionsId, s = a.registry, c = as(a9), u = c.type, d = c.droppableId, h = He(function() {
    return {
      id: e.draggableId,
      index: e.index,
      type: u,
      droppableId: d
    };
  }, [e.draggableId, e.index, u, d]), A = e.children, p = e.draggableId, m = e.isEnabled, g = e.shouldRespectForcePress, v = e.canDragInteractiveElements, C = e.isClone, y = e.mapped, w = e.dropAnimationFinished;
  if (CR(e, i, n), bR(C), !C) {
    var O = He(function() {
      return {
        descriptor: h,
        registry: s,
        getDraggableRef: n,
        canDragInteractiveElements: v,
        shouldRespectForcePress: g,
        isEnabled: m
      };
    }, [h, s, n, v, g, m]);
    mR(O);
  }
  var b = He(function() {
    return m ? {
      tabIndex: 0,
      role: "button",
      "aria-describedby": o,
      "data-rbd-drag-handle-draggable-id": p,
      "data-rbd-drag-handle-context-id": i,
      draggable: !1,
      onDragStart: yR
    } : null;
  }, [i, o, p, m]), D = pe(function(P) {
    y.type === "DRAGGING" && y.dropping && P.propertyName === "transform" && w();
  }, [w, y]), M = He(function() {
    var P = vR(y), H = y.type === "DRAGGING" && y.dropping ? D : null, F = {
      innerRef: r,
      draggableProps: {
        "data-rbd-draggable-context-id": i,
        "data-rbd-draggable-id": p,
        style: P,
        onTransitionEnd: H
      },
      dragHandleProps: b
    };
    return F;
  }, [i, b, p, y, D, r]), j = He(function() {
    return {
      draggableId: h.id,
      type: h.type,
      source: {
        index: h.index,
        droppableId: h.droppableId
      }
    };
  }, [h.droppableId, h.id, h.index, h.type]);
  return A(M, y.snapshot, j);
}
var Eb = function(e, t) {
  return e === t;
}, Pb = function(e) {
  var t = e.combine, r = e.destination;
  return r ? r.droppableId : t ? t.droppableId : null;
}, xR = function(t) {
  return t.combine ? t.combine.draggableId : null;
}, OR = function(t) {
  return t.at && t.at.type === "COMBINE" ? t.at.combine.draggableId : null;
};
function DR() {
  var e = Ft(function(a, i) {
    return {
      x: a,
      y: i
    };
  }), t = Ft(function(a, i, o, s, c) {
    return {
      isDragging: !0,
      isClone: i,
      isDropAnimating: !!c,
      dropAnimation: c,
      mode: a,
      draggingOver: o,
      combineWith: s,
      combineTargetFor: null
    };
  }), r = Ft(function(a, i, o, s, c, u, d) {
    return {
      mapped: {
        type: "DRAGGING",
        dropping: null,
        draggingOver: c,
        combineWith: u,
        mode: i,
        offset: a,
        dimension: o,
        forceShouldAnimate: d,
        snapshot: t(i, s, c, u, null)
      }
    };
  }), n = function(i, o) {
    if (i.isDragging) {
      if (i.critical.draggable.id !== o.draggableId)
        return null;
      var s = i.current.client.offset, c = i.dimensions.draggables[o.draggableId], u = vr(i.impact), d = OR(i.impact), h = i.forceShouldAnimate;
      return r(e(s.x, s.y), i.movementMode, c, o.isClone, u, d, h);
    }
    if (i.phase === "DROP_ANIMATING") {
      var A = i.completed;
      if (A.result.draggableId !== o.draggableId)
        return null;
      var p = o.isClone, m = i.dimensions.draggables[o.draggableId], g = A.result, v = g.mode, C = Pb(g), y = xR(g), w = i.dropDuration, O = {
        duration: w,
        curve: Q7.drop,
        moveTo: i.newHomeClientOffset,
        opacity: y ? ao.opacity.drop : null,
        scale: y ? ao.scale.drop : null
      };
      return {
        mapped: {
          type: "DRAGGING",
          offset: i.newHomeClientOffset,
          dimension: m,
          dropping: O,
          draggingOver: C,
          combineWith: y,
          mode: v,
          forceShouldAnimate: null,
          snapshot: t(v, p, C, y, O)
        }
      };
    }
    return null;
  };
  return n;
}
function jb(e) {
  return {
    isDragging: !1,
    isDropAnimating: !1,
    isClone: !1,
    dropAnimation: null,
    mode: null,
    draggingOver: null,
    combineTargetFor: e,
    combineWith: null
  };
}
var MR = {
  mapped: {
    type: "SECONDARY",
    offset: Ht,
    combineTargetFor: null,
    shouldAnimateDisplacement: !0,
    snapshot: jb(null)
  }
};
function ER() {
  var e = Ft(function(o, s) {
    return {
      x: o,
      y: s
    };
  }), t = Ft(jb), r = Ft(function(o, s, c) {
    return s === void 0 && (s = null), {
      mapped: {
        type: "SECONDARY",
        offset: o,
        combineTargetFor: s,
        shouldAnimateDisplacement: c,
        snapshot: t(s)
      }
    };
  }), n = function(s) {
    return s ? r(Ht, s, !0) : null;
  }, a = function(s, c, u, d) {
    var h = u.displaced.visible[s], A = !!(d.inVirtualList && d.effected[s]), p = g0(u), m = p && p.draggableId === s ? c : null;
    if (!h) {
      if (!A)
        return n(m);
      if (u.displaced.invisible[s])
        return null;
      var g = E2(d.displacedBy.point), v = e(g.x, g.y);
      return r(v, m, !0);
    }
    if (A)
      return n(m);
    var C = u.displacedBy.point, y = e(C.x, C.y);
    return r(y, m, h.shouldAnimate);
  }, i = function(s, c) {
    if (s.isDragging)
      return s.critical.draggable.id === c.draggableId ? null : a(c.draggableId, s.critical.draggable.id, s.impact, s.afterCritical);
    if (s.phase === "DROP_ANIMATING") {
      var u = s.completed;
      return u.result.draggableId === c.draggableId ? null : a(c.draggableId, u.result.draggableId, u.impact, u.afterCritical);
    }
    return null;
  };
  return i;
}
var PR = function() {
  var t = DR(), r = ER(), n = function(i, o) {
    return t(i, o) || r(i, o) || MR;
  };
  return n;
}, jR = {
  dropAnimationFinished: ob
}, SR = SC(PR, jR, null, {
  context: X7,
  pure: !0,
  areStatePropsEqual: Eb
})(wR);
function Sb(e) {
  var t = as(a9), r = t.isUsingCloneFor;
  return r === e.draggableId && !e.isClone ? null : B.createElement(SR, e);
}
function IR(e) {
  var t = typeof e.isDragDisabled == "boolean" ? !e.isDragDisabled : !0, r = !!e.disableInteractiveElementBlocking, n = !!e.shouldRespectForcePress;
  return B.createElement(Sb, we({}, e, {
    isClone: !1,
    isEnabled: t,
    canDragInteractiveElements: r,
    shouldRespectForcePress: n
  }));
}
function BR(e) {
  var t = xt(b0);
  t || (process.env.NODE_ENV !== "production" ? K(!1, "Could not find app context") : K(!1));
  var r = t.contextId, n = t.isMovementAllowed, a = ge(null), i = ge(null), o = e.children, s = e.droppableId, c = e.type, u = e.mode, d = e.direction, h = e.ignoreContainerClipping, A = e.isDropDisabled, p = e.isCombineEnabled, m = e.snapshot, g = e.useClone, v = e.updateViewportMaxScroll, C = e.getContainerForClone, y = pe(function() {
    return a.current;
  }, []), w = pe(function(R) {
    a.current = R;
  }, []), O = pe(function() {
    return i.current;
  }, []), b = pe(function(R) {
    i.current = R;
  }, []);
  cR({
    props: e,
    getDroppableRef: y,
    getPlaceholderRef: O
  });
  var D = pe(function() {
    n() && v({
      maxScroll: fb()
    });
  }, [n, v]);
  tR({
    droppableId: s,
    type: c,
    mode: u,
    direction: d,
    isDropDisabled: A,
    isCombineEnabled: p,
    ignoreContainerClipping: h,
    getDroppableRef: y
  });
  var M = B.createElement(uR, {
    on: e.placeholder,
    shouldAnimate: e.shouldAnimatePlaceholder
  }, function(R) {
    var N = R.onClose, z = R.data, q = R.animate;
    return B.createElement(iR, {
      placeholder: z,
      onClose: N,
      innerRef: b,
      animate: q,
      contextId: r,
      onTransitionEnd: D
    });
  }), j = He(function() {
    return {
      innerRef: w,
      placeholder: M,
      droppableProps: {
        "data-rbd-droppable-id": s,
        "data-rbd-droppable-context-id": r
      }
    };
  }, [r, s, M, w]), P = g ? g.dragging.draggableId : null, H = He(function() {
    return {
      droppableId: s,
      type: c,
      isUsingCloneFor: P
    };
  }, [s, P, c]);
  function F() {
    if (!g)
      return null;
    var R = g.dragging, N = g.render, z = B.createElement(Sb, {
      draggableId: R.draggableId,
      index: R.source.index,
      isClone: !0,
      isEnabled: !0,
      shouldRespectForcePress: !1,
      canDragInteractiveElements: !0
    }, function(q, J) {
      return N(q, J, R);
    });
    return P7.createPortal(z, C());
  }
  return B.createElement(a9.Provider, {
    value: H
  }, o(j, m), F());
}
var F6 = function(t, r) {
  return t === r.droppable.type;
}, ch = function(t, r) {
  return r.draggables[t.draggable.id];
}, NR = function() {
  var t = {
    placeholder: null,
    shouldAnimatePlaceholder: !0,
    snapshot: {
      isDraggingOver: !1,
      draggingOverWith: null,
      draggingFromThisWith: null,
      isUsingPlaceholder: !1
    },
    useClone: null
  }, r = we({}, t, {
    shouldAnimatePlaceholder: !1
  }), n = Ft(function(o) {
    return {
      draggableId: o.id,
      type: o.type,
      source: {
        index: o.index,
        droppableId: o.droppableId
      }
    };
  }), a = Ft(function(o, s, c, u, d, h) {
    var A = d.descriptor.id, p = d.descriptor.droppableId === o;
    if (p) {
      var m = h ? {
        render: h,
        dragging: n(d.descriptor)
      } : null, g = {
        isDraggingOver: c,
        draggingOverWith: c ? A : null,
        draggingFromThisWith: A,
        isUsingPlaceholder: !0
      };
      return {
        placeholder: d.placeholder,
        shouldAnimatePlaceholder: !1,
        snapshot: g,
        useClone: m
      };
    }
    if (!s)
      return r;
    if (!u)
      return t;
    var v = {
      isDraggingOver: c,
      draggingOverWith: A,
      draggingFromThisWith: null,
      isUsingPlaceholder: !0
    };
    return {
      placeholder: d.placeholder,
      shouldAnimatePlaceholder: !0,
      snapshot: v,
      useClone: null
    };
  }), i = function(s, c) {
    var u = c.droppableId, d = c.type, h = !c.isDropDisabled, A = c.renderClone;
    if (s.isDragging) {
      var p = s.critical;
      if (!F6(d, p))
        return r;
      var m = ch(p, s.dimensions), g = vr(s.impact) === u;
      return a(u, h, g, g, m, A);
    }
    if (s.phase === "DROP_ANIMATING") {
      var v = s.completed;
      if (!F6(d, v.critical))
        return r;
      var C = ch(v.critical, s.dimensions);
      return a(u, h, Pb(v.result) === u, vr(v.impact) === u, C, A);
    }
    if (s.phase === "IDLE" && s.completed && !s.shouldFlush) {
      var y = s.completed;
      if (!F6(d, y.critical))
        return r;
      var w = vr(y.impact) === u, O = !!(y.impact.at && y.impact.at.type === "COMBINE"), b = y.critical.droppable.id === u;
      return w ? O ? t : r : b ? t : r;
    }
    return r;
  };
  return i;
}, _R = {
  updateViewportMaxScroll: E_
};
function LR() {
  return document.body || (process.env.NODE_ENV !== "production" ? K(!1, "document.body is not ready") : K(!1)), document.body;
}
var TR = {
  mode: "standard",
  type: "DEFAULT",
  direction: "vertical",
  isDropDisabled: !1,
  isCombineEnabled: !1,
  ignoreContainerClipping: !1,
  renderClone: null,
  getContainerForClone: LR
}, Ib = SC(NR, _R, null, {
  context: X7,
  pure: !0,
  areStatePropsEqual: Eb
})(BR);
Ib.defaultProps = TR;
const Bb = B.forwardRef((e, t) => {
  const {
    item: r,
    currentItem: n,
    resetCurrentItem: a
  } = e, i = xt(Ur), o = (i == null ? void 0 : i.isCollapsedMenu) ?? !1, s = (r == null ? void 0 : r.items) ?? [];
  return /* @__PURE__ */ f.jsx(f.Fragment, { children: n !== null && n.id === r.id && s.length > 0 && /* @__PURE__ */ f.jsx("div", { ref: t, className: `my-[-50px] drop-shadow-xl rounded-md fixed left-12 z-[30] w-full m:max-w-[288px] bg-white
           ${o ? "m:left-[300px] l:left-[130px]" : "m:left-[288px]"} `, children: /* @__PURE__ */ f.jsxs("div", { className: "flex h-full flex-col", children: [
    /* @__PURE__ */ f.jsxs("div", { className: "flex items-center gap-4 justify-between p-4 border-b border-secondary-300 m:px-8", children: [
      /* @__PURE__ */ f.jsx("div", { className: "w-10 min-w-[40px] h-10 m:hidden", children: /* @__PURE__ */ f.jsx(
        "button",
        {
          type: "button",
          onClick: a,
          className: "bg-secondary-300 hover:bg-secondary-400 w-full h-full flex items-center justify-center rounded-md text-Negros-900",
          children: /* @__PURE__ */ f.jsx(Me, { variant: "back-arrow", width: 18 })
        }
      ) }),
      /* @__PURE__ */ f.jsx("div", { className: "flex-grow font-bold text-Negros-900 leading-[120%]", children: n.description }),
      /* @__PURE__ */ f.jsx("div", { className: "w-10 min-w-[40px] h-10 m:hidden", children: /* @__PURE__ */ f.jsx(
        "button",
        {
          type: "button",
          onClick: i == null ? void 0 : i.closeMenu,
          className: "bg-secondary-300 hover:bg-secondary-400 w-full h-full flex items-center justify-center rounded-md text-secondary-600",
          children: /* @__PURE__ */ f.jsx(Me, { variant: "close", width: 14 })
        }
      ) })
    ] }),
    /* @__PURE__ */ f.jsx("div", { className: "flex-grow overflow-hidden px-4", children: /* @__PURE__ */ f.jsx("div", { className: "h-full max-h-[calc(100%-32px)] w-full max-w-[568px] my-4 mx-auto overflow-y-auto menu-subitems-scrollbar", children: /* @__PURE__ */ f.jsx("ul", { children: s.map((c) => /* @__PURE__ */ f.jsxs(
      "li",
      {
        className: "flex items-center px-4 py-2 font-bold text-Negros-900 cursor-pointer rounded-md hover:bg-Acento-50",
        onClick: () => {
          c.onClick !== void 0 && (c == null || c.onClick()), i == null || i.closeMenu(), a();
        },
        children: [
          /* @__PURE__ */ f.jsx(Me, { variant: "arrow-right", width: 10 }),
          "  ",
          /* @__PURE__ */ f.jsx("span", { className: "ml-3", children: c.description })
        ]
      },
      c.id
    )) }) }) })
  ] }) }) });
});
Bb.displayName = "MenuSubitems";
const Nb = (e) => {
  const {
    idx: t,
    item: r,
    currentItem: n,
    changeCurrentItem: a,
    resetCurrentItem: i
  } = e, {
    id: o,
    icon: s,
    items: c,
    isActive: u,
    description: d,
    onClick: h = () => {
    }
  } = r, A = n !== null && n.id === r.id, p = c !== void 0, m = c ?? [], g = xt(Ur), v = (g == null ? void 0 : g.isCollapsedMenu) ?? !1, C = () => {
    window.innerWidth >= 1024 && a(r);
  }, y = () => {
    window.innerWidth >= 1024 && i();
  };
  return /* @__PURE__ */ f.jsx(IR, { draggableId: `${o}`, index: t, children: (w, O) => /* @__PURE__ */ f.jsxs(
    "div",
    {
      ref: w.innerRef,
      ...w.draggableProps,
      ...w.dragHandleProps,
      style: {
        cursor: "default",
        ...w.draggableProps.style
      },
      className: "select-none px-4",
      onMouseEnter: C,
      onMouseLeave: y,
      children: [
        /* @__PURE__ */ f.jsxs(
          "div",
          {
            title: d,
            className: Ye([
              "min-h-[40px] py-2  flex items-center justify-between font-bold gap-2 cursor-pointer rounded-md px-2",
              A ? "bg-Acento-50" : u ? (O.isDragging, "bg-Acento-50") : O.isDragging ? "bg-secondary-800" : "bg-white-900"
            ]),
            onClick: () => {
              h(), a(r), p || g == null || g.closeMenu();
            },
            children: [
              /* @__PURE__ */ f.jsx("div", { className: "flex gap-2 items-center", children: /* @__PURE__ */ f.jsxs("div", { className: "flex gap-2 px-7 items-center leading-none capitalize", children: [
                /* @__PURE__ */ f.jsx("span", { className: "w-[30px] min-w-[30px]", children: /* @__PURE__ */ f.jsx(Me, { variant: s, width: 30 }) }),
                /* @__PURE__ */ f.jsx("span", { className: `${v ? "block l:hidden" : "block"}`, children: d })
              ] }) }),
              p && m.length > 0 && /* @__PURE__ */ f.jsx("span", { className: "-rotate-90", children: /* @__PURE__ */ f.jsx(Me, { variant: "arrow-down", width: 14 }) })
            ]
          }
        ),
        /* @__PURE__ */ f.jsx(
          Bb,
          {
            item: r,
            currentItem: n,
            resetCurrentItem: i
          }
        )
      ]
    }
  ) }, o);
};
Nb.displayName = "MenuItem";
const RR = ({ children: e, ...t }) => {
  const [r, n] = De(!1);
  return Ie(() => {
    const a = requestAnimationFrame(() => n(!0));
    return () => {
      cancelAnimationFrame(a), n(!1);
    };
  }, []), r ? /* @__PURE__ */ f.jsx(Ib, { ...t, children: e }) : null;
}, $R = (e, t, r) => {
  const n = Array.from(e), [a] = n.splice(t, 1);
  return n.splice(r, 0, a), n;
}, FR = B.forwardRef((e, t) => {
  const {
    className: r,
    items: n,
    activeHome: a,
    labelHome: i = "Inicio",
    onClickHome: o = () => {
    },
    onMenuDragged: s = () => {
    },
    ...c
  } = e, [u, d] = De(n), [h, A] = De(null), p = xt(Ur), m = (p == null ? void 0 : p.isOpenMenu) ?? !1, g = (p == null ? void 0 : p.isCollapsedMenu) ?? !1, v = (w) => {
    A(w);
  }, C = () => {
    A(null);
  }, y = ({ source: w, destination: O }) => {
    if (O == null)
      return;
    const b = $R(
      u,
      w.index,
      O.index
    );
    s({
      _newItems: b,
      item: {
        payload: b[O.index],
        indexes: {
          previous: w.index,
          new: O.index
        }
      }
    }), d(b);
  };
  return Ie(() => {
    m || A(null);
  }, [m]), Ie(() => {
    d(n);
  }, [n]), /* @__PURE__ */ f.jsxs(
    "ul",
    {
      ref: t,
      className: Ye(["flex flex-col text-black select-none", r]),
      ...c,
      children: [
        /* @__PURE__ */ f.jsx("li", { className: "h-10 px-4 ", children: /* @__PURE__ */ f.jsx(
          "div",
          {
            className: "h-full flex gap-2 items-center justify-between font-bold cursor-pointer rounded-md pl-2 l:pl-[36px] pr-2",
            title: i,
            onClick: () => {
              o(), p == null || p.closeMenu();
            },
            children: /* @__PURE__ */ f.jsxs("div", { className: "flex gap-2 items-center ", children: [
              /* @__PURE__ */ f.jsx(Me, { variant: "home", width: 30 }),
              /* @__PURE__ */ f.jsx("span", { className: `${g ? "block l:hidden" : "block"}`, children: i })
            ] })
          }
        ) }),
        /* @__PURE__ */ f.jsx(YT, { onDragEnd: y, children: /* @__PURE__ */ f.jsx(RR, { droppableId: "droppable", children: (w) => /* @__PURE__ */ f.jsxs(
          "div",
          {
            ...w.droppableProps,
            ref: w.innerRef,
            children: [
              u.map((O, b) => /* @__PURE__ */ f.jsx(
                Nb,
                {
                  idx: b,
                  item: O,
                  currentItem: h,
                  changeCurrentItem: v,
                  resetCurrentItem: C
                },
                O.id
              )),
              w.placeholder
            ]
          }
        ) }) })
      ]
    }
  );
});
FR.displayName = "MenuItems";
const HR = B.forwardRef((e, t) => {
  const {
    children: r,
    ...n
  } = e, a = xt(Ur), i = (a == null ? void 0 : a.isOpenMenu) ?? !1, o = (a == null ? void 0 : a.isCollapsedMenu) ?? !1;
  return /* @__PURE__ */ f.jsx("aside", { ref: t, ...n, className: `fixed z-[1000] w-full  top-0 bottom-[4.5rem] 2s:bottom-0 2s:top-[4.5rem] l:top-[5rem] ${i ? "left-0" : "-left-[100vw] m:-left-[288px] l:left-0"} ${o ? "m:max-w-[288px] l:max-w-[130px]" : "m:max-w-[288px]"}`, children: /* @__PURE__ */ f.jsxs("div", { className: "flex flex-col h-full w-full", children: [
    /* @__PURE__ */ f.jsx("div", { className: "flex-grow max-h-[calc(100%-72px-56px-32px)] l:max-h-[calc(100%-56px-56px-32px)] w-full max-w-[600px] my-4 mx-auto", children: /* @__PURE__ */ f.jsx("div", { className: "h-4/5 overflow-y-auto menu-wrapper-scrollbar", children: /* @__PURE__ */ f.jsx("div", { className: "flex flex-col gap-4", children: r }) }) }),
    /* @__PURE__ */ f.jsxs("div", { className: "flex l:hidden items-center justify-between px-4 h-[72px] text-white border-b border-secondary-850", children: [
      /* @__PURE__ */ f.jsx(Vi, { variant: "heading-6", children: "Menú" }),
      /* @__PURE__ */ f.jsx(
        "button",
        {
          type: "button",
          onClick: a == null ? void 0 : a.closeMenu,
          className: "w-10 aspect-square bg-secondary-850 hover:bg-secondary-600 rounded-md flex justify-center items-center",
          children: /* @__PURE__ */ f.jsx(Me, { variant: "close", width: 14 })
        }
      )
    ] }),
    /* @__PURE__ */ f.jsx("div", { className: "hidden l:flex items-center  px-4 h-[56px] text-black font-bold  border-secondary-850", children: /* @__PURE__ */ f.jsx(
      "button",
      {
        type: "button",
        onClick: a == null ? void 0 : a.toggleCollapsedMenu,
        className: "w-10 pl-12 aspect-square  rounded-md flex justify-center items-center ",
        children: /* @__PURE__ */ f.jsx("span", { className: `${o ? "-rotate-180" : ""}`, children: /* @__PURE__ */ f.jsx(Me, { variant: "right-arrow", width: 40 }) })
      }
    ) })
  ] }) });
});
HR.displayName = "MenuWrapper";
const YR = B.forwardRef((e, t) => {
  const {
    size: r = "xl",
    isTop: n = !1,
    isOpen: a,
    children: i
  } = e, o = {
    sm: "px-4 max-w-[calc(474px+32px)]",
    xl: "px-0 2s:px-4 w-full 2s:max-w-[calc(944px+32px)]"
  };
  return Ie(() => {
    if (!n)
      return a ? document.body.classList.add("overflow-y-hidden-modal") : document.body.classList.remove("overflow-y-hidden-modal"), () => {
        document.body.classList.remove("overflow-y-hidden-modal");
      };
  }, [a]), /* @__PURE__ */ f.jsx(
    "div",
    {
      ref: t,
      className: `
        fixed overflow-x-hidden overflow-y-auto modal-scrollbar
        ${n ? "z-[1710]" : "z-[1700]"}
        ${r === "xl" ? "bg-white 2s:bg-[rgba(3,56,108,0.6)] left-0 top-0 bottom-[4.5rem] 2s:bottom-0" : "bg-[rgba(3,56,108,0.6)] inset-0"}
        ${a ? "visible w-full" : "invisible w-0 h-0"}
      `,
      children: /* @__PURE__ */ f.jsx("div", { className: `flex ${r === "xl" ? "items-start 2s:items-center" : "items-center"} ${r === "xl" ? "my-0 2s:my-[28px]" : "my-[28px]"} mx-auto ${r === "xl" ? "min-h-full 2s:min-h-[calc(100%-56px)]" : "min-h-[calc(100%-56px)]"} w-full relative ${o[r]}`, children: /* @__PURE__ */ f.jsx("div", { className: `bg-white rounded-lg relative w-full ${a ? "scale-[1] transition-all" : "scale-[0.9]"}`, children: i }) })
    }
  );
});
YR.displayName = "Modal";
const VR = B.forwardRef((e, t) => {
  const {
    size: r = "sm",
    children: n
  } = e, a = {
    sm: "p-4 s:p-8",
    xl: "p-4 2s:p-12"
  };
  return /* @__PURE__ */ f.jsx(
    "div",
    {
      ref: t,
      className: a[r],
      children: n
    }
  );
});
VR.displayName = "ModalBody";
const kR = B.forwardRef((e, t) => {
  const {
    isOpen: r,
    children: n
  } = e;
  return Ie(() => (r ? document.body.classList.add("overflow-y-hidden-modal") : document.body.classList.remove("overflow-y-hidden-modal"), () => {
    document.body.classList.remove("overflow-y-hidden-modal");
  }), [r]), /* @__PURE__ */ f.jsx(
    "div",
    {
      ref: t,
      className: `
        fixed z-[900] l:z-[1500] left-0 top-0 bottom-[4.5rem] 2s:bottom-0 2s:top-[4.5rem] l:top-[5rem] overflow-x-hidden overflow-y-auto modal-focus-scrollbar bg-white
        ${r ? "visible w-full" : "invisible w-0 h-0"}
      `,
      children: /* @__PURE__ */ f.jsx("div", { className: "flex mx-autom mb-[80px] min-h-[calc(100%-80px)] w-full relative", children: /* @__PURE__ */ f.jsx("div", { className: `relative w-full ${r ? "scale-[1] transition-all" : "scale-[0.9]"}`, children: n }) })
    }
  );
});
kR.displayName = "ModalFocus";
const GR = B.forwardRef((e, t) => {
  const {
    size: r = "xl",
    children: n
  } = e, a = {
    xl: "p-4 2s:p-8"
  };
  return /* @__PURE__ */ f.jsx(
    "div",
    {
      ref: t,
      className: `${a[r]} border-b border-neutral-200`,
      children: n
    }
  );
});
GR.displayName = "ModalHeader";
const WR = B.forwardRef((e, t) => {
  const {
    size: r = "xl",
    children: n
  } = e, a = {
    xl: "p-4 2s:px-8 2s:pt-8 2s:pb-16"
  };
  return /* @__PURE__ */ f.jsx(
    "div",
    {
      ref: t,
      className: `${a[r]} border-t border-neutral-200`,
      children: n
    }
  );
});
WR.displayName = "ModalFooter";
const QR = B.forwardRef((e, t) => {
  const {
    children: r
  } = e;
  return /* @__PURE__ */ f.jsx("div", { ref: t, className: "w-full max-w-[1300px] mx-auto", children: r });
});
QR.displayName = "ModalFocusContainer";
const UR = B.forwardRef((e, t) => {
  const {
    variant: r,
    children: n,
    srcBgImage: a,
    className: i,
    ...o
  } = e, s = {
    login: "relative ",
    "password-recovery": "relative",
    "change-password": "relative"
  }, c = {
    login: "bg-image  m:min-h-[100vh]",
    "password-recovery": "bg-image  m:min-h-[100vh]",
    "change-password": "bg-image  m:min-h-[100vh]"
  }, u = {
    login: "m:grid m:grid-cols-2",
    "password-recovery": "m:grid m:grid-cols-2",
    "change-password": "m:grid m:grid-cols-2"
  };
  return /* @__PURE__ */ f.jsx(
    "div",
    {
      ref: t,
      className: Ye([s[r], i]),
      ...o,
      children: /* @__PURE__ */ f.jsxs("div", { className: u[r], children: [
        n,
        /* @__PURE__ */ f.jsx(
          "div",
          {
            className: c[r],
            style: { backgroundImage: `url(${a})` }
          }
        ),
        /* @__PURE__ */ f.jsx("footer", { ref: t, className: " m:absolute m:border-0", ...o, children: /* @__PURE__ */ f.jsx("div", { className: "brand p-4 flex justify-center", children: /* @__PURE__ */ f.jsx(NI, {}) }) })
      ] })
    }
  );
});
UR.displayName = "Spreen";
const ZR = B.forwardRef((e, t) => {
  const {
    variant: r,
    children: n,
    className: a,
    isSuccessPasswordRecovery: i = !1,
    ...o
  } = e, s = {
    login: "my-[2rem]  m:px-[16rem] grid gap-[2rem]",
    "password-recovery": "my-[10rem] l:px-[12rem] m:px-[8rem] grid gap-[2rem] s:px-[10rem]",
    "change-password": "my-[6rem] xl:px-[16rem]  m:px-[4rem]  grid gap-[2rem]"
  };
  return /* @__PURE__ */ f.jsx(
    "div",
    {
      ref: t,
      className: Ye([s[r], a]),
      ...o,
      children: n
    }
  );
});
ZR.displayName = "SpreenBody";
const zR = B.forwardRef((e, t) => {
  const {
    children: r,
    className: n,
    ...a
  } = e;
  return /* @__PURE__ */ f.jsx(
    "div",
    {
      ref: t,
      className: Ye([" py-[4rem] text-center", n]),
      ...a,
      children: r
    }
  );
});
zR.displayName = "SpreenFooter";
const KR = B.forwardRef((e, t) => {
  const {
    children: r,
    className: n,
    ...a
  } = e;
  return /* @__PURE__ */ f.jsxs(
    "div",
    {
      ref: t,
      className: Ye(["bg-white m:rounded-l-lg", n]),
      ...a,
      children: [
        /* @__PURE__ */ f.jsx("div", { className: "m:pt-[10rem] m:pb-[1rem] flex justify-center", id: "CastorLogo", children: /* @__PURE__ */ f.jsx(pC, {}) }),
        r
      ]
    }
  );
});
KR.displayName = "SpreenLeft";
const qR = B.forwardRef((e, t) => {
  const {
    children: r,
    className: n,
    ...a
  } = e;
  return /* @__PURE__ */ f.jsx(
    "div",
    {
      ref: t,
      className: Ye(["bg-secondary-800 text-white py-[2rem] px-[1rem] m:px-[2rem] m:rounded-r-lg", n]),
      ...a,
      children: r
    }
  );
});
qR.displayName = "SpreenRight";
const XR = B.forwardRef((e, t) => {
  const {
    variant: r,
    children: n,
    className: a,
    ...i
  } = e, o = {
    "password-recovery": "",
    "change-password": ""
  };
  return /* @__PURE__ */ f.jsxs(
    "div",
    {
      ref: t,
      className: Ye([o[r], a]),
      ...i,
      children: [
        n,
        /* @__PURE__ */ f.jsx("div", { className: "flex justify-center pb-10", children: /* @__PURE__ */ f.jsx(pC, { width: 200 }) })
      ]
    }
  );
});
XR.displayName = "SpreenHeader";
const i9 = B.forwardRef((e, t) => {
  const {
    gap: r,
    gapY: n,
    gapX: a,
    bg: i,
    rounded: o,
    columns: s,
    columnsVariant: c,
    spacing: u,
    alignItems: d,
    justifyItems: h,
    responsiveColumns: A,
    children: p,
    className: m,
    ...g
  } = e, v = {
    gridTemplateColumns: c === void 0 && s !== void 0 ? `repeat(${s}, 1fr)` : void 0,
    backgroundColor: i !== void 0 ? gt[i] : void 0,
    borderRadius: o !== void 0 ? fC[o] : void 0,
    padding: u !== void 0 ? `${u / 4}rem` : void 0,
    justifyItems: h,
    alignItems: d
  };
  r !== void 0 ? v.gap = r !== void 0 ? `${r / 4}rem` : void 0 : (v.columnGap = a !== void 0 ? `${a / 4}rem` : void 0, v.rowGap = n !== void 0 ? `${n / 4}rem` : void 0);
  const C = {
    "form-4": "grid-cols-1 2s:grid-cols-2 l:grid-cols-4 gap-x-4 gap-y-8 label-form-4",
    "form-2": "grid-cols-1 2s:grid-cols-2 gap-x-4 gap-y-8 label-form-2"
  };
  A !== void 0 && Object.entries(A).forEach(([w, O]) => {
    const b = `--ck-cols-${w}`;
    typeof O == "number" && (v[b] = `repeat(${O},1fr)`), typeof O == "string" && (v[b] = O);
  });
  const y = {
    initial: "grid-cols-[var(--ck-cols-initial)]",
    small: "s:grid-cols-[var(--ck-cols-small)]",
    extraSmall: "2s:grid-cols-[var(--ck-cols-extraSmall)]",
    medium: "m:grid-cols-[var(--ck-cols-medium)]",
    large: "l:grid-cols-[var(--ck-cols-large)]",
    extraLarge: "xl:grid-cols-[var(--ck-cols-extraLarge)]"
  };
  return /* @__PURE__ */ f.jsx(
    "div",
    {
      ref: t,
      className: Ye([
        "grid",
        c !== void 0 ? C[c] : void 0,
        A !== void 0 ? `${Object.keys(A).map((w) => y[w]).join(" ")}` : void 0
      ]),
      style: v,
      ...g,
      children: p
    }
  );
});
i9.displayName = "Stack";
const JR = B.forwardRef((e, t) => {
  const {
    responsiveColSpan: r,
    showDesktopOnly: n,
    forceWidth: a = !1,
    children: i,
    ...o
  } = e, s = {};
  r !== void 0 && Object.entries(r).forEach(([u, d]) => {
    if (typeof d == "number") {
      const h = `--ck-col-span-${u}`;
      s[h] = `span ${d} / span ${d}`;
    }
  });
  const c = {
    initial: "col-[var(--ck-col-span-initial)]",
    small: "s:col-[var(--ck-col-span-small)]",
    extraSmall: "2s:col-[var(--ck-col-span-extraSmall)]",
    medium: "m:col-[var(--ck-col-span-medium)]",
    large: "l:col-[var(--ck-col-span-large)]",
    extraLarge: "xl:col-[var(--ck-col-span-extraLarge)]"
  };
  return /* @__PURE__ */ f.jsx(
    "div",
    {
      ref: t,
      style: s,
      className: Ye([
        `${n === !0 ? "hidden m:block" : "block"} ${a ? "max-w-full overflow-x-hidden" : ""}`,
        r !== void 0 ? `${Object.keys(r).map((u) => c[u]).join(" ")}` : void 0
      ]),
      ...o,
      children: i
    }
  );
});
JR.displayName = "StackRow";
const e$ = B.forwardRef((e, t) => {
  const {
    children: r,
    className: n
  } = e;
  return /* @__PURE__ */ f.jsx("div", { ref: t, className: Ye(["bg-secondary-100 flex items-center justify-center p-5 rounded-md min-h-[70vh]", n]), children: /* @__PURE__ */ f.jsxs("div", { className: "flex flex-col items-center justify-center w-full max-w-[300px] gap-4 text-center", children: [
    /* @__PURE__ */ f.jsx("div", { className: "flex justify-center select-none", children: /* @__PURE__ */ f.jsx(
      "svg",
      {
        width: 90,
        height: 101,
        viewBox: "0 0 90 101",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /* @__PURE__ */ f.jsxs("g", { clipPath: "url(#clip0_2127_49432)", children: [
          /* @__PURE__ */ f.jsx(
            "path",
            {
              d: "M89.9844 52.4766C89.8853 51.6849 89.314 51.0339 88.5418 50.8307L80.2566 48.6484L86.6766 41.5833C87.0783 41.1406 87.2531 40.5417 87.1566 39.9531C87.0601 39.3646 86.7001 38.8542 86.1783 38.5625L62.2618 25.276C61.3644 23.6068 60.2166 22.0573 58.834 20.6823C55.1401 16.9922 50.2253 14.9609 45.0001 14.9609C39.7748 14.9609 34.8601 16.9922 31.1661 20.6823C29.7731 22.0729 28.6357 23.6224 27.7514 25.2708L3.82441 38.5651C3.30267 38.8542 2.94267 39.3672 2.84614 39.9557C2.74962 40.5443 2.92701 41.1432 3.32875 41.5859L9.74615 48.651L1.45832 50.8333C0.686145 51.0365 0.11484 51.6875 0.0157101 52.4792C-0.0834204 53.2708 0.307884 54.0417 1.00701 54.4297L11.4027 60.2057V80.974C11.4027 81.6823 11.7888 82.3359 12.407 82.6797L44.0505 100.258C44.3479 100.422 44.674 100.505 45.0027 100.505C45.3314 100.505 45.6601 100.424 45.9548 100.258L77.5983 82.6797C78.2192 82.3359 78.6027 81.6823 78.6027 80.974V60.2057L88.9983 54.4297C89.6948 54.0417 90.0888 53.2708 89.987 52.4792L89.9844 52.4766ZM82.1192 40.7839L76.2366 47.2578L63.694 40.2917C64.2679 38.4401 64.5653 36.4896 64.5653 34.4974C64.5653 33.2578 64.4505 32.0365 64.2261 30.8438L82.1218 40.7839H82.1192ZM33.9314 23.4479C36.887 20.4974 40.8183 18.8724 45.0001 18.8724C49.1818 18.8724 53.1105 20.4974 56.0688 23.4479C59.027 26.3984 60.6522 30.3229 60.6522 34.4974C60.6522 38.6719 59.0244 42.5938 56.0688 45.5469C54.0235 47.5885 51.4644 49.0208 48.6653 49.6901C48.1435 49.8151 47.6948 50.1484 47.4261 50.612L45.0001 54.8099C44.1914 53.4089 43.3827 52.0104 42.574 50.612C42.3053 50.1484 41.8566 49.8151 41.3348 49.6875C38.5383 49.0182 35.9792 47.5859 33.934 45.5443C27.8322 39.4531 27.8322 29.5391 33.934 23.4479H33.9314ZM7.88093 40.7839L25.7896 30.8359C25.1948 33.9714 25.3696 37.2214 26.3192 40.2865L13.7661 47.2604L7.88354 40.7865L7.88093 40.7839ZM13.0957 51.8073L20.5331 55.9401C20.8357 56.1068 21.1618 56.1875 21.4827 56.1875C22.1714 56.1875 22.8366 55.8255 23.194 55.1823C23.7209 54.2396 23.3792 53.0495 22.4348 52.526L17.3818 49.7188L27.8531 43.9036C28.7218 45.4844 29.8279 46.9688 31.1661 48.3073C33.5192 50.6563 36.4148 52.3594 39.5922 53.2682C40.4348 54.7266 41.2774 56.1849 42.1227 57.6458C42.7253 58.6823 43.7975 59.2995 44.9975 59.2995H45.0235C46.2131 59.2917 47.3114 58.6484 47.8957 57.6172L50.4105 53.2682C53.5853 52.3568 56.4835 50.6536 58.8366 48.3073C60.1618 46.9818 61.2757 45.5026 62.1575 43.9063L72.6209 49.7188L45.0027 65.0599L37.8261 61.0729C36.8818 60.5495 35.6896 60.888 35.1653 61.8307C34.6383 62.7734 34.9801 63.9635 35.9244 64.487L39.8061 66.6432L33.8661 68.2057L7.15571 53.3672L13.0957 51.8047V51.8073ZM15.3157 62.375L32.6505 72.0052C33.0914 72.25 33.6105 72.3151 34.1009 72.1875L43.0461 69.8333V95.2266L15.3157 79.8229V62.3776V62.375ZM74.687 79.8203L46.9566 95.224V69.8307L55.9018 72.1849C56.0661 72.2266 56.2331 72.25 56.4001 72.25C56.7314 72.25 57.0574 72.1667 57.3496 72.0026L74.6844 62.3724V79.8177L74.687 79.8203ZM56.1392 68.2083L50.1992 66.6432L76.907 51.8073L82.847 53.3698L56.1392 68.2083Z",
              fill: "#2875B4"
            }
          ),
          /* @__PURE__ */ f.jsx(
            "path",
            {
              d: "M35.2173 36.7422C36.2973 36.7422 37.1738 35.8672 37.1738 34.7891C37.1738 33.7109 36.2973 32.8359 35.2173 32.8359C34.1373 32.8359 33.2607 33.7109 33.2607 34.7891C33.2607 35.8672 34.1373 36.7422 35.2173 36.7422Z",
              fill: "#2875B4"
            }
          ),
          /* @__PURE__ */ f.jsx(
            "path",
            {
              d: "M45 36.7422C46.08 36.7422 46.9565 35.8672 46.9565 34.7891C46.9565 33.7109 46.08 32.8359 45 32.8359C43.92 32.8359 43.0435 33.7109 43.0435 34.7891C43.0435 35.8672 43.92 36.7422 45 36.7422Z",
              fill: "#2875B4"
            }
          ),
          /* @__PURE__ */ f.jsx(
            "path",
            {
              d: "M54.7827 36.7422C55.8627 36.7422 56.7392 35.8672 56.7392 34.7891C56.7392 33.7109 55.8627 32.8359 54.7827 32.8359C53.7027 32.8359 52.8262 33.7109 52.8262 34.7891C52.8262 35.8672 53.7027 36.7422 54.7827 36.7422Z",
              fill: "#2875B4"
            }
          ),
          /* @__PURE__ */ f.jsx(
            "path",
            {
              d: "M45 8.89844C46.08 8.89844 46.9565 8.02344 46.9565 6.94531V2.45312C46.9565 1.375 46.08 0.5 45 0.5C43.92 0.5 43.0435 1.375 43.0435 2.45312V6.94531C43.0435 8.02344 43.92 8.89844 45 8.89844Z",
              fill: "#2875B4"
            }
          ),
          /* @__PURE__ */ f.jsx(
            "path",
            {
              d: "M33.0573 10.6639C33.4199 11.2915 34.0773 11.6405 34.7529 11.6405C35.0842 11.6405 35.4207 11.5571 35.7286 11.38C36.6651 10.841 36.9859 9.64566 36.4459 8.71077L34.1973 4.82014C33.6573 3.88525 32.4599 3.56494 31.5259 4.104C30.5894 4.64306 30.2686 5.83837 30.8086 6.77327L33.0573 10.6639Z",
              fill: "#2875B4"
            }
          ),
          /* @__PURE__ */ f.jsx(
            "path",
            {
              d: "M54.2685 11.3776C54.5764 11.5547 54.9129 11.638 55.2468 11.638C55.9225 11.638 56.5799 11.2891 56.9425 10.6615L59.1912 6.77083C59.7312 5.83593 59.4103 4.64062 58.4738 4.10156C57.5372 3.56249 56.3425 3.88281 55.8025 4.8177L53.5538 8.70833C53.0138 9.64322 53.3346 10.8359 54.2685 11.3776Z",
              fill: "#2875B4"
            }
          ),
          /* @__PURE__ */ f.jsx(
            "path",
            {
              d: "M29.1782 56.5547C28.0982 56.5547 27.2217 57.4297 27.2217 58.5078C27.2217 59.5859 28.0982 60.4609 29.1782 60.4609C30.2582 60.4609 31.1347 59.5885 31.1347 58.5078C31.1347 57.4271 30.2582 56.5547 29.1782 56.5547Z",
              fill: "#2875B4"
            }
          )
        ] })
      }
    ) }),
    r
  ] }) });
});
e$.displayName = "TableEmpty";
const t$ = B.forwardRef((e, t) => {
  const {
    children: r,
    className: n
  } = e;
  return /* @__PURE__ */ f.jsx("div", { ref: t, className: Ye(["pt-4 px-4 border-t border-neutral-300 m:border-none", n]), children: /* @__PURE__ */ f.jsx("div", { className: "flex flex-col-reverse m:flex-row m:justify-between flex-wrap gap-4", children: r }) });
});
t$.displayName = "TableFooter";
const r$ = (e) => {
  const {
    idSearch: t,
    placeholder: r,
    minLengthToSearch: n = 5,
    onSearch: a,
    onClickRefresh: i
  } = e, [o, s] = De(""), c = ge(!0), u = AC(o), d = (p) => {
    const m = p.target.value;
    m.startsWith(" ") || s(m);
  }, h = () => {
    s(""), a !== void 0 && a({
      value: "",
      canSearch: !1
    });
  };
  Ie(() => {
    if (c.current) {
      c.current = !1;
      return;
    }
    a !== void 0 && (u.trim().length >= n ? a({
      value: u.trim(),
      canSearch: !0
    }) : a({
      value: u.trim(),
      canSearch: !1
    }));
  }, [u]);
  const A = () => {
    i !== void 0 && (h(), i());
  };
  return /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
    /* @__PURE__ */ f.jsx("div", { className: "flex-grow", children: /* @__PURE__ */ f.jsx(
      "input",
      {
        type: "text",
        id: t,
        placeholder: r,
        value: o,
        onChange: d,
        className: "w-full h-full px-3 bg-transparent text-neutral-600 placeholder:text-neutral-400 outline-none shadow-transparent",
        style: { textTransform: "none" }
      }
    ) }),
    o.trim().length >= n ? /* @__PURE__ */ f.jsx(
      "button",
      {
        type: "button",
        onClick: h,
        className: "w-[48px] min-w-[48px] flex items-center justify-center border-l border-neutral-300 cursor-pointer",
        children: /* @__PURE__ */ f.jsx(Me, { variant: "close", width: 14 })
      }
    ) : /* @__PURE__ */ f.jsx("label", { htmlFor: t, className: "w-[48px] min-w-[48px] flex items-center justify-center border-l border-neutral-300 cursor-pointer", children: /* @__PURE__ */ f.jsx(Me, { variant: "search", width: 20 }) }),
    /* @__PURE__ */ f.jsx(
      "button",
      {
        type: "button",
        onClick: A,
        className: "w-[48px] min-w-[48px] flex items-center justify-center border-l border-neutral-300 cursor-pointer",
        children: /* @__PURE__ */ f.jsx(Me, { variant: "refresh-circle", width: 18 })
      }
    )
  ] });
}, n$ = B.forwardRef((e, t) => {
  const {
    search: r,
    consult: n,
    selectFilter: a,
    permissions: i,
    onClickExport: o,
    onClickReports: s,
    onClickRefresh: c
  } = e, {
    placeholder: u = "Search...",
    minLengthToSearch: d = 5,
    onSearch: h
  } = r, A = E7(), p = (n == null ? void 0 : n.filled) ?? 0, m = () => {
    (n == null ? void 0 : n.onClick) !== void 0 && n.onClick();
  }, g = () => {
    (n == null ? void 0 : n.onReset) !== void 0 && n.onReset();
  }, v = () => {
    s !== void 0 && s();
  }, C = () => {
    o !== void 0 && o();
  }, y = Object.values(i).reduce((w, O) => O ? w + 1 : w, 0);
  return /* @__PURE__ */ f.jsx("div", { ref: t, className: "border-b border-neutral-300 m:border-none px-4 pt-4", children: /* @__PURE__ */ f.jsxs("div", { className: "flex flex-col m:flex-row m:justify-between gap-4", children: [
    /* @__PURE__ */ f.jsx("div", { className: "flex flex-grow gap-2", children: /* @__PURE__ */ f.jsxs("div", { className: "flex m:flex-grow m:max-w-[800px] justify-between h-[40px] border border-neutral-300 rounded-md bg-neutral-200 w-[100%]", children: [
      /* @__PURE__ */ f.jsx("div", { className: "w-[110px] min-w-[110px] s:w-[140px] s:min-w-[140px] 2s:min-w-[30%] relative h-full border-r border-neutral-300", children: a }),
      /* @__PURE__ */ f.jsx(
        r$,
        {
          idSearch: A,
          placeholder: u,
          minLengthToSearch: d,
          onSearch: h,
          onClickRefresh: c
        }
      )
    ] }) }),
    y > 0 && /* @__PURE__ */ f.jsx("div", { className: "flex flex-col m:flex-row gap-4", children: /* @__PURE__ */ f.jsxs("div", { className: `grid ${y < 2 ? "grid-cols-1" : "grid-table-main-header"} m:flex gap-4`, children: [
      i.consult && /* @__PURE__ */ f.jsxs("div", { className: "relative", children: [
        /* @__PURE__ */ f.jsx(
          "button",
          {
            type: "button",
            onClick: m,
            className: `h-10 w-full bg-secondary-100 text-secondary-600 hover:bg-secondary-200 font-bold flex gap-4 items-center rounded-md border ${p > 0 ? "justify-center s:justify-between pl-4 pr-4 s:pr-[4.5rem] border-secondary-600" : "justify-center px-4 border-transparent"}`,
            children: /* @__PURE__ */ f.jsxs("div", { className: "flex items-center gap-2", children: [
              /* @__PURE__ */ f.jsx("span", { className: "w-[20px] min-w-[20px]", children: /* @__PURE__ */ f.jsx(Me, { variant: "filter" }) }),
              /* @__PURE__ */ f.jsx("span", { children: "Consulta" })
            ] })
          }
        ),
        p > 0 && /* @__PURE__ */ f.jsxs("div", { className: "absolute top-1/2 -translate-y-1/2 right-4 hidden s:flex items-center gap-2 z-[1] pointer-events-none font-bold", children: [
          /* @__PURE__ */ f.jsx("span", { className: "flex w-5 h-5 rounded-full bg-secondary-600 text-white text-xs items-center justify-center", children: p }),
          /* @__PURE__ */ f.jsx(
            "span",
            {
              onClick: g,
              className: "w-[14px] min-w-[14px] hover:scale-110 active:scale-95 pointer-events-auto cursor-pointer text-secondary-600",
              children: /* @__PURE__ */ f.jsx(Me, { variant: "close", width: 14 })
            }
          )
        ] })
      ] }),
      i.reports && /* @__PURE__ */ f.jsx("div", { className: "m:w-[215px]", children: /* @__PURE__ */ f.jsx(Qr, { variant: "secondary", size: "m", isFull: !0, onClick: v, children: /* @__PURE__ */ f.jsx("span", { className: `block ${y > 1 ? "w-[35vw] m:w-auto text-ellipsis overflow-hidden whitespace-nowrap h-[30px] leading-[30px]" : "whitespace-nowrap"}`, children: "Reportes programados" }) }) }),
      i.export && /* @__PURE__ */ f.jsx("div", { className: "m:min-w-[140px]", children: /* @__PURE__ */ f.jsx(Qr, { variant: "secondary-bold", size: "m", isFull: !0, onClick: C, children: "Exportar" }) })
    ] }) })
  ] }) });
});
n$.displayName = "TableHeaderDeclarant";
const a$ = B.forwardRef((e, t) => {
  const {
    text: r = "Cargando...",
    className: n
  } = e;
  return /* @__PURE__ */ f.jsx("div", { ref: t, className: Ye(["bg-secondary-100 flex items-center justify-center p-5 rounded-md min-h-[70vh] select-none", n]), children: /* @__PURE__ */ f.jsxs("div", { className: "text-center animate-pulse", children: [
    /* @__PURE__ */ f.jsx("div", { className: "bg-white flex justify-center items-center w-[64px] h-[64px] rounded-md mb-4", children: /* @__PURE__ */ f.jsx(
      "svg",
      {
        version: "1.0",
        xmlns: "http://www.w3.org/2000/svg",
        width: "352.000000pt",
        height: "374.000000pt",
        viewBox: "0 0 352.000000 374.000000",
        preserveAspectRatio: "xMidYMid meet",
        children: /* @__PURE__ */ f.jsxs(
          "g",
          {
            transform: "translate(0.000000,374.000000) scale(0.100000,-0.100000)",
            fill: "#000000",
            stroke: "none",
            children: [
              /* @__PURE__ */ f.jsx("path", { d: `M2115 3189 c-27 -6 -63 -16 -80 -23 -16 -8 -47 -19 -67 -25 -20 -7\r
          -42 -19 -48 -27 -7 -7 -18 -14 -25 -14 -31 0 -190 -169 -231 -245 -35 -64\r
          -142 -272 -177 -340 -22 -44 -44 -81 -49 -83 -4 -2 -8 -9 -8 -15 0 -7 -13 -40\r
          -30 -73 -16 -33 -34 -72 -40 -85 -5 -13 -14 -31 -20 -39 -5 -8 -21 -42 -36\r
          -75 -14 -33 -38 -87 -53 -120 -15 -33 -34 -76 -41 -95 -8 -19 -16 -37 -20 -40\r
          -3 -3 -14 -30 -24 -60 -11 -30 -22 -57 -26 -60 -3 -3 -14 -33 -25 -67 -10 -35\r
          -21 -63 -25 -63 -3 0 -12 -22 -19 -48 -6 -26 -19 -61 -27 -78 -9 -16 -23 -51\r
          -31 -79 -8 -27 -19 -54 -23 -60 -14 -18 -32 -126 -33 -206 -2 -83 -12 -97 -46\r
          -64 -35 34 -96 67 -149 80 -66 18 -181 19 -236 4 -42 -12 -92 -57 -107 -97\r
          -12 -32 -11 -159 2 -204 21 -77 127 -158 207 -158 13 0 41 -4 61 -9 20 -5 61\r
          -14 90 -21 79 -15 138 -48 164 -89 45 -74 106 -113 203 -130 32 -6 70 -14 84\r
          -18 14 -4 88 -7 165 -8 77 0 146 -4 154 -9 21 -14 672 -12 696 2 13 7 17 14\r
          10 20 -19 18 -110 62 -127 62 -10 0 -18 5 -18 11 0 7 25 10 73 9 97 -4 110 -2\r
          131 13 17 13 15 16 -26 39 -24 15 -72 32 -106 39 -34 7 -62 16 -62 21 0 4 38\r
          46 84 93 72 73 146 164 146 181 0 3 13 33 29 67 15 34 34 87 41 117 7 30 16\r
          60 20 65 10 12 40 199 40 244 0 17 4 39 9 49 5 9 13 91 18 182 9 163 9 165 41\r
          212 37 54 128 138 148 138 8 0 14 4 14 10 0 13 95 40 141 40 21 0 41 5 44 10\r
          3 6 15 10 27 10 26 0 78 56 78 84 0 22 -51 86 -69 86 -5 0 -17 8 -27 18 -15\r
          14 -37 17 -151 17 -132 0 -133 0 -133 22 0 16 -9 27 -27 35 -31 13 -63 38 -63\r
          48 0 15 96 47 191 64 35 6 59 35 59 71 0 8 19 27 43 42 23 15 50 36 59 47 19\r
          23 24 76 8 76 -5 0 -10 22 -10 49 0 28 5 53 10 56 26 16 -6 76 -47 89 -11 3\r
          -42 32 -69 62 -82 95 -179 162 -299 207 -121 45 -242 57 -360 36z m350 -77\r
          c117 -39 180 -73 248 -133 65 -58 74 -77 52 -119 -14 -27 -14 -33 1 -62 9 -17\r
          26 -39 38 -49 17 -14 21 -28 21 -80 l0 -64 -40 -21 c-22 -13 -53 -23 -70 -25\r
          -30 -2 -30 -2 5 -8 64 -11 47 -66 -24 -76 -11 -2 -47 -13 -78 -24 -32 -12 -66\r
          -21 -77 -21 -11 0 -23 -5 -27 -11 -4 -7 -24 -9 -54 -6 -29 4 -66 0 -95 -9 -27\r
          -8 -75 -14 -107 -14 -41 0 -78 -8 -120 -26 -34 -14 -72 -24 -86 -21 l-24 5 25\r
          -26 c30 -30 109 -41 172 -23 21 6 40 9 42 8 1 -2 5 -37 9 -78 4 -41 11 -80 17\r
          -87 11 -14 2 -23 -78 -74 -67 -42 -116 -73 -167 -105 -24 -14 -55 -34 -69 -44\r
          -78 -53 -134 -74 -196 -74 -46 0 -67 5 -82 19 -12 11 -21 15 -21 10 0 -5 9\r
          -15 21 -22 24 -15 21 -41 -10 -102 -10 -19 -24 -53 -31 -75 -7 -22 -16 -44\r
          -20 -50 -14 -19 -19 -60 -13 -98 5 -34 8 -38 29 -33 19 5 24 2 24 -12 0 -10 4\r
          -22 9 -28 4 -5 16 -44 26 -86 10 -43 21 -78 24 -78 4 0 13 -15 19 -34 11 -30\r
          51 -88 122 -176 l20 -25 0 51 c0 29 6 58 15 70 11 15 13 36 8 91 -6 76 1 88\r
          31 57 15 -14 16 -7 16 81 l0 97 25 -6 c22 -6 25 -2 30 31 11 71 41 96 51 44 8\r
          -40 20 -32 28 19 3 23 20 66 36 97 53 100 70 108 70 33 0 -27 5 -50 10 -50 6\r
          0 10 9 10 20 0 11 5 20 10 20 6 0 10 10 10 23 0 29 19 57 27 40 11 -28 21 -9\r
          38 69 10 46 21 89 26 98 4 8 15 39 24 68 9 28 21 52 26 52 5 0 9 6 9 13 0 6\r
          18 33 40 58 51 60 131 101 201 103 l54 1 3 -51 c3 -44 -1 -54 -23 -75 -109\r
          -101 -136 -136 -171 -215 -20 -46 -27 -87 -40 -242 -8 -103 -19 -196 -24 -207\r
          -4 -11 -13 -73 -19 -139 -10 -118 -23 -158 -45 -136 -8 8 -14 -3 -21 -41 -10\r
          -53 -30 -75 -38 -42 -2 13 -7 7 -13 -17 -13 -44 -34 -45 -48 -3 -18 52 -26 49\r
          -26 -10 0 -56 -16 -78 -27 -37 -3 11 -9 20 -13 20 -5 0 -10 8 -12 18 -3 9 -8\r
          -34 -12 -97 -7 -92 -11 -114 -25 -118 -9 -2 -29 -31 -45 -64 -82 -169 -164\r
          -209 -433 -209 l-153 0 0 -35 c0 -29 -4 -36 -26 -41 -37 -9 -287 2 -310 14\r
          -11 5 -37 15 -59 22 -63 20 -135 79 -155 127 -6 14 -21 23 -50 28 -22 4 -46\r
          13 -53 20 -7 7 -23 16 -35 19 -28 9 -122 121 -122 145 0 9 -5 22 -12 29 -9 9\r
          -6 12 15 12 21 0 27 5 27 21 0 16 5 20 20 16 15 -4 20 0 20 14 0 22 11 24 28\r
          7 9 -9 12 -6 12 15 0 31 0 30 34 17 18 -7 26 -6 26 2 0 16 -40 78 -51 78 -5 0\r
          -9 7 -9 15 0 35 74 4 124 -52 17 -19 40 -45 51 -58 11 -12 37 -32 57 -43 l36\r
          -21 -14 34 c-8 19 -14 37 -14 40 0 13 24 3 41 -17 l19 -23 -6 30 c-4 17 -10\r
          32 -14 35 -10 7 -30 152 -32 230 -1 83 20 179 44 193 14 10 18 25 18 78 0 48\r
          4 70 15 79 9 7 23 40 32 72 15 54 53 108 75 108 5 0 15 15 23 33 29 64 64 86\r
          65 39 1 -13 7 -10 24 12 15 17 30 27 39 23 11 -4 17 8 26 53 13 67 22 77 45\r
          54 15 -14 16 -14 16 5 0 11 5 23 10 26 6 3 10 16 10 28 0 34 16 55 32 39 19\r
          -19 25 -15 32 29 8 49 51 174 69 203 25 38 29 70 36 262 4 117 10 196 17 205\r
          6 8 15 25 19 38 11 37 64 116 78 116 7 0 14 -20 17 -50 8 -69 24 -95 59 -95\r
          48 0 110 57 111 101 0 29 -13 43 -50 54 -14 3 -40 13 -57 21 -31 14 -32 16\r
          -18 37 22 33 75 72 120 88 22 7 45 17 52 22 24 18 112 26 233 22 104 -3 140\r
          -9 215 -33z m34 -721 c7 -5 14 -20 14 -35 0 -23 4 -26 31 -26 32 0 56 -15 56\r
          -35 0 -20 -233 -155 -269 -155 -28 0 -26 186 2 202 9 4 23 15 31 23 31 31 105\r
          45 135 26z m400 -154 c59 -16 74 -41 41 -69 -14 -11 -24 -25 -22 -30 1 -5 -2\r
          -18 -8 -28 -14 -27 -84 -27 -128 0 -51 31 -89 109 -65 133 10 11 134 6 182 -6z` }),
              /* @__PURE__ */ f.jsx("path", { d: `M2327 2936 c8 -38 35 -57 71 -50 36 7 39 19 16 52 -11 16 -25 22 -53\r
          22 -35 0 -38 -2 -34 -24z` }),
              /* @__PURE__ */ f.jsx("path", { d: `M1710 1990 c-13 -9 -12 -12 5 -26 14 -11 35 -14 72 -11 57 4 72 12\r
          56 28 -15 15 -115 22 -133 9z` }),
              /* @__PURE__ */ f.jsx("path", { d: `M2311 1413 c-7 -15 -20 -44 -30 -63 -10 -19 -22 -54 -26 -78 l-7 -44\r
          30 16 c46 24 74 79 70 139 -3 58 -20 71 -37 30z` }),
              /* @__PURE__ */ f.jsx("path", { d: `M1560 1267 c0 -10 -8 -17 -19 -17 -43 0 3 -115 71 -178 33 -30 58\r
          -20 58 22 0 18 7 41 15 52 32 42 1 94 -60 99 -23 2 -45 11 -52 21 -12 16 -13\r
          17 -13 1z` })
            ]
          }
        )
      }
    ) }),
    /* @__PURE__ */ f.jsx(a1, { variant: "description-3", children: r })
  ] }) });
});
a$.displayName = "TableLoader";
const _b = (e) => {
  const {
    actions: t = [],
    row: r,
    canEdit: n,
    onEditClick: a,
    onActionClick: i,
    onRowClick: o,
    handleDisplayDetail: s,
    handleClickDetail: c,
    showDetail: u
  } = e, [d, h] = De(!1), A = ge(null), p = ge(null), m = () => {
    h(!1), a !== void 0 && a({ row: r });
  }, g = (O) => () => {
    i !== void 0 && i({ row: r, action: O }), h(!1);
  }, v = () => {
    o !== void 0 && o({ row: r });
  }, C = (O) => {
    if (A.current !== null && !A.current.contains(O.target)) {
      if (p.current !== null) {
        if (p.current.contains(O.target))
          return;
        h(!1);
        return;
      }
      h(!1);
    }
  };
  Ie(() => (document.addEventListener("click", C, !0), () => {
    document.removeEventListener("click", C, !0);
  }), []);
  const [y, w] = De(!0);
  return /* @__PURE__ */ f.jsxs("div", { className: "relative", children: [
    /* @__PURE__ */ f.jsx(
      Qr,
      {
        type: "button",
        variant: "secondary-light-bold",
        icon: "menu-context",
        tooltip: "Acciones",
        tooltipDirection: "left",
        disabled: t.length === 0,
        ref: A,
        size: "s",
        onlyIcon: !0,
        onClick: () => {
          h((O) => !O);
        }
      }
    ),
    d && /* @__PURE__ */ f.jsx("div", { ref: p, className: "absolute top-[calc(100%+8px)] right-0 z-[20] cursor-default pb-[20px] pointer-events-none", children: /* @__PURE__ */ f.jsx("div", { className: "bg-white min-w-[165px] max-w-[250px] p-4 rounded-md shadow-l pointer-events-auto", children: /* @__PURE__ */ f.jsxs("ul", { children: [
      n && /* @__PURE__ */ f.jsxs(
        "li",
        {
          onClick: m,
          className: "p-2 rounded-md font-bold text-secondary-600 cursor-pointer min-h-[40px] flex items-center gap-2 hover:bg-secondary-200 2s:hidden",
          children: [
            /* @__PURE__ */ f.jsx("span", { className: "w-5 h-5 object-contain min-w-[20px]", children: /* @__PURE__ */ f.jsx(Me, { variant: "edit", isContain: !0 }) }),
            /* @__PURE__ */ f.jsx("p", { className: "leading-[120%] grow w-full text-ellipsis overflow-hidden whitespace-nowrap", children: "Editar" })
          ]
        }
      ),
      t.map((O) => /* @__PURE__ */ f.jsxs(
        "li",
        {
          onClick: g(O),
          className: "p-2 rounded-md font-bold text-secondary-600 cursor-pointer min-h-[40px] flex items-center gap-2 hover:bg-secondary-200",
          children: [
            /* @__PURE__ */ f.jsx("span", { className: "w-5 h-5 object-contain min-w-[20px]", children: /* @__PURE__ */ f.jsx(Me, { variant: O.icon, isContain: !0 }) }),
            /* @__PURE__ */ f.jsx("p", { className: "leading-[120%] grow w-full text-ellipsis overflow-hidden whitespace-nowrap", children: O.title })
          ]
        },
        O.id
      )),
      u && /* @__PURE__ */ f.jsxs(
        "li",
        {
          onClick: () => {
            s !== void 0 && (s({ row: r, isShowDetail: y }), c !== void 0 && c({ row: r }), w((O) => !O));
          },
          className: "p-2 rounded-md font-bold text-secondary-600 cursor-pointer min-h-[40px] flex items-center gap-2 hover:bg-secondary-200 2s:hidden",
          children: [
            /* @__PURE__ */ f.jsx("span", { className: "w-5 h-5 object-contain min-w-[20px]", children: /* @__PURE__ */ f.jsx(Me, { variant: "arrow-down", isContain: !0 }) }),
            /* @__PURE__ */ f.jsx("p", { className: "leading-[120%] grow w-full text-ellipsis overflow-hidden whitespace-nowrap", children: "Ver detalle" })
          ]
        }
      ),
      t.length === 0 && /* @__PURE__ */ f.jsxs(
        "li",
        {
          onClick: v,
          className: "p-2 rounded-md font-bold text-secondary-600 cursor-pointer min-h-[40px] flex items-center gap-2 hover:bg-secondary-200",
          children: [
            /* @__PURE__ */ f.jsx("span", { className: "w-5 h-5 object-contain min-w-[20px]", children: /* @__PURE__ */ f.jsx(Me, { variant: "eye", isContain: !0 }) }),
            /* @__PURE__ */ f.jsx("p", { className: "leading-[120%] grow w-full text-ellipsis overflow-hidden whitespace-nowrap", children: "Ver" })
          ]
        }
      )
    ] }) }) })
  ] });
}, i$ = (e) => {
  const {
    actions: t,
    row: r,
    index: n,
    detailData: a = [],
    detailColumns: i = [],
    handleDeleteDetatail: o,
    rowDetail: s,
    NOMCOLXX: c,
    onRowDetailClick: u
  } = e, d = t.filter((h) => h.id === 104);
  return /* @__PURE__ */ f.jsx(f.Fragment, { children: a.map((h, A) => s !== r[c] ? null : /* @__PURE__ */ f.jsxs(
    "div",
    {
      className: "relative p-4 rounded-md bg-secondary-400 hover:bg-secondary-300 hover:text-secondary-600 w-full cursor-pointer",
      onClick: () => {
        u !== void 0 && u({ row: h });
      },
      children: [
        Object.entries(h).map(([p, m]) => i.find((v) => v.id === p) === void 0 ? null : /* @__PURE__ */ f.jsx("p", { className: "w-full text-ellipsis overflow-hidden whitespace-nowrap", children: m })),
        /* @__PURE__ */ f.jsx("div", { className: "absolute top-4 right-4", children: /* @__PURE__ */ f.jsx("div", { className: "bg-secondary-400", children: d && /* @__PURE__ */ f.jsx(
          Qr,
          {
            type: "button",
            variant: "secondary-light-bold",
            icon: "trash",
            tooltip: "Eliminar",
            tooltipDirection: "left",
            size: "s",
            onlyIcon: !0,
            onClick: () => {
              o !== void 0 && o({ item: h, row: r });
            }
          }
        ) }) })
      ]
    },
    `detail-${n}-${A}`
  )) });
}, o$ = (e) => {
  const {
    actions: t = [],
    columns: r = [],
    data: n = [],
    canEdit: a,
    onEditClick: i,
    onActionClick: o,
    onRowClick: s,
    handleDisplayDetail: c,
    detailData: u,
    detailColumns: d = [],
    showDetail: h,
    handleDeleteDetatail: A
  } = e, p = d.length > 0 ? d[0].id : "", [m, g] = De(null), v = (C) => {
    const { row: y } = C;
    g(y[p]);
  };
  return /* @__PURE__ */ f.jsx("div", { className: "grid gap-2 2s:hidden", children: n.map((C, y) => /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
    /* @__PURE__ */ f.jsxs(
      "div",
      {
        className: "relative p-4 rounded-md bg-secondary-100 hover:bg-secondary-200 hover:text-secondary-600 w-full cursor-pointer",
        children: [
          /* @__PURE__ */ f.jsx(
            "div",
            {
              className: "flex flex-wrap gap-y-1.5 gap-x-6",
              onClick: () => {
                s !== void 0 && s({ row: C });
              },
              children: Object.entries(C).filter(([w]) => r.some((O) => O.id === w && O.isMobileShow)).map(([w, O]) => {
                const b = r.find((j) => j.id === w);
                if (b === void 0)
                  return null;
                const {
                  isMobileShow: D = !1,
                  isTextBold: M = !1
                } = b;
                return D ? /* @__PURE__ */ f.jsx(
                  "p",
                  {
                    className: `leading-[120%] ${M ? "font-bold" : ""} w-full pr-12`,
                    children: O
                  },
                  w
                ) : null;
              })
            }
          ),
          /* @__PURE__ */ f.jsx("div", { className: "absolute top-4 right-4", children: /* @__PURE__ */ f.jsx(
            _b,
            {
              actions: t,
              row: C,
              canEdit: a,
              onEditClick: i,
              onActionClick: o,
              onRowClick: s,
              handleDisplayDetail: c,
              detailColumns: d,
              showDetail: h,
              handleClickDetail: v
            }
          ) })
        ]
      },
      C.id
    ),
    u.length > 0 && /* @__PURE__ */ f.jsx(
      i$,
      {
        actions: t,
        row: C,
        index: y,
        detailData: u,
        detailColumns: d,
        handleDeleteDetatail: A,
        rowDetail: m,
        NOMCOLXX: p,
        onRowDetailClick: s
      }
    )
  ] })) });
}, s$ = (e) => {
  const {
    columns: t = [],
    onChangeShowColumn: r
  } = e, [n, a] = De(!1), [i, o] = De(!1), s = ge(null), c = ge(null), u = (d) => {
    if (s.current !== null && !s.current.contains(d.target)) {
      if (c.current !== null) {
        if (c.current.contains(d.target))
          return;
        a(!1);
        return;
      }
      a(!1);
    }
  };
  return Ie(() => (document.addEventListener("click", u, !0), () => {
    document.removeEventListener("click", u, !0);
  }), []), Ie(() => {
    t.filter((h) => h.canToggleShow).length > 0 ? o(!0) : o(!1);
  }, [t]), i ? /* @__PURE__ */ f.jsxs("div", { className: "relative", children: [
    /* @__PURE__ */ f.jsx(
      Qr,
      {
        type: "button",
        ref: s,
        variant: "secondary",
        icon: "column-actions",
        active: n,
        size: "s",
        onlyIcon: !0,
        tooltip: "Visualizar columnas",
        tooltipDirection: "left",
        onClick: () => {
          a((d) => !d);
        }
      }
    ),
    n && /* @__PURE__ */ f.jsx("div", { ref: c, className: "absolute top-[calc(100%+4px)] right-0 z-[30]", children: /* @__PURE__ */ f.jsxs("div", { className: "bg-white rounded-md shadow-xl w-[330px]", children: [
      /* @__PURE__ */ f.jsx("div", { className: "px-4 py-3.5 border-b border-b-neutral-300", children: /* @__PURE__ */ f.jsx(kr, { variant: "title-3", children: "Ver / esconder columnas" }) }),
      /* @__PURE__ */ f.jsx("div", { className: "p-4 max-h-80 overflow-y-auto", children: /* @__PURE__ */ f.jsx(i9, { gap: 2, children: t.map((d) => d.canToggleShow ? /* @__PURE__ */ f.jsx(
        p0,
        {
          type: "switch",
          variantSize: "xs",
          isBold: !0,
          checked: d.isShow,
          onChange: () => {
            r !== void 0 && r({ column: d });
          },
          children: /* @__PURE__ */ f.jsx("p", { children: d.title })
        },
        d.id
      ) : null) }) })
    ] }) })
  ] }) : /* @__PURE__ */ f.jsx(f.Fragment, {});
}, l$ = (e) => {
  const {
    columns: t = [],
    onColumnClick: r,
    onChangeShowColumn: n,
    isCheckedRow: a,
    handleCheckedAllRows: i,
    data: o,
    ischeckedAll: s,
    handleOrderChange: c
  } = e;
  return /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
    a && /* @__PURE__ */ f.jsx(
      "div",
      {
        style: { gridArea: "col-reserved-check" },
        className: "min-w-[50px] flex gap-2 justify-between items-center px-4",
        children: /* @__PURE__ */ f.jsx(
          "input",
          {
            type: "checkbox",
            id: "checkAll",
            title: "Seleccionar todos",
            className: "w-full overflow-hidden whitespace-nowrap",
            onChange: (u) => {
              i !== void 0 && i(o, u.target.checked);
            },
            checked: s
          }
        )
      }
    ),
    t.filter((u) => u.isShow).map((u) => /* @__PURE__ */ f.jsxs(
      "div",
      {
        style: { gridArea: `col-${u.id}` },
        title: u.title,
        className: `min-w-[205px] flex gap-2 justify-between items-center px-4 font-bold leading-[120%] select-none ${u.sorted && u.orderBy !== null ? "text-secondary-600" : "hover:text-secondary-500"}`,
        children: [
          /* @__PURE__ */ f.jsx("p", { className: "w-full text-ellipsis overflow-hidden whitespace-nowrap", children: u.title }),
          u.sortable && /* @__PURE__ */ f.jsx(
            "button",
            {
              type: "button",
              className: "w-6 h-6 flex items-center justify-center",
              onClick: () => {
                r !== void 0 && r({ column: u });
              },
              children: /* @__PURE__ */ f.jsxs(
                "svg",
                {
                  className: "w-5",
                  viewBox: "0 0 25 24",
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg",
                  children: [
                    /* @__PURE__ */ f.jsx(
                      "path",
                      {
                        d: "M16.743 10L8.25505 10C8.1049 9.9994 7.95831 9.95665 7.83381 9.87715C7.70931 9.79765 7.6125 9.68497 7.55561 9.55336C7.49873 9.42176 7.48433 9.27713 7.51423 9.13777C7.54413 8.99841 7.61699 8.87057 7.7236 8.77043L11.96 4.75815C12.0306 4.69075 12.1145 4.63726 12.207 4.60075C12.2996 4.56425 12.3988 4.54545 12.499 4.54545C12.5992 4.54545 12.6985 4.56425 12.791 4.60075C12.8835 4.63726 12.9675 4.69075 13.0381 4.75815L17.2744 8.77043C17.3811 8.87057 17.4539 8.99841 17.4838 9.13777C17.5137 9.27713 17.4993 9.42176 17.4424 9.55337C17.3855 9.68497 17.2887 9.79765 17.1642 9.87715C17.0397 9.95665 16.8931 9.9994 16.743 10Z",
                        fill: u.sorted && u.orderBy === "asc" ? "#2875B4" : "#E6E6E6"
                      }
                    ),
                    /* @__PURE__ */ f.jsx(
                      "path",
                      {
                        d: "M8.25505 14H16.743C16.8931 14.0006 17.0397 14.0433 17.1642 14.1228C17.2887 14.2023 17.3855 14.315 17.4424 14.4466C17.4993 14.5782 17.5137 14.7229 17.4838 14.8622C17.4539 15.0016 17.3811 15.1294 17.2744 15.2296L13.0381 19.2419C12.9675 19.3092 12.8835 19.3627 12.791 19.3992C12.6985 19.4358 12.5992 19.4545 12.499 19.4545C12.3988 19.4545 12.2996 19.4358 12.207 19.3992C12.1145 19.3627 12.0306 19.3092 11.96 19.2419L7.7236 15.2296C7.61699 15.1294 7.54413 15.0016 7.51423 14.8622C7.48433 14.7229 7.49873 14.5782 7.55561 14.4466C7.6125 14.315 7.70931 14.2023 7.83381 14.1228C7.95831 14.0433 8.1049 14.0006 8.25505 14Z",
                        fill: u.sorted && u.orderBy === "desc" ? "#2875B4" : "#E6E6E6"
                      }
                    )
                  ]
                }
              )
            }
          )
        ]
      },
      u.id
    )),
    /* @__PURE__ */ f.jsx("div", { className: "sticky right-0 bg-white z-[99999]", style: { gridArea: "col-reserved-actions" }, children: /* @__PURE__ */ f.jsxs("div", { className: "flex items-center justify-between pl-4 pr-2 h-10 select-none", children: [
      /* @__PURE__ */ f.jsx("p", { className: "font-bold", children: "Acciones" }),
      /* @__PURE__ */ f.jsx(
        Qr,
        {
          type: "button",
          variant: "secondary",
          icon: "column-order",
          size: "s",
          onlyIcon: !0,
          onClick: () => {
            c !== void 0 && c(!0);
          },
          tooltip: "Reordenar Columnas",
          tooltipDirection: "left"
        }
      ),
      /* @__PURE__ */ f.jsx(
        s$,
        {
          columns: t,
          onChangeShowColumn: n
        }
      )
    ] }) })
  ] });
}, c$ = (e) => {
  const {
    actions: t,
    row: r,
    index: n,
    detailData: a = [],
    detailColumns: i = [],
    handleDeleteDetatail: o,
    rowDetail: s,
    NOMCOLXX: c,
    onRowDetailClick: u,
    colorColumn: d
  } = e, h = i.map((v) => `col-${v.id}`).concat("col-reserved-actions").join(" ").toString();
  let A = 0;
  const p = Array.from({ length: i.length }, () => {
    let v = "1fr";
    return A === 0 && (v = "0.2fr"), A++, v;
  }).join(" ").toString(), m = { gridTemplateAreas: `'${h}'`, gridTemplateColumns: p + " 150px" }, g = t.filter((v) => v.id === "toggle");
  return /* @__PURE__ */ f.jsx(f.Fragment, { children: a.map((v, C) => s !== r[c] ? null : /* @__PURE__ */ f.jsxs(
    "div",
    {
      style: m,
      className: "bg-secondary-400 hover:bg-secondary-300 hover:text-secondary-600 cursor-pointer border-b border-white last:border-none h-[48px] grid w-full",
      children: [
        /* @__PURE__ */ f.jsx("div", { className: "bg-white", children: /* @__PURE__ */ f.jsx("div", { className: "flex items-center gap-2 h-[48px]", children: /* @__PURE__ */ f.jsx(Me, { variant: "arrow-turn-down-right" }) }) }),
        Object.entries(v).map(([y, w]) => {
          const O = i.find((j) => j.id === y);
          if (O === void 0)
            return null;
          let b = d ? d.filter((j) => j.title === y) : [], D = !1, M = "";
          if (b.length > 0) {
            D = !0;
            const j = b[0].params.filter((H) => H.value === w), P = j.length > 0 ? j[0].color : "transparent";
            M = gt[P];
          }
          return /* @__PURE__ */ f.jsx(
            "div",
            {
              style: { gridArea: `col-${O.id}` },
              title: w,
              className: "min-w-[205px] flex items-center px-4 border-l border-white first:border-none leading-[120%]",
              onClick: () => {
                if (u !== void 0) {
                  const j = { ...v };
                  Object.keys(j).forEach((P) => {
                    P.startsWith("TARIDCHX") && (j.TARIDXXX = j[P], delete j[P]);
                  }), u({ row: j });
                }
              },
              children: D ? /* @__PURE__ */ f.jsx("div", { className: "w-full h-8 px-4 justify-center items-center gap-2 flex", style: { borderRadius: "8px", backgroundColor: M }, children: /* @__PURE__ */ f.jsx("div", { className: "grow text-center text-white text-xs font-bold leading-[14.40px]", children: w }) }) : /* @__PURE__ */ f.jsx("p", { className: "w-full text-ellipsis overflow-hidden whitespace-nowrap", children: w })
            },
            y
          );
        }),
        /* @__PURE__ */ f.jsx("div", { className: "bg-white sticky block right-0 border-l border-white cursor-default pr-1", children: /* @__PURE__ */ f.jsx("div", { className: "bg-secondary-400", children: /* @__PURE__ */ f.jsx("div", { className: "flex items-center gap-2 h-[48px] px-4", children: g.length > 0 && /* @__PURE__ */ f.jsx(
          Qr,
          {
            type: "button",
            variant: "secondary-light-bold",
            icon: "trash",
            tooltip: "Eliminar",
            tooltipDirection: "left",
            size: "s",
            onlyIcon: !0,
            onClick: () => {
              o !== void 0 && o({ item: v, row: r });
            }
          }
        ) }) }) })
      ]
    },
    `detail-${n}-${C}`
  )) });
}, u$ = (e) => {
  const {
    actions: t = [],
    columns: r = [],
    data: n = [],
    canEdit: a,
    activeRowValidation: i,
    onEditClick: o,
    onActionClick: s,
    onRowClick: c,
    onColumnClick: u,
    onChangeShowColumn: d,
    handleDisplayDetail: h,
    detailData: A = [],
    detailColumns: p = [],
    showDetail: m,
    handleDeleteDetatail: g,
    isCheckedRow: v,
    handleCheckedRow: C,
    handleCheckedAllRows: y,
    selectedRows: w,
    colorColumn: O,
    intermediateContent: b,
    ischeckedAll: D,
    handleOrderChange: M
  } = e, j = (v ? "col-reserved-check " : "") + r.filter((W) => W.isShow).map((W) => `col-${W.id}`).concat("col-reserved-actions").join(" ").toString(), P = (v ? "50px " : "") + Array.from({ length: r.filter((W) => W.isShow).length }, () => "1fr").concat(a ? "150px" : "").join(" ").toString(), H = { gridTemplateAreas: `'${j}'`, gridTemplateColumns: P }, [F, R] = De(null), N = p.length > 0 ? p[0].id : "", [z, q] = De(!0), J = (W) => {
    const { row: te } = W;
    R(te[N]);
  };
  return /* @__PURE__ */ f.jsx("div", { className: "grid gap-2 hidden 2s:block", children: /* @__PURE__ */ f.jsx("div", { className: `${b ? "" : "max-h-[calc(100vh-461px)] min-h-[calc(100vh-461px)]"}
                        ${b ? "" : "m:max-h-[calc(100vh-305px)] m:min-h-[calc(100vh-305px)]"}
                        ${b ? "" : "l:max-h-[calc(100vh-312px)] l:min-h-[calc(100vh-312px)]"}
                        ${b ? "table-max-height" : ""}
                        w-full overflow-x-auto overflow-y-auto table-main-scrollbar pb-1`, children: /* @__PURE__ */ f.jsxs("div", { className: "min-w-[min-content]", children: [
    /* @__PURE__ */ f.jsx("div", { className: "bg-white grid w-full h-10 sticky top-0", style: { ...H, zIndex: n.length + 10 }, children: /* @__PURE__ */ f.jsx(
      l$,
      {
        columns: r,
        onColumnClick: u,
        onChangeShowColumn: d,
        isCheckedRow: v,
        handleCheckedAllRows: y,
        data: n,
        ischeckedAll: D,
        handleOrderChange: M
      }
    ) }),
    /* @__PURE__ */ f.jsx("div", { className: "bg-secondary-100 w-full", children: /* @__PURE__ */ f.jsx("div", { children: n.map((W, te) => {
      const S = te % 2 === 0, I = i === void 0 || W[i.field] === void 0 ? !0 : W[i.field] === i.value, T = I ? S ? "bg-secondary-200" : "bg-secondary-100" : "bg-neutral-200 text-neutral-400", E = w && w.some((x) => JSON.stringify(x) === JSON.stringify(W));
      return /* @__PURE__ */ f.jsxs(rP, { children: [
        /* @__PURE__ */ f.jsxs(
          "div",
          {
            style: H,
            className: `${T} hover:bg-secondary-300 hover:text-secondary-600 cursor-pointer border-b border-white last:border-none h-[40px] grid w-full`,
            children: [
              v && /* @__PURE__ */ f.jsx("div", { className: "min-w-[50px] flex justify-between items-center pr-1", children: /* @__PURE__ */ f.jsx(
                "input",
                {
                  type: "checkbox",
                  title: "Seleccionar",
                  checked: E || D,
                  className: "checkbox w-full overflow-hidden whitespace-nowrap",
                  onChange: (x) => {
                    C !== void 0 && C(W, x.target.checked);
                  }
                }
              ) }),
              Object.entries(W).map(([x, $]) => {
                const _ = r.find((U) => U.id === x);
                if (_ === void 0 || !_.isShow)
                  return null;
                const {
                  isTextBold: Q = !1
                } = _;
                let Z = !1, X = "", Y = O ? O.filter((U) => U.title === x) : [];
                if (Y.length > 0) {
                  Z = !0;
                  const U = Y[0].params.filter((L) => L.value === $), k = U.length > 0 ? U[0].color : "transparent";
                  X = gt[k];
                }
                return /* @__PURE__ */ f.jsx(
                  "div",
                  {
                    style: { gridArea: `col-${_.id}` },
                    title: $,
                    className: `min-w-[205px] h-10 flex items-center px-4 border-l border-white first:border-none leading-[120%] ${Q ? "font-bold" : ""}`,
                    onClick: () => {
                      c !== void 0 && !_.onClickCell && c({ row: W });
                    },
                    children: Z ? /* @__PURE__ */ f.jsx("div", { className: "w-full h-8 px-4 justify-center items-center gap-2 flex", style: { borderRadius: "8px", backgroundColor: X }, children: /* @__PURE__ */ f.jsx("div", { className: "grow text-center text-white text-xs font-bold leading-[14.40px]", children: $ }) }) : /* @__PURE__ */ f.jsx(
                      "p",
                      {
                        className: `w-full text-ellipsis overflow-hidden whitespace-nowrap ${_.isHyperlink ? "underline text-secondary-600" : ""}`,
                        onClick: () => _.onClickCell && _.onClickCell(W, _),
                        children: $
                      }
                    )
                  },
                  x
                );
              }),
              /* @__PURE__ */ f.jsx("div", { className: "bg-white sticky block right-0 border-l border-white cursor-default pr-1", style: { zIndex: n.length - te + 1 }, children: /* @__PURE__ */ f.jsx("div", { className: T, children: /* @__PURE__ */ f.jsxs("div", { className: `flex items-center gap-2 h-[40px] ${a ? "px-4" : "pl-6 pr-4"} ${te + 1 === n.length ? "" : "border-b border-white"}`, children: [
                a && I ? /* @__PURE__ */ f.jsx(
                  Qr,
                  {
                    type: "button",
                    variant: "secondary-light-bold",
                    icon: "edit",
                    tooltip: "Editar",
                    tooltipDirection: "left",
                    disabled: !I,
                    size: "s",
                    onlyIcon: !0,
                    onClick: () => {
                      o !== void 0 && o({ row: W });
                    }
                  }
                ) : "        ",
                /* @__PURE__ */ f.jsx(
                  _b,
                  {
                    actions: t,
                    row: W,
                    canEdit: a,
                    onEditClick: o,
                    onActionClick: s,
                    onRowClick: c,
                    handleDisplayDetail: h,
                    detailColumns: p,
                    showDetail: m,
                    handleClickDetail: J
                  }
                ),
                m && /* @__PURE__ */ f.jsx(f.Fragment, { children: /* @__PURE__ */ f.jsx(
                  Qr,
                  {
                    type: "button",
                    variant: "secondary-light-bold",
                    icon: "arrow-down",
                    tooltip: "Ver Detalle",
                    tooltipDirection: "left",
                    size: "s",
                    onlyIcon: !0,
                    onClick: () => {
                      h !== void 0 && (h({ row: W, isShowDetail: z }), J({ row: W }), q((x) => !x));
                    }
                  }
                ) })
              ] }) }) })
            ]
          },
          W.id
        ),
        A.length > 0 && /* @__PURE__ */ f.jsx(
          c$,
          {
            actions: t,
            row: W,
            index: te,
            detailData: A,
            detailColumns: p,
            handleDeleteDetatail: g,
            rowDetail: F,
            NOMCOLXX: N,
            onRowDetailClick: c,
            colorColumn: O
          }
        )
      ] }, `fragment-${te}`);
    }) }) })
  ] }) }) });
}, f$ = B.forwardRef((e, t) => {
  const {
    actions: r = [],
    columns: n = [],
    data: a = [],
    canEdit: i = !1,
    activeRowValidation: o,
    className: s,
    onEditClick: c,
    onActionClick: u,
    onRowClick: d,
    onColumnClick: h,
    onChangeShowColumn: A,
    handleDisplayDetail: p,
    detailData: m = [],
    detailColumns: g = [],
    showDetail: v = !1,
    handleDeleteDetatail: C,
    isCheckedRow: y = !1,
    handleCheckedRow: w,
    handleCheckedAllRows: O,
    selectedRows: b,
    colorColumn: D,
    intermediateContent: M,
    ischeckedAll: j = !1,
    handleOrderChange: P
  } = e;
  return n.length < 1 ? null : /* @__PURE__ */ f.jsxs("div", { ref: t, className: Ye(["block", s]), children: [
    /* @__PURE__ */ f.jsx(
      o$,
      {
        actions: r,
        columns: n,
        data: a,
        canEdit: i,
        onEditClick: c,
        onActionClick: u,
        onRowClick: d,
        handleDisplayDetail: p,
        detailData: m,
        detailColumns: g,
        showDetail: v,
        handleDeleteDetatail: C
      }
    ),
    /* @__PURE__ */ f.jsx(
      u$,
      {
        actions: r,
        columns: n,
        data: a,
        activeRowValidation: o,
        canEdit: i,
        onEditClick: c,
        onActionClick: u,
        onRowClick: d,
        onColumnClick: h,
        onChangeShowColumn: A,
        handleDisplayDetail: p,
        detailData: m,
        detailColumns: g,
        showDetail: v,
        handleDeleteDetatail: C,
        isCheckedRow: y,
        handleCheckedRow: w,
        handleCheckedAllRows: O,
        selectedRows: b,
        colorColumn: D,
        intermediateContent: M,
        ischeckedAll: j,
        handleOrderChange: P
      }
    )
  ] });
});
f$.displayName = "TableMain";
function z3() {
  window.scrollTo({
    top: 0,
    behavior: "smooth"
  });
}
const d$ = B.forwardRef((e, t) => {
  const {
    items: r = [],
    prevActive: n = !1,
    nextActive: a = !1,
    className: i,
    onItemClick: o,
    onPrevClick: s = () => {
    },
    onNextClick: c = () => {
    },
    trackingMeta: u
  } = e;
  return /* @__PURE__ */ f.jsxs("div", { ref: t, className: Ye(["flex flex-wrap justify-center gap-4", i]), children: [
    /* @__PURE__ */ f.jsx(
      "button",
      {
        type: "button",
        className: "bg-secondary-600 rounded-md w-8 h-8 flex items-center justify-center text-white disabled:bg-neutral-300 disabled:pointer-events-none",
        disabled: !n,
        onClick: () => {
          n && (s(), z3());
        },
        children: /* @__PURE__ */ f.jsx("span", { className: "w-[20px] min-w-[20px]", children: /* @__PURE__ */ f.jsx(Me, { variant: "back-arrow", width: 18 }) })
      }
    ),
    r.map((d) => {
      const h = (d == null ? void 0 : d.isActive) ?? !0, A = (d == null ? void 0 : d.isDisabled) ?? !1;
      return /* @__PURE__ */ f.jsx(
        "button",
        {
          type: "button",
          className: `w-8 h-8 flex justify-center items-center rounded-md font-bold ${h ? "bg-secondary-600 text-white pointer-events-none" : "bg-secondary-100 text-secondary-600 hover:bg-secondary-600 hover:text-white"} disabled:pointer-events-none`,
          disabled: A,
          onClick: () => {
            A || h || o !== void 0 && (o({ item: d }), z3());
          },
          children: d.label
        },
        d.label
      );
    }),
    /* @__PURE__ */ f.jsx(
      "button",
      {
        type: "button",
        className: "bg-secondary-600 rounded-md w-8 h-8 flex items-center justify-center text-white disabled:bg-neutral-300 disabled:pointer-events-none",
        disabled: !a,
        onClick: () => {
          a && (c(), z3());
        },
        children: /* @__PURE__ */ f.jsx("span", { className: "w-[20px] min-w-[20px] -rotate-180", children: /* @__PURE__ */ f.jsx(Me, { variant: "back-arrow", width: 18 }) })
      }
    ),
    /* @__PURE__ */ f.jsxs("p", { className: "text-ellipsis text-secondary-600 font-bold", children: [
      "Mostrando ",
      u.from,
      " al ",
      u.to,
      " de un total de ",
      u.total
    ] })
  ] });
});
d$.displayName = "TablePagination";
const h$ = B.forwardRef((e, t) => {
  const {
    pages: r = [],
    onChangePage: n,
    className: a,
    trackingMeta: i
  } = e, [o, s] = De(!1), c = r;
  return /* @__PURE__ */ f.jsxs("div", { ref: t, className: Ye(["flex items-center justify-center gap-4", a]), children: [
    /* @__PURE__ */ f.jsx(kr, { variant: "title-2", children: "Items por página" }),
    /* @__PURE__ */ f.jsxs("div", { className: "flex-grow max-w-[100px] m:min-w-[100px] relative", children: [
      /* @__PURE__ */ f.jsxs(
        "button",
        {
          type: "button",
          className: `h-8 bg-neutral-200 border ${o ? "border-secondary-600" : "border-neutral-300 hover:border-secondary-400"} rounded-md w-full flex items-center justify-between gap-2 px-4`,
          onClick: () => {
            s((u) => !u);
          },
          children: [
            /* @__PURE__ */ f.jsx("span", { className: "block flex-grow text-left", children: i.per_page }),
            c.length > 0 && /* @__PURE__ */ f.jsx("span", { className: `w-[15px] min-w-[15px] ${o ? "-rotate-180" : ""}`, children: /* @__PURE__ */ f.jsx(Me, { variant: "arrow-down", width: 15 }) })
          ]
        }
      ),
      c.length > 0 && o && /* @__PURE__ */ f.jsx("ul", { className: "absolute left-0 w-full bg-neutral-200 border border-neutral-300 rounded-md bottom-[calc(100%+8px)] shadow-m z-[1000] p-2 overflow-hidden", children: c.map((u) => /* @__PURE__ */ f.jsx(
        "li",
        {
          className: `px-4 py-3 rounded-md cursor-pointer leading-[120%] ${u === i.per_page ? "text-white bg-secondary-600" : "hover:bg-secondary-200"}`,
          onClick: () => {
            s(!1), u !== i.per_page && (n !== void 0 && n(u), z3());
          },
          children: u
        },
        u
      )) })
    ] })
  ] });
});
h$.displayName = "TableShowPages";
const A$ = "h-64 animation-toast-in flex items-center justify-center grid gap-2 text-black font-bold py-4 px-5 rounded-[16px] ", p$ = {
  error: "bg-Negros-100",
  success: "bg-Negros-100",
  info: "bg-Negros-100",
  warning: "bg-Negros-100"
}, v$ = {
  error: `
  <svg width="70" height="70"  fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M34.5 54C29.3283 54 24.3684 51.9455 20.7114 48.2886C17.0545 44.6316 15 39.6717 15 34.5C15 29.3283 17.0545 24.3684 20.7114 20.7114C24.3684 17.0545 29.3283 15 34.5 15L34.5 34.5L34.5 54Z" fill="#E2807A"/>
    <path d="M34.5 54C39.6717 54 44.6316 51.9455 48.2886 48.2886C51.9455 44.6316 54 39.6717 54 34.5C54 29.3283 51.9455 24.3684 48.2886 20.7114C44.6316 17.0545 39.6717 15 34.5 15L34.5 34.5L34.5 54Z" fill="#B23B29"/>
    <path fillRule="evenodd" clipRule="evenodd" d="M43.627 25.5858C44.4081 26.3668 44.4081 27.6332 43.627 28.4142L29.4142 42.627C28.6332 43.4081 27.3668 43.4081 26.5858 42.627C25.8047 41.846 25.8047 40.5796 26.5858 39.7986L40.7986 25.5858C41.5796 24.8047 42.846 24.8047 43.627 25.5858Z" fill="white"/>
    <path fillRule="evenodd" clipRule="evenodd" d="M26.5858 25.5858C27.3668 24.8047 28.6332 24.8047 29.4142 25.5858L43.627 39.7986C44.4081 40.5796 44.4081 41.846 43.627 42.627C42.846 43.4081 41.5796 43.4081 40.7986 42.627L26.5858 28.4142C25.8047 27.6332 25.8047 26.3668 26.5858 25.5858Z" fill="white"/>
  </svg>

  `,
  success: `
  <svg width="70" height="70"  fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_57_322)">
    <path d="M18 36C27.9411 36 36 27.9411 36 18C36 8.05888 27.9411 0 18 0C8.05888 0 0 8.05888 0 18C0 27.9411 8.05888 36 18 36Z" fill="#00AD34"/>
    <path d="M0 18C0 27.9413 8.05868 36 18 36V0C8.05868 0 0 8.05868 0 18Z" fill="#76E592"/>
    <path d="M10.4687 16.9326C11.1089 16.9564 11.6054 17.2583 12.0439 17.7065C12.9089 18.5897 13.7893 19.4582 14.6633 20.3323C14.7705 20.4394 14.7719 20.438 14.8784 20.3323C16.0249 19.1843 17.1714 18.0357 18.3187 16.8885C19.2348 15.9724 20.1537 15.0591 21.0698 14.1429C22.0854 13.1267 23.1002 12.1104 24.113 11.0913C24.5332 10.6683 25.0361 10.426 25.6307 10.419C26.6645 10.4071 27.5288 11.0984 27.7466 12.0726C27.9273 12.8801 27.6878 13.5623 27.1058 14.1401C26.4131 14.8279 25.7267 15.5227 25.0361 16.2133C24.293 16.9564 23.5478 17.6967 22.8054 18.4398C22.1568 19.0884 21.511 19.7384 20.8625 20.3869C20.1194 21.13 19.3749 21.871 18.6318 22.6134C17.855 23.3902 17.0783 24.1683 16.303 24.9464C15.8904 25.3604 15.3911 25.5852 14.8097 25.595C14.2375 25.6048 13.7234 25.4192 13.313 25.0137C12.2988 24.0121 11.2945 23.0001 10.2859 21.9922C9.81315 21.5201 9.34109 21.0467 8.86763 20.576C7.81704 19.5317 8.14553 17.7275 9.49518 17.1217C9.80615 16.9823 10.1297 16.9214 10.4687 16.9333V16.9326Z" fill="white"/>
    <path d="M26.9426 10.9064L12.8942 24.6663C13.0342 24.805 13.1729 24.945 13.313 25.083C13.7234 25.4885 14.2375 25.6741 14.8097 25.6643C15.3911 25.6545 15.8904 25.429 16.303 25.0158C17.079 24.2376 17.855 23.4595 18.6318 22.6828C19.3749 21.9397 20.1194 21.1987 20.8625 20.4562C21.5111 19.8077 22.1568 19.157 22.8054 18.5092C23.5485 17.766 24.2937 17.0257 25.0361 16.2826C25.7267 15.592 26.4124 14.898 27.1058 14.2095C27.6871 13.6323 27.9273 12.9495 27.7466 12.1419C27.6325 11.6327 27.3418 11.2006 26.9426 10.9064Z" fill="#DDEBF0"/>
    </g>
    <defs>
    <clipPath id="clip0_57_322">
    <rect width="36" height="36" fill="white"/>
    </clipPath>
    </defs>
  </svg>
  `,
  info: `
  <svg width="70" height="70" viewBox="0 0 70 70" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_57_332)">
    <path d="M18 36C27.9411 36 36 27.9411 36 18C36 8.05888 27.9411 0 18 0C8.05888 0 0 8.05888 0 18C0 27.9411 8.05888 36 18 36Z" fill="#FF4A04"/>
    <path d="M0 18C0 27.9413 8.05868 36 18 36V0C8.05868 0 0 8.05868 0 18Z" fill="#FF7719"/>
    <path d="M21.2918 10.5409C21.2918 8.74218 19.8337 7.28406 18.035 7.28406C16.2363 7.28406 14.7782 8.74218 14.7782 10.5409V18.7354C14.7782 20.5341 16.2363 21.9922 18.035 21.9922C19.8337 21.9922 21.2918 20.5341 21.2918 18.7354V10.5409Z" fill="#DDEBF0"/>
    <path d="M18.07 28.716C19.772 28.716 21.1518 27.3362 21.1518 25.6343C21.1518 23.9323 19.772 22.5526 18.07 22.5526C16.3681 22.5526 14.9883 23.9323 14.9883 25.6343C14.9883 27.3362 16.3681 28.716 18.07 28.716Z" fill="#DDEBF0"/>
    <path d="M18.035 7.28406C16.2364 7.28406 14.7782 8.74227 14.7782 10.5409V18.7354C14.7782 20.534 16.2364 21.9922 18.035 21.9922C18.0469 21.9922 18.0581 21.9915 18.07 21.9915V7.28476C18.0581 7.28476 18.0469 7.28406 18.035 7.28406Z" fill="white"/>
    <path d="M14.9883 25.6343C14.9883 27.3362 16.3681 28.716 18.07 28.716V22.5526C16.3681 22.5526 14.9883 23.9323 14.9883 25.6343Z" fill="white"/>
    </g>
    <defs>
    <clipPath id="clip0_57_332">
    <rect width="36" height="36" fill="white"/>
    </clipPath>
    </defs>
  </svg>
  
  `,
  warning: `
  <svg width="40" height="36" viewBox="0 0 40 36" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M19.74 0C18.2513 -1.74141e-06 16.7625 0.734374 15.9118 2.20313L0.598825 28.6406C-1.10261 31.5781 1.02418 35.25 4.42706 35.25H19.74V0Z" fill="#E2807A"/>
    <path fillRule="evenodd" clipRule="evenodd" d="M19.74 0C21.2288 4.88378e-06 22.7175 0.73438 23.5682 2.20313L38.8812 28.6406C40.5826 31.5781 38.4558 35.25 35.0529 35.25H19.74V0Z" fill="#B23B29"/>
    <path d="M23.5 11.8597C23.5 9.9821 22.027 8.46002 20.21 8.46002C18.393 8.46002 16.92 9.9821 16.92 11.8597V20.4137C16.92 22.2913 18.393 23.8134 20.21 23.8134C22.027 23.8134 23.5 22.2913 23.5 20.4137V11.8597Z" fill="#DDEBF0"/>
    <path d="M20.21 31.4899C22.027 31.4899 23.5 30.0169 23.5 28.1999C23.5 26.3828 22.027 24.9099 20.21 24.9099C18.393 24.9099 16.92 26.3828 16.92 28.1999C16.92 30.0169 18.393 31.4899 20.21 31.4899Z" fill="#DDEBF0"/>
    <path d="M20.175 8.46002C18.3774 8.46002 16.92 9.9822 16.92 11.8597V20.4137C16.92 22.2912 18.3774 23.8134 20.175 23.8134C20.1869 23.8134 20.1981 23.8126 20.21 23.8126V8.46075C20.1981 8.46075 20.1869 8.46002 20.175 8.46002Z" fill="white"/>
  </svg>
  
  `
}, g$ = `
  <svg width="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12.9998 0.999818C12.8123 0.812347 12.558 0.707031 12.2928 0.707031C12.0277 0.707031 11.7733 0.812347 11.5858 0.999818L6.99982 5.58582L2.41382 0.999818C2.22629 0.812347 1.97198 0.707031 1.70682 0.707031C1.44165 0.707031 1.18735 0.812347 0.999818 0.999818C0.812347 1.18735 0.707031 1.44165 0.707031 1.70682C0.707031 1.97198 0.812347 2.22629 0.999818 2.41382L5.58582 6.99982L0.999818 11.5858C0.812347 11.7733 0.707031 12.0277 0.707031 12.2928C0.707031 12.558 0.812347 12.8123 0.999818 12.9998C1.18735 13.1873 1.44165 13.2926 1.70682 13.2926C1.97198 13.2926 2.22629 13.1873 2.41382 12.9998L6.99982 8.41382L11.5858 12.9998C11.7733 13.1873 12.0277 13.2926 12.2928 13.2926C12.558 13.2926 12.8123 13.1873 12.9998 12.9998C13.1873 12.8123 13.2926 12.558 13.2926 12.2928C13.2926 12.0277 13.1873 11.7733 12.9998 11.5858L8.41382 6.99982L12.9998 2.41382C13.1873 2.22629 13.2926 1.97198 13.2926 1.70682C13.2926 1.44165 13.1873 1.18735 12.9998 0.999818Z" fill="red"/>
  </svg>
`, m$ = B.forwardRef((e, t) => {
  const {
    className: r
  } = e, [n, a] = De(!1), i = ge(null);
  return Ie(() => {
    const o = (s) => {
      var y;
      let c;
      const d = s.detail, h = d.duration ?? 6e3, A = (d == null ? void 0 : d.autoHide) ?? !0, p = document.createElement("div"), m = `${A$} ${p$[d.variant]}`.trim();
      p.setAttribute("class", m), A && (c = setTimeout(() => {
        p.classList.add("animation-toast-out"), d.onClose !== void 0 && d.onClose(), setTimeout(() => {
          p.style.display = "none";
        }, 250);
      }, h));
      const g = document.createElement("div");
      g.setAttribute("class", "w-8 min-w-[90px] absolute top-0 pt-12 left-1/2 transform -translate-x-1/2"), g.innerHTML = `${v$[d.variant]}`;
      const v = document.createElement("button");
      v.setAttribute("class", "w-10 min-w-[40px] h-10 rounded-md flex items-center justify-center bg-[rgba(255,255,255,0.18)] absolute top-0 right-0 my-6 mr-4"), v.innerHTML = g$, v.onclick = () => {
        p.classList.add("animation-toast-out"), d.onClose !== void 0 && d.onClose(), clearTimeout(c), setTimeout(() => {
          p.style.display = "none", a(!1);
        }, 250);
      };
      const C = document.createElement("p");
      C.setAttribute("class", "cursor-default flex-grow text-center pt-6"), C.innerText = d.text, p.append(g), p.append(v), p.append(C), (y = i.current) == null || y.append(p), A && (console.log("Ingreso ??"), a(!0), c = setTimeout(() => {
        p.classList.add("animation-toast-out"), d.onClose !== void 0 && d.onClose(), setTimeout(() => {
          p.style.display = "none", a(!1);
        }, 250);
      }, h));
    };
    return document.addEventListener("codekit:shootToast", o, !0), () => {
      document.removeEventListener("codekit:shootToast", o, !0);
    };
  }, []), /* @__PURE__ */ f.jsxs("div", { children: [
    n && /* @__PURE__ */ f.jsx(
      "div",
      {
        className: "fixed top-0 left-0 w-full h-full bg-Marca-800 opacity-80"
      }
    ),
    /* @__PURE__ */ f.jsx("div", { ref: t, className: Ye(["fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-full pointer-events-none z-[2000] px-4", r]), children: /* @__PURE__ */ f.jsx("div", { ref: i, className: "grid gap-2 w-full max-w-[610px] mx-auto" }) })
  ] });
});
m$.displayName = "Toast";
const ewe = (e) => {
  const t = new CustomEvent("codekit:shootToast", {
    detail: e
  });
  document.dispatchEvent(t);
}, C$ = B.forwardRef((e, t) => {
  const {
    children: r,
    variant: n,
    color: a,
    alignment: i,
    asSpan: o = !1,
    ...s
  } = e, u = `${{
    "body-1": "text-[20px]",
    "body-2": "text-[16px]",
    "body-3": "text-[14px]",
    "body-4": "text-[12px]"
  }[n]} not-italic font-normal leading-[160%]`, d = {
    textAlign: i,
    color: a !== void 0 ? gt[a] : void 0
  };
  return o ? /* @__PURE__ */ f.jsx("span", { ref: t, className: u, style: d, ...s, children: r }) : /* @__PURE__ */ f.jsx("p", { ref: t, className: u, style: d, ...s, children: r });
});
C$.displayName = "Body";
const Lb = B.forwardRef((e, t) => {
  const {
    children: r,
    variant: n,
    color: a,
    alignment: i,
    asSpan: o = !1,
    ...s
  } = e, u = `${{
    "description-1": "text-[20px]",
    "description-2": "text-[16px]",
    "description-3": "text-[14px]",
    "description-4": "text-[12px]"
  }[n]} not-italic font-normal leading-[120%]`, d = {
    textAlign: i,
    color: a !== void 0 ? gt[a] : void 0
  };
  return o ? /* @__PURE__ */ f.jsx("span", { ref: t, className: u, style: d, ...s, children: r }) : /* @__PURE__ */ f.jsx("p", { ref: t, className: u, style: d, ...s, children: r });
});
Lb.displayName = "Description";
const a1 = Lb, Tb = B.forwardRef((e, t) => {
  const {
    children: r,
    variant: n,
    color: a,
    alignment: i,
    asSpan: o = !1,
    ...s
  } = e, c = "not-italic font-bold leading-[120%]", u = {
    textAlign: i,
    color: a !== void 0 ? gt[a] : void 0
  };
  if (n === "heading-1") {
    const d = `${c} text-[48px]`;
    return o ? /* @__PURE__ */ f.jsx("span", { ref: t, className: d, style: u, ...s, children: r }) : /* @__PURE__ */ f.jsx("h1", { ref: t, className: d, style: u, ...s, children: r });
  }
  if (n === "heading-2") {
    const d = `${c} text-[40px]`;
    return o ? /* @__PURE__ */ f.jsx("span", { ref: t, className: d, style: u, ...s, children: r }) : /* @__PURE__ */ f.jsx("h2", { ref: t, className: d, style: u, ...s, children: r });
  }
  if (n === "heading-3") {
    const d = `${c} text-[34px]`;
    return o ? /* @__PURE__ */ f.jsx("span", { ref: t, className: d, style: u, ...s, children: r }) : /* @__PURE__ */ f.jsx("h3", { ref: t, className: d, style: u, ...s, children: r });
  }
  if (n === "heading-4") {
    const d = `${c} text-[28px]`;
    return o ? /* @__PURE__ */ f.jsx("span", { ref: t, className: d, style: u, ...s, children: r }) : /* @__PURE__ */ f.jsx("h4", { ref: t, className: d, style: u, ...s, children: r });
  }
  if (n === "heading-5") {
    const d = `${c} text-[24px]`;
    return o ? /* @__PURE__ */ f.jsx("span", { ref: t, className: d, style: u, ...s, children: r }) : /* @__PURE__ */ f.jsx("h5", { ref: t, className: d, style: u, ...s, children: r });
  }
  if (n === "heading-6") {
    const d = `${c} text-[20px]`;
    return o ? /* @__PURE__ */ f.jsx("span", { ref: t, className: d, style: u, ...s, children: r }) : /* @__PURE__ */ f.jsx("h6", { ref: t, className: d, style: u, ...s, children: r });
  }
  return null;
});
Tb.displayName = "Heading";
const Vi = Tb, b$ = B.forwardRef((e, t) => {
  const {
    children: r,
    variant: n,
    color: a,
    alignment: i,
    asSpan: o = !1,
    ...s
  } = e, u = `${{
    "overheading-1": "font-normal text-[14px] tracking-[0.44em]",
    "hyperlink-1": "font-bold text-[16px] underline"
  }[n]} not-italic leading-[100%]`, d = {
    textAlign: i,
    color: a !== void 0 ? gt[a] : void 0
  };
  return o ? /* @__PURE__ */ f.jsx("span", { ref: t, className: u, style: d, ...s, children: r }) : /* @__PURE__ */ f.jsx("p", { ref: t, className: u, style: d, ...s, children: r });
});
b$.displayName = "TextOther";
const Rb = B.forwardRef((e, t) => {
  const {
    children: r,
    variant: n,
    color: a,
    alignment: i,
    asSpan: o = !1,
    ...s
  } = e, u = `${{
    "title-1": "text-[20px]",
    "title-2": "text-[16px]",
    "title-3": "text-[14px]",
    "title-4": "text-[12px]"
  }[n]} not-italic font-bold leading-[120%]`, d = {
    textAlign: i,
    color: a !== void 0 ? gt[a] : void 0
  };
  return o ? /* @__PURE__ */ f.jsx("span", { ref: t, className: u, style: d, ...s, children: r }) : /* @__PURE__ */ f.jsx("p", { ref: t, className: u, style: d, ...s, children: r });
});
Rb.displayName = "Title";
const kr = Rb, y$ = B.forwardRef((e) => {
  const { imageUrl: t } = e;
  return /* @__PURE__ */ f.jsx("div", { className: "max-w-md mx-auto bg-black rounded overflow-hidden shadow-lg border border-indigo-600 rounded-lg drop-shadow-md overflow-hidden shadow-lg transition-transform duration-300 ease-in-out transform hover:-translate-y-2", children: /* @__PURE__ */ f.jsx("img", { className: "w-full h-full object-cover", src: t }) });
});
y$.displayName = "Cards";
function $b(e) {
  var t, r, n = "";
  if (typeof e == "string" || typeof e == "number")
    n += e;
  else if (typeof e == "object")
    if (Array.isArray(e)) {
      var a = e.length;
      for (t = 0; t < a; t++)
        e[t] && (r = $b(e[t])) && (n && (n += " "), n += r);
    } else
      for (r in e)
        e[r] && (n && (n += " "), n += r);
  return n;
}
function Pe() {
  for (var e, t, r = 0, n = "", a = arguments.length; r < a; r++)
    (e = arguments[r]) && (t = $b(e)) && (n && (n += " "), n += t);
  return n;
}
var w$ = Array.isArray, or = w$, x$ = typeof $i == "object" && $i && $i.Object === Object && $i, Fb = x$, O$ = Fb, D$ = typeof self == "object" && self && self.Object === Object && self, M$ = O$ || D$ || Function("return this")(), fn = M$, E$ = fn, P$ = E$.Symbol, Zo = P$, uh = Zo, Hb = Object.prototype, j$ = Hb.hasOwnProperty, S$ = Hb.toString, pi = uh ? uh.toStringTag : void 0;
function I$(e) {
  var t = j$.call(e, pi), r = e[pi];
  try {
    e[pi] = void 0;
    var n = !0;
  } catch {
  }
  var a = S$.call(e);
  return n && (t ? e[pi] = r : delete e[pi]), a;
}
var B$ = I$, N$ = Object.prototype, _$ = N$.toString;
function L$(e) {
  return _$.call(e);
}
var T$ = L$, fh = Zo, R$ = B$, $$ = T$, F$ = "[object Null]", H$ = "[object Undefined]", dh = fh ? fh.toStringTag : void 0;
function Y$(e) {
  return e == null ? e === void 0 ? H$ : F$ : dh && dh in Object(e) ? R$(e) : $$(e);
}
var Bn = Y$;
function V$(e) {
  return e != null && typeof e == "object";
}
var Nn = V$, k$ = Bn, G$ = Nn, W$ = "[object Symbol]";
function Q$(e) {
  return typeof e == "symbol" || G$(e) && k$(e) == W$;
}
var j2 = Q$, U$ = or, Z$ = j2, z$ = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, K$ = /^\w*$/;
function q$(e, t) {
  if (U$(e))
    return !1;
  var r = typeof e;
  return r == "number" || r == "symbol" || r == "boolean" || e == null || Z$(e) ? !0 : K$.test(e) || !z$.test(e) || t != null && e in Object(t);
}
var o9 = q$;
function X$(e) {
  var t = typeof e;
  return e != null && (t == "object" || t == "function");
}
var v1 = X$;
const S2 = /* @__PURE__ */ qe(v1);
var J$ = Bn, eF = v1, tF = "[object AsyncFunction]", rF = "[object Function]", nF = "[object GeneratorFunction]", aF = "[object Proxy]";
function iF(e) {
  if (!eF(e))
    return !1;
  var t = J$(e);
  return t == rF || t == nF || t == tF || t == aF;
}
var s9 = iF;
const ye = /* @__PURE__ */ qe(s9);
var oF = fn, sF = oF["__core-js_shared__"], lF = sF, H6 = lF, hh = function() {
  var e = /[^.]+$/.exec(H6 && H6.keys && H6.keys.IE_PROTO || "");
  return e ? "Symbol(src)_1." + e : "";
}();
function cF(e) {
  return !!hh && hh in e;
}
var uF = cF, fF = Function.prototype, dF = fF.toString;
function hF(e) {
  if (e != null) {
    try {
      return dF.call(e);
    } catch {
    }
    try {
      return e + "";
    } catch {
    }
  }
  return "";
}
var Yb = hF, AF = s9, pF = uF, vF = v1, gF = Yb, mF = /[\\^$.*+?()[\]{}|]/g, CF = /^\[object .+?Constructor\]$/, bF = Function.prototype, yF = Object.prototype, wF = bF.toString, xF = yF.hasOwnProperty, OF = RegExp(
  "^" + wF.call(xF).replace(mF, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function DF(e) {
  if (!vF(e) || pF(e))
    return !1;
  var t = AF(e) ? OF : CF;
  return t.test(gF(e));
}
var MF = DF;
function EF(e, t) {
  return e == null ? void 0 : e[t];
}
var PF = EF, jF = MF, SF = PF;
function IF(e, t) {
  var r = SF(e, t);
  return jF(r) ? r : void 0;
}
var ia = IF, BF = ia, NF = BF(Object, "create"), w0 = NF, Ah = w0;
function _F() {
  this.__data__ = Ah ? Ah(null) : {}, this.size = 0;
}
var LF = _F;
function TF(e) {
  var t = this.has(e) && delete this.__data__[e];
  return this.size -= t ? 1 : 0, t;
}
var RF = TF, $F = w0, FF = "__lodash_hash_undefined__", HF = Object.prototype, YF = HF.hasOwnProperty;
function VF(e) {
  var t = this.__data__;
  if ($F) {
    var r = t[e];
    return r === FF ? void 0 : r;
  }
  return YF.call(t, e) ? t[e] : void 0;
}
var kF = VF, GF = w0, WF = Object.prototype, QF = WF.hasOwnProperty;
function UF(e) {
  var t = this.__data__;
  return GF ? t[e] !== void 0 : QF.call(t, e);
}
var ZF = UF, zF = w0, KF = "__lodash_hash_undefined__";
function qF(e, t) {
  var r = this.__data__;
  return this.size += this.has(e) ? 0 : 1, r[e] = zF && t === void 0 ? KF : t, this;
}
var XF = qF, JF = LF, eH = RF, tH = kF, rH = ZF, nH = XF;
function I2(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}
I2.prototype.clear = JF;
I2.prototype.delete = eH;
I2.prototype.get = tH;
I2.prototype.has = rH;
I2.prototype.set = nH;
var aH = I2;
function iH() {
  this.__data__ = [], this.size = 0;
}
var oH = iH;
function sH(e, t) {
  return e === t || e !== e && t !== t;
}
var l9 = sH, lH = l9;
function cH(e, t) {
  for (var r = e.length; r--; )
    if (lH(e[r][0], t))
      return r;
  return -1;
}
var x0 = cH, uH = x0, fH = Array.prototype, dH = fH.splice;
function hH(e) {
  var t = this.__data__, r = uH(t, e);
  if (r < 0)
    return !1;
  var n = t.length - 1;
  return r == n ? t.pop() : dH.call(t, r, 1), --this.size, !0;
}
var AH = hH, pH = x0;
function vH(e) {
  var t = this.__data__, r = pH(t, e);
  return r < 0 ? void 0 : t[r][1];
}
var gH = vH, mH = x0;
function CH(e) {
  return mH(this.__data__, e) > -1;
}
var bH = CH, yH = x0;
function wH(e, t) {
  var r = this.__data__, n = yH(r, e);
  return n < 0 ? (++this.size, r.push([e, t])) : r[n][1] = t, this;
}
var xH = wH, OH = oH, DH = AH, MH = gH, EH = bH, PH = xH;
function B2(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}
B2.prototype.clear = OH;
B2.prototype.delete = DH;
B2.prototype.get = MH;
B2.prototype.has = EH;
B2.prototype.set = PH;
var O0 = B2, jH = ia, SH = fn, IH = jH(SH, "Map"), c9 = IH, ph = aH, BH = O0, NH = c9;
function _H() {
  this.size = 0, this.__data__ = {
    hash: new ph(),
    map: new (NH || BH)(),
    string: new ph()
  };
}
var LH = _H;
function TH(e) {
  var t = typeof e;
  return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
}
var RH = TH, $H = RH;
function FH(e, t) {
  var r = e.__data__;
  return $H(t) ? r[typeof t == "string" ? "string" : "hash"] : r.map;
}
var D0 = FH, HH = D0;
function YH(e) {
  var t = HH(this, e).delete(e);
  return this.size -= t ? 1 : 0, t;
}
var VH = YH, kH = D0;
function GH(e) {
  return kH(this, e).get(e);
}
var WH = GH, QH = D0;
function UH(e) {
  return QH(this, e).has(e);
}
var ZH = UH, zH = D0;
function KH(e, t) {
  var r = zH(this, e), n = r.size;
  return r.set(e, t), this.size += r.size == n ? 0 : 1, this;
}
var qH = KH, XH = LH, JH = VH, eY = WH, tY = ZH, rY = qH;
function N2(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}
N2.prototype.clear = XH;
N2.prototype.delete = JH;
N2.prototype.get = eY;
N2.prototype.has = tY;
N2.prototype.set = rY;
var u9 = N2, Vb = u9, nY = "Expected a function";
function f9(e, t) {
  if (typeof e != "function" || t != null && typeof t != "function")
    throw new TypeError(nY);
  var r = function() {
    var n = arguments, a = t ? t.apply(this, n) : n[0], i = r.cache;
    if (i.has(a))
      return i.get(a);
    var o = e.apply(this, n);
    return r.cache = i.set(a, o) || i, o;
  };
  return r.cache = new (f9.Cache || Vb)(), r;
}
f9.Cache = Vb;
var kb = f9;
const aY = /* @__PURE__ */ qe(kb);
var iY = kb, oY = 500;
function sY(e) {
  var t = iY(e, function(n) {
    return r.size === oY && r.clear(), n;
  }), r = t.cache;
  return t;
}
var lY = sY, cY = lY, uY = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, fY = /\\(\\)?/g, dY = cY(function(e) {
  var t = [];
  return e.charCodeAt(0) === 46 && t.push(""), e.replace(uY, function(r, n, a, i) {
    t.push(a ? i.replace(fY, "$1") : n || r);
  }), t;
}), hY = dY;
function AY(e, t) {
  for (var r = -1, n = e == null ? 0 : e.length, a = Array(n); ++r < n; )
    a[r] = t(e[r], r, e);
  return a;
}
var d9 = AY, vh = Zo, pY = d9, vY = or, gY = j2, mY = 1 / 0, gh = vh ? vh.prototype : void 0, mh = gh ? gh.toString : void 0;
function Gb(e) {
  if (typeof e == "string")
    return e;
  if (vY(e))
    return pY(e, Gb) + "";
  if (gY(e))
    return mh ? mh.call(e) : "";
  var t = e + "";
  return t == "0" && 1 / e == -mY ? "-0" : t;
}
var CY = Gb, bY = CY;
function yY(e) {
  return e == null ? "" : bY(e);
}
var Wb = yY, wY = or, xY = o9, OY = hY, DY = Wb;
function MY(e, t) {
  return wY(e) ? e : xY(e, t) ? [e] : OY(DY(e));
}
var Qb = MY, EY = j2, PY = 1 / 0;
function jY(e) {
  if (typeof e == "string" || EY(e))
    return e;
  var t = e + "";
  return t == "0" && 1 / e == -PY ? "-0" : t;
}
var M0 = jY, SY = Qb, IY = M0;
function BY(e, t) {
  t = SY(t, e);
  for (var r = 0, n = t.length; e != null && r < n; )
    e = e[IY(t[r++])];
  return r && r == n ? e : void 0;
}
var h9 = BY, NY = h9;
function _Y(e, t, r) {
  var n = e == null ? void 0 : NY(e, t);
  return n === void 0 ? r : n;
}
var Ub = _Y;
const mr = /* @__PURE__ */ qe(Ub);
function LY(e) {
  return e == null;
}
var TY = LY;
const be = /* @__PURE__ */ qe(TY);
var RY = Bn, $Y = or, FY = Nn, HY = "[object String]";
function YY(e) {
  return typeof e == "string" || !$Y(e) && FY(e) && RY(e) == HY;
}
var VY = YY;
const ea = /* @__PURE__ */ qe(VY);
var Q4 = { exports: {} }, ze = {};
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ch;
function kY() {
  if (Ch)
    return ze;
  Ch = 1;
  var e = Symbol.for("react.element"), t = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), n = Symbol.for("react.strict_mode"), a = Symbol.for("react.profiler"), i = Symbol.for("react.provider"), o = Symbol.for("react.context"), s = Symbol.for("react.server_context"), c = Symbol.for("react.forward_ref"), u = Symbol.for("react.suspense"), d = Symbol.for("react.suspense_list"), h = Symbol.for("react.memo"), A = Symbol.for("react.lazy"), p = Symbol.for("react.offscreen"), m;
  m = Symbol.for("react.module.reference");
  function g(v) {
    if (typeof v == "object" && v !== null) {
      var C = v.$$typeof;
      switch (C) {
        case e:
          switch (v = v.type, v) {
            case r:
            case a:
            case n:
            case u:
            case d:
              return v;
            default:
              switch (v = v && v.$$typeof, v) {
                case s:
                case o:
                case c:
                case A:
                case h:
                case i:
                  return v;
                default:
                  return C;
              }
          }
        case t:
          return C;
      }
    }
  }
  return ze.ContextConsumer = o, ze.ContextProvider = i, ze.Element = e, ze.ForwardRef = c, ze.Fragment = r, ze.Lazy = A, ze.Memo = h, ze.Portal = t, ze.Profiler = a, ze.StrictMode = n, ze.Suspense = u, ze.SuspenseList = d, ze.isAsyncMode = function() {
    return !1;
  }, ze.isConcurrentMode = function() {
    return !1;
  }, ze.isContextConsumer = function(v) {
    return g(v) === o;
  }, ze.isContextProvider = function(v) {
    return g(v) === i;
  }, ze.isElement = function(v) {
    return typeof v == "object" && v !== null && v.$$typeof === e;
  }, ze.isForwardRef = function(v) {
    return g(v) === c;
  }, ze.isFragment = function(v) {
    return g(v) === r;
  }, ze.isLazy = function(v) {
    return g(v) === A;
  }, ze.isMemo = function(v) {
    return g(v) === h;
  }, ze.isPortal = function(v) {
    return g(v) === t;
  }, ze.isProfiler = function(v) {
    return g(v) === a;
  }, ze.isStrictMode = function(v) {
    return g(v) === n;
  }, ze.isSuspense = function(v) {
    return g(v) === u;
  }, ze.isSuspenseList = function(v) {
    return g(v) === d;
  }, ze.isValidElementType = function(v) {
    return typeof v == "string" || typeof v == "function" || v === r || v === a || v === n || v === u || v === d || v === p || typeof v == "object" && v !== null && (v.$$typeof === A || v.$$typeof === h || v.$$typeof === i || v.$$typeof === o || v.$$typeof === c || v.$$typeof === m || v.getModuleId !== void 0);
  }, ze.typeOf = g, ze;
}
var Ke = {};
/**
 * @license React
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var bh;
function GY() {
  return bh || (bh = 1, process.env.NODE_ENV !== "production" && function() {
    var e = Symbol.for("react.element"), t = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), n = Symbol.for("react.strict_mode"), a = Symbol.for("react.profiler"), i = Symbol.for("react.provider"), o = Symbol.for("react.context"), s = Symbol.for("react.server_context"), c = Symbol.for("react.forward_ref"), u = Symbol.for("react.suspense"), d = Symbol.for("react.suspense_list"), h = Symbol.for("react.memo"), A = Symbol.for("react.lazy"), p = Symbol.for("react.offscreen"), m = !1, g = !1, v = !1, C = !1, y = !1, w;
    w = Symbol.for("react.module.reference");
    function O(V) {
      return !!(typeof V == "string" || typeof V == "function" || V === r || V === a || y || V === n || V === u || V === d || C || V === p || m || g || v || typeof V == "object" && V !== null && (V.$$typeof === A || V.$$typeof === h || V.$$typeof === i || V.$$typeof === o || V.$$typeof === c || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      V.$$typeof === w || V.getModuleId !== void 0));
    }
    function b(V) {
      if (typeof V == "object" && V !== null) {
        var ne = V.$$typeof;
        switch (ne) {
          case e:
            var ie = V.type;
            switch (ie) {
              case r:
              case a:
              case n:
              case u:
              case d:
                return ie;
              default:
                var le = ie && ie.$$typeof;
                switch (le) {
                  case s:
                  case o:
                  case c:
                  case A:
                  case h:
                  case i:
                    return le;
                  default:
                    return ne;
                }
            }
          case t:
            return ne;
        }
      }
    }
    var D = o, M = i, j = e, P = c, H = r, F = A, R = h, N = t, z = a, q = n, J = u, W = d, te = !1, S = !1;
    function I(V) {
      return te || (te = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function T(V) {
      return S || (S = !0, console.warn("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function E(V) {
      return b(V) === o;
    }
    function x(V) {
      return b(V) === i;
    }
    function $(V) {
      return typeof V == "object" && V !== null && V.$$typeof === e;
    }
    function _(V) {
      return b(V) === c;
    }
    function Q(V) {
      return b(V) === r;
    }
    function Z(V) {
      return b(V) === A;
    }
    function X(V) {
      return b(V) === h;
    }
    function Y(V) {
      return b(V) === t;
    }
    function U(V) {
      return b(V) === a;
    }
    function k(V) {
      return b(V) === n;
    }
    function L(V) {
      return b(V) === u;
    }
    function ee(V) {
      return b(V) === d;
    }
    Ke.ContextConsumer = D, Ke.ContextProvider = M, Ke.Element = j, Ke.ForwardRef = P, Ke.Fragment = H, Ke.Lazy = F, Ke.Memo = R, Ke.Portal = N, Ke.Profiler = z, Ke.StrictMode = q, Ke.Suspense = J, Ke.SuspenseList = W, Ke.isAsyncMode = I, Ke.isConcurrentMode = T, Ke.isContextConsumer = E, Ke.isContextProvider = x, Ke.isElement = $, Ke.isForwardRef = _, Ke.isFragment = Q, Ke.isLazy = Z, Ke.isMemo = X, Ke.isPortal = Y, Ke.isProfiler = U, Ke.isStrictMode = k, Ke.isSuspense = L, Ke.isSuspenseList = ee, Ke.isValidElementType = O, Ke.typeOf = b;
  }()), Ke;
}
process.env.NODE_ENV === "production" ? Q4.exports = kY() : Q4.exports = GY();
var WY = Q4.exports, QY = Bn, UY = Nn, ZY = "[object Number]";
function zY(e) {
  return typeof e == "number" || UY(e) && QY(e) == ZY;
}
var Zb = zY;
const KY = /* @__PURE__ */ qe(Zb);
var qY = Zb;
function XY(e) {
  return qY(e) && e != +e;
}
var JY = XY;
const _2 = /* @__PURE__ */ qe(JY);
var Jt = function(t) {
  return t === 0 ? 0 : t > 0 ? 1 : -1;
}, W1 = function(t) {
  return ea(t) && t.indexOf("%") === t.length - 1;
}, se = function(t) {
  return KY(t) && !_2(t);
}, eV = function(t) {
  return be(t);
}, Nt = function(t) {
  return se(t) || ea(t);
}, tV = 0, g1 = function(t) {
  var r = ++tV;
  return "".concat(t || "").concat(r);
}, er = function(t, r) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, a = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !1;
  if (!se(t) && !ea(t))
    return n;
  var i;
  if (W1(t)) {
    var o = t.indexOf("%");
    i = r * parseFloat(t.slice(0, o)) / 100;
  } else
    i = +t;
  return _2(i) && (i = n), a && i > r && (i = r), i;
}, qn = function(t) {
  if (!t)
    return null;
  var r = Object.keys(t);
  return r && r.length ? t[r[0]] : null;
}, rV = function(t) {
  if (!Array.isArray(t))
    return !1;
  for (var r = t.length, n = {}, a = 0; a < r; a++)
    if (!n[t[a]])
      n[t[a]] = !0;
    else
      return !0;
  return !1;
}, bt = function(t, r) {
  return se(t) && se(r) ? function(n) {
    return t + n * (r - t);
  } : function() {
    return r;
  };
};
function is(e, t, r) {
  return !e || !e.length ? null : e.find(function(n) {
    return n && (typeof t == "function" ? t(n) : mr(n, t)) === r;
  });
}
var nV = function(t) {
  if (!t || !t.length)
    return null;
  for (var r = t.length, n = 0, a = 0, i = 0, o = 0, s = 1 / 0, c = -1 / 0, u = 0, d = 0, h = 0; h < r; h++)
    u = t[h].cx || 0, d = t[h].cy || 0, n += u, a += d, i += u * d, o += u * u, s = Math.min(s, u), c = Math.max(c, u);
  var A = r * o !== n * n ? (r * i - n * a) / (r * o - n * n) : 0;
  return {
    xmin: s,
    xmax: c,
    a: A,
    b: (a - A * n) / r
  };
}, aV = function(t, r) {
  return se(t) && se(r) ? t - r : ea(t) && ea(r) ? t.localeCompare(r) : t instanceof Date && r instanceof Date ? t.getTime() - r.getTime() : String(t).localeCompare(String(r));
};
function Va(e, t) {
  for (var r in e)
    if ({}.hasOwnProperty.call(e, r) && (!{}.hasOwnProperty.call(t, r) || e[r] !== t[r]))
      return !1;
  for (var n in t)
    if ({}.hasOwnProperty.call(t, n) && !{}.hasOwnProperty.call(e, n))
      return !1;
  return !0;
}
function U4(e) {
  "@babel/helpers - typeof";
  return U4 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, U4(e);
}
var iV = ["viewBox", "children"], oV = [
  "aria-activedescendant",
  "aria-atomic",
  "aria-autocomplete",
  "aria-busy",
  "aria-checked",
  "aria-colcount",
  "aria-colindex",
  "aria-colspan",
  "aria-controls",
  "aria-current",
  "aria-describedby",
  "aria-details",
  "aria-disabled",
  "aria-errormessage",
  "aria-expanded",
  "aria-flowto",
  "aria-haspopup",
  "aria-hidden",
  "aria-invalid",
  "aria-keyshortcuts",
  "aria-label",
  "aria-labelledby",
  "aria-level",
  "aria-live",
  "aria-modal",
  "aria-multiline",
  "aria-multiselectable",
  "aria-orientation",
  "aria-owns",
  "aria-placeholder",
  "aria-posinset",
  "aria-pressed",
  "aria-readonly",
  "aria-relevant",
  "aria-required",
  "aria-roledescription",
  "aria-rowcount",
  "aria-rowindex",
  "aria-rowspan",
  "aria-selected",
  "aria-setsize",
  "aria-sort",
  "aria-valuemax",
  "aria-valuemin",
  "aria-valuenow",
  "aria-valuetext",
  "className",
  "color",
  "height",
  "id",
  "lang",
  "max",
  "media",
  "method",
  "min",
  "name",
  "style",
  /*
   * removed 'type' SVGElementPropKey because we do not currently use any SVG elements
   * that can use it and it conflicts with the recharts prop 'type'
   * https://github.com/recharts/recharts/pull/3327
   * https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/type
   */
  // 'type',
  "target",
  "width",
  "role",
  "tabIndex",
  "accentHeight",
  "accumulate",
  "additive",
  "alignmentBaseline",
  "allowReorder",
  "alphabetic",
  "amplitude",
  "arabicForm",
  "ascent",
  "attributeName",
  "attributeType",
  "autoReverse",
  "azimuth",
  "baseFrequency",
  "baselineShift",
  "baseProfile",
  "bbox",
  "begin",
  "bias",
  "by",
  "calcMode",
  "capHeight",
  "clip",
  "clipPath",
  "clipPathUnits",
  "clipRule",
  "colorInterpolation",
  "colorInterpolationFilters",
  "colorProfile",
  "colorRendering",
  "contentScriptType",
  "contentStyleType",
  "cursor",
  "cx",
  "cy",
  "d",
  "decelerate",
  "descent",
  "diffuseConstant",
  "direction",
  "display",
  "divisor",
  "dominantBaseline",
  "dur",
  "dx",
  "dy",
  "edgeMode",
  "elevation",
  "enableBackground",
  "end",
  "exponent",
  "externalResourcesRequired",
  "fill",
  "fillOpacity",
  "fillRule",
  "filter",
  "filterRes",
  "filterUnits",
  "floodColor",
  "floodOpacity",
  "focusable",
  "fontFamily",
  "fontSize",
  "fontSizeAdjust",
  "fontStretch",
  "fontStyle",
  "fontVariant",
  "fontWeight",
  "format",
  "from",
  "fx",
  "fy",
  "g1",
  "g2",
  "glyphName",
  "glyphOrientationHorizontal",
  "glyphOrientationVertical",
  "glyphRef",
  "gradientTransform",
  "gradientUnits",
  "hanging",
  "horizAdvX",
  "horizOriginX",
  "href",
  "ideographic",
  "imageRendering",
  "in2",
  "in",
  "intercept",
  "k1",
  "k2",
  "k3",
  "k4",
  "k",
  "kernelMatrix",
  "kernelUnitLength",
  "kerning",
  "keyPoints",
  "keySplines",
  "keyTimes",
  "lengthAdjust",
  "letterSpacing",
  "lightingColor",
  "limitingConeAngle",
  "local",
  "markerEnd",
  "markerHeight",
  "markerMid",
  "markerStart",
  "markerUnits",
  "markerWidth",
  "mask",
  "maskContentUnits",
  "maskUnits",
  "mathematical",
  "mode",
  "numOctaves",
  "offset",
  "opacity",
  "operator",
  "order",
  "orient",
  "orientation",
  "origin",
  "overflow",
  "overlinePosition",
  "overlineThickness",
  "paintOrder",
  "panose1",
  "pathLength",
  "patternContentUnits",
  "patternTransform",
  "patternUnits",
  "pointerEvents",
  "pointsAtX",
  "pointsAtY",
  "pointsAtZ",
  "preserveAlpha",
  "preserveAspectRatio",
  "primitiveUnits",
  "r",
  "radius",
  "refX",
  "refY",
  "renderingIntent",
  "repeatCount",
  "repeatDur",
  "requiredExtensions",
  "requiredFeatures",
  "restart",
  "result",
  "rotate",
  "rx",
  "ry",
  "seed",
  "shapeRendering",
  "slope",
  "spacing",
  "specularConstant",
  "specularExponent",
  "speed",
  "spreadMethod",
  "startOffset",
  "stdDeviation",
  "stemh",
  "stemv",
  "stitchTiles",
  "stopColor",
  "stopOpacity",
  "strikethroughPosition",
  "strikethroughThickness",
  "string",
  "stroke",
  "strokeDasharray",
  "strokeDashoffset",
  "strokeLinecap",
  "strokeLinejoin",
  "strokeMiterlimit",
  "strokeOpacity",
  "strokeWidth",
  "surfaceScale",
  "systemLanguage",
  "tableValues",
  "targetX",
  "targetY",
  "textAnchor",
  "textDecoration",
  "textLength",
  "textRendering",
  "to",
  "transform",
  "u1",
  "u2",
  "underlinePosition",
  "underlineThickness",
  "unicode",
  "unicodeBidi",
  "unicodeRange",
  "unitsPerEm",
  "vAlphabetic",
  "values",
  "vectorEffect",
  "version",
  "vertAdvY",
  "vertOriginX",
  "vertOriginY",
  "vHanging",
  "vIdeographic",
  "viewTarget",
  "visibility",
  "vMathematical",
  "widths",
  "wordSpacing",
  "writingMode",
  "x1",
  "x2",
  "x",
  "xChannelSelector",
  "xHeight",
  "xlinkActuate",
  "xlinkArcrole",
  "xlinkHref",
  "xlinkRole",
  "xlinkShow",
  "xlinkTitle",
  "xlinkType",
  "xmlBase",
  "xmlLang",
  "xmlns",
  "xmlnsXlink",
  "xmlSpace",
  "y1",
  "y2",
  "y",
  "yChannelSelector",
  "z",
  "zoomAndPan",
  "ref",
  "key",
  "angle"
], yh = ["points", "pathLength"], Y6 = {
  svg: iV,
  polygon: yh,
  polyline: yh
}, A9 = ["dangerouslySetInnerHTML", "onCopy", "onCopyCapture", "onCut", "onCutCapture", "onPaste", "onPasteCapture", "onCompositionEnd", "onCompositionEndCapture", "onCompositionStart", "onCompositionStartCapture", "onCompositionUpdate", "onCompositionUpdateCapture", "onFocus", "onFocusCapture", "onBlur", "onBlurCapture", "onChange", "onChangeCapture", "onBeforeInput", "onBeforeInputCapture", "onInput", "onInputCapture", "onReset", "onResetCapture", "onSubmit", "onSubmitCapture", "onInvalid", "onInvalidCapture", "onLoad", "onLoadCapture", "onError", "onErrorCapture", "onKeyDown", "onKeyDownCapture", "onKeyPress", "onKeyPressCapture", "onKeyUp", "onKeyUpCapture", "onAbort", "onAbortCapture", "onCanPlay", "onCanPlayCapture", "onCanPlayThrough", "onCanPlayThroughCapture", "onDurationChange", "onDurationChangeCapture", "onEmptied", "onEmptiedCapture", "onEncrypted", "onEncryptedCapture", "onEnded", "onEndedCapture", "onLoadedData", "onLoadedDataCapture", "onLoadedMetadata", "onLoadedMetadataCapture", "onLoadStart", "onLoadStartCapture", "onPause", "onPauseCapture", "onPlay", "onPlayCapture", "onPlaying", "onPlayingCapture", "onProgress", "onProgressCapture", "onRateChange", "onRateChangeCapture", "onSeeked", "onSeekedCapture", "onSeeking", "onSeekingCapture", "onStalled", "onStalledCapture", "onSuspend", "onSuspendCapture", "onTimeUpdate", "onTimeUpdateCapture", "onVolumeChange", "onVolumeChangeCapture", "onWaiting", "onWaitingCapture", "onAuxClick", "onAuxClickCapture", "onClick", "onClickCapture", "onContextMenu", "onContextMenuCapture", "onDoubleClick", "onDoubleClickCapture", "onDrag", "onDragCapture", "onDragEnd", "onDragEndCapture", "onDragEnter", "onDragEnterCapture", "onDragExit", "onDragExitCapture", "onDragLeave", "onDragLeaveCapture", "onDragOver", "onDragOverCapture", "onDragStart", "onDragStartCapture", "onDrop", "onDropCapture", "onMouseDown", "onMouseDownCapture", "onMouseEnter", "onMouseLeave", "onMouseMove", "onMouseMoveCapture", "onMouseOut", "onMouseOutCapture", "onMouseOver", "onMouseOverCapture", "onMouseUp", "onMouseUpCapture", "onSelect", "onSelectCapture", "onTouchCancel", "onTouchCancelCapture", "onTouchEnd", "onTouchEndCapture", "onTouchMove", "onTouchMoveCapture", "onTouchStart", "onTouchStartCapture", "onPointerDown", "onPointerDownCapture", "onPointerMove", "onPointerMoveCapture", "onPointerUp", "onPointerUpCapture", "onPointerCancel", "onPointerCancelCapture", "onPointerEnter", "onPointerEnterCapture", "onPointerLeave", "onPointerLeaveCapture", "onPointerOver", "onPointerOverCapture", "onPointerOut", "onPointerOutCapture", "onGotPointerCapture", "onGotPointerCaptureCapture", "onLostPointerCapture", "onLostPointerCaptureCapture", "onScroll", "onScrollCapture", "onWheel", "onWheelCapture", "onAnimationStart", "onAnimationStartCapture", "onAnimationEnd", "onAnimationEndCapture", "onAnimationIteration", "onAnimationIterationCapture", "onTransitionEnd", "onTransitionEndCapture"], os = function(t, r) {
  if (!t || typeof t == "function" || typeof t == "boolean")
    return null;
  var n = t;
  if (/* @__PURE__ */ Vr(t) && (n = t.props), !S2(n))
    return null;
  var a = {};
  return Object.keys(n).forEach(function(i) {
    A9.includes(i) && (a[i] = r || function(o) {
      return n[i](n, o);
    });
  }), a;
}, sV = function(t, r, n) {
  return function(a) {
    return t(r, n, a), null;
  };
}, c1 = function(t, r, n) {
  if (!S2(t) || U4(t) !== "object")
    return null;
  var a = null;
  return Object.keys(t).forEach(function(i) {
    var o = t[i];
    A9.includes(i) && typeof o == "function" && (a || (a = {}), a[i] = sV(o, r, n));
  }), a;
}, lV = ["children"], cV = ["children"];
function wh(e, t) {
  if (e == null)
    return {};
  var r = uV(e, t), n, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (a = 0; a < i.length; a++)
      n = i[a], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function uV(e, t) {
  if (e == null)
    return {};
  var r = {};
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      if (t.indexOf(n) >= 0)
        continue;
      r[n] = e[n];
    }
  return r;
}
function Z4(e) {
  "@babel/helpers - typeof";
  return Z4 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Z4(e);
}
var xh = {
  click: "onClick",
  mousedown: "onMouseDown",
  mouseup: "onMouseUp",
  mouseover: "onMouseOver",
  mousemove: "onMouseMove",
  mouseout: "onMouseOut",
  mouseenter: "onMouseEnter",
  mouseleave: "onMouseLeave",
  touchcancel: "onTouchCancel",
  touchend: "onTouchEnd",
  touchmove: "onTouchMove",
  touchstart: "onTouchStart",
  contextmenu: "onContextMenu",
  dblclick: "onDoubleClick"
}, On = function(t) {
  return typeof t == "string" ? t : t ? t.displayName || t.name || "Component" : "";
}, Oh = null, V6 = null, p9 = function e(t) {
  if (t === Oh && Array.isArray(V6))
    return V6;
  var r = [];
  return K1.forEach(t, function(n) {
    be(n) || (WY.isFragment(n) ? r = r.concat(e(n.props.children)) : r.push(n));
  }), V6 = r, Oh = t, r;
};
function rr(e, t) {
  var r = [], n = [];
  return Array.isArray(t) ? n = t.map(function(a) {
    return On(a);
  }) : n = [On(t)], p9(e).forEach(function(a) {
    var i = mr(a, "type.displayName") || mr(a, "type.name");
    n.indexOf(i) !== -1 && r.push(a);
  }), r;
}
function hr(e, t) {
  var r = rr(e, t);
  return r && r[0];
}
var Dh = function(t) {
  if (!t || !t.props)
    return !1;
  var r = t.props, n = r.width, a = r.height;
  return !(!se(n) || n <= 0 || !se(a) || a <= 0);
}, fV = ["a", "altGlyph", "altGlyphDef", "altGlyphItem", "animate", "animateColor", "animateMotion", "animateTransform", "circle", "clipPath", "color-profile", "cursor", "defs", "desc", "ellipse", "feBlend", "feColormatrix", "feComponentTransfer", "feComposite", "feConvolveMatrix", "feDiffuseLighting", "feDisplacementMap", "feDistantLight", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feImage", "feMerge", "feMergeNode", "feMorphology", "feOffset", "fePointLight", "feSpecularLighting", "feSpotLight", "feTile", "feTurbulence", "filter", "font", "font-face", "font-face-format", "font-face-name", "font-face-url", "foreignObject", "g", "glyph", "glyphRef", "hkern", "image", "line", "lineGradient", "marker", "mask", "metadata", "missing-glyph", "mpath", "path", "pattern", "polygon", "polyline", "radialGradient", "rect", "script", "set", "stop", "style", "svg", "switch", "symbol", "text", "textPath", "title", "tref", "tspan", "use", "view", "vkern"], dV = function(t) {
  return t && t.type && ea(t.type) && fV.indexOf(t.type) >= 0;
}, zb = function(t) {
  return t && Z4(t) === "object" && "clipDot" in t;
}, hV = function(t, r, n, a) {
  var i, o = (i = Y6 == null ? void 0 : Y6[a]) !== null && i !== void 0 ? i : [];
  return r.startsWith("data-") || !ye(t) && (a && o.includes(r) || oV.includes(r)) || n && A9.includes(r);
}, Ae = function(t, r, n) {
  if (!t || typeof t == "function" || typeof t == "boolean")
    return null;
  var a = t;
  if (/* @__PURE__ */ Vr(t) && (a = t.props), !S2(a))
    return null;
  var i = {};
  return Object.keys(a).forEach(function(o) {
    var s;
    hV((s = a) === null || s === void 0 ? void 0 : s[o], o, r, n) && (i[o] = a[o]);
  }), i;
}, z4 = function e(t, r) {
  if (t === r)
    return !0;
  var n = K1.count(t);
  if (n !== K1.count(r))
    return !1;
  if (n === 0)
    return !0;
  if (n === 1)
    return Mh(Array.isArray(t) ? t[0] : t, Array.isArray(r) ? r[0] : r);
  for (var a = 0; a < n; a++) {
    var i = t[a], o = r[a];
    if (Array.isArray(i) || Array.isArray(o)) {
      if (!e(i, o))
        return !1;
    } else if (!Mh(i, o))
      return !1;
  }
  return !0;
}, Mh = function(t, r) {
  if (be(t) && be(r))
    return !0;
  if (!be(t) && !be(r)) {
    var n = t.props || {}, a = n.children, i = wh(n, lV), o = r.props || {}, s = o.children, c = wh(o, cV);
    return a && s ? Va(i, c) && z4(a, s) : !a && !s ? Va(i, c) : !1;
  }
  return !1;
}, Eh = function(t, r) {
  var n = [], a = {};
  return p9(t).forEach(function(i, o) {
    if (dV(i))
      n.push(i);
    else if (i) {
      var s = On(i.type), c = r[s] || {}, u = c.handler, d = c.once;
      if (u && (!d || !a[s])) {
        var h = u(i, s, o);
        n.push(h), a[s] = !0;
      }
    }
  }), n;
}, AV = function(t) {
  var r = t && t.type;
  return r && xh[r] ? xh[r] : null;
}, pV = function(t, r) {
  return p9(r).indexOf(t);
}, vV = ["children", "width", "height", "viewBox", "className", "style", "title", "desc"];
function K4() {
  return K4 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, K4.apply(this, arguments);
}
function gV(e, t) {
  if (e == null)
    return {};
  var r = mV(e, t), n, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (a = 0; a < i.length; a++)
      n = i[a], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function mV(e, t) {
  if (e == null)
    return {};
  var r = {};
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      if (t.indexOf(n) >= 0)
        continue;
      r[n] = e[n];
    }
  return r;
}
function q4(e) {
  var t = e.children, r = e.width, n = e.height, a = e.viewBox, i = e.className, o = e.style, s = e.title, c = e.desc, u = gV(e, vV), d = a || {
    width: r,
    height: n,
    x: 0,
    y: 0
  }, h = Pe("recharts-surface", i);
  return /* @__PURE__ */ B.createElement("svg", K4({}, Ae(u, !0, "svg"), {
    className: h,
    width: r,
    height: n,
    style: o,
    viewBox: "".concat(d.x, " ").concat(d.y, " ").concat(d.width, " ").concat(d.height)
  }), /* @__PURE__ */ B.createElement("title", null, s), /* @__PURE__ */ B.createElement("desc", null, c), t);
}
var CV = ["children", "className"];
function X4() {
  return X4 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, X4.apply(this, arguments);
}
function bV(e, t) {
  if (e == null)
    return {};
  var r = yV(e, t), n, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (a = 0; a < i.length; a++)
      n = i[a], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function yV(e, t) {
  if (e == null)
    return {};
  var r = {};
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      if (t.indexOf(n) >= 0)
        continue;
      r[n] = e[n];
    }
  return r;
}
var Se = /* @__PURE__ */ B.forwardRef(function(e, t) {
  var r = e.children, n = e.className, a = bV(e, CV), i = Pe("recharts-layer", n);
  return /* @__PURE__ */ B.createElement("g", X4({
    className: i
  }, Ae(a, !0), {
    ref: t
  }), r);
}), wV = process.env.NODE_ENV !== "production", Gr = function(t, r) {
  for (var n = arguments.length, a = new Array(n > 2 ? n - 2 : 0), i = 2; i < n; i++)
    a[i - 2] = arguments[i];
  if (wV && typeof console < "u" && console.warn && (r === void 0 && console.warn("LogUtils requires an error message argument"), !t))
    if (r === void 0)
      console.warn("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
    else {
      var o = 0;
      console.warn(r.replace(/%s/g, function() {
        return a[o++];
      }));
    }
};
function xV(e, t, r) {
  var n = -1, a = e.length;
  t < 0 && (t = -t > a ? 0 : a + t), r = r > a ? a : r, r < 0 && (r += a), a = t > r ? 0 : r - t >>> 0, t >>>= 0;
  for (var i = Array(a); ++n < a; )
    i[n] = e[n + t];
  return i;
}
var OV = xV, DV = OV;
function MV(e, t, r) {
  var n = e.length;
  return r = r === void 0 ? n : r, !t && r >= n ? e : DV(e, t, r);
}
var EV = MV, PV = "\\ud800-\\udfff", jV = "\\u0300-\\u036f", SV = "\\ufe20-\\ufe2f", IV = "\\u20d0-\\u20ff", BV = jV + SV + IV, NV = "\\ufe0e\\ufe0f", _V = "\\u200d", LV = RegExp("[" + _V + PV + BV + NV + "]");
function TV(e) {
  return LV.test(e);
}
var Kb = TV;
function RV(e) {
  return e.split("");
}
var $V = RV, qb = "\\ud800-\\udfff", FV = "\\u0300-\\u036f", HV = "\\ufe20-\\ufe2f", YV = "\\u20d0-\\u20ff", VV = FV + HV + YV, kV = "\\ufe0e\\ufe0f", GV = "[" + qb + "]", J4 = "[" + VV + "]", e5 = "\\ud83c[\\udffb-\\udfff]", WV = "(?:" + J4 + "|" + e5 + ")", Xb = "[^" + qb + "]", Jb = "(?:\\ud83c[\\udde6-\\uddff]){2}", ey = "[\\ud800-\\udbff][\\udc00-\\udfff]", QV = "\\u200d", ty = WV + "?", ry = "[" + kV + "]?", UV = "(?:" + QV + "(?:" + [Xb, Jb, ey].join("|") + ")" + ry + ty + ")*", ZV = ry + ty + UV, zV = "(?:" + [Xb + J4 + "?", J4, Jb, ey, GV].join("|") + ")", KV = RegExp(e5 + "(?=" + e5 + ")|" + zV + ZV, "g");
function qV(e) {
  return e.match(KV) || [];
}
var XV = qV, JV = $V, ek = Kb, tk = XV;
function rk(e) {
  return ek(e) ? tk(e) : JV(e);
}
var nk = rk, ak = EV, ik = Kb, ok = nk, sk = Wb;
function lk(e) {
  return function(t) {
    t = sk(t);
    var r = ik(t) ? ok(t) : void 0, n = r ? r[0] : t.charAt(0), a = r ? ak(r, 1).join("") : t.slice(1);
    return n[e]() + a;
  };
}
var ck = lk, uk = ck, fk = uk("toUpperCase"), dk = fk;
const E0 = /* @__PURE__ */ qe(dk);
function lt(e) {
  return function() {
    return e;
  };
}
const ny = Math.cos, ss = Math.sin, Zr = Math.sqrt, ls = Math.PI, P0 = 2 * ls, t5 = Math.PI, r5 = 2 * t5, $1 = 1e-6, hk = r5 - $1;
function ay(e) {
  this._ += e[0];
  for (let t = 1, r = e.length; t < r; ++t)
    this._ += arguments[t] + e[t];
}
function Ak(e) {
  let t = Math.floor(e);
  if (!(t >= 0))
    throw new Error(`invalid digits: ${e}`);
  if (t > 15)
    return ay;
  const r = 10 ** t;
  return function(n) {
    this._ += n[0];
    for (let a = 1, i = n.length; a < i; ++a)
      this._ += Math.round(arguments[a] * r) / r + n[a];
  };
}
class pk {
  constructor(t) {
    this._x0 = this._y0 = // start of current subpath
    this._x1 = this._y1 = null, this._ = "", this._append = t == null ? ay : Ak(t);
  }
  moveTo(t, r) {
    this._append`M${this._x0 = this._x1 = +t},${this._y0 = this._y1 = +r}`;
  }
  closePath() {
    this._x1 !== null && (this._x1 = this._x0, this._y1 = this._y0, this._append`Z`);
  }
  lineTo(t, r) {
    this._append`L${this._x1 = +t},${this._y1 = +r}`;
  }
  quadraticCurveTo(t, r, n, a) {
    this._append`Q${+t},${+r},${this._x1 = +n},${this._y1 = +a}`;
  }
  bezierCurveTo(t, r, n, a, i, o) {
    this._append`C${+t},${+r},${+n},${+a},${this._x1 = +i},${this._y1 = +o}`;
  }
  arcTo(t, r, n, a, i) {
    if (t = +t, r = +r, n = +n, a = +a, i = +i, i < 0)
      throw new Error(`negative radius: ${i}`);
    let o = this._x1, s = this._y1, c = n - t, u = a - r, d = o - t, h = s - r, A = d * d + h * h;
    if (this._x1 === null)
      this._append`M${this._x1 = t},${this._y1 = r}`;
    else if (A > $1)
      if (!(Math.abs(h * c - u * d) > $1) || !i)
        this._append`L${this._x1 = t},${this._y1 = r}`;
      else {
        let p = n - o, m = a - s, g = c * c + u * u, v = p * p + m * m, C = Math.sqrt(g), y = Math.sqrt(A), w = i * Math.tan((t5 - Math.acos((g + A - v) / (2 * C * y))) / 2), O = w / y, b = w / C;
        Math.abs(O - 1) > $1 && this._append`L${t + O * d},${r + O * h}`, this._append`A${i},${i},0,0,${+(h * p > d * m)},${this._x1 = t + b * c},${this._y1 = r + b * u}`;
      }
  }
  arc(t, r, n, a, i, o) {
    if (t = +t, r = +r, n = +n, o = !!o, n < 0)
      throw new Error(`negative radius: ${n}`);
    let s = n * Math.cos(a), c = n * Math.sin(a), u = t + s, d = r + c, h = 1 ^ o, A = o ? a - i : i - a;
    this._x1 === null ? this._append`M${u},${d}` : (Math.abs(this._x1 - u) > $1 || Math.abs(this._y1 - d) > $1) && this._append`L${u},${d}`, n && (A < 0 && (A = A % r5 + r5), A > hk ? this._append`A${n},${n},0,1,${h},${t - s},${r - c}A${n},${n},0,1,${h},${this._x1 = u},${this._y1 = d}` : A > $1 && this._append`A${n},${n},0,${+(A >= t5)},${h},${this._x1 = t + n * Math.cos(i)},${this._y1 = r + n * Math.sin(i)}`);
  }
  rect(t, r, n, a) {
    this._append`M${this._x0 = this._x1 = +t},${this._y0 = this._y1 = +r}h${n = +n}v${+a}h${-n}Z`;
  }
  toString() {
    return this._;
  }
}
function v9(e) {
  let t = 3;
  return e.digits = function(r) {
    if (!arguments.length)
      return t;
    if (r == null)
      t = null;
    else {
      const n = Math.floor(r);
      if (!(n >= 0))
        throw new RangeError(`invalid digits: ${r}`);
      t = n;
    }
    return e;
  }, () => new pk(t);
}
function g9(e) {
  return typeof e == "object" && "length" in e ? e : Array.from(e);
}
function iy(e) {
  this._context = e;
}
iy.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(e, t) {
    switch (e = +e, t = +t, this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(e, t) : this._context.moveTo(e, t);
        break;
      case 1:
        this._point = 2;
      default:
        this._context.lineTo(e, t);
        break;
    }
  }
};
function j0(e) {
  return new iy(e);
}
function oy(e) {
  return e[0];
}
function sy(e) {
  return e[1];
}
function ly(e, t) {
  var r = lt(!0), n = null, a = j0, i = null, o = v9(s);
  e = typeof e == "function" ? e : e === void 0 ? oy : lt(e), t = typeof t == "function" ? t : t === void 0 ? sy : lt(t);
  function s(c) {
    var u, d = (c = g9(c)).length, h, A = !1, p;
    for (n == null && (i = a(p = o())), u = 0; u <= d; ++u)
      !(u < d && r(h = c[u], u, c)) === A && ((A = !A) ? i.lineStart() : i.lineEnd()), A && i.point(+e(h, u, c), +t(h, u, c));
    if (p)
      return i = null, p + "" || null;
  }
  return s.x = function(c) {
    return arguments.length ? (e = typeof c == "function" ? c : lt(+c), s) : e;
  }, s.y = function(c) {
    return arguments.length ? (t = typeof c == "function" ? c : lt(+c), s) : t;
  }, s.defined = function(c) {
    return arguments.length ? (r = typeof c == "function" ? c : lt(!!c), s) : r;
  }, s.curve = function(c) {
    return arguments.length ? (a = c, n != null && (i = a(n)), s) : a;
  }, s.context = function(c) {
    return arguments.length ? (c == null ? n = i = null : i = a(n = c), s) : n;
  }, s;
}
function x3(e, t, r) {
  var n = null, a = lt(!0), i = null, o = j0, s = null, c = v9(u);
  e = typeof e == "function" ? e : e === void 0 ? oy : lt(+e), t = typeof t == "function" ? t : lt(t === void 0 ? 0 : +t), r = typeof r == "function" ? r : r === void 0 ? sy : lt(+r);
  function u(h) {
    var A, p, m, g = (h = g9(h)).length, v, C = !1, y, w = new Array(g), O = new Array(g);
    for (i == null && (s = o(y = c())), A = 0; A <= g; ++A) {
      if (!(A < g && a(v = h[A], A, h)) === C)
        if (C = !C)
          p = A, s.areaStart(), s.lineStart();
        else {
          for (s.lineEnd(), s.lineStart(), m = A - 1; m >= p; --m)
            s.point(w[m], O[m]);
          s.lineEnd(), s.areaEnd();
        }
      C && (w[A] = +e(v, A, h), O[A] = +t(v, A, h), s.point(n ? +n(v, A, h) : w[A], r ? +r(v, A, h) : O[A]));
    }
    if (y)
      return s = null, y + "" || null;
  }
  function d() {
    return ly().defined(a).curve(o).context(i);
  }
  return u.x = function(h) {
    return arguments.length ? (e = typeof h == "function" ? h : lt(+h), n = null, u) : e;
  }, u.x0 = function(h) {
    return arguments.length ? (e = typeof h == "function" ? h : lt(+h), u) : e;
  }, u.x1 = function(h) {
    return arguments.length ? (n = h == null ? null : typeof h == "function" ? h : lt(+h), u) : n;
  }, u.y = function(h) {
    return arguments.length ? (t = typeof h == "function" ? h : lt(+h), r = null, u) : t;
  }, u.y0 = function(h) {
    return arguments.length ? (t = typeof h == "function" ? h : lt(+h), u) : t;
  }, u.y1 = function(h) {
    return arguments.length ? (r = h == null ? null : typeof h == "function" ? h : lt(+h), u) : r;
  }, u.lineX0 = u.lineY0 = function() {
    return d().x(e).y(t);
  }, u.lineY1 = function() {
    return d().x(e).y(r);
  }, u.lineX1 = function() {
    return d().x(n).y(t);
  }, u.defined = function(h) {
    return arguments.length ? (a = typeof h == "function" ? h : lt(!!h), u) : a;
  }, u.curve = function(h) {
    return arguments.length ? (o = h, i != null && (s = o(i)), u) : o;
  }, u.context = function(h) {
    return arguments.length ? (h == null ? i = s = null : s = o(i = h), u) : i;
  }, u;
}
class cy {
  constructor(t, r) {
    this._context = t, this._x = r;
  }
  areaStart() {
    this._line = 0;
  }
  areaEnd() {
    this._line = NaN;
  }
  lineStart() {
    this._point = 0;
  }
  lineEnd() {
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  }
  point(t, r) {
    switch (t = +t, r = +r, this._point) {
      case 0: {
        this._point = 1, this._line ? this._context.lineTo(t, r) : this._context.moveTo(t, r);
        break;
      }
      case 1:
        this._point = 2;
      default: {
        this._x ? this._context.bezierCurveTo(this._x0 = (this._x0 + t) / 2, this._y0, this._x0, r, t, r) : this._context.bezierCurveTo(this._x0, this._y0 = (this._y0 + r) / 2, t, this._y0, t, r);
        break;
      }
    }
    this._x0 = t, this._y0 = r;
  }
}
function vk(e) {
  return new cy(e, !0);
}
function gk(e) {
  return new cy(e, !1);
}
const m9 = {
  draw(e, t) {
    const r = Zr(t / ls);
    e.moveTo(r, 0), e.arc(0, 0, r, 0, P0);
  }
}, mk = {
  draw(e, t) {
    const r = Zr(t / 5) / 2;
    e.moveTo(-3 * r, -r), e.lineTo(-r, -r), e.lineTo(-r, -3 * r), e.lineTo(r, -3 * r), e.lineTo(r, -r), e.lineTo(3 * r, -r), e.lineTo(3 * r, r), e.lineTo(r, r), e.lineTo(r, 3 * r), e.lineTo(-r, 3 * r), e.lineTo(-r, r), e.lineTo(-3 * r, r), e.closePath();
  }
}, uy = Zr(1 / 3), Ck = uy * 2, bk = {
  draw(e, t) {
    const r = Zr(t / Ck), n = r * uy;
    e.moveTo(0, -r), e.lineTo(n, 0), e.lineTo(0, r), e.lineTo(-n, 0), e.closePath();
  }
}, yk = {
  draw(e, t) {
    const r = Zr(t), n = -r / 2;
    e.rect(n, n, r, r);
  }
}, wk = 0.8908130915292852, fy = ss(ls / 10) / ss(7 * ls / 10), xk = ss(P0 / 10) * fy, Ok = -ny(P0 / 10) * fy, Dk = {
  draw(e, t) {
    const r = Zr(t * wk), n = xk * r, a = Ok * r;
    e.moveTo(0, -r), e.lineTo(n, a);
    for (let i = 1; i < 5; ++i) {
      const o = P0 * i / 5, s = ny(o), c = ss(o);
      e.lineTo(c * r, -s * r), e.lineTo(s * n - c * a, c * n + s * a);
    }
    e.closePath();
  }
}, k6 = Zr(3), Mk = {
  draw(e, t) {
    const r = -Zr(t / (k6 * 3));
    e.moveTo(0, r * 2), e.lineTo(-k6 * r, -r), e.lineTo(k6 * r, -r), e.closePath();
  }
}, yr = -0.5, wr = Zr(3) / 2, n5 = 1 / Zr(12), Ek = (n5 / 2 + 1) * 3, Pk = {
  draw(e, t) {
    const r = Zr(t / Ek), n = r / 2, a = r * n5, i = n, o = r * n5 + r, s = -i, c = o;
    e.moveTo(n, a), e.lineTo(i, o), e.lineTo(s, c), e.lineTo(yr * n - wr * a, wr * n + yr * a), e.lineTo(yr * i - wr * o, wr * i + yr * o), e.lineTo(yr * s - wr * c, wr * s + yr * c), e.lineTo(yr * n + wr * a, yr * a - wr * n), e.lineTo(yr * i + wr * o, yr * o - wr * i), e.lineTo(yr * s + wr * c, yr * c - wr * s), e.closePath();
  }
};
function jk(e, t) {
  let r = null, n = v9(a);
  e = typeof e == "function" ? e : lt(e || m9), t = typeof t == "function" ? t : lt(t === void 0 ? 64 : +t);
  function a() {
    let i;
    if (r || (r = i = n()), e.apply(this, arguments).draw(r, +t.apply(this, arguments)), i)
      return r = null, i + "" || null;
  }
  return a.type = function(i) {
    return arguments.length ? (e = typeof i == "function" ? i : lt(i), a) : e;
  }, a.size = function(i) {
    return arguments.length ? (t = typeof i == "function" ? i : lt(+i), a) : t;
  }, a.context = function(i) {
    return arguments.length ? (r = i ?? null, a) : r;
  }, a;
}
function cs() {
}
function us(e, t, r) {
  e._context.bezierCurveTo(
    (2 * e._x0 + e._x1) / 3,
    (2 * e._y0 + e._y1) / 3,
    (e._x0 + 2 * e._x1) / 3,
    (e._y0 + 2 * e._y1) / 3,
    (e._x0 + 4 * e._x1 + t) / 6,
    (e._y0 + 4 * e._y1 + r) / 6
  );
}
function dy(e) {
  this._context = e;
}
dy.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._y0 = this._y1 = NaN, this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 3:
        us(this, this._x1, this._y1);
      case 2:
        this._context.lineTo(this._x1, this._y1);
        break;
    }
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(e, t) {
    switch (e = +e, t = +t, this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(e, t) : this._context.moveTo(e, t);
        break;
      case 1:
        this._point = 2;
        break;
      case 2:
        this._point = 3, this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6);
      default:
        us(this, e, t);
        break;
    }
    this._x0 = this._x1, this._x1 = e, this._y0 = this._y1, this._y1 = t;
  }
};
function Sk(e) {
  return new dy(e);
}
function hy(e) {
  this._context = e;
}
hy.prototype = {
  areaStart: cs,
  areaEnd: cs,
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN, this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 1: {
        this._context.moveTo(this._x2, this._y2), this._context.closePath();
        break;
      }
      case 2: {
        this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3), this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3), this._context.closePath();
        break;
      }
      case 3: {
        this.point(this._x2, this._y2), this.point(this._x3, this._y3), this.point(this._x4, this._y4);
        break;
      }
    }
  },
  point: function(e, t) {
    switch (e = +e, t = +t, this._point) {
      case 0:
        this._point = 1, this._x2 = e, this._y2 = t;
        break;
      case 1:
        this._point = 2, this._x3 = e, this._y3 = t;
        break;
      case 2:
        this._point = 3, this._x4 = e, this._y4 = t, this._context.moveTo((this._x0 + 4 * this._x1 + e) / 6, (this._y0 + 4 * this._y1 + t) / 6);
        break;
      default:
        us(this, e, t);
        break;
    }
    this._x0 = this._x1, this._x1 = e, this._y0 = this._y1, this._y1 = t;
  }
};
function Ik(e) {
  return new hy(e);
}
function Ay(e) {
  this._context = e;
}
Ay.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._y0 = this._y1 = NaN, this._point = 0;
  },
  lineEnd: function() {
    (this._line || this._line !== 0 && this._point === 3) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(e, t) {
    switch (e = +e, t = +t, this._point) {
      case 0:
        this._point = 1;
        break;
      case 1:
        this._point = 2;
        break;
      case 2:
        this._point = 3;
        var r = (this._x0 + 4 * this._x1 + e) / 6, n = (this._y0 + 4 * this._y1 + t) / 6;
        this._line ? this._context.lineTo(r, n) : this._context.moveTo(r, n);
        break;
      case 3:
        this._point = 4;
      default:
        us(this, e, t);
        break;
    }
    this._x0 = this._x1, this._x1 = e, this._y0 = this._y1, this._y1 = t;
  }
};
function Bk(e) {
  return new Ay(e);
}
function py(e) {
  this._context = e;
}
py.prototype = {
  areaStart: cs,
  areaEnd: cs,
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    this._point && this._context.closePath();
  },
  point: function(e, t) {
    e = +e, t = +t, this._point ? this._context.lineTo(e, t) : (this._point = 1, this._context.moveTo(e, t));
  }
};
function Nk(e) {
  return new py(e);
}
function Ph(e) {
  return e < 0 ? -1 : 1;
}
function jh(e, t, r) {
  var n = e._x1 - e._x0, a = t - e._x1, i = (e._y1 - e._y0) / (n || a < 0 && -0), o = (r - e._y1) / (a || n < 0 && -0), s = (i * a + o * n) / (n + a);
  return (Ph(i) + Ph(o)) * Math.min(Math.abs(i), Math.abs(o), 0.5 * Math.abs(s)) || 0;
}
function Sh(e, t) {
  var r = e._x1 - e._x0;
  return r ? (3 * (e._y1 - e._y0) / r - t) / 2 : t;
}
function G6(e, t, r) {
  var n = e._x0, a = e._y0, i = e._x1, o = e._y1, s = (i - n) / 3;
  e._context.bezierCurveTo(n + s, a + s * t, i - s, o - s * r, i, o);
}
function fs(e) {
  this._context = e;
}
fs.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._y0 = this._y1 = this._t0 = NaN, this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2:
        this._context.lineTo(this._x1, this._y1);
        break;
      case 3:
        G6(this, this._t0, Sh(this, this._t0));
        break;
    }
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(e, t) {
    var r = NaN;
    if (e = +e, t = +t, !(e === this._x1 && t === this._y1)) {
      switch (this._point) {
        case 0:
          this._point = 1, this._line ? this._context.lineTo(e, t) : this._context.moveTo(e, t);
          break;
        case 1:
          this._point = 2;
          break;
        case 2:
          this._point = 3, G6(this, Sh(this, r = jh(this, e, t)), r);
          break;
        default:
          G6(this, this._t0, r = jh(this, e, t));
          break;
      }
      this._x0 = this._x1, this._x1 = e, this._y0 = this._y1, this._y1 = t, this._t0 = r;
    }
  }
};
function vy(e) {
  this._context = new gy(e);
}
(vy.prototype = Object.create(fs.prototype)).point = function(e, t) {
  fs.prototype.point.call(this, t, e);
};
function gy(e) {
  this._context = e;
}
gy.prototype = {
  moveTo: function(e, t) {
    this._context.moveTo(t, e);
  },
  closePath: function() {
    this._context.closePath();
  },
  lineTo: function(e, t) {
    this._context.lineTo(t, e);
  },
  bezierCurveTo: function(e, t, r, n, a, i) {
    this._context.bezierCurveTo(t, e, n, r, i, a);
  }
};
function _k(e) {
  return new fs(e);
}
function Lk(e) {
  return new vy(e);
}
function my(e) {
  this._context = e;
}
my.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x = [], this._y = [];
  },
  lineEnd: function() {
    var e = this._x, t = this._y, r = e.length;
    if (r)
      if (this._line ? this._context.lineTo(e[0], t[0]) : this._context.moveTo(e[0], t[0]), r === 2)
        this._context.lineTo(e[1], t[1]);
      else
        for (var n = Ih(e), a = Ih(t), i = 0, o = 1; o < r; ++i, ++o)
          this._context.bezierCurveTo(n[0][i], a[0][i], n[1][i], a[1][i], e[o], t[o]);
    (this._line || this._line !== 0 && r === 1) && this._context.closePath(), this._line = 1 - this._line, this._x = this._y = null;
  },
  point: function(e, t) {
    this._x.push(+e), this._y.push(+t);
  }
};
function Ih(e) {
  var t, r = e.length - 1, n, a = new Array(r), i = new Array(r), o = new Array(r);
  for (a[0] = 0, i[0] = 2, o[0] = e[0] + 2 * e[1], t = 1; t < r - 1; ++t)
    a[t] = 1, i[t] = 4, o[t] = 4 * e[t] + 2 * e[t + 1];
  for (a[r - 1] = 2, i[r - 1] = 7, o[r - 1] = 8 * e[r - 1] + e[r], t = 1; t < r; ++t)
    n = a[t] / i[t - 1], i[t] -= n, o[t] -= n * o[t - 1];
  for (a[r - 1] = o[r - 1] / i[r - 1], t = r - 2; t >= 0; --t)
    a[t] = (o[t] - a[t + 1]) / i[t];
  for (i[r - 1] = (e[r] + a[r - 1]) / 2, t = 0; t < r - 1; ++t)
    i[t] = 2 * e[t + 1] - a[t + 1];
  return [a, i];
}
function Tk(e) {
  return new my(e);
}
function S0(e, t) {
  this._context = e, this._t = t;
}
S0.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x = this._y = NaN, this._point = 0;
  },
  lineEnd: function() {
    0 < this._t && this._t < 1 && this._point === 2 && this._context.lineTo(this._x, this._y), (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line >= 0 && (this._t = 1 - this._t, this._line = 1 - this._line);
  },
  point: function(e, t) {
    switch (e = +e, t = +t, this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(e, t) : this._context.moveTo(e, t);
        break;
      case 1:
        this._point = 2;
      default: {
        if (this._t <= 0)
          this._context.lineTo(this._x, t), this._context.lineTo(e, t);
        else {
          var r = this._x * (1 - this._t) + e * this._t;
          this._context.lineTo(r, this._y), this._context.lineTo(r, t);
        }
        break;
      }
    }
    this._x = e, this._y = t;
  }
};
function Rk(e) {
  return new S0(e, 0.5);
}
function $k(e) {
  return new S0(e, 0);
}
function Fk(e) {
  return new S0(e, 1);
}
function Ka(e, t) {
  if ((o = e.length) > 1)
    for (var r = 1, n, a, i = e[t[0]], o, s = i.length; r < o; ++r)
      for (a = i, i = e[t[r]], n = 0; n < s; ++n)
        i[n][1] += i[n][0] = isNaN(a[n][1]) ? a[n][0] : a[n][1];
}
function a5(e) {
  for (var t = e.length, r = new Array(t); --t >= 0; )
    r[t] = t;
  return r;
}
function Hk(e, t) {
  return e[t];
}
function Yk(e) {
  const t = [];
  return t.key = e, t;
}
function Vk() {
  var e = lt([]), t = a5, r = Ka, n = Hk;
  function a(i) {
    var o = Array.from(e.apply(this, arguments), Yk), s, c = o.length, u = -1, d;
    for (const h of i)
      for (s = 0, ++u; s < c; ++s)
        (o[s][u] = [0, +n(h, o[s].key, u, i)]).data = h;
    for (s = 0, d = g9(t(o)); s < c; ++s)
      o[d[s]].index = s;
    return r(o, d), o;
  }
  return a.keys = function(i) {
    return arguments.length ? (e = typeof i == "function" ? i : lt(Array.from(i)), a) : e;
  }, a.value = function(i) {
    return arguments.length ? (n = typeof i == "function" ? i : lt(+i), a) : n;
  }, a.order = function(i) {
    return arguments.length ? (t = i == null ? a5 : typeof i == "function" ? i : lt(Array.from(i)), a) : t;
  }, a.offset = function(i) {
    return arguments.length ? (r = i ?? Ka, a) : r;
  }, a;
}
function kk(e, t) {
  if ((n = e.length) > 0) {
    for (var r, n, a = 0, i = e[0].length, o; a < i; ++a) {
      for (o = r = 0; r < n; ++r)
        o += e[r][a][1] || 0;
      if (o)
        for (r = 0; r < n; ++r)
          e[r][a][1] /= o;
    }
    Ka(e, t);
  }
}
function Gk(e, t) {
  if ((a = e.length) > 0) {
    for (var r = 0, n = e[t[0]], a, i = n.length; r < i; ++r) {
      for (var o = 0, s = 0; o < a; ++o)
        s += e[o][r][1] || 0;
      n[r][1] += n[r][0] = -s / 2;
    }
    Ka(e, t);
  }
}
function Wk(e, t) {
  if (!(!((o = e.length) > 0) || !((i = (a = e[t[0]]).length) > 0))) {
    for (var r = 0, n = 1, a, i, o; n < i; ++n) {
      for (var s = 0, c = 0, u = 0; s < o; ++s) {
        for (var d = e[t[s]], h = d[n][1] || 0, A = d[n - 1][1] || 0, p = (h - A) / 2, m = 0; m < s; ++m) {
          var g = e[t[m]], v = g[n][1] || 0, C = g[n - 1][1] || 0;
          p += v - C;
        }
        c += h, u += p * h;
      }
      a[n - 1][1] += a[n - 1][0] = r, c && (r -= u / c);
    }
    a[n - 1][1] += a[n - 1][0] = r, Ka(e, t);
  }
}
function oo(e) {
  "@babel/helpers - typeof";
  return oo = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, oo(e);
}
var Qk = ["type", "size", "sizeType"];
function i5() {
  return i5 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, i5.apply(this, arguments);
}
function Bh(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Nh(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Bh(Object(r), !0).forEach(function(n) {
      Uk(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Bh(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function Uk(e, t, r) {
  return t = Zk(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function Zk(e) {
  var t = zk(e, "string");
  return oo(t) == "symbol" ? t : t + "";
}
function zk(e, t) {
  if (oo(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (oo(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function Kk(e, t) {
  if (e == null)
    return {};
  var r = qk(e, t), n, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (a = 0; a < i.length; a++)
      n = i[a], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function qk(e, t) {
  if (e == null)
    return {};
  var r = {};
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      if (t.indexOf(n) >= 0)
        continue;
      r[n] = e[n];
    }
  return r;
}
var Cy = {
  symbolCircle: m9,
  symbolCross: mk,
  symbolDiamond: bk,
  symbolSquare: yk,
  symbolStar: Dk,
  symbolTriangle: Mk,
  symbolWye: Pk
}, Xk = Math.PI / 180, Jk = function(t) {
  var r = "symbol".concat(E0(t));
  return Cy[r] || m9;
}, eG = function(t, r, n) {
  if (r === "area")
    return t;
  switch (n) {
    case "cross":
      return 5 * t * t / 9;
    case "diamond":
      return 0.5 * t * t / Math.sqrt(3);
    case "square":
      return t * t;
    case "star": {
      var a = 18 * Xk;
      return 1.25 * t * t * (Math.tan(a) - Math.tan(a * 2) * Math.pow(Math.tan(a), 2));
    }
    case "triangle":
      return Math.sqrt(3) * t * t / 4;
    case "wye":
      return (21 - 10 * Math.sqrt(3)) * t * t / 8;
    default:
      return Math.PI * t * t / 4;
  }
}, tG = function(t, r) {
  Cy["symbol".concat(E0(t))] = r;
}, I0 = function(t) {
  var r = t.type, n = r === void 0 ? "circle" : r, a = t.size, i = a === void 0 ? 64 : a, o = t.sizeType, s = o === void 0 ? "area" : o, c = Kk(t, Qk), u = Nh(Nh({}, c), {}, {
    type: n,
    size: i,
    sizeType: s
  }), d = function() {
    var v = Jk(n), C = jk().type(v).size(eG(i, s, n));
    return C();
  }, h = u.className, A = u.cx, p = u.cy, m = Ae(u, !0);
  return A === +A && p === +p && i === +i ? /* @__PURE__ */ B.createElement("path", i5({}, m, {
    className: Pe("recharts-symbols", h),
    transform: "translate(".concat(A, ", ").concat(p, ")"),
    d: d()
  })) : null;
};
I0.registerSymbol = tG;
function qa(e) {
  "@babel/helpers - typeof";
  return qa = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, qa(e);
}
function o5() {
  return o5 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, o5.apply(this, arguments);
}
function _h(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function rG(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? _h(Object(r), !0).forEach(function(n) {
      so(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : _h(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function nG(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Lh(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, yy(n.key), n);
  }
}
function aG(e, t, r) {
  return t && Lh(e.prototype, t), r && Lh(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function iG(e, t, r) {
  return t = ds(t), oG(e, by() ? Reflect.construct(t, r || [], ds(e).constructor) : t.apply(e, r));
}
function oG(e, t) {
  if (t && (qa(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return sG(e);
}
function sG(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function by() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (by = function() {
    return !!e;
  })();
}
function ds(e) {
  return ds = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, ds(e);
}
function lG(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && s5(e, t);
}
function s5(e, t) {
  return s5 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, a) {
    return n.__proto__ = a, n;
  }, s5(e, t);
}
function so(e, t, r) {
  return t = yy(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function yy(e) {
  var t = cG(e, "string");
  return qa(t) == "symbol" ? t : t + "";
}
function cG(e, t) {
  if (qa(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (qa(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var xr = 32, C9 = /* @__PURE__ */ function(e) {
  function t() {
    return nG(this, t), iG(this, t, arguments);
  }
  return lG(t, e), aG(t, [{
    key: "renderIcon",
    value: (
      /**
       * Render the path of icon
       * @param {Object} data Data of each legend item
       * @return {String} Path element
       */
      function(n) {
        var a = this.props.inactiveColor, i = xr / 2, o = xr / 6, s = xr / 3, c = n.inactive ? a : n.color;
        if (n.type === "plainline")
          return /* @__PURE__ */ B.createElement("line", {
            strokeWidth: 4,
            fill: "none",
            stroke: c,
            strokeDasharray: n.payload.strokeDasharray,
            x1: 0,
            y1: i,
            x2: xr,
            y2: i,
            className: "recharts-legend-icon"
          });
        if (n.type === "line")
          return /* @__PURE__ */ B.createElement("path", {
            strokeWidth: 4,
            fill: "none",
            stroke: c,
            d: "M0,".concat(i, "h").concat(s, `
            A`).concat(o, ",").concat(o, ",0,1,1,").concat(2 * s, ",").concat(i, `
            H`).concat(xr, "M").concat(2 * s, ",").concat(i, `
            A`).concat(o, ",").concat(o, ",0,1,1,").concat(s, ",").concat(i),
            className: "recharts-legend-icon"
          });
        if (n.type === "rect")
          return /* @__PURE__ */ B.createElement("path", {
            stroke: "none",
            fill: c,
            d: "M0,".concat(xr / 8, "h").concat(xr, "v").concat(xr * 3 / 4, "h").concat(-xr, "z"),
            className: "recharts-legend-icon"
          });
        if (/* @__PURE__ */ B.isValidElement(n.legendIcon)) {
          var u = rG({}, n);
          return delete u.legendIcon, /* @__PURE__ */ B.cloneElement(n.legendIcon, u);
        }
        return /* @__PURE__ */ B.createElement(I0, {
          fill: c,
          cx: i,
          cy: i,
          size: xr,
          sizeType: "diameter",
          type: n.type
        });
      }
    )
    /**
     * Draw items of legend
     * @return {ReactElement} Items
     */
  }, {
    key: "renderItems",
    value: function() {
      var n = this, a = this.props, i = a.payload, o = a.iconSize, s = a.layout, c = a.formatter, u = a.inactiveColor, d = {
        x: 0,
        y: 0,
        width: xr,
        height: xr
      }, h = {
        display: s === "horizontal" ? "inline-block" : "block",
        marginRight: 10
      }, A = {
        display: "inline-block",
        verticalAlign: "middle",
        marginRight: 4
      };
      return i.map(function(p, m) {
        var g = p.formatter || c, v = Pe(so(so({
          "recharts-legend-item": !0
        }, "legend-item-".concat(m), !0), "inactive", p.inactive));
        if (p.type === "none")
          return null;
        var C = ye(p.value) ? null : p.value;
        Gr(
          !ye(p.value),
          `The name property is also required when using a function for the dataKey of a chart's cartesian components. Ex: <Bar name="Name of my Data"/>`
          // eslint-disable-line max-len
        );
        var y = p.inactive ? u : p.color;
        return /* @__PURE__ */ B.createElement("li", o5({
          className: v,
          style: h,
          key: "legend-item-".concat(m)
        }, c1(n.props, p, m)), /* @__PURE__ */ B.createElement(q4, {
          width: o,
          height: o,
          viewBox: d,
          style: A
        }, n.renderIcon(p)), /* @__PURE__ */ B.createElement("span", {
          className: "recharts-legend-item-text",
          style: {
            color: y
          }
        }, g ? g(C, p, m) : C));
      });
    }
  }, {
    key: "render",
    value: function() {
      var n = this.props, a = n.payload, i = n.layout, o = n.align;
      if (!a || !a.length)
        return null;
      var s = {
        padding: 0,
        margin: 0,
        textAlign: i === "horizontal" ? o : "left"
      };
      return /* @__PURE__ */ B.createElement("ul", {
        className: "recharts-default-legend",
        style: s
      }, this.renderItems());
    }
  }]);
}(Cr);
so(C9, "displayName", "Legend");
so(C9, "defaultProps", {
  iconSize: 14,
  layout: "horizontal",
  align: "center",
  verticalAlign: "middle",
  inactiveColor: "#ccc"
});
var uG = O0;
function fG() {
  this.__data__ = new uG(), this.size = 0;
}
var dG = fG;
function hG(e) {
  var t = this.__data__, r = t.delete(e);
  return this.size = t.size, r;
}
var AG = hG;
function pG(e) {
  return this.__data__.get(e);
}
var vG = pG;
function gG(e) {
  return this.__data__.has(e);
}
var mG = gG, CG = O0, bG = c9, yG = u9, wG = 200;
function xG(e, t) {
  var r = this.__data__;
  if (r instanceof CG) {
    var n = r.__data__;
    if (!bG || n.length < wG - 1)
      return n.push([e, t]), this.size = ++r.size, this;
    r = this.__data__ = new yG(n);
  }
  return r.set(e, t), this.size = r.size, this;
}
var OG = xG, DG = O0, MG = dG, EG = AG, PG = vG, jG = mG, SG = OG;
function L2(e) {
  var t = this.__data__ = new DG(e);
  this.size = t.size;
}
L2.prototype.clear = MG;
L2.prototype.delete = EG;
L2.prototype.get = PG;
L2.prototype.has = jG;
L2.prototype.set = SG;
var wy = L2, IG = "__lodash_hash_undefined__";
function BG(e) {
  return this.__data__.set(e, IG), this;
}
var NG = BG;
function _G(e) {
  return this.__data__.has(e);
}
var LG = _G, TG = u9, RG = NG, $G = LG;
function hs(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.__data__ = new TG(); ++t < r; )
    this.add(e[t]);
}
hs.prototype.add = hs.prototype.push = RG;
hs.prototype.has = $G;
var xy = hs;
function FG(e, t) {
  for (var r = -1, n = e == null ? 0 : e.length; ++r < n; )
    if (t(e[r], r, e))
      return !0;
  return !1;
}
var Oy = FG;
function HG(e, t) {
  return e.has(t);
}
var Dy = HG, YG = xy, VG = Oy, kG = Dy, GG = 1, WG = 2;
function QG(e, t, r, n, a, i) {
  var o = r & GG, s = e.length, c = t.length;
  if (s != c && !(o && c > s))
    return !1;
  var u = i.get(e), d = i.get(t);
  if (u && d)
    return u == t && d == e;
  var h = -1, A = !0, p = r & WG ? new YG() : void 0;
  for (i.set(e, t), i.set(t, e); ++h < s; ) {
    var m = e[h], g = t[h];
    if (n)
      var v = o ? n(g, m, h, t, e, i) : n(m, g, h, e, t, i);
    if (v !== void 0) {
      if (v)
        continue;
      A = !1;
      break;
    }
    if (p) {
      if (!VG(t, function(C, y) {
        if (!kG(p, y) && (m === C || a(m, C, r, n, i)))
          return p.push(y);
      })) {
        A = !1;
        break;
      }
    } else if (!(m === g || a(m, g, r, n, i))) {
      A = !1;
      break;
    }
  }
  return i.delete(e), i.delete(t), A;
}
var My = QG, UG = fn, ZG = UG.Uint8Array, zG = ZG;
function KG(e) {
  var t = -1, r = Array(e.size);
  return e.forEach(function(n, a) {
    r[++t] = [a, n];
  }), r;
}
var qG = KG;
function XG(e) {
  var t = -1, r = Array(e.size);
  return e.forEach(function(n) {
    r[++t] = n;
  }), r;
}
var b9 = XG, Th = Zo, Rh = zG, JG = l9, eW = My, tW = qG, rW = b9, nW = 1, aW = 2, iW = "[object Boolean]", oW = "[object Date]", sW = "[object Error]", lW = "[object Map]", cW = "[object Number]", uW = "[object RegExp]", fW = "[object Set]", dW = "[object String]", hW = "[object Symbol]", AW = "[object ArrayBuffer]", pW = "[object DataView]", $h = Th ? Th.prototype : void 0, W6 = $h ? $h.valueOf : void 0;
function vW(e, t, r, n, a, i, o) {
  switch (r) {
    case pW:
      if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset)
        return !1;
      e = e.buffer, t = t.buffer;
    case AW:
      return !(e.byteLength != t.byteLength || !i(new Rh(e), new Rh(t)));
    case iW:
    case oW:
    case cW:
      return JG(+e, +t);
    case sW:
      return e.name == t.name && e.message == t.message;
    case uW:
    case dW:
      return e == t + "";
    case lW:
      var s = tW;
    case fW:
      var c = n & nW;
      if (s || (s = rW), e.size != t.size && !c)
        return !1;
      var u = o.get(e);
      if (u)
        return u == t;
      n |= aW, o.set(e, t);
      var d = eW(s(e), s(t), n, a, i, o);
      return o.delete(e), d;
    case hW:
      if (W6)
        return W6.call(e) == W6.call(t);
  }
  return !1;
}
var gW = vW;
function mW(e, t) {
  for (var r = -1, n = t.length, a = e.length; ++r < n; )
    e[a + r] = t[r];
  return e;
}
var Ey = mW, CW = Ey, bW = or;
function yW(e, t, r) {
  var n = t(e);
  return bW(e) ? n : CW(n, r(e));
}
var wW = yW;
function xW(e, t) {
  for (var r = -1, n = e == null ? 0 : e.length, a = 0, i = []; ++r < n; ) {
    var o = e[r];
    t(o, r, e) && (i[a++] = o);
  }
  return i;
}
var OW = xW;
function DW() {
  return [];
}
var MW = DW, EW = OW, PW = MW, jW = Object.prototype, SW = jW.propertyIsEnumerable, Fh = Object.getOwnPropertySymbols, IW = Fh ? function(e) {
  return e == null ? [] : (e = Object(e), EW(Fh(e), function(t) {
    return SW.call(e, t);
  }));
} : PW, BW = IW;
function NW(e, t) {
  for (var r = -1, n = Array(e); ++r < e; )
    n[r] = t(r);
  return n;
}
var _W = NW, LW = Bn, TW = Nn, RW = "[object Arguments]";
function $W(e) {
  return TW(e) && LW(e) == RW;
}
var FW = $W, Hh = FW, HW = Nn, Py = Object.prototype, YW = Py.hasOwnProperty, VW = Py.propertyIsEnumerable, kW = Hh(function() {
  return arguments;
}()) ? Hh : function(e) {
  return HW(e) && YW.call(e, "callee") && !VW.call(e, "callee");
}, y9 = kW, As = { exports: {} };
function GW() {
  return !1;
}
var WW = GW;
As.exports;
(function(e, t) {
  var r = fn, n = WW, a = t && !t.nodeType && t, i = a && !0 && e && !e.nodeType && e, o = i && i.exports === a, s = o ? r.Buffer : void 0, c = s ? s.isBuffer : void 0, u = c || n;
  e.exports = u;
})(As, As.exports);
var jy = As.exports, QW = 9007199254740991, UW = /^(?:0|[1-9]\d*)$/;
function ZW(e, t) {
  var r = typeof e;
  return t = t ?? QW, !!t && (r == "number" || r != "symbol" && UW.test(e)) && e > -1 && e % 1 == 0 && e < t;
}
var w9 = ZW, zW = 9007199254740991;
function KW(e) {
  return typeof e == "number" && e > -1 && e % 1 == 0 && e <= zW;
}
var x9 = KW, qW = Bn, XW = x9, JW = Nn, eQ = "[object Arguments]", tQ = "[object Array]", rQ = "[object Boolean]", nQ = "[object Date]", aQ = "[object Error]", iQ = "[object Function]", oQ = "[object Map]", sQ = "[object Number]", lQ = "[object Object]", cQ = "[object RegExp]", uQ = "[object Set]", fQ = "[object String]", dQ = "[object WeakMap]", hQ = "[object ArrayBuffer]", AQ = "[object DataView]", pQ = "[object Float32Array]", vQ = "[object Float64Array]", gQ = "[object Int8Array]", mQ = "[object Int16Array]", CQ = "[object Int32Array]", bQ = "[object Uint8Array]", yQ = "[object Uint8ClampedArray]", wQ = "[object Uint16Array]", xQ = "[object Uint32Array]", At = {};
At[pQ] = At[vQ] = At[gQ] = At[mQ] = At[CQ] = At[bQ] = At[yQ] = At[wQ] = At[xQ] = !0;
At[eQ] = At[tQ] = At[hQ] = At[rQ] = At[AQ] = At[nQ] = At[aQ] = At[iQ] = At[oQ] = At[sQ] = At[lQ] = At[cQ] = At[uQ] = At[fQ] = At[dQ] = !1;
function OQ(e) {
  return JW(e) && XW(e.length) && !!At[qW(e)];
}
var DQ = OQ;
function MQ(e) {
  return function(t) {
    return e(t);
  };
}
var Sy = MQ, ps = { exports: {} };
ps.exports;
(function(e, t) {
  var r = Fb, n = t && !t.nodeType && t, a = n && !0 && e && !e.nodeType && e, i = a && a.exports === n, o = i && r.process, s = function() {
    try {
      var c = a && a.require && a.require("util").types;
      return c || o && o.binding && o.binding("util");
    } catch {
    }
  }();
  e.exports = s;
})(ps, ps.exports);
var EQ = ps.exports, PQ = DQ, jQ = Sy, Yh = EQ, Vh = Yh && Yh.isTypedArray, SQ = Vh ? jQ(Vh) : PQ, Iy = SQ, IQ = _W, BQ = y9, NQ = or, _Q = jy, LQ = w9, TQ = Iy, RQ = Object.prototype, $Q = RQ.hasOwnProperty;
function FQ(e, t) {
  var r = NQ(e), n = !r && BQ(e), a = !r && !n && _Q(e), i = !r && !n && !a && TQ(e), o = r || n || a || i, s = o ? IQ(e.length, String) : [], c = s.length;
  for (var u in e)
    (t || $Q.call(e, u)) && !(o && // Safari 9 has enumerable `arguments.length` in strict mode.
    (u == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    a && (u == "offset" || u == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    i && (u == "buffer" || u == "byteLength" || u == "byteOffset") || // Skip index properties.
    LQ(u, c))) && s.push(u);
  return s;
}
var HQ = FQ, YQ = Object.prototype;
function VQ(e) {
  var t = e && e.constructor, r = typeof t == "function" && t.prototype || YQ;
  return e === r;
}
var kQ = VQ;
function GQ(e, t) {
  return function(r) {
    return e(t(r));
  };
}
var By = GQ, WQ = By, QQ = WQ(Object.keys, Object), UQ = QQ, ZQ = kQ, zQ = UQ, KQ = Object.prototype, qQ = KQ.hasOwnProperty;
function XQ(e) {
  if (!ZQ(e))
    return zQ(e);
  var t = [];
  for (var r in Object(e))
    qQ.call(e, r) && r != "constructor" && t.push(r);
  return t;
}
var JQ = XQ, eU = s9, tU = x9;
function rU(e) {
  return e != null && tU(e.length) && !eU(e);
}
var zo = rU, nU = HQ, aU = JQ, iU = zo;
function oU(e) {
  return iU(e) ? nU(e) : aU(e);
}
var B0 = oU, sU = wW, lU = BW, cU = B0;
function uU(e) {
  return sU(e, cU, lU);
}
var fU = uU, kh = fU, dU = 1, hU = Object.prototype, AU = hU.hasOwnProperty;
function pU(e, t, r, n, a, i) {
  var o = r & dU, s = kh(e), c = s.length, u = kh(t), d = u.length;
  if (c != d && !o)
    return !1;
  for (var h = c; h--; ) {
    var A = s[h];
    if (!(o ? A in t : AU.call(t, A)))
      return !1;
  }
  var p = i.get(e), m = i.get(t);
  if (p && m)
    return p == t && m == e;
  var g = !0;
  i.set(e, t), i.set(t, e);
  for (var v = o; ++h < c; ) {
    A = s[h];
    var C = e[A], y = t[A];
    if (n)
      var w = o ? n(y, C, A, t, e, i) : n(C, y, A, e, t, i);
    if (!(w === void 0 ? C === y || a(C, y, r, n, i) : w)) {
      g = !1;
      break;
    }
    v || (v = A == "constructor");
  }
  if (g && !v) {
    var O = e.constructor, b = t.constructor;
    O != b && "constructor" in e && "constructor" in t && !(typeof O == "function" && O instanceof O && typeof b == "function" && b instanceof b) && (g = !1);
  }
  return i.delete(e), i.delete(t), g;
}
var vU = pU, gU = ia, mU = fn, CU = gU(mU, "DataView"), bU = CU, yU = ia, wU = fn, xU = yU(wU, "Promise"), OU = xU, DU = ia, MU = fn, EU = DU(MU, "Set"), Ny = EU, PU = ia, jU = fn, SU = PU(jU, "WeakMap"), IU = SU, l5 = bU, c5 = c9, u5 = OU, f5 = Ny, d5 = IU, _y = Bn, T2 = Yb, Gh = "[object Map]", BU = "[object Object]", Wh = "[object Promise]", Qh = "[object Set]", Uh = "[object WeakMap]", Zh = "[object DataView]", NU = T2(l5), _U = T2(c5), LU = T2(u5), TU = T2(f5), RU = T2(d5), F1 = _y;
(l5 && F1(new l5(new ArrayBuffer(1))) != Zh || c5 && F1(new c5()) != Gh || u5 && F1(u5.resolve()) != Wh || f5 && F1(new f5()) != Qh || d5 && F1(new d5()) != Uh) && (F1 = function(e) {
  var t = _y(e), r = t == BU ? e.constructor : void 0, n = r ? T2(r) : "";
  if (n)
    switch (n) {
      case NU:
        return Zh;
      case _U:
        return Gh;
      case LU:
        return Wh;
      case TU:
        return Qh;
      case RU:
        return Uh;
    }
  return t;
});
var $U = F1, Q6 = wy, FU = My, HU = gW, YU = vU, zh = $U, Kh = or, qh = jy, VU = Iy, kU = 1, Xh = "[object Arguments]", Jh = "[object Array]", O3 = "[object Object]", GU = Object.prototype, eA = GU.hasOwnProperty;
function WU(e, t, r, n, a, i) {
  var o = Kh(e), s = Kh(t), c = o ? Jh : zh(e), u = s ? Jh : zh(t);
  c = c == Xh ? O3 : c, u = u == Xh ? O3 : u;
  var d = c == O3, h = u == O3, A = c == u;
  if (A && qh(e)) {
    if (!qh(t))
      return !1;
    o = !0, d = !1;
  }
  if (A && !d)
    return i || (i = new Q6()), o || VU(e) ? FU(e, t, r, n, a, i) : HU(e, t, c, r, n, a, i);
  if (!(r & kU)) {
    var p = d && eA.call(e, "__wrapped__"), m = h && eA.call(t, "__wrapped__");
    if (p || m) {
      var g = p ? e.value() : e, v = m ? t.value() : t;
      return i || (i = new Q6()), a(g, v, r, n, i);
    }
  }
  return A ? (i || (i = new Q6()), YU(e, t, r, n, a, i)) : !1;
}
var QU = WU, UU = QU, tA = Nn;
function Ly(e, t, r, n, a) {
  return e === t ? !0 : e == null || t == null || !tA(e) && !tA(t) ? e !== e && t !== t : UU(e, t, r, n, Ly, a);
}
var O9 = Ly, ZU = wy, zU = O9, KU = 1, qU = 2;
function XU(e, t, r, n) {
  var a = r.length, i = a, o = !n;
  if (e == null)
    return !i;
  for (e = Object(e); a--; ) {
    var s = r[a];
    if (o && s[2] ? s[1] !== e[s[0]] : !(s[0] in e))
      return !1;
  }
  for (; ++a < i; ) {
    s = r[a];
    var c = s[0], u = e[c], d = s[1];
    if (o && s[2]) {
      if (u === void 0 && !(c in e))
        return !1;
    } else {
      var h = new ZU();
      if (n)
        var A = n(u, d, c, e, t, h);
      if (!(A === void 0 ? zU(d, u, KU | qU, n, h) : A))
        return !1;
    }
  }
  return !0;
}
var JU = XU, eZ = v1;
function tZ(e) {
  return e === e && !eZ(e);
}
var Ty = tZ, rZ = Ty, nZ = B0;
function aZ(e) {
  for (var t = nZ(e), r = t.length; r--; ) {
    var n = t[r], a = e[n];
    t[r] = [n, a, rZ(a)];
  }
  return t;
}
var iZ = aZ;
function oZ(e, t) {
  return function(r) {
    return r == null ? !1 : r[e] === t && (t !== void 0 || e in Object(r));
  };
}
var Ry = oZ, sZ = JU, lZ = iZ, cZ = Ry;
function uZ(e) {
  var t = lZ(e);
  return t.length == 1 && t[0][2] ? cZ(t[0][0], t[0][1]) : function(r) {
    return r === e || sZ(r, e, t);
  };
}
var fZ = uZ;
function dZ(e, t) {
  return e != null && t in Object(e);
}
var hZ = dZ, AZ = Qb, pZ = y9, vZ = or, gZ = w9, mZ = x9, CZ = M0;
function bZ(e, t, r) {
  t = AZ(t, e);
  for (var n = -1, a = t.length, i = !1; ++n < a; ) {
    var o = CZ(t[n]);
    if (!(i = e != null && r(e, o)))
      break;
    e = e[o];
  }
  return i || ++n != a ? i : (a = e == null ? 0 : e.length, !!a && mZ(a) && gZ(o, a) && (vZ(e) || pZ(e)));
}
var yZ = bZ, wZ = hZ, xZ = yZ;
function OZ(e, t) {
  return e != null && xZ(e, t, wZ);
}
var DZ = OZ, MZ = O9, EZ = Ub, PZ = DZ, jZ = o9, SZ = Ty, IZ = Ry, BZ = M0, NZ = 1, _Z = 2;
function LZ(e, t) {
  return jZ(e) && SZ(t) ? IZ(BZ(e), t) : function(r) {
    var n = EZ(r, e);
    return n === void 0 && n === t ? PZ(r, e) : MZ(t, n, NZ | _Z);
  };
}
var TZ = LZ;
function RZ(e) {
  return e;
}
var R2 = RZ;
function $Z(e) {
  return function(t) {
    return t == null ? void 0 : t[e];
  };
}
var FZ = $Z, HZ = h9;
function YZ(e) {
  return function(t) {
    return HZ(t, e);
  };
}
var VZ = YZ, kZ = FZ, GZ = VZ, WZ = o9, QZ = M0;
function UZ(e) {
  return WZ(e) ? kZ(QZ(e)) : GZ(e);
}
var ZZ = UZ, zZ = fZ, KZ = TZ, qZ = R2, XZ = or, JZ = ZZ;
function ez(e) {
  return typeof e == "function" ? e : e == null ? qZ : typeof e == "object" ? XZ(e) ? KZ(e[0], e[1]) : zZ(e) : JZ(e);
}
var dn = ez;
function tz(e, t, r, n) {
  for (var a = e.length, i = r + (n ? 1 : -1); n ? i-- : ++i < a; )
    if (t(e[i], i, e))
      return i;
  return -1;
}
var $y = tz;
function rz(e) {
  return e !== e;
}
var nz = rz;
function az(e, t, r) {
  for (var n = r - 1, a = e.length; ++n < a; )
    if (e[n] === t)
      return n;
  return -1;
}
var iz = az, oz = $y, sz = nz, lz = iz;
function cz(e, t, r) {
  return t === t ? lz(e, t, r) : oz(e, sz, r);
}
var uz = cz, fz = uz;
function dz(e, t) {
  var r = e == null ? 0 : e.length;
  return !!r && fz(e, t, 0) > -1;
}
var hz = dz;
function Az(e, t, r) {
  for (var n = -1, a = e == null ? 0 : e.length; ++n < a; )
    if (r(t, e[n]))
      return !0;
  return !1;
}
var pz = Az;
function vz() {
}
var gz = vz, U6 = Ny, mz = gz, Cz = b9, bz = 1 / 0, yz = U6 && 1 / Cz(new U6([, -0]))[1] == bz ? function(e) {
  return new U6(e);
} : mz, wz = yz, xz = xy, Oz = hz, Dz = pz, Mz = Dy, Ez = wz, Pz = b9, jz = 200;
function Sz(e, t, r) {
  var n = -1, a = Oz, i = e.length, o = !0, s = [], c = s;
  if (r)
    o = !1, a = Dz;
  else if (i >= jz) {
    var u = t ? null : Ez(e);
    if (u)
      return Pz(u);
    o = !1, a = Mz, c = new xz();
  } else
    c = t ? [] : s;
  e:
    for (; ++n < i; ) {
      var d = e[n], h = t ? t(d) : d;
      if (d = r || d !== 0 ? d : 0, o && h === h) {
        for (var A = c.length; A--; )
          if (c[A] === h)
            continue e;
        t && c.push(h), s.push(d);
      } else
        a(c, h, r) || (c !== s && c.push(h), s.push(d));
    }
  return s;
}
var Iz = Sz, Bz = dn, Nz = Iz;
function _z(e, t) {
  return e && e.length ? Nz(e, Bz(t)) : [];
}
var Lz = _z;
const rA = /* @__PURE__ */ qe(Lz);
function Fy(e, t, r) {
  return t === !0 ? rA(e, r) : ye(t) ? rA(e, t) : e;
}
function Xa(e) {
  "@babel/helpers - typeof";
  return Xa = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Xa(e);
}
var Tz = ["ref"];
function nA(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function vn(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? nA(Object(r), !0).forEach(function(n) {
      N0(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : nA(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function Rz(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function aA(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Yy(n.key), n);
  }
}
function $z(e, t, r) {
  return t && aA(e.prototype, t), r && aA(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function Fz(e, t, r) {
  return t = vs(t), Hz(e, Hy() ? Reflect.construct(t, r || [], vs(e).constructor) : t.apply(e, r));
}
function Hz(e, t) {
  if (t && (Xa(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return Yz(e);
}
function Yz(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function Hy() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (Hy = function() {
    return !!e;
  })();
}
function vs(e) {
  return vs = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, vs(e);
}
function Vz(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && h5(e, t);
}
function h5(e, t) {
  return h5 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, a) {
    return n.__proto__ = a, n;
  }, h5(e, t);
}
function N0(e, t, r) {
  return t = Yy(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function Yy(e) {
  var t = kz(e, "string");
  return Xa(t) == "symbol" ? t : t + "";
}
function kz(e, t) {
  if (Xa(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (Xa(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function Gz(e, t) {
  if (e == null)
    return {};
  var r = Wz(e, t), n, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (a = 0; a < i.length; a++)
      n = i[a], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function Wz(e, t) {
  if (e == null)
    return {};
  var r = {};
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      if (t.indexOf(n) >= 0)
        continue;
      r[n] = e[n];
    }
  return r;
}
function Qz(e) {
  return e.value;
}
function Uz(e, t) {
  if (/* @__PURE__ */ B.isValidElement(e))
    return /* @__PURE__ */ B.cloneElement(e, t);
  if (typeof e == "function")
    return /* @__PURE__ */ B.createElement(e, t);
  t.ref;
  var r = Gz(t, Tz);
  return /* @__PURE__ */ B.createElement(C9, r);
}
var iA = 1, Dn = /* @__PURE__ */ function(e) {
  function t() {
    var r;
    Rz(this, t);
    for (var n = arguments.length, a = new Array(n), i = 0; i < n; i++)
      a[i] = arguments[i];
    return r = Fz(this, t, [].concat(a)), N0(r, "lastBoundingBox", {
      width: -1,
      height: -1
    }), r;
  }
  return Vz(t, e), $z(t, [{
    key: "componentDidMount",
    value: function() {
      this.updateBBox();
    }
  }, {
    key: "componentDidUpdate",
    value: function() {
      this.updateBBox();
    }
  }, {
    key: "getBBox",
    value: function() {
      if (this.wrapperNode && this.wrapperNode.getBoundingClientRect) {
        var n = this.wrapperNode.getBoundingClientRect();
        return n.height = this.wrapperNode.offsetHeight, n.width = this.wrapperNode.offsetWidth, n;
      }
      return null;
    }
  }, {
    key: "updateBBox",
    value: function() {
      var n = this.props.onBBoxUpdate, a = this.getBBox();
      a ? (Math.abs(a.width - this.lastBoundingBox.width) > iA || Math.abs(a.height - this.lastBoundingBox.height) > iA) && (this.lastBoundingBox.width = a.width, this.lastBoundingBox.height = a.height, n && n(a)) : (this.lastBoundingBox.width !== -1 || this.lastBoundingBox.height !== -1) && (this.lastBoundingBox.width = -1, this.lastBoundingBox.height = -1, n && n(null));
    }
  }, {
    key: "getBBoxSnapshot",
    value: function() {
      return this.lastBoundingBox.width >= 0 && this.lastBoundingBox.height >= 0 ? vn({}, this.lastBoundingBox) : {
        width: 0,
        height: 0
      };
    }
  }, {
    key: "getDefaultPosition",
    value: function(n) {
      var a = this.props, i = a.layout, o = a.align, s = a.verticalAlign, c = a.margin, u = a.chartWidth, d = a.chartHeight, h, A;
      if (!n || (n.left === void 0 || n.left === null) && (n.right === void 0 || n.right === null))
        if (o === "center" && i === "vertical") {
          var p = this.getBBoxSnapshot();
          h = {
            left: ((u || 0) - p.width) / 2
          };
        } else
          h = o === "right" ? {
            right: c && c.right || 0
          } : {
            left: c && c.left || 0
          };
      if (!n || (n.top === void 0 || n.top === null) && (n.bottom === void 0 || n.bottom === null))
        if (s === "middle") {
          var m = this.getBBoxSnapshot();
          A = {
            top: ((d || 0) - m.height) / 2
          };
        } else
          A = s === "bottom" ? {
            bottom: c && c.bottom || 0
          } : {
            top: c && c.top || 0
          };
      return vn(vn({}, h), A);
    }
  }, {
    key: "render",
    value: function() {
      var n = this, a = this.props, i = a.content, o = a.width, s = a.height, c = a.wrapperStyle, u = a.payloadUniqBy, d = a.payload, h = vn(vn({
        position: "absolute",
        width: o || "auto",
        height: s || "auto"
      }, this.getDefaultPosition(c)), c);
      return /* @__PURE__ */ B.createElement("div", {
        className: "recharts-legend-wrapper",
        style: h,
        ref: function(p) {
          n.wrapperNode = p;
        }
      }, Uz(i, vn(vn({}, this.props), {}, {
        payload: Fy(d, u, Qz)
      })));
    }
  }], [{
    key: "getWithHeight",
    value: function(n, a) {
      var i = vn(vn({}, this.defaultProps), n.props), o = i.layout;
      return o === "vertical" && se(n.props.height) ? {
        height: n.props.height
      } : o === "horizontal" ? {
        width: n.props.width || a
      } : null;
    }
  }]);
}(Cr);
N0(Dn, "displayName", "Legend");
N0(Dn, "defaultProps", {
  iconSize: 14,
  layout: "horizontal",
  align: "center",
  verticalAlign: "bottom"
});
var oA = Zo, Zz = y9, zz = or, sA = oA ? oA.isConcatSpreadable : void 0;
function Kz(e) {
  return zz(e) || Zz(e) || !!(sA && e && e[sA]);
}
var qz = Kz, Xz = Ey, Jz = qz;
function Vy(e, t, r, n, a) {
  var i = -1, o = e.length;
  for (r || (r = Jz), a || (a = []); ++i < o; ) {
    var s = e[i];
    t > 0 && r(s) ? t > 1 ? Vy(s, t - 1, r, n, a) : Xz(a, s) : n || (a[a.length] = s);
  }
  return a;
}
var ky = Vy;
function eK(e) {
  return function(t, r, n) {
    for (var a = -1, i = Object(t), o = n(t), s = o.length; s--; ) {
      var c = o[e ? s : ++a];
      if (r(i[c], c, i) === !1)
        break;
    }
    return t;
  };
}
var tK = eK, rK = tK, nK = rK(), aK = nK, iK = aK, oK = B0;
function sK(e, t) {
  return e && iK(e, t, oK);
}
var Gy = sK, lK = zo;
function cK(e, t) {
  return function(r, n) {
    if (r == null)
      return r;
    if (!lK(r))
      return e(r, n);
    for (var a = r.length, i = t ? a : -1, o = Object(r); (t ? i-- : ++i < a) && n(o[i], i, o) !== !1; )
      ;
    return r;
  };
}
var uK = cK, fK = Gy, dK = uK, hK = dK(fK), D9 = hK, AK = D9, pK = zo;
function vK(e, t) {
  var r = -1, n = pK(e) ? Array(e.length) : [];
  return AK(e, function(a, i, o) {
    n[++r] = t(a, i, o);
  }), n;
}
var Wy = vK;
function gK(e, t) {
  var r = e.length;
  for (e.sort(t); r--; )
    e[r] = e[r].value;
  return e;
}
var mK = gK, lA = j2;
function CK(e, t) {
  if (e !== t) {
    var r = e !== void 0, n = e === null, a = e === e, i = lA(e), o = t !== void 0, s = t === null, c = t === t, u = lA(t);
    if (!s && !u && !i && e > t || i && o && c && !s && !u || n && o && c || !r && c || !a)
      return 1;
    if (!n && !i && !u && e < t || u && r && a && !n && !i || s && r && a || !o && a || !c)
      return -1;
  }
  return 0;
}
var bK = CK, yK = bK;
function wK(e, t, r) {
  for (var n = -1, a = e.criteria, i = t.criteria, o = a.length, s = r.length; ++n < o; ) {
    var c = yK(a[n], i[n]);
    if (c) {
      if (n >= s)
        return c;
      var u = r[n];
      return c * (u == "desc" ? -1 : 1);
    }
  }
  return e.index - t.index;
}
var xK = wK, Z6 = d9, OK = h9, DK = dn, MK = Wy, EK = mK, PK = Sy, jK = xK, SK = R2, IK = or;
function BK(e, t, r) {
  t.length ? t = Z6(t, function(i) {
    return IK(i) ? function(o) {
      return OK(o, i.length === 1 ? i[0] : i);
    } : i;
  }) : t = [SK];
  var n = -1;
  t = Z6(t, PK(DK));
  var a = MK(e, function(i, o, s) {
    var c = Z6(t, function(u) {
      return u(i);
    });
    return { criteria: c, index: ++n, value: i };
  });
  return EK(a, function(i, o) {
    return jK(i, o, r);
  });
}
var NK = BK;
function _K(e, t, r) {
  switch (r.length) {
    case 0:
      return e.call(t);
    case 1:
      return e.call(t, r[0]);
    case 2:
      return e.call(t, r[0], r[1]);
    case 3:
      return e.call(t, r[0], r[1], r[2]);
  }
  return e.apply(t, r);
}
var LK = _K, TK = LK, cA = Math.max;
function RK(e, t, r) {
  return t = cA(t === void 0 ? e.length - 1 : t, 0), function() {
    for (var n = arguments, a = -1, i = cA(n.length - t, 0), o = Array(i); ++a < i; )
      o[a] = n[t + a];
    a = -1;
    for (var s = Array(t + 1); ++a < t; )
      s[a] = n[a];
    return s[t] = r(o), TK(e, this, s);
  };
}
var $K = RK;
function FK(e) {
  return function() {
    return e;
  };
}
var HK = FK, YK = ia, VK = function() {
  try {
    var e = YK(Object, "defineProperty");
    return e({}, "", {}), e;
  } catch {
  }
}(), Qy = VK, kK = HK, uA = Qy, GK = R2, WK = uA ? function(e, t) {
  return uA(e, "toString", {
    configurable: !0,
    enumerable: !1,
    value: kK(t),
    writable: !0
  });
} : GK, QK = WK, UK = 800, ZK = 16, zK = Date.now;
function KK(e) {
  var t = 0, r = 0;
  return function() {
    var n = zK(), a = ZK - (n - r);
    if (r = n, a > 0) {
      if (++t >= UK)
        return arguments[0];
    } else
      t = 0;
    return e.apply(void 0, arguments);
  };
}
var qK = KK, XK = QK, JK = qK, eq = JK(XK), tq = eq, rq = R2, nq = $K, aq = tq;
function iq(e, t) {
  return aq(nq(e, t, rq), e + "");
}
var oq = iq, sq = l9, lq = zo, cq = w9, uq = v1;
function fq(e, t, r) {
  if (!uq(r))
    return !1;
  var n = typeof t;
  return (n == "number" ? lq(r) && cq(t, r.length) : n == "string" && t in r) ? sq(r[t], e) : !1;
}
var _0 = fq, dq = ky, hq = NK, Aq = oq, fA = _0, pq = Aq(function(e, t) {
  if (e == null)
    return [];
  var r = t.length;
  return r > 1 && fA(e, t[0], t[1]) ? t = [] : r > 2 && fA(t[0], t[1], t[2]) && (t = [t[0]]), hq(e, dq(t, 1), []);
}), vq = pq;
const M9 = /* @__PURE__ */ qe(vq);
function lo(e) {
  "@babel/helpers - typeof";
  return lo = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, lo(e);
}
function A5() {
  return A5 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, A5.apply(this, arguments);
}
function gq(e, t) {
  return yq(e) || bq(e, t) || Cq(e, t) || mq();
}
function mq() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Cq(e, t) {
  if (e) {
    if (typeof e == "string")
      return dA(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return dA(e, t);
  }
}
function dA(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
function bq(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, a, i, o, s = [], c = !0, u = !1;
    try {
      if (i = (r = r.call(e)).next, t === 0) {
        if (Object(r) !== r)
          return;
        c = !1;
      } else
        for (; !(c = (n = i.call(r)).done) && (s.push(n.value), s.length !== t); c = !0)
          ;
    } catch (d) {
      u = !0, a = d;
    } finally {
      try {
        if (!c && r.return != null && (o = r.return(), Object(o) !== o))
          return;
      } finally {
        if (u)
          throw a;
      }
    }
    return s;
  }
}
function yq(e) {
  if (Array.isArray(e))
    return e;
}
function hA(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function z6(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? hA(Object(r), !0).forEach(function(n) {
      wq(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : hA(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function wq(e, t, r) {
  return t = xq(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function xq(e) {
  var t = Oq(e, "string");
  return lo(t) == "symbol" ? t : t + "";
}
function Oq(e, t) {
  if (lo(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (lo(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function Dq(e) {
  return Array.isArray(e) && Nt(e[0]) && Nt(e[1]) ? e.join(" ~ ") : e;
}
var Mq = function(t) {
  var r = t.separator, n = r === void 0 ? " : " : r, a = t.contentStyle, i = a === void 0 ? {} : a, o = t.itemStyle, s = o === void 0 ? {} : o, c = t.labelStyle, u = c === void 0 ? {} : c, d = t.payload, h = t.formatter, A = t.itemSorter, p = t.wrapperClassName, m = t.labelClassName, g = t.label, v = t.labelFormatter, C = t.accessibilityLayer, y = C === void 0 ? !1 : C, w = function() {
    if (d && d.length) {
      var R = {
        padding: 0,
        margin: 0
      }, N = (A ? M9(d, A) : d).map(function(z, q) {
        if (z.type === "none")
          return null;
        var J = z6({
          display: "block",
          paddingTop: 4,
          paddingBottom: 4,
          color: z.color || "#000"
        }, s), W = z.formatter || h || Dq, te = z.value, S = z.name, I = te, T = S;
        if (W && I != null && T != null) {
          var E = W(te, S, z, q, d);
          if (Array.isArray(E)) {
            var x = gq(E, 2);
            I = x[0], T = x[1];
          } else
            I = E;
        }
        return (
          // eslint-disable-next-line react/no-array-index-key
          /* @__PURE__ */ B.createElement("li", {
            className: "recharts-tooltip-item",
            key: "tooltip-item-".concat(q),
            style: J
          }, Nt(T) ? /* @__PURE__ */ B.createElement("span", {
            className: "recharts-tooltip-item-name"
          }, T) : null, Nt(T) ? /* @__PURE__ */ B.createElement("span", {
            className: "recharts-tooltip-item-separator"
          }, n) : null, /* @__PURE__ */ B.createElement("span", {
            className: "recharts-tooltip-item-value"
          }, I), /* @__PURE__ */ B.createElement("span", {
            className: "recharts-tooltip-item-unit"
          }, z.unit || ""))
        );
      });
      return /* @__PURE__ */ B.createElement("ul", {
        className: "recharts-tooltip-item-list",
        style: R
      }, N);
    }
    return null;
  }, O = z6({
    margin: 0,
    padding: 10,
    backgroundColor: "#fff",
    border: "1px solid #ccc",
    whiteSpace: "nowrap"
  }, i), b = z6({
    margin: 0
  }, u), D = !be(g), M = D ? g : "", j = Pe("recharts-default-tooltip", p), P = Pe("recharts-tooltip-label", m);
  D && v && d !== void 0 && d !== null && (M = v(g, d));
  var H = y ? {
    role: "status",
    "aria-live": "assertive"
  } : {};
  return /* @__PURE__ */ B.createElement("div", A5({
    className: j,
    style: O
  }, H), /* @__PURE__ */ B.createElement("p", {
    className: P,
    style: b
  }, /* @__PURE__ */ B.isValidElement(M) ? M : "".concat(M)), w());
};
function co(e) {
  "@babel/helpers - typeof";
  return co = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, co(e);
}
function D3(e, t, r) {
  return t = Eq(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function Eq(e) {
  var t = Pq(e, "string");
  return co(t) == "symbol" ? t : t + "";
}
function Pq(e, t) {
  if (co(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (co(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var vi = "recharts-tooltip-wrapper", jq = {
  visibility: "hidden"
};
function Sq(e) {
  var t = e.coordinate, r = e.translateX, n = e.translateY;
  return Pe(vi, D3(D3(D3(D3({}, "".concat(vi, "-right"), se(r) && t && se(t.x) && r >= t.x), "".concat(vi, "-left"), se(r) && t && se(t.x) && r < t.x), "".concat(vi, "-bottom"), se(n) && t && se(t.y) && n >= t.y), "".concat(vi, "-top"), se(n) && t && se(t.y) && n < t.y));
}
function AA(e) {
  var t = e.allowEscapeViewBox, r = e.coordinate, n = e.key, a = e.offsetTopLeft, i = e.position, o = e.reverseDirection, s = e.tooltipDimension, c = e.viewBox, u = e.viewBoxDimension;
  if (i && se(i[n]))
    return i[n];
  var d = r[n] - s - a, h = r[n] + a;
  if (t[n])
    return o[n] ? d : h;
  if (o[n]) {
    var A = d, p = c[n];
    return A < p ? Math.max(h, c[n]) : Math.max(d, c[n]);
  }
  var m = h + s, g = c[n] + u;
  return m > g ? Math.max(d, c[n]) : Math.max(h, c[n]);
}
function Iq(e) {
  var t = e.translateX, r = e.translateY, n = e.useTranslate3d;
  return {
    transform: n ? "translate3d(".concat(t, "px, ").concat(r, "px, 0)") : "translate(".concat(t, "px, ").concat(r, "px)")
  };
}
function Bq(e) {
  var t = e.allowEscapeViewBox, r = e.coordinate, n = e.offsetTopLeft, a = e.position, i = e.reverseDirection, o = e.tooltipBox, s = e.useTranslate3d, c = e.viewBox, u, d, h;
  return o.height > 0 && o.width > 0 && r ? (d = AA({
    allowEscapeViewBox: t,
    coordinate: r,
    key: "x",
    offsetTopLeft: n,
    position: a,
    reverseDirection: i,
    tooltipDimension: o.width,
    viewBox: c,
    viewBoxDimension: c.width
  }), h = AA({
    allowEscapeViewBox: t,
    coordinate: r,
    key: "y",
    offsetTopLeft: n,
    position: a,
    reverseDirection: i,
    tooltipDimension: o.height,
    viewBox: c,
    viewBoxDimension: c.height
  }), u = Iq({
    translateX: d,
    translateY: h,
    useTranslate3d: s
  })) : u = jq, {
    cssProperties: u,
    cssClasses: Sq({
      translateX: d,
      translateY: h,
      coordinate: r
    })
  };
}
function Ja(e) {
  "@babel/helpers - typeof";
  return Ja = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Ja(e);
}
function pA(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function vA(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? pA(Object(r), !0).forEach(function(n) {
      v5(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : pA(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function Nq(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function gA(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Zy(n.key), n);
  }
}
function _q(e, t, r) {
  return t && gA(e.prototype, t), r && gA(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function Lq(e, t, r) {
  return t = gs(t), Tq(e, Uy() ? Reflect.construct(t, r || [], gs(e).constructor) : t.apply(e, r));
}
function Tq(e, t) {
  if (t && (Ja(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return Rq(e);
}
function Rq(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function Uy() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (Uy = function() {
    return !!e;
  })();
}
function gs(e) {
  return gs = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, gs(e);
}
function $q(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && p5(e, t);
}
function p5(e, t) {
  return p5 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, a) {
    return n.__proto__ = a, n;
  }, p5(e, t);
}
function v5(e, t, r) {
  return t = Zy(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function Zy(e) {
  var t = Fq(e, "string");
  return Ja(t) == "symbol" ? t : t + "";
}
function Fq(e, t) {
  if (Ja(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (Ja(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var mA = 1, Hq = /* @__PURE__ */ function(e) {
  function t() {
    var r;
    Nq(this, t);
    for (var n = arguments.length, a = new Array(n), i = 0; i < n; i++)
      a[i] = arguments[i];
    return r = Lq(this, t, [].concat(a)), v5(r, "state", {
      dismissed: !1,
      dismissedAtCoordinate: {
        x: 0,
        y: 0
      },
      lastBoundingBox: {
        width: -1,
        height: -1
      }
    }), v5(r, "handleKeyDown", function(o) {
      if (o.key === "Escape") {
        var s, c, u, d;
        r.setState({
          dismissed: !0,
          dismissedAtCoordinate: {
            x: (s = (c = r.props.coordinate) === null || c === void 0 ? void 0 : c.x) !== null && s !== void 0 ? s : 0,
            y: (u = (d = r.props.coordinate) === null || d === void 0 ? void 0 : d.y) !== null && u !== void 0 ? u : 0
          }
        });
      }
    }), r;
  }
  return $q(t, e), _q(t, [{
    key: "updateBBox",
    value: function() {
      if (this.wrapperNode && this.wrapperNode.getBoundingClientRect) {
        var n = this.wrapperNode.getBoundingClientRect();
        (Math.abs(n.width - this.state.lastBoundingBox.width) > mA || Math.abs(n.height - this.state.lastBoundingBox.height) > mA) && this.setState({
          lastBoundingBox: {
            width: n.width,
            height: n.height
          }
        });
      } else
        (this.state.lastBoundingBox.width !== -1 || this.state.lastBoundingBox.height !== -1) && this.setState({
          lastBoundingBox: {
            width: -1,
            height: -1
          }
        });
    }
  }, {
    key: "componentDidMount",
    value: function() {
      document.addEventListener("keydown", this.handleKeyDown), this.updateBBox();
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      document.removeEventListener("keydown", this.handleKeyDown);
    }
  }, {
    key: "componentDidUpdate",
    value: function() {
      var n, a;
      this.props.active && this.updateBBox(), this.state.dismissed && (((n = this.props.coordinate) === null || n === void 0 ? void 0 : n.x) !== this.state.dismissedAtCoordinate.x || ((a = this.props.coordinate) === null || a === void 0 ? void 0 : a.y) !== this.state.dismissedAtCoordinate.y) && (this.state.dismissed = !1);
    }
  }, {
    key: "render",
    value: function() {
      var n = this, a = this.props, i = a.active, o = a.allowEscapeViewBox, s = a.animationDuration, c = a.animationEasing, u = a.children, d = a.coordinate, h = a.hasPayload, A = a.isAnimationActive, p = a.offset, m = a.position, g = a.reverseDirection, v = a.useTranslate3d, C = a.viewBox, y = a.wrapperStyle, w = Bq({
        allowEscapeViewBox: o,
        coordinate: d,
        offsetTopLeft: p,
        position: m,
        reverseDirection: g,
        tooltipBox: this.state.lastBoundingBox,
        useTranslate3d: v,
        viewBox: C
      }), O = w.cssClasses, b = w.cssProperties, D = vA(vA({
        transition: A && i ? "transform ".concat(s, "ms ").concat(c) : void 0
      }, b), {}, {
        pointerEvents: "none",
        visibility: !this.state.dismissed && i && h ? "visible" : "hidden",
        position: "absolute",
        top: 0,
        left: 0
      }, y);
      return (
        // This element allow listening to the `Escape` key.
        // See https://github.com/recharts/recharts/pull/2925
        /* @__PURE__ */ B.createElement("div", {
          tabIndex: -1,
          className: O,
          style: D,
          ref: function(j) {
            n.wrapperNode = j;
          }
        }, u)
      );
    }
  }]);
}(Cr), Yq = function() {
  return !(typeof window < "u" && window.document && window.document.createElement && window.setTimeout);
}, Br = {
  isSsr: Yq(),
  get: function(t) {
    return Br[t];
  },
  set: function(t, r) {
    if (typeof t == "string")
      Br[t] = r;
    else {
      var n = Object.keys(t);
      n && n.length && n.forEach(function(a) {
        Br[a] = t[a];
      });
    }
  }
};
function e2(e) {
  "@babel/helpers - typeof";
  return e2 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, e2(e);
}
function CA(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function bA(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? CA(Object(r), !0).forEach(function(n) {
      E9(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : CA(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function Vq(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function yA(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Ky(n.key), n);
  }
}
function kq(e, t, r) {
  return t && yA(e.prototype, t), r && yA(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function Gq(e, t, r) {
  return t = ms(t), Wq(e, zy() ? Reflect.construct(t, r || [], ms(e).constructor) : t.apply(e, r));
}
function Wq(e, t) {
  if (t && (e2(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return Qq(e);
}
function Qq(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function zy() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (zy = function() {
    return !!e;
  })();
}
function ms(e) {
  return ms = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, ms(e);
}
function Uq(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && g5(e, t);
}
function g5(e, t) {
  return g5 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, a) {
    return n.__proto__ = a, n;
  }, g5(e, t);
}
function E9(e, t, r) {
  return t = Ky(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function Ky(e) {
  var t = Zq(e, "string");
  return e2(t) == "symbol" ? t : t + "";
}
function Zq(e, t) {
  if (e2(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (e2(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function zq(e) {
  return e.dataKey;
}
function Kq(e, t) {
  return /* @__PURE__ */ B.isValidElement(e) ? /* @__PURE__ */ B.cloneElement(e, t) : typeof e == "function" ? /* @__PURE__ */ B.createElement(e, t) : /* @__PURE__ */ B.createElement(Mq, t);
}
var Xt = /* @__PURE__ */ function(e) {
  function t() {
    return Vq(this, t), Gq(this, t, arguments);
  }
  return Uq(t, e), kq(t, [{
    key: "render",
    value: function() {
      var n = this, a = this.props, i = a.active, o = a.allowEscapeViewBox, s = a.animationDuration, c = a.animationEasing, u = a.content, d = a.coordinate, h = a.filterNull, A = a.isAnimationActive, p = a.offset, m = a.payload, g = a.payloadUniqBy, v = a.position, C = a.reverseDirection, y = a.useTranslate3d, w = a.viewBox, O = a.wrapperStyle, b = m ?? [];
      h && b.length && (b = Fy(m.filter(function(M) {
        return M.value != null && (M.hide !== !0 || n.props.includeHidden);
      }), g, zq));
      var D = b.length > 0;
      return /* @__PURE__ */ B.createElement(Hq, {
        allowEscapeViewBox: o,
        animationDuration: s,
        animationEasing: c,
        isAnimationActive: A,
        active: i,
        coordinate: d,
        hasPayload: D,
        offset: p,
        position: v,
        reverseDirection: C,
        useTranslate3d: y,
        viewBox: w,
        wrapperStyle: O
      }, Kq(u, bA(bA({}, this.props), {}, {
        payload: b
      })));
    }
  }]);
}(Cr);
E9(Xt, "displayName", "Tooltip");
E9(Xt, "defaultProps", {
  accessibilityLayer: !1,
  allowEscapeViewBox: {
    x: !1,
    y: !1
  },
  animationDuration: 400,
  animationEasing: "ease",
  contentStyle: {},
  coordinate: {
    x: 0,
    y: 0
  },
  cursor: !0,
  cursorStyle: {},
  filterNull: !0,
  isAnimationActive: !Br.isSsr,
  itemStyle: {},
  labelStyle: {},
  offset: 10,
  reverseDirection: {
    x: !1,
    y: !1
  },
  separator: " : ",
  trigger: "hover",
  useTranslate3d: !1,
  viewBox: {
    x: 0,
    y: 0,
    height: 0,
    width: 0
  },
  wrapperStyle: {}
});
var qq = fn, Xq = function() {
  return qq.Date.now();
}, Jq = Xq, eX = /\s/;
function tX(e) {
  for (var t = e.length; t-- && eX.test(e.charAt(t)); )
    ;
  return t;
}
var rX = tX, nX = rX, aX = /^\s+/;
function iX(e) {
  return e && e.slice(0, nX(e) + 1).replace(aX, "");
}
var oX = iX, sX = oX, wA = v1, lX = j2, xA = 0 / 0, cX = /^[-+]0x[0-9a-f]+$/i, uX = /^0b[01]+$/i, fX = /^0o[0-7]+$/i, dX = parseInt;
function hX(e) {
  if (typeof e == "number")
    return e;
  if (lX(e))
    return xA;
  if (wA(e)) {
    var t = typeof e.valueOf == "function" ? e.valueOf() : e;
    e = wA(t) ? t + "" : t;
  }
  if (typeof e != "string")
    return e === 0 ? e : +e;
  e = sX(e);
  var r = uX.test(e);
  return r || fX.test(e) ? dX(e.slice(2), r ? 2 : 8) : cX.test(e) ? xA : +e;
}
var qy = hX, AX = v1, K6 = Jq, OA = qy, pX = "Expected a function", vX = Math.max, gX = Math.min;
function mX(e, t, r) {
  var n, a, i, o, s, c, u = 0, d = !1, h = !1, A = !0;
  if (typeof e != "function")
    throw new TypeError(pX);
  t = OA(t) || 0, AX(r) && (d = !!r.leading, h = "maxWait" in r, i = h ? vX(OA(r.maxWait) || 0, t) : i, A = "trailing" in r ? !!r.trailing : A);
  function p(D) {
    var M = n, j = a;
    return n = a = void 0, u = D, o = e.apply(j, M), o;
  }
  function m(D) {
    return u = D, s = setTimeout(C, t), d ? p(D) : o;
  }
  function g(D) {
    var M = D - c, j = D - u, P = t - M;
    return h ? gX(P, i - j) : P;
  }
  function v(D) {
    var M = D - c, j = D - u;
    return c === void 0 || M >= t || M < 0 || h && j >= i;
  }
  function C() {
    var D = K6();
    if (v(D))
      return y(D);
    s = setTimeout(C, g(D));
  }
  function y(D) {
    return s = void 0, A && n ? p(D) : (n = a = void 0, o);
  }
  function w() {
    s !== void 0 && clearTimeout(s), u = 0, n = c = a = s = void 0;
  }
  function O() {
    return s === void 0 ? o : y(K6());
  }
  function b() {
    var D = K6(), M = v(D);
    if (n = arguments, a = this, c = D, M) {
      if (s === void 0)
        return m(c);
      if (h)
        return clearTimeout(s), s = setTimeout(C, t), p(c);
    }
    return s === void 0 && (s = setTimeout(C, t)), o;
  }
  return b.cancel = w, b.flush = O, b;
}
var CX = mX, bX = CX, yX = v1, wX = "Expected a function";
function xX(e, t, r) {
  var n = !0, a = !0;
  if (typeof e != "function")
    throw new TypeError(wX);
  return yX(r) && (n = "leading" in r ? !!r.leading : n, a = "trailing" in r ? !!r.trailing : a), bX(e, t, {
    leading: n,
    maxWait: t,
    trailing: a
  });
}
var OX = xX;
const Xy = /* @__PURE__ */ qe(OX);
function uo(e) {
  "@babel/helpers - typeof";
  return uo = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, uo(e);
}
function DA(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function M3(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? DA(Object(r), !0).forEach(function(n) {
      DX(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : DA(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function DX(e, t, r) {
  return t = MX(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function MX(e) {
  var t = EX(e, "string");
  return uo(t) == "symbol" ? t : t + "";
}
function EX(e, t) {
  if (uo(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (uo(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function PX(e, t) {
  return BX(e) || IX(e, t) || SX(e, t) || jX();
}
function jX() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function SX(e, t) {
  if (e) {
    if (typeof e == "string")
      return MA(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return MA(e, t);
  }
}
function MA(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
function IX(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, a, i, o, s = [], c = !0, u = !1;
    try {
      if (i = (r = r.call(e)).next, t === 0) {
        if (Object(r) !== r)
          return;
        c = !1;
      } else
        for (; !(c = (n = i.call(r)).done) && (s.push(n.value), s.length !== t); c = !0)
          ;
    } catch (d) {
      u = !0, a = d;
    } finally {
      try {
        if (!c && r.return != null && (o = r.return(), Object(o) !== o))
          return;
      } finally {
        if (u)
          throw a;
      }
    }
    return s;
  }
}
function BX(e) {
  if (Array.isArray(e))
    return e;
}
var $2 = /* @__PURE__ */ lC(function(e, t) {
  var r = e.aspect, n = e.initialDimension, a = n === void 0 ? {
    width: -1,
    height: -1
  } : n, i = e.width, o = i === void 0 ? "100%" : i, s = e.height, c = s === void 0 ? "100%" : s, u = e.minWidth, d = u === void 0 ? 0 : u, h = e.minHeight, A = e.maxHeight, p = e.children, m = e.debounce, g = m === void 0 ? 0 : m, v = e.id, C = e.className, y = e.onResize, w = e.style, O = w === void 0 ? {} : w, b = ge(null), D = ge();
  D.current = y, nP(t, function() {
    return Object.defineProperty(b.current, "current", {
      get: function() {
        return console.warn("The usage of ref.current.current is deprecated and will no longer be supported."), b.current;
      },
      configurable: !0
    });
  });
  var M = De({
    containerWidth: a.width,
    containerHeight: a.height
  }), j = PX(M, 2), P = j[0], H = j[1], F = aP(function(N, z) {
    H(function(q) {
      var J = Math.round(N), W = Math.round(z);
      return q.containerWidth === J && q.containerHeight === W ? q : {
        containerWidth: J,
        containerHeight: W
      };
    });
  }, []);
  Ie(function() {
    var N = function(S) {
      var I, T = S[0].contentRect, E = T.width, x = T.height;
      F(E, x), (I = D.current) === null || I === void 0 || I.call(D, E, x);
    };
    g > 0 && (N = Xy(N, g, {
      trailing: !0,
      leading: !1
    }));
    var z = new ResizeObserver(N), q = b.current.getBoundingClientRect(), J = q.width, W = q.height;
    return F(J, W), z.observe(b.current), function() {
      z.disconnect();
    };
  }, [F, g]);
  var R = dr(function() {
    var N = P.containerWidth, z = P.containerHeight;
    if (N < 0 || z < 0)
      return null;
    Gr(W1(o) || W1(c), `The width(%s) and height(%s) are both fixed numbers,
       maybe you don't need to use a ResponsiveContainer.`, o, c), Gr(!r || r > 0, "The aspect(%s) must be greater than zero.", r);
    var q = W1(o) ? N : o, J = W1(c) ? z : c;
    r && r > 0 && (q ? J = q / r : J && (q = J * r), A && J > A && (J = A)), Gr(q > 0 || J > 0, `The width(%s) and height(%s) of chart should be greater than 0,
       please check the style of container, or the props width(%s) and height(%s),
       or add a minWidth(%s) or minHeight(%s) or use aspect(%s) to control the
       height and width.`, q, J, o, c, d, h, r);
    var W = !Array.isArray(p) && On(p.type).endsWith("Chart");
    return B.Children.map(p, function(te) {
      return /* @__PURE__ */ B.isValidElement(te) ? /* @__PURE__ */ Bt(te, M3({
        width: q,
        height: J
      }, W ? {
        style: M3({
          height: "100%",
          width: "100%",
          maxHeight: J,
          maxWidth: q
        }, te.props.style)
      } : {})) : te;
    });
  }, [r, p, c, A, h, d, P, o]);
  return /* @__PURE__ */ B.createElement("div", {
    id: v ? "".concat(v) : void 0,
    className: Pe("recharts-responsive-container", C),
    style: M3(M3({}, O), {}, {
      width: o,
      height: c,
      minWidth: d,
      minHeight: h,
      maxHeight: A
    }),
    ref: b
  }, R);
}), Nr = function(t) {
  return null;
};
Nr.displayName = "Cell";
function fo(e) {
  "@babel/helpers - typeof";
  return fo = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, fo(e);
}
function EA(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function m5(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? EA(Object(r), !0).forEach(function(n) {
      NX(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : EA(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function NX(e, t, r) {
  return t = _X(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function _X(e) {
  var t = LX(e, "string");
  return fo(t) == "symbol" ? t : t + "";
}
function LX(e, t) {
  if (fo(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (fo(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var Ma = {
  widthCache: {},
  cacheCount: 0
}, TX = 2e3, RX = {
  position: "absolute",
  top: "-20000px",
  left: 0,
  padding: 0,
  margin: 0,
  border: "none",
  whiteSpace: "pre"
}, PA = "recharts_measurement_span";
function $X(e) {
  var t = m5({}, e);
  return Object.keys(t).forEach(function(r) {
    t[r] || delete t[r];
  }), t;
}
var ki = function(t) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  if (t == null || Br.isSsr)
    return {
      width: 0,
      height: 0
    };
  var n = $X(r), a = JSON.stringify({
    text: t,
    copyStyle: n
  });
  if (Ma.widthCache[a])
    return Ma.widthCache[a];
  try {
    var i = document.getElementById(PA);
    i || (i = document.createElement("span"), i.setAttribute("id", PA), i.setAttribute("aria-hidden", "true"), document.body.appendChild(i));
    var o = m5(m5({}, RX), n);
    Object.assign(i.style, o), i.textContent = "".concat(t);
    var s = i.getBoundingClientRect(), c = {
      width: s.width,
      height: s.height
    };
    return Ma.widthCache[a] = c, ++Ma.cacheCount > TX && (Ma.cacheCount = 0, Ma.widthCache = {}), c;
  } catch {
    return {
      width: 0,
      height: 0
    };
  }
}, FX = function(t) {
  return {
    top: t.top + window.scrollY - document.documentElement.clientTop,
    left: t.left + window.scrollX - document.documentElement.clientLeft
  };
};
function ho(e) {
  "@babel/helpers - typeof";
  return ho = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, ho(e);
}
function Cs(e, t) {
  return kX(e) || VX(e, t) || YX(e, t) || HX();
}
function HX() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function YX(e, t) {
  if (e) {
    if (typeof e == "string")
      return jA(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return jA(e, t);
  }
}
function jA(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
function VX(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, a, i, o, s = [], c = !0, u = !1;
    try {
      if (i = (r = r.call(e)).next, t === 0) {
        if (Object(r) !== r)
          return;
        c = !1;
      } else
        for (; !(c = (n = i.call(r)).done) && (s.push(n.value), s.length !== t); c = !0)
          ;
    } catch (d) {
      u = !0, a = d;
    } finally {
      try {
        if (!c && r.return != null && (o = r.return(), Object(o) !== o))
          return;
      } finally {
        if (u)
          throw a;
      }
    }
    return s;
  }
}
function kX(e) {
  if (Array.isArray(e))
    return e;
}
function GX(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function SA(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, QX(n.key), n);
  }
}
function WX(e, t, r) {
  return t && SA(e.prototype, t), r && SA(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function QX(e) {
  var t = UX(e, "string");
  return ho(t) == "symbol" ? t : t + "";
}
function UX(e, t) {
  if (ho(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (ho(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var IA = /(-?\d+(?:\.\d+)?[a-zA-Z%]*)([*/])(-?\d+(?:\.\d+)?[a-zA-Z%]*)/, BA = /(-?\d+(?:\.\d+)?[a-zA-Z%]*)([+-])(-?\d+(?:\.\d+)?[a-zA-Z%]*)/, ZX = /^px|cm|vh|vw|em|rem|%|mm|in|pt|pc|ex|ch|vmin|vmax|Q$/, zX = /(-?\d+(?:\.\d+)?)([a-zA-Z%]+)?/, Jy = {
  cm: 96 / 2.54,
  mm: 96 / 25.4,
  pt: 96 / 72,
  pc: 96 / 6,
  in: 96,
  Q: 96 / (2.54 * 40),
  px: 1
}, KX = Object.keys(Jy), Ra = "NaN";
function qX(e, t) {
  return e * Jy[t];
}
var E3 = /* @__PURE__ */ function() {
  function e(t, r) {
    GX(this, e), this.num = t, this.unit = r, this.num = t, this.unit = r, Number.isNaN(t) && (this.unit = ""), r !== "" && !ZX.test(r) && (this.num = NaN, this.unit = ""), KX.includes(r) && (this.num = qX(t, r), this.unit = "px");
  }
  return WX(e, [{
    key: "add",
    value: function(r) {
      return this.unit !== r.unit ? new e(NaN, "") : new e(this.num + r.num, this.unit);
    }
  }, {
    key: "subtract",
    value: function(r) {
      return this.unit !== r.unit ? new e(NaN, "") : new e(this.num - r.num, this.unit);
    }
  }, {
    key: "multiply",
    value: function(r) {
      return this.unit !== "" && r.unit !== "" && this.unit !== r.unit ? new e(NaN, "") : new e(this.num * r.num, this.unit || r.unit);
    }
  }, {
    key: "divide",
    value: function(r) {
      return this.unit !== "" && r.unit !== "" && this.unit !== r.unit ? new e(NaN, "") : new e(this.num / r.num, this.unit || r.unit);
    }
  }, {
    key: "toString",
    value: function() {
      return "".concat(this.num).concat(this.unit);
    }
  }, {
    key: "isNaN",
    value: function() {
      return Number.isNaN(this.num);
    }
  }], [{
    key: "parse",
    value: function(r) {
      var n, a = (n = zX.exec(r)) !== null && n !== void 0 ? n : [], i = Cs(a, 3), o = i[1], s = i[2];
      return new e(parseFloat(o), s ?? "");
    }
  }]);
}();
function ew(e) {
  if (e.includes(Ra))
    return Ra;
  for (var t = e; t.includes("*") || t.includes("/"); ) {
    var r, n = (r = IA.exec(t)) !== null && r !== void 0 ? r : [], a = Cs(n, 4), i = a[1], o = a[2], s = a[3], c = E3.parse(i ?? ""), u = E3.parse(s ?? ""), d = o === "*" ? c.multiply(u) : c.divide(u);
    if (d.isNaN())
      return Ra;
    t = t.replace(IA, d.toString());
  }
  for (; t.includes("+") || /.-\d+(?:\.\d+)?/.test(t); ) {
    var h, A = (h = BA.exec(t)) !== null && h !== void 0 ? h : [], p = Cs(A, 4), m = p[1], g = p[2], v = p[3], C = E3.parse(m ?? ""), y = E3.parse(v ?? ""), w = g === "+" ? C.add(y) : C.subtract(y);
    if (w.isNaN())
      return Ra;
    t = t.replace(BA, w.toString());
  }
  return t;
}
var NA = /\(([^()]*)\)/;
function XX(e) {
  for (var t = e; t.includes("("); ) {
    var r = NA.exec(t), n = Cs(r, 2), a = n[1];
    t = t.replace(NA, ew(a));
  }
  return t;
}
function JX(e) {
  var t = e.replace(/\s+/g, "");
  return t = XX(t), t = ew(t), t;
}
function eJ(e) {
  try {
    return JX(e);
  } catch {
    return Ra;
  }
}
function q6(e) {
  var t = eJ(e.slice(5, -1));
  return t === Ra ? "" : t;
}
var tJ = ["x", "y", "lineHeight", "capHeight", "scaleToFit", "textAnchor", "verticalAnchor", "fill"], rJ = ["dx", "dy", "angle", "className", "breakAll"];
function C5() {
  return C5 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, C5.apply(this, arguments);
}
function _A(e, t) {
  if (e == null)
    return {};
  var r = nJ(e, t), n, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (a = 0; a < i.length; a++)
      n = i[a], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function nJ(e, t) {
  if (e == null)
    return {};
  var r = {};
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      if (t.indexOf(n) >= 0)
        continue;
      r[n] = e[n];
    }
  return r;
}
function LA(e, t) {
  return sJ(e) || oJ(e, t) || iJ(e, t) || aJ();
}
function aJ() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function iJ(e, t) {
  if (e) {
    if (typeof e == "string")
      return TA(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return TA(e, t);
  }
}
function TA(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
function oJ(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, a, i, o, s = [], c = !0, u = !1;
    try {
      if (i = (r = r.call(e)).next, t === 0) {
        if (Object(r) !== r)
          return;
        c = !1;
      } else
        for (; !(c = (n = i.call(r)).done) && (s.push(n.value), s.length !== t); c = !0)
          ;
    } catch (d) {
      u = !0, a = d;
    } finally {
      try {
        if (!c && r.return != null && (o = r.return(), Object(o) !== o))
          return;
      } finally {
        if (u)
          throw a;
      }
    }
    return s;
  }
}
function sJ(e) {
  if (Array.isArray(e))
    return e;
}
var tw = /[ \f\n\r\t\v\u2028\u2029]+/, rw = function(t) {
  var r = t.children, n = t.breakAll, a = t.style;
  try {
    var i = [];
    be(r) || (n ? i = r.toString().split("") : i = r.toString().split(tw));
    var o = i.map(function(c) {
      return {
        word: c,
        width: ki(c, a).width
      };
    }), s = n ? 0 : ki(" ", a).width;
    return {
      wordsWithComputedWidth: o,
      spaceWidth: s
    };
  } catch {
    return null;
  }
}, lJ = function(t, r, n, a, i) {
  var o = t.maxLines, s = t.children, c = t.style, u = t.breakAll, d = se(o), h = s, A = function() {
    var q = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    return q.reduce(function(J, W) {
      var te = W.word, S = W.width, I = J[J.length - 1];
      if (I && (a == null || i || I.width + S + n < Number(a)))
        I.words.push(te), I.width += S + n;
      else {
        var T = {
          words: [te],
          width: S
        };
        J.push(T);
      }
      return J;
    }, []);
  }, p = A(r), m = function(q) {
    return q.reduce(function(J, W) {
      return J.width > W.width ? J : W;
    });
  };
  if (!d)
    return p;
  for (var g = "…", v = function(q) {
    var J = h.slice(0, q), W = rw({
      breakAll: u,
      style: c,
      children: J + g
    }).wordsWithComputedWidth, te = A(W), S = te.length > o || m(te).width > Number(a);
    return [S, te];
  }, C = 0, y = h.length - 1, w = 0, O; C <= y && w <= h.length - 1; ) {
    var b = Math.floor((C + y) / 2), D = b - 1, M = v(D), j = LA(M, 2), P = j[0], H = j[1], F = v(b), R = LA(F, 1), N = R[0];
    if (!P && !N && (C = b + 1), P && N && (y = b - 1), !P && N) {
      O = H;
      break;
    }
    w++;
  }
  return O || p;
}, RA = function(t) {
  var r = be(t) ? [] : t.toString().split(tw);
  return [{
    words: r
  }];
}, cJ = function(t) {
  var r = t.width, n = t.scaleToFit, a = t.children, i = t.style, o = t.breakAll, s = t.maxLines;
  if ((r || n) && !Br.isSsr) {
    var c, u, d = rw({
      breakAll: o,
      children: a,
      style: i
    });
    if (d) {
      var h = d.wordsWithComputedWidth, A = d.spaceWidth;
      c = h, u = A;
    } else
      return RA(a);
    return lJ({
      breakAll: o,
      children: a,
      maxLines: s,
      style: i
    }, c, u, r, n);
  }
  return RA(a);
}, $A = "#808080", ta = function(t) {
  var r = t.x, n = r === void 0 ? 0 : r, a = t.y, i = a === void 0 ? 0 : a, o = t.lineHeight, s = o === void 0 ? "1em" : o, c = t.capHeight, u = c === void 0 ? "0.71em" : c, d = t.scaleToFit, h = d === void 0 ? !1 : d, A = t.textAnchor, p = A === void 0 ? "start" : A, m = t.verticalAnchor, g = m === void 0 ? "end" : m, v = t.fill, C = v === void 0 ? $A : v, y = _A(t, tJ), w = dr(function() {
    return cJ({
      breakAll: y.breakAll,
      children: y.children,
      maxLines: y.maxLines,
      scaleToFit: h,
      style: y.style,
      width: y.width
    });
  }, [y.breakAll, y.children, y.maxLines, h, y.style, y.width]), O = y.dx, b = y.dy, D = y.angle, M = y.className, j = y.breakAll, P = _A(y, rJ);
  if (!Nt(n) || !Nt(i))
    return null;
  var H = n + (se(O) ? O : 0), F = i + (se(b) ? b : 0), R;
  switch (g) {
    case "start":
      R = q6("calc(".concat(u, ")"));
      break;
    case "middle":
      R = q6("calc(".concat((w.length - 1) / 2, " * -").concat(s, " + (").concat(u, " / 2))"));
      break;
    default:
      R = q6("calc(".concat(w.length - 1, " * -").concat(s, ")"));
      break;
  }
  var N = [];
  if (h) {
    var z = w[0].width, q = y.width;
    N.push("scale(".concat((se(q) ? q / z : 1) / z, ")"));
  }
  return D && N.push("rotate(".concat(D, ", ").concat(H, ", ").concat(F, ")")), N.length && (P.transform = N.join(" ")), /* @__PURE__ */ B.createElement("text", C5({}, Ae(P, !0), {
    x: H,
    y: F,
    className: Pe("recharts-text", M),
    textAnchor: p,
    fill: C.includes("url") ? $A : C
  }), w.map(function(J, W) {
    var te = J.words.join(j ? "" : " ");
    return (
      // duplicate words will cause duplicate keys
      // eslint-disable-next-line react/no-array-index-key
      /* @__PURE__ */ B.createElement("tspan", {
        x: H,
        dy: W === 0 ? R : s,
        key: "".concat(te, "-").concat(W)
      }, te)
    );
  }));
};
function i1(e, t) {
  return e == null || t == null ? NaN : e < t ? -1 : e > t ? 1 : e >= t ? 0 : NaN;
}
function uJ(e, t) {
  return e == null || t == null ? NaN : t < e ? -1 : t > e ? 1 : t >= e ? 0 : NaN;
}
function P9(e) {
  let t, r, n;
  e.length !== 2 ? (t = i1, r = (s, c) => i1(e(s), c), n = (s, c) => e(s) - c) : (t = e === i1 || e === uJ ? e : fJ, r = e, n = e);
  function a(s, c, u = 0, d = s.length) {
    if (u < d) {
      if (t(c, c) !== 0)
        return d;
      do {
        const h = u + d >>> 1;
        r(s[h], c) < 0 ? u = h + 1 : d = h;
      } while (u < d);
    }
    return u;
  }
  function i(s, c, u = 0, d = s.length) {
    if (u < d) {
      if (t(c, c) !== 0)
        return d;
      do {
        const h = u + d >>> 1;
        r(s[h], c) <= 0 ? u = h + 1 : d = h;
      } while (u < d);
    }
    return u;
  }
  function o(s, c, u = 0, d = s.length) {
    const h = a(s, c, u, d - 1);
    return h > u && n(s[h - 1], c) > -n(s[h], c) ? h - 1 : h;
  }
  return { left: a, center: o, right: i };
}
function fJ() {
  return 0;
}
function nw(e) {
  return e === null ? NaN : +e;
}
function* dJ(e, t) {
  if (t === void 0)
    for (let r of e)
      r != null && (r = +r) >= r && (yield r);
  else {
    let r = -1;
    for (let n of e)
      (n = t(n, ++r, e)) != null && (n = +n) >= n && (yield n);
  }
}
const hJ = P9(i1), AJ = hJ.right;
P9(nw).center;
const Ko = AJ;
class FA extends Map {
  constructor(t, r = gJ) {
    if (super(), Object.defineProperties(this, { _intern: { value: /* @__PURE__ */ new Map() }, _key: { value: r } }), t != null)
      for (const [n, a] of t)
        this.set(n, a);
  }
  get(t) {
    return super.get(HA(this, t));
  }
  has(t) {
    return super.has(HA(this, t));
  }
  set(t, r) {
    return super.set(pJ(this, t), r);
  }
  delete(t) {
    return super.delete(vJ(this, t));
  }
}
function HA({ _intern: e, _key: t }, r) {
  const n = t(r);
  return e.has(n) ? e.get(n) : r;
}
function pJ({ _intern: e, _key: t }, r) {
  const n = t(r);
  return e.has(n) ? e.get(n) : (e.set(n, r), r);
}
function vJ({ _intern: e, _key: t }, r) {
  const n = t(r);
  return e.has(n) && (r = e.get(n), e.delete(n)), r;
}
function gJ(e) {
  return e !== null && typeof e == "object" ? e.valueOf() : e;
}
function mJ(e = i1) {
  if (e === i1)
    return aw;
  if (typeof e != "function")
    throw new TypeError("compare is not a function");
  return (t, r) => {
    const n = e(t, r);
    return n || n === 0 ? n : (e(r, r) === 0) - (e(t, t) === 0);
  };
}
function aw(e, t) {
  return (e == null || !(e >= e)) - (t == null || !(t >= t)) || (e < t ? -1 : e > t ? 1 : 0);
}
const CJ = Math.sqrt(50), bJ = Math.sqrt(10), yJ = Math.sqrt(2);
function bs(e, t, r) {
  const n = (t - e) / Math.max(0, r), a = Math.floor(Math.log10(n)), i = n / Math.pow(10, a), o = i >= CJ ? 10 : i >= bJ ? 5 : i >= yJ ? 2 : 1;
  let s, c, u;
  return a < 0 ? (u = Math.pow(10, -a) / o, s = Math.round(e * u), c = Math.round(t * u), s / u < e && ++s, c / u > t && --c, u = -u) : (u = Math.pow(10, a) * o, s = Math.round(e / u), c = Math.round(t / u), s * u < e && ++s, c * u > t && --c), c < s && 0.5 <= r && r < 2 ? bs(e, t, r * 2) : [s, c, u];
}
function b5(e, t, r) {
  if (t = +t, e = +e, r = +r, !(r > 0))
    return [];
  if (e === t)
    return [e];
  const n = t < e, [a, i, o] = n ? bs(t, e, r) : bs(e, t, r);
  if (!(i >= a))
    return [];
  const s = i - a + 1, c = new Array(s);
  if (n)
    if (o < 0)
      for (let u = 0; u < s; ++u)
        c[u] = (i - u) / -o;
    else
      for (let u = 0; u < s; ++u)
        c[u] = (i - u) * o;
  else if (o < 0)
    for (let u = 0; u < s; ++u)
      c[u] = (a + u) / -o;
  else
    for (let u = 0; u < s; ++u)
      c[u] = (a + u) * o;
  return c;
}
function y5(e, t, r) {
  return t = +t, e = +e, r = +r, bs(e, t, r)[2];
}
function w5(e, t, r) {
  t = +t, e = +e, r = +r;
  const n = t < e, a = n ? y5(t, e, r) : y5(e, t, r);
  return (n ? -1 : 1) * (a < 0 ? 1 / -a : a);
}
function YA(e, t) {
  let r;
  if (t === void 0)
    for (const n of e)
      n != null && (r < n || r === void 0 && n >= n) && (r = n);
  else {
    let n = -1;
    for (let a of e)
      (a = t(a, ++n, e)) != null && (r < a || r === void 0 && a >= a) && (r = a);
  }
  return r;
}
function VA(e, t) {
  let r;
  if (t === void 0)
    for (const n of e)
      n != null && (r > n || r === void 0 && n >= n) && (r = n);
  else {
    let n = -1;
    for (let a of e)
      (a = t(a, ++n, e)) != null && (r > a || r === void 0 && a >= a) && (r = a);
  }
  return r;
}
function iw(e, t, r = 0, n = 1 / 0, a) {
  if (t = Math.floor(t), r = Math.floor(Math.max(0, r)), n = Math.floor(Math.min(e.length - 1, n)), !(r <= t && t <= n))
    return e;
  for (a = a === void 0 ? aw : mJ(a); n > r; ) {
    if (n - r > 600) {
      const c = n - r + 1, u = t - r + 1, d = Math.log(c), h = 0.5 * Math.exp(2 * d / 3), A = 0.5 * Math.sqrt(d * h * (c - h) / c) * (u - c / 2 < 0 ? -1 : 1), p = Math.max(r, Math.floor(t - u * h / c + A)), m = Math.min(n, Math.floor(t + (c - u) * h / c + A));
      iw(e, t, p, m, a);
    }
    const i = e[t];
    let o = r, s = n;
    for (gi(e, r, t), a(e[n], i) > 0 && gi(e, r, n); o < s; ) {
      for (gi(e, o, s), ++o, --s; a(e[o], i) < 0; )
        ++o;
      for (; a(e[s], i) > 0; )
        --s;
    }
    a(e[r], i) === 0 ? gi(e, r, s) : (++s, gi(e, s, n)), s <= t && (r = s + 1), t <= s && (n = s - 1);
  }
  return e;
}
function gi(e, t, r) {
  const n = e[t];
  e[t] = e[r], e[r] = n;
}
function wJ(e, t, r) {
  if (e = Float64Array.from(dJ(e, r)), !(!(n = e.length) || isNaN(t = +t))) {
    if (t <= 0 || n < 2)
      return VA(e);
    if (t >= 1)
      return YA(e);
    var n, a = (n - 1) * t, i = Math.floor(a), o = YA(iw(e, i).subarray(0, i + 1)), s = VA(e.subarray(i + 1));
    return o + (s - o) * (a - i);
  }
}
function xJ(e, t, r = nw) {
  if (!(!(n = e.length) || isNaN(t = +t))) {
    if (t <= 0 || n < 2)
      return +r(e[0], 0, e);
    if (t >= 1)
      return +r(e[n - 1], n - 1, e);
    var n, a = (n - 1) * t, i = Math.floor(a), o = +r(e[i], i, e), s = +r(e[i + 1], i + 1, e);
    return o + (s - o) * (a - i);
  }
}
function OJ(e, t, r) {
  e = +e, t = +t, r = (a = arguments.length) < 2 ? (t = e, e = 0, 1) : a < 3 ? 1 : +r;
  for (var n = -1, a = Math.max(0, Math.ceil((t - e) / r)) | 0, i = new Array(a); ++n < a; )
    i[n] = e + n * r;
  return i;
}
function Tr(e, t) {
  switch (arguments.length) {
    case 0:
      break;
    case 1:
      this.range(e);
      break;
    default:
      this.range(t).domain(e);
      break;
  }
  return this;
}
function _n(e, t) {
  switch (arguments.length) {
    case 0:
      break;
    case 1: {
      typeof e == "function" ? this.interpolator(e) : this.range(e);
      break;
    }
    default: {
      this.domain(e), typeof t == "function" ? this.interpolator(t) : this.range(t);
      break;
    }
  }
  return this;
}
const x5 = Symbol("implicit");
function j9() {
  var e = new FA(), t = [], r = [], n = x5;
  function a(i) {
    let o = e.get(i);
    if (o === void 0) {
      if (n !== x5)
        return n;
      e.set(i, o = t.push(i) - 1);
    }
    return r[o % r.length];
  }
  return a.domain = function(i) {
    if (!arguments.length)
      return t.slice();
    t = [], e = new FA();
    for (const o of i)
      e.has(o) || e.set(o, t.push(o) - 1);
    return a;
  }, a.range = function(i) {
    return arguments.length ? (r = Array.from(i), a) : r.slice();
  }, a.unknown = function(i) {
    return arguments.length ? (n = i, a) : n;
  }, a.copy = function() {
    return j9(t, r).unknown(n);
  }, Tr.apply(a, arguments), a;
}
function Ao() {
  var e = j9().unknown(void 0), t = e.domain, r = e.range, n = 0, a = 1, i, o, s = !1, c = 0, u = 0, d = 0.5;
  delete e.unknown;
  function h() {
    var A = t().length, p = a < n, m = p ? a : n, g = p ? n : a;
    i = (g - m) / Math.max(1, A - c + u * 2), s && (i = Math.floor(i)), m += (g - m - i * (A - c)) * d, o = i * (1 - c), s && (m = Math.round(m), o = Math.round(o));
    var v = OJ(A).map(function(C) {
      return m + i * C;
    });
    return r(p ? v.reverse() : v);
  }
  return e.domain = function(A) {
    return arguments.length ? (t(A), h()) : t();
  }, e.range = function(A) {
    return arguments.length ? ([n, a] = A, n = +n, a = +a, h()) : [n, a];
  }, e.rangeRound = function(A) {
    return [n, a] = A, n = +n, a = +a, s = !0, h();
  }, e.bandwidth = function() {
    return o;
  }, e.step = function() {
    return i;
  }, e.round = function(A) {
    return arguments.length ? (s = !!A, h()) : s;
  }, e.padding = function(A) {
    return arguments.length ? (c = Math.min(1, u = +A), h()) : c;
  }, e.paddingInner = function(A) {
    return arguments.length ? (c = Math.min(1, A), h()) : c;
  }, e.paddingOuter = function(A) {
    return arguments.length ? (u = +A, h()) : u;
  }, e.align = function(A) {
    return arguments.length ? (d = Math.max(0, Math.min(1, A)), h()) : d;
  }, e.copy = function() {
    return Ao(t(), [n, a]).round(s).paddingInner(c).paddingOuter(u).align(d);
  }, Tr.apply(h(), arguments);
}
function ow(e) {
  var t = e.copy;
  return e.padding = e.paddingOuter, delete e.paddingInner, delete e.paddingOuter, e.copy = function() {
    return ow(t());
  }, e;
}
function Gi() {
  return ow(Ao.apply(null, arguments).paddingInner(1));
}
function S9(e, t, r) {
  e.prototype = t.prototype = r, r.constructor = e;
}
function sw(e, t) {
  var r = Object.create(e.prototype);
  for (var n in t)
    r[n] = t[n];
  return r;
}
function qo() {
}
var po = 0.7, ys = 1 / po, ka = "\\s*([+-]?\\d+)\\s*", vo = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)\\s*", sn = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)%\\s*", DJ = /^#([0-9a-f]{3,8})$/, MJ = new RegExp(`^rgb\\(${ka},${ka},${ka}\\)$`), EJ = new RegExp(`^rgb\\(${sn},${sn},${sn}\\)$`), PJ = new RegExp(`^rgba\\(${ka},${ka},${ka},${vo}\\)$`), jJ = new RegExp(`^rgba\\(${sn},${sn},${sn},${vo}\\)$`), SJ = new RegExp(`^hsl\\(${vo},${sn},${sn}\\)$`), IJ = new RegExp(`^hsla\\(${vo},${sn},${sn},${vo}\\)$`), kA = {
  aliceblue: 15792383,
  antiquewhite: 16444375,
  aqua: 65535,
  aquamarine: 8388564,
  azure: 15794175,
  beige: 16119260,
  bisque: 16770244,
  black: 0,
  blanchedalmond: 16772045,
  blue: 255,
  blueviolet: 9055202,
  brown: 10824234,
  burlywood: 14596231,
  cadetblue: 6266528,
  chartreuse: 8388352,
  chocolate: 13789470,
  coral: 16744272,
  cornflowerblue: 6591981,
  cornsilk: 16775388,
  crimson: 14423100,
  cyan: 65535,
  darkblue: 139,
  darkcyan: 35723,
  darkgoldenrod: 12092939,
  darkgray: 11119017,
  darkgreen: 25600,
  darkgrey: 11119017,
  darkkhaki: 12433259,
  darkmagenta: 9109643,
  darkolivegreen: 5597999,
  darkorange: 16747520,
  darkorchid: 10040012,
  darkred: 9109504,
  darksalmon: 15308410,
  darkseagreen: 9419919,
  darkslateblue: 4734347,
  darkslategray: 3100495,
  darkslategrey: 3100495,
  darkturquoise: 52945,
  darkviolet: 9699539,
  deeppink: 16716947,
  deepskyblue: 49151,
  dimgray: 6908265,
  dimgrey: 6908265,
  dodgerblue: 2003199,
  firebrick: 11674146,
  floralwhite: 16775920,
  forestgreen: 2263842,
  fuchsia: 16711935,
  gainsboro: 14474460,
  ghostwhite: 16316671,
  gold: 16766720,
  goldenrod: 14329120,
  gray: 8421504,
  green: 32768,
  greenyellow: 11403055,
  grey: 8421504,
  honeydew: 15794160,
  hotpink: 16738740,
  indianred: 13458524,
  indigo: 4915330,
  ivory: 16777200,
  khaki: 15787660,
  lavender: 15132410,
  lavenderblush: 16773365,
  lawngreen: 8190976,
  lemonchiffon: 16775885,
  lightblue: 11393254,
  lightcoral: 15761536,
  lightcyan: 14745599,
  lightgoldenrodyellow: 16448210,
  lightgray: 13882323,
  lightgreen: 9498256,
  lightgrey: 13882323,
  lightpink: 16758465,
  lightsalmon: 16752762,
  lightseagreen: 2142890,
  lightskyblue: 8900346,
  lightslategray: 7833753,
  lightslategrey: 7833753,
  lightsteelblue: 11584734,
  lightyellow: 16777184,
  lime: 65280,
  limegreen: 3329330,
  linen: 16445670,
  magenta: 16711935,
  maroon: 8388608,
  mediumaquamarine: 6737322,
  mediumblue: 205,
  mediumorchid: 12211667,
  mediumpurple: 9662683,
  mediumseagreen: 3978097,
  mediumslateblue: 8087790,
  mediumspringgreen: 64154,
  mediumturquoise: 4772300,
  mediumvioletred: 13047173,
  midnightblue: 1644912,
  mintcream: 16121850,
  mistyrose: 16770273,
  moccasin: 16770229,
  navajowhite: 16768685,
  navy: 128,
  oldlace: 16643558,
  olive: 8421376,
  olivedrab: 7048739,
  orange: 16753920,
  orangered: 16729344,
  orchid: 14315734,
  palegoldenrod: 15657130,
  palegreen: 10025880,
  paleturquoise: 11529966,
  palevioletred: 14381203,
  papayawhip: 16773077,
  peachpuff: 16767673,
  peru: 13468991,
  pink: 16761035,
  plum: 14524637,
  powderblue: 11591910,
  purple: 8388736,
  rebeccapurple: 6697881,
  red: 16711680,
  rosybrown: 12357519,
  royalblue: 4286945,
  saddlebrown: 9127187,
  salmon: 16416882,
  sandybrown: 16032864,
  seagreen: 3050327,
  seashell: 16774638,
  sienna: 10506797,
  silver: 12632256,
  skyblue: 8900331,
  slateblue: 6970061,
  slategray: 7372944,
  slategrey: 7372944,
  snow: 16775930,
  springgreen: 65407,
  steelblue: 4620980,
  tan: 13808780,
  teal: 32896,
  thistle: 14204888,
  tomato: 16737095,
  turquoise: 4251856,
  violet: 15631086,
  wheat: 16113331,
  white: 16777215,
  whitesmoke: 16119285,
  yellow: 16776960,
  yellowgreen: 10145074
};
S9(qo, go, {
  copy(e) {
    return Object.assign(new this.constructor(), this, e);
  },
  displayable() {
    return this.rgb().displayable();
  },
  hex: GA,
  // Deprecated! Use color.formatHex.
  formatHex: GA,
  formatHex8: BJ,
  formatHsl: NJ,
  formatRgb: WA,
  toString: WA
});
function GA() {
  return this.rgb().formatHex();
}
function BJ() {
  return this.rgb().formatHex8();
}
function NJ() {
  return lw(this).formatHsl();
}
function WA() {
  return this.rgb().formatRgb();
}
function go(e) {
  var t, r;
  return e = (e + "").trim().toLowerCase(), (t = DJ.exec(e)) ? (r = t[1].length, t = parseInt(t[1], 16), r === 6 ? QA(t) : r === 3 ? new ir(t >> 8 & 15 | t >> 4 & 240, t >> 4 & 15 | t & 240, (t & 15) << 4 | t & 15, 1) : r === 8 ? P3(t >> 24 & 255, t >> 16 & 255, t >> 8 & 255, (t & 255) / 255) : r === 4 ? P3(t >> 12 & 15 | t >> 8 & 240, t >> 8 & 15 | t >> 4 & 240, t >> 4 & 15 | t & 240, ((t & 15) << 4 | t & 15) / 255) : null) : (t = MJ.exec(e)) ? new ir(t[1], t[2], t[3], 1) : (t = EJ.exec(e)) ? new ir(t[1] * 255 / 100, t[2] * 255 / 100, t[3] * 255 / 100, 1) : (t = PJ.exec(e)) ? P3(t[1], t[2], t[3], t[4]) : (t = jJ.exec(e)) ? P3(t[1] * 255 / 100, t[2] * 255 / 100, t[3] * 255 / 100, t[4]) : (t = SJ.exec(e)) ? zA(t[1], t[2] / 100, t[3] / 100, 1) : (t = IJ.exec(e)) ? zA(t[1], t[2] / 100, t[3] / 100, t[4]) : kA.hasOwnProperty(e) ? QA(kA[e]) : e === "transparent" ? new ir(NaN, NaN, NaN, 0) : null;
}
function QA(e) {
  return new ir(e >> 16 & 255, e >> 8 & 255, e & 255, 1);
}
function P3(e, t, r, n) {
  return n <= 0 && (e = t = r = NaN), new ir(e, t, r, n);
}
function _J(e) {
  return e instanceof qo || (e = go(e)), e ? (e = e.rgb(), new ir(e.r, e.g, e.b, e.opacity)) : new ir();
}
function O5(e, t, r, n) {
  return arguments.length === 1 ? _J(e) : new ir(e, t, r, n ?? 1);
}
function ir(e, t, r, n) {
  this.r = +e, this.g = +t, this.b = +r, this.opacity = +n;
}
S9(ir, O5, sw(qo, {
  brighter(e) {
    return e = e == null ? ys : Math.pow(ys, e), new ir(this.r * e, this.g * e, this.b * e, this.opacity);
  },
  darker(e) {
    return e = e == null ? po : Math.pow(po, e), new ir(this.r * e, this.g * e, this.b * e, this.opacity);
  },
  rgb() {
    return this;
  },
  clamp() {
    return new ir(q1(this.r), q1(this.g), q1(this.b), ws(this.opacity));
  },
  displayable() {
    return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
  },
  hex: UA,
  // Deprecated! Use color.formatHex.
  formatHex: UA,
  formatHex8: LJ,
  formatRgb: ZA,
  toString: ZA
}));
function UA() {
  return `#${Q1(this.r)}${Q1(this.g)}${Q1(this.b)}`;
}
function LJ() {
  return `#${Q1(this.r)}${Q1(this.g)}${Q1(this.b)}${Q1((isNaN(this.opacity) ? 1 : this.opacity) * 255)}`;
}
function ZA() {
  const e = ws(this.opacity);
  return `${e === 1 ? "rgb(" : "rgba("}${q1(this.r)}, ${q1(this.g)}, ${q1(this.b)}${e === 1 ? ")" : `, ${e})`}`;
}
function ws(e) {
  return isNaN(e) ? 1 : Math.max(0, Math.min(1, e));
}
function q1(e) {
  return Math.max(0, Math.min(255, Math.round(e) || 0));
}
function Q1(e) {
  return e = q1(e), (e < 16 ? "0" : "") + e.toString(16);
}
function zA(e, t, r, n) {
  return n <= 0 ? e = t = r = NaN : r <= 0 || r >= 1 ? e = t = NaN : t <= 0 && (e = NaN), new Hr(e, t, r, n);
}
function lw(e) {
  if (e instanceof Hr)
    return new Hr(e.h, e.s, e.l, e.opacity);
  if (e instanceof qo || (e = go(e)), !e)
    return new Hr();
  if (e instanceof Hr)
    return e;
  e = e.rgb();
  var t = e.r / 255, r = e.g / 255, n = e.b / 255, a = Math.min(t, r, n), i = Math.max(t, r, n), o = NaN, s = i - a, c = (i + a) / 2;
  return s ? (t === i ? o = (r - n) / s + (r < n) * 6 : r === i ? o = (n - t) / s + 2 : o = (t - r) / s + 4, s /= c < 0.5 ? i + a : 2 - i - a, o *= 60) : s = c > 0 && c < 1 ? 0 : o, new Hr(o, s, c, e.opacity);
}
function TJ(e, t, r, n) {
  return arguments.length === 1 ? lw(e) : new Hr(e, t, r, n ?? 1);
}
function Hr(e, t, r, n) {
  this.h = +e, this.s = +t, this.l = +r, this.opacity = +n;
}
S9(Hr, TJ, sw(qo, {
  brighter(e) {
    return e = e == null ? ys : Math.pow(ys, e), new Hr(this.h, this.s, this.l * e, this.opacity);
  },
  darker(e) {
    return e = e == null ? po : Math.pow(po, e), new Hr(this.h, this.s, this.l * e, this.opacity);
  },
  rgb() {
    var e = this.h % 360 + (this.h < 0) * 360, t = isNaN(e) || isNaN(this.s) ? 0 : this.s, r = this.l, n = r + (r < 0.5 ? r : 1 - r) * t, a = 2 * r - n;
    return new ir(
      X6(e >= 240 ? e - 240 : e + 120, a, n),
      X6(e, a, n),
      X6(e < 120 ? e + 240 : e - 120, a, n),
      this.opacity
    );
  },
  clamp() {
    return new Hr(KA(this.h), j3(this.s), j3(this.l), ws(this.opacity));
  },
  displayable() {
    return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
  },
  formatHsl() {
    const e = ws(this.opacity);
    return `${e === 1 ? "hsl(" : "hsla("}${KA(this.h)}, ${j3(this.s) * 100}%, ${j3(this.l) * 100}%${e === 1 ? ")" : `, ${e})`}`;
  }
}));
function KA(e) {
  return e = (e || 0) % 360, e < 0 ? e + 360 : e;
}
function j3(e) {
  return Math.max(0, Math.min(1, e || 0));
}
function X6(e, t, r) {
  return (e < 60 ? t + (r - t) * e / 60 : e < 180 ? r : e < 240 ? t + (r - t) * (240 - e) / 60 : t) * 255;
}
const I9 = (e) => () => e;
function RJ(e, t) {
  return function(r) {
    return e + r * t;
  };
}
function $J(e, t, r) {
  return e = Math.pow(e, r), t = Math.pow(t, r) - e, r = 1 / r, function(n) {
    return Math.pow(e + n * t, r);
  };
}
function FJ(e) {
  return (e = +e) == 1 ? cw : function(t, r) {
    return r - t ? $J(t, r, e) : I9(isNaN(t) ? r : t);
  };
}
function cw(e, t) {
  var r = t - e;
  return r ? RJ(e, r) : I9(isNaN(e) ? t : e);
}
const qA = function e(t) {
  var r = FJ(t);
  function n(a, i) {
    var o = r((a = O5(a)).r, (i = O5(i)).r), s = r(a.g, i.g), c = r(a.b, i.b), u = cw(a.opacity, i.opacity);
    return function(d) {
      return a.r = o(d), a.g = s(d), a.b = c(d), a.opacity = u(d), a + "";
    };
  }
  return n.gamma = e, n;
}(1);
function HJ(e, t) {
  t || (t = []);
  var r = e ? Math.min(t.length, e.length) : 0, n = t.slice(), a;
  return function(i) {
    for (a = 0; a < r; ++a)
      n[a] = e[a] * (1 - i) + t[a] * i;
    return n;
  };
}
function YJ(e) {
  return ArrayBuffer.isView(e) && !(e instanceof DataView);
}
function VJ(e, t) {
  var r = t ? t.length : 0, n = e ? Math.min(r, e.length) : 0, a = new Array(n), i = new Array(r), o;
  for (o = 0; o < n; ++o)
    a[o] = F2(e[o], t[o]);
  for (; o < r; ++o)
    i[o] = t[o];
  return function(s) {
    for (o = 0; o < n; ++o)
      i[o] = a[o](s);
    return i;
  };
}
function kJ(e, t) {
  var r = /* @__PURE__ */ new Date();
  return e = +e, t = +t, function(n) {
    return r.setTime(e * (1 - n) + t * n), r;
  };
}
function xs(e, t) {
  return e = +e, t = +t, function(r) {
    return e * (1 - r) + t * r;
  };
}
function GJ(e, t) {
  var r = {}, n = {}, a;
  (e === null || typeof e != "object") && (e = {}), (t === null || typeof t != "object") && (t = {});
  for (a in t)
    a in e ? r[a] = F2(e[a], t[a]) : n[a] = t[a];
  return function(i) {
    for (a in r)
      n[a] = r[a](i);
    return n;
  };
}
var D5 = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, J6 = new RegExp(D5.source, "g");
function WJ(e) {
  return function() {
    return e;
  };
}
function QJ(e) {
  return function(t) {
    return e(t) + "";
  };
}
function UJ(e, t) {
  var r = D5.lastIndex = J6.lastIndex = 0, n, a, i, o = -1, s = [], c = [];
  for (e = e + "", t = t + ""; (n = D5.exec(e)) && (a = J6.exec(t)); )
    (i = a.index) > r && (i = t.slice(r, i), s[o] ? s[o] += i : s[++o] = i), (n = n[0]) === (a = a[0]) ? s[o] ? s[o] += a : s[++o] = a : (s[++o] = null, c.push({ i: o, x: xs(n, a) })), r = J6.lastIndex;
  return r < t.length && (i = t.slice(r), s[o] ? s[o] += i : s[++o] = i), s.length < 2 ? c[0] ? QJ(c[0].x) : WJ(t) : (t = c.length, function(u) {
    for (var d = 0, h; d < t; ++d)
      s[(h = c[d]).i] = h.x(u);
    return s.join("");
  });
}
function F2(e, t) {
  var r = typeof t, n;
  return t == null || r === "boolean" ? I9(t) : (r === "number" ? xs : r === "string" ? (n = go(t)) ? (t = n, qA) : UJ : t instanceof go ? qA : t instanceof Date ? kJ : YJ(t) ? HJ : Array.isArray(t) ? VJ : typeof t.valueOf != "function" && typeof t.toString != "function" || isNaN(t) ? GJ : xs)(e, t);
}
function B9(e, t) {
  return e = +e, t = +t, function(r) {
    return Math.round(e * (1 - r) + t * r);
  };
}
function ZJ(e, t) {
  t === void 0 && (t = e, e = F2);
  for (var r = 0, n = t.length - 1, a = t[0], i = new Array(n < 0 ? 0 : n); r < n; )
    i[r] = e(a, a = t[++r]);
  return function(o) {
    var s = Math.max(0, Math.min(n - 1, Math.floor(o *= n)));
    return i[s](o - s);
  };
}
function zJ(e) {
  return function() {
    return e;
  };
}
function Os(e) {
  return +e;
}
var XA = [0, 1];
function tr(e) {
  return e;
}
function M5(e, t) {
  return (t -= e = +e) ? function(r) {
    return (r - e) / t;
  } : zJ(isNaN(t) ? NaN : 0.5);
}
function KJ(e, t) {
  var r;
  return e > t && (r = e, e = t, t = r), function(n) {
    return Math.max(e, Math.min(t, n));
  };
}
function qJ(e, t, r) {
  var n = e[0], a = e[1], i = t[0], o = t[1];
  return a < n ? (n = M5(a, n), i = r(o, i)) : (n = M5(n, a), i = r(i, o)), function(s) {
    return i(n(s));
  };
}
function XJ(e, t, r) {
  var n = Math.min(e.length, t.length) - 1, a = new Array(n), i = new Array(n), o = -1;
  for (e[n] < e[0] && (e = e.slice().reverse(), t = t.slice().reverse()); ++o < n; )
    a[o] = M5(e[o], e[o + 1]), i[o] = r(t[o], t[o + 1]);
  return function(s) {
    var c = Ko(e, s, 1, n) - 1;
    return i[c](a[c](s));
  };
}
function Xo(e, t) {
  return t.domain(e.domain()).range(e.range()).interpolate(e.interpolate()).clamp(e.clamp()).unknown(e.unknown());
}
function L0() {
  var e = XA, t = XA, r = F2, n, a, i, o = tr, s, c, u;
  function d() {
    var A = Math.min(e.length, t.length);
    return o !== tr && (o = KJ(e[0], e[A - 1])), s = A > 2 ? XJ : qJ, c = u = null, h;
  }
  function h(A) {
    return A == null || isNaN(A = +A) ? i : (c || (c = s(e.map(n), t, r)))(n(o(A)));
  }
  return h.invert = function(A) {
    return o(a((u || (u = s(t, e.map(n), xs)))(A)));
  }, h.domain = function(A) {
    return arguments.length ? (e = Array.from(A, Os), d()) : e.slice();
  }, h.range = function(A) {
    return arguments.length ? (t = Array.from(A), d()) : t.slice();
  }, h.rangeRound = function(A) {
    return t = Array.from(A), r = B9, d();
  }, h.clamp = function(A) {
    return arguments.length ? (o = A ? !0 : tr, d()) : o !== tr;
  }, h.interpolate = function(A) {
    return arguments.length ? (r = A, d()) : r;
  }, h.unknown = function(A) {
    return arguments.length ? (i = A, h) : i;
  }, function(A, p) {
    return n = A, a = p, d();
  };
}
function N9() {
  return L0()(tr, tr);
}
function JJ(e) {
  return Math.abs(e = Math.round(e)) >= 1e21 ? e.toLocaleString("en").replace(/,/g, "") : e.toString(10);
}
function Ds(e, t) {
  if ((r = (e = t ? e.toExponential(t - 1) : e.toExponential()).indexOf("e")) < 0)
    return null;
  var r, n = e.slice(0, r);
  return [
    n.length > 1 ? n[0] + n.slice(2) : n,
    +e.slice(r + 1)
  ];
}
function t2(e) {
  return e = Ds(Math.abs(e)), e ? e[1] : NaN;
}
function eee(e, t) {
  return function(r, n) {
    for (var a = r.length, i = [], o = 0, s = e[0], c = 0; a > 0 && s > 0 && (c + s + 1 > n && (s = Math.max(1, n - c)), i.push(r.substring(a -= s, a + s)), !((c += s + 1) > n)); )
      s = e[o = (o + 1) % e.length];
    return i.reverse().join(t);
  };
}
function tee(e) {
  return function(t) {
    return t.replace(/[0-9]/g, function(r) {
      return e[+r];
    });
  };
}
var ree = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
function mo(e) {
  if (!(t = ree.exec(e)))
    throw new Error("invalid format: " + e);
  var t;
  return new _9({
    fill: t[1],
    align: t[2],
    sign: t[3],
    symbol: t[4],
    zero: t[5],
    width: t[6],
    comma: t[7],
    precision: t[8] && t[8].slice(1),
    trim: t[9],
    type: t[10]
  });
}
mo.prototype = _9.prototype;
function _9(e) {
  this.fill = e.fill === void 0 ? " " : e.fill + "", this.align = e.align === void 0 ? ">" : e.align + "", this.sign = e.sign === void 0 ? "-" : e.sign + "", this.symbol = e.symbol === void 0 ? "" : e.symbol + "", this.zero = !!e.zero, this.width = e.width === void 0 ? void 0 : +e.width, this.comma = !!e.comma, this.precision = e.precision === void 0 ? void 0 : +e.precision, this.trim = !!e.trim, this.type = e.type === void 0 ? "" : e.type + "";
}
_9.prototype.toString = function() {
  return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width === void 0 ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision === void 0 ? "" : "." + Math.max(0, this.precision | 0)) + (this.trim ? "~" : "") + this.type;
};
function nee(e) {
  e:
    for (var t = e.length, r = 1, n = -1, a; r < t; ++r)
      switch (e[r]) {
        case ".":
          n = a = r;
          break;
        case "0":
          n === 0 && (n = r), a = r;
          break;
        default:
          if (!+e[r])
            break e;
          n > 0 && (n = 0);
          break;
      }
  return n > 0 ? e.slice(0, n) + e.slice(a + 1) : e;
}
var uw;
function aee(e, t) {
  var r = Ds(e, t);
  if (!r)
    return e + "";
  var n = r[0], a = r[1], i = a - (uw = Math.max(-8, Math.min(8, Math.floor(a / 3))) * 3) + 1, o = n.length;
  return i === o ? n : i > o ? n + new Array(i - o + 1).join("0") : i > 0 ? n.slice(0, i) + "." + n.slice(i) : "0." + new Array(1 - i).join("0") + Ds(e, Math.max(0, t + i - 1))[0];
}
function JA(e, t) {
  var r = Ds(e, t);
  if (!r)
    return e + "";
  var n = r[0], a = r[1];
  return a < 0 ? "0." + new Array(-a).join("0") + n : n.length > a + 1 ? n.slice(0, a + 1) + "." + n.slice(a + 1) : n + new Array(a - n.length + 2).join("0");
}
const ep = {
  "%": (e, t) => (e * 100).toFixed(t),
  b: (e) => Math.round(e).toString(2),
  c: (e) => e + "",
  d: JJ,
  e: (e, t) => e.toExponential(t),
  f: (e, t) => e.toFixed(t),
  g: (e, t) => e.toPrecision(t),
  o: (e) => Math.round(e).toString(8),
  p: (e, t) => JA(e * 100, t),
  r: JA,
  s: aee,
  X: (e) => Math.round(e).toString(16).toUpperCase(),
  x: (e) => Math.round(e).toString(16)
};
function tp(e) {
  return e;
}
var rp = Array.prototype.map, np = ["y", "z", "a", "f", "p", "n", "µ", "m", "", "k", "M", "G", "T", "P", "E", "Z", "Y"];
function iee(e) {
  var t = e.grouping === void 0 || e.thousands === void 0 ? tp : eee(rp.call(e.grouping, Number), e.thousands + ""), r = e.currency === void 0 ? "" : e.currency[0] + "", n = e.currency === void 0 ? "" : e.currency[1] + "", a = e.decimal === void 0 ? "." : e.decimal + "", i = e.numerals === void 0 ? tp : tee(rp.call(e.numerals, String)), o = e.percent === void 0 ? "%" : e.percent + "", s = e.minus === void 0 ? "−" : e.minus + "", c = e.nan === void 0 ? "NaN" : e.nan + "";
  function u(h) {
    h = mo(h);
    var A = h.fill, p = h.align, m = h.sign, g = h.symbol, v = h.zero, C = h.width, y = h.comma, w = h.precision, O = h.trim, b = h.type;
    b === "n" ? (y = !0, b = "g") : ep[b] || (w === void 0 && (w = 12), O = !0, b = "g"), (v || A === "0" && p === "=") && (v = !0, A = "0", p = "=");
    var D = g === "$" ? r : g === "#" && /[boxX]/.test(b) ? "0" + b.toLowerCase() : "", M = g === "$" ? n : /[%p]/.test(b) ? o : "", j = ep[b], P = /[defgprs%]/.test(b);
    w = w === void 0 ? 6 : /[gprs]/.test(b) ? Math.max(1, Math.min(21, w)) : Math.max(0, Math.min(20, w));
    function H(F) {
      var R = D, N = M, z, q, J;
      if (b === "c")
        N = j(F) + N, F = "";
      else {
        F = +F;
        var W = F < 0 || 1 / F < 0;
        if (F = isNaN(F) ? c : j(Math.abs(F), w), O && (F = nee(F)), W && +F == 0 && m !== "+" && (W = !1), R = (W ? m === "(" ? m : s : m === "-" || m === "(" ? "" : m) + R, N = (b === "s" ? np[8 + uw / 3] : "") + N + (W && m === "(" ? ")" : ""), P) {
          for (z = -1, q = F.length; ++z < q; )
            if (J = F.charCodeAt(z), 48 > J || J > 57) {
              N = (J === 46 ? a + F.slice(z + 1) : F.slice(z)) + N, F = F.slice(0, z);
              break;
            }
        }
      }
      y && !v && (F = t(F, 1 / 0));
      var te = R.length + F.length + N.length, S = te < C ? new Array(C - te + 1).join(A) : "";
      switch (y && v && (F = t(S + F, S.length ? C - N.length : 1 / 0), S = ""), p) {
        case "<":
          F = R + F + N + S;
          break;
        case "=":
          F = R + S + F + N;
          break;
        case "^":
          F = S.slice(0, te = S.length >> 1) + R + F + N + S.slice(te);
          break;
        default:
          F = S + R + F + N;
          break;
      }
      return i(F);
    }
    return H.toString = function() {
      return h + "";
    }, H;
  }
  function d(h, A) {
    var p = u((h = mo(h), h.type = "f", h)), m = Math.max(-8, Math.min(8, Math.floor(t2(A) / 3))) * 3, g = Math.pow(10, -m), v = np[8 + m / 3];
    return function(C) {
      return p(g * C) + v;
    };
  }
  return {
    format: u,
    formatPrefix: d
  };
}
var S3, L9, fw;
oee({
  thousands: ",",
  grouping: [3],
  currency: ["$", ""]
});
function oee(e) {
  return S3 = iee(e), L9 = S3.format, fw = S3.formatPrefix, S3;
}
function see(e) {
  return Math.max(0, -t2(Math.abs(e)));
}
function lee(e, t) {
  return Math.max(0, Math.max(-8, Math.min(8, Math.floor(t2(t) / 3))) * 3 - t2(Math.abs(e)));
}
function cee(e, t) {
  return e = Math.abs(e), t = Math.abs(t) - e, Math.max(0, t2(t) - t2(e)) + 1;
}
function dw(e, t, r, n) {
  var a = w5(e, t, r), i;
  switch (n = mo(n ?? ",f"), n.type) {
    case "s": {
      var o = Math.max(Math.abs(e), Math.abs(t));
      return n.precision == null && !isNaN(i = lee(a, o)) && (n.precision = i), fw(n, o);
    }
    case "":
    case "e":
    case "g":
    case "p":
    case "r": {
      n.precision == null && !isNaN(i = cee(a, Math.max(Math.abs(e), Math.abs(t)))) && (n.precision = i - (n.type === "e"));
      break;
    }
    case "f":
    case "%": {
      n.precision == null && !isNaN(i = see(a)) && (n.precision = i - (n.type === "%") * 2);
      break;
    }
  }
  return L9(n);
}
function m1(e) {
  var t = e.domain;
  return e.ticks = function(r) {
    var n = t();
    return b5(n[0], n[n.length - 1], r ?? 10);
  }, e.tickFormat = function(r, n) {
    var a = t();
    return dw(a[0], a[a.length - 1], r ?? 10, n);
  }, e.nice = function(r) {
    r == null && (r = 10);
    var n = t(), a = 0, i = n.length - 1, o = n[a], s = n[i], c, u, d = 10;
    for (s < o && (u = o, o = s, s = u, u = a, a = i, i = u); d-- > 0; ) {
      if (u = y5(o, s, r), u === c)
        return n[a] = o, n[i] = s, t(n);
      if (u > 0)
        o = Math.floor(o / u) * u, s = Math.ceil(s / u) * u;
      else if (u < 0)
        o = Math.ceil(o * u) / u, s = Math.floor(s * u) / u;
      else
        break;
      c = u;
    }
    return e;
  }, e;
}
function Ms() {
  var e = N9();
  return e.copy = function() {
    return Xo(e, Ms());
  }, Tr.apply(e, arguments), m1(e);
}
function hw(e) {
  var t;
  function r(n) {
    return n == null || isNaN(n = +n) ? t : n;
  }
  return r.invert = r, r.domain = r.range = function(n) {
    return arguments.length ? (e = Array.from(n, Os), r) : e.slice();
  }, r.unknown = function(n) {
    return arguments.length ? (t = n, r) : t;
  }, r.copy = function() {
    return hw(e).unknown(t);
  }, e = arguments.length ? Array.from(e, Os) : [0, 1], m1(r);
}
function Aw(e, t) {
  e = e.slice();
  var r = 0, n = e.length - 1, a = e[r], i = e[n], o;
  return i < a && (o = r, r = n, n = o, o = a, a = i, i = o), e[r] = t.floor(a), e[n] = t.ceil(i), e;
}
function ap(e) {
  return Math.log(e);
}
function ip(e) {
  return Math.exp(e);
}
function uee(e) {
  return -Math.log(-e);
}
function fee(e) {
  return -Math.exp(-e);
}
function dee(e) {
  return isFinite(e) ? +("1e" + e) : e < 0 ? 0 : e;
}
function hee(e) {
  return e === 10 ? dee : e === Math.E ? Math.exp : (t) => Math.pow(e, t);
}
function Aee(e) {
  return e === Math.E ? Math.log : e === 10 && Math.log10 || e === 2 && Math.log2 || (e = Math.log(e), (t) => Math.log(t) / e);
}
function op(e) {
  return (t, r) => -e(-t, r);
}
function T9(e) {
  const t = e(ap, ip), r = t.domain;
  let n = 10, a, i;
  function o() {
    return a = Aee(n), i = hee(n), r()[0] < 0 ? (a = op(a), i = op(i), e(uee, fee)) : e(ap, ip), t;
  }
  return t.base = function(s) {
    return arguments.length ? (n = +s, o()) : n;
  }, t.domain = function(s) {
    return arguments.length ? (r(s), o()) : r();
  }, t.ticks = (s) => {
    const c = r();
    let u = c[0], d = c[c.length - 1];
    const h = d < u;
    h && ([u, d] = [d, u]);
    let A = a(u), p = a(d), m, g;
    const v = s == null ? 10 : +s;
    let C = [];
    if (!(n % 1) && p - A < v) {
      if (A = Math.floor(A), p = Math.ceil(p), u > 0) {
        for (; A <= p; ++A)
          for (m = 1; m < n; ++m)
            if (g = A < 0 ? m / i(-A) : m * i(A), !(g < u)) {
              if (g > d)
                break;
              C.push(g);
            }
      } else
        for (; A <= p; ++A)
          for (m = n - 1; m >= 1; --m)
            if (g = A > 0 ? m / i(-A) : m * i(A), !(g < u)) {
              if (g > d)
                break;
              C.push(g);
            }
      C.length * 2 < v && (C = b5(u, d, v));
    } else
      C = b5(A, p, Math.min(p - A, v)).map(i);
    return h ? C.reverse() : C;
  }, t.tickFormat = (s, c) => {
    if (s == null && (s = 10), c == null && (c = n === 10 ? "s" : ","), typeof c != "function" && (!(n % 1) && (c = mo(c)).precision == null && (c.trim = !0), c = L9(c)), s === 1 / 0)
      return c;
    const u = Math.max(1, n * s / t.ticks().length);
    return (d) => {
      let h = d / i(Math.round(a(d)));
      return h * n < n - 0.5 && (h *= n), h <= u ? c(d) : "";
    };
  }, t.nice = () => r(Aw(r(), {
    floor: (s) => i(Math.floor(a(s))),
    ceil: (s) => i(Math.ceil(a(s)))
  })), t;
}
function pw() {
  const e = T9(L0()).domain([1, 10]);
  return e.copy = () => Xo(e, pw()).base(e.base()), Tr.apply(e, arguments), e;
}
function sp(e) {
  return function(t) {
    return Math.sign(t) * Math.log1p(Math.abs(t / e));
  };
}
function lp(e) {
  return function(t) {
    return Math.sign(t) * Math.expm1(Math.abs(t)) * e;
  };
}
function R9(e) {
  var t = 1, r = e(sp(t), lp(t));
  return r.constant = function(n) {
    return arguments.length ? e(sp(t = +n), lp(t)) : t;
  }, m1(r);
}
function vw() {
  var e = R9(L0());
  return e.copy = function() {
    return Xo(e, vw()).constant(e.constant());
  }, Tr.apply(e, arguments);
}
function cp(e) {
  return function(t) {
    return t < 0 ? -Math.pow(-t, e) : Math.pow(t, e);
  };
}
function pee(e) {
  return e < 0 ? -Math.sqrt(-e) : Math.sqrt(e);
}
function vee(e) {
  return e < 0 ? -e * e : e * e;
}
function $9(e) {
  var t = e(tr, tr), r = 1;
  function n() {
    return r === 1 ? e(tr, tr) : r === 0.5 ? e(pee, vee) : e(cp(r), cp(1 / r));
  }
  return t.exponent = function(a) {
    return arguments.length ? (r = +a, n()) : r;
  }, m1(t);
}
function F9() {
  var e = $9(L0());
  return e.copy = function() {
    return Xo(e, F9()).exponent(e.exponent());
  }, Tr.apply(e, arguments), e;
}
function gee() {
  return F9.apply(null, arguments).exponent(0.5);
}
function up(e) {
  return Math.sign(e) * e * e;
}
function mee(e) {
  return Math.sign(e) * Math.sqrt(Math.abs(e));
}
function gw() {
  var e = N9(), t = [0, 1], r = !1, n;
  function a(i) {
    var o = mee(e(i));
    return isNaN(o) ? n : r ? Math.round(o) : o;
  }
  return a.invert = function(i) {
    return e.invert(up(i));
  }, a.domain = function(i) {
    return arguments.length ? (e.domain(i), a) : e.domain();
  }, a.range = function(i) {
    return arguments.length ? (e.range((t = Array.from(i, Os)).map(up)), a) : t.slice();
  }, a.rangeRound = function(i) {
    return a.range(i).round(!0);
  }, a.round = function(i) {
    return arguments.length ? (r = !!i, a) : r;
  }, a.clamp = function(i) {
    return arguments.length ? (e.clamp(i), a) : e.clamp();
  }, a.unknown = function(i) {
    return arguments.length ? (n = i, a) : n;
  }, a.copy = function() {
    return gw(e.domain(), t).round(r).clamp(e.clamp()).unknown(n);
  }, Tr.apply(a, arguments), m1(a);
}
function mw() {
  var e = [], t = [], r = [], n;
  function a() {
    var o = 0, s = Math.max(1, t.length);
    for (r = new Array(s - 1); ++o < s; )
      r[o - 1] = xJ(e, o / s);
    return i;
  }
  function i(o) {
    return o == null || isNaN(o = +o) ? n : t[Ko(r, o)];
  }
  return i.invertExtent = function(o) {
    var s = t.indexOf(o);
    return s < 0 ? [NaN, NaN] : [
      s > 0 ? r[s - 1] : e[0],
      s < r.length ? r[s] : e[e.length - 1]
    ];
  }, i.domain = function(o) {
    if (!arguments.length)
      return e.slice();
    e = [];
    for (let s of o)
      s != null && !isNaN(s = +s) && e.push(s);
    return e.sort(i1), a();
  }, i.range = function(o) {
    return arguments.length ? (t = Array.from(o), a()) : t.slice();
  }, i.unknown = function(o) {
    return arguments.length ? (n = o, i) : n;
  }, i.quantiles = function() {
    return r.slice();
  }, i.copy = function() {
    return mw().domain(e).range(t).unknown(n);
  }, Tr.apply(i, arguments);
}
function Cw() {
  var e = 0, t = 1, r = 1, n = [0.5], a = [0, 1], i;
  function o(c) {
    return c != null && c <= c ? a[Ko(n, c, 0, r)] : i;
  }
  function s() {
    var c = -1;
    for (n = new Array(r); ++c < r; )
      n[c] = ((c + 1) * t - (c - r) * e) / (r + 1);
    return o;
  }
  return o.domain = function(c) {
    return arguments.length ? ([e, t] = c, e = +e, t = +t, s()) : [e, t];
  }, o.range = function(c) {
    return arguments.length ? (r = (a = Array.from(c)).length - 1, s()) : a.slice();
  }, o.invertExtent = function(c) {
    var u = a.indexOf(c);
    return u < 0 ? [NaN, NaN] : u < 1 ? [e, n[0]] : u >= r ? [n[r - 1], t] : [n[u - 1], n[u]];
  }, o.unknown = function(c) {
    return arguments.length && (i = c), o;
  }, o.thresholds = function() {
    return n.slice();
  }, o.copy = function() {
    return Cw().domain([e, t]).range(a).unknown(i);
  }, Tr.apply(m1(o), arguments);
}
function bw() {
  var e = [0.5], t = [0, 1], r, n = 1;
  function a(i) {
    return i != null && i <= i ? t[Ko(e, i, 0, n)] : r;
  }
  return a.domain = function(i) {
    return arguments.length ? (e = Array.from(i), n = Math.min(e.length, t.length - 1), a) : e.slice();
  }, a.range = function(i) {
    return arguments.length ? (t = Array.from(i), n = Math.min(e.length, t.length - 1), a) : t.slice();
  }, a.invertExtent = function(i) {
    var o = t.indexOf(i);
    return [e[o - 1], e[o]];
  }, a.unknown = function(i) {
    return arguments.length ? (r = i, a) : r;
  }, a.copy = function() {
    return bw().domain(e).range(t).unknown(r);
  }, Tr.apply(a, arguments);
}
const e4 = /* @__PURE__ */ new Date(), t4 = /* @__PURE__ */ new Date();
function Lt(e, t, r, n) {
  function a(i) {
    return e(i = arguments.length === 0 ? /* @__PURE__ */ new Date() : /* @__PURE__ */ new Date(+i)), i;
  }
  return a.floor = (i) => (e(i = /* @__PURE__ */ new Date(+i)), i), a.ceil = (i) => (e(i = new Date(i - 1)), t(i, 1), e(i), i), a.round = (i) => {
    const o = a(i), s = a.ceil(i);
    return i - o < s - i ? o : s;
  }, a.offset = (i, o) => (t(i = /* @__PURE__ */ new Date(+i), o == null ? 1 : Math.floor(o)), i), a.range = (i, o, s) => {
    const c = [];
    if (i = a.ceil(i), s = s == null ? 1 : Math.floor(s), !(i < o) || !(s > 0))
      return c;
    let u;
    do
      c.push(u = /* @__PURE__ */ new Date(+i)), t(i, s), e(i);
    while (u < i && i < o);
    return c;
  }, a.filter = (i) => Lt((o) => {
    if (o >= o)
      for (; e(o), !i(o); )
        o.setTime(o - 1);
  }, (o, s) => {
    if (o >= o)
      if (s < 0)
        for (; ++s <= 0; )
          for (; t(o, -1), !i(o); )
            ;
      else
        for (; --s >= 0; )
          for (; t(o, 1), !i(o); )
            ;
  }), r && (a.count = (i, o) => (e4.setTime(+i), t4.setTime(+o), e(e4), e(t4), Math.floor(r(e4, t4))), a.every = (i) => (i = Math.floor(i), !isFinite(i) || !(i > 0) ? null : i > 1 ? a.filter(n ? (o) => n(o) % i === 0 : (o) => a.count(0, o) % i === 0) : a)), a;
}
const Es = Lt(() => {
}, (e, t) => {
  e.setTime(+e + t);
}, (e, t) => t - e);
Es.every = (e) => (e = Math.floor(e), !isFinite(e) || !(e > 0) ? null : e > 1 ? Lt((t) => {
  t.setTime(Math.floor(t / e) * e);
}, (t, r) => {
  t.setTime(+t + r * e);
}, (t, r) => (r - t) / e) : Es);
Es.range;
const bn = 1e3, jr = bn * 60, yn = jr * 60, En = yn * 24, H9 = En * 7, fp = En * 30, r4 = En * 365, U1 = Lt((e) => {
  e.setTime(e - e.getMilliseconds());
}, (e, t) => {
  e.setTime(+e + t * bn);
}, (e, t) => (t - e) / bn, (e) => e.getUTCSeconds());
U1.range;
const Y9 = Lt((e) => {
  e.setTime(e - e.getMilliseconds() - e.getSeconds() * bn);
}, (e, t) => {
  e.setTime(+e + t * jr);
}, (e, t) => (t - e) / jr, (e) => e.getMinutes());
Y9.range;
const V9 = Lt((e) => {
  e.setUTCSeconds(0, 0);
}, (e, t) => {
  e.setTime(+e + t * jr);
}, (e, t) => (t - e) / jr, (e) => e.getUTCMinutes());
V9.range;
const k9 = Lt((e) => {
  e.setTime(e - e.getMilliseconds() - e.getSeconds() * bn - e.getMinutes() * jr);
}, (e, t) => {
  e.setTime(+e + t * yn);
}, (e, t) => (t - e) / yn, (e) => e.getHours());
k9.range;
const G9 = Lt((e) => {
  e.setUTCMinutes(0, 0, 0);
}, (e, t) => {
  e.setTime(+e + t * yn);
}, (e, t) => (t - e) / yn, (e) => e.getUTCHours());
G9.range;
const Jo = Lt(
  (e) => e.setHours(0, 0, 0, 0),
  (e, t) => e.setDate(e.getDate() + t),
  (e, t) => (t - e - (t.getTimezoneOffset() - e.getTimezoneOffset()) * jr) / En,
  (e) => e.getDate() - 1
);
Jo.range;
const T0 = Lt((e) => {
  e.setUTCHours(0, 0, 0, 0);
}, (e, t) => {
  e.setUTCDate(e.getUTCDate() + t);
}, (e, t) => (t - e) / En, (e) => e.getUTCDate() - 1);
T0.range;
const yw = Lt((e) => {
  e.setUTCHours(0, 0, 0, 0);
}, (e, t) => {
  e.setUTCDate(e.getUTCDate() + t);
}, (e, t) => (t - e) / En, (e) => Math.floor(e / En));
yw.range;
function oa(e) {
  return Lt((t) => {
    t.setDate(t.getDate() - (t.getDay() + 7 - e) % 7), t.setHours(0, 0, 0, 0);
  }, (t, r) => {
    t.setDate(t.getDate() + r * 7);
  }, (t, r) => (r - t - (r.getTimezoneOffset() - t.getTimezoneOffset()) * jr) / H9);
}
const R0 = oa(0), Ps = oa(1), Cee = oa(2), bee = oa(3), r2 = oa(4), yee = oa(5), wee = oa(6);
R0.range;
Ps.range;
Cee.range;
bee.range;
r2.range;
yee.range;
wee.range;
function sa(e) {
  return Lt((t) => {
    t.setUTCDate(t.getUTCDate() - (t.getUTCDay() + 7 - e) % 7), t.setUTCHours(0, 0, 0, 0);
  }, (t, r) => {
    t.setUTCDate(t.getUTCDate() + r * 7);
  }, (t, r) => (r - t) / H9);
}
const $0 = sa(0), js = sa(1), xee = sa(2), Oee = sa(3), n2 = sa(4), Dee = sa(5), Mee = sa(6);
$0.range;
js.range;
xee.range;
Oee.range;
n2.range;
Dee.range;
Mee.range;
const W9 = Lt((e) => {
  e.setDate(1), e.setHours(0, 0, 0, 0);
}, (e, t) => {
  e.setMonth(e.getMonth() + t);
}, (e, t) => t.getMonth() - e.getMonth() + (t.getFullYear() - e.getFullYear()) * 12, (e) => e.getMonth());
W9.range;
const Q9 = Lt((e) => {
  e.setUTCDate(1), e.setUTCHours(0, 0, 0, 0);
}, (e, t) => {
  e.setUTCMonth(e.getUTCMonth() + t);
}, (e, t) => t.getUTCMonth() - e.getUTCMonth() + (t.getUTCFullYear() - e.getUTCFullYear()) * 12, (e) => e.getUTCMonth());
Q9.range;
const Pn = Lt((e) => {
  e.setMonth(0, 1), e.setHours(0, 0, 0, 0);
}, (e, t) => {
  e.setFullYear(e.getFullYear() + t);
}, (e, t) => t.getFullYear() - e.getFullYear(), (e) => e.getFullYear());
Pn.every = (e) => !isFinite(e = Math.floor(e)) || !(e > 0) ? null : Lt((t) => {
  t.setFullYear(Math.floor(t.getFullYear() / e) * e), t.setMonth(0, 1), t.setHours(0, 0, 0, 0);
}, (t, r) => {
  t.setFullYear(t.getFullYear() + r * e);
});
Pn.range;
const jn = Lt((e) => {
  e.setUTCMonth(0, 1), e.setUTCHours(0, 0, 0, 0);
}, (e, t) => {
  e.setUTCFullYear(e.getUTCFullYear() + t);
}, (e, t) => t.getUTCFullYear() - e.getUTCFullYear(), (e) => e.getUTCFullYear());
jn.every = (e) => !isFinite(e = Math.floor(e)) || !(e > 0) ? null : Lt((t) => {
  t.setUTCFullYear(Math.floor(t.getUTCFullYear() / e) * e), t.setUTCMonth(0, 1), t.setUTCHours(0, 0, 0, 0);
}, (t, r) => {
  t.setUTCFullYear(t.getUTCFullYear() + r * e);
});
jn.range;
function ww(e, t, r, n, a, i) {
  const o = [
    [U1, 1, bn],
    [U1, 5, 5 * bn],
    [U1, 15, 15 * bn],
    [U1, 30, 30 * bn],
    [i, 1, jr],
    [i, 5, 5 * jr],
    [i, 15, 15 * jr],
    [i, 30, 30 * jr],
    [a, 1, yn],
    [a, 3, 3 * yn],
    [a, 6, 6 * yn],
    [a, 12, 12 * yn],
    [n, 1, En],
    [n, 2, 2 * En],
    [r, 1, H9],
    [t, 1, fp],
    [t, 3, 3 * fp],
    [e, 1, r4]
  ];
  function s(u, d, h) {
    const A = d < u;
    A && ([u, d] = [d, u]);
    const p = h && typeof h.range == "function" ? h : c(u, d, h), m = p ? p.range(u, +d + 1) : [];
    return A ? m.reverse() : m;
  }
  function c(u, d, h) {
    const A = Math.abs(d - u) / h, p = P9(([, , v]) => v).right(o, A);
    if (p === o.length)
      return e.every(w5(u / r4, d / r4, h));
    if (p === 0)
      return Es.every(Math.max(w5(u, d, h), 1));
    const [m, g] = o[A / o[p - 1][2] < o[p][2] / A ? p - 1 : p];
    return m.every(g);
  }
  return [s, c];
}
const [Eee, Pee] = ww(jn, Q9, $0, yw, G9, V9), [jee, See] = ww(Pn, W9, R0, Jo, k9, Y9);
function n4(e) {
  if (0 <= e.y && e.y < 100) {
    var t = new Date(-1, e.m, e.d, e.H, e.M, e.S, e.L);
    return t.setFullYear(e.y), t;
  }
  return new Date(e.y, e.m, e.d, e.H, e.M, e.S, e.L);
}
function a4(e) {
  if (0 <= e.y && e.y < 100) {
    var t = new Date(Date.UTC(-1, e.m, e.d, e.H, e.M, e.S, e.L));
    return t.setUTCFullYear(e.y), t;
  }
  return new Date(Date.UTC(e.y, e.m, e.d, e.H, e.M, e.S, e.L));
}
function mi(e, t, r) {
  return { y: e, m: t, d: r, H: 0, M: 0, S: 0, L: 0 };
}
function Iee(e) {
  var t = e.dateTime, r = e.date, n = e.time, a = e.periods, i = e.days, o = e.shortDays, s = e.months, c = e.shortMonths, u = Ci(a), d = bi(a), h = Ci(i), A = bi(i), p = Ci(o), m = bi(o), g = Ci(s), v = bi(s), C = Ci(c), y = bi(c), w = {
    a: W,
    A: te,
    b: S,
    B: I,
    c: null,
    d: gp,
    e: gp,
    f: ete,
    g: ute,
    G: dte,
    H: qee,
    I: Xee,
    j: Jee,
    L: xw,
    m: tte,
    M: rte,
    p: T,
    q: E,
    Q: bp,
    s: yp,
    S: nte,
    u: ate,
    U: ite,
    V: ote,
    w: ste,
    W: lte,
    x: null,
    X: null,
    y: cte,
    Y: fte,
    Z: hte,
    "%": Cp
  }, O = {
    a: x,
    A: $,
    b: _,
    B: Q,
    c: null,
    d: mp,
    e: mp,
    f: gte,
    g: Ete,
    G: jte,
    H: Ate,
    I: pte,
    j: vte,
    L: Dw,
    m: mte,
    M: Cte,
    p: Z,
    q: X,
    Q: bp,
    s: yp,
    S: bte,
    u: yte,
    U: wte,
    V: xte,
    w: Ote,
    W: Dte,
    x: null,
    X: null,
    y: Mte,
    Y: Pte,
    Z: Ste,
    "%": Cp
  }, b = {
    a: H,
    A: F,
    b: R,
    B: N,
    c: z,
    d: pp,
    e: pp,
    f: Uee,
    g: Ap,
    G: hp,
    H: vp,
    I: vp,
    j: kee,
    L: Qee,
    m: Vee,
    M: Gee,
    p: P,
    q: Yee,
    Q: zee,
    s: Kee,
    S: Wee,
    u: Tee,
    U: Ree,
    V: $ee,
    w: Lee,
    W: Fee,
    x: q,
    X: J,
    y: Ap,
    Y: hp,
    Z: Hee,
    "%": Zee
  };
  w.x = D(r, w), w.X = D(n, w), w.c = D(t, w), O.x = D(r, O), O.X = D(n, O), O.c = D(t, O);
  function D(Y, U) {
    return function(k) {
      var L = [], ee = -1, V = 0, ne = Y.length, ie, le, de;
      for (k instanceof Date || (k = /* @__PURE__ */ new Date(+k)); ++ee < ne; )
        Y.charCodeAt(ee) === 37 && (L.push(Y.slice(V, ee)), (le = dp[ie = Y.charAt(++ee)]) != null ? ie = Y.charAt(++ee) : le = ie === "e" ? " " : "0", (de = U[ie]) && (ie = de(k, le)), L.push(ie), V = ee + 1);
      return L.push(Y.slice(V, ee)), L.join("");
    };
  }
  function M(Y, U) {
    return function(k) {
      var L = mi(1900, void 0, 1), ee = j(L, Y, k += "", 0), V, ne;
      if (ee != k.length)
        return null;
      if ("Q" in L)
        return new Date(L.Q);
      if ("s" in L)
        return new Date(L.s * 1e3 + ("L" in L ? L.L : 0));
      if (U && !("Z" in L) && (L.Z = 0), "p" in L && (L.H = L.H % 12 + L.p * 12), L.m === void 0 && (L.m = "q" in L ? L.q : 0), "V" in L) {
        if (L.V < 1 || L.V > 53)
          return null;
        "w" in L || (L.w = 1), "Z" in L ? (V = a4(mi(L.y, 0, 1)), ne = V.getUTCDay(), V = ne > 4 || ne === 0 ? js.ceil(V) : js(V), V = T0.offset(V, (L.V - 1) * 7), L.y = V.getUTCFullYear(), L.m = V.getUTCMonth(), L.d = V.getUTCDate() + (L.w + 6) % 7) : (V = n4(mi(L.y, 0, 1)), ne = V.getDay(), V = ne > 4 || ne === 0 ? Ps.ceil(V) : Ps(V), V = Jo.offset(V, (L.V - 1) * 7), L.y = V.getFullYear(), L.m = V.getMonth(), L.d = V.getDate() + (L.w + 6) % 7);
      } else
        ("W" in L || "U" in L) && ("w" in L || (L.w = "u" in L ? L.u % 7 : "W" in L ? 1 : 0), ne = "Z" in L ? a4(mi(L.y, 0, 1)).getUTCDay() : n4(mi(L.y, 0, 1)).getDay(), L.m = 0, L.d = "W" in L ? (L.w + 6) % 7 + L.W * 7 - (ne + 5) % 7 : L.w + L.U * 7 - (ne + 6) % 7);
      return "Z" in L ? (L.H += L.Z / 100 | 0, L.M += L.Z % 100, a4(L)) : n4(L);
    };
  }
  function j(Y, U, k, L) {
    for (var ee = 0, V = U.length, ne = k.length, ie, le; ee < V; ) {
      if (L >= ne)
        return -1;
      if (ie = U.charCodeAt(ee++), ie === 37) {
        if (ie = U.charAt(ee++), le = b[ie in dp ? U.charAt(ee++) : ie], !le || (L = le(Y, k, L)) < 0)
          return -1;
      } else if (ie != k.charCodeAt(L++))
        return -1;
    }
    return L;
  }
  function P(Y, U, k) {
    var L = u.exec(U.slice(k));
    return L ? (Y.p = d.get(L[0].toLowerCase()), k + L[0].length) : -1;
  }
  function H(Y, U, k) {
    var L = p.exec(U.slice(k));
    return L ? (Y.w = m.get(L[0].toLowerCase()), k + L[0].length) : -1;
  }
  function F(Y, U, k) {
    var L = h.exec(U.slice(k));
    return L ? (Y.w = A.get(L[0].toLowerCase()), k + L[0].length) : -1;
  }
  function R(Y, U, k) {
    var L = C.exec(U.slice(k));
    return L ? (Y.m = y.get(L[0].toLowerCase()), k + L[0].length) : -1;
  }
  function N(Y, U, k) {
    var L = g.exec(U.slice(k));
    return L ? (Y.m = v.get(L[0].toLowerCase()), k + L[0].length) : -1;
  }
  function z(Y, U, k) {
    return j(Y, t, U, k);
  }
  function q(Y, U, k) {
    return j(Y, r, U, k);
  }
  function J(Y, U, k) {
    return j(Y, n, U, k);
  }
  function W(Y) {
    return o[Y.getDay()];
  }
  function te(Y) {
    return i[Y.getDay()];
  }
  function S(Y) {
    return c[Y.getMonth()];
  }
  function I(Y) {
    return s[Y.getMonth()];
  }
  function T(Y) {
    return a[+(Y.getHours() >= 12)];
  }
  function E(Y) {
    return 1 + ~~(Y.getMonth() / 3);
  }
  function x(Y) {
    return o[Y.getUTCDay()];
  }
  function $(Y) {
    return i[Y.getUTCDay()];
  }
  function _(Y) {
    return c[Y.getUTCMonth()];
  }
  function Q(Y) {
    return s[Y.getUTCMonth()];
  }
  function Z(Y) {
    return a[+(Y.getUTCHours() >= 12)];
  }
  function X(Y) {
    return 1 + ~~(Y.getUTCMonth() / 3);
  }
  return {
    format: function(Y) {
      var U = D(Y += "", w);
      return U.toString = function() {
        return Y;
      }, U;
    },
    parse: function(Y) {
      var U = M(Y += "", !1);
      return U.toString = function() {
        return Y;
      }, U;
    },
    utcFormat: function(Y) {
      var U = D(Y += "", O);
      return U.toString = function() {
        return Y;
      }, U;
    },
    utcParse: function(Y) {
      var U = M(Y += "", !0);
      return U.toString = function() {
        return Y;
      }, U;
    }
  };
}
var dp = { "-": "", _: " ", 0: "0" }, Yt = /^\s*\d+/, Bee = /^%/, Nee = /[\\^$*+?|[\]().{}]/g;
function ke(e, t, r) {
  var n = e < 0 ? "-" : "", a = (n ? -e : e) + "", i = a.length;
  return n + (i < r ? new Array(r - i + 1).join(t) + a : a);
}
function _ee(e) {
  return e.replace(Nee, "\\$&");
}
function Ci(e) {
  return new RegExp("^(?:" + e.map(_ee).join("|") + ")", "i");
}
function bi(e) {
  return new Map(e.map((t, r) => [t.toLowerCase(), r]));
}
function Lee(e, t, r) {
  var n = Yt.exec(t.slice(r, r + 1));
  return n ? (e.w = +n[0], r + n[0].length) : -1;
}
function Tee(e, t, r) {
  var n = Yt.exec(t.slice(r, r + 1));
  return n ? (e.u = +n[0], r + n[0].length) : -1;
}
function Ree(e, t, r) {
  var n = Yt.exec(t.slice(r, r + 2));
  return n ? (e.U = +n[0], r + n[0].length) : -1;
}
function $ee(e, t, r) {
  var n = Yt.exec(t.slice(r, r + 2));
  return n ? (e.V = +n[0], r + n[0].length) : -1;
}
function Fee(e, t, r) {
  var n = Yt.exec(t.slice(r, r + 2));
  return n ? (e.W = +n[0], r + n[0].length) : -1;
}
function hp(e, t, r) {
  var n = Yt.exec(t.slice(r, r + 4));
  return n ? (e.y = +n[0], r + n[0].length) : -1;
}
function Ap(e, t, r) {
  var n = Yt.exec(t.slice(r, r + 2));
  return n ? (e.y = +n[0] + (+n[0] > 68 ? 1900 : 2e3), r + n[0].length) : -1;
}
function Hee(e, t, r) {
  var n = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(t.slice(r, r + 6));
  return n ? (e.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), r + n[0].length) : -1;
}
function Yee(e, t, r) {
  var n = Yt.exec(t.slice(r, r + 1));
  return n ? (e.q = n[0] * 3 - 3, r + n[0].length) : -1;
}
function Vee(e, t, r) {
  var n = Yt.exec(t.slice(r, r + 2));
  return n ? (e.m = n[0] - 1, r + n[0].length) : -1;
}
function pp(e, t, r) {
  var n = Yt.exec(t.slice(r, r + 2));
  return n ? (e.d = +n[0], r + n[0].length) : -1;
}
function kee(e, t, r) {
  var n = Yt.exec(t.slice(r, r + 3));
  return n ? (e.m = 0, e.d = +n[0], r + n[0].length) : -1;
}
function vp(e, t, r) {
  var n = Yt.exec(t.slice(r, r + 2));
  return n ? (e.H = +n[0], r + n[0].length) : -1;
}
function Gee(e, t, r) {
  var n = Yt.exec(t.slice(r, r + 2));
  return n ? (e.M = +n[0], r + n[0].length) : -1;
}
function Wee(e, t, r) {
  var n = Yt.exec(t.slice(r, r + 2));
  return n ? (e.S = +n[0], r + n[0].length) : -1;
}
function Qee(e, t, r) {
  var n = Yt.exec(t.slice(r, r + 3));
  return n ? (e.L = +n[0], r + n[0].length) : -1;
}
function Uee(e, t, r) {
  var n = Yt.exec(t.slice(r, r + 6));
  return n ? (e.L = Math.floor(n[0] / 1e3), r + n[0].length) : -1;
}
function Zee(e, t, r) {
  var n = Bee.exec(t.slice(r, r + 1));
  return n ? r + n[0].length : -1;
}
function zee(e, t, r) {
  var n = Yt.exec(t.slice(r));
  return n ? (e.Q = +n[0], r + n[0].length) : -1;
}
function Kee(e, t, r) {
  var n = Yt.exec(t.slice(r));
  return n ? (e.s = +n[0], r + n[0].length) : -1;
}
function gp(e, t) {
  return ke(e.getDate(), t, 2);
}
function qee(e, t) {
  return ke(e.getHours(), t, 2);
}
function Xee(e, t) {
  return ke(e.getHours() % 12 || 12, t, 2);
}
function Jee(e, t) {
  return ke(1 + Jo.count(Pn(e), e), t, 3);
}
function xw(e, t) {
  return ke(e.getMilliseconds(), t, 3);
}
function ete(e, t) {
  return xw(e, t) + "000";
}
function tte(e, t) {
  return ke(e.getMonth() + 1, t, 2);
}
function rte(e, t) {
  return ke(e.getMinutes(), t, 2);
}
function nte(e, t) {
  return ke(e.getSeconds(), t, 2);
}
function ate(e) {
  var t = e.getDay();
  return t === 0 ? 7 : t;
}
function ite(e, t) {
  return ke(R0.count(Pn(e) - 1, e), t, 2);
}
function Ow(e) {
  var t = e.getDay();
  return t >= 4 || t === 0 ? r2(e) : r2.ceil(e);
}
function ote(e, t) {
  return e = Ow(e), ke(r2.count(Pn(e), e) + (Pn(e).getDay() === 4), t, 2);
}
function ste(e) {
  return e.getDay();
}
function lte(e, t) {
  return ke(Ps.count(Pn(e) - 1, e), t, 2);
}
function cte(e, t) {
  return ke(e.getFullYear() % 100, t, 2);
}
function ute(e, t) {
  return e = Ow(e), ke(e.getFullYear() % 100, t, 2);
}
function fte(e, t) {
  return ke(e.getFullYear() % 1e4, t, 4);
}
function dte(e, t) {
  var r = e.getDay();
  return e = r >= 4 || r === 0 ? r2(e) : r2.ceil(e), ke(e.getFullYear() % 1e4, t, 4);
}
function hte(e) {
  var t = e.getTimezoneOffset();
  return (t > 0 ? "-" : (t *= -1, "+")) + ke(t / 60 | 0, "0", 2) + ke(t % 60, "0", 2);
}
function mp(e, t) {
  return ke(e.getUTCDate(), t, 2);
}
function Ate(e, t) {
  return ke(e.getUTCHours(), t, 2);
}
function pte(e, t) {
  return ke(e.getUTCHours() % 12 || 12, t, 2);
}
function vte(e, t) {
  return ke(1 + T0.count(jn(e), e), t, 3);
}
function Dw(e, t) {
  return ke(e.getUTCMilliseconds(), t, 3);
}
function gte(e, t) {
  return Dw(e, t) + "000";
}
function mte(e, t) {
  return ke(e.getUTCMonth() + 1, t, 2);
}
function Cte(e, t) {
  return ke(e.getUTCMinutes(), t, 2);
}
function bte(e, t) {
  return ke(e.getUTCSeconds(), t, 2);
}
function yte(e) {
  var t = e.getUTCDay();
  return t === 0 ? 7 : t;
}
function wte(e, t) {
  return ke($0.count(jn(e) - 1, e), t, 2);
}
function Mw(e) {
  var t = e.getUTCDay();
  return t >= 4 || t === 0 ? n2(e) : n2.ceil(e);
}
function xte(e, t) {
  return e = Mw(e), ke(n2.count(jn(e), e) + (jn(e).getUTCDay() === 4), t, 2);
}
function Ote(e) {
  return e.getUTCDay();
}
function Dte(e, t) {
  return ke(js.count(jn(e) - 1, e), t, 2);
}
function Mte(e, t) {
  return ke(e.getUTCFullYear() % 100, t, 2);
}
function Ete(e, t) {
  return e = Mw(e), ke(e.getUTCFullYear() % 100, t, 2);
}
function Pte(e, t) {
  return ke(e.getUTCFullYear() % 1e4, t, 4);
}
function jte(e, t) {
  var r = e.getUTCDay();
  return e = r >= 4 || r === 0 ? n2(e) : n2.ceil(e), ke(e.getUTCFullYear() % 1e4, t, 4);
}
function Ste() {
  return "+0000";
}
function Cp() {
  return "%";
}
function bp(e) {
  return +e;
}
function yp(e) {
  return Math.floor(+e / 1e3);
}
var Ea, Ew, Pw;
Ite({
  dateTime: "%x, %X",
  date: "%-m/%-d/%Y",
  time: "%-I:%M:%S %p",
  periods: ["AM", "PM"],
  days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
  shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
  shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
});
function Ite(e) {
  return Ea = Iee(e), Ew = Ea.format, Ea.parse, Pw = Ea.utcFormat, Ea.utcParse, Ea;
}
function Bte(e) {
  return new Date(e);
}
function Nte(e) {
  return e instanceof Date ? +e : +/* @__PURE__ */ new Date(+e);
}
function U9(e, t, r, n, a, i, o, s, c, u) {
  var d = N9(), h = d.invert, A = d.domain, p = u(".%L"), m = u(":%S"), g = u("%I:%M"), v = u("%I %p"), C = u("%a %d"), y = u("%b %d"), w = u("%B"), O = u("%Y");
  function b(D) {
    return (c(D) < D ? p : s(D) < D ? m : o(D) < D ? g : i(D) < D ? v : n(D) < D ? a(D) < D ? C : y : r(D) < D ? w : O)(D);
  }
  return d.invert = function(D) {
    return new Date(h(D));
  }, d.domain = function(D) {
    return arguments.length ? A(Array.from(D, Nte)) : A().map(Bte);
  }, d.ticks = function(D) {
    var M = A();
    return e(M[0], M[M.length - 1], D ?? 10);
  }, d.tickFormat = function(D, M) {
    return M == null ? b : u(M);
  }, d.nice = function(D) {
    var M = A();
    return (!D || typeof D.range != "function") && (D = t(M[0], M[M.length - 1], D ?? 10)), D ? A(Aw(M, D)) : d;
  }, d.copy = function() {
    return Xo(d, U9(e, t, r, n, a, i, o, s, c, u));
  }, d;
}
function _te() {
  return Tr.apply(U9(jee, See, Pn, W9, R0, Jo, k9, Y9, U1, Ew).domain([new Date(2e3, 0, 1), new Date(2e3, 0, 2)]), arguments);
}
function Lte() {
  return Tr.apply(U9(Eee, Pee, jn, Q9, $0, T0, G9, V9, U1, Pw).domain([Date.UTC(2e3, 0, 1), Date.UTC(2e3, 0, 2)]), arguments);
}
function F0() {
  var e = 0, t = 1, r, n, a, i, o = tr, s = !1, c;
  function u(h) {
    return h == null || isNaN(h = +h) ? c : o(a === 0 ? 0.5 : (h = (i(h) - r) * a, s ? Math.max(0, Math.min(1, h)) : h));
  }
  u.domain = function(h) {
    return arguments.length ? ([e, t] = h, r = i(e = +e), n = i(t = +t), a = r === n ? 0 : 1 / (n - r), u) : [e, t];
  }, u.clamp = function(h) {
    return arguments.length ? (s = !!h, u) : s;
  }, u.interpolator = function(h) {
    return arguments.length ? (o = h, u) : o;
  };
  function d(h) {
    return function(A) {
      var p, m;
      return arguments.length ? ([p, m] = A, o = h(p, m), u) : [o(0), o(1)];
    };
  }
  return u.range = d(F2), u.rangeRound = d(B9), u.unknown = function(h) {
    return arguments.length ? (c = h, u) : c;
  }, function(h) {
    return i = h, r = h(e), n = h(t), a = r === n ? 0 : 1 / (n - r), u;
  };
}
function C1(e, t) {
  return t.domain(e.domain()).interpolator(e.interpolator()).clamp(e.clamp()).unknown(e.unknown());
}
function jw() {
  var e = m1(F0()(tr));
  return e.copy = function() {
    return C1(e, jw());
  }, _n.apply(e, arguments);
}
function Sw() {
  var e = T9(F0()).domain([1, 10]);
  return e.copy = function() {
    return C1(e, Sw()).base(e.base());
  }, _n.apply(e, arguments);
}
function Iw() {
  var e = R9(F0());
  return e.copy = function() {
    return C1(e, Iw()).constant(e.constant());
  }, _n.apply(e, arguments);
}
function Z9() {
  var e = $9(F0());
  return e.copy = function() {
    return C1(e, Z9()).exponent(e.exponent());
  }, _n.apply(e, arguments);
}
function Tte() {
  return Z9.apply(null, arguments).exponent(0.5);
}
function Bw() {
  var e = [], t = tr;
  function r(n) {
    if (n != null && !isNaN(n = +n))
      return t((Ko(e, n, 1) - 1) / (e.length - 1));
  }
  return r.domain = function(n) {
    if (!arguments.length)
      return e.slice();
    e = [];
    for (let a of n)
      a != null && !isNaN(a = +a) && e.push(a);
    return e.sort(i1), r;
  }, r.interpolator = function(n) {
    return arguments.length ? (t = n, r) : t;
  }, r.range = function() {
    return e.map((n, a) => t(a / (e.length - 1)));
  }, r.quantiles = function(n) {
    return Array.from({ length: n + 1 }, (a, i) => wJ(e, i / n));
  }, r.copy = function() {
    return Bw(t).domain(e);
  }, _n.apply(r, arguments);
}
function H0() {
  var e = 0, t = 0.5, r = 1, n = 1, a, i, o, s, c, u = tr, d, h = !1, A;
  function p(g) {
    return isNaN(g = +g) ? A : (g = 0.5 + ((g = +d(g)) - i) * (n * g < n * i ? s : c), u(h ? Math.max(0, Math.min(1, g)) : g));
  }
  p.domain = function(g) {
    return arguments.length ? ([e, t, r] = g, a = d(e = +e), i = d(t = +t), o = d(r = +r), s = a === i ? 0 : 0.5 / (i - a), c = i === o ? 0 : 0.5 / (o - i), n = i < a ? -1 : 1, p) : [e, t, r];
  }, p.clamp = function(g) {
    return arguments.length ? (h = !!g, p) : h;
  }, p.interpolator = function(g) {
    return arguments.length ? (u = g, p) : u;
  };
  function m(g) {
    return function(v) {
      var C, y, w;
      return arguments.length ? ([C, y, w] = v, u = ZJ(g, [C, y, w]), p) : [u(0), u(0.5), u(1)];
    };
  }
  return p.range = m(F2), p.rangeRound = m(B9), p.unknown = function(g) {
    return arguments.length ? (A = g, p) : A;
  }, function(g) {
    return d = g, a = g(e), i = g(t), o = g(r), s = a === i ? 0 : 0.5 / (i - a), c = i === o ? 0 : 0.5 / (o - i), n = i < a ? -1 : 1, p;
  };
}
function Nw() {
  var e = m1(H0()(tr));
  return e.copy = function() {
    return C1(e, Nw());
  }, _n.apply(e, arguments);
}
function _w() {
  var e = T9(H0()).domain([0.1, 1, 10]);
  return e.copy = function() {
    return C1(e, _w()).base(e.base());
  }, _n.apply(e, arguments);
}
function Lw() {
  var e = R9(H0());
  return e.copy = function() {
    return C1(e, Lw()).constant(e.constant());
  }, _n.apply(e, arguments);
}
function z9() {
  var e = $9(H0());
  return e.copy = function() {
    return C1(e, z9()).exponent(e.exponent());
  }, _n.apply(e, arguments);
}
function Rte() {
  return z9.apply(null, arguments).exponent(0.5);
}
const wp = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  scaleBand: Ao,
  scaleDiverging: Nw,
  scaleDivergingLog: _w,
  scaleDivergingPow: z9,
  scaleDivergingSqrt: Rte,
  scaleDivergingSymlog: Lw,
  scaleIdentity: hw,
  scaleImplicit: x5,
  scaleLinear: Ms,
  scaleLog: pw,
  scaleOrdinal: j9,
  scalePoint: Gi,
  scalePow: F9,
  scaleQuantile: mw,
  scaleQuantize: Cw,
  scaleRadial: gw,
  scaleSequential: jw,
  scaleSequentialLog: Sw,
  scaleSequentialPow: Z9,
  scaleSequentialQuantile: Bw,
  scaleSequentialSqrt: Tte,
  scaleSequentialSymlog: Iw,
  scaleSqrt: gee,
  scaleSymlog: vw,
  scaleThreshold: bw,
  scaleTime: _te,
  scaleUtc: Lte,
  tickFormat: dw
}, Symbol.toStringTag, { value: "Module" }));
var $te = j2;
function Fte(e, t, r) {
  for (var n = -1, a = e.length; ++n < a; ) {
    var i = e[n], o = t(i);
    if (o != null && (s === void 0 ? o === o && !$te(o) : r(o, s)))
      var s = o, c = i;
  }
  return c;
}
var Y0 = Fte;
function Hte(e, t) {
  return e > t;
}
var Tw = Hte, Yte = Y0, Vte = Tw, kte = R2;
function Gte(e) {
  return e && e.length ? Yte(e, kte, Vte) : void 0;
}
var Wte = Gte;
const Xn = /* @__PURE__ */ qe(Wte);
function Qte(e, t) {
  return e < t;
}
var Rw = Qte, Ute = Y0, Zte = Rw, zte = R2;
function Kte(e) {
  return e && e.length ? Ute(e, zte, Zte) : void 0;
}
var qte = Kte;
const V0 = /* @__PURE__ */ qe(qte);
var Xte = d9, Jte = dn, ere = Wy, tre = or;
function rre(e, t) {
  var r = tre(e) ? Xte : ere;
  return r(e, Jte(t));
}
var nre = rre, are = ky, ire = nre;
function ore(e, t) {
  return are(ire(e, t), 1);
}
var sre = ore;
const lre = /* @__PURE__ */ qe(sre);
var cre = O9;
function ure(e, t) {
  return cre(e, t);
}
var fre = ure;
const u1 = /* @__PURE__ */ qe(fre);
var H2 = 1e9, dre = {
  // These values must be integers within the stated ranges (inclusive).
  // Most of these values can be changed during run-time using `Decimal.config`.
  // The maximum number of significant digits of the result of a calculation or base conversion.
  // E.g. `Decimal.config({ precision: 20 });`
  precision: 20,
  // 1 to MAX_DIGITS
  // The rounding mode used by default by `toInteger`, `toDecimalPlaces`, `toExponential`,
  // `toFixed`, `toPrecision` and `toSignificantDigits`.
  //
  // ROUND_UP         0 Away from zero.
  // ROUND_DOWN       1 Towards zero.
  // ROUND_CEIL       2 Towards +Infinity.
  // ROUND_FLOOR      3 Towards -Infinity.
  // ROUND_HALF_UP    4 Towards nearest neighbour. If equidistant, up.
  // ROUND_HALF_DOWN  5 Towards nearest neighbour. If equidistant, down.
  // ROUND_HALF_EVEN  6 Towards nearest neighbour. If equidistant, towards even neighbour.
  // ROUND_HALF_CEIL  7 Towards nearest neighbour. If equidistant, towards +Infinity.
  // ROUND_HALF_FLOOR 8 Towards nearest neighbour. If equidistant, towards -Infinity.
  //
  // E.g.
  // `Decimal.rounding = 4;`
  // `Decimal.rounding = Decimal.ROUND_HALF_UP;`
  rounding: 4,
  // 0 to 8
  // The exponent value at and beneath which `toString` returns exponential notation.
  // JavaScript numbers: -7
  toExpNeg: -7,
  // 0 to -MAX_E
  // The exponent value at and above which `toString` returns exponential notation.
  // JavaScript numbers: 21
  toExpPos: 21,
  // 0 to MAX_E
  // The natural logarithm of 10.
  // 115 digits
  LN10: "2.302585092994045684017991454684364207601101488628772976033327900967572609677352480235997205089598298341967784042286"
}, q9, Ct = !0, _r = "[DecimalError] ", X1 = _r + "Invalid argument: ", K9 = _r + "Exponent out of range: ", Y2 = Math.floor, H1 = Math.pow, hre = /^(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i, Ar, $t = 1e7, pt = 7, $w = 9007199254740991, Ss = Y2($w / pt), he = {};
he.absoluteValue = he.abs = function() {
  var e = new this.constructor(this);
  return e.s && (e.s = 1), e;
};
he.comparedTo = he.cmp = function(e) {
  var t, r, n, a, i = this;
  if (e = new i.constructor(e), i.s !== e.s)
    return i.s || -e.s;
  if (i.e !== e.e)
    return i.e > e.e ^ i.s < 0 ? 1 : -1;
  for (n = i.d.length, a = e.d.length, t = 0, r = n < a ? n : a; t < r; ++t)
    if (i.d[t] !== e.d[t])
      return i.d[t] > e.d[t] ^ i.s < 0 ? 1 : -1;
  return n === a ? 0 : n > a ^ i.s < 0 ? 1 : -1;
};
he.decimalPlaces = he.dp = function() {
  var e = this, t = e.d.length - 1, r = (t - e.e) * pt;
  if (t = e.d[t], t)
    for (; t % 10 == 0; t /= 10)
      r--;
  return r < 0 ? 0 : r;
};
he.dividedBy = he.div = function(e) {
  return Mn(this, new this.constructor(e));
};
he.dividedToIntegerBy = he.idiv = function(e) {
  var t = this, r = t.constructor;
  return it(Mn(t, new r(e), 0, 1), r.precision);
};
he.equals = he.eq = function(e) {
  return !this.cmp(e);
};
he.exponent = function() {
  return Pt(this);
};
he.greaterThan = he.gt = function(e) {
  return this.cmp(e) > 0;
};
he.greaterThanOrEqualTo = he.gte = function(e) {
  return this.cmp(e) >= 0;
};
he.isInteger = he.isint = function() {
  return this.e > this.d.length - 2;
};
he.isNegative = he.isneg = function() {
  return this.s < 0;
};
he.isPositive = he.ispos = function() {
  return this.s > 0;
};
he.isZero = function() {
  return this.s === 0;
};
he.lessThan = he.lt = function(e) {
  return this.cmp(e) < 0;
};
he.lessThanOrEqualTo = he.lte = function(e) {
  return this.cmp(e) < 1;
};
he.logarithm = he.log = function(e) {
  var t, r = this, n = r.constructor, a = n.precision, i = a + 5;
  if (e === void 0)
    e = new n(10);
  else if (e = new n(e), e.s < 1 || e.eq(Ar))
    throw Error(_r + "NaN");
  if (r.s < 1)
    throw Error(_r + (r.s ? "NaN" : "-Infinity"));
  return r.eq(Ar) ? new n(0) : (Ct = !1, t = Mn(Co(r, i), Co(e, i), i), Ct = !0, it(t, a));
};
he.minus = he.sub = function(e) {
  var t = this;
  return e = new t.constructor(e), t.s == e.s ? Yw(t, e) : Fw(t, (e.s = -e.s, e));
};
he.modulo = he.mod = function(e) {
  var t, r = this, n = r.constructor, a = n.precision;
  if (e = new n(e), !e.s)
    throw Error(_r + "NaN");
  return r.s ? (Ct = !1, t = Mn(r, e, 0, 1).times(e), Ct = !0, r.minus(t)) : it(new n(r), a);
};
he.naturalExponential = he.exp = function() {
  return Hw(this);
};
he.naturalLogarithm = he.ln = function() {
  return Co(this);
};
he.negated = he.neg = function() {
  var e = new this.constructor(this);
  return e.s = -e.s || 0, e;
};
he.plus = he.add = function(e) {
  var t = this;
  return e = new t.constructor(e), t.s == e.s ? Fw(t, e) : Yw(t, (e.s = -e.s, e));
};
he.precision = he.sd = function(e) {
  var t, r, n, a = this;
  if (e !== void 0 && e !== !!e && e !== 1 && e !== 0)
    throw Error(X1 + e);
  if (t = Pt(a) + 1, n = a.d.length - 1, r = n * pt + 1, n = a.d[n], n) {
    for (; n % 10 == 0; n /= 10)
      r--;
    for (n = a.d[0]; n >= 10; n /= 10)
      r++;
  }
  return e && t > r ? t : r;
};
he.squareRoot = he.sqrt = function() {
  var e, t, r, n, a, i, o, s = this, c = s.constructor;
  if (s.s < 1) {
    if (!s.s)
      return new c(0);
    throw Error(_r + "NaN");
  }
  for (e = Pt(s), Ct = !1, a = Math.sqrt(+s), a == 0 || a == 1 / 0 ? (t = an(s.d), (t.length + e) % 2 == 0 && (t += "0"), a = Math.sqrt(t), e = Y2((e + 1) / 2) - (e < 0 || e % 2), a == 1 / 0 ? t = "5e" + e : (t = a.toExponential(), t = t.slice(0, t.indexOf("e") + 1) + e), n = new c(t)) : n = new c(a.toString()), r = c.precision, a = o = r + 3; ; )
    if (i = n, n = i.plus(Mn(s, i, o + 2)).times(0.5), an(i.d).slice(0, o) === (t = an(n.d)).slice(0, o)) {
      if (t = t.slice(o - 3, o + 1), a == o && t == "4999") {
        if (it(i, r + 1, 0), i.times(i).eq(s)) {
          n = i;
          break;
        }
      } else if (t != "9999")
        break;
      o += 4;
    }
  return Ct = !0, it(n, r);
};
he.times = he.mul = function(e) {
  var t, r, n, a, i, o, s, c, u, d = this, h = d.constructor, A = d.d, p = (e = new h(e)).d;
  if (!d.s || !e.s)
    return new h(0);
  for (e.s *= d.s, r = d.e + e.e, c = A.length, u = p.length, c < u && (i = A, A = p, p = i, o = c, c = u, u = o), i = [], o = c + u, n = o; n--; )
    i.push(0);
  for (n = u; --n >= 0; ) {
    for (t = 0, a = c + n; a > n; )
      s = i[a] + p[n] * A[a - n - 1] + t, i[a--] = s % $t | 0, t = s / $t | 0;
    i[a] = (i[a] + t) % $t | 0;
  }
  for (; !i[--o]; )
    i.pop();
  return t ? ++r : i.shift(), e.d = i, e.e = r, Ct ? it(e, h.precision) : e;
};
he.toDecimalPlaces = he.todp = function(e, t) {
  var r = this, n = r.constructor;
  return r = new n(r), e === void 0 ? r : (cn(e, 0, H2), t === void 0 ? t = n.rounding : cn(t, 0, 8), it(r, e + Pt(r) + 1, t));
};
he.toExponential = function(e, t) {
  var r, n = this, a = n.constructor;
  return e === void 0 ? r = ra(n, !0) : (cn(e, 0, H2), t === void 0 ? t = a.rounding : cn(t, 0, 8), n = it(new a(n), e + 1, t), r = ra(n, !0, e + 1)), r;
};
he.toFixed = function(e, t) {
  var r, n, a = this, i = a.constructor;
  return e === void 0 ? ra(a) : (cn(e, 0, H2), t === void 0 ? t = i.rounding : cn(t, 0, 8), n = it(new i(a), e + Pt(a) + 1, t), r = ra(n.abs(), !1, e + Pt(n) + 1), a.isneg() && !a.isZero() ? "-" + r : r);
};
he.toInteger = he.toint = function() {
  var e = this, t = e.constructor;
  return it(new t(e), Pt(e) + 1, t.rounding);
};
he.toNumber = function() {
  return +this;
};
he.toPower = he.pow = function(e) {
  var t, r, n, a, i, o, s = this, c = s.constructor, u = 12, d = +(e = new c(e));
  if (!e.s)
    return new c(Ar);
  if (s = new c(s), !s.s) {
    if (e.s < 1)
      throw Error(_r + "Infinity");
    return s;
  }
  if (s.eq(Ar))
    return s;
  if (n = c.precision, e.eq(Ar))
    return it(s, n);
  if (t = e.e, r = e.d.length - 1, o = t >= r, i = s.s, o) {
    if ((r = d < 0 ? -d : d) <= $w) {
      for (a = new c(Ar), t = Math.ceil(n / pt + 4), Ct = !1; r % 2 && (a = a.times(s), Op(a.d, t)), r = Y2(r / 2), r !== 0; )
        s = s.times(s), Op(s.d, t);
      return Ct = !0, e.s < 0 ? new c(Ar).div(a) : it(a, n);
    }
  } else if (i < 0)
    throw Error(_r + "NaN");
  return i = i < 0 && e.d[Math.max(t, r)] & 1 ? -1 : 1, s.s = 1, Ct = !1, a = e.times(Co(s, n + u)), Ct = !0, a = Hw(a), a.s = i, a;
};
he.toPrecision = function(e, t) {
  var r, n, a = this, i = a.constructor;
  return e === void 0 ? (r = Pt(a), n = ra(a, r <= i.toExpNeg || r >= i.toExpPos)) : (cn(e, 1, H2), t === void 0 ? t = i.rounding : cn(t, 0, 8), a = it(new i(a), e, t), r = Pt(a), n = ra(a, e <= r || r <= i.toExpNeg, e)), n;
};
he.toSignificantDigits = he.tosd = function(e, t) {
  var r = this, n = r.constructor;
  return e === void 0 ? (e = n.precision, t = n.rounding) : (cn(e, 1, H2), t === void 0 ? t = n.rounding : cn(t, 0, 8)), it(new n(r), e, t);
};
he.toString = he.valueOf = he.val = he.toJSON = he[Symbol.for("nodejs.util.inspect.custom")] = function() {
  var e = this, t = Pt(e), r = e.constructor;
  return ra(e, t <= r.toExpNeg || t >= r.toExpPos);
};
function Fw(e, t) {
  var r, n, a, i, o, s, c, u, d = e.constructor, h = d.precision;
  if (!e.s || !t.s)
    return t.s || (t = new d(e)), Ct ? it(t, h) : t;
  if (c = e.d, u = t.d, o = e.e, a = t.e, c = c.slice(), i = o - a, i) {
    for (i < 0 ? (n = c, i = -i, s = u.length) : (n = u, a = o, s = c.length), o = Math.ceil(h / pt), s = o > s ? o + 1 : s + 1, i > s && (i = s, n.length = 1), n.reverse(); i--; )
      n.push(0);
    n.reverse();
  }
  for (s = c.length, i = u.length, s - i < 0 && (i = s, n = u, u = c, c = n), r = 0; i; )
    r = (c[--i] = c[i] + u[i] + r) / $t | 0, c[i] %= $t;
  for (r && (c.unshift(r), ++a), s = c.length; c[--s] == 0; )
    c.pop();
  return t.d = c, t.e = a, Ct ? it(t, h) : t;
}
function cn(e, t, r) {
  if (e !== ~~e || e < t || e > r)
    throw Error(X1 + e);
}
function an(e) {
  var t, r, n, a = e.length - 1, i = "", o = e[0];
  if (a > 0) {
    for (i += o, t = 1; t < a; t++)
      n = e[t] + "", r = pt - n.length, r && (i += Kn(r)), i += n;
    o = e[t], n = o + "", r = pt - n.length, r && (i += Kn(r));
  } else if (o === 0)
    return "0";
  for (; o % 10 === 0; )
    o /= 10;
  return i + o;
}
var Mn = function() {
  function e(n, a) {
    var i, o = 0, s = n.length;
    for (n = n.slice(); s--; )
      i = n[s] * a + o, n[s] = i % $t | 0, o = i / $t | 0;
    return o && n.unshift(o), n;
  }
  function t(n, a, i, o) {
    var s, c;
    if (i != o)
      c = i > o ? 1 : -1;
    else
      for (s = c = 0; s < i; s++)
        if (n[s] != a[s]) {
          c = n[s] > a[s] ? 1 : -1;
          break;
        }
    return c;
  }
  function r(n, a, i) {
    for (var o = 0; i--; )
      n[i] -= o, o = n[i] < a[i] ? 1 : 0, n[i] = o * $t + n[i] - a[i];
    for (; !n[0] && n.length > 1; )
      n.shift();
  }
  return function(n, a, i, o) {
    var s, c, u, d, h, A, p, m, g, v, C, y, w, O, b, D, M, j, P = n.constructor, H = n.s == a.s ? 1 : -1, F = n.d, R = a.d;
    if (!n.s)
      return new P(n);
    if (!a.s)
      throw Error(_r + "Division by zero");
    for (c = n.e - a.e, M = R.length, b = F.length, p = new P(H), m = p.d = [], u = 0; R[u] == (F[u] || 0); )
      ++u;
    if (R[u] > (F[u] || 0) && --c, i == null ? y = i = P.precision : o ? y = i + (Pt(n) - Pt(a)) + 1 : y = i, y < 0)
      return new P(0);
    if (y = y / pt + 2 | 0, u = 0, M == 1)
      for (d = 0, R = R[0], y++; (u < b || d) && y--; u++)
        w = d * $t + (F[u] || 0), m[u] = w / R | 0, d = w % R | 0;
    else {
      for (d = $t / (R[0] + 1) | 0, d > 1 && (R = e(R, d), F = e(F, d), M = R.length, b = F.length), O = M, g = F.slice(0, M), v = g.length; v < M; )
        g[v++] = 0;
      j = R.slice(), j.unshift(0), D = R[0], R[1] >= $t / 2 && ++D;
      do
        d = 0, s = t(R, g, M, v), s < 0 ? (C = g[0], M != v && (C = C * $t + (g[1] || 0)), d = C / D | 0, d > 1 ? (d >= $t && (d = $t - 1), h = e(R, d), A = h.length, v = g.length, s = t(h, g, A, v), s == 1 && (d--, r(h, M < A ? j : R, A))) : (d == 0 && (s = d = 1), h = R.slice()), A = h.length, A < v && h.unshift(0), r(g, h, v), s == -1 && (v = g.length, s = t(R, g, M, v), s < 1 && (d++, r(g, M < v ? j : R, v))), v = g.length) : s === 0 && (d++, g = [0]), m[u++] = d, s && g[0] ? g[v++] = F[O] || 0 : (g = [F[O]], v = 1);
      while ((O++ < b || g[0] !== void 0) && y--);
    }
    return m[0] || m.shift(), p.e = c, it(p, o ? i + Pt(p) + 1 : i);
  };
}();
function Hw(e, t) {
  var r, n, a, i, o, s, c = 0, u = 0, d = e.constructor, h = d.precision;
  if (Pt(e) > 16)
    throw Error(K9 + Pt(e));
  if (!e.s)
    return new d(Ar);
  for (t == null ? (Ct = !1, s = h) : s = t, o = new d(0.03125); e.abs().gte(0.1); )
    e = e.times(o), u += 5;
  for (n = Math.log(H1(2, u)) / Math.LN10 * 2 + 5 | 0, s += n, r = a = i = new d(Ar), d.precision = s; ; ) {
    if (a = it(a.times(e), s), r = r.times(++c), o = i.plus(Mn(a, r, s)), an(o.d).slice(0, s) === an(i.d).slice(0, s)) {
      for (; u--; )
        i = it(i.times(i), s);
      return d.precision = h, t == null ? (Ct = !0, it(i, h)) : i;
    }
    i = o;
  }
}
function Pt(e) {
  for (var t = e.e * pt, r = e.d[0]; r >= 10; r /= 10)
    t++;
  return t;
}
function i4(e, t, r) {
  if (t > e.LN10.sd())
    throw Ct = !0, r && (e.precision = r), Error(_r + "LN10 precision limit exceeded");
  return it(new e(e.LN10), t);
}
function Kn(e) {
  for (var t = ""; e--; )
    t += "0";
  return t;
}
function Co(e, t) {
  var r, n, a, i, o, s, c, u, d, h = 1, A = 10, p = e, m = p.d, g = p.constructor, v = g.precision;
  if (p.s < 1)
    throw Error(_r + (p.s ? "NaN" : "-Infinity"));
  if (p.eq(Ar))
    return new g(0);
  if (t == null ? (Ct = !1, u = v) : u = t, p.eq(10))
    return t == null && (Ct = !0), i4(g, u);
  if (u += A, g.precision = u, r = an(m), n = r.charAt(0), i = Pt(p), Math.abs(i) < 15e14) {
    for (; n < 7 && n != 1 || n == 1 && r.charAt(1) > 3; )
      p = p.times(e), r = an(p.d), n = r.charAt(0), h++;
    i = Pt(p), n > 1 ? (p = new g("0." + r), i++) : p = new g(n + "." + r.slice(1));
  } else
    return c = i4(g, u + 2, v).times(i + ""), p = Co(new g(n + "." + r.slice(1)), u - A).plus(c), g.precision = v, t == null ? (Ct = !0, it(p, v)) : p;
  for (s = o = p = Mn(p.minus(Ar), p.plus(Ar), u), d = it(p.times(p), u), a = 3; ; ) {
    if (o = it(o.times(d), u), c = s.plus(Mn(o, new g(a), u)), an(c.d).slice(0, u) === an(s.d).slice(0, u))
      return s = s.times(2), i !== 0 && (s = s.plus(i4(g, u + 2, v).times(i + ""))), s = Mn(s, new g(h), u), g.precision = v, t == null ? (Ct = !0, it(s, v)) : s;
    s = c, a += 2;
  }
}
function xp(e, t) {
  var r, n, a;
  for ((r = t.indexOf(".")) > -1 && (t = t.replace(".", "")), (n = t.search(/e/i)) > 0 ? (r < 0 && (r = n), r += +t.slice(n + 1), t = t.substring(0, n)) : r < 0 && (r = t.length), n = 0; t.charCodeAt(n) === 48; )
    ++n;
  for (a = t.length; t.charCodeAt(a - 1) === 48; )
    --a;
  if (t = t.slice(n, a), t) {
    if (a -= n, r = r - n - 1, e.e = Y2(r / pt), e.d = [], n = (r + 1) % pt, r < 0 && (n += pt), n < a) {
      for (n && e.d.push(+t.slice(0, n)), a -= pt; n < a; )
        e.d.push(+t.slice(n, n += pt));
      t = t.slice(n), n = pt - t.length;
    } else
      n -= a;
    for (; n--; )
      t += "0";
    if (e.d.push(+t), Ct && (e.e > Ss || e.e < -Ss))
      throw Error(K9 + r);
  } else
    e.s = 0, e.e = 0, e.d = [0];
  return e;
}
function it(e, t, r) {
  var n, a, i, o, s, c, u, d, h = e.d;
  for (o = 1, i = h[0]; i >= 10; i /= 10)
    o++;
  if (n = t - o, n < 0)
    n += pt, a = t, u = h[d = 0];
  else {
    if (d = Math.ceil((n + 1) / pt), i = h.length, d >= i)
      return e;
    for (u = i = h[d], o = 1; i >= 10; i /= 10)
      o++;
    n %= pt, a = n - pt + o;
  }
  if (r !== void 0 && (i = H1(10, o - a - 1), s = u / i % 10 | 0, c = t < 0 || h[d + 1] !== void 0 || u % i, c = r < 4 ? (s || c) && (r == 0 || r == (e.s < 0 ? 3 : 2)) : s > 5 || s == 5 && (r == 4 || c || r == 6 && // Check whether the digit to the left of the rounding digit is odd.
  (n > 0 ? a > 0 ? u / H1(10, o - a) : 0 : h[d - 1]) % 10 & 1 || r == (e.s < 0 ? 8 : 7))), t < 1 || !h[0])
    return c ? (i = Pt(e), h.length = 1, t = t - i - 1, h[0] = H1(10, (pt - t % pt) % pt), e.e = Y2(-t / pt) || 0) : (h.length = 1, h[0] = e.e = e.s = 0), e;
  if (n == 0 ? (h.length = d, i = 1, d--) : (h.length = d + 1, i = H1(10, pt - n), h[d] = a > 0 ? (u / H1(10, o - a) % H1(10, a) | 0) * i : 0), c)
    for (; ; )
      if (d == 0) {
        (h[0] += i) == $t && (h[0] = 1, ++e.e);
        break;
      } else {
        if (h[d] += i, h[d] != $t)
          break;
        h[d--] = 0, i = 1;
      }
  for (n = h.length; h[--n] === 0; )
    h.pop();
  if (Ct && (e.e > Ss || e.e < -Ss))
    throw Error(K9 + Pt(e));
  return e;
}
function Yw(e, t) {
  var r, n, a, i, o, s, c, u, d, h, A = e.constructor, p = A.precision;
  if (!e.s || !t.s)
    return t.s ? t.s = -t.s : t = new A(e), Ct ? it(t, p) : t;
  if (c = e.d, h = t.d, n = t.e, u = e.e, c = c.slice(), o = u - n, o) {
    for (d = o < 0, d ? (r = c, o = -o, s = h.length) : (r = h, n = u, s = c.length), a = Math.max(Math.ceil(p / pt), s) + 2, o > a && (o = a, r.length = 1), r.reverse(), a = o; a--; )
      r.push(0);
    r.reverse();
  } else {
    for (a = c.length, s = h.length, d = a < s, d && (s = a), a = 0; a < s; a++)
      if (c[a] != h[a]) {
        d = c[a] < h[a];
        break;
      }
    o = 0;
  }
  for (d && (r = c, c = h, h = r, t.s = -t.s), s = c.length, a = h.length - s; a > 0; --a)
    c[s++] = 0;
  for (a = h.length; a > o; ) {
    if (c[--a] < h[a]) {
      for (i = a; i && c[--i] === 0; )
        c[i] = $t - 1;
      --c[i], c[a] += $t;
    }
    c[a] -= h[a];
  }
  for (; c[--s] === 0; )
    c.pop();
  for (; c[0] === 0; c.shift())
    --n;
  return c[0] ? (t.d = c, t.e = n, Ct ? it(t, p) : t) : new A(0);
}
function ra(e, t, r) {
  var n, a = Pt(e), i = an(e.d), o = i.length;
  return t ? (r && (n = r - o) > 0 ? i = i.charAt(0) + "." + i.slice(1) + Kn(n) : o > 1 && (i = i.charAt(0) + "." + i.slice(1)), i = i + (a < 0 ? "e" : "e+") + a) : a < 0 ? (i = "0." + Kn(-a - 1) + i, r && (n = r - o) > 0 && (i += Kn(n))) : a >= o ? (i += Kn(a + 1 - o), r && (n = r - a - 1) > 0 && (i = i + "." + Kn(n))) : ((n = a + 1) < o && (i = i.slice(0, n) + "." + i.slice(n)), r && (n = r - o) > 0 && (a + 1 === o && (i += "."), i += Kn(n))), e.s < 0 ? "-" + i : i;
}
function Op(e, t) {
  if (e.length > t)
    return e.length = t, !0;
}
function Vw(e) {
  var t, r, n;
  function a(i) {
    var o = this;
    if (!(o instanceof a))
      return new a(i);
    if (o.constructor = a, i instanceof a) {
      o.s = i.s, o.e = i.e, o.d = (i = i.d) ? i.slice() : i;
      return;
    }
    if (typeof i == "number") {
      if (i * 0 !== 0)
        throw Error(X1 + i);
      if (i > 0)
        o.s = 1;
      else if (i < 0)
        i = -i, o.s = -1;
      else {
        o.s = 0, o.e = 0, o.d = [0];
        return;
      }
      if (i === ~~i && i < 1e7) {
        o.e = 0, o.d = [i];
        return;
      }
      return xp(o, i.toString());
    } else if (typeof i != "string")
      throw Error(X1 + i);
    if (i.charCodeAt(0) === 45 ? (i = i.slice(1), o.s = -1) : o.s = 1, hre.test(i))
      xp(o, i);
    else
      throw Error(X1 + i);
  }
  if (a.prototype = he, a.ROUND_UP = 0, a.ROUND_DOWN = 1, a.ROUND_CEIL = 2, a.ROUND_FLOOR = 3, a.ROUND_HALF_UP = 4, a.ROUND_HALF_DOWN = 5, a.ROUND_HALF_EVEN = 6, a.ROUND_HALF_CEIL = 7, a.ROUND_HALF_FLOOR = 8, a.clone = Vw, a.config = a.set = Are, e === void 0 && (e = {}), e)
    for (n = ["precision", "rounding", "toExpNeg", "toExpPos", "LN10"], t = 0; t < n.length; )
      e.hasOwnProperty(r = n[t++]) || (e[r] = this[r]);
  return a.config(e), a;
}
function Are(e) {
  if (!e || typeof e != "object")
    throw Error(_r + "Object expected");
  var t, r, n, a = [
    "precision",
    1,
    H2,
    "rounding",
    0,
    8,
    "toExpNeg",
    -1 / 0,
    0,
    "toExpPos",
    0,
    1 / 0
  ];
  for (t = 0; t < a.length; t += 3)
    if ((n = e[r = a[t]]) !== void 0)
      if (Y2(n) === n && n >= a[t + 1] && n <= a[t + 2])
        this[r] = n;
      else
        throw Error(X1 + r + ": " + n);
  if ((n = e[r = "LN10"]) !== void 0)
    if (n == Math.LN10)
      this[r] = new this(n);
    else
      throw Error(X1 + r + ": " + n);
  return this;
}
var q9 = Vw(dre);
Ar = new q9(1);
const nt = q9;
function pre(e) {
  return Cre(e) || mre(e) || gre(e) || vre();
}
function vre() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function gre(e, t) {
  if (e) {
    if (typeof e == "string")
      return E5(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return E5(e, t);
  }
}
function mre(e) {
  if (typeof Symbol < "u" && Symbol.iterator in Object(e))
    return Array.from(e);
}
function Cre(e) {
  if (Array.isArray(e))
    return E5(e);
}
function E5(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
var bre = function(t) {
  return t;
}, kw = {
  "@@functional/placeholder": !0
}, Gw = function(t) {
  return t === kw;
}, Dp = function(t) {
  return function r() {
    return arguments.length === 0 || arguments.length === 1 && Gw(arguments.length <= 0 ? void 0 : arguments[0]) ? r : t.apply(void 0, arguments);
  };
}, yre = function e(t, r) {
  return t === 1 ? r : Dp(function() {
    for (var n = arguments.length, a = new Array(n), i = 0; i < n; i++)
      a[i] = arguments[i];
    var o = a.filter(function(s) {
      return s !== kw;
    }).length;
    return o >= t ? r.apply(void 0, a) : e(t - o, Dp(function() {
      for (var s = arguments.length, c = new Array(s), u = 0; u < s; u++)
        c[u] = arguments[u];
      var d = a.map(function(h) {
        return Gw(h) ? c.shift() : h;
      });
      return r.apply(void 0, pre(d).concat(c));
    }));
  });
}, k0 = function(t) {
  return yre(t.length, t);
}, P5 = function(t, r) {
  for (var n = [], a = t; a < r; ++a)
    n[a - t] = a;
  return n;
}, wre = k0(function(e, t) {
  return Array.isArray(t) ? t.map(e) : Object.keys(t).map(function(r) {
    return t[r];
  }).map(e);
}), xre = function() {
  for (var t = arguments.length, r = new Array(t), n = 0; n < t; n++)
    r[n] = arguments[n];
  if (!r.length)
    return bre;
  var a = r.reverse(), i = a[0], o = a.slice(1);
  return function() {
    return o.reduce(function(s, c) {
      return c(s);
    }, i.apply(void 0, arguments));
  };
}, j5 = function(t) {
  return Array.isArray(t) ? t.reverse() : t.split("").reverse.join("");
}, Ww = function(t) {
  var r = null, n = null;
  return function() {
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return r && i.every(function(s, c) {
      return s === r[c];
    }) || (r = i, n = t.apply(void 0, i)), n;
  };
};
function Ore(e) {
  var t;
  return e === 0 ? t = 1 : t = Math.floor(new nt(e).abs().log(10).toNumber()) + 1, t;
}
function Dre(e, t, r) {
  for (var n = new nt(e), a = 0, i = []; n.lt(t) && a < 1e5; )
    i.push(n.toNumber()), n = n.add(r), a++;
  return i;
}
var Mre = k0(function(e, t, r) {
  var n = +e, a = +t;
  return n + r * (a - n);
}), Ere = k0(function(e, t, r) {
  var n = t - +e;
  return n = n || 1 / 0, (r - e) / n;
}), Pre = k0(function(e, t, r) {
  var n = t - +e;
  return n = n || 1 / 0, Math.max(0, Math.min(1, (r - e) / n));
});
const G0 = {
  rangeStep: Dre,
  getDigitCount: Ore,
  interpolateNumber: Mre,
  uninterpolateNumber: Ere,
  uninterpolateTruncation: Pre
};
function S5(e) {
  return Ire(e) || Sre(e) || Qw(e) || jre();
}
function jre() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Sre(e) {
  if (typeof Symbol < "u" && Symbol.iterator in Object(e))
    return Array.from(e);
}
function Ire(e) {
  if (Array.isArray(e))
    return I5(e);
}
function bo(e, t) {
  return _re(e) || Nre(e, t) || Qw(e, t) || Bre();
}
function Bre() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Qw(e, t) {
  if (e) {
    if (typeof e == "string")
      return I5(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return I5(e, t);
  }
}
function I5(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
function Nre(e, t) {
  if (!(typeof Symbol > "u" || !(Symbol.iterator in Object(e)))) {
    var r = [], n = !0, a = !1, i = void 0;
    try {
      for (var o = e[Symbol.iterator](), s; !(n = (s = o.next()).done) && (r.push(s.value), !(t && r.length === t)); n = !0)
        ;
    } catch (c) {
      a = !0, i = c;
    } finally {
      try {
        !n && o.return != null && o.return();
      } finally {
        if (a)
          throw i;
      }
    }
    return r;
  }
}
function _re(e) {
  if (Array.isArray(e))
    return e;
}
function Uw(e) {
  var t = bo(e, 2), r = t[0], n = t[1], a = r, i = n;
  return r > n && (a = n, i = r), [a, i];
}
function Zw(e, t, r) {
  if (e.lte(0))
    return new nt(0);
  var n = G0.getDigitCount(e.toNumber()), a = new nt(10).pow(n), i = e.div(a), o = n !== 1 ? 0.05 : 0.1, s = new nt(Math.ceil(i.div(o).toNumber())).add(r).mul(o), c = s.mul(a);
  return t ? c : new nt(Math.ceil(c));
}
function Lre(e, t, r) {
  var n = 1, a = new nt(e);
  if (!a.isint() && r) {
    var i = Math.abs(e);
    i < 1 ? (n = new nt(10).pow(G0.getDigitCount(e) - 1), a = new nt(Math.floor(a.div(n).toNumber())).mul(n)) : i > 1 && (a = new nt(Math.floor(e)));
  } else
    e === 0 ? a = new nt(Math.floor((t - 1) / 2)) : r || (a = new nt(Math.floor(e)));
  var o = Math.floor((t - 1) / 2), s = xre(wre(function(c) {
    return a.add(new nt(c - o).mul(n)).toNumber();
  }), P5);
  return s(0, t);
}
function zw(e, t, r, n) {
  var a = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 0;
  if (!Number.isFinite((t - e) / (r - 1)))
    return {
      step: new nt(0),
      tickMin: new nt(0),
      tickMax: new nt(0)
    };
  var i = Zw(new nt(t).sub(e).div(r - 1), n, a), o;
  e <= 0 && t >= 0 ? o = new nt(0) : (o = new nt(e).add(t).div(2), o = o.sub(new nt(o).mod(i)));
  var s = Math.ceil(o.sub(e).div(i).toNumber()), c = Math.ceil(new nt(t).sub(o).div(i).toNumber()), u = s + c + 1;
  return u > r ? zw(e, t, r, n, a + 1) : (u < r && (c = t > 0 ? c + (r - u) : c, s = t > 0 ? s : s + (r - u)), {
    step: i,
    tickMin: o.sub(new nt(s).mul(i)),
    tickMax: o.add(new nt(c).mul(i))
  });
}
function Tre(e) {
  var t = bo(e, 2), r = t[0], n = t[1], a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 6, i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0, o = Math.max(a, 2), s = Uw([r, n]), c = bo(s, 2), u = c[0], d = c[1];
  if (u === -1 / 0 || d === 1 / 0) {
    var h = d === 1 / 0 ? [u].concat(S5(P5(0, a - 1).map(function() {
      return 1 / 0;
    }))) : [].concat(S5(P5(0, a - 1).map(function() {
      return -1 / 0;
    })), [d]);
    return r > n ? j5(h) : h;
  }
  if (u === d)
    return Lre(u, a, i);
  var A = zw(u, d, o, i), p = A.step, m = A.tickMin, g = A.tickMax, v = G0.rangeStep(m, g.add(new nt(0.1).mul(p)), p);
  return r > n ? j5(v) : v;
}
function Rre(e, t) {
  var r = bo(e, 2), n = r[0], a = r[1], i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0, o = Uw([n, a]), s = bo(o, 2), c = s[0], u = s[1];
  if (c === -1 / 0 || u === 1 / 0)
    return [n, a];
  if (c === u)
    return [c];
  var d = Math.max(t, 2), h = Zw(new nt(u).sub(c).div(d - 1), i, 0), A = [].concat(S5(G0.rangeStep(new nt(c), new nt(u).sub(new nt(0.99).mul(h)), h)), [u]);
  return n > a ? j5(A) : A;
}
var $re = Ww(Tre), Fre = Ww(Rre), Hre = ["offset", "layout", "width", "dataKey", "data", "dataPointFormatter", "xAxis", "yAxis"];
function a2(e) {
  "@babel/helpers - typeof";
  return a2 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, a2(e);
}
function Is() {
  return Is = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Is.apply(this, arguments);
}
function Yre(e, t) {
  return Wre(e) || Gre(e, t) || kre(e, t) || Vre();
}
function Vre() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function kre(e, t) {
  if (e) {
    if (typeof e == "string")
      return Mp(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return Mp(e, t);
  }
}
function Mp(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
function Gre(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, a, i, o, s = [], c = !0, u = !1;
    try {
      if (i = (r = r.call(e)).next, t === 0) {
        if (Object(r) !== r)
          return;
        c = !1;
      } else
        for (; !(c = (n = i.call(r)).done) && (s.push(n.value), s.length !== t); c = !0)
          ;
    } catch (d) {
      u = !0, a = d;
    } finally {
      try {
        if (!c && r.return != null && (o = r.return(), Object(o) !== o))
          return;
      } finally {
        if (u)
          throw a;
      }
    }
    return s;
  }
}
function Wre(e) {
  if (Array.isArray(e))
    return e;
}
function Qre(e, t) {
  if (e == null)
    return {};
  var r = Ure(e, t), n, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (a = 0; a < i.length; a++)
      n = i[a], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function Ure(e, t) {
  if (e == null)
    return {};
  var r = {};
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      if (t.indexOf(n) >= 0)
        continue;
      r[n] = e[n];
    }
  return r;
}
function Zre(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Ep(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Xw(n.key), n);
  }
}
function zre(e, t, r) {
  return t && Ep(e.prototype, t), r && Ep(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function Kre(e, t, r) {
  return t = Bs(t), qre(e, Kw() ? Reflect.construct(t, r || [], Bs(e).constructor) : t.apply(e, r));
}
function qre(e, t) {
  if (t && (a2(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return Xre(e);
}
function Xre(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function Kw() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (Kw = function() {
    return !!e;
  })();
}
function Bs(e) {
  return Bs = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, Bs(e);
}
function Jre(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && B5(e, t);
}
function B5(e, t) {
  return B5 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, a) {
    return n.__proto__ = a, n;
  }, B5(e, t);
}
function qw(e, t, r) {
  return t = Xw(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function Xw(e) {
  var t = ene(e, "string");
  return a2(t) == "symbol" ? t : t + "";
}
function ene(e, t) {
  if (a2(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (a2(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var V2 = /* @__PURE__ */ function(e) {
  function t() {
    return Zre(this, t), Kre(this, t, arguments);
  }
  return Jre(t, e), zre(t, [{
    key: "render",
    value: function() {
      var n = this.props, a = n.offset, i = n.layout, o = n.width, s = n.dataKey, c = n.data, u = n.dataPointFormatter, d = n.xAxis, h = n.yAxis, A = Qre(n, Hre), p = Ae(A, !1);
      this.props.direction === "x" && d.type !== "number" && (process.env.NODE_ENV !== "production" ? Zt(!1, 'ErrorBar requires Axis type property to be "number".') : Zt(!1));
      var m = c.map(function(g) {
        var v = u(g, s), C = v.x, y = v.y, w = v.value, O = v.errorVal;
        if (!O)
          return null;
        var b = [], D, M;
        if (Array.isArray(O)) {
          var j = Yre(O, 2);
          D = j[0], M = j[1];
        } else
          D = M = O;
        if (i === "vertical") {
          var P = d.scale, H = y + a, F = H + o, R = H - o, N = P(w - D), z = P(w + M);
          b.push({
            x1: z,
            y1: F,
            x2: z,
            y2: R
          }), b.push({
            x1: N,
            y1: H,
            x2: z,
            y2: H
          }), b.push({
            x1: N,
            y1: F,
            x2: N,
            y2: R
          });
        } else if (i === "horizontal") {
          var q = h.scale, J = C + a, W = J - o, te = J + o, S = q(w - D), I = q(w + M);
          b.push({
            x1: W,
            y1: I,
            x2: te,
            y2: I
          }), b.push({
            x1: J,
            y1: S,
            x2: J,
            y2: I
          }), b.push({
            x1: W,
            y1: S,
            x2: te,
            y2: S
          });
        }
        return /* @__PURE__ */ B.createElement(Se, Is({
          className: "recharts-errorBar",
          key: "bar-".concat(b.map(function(T) {
            return "".concat(T.x1, "-").concat(T.x2, "-").concat(T.y1, "-").concat(T.y2);
          }))
        }, p), b.map(function(T) {
          return /* @__PURE__ */ B.createElement("line", Is({}, T, {
            key: "line-".concat(T.x1, "-").concat(T.x2, "-").concat(T.y1, "-").concat(T.y2)
          }));
        }));
      });
      return /* @__PURE__ */ B.createElement(Se, {
        className: "recharts-errorBars"
      }, m);
    }
  }]);
}(B.Component);
qw(V2, "defaultProps", {
  stroke: "black",
  strokeWidth: 1.5,
  width: 5,
  offset: 0,
  layout: "horizontal"
});
qw(V2, "displayName", "ErrorBar");
function yo(e) {
  "@babel/helpers - typeof";
  return yo = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, yo(e);
}
function Pp(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function P1(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Pp(Object(r), !0).forEach(function(n) {
      tne(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Pp(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function tne(e, t, r) {
  return t = rne(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function rne(e) {
  var t = nne(e, "string");
  return yo(t) == "symbol" ? t : t + "";
}
function nne(e, t) {
  if (yo(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (yo(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var Jw = function(t) {
  var r = t.children, n = t.formattedGraphicalItems, a = t.legendWidth, i = t.legendContent, o = hr(r, Dn);
  if (!o)
    return null;
  var s = Dn.defaultProps, c = s !== void 0 ? P1(P1({}, s), o.props) : {}, u;
  return o.props && o.props.payload ? u = o.props && o.props.payload : i === "children" ? u = (n || []).reduce(function(d, h) {
    var A = h.item, p = h.props, m = p.sectors || p.data || [];
    return d.concat(m.map(function(g) {
      return {
        type: o.props.iconType || A.props.legendType,
        value: g.name,
        color: g.fill,
        payload: g
      };
    }));
  }, []) : u = (n || []).map(function(d) {
    var h = d.item, A = h.type.defaultProps, p = A !== void 0 ? P1(P1({}, A), h.props) : {}, m = p.dataKey, g = p.name, v = p.legendType, C = p.hide;
    return {
      inactive: C,
      dataKey: m,
      type: c.iconType || v || "square",
      color: X9(h),
      value: g || m,
      // @ts-expect-error property strokeDasharray is required in Payload but optional in props
      payload: p
    };
  }), P1(P1(P1({}, c), Dn.getWithHeight(o, a)), {}, {
    payload: u,
    item: o
  });
};
function wo(e) {
  "@babel/helpers - typeof";
  return wo = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, wo(e);
}
function jp(e) {
  return sne(e) || one(e) || ine(e) || ane();
}
function ane() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function ine(e, t) {
  if (e) {
    if (typeof e == "string")
      return N5(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return N5(e, t);
  }
}
function one(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null)
    return Array.from(e);
}
function sne(e) {
  if (Array.isArray(e))
    return N5(e);
}
function N5(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
function Sp(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function wt(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Sp(Object(r), !0).forEach(function(n) {
      Ga(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Sp(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function Ga(e, t, r) {
  return t = lne(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function lne(e) {
  var t = cne(e, "string");
  return wo(t) == "symbol" ? t : t + "";
}
function cne(e, t) {
  if (wo(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (wo(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function vt(e, t, r) {
  return be(e) || be(t) ? r : Nt(t) ? mr(e, t, r) : ye(t) ? t(e) : r;
}
function Wi(e, t, r, n) {
  var a = lre(e, function(s) {
    return vt(s, t);
  });
  if (r === "number") {
    var i = a.filter(function(s) {
      return se(s) || parseFloat(s);
    });
    return i.length ? [V0(i), Xn(i)] : [1 / 0, -1 / 0];
  }
  var o = n ? a.filter(function(s) {
    return !be(s);
  }) : a;
  return o.map(function(s) {
    return Nt(s) || s instanceof Date ? s : "";
  });
}
var une = function(t) {
  var r, n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], a = arguments.length > 2 ? arguments[2] : void 0, i = arguments.length > 3 ? arguments[3] : void 0, o = -1, s = (r = n == null ? void 0 : n.length) !== null && r !== void 0 ? r : 0;
  if (s <= 1)
    return 0;
  if (i && i.axisType === "angleAxis" && Math.abs(Math.abs(i.range[1] - i.range[0]) - 360) <= 1e-6)
    for (var c = i.range, u = 0; u < s; u++) {
      var d = u > 0 ? a[u - 1].coordinate : a[s - 1].coordinate, h = a[u].coordinate, A = u >= s - 1 ? a[0].coordinate : a[u + 1].coordinate, p = void 0;
      if (Jt(h - d) !== Jt(A - h)) {
        var m = [];
        if (Jt(A - h) === Jt(c[1] - c[0])) {
          p = A;
          var g = h + c[1] - c[0];
          m[0] = Math.min(g, (g + d) / 2), m[1] = Math.max(g, (g + d) / 2);
        } else {
          p = d;
          var v = A + c[1] - c[0];
          m[0] = Math.min(h, (v + h) / 2), m[1] = Math.max(h, (v + h) / 2);
        }
        var C = [Math.min(h, (p + h) / 2), Math.max(h, (p + h) / 2)];
        if (t > C[0] && t <= C[1] || t >= m[0] && t <= m[1]) {
          o = a[u].index;
          break;
        }
      } else {
        var y = Math.min(d, A), w = Math.max(d, A);
        if (t > (y + h) / 2 && t <= (w + h) / 2) {
          o = a[u].index;
          break;
        }
      }
    }
  else
    for (var O = 0; O < s; O++)
      if (O === 0 && t <= (n[O].coordinate + n[O + 1].coordinate) / 2 || O > 0 && O < s - 1 && t > (n[O].coordinate + n[O - 1].coordinate) / 2 && t <= (n[O].coordinate + n[O + 1].coordinate) / 2 || O === s - 1 && t > (n[O].coordinate + n[O - 1].coordinate) / 2) {
        o = n[O].index;
        break;
      }
  return o;
}, X9 = function(t) {
  var r, n = t, a = n.type.displayName, i = (r = t.type) !== null && r !== void 0 && r.defaultProps ? wt(wt({}, t.type.defaultProps), t.props) : t.props, o = i.stroke, s = i.fill, c;
  switch (a) {
    case "Line":
      c = o;
      break;
    case "Area":
    case "Radar":
      c = o && o !== "none" ? o : s;
      break;
    default:
      c = s;
      break;
  }
  return c;
}, fne = function(t) {
  var r = t.barSize, n = t.totalSize, a = t.stackGroups, i = a === void 0 ? {} : a;
  if (!i)
    return {};
  for (var o = {}, s = Object.keys(i), c = 0, u = s.length; c < u; c++)
    for (var d = i[s[c]].stackGroups, h = Object.keys(d), A = 0, p = h.length; A < p; A++) {
      var m = d[h[A]], g = m.items, v = m.cateAxisId, C = g.filter(function(M) {
        return On(M.type).indexOf("Bar") >= 0;
      });
      if (C && C.length) {
        var y = C[0].type.defaultProps, w = y !== void 0 ? wt(wt({}, y), C[0].props) : C[0].props, O = w.barSize, b = w[v];
        o[b] || (o[b] = []);
        var D = be(O) ? r : O;
        o[b].push({
          item: C[0],
          stackList: C.slice(1),
          barSize: be(D) ? void 0 : er(D, n, 0)
        });
      }
    }
  return o;
}, dne = function(t) {
  var r = t.barGap, n = t.barCategoryGap, a = t.bandSize, i = t.sizeList, o = i === void 0 ? [] : i, s = t.maxBarSize, c = o.length;
  if (c < 1)
    return null;
  var u = er(r, a, 0, !0), d, h = [];
  if (o[0].barSize === +o[0].barSize) {
    var A = !1, p = a / c, m = o.reduce(function(O, b) {
      return O + b.barSize || 0;
    }, 0);
    m += (c - 1) * u, m >= a && (m -= (c - 1) * u, u = 0), m >= a && p > 0 && (A = !0, p *= 0.9, m = c * p);
    var g = (a - m) / 2 >> 0, v = {
      offset: g - u,
      size: 0
    };
    d = o.reduce(function(O, b) {
      var D = {
        item: b.item,
        position: {
          offset: v.offset + v.size + u,
          // @ts-expect-error the type check above does not check for type number explicitly
          size: A ? p : b.barSize
        }
      }, M = [].concat(jp(O), [D]);
      return v = M[M.length - 1].position, b.stackList && b.stackList.length && b.stackList.forEach(function(j) {
        M.push({
          item: j,
          position: v
        });
      }), M;
    }, h);
  } else {
    var C = er(n, a, 0, !0);
    a - 2 * C - (c - 1) * u <= 0 && (u = 0);
    var y = (a - 2 * C - (c - 1) * u) / c;
    y > 1 && (y >>= 0);
    var w = s === +s ? Math.min(y, s) : y;
    d = o.reduce(function(O, b, D) {
      var M = [].concat(jp(O), [{
        item: b.item,
        position: {
          offset: C + (y + u) * D + (y - w) / 2,
          size: w
        }
      }]);
      return b.stackList && b.stackList.length && b.stackList.forEach(function(j) {
        M.push({
          item: j,
          position: M[M.length - 1].position
        });
      }), M;
    }, h);
  }
  return d;
}, hne = function(t, r, n, a) {
  var i = n.children, o = n.width, s = n.margin, c = o - (s.left || 0) - (s.right || 0), u = Jw({
    children: i,
    legendWidth: c
  });
  if (u) {
    var d = a || {}, h = d.width, A = d.height, p = u.align, m = u.verticalAlign, g = u.layout;
    if ((g === "vertical" || g === "horizontal" && m === "middle") && p !== "center" && se(t[p]))
      return wt(wt({}, t), {}, Ga({}, p, t[p] + (h || 0)));
    if ((g === "horizontal" || g === "vertical" && p === "center") && m !== "middle" && se(t[m]))
      return wt(wt({}, t), {}, Ga({}, m, t[m] + (A || 0)));
  }
  return t;
}, Ane = function(t, r, n) {
  return be(r) ? !0 : t === "horizontal" ? r === "yAxis" : t === "vertical" || n === "x" ? r === "xAxis" : n === "y" ? r === "yAxis" : !0;
}, ex = function(t, r, n, a, i) {
  var o = r.props.children, s = rr(o, V2).filter(function(u) {
    return Ane(a, i, u.props.direction);
  });
  if (s && s.length) {
    var c = s.map(function(u) {
      return u.props.dataKey;
    });
    return t.reduce(function(u, d) {
      var h = vt(d, n);
      if (be(h))
        return u;
      var A = Array.isArray(h) ? [V0(h), Xn(h)] : [h, h], p = c.reduce(function(m, g) {
        var v = vt(d, g, 0), C = A[0] - Math.abs(Array.isArray(v) ? v[0] : v), y = A[1] + Math.abs(Array.isArray(v) ? v[1] : v);
        return [Math.min(C, m[0]), Math.max(y, m[1])];
      }, [1 / 0, -1 / 0]);
      return [Math.min(p[0], u[0]), Math.max(p[1], u[1])];
    }, [1 / 0, -1 / 0]);
  }
  return null;
}, pne = function(t, r, n, a, i) {
  var o = r.map(function(s) {
    return ex(t, s, n, i, a);
  }).filter(function(s) {
    return !be(s);
  });
  return o && o.length ? o.reduce(function(s, c) {
    return [Math.min(s[0], c[0]), Math.max(s[1], c[1])];
  }, [1 / 0, -1 / 0]) : null;
}, tx = function(t, r, n, a, i) {
  var o = r.map(function(c) {
    var u = c.props.dataKey;
    return n === "number" && u && ex(t, c, u, a) || Wi(t, u, n, i);
  });
  if (n === "number")
    return o.reduce(
      // @ts-expect-error if (type === number) means that the domain is numerical type
      // - but this link is missing in the type definition
      function(c, u) {
        return [Math.min(c[0], u[0]), Math.max(c[1], u[1])];
      },
      [1 / 0, -1 / 0]
    );
  var s = {};
  return o.reduce(function(c, u) {
    for (var d = 0, h = u.length; d < h; d++)
      s[u[d]] || (s[u[d]] = !0, c.push(u[d]));
    return c;
  }, []);
}, rx = function(t, r) {
  return t === "horizontal" && r === "xAxis" || t === "vertical" && r === "yAxis" || t === "centric" && r === "angleAxis" || t === "radial" && r === "radiusAxis";
}, nx = function(t, r, n, a) {
  if (a)
    return t.map(function(c) {
      return c.coordinate;
    });
  var i, o, s = t.map(function(c) {
    return c.coordinate === r && (i = !0), c.coordinate === n && (o = !0), c.coordinate;
  });
  return i || s.push(r), o || s.push(n), s;
}, wn = function(t, r, n) {
  if (!t)
    return null;
  var a = t.scale, i = t.duplicateDomain, o = t.type, s = t.range, c = t.realScaleType === "scaleBand" ? a.bandwidth() / 2 : 2, u = (r || n) && o === "category" && a.bandwidth ? a.bandwidth() / c : 0;
  if (u = t.axisType === "angleAxis" && (s == null ? void 0 : s.length) >= 2 ? Jt(s[0] - s[1]) * 2 * u : u, r && (t.ticks || t.niceTicks)) {
    var d = (t.ticks || t.niceTicks).map(function(h) {
      var A = i ? i.indexOf(h) : h;
      return {
        // If the scaleContent is not a number, the coordinate will be NaN.
        // That could be the case for example with a PointScale and a string as domain.
        coordinate: a(A) + u,
        value: h,
        offset: u
      };
    });
    return d.filter(function(h) {
      return !_2(h.coordinate);
    });
  }
  return t.isCategorical && t.categoricalDomain ? t.categoricalDomain.map(function(h, A) {
    return {
      coordinate: a(h) + u,
      value: h,
      index: A,
      offset: u
    };
  }) : a.ticks && !n ? a.ticks(t.tickCount).map(function(h) {
    return {
      coordinate: a(h) + u,
      value: h,
      offset: u
    };
  }) : a.domain().map(function(h, A) {
    return {
      coordinate: a(h) + u,
      value: i ? i[h] : h,
      index: A,
      offset: u
    };
  });
}, o4 = /* @__PURE__ */ new WeakMap(), I3 = function(t, r) {
  if (typeof r != "function")
    return t;
  o4.has(t) || o4.set(t, /* @__PURE__ */ new WeakMap());
  var n = o4.get(t);
  if (n.has(r))
    return n.get(r);
  var a = function() {
    t.apply(void 0, arguments), r.apply(void 0, arguments);
  };
  return n.set(r, a), a;
}, ax = function(t, r, n) {
  var a = t.scale, i = t.type, o = t.layout, s = t.axisType;
  if (a === "auto")
    return o === "radial" && s === "radiusAxis" ? {
      scale: Ao(),
      realScaleType: "band"
    } : o === "radial" && s === "angleAxis" ? {
      scale: Ms(),
      realScaleType: "linear"
    } : i === "category" && r && (r.indexOf("LineChart") >= 0 || r.indexOf("AreaChart") >= 0 || r.indexOf("ComposedChart") >= 0 && !n) ? {
      scale: Gi(),
      realScaleType: "point"
    } : i === "category" ? {
      scale: Ao(),
      realScaleType: "band"
    } : {
      scale: Ms(),
      realScaleType: "linear"
    };
  if (ea(a)) {
    var c = "scale".concat(E0(a));
    return {
      scale: (wp[c] || Gi)(),
      realScaleType: wp[c] ? c : "point"
    };
  }
  return ye(a) ? {
    scale: a
  } : {
    scale: Gi(),
    realScaleType: "point"
  };
}, Ip = 1e-4, ix = function(t) {
  var r = t.domain();
  if (!(!r || r.length <= 2)) {
    var n = r.length, a = t.range(), i = Math.min(a[0], a[1]) - Ip, o = Math.max(a[0], a[1]) + Ip, s = t(r[0]), c = t(r[n - 1]);
    (s < i || s > o || c < i || c > o) && t.domain([r[0], r[n - 1]]);
  }
}, vne = function(t, r) {
  if (!t)
    return null;
  for (var n = 0, a = t.length; n < a; n++)
    if (t[n].item === r)
      return t[n].position;
  return null;
}, gne = function(t, r) {
  if (!r || r.length !== 2 || !se(r[0]) || !se(r[1]))
    return t;
  var n = Math.min(r[0], r[1]), a = Math.max(r[0], r[1]), i = [t[0], t[1]];
  return (!se(t[0]) || t[0] < n) && (i[0] = n), (!se(t[1]) || t[1] > a) && (i[1] = a), i[0] > a && (i[0] = a), i[1] < n && (i[1] = n), i;
}, mne = function(t) {
  var r = t.length;
  if (!(r <= 0))
    for (var n = 0, a = t[0].length; n < a; ++n)
      for (var i = 0, o = 0, s = 0; s < r; ++s) {
        var c = _2(t[s][n][1]) ? t[s][n][0] : t[s][n][1];
        c >= 0 ? (t[s][n][0] = i, t[s][n][1] = i + c, i = t[s][n][1]) : (t[s][n][0] = o, t[s][n][1] = o + c, o = t[s][n][1]);
      }
}, Cne = function(t) {
  var r = t.length;
  if (!(r <= 0))
    for (var n = 0, a = t[0].length; n < a; ++n)
      for (var i = 0, o = 0; o < r; ++o) {
        var s = _2(t[o][n][1]) ? t[o][n][0] : t[o][n][1];
        s >= 0 ? (t[o][n][0] = i, t[o][n][1] = i + s, i = t[o][n][1]) : (t[o][n][0] = 0, t[o][n][1] = 0);
      }
}, bne = {
  sign: mne,
  // @ts-expect-error definitelytyped types are incorrect
  expand: kk,
  // @ts-expect-error definitelytyped types are incorrect
  none: Ka,
  // @ts-expect-error definitelytyped types are incorrect
  silhouette: Gk,
  // @ts-expect-error definitelytyped types are incorrect
  wiggle: Wk,
  positive: Cne
}, yne = function(t, r, n) {
  var a = r.map(function(s) {
    return s.props.dataKey;
  }), i = bne[n], o = Vk().keys(a).value(function(s, c) {
    return +vt(s, c, 0);
  }).order(a5).offset(i);
  return o(t);
}, wne = function(t, r, n, a, i, o) {
  if (!t)
    return null;
  var s = o ? r.reverse() : r, c = {}, u = s.reduce(function(h, A) {
    var p, m = (p = A.type) !== null && p !== void 0 && p.defaultProps ? wt(wt({}, A.type.defaultProps), A.props) : A.props, g = m.stackId, v = m.hide;
    if (v)
      return h;
    var C = m[n], y = h[C] || {
      hasStack: !1,
      stackGroups: {}
    };
    if (Nt(g)) {
      var w = y.stackGroups[g] || {
        numericAxisId: n,
        cateAxisId: a,
        items: []
      };
      w.items.push(A), y.hasStack = !0, y.stackGroups[g] = w;
    } else
      y.stackGroups[g1("_stackId_")] = {
        numericAxisId: n,
        cateAxisId: a,
        items: [A]
      };
    return wt(wt({}, h), {}, Ga({}, C, y));
  }, c), d = {};
  return Object.keys(u).reduce(function(h, A) {
    var p = u[A];
    if (p.hasStack) {
      var m = {};
      p.stackGroups = Object.keys(p.stackGroups).reduce(function(g, v) {
        var C = p.stackGroups[v];
        return wt(wt({}, g), {}, Ga({}, v, {
          numericAxisId: n,
          cateAxisId: a,
          items: C.items,
          stackedData: yne(t, C.items, i)
        }));
      }, m);
    }
    return wt(wt({}, h), {}, Ga({}, A, p));
  }, d);
}, ox = function(t, r) {
  var n = r.realScaleType, a = r.type, i = r.tickCount, o = r.originalDomain, s = r.allowDecimals, c = n || r.scale;
  if (c !== "auto" && c !== "linear")
    return null;
  if (i && a === "number" && o && (o[0] === "auto" || o[1] === "auto")) {
    var u = t.domain();
    if (!u.length)
      return null;
    var d = $re(u, i, s);
    return t.domain([V0(d), Xn(d)]), {
      niceTicks: d
    };
  }
  if (i && a === "number") {
    var h = t.domain(), A = Fre(h, i, s);
    return {
      niceTicks: A
    };
  }
  return null;
};
function i2(e) {
  var t = e.axis, r = e.ticks, n = e.bandSize, a = e.entry, i = e.index, o = e.dataKey;
  if (t.type === "category") {
    if (!t.allowDuplicatedCategory && t.dataKey && !be(a[t.dataKey])) {
      var s = is(r, "value", a[t.dataKey]);
      if (s)
        return s.coordinate + n / 2;
    }
    return r[i] ? r[i].coordinate + n / 2 : null;
  }
  var c = vt(a, be(o) ? t.dataKey : o);
  return be(c) ? null : t.scale(c);
}
var Bp = function(t) {
  var r = t.axis, n = t.ticks, a = t.offset, i = t.bandSize, o = t.entry, s = t.index;
  if (r.type === "category")
    return n[s] ? n[s].coordinate + a : null;
  var c = vt(o, r.dataKey, r.domain[s]);
  return be(c) ? null : r.scale(c) - i / 2 + a;
}, xne = function(t) {
  var r = t.numericAxis, n = r.scale.domain();
  if (r.type === "number") {
    var a = Math.min(n[0], n[1]), i = Math.max(n[0], n[1]);
    return a <= 0 && i >= 0 ? 0 : i < 0 ? i : a;
  }
  return n[0];
}, One = function(t, r) {
  var n, a = (n = t.type) !== null && n !== void 0 && n.defaultProps ? wt(wt({}, t.type.defaultProps), t.props) : t.props, i = a.stackId;
  if (Nt(i)) {
    var o = r[i];
    if (o) {
      var s = o.items.indexOf(t);
      return s >= 0 ? o.stackedData[s] : null;
    }
  }
  return null;
}, Dne = function(t) {
  return t.reduce(function(r, n) {
    return [V0(n.concat([r[0]]).filter(se)), Xn(n.concat([r[1]]).filter(se))];
  }, [1 / 0, -1 / 0]);
}, sx = function(t, r, n) {
  return Object.keys(t).reduce(function(a, i) {
    var o = t[i], s = o.stackedData, c = s.reduce(function(u, d) {
      var h = Dne(d.slice(r, n + 1));
      return [Math.min(u[0], h[0]), Math.max(u[1], h[1])];
    }, [1 / 0, -1 / 0]);
    return [Math.min(c[0], a[0]), Math.max(c[1], a[1])];
  }, [1 / 0, -1 / 0]).map(function(a) {
    return a === 1 / 0 || a === -1 / 0 ? 0 : a;
  });
}, Np = /^dataMin[\s]*-[\s]*([0-9]+([.]{1}[0-9]+){0,1})$/, _p = /^dataMax[\s]*\+[\s]*([0-9]+([.]{1}[0-9]+){0,1})$/, _5 = function(t, r, n) {
  if (ye(t))
    return t(r, n);
  if (!Array.isArray(t))
    return r;
  var a = [];
  if (se(t[0]))
    a[0] = n ? t[0] : Math.min(t[0], r[0]);
  else if (Np.test(t[0])) {
    var i = +Np.exec(t[0])[1];
    a[0] = r[0] - i;
  } else
    ye(t[0]) ? a[0] = t[0](r[0]) : a[0] = r[0];
  if (se(t[1]))
    a[1] = n ? t[1] : Math.max(t[1], r[1]);
  else if (_p.test(t[1])) {
    var o = +_p.exec(t[1])[1];
    a[1] = r[1] + o;
  } else
    ye(t[1]) ? a[1] = t[1](r[1]) : a[1] = r[1];
  return a;
}, Ns = function(t, r, n) {
  if (t && t.scale && t.scale.bandwidth) {
    var a = t.scale.bandwidth();
    if (!n || a > 0)
      return a;
  }
  if (t && r && r.length >= 2) {
    for (var i = M9(r, function(h) {
      return h.coordinate;
    }), o = 1 / 0, s = 1, c = i.length; s < c; s++) {
      var u = i[s], d = i[s - 1];
      o = Math.min((u.coordinate || 0) - (d.coordinate || 0), o);
    }
    return o === 1 / 0 ? 0 : o;
  }
  return n ? void 0 : 0;
}, Lp = function(t, r, n) {
  return !t || !t.length || u1(t, mr(n, "type.defaultProps.domain")) ? r : t;
}, lx = function(t, r) {
  var n = t.type.defaultProps ? wt(wt({}, t.type.defaultProps), t.props) : t.props, a = n.dataKey, i = n.name, o = n.unit, s = n.formatter, c = n.tooltipType, u = n.chartType, d = n.hide;
  return wt(wt({}, Ae(t, !1)), {}, {
    dataKey: a,
    unit: o,
    formatter: s,
    name: i || a,
    color: X9(t),
    value: vt(r, a),
    type: c,
    payload: r,
    chartType: u,
    hide: d
  });
};
function xo(e) {
  "@babel/helpers - typeof";
  return xo = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, xo(e);
}
function Tp(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function mn(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Tp(Object(r), !0).forEach(function(n) {
      cx(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Tp(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function cx(e, t, r) {
  return t = Mne(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function Mne(e) {
  var t = Ene(e, "string");
  return xo(t) == "symbol" ? t : t + "";
}
function Ene(e, t) {
  if (xo(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (xo(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function Pne(e, t) {
  return Bne(e) || Ine(e, t) || Sne(e, t) || jne();
}
function jne() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Sne(e, t) {
  if (e) {
    if (typeof e == "string")
      return Rp(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return Rp(e, t);
  }
}
function Rp(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
function Ine(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, a, i, o, s = [], c = !0, u = !1;
    try {
      if (i = (r = r.call(e)).next, t === 0) {
        if (Object(r) !== r)
          return;
        c = !1;
      } else
        for (; !(c = (n = i.call(r)).done) && (s.push(n.value), s.length !== t); c = !0)
          ;
    } catch (d) {
      u = !0, a = d;
    } finally {
      try {
        if (!c && r.return != null && (o = r.return(), Object(o) !== o))
          return;
      } finally {
        if (u)
          throw a;
      }
    }
    return s;
  }
}
function Bne(e) {
  if (Array.isArray(e))
    return e;
}
var _s = Math.PI / 180, Nne = function(t) {
  return t * 180 / Math.PI;
}, ct = function(t, r, n, a) {
  return {
    x: t + Math.cos(-_s * a) * n,
    y: r + Math.sin(-_s * a) * n
  };
}, ux = function(t, r) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
  return Math.min(Math.abs(t - (n.left || 0) - (n.right || 0)), Math.abs(r - (n.top || 0) - (n.bottom || 0))) / 2;
}, _ne = function(t, r, n, a, i) {
  var o = t.width, s = t.height, c = t.startAngle, u = t.endAngle, d = er(t.cx, o, o / 2), h = er(t.cy, s, s / 2), A = ux(o, s, n), p = er(t.innerRadius, A, 0), m = er(t.outerRadius, A, A * 0.8), g = Object.keys(r);
  return g.reduce(function(v, C) {
    var y = r[C], w = y.domain, O = y.reversed, b;
    if (be(y.range))
      a === "angleAxis" ? b = [c, u] : a === "radiusAxis" && (b = [p, m]), O && (b = [b[1], b[0]]);
    else {
      b = y.range;
      var D = b, M = Pne(D, 2);
      c = M[0], u = M[1];
    }
    var j = ax(y, i), P = j.realScaleType, H = j.scale;
    H.domain(w).range(b), ix(H);
    var F = ox(H, mn(mn({}, y), {}, {
      realScaleType: P
    })), R = mn(mn(mn({}, y), F), {}, {
      range: b,
      radius: m,
      realScaleType: P,
      scale: H,
      cx: d,
      cy: h,
      innerRadius: p,
      outerRadius: m,
      startAngle: c,
      endAngle: u
    });
    return mn(mn({}, v), {}, cx({}, C, R));
  }, {});
}, Lne = function(t, r) {
  var n = t.x, a = t.y, i = r.x, o = r.y;
  return Math.sqrt(Math.pow(n - i, 2) + Math.pow(a - o, 2));
}, Tne = function(t, r) {
  var n = t.x, a = t.y, i = r.cx, o = r.cy, s = Lne({
    x: n,
    y: a
  }, {
    x: i,
    y: o
  });
  if (s <= 0)
    return {
      radius: s
    };
  var c = (n - i) / s, u = Math.acos(c);
  return a > o && (u = 2 * Math.PI - u), {
    radius: s,
    angle: Nne(u),
    angleInRadian: u
  };
}, Rne = function(t) {
  var r = t.startAngle, n = t.endAngle, a = Math.floor(r / 360), i = Math.floor(n / 360), o = Math.min(a, i);
  return {
    startAngle: r - o * 360,
    endAngle: n - o * 360
  };
}, $ne = function(t, r) {
  var n = r.startAngle, a = r.endAngle, i = Math.floor(n / 360), o = Math.floor(a / 360), s = Math.min(i, o);
  return t + s * 360;
}, $p = function(t, r) {
  var n = t.x, a = t.y, i = Tne({
    x: n,
    y: a
  }, r), o = i.radius, s = i.angle, c = r.innerRadius, u = r.outerRadius;
  if (o < c || o > u)
    return !1;
  if (o === 0)
    return !0;
  var d = Rne(r), h = d.startAngle, A = d.endAngle, p = s, m;
  if (h <= A) {
    for (; p > A; )
      p -= 360;
    for (; p < h; )
      p += 360;
    m = p >= h && p <= A;
  } else {
    for (; p > h; )
      p -= 360;
    for (; p < A; )
      p += 360;
    m = p >= A && p <= h;
  }
  return m ? mn(mn({}, r), {}, {
    radius: o,
    angle: $ne(p, r)
  }) : null;
}, fx = function(t) {
  return !/* @__PURE__ */ Vr(t) && !ye(t) && typeof t != "boolean" ? t.className : "";
};
function Oo(e) {
  "@babel/helpers - typeof";
  return Oo = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Oo(e);
}
var Fne = ["offset"];
function Hne(e) {
  return Gne(e) || kne(e) || Vne(e) || Yne();
}
function Yne() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Vne(e, t) {
  if (e) {
    if (typeof e == "string")
      return L5(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return L5(e, t);
  }
}
function kne(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null)
    return Array.from(e);
}
function Gne(e) {
  if (Array.isArray(e))
    return L5(e);
}
function L5(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
function Wne(e, t) {
  if (e == null)
    return {};
  var r = Qne(e, t), n, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (a = 0; a < i.length; a++)
      n = i[a], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function Qne(e, t) {
  if (e == null)
    return {};
  var r = {};
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      if (t.indexOf(n) >= 0)
        continue;
      r[n] = e[n];
    }
  return r;
}
function Fp(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function It(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Fp(Object(r), !0).forEach(function(n) {
      Une(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Fp(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function Une(e, t, r) {
  return t = Zne(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function Zne(e) {
  var t = zne(e, "string");
  return Oo(t) == "symbol" ? t : t + "";
}
function zne(e, t) {
  if (Oo(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (Oo(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function Do() {
  return Do = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Do.apply(this, arguments);
}
var Kne = function(t) {
  var r = t.value, n = t.formatter, a = be(t.children) ? r : t.children;
  return ye(n) ? n(a) : a;
}, qne = function(t, r) {
  var n = Jt(r - t), a = Math.min(Math.abs(r - t), 360);
  return n * a;
}, Xne = function(t, r, n) {
  var a = t.position, i = t.viewBox, o = t.offset, s = t.className, c = i, u = c.cx, d = c.cy, h = c.innerRadius, A = c.outerRadius, p = c.startAngle, m = c.endAngle, g = c.clockWise, v = (h + A) / 2, C = qne(p, m), y = C >= 0 ? 1 : -1, w, O;
  a === "insideStart" ? (w = p + y * o, O = g) : a === "insideEnd" ? (w = m - y * o, O = !g) : a === "end" && (w = m + y * o, O = g), O = C <= 0 ? O : !O;
  var b = ct(u, d, v, w), D = ct(u, d, v, w + (O ? 1 : -1) * 359), M = "M".concat(b.x, ",").concat(b.y, `
    A`).concat(v, ",").concat(v, ",0,1,").concat(O ? 0 : 1, `,
    `).concat(D.x, ",").concat(D.y), j = be(t.id) ? g1("recharts-radial-line-") : t.id;
  return /* @__PURE__ */ B.createElement("text", Do({}, n, {
    dominantBaseline: "central",
    className: Pe("recharts-radial-bar-label", s)
  }), /* @__PURE__ */ B.createElement("defs", null, /* @__PURE__ */ B.createElement("path", {
    id: j,
    d: M
  })), /* @__PURE__ */ B.createElement("textPath", {
    xlinkHref: "#".concat(j)
  }, r));
}, Jne = function(t) {
  var r = t.viewBox, n = t.offset, a = t.position, i = r, o = i.cx, s = i.cy, c = i.innerRadius, u = i.outerRadius, d = i.startAngle, h = i.endAngle, A = (d + h) / 2;
  if (a === "outside") {
    var p = ct(o, s, u + n, A), m = p.x, g = p.y;
    return {
      x: m,
      y: g,
      textAnchor: m >= o ? "start" : "end",
      verticalAnchor: "middle"
    };
  }
  if (a === "center")
    return {
      x: o,
      y: s,
      textAnchor: "middle",
      verticalAnchor: "middle"
    };
  if (a === "centerTop")
    return {
      x: o,
      y: s,
      textAnchor: "middle",
      verticalAnchor: "start"
    };
  if (a === "centerBottom")
    return {
      x: o,
      y: s,
      textAnchor: "middle",
      verticalAnchor: "end"
    };
  var v = (c + u) / 2, C = ct(o, s, v, A), y = C.x, w = C.y;
  return {
    x: y,
    y: w,
    textAnchor: "middle",
    verticalAnchor: "middle"
  };
}, e1e = function(t) {
  var r = t.viewBox, n = t.parentViewBox, a = t.offset, i = t.position, o = r, s = o.x, c = o.y, u = o.width, d = o.height, h = d >= 0 ? 1 : -1, A = h * a, p = h > 0 ? "end" : "start", m = h > 0 ? "start" : "end", g = u >= 0 ? 1 : -1, v = g * a, C = g > 0 ? "end" : "start", y = g > 0 ? "start" : "end";
  if (i === "top") {
    var w = {
      x: s + u / 2,
      y: c - h * a,
      textAnchor: "middle",
      verticalAnchor: p
    };
    return It(It({}, w), n ? {
      height: Math.max(c - n.y, 0),
      width: u
    } : {});
  }
  if (i === "bottom") {
    var O = {
      x: s + u / 2,
      y: c + d + A,
      textAnchor: "middle",
      verticalAnchor: m
    };
    return It(It({}, O), n ? {
      height: Math.max(n.y + n.height - (c + d), 0),
      width: u
    } : {});
  }
  if (i === "left") {
    var b = {
      x: s - v,
      y: c + d / 2,
      textAnchor: C,
      verticalAnchor: "middle"
    };
    return It(It({}, b), n ? {
      width: Math.max(b.x - n.x, 0),
      height: d
    } : {});
  }
  if (i === "right") {
    var D = {
      x: s + u + v,
      y: c + d / 2,
      textAnchor: y,
      verticalAnchor: "middle"
    };
    return It(It({}, D), n ? {
      width: Math.max(n.x + n.width - D.x, 0),
      height: d
    } : {});
  }
  var M = n ? {
    width: u,
    height: d
  } : {};
  return i === "insideLeft" ? It({
    x: s + v,
    y: c + d / 2,
    textAnchor: y,
    verticalAnchor: "middle"
  }, M) : i === "insideRight" ? It({
    x: s + u - v,
    y: c + d / 2,
    textAnchor: C,
    verticalAnchor: "middle"
  }, M) : i === "insideTop" ? It({
    x: s + u / 2,
    y: c + A,
    textAnchor: "middle",
    verticalAnchor: m
  }, M) : i === "insideBottom" ? It({
    x: s + u / 2,
    y: c + d - A,
    textAnchor: "middle",
    verticalAnchor: p
  }, M) : i === "insideTopLeft" ? It({
    x: s + v,
    y: c + A,
    textAnchor: y,
    verticalAnchor: m
  }, M) : i === "insideTopRight" ? It({
    x: s + u - v,
    y: c + A,
    textAnchor: C,
    verticalAnchor: m
  }, M) : i === "insideBottomLeft" ? It({
    x: s + v,
    y: c + d - A,
    textAnchor: y,
    verticalAnchor: p
  }, M) : i === "insideBottomRight" ? It({
    x: s + u - v,
    y: c + d - A,
    textAnchor: C,
    verticalAnchor: p
  }, M) : S2(i) && (se(i.x) || W1(i.x)) && (se(i.y) || W1(i.y)) ? It({
    x: s + er(i.x, u),
    y: c + er(i.y, d),
    textAnchor: "end",
    verticalAnchor: "end"
  }, M) : It({
    x: s + u / 2,
    y: c + d / 2,
    textAnchor: "middle",
    verticalAnchor: "middle"
  }, M);
}, t1e = function(t) {
  return "cx" in t && se(t.cx);
};
function Et(e) {
  var t = e.offset, r = t === void 0 ? 5 : t, n = Wne(e, Fne), a = It({
    offset: r
  }, n), i = a.viewBox, o = a.position, s = a.value, c = a.children, u = a.content, d = a.className, h = d === void 0 ? "" : d, A = a.textBreakAll;
  if (!i || be(s) && be(c) && !/* @__PURE__ */ Vr(u) && !ye(u))
    return null;
  if (/* @__PURE__ */ Vr(u))
    return /* @__PURE__ */ Bt(u, a);
  var p;
  if (ye(u)) {
    if (p = /* @__PURE__ */ cC(u, a), /* @__PURE__ */ Vr(p))
      return p;
  } else
    p = Kne(a);
  var m = t1e(i), g = Ae(a, !0);
  if (m && (o === "insideStart" || o === "insideEnd" || o === "end"))
    return Xne(a, p, g);
  var v = m ? Jne(a) : e1e(a);
  return /* @__PURE__ */ B.createElement(ta, Do({
    className: Pe("recharts-label", h)
  }, g, v, {
    breakAll: A
  }), p);
}
Et.displayName = "Label";
var dx = function(t) {
  var r = t.cx, n = t.cy, a = t.angle, i = t.startAngle, o = t.endAngle, s = t.r, c = t.radius, u = t.innerRadius, d = t.outerRadius, h = t.x, A = t.y, p = t.top, m = t.left, g = t.width, v = t.height, C = t.clockWise, y = t.labelViewBox;
  if (y)
    return y;
  if (se(g) && se(v)) {
    if (se(h) && se(A))
      return {
        x: h,
        y: A,
        width: g,
        height: v
      };
    if (se(p) && se(m))
      return {
        x: p,
        y: m,
        width: g,
        height: v
      };
  }
  return se(h) && se(A) ? {
    x: h,
    y: A,
    width: 0,
    height: 0
  } : se(r) && se(n) ? {
    cx: r,
    cy: n,
    startAngle: i || a || 0,
    endAngle: o || a || 0,
    innerRadius: u || 0,
    outerRadius: d || c || s || 0,
    clockWise: C
  } : t.viewBox ? t.viewBox : {};
}, r1e = function(t, r) {
  return t ? t === !0 ? /* @__PURE__ */ B.createElement(Et, {
    key: "label-implicit",
    viewBox: r
  }) : Nt(t) ? /* @__PURE__ */ B.createElement(Et, {
    key: "label-implicit",
    viewBox: r,
    value: t
  }) : /* @__PURE__ */ Vr(t) ? t.type === Et ? /* @__PURE__ */ Bt(t, {
    key: "label-implicit",
    viewBox: r
  }) : /* @__PURE__ */ B.createElement(Et, {
    key: "label-implicit",
    content: t,
    viewBox: r
  }) : ye(t) ? /* @__PURE__ */ B.createElement(Et, {
    key: "label-implicit",
    content: t,
    viewBox: r
  }) : S2(t) ? /* @__PURE__ */ B.createElement(Et, Do({
    viewBox: r
  }, t, {
    key: "label-implicit"
  })) : null : null;
}, n1e = function(t, r) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0;
  if (!t || !t.children && n && !t.label)
    return null;
  var a = t.children, i = dx(t), o = rr(a, Et).map(function(c, u) {
    return /* @__PURE__ */ Bt(c, {
      viewBox: r || i,
      // eslint-disable-next-line react/no-array-index-key
      key: "label-".concat(u)
    });
  });
  if (!n)
    return o;
  var s = r1e(t.label, r || i);
  return [s].concat(Hne(o));
};
Et.parseViewBox = dx;
Et.renderCallByParent = n1e;
function a1e(e) {
  var t = e == null ? 0 : e.length;
  return t ? e[t - 1] : void 0;
}
var i1e = a1e;
const o1e = /* @__PURE__ */ qe(i1e);
function Mo(e) {
  "@babel/helpers - typeof";
  return Mo = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Mo(e);
}
var s1e = ["valueAccessor"], l1e = ["data", "dataKey", "clockWise", "id", "textBreakAll"];
function c1e(e) {
  return h1e(e) || d1e(e) || f1e(e) || u1e();
}
function u1e() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function f1e(e, t) {
  if (e) {
    if (typeof e == "string")
      return T5(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return T5(e, t);
  }
}
function d1e(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null)
    return Array.from(e);
}
function h1e(e) {
  if (Array.isArray(e))
    return T5(e);
}
function T5(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
function Ls() {
  return Ls = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Ls.apply(this, arguments);
}
function Hp(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Yp(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Hp(Object(r), !0).forEach(function(n) {
      A1e(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Hp(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function A1e(e, t, r) {
  return t = p1e(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function p1e(e) {
  var t = v1e(e, "string");
  return Mo(t) == "symbol" ? t : t + "";
}
function v1e(e, t) {
  if (Mo(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (Mo(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function Vp(e, t) {
  if (e == null)
    return {};
  var r = g1e(e, t), n, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (a = 0; a < i.length; a++)
      n = i[a], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function g1e(e, t) {
  if (e == null)
    return {};
  var r = {};
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      if (t.indexOf(n) >= 0)
        continue;
      r[n] = e[n];
    }
  return r;
}
var m1e = function(t) {
  return Array.isArray(t.value) ? o1e(t.value) : t.value;
};
function Wr(e) {
  var t = e.valueAccessor, r = t === void 0 ? m1e : t, n = Vp(e, s1e), a = n.data, i = n.dataKey, o = n.clockWise, s = n.id, c = n.textBreakAll, u = Vp(n, l1e);
  return !a || !a.length ? null : /* @__PURE__ */ B.createElement(Se, {
    className: "recharts-label-list"
  }, a.map(function(d, h) {
    var A = be(i) ? r(d, h) : vt(d && d.payload, i), p = be(s) ? {} : {
      id: "".concat(s, "-").concat(h)
    };
    return /* @__PURE__ */ B.createElement(Et, Ls({}, Ae(d, !0), u, p, {
      parentViewBox: d.parentViewBox,
      value: A,
      textBreakAll: c,
      viewBox: Et.parseViewBox(be(o) ? d : Yp(Yp({}, d), {}, {
        clockWise: o
      })),
      key: "label-".concat(h),
      index: h
    }));
  }));
}
Wr.displayName = "LabelList";
function C1e(e, t) {
  return e ? e === !0 ? /* @__PURE__ */ B.createElement(Wr, {
    key: "labelList-implicit",
    data: t
  }) : /* @__PURE__ */ B.isValidElement(e) || ye(e) ? /* @__PURE__ */ B.createElement(Wr, {
    key: "labelList-implicit",
    data: t,
    content: e
  }) : S2(e) ? /* @__PURE__ */ B.createElement(Wr, Ls({
    data: t
  }, e, {
    key: "labelList-implicit"
  })) : null : null;
}
function b1e(e, t) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0;
  if (!e || !e.children && r && !e.label)
    return null;
  var n = e.children, a = rr(n, Wr).map(function(o, s) {
    return /* @__PURE__ */ Bt(o, {
      data: t,
      // eslint-disable-next-line react/no-array-index-key
      key: "labelList-".concat(s)
    });
  });
  if (!r)
    return a;
  var i = C1e(e.label, t);
  return [i].concat(c1e(a));
}
Wr.renderCallByParent = b1e;
function Eo(e) {
  "@babel/helpers - typeof";
  return Eo = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Eo(e);
}
function R5() {
  return R5 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, R5.apply(this, arguments);
}
function kp(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Gp(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? kp(Object(r), !0).forEach(function(n) {
      y1e(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : kp(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function y1e(e, t, r) {
  return t = w1e(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function w1e(e) {
  var t = x1e(e, "string");
  return Eo(t) == "symbol" ? t : t + "";
}
function x1e(e, t) {
  if (Eo(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (Eo(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var O1e = function(t, r) {
  var n = Jt(r - t), a = Math.min(Math.abs(r - t), 359.999);
  return n * a;
}, B3 = function(t) {
  var r = t.cx, n = t.cy, a = t.radius, i = t.angle, o = t.sign, s = t.isExternal, c = t.cornerRadius, u = t.cornerIsExternal, d = c * (s ? 1 : -1) + a, h = Math.asin(c / d) / _s, A = u ? i : i + o * h, p = ct(r, n, d, A), m = ct(r, n, a, A), g = u ? i - o * h : i, v = ct(r, n, d * Math.cos(h * _s), g);
  return {
    center: p,
    circleTangency: m,
    lineTangency: v,
    theta: h
  };
}, hx = function(t) {
  var r = t.cx, n = t.cy, a = t.innerRadius, i = t.outerRadius, o = t.startAngle, s = t.endAngle, c = O1e(o, s), u = o + c, d = ct(r, n, i, o), h = ct(r, n, i, u), A = "M ".concat(d.x, ",").concat(d.y, `
    A `).concat(i, ",").concat(i, `,0,
    `).concat(+(Math.abs(c) > 180), ",").concat(+(o > u), `,
    `).concat(h.x, ",").concat(h.y, `
  `);
  if (a > 0) {
    var p = ct(r, n, a, o), m = ct(r, n, a, u);
    A += "L ".concat(m.x, ",").concat(m.y, `
            A `).concat(a, ",").concat(a, `,0,
            `).concat(+(Math.abs(c) > 180), ",").concat(+(o <= u), `,
            `).concat(p.x, ",").concat(p.y, " Z");
  } else
    A += "L ".concat(r, ",").concat(n, " Z");
  return A;
}, D1e = function(t) {
  var r = t.cx, n = t.cy, a = t.innerRadius, i = t.outerRadius, o = t.cornerRadius, s = t.forceCornerRadius, c = t.cornerIsExternal, u = t.startAngle, d = t.endAngle, h = Jt(d - u), A = B3({
    cx: r,
    cy: n,
    radius: i,
    angle: u,
    sign: h,
    cornerRadius: o,
    cornerIsExternal: c
  }), p = A.circleTangency, m = A.lineTangency, g = A.theta, v = B3({
    cx: r,
    cy: n,
    radius: i,
    angle: d,
    sign: -h,
    cornerRadius: o,
    cornerIsExternal: c
  }), C = v.circleTangency, y = v.lineTangency, w = v.theta, O = c ? Math.abs(u - d) : Math.abs(u - d) - g - w;
  if (O < 0)
    return s ? "M ".concat(m.x, ",").concat(m.y, `
        a`).concat(o, ",").concat(o, ",0,0,1,").concat(o * 2, `,0
        a`).concat(o, ",").concat(o, ",0,0,1,").concat(-o * 2, `,0
      `) : hx({
      cx: r,
      cy: n,
      innerRadius: a,
      outerRadius: i,
      startAngle: u,
      endAngle: d
    });
  var b = "M ".concat(m.x, ",").concat(m.y, `
    A`).concat(o, ",").concat(o, ",0,0,").concat(+(h < 0), ",").concat(p.x, ",").concat(p.y, `
    A`).concat(i, ",").concat(i, ",0,").concat(+(O > 180), ",").concat(+(h < 0), ",").concat(C.x, ",").concat(C.y, `
    A`).concat(o, ",").concat(o, ",0,0,").concat(+(h < 0), ",").concat(y.x, ",").concat(y.y, `
  `);
  if (a > 0) {
    var D = B3({
      cx: r,
      cy: n,
      radius: a,
      angle: u,
      sign: h,
      isExternal: !0,
      cornerRadius: o,
      cornerIsExternal: c
    }), M = D.circleTangency, j = D.lineTangency, P = D.theta, H = B3({
      cx: r,
      cy: n,
      radius: a,
      angle: d,
      sign: -h,
      isExternal: !0,
      cornerRadius: o,
      cornerIsExternal: c
    }), F = H.circleTangency, R = H.lineTangency, N = H.theta, z = c ? Math.abs(u - d) : Math.abs(u - d) - P - N;
    if (z < 0 && o === 0)
      return "".concat(b, "L").concat(r, ",").concat(n, "Z");
    b += "L".concat(R.x, ",").concat(R.y, `
      A`).concat(o, ",").concat(o, ",0,0,").concat(+(h < 0), ",").concat(F.x, ",").concat(F.y, `
      A`).concat(a, ",").concat(a, ",0,").concat(+(z > 180), ",").concat(+(h > 0), ",").concat(M.x, ",").concat(M.y, `
      A`).concat(o, ",").concat(o, ",0,0,").concat(+(h < 0), ",").concat(j.x, ",").concat(j.y, "Z");
  } else
    b += "L".concat(r, ",").concat(n, "Z");
  return b;
}, M1e = {
  cx: 0,
  cy: 0,
  innerRadius: 0,
  outerRadius: 0,
  startAngle: 0,
  endAngle: 0,
  cornerRadius: 0,
  forceCornerRadius: !1,
  cornerIsExternal: !1
}, Ax = function(t) {
  var r = Gp(Gp({}, M1e), t), n = r.cx, a = r.cy, i = r.innerRadius, o = r.outerRadius, s = r.cornerRadius, c = r.forceCornerRadius, u = r.cornerIsExternal, d = r.startAngle, h = r.endAngle, A = r.className;
  if (o < i || d === h)
    return null;
  var p = Pe("recharts-sector", A), m = o - i, g = er(s, m, 0, !0), v;
  return g > 0 && Math.abs(d - h) < 360 ? v = D1e({
    cx: n,
    cy: a,
    innerRadius: i,
    outerRadius: o,
    cornerRadius: Math.min(g, m / 2),
    forceCornerRadius: c,
    cornerIsExternal: u,
    startAngle: d,
    endAngle: h
  }) : v = hx({
    cx: n,
    cy: a,
    innerRadius: i,
    outerRadius: o,
    startAngle: d,
    endAngle: h
  }), /* @__PURE__ */ B.createElement("path", R5({}, Ae(r, !0), {
    className: p,
    d: v,
    role: "img"
  }));
};
function Po(e) {
  "@babel/helpers - typeof";
  return Po = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Po(e);
}
function $5() {
  return $5 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, $5.apply(this, arguments);
}
function Wp(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Qp(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Wp(Object(r), !0).forEach(function(n) {
      E1e(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Wp(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function E1e(e, t, r) {
  return t = P1e(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function P1e(e) {
  var t = j1e(e, "string");
  return Po(t) == "symbol" ? t : t + "";
}
function j1e(e, t) {
  if (Po(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (Po(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var Up = {
  curveBasisClosed: Ik,
  curveBasisOpen: Bk,
  curveBasis: Sk,
  curveBumpX: vk,
  curveBumpY: gk,
  curveLinearClosed: Nk,
  curveLinear: j0,
  curveMonotoneX: _k,
  curveMonotoneY: Lk,
  curveNatural: Tk,
  curveStep: Rk,
  curveStepAfter: Fk,
  curveStepBefore: $k
}, N3 = function(t) {
  return t.x === +t.x && t.y === +t.y;
}, yi = function(t) {
  return t.x;
}, wi = function(t) {
  return t.y;
}, S1e = function(t, r) {
  if (ye(t))
    return t;
  var n = "curve".concat(E0(t));
  return (n === "curveMonotone" || n === "curveBump") && r ? Up["".concat(n).concat(r === "vertical" ? "Y" : "X")] : Up[n] || j0;
}, I1e = function(t) {
  var r = t.type, n = r === void 0 ? "linear" : r, a = t.points, i = a === void 0 ? [] : a, o = t.baseLine, s = t.layout, c = t.connectNulls, u = c === void 0 ? !1 : c, d = S1e(n, s), h = u ? i.filter(function(g) {
    return N3(g);
  }) : i, A;
  if (Array.isArray(o)) {
    var p = u ? o.filter(function(g) {
      return N3(g);
    }) : o, m = h.map(function(g, v) {
      return Qp(Qp({}, g), {}, {
        base: p[v]
      });
    });
    return s === "vertical" ? A = x3().y(wi).x1(yi).x0(function(g) {
      return g.base.x;
    }) : A = x3().x(yi).y1(wi).y0(function(g) {
      return g.base.y;
    }), A.defined(N3).curve(d), A(m);
  }
  return s === "vertical" && se(o) ? A = x3().y(wi).x1(yi).x0(o) : se(o) ? A = x3().x(yi).y1(wi).y0(o) : A = ly().x(yi).y(wi), A.defined(N3).curve(d), A(h);
}, o1 = function(t) {
  var r = t.className, n = t.points, a = t.path, i = t.pathRef;
  if ((!n || !n.length) && !a)
    return null;
  var o = n && n.length ? I1e(t) : a;
  return /* @__PURE__ */ Sr.createElement("path", $5({}, Ae(t, !1), os(t), {
    className: Pe("recharts-curve", r),
    d: o,
    ref: i
  }));
}, B1e = Object.getOwnPropertyNames, N1e = Object.getOwnPropertySymbols, _1e = Object.prototype.hasOwnProperty;
function Zp(e, t) {
  return function(n, a, i) {
    return e(n, a, i) && t(n, a, i);
  };
}
function _3(e) {
  return function(r, n, a) {
    if (!r || !n || typeof r != "object" || typeof n != "object")
      return e(r, n, a);
    var i = a.cache, o = i.get(r), s = i.get(n);
    if (o && s)
      return o === n && s === r;
    i.set(r, n), i.set(n, r);
    var c = e(r, n, a);
    return i.delete(r), i.delete(n), c;
  };
}
function zp(e) {
  return B1e(e).concat(N1e(e));
}
var L1e = Object.hasOwn || function(e, t) {
  return _1e.call(e, t);
};
function la(e, t) {
  return e === t || !e && !t && e !== e && t !== t;
}
var T1e = "__v", R1e = "__o", $1e = "_owner", Kp = Object.getOwnPropertyDescriptor, qp = Object.keys;
function F1e(e, t, r) {
  var n = e.length;
  if (t.length !== n)
    return !1;
  for (; n-- > 0; )
    if (!r.equals(e[n], t[n], n, n, e, t, r))
      return !1;
  return !0;
}
function H1e(e, t) {
  return la(e.getTime(), t.getTime());
}
function Y1e(e, t) {
  return e.name === t.name && e.message === t.message && e.cause === t.cause && e.stack === t.stack;
}
function V1e(e, t) {
  return e === t;
}
function Xp(e, t, r) {
  var n = e.size;
  if (n !== t.size)
    return !1;
  if (!n)
    return !0;
  for (var a = new Array(n), i = e.entries(), o, s, c = 0; (o = i.next()) && !o.done; ) {
    for (var u = t.entries(), d = !1, h = 0; (s = u.next()) && !s.done; ) {
      if (a[h]) {
        h++;
        continue;
      }
      var A = o.value, p = s.value;
      if (r.equals(A[0], p[0], c, h, e, t, r) && r.equals(A[1], p[1], A[0], p[0], e, t, r)) {
        d = a[h] = !0;
        break;
      }
      h++;
    }
    if (!d)
      return !1;
    c++;
  }
  return !0;
}
var k1e = la;
function G1e(e, t, r) {
  var n = qp(e), a = n.length;
  if (qp(t).length !== a)
    return !1;
  for (; a-- > 0; )
    if (!px(e, t, r, n[a]))
      return !1;
  return !0;
}
function xi(e, t, r) {
  var n = zp(e), a = n.length;
  if (zp(t).length !== a)
    return !1;
  for (var i, o, s; a-- > 0; )
    if (i = n[a], !px(e, t, r, i) || (o = Kp(e, i), s = Kp(t, i), (o || s) && (!o || !s || o.configurable !== s.configurable || o.enumerable !== s.enumerable || o.writable !== s.writable)))
      return !1;
  return !0;
}
function W1e(e, t) {
  return la(e.valueOf(), t.valueOf());
}
function Q1e(e, t) {
  return e.source === t.source && e.flags === t.flags;
}
function Jp(e, t, r) {
  var n = e.size;
  if (n !== t.size)
    return !1;
  if (!n)
    return !0;
  for (var a = new Array(n), i = e.values(), o, s; (o = i.next()) && !o.done; ) {
    for (var c = t.values(), u = !1, d = 0; (s = c.next()) && !s.done; ) {
      if (!a[d] && r.equals(o.value, s.value, o.value, s.value, e, t, r)) {
        u = a[d] = !0;
        break;
      }
      d++;
    }
    if (!u)
      return !1;
  }
  return !0;
}
function U1e(e, t) {
  var r = e.length;
  if (t.length !== r)
    return !1;
  for (; r-- > 0; )
    if (e[r] !== t[r])
      return !1;
  return !0;
}
function Z1e(e, t) {
  return e.hostname === t.hostname && e.pathname === t.pathname && e.protocol === t.protocol && e.port === t.port && e.hash === t.hash && e.username === t.username && e.password === t.password;
}
function px(e, t, r, n) {
  return (n === $1e || n === R1e || n === T1e) && (e.$$typeof || t.$$typeof) ? !0 : L1e(t, n) && r.equals(e[n], t[n], n, n, e, t, r);
}
var z1e = "[object Arguments]", K1e = "[object Boolean]", q1e = "[object Date]", X1e = "[object Error]", J1e = "[object Map]", eae = "[object Number]", tae = "[object Object]", rae = "[object RegExp]", nae = "[object Set]", aae = "[object String]", iae = "[object URL]", oae = Array.isArray, ev = typeof ArrayBuffer == "function" && ArrayBuffer.isView ? ArrayBuffer.isView : null, tv = Object.assign, sae = Object.prototype.toString.call.bind(Object.prototype.toString);
function lae(e) {
  var t = e.areArraysEqual, r = e.areDatesEqual, n = e.areErrorsEqual, a = e.areFunctionsEqual, i = e.areMapsEqual, o = e.areNumbersEqual, s = e.areObjectsEqual, c = e.arePrimitiveWrappersEqual, u = e.areRegExpsEqual, d = e.areSetsEqual, h = e.areTypedArraysEqual, A = e.areUrlsEqual;
  return function(m, g, v) {
    if (m === g)
      return !0;
    if (m == null || g == null)
      return !1;
    var C = typeof m;
    if (C !== typeof g)
      return !1;
    if (C !== "object")
      return C === "number" ? o(m, g, v) : C === "function" ? a(m, g, v) : !1;
    var y = m.constructor;
    if (y !== g.constructor)
      return !1;
    if (y === Object)
      return s(m, g, v);
    if (oae(m))
      return t(m, g, v);
    if (ev != null && ev(m))
      return h(m, g, v);
    if (y === Date)
      return r(m, g, v);
    if (y === RegExp)
      return u(m, g, v);
    if (y === Map)
      return i(m, g, v);
    if (y === Set)
      return d(m, g, v);
    var w = sae(m);
    return w === q1e ? r(m, g, v) : w === rae ? u(m, g, v) : w === J1e ? i(m, g, v) : w === nae ? d(m, g, v) : w === tae ? typeof m.then != "function" && typeof g.then != "function" && s(m, g, v) : w === iae ? A(m, g, v) : w === X1e ? n(m, g, v) : w === z1e ? s(m, g, v) : w === K1e || w === eae || w === aae ? c(m, g, v) : !1;
  };
}
function cae(e) {
  var t = e.circular, r = e.createCustomConfig, n = e.strict, a = {
    areArraysEqual: n ? xi : F1e,
    areDatesEqual: H1e,
    areErrorsEqual: Y1e,
    areFunctionsEqual: V1e,
    areMapsEqual: n ? Zp(Xp, xi) : Xp,
    areNumbersEqual: k1e,
    areObjectsEqual: n ? xi : G1e,
    arePrimitiveWrappersEqual: W1e,
    areRegExpsEqual: Q1e,
    areSetsEqual: n ? Zp(Jp, xi) : Jp,
    areTypedArraysEqual: n ? xi : U1e,
    areUrlsEqual: Z1e
  };
  if (r && (a = tv({}, a, r(a))), t) {
    var i = _3(a.areArraysEqual), o = _3(a.areMapsEqual), s = _3(a.areObjectsEqual), c = _3(a.areSetsEqual);
    a = tv({}, a, {
      areArraysEqual: i,
      areMapsEqual: o,
      areObjectsEqual: s,
      areSetsEqual: c
    });
  }
  return a;
}
function uae(e) {
  return function(t, r, n, a, i, o, s) {
    return e(t, r, s);
  };
}
function fae(e) {
  var t = e.circular, r = e.comparator, n = e.createState, a = e.equals, i = e.strict;
  if (n)
    return function(c, u) {
      var d = n(), h = d.cache, A = h === void 0 ? t ? /* @__PURE__ */ new WeakMap() : void 0 : h, p = d.meta;
      return r(c, u, {
        cache: A,
        equals: a,
        meta: p,
        strict: i
      });
    };
  if (t)
    return function(c, u) {
      return r(c, u, {
        cache: /* @__PURE__ */ new WeakMap(),
        equals: a,
        meta: void 0,
        strict: i
      });
    };
  var o = {
    cache: void 0,
    equals: a,
    meta: void 0,
    strict: i
  };
  return function(c, u) {
    return r(c, u, o);
  };
}
var dae = b1();
b1({ strict: !0 });
b1({ circular: !0 });
b1({
  circular: !0,
  strict: !0
});
b1({
  createInternalComparator: function() {
    return la;
  }
});
b1({
  strict: !0,
  createInternalComparator: function() {
    return la;
  }
});
b1({
  circular: !0,
  createInternalComparator: function() {
    return la;
  }
});
b1({
  circular: !0,
  createInternalComparator: function() {
    return la;
  },
  strict: !0
});
function b1(e) {
  e === void 0 && (e = {});
  var t = e.circular, r = t === void 0 ? !1 : t, n = e.createInternalComparator, a = e.createState, i = e.strict, o = i === void 0 ? !1 : i, s = cae(e), c = lae(s), u = n ? n(c) : uae(c);
  return fae({ circular: r, comparator: c, createState: a, equals: u, strict: o });
}
function hae(e) {
  typeof requestAnimationFrame < "u" && requestAnimationFrame(e);
}
function rv(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, r = -1, n = function a(i) {
    r < 0 && (r = i), i - r > t ? (e(i), r = -1) : hae(a);
  };
  requestAnimationFrame(n);
}
function F5(e) {
  "@babel/helpers - typeof";
  return F5 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, F5(e);
}
function Aae(e) {
  return mae(e) || gae(e) || vae(e) || pae();
}
function pae() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function vae(e, t) {
  if (e) {
    if (typeof e == "string")
      return nv(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return nv(e, t);
  }
}
function nv(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
function gae(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null)
    return Array.from(e);
}
function mae(e) {
  if (Array.isArray(e))
    return e;
}
function Cae() {
  var e = {}, t = function() {
    return null;
  }, r = !1, n = function a(i) {
    if (!r) {
      if (Array.isArray(i)) {
        if (!i.length)
          return;
        var o = i, s = Aae(o), c = s[0], u = s.slice(1);
        if (typeof c == "number") {
          rv(a.bind(null, u), c);
          return;
        }
        a(c), rv(a.bind(null, u));
        return;
      }
      F5(i) === "object" && (e = i, t(e)), typeof i == "function" && i();
    }
  };
  return {
    stop: function() {
      r = !0;
    },
    start: function(i) {
      r = !1, n(i);
    },
    subscribe: function(i) {
      return t = i, function() {
        t = function() {
          return null;
        };
      };
    }
  };
}
function jo(e) {
  "@babel/helpers - typeof";
  return jo = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, jo(e);
}
function av(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function iv(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? av(Object(r), !0).forEach(function(n) {
      vx(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : av(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function vx(e, t, r) {
  return t = bae(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function bae(e) {
  var t = yae(e, "string");
  return jo(t) === "symbol" ? t : String(t);
}
function yae(e, t) {
  if (jo(e) !== "object" || e === null)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (jo(n) !== "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var wae = function(t, r) {
  return [Object.keys(t), Object.keys(r)].reduce(function(n, a) {
    return n.filter(function(i) {
      return a.includes(i);
    });
  });
}, xae = function(t) {
  return t;
}, Oae = function(t) {
  return t.replace(/([A-Z])/g, function(r) {
    return "-".concat(r.toLowerCase());
  });
}, Qi = function(t, r) {
  return Object.keys(r).reduce(function(n, a) {
    return iv(iv({}, n), {}, vx({}, a, t(a, r[a])));
  }, {});
}, ov = function(t, r, n) {
  return t.map(function(a) {
    return "".concat(Oae(a), " ").concat(r, "ms ").concat(n);
  }).join(",");
}, Dae = process.env.NODE_ENV !== "production", Ts = function(t, r, n, a, i, o, s, c) {
  if (Dae && typeof console < "u" && console.warn && (r === void 0 && console.warn("LogUtils requires an error message argument"), !t))
    if (r === void 0)
      console.warn("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
    else {
      var u = [n, a, i, o, s, c], d = 0;
      console.warn(r.replace(/%s/g, function() {
        return u[d++];
      }));
    }
};
function Mae(e, t) {
  return jae(e) || Pae(e, t) || gx(e, t) || Eae();
}
function Eae() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Pae(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, a, i, o, s = [], c = !0, u = !1;
    try {
      if (i = (r = r.call(e)).next, t === 0) {
        if (Object(r) !== r)
          return;
        c = !1;
      } else
        for (; !(c = (n = i.call(r)).done) && (s.push(n.value), s.length !== t); c = !0)
          ;
    } catch (d) {
      u = !0, a = d;
    } finally {
      try {
        if (!c && r.return != null && (o = r.return(), Object(o) !== o))
          return;
      } finally {
        if (u)
          throw a;
      }
    }
    return s;
  }
}
function jae(e) {
  if (Array.isArray(e))
    return e;
}
function Sae(e) {
  return Nae(e) || Bae(e) || gx(e) || Iae();
}
function Iae() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function gx(e, t) {
  if (e) {
    if (typeof e == "string")
      return H5(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return H5(e, t);
  }
}
function Bae(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null)
    return Array.from(e);
}
function Nae(e) {
  if (Array.isArray(e))
    return H5(e);
}
function H5(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
var Rs = 1e-4, mx = function(t, r) {
  return [0, 3 * t, 3 * r - 6 * t, 3 * t - 3 * r + 1];
}, Cx = function(t, r) {
  return t.map(function(n, a) {
    return n * Math.pow(r, a);
  }).reduce(function(n, a) {
    return n + a;
  });
}, sv = function(t, r) {
  return function(n) {
    var a = mx(t, r);
    return Cx(a, n);
  };
}, _ae = function(t, r) {
  return function(n) {
    var a = mx(t, r), i = [].concat(Sae(a.map(function(o, s) {
      return o * s;
    }).slice(1)), [0]);
    return Cx(i, n);
  };
}, lv = function() {
  for (var t = arguments.length, r = new Array(t), n = 0; n < t; n++)
    r[n] = arguments[n];
  var a = r[0], i = r[1], o = r[2], s = r[3];
  if (r.length === 1)
    switch (r[0]) {
      case "linear":
        a = 0, i = 0, o = 1, s = 1;
        break;
      case "ease":
        a = 0.25, i = 0.1, o = 0.25, s = 1;
        break;
      case "ease-in":
        a = 0.42, i = 0, o = 1, s = 1;
        break;
      case "ease-out":
        a = 0.42, i = 0, o = 0.58, s = 1;
        break;
      case "ease-in-out":
        a = 0, i = 0, o = 0.58, s = 1;
        break;
      default: {
        var c = r[0].split("(");
        if (c[0] === "cubic-bezier" && c[1].split(")")[0].split(",").length === 4) {
          var u = c[1].split(")")[0].split(",").map(function(v) {
            return parseFloat(v);
          }), d = Mae(u, 4);
          a = d[0], i = d[1], o = d[2], s = d[3];
        } else
          Ts(!1, "[configBezier]: arguments should be one of oneOf 'linear', 'ease', 'ease-in', 'ease-out', 'ease-in-out','cubic-bezier(x1,y1,x2,y2)', instead received %s", r);
      }
    }
  Ts([a, o, i, s].every(function(v) {
    return typeof v == "number" && v >= 0 && v <= 1;
  }), "[configBezier]: arguments should be x1, y1, x2, y2 of [0, 1] instead received %s", r);
  var h = sv(a, o), A = sv(i, s), p = _ae(a, o), m = function(C) {
    return C > 1 ? 1 : C < 0 ? 0 : C;
  }, g = function(C) {
    for (var y = C > 1 ? 1 : C, w = y, O = 0; O < 8; ++O) {
      var b = h(w) - y, D = p(w);
      if (Math.abs(b - y) < Rs || D < Rs)
        return A(w);
      w = m(w - b / D);
    }
    return A(w);
  };
  return g.isStepper = !1, g;
}, Lae = function() {
  var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, r = t.stiff, n = r === void 0 ? 100 : r, a = t.damping, i = a === void 0 ? 8 : a, o = t.dt, s = o === void 0 ? 17 : o, c = function(d, h, A) {
    var p = -(d - h) * n, m = A * i, g = A + (p - m) * s / 1e3, v = A * s / 1e3 + d;
    return Math.abs(v - h) < Rs && Math.abs(g) < Rs ? [h, 0] : [v, g];
  };
  return c.isStepper = !0, c.dt = s, c;
}, Tae = function() {
  for (var t = arguments.length, r = new Array(t), n = 0; n < t; n++)
    r[n] = arguments[n];
  var a = r[0];
  if (typeof a == "string")
    switch (a) {
      case "ease":
      case "ease-in-out":
      case "ease-out":
      case "ease-in":
      case "linear":
        return lv(a);
      case "spring":
        return Lae();
      default:
        if (a.split("(")[0] === "cubic-bezier")
          return lv(a);
        Ts(!1, "[configEasing]: first argument should be one of 'ease', 'ease-in', 'ease-out', 'ease-in-out','cubic-bezier(x1,y1,x2,y2)', 'linear' and 'spring', instead  received %s", r);
    }
  return typeof a == "function" ? a : (Ts(!1, "[configEasing]: first argument type should be function or string, instead received %s", r), null);
};
function So(e) {
  "@babel/helpers - typeof";
  return So = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, So(e);
}
function cv(e) {
  return Fae(e) || $ae(e) || bx(e) || Rae();
}
function Rae() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function $ae(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null)
    return Array.from(e);
}
function Fae(e) {
  if (Array.isArray(e))
    return V5(e);
}
function uv(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Vt(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? uv(Object(r), !0).forEach(function(n) {
      Y5(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : uv(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function Y5(e, t, r) {
  return t = Hae(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function Hae(e) {
  var t = Yae(e, "string");
  return So(t) === "symbol" ? t : String(t);
}
function Yae(e, t) {
  if (So(e) !== "object" || e === null)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (So(n) !== "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function Vae(e, t) {
  return Wae(e) || Gae(e, t) || bx(e, t) || kae();
}
function kae() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function bx(e, t) {
  if (e) {
    if (typeof e == "string")
      return V5(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return V5(e, t);
  }
}
function V5(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
function Gae(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, a, i, o, s = [], c = !0, u = !1;
    try {
      if (i = (r = r.call(e)).next, t === 0) {
        if (Object(r) !== r)
          return;
        c = !1;
      } else
        for (; !(c = (n = i.call(r)).done) && (s.push(n.value), s.length !== t); c = !0)
          ;
    } catch (d) {
      u = !0, a = d;
    } finally {
      try {
        if (!c && r.return != null && (o = r.return(), Object(o) !== o))
          return;
      } finally {
        if (u)
          throw a;
      }
    }
    return s;
  }
}
function Wae(e) {
  if (Array.isArray(e))
    return e;
}
var $s = function(t, r, n) {
  return t + (r - t) * n;
}, k5 = function(t) {
  var r = t.from, n = t.to;
  return r !== n;
}, Qae = function e(t, r, n) {
  var a = Qi(function(i, o) {
    if (k5(o)) {
      var s = t(o.from, o.to, o.velocity), c = Vae(s, 2), u = c[0], d = c[1];
      return Vt(Vt({}, o), {}, {
        from: u,
        velocity: d
      });
    }
    return o;
  }, r);
  return n < 1 ? Qi(function(i, o) {
    return k5(o) ? Vt(Vt({}, o), {}, {
      velocity: $s(o.velocity, a[i].velocity, n),
      from: $s(o.from, a[i].from, n)
    }) : o;
  }, r) : e(t, a, n - 1);
};
const Uae = function(e, t, r, n, a) {
  var i = wae(e, t), o = i.reduce(function(v, C) {
    return Vt(Vt({}, v), {}, Y5({}, C, [e[C], t[C]]));
  }, {}), s = i.reduce(function(v, C) {
    return Vt(Vt({}, v), {}, Y5({}, C, {
      from: e[C],
      velocity: 0,
      to: t[C]
    }));
  }, {}), c = -1, u, d, h = function() {
    return null;
  }, A = function() {
    return Qi(function(C, y) {
      return y.from;
    }, s);
  }, p = function() {
    return !Object.values(s).filter(k5).length;
  }, m = function(C) {
    u || (u = C);
    var y = C - u, w = y / r.dt;
    s = Qae(r, s, w), a(Vt(Vt(Vt({}, e), t), A())), u = C, p() || (c = requestAnimationFrame(h));
  }, g = function(C) {
    d || (d = C);
    var y = (C - d) / n, w = Qi(function(b, D) {
      return $s.apply(void 0, cv(D).concat([r(y)]));
    }, o);
    if (a(Vt(Vt(Vt({}, e), t), w)), y < 1)
      c = requestAnimationFrame(h);
    else {
      var O = Qi(function(b, D) {
        return $s.apply(void 0, cv(D).concat([r(1)]));
      }, o);
      a(Vt(Vt(Vt({}, e), t), O));
    }
  };
  return h = r.isStepper ? m : g, function() {
    return requestAnimationFrame(h), function() {
      cancelAnimationFrame(c);
    };
  };
};
function o2(e) {
  "@babel/helpers - typeof";
  return o2 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, o2(e);
}
var Zae = ["children", "begin", "duration", "attributeName", "easing", "isActive", "steps", "from", "to", "canBegin", "onAnimationEnd", "shouldReAnimate", "onAnimationReStart"];
function zae(e, t) {
  if (e == null)
    return {};
  var r = Kae(e, t), n, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (a = 0; a < i.length; a++)
      n = i[a], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function Kae(e, t) {
  if (e == null)
    return {};
  var r = {}, n = Object.keys(e), a, i;
  for (i = 0; i < n.length; i++)
    a = n[i], !(t.indexOf(a) >= 0) && (r[a] = e[a]);
  return r;
}
function s4(e) {
  return e2e(e) || Jae(e) || Xae(e) || qae();
}
function qae() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Xae(e, t) {
  if (e) {
    if (typeof e == "string")
      return G5(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return G5(e, t);
  }
}
function Jae(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null)
    return Array.from(e);
}
function e2e(e) {
  if (Array.isArray(e))
    return G5(e);
}
function G5(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
function fv(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Rr(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? fv(Object(r), !0).forEach(function(n) {
      Fi(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : fv(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function Fi(e, t, r) {
  return t = yx(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function t2e(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function dv(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, yx(n.key), n);
  }
}
function r2e(e, t, r) {
  return t && dv(e.prototype, t), r && dv(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function yx(e) {
  var t = n2e(e, "string");
  return o2(t) === "symbol" ? t : String(t);
}
function n2e(e, t) {
  if (o2(e) !== "object" || e === null)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (o2(n) !== "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function a2e(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && W5(e, t);
}
function W5(e, t) {
  return W5 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, a) {
    return n.__proto__ = a, n;
  }, W5(e, t);
}
function i2e(e) {
  var t = o2e();
  return function() {
    var n = Fs(e), a;
    if (t) {
      var i = Fs(this).constructor;
      a = Reflect.construct(n, arguments, i);
    } else
      a = n.apply(this, arguments);
    return Q5(this, a);
  };
}
function Q5(e, t) {
  if (t && (o2(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return U5(e);
}
function U5(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function o2e() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function Fs(e) {
  return Fs = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, Fs(e);
}
var W0 = /* @__PURE__ */ function(e) {
  a2e(r, e);
  var t = i2e(r);
  function r(n, a) {
    var i;
    t2e(this, r), i = t.call(this, n, a);
    var o = i.props, s = o.isActive, c = o.attributeName, u = o.from, d = o.to, h = o.steps, A = o.children, p = o.duration;
    if (i.handleStyleChange = i.handleStyleChange.bind(U5(i)), i.changeStyle = i.changeStyle.bind(U5(i)), !s || p <= 0)
      return i.state = {
        style: {}
      }, typeof A == "function" && (i.state = {
        style: d
      }), Q5(i);
    if (h && h.length)
      i.state = {
        style: h[0].style
      };
    else if (u) {
      if (typeof A == "function")
        return i.state = {
          style: u
        }, Q5(i);
      i.state = {
        style: c ? Fi({}, c, u) : u
      };
    } else
      i.state = {
        style: {}
      };
    return i;
  }
  return r2e(r, [{
    key: "componentDidMount",
    value: function() {
      var a = this.props, i = a.isActive, o = a.canBegin;
      this.mounted = !0, !(!i || !o) && this.runAnimation(this.props);
    }
  }, {
    key: "componentDidUpdate",
    value: function(a) {
      var i = this.props, o = i.isActive, s = i.canBegin, c = i.attributeName, u = i.shouldReAnimate, d = i.to, h = i.from, A = this.state.style;
      if (s) {
        if (!o) {
          var p = {
            style: c ? Fi({}, c, d) : d
          };
          this.state && A && (c && A[c] !== d || !c && A !== d) && this.setState(p);
          return;
        }
        if (!(dae(a.to, d) && a.canBegin && a.isActive)) {
          var m = !a.canBegin || !a.isActive;
          this.manager && this.manager.stop(), this.stopJSAnimation && this.stopJSAnimation();
          var g = m || u ? h : a.to;
          if (this.state && A) {
            var v = {
              style: c ? Fi({}, c, g) : g
            };
            (c && A[c] !== g || !c && A !== g) && this.setState(v);
          }
          this.runAnimation(Rr(Rr({}, this.props), {}, {
            from: g,
            begin: 0
          }));
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      this.mounted = !1;
      var a = this.props.onAnimationEnd;
      this.unSubscribe && this.unSubscribe(), this.manager && (this.manager.stop(), this.manager = null), this.stopJSAnimation && this.stopJSAnimation(), a && a();
    }
  }, {
    key: "handleStyleChange",
    value: function(a) {
      this.changeStyle(a);
    }
  }, {
    key: "changeStyle",
    value: function(a) {
      this.mounted && this.setState({
        style: a
      });
    }
  }, {
    key: "runJSAnimation",
    value: function(a) {
      var i = this, o = a.from, s = a.to, c = a.duration, u = a.easing, d = a.begin, h = a.onAnimationEnd, A = a.onAnimationStart, p = Uae(o, s, Tae(u), c, this.changeStyle), m = function() {
        i.stopJSAnimation = p();
      };
      this.manager.start([A, d, m, c, h]);
    }
  }, {
    key: "runStepAnimation",
    value: function(a) {
      var i = this, o = a.steps, s = a.begin, c = a.onAnimationStart, u = o[0], d = u.style, h = u.duration, A = h === void 0 ? 0 : h, p = function(g, v, C) {
        if (C === 0)
          return g;
        var y = v.duration, w = v.easing, O = w === void 0 ? "ease" : w, b = v.style, D = v.properties, M = v.onAnimationEnd, j = C > 0 ? o[C - 1] : v, P = D || Object.keys(b);
        if (typeof O == "function" || O === "spring")
          return [].concat(s4(g), [i.runJSAnimation.bind(i, {
            from: j.style,
            to: b,
            duration: y,
            easing: O
          }), y]);
        var H = ov(P, y, O), F = Rr(Rr(Rr({}, j.style), b), {}, {
          transition: H
        });
        return [].concat(s4(g), [F, y, M]).filter(xae);
      };
      return this.manager.start([c].concat(s4(o.reduce(p, [d, Math.max(A, s)])), [a.onAnimationEnd]));
    }
  }, {
    key: "runAnimation",
    value: function(a) {
      this.manager || (this.manager = Cae());
      var i = a.begin, o = a.duration, s = a.attributeName, c = a.to, u = a.easing, d = a.onAnimationStart, h = a.onAnimationEnd, A = a.steps, p = a.children, m = this.manager;
      if (this.unSubscribe = m.subscribe(this.handleStyleChange), typeof u == "function" || typeof p == "function" || u === "spring") {
        this.runJSAnimation(a);
        return;
      }
      if (A.length > 1) {
        this.runStepAnimation(a);
        return;
      }
      var g = s ? Fi({}, s, c) : c, v = ov(Object.keys(g), o, u);
      m.start([d, i, Rr(Rr({}, g), {}, {
        transition: v
      }), o, h]);
    }
  }, {
    key: "render",
    value: function() {
      var a = this.props, i = a.children;
      a.begin;
      var o = a.duration;
      a.attributeName, a.easing;
      var s = a.isActive;
      a.steps, a.from, a.to, a.canBegin, a.onAnimationEnd, a.shouldReAnimate, a.onAnimationReStart;
      var c = zae(a, Zae), u = K1.count(i), d = this.state.style;
      if (typeof i == "function")
        return i(d);
      if (!s || u === 0 || o <= 0)
        return i;
      var h = function(p) {
        var m = p.props, g = m.style, v = g === void 0 ? {} : g, C = m.className, y = /* @__PURE__ */ Bt(p, Rr(Rr({}, c), {}, {
          style: Rr(Rr({}, v), d),
          className: C
        }));
        return y;
      };
      return u === 1 ? h(K1.only(i)) : /* @__PURE__ */ B.createElement("div", null, K1.map(i, function(A) {
        return h(A);
      }));
    }
  }]), r;
}(Cr);
W0.displayName = "Animate";
W0.defaultProps = {
  begin: 0,
  duration: 1e3,
  from: "",
  to: "",
  attributeName: "",
  easing: "ease",
  isActive: !0,
  canBegin: !0,
  steps: [],
  onAnimationEnd: function() {
  },
  onAnimationStart: function() {
  }
};
W0.propTypes = {
  from: Te.oneOfType([Te.object, Te.string]),
  to: Te.oneOfType([Te.object, Te.string]),
  attributeName: Te.string,
  // animation duration
  duration: Te.number,
  begin: Te.number,
  easing: Te.oneOfType([Te.string, Te.func]),
  steps: Te.arrayOf(Te.shape({
    duration: Te.number.isRequired,
    style: Te.object.isRequired,
    easing: Te.oneOfType([Te.oneOf(["ease", "ease-in", "ease-out", "ease-in-out", "linear"]), Te.func]),
    // transition css properties(dash case), optional
    properties: Te.arrayOf("string"),
    onAnimationEnd: Te.func
  })),
  children: Te.oneOfType([Te.node, Te.func]),
  isActive: Te.bool,
  canBegin: Te.bool,
  onAnimationEnd: Te.func,
  // decide if it should reanimate with initial from style when props change
  shouldReAnimate: Te.bool,
  onAnimationStart: Te.func,
  onAnimationReStart: Te.func
};
const Sn = W0;
function Io(e) {
  "@babel/helpers - typeof";
  return Io = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Io(e);
}
function Hs() {
  return Hs = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Hs.apply(this, arguments);
}
function s2e(e, t) {
  return f2e(e) || u2e(e, t) || c2e(e, t) || l2e();
}
function l2e() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function c2e(e, t) {
  if (e) {
    if (typeof e == "string")
      return hv(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return hv(e, t);
  }
}
function hv(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
function u2e(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, a, i, o, s = [], c = !0, u = !1;
    try {
      if (i = (r = r.call(e)).next, t === 0) {
        if (Object(r) !== r)
          return;
        c = !1;
      } else
        for (; !(c = (n = i.call(r)).done) && (s.push(n.value), s.length !== t); c = !0)
          ;
    } catch (d) {
      u = !0, a = d;
    } finally {
      try {
        if (!c && r.return != null && (o = r.return(), Object(o) !== o))
          return;
      } finally {
        if (u)
          throw a;
      }
    }
    return s;
  }
}
function f2e(e) {
  if (Array.isArray(e))
    return e;
}
function Av(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function pv(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Av(Object(r), !0).forEach(function(n) {
      d2e(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Av(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function d2e(e, t, r) {
  return t = h2e(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function h2e(e) {
  var t = A2e(e, "string");
  return Io(t) == "symbol" ? t : t + "";
}
function A2e(e, t) {
  if (Io(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (Io(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var vv = function(t, r, n, a, i) {
  var o = Math.min(Math.abs(n) / 2, Math.abs(a) / 2), s = a >= 0 ? 1 : -1, c = n >= 0 ? 1 : -1, u = a >= 0 && n >= 0 || a < 0 && n < 0 ? 1 : 0, d;
  if (o > 0 && i instanceof Array) {
    for (var h = [0, 0, 0, 0], A = 0, p = 4; A < p; A++)
      h[A] = i[A] > o ? o : i[A];
    d = "M".concat(t, ",").concat(r + s * h[0]), h[0] > 0 && (d += "A ".concat(h[0], ",").concat(h[0], ",0,0,").concat(u, ",").concat(t + c * h[0], ",").concat(r)), d += "L ".concat(t + n - c * h[1], ",").concat(r), h[1] > 0 && (d += "A ".concat(h[1], ",").concat(h[1], ",0,0,").concat(u, `,
        `).concat(t + n, ",").concat(r + s * h[1])), d += "L ".concat(t + n, ",").concat(r + a - s * h[2]), h[2] > 0 && (d += "A ".concat(h[2], ",").concat(h[2], ",0,0,").concat(u, `,
        `).concat(t + n - c * h[2], ",").concat(r + a)), d += "L ".concat(t + c * h[3], ",").concat(r + a), h[3] > 0 && (d += "A ".concat(h[3], ",").concat(h[3], ",0,0,").concat(u, `,
        `).concat(t, ",").concat(r + a - s * h[3])), d += "Z";
  } else if (o > 0 && i === +i && i > 0) {
    var m = Math.min(o, i);
    d = "M ".concat(t, ",").concat(r + s * m, `
            A `).concat(m, ",").concat(m, ",0,0,").concat(u, ",").concat(t + c * m, ",").concat(r, `
            L `).concat(t + n - c * m, ",").concat(r, `
            A `).concat(m, ",").concat(m, ",0,0,").concat(u, ",").concat(t + n, ",").concat(r + s * m, `
            L `).concat(t + n, ",").concat(r + a - s * m, `
            A `).concat(m, ",").concat(m, ",0,0,").concat(u, ",").concat(t + n - c * m, ",").concat(r + a, `
            L `).concat(t + c * m, ",").concat(r + a, `
            A `).concat(m, ",").concat(m, ",0,0,").concat(u, ",").concat(t, ",").concat(r + a - s * m, " Z");
  } else
    d = "M ".concat(t, ",").concat(r, " h ").concat(n, " v ").concat(a, " h ").concat(-n, " Z");
  return d;
}, p2e = function(t, r) {
  if (!t || !r)
    return !1;
  var n = t.x, a = t.y, i = r.x, o = r.y, s = r.width, c = r.height;
  if (Math.abs(s) > 0 && Math.abs(c) > 0) {
    var u = Math.min(i, i + s), d = Math.max(i, i + s), h = Math.min(o, o + c), A = Math.max(o, o + c);
    return n >= u && n <= d && a >= h && a <= A;
  }
  return !1;
}, v2e = {
  x: 0,
  y: 0,
  width: 0,
  height: 0,
  // The radius of border
  // The radius of four corners when radius is a number
  // The radius of left-top, right-top, right-bottom, left-bottom when radius is an array
  radius: 0,
  isAnimationActive: !1,
  isUpdateAnimationActive: !1,
  animationBegin: 0,
  animationDuration: 1500,
  animationEasing: "ease"
}, J9 = function(t) {
  var r = pv(pv({}, v2e), t), n = ge(), a = De(-1), i = s2e(a, 2), o = i[0], s = i[1];
  Ie(function() {
    if (n.current && n.current.getTotalLength)
      try {
        var O = n.current.getTotalLength();
        O && s(O);
      } catch {
      }
  }, []);
  var c = r.x, u = r.y, d = r.width, h = r.height, A = r.radius, p = r.className, m = r.animationEasing, g = r.animationDuration, v = r.animationBegin, C = r.isAnimationActive, y = r.isUpdateAnimationActive;
  if (c !== +c || u !== +u || d !== +d || h !== +h || d === 0 || h === 0)
    return null;
  var w = Pe("recharts-rectangle", p);
  return y ? /* @__PURE__ */ B.createElement(Sn, {
    canBegin: o > 0,
    from: {
      width: d,
      height: h,
      x: c,
      y: u
    },
    to: {
      width: d,
      height: h,
      x: c,
      y: u
    },
    duration: g,
    animationEasing: m,
    isActive: y
  }, function(O) {
    var b = O.width, D = O.height, M = O.x, j = O.y;
    return /* @__PURE__ */ B.createElement(Sn, {
      canBegin: o > 0,
      from: "0px ".concat(o === -1 ? 1 : o, "px"),
      to: "".concat(o, "px 0px"),
      attributeName: "strokeDasharray",
      begin: v,
      duration: g,
      isActive: C,
      easing: m
    }, /* @__PURE__ */ B.createElement("path", Hs({}, Ae(r, !0), {
      className: w,
      d: vv(M, j, b, D, A),
      ref: n
    })));
  }) : /* @__PURE__ */ B.createElement("path", Hs({}, Ae(r, !0), {
    className: w,
    d: vv(c, u, d, h, A)
  }));
}, g2e = ["points", "className", "baseLinePoints", "connectNulls"];
function $a() {
  return $a = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, $a.apply(this, arguments);
}
function m2e(e, t) {
  if (e == null)
    return {};
  var r = C2e(e, t), n, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (a = 0; a < i.length; a++)
      n = i[a], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function C2e(e, t) {
  if (e == null)
    return {};
  var r = {};
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      if (t.indexOf(n) >= 0)
        continue;
      r[n] = e[n];
    }
  return r;
}
function gv(e) {
  return x2e(e) || w2e(e) || y2e(e) || b2e();
}
function b2e() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function y2e(e, t) {
  if (e) {
    if (typeof e == "string")
      return Z5(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return Z5(e, t);
  }
}
function w2e(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null)
    return Array.from(e);
}
function x2e(e) {
  if (Array.isArray(e))
    return Z5(e);
}
function Z5(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
var mv = function(t) {
  return t && t.x === +t.x && t.y === +t.y;
}, O2e = function() {
  var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], r = [[]];
  return t.forEach(function(n) {
    mv(n) ? r[r.length - 1].push(n) : r[r.length - 1].length > 0 && r.push([]);
  }), mv(t[0]) && r[r.length - 1].push(t[0]), r[r.length - 1].length <= 0 && (r = r.slice(0, -1)), r;
}, Ui = function(t, r) {
  var n = O2e(t);
  r && (n = [n.reduce(function(i, o) {
    return [].concat(gv(i), gv(o));
  }, [])]);
  var a = n.map(function(i) {
    return i.reduce(function(o, s, c) {
      return "".concat(o).concat(c === 0 ? "M" : "L").concat(s.x, ",").concat(s.y);
    }, "");
  }).join("");
  return n.length === 1 ? "".concat(a, "Z") : a;
}, D2e = function(t, r, n) {
  var a = Ui(t, n);
  return "".concat(a.slice(-1) === "Z" ? a.slice(0, -1) : a, "L").concat(Ui(r.reverse(), n).slice(1));
}, M2e = function(t) {
  var r = t.points, n = t.className, a = t.baseLinePoints, i = t.connectNulls, o = m2e(t, g2e);
  if (!r || !r.length)
    return null;
  var s = Pe("recharts-polygon", n);
  if (a && a.length) {
    var c = o.stroke && o.stroke !== "none", u = D2e(r, a, i);
    return /* @__PURE__ */ B.createElement("g", {
      className: s
    }, /* @__PURE__ */ B.createElement("path", $a({}, Ae(o, !0), {
      fill: u.slice(-1) === "Z" ? o.fill : "none",
      stroke: "none",
      d: u
    })), c ? /* @__PURE__ */ B.createElement("path", $a({}, Ae(o, !0), {
      fill: "none",
      d: Ui(r, i)
    })) : null, c ? /* @__PURE__ */ B.createElement("path", $a({}, Ae(o, !0), {
      fill: "none",
      d: Ui(a, i)
    })) : null);
  }
  var d = Ui(r, i);
  return /* @__PURE__ */ B.createElement("path", $a({}, Ae(o, !0), {
    fill: d.slice(-1) === "Z" ? o.fill : "none",
    className: s,
    d
  }));
};
function z5() {
  return z5 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, z5.apply(this, arguments);
}
var e3 = function(t) {
  var r = t.cx, n = t.cy, a = t.r, i = t.className, o = Pe("recharts-dot", i);
  return r === +r && n === +n && a === +a ? /* @__PURE__ */ Sr.createElement("circle", z5({}, Ae(t, !1), os(t), {
    className: o,
    cx: r,
    cy: n,
    r: a
  })) : null;
};
function Bo(e) {
  "@babel/helpers - typeof";
  return Bo = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Bo(e);
}
var E2e = ["x", "y", "top", "left", "width", "height", "className"];
function K5() {
  return K5 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, K5.apply(this, arguments);
}
function Cv(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function P2e(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Cv(Object(r), !0).forEach(function(n) {
      j2e(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Cv(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function j2e(e, t, r) {
  return t = S2e(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function S2e(e) {
  var t = I2e(e, "string");
  return Bo(t) == "symbol" ? t : t + "";
}
function I2e(e, t) {
  if (Bo(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (Bo(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function B2e(e, t) {
  if (e == null)
    return {};
  var r = N2e(e, t), n, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (a = 0; a < i.length; a++)
      n = i[a], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function N2e(e, t) {
  if (e == null)
    return {};
  var r = {};
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      if (t.indexOf(n) >= 0)
        continue;
      r[n] = e[n];
    }
  return r;
}
var _2e = function(t, r, n, a, i, o) {
  return "M".concat(t, ",").concat(i, "v").concat(a, "M").concat(o, ",").concat(r, "h").concat(n);
}, L2e = function(t) {
  var r = t.x, n = r === void 0 ? 0 : r, a = t.y, i = a === void 0 ? 0 : a, o = t.top, s = o === void 0 ? 0 : o, c = t.left, u = c === void 0 ? 0 : c, d = t.width, h = d === void 0 ? 0 : d, A = t.height, p = A === void 0 ? 0 : A, m = t.className, g = B2e(t, E2e), v = P2e({
    x: n,
    y: i,
    top: s,
    left: u,
    width: h,
    height: p
  }, g);
  return !se(n) || !se(i) || !se(h) || !se(p) || !se(s) || !se(u) ? null : /* @__PURE__ */ B.createElement("path", K5({}, Ae(v, !0), {
    className: Pe("recharts-cross", m),
    d: _2e(n, i, h, p, s, u)
  }));
}, T2e = Y0, R2e = Tw, $2e = dn;
function F2e(e, t) {
  return e && e.length ? T2e(e, $2e(t), R2e) : void 0;
}
var H2e = F2e;
const Y2e = /* @__PURE__ */ qe(H2e);
var V2e = Y0, k2e = dn, G2e = Rw;
function W2e(e, t) {
  return e && e.length ? V2e(e, k2e(t), G2e) : void 0;
}
var Q2e = W2e;
const U2e = /* @__PURE__ */ qe(Q2e);
var Z2e = ["cx", "cy", "angle", "ticks", "axisLine"], z2e = ["ticks", "tick", "angle", "tickFormatter", "stroke"];
function s2(e) {
  "@babel/helpers - typeof";
  return s2 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, s2(e);
}
function Zi() {
  return Zi = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Zi.apply(this, arguments);
}
function bv(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function j1(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? bv(Object(r), !0).forEach(function(n) {
      Q0(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : bv(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function yv(e, t) {
  if (e == null)
    return {};
  var r = K2e(e, t), n, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (a = 0; a < i.length; a++)
      n = i[a], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function K2e(e, t) {
  if (e == null)
    return {};
  var r = {};
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      if (t.indexOf(n) >= 0)
        continue;
      r[n] = e[n];
    }
  return r;
}
function q2e(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function wv(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, xx(n.key), n);
  }
}
function X2e(e, t, r) {
  return t && wv(e.prototype, t), r && wv(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function J2e(e, t, r) {
  return t = Ys(t), eie(e, wx() ? Reflect.construct(t, r || [], Ys(e).constructor) : t.apply(e, r));
}
function eie(e, t) {
  if (t && (s2(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return tie(e);
}
function tie(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function wx() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (wx = function() {
    return !!e;
  })();
}
function Ys(e) {
  return Ys = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, Ys(e);
}
function rie(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && q5(e, t);
}
function q5(e, t) {
  return q5 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, a) {
    return n.__proto__ = a, n;
  }, q5(e, t);
}
function Q0(e, t, r) {
  return t = xx(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function xx(e) {
  var t = nie(e, "string");
  return s2(t) == "symbol" ? t : t + "";
}
function nie(e, t) {
  if (s2(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (s2(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var U0 = /* @__PURE__ */ function(e) {
  function t() {
    return q2e(this, t), J2e(this, t, arguments);
  }
  return rie(t, e), X2e(t, [{
    key: "getTickValueCoord",
    value: (
      /**
       * Calculate the coordinate of tick
       * @param  {Number} coordinate The radius of tick
       * @return {Object} (x, y)
       */
      function(n) {
        var a = n.coordinate, i = this.props, o = i.angle, s = i.cx, c = i.cy;
        return ct(s, c, a, o);
      }
    )
  }, {
    key: "getTickTextAnchor",
    value: function() {
      var n = this.props.orientation, a;
      switch (n) {
        case "left":
          a = "end";
          break;
        case "right":
          a = "start";
          break;
        default:
          a = "middle";
          break;
      }
      return a;
    }
  }, {
    key: "getViewBox",
    value: function() {
      var n = this.props, a = n.cx, i = n.cy, o = n.angle, s = n.ticks, c = Y2e(s, function(d) {
        return d.coordinate || 0;
      }), u = U2e(s, function(d) {
        return d.coordinate || 0;
      });
      return {
        cx: a,
        cy: i,
        startAngle: o,
        endAngle: o,
        innerRadius: u.coordinate || 0,
        outerRadius: c.coordinate || 0
      };
    }
  }, {
    key: "renderAxisLine",
    value: function() {
      var n = this.props, a = n.cx, i = n.cy, o = n.angle, s = n.ticks, c = n.axisLine, u = yv(n, Z2e), d = s.reduce(function(m, g) {
        return [Math.min(m[0], g.coordinate), Math.max(m[1], g.coordinate)];
      }, [1 / 0, -1 / 0]), h = ct(a, i, d[0], o), A = ct(a, i, d[1], o), p = j1(j1(j1({}, Ae(u, !1)), {}, {
        fill: "none"
      }, Ae(c, !1)), {}, {
        x1: h.x,
        y1: h.y,
        x2: A.x,
        y2: A.y
      });
      return /* @__PURE__ */ B.createElement("line", Zi({
        className: "recharts-polar-radius-axis-line"
      }, p));
    }
  }, {
    key: "renderTicks",
    value: function() {
      var n = this, a = this.props, i = a.ticks, o = a.tick, s = a.angle, c = a.tickFormatter, u = a.stroke, d = yv(a, z2e), h = this.getTickTextAnchor(), A = Ae(d, !1), p = Ae(o, !1), m = i.map(function(g, v) {
        var C = n.getTickValueCoord(g), y = j1(j1(j1(j1({
          textAnchor: h,
          transform: "rotate(".concat(90 - s, ", ").concat(C.x, ", ").concat(C.y, ")")
        }, A), {}, {
          stroke: "none",
          fill: u
        }, p), {}, {
          index: v
        }, C), {}, {
          payload: g
        });
        return /* @__PURE__ */ B.createElement(Se, Zi({
          className: Pe("recharts-polar-radius-axis-tick", fx(o)),
          key: "tick-".concat(g.coordinate)
        }, c1(n.props, g, v)), t.renderTickItem(o, y, c ? c(g.value, v) : g.value));
      });
      return /* @__PURE__ */ B.createElement(Se, {
        className: "recharts-polar-radius-axis-ticks"
      }, m);
    }
  }, {
    key: "render",
    value: function() {
      var n = this.props, a = n.ticks, i = n.axisLine, o = n.tick;
      return !a || !a.length ? null : /* @__PURE__ */ B.createElement(Se, {
        className: Pe("recharts-polar-radius-axis", this.props.className)
      }, i && this.renderAxisLine(), o && this.renderTicks(), Et.renderCallByParent(this.props, this.getViewBox()));
    }
  }], [{
    key: "renderTickItem",
    value: function(n, a, i) {
      var o;
      return /* @__PURE__ */ B.isValidElement(n) ? o = /* @__PURE__ */ B.cloneElement(n, a) : ye(n) ? o = n(a) : o = /* @__PURE__ */ B.createElement(ta, Zi({}, a, {
        className: "recharts-polar-radius-axis-tick-value"
      }), i), o;
    }
  }]);
}(Cr);
Q0(U0, "displayName", "PolarRadiusAxis");
Q0(U0, "axisType", "radiusAxis");
Q0(U0, "defaultProps", {
  type: "number",
  radiusAxisId: 0,
  cx: 0,
  cy: 0,
  angle: 0,
  orientation: "right",
  stroke: "#ccc",
  axisLine: !0,
  tick: !0,
  tickCount: 5,
  allowDataOverflow: !1,
  scale: "auto",
  allowDuplicatedCategory: !0
});
function l2(e) {
  "@babel/helpers - typeof";
  return l2 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, l2(e);
}
function k1() {
  return k1 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, k1.apply(this, arguments);
}
function xv(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function S1(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? xv(Object(r), !0).forEach(function(n) {
      Z0(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : xv(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function aie(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Ov(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Dx(n.key), n);
  }
}
function iie(e, t, r) {
  return t && Ov(e.prototype, t), r && Ov(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function oie(e, t, r) {
  return t = Vs(t), sie(e, Ox() ? Reflect.construct(t, r || [], Vs(e).constructor) : t.apply(e, r));
}
function sie(e, t) {
  if (t && (l2(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return lie(e);
}
function lie(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function Ox() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (Ox = function() {
    return !!e;
  })();
}
function Vs(e) {
  return Vs = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, Vs(e);
}
function cie(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && X5(e, t);
}
function X5(e, t) {
  return X5 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, a) {
    return n.__proto__ = a, n;
  }, X5(e, t);
}
function Z0(e, t, r) {
  return t = Dx(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function Dx(e) {
  var t = uie(e, "string");
  return l2(t) == "symbol" ? t : t + "";
}
function uie(e, t) {
  if (l2(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (l2(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var fie = Math.PI / 180, Dv = 1e-5, z0 = /* @__PURE__ */ function(e) {
  function t() {
    return aie(this, t), oie(this, t, arguments);
  }
  return cie(t, e), iie(t, [{
    key: "getTickLineCoord",
    value: (
      /**
       * Calculate the coordinate of line endpoint
       * @param  {Object} data The Data if ticks
       * @return {Object} (x0, y0): The start point of text,
       *                  (x1, y1): The end point close to text,
       *                  (x2, y2): The end point close to axis
       */
      function(n) {
        var a = this.props, i = a.cx, o = a.cy, s = a.radius, c = a.orientation, u = a.tickSize, d = u || 8, h = ct(i, o, s, n.coordinate), A = ct(i, o, s + (c === "inner" ? -1 : 1) * d, n.coordinate);
        return {
          x1: h.x,
          y1: h.y,
          x2: A.x,
          y2: A.y
        };
      }
    )
    /**
     * Get the text-anchor of each tick
     * @param  {Object} data Data of ticks
     * @return {String} text-anchor
     */
  }, {
    key: "getTickTextAnchor",
    value: function(n) {
      var a = this.props.orientation, i = Math.cos(-n.coordinate * fie), o;
      return i > Dv ? o = a === "outer" ? "start" : "end" : i < -Dv ? o = a === "outer" ? "end" : "start" : o = "middle", o;
    }
  }, {
    key: "renderAxisLine",
    value: function() {
      var n = this.props, a = n.cx, i = n.cy, o = n.radius, s = n.axisLine, c = n.axisLineType, u = S1(S1({}, Ae(this.props, !1)), {}, {
        fill: "none"
      }, Ae(s, !1));
      if (c === "circle")
        return /* @__PURE__ */ B.createElement(e3, k1({
          className: "recharts-polar-angle-axis-line"
        }, u, {
          cx: a,
          cy: i,
          r: o
        }));
      var d = this.props.ticks, h = d.map(function(A) {
        return ct(a, i, o, A.coordinate);
      });
      return /* @__PURE__ */ B.createElement(M2e, k1({
        className: "recharts-polar-angle-axis-line"
      }, u, {
        points: h
      }));
    }
  }, {
    key: "renderTicks",
    value: function() {
      var n = this, a = this.props, i = a.ticks, o = a.tick, s = a.tickLine, c = a.tickFormatter, u = a.stroke, d = Ae(this.props, !1), h = Ae(o, !1), A = S1(S1({}, d), {}, {
        fill: "none"
      }, Ae(s, !1)), p = i.map(function(m, g) {
        var v = n.getTickLineCoord(m), C = n.getTickTextAnchor(m), y = S1(S1(S1({
          textAnchor: C
        }, d), {}, {
          stroke: "none",
          fill: u
        }, h), {}, {
          index: g,
          payload: m,
          x: v.x2,
          y: v.y2
        });
        return /* @__PURE__ */ B.createElement(Se, k1({
          className: Pe("recharts-polar-angle-axis-tick", fx(o)),
          key: "tick-".concat(m.coordinate)
        }, c1(n.props, m, g)), s && /* @__PURE__ */ B.createElement("line", k1({
          className: "recharts-polar-angle-axis-tick-line"
        }, A, v)), o && t.renderTickItem(o, y, c ? c(m.value, g) : m.value));
      });
      return /* @__PURE__ */ B.createElement(Se, {
        className: "recharts-polar-angle-axis-ticks"
      }, p);
    }
  }, {
    key: "render",
    value: function() {
      var n = this.props, a = n.ticks, i = n.radius, o = n.axisLine;
      return i <= 0 || !a || !a.length ? null : /* @__PURE__ */ B.createElement(Se, {
        className: Pe("recharts-polar-angle-axis", this.props.className)
      }, o && this.renderAxisLine(), this.renderTicks());
    }
  }], [{
    key: "renderTickItem",
    value: function(n, a, i) {
      var o;
      return /* @__PURE__ */ B.isValidElement(n) ? o = /* @__PURE__ */ B.cloneElement(n, a) : ye(n) ? o = n(a) : o = /* @__PURE__ */ B.createElement(ta, k1({}, a, {
        className: "recharts-polar-angle-axis-tick-value"
      }), i), o;
    }
  }]);
}(Cr);
Z0(z0, "displayName", "PolarAngleAxis");
Z0(z0, "axisType", "angleAxis");
Z0(z0, "defaultProps", {
  type: "category",
  angleAxisId: 0,
  scale: "auto",
  cx: 0,
  cy: 0,
  orientation: "outer",
  axisLine: !0,
  tickLine: !0,
  tickSize: 8,
  tick: !0,
  hide: !1,
  allowDuplicatedCategory: !0
});
var die = By, hie = die(Object.getPrototypeOf, Object), Aie = hie, pie = Bn, vie = Aie, gie = Nn, mie = "[object Object]", Cie = Function.prototype, bie = Object.prototype, Mx = Cie.toString, yie = bie.hasOwnProperty, wie = Mx.call(Object);
function xie(e) {
  if (!gie(e) || pie(e) != mie)
    return !1;
  var t = vie(e);
  if (t === null)
    return !0;
  var r = yie.call(t, "constructor") && t.constructor;
  return typeof r == "function" && r instanceof r && Mx.call(r) == wie;
}
var Oie = xie;
const Die = /* @__PURE__ */ qe(Oie);
var Mie = Bn, Eie = Nn, Pie = "[object Boolean]";
function jie(e) {
  return e === !0 || e === !1 || Eie(e) && Mie(e) == Pie;
}
var Sie = jie;
const Iie = /* @__PURE__ */ qe(Sie);
function No(e) {
  "@babel/helpers - typeof";
  return No = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, No(e);
}
function ks() {
  return ks = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, ks.apply(this, arguments);
}
function Bie(e, t) {
  return Tie(e) || Lie(e, t) || _ie(e, t) || Nie();
}
function Nie() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _ie(e, t) {
  if (e) {
    if (typeof e == "string")
      return Mv(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return Mv(e, t);
  }
}
function Mv(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
function Lie(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, a, i, o, s = [], c = !0, u = !1;
    try {
      if (i = (r = r.call(e)).next, t === 0) {
        if (Object(r) !== r)
          return;
        c = !1;
      } else
        for (; !(c = (n = i.call(r)).done) && (s.push(n.value), s.length !== t); c = !0)
          ;
    } catch (d) {
      u = !0, a = d;
    } finally {
      try {
        if (!c && r.return != null && (o = r.return(), Object(o) !== o))
          return;
      } finally {
        if (u)
          throw a;
      }
    }
    return s;
  }
}
function Tie(e) {
  if (Array.isArray(e))
    return e;
}
function Ev(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Pv(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Ev(Object(r), !0).forEach(function(n) {
      Rie(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Ev(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function Rie(e, t, r) {
  return t = $ie(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function $ie(e) {
  var t = Fie(e, "string");
  return No(t) == "symbol" ? t : t + "";
}
function Fie(e, t) {
  if (No(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (No(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var jv = function(t, r, n, a, i) {
  var o = n - a, s;
  return s = "M ".concat(t, ",").concat(r), s += "L ".concat(t + n, ",").concat(r), s += "L ".concat(t + n - o / 2, ",").concat(r + i), s += "L ".concat(t + n - o / 2 - a, ",").concat(r + i), s += "L ".concat(t, ",").concat(r, " Z"), s;
}, Hie = {
  x: 0,
  y: 0,
  upperWidth: 0,
  lowerWidth: 0,
  height: 0,
  isUpdateAnimationActive: !1,
  animationBegin: 0,
  animationDuration: 1500,
  animationEasing: "ease"
}, Yie = function(t) {
  var r = Pv(Pv({}, Hie), t), n = ge(), a = De(-1), i = Bie(a, 2), o = i[0], s = i[1];
  Ie(function() {
    if (n.current && n.current.getTotalLength)
      try {
        var w = n.current.getTotalLength();
        w && s(w);
      } catch {
      }
  }, []);
  var c = r.x, u = r.y, d = r.upperWidth, h = r.lowerWidth, A = r.height, p = r.className, m = r.animationEasing, g = r.animationDuration, v = r.animationBegin, C = r.isUpdateAnimationActive;
  if (c !== +c || u !== +u || d !== +d || h !== +h || A !== +A || d === 0 && h === 0 || A === 0)
    return null;
  var y = Pe("recharts-trapezoid", p);
  return C ? /* @__PURE__ */ B.createElement(Sn, {
    canBegin: o > 0,
    from: {
      upperWidth: 0,
      lowerWidth: 0,
      height: A,
      x: c,
      y: u
    },
    to: {
      upperWidth: d,
      lowerWidth: h,
      height: A,
      x: c,
      y: u
    },
    duration: g,
    animationEasing: m,
    isActive: C
  }, function(w) {
    var O = w.upperWidth, b = w.lowerWidth, D = w.height, M = w.x, j = w.y;
    return /* @__PURE__ */ B.createElement(Sn, {
      canBegin: o > 0,
      from: "0px ".concat(o === -1 ? 1 : o, "px"),
      to: "".concat(o, "px 0px"),
      attributeName: "strokeDasharray",
      begin: v,
      duration: g,
      easing: m
    }, /* @__PURE__ */ B.createElement("path", ks({}, Ae(r, !0), {
      className: y,
      d: jv(M, j, O, b, D),
      ref: n
    })));
  }) : /* @__PURE__ */ B.createElement("g", null, /* @__PURE__ */ B.createElement("path", ks({}, Ae(r, !0), {
    className: y,
    d: jv(c, u, d, h, A)
  })));
}, Vie = ["option", "shapeType", "propTransformer", "activeClassName", "isActive"];
function _o(e) {
  "@babel/helpers - typeof";
  return _o = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, _o(e);
}
function kie(e, t) {
  if (e == null)
    return {};
  var r = Gie(e, t), n, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (a = 0; a < i.length; a++)
      n = i[a], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function Gie(e, t) {
  if (e == null)
    return {};
  var r = {};
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      if (t.indexOf(n) >= 0)
        continue;
      r[n] = e[n];
    }
  return r;
}
function Sv(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Gs(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Sv(Object(r), !0).forEach(function(n) {
      Wie(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Sv(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function Wie(e, t, r) {
  return t = Qie(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function Qie(e) {
  var t = Uie(e, "string");
  return _o(t) == "symbol" ? t : t + "";
}
function Uie(e, t) {
  if (_o(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (_o(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function Zie(e, t) {
  return Gs(Gs({}, t), e);
}
function zie(e, t) {
  return e === "symbols";
}
function Iv(e) {
  var t = e.shapeType, r = e.elementProps;
  switch (t) {
    case "rectangle":
      return /* @__PURE__ */ B.createElement(J9, r);
    case "trapezoid":
      return /* @__PURE__ */ B.createElement(Yie, r);
    case "sector":
      return /* @__PURE__ */ B.createElement(Ax, r);
    case "symbols":
      if (zie(t))
        return /* @__PURE__ */ B.createElement(I0, r);
      break;
    default:
      return null;
  }
}
function Kie(e) {
  return /* @__PURE__ */ Vr(e) ? e.props : e;
}
function Ws(e) {
  var t = e.option, r = e.shapeType, n = e.propTransformer, a = n === void 0 ? Zie : n, i = e.activeClassName, o = i === void 0 ? "recharts-active-shape" : i, s = e.isActive, c = kie(e, Vie), u;
  if (/* @__PURE__ */ Vr(t))
    u = /* @__PURE__ */ Bt(t, Gs(Gs({}, c), Kie(t)));
  else if (ye(t))
    u = t(c);
  else if (Die(t) && !Iie(t)) {
    var d = a(t, c);
    u = /* @__PURE__ */ B.createElement(Iv, {
      shapeType: r,
      elementProps: d
    });
  } else {
    var h = c;
    u = /* @__PURE__ */ B.createElement(Iv, {
      shapeType: r,
      elementProps: h
    });
  }
  return s ? /* @__PURE__ */ B.createElement(Se, {
    className: o
  }, u) : u;
}
function K0(e, t) {
  return t != null && "trapezoids" in e.props;
}
function q0(e, t) {
  return t != null && "sectors" in e.props;
}
function Lo(e, t) {
  return t != null && "points" in e.props;
}
function qie(e, t) {
  var r, n, a = e.x === (t == null || (r = t.labelViewBox) === null || r === void 0 ? void 0 : r.x) || e.x === t.x, i = e.y === (t == null || (n = t.labelViewBox) === null || n === void 0 ? void 0 : n.y) || e.y === t.y;
  return a && i;
}
function Xie(e, t) {
  var r = e.endAngle === t.endAngle, n = e.startAngle === t.startAngle;
  return r && n;
}
function Jie(e, t) {
  var r = e.x === t.x, n = e.y === t.y, a = e.z === t.z;
  return r && n && a;
}
function eoe(e, t) {
  var r;
  return K0(e, t) ? r = qie : q0(e, t) ? r = Xie : Lo(e, t) && (r = Jie), r;
}
function toe(e, t) {
  var r;
  return K0(e, t) ? r = "trapezoids" : q0(e, t) ? r = "sectors" : Lo(e, t) && (r = "points"), r;
}
function roe(e, t) {
  if (K0(e, t)) {
    var r;
    return (r = t.tooltipPayload) === null || r === void 0 || (r = r[0]) === null || r === void 0 || (r = r.payload) === null || r === void 0 ? void 0 : r.payload;
  }
  if (q0(e, t)) {
    var n;
    return (n = t.tooltipPayload) === null || n === void 0 || (n = n[0]) === null || n === void 0 || (n = n.payload) === null || n === void 0 ? void 0 : n.payload;
  }
  return Lo(e, t) ? t.payload : {};
}
function noe(e) {
  var t = e.activeTooltipItem, r = e.graphicalItem, n = e.itemData, a = toe(r, t), i = roe(r, t), o = n.filter(function(c, u) {
    var d = u1(i, c), h = r.props[a].filter(function(m) {
      var g = eoe(r, t);
      return g(m, t);
    }), A = r.props[a].indexOf(h[h.length - 1]), p = u === A;
    return d && p;
  }), s = n.indexOf(o[o.length - 1]);
  return s;
}
var K3;
function c2(e) {
  "@babel/helpers - typeof";
  return c2 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, c2(e);
}
function Fa() {
  return Fa = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Fa.apply(this, arguments);
}
function Bv(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function st(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Bv(Object(r), !0).forEach(function(n) {
      Mr(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Bv(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function aoe(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Nv(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Px(n.key), n);
  }
}
function ioe(e, t, r) {
  return t && Nv(e.prototype, t), r && Nv(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function ooe(e, t, r) {
  return t = Qs(t), soe(e, Ex() ? Reflect.construct(t, r || [], Qs(e).constructor) : t.apply(e, r));
}
function soe(e, t) {
  if (t && (c2(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return loe(e);
}
function loe(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function Ex() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (Ex = function() {
    return !!e;
  })();
}
function Qs(e) {
  return Qs = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, Qs(e);
}
function coe(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && J5(e, t);
}
function J5(e, t) {
  return J5 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, a) {
    return n.__proto__ = a, n;
  }, J5(e, t);
}
function Mr(e, t, r) {
  return t = Px(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function Px(e) {
  var t = uoe(e, "string");
  return c2(t) == "symbol" ? t : t + "";
}
function uoe(e, t) {
  if (c2(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (c2(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var zr = /* @__PURE__ */ function(e) {
  function t(r) {
    var n;
    return aoe(this, t), n = ooe(this, t, [r]), Mr(n, "pieRef", null), Mr(n, "sectorRefs", []), Mr(n, "id", g1("recharts-pie-")), Mr(n, "handleAnimationEnd", function() {
      var a = n.props.onAnimationEnd;
      n.setState({
        isAnimationFinished: !0
      }), ye(a) && a();
    }), Mr(n, "handleAnimationStart", function() {
      var a = n.props.onAnimationStart;
      n.setState({
        isAnimationFinished: !1
      }), ye(a) && a();
    }), n.state = {
      isAnimationFinished: !r.isAnimationActive,
      prevIsAnimationActive: r.isAnimationActive,
      prevAnimationId: r.animationId,
      sectorToFocus: 0
    }, n;
  }
  return coe(t, e), ioe(t, [{
    key: "isActiveIndex",
    value: function(n) {
      var a = this.props.activeIndex;
      return Array.isArray(a) ? a.indexOf(n) !== -1 : n === a;
    }
  }, {
    key: "hasActiveIndex",
    value: function() {
      var n = this.props.activeIndex;
      return Array.isArray(n) ? n.length !== 0 : n || n === 0;
    }
  }, {
    key: "renderLabels",
    value: function(n) {
      var a = this.props.isAnimationActive;
      if (a && !this.state.isAnimationFinished)
        return null;
      var i = this.props, o = i.label, s = i.labelLine, c = i.dataKey, u = i.valueKey, d = Ae(this.props, !1), h = Ae(o, !1), A = Ae(s, !1), p = o && o.offsetRadius || 20, m = n.map(function(g, v) {
        var C = (g.startAngle + g.endAngle) / 2, y = ct(g.cx, g.cy, g.outerRadius + p, C), w = st(st(st(st({}, d), g), {}, {
          stroke: "none"
        }, h), {}, {
          index: v,
          textAnchor: t.getTextAnchor(y.x, g.cx)
        }, y), O = st(st(st(st({}, d), g), {}, {
          fill: "none",
          stroke: g.fill
        }, A), {}, {
          index: v,
          points: [ct(g.cx, g.cy, g.outerRadius, C), y]
        }), b = c;
        return be(c) && be(u) ? b = "value" : be(c) && (b = u), // eslint-disable-next-line react/no-array-index-key
        /* @__PURE__ */ B.createElement(Se, {
          key: "label-".concat(g.startAngle, "-").concat(g.endAngle, "-").concat(g.midAngle, "-").concat(v)
        }, s && t.renderLabelLineItem(s, O, "line"), t.renderLabelItem(o, w, vt(g, b)));
      });
      return /* @__PURE__ */ B.createElement(Se, {
        className: "recharts-pie-labels"
      }, m);
    }
  }, {
    key: "renderSectorsStatically",
    value: function(n) {
      var a = this, i = this.props, o = i.activeShape, s = i.blendStroke, c = i.inactiveShape;
      return n.map(function(u, d) {
        if ((u == null ? void 0 : u.startAngle) === 0 && (u == null ? void 0 : u.endAngle) === 0 && n.length !== 1)
          return null;
        var h = a.isActiveIndex(d), A = c && a.hasActiveIndex() ? c : null, p = h ? o : A, m = st(st({}, u), {}, {
          stroke: s ? u.fill : u.stroke,
          tabIndex: -1
        });
        return /* @__PURE__ */ B.createElement(Se, Fa({
          ref: function(v) {
            v && !a.sectorRefs.includes(v) && a.sectorRefs.push(v);
          },
          tabIndex: -1,
          className: "recharts-pie-sector"
        }, c1(a.props, u, d), {
          // eslint-disable-next-line react/no-array-index-key
          key: "sector-".concat(u == null ? void 0 : u.startAngle, "-").concat(u == null ? void 0 : u.endAngle, "-").concat(u.midAngle, "-").concat(d)
        }), /* @__PURE__ */ B.createElement(Ws, Fa({
          option: p,
          isActive: h,
          shapeType: "sector"
        }, m)));
      });
    }
  }, {
    key: "renderSectorsWithAnimation",
    value: function() {
      var n = this, a = this.props, i = a.sectors, o = a.isAnimationActive, s = a.animationBegin, c = a.animationDuration, u = a.animationEasing, d = a.animationId, h = this.state, A = h.prevSectors, p = h.prevIsAnimationActive;
      return /* @__PURE__ */ B.createElement(Sn, {
        begin: s,
        duration: c,
        isActive: o,
        easing: u,
        from: {
          t: 0
        },
        to: {
          t: 1
        },
        key: "pie-".concat(d, "-").concat(p),
        onAnimationStart: this.handleAnimationStart,
        onAnimationEnd: this.handleAnimationEnd
      }, function(m) {
        var g = m.t, v = [], C = i && i[0], y = C.startAngle;
        return i.forEach(function(w, O) {
          var b = A && A[O], D = O > 0 ? mr(w, "paddingAngle", 0) : 0;
          if (b) {
            var M = bt(b.endAngle - b.startAngle, w.endAngle - w.startAngle), j = st(st({}, w), {}, {
              startAngle: y + D,
              endAngle: y + M(g) + D
            });
            v.push(j), y = j.endAngle;
          } else {
            var P = w.endAngle, H = w.startAngle, F = bt(0, P - H), R = F(g), N = st(st({}, w), {}, {
              startAngle: y + D,
              endAngle: y + R + D
            });
            v.push(N), y = N.endAngle;
          }
        }), /* @__PURE__ */ B.createElement(Se, null, n.renderSectorsStatically(v));
      });
    }
  }, {
    key: "attachKeyboardHandlers",
    value: function(n) {
      var a = this;
      n.onkeydown = function(i) {
        if (!i.altKey)
          switch (i.key) {
            case "ArrowLeft": {
              var o = ++a.state.sectorToFocus % a.sectorRefs.length;
              a.sectorRefs[o].focus(), a.setState({
                sectorToFocus: o
              });
              break;
            }
            case "ArrowRight": {
              var s = --a.state.sectorToFocus < 0 ? a.sectorRefs.length - 1 : a.state.sectorToFocus % a.sectorRefs.length;
              a.sectorRefs[s].focus(), a.setState({
                sectorToFocus: s
              });
              break;
            }
            case "Escape": {
              a.sectorRefs[a.state.sectorToFocus].blur(), a.setState({
                sectorToFocus: 0
              });
              break;
            }
          }
      };
    }
  }, {
    key: "renderSectors",
    value: function() {
      var n = this.props, a = n.sectors, i = n.isAnimationActive, o = this.state.prevSectors;
      return i && a && a.length && (!o || !u1(o, a)) ? this.renderSectorsWithAnimation() : this.renderSectorsStatically(a);
    }
  }, {
    key: "componentDidMount",
    value: function() {
      this.pieRef && this.attachKeyboardHandlers(this.pieRef);
    }
  }, {
    key: "render",
    value: function() {
      var n = this, a = this.props, i = a.hide, o = a.sectors, s = a.className, c = a.label, u = a.cx, d = a.cy, h = a.innerRadius, A = a.outerRadius, p = a.isAnimationActive, m = this.state.isAnimationFinished;
      if (i || !o || !o.length || !se(u) || !se(d) || !se(h) || !se(A))
        return null;
      var g = Pe("recharts-pie", s);
      return /* @__PURE__ */ B.createElement(Se, {
        tabIndex: this.props.rootTabIndex,
        className: g,
        ref: function(C) {
          n.pieRef = C;
        }
      }, this.renderSectors(), c && this.renderLabels(o), Et.renderCallByParent(this.props, null, !1), (!p || m) && Wr.renderCallByParent(this.props, o, !1));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function(n, a) {
      return a.prevIsAnimationActive !== n.isAnimationActive ? {
        prevIsAnimationActive: n.isAnimationActive,
        prevAnimationId: n.animationId,
        curSectors: n.sectors,
        prevSectors: [],
        isAnimationFinished: !0
      } : n.isAnimationActive && n.animationId !== a.prevAnimationId ? {
        prevAnimationId: n.animationId,
        curSectors: n.sectors,
        prevSectors: a.curSectors,
        isAnimationFinished: !0
      } : n.sectors !== a.curSectors ? {
        curSectors: n.sectors,
        isAnimationFinished: !0
      } : null;
    }
  }, {
    key: "getTextAnchor",
    value: function(n, a) {
      return n > a ? "start" : n < a ? "end" : "middle";
    }
  }, {
    key: "renderLabelLineItem",
    value: function(n, a, i) {
      if (/* @__PURE__ */ B.isValidElement(n))
        return /* @__PURE__ */ B.cloneElement(n, a);
      if (ye(n))
        return n(a);
      var o = Pe("recharts-pie-label-line", typeof n != "boolean" ? n.className : "");
      return /* @__PURE__ */ B.createElement(o1, Fa({}, a, {
        key: i,
        type: "linear",
        className: o
      }));
    }
  }, {
    key: "renderLabelItem",
    value: function(n, a, i) {
      if (/* @__PURE__ */ B.isValidElement(n))
        return /* @__PURE__ */ B.cloneElement(n, a);
      var o = i;
      if (ye(n) && (o = n(a), /* @__PURE__ */ B.isValidElement(o)))
        return o;
      var s = Pe("recharts-pie-label-text", typeof n != "boolean" && !ye(n) ? n.className : "");
      return /* @__PURE__ */ B.createElement(ta, Fa({}, a, {
        alignmentBaseline: "middle",
        className: s
      }), o);
    }
  }]);
}(Cr);
K3 = zr;
Mr(zr, "displayName", "Pie");
Mr(zr, "defaultProps", {
  stroke: "#fff",
  fill: "#808080",
  legendType: "rect",
  cx: "50%",
  cy: "50%",
  startAngle: 0,
  endAngle: 360,
  innerRadius: 0,
  outerRadius: "80%",
  paddingAngle: 0,
  labelLine: !0,
  hide: !1,
  minAngle: 0,
  isAnimationActive: !Br.isSsr,
  animationBegin: 400,
  animationDuration: 1500,
  animationEasing: "ease",
  nameKey: "name",
  blendStroke: !1,
  rootTabIndex: 0
});
Mr(zr, "parseDeltaAngle", function(e, t) {
  var r = Jt(t - e), n = Math.min(Math.abs(t - e), 360);
  return r * n;
});
Mr(zr, "getRealPieData", function(e) {
  var t = e.data, r = e.children, n = Ae(e, !1), a = rr(r, Nr);
  return t && t.length ? t.map(function(i, o) {
    return st(st(st({
      payload: i
    }, n), i), a && a[o] && a[o].props);
  }) : a && a.length ? a.map(function(i) {
    return st(st({}, n), i.props);
  }) : [];
});
Mr(zr, "parseCoordinateOfPie", function(e, t) {
  var r = t.top, n = t.left, a = t.width, i = t.height, o = ux(a, i), s = n + er(e.cx, a, a / 2), c = r + er(e.cy, i, i / 2), u = er(e.innerRadius, o, 0), d = er(e.outerRadius, o, o * 0.8), h = e.maxRadius || Math.sqrt(a * a + i * i) / 2;
  return {
    cx: s,
    cy: c,
    innerRadius: u,
    outerRadius: d,
    maxRadius: h
  };
});
Mr(zr, "getComposedData", function(e) {
  var t = e.item, r = e.offset, n = t.type.defaultProps !== void 0 ? st(st({}, t.type.defaultProps), t.props) : t.props, a = K3.getRealPieData(n);
  if (!a || !a.length)
    return null;
  var i = n.cornerRadius, o = n.startAngle, s = n.endAngle, c = n.paddingAngle, u = n.dataKey, d = n.nameKey, h = n.valueKey, A = n.tooltipType, p = Math.abs(n.minAngle), m = K3.parseCoordinateOfPie(n, r), g = K3.parseDeltaAngle(o, s), v = Math.abs(g), C = u;
  be(u) && be(h) ? (Gr(!1, `Use "dataKey" to specify the value of pie,
      the props "valueKey" will be deprecated in 1.1.0`), C = "value") : be(u) && (Gr(!1, `Use "dataKey" to specify the value of pie,
      the props "valueKey" will be deprecated in 1.1.0`), C = h);
  var y = a.filter(function(j) {
    return vt(j, C, 0) !== 0;
  }).length, w = (v >= 360 ? y : y - 1) * c, O = v - y * p - w, b = a.reduce(function(j, P) {
    var H = vt(P, C, 0);
    return j + (se(H) ? H : 0);
  }, 0), D;
  if (b > 0) {
    var M;
    D = a.map(function(j, P) {
      var H = vt(j, C, 0), F = vt(j, d, P), R = (se(H) ? H : 0) / b, N;
      P ? N = M.endAngle + Jt(g) * c * (H !== 0 ? 1 : 0) : N = o;
      var z = N + Jt(g) * ((H !== 0 ? p : 0) + R * O), q = (N + z) / 2, J = (m.innerRadius + m.outerRadius) / 2, W = [{
        name: F,
        value: H,
        payload: j,
        dataKey: C,
        type: A
      }], te = ct(m.cx, m.cy, J, q);
      return M = st(st(st({
        percent: R,
        cornerRadius: i,
        name: F,
        tooltipPayload: W,
        midAngle: q,
        middleRadius: J,
        tooltipPosition: te
      }, j), m), {}, {
        value: vt(j, C),
        startAngle: N,
        endAngle: z,
        payload: j,
        paddingAngle: Jt(g) * c
      }), M;
    });
  }
  return st(st({}, m), {}, {
    sectors: D,
    data: a
  });
});
var foe = Math.ceil, doe = Math.max;
function hoe(e, t, r, n) {
  for (var a = -1, i = doe(foe((t - e) / (r || 1)), 0), o = Array(i); i--; )
    o[n ? i : ++a] = e, e += r;
  return o;
}
var Aoe = hoe, poe = qy, _v = 1 / 0, voe = 17976931348623157e292;
function goe(e) {
  if (!e)
    return e === 0 ? e : 0;
  if (e = poe(e), e === _v || e === -_v) {
    var t = e < 0 ? -1 : 1;
    return t * voe;
  }
  return e === e ? e : 0;
}
var jx = goe, moe = Aoe, Coe = _0, l4 = jx;
function boe(e) {
  return function(t, r, n) {
    return n && typeof n != "number" && Coe(t, r, n) && (r = n = void 0), t = l4(t), r === void 0 ? (r = t, t = 0) : r = l4(r), n = n === void 0 ? t < r ? 1 : -1 : l4(n), moe(t, r, n, e);
  };
}
var yoe = boe, woe = yoe, xoe = woe(), Ooe = xoe;
const Us = /* @__PURE__ */ qe(Ooe);
function To(e) {
  "@babel/helpers - typeof";
  return To = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, To(e);
}
function Lv(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Tv(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Lv(Object(r), !0).forEach(function(n) {
      Sx(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Lv(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function Sx(e, t, r) {
  return t = Doe(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function Doe(e) {
  var t = Moe(e, "string");
  return To(t) == "symbol" ? t : t + "";
}
function Moe(e, t) {
  if (To(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (To(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var Eoe = ["Webkit", "Moz", "O", "ms"], Poe = function(t, r) {
  if (!t)
    return null;
  var n = t.replace(/(\w)/, function(i) {
    return i.toUpperCase();
  }), a = Eoe.reduce(function(i, o) {
    return Tv(Tv({}, i), {}, Sx({}, o + n, r));
  }, {});
  return a[t] = r, a;
};
function u2(e) {
  "@babel/helpers - typeof";
  return u2 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, u2(e);
}
function Zs() {
  return Zs = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Zs.apply(this, arguments);
}
function Rv(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function c4(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Rv(Object(r), !0).forEach(function(n) {
      fr(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Rv(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function joe(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function $v(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Bx(n.key), n);
  }
}
function Soe(e, t, r) {
  return t && $v(e.prototype, t), r && $v(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function Ioe(e, t, r) {
  return t = zs(t), Boe(e, Ix() ? Reflect.construct(t, r || [], zs(e).constructor) : t.apply(e, r));
}
function Boe(e, t) {
  if (t && (u2(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return Noe(e);
}
function Noe(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function Ix() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (Ix = function() {
    return !!e;
  })();
}
function zs(e) {
  return zs = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, zs(e);
}
function _oe(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && e7(e, t);
}
function e7(e, t) {
  return e7 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, a) {
    return n.__proto__ = a, n;
  }, e7(e, t);
}
function fr(e, t, r) {
  return t = Bx(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function Bx(e) {
  var t = Loe(e, "string");
  return u2(t) == "symbol" ? t : t + "";
}
function Loe(e, t) {
  if (u2(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (u2(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var Toe = function(t) {
  var r = t.data, n = t.startIndex, a = t.endIndex, i = t.x, o = t.width, s = t.travellerWidth;
  if (!r || !r.length)
    return {};
  var c = r.length, u = Gi().domain(Us(0, c)).range([i, i + o - s]), d = u.domain().map(function(h) {
    return u(h);
  });
  return {
    isTextActive: !1,
    isSlideMoving: !1,
    isTravellerMoving: !1,
    isTravellerFocused: !1,
    startX: u(n),
    endX: u(a),
    scale: u,
    scaleValues: d
  };
}, Fv = function(t) {
  return t.changedTouches && !!t.changedTouches.length;
}, f2 = /* @__PURE__ */ function(e) {
  function t(r) {
    var n;
    return joe(this, t), n = Ioe(this, t, [r]), fr(n, "handleDrag", function(a) {
      n.leaveTimer && (clearTimeout(n.leaveTimer), n.leaveTimer = null), n.state.isTravellerMoving ? n.handleTravellerMove(a) : n.state.isSlideMoving && n.handleSlideDrag(a);
    }), fr(n, "handleTouchMove", function(a) {
      a.changedTouches != null && a.changedTouches.length > 0 && n.handleDrag(a.changedTouches[0]);
    }), fr(n, "handleDragEnd", function() {
      n.setState({
        isTravellerMoving: !1,
        isSlideMoving: !1
      }, function() {
        var a = n.props, i = a.endIndex, o = a.onDragEnd, s = a.startIndex;
        o == null || o({
          endIndex: i,
          startIndex: s
        });
      }), n.detachDragEndListener();
    }), fr(n, "handleLeaveWrapper", function() {
      (n.state.isTravellerMoving || n.state.isSlideMoving) && (n.leaveTimer = window.setTimeout(n.handleDragEnd, n.props.leaveTimeOut));
    }), fr(n, "handleEnterSlideOrTraveller", function() {
      n.setState({
        isTextActive: !0
      });
    }), fr(n, "handleLeaveSlideOrTraveller", function() {
      n.setState({
        isTextActive: !1
      });
    }), fr(n, "handleSlideDragStart", function(a) {
      var i = Fv(a) ? a.changedTouches[0] : a;
      n.setState({
        isTravellerMoving: !1,
        isSlideMoving: !0,
        slideMoveStartX: i.pageX
      }), n.attachDragEndListener();
    }), n.travellerDragStartHandlers = {
      startX: n.handleTravellerDragStart.bind(n, "startX"),
      endX: n.handleTravellerDragStart.bind(n, "endX")
    }, n.state = {}, n;
  }
  return _oe(t, e), Soe(t, [{
    key: "componentWillUnmount",
    value: function() {
      this.leaveTimer && (clearTimeout(this.leaveTimer), this.leaveTimer = null), this.detachDragEndListener();
    }
  }, {
    key: "getIndex",
    value: function(n) {
      var a = n.startX, i = n.endX, o = this.state.scaleValues, s = this.props, c = s.gap, u = s.data, d = u.length - 1, h = Math.min(a, i), A = Math.max(a, i), p = t.getIndexInRange(o, h), m = t.getIndexInRange(o, A);
      return {
        startIndex: p - p % c,
        endIndex: m === d ? d : m - m % c
      };
    }
  }, {
    key: "getTextOfTick",
    value: function(n) {
      var a = this.props, i = a.data, o = a.tickFormatter, s = a.dataKey, c = vt(i[n], s, n);
      return ye(o) ? o(c, n) : c;
    }
  }, {
    key: "attachDragEndListener",
    value: function() {
      window.addEventListener("mouseup", this.handleDragEnd, !0), window.addEventListener("touchend", this.handleDragEnd, !0), window.addEventListener("mousemove", this.handleDrag, !0);
    }
  }, {
    key: "detachDragEndListener",
    value: function() {
      window.removeEventListener("mouseup", this.handleDragEnd, !0), window.removeEventListener("touchend", this.handleDragEnd, !0), window.removeEventListener("mousemove", this.handleDrag, !0);
    }
  }, {
    key: "handleSlideDrag",
    value: function(n) {
      var a = this.state, i = a.slideMoveStartX, o = a.startX, s = a.endX, c = this.props, u = c.x, d = c.width, h = c.travellerWidth, A = c.startIndex, p = c.endIndex, m = c.onChange, g = n.pageX - i;
      g > 0 ? g = Math.min(g, u + d - h - s, u + d - h - o) : g < 0 && (g = Math.max(g, u - o, u - s));
      var v = this.getIndex({
        startX: o + g,
        endX: s + g
      });
      (v.startIndex !== A || v.endIndex !== p) && m && m(v), this.setState({
        startX: o + g,
        endX: s + g,
        slideMoveStartX: n.pageX
      });
    }
  }, {
    key: "handleTravellerDragStart",
    value: function(n, a) {
      var i = Fv(a) ? a.changedTouches[0] : a;
      this.setState({
        isSlideMoving: !1,
        isTravellerMoving: !0,
        movingTravellerId: n,
        brushMoveStartX: i.pageX
      }), this.attachDragEndListener();
    }
  }, {
    key: "handleTravellerMove",
    value: function(n) {
      var a = this.state, i = a.brushMoveStartX, o = a.movingTravellerId, s = a.endX, c = a.startX, u = this.state[o], d = this.props, h = d.x, A = d.width, p = d.travellerWidth, m = d.onChange, g = d.gap, v = d.data, C = {
        startX: this.state.startX,
        endX: this.state.endX
      }, y = n.pageX - i;
      y > 0 ? y = Math.min(y, h + A - p - u) : y < 0 && (y = Math.max(y, h - u)), C[o] = u + y;
      var w = this.getIndex(C), O = w.startIndex, b = w.endIndex, D = function() {
        var j = v.length - 1;
        return o === "startX" && (s > c ? O % g === 0 : b % g === 0) || s < c && b === j || o === "endX" && (s > c ? b % g === 0 : O % g === 0) || s > c && b === j;
      };
      this.setState(fr(fr({}, o, u + y), "brushMoveStartX", n.pageX), function() {
        m && D() && m(w);
      });
    }
  }, {
    key: "handleTravellerMoveKeyboard",
    value: function(n, a) {
      var i = this, o = this.state, s = o.scaleValues, c = o.startX, u = o.endX, d = this.state[a], h = s.indexOf(d);
      if (h !== -1) {
        var A = h + n;
        if (!(A === -1 || A >= s.length)) {
          var p = s[A];
          a === "startX" && p >= u || a === "endX" && p <= c || this.setState(fr({}, a, p), function() {
            i.props.onChange(i.getIndex({
              startX: i.state.startX,
              endX: i.state.endX
            }));
          });
        }
      }
    }
  }, {
    key: "renderBackground",
    value: function() {
      var n = this.props, a = n.x, i = n.y, o = n.width, s = n.height, c = n.fill, u = n.stroke;
      return /* @__PURE__ */ B.createElement("rect", {
        stroke: u,
        fill: c,
        x: a,
        y: i,
        width: o,
        height: s
      });
    }
  }, {
    key: "renderPanorama",
    value: function() {
      var n = this.props, a = n.x, i = n.y, o = n.width, s = n.height, c = n.data, u = n.children, d = n.padding, h = K1.only(u);
      return h ? /* @__PURE__ */ B.cloneElement(h, {
        x: a,
        y: i,
        width: o,
        height: s,
        margin: d,
        compact: !0,
        data: c
      }) : null;
    }
  }, {
    key: "renderTravellerLayer",
    value: function(n, a) {
      var i, o, s = this, c = this.props, u = c.y, d = c.travellerWidth, h = c.height, A = c.traveller, p = c.ariaLabel, m = c.data, g = c.startIndex, v = c.endIndex, C = Math.max(n, this.props.x), y = c4(c4({}, Ae(this.props, !1)), {}, {
        x: C,
        y: u,
        width: d,
        height: h
      }), w = p || "Min value: ".concat((i = m[g]) === null || i === void 0 ? void 0 : i.name, ", Max value: ").concat((o = m[v]) === null || o === void 0 ? void 0 : o.name);
      return /* @__PURE__ */ B.createElement(Se, {
        tabIndex: 0,
        role: "slider",
        "aria-label": w,
        "aria-valuenow": n,
        className: "recharts-brush-traveller",
        onMouseEnter: this.handleEnterSlideOrTraveller,
        onMouseLeave: this.handleLeaveSlideOrTraveller,
        onMouseDown: this.travellerDragStartHandlers[a],
        onTouchStart: this.travellerDragStartHandlers[a],
        onKeyDown: function(b) {
          ["ArrowLeft", "ArrowRight"].includes(b.key) && (b.preventDefault(), b.stopPropagation(), s.handleTravellerMoveKeyboard(b.key === "ArrowRight" ? 1 : -1, a));
        },
        onFocus: function() {
          s.setState({
            isTravellerFocused: !0
          });
        },
        onBlur: function() {
          s.setState({
            isTravellerFocused: !1
          });
        },
        style: {
          cursor: "col-resize"
        }
      }, t.renderTraveller(A, y));
    }
  }, {
    key: "renderSlide",
    value: function(n, a) {
      var i = this.props, o = i.y, s = i.height, c = i.stroke, u = i.travellerWidth, d = Math.min(n, a) + u, h = Math.max(Math.abs(a - n) - u, 0);
      return /* @__PURE__ */ B.createElement("rect", {
        className: "recharts-brush-slide",
        onMouseEnter: this.handleEnterSlideOrTraveller,
        onMouseLeave: this.handleLeaveSlideOrTraveller,
        onMouseDown: this.handleSlideDragStart,
        onTouchStart: this.handleSlideDragStart,
        style: {
          cursor: "move"
        },
        stroke: "none",
        fill: c,
        fillOpacity: 0.2,
        x: d,
        y: o,
        width: h,
        height: s
      });
    }
  }, {
    key: "renderText",
    value: function() {
      var n = this.props, a = n.startIndex, i = n.endIndex, o = n.y, s = n.height, c = n.travellerWidth, u = n.stroke, d = this.state, h = d.startX, A = d.endX, p = 5, m = {
        pointerEvents: "none",
        fill: u
      };
      return /* @__PURE__ */ B.createElement(Se, {
        className: "recharts-brush-texts"
      }, /* @__PURE__ */ B.createElement(ta, Zs({
        textAnchor: "end",
        verticalAnchor: "middle",
        x: Math.min(h, A) - p,
        y: o + s / 2
      }, m), this.getTextOfTick(a)), /* @__PURE__ */ B.createElement(ta, Zs({
        textAnchor: "start",
        verticalAnchor: "middle",
        x: Math.max(h, A) + c + p,
        y: o + s / 2
      }, m), this.getTextOfTick(i)));
    }
  }, {
    key: "render",
    value: function() {
      var n = this.props, a = n.data, i = n.className, o = n.children, s = n.x, c = n.y, u = n.width, d = n.height, h = n.alwaysShowText, A = this.state, p = A.startX, m = A.endX, g = A.isTextActive, v = A.isSlideMoving, C = A.isTravellerMoving, y = A.isTravellerFocused;
      if (!a || !a.length || !se(s) || !se(c) || !se(u) || !se(d) || u <= 0 || d <= 0)
        return null;
      var w = Pe("recharts-brush", i), O = B.Children.count(o) === 1, b = Poe("userSelect", "none");
      return /* @__PURE__ */ B.createElement(Se, {
        className: w,
        onMouseLeave: this.handleLeaveWrapper,
        onTouchMove: this.handleTouchMove,
        style: b
      }, this.renderBackground(), O && this.renderPanorama(), this.renderSlide(p, m), this.renderTravellerLayer(p, "startX"), this.renderTravellerLayer(m, "endX"), (g || v || C || y || h) && this.renderText());
    }
  }], [{
    key: "renderDefaultTraveller",
    value: function(n) {
      var a = n.x, i = n.y, o = n.width, s = n.height, c = n.stroke, u = Math.floor(i + s / 2) - 1;
      return /* @__PURE__ */ B.createElement(B.Fragment, null, /* @__PURE__ */ B.createElement("rect", {
        x: a,
        y: i,
        width: o,
        height: s,
        fill: c,
        stroke: "none"
      }), /* @__PURE__ */ B.createElement("line", {
        x1: a + 1,
        y1: u,
        x2: a + o - 1,
        y2: u,
        fill: "none",
        stroke: "#fff"
      }), /* @__PURE__ */ B.createElement("line", {
        x1: a + 1,
        y1: u + 2,
        x2: a + o - 1,
        y2: u + 2,
        fill: "none",
        stroke: "#fff"
      }));
    }
  }, {
    key: "renderTraveller",
    value: function(n, a) {
      var i;
      return /* @__PURE__ */ B.isValidElement(n) ? i = /* @__PURE__ */ B.cloneElement(n, a) : ye(n) ? i = n(a) : i = t.renderDefaultTraveller(a), i;
    }
  }, {
    key: "getDerivedStateFromProps",
    value: function(n, a) {
      var i = n.data, o = n.width, s = n.x, c = n.travellerWidth, u = n.updateId, d = n.startIndex, h = n.endIndex;
      if (i !== a.prevData || u !== a.prevUpdateId)
        return c4({
          prevData: i,
          prevTravellerWidth: c,
          prevUpdateId: u,
          prevX: s,
          prevWidth: o
        }, i && i.length ? Toe({
          data: i,
          width: o,
          x: s,
          travellerWidth: c,
          startIndex: d,
          endIndex: h
        }) : {
          scale: null,
          scaleValues: null
        });
      if (a.scale && (o !== a.prevWidth || s !== a.prevX || c !== a.prevTravellerWidth)) {
        a.scale.range([s, s + o - c]);
        var A = a.scale.domain().map(function(p) {
          return a.scale(p);
        });
        return {
          prevData: i,
          prevTravellerWidth: c,
          prevUpdateId: u,
          prevX: s,
          prevWidth: o,
          startX: a.scale(n.startIndex),
          endX: a.scale(n.endIndex),
          scaleValues: A
        };
      }
      return null;
    }
  }, {
    key: "getIndexInRange",
    value: function(n, a) {
      for (var i = n.length, o = 0, s = i - 1; s - o > 1; ) {
        var c = Math.floor((o + s) / 2);
        n[c] > a ? s = c : o = c;
      }
      return a >= n[s] ? s : o;
    }
  }]);
}(Cr);
fr(f2, "displayName", "Brush");
fr(f2, "defaultProps", {
  height: 40,
  travellerWidth: 5,
  gap: 1,
  fill: "#fff",
  stroke: "#666",
  padding: {
    top: 1,
    right: 1,
    bottom: 1,
    left: 1
  },
  leaveTimeOut: 1e3,
  alwaysShowText: !1
});
var Roe = D9;
function $oe(e, t) {
  var r;
  return Roe(e, function(n, a, i) {
    return r = t(n, a, i), !r;
  }), !!r;
}
var Foe = $oe, Hoe = Oy, Yoe = dn, Voe = Foe, koe = or, Goe = _0;
function Woe(e, t, r) {
  var n = koe(e) ? Hoe : Voe;
  return r && Goe(e, t, r) && (t = void 0), n(e, Yoe(t));
}
var Qoe = Woe;
const Uoe = /* @__PURE__ */ qe(Qoe);
var ln = function(t, r) {
  var n = t.alwaysShow, a = t.ifOverflow;
  return n && (a = "extendDomain"), a === r;
}, Hv = Qy;
function Zoe(e, t, r) {
  t == "__proto__" && Hv ? Hv(e, t, {
    configurable: !0,
    enumerable: !0,
    value: r,
    writable: !0
  }) : e[t] = r;
}
var zoe = Zoe, Koe = zoe, qoe = Gy, Xoe = dn;
function Joe(e, t) {
  var r = {};
  return t = Xoe(t), qoe(e, function(n, a, i) {
    Koe(r, a, t(n, a, i));
  }), r;
}
var e3e = Joe;
const t3e = /* @__PURE__ */ qe(e3e);
function r3e(e, t) {
  for (var r = -1, n = e == null ? 0 : e.length; ++r < n; )
    if (!t(e[r], r, e))
      return !1;
  return !0;
}
var n3e = r3e, a3e = D9;
function i3e(e, t) {
  var r = !0;
  return a3e(e, function(n, a, i) {
    return r = !!t(n, a, i), r;
  }), r;
}
var o3e = i3e, s3e = n3e, l3e = o3e, c3e = dn, u3e = or, f3e = _0;
function d3e(e, t, r) {
  var n = u3e(e) ? s3e : l3e;
  return r && f3e(e, t, r) && (t = void 0), n(e, c3e(t));
}
var h3e = d3e;
const Nx = /* @__PURE__ */ qe(h3e);
var A3e = ["x", "y"];
function d2(e) {
  "@babel/helpers - typeof";
  return d2 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, d2(e);
}
function t7() {
  return t7 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, t7.apply(this, arguments);
}
function Yv(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Oi(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Yv(Object(r), !0).forEach(function(n) {
      p3e(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Yv(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function p3e(e, t, r) {
  return t = v3e(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function v3e(e) {
  var t = g3e(e, "string");
  return d2(t) == "symbol" ? t : t + "";
}
function g3e(e, t) {
  if (d2(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (d2(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function m3e(e, t) {
  if (e == null)
    return {};
  var r = C3e(e, t), n, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (a = 0; a < i.length; a++)
      n = i[a], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function C3e(e, t) {
  if (e == null)
    return {};
  var r = {};
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      if (t.indexOf(n) >= 0)
        continue;
      r[n] = e[n];
    }
  return r;
}
function b3e(e, t) {
  var r = e.x, n = e.y, a = m3e(e, A3e), i = "".concat(r), o = parseInt(i, 10), s = "".concat(n), c = parseInt(s, 10), u = "".concat(t.height || a.height), d = parseInt(u, 10), h = "".concat(t.width || a.width), A = parseInt(h, 10);
  return Oi(Oi(Oi(Oi(Oi({}, t), a), o ? {
    x: o
  } : {}), c ? {
    y: c
  } : {}), {}, {
    height: d,
    width: A,
    name: t.name,
    radius: t.radius
  });
}
function Vv(e) {
  return /* @__PURE__ */ B.createElement(Ws, t7({
    shapeType: "rectangle",
    propTransformer: b3e,
    activeClassName: "recharts-active-bar"
  }, e));
}
var y3e = function(t) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
  return function(n, a) {
    if (typeof t == "number")
      return t;
    var i = se(n) || eV(n);
    return i ? t(n, a) : (i || (process.env.NODE_ENV !== "production" ? Zt(!1, "minPointSize callback function received a value with type of ".concat(d2(n), ". Currently only numbers or null/undefined are supported.")) : Zt(!1)), r);
  };
}, w3e = ["value", "background"], _x;
function h2(e) {
  "@babel/helpers - typeof";
  return h2 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, h2(e);
}
function x3e(e, t) {
  if (e == null)
    return {};
  var r = O3e(e, t), n, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (a = 0; a < i.length; a++)
      n = i[a], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function O3e(e, t) {
  if (e == null)
    return {};
  var r = {};
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      if (t.indexOf(n) >= 0)
        continue;
      r[n] = e[n];
    }
  return r;
}
function Ks() {
  return Ks = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Ks.apply(this, arguments);
}
function kv(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Mt(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? kv(Object(r), !0).forEach(function(n) {
      Jn(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : kv(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function D3e(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Gv(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Tx(n.key), n);
  }
}
function M3e(e, t, r) {
  return t && Gv(e.prototype, t), r && Gv(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function E3e(e, t, r) {
  return t = qs(t), P3e(e, Lx() ? Reflect.construct(t, r || [], qs(e).constructor) : t.apply(e, r));
}
function P3e(e, t) {
  if (t && (h2(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return j3e(e);
}
function j3e(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function Lx() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (Lx = function() {
    return !!e;
  })();
}
function qs(e) {
  return qs = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, qs(e);
}
function S3e(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && r7(e, t);
}
function r7(e, t) {
  return r7 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, a) {
    return n.__proto__ = a, n;
  }, r7(e, t);
}
function Jn(e, t, r) {
  return t = Tx(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function Tx(e) {
  var t = I3e(e, "string");
  return h2(t) == "symbol" ? t : t + "";
}
function I3e(e, t) {
  if (h2(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (h2(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var Lr = /* @__PURE__ */ function(e) {
  function t() {
    var r;
    D3e(this, t);
    for (var n = arguments.length, a = new Array(n), i = 0; i < n; i++)
      a[i] = arguments[i];
    return r = E3e(this, t, [].concat(a)), Jn(r, "state", {
      isAnimationFinished: !1
    }), Jn(r, "id", g1("recharts-bar-")), Jn(r, "handleAnimationEnd", function() {
      var o = r.props.onAnimationEnd;
      r.setState({
        isAnimationFinished: !0
      }), o && o();
    }), Jn(r, "handleAnimationStart", function() {
      var o = r.props.onAnimationStart;
      r.setState({
        isAnimationFinished: !1
      }), o && o();
    }), r;
  }
  return S3e(t, e), M3e(t, [{
    key: "renderRectanglesStatically",
    value: function(n) {
      var a = this, i = this.props, o = i.shape, s = i.dataKey, c = i.activeIndex, u = i.activeBar, d = Ae(this.props, !1);
      return n && n.map(function(h, A) {
        var p = A === c, m = p ? u : o, g = Mt(Mt(Mt({}, d), h), {}, {
          isActive: p,
          option: m,
          index: A,
          dataKey: s,
          onAnimationStart: a.handleAnimationStart,
          onAnimationEnd: a.handleAnimationEnd
        });
        return /* @__PURE__ */ B.createElement(Se, Ks({
          className: "recharts-bar-rectangle"
        }, c1(a.props, h, A), {
          // https://github.com/recharts/recharts/issues/5415
          // eslint-disable-next-line react/no-array-index-key
          key: "rectangle-".concat(h == null ? void 0 : h.x, "-").concat(h == null ? void 0 : h.y, "-").concat(h == null ? void 0 : h.value, "-").concat(A)
        }), /* @__PURE__ */ B.createElement(Vv, g));
      });
    }
  }, {
    key: "renderRectanglesWithAnimation",
    value: function() {
      var n = this, a = this.props, i = a.data, o = a.layout, s = a.isAnimationActive, c = a.animationBegin, u = a.animationDuration, d = a.animationEasing, h = a.animationId, A = this.state.prevData;
      return /* @__PURE__ */ B.createElement(Sn, {
        begin: c,
        duration: u,
        isActive: s,
        easing: d,
        from: {
          t: 0
        },
        to: {
          t: 1
        },
        key: "bar-".concat(h),
        onAnimationEnd: this.handleAnimationEnd,
        onAnimationStart: this.handleAnimationStart
      }, function(p) {
        var m = p.t, g = i.map(function(v, C) {
          var y = A && A[C];
          if (y) {
            var w = bt(y.x, v.x), O = bt(y.y, v.y), b = bt(y.width, v.width), D = bt(y.height, v.height);
            return Mt(Mt({}, v), {}, {
              x: w(m),
              y: O(m),
              width: b(m),
              height: D(m)
            });
          }
          if (o === "horizontal") {
            var M = bt(0, v.height), j = M(m);
            return Mt(Mt({}, v), {}, {
              y: v.y + v.height - j,
              height: j
            });
          }
          var P = bt(0, v.width), H = P(m);
          return Mt(Mt({}, v), {}, {
            width: H
          });
        });
        return /* @__PURE__ */ B.createElement(Se, null, n.renderRectanglesStatically(g));
      });
    }
  }, {
    key: "renderRectangles",
    value: function() {
      var n = this.props, a = n.data, i = n.isAnimationActive, o = this.state.prevData;
      return i && a && a.length && (!o || !u1(o, a)) ? this.renderRectanglesWithAnimation() : this.renderRectanglesStatically(a);
    }
  }, {
    key: "renderBackground",
    value: function() {
      var n = this, a = this.props, i = a.data, o = a.dataKey, s = a.activeIndex, c = Ae(this.props.background, !1);
      return i.map(function(u, d) {
        u.value;
        var h = u.background, A = x3e(u, w3e);
        if (!h)
          return null;
        var p = Mt(Mt(Mt(Mt(Mt({}, A), {}, {
          fill: "#eee"
        }, h), c), c1(n.props, u, d)), {}, {
          onAnimationStart: n.handleAnimationStart,
          onAnimationEnd: n.handleAnimationEnd,
          dataKey: o,
          index: d,
          className: "recharts-bar-background-rectangle"
        });
        return /* @__PURE__ */ B.createElement(Vv, Ks({
          key: "background-bar-".concat(d),
          option: n.props.background,
          isActive: d === s
        }, p));
      });
    }
  }, {
    key: "renderErrorBar",
    value: function(n, a) {
      if (this.props.isAnimationActive && !this.state.isAnimationFinished)
        return null;
      var i = this.props, o = i.data, s = i.xAxis, c = i.yAxis, u = i.layout, d = i.children, h = rr(d, V2);
      if (!h)
        return null;
      var A = u === "vertical" ? o[0].height / 2 : o[0].width / 2, p = function(v, C) {
        var y = Array.isArray(v.value) ? v.value[1] : v.value;
        return {
          x: v.x,
          y: v.y,
          value: y,
          errorVal: vt(v, C)
        };
      }, m = {
        clipPath: n ? "url(#clipPath-".concat(a, ")") : null
      };
      return /* @__PURE__ */ B.createElement(Se, m, h.map(function(g) {
        return /* @__PURE__ */ B.cloneElement(g, {
          key: "error-bar-".concat(a, "-").concat(g.props.dataKey),
          data: o,
          xAxis: s,
          yAxis: c,
          layout: u,
          offset: A,
          dataPointFormatter: p
        });
      }));
    }
  }, {
    key: "render",
    value: function() {
      var n = this.props, a = n.hide, i = n.data, o = n.className, s = n.xAxis, c = n.yAxis, u = n.left, d = n.top, h = n.width, A = n.height, p = n.isAnimationActive, m = n.background, g = n.id;
      if (a || !i || !i.length)
        return null;
      var v = this.state.isAnimationFinished, C = Pe("recharts-bar", o), y = s && s.allowDataOverflow, w = c && c.allowDataOverflow, O = y || w, b = be(g) ? this.id : g;
      return /* @__PURE__ */ B.createElement(Se, {
        className: C
      }, y || w ? /* @__PURE__ */ B.createElement("defs", null, /* @__PURE__ */ B.createElement("clipPath", {
        id: "clipPath-".concat(b)
      }, /* @__PURE__ */ B.createElement("rect", {
        x: y ? u : u - h / 2,
        y: w ? d : d - A / 2,
        width: y ? h : h * 2,
        height: w ? A : A * 2
      }))) : null, /* @__PURE__ */ B.createElement(Se, {
        className: "recharts-bar-rectangles",
        clipPath: O ? "url(#clipPath-".concat(b, ")") : null
      }, m ? this.renderBackground() : null, this.renderRectangles()), this.renderErrorBar(O, b), (!p || v) && Wr.renderCallByParent(this.props, i));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function(n, a) {
      return n.animationId !== a.prevAnimationId ? {
        prevAnimationId: n.animationId,
        curData: n.data,
        prevData: a.curData
      } : n.data !== a.curData ? {
        curData: n.data
      } : null;
    }
  }]);
}(Cr);
_x = Lr;
Jn(Lr, "displayName", "Bar");
Jn(Lr, "defaultProps", {
  xAxisId: 0,
  yAxisId: 0,
  legendType: "rect",
  minPointSize: 0,
  hide: !1,
  data: [],
  layout: "vertical",
  activeBar: !1,
  isAnimationActive: !Br.isSsr,
  animationBegin: 0,
  animationDuration: 400,
  animationEasing: "ease"
});
Jn(Lr, "getComposedData", function(e) {
  var t = e.props, r = e.item, n = e.barPosition, a = e.bandSize, i = e.xAxis, o = e.yAxis, s = e.xAxisTicks, c = e.yAxisTicks, u = e.stackedData, d = e.dataStartIndex, h = e.displayedData, A = e.offset, p = vne(n, r);
  if (!p)
    return null;
  var m = t.layout, g = r.type.defaultProps, v = g !== void 0 ? Mt(Mt({}, g), r.props) : r.props, C = v.dataKey, y = v.children, w = v.minPointSize, O = m === "horizontal" ? o : i, b = u ? O.scale.domain() : null, D = xne({
    numericAxis: O
  }), M = rr(y, Nr), j = h.map(function(P, H) {
    var F, R, N, z, q, J;
    u ? F = gne(u[d + H], b) : (F = vt(P, C), Array.isArray(F) || (F = [D, F]));
    var W = y3e(w, _x.defaultProps.minPointSize)(F[1], H);
    if (m === "horizontal") {
      var te, S = [o.scale(F[0]), o.scale(F[1])], I = S[0], T = S[1];
      R = Bp({
        axis: i,
        ticks: s,
        bandSize: a,
        offset: p.offset,
        entry: P,
        index: H
      }), N = (te = T ?? I) !== null && te !== void 0 ? te : void 0, z = p.size;
      var E = I - T;
      if (q = Number.isNaN(E) ? 0 : E, J = {
        x: R,
        y: o.y,
        width: z,
        height: o.height
      }, Math.abs(W) > 0 && Math.abs(q) < Math.abs(W)) {
        var x = Jt(q || W) * (Math.abs(W) - Math.abs(q));
        N -= x, q += x;
      }
    } else {
      var $ = [i.scale(F[0]), i.scale(F[1])], _ = $[0], Q = $[1];
      if (R = _, N = Bp({
        axis: o,
        ticks: c,
        bandSize: a,
        offset: p.offset,
        entry: P,
        index: H
      }), z = Q - _, q = p.size, J = {
        x: i.x,
        y: N,
        width: i.width,
        height: q
      }, Math.abs(W) > 0 && Math.abs(z) < Math.abs(W)) {
        var Z = Jt(z || W) * (Math.abs(W) - Math.abs(z));
        z += Z;
      }
    }
    return Mt(Mt(Mt({}, P), {}, {
      x: R,
      y: N,
      width: z,
      height: q,
      value: u ? F : F[1],
      payload: P,
      background: J
    }, M && M[H] && M[H].props), {}, {
      tooltipPayload: [lx(r, P)],
      tooltipPosition: {
        x: R + z / 2,
        y: N + q / 2
      }
    });
  });
  return Mt({
    data: j,
    layout: m
  }, A);
});
function Ro(e) {
  "@babel/helpers - typeof";
  return Ro = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Ro(e);
}
function B3e(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Wv(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Rx(n.key), n);
  }
}
function N3e(e, t, r) {
  return t && Wv(e.prototype, t), r && Wv(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function Qv(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function $r(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Qv(Object(r), !0).forEach(function(n) {
      X0(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Qv(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function X0(e, t, r) {
  return t = Rx(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function Rx(e) {
  var t = _3e(e, "string");
  return Ro(t) == "symbol" ? t : t + "";
}
function _3e(e, t) {
  if (Ro(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (Ro(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var $x = function(t, r, n, a, i) {
  var o = t.width, s = t.height, c = t.layout, u = t.children, d = Object.keys(r), h = {
    left: n.left,
    leftMirror: n.left,
    right: o - n.right,
    rightMirror: o - n.right,
    top: n.top,
    topMirror: n.top,
    bottom: s - n.bottom,
    bottomMirror: s - n.bottom
  }, A = !!hr(u, Lr);
  return d.reduce(function(p, m) {
    var g = r[m], v = g.orientation, C = g.domain, y = g.padding, w = y === void 0 ? {} : y, O = g.mirror, b = g.reversed, D = "".concat(v).concat(O ? "Mirror" : ""), M, j, P, H, F;
    if (g.type === "number" && (g.padding === "gap" || g.padding === "no-gap")) {
      var R = C[1] - C[0], N = 1 / 0, z = g.categoricalDomain.sort(aV);
      if (z.forEach(function($, _) {
        _ > 0 && (N = Math.min(($ || 0) - (z[_ - 1] || 0), N));
      }), Number.isFinite(N)) {
        var q = N / R, J = g.layout === "vertical" ? n.height : n.width;
        if (g.padding === "gap" && (M = q * J / 2), g.padding === "no-gap") {
          var W = er(t.barCategoryGap, q * J), te = q * J / 2;
          M = te - W - (te - W) / J * W;
        }
      }
    }
    a === "xAxis" ? j = [n.left + (w.left || 0) + (M || 0), n.left + n.width - (w.right || 0) - (M || 0)] : a === "yAxis" ? j = c === "horizontal" ? [n.top + n.height - (w.bottom || 0), n.top + (w.top || 0)] : [n.top + (w.top || 0) + (M || 0), n.top + n.height - (w.bottom || 0) - (M || 0)] : j = g.range, b && (j = [j[1], j[0]]);
    var S = ax(g, i, A), I = S.scale, T = S.realScaleType;
    I.domain(C).range(j), ix(I);
    var E = ox(I, $r($r({}, g), {}, {
      realScaleType: T
    }));
    a === "xAxis" ? (F = v === "top" && !O || v === "bottom" && O, P = n.left, H = h[D] - F * g.height) : a === "yAxis" && (F = v === "left" && !O || v === "right" && O, P = h[D] - F * g.width, H = n.top);
    var x = $r($r($r({}, g), E), {}, {
      realScaleType: T,
      x: P,
      y: H,
      scale: I,
      width: a === "xAxis" ? n.width : g.width,
      height: a === "yAxis" ? n.height : g.height
    });
    return x.bandSize = Ns(x, E), !g.hide && a === "xAxis" ? h[D] += (F ? -1 : 1) * x.height : g.hide || (h[D] += (F ? -1 : 1) * x.width), $r($r({}, p), {}, X0({}, m, x));
  }, {});
}, Fx = function(t, r) {
  var n = t.x, a = t.y, i = r.x, o = r.y;
  return {
    x: Math.min(n, i),
    y: Math.min(a, o),
    width: Math.abs(i - n),
    height: Math.abs(o - a)
  };
}, L3e = function(t) {
  var r = t.x1, n = t.y1, a = t.x2, i = t.y2;
  return Fx({
    x: r,
    y: n
  }, {
    x: a,
    y: i
  });
}, Hx = /* @__PURE__ */ function() {
  function e(t) {
    B3e(this, e), this.scale = t;
  }
  return N3e(e, [{
    key: "domain",
    get: function() {
      return this.scale.domain;
    }
  }, {
    key: "range",
    get: function() {
      return this.scale.range;
    }
  }, {
    key: "rangeMin",
    get: function() {
      return this.range()[0];
    }
  }, {
    key: "rangeMax",
    get: function() {
      return this.range()[1];
    }
  }, {
    key: "bandwidth",
    get: function() {
      return this.scale.bandwidth;
    }
  }, {
    key: "apply",
    value: function(r) {
      var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, a = n.bandAware, i = n.position;
      if (r !== void 0) {
        if (i)
          switch (i) {
            case "start":
              return this.scale(r);
            case "middle": {
              var o = this.bandwidth ? this.bandwidth() / 2 : 0;
              return this.scale(r) + o;
            }
            case "end": {
              var s = this.bandwidth ? this.bandwidth() : 0;
              return this.scale(r) + s;
            }
            default:
              return this.scale(r);
          }
        if (a) {
          var c = this.bandwidth ? this.bandwidth() / 2 : 0;
          return this.scale(r) + c;
        }
        return this.scale(r);
      }
    }
  }, {
    key: "isInRange",
    value: function(r) {
      var n = this.range(), a = n[0], i = n[n.length - 1];
      return a <= i ? r >= a && r <= i : r >= i && r <= a;
    }
  }], [{
    key: "create",
    value: function(r) {
      return new e(r);
    }
  }]);
}();
X0(Hx, "EPS", 1e-4);
var e8 = function(t) {
  var r = Object.keys(t).reduce(function(n, a) {
    return $r($r({}, n), {}, X0({}, a, Hx.create(t[a])));
  }, {});
  return $r($r({}, r), {}, {
    apply: function(a) {
      var i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, o = i.bandAware, s = i.position;
      return t3e(a, function(c, u) {
        return r[u].apply(c, {
          bandAware: o,
          position: s
        });
      });
    },
    isInRange: function(a) {
      return Nx(a, function(i, o) {
        return r[o].isInRange(i);
      });
    }
  });
};
function T3e(e) {
  return (e % 180 + 180) % 180;
}
var R3e = function(t) {
  var r = t.width, n = t.height, a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, i = T3e(a), o = i * Math.PI / 180, s = Math.atan(n / r), c = o > s && o < Math.PI - s ? n / Math.sin(o) : r / Math.cos(o);
  return Math.abs(c);
}, $3e = dn, F3e = zo, H3e = B0;
function Y3e(e) {
  return function(t, r, n) {
    var a = Object(t);
    if (!F3e(t)) {
      var i = $3e(r);
      t = H3e(t), r = function(s) {
        return i(a[s], s, a);
      };
    }
    var o = e(t, r, n);
    return o > -1 ? a[i ? t[o] : o] : void 0;
  };
}
var V3e = Y3e, k3e = jx;
function G3e(e) {
  var t = k3e(e), r = t % 1;
  return t === t ? r ? t - r : t : 0;
}
var W3e = G3e, Q3e = $y, U3e = dn, Z3e = W3e, z3e = Math.max;
function K3e(e, t, r) {
  var n = e == null ? 0 : e.length;
  if (!n)
    return -1;
  var a = r == null ? 0 : Z3e(r);
  return a < 0 && (a = z3e(n + a, 0)), Q3e(e, U3e(t), a);
}
var q3e = K3e, X3e = V3e, J3e = q3e, ese = X3e(J3e), tse = ese;
const rse = /* @__PURE__ */ qe(tse);
var nse = aY(function(e) {
  return {
    x: e.left,
    y: e.top,
    width: e.width,
    height: e.height
  };
}, function(e) {
  return ["l", e.left, "t", e.top, "w", e.width, "h", e.height].join("");
});
function Xs(e) {
  "@babel/helpers - typeof";
  return Xs = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Xs(e);
}
var t8 = /* @__PURE__ */ A1(void 0), r8 = /* @__PURE__ */ A1(void 0), Yx = /* @__PURE__ */ A1(void 0), Vx = /* @__PURE__ */ A1({}), kx = /* @__PURE__ */ A1(void 0), Gx = /* @__PURE__ */ A1(0), Wx = /* @__PURE__ */ A1(0), Uv = function(t) {
  var r = t.state, n = r.xAxisMap, a = r.yAxisMap, i = r.offset, o = t.clipPathId, s = t.children, c = t.width, u = t.height, d = nse(i);
  return /* @__PURE__ */ B.createElement(t8.Provider, {
    value: n
  }, /* @__PURE__ */ B.createElement(r8.Provider, {
    value: a
  }, /* @__PURE__ */ B.createElement(Vx.Provider, {
    value: i
  }, /* @__PURE__ */ B.createElement(Yx.Provider, {
    value: d
  }, /* @__PURE__ */ B.createElement(kx.Provider, {
    value: o
  }, /* @__PURE__ */ B.createElement(Gx.Provider, {
    value: u
  }, /* @__PURE__ */ B.createElement(Wx.Provider, {
    value: c
  }, s)))))));
}, ase = function() {
  return xt(kx);
};
function Qx(e) {
  var t = Object.keys(e);
  return t.length === 0 ? "There are no available ids." : "Available ids are: ".concat(t, ".");
}
var Ux = function(t) {
  var r = xt(t8);
  r == null && (process.env.NODE_ENV !== "production" ? Zt(!1, "Could not find Recharts context; are you sure this is rendered inside a Recharts wrapper component?") : Zt(!1));
  var n = r[t];
  return n == null && (process.env.NODE_ENV !== "production" ? Zt(!1, 'Could not find xAxis by id "'.concat(t, '" [').concat(Xs(t), "]. ").concat(Qx(r))) : Zt(!1)), n;
}, ise = function() {
  var t = xt(t8);
  return qn(t);
}, ose = function() {
  var t = xt(r8), r = rse(t, function(n) {
    return Nx(n.domain, Number.isFinite);
  });
  return r || qn(t);
}, Zx = function(t) {
  var r = xt(r8);
  r == null && (process.env.NODE_ENV !== "production" ? Zt(!1, "Could not find Recharts context; are you sure this is rendered inside a Recharts wrapper component?") : Zt(!1));
  var n = r[t];
  return n == null && (process.env.NODE_ENV !== "production" ? Zt(!1, 'Could not find yAxis by id "'.concat(t, '" [').concat(Xs(t), "]. ").concat(Qx(r))) : Zt(!1)), n;
}, sse = function() {
  var t = xt(Yx);
  return t;
}, lse = function() {
  return xt(Vx);
}, n8 = function() {
  return xt(Wx);
}, a8 = function() {
  return xt(Gx);
};
function A2(e) {
  "@babel/helpers - typeof";
  return A2 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, A2(e);
}
function cse(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Zv(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Kx(n.key), n);
  }
}
function use(e, t, r) {
  return t && Zv(e.prototype, t), r && Zv(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function fse(e, t, r) {
  return t = Js(t), dse(e, zx() ? Reflect.construct(t, r || [], Js(e).constructor) : t.apply(e, r));
}
function dse(e, t) {
  if (t && (A2(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return hse(e);
}
function hse(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function zx() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (zx = function() {
    return !!e;
  })();
}
function Js(e) {
  return Js = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, Js(e);
}
function Ase(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && n7(e, t);
}
function n7(e, t) {
  return n7 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, a) {
    return n.__proto__ = a, n;
  }, n7(e, t);
}
function zv(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Kv(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? zv(Object(r), !0).forEach(function(n) {
      i8(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : zv(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function i8(e, t, r) {
  return t = Kx(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function Kx(e) {
  var t = pse(e, "string");
  return A2(t) == "symbol" ? t : t + "";
}
function pse(e, t) {
  if (A2(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (A2(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function vse(e, t) {
  return bse(e) || Cse(e, t) || mse(e, t) || gse();
}
function gse() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function mse(e, t) {
  if (e) {
    if (typeof e == "string")
      return qv(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return qv(e, t);
  }
}
function qv(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
function Cse(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, a, i, o, s = [], c = !0, u = !1;
    try {
      if (i = (r = r.call(e)).next, t === 0) {
        if (Object(r) !== r)
          return;
        c = !1;
      } else
        for (; !(c = (n = i.call(r)).done) && (s.push(n.value), s.length !== t); c = !0)
          ;
    } catch (d) {
      u = !0, a = d;
    } finally {
      try {
        if (!c && r.return != null && (o = r.return(), Object(o) !== o))
          return;
      } finally {
        if (u)
          throw a;
      }
    }
    return s;
  }
}
function bse(e) {
  if (Array.isArray(e))
    return e;
}
function a7() {
  return a7 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, a7.apply(this, arguments);
}
var yse = function(t, r) {
  var n;
  return /* @__PURE__ */ B.isValidElement(t) ? n = /* @__PURE__ */ B.cloneElement(t, r) : ye(t) ? n = t(r) : n = /* @__PURE__ */ B.createElement("line", a7({}, r, {
    className: "recharts-reference-line-line"
  })), n;
}, wse = function(t, r, n, a, i, o, s, c, u) {
  var d = i.x, h = i.y, A = i.width, p = i.height;
  if (n) {
    var m = u.y, g = t.y.apply(m, {
      position: o
    });
    if (ln(u, "discard") && !t.y.isInRange(g))
      return null;
    var v = [{
      x: d + A,
      y: g
    }, {
      x: d,
      y: g
    }];
    return c === "left" ? v.reverse() : v;
  }
  if (r) {
    var C = u.x, y = t.x.apply(C, {
      position: o
    });
    if (ln(u, "discard") && !t.x.isInRange(y))
      return null;
    var w = [{
      x: y,
      y: h + p
    }, {
      x: y,
      y: h
    }];
    return s === "top" ? w.reverse() : w;
  }
  if (a) {
    var O = u.segment, b = O.map(function(D) {
      return t.apply(D, {
        position: o
      });
    });
    return ln(u, "discard") && Uoe(b, function(D) {
      return !t.isInRange(D);
    }) ? null : b;
  }
  return null;
};
function xse(e) {
  var t = e.x, r = e.y, n = e.segment, a = e.xAxisId, i = e.yAxisId, o = e.shape, s = e.className, c = e.alwaysShow, u = ase(), d = Ux(a), h = Zx(i), A = sse();
  if (!u || !A)
    return null;
  Gr(c === void 0, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.');
  var p = e8({
    x: d.scale,
    y: h.scale
  }), m = Nt(t), g = Nt(r), v = n && n.length === 2, C = wse(p, m, g, v, A, e.position, d.orientation, h.orientation, e);
  if (!C)
    return null;
  var y = vse(C, 2), w = y[0], O = w.x, b = w.y, D = y[1], M = D.x, j = D.y, P = ln(e, "hidden") ? "url(#".concat(u, ")") : void 0, H = Kv(Kv({
    clipPath: P
  }, Ae(e, !0)), {}, {
    x1: O,
    y1: b,
    x2: M,
    y2: j
  });
  return /* @__PURE__ */ B.createElement(Se, {
    className: Pe("recharts-reference-line", s)
  }, yse(o, H), Et.renderCallByParent(e, L3e({
    x1: O,
    y1: b,
    x2: M,
    y2: j
  })));
}
var o8 = /* @__PURE__ */ function(e) {
  function t() {
    return cse(this, t), fse(this, t, arguments);
  }
  return Ase(t, e), use(t, [{
    key: "render",
    value: function() {
      return /* @__PURE__ */ B.createElement(xse, this.props);
    }
  }]);
}(B.Component);
i8(o8, "displayName", "ReferenceLine");
i8(o8, "defaultProps", {
  isFront: !1,
  ifOverflow: "discard",
  xAxisId: 0,
  yAxisId: 0,
  fill: "none",
  stroke: "#ccc",
  fillOpacity: 1,
  strokeWidth: 1,
  position: "middle"
});
function i7() {
  return i7 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, i7.apply(this, arguments);
}
function p2(e) {
  "@babel/helpers - typeof";
  return p2 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, p2(e);
}
function Xv(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Jv(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Xv(Object(r), !0).forEach(function(n) {
      J0(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Xv(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function Ose(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function eg(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Xx(n.key), n);
  }
}
function Dse(e, t, r) {
  return t && eg(e.prototype, t), r && eg(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function Mse(e, t, r) {
  return t = e0(t), Ese(e, qx() ? Reflect.construct(t, r || [], e0(e).constructor) : t.apply(e, r));
}
function Ese(e, t) {
  if (t && (p2(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return Pse(e);
}
function Pse(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function qx() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (qx = function() {
    return !!e;
  })();
}
function e0(e) {
  return e0 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, e0(e);
}
function jse(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && o7(e, t);
}
function o7(e, t) {
  return o7 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, a) {
    return n.__proto__ = a, n;
  }, o7(e, t);
}
function J0(e, t, r) {
  return t = Xx(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function Xx(e) {
  var t = Sse(e, "string");
  return p2(t) == "symbol" ? t : t + "";
}
function Sse(e, t) {
  if (p2(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (p2(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var Ise = function(t) {
  var r = t.x, n = t.y, a = t.xAxis, i = t.yAxis, o = e8({
    x: a.scale,
    y: i.scale
  }), s = o.apply({
    x: r,
    y: n
  }, {
    bandAware: !0
  });
  return ln(t, "discard") && !o.isInRange(s) ? null : s;
}, el = /* @__PURE__ */ function(e) {
  function t() {
    return Ose(this, t), Mse(this, t, arguments);
  }
  return jse(t, e), Dse(t, [{
    key: "render",
    value: function() {
      var n = this.props, a = n.x, i = n.y, o = n.r, s = n.alwaysShow, c = n.clipPathId, u = Nt(a), d = Nt(i);
      if (Gr(s === void 0, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.'), !u || !d)
        return null;
      var h = Ise(this.props);
      if (!h)
        return null;
      var A = h.x, p = h.y, m = this.props, g = m.shape, v = m.className, C = ln(this.props, "hidden") ? "url(#".concat(c, ")") : void 0, y = Jv(Jv({
        clipPath: C
      }, Ae(this.props, !0)), {}, {
        cx: A,
        cy: p
      });
      return /* @__PURE__ */ B.createElement(Se, {
        className: Pe("recharts-reference-dot", v)
      }, t.renderDot(g, y), Et.renderCallByParent(this.props, {
        x: A - o,
        y: p - o,
        width: 2 * o,
        height: 2 * o
      }));
    }
  }]);
}(B.Component);
J0(el, "displayName", "ReferenceDot");
J0(el, "defaultProps", {
  isFront: !1,
  ifOverflow: "discard",
  xAxisId: 0,
  yAxisId: 0,
  r: 10,
  fill: "#fff",
  stroke: "#ccc",
  fillOpacity: 1,
  strokeWidth: 1
});
J0(el, "renderDot", function(e, t) {
  var r;
  return /* @__PURE__ */ B.isValidElement(e) ? r = /* @__PURE__ */ B.cloneElement(e, t) : ye(e) ? r = e(t) : r = /* @__PURE__ */ B.createElement(e3, i7({}, t, {
    cx: t.cx,
    cy: t.cy,
    className: "recharts-reference-dot-dot"
  })), r;
});
function s7() {
  return s7 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, s7.apply(this, arguments);
}
function v2(e) {
  "@babel/helpers - typeof";
  return v2 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, v2(e);
}
function tg(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function rg(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? tg(Object(r), !0).forEach(function(n) {
      tl(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : tg(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function Bse(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function ng(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, eO(n.key), n);
  }
}
function Nse(e, t, r) {
  return t && ng(e.prototype, t), r && ng(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function _se(e, t, r) {
  return t = t0(t), Lse(e, Jx() ? Reflect.construct(t, r || [], t0(e).constructor) : t.apply(e, r));
}
function Lse(e, t) {
  if (t && (v2(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return Tse(e);
}
function Tse(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function Jx() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (Jx = function() {
    return !!e;
  })();
}
function t0(e) {
  return t0 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, t0(e);
}
function Rse(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && l7(e, t);
}
function l7(e, t) {
  return l7 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, a) {
    return n.__proto__ = a, n;
  }, l7(e, t);
}
function tl(e, t, r) {
  return t = eO(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function eO(e) {
  var t = $se(e, "string");
  return v2(t) == "symbol" ? t : t + "";
}
function $se(e, t) {
  if (v2(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (v2(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var Fse = function(t, r, n, a, i) {
  var o = i.x1, s = i.x2, c = i.y1, u = i.y2, d = i.xAxis, h = i.yAxis;
  if (!d || !h)
    return null;
  var A = e8({
    x: d.scale,
    y: h.scale
  }), p = {
    x: t ? A.x.apply(o, {
      position: "start"
    }) : A.x.rangeMin,
    y: n ? A.y.apply(c, {
      position: "start"
    }) : A.y.rangeMin
  }, m = {
    x: r ? A.x.apply(s, {
      position: "end"
    }) : A.x.rangeMax,
    y: a ? A.y.apply(u, {
      position: "end"
    }) : A.y.rangeMax
  };
  return ln(i, "discard") && (!A.isInRange(p) || !A.isInRange(m)) ? null : Fx(p, m);
}, rl = /* @__PURE__ */ function(e) {
  function t() {
    return Bse(this, t), _se(this, t, arguments);
  }
  return Rse(t, e), Nse(t, [{
    key: "render",
    value: function() {
      var n = this.props, a = n.x1, i = n.x2, o = n.y1, s = n.y2, c = n.className, u = n.alwaysShow, d = n.clipPathId;
      Gr(u === void 0, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.');
      var h = Nt(a), A = Nt(i), p = Nt(o), m = Nt(s), g = this.props.shape;
      if (!h && !A && !p && !m && !g)
        return null;
      var v = Fse(h, A, p, m, this.props);
      if (!v && !g)
        return null;
      var C = ln(this.props, "hidden") ? "url(#".concat(d, ")") : void 0;
      return /* @__PURE__ */ B.createElement(Se, {
        className: Pe("recharts-reference-area", c)
      }, t.renderRect(g, rg(rg({
        clipPath: C
      }, Ae(this.props, !0)), v)), Et.renderCallByParent(this.props, v));
    }
  }]);
}(B.Component);
tl(rl, "displayName", "ReferenceArea");
tl(rl, "defaultProps", {
  isFront: !1,
  ifOverflow: "discard",
  xAxisId: 0,
  yAxisId: 0,
  r: 10,
  fill: "#ccc",
  fillOpacity: 0.5,
  stroke: "none",
  strokeWidth: 1
});
tl(rl, "renderRect", function(e, t) {
  var r;
  return /* @__PURE__ */ B.isValidElement(e) ? r = /* @__PURE__ */ B.cloneElement(e, t) : ye(e) ? r = e(t) : r = /* @__PURE__ */ B.createElement(J9, s7({}, t, {
    className: "recharts-reference-area-rect"
  })), r;
});
function tO(e, t, r) {
  if (t < 1)
    return [];
  if (t === 1 && r === void 0)
    return e;
  for (var n = [], a = 0; a < e.length; a += t)
    if (r === void 0 || r(e[a]) === !0)
      n.push(e[a]);
    else
      return;
  return n;
}
function Hse(e, t, r) {
  var n = {
    width: e.width + t.width,
    height: e.height + t.height
  };
  return R3e(n, r);
}
function Yse(e, t, r) {
  var n = r === "width", a = e.x, i = e.y, o = e.width, s = e.height;
  return t === 1 ? {
    start: n ? a : i,
    end: n ? a + o : i + s
  } : {
    start: n ? a + o : i + s,
    end: n ? a : i
  };
}
function r0(e, t, r, n, a) {
  if (e * t < e * n || e * t > e * a)
    return !1;
  var i = r();
  return e * (t - e * i / 2 - n) >= 0 && e * (t + e * i / 2 - a) <= 0;
}
function Vse(e, t) {
  return tO(e, t + 1);
}
function kse(e, t, r, n, a) {
  for (var i = (n || []).slice(), o = t.start, s = t.end, c = 0, u = 1, d = o, h = function() {
    var m = n == null ? void 0 : n[c];
    if (m === void 0)
      return {
        v: tO(n, u)
      };
    var g = c, v, C = function() {
      return v === void 0 && (v = r(m, g)), v;
    }, y = m.coordinate, w = c === 0 || r0(e, y, C, d, s);
    w || (c = 0, d = o, u += 1), w && (d = y + e * (C() / 2 + a), c += u);
  }, A; u <= i.length; )
    if (A = h(), A)
      return A.v;
  return [];
}
function $o(e) {
  "@babel/helpers - typeof";
  return $o = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, $o(e);
}
function ag(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Qt(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? ag(Object(r), !0).forEach(function(n) {
      Gse(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : ag(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function Gse(e, t, r) {
  return t = Wse(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function Wse(e) {
  var t = Qse(e, "string");
  return $o(t) == "symbol" ? t : t + "";
}
function Qse(e, t) {
  if ($o(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if ($o(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function Use(e, t, r, n, a) {
  for (var i = (n || []).slice(), o = i.length, s = t.start, c = t.end, u = function(A) {
    var p = i[A], m, g = function() {
      return m === void 0 && (m = r(p, A)), m;
    };
    if (A === o - 1) {
      var v = e * (p.coordinate + e * g() / 2 - c);
      i[A] = p = Qt(Qt({}, p), {}, {
        tickCoord: v > 0 ? p.coordinate - v * e : p.coordinate
      });
    } else
      i[A] = p = Qt(Qt({}, p), {}, {
        tickCoord: p.coordinate
      });
    var C = r0(e, p.tickCoord, g, s, c);
    C && (c = p.tickCoord - e * (g() / 2 + a), i[A] = Qt(Qt({}, p), {}, {
      isShow: !0
    }));
  }, d = o - 1; d >= 0; d--)
    u(d);
  return i;
}
function Zse(e, t, r, n, a, i) {
  var o = (n || []).slice(), s = o.length, c = t.start, u = t.end;
  if (i) {
    var d = n[s - 1], h = r(d, s - 1), A = e * (d.coordinate + e * h / 2 - u);
    o[s - 1] = d = Qt(Qt({}, d), {}, {
      tickCoord: A > 0 ? d.coordinate - A * e : d.coordinate
    });
    var p = r0(e, d.tickCoord, function() {
      return h;
    }, c, u);
    p && (u = d.tickCoord - e * (h / 2 + a), o[s - 1] = Qt(Qt({}, d), {}, {
      isShow: !0
    }));
  }
  for (var m = i ? s - 1 : s, g = function(y) {
    var w = o[y], O, b = function() {
      return O === void 0 && (O = r(w, y)), O;
    };
    if (y === 0) {
      var D = e * (w.coordinate - e * b() / 2 - c);
      o[y] = w = Qt(Qt({}, w), {}, {
        tickCoord: D < 0 ? w.coordinate - D * e : w.coordinate
      });
    } else
      o[y] = w = Qt(Qt({}, w), {}, {
        tickCoord: w.coordinate
      });
    var M = r0(e, w.tickCoord, b, c, u);
    M && (c = w.tickCoord + e * (b() / 2 + a), o[y] = Qt(Qt({}, w), {}, {
      isShow: !0
    }));
  }, v = 0; v < m; v++)
    g(v);
  return o;
}
function s8(e, t, r) {
  var n = e.tick, a = e.ticks, i = e.viewBox, o = e.minTickGap, s = e.orientation, c = e.interval, u = e.tickFormatter, d = e.unit, h = e.angle;
  if (!a || !a.length || !n)
    return [];
  if (se(c) || Br.isSsr)
    return Vse(a, typeof c == "number" && se(c) ? c : 0);
  var A = [], p = s === "top" || s === "bottom" ? "width" : "height", m = d && p === "width" ? ki(d, {
    fontSize: t,
    letterSpacing: r
  }) : {
    width: 0,
    height: 0
  }, g = function(w, O) {
    var b = ye(u) ? u(w.value, O) : w.value;
    return p === "width" ? Hse(ki(b, {
      fontSize: t,
      letterSpacing: r
    }), m, h) : ki(b, {
      fontSize: t,
      letterSpacing: r
    })[p];
  }, v = a.length >= 2 ? Jt(a[1].coordinate - a[0].coordinate) : 1, C = Yse(i, v, p);
  return c === "equidistantPreserveStart" ? kse(v, C, g, a, o) : (c === "preserveStart" || c === "preserveStartEnd" ? A = Zse(v, C, g, a, o, c === "preserveStartEnd") : A = Use(v, C, g, a, o), A.filter(function(y) {
    return y.isShow;
  }));
}
var zse = ["viewBox"], Kse = ["viewBox"], qse = ["ticks"];
function g2(e) {
  "@babel/helpers - typeof";
  return g2 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, g2(e);
}
function Ha() {
  return Ha = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Ha.apply(this, arguments);
}
function ig(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function St(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? ig(Object(r), !0).forEach(function(n) {
      l8(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : ig(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function u4(e, t) {
  if (e == null)
    return {};
  var r = Xse(e, t), n, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (a = 0; a < i.length; a++)
      n = i[a], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function Xse(e, t) {
  if (e == null)
    return {};
  var r = {};
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      if (t.indexOf(n) >= 0)
        continue;
      r[n] = e[n];
    }
  return r;
}
function Jse(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function og(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, nO(n.key), n);
  }
}
function e0e(e, t, r) {
  return t && og(e.prototype, t), r && og(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function t0e(e, t, r) {
  return t = n0(t), r0e(e, rO() ? Reflect.construct(t, r || [], n0(e).constructor) : t.apply(e, r));
}
function r0e(e, t) {
  if (t && (g2(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return n0e(e);
}
function n0e(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function rO() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (rO = function() {
    return !!e;
  })();
}
function n0(e) {
  return n0 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, n0(e);
}
function a0e(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && c7(e, t);
}
function c7(e, t) {
  return c7 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, a) {
    return n.__proto__ = a, n;
  }, c7(e, t);
}
function l8(e, t, r) {
  return t = nO(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function nO(e) {
  var t = i0e(e, "string");
  return g2(t) == "symbol" ? t : t + "";
}
function i0e(e, t) {
  if (g2(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (g2(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var k2 = /* @__PURE__ */ function(e) {
  function t(r) {
    var n;
    return Jse(this, t), n = t0e(this, t, [r]), n.state = {
      fontSize: "",
      letterSpacing: ""
    }, n;
  }
  return a0e(t, e), e0e(t, [{
    key: "shouldComponentUpdate",
    value: function(n, a) {
      var i = n.viewBox, o = u4(n, zse), s = this.props, c = s.viewBox, u = u4(s, Kse);
      return !Va(i, c) || !Va(o, u) || !Va(a, this.state);
    }
  }, {
    key: "componentDidMount",
    value: function() {
      var n = this.layerReference;
      if (n) {
        var a = n.getElementsByClassName("recharts-cartesian-axis-tick-value")[0];
        a && this.setState({
          fontSize: window.getComputedStyle(a).fontSize,
          letterSpacing: window.getComputedStyle(a).letterSpacing
        });
      }
    }
    /**
     * Calculate the coordinates of endpoints in ticks
     * @param  {Object} data The data of a simple tick
     * @return {Object} (x1, y1): The coordinate of endpoint close to tick text
     *  (x2, y2): The coordinate of endpoint close to axis
     */
  }, {
    key: "getTickLineCoord",
    value: function(n) {
      var a = this.props, i = a.x, o = a.y, s = a.width, c = a.height, u = a.orientation, d = a.tickSize, h = a.mirror, A = a.tickMargin, p, m, g, v, C, y, w = h ? -1 : 1, O = n.tickSize || d, b = se(n.tickCoord) ? n.tickCoord : n.coordinate;
      switch (u) {
        case "top":
          p = m = n.coordinate, v = o + +!h * c, g = v - w * O, y = g - w * A, C = b;
          break;
        case "left":
          g = v = n.coordinate, m = i + +!h * s, p = m - w * O, C = p - w * A, y = b;
          break;
        case "right":
          g = v = n.coordinate, m = i + +h * s, p = m + w * O, C = p + w * A, y = b;
          break;
        default:
          p = m = n.coordinate, v = o + +h * c, g = v + w * O, y = g + w * A, C = b;
          break;
      }
      return {
        line: {
          x1: p,
          y1: g,
          x2: m,
          y2: v
        },
        tick: {
          x: C,
          y
        }
      };
    }
  }, {
    key: "getTickTextAnchor",
    value: function() {
      var n = this.props, a = n.orientation, i = n.mirror, o;
      switch (a) {
        case "left":
          o = i ? "start" : "end";
          break;
        case "right":
          o = i ? "end" : "start";
          break;
        default:
          o = "middle";
          break;
      }
      return o;
    }
  }, {
    key: "getTickVerticalAnchor",
    value: function() {
      var n = this.props, a = n.orientation, i = n.mirror, o = "end";
      switch (a) {
        case "left":
        case "right":
          o = "middle";
          break;
        case "top":
          o = i ? "start" : "end";
          break;
        default:
          o = i ? "end" : "start";
          break;
      }
      return o;
    }
  }, {
    key: "renderAxisLine",
    value: function() {
      var n = this.props, a = n.x, i = n.y, o = n.width, s = n.height, c = n.orientation, u = n.mirror, d = n.axisLine, h = St(St(St({}, Ae(this.props, !1)), Ae(d, !1)), {}, {
        fill: "none"
      });
      if (c === "top" || c === "bottom") {
        var A = +(c === "top" && !u || c === "bottom" && u);
        h = St(St({}, h), {}, {
          x1: a,
          y1: i + A * s,
          x2: a + o,
          y2: i + A * s
        });
      } else {
        var p = +(c === "left" && !u || c === "right" && u);
        h = St(St({}, h), {}, {
          x1: a + p * o,
          y1: i,
          x2: a + p * o,
          y2: i + s
        });
      }
      return /* @__PURE__ */ B.createElement("line", Ha({}, h, {
        className: Pe("recharts-cartesian-axis-line", mr(d, "className"))
      }));
    }
  }, {
    key: "renderTicks",
    value: (
      /**
       * render the ticks
       * @param {Array} ticks The ticks to actually render (overrides what was passed in props)
       * @param {string} fontSize Fontsize to consider for tick spacing
       * @param {string} letterSpacing Letterspacing to consider for tick spacing
       * @return {ReactComponent} renderedTicks
       */
      function(n, a, i) {
        var o = this, s = this.props, c = s.tickLine, u = s.stroke, d = s.tick, h = s.tickFormatter, A = s.unit, p = s8(St(St({}, this.props), {}, {
          ticks: n
        }), a, i), m = this.getTickTextAnchor(), g = this.getTickVerticalAnchor(), v = Ae(this.props, !1), C = Ae(d, !1), y = St(St({}, v), {}, {
          fill: "none"
        }, Ae(c, !1)), w = p.map(function(O, b) {
          var D = o.getTickLineCoord(O), M = D.line, j = D.tick, P = St(St(St(St({
            textAnchor: m,
            verticalAnchor: g
          }, v), {}, {
            stroke: "none",
            fill: u
          }, C), j), {}, {
            index: b,
            payload: O,
            visibleTicksCount: p.length,
            tickFormatter: h
          });
          return /* @__PURE__ */ B.createElement(Se, Ha({
            className: "recharts-cartesian-axis-tick",
            key: "tick-".concat(O.value, "-").concat(O.coordinate, "-").concat(O.tickCoord)
          }, c1(o.props, O, b)), c && /* @__PURE__ */ B.createElement("line", Ha({}, y, M, {
            className: Pe("recharts-cartesian-axis-tick-line", mr(c, "className"))
          })), d && t.renderTickItem(d, P, "".concat(ye(h) ? h(O.value, b) : O.value).concat(A || "")));
        });
        return /* @__PURE__ */ B.createElement("g", {
          className: "recharts-cartesian-axis-ticks"
        }, w);
      }
    )
  }, {
    key: "render",
    value: function() {
      var n = this, a = this.props, i = a.axisLine, o = a.width, s = a.height, c = a.ticksGenerator, u = a.className, d = a.hide;
      if (d)
        return null;
      var h = this.props, A = h.ticks, p = u4(h, qse), m = A;
      return ye(c) && (m = A && A.length > 0 ? c(this.props) : c(p)), o <= 0 || s <= 0 || !m || !m.length ? null : /* @__PURE__ */ B.createElement(Se, {
        className: Pe("recharts-cartesian-axis", u),
        ref: function(v) {
          n.layerReference = v;
        }
      }, i && this.renderAxisLine(), this.renderTicks(m, this.state.fontSize, this.state.letterSpacing), Et.renderCallByParent(this.props));
    }
  }], [{
    key: "renderTickItem",
    value: function(n, a, i) {
      var o, s = Pe(a.className, "recharts-cartesian-axis-tick-value");
      return /* @__PURE__ */ B.isValidElement(n) ? o = /* @__PURE__ */ B.cloneElement(n, St(St({}, a), {}, {
        className: s
      })) : ye(n) ? o = n(St(St({}, a), {}, {
        className: s
      })) : o = /* @__PURE__ */ B.createElement(ta, Ha({}, a, {
        className: "recharts-cartesian-axis-tick-value"
      }), i), o;
    }
  }]);
}(uC);
l8(k2, "displayName", "CartesianAxis");
l8(k2, "defaultProps", {
  x: 0,
  y: 0,
  width: 0,
  height: 0,
  viewBox: {
    x: 0,
    y: 0,
    width: 0,
    height: 0
  },
  // The orientation of axis
  orientation: "bottom",
  // The ticks
  ticks: [],
  stroke: "#666",
  tickLine: !0,
  axisLine: !0,
  tick: !0,
  mirror: !1,
  minTickGap: 5,
  // The width or height of tick
  tickSize: 6,
  tickMargin: 2,
  interval: "preserveEnd"
});
var o0e = ["x1", "y1", "x2", "y2", "key"], s0e = ["offset"];
function na(e) {
  "@babel/helpers - typeof";
  return na = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, na(e);
}
function sg(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Ut(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? sg(Object(r), !0).forEach(function(n) {
      l0e(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : sg(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function l0e(e, t, r) {
  return t = c0e(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function c0e(e) {
  var t = u0e(e, "string");
  return na(t) == "symbol" ? t : t + "";
}
function u0e(e, t) {
  if (na(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (na(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function Z1() {
  return Z1 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Z1.apply(this, arguments);
}
function lg(e, t) {
  if (e == null)
    return {};
  var r = f0e(e, t), n, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (a = 0; a < i.length; a++)
      n = i[a], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function f0e(e, t) {
  if (e == null)
    return {};
  var r = {};
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      if (t.indexOf(n) >= 0)
        continue;
      r[n] = e[n];
    }
  return r;
}
var d0e = function(t) {
  var r = t.fill;
  if (!r || r === "none")
    return null;
  var n = t.fillOpacity, a = t.x, i = t.y, o = t.width, s = t.height, c = t.ry;
  return /* @__PURE__ */ B.createElement("rect", {
    x: a,
    y: i,
    ry: c,
    width: o,
    height: s,
    stroke: "none",
    fill: r,
    fillOpacity: n,
    className: "recharts-cartesian-grid-bg"
  });
};
function aO(e, t) {
  var r;
  if (/* @__PURE__ */ B.isValidElement(e))
    r = /* @__PURE__ */ B.cloneElement(e, t);
  else if (ye(e))
    r = e(t);
  else {
    var n = t.x1, a = t.y1, i = t.x2, o = t.y2, s = t.key, c = lg(t, o0e), u = Ae(c, !1);
    u.offset;
    var d = lg(u, s0e);
    r = /* @__PURE__ */ B.createElement("line", Z1({}, d, {
      x1: n,
      y1: a,
      x2: i,
      y2: o,
      fill: "none",
      key: s
    }));
  }
  return r;
}
function h0e(e) {
  var t = e.x, r = e.width, n = e.horizontal, a = n === void 0 ? !0 : n, i = e.horizontalPoints;
  if (!a || !i || !i.length)
    return null;
  var o = i.map(function(s, c) {
    var u = Ut(Ut({}, e), {}, {
      x1: t,
      y1: s,
      x2: t + r,
      y2: s,
      key: "line-".concat(c),
      index: c
    });
    return aO(a, u);
  });
  return /* @__PURE__ */ B.createElement("g", {
    className: "recharts-cartesian-grid-horizontal"
  }, o);
}
function A0e(e) {
  var t = e.y, r = e.height, n = e.vertical, a = n === void 0 ? !0 : n, i = e.verticalPoints;
  if (!a || !i || !i.length)
    return null;
  var o = i.map(function(s, c) {
    var u = Ut(Ut({}, e), {}, {
      x1: s,
      y1: t,
      x2: s,
      y2: t + r,
      key: "line-".concat(c),
      index: c
    });
    return aO(a, u);
  });
  return /* @__PURE__ */ B.createElement("g", {
    className: "recharts-cartesian-grid-vertical"
  }, o);
}
function p0e(e) {
  var t = e.horizontalFill, r = e.fillOpacity, n = e.x, a = e.y, i = e.width, o = e.height, s = e.horizontalPoints, c = e.horizontal, u = c === void 0 ? !0 : c;
  if (!u || !t || !t.length)
    return null;
  var d = s.map(function(A) {
    return Math.round(A + a - a);
  }).sort(function(A, p) {
    return A - p;
  });
  a !== d[0] && d.unshift(0);
  var h = d.map(function(A, p) {
    var m = !d[p + 1], g = m ? a + o - A : d[p + 1] - A;
    if (g <= 0)
      return null;
    var v = p % t.length;
    return /* @__PURE__ */ B.createElement("rect", {
      key: "react-".concat(p),
      y: A,
      x: n,
      height: g,
      width: i,
      stroke: "none",
      fill: t[v],
      fillOpacity: r,
      className: "recharts-cartesian-grid-bg"
    });
  });
  return /* @__PURE__ */ B.createElement("g", {
    className: "recharts-cartesian-gridstripes-horizontal"
  }, h);
}
function v0e(e) {
  var t = e.vertical, r = t === void 0 ? !0 : t, n = e.verticalFill, a = e.fillOpacity, i = e.x, o = e.y, s = e.width, c = e.height, u = e.verticalPoints;
  if (!r || !n || !n.length)
    return null;
  var d = u.map(function(A) {
    return Math.round(A + i - i);
  }).sort(function(A, p) {
    return A - p;
  });
  i !== d[0] && d.unshift(0);
  var h = d.map(function(A, p) {
    var m = !d[p + 1], g = m ? i + s - A : d[p + 1] - A;
    if (g <= 0)
      return null;
    var v = p % n.length;
    return /* @__PURE__ */ B.createElement("rect", {
      key: "react-".concat(p),
      x: A,
      y: o,
      width: g,
      height: c,
      stroke: "none",
      fill: n[v],
      fillOpacity: a,
      className: "recharts-cartesian-grid-bg"
    });
  });
  return /* @__PURE__ */ B.createElement("g", {
    className: "recharts-cartesian-gridstripes-vertical"
  }, h);
}
var g0e = function(t, r) {
  var n = t.xAxis, a = t.width, i = t.height, o = t.offset;
  return nx(s8(Ut(Ut(Ut({}, k2.defaultProps), n), {}, {
    ticks: wn(n, !0),
    viewBox: {
      x: 0,
      y: 0,
      width: a,
      height: i
    }
  })), o.left, o.left + o.width, r);
}, m0e = function(t, r) {
  var n = t.yAxis, a = t.width, i = t.height, o = t.offset;
  return nx(s8(Ut(Ut(Ut({}, k2.defaultProps), n), {}, {
    ticks: wn(n, !0),
    viewBox: {
      x: 0,
      y: 0,
      width: a,
      height: i
    }
  })), o.top, o.top + o.height, r);
}, Pa = {
  horizontal: !0,
  vertical: !0,
  // The ordinates of horizontal grid lines
  horizontalPoints: [],
  // The abscissas of vertical grid lines
  verticalPoints: [],
  stroke: "#ccc",
  fill: "none",
  // The fill of colors of grid lines
  verticalFill: [],
  horizontalFill: []
};
function nl(e) {
  var t, r, n, a, i, o, s = n8(), c = a8(), u = lse(), d = Ut(Ut({}, e), {}, {
    stroke: (t = e.stroke) !== null && t !== void 0 ? t : Pa.stroke,
    fill: (r = e.fill) !== null && r !== void 0 ? r : Pa.fill,
    horizontal: (n = e.horizontal) !== null && n !== void 0 ? n : Pa.horizontal,
    horizontalFill: (a = e.horizontalFill) !== null && a !== void 0 ? a : Pa.horizontalFill,
    vertical: (i = e.vertical) !== null && i !== void 0 ? i : Pa.vertical,
    verticalFill: (o = e.verticalFill) !== null && o !== void 0 ? o : Pa.verticalFill,
    x: se(e.x) ? e.x : u.left,
    y: se(e.y) ? e.y : u.top,
    width: se(e.width) ? e.width : u.width,
    height: se(e.height) ? e.height : u.height
  }), h = d.x, A = d.y, p = d.width, m = d.height, g = d.syncWithTicks, v = d.horizontalValues, C = d.verticalValues, y = ise(), w = ose();
  if (!se(p) || p <= 0 || !se(m) || m <= 0 || !se(h) || h !== +h || !se(A) || A !== +A)
    return null;
  var O = d.verticalCoordinatesGenerator || g0e, b = d.horizontalCoordinatesGenerator || m0e, D = d.horizontalPoints, M = d.verticalPoints;
  if ((!D || !D.length) && ye(b)) {
    var j = v && v.length, P = b({
      yAxis: w ? Ut(Ut({}, w), {}, {
        ticks: j ? v : w.ticks
      }) : void 0,
      width: s,
      height: c,
      offset: u
    }, j ? !0 : g);
    Gr(Array.isArray(P), "horizontalCoordinatesGenerator should return Array but instead it returned [".concat(na(P), "]")), Array.isArray(P) && (D = P);
  }
  if ((!M || !M.length) && ye(O)) {
    var H = C && C.length, F = O({
      xAxis: y ? Ut(Ut({}, y), {}, {
        ticks: H ? C : y.ticks
      }) : void 0,
      width: s,
      height: c,
      offset: u
    }, H ? !0 : g);
    Gr(Array.isArray(F), "verticalCoordinatesGenerator should return Array but instead it returned [".concat(na(F), "]")), Array.isArray(F) && (M = F);
  }
  return /* @__PURE__ */ B.createElement("g", {
    className: "recharts-cartesian-grid"
  }, /* @__PURE__ */ B.createElement(d0e, {
    fill: d.fill,
    fillOpacity: d.fillOpacity,
    x: d.x,
    y: d.y,
    width: d.width,
    height: d.height,
    ry: d.ry
  }), /* @__PURE__ */ B.createElement(h0e, Z1({}, d, {
    offset: u,
    horizontalPoints: D,
    xAxis: y,
    yAxis: w
  })), /* @__PURE__ */ B.createElement(A0e, Z1({}, d, {
    offset: u,
    verticalPoints: M,
    xAxis: y,
    yAxis: w
  })), /* @__PURE__ */ B.createElement(p0e, Z1({}, d, {
    horizontalPoints: D
  })), /* @__PURE__ */ B.createElement(v0e, Z1({}, d, {
    verticalPoints: M
  })));
}
nl.displayName = "CartesianGrid";
var C0e = ["type", "layout", "connectNulls", "ref"], b0e = ["key"];
function m2(e) {
  "@babel/helpers - typeof";
  return m2 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, m2(e);
}
function cg(e, t) {
  if (e == null)
    return {};
  var r = y0e(e, t), n, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (a = 0; a < i.length; a++)
      n = i[a], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function y0e(e, t) {
  if (e == null)
    return {};
  var r = {};
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      if (t.indexOf(n) >= 0)
        continue;
      r[n] = e[n];
    }
  return r;
}
function zi() {
  return zi = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, zi.apply(this, arguments);
}
function ug(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function ur(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? ug(Object(r), !0).forEach(function(n) {
      Fr(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : ug(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function ja(e) {
  return D0e(e) || O0e(e) || x0e(e) || w0e();
}
function w0e() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function x0e(e, t) {
  if (e) {
    if (typeof e == "string")
      return u7(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return u7(e, t);
  }
}
function O0e(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null)
    return Array.from(e);
}
function D0e(e) {
  if (Array.isArray(e))
    return u7(e);
}
function u7(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
function M0e(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function fg(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, oO(n.key), n);
  }
}
function E0e(e, t, r) {
  return t && fg(e.prototype, t), r && fg(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function P0e(e, t, r) {
  return t = a0(t), j0e(e, iO() ? Reflect.construct(t, r || [], a0(e).constructor) : t.apply(e, r));
}
function j0e(e, t) {
  if (t && (m2(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return S0e(e);
}
function S0e(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function iO() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (iO = function() {
    return !!e;
  })();
}
function a0(e) {
  return a0 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, a0(e);
}
function I0e(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && f7(e, t);
}
function f7(e, t) {
  return f7 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, a) {
    return n.__proto__ = a, n;
  }, f7(e, t);
}
function Fr(e, t, r) {
  return t = oO(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function oO(e) {
  var t = B0e(e, "string");
  return m2(t) == "symbol" ? t : t + "";
}
function B0e(e, t) {
  if (m2(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (m2(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var t3 = /* @__PURE__ */ function(e) {
  function t() {
    var r;
    M0e(this, t);
    for (var n = arguments.length, a = new Array(n), i = 0; i < n; i++)
      a[i] = arguments[i];
    return r = P0e(this, t, [].concat(a)), Fr(r, "state", {
      isAnimationFinished: !0,
      totalLength: 0
    }), Fr(r, "generateSimpleStrokeDasharray", function(o, s) {
      return "".concat(s, "px ").concat(o - s, "px");
    }), Fr(r, "getStrokeDasharray", function(o, s, c) {
      var u = c.reduce(function(C, y) {
        return C + y;
      });
      if (!u)
        return r.generateSimpleStrokeDasharray(s, o);
      for (var d = Math.floor(o / u), h = o % u, A = s - o, p = [], m = 0, g = 0; m < c.length; g += c[m], ++m)
        if (g + c[m] > h) {
          p = [].concat(ja(c.slice(0, m)), [h - g]);
          break;
        }
      var v = p.length % 2 === 0 ? [0, A] : [A];
      return [].concat(ja(t.repeat(c, d)), ja(p), v).map(function(C) {
        return "".concat(C, "px");
      }).join(", ");
    }), Fr(r, "id", g1("recharts-line-")), Fr(r, "pathRef", function(o) {
      r.mainCurve = o;
    }), Fr(r, "handleAnimationEnd", function() {
      r.setState({
        isAnimationFinished: !0
      }), r.props.onAnimationEnd && r.props.onAnimationEnd();
    }), Fr(r, "handleAnimationStart", function() {
      r.setState({
        isAnimationFinished: !1
      }), r.props.onAnimationStart && r.props.onAnimationStart();
    }), r;
  }
  return I0e(t, e), E0e(t, [{
    key: "componentDidMount",
    value: function() {
      if (this.props.isAnimationActive) {
        var n = this.getTotalLength();
        this.setState({
          totalLength: n
        });
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function() {
      if (this.props.isAnimationActive) {
        var n = this.getTotalLength();
        n !== this.state.totalLength && this.setState({
          totalLength: n
        });
      }
    }
  }, {
    key: "getTotalLength",
    value: function() {
      var n = this.mainCurve;
      try {
        return n && n.getTotalLength && n.getTotalLength() || 0;
      } catch {
        return 0;
      }
    }
  }, {
    key: "renderErrorBar",
    value: function(n, a) {
      if (this.props.isAnimationActive && !this.state.isAnimationFinished)
        return null;
      var i = this.props, o = i.points, s = i.xAxis, c = i.yAxis, u = i.layout, d = i.children, h = rr(d, V2);
      if (!h)
        return null;
      var A = function(g, v) {
        return {
          x: g.x,
          y: g.y,
          value: g.value,
          errorVal: vt(g.payload, v)
        };
      }, p = {
        clipPath: n ? "url(#clipPath-".concat(a, ")") : null
      };
      return /* @__PURE__ */ B.createElement(Se, p, h.map(function(m) {
        return /* @__PURE__ */ B.cloneElement(m, {
          key: "bar-".concat(m.props.dataKey),
          data: o,
          xAxis: s,
          yAxis: c,
          layout: u,
          dataPointFormatter: A
        });
      }));
    }
  }, {
    key: "renderDots",
    value: function(n, a, i) {
      var o = this.props.isAnimationActive;
      if (o && !this.state.isAnimationFinished)
        return null;
      var s = this.props, c = s.dot, u = s.points, d = s.dataKey, h = Ae(this.props, !1), A = Ae(c, !0), p = u.map(function(g, v) {
        var C = ur(ur(ur({
          key: "dot-".concat(v),
          r: 3
        }, h), A), {}, {
          index: v,
          cx: g.x,
          cy: g.y,
          value: g.value,
          dataKey: d,
          payload: g.payload,
          points: u
        });
        return t.renderDotItem(c, C);
      }), m = {
        clipPath: n ? "url(#clipPath-".concat(a ? "" : "dots-").concat(i, ")") : null
      };
      return /* @__PURE__ */ B.createElement(Se, zi({
        className: "recharts-line-dots",
        key: "dots"
      }, m), p);
    }
  }, {
    key: "renderCurveStatically",
    value: function(n, a, i, o) {
      var s = this.props, c = s.type, u = s.layout, d = s.connectNulls;
      s.ref;
      var h = cg(s, C0e), A = ur(ur(ur({}, Ae(h, !0)), {}, {
        fill: "none",
        className: "recharts-line-curve",
        clipPath: a ? "url(#clipPath-".concat(i, ")") : null,
        points: n
      }, o), {}, {
        type: c,
        layout: u,
        connectNulls: d
      });
      return /* @__PURE__ */ B.createElement(o1, zi({}, A, {
        pathRef: this.pathRef
      }));
    }
  }, {
    key: "renderCurveWithAnimation",
    value: function(n, a) {
      var i = this, o = this.props, s = o.points, c = o.strokeDasharray, u = o.isAnimationActive, d = o.animationBegin, h = o.animationDuration, A = o.animationEasing, p = o.animationId, m = o.animateNewValues, g = o.width, v = o.height, C = this.state, y = C.prevPoints, w = C.totalLength;
      return /* @__PURE__ */ B.createElement(Sn, {
        begin: d,
        duration: h,
        isActive: u,
        easing: A,
        from: {
          t: 0
        },
        to: {
          t: 1
        },
        key: "line-".concat(p),
        onAnimationEnd: this.handleAnimationEnd,
        onAnimationStart: this.handleAnimationStart
      }, function(O) {
        var b = O.t;
        if (y) {
          var D = y.length / s.length, M = s.map(function(R, N) {
            var z = Math.floor(N * D);
            if (y[z]) {
              var q = y[z], J = bt(q.x, R.x), W = bt(q.y, R.y);
              return ur(ur({}, R), {}, {
                x: J(b),
                y: W(b)
              });
            }
            if (m) {
              var te = bt(g * 2, R.x), S = bt(v / 2, R.y);
              return ur(ur({}, R), {}, {
                x: te(b),
                y: S(b)
              });
            }
            return ur(ur({}, R), {}, {
              x: R.x,
              y: R.y
            });
          });
          return i.renderCurveStatically(M, n, a);
        }
        var j = bt(0, w), P = j(b), H;
        if (c) {
          var F = "".concat(c).split(/[,\s]+/gim).map(function(R) {
            return parseFloat(R);
          });
          H = i.getStrokeDasharray(P, w, F);
        } else
          H = i.generateSimpleStrokeDasharray(w, P);
        return i.renderCurveStatically(s, n, a, {
          strokeDasharray: H
        });
      });
    }
  }, {
    key: "renderCurve",
    value: function(n, a) {
      var i = this.props, o = i.points, s = i.isAnimationActive, c = this.state, u = c.prevPoints, d = c.totalLength;
      return s && o && o.length && (!u && d > 0 || !u1(u, o)) ? this.renderCurveWithAnimation(n, a) : this.renderCurveStatically(o, n, a);
    }
  }, {
    key: "render",
    value: function() {
      var n, a = this.props, i = a.hide, o = a.dot, s = a.points, c = a.className, u = a.xAxis, d = a.yAxis, h = a.top, A = a.left, p = a.width, m = a.height, g = a.isAnimationActive, v = a.id;
      if (i || !s || !s.length)
        return null;
      var C = this.state.isAnimationFinished, y = s.length === 1, w = Pe("recharts-line", c), O = u && u.allowDataOverflow, b = d && d.allowDataOverflow, D = O || b, M = be(v) ? this.id : v, j = (n = Ae(o, !1)) !== null && n !== void 0 ? n : {
        r: 3,
        strokeWidth: 2
      }, P = j.r, H = P === void 0 ? 3 : P, F = j.strokeWidth, R = F === void 0 ? 2 : F, N = zb(o) ? o : {}, z = N.clipDot, q = z === void 0 ? !0 : z, J = H * 2 + R;
      return /* @__PURE__ */ B.createElement(Se, {
        className: w
      }, O || b ? /* @__PURE__ */ B.createElement("defs", null, /* @__PURE__ */ B.createElement("clipPath", {
        id: "clipPath-".concat(M)
      }, /* @__PURE__ */ B.createElement("rect", {
        x: O ? A : A - p / 2,
        y: b ? h : h - m / 2,
        width: O ? p : p * 2,
        height: b ? m : m * 2
      })), !q && /* @__PURE__ */ B.createElement("clipPath", {
        id: "clipPath-dots-".concat(M)
      }, /* @__PURE__ */ B.createElement("rect", {
        x: A - J / 2,
        y: h - J / 2,
        width: p + J,
        height: m + J
      }))) : null, !y && this.renderCurve(D, M), this.renderErrorBar(D, M), (y || o) && this.renderDots(D, q, M), (!g || C) && Wr.renderCallByParent(this.props, s));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function(n, a) {
      return n.animationId !== a.prevAnimationId ? {
        prevAnimationId: n.animationId,
        curPoints: n.points,
        prevPoints: a.curPoints
      } : n.points !== a.curPoints ? {
        curPoints: n.points
      } : null;
    }
  }, {
    key: "repeat",
    value: function(n, a) {
      for (var i = n.length % 2 !== 0 ? [].concat(ja(n), [0]) : n, o = [], s = 0; s < a; ++s)
        o = [].concat(ja(o), ja(i));
      return o;
    }
  }, {
    key: "renderDotItem",
    value: function(n, a) {
      var i;
      if (/* @__PURE__ */ B.isValidElement(n))
        i = /* @__PURE__ */ B.cloneElement(n, a);
      else if (ye(n))
        i = n(a);
      else {
        var o = a.key, s = cg(a, b0e), c = Pe("recharts-line-dot", typeof n != "boolean" ? n.className : "");
        i = /* @__PURE__ */ B.createElement(e3, zi({
          key: o
        }, s, {
          className: c
        }));
      }
      return i;
    }
  }]);
}(Cr);
Fr(t3, "displayName", "Line");
Fr(t3, "defaultProps", {
  xAxisId: 0,
  yAxisId: 0,
  connectNulls: !1,
  activeDot: !0,
  dot: !0,
  legendType: "line",
  stroke: "#3182bd",
  strokeWidth: 1,
  fill: "#fff",
  points: [],
  isAnimationActive: !Br.isSsr,
  animateNewValues: !0,
  animationBegin: 0,
  animationDuration: 1500,
  animationEasing: "ease",
  hide: !1,
  label: !1
});
Fr(t3, "getComposedData", function(e) {
  var t = e.props, r = e.xAxis, n = e.yAxis, a = e.xAxisTicks, i = e.yAxisTicks, o = e.dataKey, s = e.bandSize, c = e.displayedData, u = e.offset, d = t.layout, h = c.map(function(A, p) {
    var m = vt(A, o);
    return d === "horizontal" ? {
      x: i2({
        axis: r,
        ticks: a,
        bandSize: s,
        entry: A,
        index: p
      }),
      y: be(m) ? null : n.scale(m),
      value: m,
      payload: A
    } : {
      x: be(m) ? null : r.scale(m),
      y: i2({
        axis: n,
        ticks: i,
        bandSize: s,
        entry: A,
        index: p
      }),
      value: m,
      payload: A
    };
  });
  return ur({
    points: h,
    layout: d
  }, u);
});
var N0e = ["layout", "type", "stroke", "connectNulls", "isRange", "ref"], _0e = ["key"], sO;
function C2(e) {
  "@babel/helpers - typeof";
  return C2 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, C2(e);
}
function lO(e, t) {
  if (e == null)
    return {};
  var r = L0e(e, t), n, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (a = 0; a < i.length; a++)
      n = i[a], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function L0e(e, t) {
  if (e == null)
    return {};
  var r = {};
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      if (t.indexOf(n) >= 0)
        continue;
      r[n] = e[n];
    }
  return r;
}
function z1() {
  return z1 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, z1.apply(this, arguments);
}
function dg(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Zn(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? dg(Object(r), !0).forEach(function(n) {
      on(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : dg(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function T0e(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function hg(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, uO(n.key), n);
  }
}
function R0e(e, t, r) {
  return t && hg(e.prototype, t), r && hg(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function $0e(e, t, r) {
  return t = i0(t), F0e(e, cO() ? Reflect.construct(t, r || [], i0(e).constructor) : t.apply(e, r));
}
function F0e(e, t) {
  if (t && (C2(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return H0e(e);
}
function H0e(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function cO() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (cO = function() {
    return !!e;
  })();
}
function i0(e) {
  return i0 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, i0(e);
}
function Y0e(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && d7(e, t);
}
function d7(e, t) {
  return d7 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, a) {
    return n.__proto__ = a, n;
  }, d7(e, t);
}
function on(e, t, r) {
  return t = uO(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function uO(e) {
  var t = V0e(e, "string");
  return C2(t) == "symbol" ? t : t + "";
}
function V0e(e, t) {
  if (C2(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (C2(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var ca = /* @__PURE__ */ function(e) {
  function t() {
    var r;
    T0e(this, t);
    for (var n = arguments.length, a = new Array(n), i = 0; i < n; i++)
      a[i] = arguments[i];
    return r = $0e(this, t, [].concat(a)), on(r, "state", {
      isAnimationFinished: !0
    }), on(r, "id", g1("recharts-area-")), on(r, "handleAnimationEnd", function() {
      var o = r.props.onAnimationEnd;
      r.setState({
        isAnimationFinished: !0
      }), ye(o) && o();
    }), on(r, "handleAnimationStart", function() {
      var o = r.props.onAnimationStart;
      r.setState({
        isAnimationFinished: !1
      }), ye(o) && o();
    }), r;
  }
  return Y0e(t, e), R0e(t, [{
    key: "renderDots",
    value: function(n, a, i) {
      var o = this.props.isAnimationActive, s = this.state.isAnimationFinished;
      if (o && !s)
        return null;
      var c = this.props, u = c.dot, d = c.points, h = c.dataKey, A = Ae(this.props, !1), p = Ae(u, !0), m = d.map(function(v, C) {
        var y = Zn(Zn(Zn({
          key: "dot-".concat(C),
          r: 3
        }, A), p), {}, {
          index: C,
          cx: v.x,
          cy: v.y,
          dataKey: h,
          value: v.value,
          payload: v.payload,
          points: d
        });
        return t.renderDotItem(u, y);
      }), g = {
        clipPath: n ? "url(#clipPath-".concat(a ? "" : "dots-").concat(i, ")") : null
      };
      return /* @__PURE__ */ B.createElement(Se, z1({
        className: "recharts-area-dots"
      }, g), m);
    }
  }, {
    key: "renderHorizontalRect",
    value: function(n) {
      var a = this.props, i = a.baseLine, o = a.points, s = a.strokeWidth, c = o[0].x, u = o[o.length - 1].x, d = n * Math.abs(c - u), h = Xn(o.map(function(A) {
        return A.y || 0;
      }));
      return se(i) && typeof i == "number" ? h = Math.max(i, h) : i && Array.isArray(i) && i.length && (h = Math.max(Xn(i.map(function(A) {
        return A.y || 0;
      })), h)), se(h) ? /* @__PURE__ */ B.createElement("rect", {
        x: c < u ? c : c - d,
        y: 0,
        width: d,
        height: Math.floor(h + (s ? parseInt("".concat(s), 10) : 1))
      }) : null;
    }
  }, {
    key: "renderVerticalRect",
    value: function(n) {
      var a = this.props, i = a.baseLine, o = a.points, s = a.strokeWidth, c = o[0].y, u = o[o.length - 1].y, d = n * Math.abs(c - u), h = Xn(o.map(function(A) {
        return A.x || 0;
      }));
      return se(i) && typeof i == "number" ? h = Math.max(i, h) : i && Array.isArray(i) && i.length && (h = Math.max(Xn(i.map(function(A) {
        return A.x || 0;
      })), h)), se(h) ? /* @__PURE__ */ B.createElement("rect", {
        x: 0,
        y: c < u ? c : c - d,
        width: h + (s ? parseInt("".concat(s), 10) : 1),
        height: Math.floor(d)
      }) : null;
    }
  }, {
    key: "renderClipRect",
    value: function(n) {
      var a = this.props.layout;
      return a === "vertical" ? this.renderVerticalRect(n) : this.renderHorizontalRect(n);
    }
  }, {
    key: "renderAreaStatically",
    value: function(n, a, i, o) {
      var s = this.props, c = s.layout, u = s.type, d = s.stroke, h = s.connectNulls, A = s.isRange;
      s.ref;
      var p = lO(s, N0e);
      return /* @__PURE__ */ B.createElement(Se, {
        clipPath: i ? "url(#clipPath-".concat(o, ")") : null
      }, /* @__PURE__ */ B.createElement(o1, z1({}, Ae(p, !0), {
        points: n,
        connectNulls: h,
        type: u,
        baseLine: a,
        layout: c,
        stroke: "none",
        className: "recharts-area-area"
      })), d !== "none" && /* @__PURE__ */ B.createElement(o1, z1({}, Ae(this.props, !1), {
        className: "recharts-area-curve",
        layout: c,
        type: u,
        connectNulls: h,
        fill: "none",
        points: n
      })), d !== "none" && A && /* @__PURE__ */ B.createElement(o1, z1({}, Ae(this.props, !1), {
        className: "recharts-area-curve",
        layout: c,
        type: u,
        connectNulls: h,
        fill: "none",
        points: a
      })));
    }
  }, {
    key: "renderAreaWithAnimation",
    value: function(n, a) {
      var i = this, o = this.props, s = o.points, c = o.baseLine, u = o.isAnimationActive, d = o.animationBegin, h = o.animationDuration, A = o.animationEasing, p = o.animationId, m = this.state, g = m.prevPoints, v = m.prevBaseLine;
      return /* @__PURE__ */ B.createElement(Sn, {
        begin: d,
        duration: h,
        isActive: u,
        easing: A,
        from: {
          t: 0
        },
        to: {
          t: 1
        },
        key: "area-".concat(p),
        onAnimationEnd: this.handleAnimationEnd,
        onAnimationStart: this.handleAnimationStart
      }, function(C) {
        var y = C.t;
        if (g) {
          var w = g.length / s.length, O = s.map(function(j, P) {
            var H = Math.floor(P * w);
            if (g[H]) {
              var F = g[H], R = bt(F.x, j.x), N = bt(F.y, j.y);
              return Zn(Zn({}, j), {}, {
                x: R(y),
                y: N(y)
              });
            }
            return j;
          }), b;
          if (se(c) && typeof c == "number") {
            var D = bt(v, c);
            b = D(y);
          } else if (be(c) || _2(c)) {
            var M = bt(v, 0);
            b = M(y);
          } else
            b = c.map(function(j, P) {
              var H = Math.floor(P * w);
              if (v[H]) {
                var F = v[H], R = bt(F.x, j.x), N = bt(F.y, j.y);
                return Zn(Zn({}, j), {}, {
                  x: R(y),
                  y: N(y)
                });
              }
              return j;
            });
          return i.renderAreaStatically(O, b, n, a);
        }
        return /* @__PURE__ */ B.createElement(Se, null, /* @__PURE__ */ B.createElement("defs", null, /* @__PURE__ */ B.createElement("clipPath", {
          id: "animationClipPath-".concat(a)
        }, i.renderClipRect(y))), /* @__PURE__ */ B.createElement(Se, {
          clipPath: "url(#animationClipPath-".concat(a, ")")
        }, i.renderAreaStatically(s, c, n, a)));
      });
    }
  }, {
    key: "renderArea",
    value: function(n, a) {
      var i = this.props, o = i.points, s = i.baseLine, c = i.isAnimationActive, u = this.state, d = u.prevPoints, h = u.prevBaseLine, A = u.totalLength;
      return c && o && o.length && (!d && A > 0 || !u1(d, o) || !u1(h, s)) ? this.renderAreaWithAnimation(n, a) : this.renderAreaStatically(o, s, n, a);
    }
  }, {
    key: "render",
    value: function() {
      var n, a = this.props, i = a.hide, o = a.dot, s = a.points, c = a.className, u = a.top, d = a.left, h = a.xAxis, A = a.yAxis, p = a.width, m = a.height, g = a.isAnimationActive, v = a.id;
      if (i || !s || !s.length)
        return null;
      var C = this.state.isAnimationFinished, y = s.length === 1, w = Pe("recharts-area", c), O = h && h.allowDataOverflow, b = A && A.allowDataOverflow, D = O || b, M = be(v) ? this.id : v, j = (n = Ae(o, !1)) !== null && n !== void 0 ? n : {
        r: 3,
        strokeWidth: 2
      }, P = j.r, H = P === void 0 ? 3 : P, F = j.strokeWidth, R = F === void 0 ? 2 : F, N = zb(o) ? o : {}, z = N.clipDot, q = z === void 0 ? !0 : z, J = H * 2 + R;
      return /* @__PURE__ */ B.createElement(Se, {
        className: w
      }, O || b ? /* @__PURE__ */ B.createElement("defs", null, /* @__PURE__ */ B.createElement("clipPath", {
        id: "clipPath-".concat(M)
      }, /* @__PURE__ */ B.createElement("rect", {
        x: O ? d : d - p / 2,
        y: b ? u : u - m / 2,
        width: O ? p : p * 2,
        height: b ? m : m * 2
      })), !q && /* @__PURE__ */ B.createElement("clipPath", {
        id: "clipPath-dots-".concat(M)
      }, /* @__PURE__ */ B.createElement("rect", {
        x: d - J / 2,
        y: u - J / 2,
        width: p + J,
        height: m + J
      }))) : null, y ? null : this.renderArea(D, M), (o || y) && this.renderDots(D, q, M), (!g || C) && Wr.renderCallByParent(this.props, s));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function(n, a) {
      return n.animationId !== a.prevAnimationId ? {
        prevAnimationId: n.animationId,
        curPoints: n.points,
        curBaseLine: n.baseLine,
        prevPoints: a.curPoints,
        prevBaseLine: a.curBaseLine
      } : n.points !== a.curPoints || n.baseLine !== a.curBaseLine ? {
        curPoints: n.points,
        curBaseLine: n.baseLine
      } : null;
    }
  }]);
}(Cr);
sO = ca;
on(ca, "displayName", "Area");
on(ca, "defaultProps", {
  stroke: "#3182bd",
  fill: "#3182bd",
  fillOpacity: 0.6,
  xAxisId: 0,
  yAxisId: 0,
  legendType: "line",
  connectNulls: !1,
  // points of area
  points: [],
  dot: !1,
  activeDot: !0,
  hide: !1,
  isAnimationActive: !Br.isSsr,
  animationBegin: 0,
  animationDuration: 1500,
  animationEasing: "ease"
});
on(ca, "getBaseValue", function(e, t, r, n) {
  var a = e.layout, i = e.baseValue, o = t.props.baseValue, s = o ?? i;
  if (se(s) && typeof s == "number")
    return s;
  var c = a === "horizontal" ? n : r, u = c.scale.domain();
  if (c.type === "number") {
    var d = Math.max(u[0], u[1]), h = Math.min(u[0], u[1]);
    return s === "dataMin" ? h : s === "dataMax" || d < 0 ? d : Math.max(Math.min(u[0], u[1]), 0);
  }
  return s === "dataMin" ? u[0] : s === "dataMax" ? u[1] : u[0];
});
on(ca, "getComposedData", function(e) {
  var t = e.props, r = e.item, n = e.xAxis, a = e.yAxis, i = e.xAxisTicks, o = e.yAxisTicks, s = e.bandSize, c = e.dataKey, u = e.stackedData, d = e.dataStartIndex, h = e.displayedData, A = e.offset, p = t.layout, m = u && u.length, g = sO.getBaseValue(t, r, n, a), v = p === "horizontal", C = !1, y = h.map(function(O, b) {
    var D;
    m ? D = u[d + b] : (D = vt(O, c), Array.isArray(D) ? C = !0 : D = [g, D]);
    var M = D[1] == null || m && vt(O, c) == null;
    return v ? {
      x: i2({
        axis: n,
        ticks: i,
        bandSize: s,
        entry: O,
        index: b
      }),
      y: M ? null : a.scale(D[1]),
      value: D,
      payload: O
    } : {
      x: M ? null : n.scale(D[1]),
      y: i2({
        axis: a,
        ticks: o,
        bandSize: s,
        entry: O,
        index: b
      }),
      value: D,
      payload: O
    };
  }), w;
  return m || C ? w = y.map(function(O) {
    var b = Array.isArray(O.value) ? O.value[0] : null;
    return v ? {
      x: O.x,
      y: b != null && O.y != null ? a.scale(b) : null
    } : {
      x: b != null ? n.scale(b) : null,
      y: O.y
    };
  }) : w = v ? a.scale(g) : n.scale(g), Zn({
    points: y,
    baseLine: w,
    layout: p,
    isRange: C
  }, A);
});
on(ca, "renderDotItem", function(e, t) {
  var r;
  if (/* @__PURE__ */ B.isValidElement(e))
    r = /* @__PURE__ */ B.cloneElement(e, t);
  else if (ye(e))
    r = e(t);
  else {
    var n = Pe("recharts-area-dot", typeof e != "boolean" ? e.className : ""), a = t.key, i = lO(t, _0e);
    r = /* @__PURE__ */ B.createElement(e3, z1({}, i, {
      key: a,
      className: n
    }));
  }
  return r;
});
function b2(e) {
  "@babel/helpers - typeof";
  return b2 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, b2(e);
}
function k0e(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Ag(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, hO(n.key), n);
  }
}
function G0e(e, t, r) {
  return t && Ag(e.prototype, t), r && Ag(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function W0e(e, t, r) {
  return t = o0(t), Q0e(e, fO() ? Reflect.construct(t, r || [], o0(e).constructor) : t.apply(e, r));
}
function Q0e(e, t) {
  if (t && (b2(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return U0e(e);
}
function U0e(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function fO() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (fO = function() {
    return !!e;
  })();
}
function o0(e) {
  return o0 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, o0(e);
}
function Z0e(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && h7(e, t);
}
function h7(e, t) {
  return h7 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, a) {
    return n.__proto__ = a, n;
  }, h7(e, t);
}
function dO(e, t, r) {
  return t = hO(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function hO(e) {
  var t = z0e(e, "string");
  return b2(t) == "symbol" ? t : t + "";
}
function z0e(e, t) {
  if (b2(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (b2(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var al = /* @__PURE__ */ function(e) {
  function t() {
    return k0e(this, t), W0e(this, t, arguments);
  }
  return Z0e(t, e), G0e(t, [{
    key: "render",
    value: function() {
      return null;
    }
  }]);
}(Sr.Component);
dO(al, "displayName", "ZAxis");
dO(al, "defaultProps", {
  zAxisId: 0,
  range: [64, 64],
  scale: "auto",
  type: "number"
});
var K0e = ["option", "isActive"];
function Ki() {
  return Ki = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Ki.apply(this, arguments);
}
function q0e(e, t) {
  if (e == null)
    return {};
  var r = X0e(e, t), n, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (a = 0; a < i.length; a++)
      n = i[a], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function X0e(e, t) {
  if (e == null)
    return {};
  var r = {};
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      if (t.indexOf(n) >= 0)
        continue;
      r[n] = e[n];
    }
  return r;
}
function J0e(e) {
  var t = e.option, r = e.isActive, n = q0e(e, K0e);
  return typeof t == "string" ? /* @__PURE__ */ Sr.createElement(Ws, Ki({
    option: /* @__PURE__ */ Sr.createElement(I0, Ki({
      type: t
    }, n)),
    isActive: r,
    shapeType: "symbols"
  }, n)) : /* @__PURE__ */ Sr.createElement(Ws, Ki({
    option: t,
    isActive: r,
    shapeType: "symbols"
  }, n));
}
function y2(e) {
  "@babel/helpers - typeof";
  return y2 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, y2(e);
}
function qi() {
  return qi = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, qi.apply(this, arguments);
}
function pg(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Dr(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? pg(Object(r), !0).forEach(function(n) {
      e1(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : pg(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function ele(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function vg(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, pO(n.key), n);
  }
}
function tle(e, t, r) {
  return t && vg(e.prototype, t), r && vg(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function rle(e, t, r) {
  return t = s0(t), nle(e, AO() ? Reflect.construct(t, r || [], s0(e).constructor) : t.apply(e, r));
}
function nle(e, t) {
  if (t && (y2(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return ale(e);
}
function ale(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function AO() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (AO = function() {
    return !!e;
  })();
}
function s0(e) {
  return s0 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, s0(e);
}
function ile(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && A7(e, t);
}
function A7(e, t) {
  return A7 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, a) {
    return n.__proto__ = a, n;
  }, A7(e, t);
}
function e1(e, t, r) {
  return t = pO(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function pO(e) {
  var t = ole(e, "string");
  return y2(t) == "symbol" ? t : t + "";
}
function ole(e, t) {
  if (y2(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (y2(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var il = /* @__PURE__ */ function(e) {
  function t() {
    var r;
    ele(this, t);
    for (var n = arguments.length, a = new Array(n), i = 0; i < n; i++)
      a[i] = arguments[i];
    return r = rle(this, t, [].concat(a)), e1(r, "state", {
      isAnimationFinished: !1
    }), e1(r, "handleAnimationEnd", function() {
      r.setState({
        isAnimationFinished: !0
      });
    }), e1(r, "handleAnimationStart", function() {
      r.setState({
        isAnimationFinished: !1
      });
    }), e1(r, "id", g1("recharts-scatter-")), r;
  }
  return ile(t, e), tle(t, [{
    key: "renderSymbolsStatically",
    value: function(n) {
      var a = this, i = this.props, o = i.shape, s = i.activeShape, c = i.activeIndex, u = Ae(this.props, !1);
      return n.map(function(d, h) {
        var A = c === h, p = A ? s : o, m = Dr(Dr({}, u), d);
        return /* @__PURE__ */ B.createElement(Se, qi({
          className: "recharts-scatter-symbol",
          key: "symbol-".concat(d == null ? void 0 : d.cx, "-").concat(d == null ? void 0 : d.cy, "-").concat(d == null ? void 0 : d.size, "-").concat(h)
        }, c1(a.props, d, h), {
          role: "img"
        }), /* @__PURE__ */ B.createElement(J0e, qi({
          option: p,
          isActive: A,
          key: "symbol-".concat(h)
        }, m)));
      });
    }
  }, {
    key: "renderSymbolsWithAnimation",
    value: function() {
      var n = this, a = this.props, i = a.points, o = a.isAnimationActive, s = a.animationBegin, c = a.animationDuration, u = a.animationEasing, d = a.animationId, h = this.state.prevPoints;
      return /* @__PURE__ */ B.createElement(Sn, {
        begin: s,
        duration: c,
        isActive: o,
        easing: u,
        from: {
          t: 0
        },
        to: {
          t: 1
        },
        key: "pie-".concat(d),
        onAnimationEnd: this.handleAnimationEnd,
        onAnimationStart: this.handleAnimationStart
      }, function(A) {
        var p = A.t, m = i.map(function(g, v) {
          var C = h && h[v];
          if (C) {
            var y = bt(C.cx, g.cx), w = bt(C.cy, g.cy), O = bt(C.size, g.size);
            return Dr(Dr({}, g), {}, {
              cx: y(p),
              cy: w(p),
              size: O(p)
            });
          }
          var b = bt(0, g.size);
          return Dr(Dr({}, g), {}, {
            size: b(p)
          });
        });
        return /* @__PURE__ */ B.createElement(Se, null, n.renderSymbolsStatically(m));
      });
    }
  }, {
    key: "renderSymbols",
    value: function() {
      var n = this.props, a = n.points, i = n.isAnimationActive, o = this.state.prevPoints;
      return i && a && a.length && (!o || !u1(o, a)) ? this.renderSymbolsWithAnimation() : this.renderSymbolsStatically(a);
    }
  }, {
    key: "renderErrorBar",
    value: function() {
      var n = this.props.isAnimationActive;
      if (n && !this.state.isAnimationFinished)
        return null;
      var a = this.props, i = a.points, o = a.xAxis, s = a.yAxis, c = a.children, u = rr(c, V2);
      return u ? u.map(function(d, h) {
        var A = d.props, p = A.direction, m = A.dataKey;
        return /* @__PURE__ */ B.cloneElement(d, {
          key: "".concat(p, "-").concat(m, "-").concat(i[h]),
          data: i,
          xAxis: o,
          yAxis: s,
          layout: p === "x" ? "vertical" : "horizontal",
          dataPointFormatter: function(v, C) {
            return {
              x: v.cx,
              y: v.cy,
              value: p === "x" ? +v.node.x : +v.node.y,
              errorVal: vt(v, C)
            };
          }
        });
      }) : null;
    }
  }, {
    key: "renderLine",
    value: function() {
      var n = this.props, a = n.points, i = n.line, o = n.lineType, s = n.lineJointType, c = Ae(this.props, !1), u = Ae(i, !1), d, h;
      if (o === "joint")
        d = a.map(function(w) {
          return {
            x: w.cx,
            y: w.cy
          };
        });
      else if (o === "fitting") {
        var A = nV(a), p = A.xmin, m = A.xmax, g = A.a, v = A.b, C = function(O) {
          return g * O + v;
        };
        d = [{
          x: p,
          y: C(p)
        }, {
          x: m,
          y: C(m)
        }];
      }
      var y = Dr(Dr(Dr({}, c), {}, {
        fill: "none",
        stroke: c && c.fill
      }, u), {}, {
        points: d
      });
      return /* @__PURE__ */ B.isValidElement(i) ? h = /* @__PURE__ */ B.cloneElement(i, y) : ye(i) ? h = i(y) : h = /* @__PURE__ */ B.createElement(o1, qi({}, y, {
        type: s
      })), /* @__PURE__ */ B.createElement(Se, {
        className: "recharts-scatter-line",
        key: "recharts-scatter-line"
      }, h);
    }
  }, {
    key: "render",
    value: function() {
      var n = this.props, a = n.hide, i = n.points, o = n.line, s = n.className, c = n.xAxis, u = n.yAxis, d = n.left, h = n.top, A = n.width, p = n.height, m = n.id, g = n.isAnimationActive;
      if (a || !i || !i.length)
        return null;
      var v = this.state.isAnimationFinished, C = Pe("recharts-scatter", s), y = c && c.allowDataOverflow, w = u && u.allowDataOverflow, O = y || w, b = be(m) ? this.id : m;
      return /* @__PURE__ */ B.createElement(Se, {
        className: C,
        clipPath: O ? "url(#clipPath-".concat(b, ")") : null
      }, y || w ? /* @__PURE__ */ B.createElement("defs", null, /* @__PURE__ */ B.createElement("clipPath", {
        id: "clipPath-".concat(b)
      }, /* @__PURE__ */ B.createElement("rect", {
        x: y ? d : d - A / 2,
        y: w ? h : h - p / 2,
        width: y ? A : A * 2,
        height: w ? p : p * 2
      }))) : null, o && this.renderLine(), this.renderErrorBar(), /* @__PURE__ */ B.createElement(Se, {
        key: "recharts-scatter-symbols"
      }, this.renderSymbols()), (!g || v) && Wr.renderCallByParent(this.props, i));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function(n, a) {
      return n.animationId !== a.prevAnimationId ? {
        prevAnimationId: n.animationId,
        curPoints: n.points,
        prevPoints: a.curPoints
      } : n.points !== a.curPoints ? {
        curPoints: n.points
      } : null;
    }
  }]);
}(Cr);
e1(il, "displayName", "Scatter");
e1(il, "defaultProps", {
  xAxisId: 0,
  yAxisId: 0,
  zAxisId: 0,
  legendType: "circle",
  lineType: "joint",
  lineJointType: "linear",
  data: [],
  shape: "circle",
  hide: !1,
  isAnimationActive: !Br.isSsr,
  animationBegin: 0,
  animationDuration: 400,
  animationEasing: "linear"
});
e1(il, "getComposedData", function(e) {
  var t = e.xAxis, r = e.yAxis, n = e.zAxis, a = e.item, i = e.displayedData, o = e.xAxisTicks, s = e.yAxisTicks, c = e.offset, u = a.props.tooltipType, d = rr(a.props.children, Nr), h = be(t.dataKey) ? a.props.dataKey : t.dataKey, A = be(r.dataKey) ? a.props.dataKey : r.dataKey, p = n && n.dataKey, m = n ? n.range : al.defaultProps.range, g = m && m[0], v = t.scale.bandwidth ? t.scale.bandwidth() : 0, C = r.scale.bandwidth ? r.scale.bandwidth() : 0, y = i.map(function(w, O) {
    var b = vt(w, h), D = vt(w, A), M = !be(p) && vt(w, p) || "-", j = [{
      name: be(t.dataKey) ? a.props.name : t.name || t.dataKey,
      unit: t.unit || "",
      value: b,
      payload: w,
      dataKey: h,
      type: u
    }, {
      name: be(r.dataKey) ? a.props.name : r.name || r.dataKey,
      unit: r.unit || "",
      value: D,
      payload: w,
      dataKey: A,
      type: u
    }];
    M !== "-" && j.push({
      name: n.name || n.dataKey,
      unit: n.unit || "",
      value: M,
      payload: w,
      dataKey: p,
      type: u
    });
    var P = i2({
      axis: t,
      ticks: o,
      bandSize: v,
      entry: w,
      index: O,
      dataKey: h
    }), H = i2({
      axis: r,
      ticks: s,
      bandSize: C,
      entry: w,
      index: O,
      dataKey: A
    }), F = M !== "-" ? n.scale(M) : g, R = Math.sqrt(Math.max(F, 0) / Math.PI);
    return Dr(Dr({}, w), {}, {
      cx: P,
      cy: H,
      x: P - R,
      y: H - R,
      xAxis: t,
      yAxis: r,
      zAxis: n,
      width: 2 * R,
      height: 2 * R,
      size: F,
      node: {
        x: b,
        y: D,
        z: M
      },
      tooltipPayload: j,
      tooltipPosition: {
        x: P,
        y: H
      },
      payload: w
    }, d && d[O] && d[O].props);
  });
  return Dr({
    points: y
  }, c);
});
function w2(e) {
  "@babel/helpers - typeof";
  return w2 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, w2(e);
}
function sle(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function gg(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, mO(n.key), n);
  }
}
function lle(e, t, r) {
  return t && gg(e.prototype, t), r && gg(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function cle(e, t, r) {
  return t = l0(t), ule(e, vO() ? Reflect.construct(t, r || [], l0(e).constructor) : t.apply(e, r));
}
function ule(e, t) {
  if (t && (w2(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return fle(e);
}
function fle(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function vO() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (vO = function() {
    return !!e;
  })();
}
function l0(e) {
  return l0 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, l0(e);
}
function dle(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && p7(e, t);
}
function p7(e, t) {
  return p7 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, a) {
    return n.__proto__ = a, n;
  }, p7(e, t);
}
function gO(e, t, r) {
  return t = mO(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function mO(e) {
  var t = hle(e, "string");
  return w2(t) == "symbol" ? t : t + "";
}
function hle(e, t) {
  if (w2(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (w2(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function v7() {
  return v7 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, v7.apply(this, arguments);
}
function Ale(e) {
  var t = e.xAxisId, r = n8(), n = a8(), a = Ux(t);
  return a == null ? null : (
    // @ts-expect-error the axisOptions type is not exactly what CartesianAxis is expecting.
    /* @__PURE__ */ Sr.createElement(k2, v7({}, a, {
      className: Pe("recharts-".concat(a.axisType, " ").concat(a.axisType), a.className),
      viewBox: {
        x: 0,
        y: 0,
        width: r,
        height: n
      },
      ticksGenerator: function(o) {
        return wn(o, !0);
      }
    }))
  );
}
var f1 = /* @__PURE__ */ function(e) {
  function t() {
    return sle(this, t), cle(this, t, arguments);
  }
  return dle(t, e), lle(t, [{
    key: "render",
    value: function() {
      return /* @__PURE__ */ Sr.createElement(Ale, this.props);
    }
  }]);
}(Sr.Component);
gO(f1, "displayName", "XAxis");
gO(f1, "defaultProps", {
  allowDecimals: !0,
  hide: !1,
  orientation: "bottom",
  width: 0,
  height: 30,
  mirror: !1,
  xAxisId: 0,
  tickCount: 5,
  type: "category",
  padding: {
    left: 0,
    right: 0
  },
  allowDataOverflow: !1,
  scale: "auto",
  reversed: !1,
  allowDuplicatedCategory: !0
});
function x2(e) {
  "@babel/helpers - typeof";
  return x2 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, x2(e);
}
function ple(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function mg(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, yO(n.key), n);
  }
}
function vle(e, t, r) {
  return t && mg(e.prototype, t), r && mg(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function gle(e, t, r) {
  return t = c0(t), mle(e, CO() ? Reflect.construct(t, r || [], c0(e).constructor) : t.apply(e, r));
}
function mle(e, t) {
  if (t && (x2(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return Cle(e);
}
function Cle(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function CO() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (CO = function() {
    return !!e;
  })();
}
function c0(e) {
  return c0 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, c0(e);
}
function ble(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && g7(e, t);
}
function g7(e, t) {
  return g7 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, a) {
    return n.__proto__ = a, n;
  }, g7(e, t);
}
function bO(e, t, r) {
  return t = yO(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function yO(e) {
  var t = yle(e, "string");
  return x2(t) == "symbol" ? t : t + "";
}
function yle(e, t) {
  if (x2(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (x2(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function m7() {
  return m7 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, m7.apply(this, arguments);
}
var wle = function(t) {
  var r = t.yAxisId, n = n8(), a = a8(), i = Zx(r);
  return i == null ? null : (
    // @ts-expect-error the axisOptions type is not exactly what CartesianAxis is expecting.
    /* @__PURE__ */ Sr.createElement(k2, m7({}, i, {
      className: Pe("recharts-".concat(i.axisType, " ").concat(i.axisType), i.className),
      viewBox: {
        x: 0,
        y: 0,
        width: n,
        height: a
      },
      ticksGenerator: function(s) {
        return wn(s, !0);
      }
    }))
  );
}, ua = /* @__PURE__ */ function(e) {
  function t() {
    return ple(this, t), gle(this, t, arguments);
  }
  return ble(t, e), vle(t, [{
    key: "render",
    value: function() {
      return /* @__PURE__ */ Sr.createElement(wle, this.props);
    }
  }]);
}(Sr.Component);
bO(ua, "displayName", "YAxis");
bO(ua, "defaultProps", {
  allowDuplicatedCategory: !0,
  allowDecimals: !0,
  hide: !1,
  orientation: "left",
  width: 60,
  height: 0,
  mirror: !1,
  yAxisId: 0,
  tickCount: 5,
  type: "number",
  padding: {
    top: 0,
    bottom: 0
  },
  allowDataOverflow: !1,
  scale: "auto",
  reversed: !1
});
function Cg(e) {
  return Mle(e) || Dle(e) || Ole(e) || xle();
}
function xle() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Ole(e, t) {
  if (e) {
    if (typeof e == "string")
      return C7(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return C7(e, t);
  }
}
function Dle(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null)
    return Array.from(e);
}
function Mle(e) {
  if (Array.isArray(e))
    return C7(e);
}
function C7(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
var b7 = function(t, r, n, a, i) {
  var o = rr(t, o8), s = rr(t, el), c = [].concat(Cg(o), Cg(s)), u = rr(t, rl), d = "".concat(a, "Id"), h = a[0], A = r;
  if (c.length && (A = c.reduce(function(g, v) {
    if (v.props[d] === n && ln(v.props, "extendDomain") && se(v.props[h])) {
      var C = v.props[h];
      return [Math.min(g[0], C), Math.max(g[1], C)];
    }
    return g;
  }, A)), u.length) {
    var p = "".concat(h, "1"), m = "".concat(h, "2");
    A = u.reduce(function(g, v) {
      if (v.props[d] === n && ln(v.props, "extendDomain") && se(v.props[p]) && se(v.props[m])) {
        var C = v.props[p], y = v.props[m];
        return [Math.min(g[0], C, y), Math.max(g[1], C, y)];
      }
      return g;
    }, A);
  }
  return i && i.length && (A = i.reduce(function(g, v) {
    return se(v) ? [Math.min(g[0], v), Math.max(g[1], v)] : g;
  }, A)), A;
}, wO = { exports: {} };
(function(e) {
  var t = Object.prototype.hasOwnProperty, r = "~";
  function n() {
  }
  Object.create && (n.prototype = /* @__PURE__ */ Object.create(null), new n().__proto__ || (r = !1));
  function a(c, u, d) {
    this.fn = c, this.context = u, this.once = d || !1;
  }
  function i(c, u, d, h, A) {
    if (typeof d != "function")
      throw new TypeError("The listener must be a function");
    var p = new a(d, h || c, A), m = r ? r + u : u;
    return c._events[m] ? c._events[m].fn ? c._events[m] = [c._events[m], p] : c._events[m].push(p) : (c._events[m] = p, c._eventsCount++), c;
  }
  function o(c, u) {
    --c._eventsCount === 0 ? c._events = new n() : delete c._events[u];
  }
  function s() {
    this._events = new n(), this._eventsCount = 0;
  }
  s.prototype.eventNames = function() {
    var u = [], d, h;
    if (this._eventsCount === 0)
      return u;
    for (h in d = this._events)
      t.call(d, h) && u.push(r ? h.slice(1) : h);
    return Object.getOwnPropertySymbols ? u.concat(Object.getOwnPropertySymbols(d)) : u;
  }, s.prototype.listeners = function(u) {
    var d = r ? r + u : u, h = this._events[d];
    if (!h)
      return [];
    if (h.fn)
      return [h.fn];
    for (var A = 0, p = h.length, m = new Array(p); A < p; A++)
      m[A] = h[A].fn;
    return m;
  }, s.prototype.listenerCount = function(u) {
    var d = r ? r + u : u, h = this._events[d];
    return h ? h.fn ? 1 : h.length : 0;
  }, s.prototype.emit = function(u, d, h, A, p, m) {
    var g = r ? r + u : u;
    if (!this._events[g])
      return !1;
    var v = this._events[g], C = arguments.length, y, w;
    if (v.fn) {
      switch (v.once && this.removeListener(u, v.fn, void 0, !0), C) {
        case 1:
          return v.fn.call(v.context), !0;
        case 2:
          return v.fn.call(v.context, d), !0;
        case 3:
          return v.fn.call(v.context, d, h), !0;
        case 4:
          return v.fn.call(v.context, d, h, A), !0;
        case 5:
          return v.fn.call(v.context, d, h, A, p), !0;
        case 6:
          return v.fn.call(v.context, d, h, A, p, m), !0;
      }
      for (w = 1, y = new Array(C - 1); w < C; w++)
        y[w - 1] = arguments[w];
      v.fn.apply(v.context, y);
    } else {
      var O = v.length, b;
      for (w = 0; w < O; w++)
        switch (v[w].once && this.removeListener(u, v[w].fn, void 0, !0), C) {
          case 1:
            v[w].fn.call(v[w].context);
            break;
          case 2:
            v[w].fn.call(v[w].context, d);
            break;
          case 3:
            v[w].fn.call(v[w].context, d, h);
            break;
          case 4:
            v[w].fn.call(v[w].context, d, h, A);
            break;
          default:
            if (!y)
              for (b = 1, y = new Array(C - 1); b < C; b++)
                y[b - 1] = arguments[b];
            v[w].fn.apply(v[w].context, y);
        }
    }
    return !0;
  }, s.prototype.on = function(u, d, h) {
    return i(this, u, d, h, !1);
  }, s.prototype.once = function(u, d, h) {
    return i(this, u, d, h, !0);
  }, s.prototype.removeListener = function(u, d, h, A) {
    var p = r ? r + u : u;
    if (!this._events[p])
      return this;
    if (!d)
      return o(this, p), this;
    var m = this._events[p];
    if (m.fn)
      m.fn === d && (!A || m.once) && (!h || m.context === h) && o(this, p);
    else {
      for (var g = 0, v = [], C = m.length; g < C; g++)
        (m[g].fn !== d || A && !m[g].once || h && m[g].context !== h) && v.push(m[g]);
      v.length ? this._events[p] = v.length === 1 ? v[0] : v : o(this, p);
    }
    return this;
  }, s.prototype.removeAllListeners = function(u) {
    var d;
    return u ? (d = r ? r + u : u, this._events[d] && o(this, d)) : (this._events = new n(), this._eventsCount = 0), this;
  }, s.prototype.off = s.prototype.removeListener, s.prototype.addListener = s.prototype.on, s.prefixed = r, s.EventEmitter = s, e.exports = s;
})(wO);
var Ele = wO.exports;
const Ple = /* @__PURE__ */ qe(Ele);
var f4 = new Ple(), d4 = "recharts.syncMouseEvents";
function Fo(e) {
  "@babel/helpers - typeof";
  return Fo = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Fo(e);
}
function jle(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function bg(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, xO(n.key), n);
  }
}
function Sle(e, t, r) {
  return t && bg(e.prototype, t), r && bg(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function h4(e, t, r) {
  return t = xO(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function xO(e) {
  var t = Ile(e, "string");
  return Fo(t) == "symbol" ? t : t + "";
}
function Ile(e, t) {
  if (Fo(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (Fo(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var Ble = /* @__PURE__ */ function() {
  function e() {
    jle(this, e), h4(this, "activeIndex", 0), h4(this, "coordinateList", []), h4(this, "layout", "horizontal");
  }
  return Sle(e, [{
    key: "setDetails",
    value: function(r) {
      var n, a = r.coordinateList, i = a === void 0 ? null : a, o = r.container, s = o === void 0 ? null : o, c = r.layout, u = c === void 0 ? null : c, d = r.offset, h = d === void 0 ? null : d, A = r.mouseHandlerCallback, p = A === void 0 ? null : A;
      this.coordinateList = (n = i ?? this.coordinateList) !== null && n !== void 0 ? n : [], this.container = s ?? this.container, this.layout = u ?? this.layout, this.offset = h ?? this.offset, this.mouseHandlerCallback = p ?? this.mouseHandlerCallback, this.activeIndex = Math.min(Math.max(this.activeIndex, 0), this.coordinateList.length - 1);
    }
  }, {
    key: "focus",
    value: function() {
      this.spoofMouse();
    }
  }, {
    key: "keyboardEvent",
    value: function(r) {
      if (this.coordinateList.length !== 0)
        switch (r.key) {
          case "ArrowRight": {
            if (this.layout !== "horizontal")
              return;
            this.activeIndex = Math.min(this.activeIndex + 1, this.coordinateList.length - 1), this.spoofMouse();
            break;
          }
          case "ArrowLeft": {
            if (this.layout !== "horizontal")
              return;
            this.activeIndex = Math.max(this.activeIndex - 1, 0), this.spoofMouse();
            break;
          }
        }
    }
  }, {
    key: "setIndex",
    value: function(r) {
      this.activeIndex = r;
    }
  }, {
    key: "spoofMouse",
    value: function() {
      var r, n;
      if (this.layout === "horizontal" && this.coordinateList.length !== 0) {
        var a = this.container.getBoundingClientRect(), i = a.x, o = a.y, s = a.height, c = this.coordinateList[this.activeIndex].coordinate, u = ((r = window) === null || r === void 0 ? void 0 : r.scrollX) || 0, d = ((n = window) === null || n === void 0 ? void 0 : n.scrollY) || 0, h = i + c + u, A = o + this.offset.top + s / 2 + d;
        this.mouseHandlerCallback({
          pageX: h,
          pageY: A
        });
      }
    }
  }]);
}();
function Nle(e, t, r) {
  if (r === "number" && t === !0 && Array.isArray(e)) {
    var n = e == null ? void 0 : e[0], a = e == null ? void 0 : e[1];
    if (n && a && se(n) && se(a))
      return !0;
  }
  return !1;
}
function _le(e, t, r, n) {
  var a = n / 2;
  return {
    stroke: "none",
    fill: "#ccc",
    x: e === "horizontal" ? t.x - a : r.left + 0.5,
    y: e === "horizontal" ? r.top + 0.5 : t.y - a,
    width: e === "horizontal" ? n : r.width - 1,
    height: e === "horizontal" ? r.height - 1 : n
  };
}
function OO(e) {
  var t = e.cx, r = e.cy, n = e.radius, a = e.startAngle, i = e.endAngle, o = ct(t, r, n, a), s = ct(t, r, n, i);
  return {
    points: [o, s],
    cx: t,
    cy: r,
    radius: n,
    startAngle: a,
    endAngle: i
  };
}
function Lle(e, t, r) {
  var n, a, i, o;
  if (e === "horizontal")
    n = t.x, i = n, a = r.top, o = r.top + r.height;
  else if (e === "vertical")
    a = t.y, o = a, n = r.left, i = r.left + r.width;
  else if (t.cx != null && t.cy != null)
    if (e === "centric") {
      var s = t.cx, c = t.cy, u = t.innerRadius, d = t.outerRadius, h = t.angle, A = ct(s, c, u, h), p = ct(s, c, d, h);
      n = A.x, a = A.y, i = p.x, o = p.y;
    } else
      return OO(t);
  return [{
    x: n,
    y: a
  }, {
    x: i,
    y: o
  }];
}
function Ho(e) {
  "@babel/helpers - typeof";
  return Ho = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Ho(e);
}
function yg(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function L3(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? yg(Object(r), !0).forEach(function(n) {
      Tle(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : yg(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function Tle(e, t, r) {
  return t = Rle(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function Rle(e) {
  var t = $le(e, "string");
  return Ho(t) == "symbol" ? t : t + "";
}
function $le(e, t) {
  if (Ho(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (Ho(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function Fle(e) {
  var t, r, n = e.element, a = e.tooltipEventType, i = e.isActive, o = e.activeCoordinate, s = e.activePayload, c = e.offset, u = e.activeTooltipIndex, d = e.tooltipAxisBandSize, h = e.layout, A = e.chartName, p = (t = n.props.cursor) !== null && t !== void 0 ? t : (r = n.type.defaultProps) === null || r === void 0 ? void 0 : r.cursor;
  if (!n || !p || !i || !o || A !== "ScatterChart" && a !== "axis")
    return null;
  var m, g = o1;
  if (A === "ScatterChart")
    m = o, g = L2e;
  else if (A === "BarChart")
    m = _le(h, o, c, d), g = J9;
  else if (h === "radial") {
    var v = OO(o), C = v.cx, y = v.cy, w = v.radius, O = v.startAngle, b = v.endAngle;
    m = {
      cx: C,
      cy: y,
      startAngle: O,
      endAngle: b,
      innerRadius: w,
      outerRadius: w
    }, g = Ax;
  } else
    m = {
      points: Lle(h, o, c)
    }, g = o1;
  var D = L3(L3(L3(L3({
    stroke: "#ccc",
    pointerEvents: "none"
  }, c), m), Ae(p, !1)), {}, {
    payload: s,
    payloadIndex: u,
    className: Pe("recharts-tooltip-cursor", p.className)
  });
  return /* @__PURE__ */ Vr(p) ? /* @__PURE__ */ Bt(p, D) : /* @__PURE__ */ cC(g, D);
}
var Hle = ["item"], Yle = ["children", "className", "width", "height", "style", "compact", "title", "desc"];
function O2(e) {
  "@babel/helpers - typeof";
  return O2 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, O2(e);
}
function Ya() {
  return Ya = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Ya.apply(this, arguments);
}
function wg(e, t) {
  return Gle(e) || kle(e, t) || MO(e, t) || Vle();
}
function Vle() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function kle(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, a, i, o, s = [], c = !0, u = !1;
    try {
      if (i = (r = r.call(e)).next, t === 0) {
        if (Object(r) !== r)
          return;
        c = !1;
      } else
        for (; !(c = (n = i.call(r)).done) && (s.push(n.value), s.length !== t); c = !0)
          ;
    } catch (d) {
      u = !0, a = d;
    } finally {
      try {
        if (!c && r.return != null && (o = r.return(), Object(o) !== o))
          return;
      } finally {
        if (u)
          throw a;
      }
    }
    return s;
  }
}
function Gle(e) {
  if (Array.isArray(e))
    return e;
}
function xg(e, t) {
  if (e == null)
    return {};
  var r = Wle(e, t), n, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (a = 0; a < i.length; a++)
      n = i[a], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function Wle(e, t) {
  if (e == null)
    return {};
  var r = {};
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      if (t.indexOf(n) >= 0)
        continue;
      r[n] = e[n];
    }
  return r;
}
function Qle(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Og(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, EO(n.key), n);
  }
}
function Ule(e, t, r) {
  return t && Og(e.prototype, t), r && Og(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function Zle(e, t, r) {
  return t = u0(t), zle(e, DO() ? Reflect.construct(t, r || [], u0(e).constructor) : t.apply(e, r));
}
function zle(e, t) {
  if (t && (O2(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return Kle(e);
}
function Kle(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function DO() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (DO = function() {
    return !!e;
  })();
}
function u0(e) {
  return u0 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, u0(e);
}
function qle(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && y7(e, t);
}
function y7(e, t) {
  return y7 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, a) {
    return n.__proto__ = a, n;
  }, y7(e, t);
}
function D2(e) {
  return ece(e) || Jle(e) || MO(e) || Xle();
}
function Xle() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function MO(e, t) {
  if (e) {
    if (typeof e == "string")
      return w7(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return w7(e, t);
  }
}
function Jle(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null)
    return Array.from(e);
}
function ece(e) {
  if (Array.isArray(e))
    return w7(e);
}
function w7(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
function Dg(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function re(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Dg(Object(r), !0).forEach(function(n) {
      Oe(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Dg(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function Oe(e, t, r) {
  return t = EO(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function EO(e) {
  var t = tce(e, "string");
  return O2(t) == "symbol" ? t : t + "";
}
function tce(e, t) {
  if (O2(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (O2(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var rce = {
  xAxis: ["bottom", "top"],
  yAxis: ["left", "right"]
}, nce = {
  width: "100%",
  height: "100%"
}, PO = {
  x: 0,
  y: 0
};
function T3(e) {
  return e;
}
var ace = function(t, r) {
  return r === "horizontal" ? t.x : r === "vertical" ? t.y : r === "centric" ? t.angle : t.radius;
}, ice = function(t, r, n, a) {
  var i = r.find(function(d) {
    return d && d.index === n;
  });
  if (i) {
    if (t === "horizontal")
      return {
        x: i.coordinate,
        y: a.y
      };
    if (t === "vertical")
      return {
        x: a.x,
        y: i.coordinate
      };
    if (t === "centric") {
      var o = i.coordinate, s = a.radius;
      return re(re(re({}, a), ct(a.cx, a.cy, s, o)), {}, {
        angle: o,
        radius: s
      });
    }
    var c = i.coordinate, u = a.angle;
    return re(re(re({}, a), ct(a.cx, a.cy, c, u)), {}, {
      angle: u,
      radius: c
    });
  }
  return PO;
}, ol = function(t, r) {
  var n = r.graphicalItems, a = r.dataStartIndex, i = r.dataEndIndex, o = (n ?? []).reduce(function(s, c) {
    var u = c.props.data;
    return u && u.length ? [].concat(D2(s), D2(u)) : s;
  }, []);
  return o.length > 0 ? o : t && t.length && se(a) && se(i) ? t.slice(a, i + 1) : [];
};
function jO(e) {
  return e === "number" ? [0, "auto"] : void 0;
}
var x7 = function(t, r, n, a) {
  var i = t.graphicalItems, o = t.tooltipAxis, s = ol(r, t);
  return n < 0 || !i || !i.length || n >= s.length ? null : i.reduce(function(c, u) {
    var d, h = (d = u.props.data) !== null && d !== void 0 ? d : r;
    h && t.dataStartIndex + t.dataEndIndex !== 0 && // https://github.com/recharts/recharts/issues/4717
    // The data is sliced only when the active index is within the start/end index range.
    t.dataEndIndex - t.dataStartIndex >= n && (h = h.slice(t.dataStartIndex, t.dataEndIndex + 1));
    var A;
    if (o.dataKey && !o.allowDuplicatedCategory) {
      var p = h === void 0 ? s : h;
      A = is(p, o.dataKey, a);
    } else
      A = h && h[n] || s[n];
    return A ? [].concat(D2(c), [lx(u, A)]) : c;
  }, []);
}, Mg = function(t, r, n, a) {
  var i = a || {
    x: t.chartX,
    y: t.chartY
  }, o = ace(i, n), s = t.orderedTooltipTicks, c = t.tooltipAxis, u = t.tooltipTicks, d = une(o, s, u, c);
  if (d >= 0 && u) {
    var h = u[d] && u[d].value, A = x7(t, r, d, h), p = ice(n, s, d, i);
    return {
      activeTooltipIndex: d,
      activeLabel: h,
      activePayload: A,
      activeCoordinate: p
    };
  }
  return null;
}, oce = function(t, r) {
  var n = r.axes, a = r.graphicalItems, i = r.axisType, o = r.axisIdKey, s = r.stackGroups, c = r.dataStartIndex, u = r.dataEndIndex, d = t.layout, h = t.children, A = t.stackOffset, p = rx(d, i);
  return n.reduce(function(m, g) {
    var v, C = g.type.defaultProps !== void 0 ? re(re({}, g.type.defaultProps), g.props) : g.props, y = C.type, w = C.dataKey, O = C.allowDataOverflow, b = C.allowDuplicatedCategory, D = C.scale, M = C.ticks, j = C.includeHidden, P = C[o];
    if (m[P])
      return m;
    var H = ol(t.data, {
      graphicalItems: a.filter(function(E) {
        var x, $ = o in E.props ? E.props[o] : (x = E.type.defaultProps) === null || x === void 0 ? void 0 : x[o];
        return $ === P;
      }),
      dataStartIndex: c,
      dataEndIndex: u
    }), F = H.length, R, N, z;
    Nle(C.domain, O, y) && (R = _5(C.domain, null, O), p && (y === "number" || D !== "auto") && (z = Wi(H, w, "category")));
    var q = jO(y);
    if (!R || R.length === 0) {
      var J, W = (J = C.domain) !== null && J !== void 0 ? J : q;
      if (w) {
        if (R = Wi(H, w, y), y === "category" && p) {
          var te = rV(R);
          b && te ? (N = R, R = Us(0, F)) : b || (R = Lp(W, R, g).reduce(function(E, x) {
            return E.indexOf(x) >= 0 ? E : [].concat(D2(E), [x]);
          }, []));
        } else if (y === "category")
          b ? R = R.filter(function(E) {
            return E !== "" && !be(E);
          }) : R = Lp(W, R, g).reduce(function(E, x) {
            return E.indexOf(x) >= 0 || x === "" || be(x) ? E : [].concat(D2(E), [x]);
          }, []);
        else if (y === "number") {
          var S = pne(H, a.filter(function(E) {
            var x, $, _ = o in E.props ? E.props[o] : (x = E.type.defaultProps) === null || x === void 0 ? void 0 : x[o], Q = "hide" in E.props ? E.props.hide : ($ = E.type.defaultProps) === null || $ === void 0 ? void 0 : $.hide;
            return _ === P && (j || !Q);
          }), w, i, d);
          S && (R = S);
        }
        p && (y === "number" || D !== "auto") && (z = Wi(H, w, "category"));
      } else
        p ? R = Us(0, F) : s && s[P] && s[P].hasStack && y === "number" ? R = A === "expand" ? [0, 1] : sx(s[P].stackGroups, c, u) : R = tx(H, a.filter(function(E) {
          var x = o in E.props ? E.props[o] : E.type.defaultProps[o], $ = "hide" in E.props ? E.props.hide : E.type.defaultProps.hide;
          return x === P && (j || !$);
        }), y, d, !0);
      if (y === "number")
        R = b7(h, R, P, i, M), W && (R = _5(W, R, O));
      else if (y === "category" && W) {
        var I = W, T = R.every(function(E) {
          return I.indexOf(E) >= 0;
        });
        T && (R = I);
      }
    }
    return re(re({}, m), {}, Oe({}, P, re(re({}, C), {}, {
      axisType: i,
      domain: R,
      categoricalDomain: z,
      duplicateDomain: N,
      originalDomain: (v = C.domain) !== null && v !== void 0 ? v : q,
      isCategorical: p,
      layout: d
    })));
  }, {});
}, sce = function(t, r) {
  var n = r.graphicalItems, a = r.Axis, i = r.axisType, o = r.axisIdKey, s = r.stackGroups, c = r.dataStartIndex, u = r.dataEndIndex, d = t.layout, h = t.children, A = ol(t.data, {
    graphicalItems: n,
    dataStartIndex: c,
    dataEndIndex: u
  }), p = A.length, m = rx(d, i), g = -1;
  return n.reduce(function(v, C) {
    var y = C.type.defaultProps !== void 0 ? re(re({}, C.type.defaultProps), C.props) : C.props, w = y[o], O = jO("number");
    if (!v[w]) {
      g++;
      var b;
      return m ? b = Us(0, p) : s && s[w] && s[w].hasStack ? (b = sx(s[w].stackGroups, c, u), b = b7(h, b, w, i)) : (b = _5(O, tx(A, n.filter(function(D) {
        var M, j, P = o in D.props ? D.props[o] : (M = D.type.defaultProps) === null || M === void 0 ? void 0 : M[o], H = "hide" in D.props ? D.props.hide : (j = D.type.defaultProps) === null || j === void 0 ? void 0 : j.hide;
        return P === w && !H;
      }), "number", d), a.defaultProps.allowDataOverflow), b = b7(h, b, w, i)), re(re({}, v), {}, Oe({}, w, re(re({
        axisType: i
      }, a.defaultProps), {}, {
        hide: !0,
        orientation: mr(rce, "".concat(i, ".").concat(g % 2), null),
        domain: b,
        originalDomain: O,
        isCategorical: m,
        layout: d
        // specify scale when no Axis
        // scale: isCategorical ? 'band' : 'linear',
      })));
    }
    return v;
  }, {});
}, lce = function(t, r) {
  var n = r.axisType, a = n === void 0 ? "xAxis" : n, i = r.AxisComp, o = r.graphicalItems, s = r.stackGroups, c = r.dataStartIndex, u = r.dataEndIndex, d = t.children, h = "".concat(a, "Id"), A = rr(d, i), p = {};
  return A && A.length ? p = oce(t, {
    axes: A,
    graphicalItems: o,
    axisType: a,
    axisIdKey: h,
    stackGroups: s,
    dataStartIndex: c,
    dataEndIndex: u
  }) : o && o.length && (p = sce(t, {
    Axis: i,
    graphicalItems: o,
    axisType: a,
    axisIdKey: h,
    stackGroups: s,
    dataStartIndex: c,
    dataEndIndex: u
  })), p;
}, cce = function(t) {
  var r = qn(t), n = wn(r, !1, !0);
  return {
    tooltipTicks: n,
    orderedTooltipTicks: M9(n, function(a) {
      return a.coordinate;
    }),
    tooltipAxis: r,
    tooltipAxisBandSize: Ns(r, n)
  };
}, Eg = function(t) {
  var r = t.children, n = t.defaultShowTooltip, a = hr(r, f2), i = 0, o = 0;
  return t.data && t.data.length !== 0 && (o = t.data.length - 1), a && a.props && (a.props.startIndex >= 0 && (i = a.props.startIndex), a.props.endIndex >= 0 && (o = a.props.endIndex)), {
    chartX: 0,
    chartY: 0,
    dataStartIndex: i,
    dataEndIndex: o,
    activeTooltipIndex: -1,
    isTooltipActive: !!n
  };
}, uce = function(t) {
  return !t || !t.length ? !1 : t.some(function(r) {
    var n = On(r && r.type);
    return n && n.indexOf("Bar") >= 0;
  });
}, Pg = function(t) {
  return t === "horizontal" ? {
    numericAxisName: "yAxis",
    cateAxisName: "xAxis"
  } : t === "vertical" ? {
    numericAxisName: "xAxis",
    cateAxisName: "yAxis"
  } : t === "centric" ? {
    numericAxisName: "radiusAxis",
    cateAxisName: "angleAxis"
  } : {
    numericAxisName: "angleAxis",
    cateAxisName: "radiusAxis"
  };
}, fce = function(t, r) {
  var n = t.props, a = t.graphicalItems, i = t.xAxisMap, o = i === void 0 ? {} : i, s = t.yAxisMap, c = s === void 0 ? {} : s, u = n.width, d = n.height, h = n.children, A = n.margin || {}, p = hr(h, f2), m = hr(h, Dn), g = Object.keys(c).reduce(function(b, D) {
    var M = c[D], j = M.orientation;
    return !M.mirror && !M.hide ? re(re({}, b), {}, Oe({}, j, b[j] + M.width)) : b;
  }, {
    left: A.left || 0,
    right: A.right || 0
  }), v = Object.keys(o).reduce(function(b, D) {
    var M = o[D], j = M.orientation;
    return !M.mirror && !M.hide ? re(re({}, b), {}, Oe({}, j, mr(b, "".concat(j)) + M.height)) : b;
  }, {
    top: A.top || 0,
    bottom: A.bottom || 0
  }), C = re(re({}, v), g), y = C.bottom;
  p && (C.bottom += p.props.height || f2.defaultProps.height), m && r && (C = hne(C, a, n, r));
  var w = u - C.left - C.right, O = d - C.top - C.bottom;
  return re(re({
    brushBottom: y
  }, C), {}, {
    // never return negative values for height and width
    width: Math.max(w, 0),
    height: Math.max(O, 0)
  });
}, dce = function(t, r) {
  if (r === "xAxis")
    return t[r].width;
  if (r === "yAxis")
    return t[r].height;
}, c8 = function(t) {
  var r = t.chartName, n = t.GraphicalChild, a = t.defaultTooltipEventType, i = a === void 0 ? "axis" : a, o = t.validateTooltipEventTypes, s = o === void 0 ? ["axis"] : o, c = t.axisComponents, u = t.legendContent, d = t.formatAxisMap, h = t.defaultProps, A = function(C, y) {
    var w = y.graphicalItems, O = y.stackGroups, b = y.offset, D = y.updateId, M = y.dataStartIndex, j = y.dataEndIndex, P = C.barSize, H = C.layout, F = C.barGap, R = C.barCategoryGap, N = C.maxBarSize, z = Pg(H), q = z.numericAxisName, J = z.cateAxisName, W = uce(w), te = [];
    return w.forEach(function(S, I) {
      var T = ol(C.data, {
        graphicalItems: [S],
        dataStartIndex: M,
        dataEndIndex: j
      }), E = S.type.defaultProps !== void 0 ? re(re({}, S.type.defaultProps), S.props) : S.props, x = E.dataKey, $ = E.maxBarSize, _ = E["".concat(q, "Id")], Q = E["".concat(J, "Id")], Z = {}, X = c.reduce(function(Ne, je) {
        var $e, ft, yt = y["".concat(je.axisType, "Map")], sr = E["".concat(je.axisType, "Id")];
        yt && yt[sr] || je.axisType === "zAxis" || (process.env.NODE_ENV !== "production" ? Zt(!1, "Specifying a(n) ".concat(je.axisType, "Id requires a corresponding ").concat(
          je.axisType,
          "Id on the targeted graphical component "
        ).concat(($e = S == null || (ft = S.type) === null || ft === void 0 ? void 0 : ft.displayName) !== null && $e !== void 0 ? $e : "")) : Zt(!1));
        var zt = yt[sr];
        return re(re({}, Ne), {}, Oe(Oe({}, je.axisType, zt), "".concat(je.axisType, "Ticks"), wn(zt)));
      }, Z), Y = X[J], U = X["".concat(J, "Ticks")], k = O && O[_] && O[_].hasStack && One(S, O[_].stackGroups), L = On(S.type).indexOf("Bar") >= 0, ee = Ns(Y, U), V = [], ne = W && fne({
        barSize: P,
        stackGroups: O,
        totalSize: dce(X, J)
      });
      if (L) {
        var ie, le, de = be($) ? N : $, ve = (ie = (le = Ns(Y, U, !0)) !== null && le !== void 0 ? le : de) !== null && ie !== void 0 ? ie : 0;
        V = dne({
          barGap: F,
          barCategoryGap: R,
          bandSize: ve !== ee ? ve : ee,
          sizeList: ne[Q],
          maxBarSize: de
        }), ve !== ee && (V = V.map(function(Ne) {
          return re(re({}, Ne), {}, {
            position: re(re({}, Ne.position), {}, {
              offset: Ne.position.offset - ve / 2
            })
          });
        }));
      }
      var Ee = S && S.type && S.type.getComposedData;
      Ee && te.push({
        props: re(re({}, Ee(re(re({}, X), {}, {
          displayedData: T,
          props: C,
          dataKey: x,
          item: S,
          bandSize: ee,
          barPosition: V,
          offset: b,
          stackedData: k,
          layout: H,
          dataStartIndex: M,
          dataEndIndex: j
        }))), {}, Oe(Oe(Oe({
          key: S.key || "item-".concat(I)
        }, q, X[q]), J, X[J]), "animationId", D)),
        childIndex: pV(S, C.children),
        item: S
      });
    }), te;
  }, p = function(C, y) {
    var w = C.props, O = C.dataStartIndex, b = C.dataEndIndex, D = C.updateId;
    if (!Dh({
      props: w
    }))
      return null;
    var M = w.children, j = w.layout, P = w.stackOffset, H = w.data, F = w.reverseStackOrder, R = Pg(j), N = R.numericAxisName, z = R.cateAxisName, q = rr(M, n), J = wne(H, q, "".concat(N, "Id"), "".concat(z, "Id"), P, F), W = c.reduce(function(E, x) {
      var $ = "".concat(x.axisType, "Map");
      return re(re({}, E), {}, Oe({}, $, lce(w, re(re({}, x), {}, {
        graphicalItems: q,
        stackGroups: x.axisType === N && J,
        dataStartIndex: O,
        dataEndIndex: b
      }))));
    }, {}), te = fce(re(re({}, W), {}, {
      props: w,
      graphicalItems: q
    }), y == null ? void 0 : y.legendBBox);
    Object.keys(W).forEach(function(E) {
      W[E] = d(w, W[E], te, E.replace("Map", ""), r);
    });
    var S = W["".concat(z, "Map")], I = cce(S), T = A(w, re(re({}, W), {}, {
      dataStartIndex: O,
      dataEndIndex: b,
      updateId: D,
      graphicalItems: q,
      stackGroups: J,
      offset: te
    }));
    return re(re({
      formattedGraphicalItems: T,
      graphicalItems: q,
      offset: te,
      stackGroups: J
    }, I), W);
  }, m = /* @__PURE__ */ function(v) {
    function C(y) {
      var w, O, b;
      return Qle(this, C), b = Zle(this, C, [y]), Oe(b, "eventEmitterSymbol", Symbol("rechartsEventEmitter")), Oe(b, "accessibilityManager", new Ble()), Oe(b, "handleLegendBBoxUpdate", function(D) {
        if (D) {
          var M = b.state, j = M.dataStartIndex, P = M.dataEndIndex, H = M.updateId;
          b.setState(re({
            legendBBox: D
          }, p({
            props: b.props,
            dataStartIndex: j,
            dataEndIndex: P,
            updateId: H
          }, re(re({}, b.state), {}, {
            legendBBox: D
          }))));
        }
      }), Oe(b, "handleReceiveSyncEvent", function(D, M, j) {
        if (b.props.syncId === D) {
          if (j === b.eventEmitterSymbol && typeof b.props.syncMethod != "function")
            return;
          b.applySyncEvent(M);
        }
      }), Oe(b, "handleBrushChange", function(D) {
        var M = D.startIndex, j = D.endIndex;
        if (M !== b.state.dataStartIndex || j !== b.state.dataEndIndex) {
          var P = b.state.updateId;
          b.setState(function() {
            return re({
              dataStartIndex: M,
              dataEndIndex: j
            }, p({
              props: b.props,
              dataStartIndex: M,
              dataEndIndex: j,
              updateId: P
            }, b.state));
          }), b.triggerSyncEvent({
            dataStartIndex: M,
            dataEndIndex: j
          });
        }
      }), Oe(b, "handleMouseEnter", function(D) {
        var M = b.getMouseInfo(D);
        if (M) {
          var j = re(re({}, M), {}, {
            isTooltipActive: !0
          });
          b.setState(j), b.triggerSyncEvent(j);
          var P = b.props.onMouseEnter;
          ye(P) && P(j, D);
        }
      }), Oe(b, "triggeredAfterMouseMove", function(D) {
        var M = b.getMouseInfo(D), j = M ? re(re({}, M), {}, {
          isTooltipActive: !0
        }) : {
          isTooltipActive: !1
        };
        b.setState(j), b.triggerSyncEvent(j);
        var P = b.props.onMouseMove;
        ye(P) && P(j, D);
      }), Oe(b, "handleItemMouseEnter", function(D) {
        b.setState(function() {
          return {
            isTooltipActive: !0,
            activeItem: D,
            activePayload: D.tooltipPayload,
            activeCoordinate: D.tooltipPosition || {
              x: D.cx,
              y: D.cy
            }
          };
        });
      }), Oe(b, "handleItemMouseLeave", function() {
        b.setState(function() {
          return {
            isTooltipActive: !1
          };
        });
      }), Oe(b, "handleMouseMove", function(D) {
        D.persist(), b.throttleTriggeredAfterMouseMove(D);
      }), Oe(b, "handleMouseLeave", function(D) {
        b.throttleTriggeredAfterMouseMove.cancel();
        var M = {
          isTooltipActive: !1
        };
        b.setState(M), b.triggerSyncEvent(M);
        var j = b.props.onMouseLeave;
        ye(j) && j(M, D);
      }), Oe(b, "handleOuterEvent", function(D) {
        var M = AV(D), j = mr(b.props, "".concat(M));
        if (M && ye(j)) {
          var P, H;
          /.*touch.*/i.test(M) ? H = b.getMouseInfo(D.changedTouches[0]) : H = b.getMouseInfo(D), j((P = H) !== null && P !== void 0 ? P : {}, D);
        }
      }), Oe(b, "handleClick", function(D) {
        var M = b.getMouseInfo(D);
        if (M) {
          var j = re(re({}, M), {}, {
            isTooltipActive: !0
          });
          b.setState(j), b.triggerSyncEvent(j);
          var P = b.props.onClick;
          ye(P) && P(j, D);
        }
      }), Oe(b, "handleMouseDown", function(D) {
        var M = b.props.onMouseDown;
        if (ye(M)) {
          var j = b.getMouseInfo(D);
          M(j, D);
        }
      }), Oe(b, "handleMouseUp", function(D) {
        var M = b.props.onMouseUp;
        if (ye(M)) {
          var j = b.getMouseInfo(D);
          M(j, D);
        }
      }), Oe(b, "handleTouchMove", function(D) {
        D.changedTouches != null && D.changedTouches.length > 0 && b.throttleTriggeredAfterMouseMove(D.changedTouches[0]);
      }), Oe(b, "handleTouchStart", function(D) {
        D.changedTouches != null && D.changedTouches.length > 0 && b.handleMouseDown(D.changedTouches[0]);
      }), Oe(b, "handleTouchEnd", function(D) {
        D.changedTouches != null && D.changedTouches.length > 0 && b.handleMouseUp(D.changedTouches[0]);
      }), Oe(b, "handleDoubleClick", function(D) {
        var M = b.props.onDoubleClick;
        if (ye(M)) {
          var j = b.getMouseInfo(D);
          M(j, D);
        }
      }), Oe(b, "handleContextMenu", function(D) {
        var M = b.props.onContextMenu;
        if (ye(M)) {
          var j = b.getMouseInfo(D);
          M(j, D);
        }
      }), Oe(b, "triggerSyncEvent", function(D) {
        b.props.syncId !== void 0 && f4.emit(d4, b.props.syncId, D, b.eventEmitterSymbol);
      }), Oe(b, "applySyncEvent", function(D) {
        var M = b.props, j = M.layout, P = M.syncMethod, H = b.state.updateId, F = D.dataStartIndex, R = D.dataEndIndex;
        if (D.dataStartIndex !== void 0 || D.dataEndIndex !== void 0)
          b.setState(re({
            dataStartIndex: F,
            dataEndIndex: R
          }, p({
            props: b.props,
            dataStartIndex: F,
            dataEndIndex: R,
            updateId: H
          }, b.state)));
        else if (D.activeTooltipIndex !== void 0) {
          var N = D.chartX, z = D.chartY, q = D.activeTooltipIndex, J = b.state, W = J.offset, te = J.tooltipTicks;
          if (!W)
            return;
          if (typeof P == "function")
            q = P(te, D);
          else if (P === "value") {
            q = -1;
            for (var S = 0; S < te.length; S++)
              if (te[S].value === D.activeLabel) {
                q = S;
                break;
              }
          }
          var I = re(re({}, W), {}, {
            x: W.left,
            y: W.top
          }), T = Math.min(N, I.x + I.width), E = Math.min(z, I.y + I.height), x = te[q] && te[q].value, $ = x7(b.state, b.props.data, q), _ = te[q] ? {
            x: j === "horizontal" ? te[q].coordinate : T,
            y: j === "horizontal" ? E : te[q].coordinate
          } : PO;
          b.setState(re(re({}, D), {}, {
            activeLabel: x,
            activeCoordinate: _,
            activePayload: $,
            activeTooltipIndex: q
          }));
        } else
          b.setState(D);
      }), Oe(b, "renderCursor", function(D) {
        var M, j = b.state, P = j.isTooltipActive, H = j.activeCoordinate, F = j.activePayload, R = j.offset, N = j.activeTooltipIndex, z = j.tooltipAxisBandSize, q = b.getTooltipEventType(), J = (M = D.props.active) !== null && M !== void 0 ? M : P, W = b.props.layout, te = D.key || "_recharts-cursor";
        return /* @__PURE__ */ B.createElement(Fle, {
          key: te,
          activeCoordinate: H,
          activePayload: F,
          activeTooltipIndex: N,
          chartName: r,
          element: D,
          isActive: J,
          layout: W,
          offset: R,
          tooltipAxisBandSize: z,
          tooltipEventType: q
        });
      }), Oe(b, "renderPolarAxis", function(D, M, j) {
        var P = mr(D, "type.axisType"), H = mr(b.state, "".concat(P, "Map")), F = D.type.defaultProps, R = F !== void 0 ? re(re({}, F), D.props) : D.props, N = H && H[R["".concat(P, "Id")]];
        return /* @__PURE__ */ Bt(D, re(re({}, N), {}, {
          className: Pe(P, N.className),
          key: D.key || "".concat(M, "-").concat(j),
          ticks: wn(N, !0)
        }));
      }), Oe(b, "renderPolarGrid", function(D) {
        var M = D.props, j = M.radialLines, P = M.polarAngles, H = M.polarRadius, F = b.state, R = F.radiusAxisMap, N = F.angleAxisMap, z = qn(R), q = qn(N), J = q.cx, W = q.cy, te = q.innerRadius, S = q.outerRadius;
        return /* @__PURE__ */ Bt(D, {
          polarAngles: Array.isArray(P) ? P : wn(q, !0).map(function(I) {
            return I.coordinate;
          }),
          polarRadius: Array.isArray(H) ? H : wn(z, !0).map(function(I) {
            return I.coordinate;
          }),
          cx: J,
          cy: W,
          innerRadius: te,
          outerRadius: S,
          key: D.key || "polar-grid",
          radialLines: j
        });
      }), Oe(b, "renderLegend", function() {
        var D = b.state.formattedGraphicalItems, M = b.props, j = M.children, P = M.width, H = M.height, F = b.props.margin || {}, R = P - (F.left || 0) - (F.right || 0), N = Jw({
          children: j,
          formattedGraphicalItems: D,
          legendWidth: R,
          legendContent: u
        });
        if (!N)
          return null;
        var z = N.item, q = xg(N, Hle);
        return /* @__PURE__ */ Bt(z, re(re({}, q), {}, {
          chartWidth: P,
          chartHeight: H,
          margin: F,
          onBBoxUpdate: b.handleLegendBBoxUpdate
        }));
      }), Oe(b, "renderTooltip", function() {
        var D, M = b.props, j = M.children, P = M.accessibilityLayer, H = hr(j, Xt);
        if (!H)
          return null;
        var F = b.state, R = F.isTooltipActive, N = F.activeCoordinate, z = F.activePayload, q = F.activeLabel, J = F.offset, W = (D = H.props.active) !== null && D !== void 0 ? D : R;
        return /* @__PURE__ */ Bt(H, {
          viewBox: re(re({}, J), {}, {
            x: J.left,
            y: J.top
          }),
          active: W,
          label: q,
          payload: W ? z : [],
          coordinate: N,
          accessibilityLayer: P
        });
      }), Oe(b, "renderBrush", function(D) {
        var M = b.props, j = M.margin, P = M.data, H = b.state, F = H.offset, R = H.dataStartIndex, N = H.dataEndIndex, z = H.updateId;
        return /* @__PURE__ */ Bt(D, {
          key: D.key || "_recharts-brush",
          onChange: I3(b.handleBrushChange, D.props.onChange),
          data: P,
          x: se(D.props.x) ? D.props.x : F.left,
          y: se(D.props.y) ? D.props.y : F.top + F.height + F.brushBottom - (j.bottom || 0),
          width: se(D.props.width) ? D.props.width : F.width,
          startIndex: R,
          endIndex: N,
          updateId: "brush-".concat(z)
        });
      }), Oe(b, "renderReferenceElement", function(D, M, j) {
        if (!D)
          return null;
        var P = b, H = P.clipPathId, F = b.state, R = F.xAxisMap, N = F.yAxisMap, z = F.offset, q = D.type.defaultProps || {}, J = D.props, W = J.xAxisId, te = W === void 0 ? q.xAxisId : W, S = J.yAxisId, I = S === void 0 ? q.yAxisId : S;
        return /* @__PURE__ */ Bt(D, {
          key: D.key || "".concat(M, "-").concat(j),
          xAxis: R[te],
          yAxis: N[I],
          viewBox: {
            x: z.left,
            y: z.top,
            width: z.width,
            height: z.height
          },
          clipPathId: H
        });
      }), Oe(b, "renderActivePoints", function(D) {
        var M = D.item, j = D.activePoint, P = D.basePoint, H = D.childIndex, F = D.isRange, R = [], N = M.props.key, z = M.item.type.defaultProps !== void 0 ? re(re({}, M.item.type.defaultProps), M.item.props) : M.item.props, q = z.activeDot, J = z.dataKey, W = re(re({
          index: H,
          dataKey: J,
          cx: j.x,
          cy: j.y,
          r: 4,
          fill: X9(M.item),
          strokeWidth: 2,
          stroke: "#fff",
          payload: j.payload,
          value: j.value
        }, Ae(q, !1)), os(q));
        return R.push(C.renderActiveDot(q, W, "".concat(N, "-activePoint-").concat(H))), P ? R.push(C.renderActiveDot(q, re(re({}, W), {}, {
          cx: P.x,
          cy: P.y
        }), "".concat(N, "-basePoint-").concat(H))) : F && R.push(null), R;
      }), Oe(b, "renderGraphicChild", function(D, M, j) {
        var P = b.filterFormatItem(D, M, j);
        if (!P)
          return null;
        var H = b.getTooltipEventType(), F = b.state, R = F.isTooltipActive, N = F.tooltipAxis, z = F.activeTooltipIndex, q = F.activeLabel, J = b.props.children, W = hr(J, Xt), te = P.props, S = te.points, I = te.isRange, T = te.baseLine, E = P.item.type.defaultProps !== void 0 ? re(re({}, P.item.type.defaultProps), P.item.props) : P.item.props, x = E.activeDot, $ = E.hide, _ = E.activeBar, Q = E.activeShape, Z = !!(!$ && R && W && (x || _ || Q)), X = {};
        H !== "axis" && W && W.props.trigger === "click" ? X = {
          onClick: I3(b.handleItemMouseEnter, D.props.onClick)
        } : H !== "axis" && (X = {
          onMouseLeave: I3(b.handleItemMouseLeave, D.props.onMouseLeave),
          onMouseEnter: I3(b.handleItemMouseEnter, D.props.onMouseEnter)
        });
        var Y = /* @__PURE__ */ Bt(D, re(re({}, P.props), X));
        function U(je) {
          return typeof N.dataKey == "function" ? N.dataKey(je.payload) : null;
        }
        if (Z)
          if (z >= 0) {
            var k, L;
            if (N.dataKey && !N.allowDuplicatedCategory) {
              var ee = typeof N.dataKey == "function" ? U : "payload.".concat(N.dataKey.toString());
              k = is(S, ee, q), L = I && T && is(T, ee, q);
            } else
              k = S == null ? void 0 : S[z], L = I && T && T[z];
            if (Q || _) {
              var V = D.props.activeIndex !== void 0 ? D.props.activeIndex : z;
              return [/* @__PURE__ */ Bt(D, re(re(re({}, P.props), X), {}, {
                activeIndex: V
              })), null, null];
            }
            if (!be(k))
              return [Y].concat(D2(b.renderActivePoints({
                item: P,
                activePoint: k,
                basePoint: L,
                childIndex: z,
                isRange: I
              })));
          } else {
            var ne, ie = (ne = b.getItemByXY(b.state.activeCoordinate)) !== null && ne !== void 0 ? ne : {
              graphicalItem: Y
            }, le = ie.graphicalItem, de = le.item, ve = de === void 0 ? D : de, Ee = le.childIndex, Ne = re(re(re({}, P.props), X), {}, {
              activeIndex: Ee
            });
            return [/* @__PURE__ */ Bt(ve, Ne), null, null];
          }
        return I ? [Y, null, null] : [Y, null];
      }), Oe(b, "renderCustomized", function(D, M, j) {
        return /* @__PURE__ */ Bt(D, re(re({
          key: "recharts-customized-".concat(j)
        }, b.props), b.state));
      }), Oe(b, "renderMap", {
        CartesianGrid: {
          handler: T3,
          once: !0
        },
        ReferenceArea: {
          handler: b.renderReferenceElement
        },
        ReferenceLine: {
          handler: T3
        },
        ReferenceDot: {
          handler: b.renderReferenceElement
        },
        XAxis: {
          handler: T3
        },
        YAxis: {
          handler: T3
        },
        Brush: {
          handler: b.renderBrush,
          once: !0
        },
        Bar: {
          handler: b.renderGraphicChild
        },
        Line: {
          handler: b.renderGraphicChild
        },
        Area: {
          handler: b.renderGraphicChild
        },
        Radar: {
          handler: b.renderGraphicChild
        },
        RadialBar: {
          handler: b.renderGraphicChild
        },
        Scatter: {
          handler: b.renderGraphicChild
        },
        Pie: {
          handler: b.renderGraphicChild
        },
        Funnel: {
          handler: b.renderGraphicChild
        },
        Tooltip: {
          handler: b.renderCursor,
          once: !0
        },
        PolarGrid: {
          handler: b.renderPolarGrid,
          once: !0
        },
        PolarAngleAxis: {
          handler: b.renderPolarAxis
        },
        PolarRadiusAxis: {
          handler: b.renderPolarAxis
        },
        Customized: {
          handler: b.renderCustomized
        }
      }), b.clipPathId = "".concat((w = y.id) !== null && w !== void 0 ? w : g1("recharts"), "-clip"), b.throttleTriggeredAfterMouseMove = Xy(b.triggeredAfterMouseMove, (O = y.throttleDelay) !== null && O !== void 0 ? O : 1e3 / 60), b.state = {}, b;
    }
    return qle(C, v), Ule(C, [{
      key: "componentDidMount",
      value: function() {
        var w, O;
        this.addListener(), this.accessibilityManager.setDetails({
          container: this.container,
          offset: {
            left: (w = this.props.margin.left) !== null && w !== void 0 ? w : 0,
            top: (O = this.props.margin.top) !== null && O !== void 0 ? O : 0
          },
          coordinateList: this.state.tooltipTicks,
          mouseHandlerCallback: this.triggeredAfterMouseMove,
          layout: this.props.layout
        }), this.displayDefaultTooltip();
      }
    }, {
      key: "displayDefaultTooltip",
      value: function() {
        var w = this.props, O = w.children, b = w.data, D = w.height, M = w.layout, j = hr(O, Xt);
        if (j) {
          var P = j.props.defaultIndex;
          if (!(typeof P != "number" || P < 0 || P > this.state.tooltipTicks.length - 1)) {
            var H = this.state.tooltipTicks[P] && this.state.tooltipTicks[P].value, F = x7(this.state, b, P, H), R = this.state.tooltipTicks[P].coordinate, N = (this.state.offset.top + D) / 2, z = M === "horizontal", q = z ? {
              x: R,
              y: N
            } : {
              y: R,
              x: N
            }, J = this.state.formattedGraphicalItems.find(function(te) {
              var S = te.item;
              return S.type.name === "Scatter";
            });
            J && (q = re(re({}, q), J.props.points[P].tooltipPosition), F = J.props.points[P].tooltipPayload);
            var W = {
              activeTooltipIndex: P,
              isTooltipActive: !0,
              activeLabel: H,
              activePayload: F,
              activeCoordinate: q
            };
            this.setState(W), this.renderCursor(j), this.accessibilityManager.setIndex(P);
          }
        }
      }
    }, {
      key: "getSnapshotBeforeUpdate",
      value: function(w, O) {
        if (!this.props.accessibilityLayer)
          return null;
        if (this.state.tooltipTicks !== O.tooltipTicks && this.accessibilityManager.setDetails({
          coordinateList: this.state.tooltipTicks
        }), this.props.layout !== w.layout && this.accessibilityManager.setDetails({
          layout: this.props.layout
        }), this.props.margin !== w.margin) {
          var b, D;
          this.accessibilityManager.setDetails({
            offset: {
              left: (b = this.props.margin.left) !== null && b !== void 0 ? b : 0,
              top: (D = this.props.margin.top) !== null && D !== void 0 ? D : 0
            }
          });
        }
        return null;
      }
    }, {
      key: "componentDidUpdate",
      value: function(w) {
        z4([hr(w.children, Xt)], [hr(this.props.children, Xt)]) || this.displayDefaultTooltip();
      }
    }, {
      key: "componentWillUnmount",
      value: function() {
        this.removeListener(), this.throttleTriggeredAfterMouseMove.cancel();
      }
    }, {
      key: "getTooltipEventType",
      value: function() {
        var w = hr(this.props.children, Xt);
        if (w && typeof w.props.shared == "boolean") {
          var O = w.props.shared ? "axis" : "item";
          return s.indexOf(O) >= 0 ? O : i;
        }
        return i;
      }
      /**
       * Get the information of mouse in chart, return null when the mouse is not in the chart
       * @param  {MousePointer} event    The event object
       * @return {Object}          Mouse data
       */
    }, {
      key: "getMouseInfo",
      value: function(w) {
        if (!this.container)
          return null;
        var O = this.container, b = O.getBoundingClientRect(), D = FX(b), M = {
          chartX: Math.round(w.pageX - D.left),
          chartY: Math.round(w.pageY - D.top)
        }, j = b.width / O.offsetWidth || 1, P = this.inRange(M.chartX, M.chartY, j);
        if (!P)
          return null;
        var H = this.state, F = H.xAxisMap, R = H.yAxisMap, N = this.getTooltipEventType(), z = Mg(this.state, this.props.data, this.props.layout, P);
        if (N !== "axis" && F && R) {
          var q = qn(F).scale, J = qn(R).scale, W = q && q.invert ? q.invert(M.chartX) : null, te = J && J.invert ? J.invert(M.chartY) : null;
          return re(re({}, M), {}, {
            xValue: W,
            yValue: te
          }, z);
        }
        return z ? re(re({}, M), z) : null;
      }
    }, {
      key: "inRange",
      value: function(w, O) {
        var b = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1, D = this.props.layout, M = w / b, j = O / b;
        if (D === "horizontal" || D === "vertical") {
          var P = this.state.offset, H = M >= P.left && M <= P.left + P.width && j >= P.top && j <= P.top + P.height;
          return H ? {
            x: M,
            y: j
          } : null;
        }
        var F = this.state, R = F.angleAxisMap, N = F.radiusAxisMap;
        if (R && N) {
          var z = qn(R);
          return $p({
            x: M,
            y: j
          }, z);
        }
        return null;
      }
    }, {
      key: "parseEventsOfWrapper",
      value: function() {
        var w = this.props.children, O = this.getTooltipEventType(), b = hr(w, Xt), D = {};
        b && O === "axis" && (b.props.trigger === "click" ? D = {
          onClick: this.handleClick
        } : D = {
          onMouseEnter: this.handleMouseEnter,
          onDoubleClick: this.handleDoubleClick,
          onMouseMove: this.handleMouseMove,
          onMouseLeave: this.handleMouseLeave,
          onTouchMove: this.handleTouchMove,
          onTouchStart: this.handleTouchStart,
          onTouchEnd: this.handleTouchEnd,
          onContextMenu: this.handleContextMenu
        });
        var M = os(this.props, this.handleOuterEvent);
        return re(re({}, M), D);
      }
    }, {
      key: "addListener",
      value: function() {
        f4.on(d4, this.handleReceiveSyncEvent);
      }
    }, {
      key: "removeListener",
      value: function() {
        f4.removeListener(d4, this.handleReceiveSyncEvent);
      }
    }, {
      key: "filterFormatItem",
      value: function(w, O, b) {
        for (var D = this.state.formattedGraphicalItems, M = 0, j = D.length; M < j; M++) {
          var P = D[M];
          if (P.item === w || P.props.key === w.key || O === On(P.item.type) && b === P.childIndex)
            return P;
        }
        return null;
      }
    }, {
      key: "renderClipPath",
      value: function() {
        var w = this.clipPathId, O = this.state.offset, b = O.left, D = O.top, M = O.height, j = O.width;
        return /* @__PURE__ */ B.createElement("defs", null, /* @__PURE__ */ B.createElement("clipPath", {
          id: w
        }, /* @__PURE__ */ B.createElement("rect", {
          x: b,
          y: D,
          height: M,
          width: j
        })));
      }
    }, {
      key: "getXScales",
      value: function() {
        var w = this.state.xAxisMap;
        return w ? Object.entries(w).reduce(function(O, b) {
          var D = wg(b, 2), M = D[0], j = D[1];
          return re(re({}, O), {}, Oe({}, M, j.scale));
        }, {}) : null;
      }
    }, {
      key: "getYScales",
      value: function() {
        var w = this.state.yAxisMap;
        return w ? Object.entries(w).reduce(function(O, b) {
          var D = wg(b, 2), M = D[0], j = D[1];
          return re(re({}, O), {}, Oe({}, M, j.scale));
        }, {}) : null;
      }
    }, {
      key: "getXScaleByAxisId",
      value: function(w) {
        var O;
        return (O = this.state.xAxisMap) === null || O === void 0 || (O = O[w]) === null || O === void 0 ? void 0 : O.scale;
      }
    }, {
      key: "getYScaleByAxisId",
      value: function(w) {
        var O;
        return (O = this.state.yAxisMap) === null || O === void 0 || (O = O[w]) === null || O === void 0 ? void 0 : O.scale;
      }
    }, {
      key: "getItemByXY",
      value: function(w) {
        var O = this.state, b = O.formattedGraphicalItems, D = O.activeItem;
        if (b && b.length)
          for (var M = 0, j = b.length; M < j; M++) {
            var P = b[M], H = P.props, F = P.item, R = F.type.defaultProps !== void 0 ? re(re({}, F.type.defaultProps), F.props) : F.props, N = On(F.type);
            if (N === "Bar") {
              var z = (H.data || []).find(function(te) {
                return p2e(w, te);
              });
              if (z)
                return {
                  graphicalItem: P,
                  payload: z
                };
            } else if (N === "RadialBar") {
              var q = (H.data || []).find(function(te) {
                return $p(w, te);
              });
              if (q)
                return {
                  graphicalItem: P,
                  payload: q
                };
            } else if (K0(P, D) || q0(P, D) || Lo(P, D)) {
              var J = noe({
                graphicalItem: P,
                activeTooltipItem: D,
                itemData: R.data
              }), W = R.activeIndex === void 0 ? J : R.activeIndex;
              return {
                graphicalItem: re(re({}, P), {}, {
                  childIndex: W
                }),
                payload: Lo(P, D) ? R.data[J] : P.props.data[J]
              };
            }
          }
        return null;
      }
    }, {
      key: "render",
      value: function() {
        var w = this;
        if (!Dh(this))
          return null;
        var O = this.props, b = O.children, D = O.className, M = O.width, j = O.height, P = O.style, H = O.compact, F = O.title, R = O.desc, N = xg(O, Yle), z = Ae(N, !1);
        if (H)
          return /* @__PURE__ */ B.createElement(Uv, {
            state: this.state,
            width: this.props.width,
            height: this.props.height,
            clipPathId: this.clipPathId
          }, /* @__PURE__ */ B.createElement(q4, Ya({}, z, {
            width: M,
            height: j,
            title: F,
            desc: R
          }), this.renderClipPath(), Eh(b, this.renderMap)));
        if (this.props.accessibilityLayer) {
          var q, J;
          z.tabIndex = (q = this.props.tabIndex) !== null && q !== void 0 ? q : 0, z.role = (J = this.props.role) !== null && J !== void 0 ? J : "application", z.onKeyDown = function(te) {
            w.accessibilityManager.keyboardEvent(te);
          }, z.onFocus = function() {
            w.accessibilityManager.focus();
          };
        }
        var W = this.parseEventsOfWrapper();
        return /* @__PURE__ */ B.createElement(Uv, {
          state: this.state,
          width: this.props.width,
          height: this.props.height,
          clipPathId: this.clipPathId
        }, /* @__PURE__ */ B.createElement("div", Ya({
          className: Pe("recharts-wrapper", D),
          style: re({
            position: "relative",
            cursor: "default",
            width: M,
            height: j
          }, P)
        }, W, {
          ref: function(S) {
            w.container = S;
          }
        }), /* @__PURE__ */ B.createElement(q4, Ya({}, z, {
          width: M,
          height: j,
          title: F,
          desc: R,
          style: nce
        }), this.renderClipPath(), Eh(b, this.renderMap)), this.renderLegend(), this.renderTooltip()));
      }
    }]);
  }(uC);
  Oe(m, "displayName", r), Oe(m, "defaultProps", re({
    layout: "horizontal",
    stackOffset: "none",
    barCategoryGap: "10%",
    barGap: 4,
    margin: {
      top: 5,
      right: 5,
      bottom: 5,
      left: 5
    },
    reverseStackOrder: !1,
    syncMethod: "index"
  }, h)), Oe(m, "getDerivedStateFromProps", function(v, C) {
    var y = v.dataKey, w = v.data, O = v.children, b = v.width, D = v.height, M = v.layout, j = v.stackOffset, P = v.margin, H = C.dataStartIndex, F = C.dataEndIndex;
    if (C.updateId === void 0) {
      var R = Eg(v);
      return re(re(re({}, R), {}, {
        updateId: 0
      }, p(re(re({
        props: v
      }, R), {}, {
        updateId: 0
      }), C)), {}, {
        prevDataKey: y,
        prevData: w,
        prevWidth: b,
        prevHeight: D,
        prevLayout: M,
        prevStackOffset: j,
        prevMargin: P,
        prevChildren: O
      });
    }
    if (y !== C.prevDataKey || w !== C.prevData || b !== C.prevWidth || D !== C.prevHeight || M !== C.prevLayout || j !== C.prevStackOffset || !Va(P, C.prevMargin)) {
      var N = Eg(v), z = {
        // (chartX, chartY) are (0,0) in default state, but we want to keep the last mouse position to avoid
        // any flickering
        chartX: C.chartX,
        chartY: C.chartY,
        // The tooltip should stay active when it was active in the previous render. If this is not
        // the case, the tooltip disappears and immediately re-appears, causing a flickering effect
        isTooltipActive: C.isTooltipActive
      }, q = re(re({}, Mg(C, w, M)), {}, {
        updateId: C.updateId + 1
      }), J = re(re(re({}, N), z), q);
      return re(re(re({}, J), p(re({
        props: v
      }, J), C)), {}, {
        prevDataKey: y,
        prevData: w,
        prevWidth: b,
        prevHeight: D,
        prevLayout: M,
        prevStackOffset: j,
        prevMargin: P,
        prevChildren: O
      });
    }
    if (!z4(O, C.prevChildren)) {
      var W, te, S, I, T = hr(O, f2), E = T && (W = (te = T.props) === null || te === void 0 ? void 0 : te.startIndex) !== null && W !== void 0 ? W : H, x = T && (S = (I = T.props) === null || I === void 0 ? void 0 : I.endIndex) !== null && S !== void 0 ? S : F, $ = E !== H || x !== F, _ = !be(w), Q = _ && !$ ? C.updateId : C.updateId + 1;
      return re(re({
        updateId: Q
      }, p(re(re({
        props: v
      }, C), {}, {
        updateId: Q,
        dataStartIndex: E,
        dataEndIndex: x
      }), C)), {}, {
        prevChildren: O,
        dataStartIndex: E,
        dataEndIndex: x
      });
    }
    return null;
  }), Oe(m, "renderActiveDot", function(v, C, y) {
    var w;
    return /* @__PURE__ */ Vr(v) ? w = /* @__PURE__ */ Bt(v, C) : ye(v) ? w = v(C) : w = /* @__PURE__ */ B.createElement(e3, C), /* @__PURE__ */ B.createElement(Se, {
      className: "recharts-active-dot",
      key: y
    }, w);
  });
  var g = /* @__PURE__ */ lC(function(C, y) {
    return /* @__PURE__ */ B.createElement(m, Ya({}, C, {
      ref: y
    }));
  });
  return g.displayName = m.displayName, g;
}, SO = c8({
  chartName: "BarChart",
  GraphicalChild: Lr,
  defaultTooltipEventType: "axis",
  validateTooltipEventTypes: ["axis", "item"],
  axisComponents: [{
    axisType: "xAxis",
    AxisComp: f1
  }, {
    axisType: "yAxis",
    AxisComp: ua
  }],
  formatAxisMap: $x
}), u8 = c8({
  chartName: "PieChart",
  GraphicalChild: zr,
  validateTooltipEventTypes: ["item"],
  defaultTooltipEventType: "item",
  legendContent: "children",
  axisComponents: [{
    axisType: "angleAxis",
    AxisComp: z0
  }, {
    axisType: "radiusAxis",
    AxisComp: U0
  }],
  formatAxisMap: _ne,
  defaultProps: {
    layout: "centric",
    startAngle: 0,
    endAngle: 360,
    cx: "50%",
    cy: "50%",
    innerRadius: 0,
    outerRadius: "80%"
  }
}), hce = c8({
  chartName: "ComposedChart",
  GraphicalChild: [t3, ca, Lr, il],
  axisComponents: [{
    axisType: "xAxis",
    AxisComp: f1
  }, {
    axisType: "yAxis",
    AxisComp: ua
  }, {
    axisType: "zAxis",
    AxisComp: al
  }],
  formatAxisMap: $x
});
const Ace = B.forwardRef((e, t) => {
  const {
    data: r,
    onClickCellChart: n,
    onClickIconCard: a,
    chartColors: i,
    labelOne: o,
    labelTwo: s,
    percentageMessage: c,
    hiddenCenter: u,
    ...d
  } = e;
  if (r == null || o == null)
    return null;
  const h = (v) => () => {
    n !== void 0 && n({ data: v });
  }, A = i.map((v) => gt[v.colorCellChart]), p = i.map((v) => v.iconColor), m = {
    gridTemplateColumns: "4fr 6fr"
  }, g = ({
    labelTop: v,
    labelBottom: C
  }) => /* @__PURE__ */ f.jsxs("g", { children: [
    /* @__PURE__ */ f.jsx(
      "text",
      {
        x: "50%",
        y: "50%",
        textAnchor: "middle",
        dominantBaseline: "middle",
        fontSize: 30,
        fontWeight: "700",
        fill: "#292929",
        children: v
      }
    ),
    /* @__PURE__ */ f.jsx(
      "text",
      {
        x: "50%",
        y: "60%",
        textAnchor: "middle",
        dominantBaseline: "middle",
        fontSize: 14,
        fontWeight: "400",
        fill: "#292929",
        children: C
      }
    )
  ] });
  return /* @__PURE__ */ f.jsx(
    "section",
    {
      ref: t,
      className: "flex justify-center items-center",
      ...d,
      children: /* @__PURE__ */ f.jsxs(
        "div",
        {
          className: "w-full max-w-[1260px] flex flex-col gap-4 2s:grid 2s:gap-1 relative",
          style: m,
          children: [
            /* @__PURE__ */ f.jsx($2, { width: "100%", height: 300, children: /* @__PURE__ */ f.jsxs(u8, { children: [
              /* @__PURE__ */ f.jsxs(
                zr,
                {
                  dataKey: "value",
                  data: r,
                  innerRadius: u ? "0%" : "55%",
                  outerRadius: "100%",
                  cursor: "pointer",
                  children: [
                    /* @__PURE__ */ f.jsx(
                      Et,
                      {
                        content: /* @__PURE__ */ f.jsx(
                          g,
                          {
                            labelTop: o ?? "",
                            labelBottom: s ?? ""
                          }
                        ),
                        position: "center"
                      }
                    ),
                    r.map((v, C) => /* @__PURE__ */ f.jsx(
                      Nr,
                      {
                        fill: A[C % A.length],
                        onClick: h(v)
                      },
                      `cell-${C}`
                    ))
                  ]
                }
              ),
              /* @__PURE__ */ f.jsx(Xt, {})
            ] }) }),
            /* @__PURE__ */ f.jsxs("div", { className: " w-full mx-auto flex flex-col items-start justify-center", children: [
              /* @__PURE__ */ f.jsx("p", { className: "font-bold text-md", children: c }),
              r.map((v, C) => /* @__PURE__ */ f.jsx(i9, { gap: 4, spacing: 4, rounded: "md", children: /* @__PURE__ */ f.jsx(q3, { justifyContent: "between", children: /* @__PURE__ */ f.jsxs(q3, { gap: 4, children: [
                /* @__PURE__ */ f.jsx(
                  "div",
                  {
                    className: `w-3 h-3 rounded-full bg-${p[C % p.length]}`
                  }
                ),
                /* @__PURE__ */ f.jsx(kr, { variant: "title-3", children: v.name })
              ] }) }) }, C))
            ] })
          ]
        }
      )
    }
  );
});
Ace.displayName = "PieCharts";
var IO = {}, r3 = {}, n3 = {}, In = {}, BO = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
(function(e) {
  (function() {
    var t = {}.hasOwnProperty;
    function r() {
      for (var i = "", o = 0; o < arguments.length; o++) {
        var s = arguments[o];
        s && (i = a(i, n(s)));
      }
      return i;
    }
    function n(i) {
      if (typeof i == "string" || typeof i == "number")
        return i;
      if (typeof i != "object")
        return "";
      if (Array.isArray(i))
        return r.apply(null, i);
      if (i.toString !== Object.prototype.toString && !i.toString.toString().includes("[native code]"))
        return i.toString();
      var o = "";
      for (var s in i)
        t.call(i, s) && i[s] && (o = a(o, s));
      return o;
    }
    function a(i, o) {
      return o ? i ? i + " " + o : i + o : i;
    }
    e.exports ? (r.default = r, e.exports = r) : window.classNames = r;
  })();
})(BO);
var fa = BO.exports, y1 = {}, f8 = {}, hn = {}, me = {}, ce = {};
ce.secondsInYear = ce.secondsInWeek = ce.secondsInQuarter = ce.secondsInMonth = ce.secondsInMinute = ce.secondsInHour = ce.secondsInDay = ce.quartersInYear = ce.monthsInYear = ce.monthsInQuarter = ce.minutesInYear = ce.minutesInMonth = ce.minutesInHour = ce.minutesInDay = ce.minTime = ce.millisecondsInWeek = ce.millisecondsInSecond = ce.millisecondsInMinute = ce.millisecondsInHour = ce.millisecondsInDay = ce.maxTime = ce.daysInYear = ce.daysInWeek = ce.constructFromSymbol = void 0;
ce.daysInWeek = 7;
const pce = ce.daysInYear = 365.2425, vce = ce.maxTime = Math.pow(10, 8) * 24 * 60 * 60 * 1e3;
ce.minTime = -vce;
ce.millisecondsInWeek = 6048e5;
ce.millisecondsInDay = 864e5;
ce.millisecondsInMinute = 6e4;
ce.millisecondsInHour = 36e5;
ce.millisecondsInSecond = 1e3;
ce.minutesInYear = 525600;
ce.minutesInMonth = 43200;
ce.minutesInDay = 1440;
ce.minutesInHour = 60;
ce.monthsInQuarter = 3;
ce.monthsInYear = 12;
ce.quartersInYear = 4;
const gce = ce.secondsInHour = 3600;
ce.secondsInMinute = 60;
const NO = ce.secondsInDay = gce * 24;
ce.secondsInWeek = NO * 7;
const mce = ce.secondsInYear = NO * pce, Cce = ce.secondsInMonth = mce / 12;
ce.secondsInQuarter = Cce * 3;
ce.constructFromSymbol = Symbol.for("constructDateFrom");
me.constructFrom = bce;
var jg = ce;
function bce(e, t) {
  return typeof e == "function" ? e(t) : e && typeof e == "object" && jg.constructFromSymbol in e ? e[jg.constructFromSymbol](t) : e instanceof Date ? new e.constructor(t) : new Date(t);
}
var ae = {};
ae.toDate = wce;
var yce = me;
function wce(e, t) {
  return (0, yce.constructFrom)(t || e, e);
}
hn.addDays = Dce;
var xce = me, Oce = ae;
function Dce(e, t, r) {
  const n = (0, Oce.toDate)(e, r == null ? void 0 : r.in);
  return isNaN(t) ? (0, xce.constructFrom)((r == null ? void 0 : r.in) || e, NaN) : (t && n.setDate(n.getDate() + t), n);
}
var G2 = {};
G2.addMonths = Ece;
var Sg = me, Mce = ae;
function Ece(e, t, r) {
  const n = (0, Mce.toDate)(e, r == null ? void 0 : r.in);
  if (isNaN(t))
    return (0, Sg.constructFrom)((r == null ? void 0 : r.in) || e, NaN);
  if (!t)
    return n;
  const a = n.getDate(), i = (0, Sg.constructFrom)(
    (r == null ? void 0 : r.in) || e,
    n.getTime()
  );
  i.setMonth(n.getMonth() + t + 1, 0);
  const o = i.getDate();
  return a >= o ? i : (n.setFullYear(
    i.getFullYear(),
    i.getMonth(),
    a
  ), n);
}
f8.add = Bce;
var Pce = hn, jce = G2, Sce = me, Ice = ae;
function Bce(e, t, r) {
  const {
    years: n = 0,
    months: a = 0,
    weeks: i = 0,
    days: o = 0,
    hours: s = 0,
    minutes: c = 0,
    seconds: u = 0
  } = t, d = (0, Ice.toDate)(e, r == null ? void 0 : r.in), h = a || n ? (0, jce.addMonths)(d, a + n * 12) : d, A = o || i ? (0, Pce.addDays)(h, o + i * 7) : h, p = c + s * 60, g = (u + p * 60) * 1e3;
  return (0, Sce.constructFrom)(
    (r == null ? void 0 : r.in) || e,
    +A + g
  );
}
var d8 = {}, h8 = {};
h8.isSaturday = _ce;
var Nce = ae;
function _ce(e, t) {
  return (0, Nce.toDate)(e, t == null ? void 0 : t.in).getDay() === 6;
}
var A8 = {};
A8.isSunday = Tce;
var Lce = ae;
function Tce(e, t) {
  return (0, Lce.toDate)(e, t == null ? void 0 : t.in).getDay() === 0;
}
var a3 = {};
a3.isWeekend = $ce;
var Rce = ae;
function $ce(e, t) {
  const r = (0, Rce.toDate)(e, t == null ? void 0 : t.in).getDay();
  return r === 0 || r === 6;
}
d8.addBusinessDays = kce;
var Fce = me, Hce = h8, Yce = A8, A4 = a3, Vce = ae;
function kce(e, t, r) {
  const n = (0, Vce.toDate)(e, r == null ? void 0 : r.in), a = (0, A4.isWeekend)(n, r);
  if (isNaN(t))
    return (0, Fce.constructFrom)(r == null ? void 0 : r.in, NaN);
  const i = n.getHours(), o = t < 0 ? -1 : 1, s = Math.trunc(t / 5);
  n.setDate(n.getDate() + s * 7);
  let c = Math.abs(t % 5);
  for (; c > 0; )
    n.setDate(n.getDate() + o), (0, A4.isWeekend)(n, r) || (c -= 1);
  return a && (0, A4.isWeekend)(n, r) && t !== 0 && ((0, Hce.isSaturday)(n, r) && n.setDate(n.getDate() + (o < 0 ? 2 : -1)), (0, Yce.isSunday)(n, r) && n.setDate(n.getDate() + (o < 0 ? 1 : -2))), n.setHours(i), n;
}
var p8 = {}, i3 = {};
i3.addMilliseconds = Qce;
var Gce = me, Wce = ae;
function Qce(e, t, r) {
  return (0, Gce.constructFrom)(
    (r == null ? void 0 : r.in) || e,
    +(0, Wce.toDate)(e) + t
  );
}
p8.addHours = zce;
var Uce = i3, Zce = ce;
function zce(e, t, r) {
  return (0, Uce.addMilliseconds)(
    e,
    t * Zce.millisecondsInHour,
    r
  );
}
var v8 = {}, w1 = {}, An = {}, Kr = {}, Gt = {};
Gt.getDefaultOptions = Kce;
Gt.setDefaultOptions = qce;
let _O = {};
function Kce() {
  return _O;
}
function qce(e) {
  _O = e;
}
Kr.startOfWeek = eue;
var Xce = Gt, Jce = ae;
function eue(e, t) {
  var s, c, u, d;
  const r = (0, Xce.getDefaultOptions)(), n = (t == null ? void 0 : t.weekStartsOn) ?? ((c = (s = t == null ? void 0 : t.locale) == null ? void 0 : s.options) == null ? void 0 : c.weekStartsOn) ?? r.weekStartsOn ?? ((d = (u = r.locale) == null ? void 0 : u.options) == null ? void 0 : d.weekStartsOn) ?? 0, a = (0, Jce.toDate)(e, t == null ? void 0 : t.in), i = a.getDay(), o = (i < n ? 7 : 0) + i - n;
  return a.setDate(a.getDate() - o), a.setHours(0, 0, 0, 0), a;
}
An.startOfISOWeek = rue;
var tue = Kr;
function rue(e, t) {
  return (0, tue.startOfWeek)(e, { ...t, weekStartsOn: 1 });
}
w1.getISOWeekYear = aue;
var Ig = me, Bg = An, nue = ae;
function aue(e, t) {
  const r = (0, nue.toDate)(e, t == null ? void 0 : t.in), n = r.getFullYear(), a = (0, Ig.constructFrom)(r, 0);
  a.setFullYear(n + 1, 0, 4), a.setHours(0, 0, 0, 0);
  const i = (0, Bg.startOfISOWeek)(
    a
  ), o = (0, Ig.constructFrom)(r, 0);
  o.setFullYear(n, 0, 4), o.setHours(0, 0, 0, 0);
  const s = (0, Bg.startOfISOWeek)(
    o
  );
  return r.getTime() >= i.getTime() ? n + 1 : r.getTime() >= s.getTime() ? n : n - 1;
}
var g8 = {}, Ln = {}, Tn = {};
Tn.getTimezoneOffsetInMilliseconds = oue;
var iue = ae;
function oue(e) {
  const t = (0, iue.toDate)(e), r = new Date(
    Date.UTC(
      t.getFullYear(),
      t.getMonth(),
      t.getDate(),
      t.getHours(),
      t.getMinutes(),
      t.getSeconds(),
      t.getMilliseconds()
    )
  );
  return r.setUTCFullYear(t.getFullYear()), +e - +r;
}
var Je = {};
Je.normalizeDates = lue;
var sue = me;
function lue(e, ...t) {
  const r = sue.constructFrom.bind(
    null,
    e || t.find((n) => typeof n == "object")
  );
  return t.map(r);
}
var o3 = {};
o3.startOfDay = uue;
var cue = ae;
function uue(e, t) {
  const r = (0, cue.toDate)(e, t == null ? void 0 : t.in);
  return r.setHours(0, 0, 0, 0), r;
}
Ln.differenceInCalendarDays = hue;
var Ng = Tn, fue = Je, due = ce, _g = o3;
function hue(e, t, r) {
  const [n, a] = (0, fue.normalizeDates)(
    r == null ? void 0 : r.in,
    e,
    t
  ), i = (0, _g.startOfDay)(n), o = (0, _g.startOfDay)(a), s = +i - (0, Ng.getTimezoneOffsetInMilliseconds)(i), c = +o - (0, Ng.getTimezoneOffsetInMilliseconds)(o);
  return Math.round(
    (s - c) / due.millisecondsInDay
  );
}
var W2 = {};
W2.startOfISOWeekYear = gue;
var Aue = me, pue = w1, vue = An;
function gue(e, t) {
  const r = (0, pue.getISOWeekYear)(e, t), n = (0, Aue.constructFrom)((t == null ? void 0 : t.in) || e, 0);
  return n.setFullYear(r, 0, 4), n.setHours(0, 0, 0, 0), (0, vue.startOfISOWeek)(n);
}
g8.setISOWeekYear = yue;
var mue = me, Cue = Ln, Lg = W2, bue = ae;
function yue(e, t, r) {
  let n = (0, bue.toDate)(e, r == null ? void 0 : r.in);
  const a = (0, Cue.differenceInCalendarDays)(
    n,
    (0, Lg.startOfISOWeekYear)(n, r)
  ), i = (0, mue.constructFrom)((r == null ? void 0 : r.in) || e, 0);
  return i.setFullYear(t, 0, 4), i.setHours(0, 0, 0, 0), n = (0, Lg.startOfISOWeekYear)(i), n.setDate(n.getDate() + a), n;
}
v8.addISOWeekYears = Oue;
var wue = w1, xue = g8;
function Oue(e, t, r) {
  return (0, xue.setISOWeekYear)(
    e,
    (0, wue.getISOWeekYear)(e, r) + t,
    r
  );
}
var sl = {};
sl.addMinutes = Eue;
var Due = ce, Mue = ae;
function Eue(e, t, r) {
  const n = (0, Mue.toDate)(e, r == null ? void 0 : r.in);
  return n.setTime(n.getTime() + t * Due.millisecondsInMinute), n;
}
var ll = {};
ll.addQuarters = jue;
var Pue = G2;
function jue(e, t, r) {
  return (0, Pue.addMonths)(e, t * 3, r);
}
var m8 = {};
m8.addSeconds = Iue;
var Sue = i3;
function Iue(e, t, r) {
  return (0, Sue.addMilliseconds)(e, t * 1e3, r);
}
var s3 = {};
s3.addWeeks = Nue;
var Bue = hn;
function Nue(e, t, r) {
  return (0, Bue.addDays)(e, t * 7, r);
}
var C8 = {};
C8.addYears = Lue;
var _ue = G2;
function Lue(e, t, r) {
  return (0, _ue.addMonths)(e, t * 12, r);
}
var LO = {};
LO.areIntervalsOverlapping = Tue;
var R3 = ae;
function Tue(e, t, r) {
  const [n, a] = [
    +(0, R3.toDate)(e.start, r == null ? void 0 : r.in),
    +(0, R3.toDate)(e.end, r == null ? void 0 : r.in)
  ].sort((s, c) => s - c), [i, o] = [
    +(0, R3.toDate)(t.start, r == null ? void 0 : r.in),
    +(0, R3.toDate)(t.end, r == null ? void 0 : r.in)
  ].sort((s, c) => s - c);
  return r != null && r.inclusive ? n <= o && i <= a : n < o && i < a;
}
var TO = {}, b8 = {};
b8.max = $ue;
var Tg = me, Rue = ae;
function $ue(e, t) {
  let r, n = t == null ? void 0 : t.in;
  return e.forEach((a) => {
    !n && typeof a == "object" && (n = Tg.constructFrom.bind(null, a));
    const i = (0, Rue.toDate)(a, n);
    (!r || r < i || isNaN(+i)) && (r = i);
  }), (0, Tg.constructFrom)(n, r || NaN);
}
var y8 = {};
y8.min = Hue;
var Rg = me, Fue = ae;
function Hue(e, t) {
  let r, n = t == null ? void 0 : t.in;
  return e.forEach((a) => {
    !n && typeof a == "object" && (n = Rg.constructFrom.bind(null, a));
    const i = (0, Fue.toDate)(a, n);
    (!r || r > i || isNaN(+i)) && (r = i);
  }), (0, Rg.constructFrom)(n, r || NaN);
}
TO.clamp = Gue;
var Yue = Je, Vue = b8, kue = y8;
function Gue(e, t, r) {
  const [n, a, i] = (0, Yue.normalizeDates)(
    r == null ? void 0 : r.in,
    e,
    t.start,
    t.end
  );
  return (0, kue.min)(
    [(0, Vue.max)([n, a], r), i],
    r
  );
}
var w8 = {};
w8.closestIndexTo = Wue;
var $g = ae;
function Wue(e, t) {
  const r = +(0, $g.toDate)(e);
  if (isNaN(r))
    return NaN;
  let n, a;
  return t.forEach((i, o) => {
    const s = (0, $g.toDate)(i);
    if (isNaN(+s)) {
      n = NaN, a = NaN;
      return;
    }
    const c = Math.abs(r - +s);
    (n == null || c < a) && (n = o, a = c);
  }), n;
}
var RO = {};
RO.closestTo = zue;
var Que = Je, Uue = w8, Zue = me;
function zue(e, t, r) {
  const [n, ...a] = (0, Que.normalizeDates)(
    r == null ? void 0 : r.in,
    e,
    ...t
  ), i = (0, Uue.closestIndexTo)(n, a);
  if (typeof i == "number" && isNaN(i))
    return (0, Zue.constructFrom)(n, NaN);
  if (i !== void 0)
    return a[i];
}
var da = {};
da.compareAsc = Kue;
var Fg = ae;
function Kue(e, t) {
  const r = +(0, Fg.toDate)(e) - +(0, Fg.toDate)(t);
  return r < 0 ? -1 : r > 0 ? 1 : r;
}
var $O = {};
$O.compareDesc = que;
var Hg = ae;
function que(e, t) {
  const r = +(0, Hg.toDate)(e) - +(0, Hg.toDate)(t);
  return r > 0 ? -1 : r < 0 ? 1 : r;
}
var Tt = {};
Tt.constructNow = Jue;
var Xue = me;
function Jue(e) {
  return (0, Xue.constructFrom)(e, Date.now());
}
var FO = {};
FO.daysToWeeks = t6e;
var e6e = ce;
function t6e(e) {
  const t = Math.trunc(e / e6e.daysInWeek);
  return t === 0 ? 0 : t;
}
var HO = {}, Q2 = {};
Q2.isSameDay = n6e;
var r6e = Je, Yg = o3;
function n6e(e, t, r) {
  const [n, a] = (0, r6e.normalizeDates)(
    r == null ? void 0 : r.in,
    e,
    t
  );
  return +(0, Yg.startOfDay)(n) == +(0, Yg.startOfDay)(a);
}
var Rn = {}, x8 = {};
x8.isDate = a6e;
function a6e(e) {
  return e instanceof Date || typeof e == "object" && Object.prototype.toString.call(e) === "[object Date]";
}
Rn.isValid = s6e;
var i6e = x8, o6e = ae;
function s6e(e) {
  return !(!(0, i6e.isDate)(e) && typeof e != "number" || isNaN(+(0, o6e.toDate)(e)));
}
HO.differenceInBusinessDays = d6e;
var l6e = Je, Vg = hn, c6e = Ln, u6e = Q2, kg = Rn, f6e = a3;
function d6e(e, t, r) {
  const [n, a] = (0, l6e.normalizeDates)(
    r == null ? void 0 : r.in,
    e,
    t
  );
  if (!(0, kg.isValid)(n) || !(0, kg.isValid)(a))
    return NaN;
  const i = (0, c6e.differenceInCalendarDays)(n, a), o = i < 0 ? -1 : 1, s = Math.trunc(i / 7);
  let c = s * 5, u = (0, Vg.addDays)(a, s * 7);
  for (; !(0, u6e.isSameDay)(n, u); )
    c += (0, f6e.isWeekend)(u, r) ? 0 : o, u = (0, Vg.addDays)(u, o);
  return c === 0 ? 0 : c;
}
var O8 = {};
O8.differenceInCalendarISOWeekYears = A6e;
var h6e = Je, Gg = w1;
function A6e(e, t, r) {
  const [n, a] = (0, h6e.normalizeDates)(
    r == null ? void 0 : r.in,
    e,
    t
  );
  return (0, Gg.getISOWeekYear)(n, r) - (0, Gg.getISOWeekYear)(a, r);
}
var YO = {};
YO.differenceInCalendarISOWeeks = g6e;
var Wg = Tn, p6e = Je, v6e = ce, Qg = An;
function g6e(e, t, r) {
  const [n, a] = (0, p6e.normalizeDates)(
    r == null ? void 0 : r.in,
    e,
    t
  ), i = (0, Qg.startOfISOWeek)(n), o = (0, Qg.startOfISOWeek)(a), s = +i - (0, Wg.getTimezoneOffsetInMilliseconds)(i), c = +o - (0, Wg.getTimezoneOffsetInMilliseconds)(o);
  return Math.round(
    (s - c) / v6e.millisecondsInWeek
  );
}
var cl = {};
cl.differenceInCalendarMonths = C6e;
var m6e = Je;
function C6e(e, t, r) {
  const [n, a] = (0, m6e.normalizeDates)(
    r == null ? void 0 : r.in,
    e,
    t
  ), i = n.getFullYear() - a.getFullYear(), o = n.getMonth() - a.getMonth();
  return i * 12 + o;
}
var D8 = {}, M8 = {};
M8.getQuarter = y6e;
var b6e = ae;
function y6e(e, t) {
  const r = (0, b6e.toDate)(e, t == null ? void 0 : t.in);
  return Math.trunc(r.getMonth() / 3) + 1;
}
D8.differenceInCalendarQuarters = x6e;
var w6e = Je, Ug = M8;
function x6e(e, t, r) {
  const [n, a] = (0, w6e.normalizeDates)(
    r == null ? void 0 : r.in,
    e,
    t
  ), i = n.getFullYear() - a.getFullYear(), o = (0, Ug.getQuarter)(n) - (0, Ug.getQuarter)(a);
  return i * 4 + o;
}
var ul = {};
ul.differenceInCalendarWeeks = M6e;
var Zg = Tn, O6e = Je, D6e = ce, zg = Kr;
function M6e(e, t, r) {
  const [n, a] = (0, O6e.normalizeDates)(
    r == null ? void 0 : r.in,
    e,
    t
  ), i = (0, zg.startOfWeek)(n, r), o = (0, zg.startOfWeek)(a, r), s = +i - (0, Zg.getTimezoneOffsetInMilliseconds)(i), c = +o - (0, Zg.getTimezoneOffsetInMilliseconds)(o);
  return Math.round(
    (s - c) / D6e.millisecondsInWeek
  );
}
var fl = {};
fl.differenceInCalendarYears = P6e;
var E6e = Je;
function P6e(e, t, r) {
  const [n, a] = (0, E6e.normalizeDates)(
    r == null ? void 0 : r.in,
    e,
    t
  );
  return n.getFullYear() - a.getFullYear();
}
var dl = {};
dl.differenceInDays = I6e;
var j6e = Je, S6e = Ln;
function I6e(e, t, r) {
  const [n, a] = (0, j6e.normalizeDates)(
    r == null ? void 0 : r.in,
    e,
    t
  ), i = Kg(n, a), o = Math.abs(
    (0, S6e.differenceInCalendarDays)(n, a)
  );
  n.setDate(n.getDate() - i * o);
  const s = +(Kg(n, a) === -i), c = i * (o - s);
  return c === 0 ? 0 : c;
}
function Kg(e, t) {
  const r = e.getFullYear() - t.getFullYear() || e.getMonth() - t.getMonth() || e.getDate() - t.getDate() || e.getHours() - t.getHours() || e.getMinutes() - t.getMinutes() || e.getSeconds() - t.getSeconds() || e.getMilliseconds() - t.getMilliseconds();
  return r < 0 ? -1 : r > 0 ? 1 : r;
}
var hl = {}, $n = {};
$n.getRoundingMethod = B6e;
function B6e(e) {
  return (t) => {
    const n = (e ? Math[e] : Math.trunc)(t);
    return n === 0 ? 0 : n;
  };
}
hl.differenceInHours = T6e;
var N6e = $n, _6e = Je, L6e = ce;
function T6e(e, t, r) {
  const [n, a] = (0, _6e.normalizeDates)(
    r == null ? void 0 : r.in,
    e,
    t
  ), i = (+n - +a) / L6e.millisecondsInHour;
  return (0, N6e.getRoundingMethod)(r == null ? void 0 : r.roundingMethod)(i);
}
var VO = {}, E8 = {};
E8.subISOWeekYears = $6e;
var R6e = v8;
function $6e(e, t, r) {
  return (0, R6e.addISOWeekYears)(e, -t, r);
}
VO.differenceInISOWeekYears = V6e;
var F6e = Je, qg = da, H6e = O8, Y6e = E8;
function V6e(e, t, r) {
  const [n, a] = (0, F6e.normalizeDates)(
    r == null ? void 0 : r.in,
    e,
    t
  ), i = (0, qg.compareAsc)(n, a), o = Math.abs(
    (0, H6e.differenceInCalendarISOWeekYears)(
      n,
      a,
      r
    )
  ), s = (0, Y6e.subISOWeekYears)(
    n,
    i * o,
    r
  ), c = +((0, qg.compareAsc)(s, a) === -i), u = i * (o - c);
  return u === 0 ? 0 : u;
}
var Al = {};
Al.differenceInMilliseconds = k6e;
var Xg = ae;
function k6e(e, t) {
  return +(0, Xg.toDate)(e) - +(0, Xg.toDate)(t);
}
var pl = {};
pl.differenceInMinutes = U6e;
var G6e = $n, W6e = ce, Q6e = Al;
function U6e(e, t, r) {
  const n = (0, Q6e.differenceInMilliseconds)(e, t) / W6e.millisecondsInMinute;
  return (0, G6e.getRoundingMethod)(r == null ? void 0 : r.roundingMethod)(n);
}
var l3 = {}, P8 = {}, vl = {};
vl.endOfDay = z6e;
var Z6e = ae;
function z6e(e, t) {
  const r = (0, Z6e.toDate)(e, t == null ? void 0 : t.in);
  return r.setHours(23, 59, 59, 999), r;
}
var gl = {};
gl.endOfMonth = q6e;
var K6e = ae;
function q6e(e, t) {
  const r = (0, K6e.toDate)(e, t == null ? void 0 : t.in), n = r.getMonth();
  return r.setFullYear(r.getFullYear(), n + 1, 0), r.setHours(23, 59, 59, 999), r;
}
P8.isLastDayOfMonth = t4e;
var X6e = vl, J6e = gl, e4e = ae;
function t4e(e, t) {
  const r = (0, e4e.toDate)(e, t == null ? void 0 : t.in);
  return +(0, X6e.endOfDay)(r, t) == +(0, J6e.endOfMonth)(r, t);
}
l3.differenceInMonths = i4e;
var r4e = Je, p4 = da, n4e = cl, a4e = P8;
function i4e(e, t, r) {
  const [n, a, i] = (0, r4e.normalizeDates)(r == null ? void 0 : r.in, e, e, t), o = (0, p4.compareAsc)(a, i), s = Math.abs(
    (0, n4e.differenceInCalendarMonths)(a, i)
  );
  if (s < 1)
    return 0;
  a.getMonth() === 1 && a.getDate() > 27 && a.setDate(30), a.setMonth(a.getMonth() - o * s);
  let c = (0, p4.compareAsc)(a, i) === -o;
  (0, a4e.isLastDayOfMonth)(n) && s === 1 && (0, p4.compareAsc)(n, i) === 1 && (c = !1);
  const u = o * (s - +c);
  return u === 0 ? 0 : u;
}
var kO = {};
kO.differenceInQuarters = l4e;
var o4e = $n, s4e = l3;
function l4e(e, t, r) {
  const n = (0, s4e.differenceInMonths)(e, t, r) / 3;
  return (0, o4e.getRoundingMethod)(r == null ? void 0 : r.roundingMethod)(n);
}
var c3 = {};
c3.differenceInSeconds = f4e;
var c4e = $n, u4e = Al;
function f4e(e, t, r) {
  const n = (0, u4e.differenceInMilliseconds)(e, t) / 1e3;
  return (0, c4e.getRoundingMethod)(r == null ? void 0 : r.roundingMethod)(n);
}
var GO = {};
GO.differenceInWeeks = A4e;
var d4e = $n, h4e = dl;
function A4e(e, t, r) {
  const n = (0, h4e.differenceInDays)(e, t, r) / 7;
  return (0, d4e.getRoundingMethod)(r == null ? void 0 : r.roundingMethod)(n);
}
var j8 = {};
j8.differenceInYears = g4e;
var p4e = Je, Jg = da, v4e = fl;
function g4e(e, t, r) {
  const [n, a] = (0, p4e.normalizeDates)(
    r == null ? void 0 : r.in,
    e,
    t
  ), i = (0, Jg.compareAsc)(n, a), o = Math.abs(
    (0, v4e.differenceInCalendarYears)(n, a)
  );
  n.setFullYear(1584), a.setFullYear(1584);
  const s = (0, Jg.compareAsc)(n, a) === -i, c = i * (o - +s);
  return c === 0 ? 0 : c;
}
var S8 = {}, pn = {};
pn.normalizeInterval = C4e;
var m4e = Je;
function C4e(e, t) {
  const [r, n] = (0, m4e.normalizeDates)(
    e,
    t.start,
    t.end
  );
  return { start: r, end: n };
}
S8.eachDayOfInterval = w4e;
var b4e = pn, y4e = me;
function w4e(e, t) {
  const { start: r, end: n } = (0, b4e.normalizeInterval)(t == null ? void 0 : t.in, e);
  let a = +r > +n;
  const i = a ? +r : +n, o = a ? n : r;
  o.setHours(0, 0, 0, 0);
  let s = (t == null ? void 0 : t.step) ?? 1;
  if (!s)
    return [];
  s < 0 && (s = -s, a = !a);
  const c = [];
  for (; +o <= i; )
    c.push((0, y4e.constructFrom)(r, o)), o.setDate(o.getDate() + s), o.setHours(0, 0, 0, 0);
  return a ? c.reverse() : c;
}
var WO = {};
WO.eachHourOfInterval = D4e;
var x4e = pn, O4e = me;
function D4e(e, t) {
  const { start: r, end: n } = (0, x4e.normalizeInterval)(t == null ? void 0 : t.in, e);
  let a = +r > +n;
  const i = a ? +r : +n, o = a ? n : r;
  o.setMinutes(0, 0, 0);
  let s = (t == null ? void 0 : t.step) ?? 1;
  if (!s)
    return [];
  s < 0 && (s = -s, a = !a);
  const c = [];
  for (; +o <= i; )
    c.push((0, O4e.constructFrom)(r, o)), o.setHours(o.getHours() + s);
  return a ? c.reverse() : c;
}
var QO = {};
QO.eachMinuteOfInterval = j4e;
var M4e = pn, E4e = sl, P4e = me;
function j4e(e, t) {
  const { start: r, end: n } = (0, M4e.normalizeInterval)(t == null ? void 0 : t.in, e);
  r.setSeconds(0, 0);
  let a = +r > +n;
  const i = a ? +r : +n;
  let o = a ? n : r, s = (t == null ? void 0 : t.step) ?? 1;
  if (!s)
    return [];
  s < 0 && (s = -s, a = !a);
  const c = [];
  for (; +o <= i; )
    c.push((0, P4e.constructFrom)(r, o)), o = (0, E4e.addMinutes)(o, s);
  return a ? c.reverse() : c;
}
var UO = {};
UO.eachMonthOfInterval = B4e;
var S4e = pn, I4e = me;
function B4e(e, t) {
  const { start: r, end: n } = (0, S4e.normalizeInterval)(t == null ? void 0 : t.in, e);
  let a = +r > +n;
  const i = a ? +r : +n, o = a ? n : r;
  o.setHours(0, 0, 0, 0), o.setDate(1);
  let s = (t == null ? void 0 : t.step) ?? 1;
  if (!s)
    return [];
  s < 0 && (s = -s, a = !a);
  const c = [];
  for (; +o <= i; )
    c.push((0, I4e.constructFrom)(r, o)), o.setMonth(o.getMonth() + s);
  return a ? c.reverse() : c;
}
var ZO = {}, ml = {};
ml.startOfQuarter = _4e;
var N4e = ae;
function _4e(e, t) {
  const r = (0, N4e.toDate)(e, t == null ? void 0 : t.in), n = r.getMonth(), a = n - n % 3;
  return r.setMonth(a, 1), r.setHours(0, 0, 0, 0), r;
}
ZO.eachQuarterOfInterval = $4e;
var L4e = pn, T4e = ll, R4e = me, $3 = ml;
function $4e(e, t) {
  const { start: r, end: n } = (0, L4e.normalizeInterval)(t == null ? void 0 : t.in, e);
  let a = +r > +n;
  const i = a ? +(0, $3.startOfQuarter)(r) : +(0, $3.startOfQuarter)(n);
  let o = a ? (0, $3.startOfQuarter)(n) : (0, $3.startOfQuarter)(r), s = (t == null ? void 0 : t.step) ?? 1;
  if (!s)
    return [];
  s < 0 && (s = -s, a = !a);
  const c = [];
  for (; +o <= i; )
    c.push((0, R4e.constructFrom)(r, o)), o = (0, T4e.addQuarters)(o, s);
  return a ? c.reverse() : c;
}
var zO = {};
zO.eachWeekOfInterval = V4e;
var F4e = pn, H4e = s3, Y4e = me, F3 = Kr;
function V4e(e, t) {
  const { start: r, end: n } = (0, F4e.normalizeInterval)(t == null ? void 0 : t.in, e);
  let a = +r > +n;
  const i = a ? (0, F3.startOfWeek)(n, t) : (0, F3.startOfWeek)(r, t), o = a ? (0, F3.startOfWeek)(r, t) : (0, F3.startOfWeek)(n, t);
  i.setHours(15), o.setHours(15);
  const s = +o.getTime();
  let c = i, u = (t == null ? void 0 : t.step) ?? 1;
  if (!u)
    return [];
  u < 0 && (u = -u, a = !a);
  const d = [];
  for (; +c <= s; )
    c.setHours(0), d.push((0, Y4e.constructFrom)(r, c)), c = (0, H4e.addWeeks)(c, u), c.setHours(15);
  return a ? d.reverse() : d;
}
var Cl = {};
Cl.eachWeekendOfInterval = U4e;
var k4e = pn, G4e = me, W4e = S8, Q4e = a3;
function U4e(e, t) {
  const { start: r, end: n } = (0, k4e.normalizeInterval)(t == null ? void 0 : t.in, e), a = (0, W4e.eachDayOfInterval)({ start: r, end: n }, t), i = [];
  let o = 0;
  for (; o < a.length; ) {
    const s = a[o++];
    (0, Q4e.isWeekend)(s) && i.push((0, G4e.constructFrom)(r, s));
  }
  return i;
}
var KO = {}, u3 = {};
u3.startOfMonth = z4e;
var Z4e = ae;
function z4e(e, t) {
  const r = (0, Z4e.toDate)(e, t == null ? void 0 : t.in);
  return r.setDate(1), r.setHours(0, 0, 0, 0), r;
}
KO.eachWeekendOfMonth = J4e;
var K4e = Cl, q4e = gl, X4e = u3;
function J4e(e, t) {
  const r = (0, X4e.startOfMonth)(e, t), n = (0, q4e.endOfMonth)(e, t);
  return (0, K4e.eachWeekendOfInterval)({ start: r, end: n }, t);
}
var qO = {}, I8 = {};
I8.endOfYear = t5e;
var e5e = ae;
function t5e(e, t) {
  const r = (0, e5e.toDate)(e, t == null ? void 0 : t.in), n = r.getFullYear();
  return r.setFullYear(n + 1, 0, 0), r.setHours(23, 59, 59, 999), r;
}
var bl = {};
bl.startOfYear = n5e;
var r5e = ae;
function n5e(e, t) {
  const r = (0, r5e.toDate)(e, t == null ? void 0 : t.in);
  return r.setFullYear(r.getFullYear(), 0, 1), r.setHours(0, 0, 0, 0), r;
}
qO.eachWeekendOfYear = s5e;
var a5e = Cl, i5e = I8, o5e = bl;
function s5e(e, t) {
  const r = (0, o5e.startOfYear)(e, t), n = (0, i5e.endOfYear)(e, t);
  return (0, a5e.eachWeekendOfInterval)({ start: r, end: n }, t);
}
var XO = {};
XO.eachYearOfInterval = u5e;
var l5e = pn, c5e = me;
function u5e(e, t) {
  const { start: r, end: n } = (0, l5e.normalizeInterval)(t == null ? void 0 : t.in, e);
  let a = +r > +n;
  const i = a ? +r : +n, o = a ? n : r;
  o.setHours(0, 0, 0, 0), o.setMonth(0, 1);
  let s = (t == null ? void 0 : t.step) ?? 1;
  if (!s)
    return [];
  s < 0 && (s = -s, a = !a);
  const c = [];
  for (; +o <= i; )
    c.push((0, c5e.constructFrom)(r, o)), o.setFullYear(o.getFullYear() + s);
  return a ? c.reverse() : c;
}
var JO = {};
JO.endOfDecade = d5e;
var f5e = ae;
function d5e(e, t) {
  const r = (0, f5e.toDate)(e, t == null ? void 0 : t.in), n = r.getFullYear(), a = 9 + Math.floor(n / 10) * 10;
  return r.setFullYear(a, 11, 31), r.setHours(23, 59, 59, 999), r;
}
var eD = {};
eD.endOfHour = A5e;
var h5e = ae;
function A5e(e, t) {
  const r = (0, h5e.toDate)(e, t == null ? void 0 : t.in);
  return r.setMinutes(59, 59, 999), r;
}
var tD = {}, B8 = {};
B8.endOfWeek = g5e;
var p5e = Gt, v5e = ae;
function g5e(e, t) {
  var s, c, u, d;
  const r = (0, p5e.getDefaultOptions)(), n = (t == null ? void 0 : t.weekStartsOn) ?? ((c = (s = t == null ? void 0 : t.locale) == null ? void 0 : s.options) == null ? void 0 : c.weekStartsOn) ?? r.weekStartsOn ?? ((d = (u = r.locale) == null ? void 0 : u.options) == null ? void 0 : d.weekStartsOn) ?? 0, a = (0, v5e.toDate)(e, t == null ? void 0 : t.in), i = a.getDay(), o = (i < n ? -7 : 0) + 6 - (i - n);
  return a.setDate(a.getDate() + o), a.setHours(23, 59, 59, 999), a;
}
tD.endOfISOWeek = C5e;
var m5e = B8;
function C5e(e, t) {
  return (0, m5e.endOfWeek)(e, { ...t, weekStartsOn: 1 });
}
var rD = {};
rD.endOfISOWeekYear = x5e;
var b5e = me, y5e = w1, w5e = An;
function x5e(e, t) {
  const r = (0, y5e.getISOWeekYear)(e, t), n = (0, b5e.constructFrom)(
    (t == null ? void 0 : t.in) || e,
    0
  );
  n.setFullYear(r + 1, 0, 4), n.setHours(0, 0, 0, 0);
  const a = (0, w5e.startOfISOWeek)(n, t);
  return a.setMilliseconds(a.getMilliseconds() - 1), a;
}
var nD = {};
nD.endOfMinute = D5e;
var O5e = ae;
function D5e(e, t) {
  const r = (0, O5e.toDate)(e, t == null ? void 0 : t.in);
  return r.setSeconds(59, 999), r;
}
var aD = {};
aD.endOfQuarter = E5e;
var M5e = ae;
function E5e(e, t) {
  const r = (0, M5e.toDate)(e, t == null ? void 0 : t.in), n = r.getMonth(), a = n - n % 3 + 3;
  return r.setMonth(a, 0), r.setHours(23, 59, 59, 999), r;
}
var iD = {};
iD.endOfSecond = j5e;
var P5e = ae;
function j5e(e, t) {
  const r = (0, P5e.toDate)(e, t == null ? void 0 : t.in);
  return r.setMilliseconds(999), r;
}
var oD = {};
oD.endOfToday = I5e;
var S5e = vl;
function I5e(e) {
  return (0, S5e.endOfDay)(Date.now(), e);
}
var sD = {};
sD.endOfTomorrow = B5e;
var em = Tt;
function B5e(e) {
  const t = (0, em.constructNow)(e == null ? void 0 : e.in), r = t.getFullYear(), n = t.getMonth(), a = t.getDate(), i = (0, em.constructNow)(e == null ? void 0 : e.in);
  return i.setFullYear(r, n, a + 1), i.setHours(23, 59, 59, 999), e != null && e.in ? e.in(i) : i;
}
var lD = {};
lD.endOfYesterday = L5e;
var N5e = me, _5e = Tt;
function L5e(e) {
  const t = (0, _5e.constructNow)(e == null ? void 0 : e.in), r = (0, N5e.constructFrom)(e == null ? void 0 : e.in, 0);
  return r.setFullYear(t.getFullYear(), t.getMonth(), t.getDate() - 1), r.setHours(23, 59, 59, 999), r;
}
var N8 = {}, ha = {}, yl = {}, _8 = {};
_8.formatDistance = void 0;
const T5e = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, R5e = (e, t, r) => {
  let n;
  const a = T5e[e];
  return typeof a == "string" ? n = a : t === 1 ? n = a.one : n = a.other.replace("{{count}}", t.toString()), r != null && r.addSuffix ? r.comparison && r.comparison > 0 ? "in " + n : n + " ago" : n;
};
_8.formatDistance = R5e;
var L8 = {}, cD = {};
cD.buildFormatLongFn = $5e;
function $5e(e) {
  return (t = {}) => {
    const r = t.width ? String(t.width) : e.defaultWidth;
    return e.formats[r] || e.formats[e.defaultWidth];
  };
}
L8.formatLong = void 0;
var v4 = cD;
const F5e = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, H5e = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, Y5e = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
};
L8.formatLong = {
  date: (0, v4.buildFormatLongFn)({
    formats: F5e,
    defaultWidth: "full"
  }),
  time: (0, v4.buildFormatLongFn)({
    formats: H5e,
    defaultWidth: "full"
  }),
  dateTime: (0, v4.buildFormatLongFn)({
    formats: Y5e,
    defaultWidth: "full"
  })
};
var T8 = {};
T8.formatRelative = void 0;
const V5e = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, k5e = (e, t, r, n) => V5e[e];
T8.formatRelative = k5e;
var R8 = {}, uD = {};
uD.buildLocalizeFn = G5e;
function G5e(e) {
  return (t, r) => {
    const n = r != null && r.context ? String(r.context) : "standalone";
    let a;
    if (n === "formatting" && e.formattingValues) {
      const o = e.defaultFormattingWidth || e.defaultWidth, s = r != null && r.width ? String(r.width) : o;
      a = e.formattingValues[s] || e.formattingValues[o];
    } else {
      const o = e.defaultWidth, s = r != null && r.width ? String(r.width) : e.defaultWidth;
      a = e.values[s] || e.values[o];
    }
    const i = e.argumentCallback ? e.argumentCallback(t) : t;
    return a[i];
  };
}
R8.localize = void 0;
var Di = uD;
const W5e = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, Q5e = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, U5e = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
}, Z5e = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
}, z5e = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, K5e = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, q5e = (e, t) => {
  const r = Number(e), n = r % 100;
  if (n > 20 || n < 10)
    switch (n % 10) {
      case 1:
        return r + "st";
      case 2:
        return r + "nd";
      case 3:
        return r + "rd";
    }
  return r + "th";
};
R8.localize = {
  ordinalNumber: q5e,
  era: (0, Di.buildLocalizeFn)({
    values: W5e,
    defaultWidth: "wide"
  }),
  quarter: (0, Di.buildLocalizeFn)({
    values: Q5e,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: (0, Di.buildLocalizeFn)({
    values: U5e,
    defaultWidth: "wide"
  }),
  day: (0, Di.buildLocalizeFn)({
    values: Z5e,
    defaultWidth: "wide"
  }),
  dayPeriod: (0, Di.buildLocalizeFn)({
    values: z5e,
    defaultWidth: "wide",
    formattingValues: K5e,
    defaultFormattingWidth: "wide"
  })
};
var $8 = {}, fD = {};
fD.buildMatchFn = X5e;
function X5e(e) {
  return (t, r = {}) => {
    const n = r.width, a = n && e.matchPatterns[n] || e.matchPatterns[e.defaultMatchWidth], i = t.match(a);
    if (!i)
      return null;
    const o = i[0], s = n && e.parsePatterns[n] || e.parsePatterns[e.defaultParseWidth], c = Array.isArray(s) ? e7e(s, (h) => h.test(o)) : (
      // [TODO] -- I challenge you to fix the type
      J5e(s, (h) => h.test(o))
    );
    let u;
    u = e.valueCallback ? e.valueCallback(c) : c, u = r.valueCallback ? (
      // [TODO] -- I challenge you to fix the type
      r.valueCallback(u)
    ) : u;
    const d = t.slice(o.length);
    return { value: u, rest: d };
  };
}
function J5e(e, t) {
  for (const r in e)
    if (Object.prototype.hasOwnProperty.call(e, r) && t(e[r]))
      return r;
}
function e7e(e, t) {
  for (let r = 0; r < e.length; r++)
    if (t(e[r]))
      return r;
}
var dD = {};
dD.buildMatchPatternFn = t7e;
function t7e(e) {
  return (t, r = {}) => {
    const n = t.match(e.matchPattern);
    if (!n)
      return null;
    const a = n[0], i = t.match(e.parsePattern);
    if (!i)
      return null;
    let o = e.valueCallback ? e.valueCallback(i[0]) : i[0];
    o = r.valueCallback ? r.valueCallback(o) : o;
    const s = t.slice(a.length);
    return { value: o, rest: s };
  };
}
$8.match = void 0;
var Mi = fD, r7e = dD;
const n7e = /^(\d+)(th|st|nd|rd)?/i, a7e = /\d+/i, i7e = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, o7e = {
  any: [/^b/i, /^(a|c)/i]
}, s7e = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, l7e = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, c7e = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, u7e = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, f7e = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, d7e = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, h7e = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, A7e = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
};
$8.match = {
  ordinalNumber: (0, r7e.buildMatchPatternFn)({
    matchPattern: n7e,
    parsePattern: a7e,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: (0, Mi.buildMatchFn)({
    matchPatterns: i7e,
    defaultMatchWidth: "wide",
    parsePatterns: o7e,
    defaultParseWidth: "any"
  }),
  quarter: (0, Mi.buildMatchFn)({
    matchPatterns: s7e,
    defaultMatchWidth: "wide",
    parsePatterns: l7e,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: (0, Mi.buildMatchFn)({
    matchPatterns: c7e,
    defaultMatchWidth: "wide",
    parsePatterns: u7e,
    defaultParseWidth: "any"
  }),
  day: (0, Mi.buildMatchFn)({
    matchPatterns: f7e,
    defaultMatchWidth: "wide",
    parsePatterns: d7e,
    defaultParseWidth: "any"
  }),
  dayPeriod: (0, Mi.buildMatchFn)({
    matchPatterns: h7e,
    defaultMatchWidth: "any",
    parsePatterns: A7e,
    defaultParseWidth: "any"
  })
};
yl.enUS = void 0;
var p7e = _8, v7e = L8, g7e = T8, m7e = R8, C7e = $8;
yl.enUS = {
  code: "en-US",
  formatDistance: p7e.formatDistance,
  formatLong: v7e.formatLong,
  formatRelative: g7e.formatRelative,
  localize: m7e.localize,
  match: C7e.match,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
(function(e) {
  Object.defineProperty(e, "defaultLocale", {
    enumerable: !0,
    get: function() {
      return t.enUS;
    }
  });
  var t = yl;
})(ha);
var F8 = {}, H8 = {};
H8.getDayOfYear = x7e;
var b7e = Ln, y7e = bl, w7e = ae;
function x7e(e, t) {
  const r = (0, w7e.toDate)(e, t == null ? void 0 : t.in);
  return (0, b7e.differenceInCalendarDays)(
    r,
    (0, y7e.startOfYear)(r)
  ) + 1;
}
var wl = {};
wl.getISOWeek = P7e;
var O7e = ce, D7e = An, M7e = W2, E7e = ae;
function P7e(e, t) {
  const r = (0, E7e.toDate)(e, t == null ? void 0 : t.in), n = +(0, D7e.startOfISOWeek)(r) - +(0, M7e.startOfISOWeekYear)(r);
  return Math.round(n / O7e.millisecondsInWeek) + 1;
}
var xl = {}, Ol = {}, f3 = {};
f3.getWeekYear = I7e;
var j7e = Gt, tm = me, rm = Kr, S7e = ae;
function I7e(e, t) {
  var d, h, A, p;
  const r = (0, S7e.toDate)(e, t == null ? void 0 : t.in), n = r.getFullYear(), a = (0, j7e.getDefaultOptions)(), i = (t == null ? void 0 : t.firstWeekContainsDate) ?? ((h = (d = t == null ? void 0 : t.locale) == null ? void 0 : d.options) == null ? void 0 : h.firstWeekContainsDate) ?? a.firstWeekContainsDate ?? ((p = (A = a.locale) == null ? void 0 : A.options) == null ? void 0 : p.firstWeekContainsDate) ?? 1, o = (0, tm.constructFrom)(
    (t == null ? void 0 : t.in) || e,
    0
  );
  o.setFullYear(n + 1, 0, i), o.setHours(0, 0, 0, 0);
  const s = (0, rm.startOfWeek)(
    o,
    t
  ), c = (0, tm.constructFrom)(
    (t == null ? void 0 : t.in) || e,
    0
  );
  c.setFullYear(n, 0, i), c.setHours(0, 0, 0, 0);
  const u = (0, rm.startOfWeek)(
    c,
    t
  );
  return +r >= +s ? n + 1 : +r >= +u ? n : n - 1;
}
Ol.startOfWeekYear = T7e;
var B7e = Gt, N7e = me, _7e = f3, L7e = Kr;
function T7e(e, t) {
  var s, c, u, d;
  const r = (0, B7e.getDefaultOptions)(), n = (t == null ? void 0 : t.firstWeekContainsDate) ?? ((c = (s = t == null ? void 0 : t.locale) == null ? void 0 : s.options) == null ? void 0 : c.firstWeekContainsDate) ?? r.firstWeekContainsDate ?? ((d = (u = r.locale) == null ? void 0 : u.options) == null ? void 0 : d.firstWeekContainsDate) ?? 1, a = (0, _7e.getWeekYear)(e, t), i = (0, N7e.constructFrom)((t == null ? void 0 : t.in) || e, 0);
  return i.setFullYear(a, 0, n), i.setHours(0, 0, 0, 0), (0, L7e.startOfWeek)(i, t);
}
xl.getWeek = Y7e;
var R7e = ce, $7e = Kr, F7e = Ol, H7e = ae;
function Y7e(e, t) {
  const r = (0, H7e.toDate)(e, t == null ? void 0 : t.in), n = +(0, $7e.startOfWeek)(r, t) - +(0, F7e.startOfWeekYear)(r, t);
  return Math.round(n / R7e.millisecondsInWeek) + 1;
}
var Aa = {};
Aa.addLeadingZeros = V7e;
function V7e(e, t) {
  const r = e < 0 ? "-" : "", n = Math.abs(e).toString().padStart(t, "0");
  return r + n;
}
var Dl = {};
Dl.lightFormatters = void 0;
var Vn = Aa;
Dl.lightFormatters = {
  // Year
  y(e, t) {
    const r = e.getFullYear(), n = r > 0 ? r : 1 - r;
    return (0, Vn.addLeadingZeros)(
      t === "yy" ? n % 100 : n,
      t.length
    );
  },
  // Month
  M(e, t) {
    const r = e.getMonth();
    return t === "M" ? String(r + 1) : (0, Vn.addLeadingZeros)(r + 1, 2);
  },
  // Day of the month
  d(e, t) {
    return (0, Vn.addLeadingZeros)(e.getDate(), t.length);
  },
  // AM or PM
  a(e, t) {
    const r = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return r.toUpperCase();
      case "aaa":
        return r;
      case "aaaaa":
        return r[0];
      case "aaaa":
      default:
        return r === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h(e, t) {
    return (0, Vn.addLeadingZeros)(
      e.getHours() % 12 || 12,
      t.length
    );
  },
  // Hour [0-23]
  H(e, t) {
    return (0, Vn.addLeadingZeros)(e.getHours(), t.length);
  },
  // Minute
  m(e, t) {
    return (0, Vn.addLeadingZeros)(e.getMinutes(), t.length);
  },
  // Second
  s(e, t) {
    return (0, Vn.addLeadingZeros)(e.getSeconds(), t.length);
  },
  // Fraction of second
  S(e, t) {
    const r = t.length, n = e.getMilliseconds(), a = Math.trunc(
      n * Math.pow(10, r - 3)
    );
    return (0, Vn.addLeadingZeros)(a, t.length);
  }
};
F8.formatters = void 0;
var k7e = H8, G7e = wl, W7e = w1, Q7e = xl, U7e = f3, Ot = Aa, kn = Dl;
const Sa = {
  am: "am",
  pm: "pm",
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
};
F8.formatters = {
  // Era
  G: function(e, t, r) {
    const n = e.getFullYear() > 0 ? 1 : 0;
    switch (t) {
      case "G":
      case "GG":
      case "GGG":
        return r.era(n, { width: "abbreviated" });
      case "GGGGG":
        return r.era(n, { width: "narrow" });
      case "GGGG":
      default:
        return r.era(n, { width: "wide" });
    }
  },
  // Year
  y: function(e, t, r) {
    if (t === "yo") {
      const n = e.getFullYear(), a = n > 0 ? n : 1 - n;
      return r.ordinalNumber(a, { unit: "year" });
    }
    return kn.lightFormatters.y(e, t);
  },
  // Local week-numbering year
  Y: function(e, t, r, n) {
    const a = (0, U7e.getWeekYear)(e, n), i = a > 0 ? a : 1 - a;
    if (t === "YY") {
      const o = i % 100;
      return (0, Ot.addLeadingZeros)(o, 2);
    }
    return t === "Yo" ? r.ordinalNumber(i, { unit: "year" }) : (0, Ot.addLeadingZeros)(i, t.length);
  },
  // ISO week-numbering year
  R: function(e, t) {
    const r = (0, W7e.getISOWeekYear)(e);
    return (0, Ot.addLeadingZeros)(r, t.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(e, t) {
    const r = e.getFullYear();
    return (0, Ot.addLeadingZeros)(r, t.length);
  },
  // Quarter
  Q: function(e, t, r) {
    const n = Math.ceil((e.getMonth() + 1) / 3);
    switch (t) {
      case "Q":
        return String(n);
      case "QQ":
        return (0, Ot.addLeadingZeros)(n, 2);
      case "Qo":
        return r.ordinalNumber(n, { unit: "quarter" });
      case "QQQ":
        return r.quarter(n, {
          width: "abbreviated",
          context: "formatting"
        });
      case "QQQQQ":
        return r.quarter(n, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return r.quarter(n, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(e, t, r) {
    const n = Math.ceil((e.getMonth() + 1) / 3);
    switch (t) {
      case "q":
        return String(n);
      case "qq":
        return (0, Ot.addLeadingZeros)(n, 2);
      case "qo":
        return r.ordinalNumber(n, { unit: "quarter" });
      case "qqq":
        return r.quarter(n, {
          width: "abbreviated",
          context: "standalone"
        });
      case "qqqqq":
        return r.quarter(n, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return r.quarter(n, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(e, t, r) {
    const n = e.getMonth();
    switch (t) {
      case "M":
      case "MM":
        return kn.lightFormatters.M(e, t);
      case "Mo":
        return r.ordinalNumber(n + 1, { unit: "month" });
      case "MMM":
        return r.month(n, {
          width: "abbreviated",
          context: "formatting"
        });
      case "MMMMM":
        return r.month(n, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return r.month(n, { width: "wide", context: "formatting" });
    }
  },
  // Stand-alone month
  L: function(e, t, r) {
    const n = e.getMonth();
    switch (t) {
      case "L":
        return String(n + 1);
      case "LL":
        return (0, Ot.addLeadingZeros)(n + 1, 2);
      case "Lo":
        return r.ordinalNumber(n + 1, { unit: "month" });
      case "LLL":
        return r.month(n, {
          width: "abbreviated",
          context: "standalone"
        });
      case "LLLLL":
        return r.month(n, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return r.month(n, { width: "wide", context: "standalone" });
    }
  },
  // Local week of year
  w: function(e, t, r, n) {
    const a = (0, Q7e.getWeek)(e, n);
    return t === "wo" ? r.ordinalNumber(a, { unit: "week" }) : (0, Ot.addLeadingZeros)(a, t.length);
  },
  // ISO week of year
  I: function(e, t, r) {
    const n = (0, G7e.getISOWeek)(e);
    return t === "Io" ? r.ordinalNumber(n, { unit: "week" }) : (0, Ot.addLeadingZeros)(n, t.length);
  },
  // Day of the month
  d: function(e, t, r) {
    return t === "do" ? r.ordinalNumber(e.getDate(), { unit: "date" }) : kn.lightFormatters.d(e, t);
  },
  // Day of year
  D: function(e, t, r) {
    const n = (0, k7e.getDayOfYear)(e);
    return t === "Do" ? r.ordinalNumber(n, { unit: "dayOfYear" }) : (0, Ot.addLeadingZeros)(n, t.length);
  },
  // Day of week
  E: function(e, t, r) {
    const n = e.getDay();
    switch (t) {
      case "E":
      case "EE":
      case "EEE":
        return r.day(n, {
          width: "abbreviated",
          context: "formatting"
        });
      case "EEEEE":
        return r.day(n, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return r.day(n, {
          width: "short",
          context: "formatting"
        });
      case "EEEE":
      default:
        return r.day(n, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(e, t, r, n) {
    const a = e.getDay(), i = (a - n.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      case "e":
        return String(i);
      case "ee":
        return (0, Ot.addLeadingZeros)(i, 2);
      case "eo":
        return r.ordinalNumber(i, { unit: "day" });
      case "eee":
        return r.day(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "eeeee":
        return r.day(a, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return r.day(a, {
          width: "short",
          context: "formatting"
        });
      case "eeee":
      default:
        return r.day(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(e, t, r, n) {
    const a = e.getDay(), i = (a - n.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      case "c":
        return String(i);
      case "cc":
        return (0, Ot.addLeadingZeros)(i, t.length);
      case "co":
        return r.ordinalNumber(i, { unit: "day" });
      case "ccc":
        return r.day(a, {
          width: "abbreviated",
          context: "standalone"
        });
      case "ccccc":
        return r.day(a, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return r.day(a, {
          width: "short",
          context: "standalone"
        });
      case "cccc":
      default:
        return r.day(a, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(e, t, r) {
    const n = e.getDay(), a = n === 0 ? 7 : n;
    switch (t) {
      case "i":
        return String(a);
      case "ii":
        return (0, Ot.addLeadingZeros)(a, t.length);
      case "io":
        return r.ordinalNumber(a, { unit: "day" });
      case "iii":
        return r.day(n, {
          width: "abbreviated",
          context: "formatting"
        });
      case "iiiii":
        return r.day(n, {
          width: "narrow",
          context: "formatting"
        });
      case "iiiiii":
        return r.day(n, {
          width: "short",
          context: "formatting"
        });
      case "iiii":
      default:
        return r.day(n, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(e, t, r) {
    const a = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return r.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return r.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return r.dayPeriod(a, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return r.dayPeriod(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(e, t, r) {
    const n = e.getHours();
    let a;
    switch (n === 12 ? a = Sa.noon : n === 0 ? a = Sa.midnight : a = n / 12 >= 1 ? "pm" : "am", t) {
      case "b":
      case "bb":
        return r.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return r.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return r.dayPeriod(a, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return r.dayPeriod(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(e, t, r) {
    const n = e.getHours();
    let a;
    switch (n >= 17 ? a = Sa.evening : n >= 12 ? a = Sa.afternoon : n >= 4 ? a = Sa.morning : a = Sa.night, t) {
      case "B":
      case "BB":
      case "BBB":
        return r.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return r.dayPeriod(a, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return r.dayPeriod(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(e, t, r) {
    if (t === "ho") {
      let n = e.getHours() % 12;
      return n === 0 && (n = 12), r.ordinalNumber(n, { unit: "hour" });
    }
    return kn.lightFormatters.h(e, t);
  },
  // Hour [0-23]
  H: function(e, t, r) {
    return t === "Ho" ? r.ordinalNumber(e.getHours(), { unit: "hour" }) : kn.lightFormatters.H(e, t);
  },
  // Hour [0-11]
  K: function(e, t, r) {
    const n = e.getHours() % 12;
    return t === "Ko" ? r.ordinalNumber(n, { unit: "hour" }) : (0, Ot.addLeadingZeros)(n, t.length);
  },
  // Hour [1-24]
  k: function(e, t, r) {
    let n = e.getHours();
    return n === 0 && (n = 24), t === "ko" ? r.ordinalNumber(n, { unit: "hour" }) : (0, Ot.addLeadingZeros)(n, t.length);
  },
  // Minute
  m: function(e, t, r) {
    return t === "mo" ? r.ordinalNumber(e.getMinutes(), { unit: "minute" }) : kn.lightFormatters.m(e, t);
  },
  // Second
  s: function(e, t, r) {
    return t === "so" ? r.ordinalNumber(e.getSeconds(), { unit: "second" }) : kn.lightFormatters.s(e, t);
  },
  // Fraction of second
  S: function(e, t) {
    return kn.lightFormatters.S(e, t);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(e, t, r) {
    const n = e.getTimezoneOffset();
    if (n === 0)
      return "Z";
    switch (t) {
      case "X":
        return am(n);
      case "XXXX":
      case "XX":
        return Y1(n);
      case "XXXXX":
      case "XXX":
      default:
        return Y1(n, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(e, t, r) {
    const n = e.getTimezoneOffset();
    switch (t) {
      case "x":
        return am(n);
      case "xxxx":
      case "xx":
        return Y1(n);
      case "xxxxx":
      case "xxx":
      default:
        return Y1(n, ":");
    }
  },
  // Timezone (GMT)
  O: function(e, t, r) {
    const n = e.getTimezoneOffset();
    switch (t) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + nm(n, ":");
      case "OOOO":
      default:
        return "GMT" + Y1(n, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(e, t, r) {
    const n = e.getTimezoneOffset();
    switch (t) {
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + nm(n, ":");
      case "zzzz":
      default:
        return "GMT" + Y1(n, ":");
    }
  },
  // Seconds timestamp
  t: function(e, t, r) {
    const n = Math.trunc(+e / 1e3);
    return (0, Ot.addLeadingZeros)(n, t.length);
  },
  // Milliseconds timestamp
  T: function(e, t, r) {
    return (0, Ot.addLeadingZeros)(+e, t.length);
  }
};
function nm(e, t = "") {
  const r = e > 0 ? "-" : "+", n = Math.abs(e), a = Math.trunc(n / 60), i = n % 60;
  return i === 0 ? r + String(a) : r + String(a) + t + (0, Ot.addLeadingZeros)(i, 2);
}
function am(e, t) {
  return e % 60 === 0 ? (e > 0 ? "-" : "+") + (0, Ot.addLeadingZeros)(Math.abs(e) / 60, 2) : Y1(e, t);
}
function Y1(e, t = "") {
  const r = e > 0 ? "-" : "+", n = Math.abs(e), a = (0, Ot.addLeadingZeros)(Math.trunc(n / 60), 2), i = (0, Ot.addLeadingZeros)(n % 60, 2);
  return r + a + t + i;
}
var Ml = {};
Ml.longFormatters = void 0;
const im = (e, t) => {
  switch (e) {
    case "P":
      return t.date({ width: "short" });
    case "PP":
      return t.date({ width: "medium" });
    case "PPP":
      return t.date({ width: "long" });
    case "PPPP":
    default:
      return t.date({ width: "full" });
  }
}, hD = (e, t) => {
  switch (e) {
    case "p":
      return t.time({ width: "short" });
    case "pp":
      return t.time({ width: "medium" });
    case "ppp":
      return t.time({ width: "long" });
    case "pppp":
    default:
      return t.time({ width: "full" });
  }
}, Z7e = (e, t) => {
  const r = e.match(/(P+)(p+)?/) || [], n = r[1], a = r[2];
  if (!a)
    return im(e, t);
  let i;
  switch (n) {
    case "P":
      i = t.dateTime({ width: "short" });
      break;
    case "PP":
      i = t.dateTime({ width: "medium" });
      break;
    case "PPP":
      i = t.dateTime({ width: "long" });
      break;
    case "PPPP":
    default:
      i = t.dateTime({ width: "full" });
      break;
  }
  return i.replace("{{date}}", im(n, t)).replace("{{time}}", hD(a, t));
};
Ml.longFormatters = {
  p: hD,
  P: Z7e
};
var d3 = {};
d3.isProtectedDayOfYearToken = X7e;
d3.isProtectedWeekYearToken = J7e;
d3.warnOrThrowProtectedError = e9e;
const z7e = /^D+$/, K7e = /^Y+$/, q7e = ["D", "DD", "YY", "YYYY"];
function X7e(e) {
  return z7e.test(e);
}
function J7e(e) {
  return K7e.test(e);
}
function e9e(e, t, r) {
  const n = t9e(e, t, r);
  if (console.warn(n), q7e.includes(e))
    throw new RangeError(n);
}
function t9e(e, t, r) {
  const n = e[0] === "Y" ? "years" : "days of the month";
  return `Use \`${e.toLowerCase()}\` instead of \`${e}\` (in \`${t}\`) for formatting ${n} to the input \`${r}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}
(function(e) {
  e.format = e.formatDate = p, Object.defineProperty(e, "formatters", {
    enumerable: !0,
    get: function() {
      return n.formatters;
    }
  }), Object.defineProperty(e, "longFormatters", {
    enumerable: !0,
    get: function() {
      return a.longFormatters;
    }
  });
  var t = ha, r = Gt, n = F8, a = Ml, i = d3, o = Rn, s = ae;
  const c = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, u = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, d = /^'([^]*?)'?$/, h = /''/g, A = /[a-zA-Z]/;
  function p(g, v, C) {
    var P, H, F, R, N, z, q, J;
    const y = (0, r.getDefaultOptions)(), w = (C == null ? void 0 : C.locale) ?? y.locale ?? t.defaultLocale, O = (C == null ? void 0 : C.firstWeekContainsDate) ?? ((H = (P = C == null ? void 0 : C.locale) == null ? void 0 : P.options) == null ? void 0 : H.firstWeekContainsDate) ?? y.firstWeekContainsDate ?? ((R = (F = y.locale) == null ? void 0 : F.options) == null ? void 0 : R.firstWeekContainsDate) ?? 1, b = (C == null ? void 0 : C.weekStartsOn) ?? ((z = (N = C == null ? void 0 : C.locale) == null ? void 0 : N.options) == null ? void 0 : z.weekStartsOn) ?? y.weekStartsOn ?? ((J = (q = y.locale) == null ? void 0 : q.options) == null ? void 0 : J.weekStartsOn) ?? 0, D = (0, s.toDate)(g, C == null ? void 0 : C.in);
    if (!(0, o.isValid)(D))
      throw new RangeError("Invalid time value");
    let M = v.match(u).map((W) => {
      const te = W[0];
      if (te === "p" || te === "P") {
        const S = a.longFormatters[te];
        return S(W, w.formatLong);
      }
      return W;
    }).join("").match(c).map((W) => {
      if (W === "''")
        return { isToken: !1, value: "'" };
      const te = W[0];
      if (te === "'")
        return { isToken: !1, value: m(W) };
      if (n.formatters[te])
        return { isToken: !0, value: W };
      if (te.match(A))
        throw new RangeError(
          "Format string contains an unescaped latin alphabet character `" + te + "`"
        );
      return { isToken: !1, value: W };
    });
    w.localize.preprocessor && (M = w.localize.preprocessor(D, M));
    const j = {
      firstWeekContainsDate: O,
      weekStartsOn: b,
      locale: w
    };
    return M.map((W) => {
      if (!W.isToken)
        return W.value;
      const te = W.value;
      (!(C != null && C.useAdditionalWeekYearTokens) && (0, i.isProtectedWeekYearToken)(te) || !(C != null && C.useAdditionalDayOfYearTokens) && (0, i.isProtectedDayOfYearToken)(te)) && (0, i.warnOrThrowProtectedError)(te, v, String(g));
      const S = n.formatters[te[0]];
      return S(D, te, w.localize, j);
    }).join("");
  }
  function m(g) {
    const v = g.match(d);
    return v ? v[1].replace(h, "'") : g;
  }
})(N8);
var Y8 = {};
Y8.formatDistance = l9e;
var r9e = ha, n9e = Gt, om = Tn, a9e = Je, i9e = da, Ia = ce, o9e = l3, s9e = c3;
function l9e(e, t, r) {
  const n = (0, n9e.getDefaultOptions)(), a = (r == null ? void 0 : r.locale) ?? n.locale ?? r9e.defaultLocale, i = 2520, o = (0, i9e.compareAsc)(e, t);
  if (isNaN(o))
    throw new RangeError("Invalid time value");
  const s = Object.assign({}, r, {
    addSuffix: r == null ? void 0 : r.addSuffix,
    comparison: o
  }), [c, u] = (0, a9e.normalizeDates)(
    r == null ? void 0 : r.in,
    ...o > 0 ? [t, e] : [e, t]
  ), d = (0, s9e.differenceInSeconds)(u, c), h = ((0, om.getTimezoneOffsetInMilliseconds)(u) - (0, om.getTimezoneOffsetInMilliseconds)(c)) / 1e3, A = Math.round((d - h) / 60);
  let p;
  if (A < 2)
    return r != null && r.includeSeconds ? d < 5 ? a.formatDistance("lessThanXSeconds", 5, s) : d < 10 ? a.formatDistance("lessThanXSeconds", 10, s) : d < 20 ? a.formatDistance("lessThanXSeconds", 20, s) : d < 40 ? a.formatDistance("halfAMinute", 0, s) : d < 60 ? a.formatDistance("lessThanXMinutes", 1, s) : a.formatDistance("xMinutes", 1, s) : A === 0 ? a.formatDistance("lessThanXMinutes", 1, s) : a.formatDistance("xMinutes", A, s);
  if (A < 45)
    return a.formatDistance("xMinutes", A, s);
  if (A < 90)
    return a.formatDistance("aboutXHours", 1, s);
  if (A < Ia.minutesInDay) {
    const m = Math.round(A / 60);
    return a.formatDistance("aboutXHours", m, s);
  } else {
    if (A < i)
      return a.formatDistance("xDays", 1, s);
    if (A < Ia.minutesInMonth) {
      const m = Math.round(A / Ia.minutesInDay);
      return a.formatDistance("xDays", m, s);
    } else if (A < Ia.minutesInMonth * 2)
      return p = Math.round(A / Ia.minutesInMonth), a.formatDistance("aboutXMonths", p, s);
  }
  if (p = (0, o9e.differenceInMonths)(u, c), p < 12) {
    const m = Math.round(A / Ia.minutesInMonth);
    return a.formatDistance("xMonths", m, s);
  } else {
    const m = p % 12, g = Math.trunc(p / 12);
    return m < 3 ? a.formatDistance("aboutXYears", g, s) : m < 9 ? a.formatDistance("overXYears", g, s) : a.formatDistance("almostXYears", g + 1, s);
  }
}
var V8 = {};
V8.formatDistanceStrict = A9e;
var c9e = ha, u9e = Gt, f9e = $n, sm = Tn, d9e = Je, h9e = da, Gn = ce;
function A9e(e, t, r) {
  const n = (0, u9e.getDefaultOptions)(), a = (r == null ? void 0 : r.locale) ?? n.locale ?? c9e.defaultLocale, i = (0, h9e.compareAsc)(e, t);
  if (isNaN(i))
    throw new RangeError("Invalid time value");
  const o = Object.assign({}, r, {
    addSuffix: r == null ? void 0 : r.addSuffix,
    comparison: i
  }), [s, c] = (0, d9e.normalizeDates)(
    r == null ? void 0 : r.in,
    ...i > 0 ? [t, e] : [e, t]
  ), u = (0, f9e.getRoundingMethod)(
    (r == null ? void 0 : r.roundingMethod) ?? "round"
  ), d = c.getTime() - s.getTime(), h = d / Gn.millisecondsInMinute, A = (0, sm.getTimezoneOffsetInMilliseconds)(c) - (0, sm.getTimezoneOffsetInMilliseconds)(s), p = (d - A) / Gn.millisecondsInMinute, m = r == null ? void 0 : r.unit;
  let g;
  if (m ? g = m : h < 1 ? g = "second" : h < 60 ? g = "minute" : h < Gn.minutesInDay ? g = "hour" : p < Gn.minutesInMonth ? g = "day" : p < Gn.minutesInYear ? g = "month" : g = "year", g === "second") {
    const v = u(d / 1e3);
    return a.formatDistance("xSeconds", v, o);
  } else if (g === "minute") {
    const v = u(h);
    return a.formatDistance("xMinutes", v, o);
  } else if (g === "hour") {
    const v = u(h / 60);
    return a.formatDistance("xHours", v, o);
  } else if (g === "day") {
    const v = u(p / Gn.minutesInDay);
    return a.formatDistance("xDays", v, o);
  } else if (g === "month") {
    const v = u(
      p / Gn.minutesInMonth
    );
    return v === 12 && m !== "month" ? a.formatDistance("xYears", 1, o) : a.formatDistance("xMonths", v, o);
  } else {
    const v = u(p / Gn.minutesInYear);
    return a.formatDistance("xYears", v, o);
  }
}
var AD = {};
AD.formatDistanceToNow = g9e;
var p9e = Tt, v9e = Y8;
function g9e(e, t) {
  return (0, v9e.formatDistance)(
    e,
    (0, p9e.constructNow)(e),
    t
  );
}
var pD = {};
pD.formatDistanceToNowStrict = b9e;
var m9e = Tt, C9e = V8;
function b9e(e, t) {
  return (0, C9e.formatDistanceStrict)(
    e,
    (0, m9e.constructNow)(e),
    t
  );
}
var vD = {};
vD.formatDuration = O9e;
var y9e = ha, w9e = Gt;
const x9e = [
  "years",
  "months",
  "weeks",
  "days",
  "hours",
  "minutes",
  "seconds"
];
function O9e(e, t) {
  const r = (0, w9e.getDefaultOptions)(), n = (t == null ? void 0 : t.locale) ?? r.locale ?? y9e.defaultLocale, a = (t == null ? void 0 : t.format) ?? x9e, i = (t == null ? void 0 : t.zero) ?? !1, o = (t == null ? void 0 : t.delimiter) ?? " ";
  return n.formatDistance ? a.reduce((c, u) => {
    const d = `x${u.replace(/(^.)/, (A) => A.toUpperCase())}`, h = e[u];
    return h !== void 0 && (i || e[u]) ? c.concat(n.formatDistance(d, h)) : c;
  }, []).join(o) : "";
}
var gD = {};
gD.formatISO = M9e;
var Wn = Aa, D9e = ae;
function M9e(e, t) {
  const r = (0, D9e.toDate)(e, t == null ? void 0 : t.in);
  if (isNaN(+r))
    throw new RangeError("Invalid time value");
  const n = (t == null ? void 0 : t.format) ?? "extended", a = (t == null ? void 0 : t.representation) ?? "complete";
  let i = "", o = "";
  const s = n === "extended" ? "-" : "", c = n === "extended" ? ":" : "";
  if (a !== "time") {
    const u = (0, Wn.addLeadingZeros)(r.getDate(), 2), d = (0, Wn.addLeadingZeros)(r.getMonth() + 1, 2);
    i = `${(0, Wn.addLeadingZeros)(r.getFullYear(), 4)}${s}${d}${s}${u}`;
  }
  if (a !== "date") {
    const u = r.getTimezoneOffset();
    if (u !== 0) {
      const g = Math.abs(u), v = (0, Wn.addLeadingZeros)(
        Math.trunc(g / 60),
        2
      ), C = (0, Wn.addLeadingZeros)(g % 60, 2);
      o = `${u < 0 ? "+" : "-"}${v}:${C}`;
    } else
      o = "Z";
    const d = (0, Wn.addLeadingZeros)(r.getHours(), 2), h = (0, Wn.addLeadingZeros)(r.getMinutes(), 2), A = (0, Wn.addLeadingZeros)(r.getSeconds(), 2), p = i === "" ? "" : "T", m = [d, h, A].join(c);
    i = `${i}${p}${m}${o}`;
  }
  return i;
}
var mD = {};
mD.formatISO9075 = j9e;
var Ba = Aa, E9e = Rn, P9e = ae;
function j9e(e, t) {
  const r = (0, P9e.toDate)(e, t == null ? void 0 : t.in);
  if (!(0, E9e.isValid)(r))
    throw new RangeError("Invalid time value");
  const n = (t == null ? void 0 : t.format) ?? "extended", a = (t == null ? void 0 : t.representation) ?? "complete";
  let i = "";
  const o = n === "extended" ? "-" : "", s = n === "extended" ? ":" : "";
  if (a !== "time") {
    const c = (0, Ba.addLeadingZeros)(r.getDate(), 2), u = (0, Ba.addLeadingZeros)(r.getMonth() + 1, 2);
    i = `${(0, Ba.addLeadingZeros)(r.getFullYear(), 4)}${o}${u}${o}${c}`;
  }
  if (a !== "date") {
    const c = (0, Ba.addLeadingZeros)(r.getHours(), 2), u = (0, Ba.addLeadingZeros)(r.getMinutes(), 2), d = (0, Ba.addLeadingZeros)(r.getSeconds(), 2);
    i = `${i}${i === "" ? "" : " "}${c}${s}${u}${s}${d}`;
  }
  return i;
}
var CD = {};
CD.formatISODuration = S9e;
function S9e(e) {
  const {
    years: t = 0,
    months: r = 0,
    days: n = 0,
    hours: a = 0,
    minutes: i = 0,
    seconds: o = 0
  } = e;
  return `P${t}Y${r}M${n}DT${a}H${i}M${o}S`;
}
var bD = {};
bD.formatRFC3339 = N9e;
var Qn = Aa, I9e = Rn, B9e = ae;
function N9e(e, t) {
  const r = (0, B9e.toDate)(e, t == null ? void 0 : t.in);
  if (!(0, I9e.isValid)(r))
    throw new RangeError("Invalid time value");
  const n = (t == null ? void 0 : t.fractionDigits) ?? 0, a = (0, Qn.addLeadingZeros)(r.getDate(), 2), i = (0, Qn.addLeadingZeros)(r.getMonth() + 1, 2), o = r.getFullYear(), s = (0, Qn.addLeadingZeros)(r.getHours(), 2), c = (0, Qn.addLeadingZeros)(r.getMinutes(), 2), u = (0, Qn.addLeadingZeros)(r.getSeconds(), 2);
  let d = "";
  if (n > 0) {
    const p = r.getMilliseconds(), m = Math.trunc(
      p * Math.pow(10, n - 3)
    );
    d = "." + (0, Qn.addLeadingZeros)(m, n);
  }
  let h = "";
  const A = r.getTimezoneOffset();
  if (A !== 0) {
    const p = Math.abs(A), m = (0, Qn.addLeadingZeros)(
      Math.trunc(p / 60),
      2
    ), g = (0, Qn.addLeadingZeros)(p % 60, 2);
    h = `${A < 0 ? "+" : "-"}${m}:${g}`;
  } else
    h = "Z";
  return `${o}-${i}-${a}T${s}:${c}:${u}${d}${h}`;
}
var yD = {};
yD.formatRFC7231 = $9e;
var H3 = Aa, _9e = Rn, L9e = ae;
const T9e = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"], R9e = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec"
];
function $9e(e) {
  const t = (0, L9e.toDate)(e);
  if (!(0, _9e.isValid)(t))
    throw new RangeError("Invalid time value");
  const r = T9e[t.getUTCDay()], n = (0, H3.addLeadingZeros)(t.getUTCDate(), 2), a = R9e[t.getUTCMonth()], i = t.getUTCFullYear(), o = (0, H3.addLeadingZeros)(t.getUTCHours(), 2), s = (0, H3.addLeadingZeros)(t.getUTCMinutes(), 2), c = (0, H3.addLeadingZeros)(t.getUTCSeconds(), 2);
  return `${r}, ${n} ${a} ${i} ${o}:${s}:${c} GMT`;
}
var wD = {};
wD.formatRelative = G9e;
var F9e = ha, H9e = Gt, Y9e = Je, V9e = Ln, k9e = N8;
function G9e(e, t, r) {
  var h, A, p, m;
  const [n, a] = (0, Y9e.normalizeDates)(
    r == null ? void 0 : r.in,
    e,
    t
  ), i = (0, H9e.getDefaultOptions)(), o = (r == null ? void 0 : r.locale) ?? i.locale ?? F9e.defaultLocale, s = (r == null ? void 0 : r.weekStartsOn) ?? ((A = (h = r == null ? void 0 : r.locale) == null ? void 0 : h.options) == null ? void 0 : A.weekStartsOn) ?? i.weekStartsOn ?? ((m = (p = i.locale) == null ? void 0 : p.options) == null ? void 0 : m.weekStartsOn) ?? 0, c = (0, V9e.differenceInCalendarDays)(n, a);
  if (isNaN(c))
    throw new RangeError("Invalid time value");
  let u;
  c < -6 ? u = "other" : c < -1 ? u = "lastWeek" : c < 0 ? u = "yesterday" : c < 1 ? u = "today" : c < 2 ? u = "tomorrow" : c < 7 ? u = "nextWeek" : u = "other";
  const d = o.formatRelative(u, n, a, {
    locale: o,
    weekStartsOn: s
  });
  return (0, k9e.format)(n, d, { locale: o, weekStartsOn: s });
}
var xD = {};
xD.fromUnixTime = Q9e;
var W9e = ae;
function Q9e(e, t) {
  return (0, W9e.toDate)(e * 1e3, t == null ? void 0 : t.in);
}
var k8 = {};
k8.getDate = Z9e;
var U9e = ae;
function Z9e(e, t) {
  return (0, U9e.toDate)(e, t == null ? void 0 : t.in).getDate();
}
var h3 = {};
h3.getDay = K9e;
var z9e = ae;
function K9e(e, t) {
  return (0, z9e.toDate)(e, t == null ? void 0 : t.in).getDay();
}
var G8 = {};
G8.getDaysInMonth = J9e;
var q9e = me, X9e = ae;
function J9e(e, t) {
  const r = (0, X9e.toDate)(e, t == null ? void 0 : t.in), n = r.getFullYear(), a = r.getMonth(), i = (0, q9e.constructFrom)(r, 0);
  return i.setFullYear(n, a + 1, 0), i.setHours(0, 0, 0, 0), i.getDate();
}
var OD = {}, W8 = {};
W8.isLeapYear = t8e;
var e8e = ae;
function t8e(e, t) {
  const n = (0, e8e.toDate)(e, t == null ? void 0 : t.in).getFullYear();
  return n % 400 === 0 || n % 4 === 0 && n % 100 !== 0;
}
OD.getDaysInYear = a8e;
var r8e = W8, n8e = ae;
function a8e(e, t) {
  const r = (0, n8e.toDate)(e, t == null ? void 0 : t.in);
  return Number.isNaN(+r) ? NaN : (0, r8e.isLeapYear)(r) ? 366 : 365;
}
var DD = {};
DD.getDecade = o8e;
var i8e = ae;
function o8e(e, t) {
  const n = (0, i8e.toDate)(e, t == null ? void 0 : t.in).getFullYear();
  return Math.floor(n / 10) * 10;
}
var Q8 = {};
Q8.getDefaultOptions = l8e;
var s8e = Gt;
function l8e() {
  return Object.assign({}, (0, s8e.getDefaultOptions)());
}
var MD = {};
MD.getHours = u8e;
var c8e = ae;
function u8e(e, t) {
  return (0, c8e.toDate)(e, t == null ? void 0 : t.in).getHours();
}
var U8 = {};
U8.getISODay = d8e;
var f8e = ae;
function d8e(e, t) {
  const r = (0, f8e.toDate)(e, t == null ? void 0 : t.in).getDay();
  return r === 0 ? 7 : r;
}
var ED = {};
ED.getISOWeeksInYear = p8e;
var h8e = s3, A8e = ce, lm = W2;
function p8e(e, t) {
  const r = (0, lm.startOfISOWeekYear)(e, t), a = +(0, lm.startOfISOWeekYear)(
    (0, h8e.addWeeks)(r, 60)
  ) - +r;
  return Math.round(a / A8e.millisecondsInWeek);
}
var PD = {};
PD.getMilliseconds = g8e;
var v8e = ae;
function g8e(e) {
  return (0, v8e.toDate)(e).getMilliseconds();
}
var jD = {};
jD.getMinutes = C8e;
var m8e = ae;
function C8e(e, t) {
  return (0, m8e.toDate)(e, t == null ? void 0 : t.in).getMinutes();
}
var SD = {};
SD.getMonth = y8e;
var b8e = ae;
function y8e(e, t) {
  return (0, b8e.toDate)(e, t == null ? void 0 : t.in).getMonth();
}
var ID = {};
ID.getOverlappingDaysInIntervals = x8e;
var cm = Tn, w8e = ce, Y3 = ae;
function x8e(e, t) {
  const [r, n] = [
    +(0, Y3.toDate)(e.start),
    +(0, Y3.toDate)(e.end)
  ].sort((h, A) => h - A), [a, i] = [
    +(0, Y3.toDate)(t.start),
    +(0, Y3.toDate)(t.end)
  ].sort((h, A) => h - A);
  if (!(r < i && a < n))
    return 0;
  const s = a < r ? r : a, c = s - (0, cm.getTimezoneOffsetInMilliseconds)(s), u = i > n ? n : i, d = u - (0, cm.getTimezoneOffsetInMilliseconds)(u);
  return Math.ceil((d - c) / w8e.millisecondsInDay);
}
var BD = {};
BD.getSeconds = D8e;
var O8e = ae;
function D8e(e) {
  return (0, O8e.toDate)(e).getSeconds();
}
var ND = {};
ND.getTime = E8e;
var M8e = ae;
function E8e(e) {
  return +(0, M8e.toDate)(e);
}
var _D = {};
_D.getUnixTime = j8e;
var P8e = ae;
function j8e(e) {
  return Math.trunc(+(0, P8e.toDate)(e) / 1e3);
}
var LD = {};
LD.getWeekOfMonth = L8e;
var S8e = Gt, I8e = k8, B8e = h3, N8e = u3, _8e = ae;
function L8e(e, t) {
  var c, u, d, h;
  const r = (0, S8e.getDefaultOptions)(), n = (t == null ? void 0 : t.weekStartsOn) ?? ((u = (c = t == null ? void 0 : t.locale) == null ? void 0 : c.options) == null ? void 0 : u.weekStartsOn) ?? r.weekStartsOn ?? ((h = (d = r.locale) == null ? void 0 : d.options) == null ? void 0 : h.weekStartsOn) ?? 0, a = (0, I8e.getDate)(
    (0, _8e.toDate)(e, t == null ? void 0 : t.in)
  );
  if (isNaN(a))
    return NaN;
  const i = (0, B8e.getDay)(
    (0, N8e.startOfMonth)(e, t)
  );
  let o = n - i;
  o <= 0 && (o += 7);
  const s = a - o;
  return Math.ceil(s / 7) + 1;
}
var TD = {}, Z8 = {};
Z8.lastDayOfMonth = T8e;
var um = ae;
function T8e(e, t) {
  const r = (0, um.toDate)(e, t == null ? void 0 : t.in), n = r.getMonth();
  return r.setFullYear(r.getFullYear(), n + 1, 0), r.setHours(0, 0, 0, 0), (0, um.toDate)(r, t == null ? void 0 : t.in);
}
TD.getWeeksInMonth = Y8e;
var R8e = ul, $8e = Z8, F8e = u3, H8e = ae;
function Y8e(e, t) {
  const r = (0, H8e.toDate)(e, t == null ? void 0 : t.in);
  return (0, R8e.differenceInCalendarWeeks)(
    (0, $8e.lastDayOfMonth)(r, t),
    (0, F8e.startOfMonth)(r, t),
    t
  ) + 1;
}
var RD = {};
RD.getYear = k8e;
var V8e = ae;
function k8e(e, t) {
  return (0, V8e.toDate)(e, t == null ? void 0 : t.in).getFullYear();
}
var $D = {};
$D.hoursToMilliseconds = W8e;
var G8e = ce;
function W8e(e) {
  return Math.trunc(e * G8e.millisecondsInHour);
}
var FD = {};
FD.hoursToMinutes = U8e;
var Q8e = ce;
function U8e(e) {
  return Math.trunc(e * Q8e.minutesInHour);
}
var HD = {};
HD.hoursToSeconds = z8e;
var Z8e = ce;
function z8e(e) {
  return Math.trunc(e * Z8e.secondsInHour);
}
var YD = {};
YD.interval = q8e;
var K8e = Je;
function q8e(e, t, r) {
  const [n, a] = (0, K8e.normalizeDates)(r == null ? void 0 : r.in, e, t);
  if (isNaN(+n))
    throw new TypeError("Start date is invalid");
  if (isNaN(+a))
    throw new TypeError("End date is invalid");
  if (r != null && r.assertPositive && +n > +a)
    throw new TypeError("End date must be after start date");
  return { start: n, end: a };
}
var VD = {};
VD.intervalToDuration = ife;
var X8e = pn, Ei = f8, J8e = dl, efe = hl, tfe = pl, rfe = l3, nfe = c3, afe = j8;
function ife(e, t) {
  const { start: r, end: n } = (0, X8e.normalizeInterval)(t == null ? void 0 : t.in, e), a = {}, i = (0, afe.differenceInYears)(n, r);
  i && (a.years = i);
  const o = (0, Ei.add)(r, { years: a.years }), s = (0, rfe.differenceInMonths)(n, o);
  s && (a.months = s);
  const c = (0, Ei.add)(o, {
    months: a.months
  }), u = (0, J8e.differenceInDays)(n, c);
  u && (a.days = u);
  const d = (0, Ei.add)(c, {
    days: a.days
  }), h = (0, efe.differenceInHours)(n, d);
  h && (a.hours = h);
  const A = (0, Ei.add)(d, {
    hours: a.hours
  }), p = (0, tfe.differenceInMinutes)(n, A);
  p && (a.minutes = p);
  const m = (0, Ei.add)(A, {
    minutes: a.minutes
  }), g = (0, nfe.differenceInSeconds)(n, m);
  return g && (a.seconds = g), a;
}
var kD = {};
kD.intlFormat = sfe;
var ofe = ae;
function sfe(e, t, r) {
  let n;
  return lfe(t) ? n = t : r = t, new Intl.DateTimeFormat(r == null ? void 0 : r.locale, n).format(
    (0, ofe.toDate)(e)
  );
}
function lfe(e) {
  return e !== void 0 && !("locale" in e);
}
var GD = {};
GD.intlFormatDistance = ufe;
var cfe = Je, I1 = ce, g4 = Ln, fm = cl, m4 = D8, dm = ul, C4 = fl, hm = hl, Am = pl, b4 = c3;
function ufe(e, t, r) {
  let n = 0, a;
  const [i, o] = (0, cfe.normalizeDates)(
    r == null ? void 0 : r.in,
    e,
    t
  );
  if (r != null && r.unit)
    a = r == null ? void 0 : r.unit, a === "second" ? n = (0, b4.differenceInSeconds)(i, o) : a === "minute" ? n = (0, Am.differenceInMinutes)(i, o) : a === "hour" ? n = (0, hm.differenceInHours)(i, o) : a === "day" ? n = (0, g4.differenceInCalendarDays)(i, o) : a === "week" ? n = (0, dm.differenceInCalendarWeeks)(i, o) : a === "month" ? n = (0, fm.differenceInCalendarMonths)(i, o) : a === "quarter" ? n = (0, m4.differenceInCalendarQuarters)(
      i,
      o
    ) : a === "year" && (n = (0, C4.differenceInCalendarYears)(i, o));
  else {
    const c = (0, b4.differenceInSeconds)(
      i,
      o
    );
    Math.abs(c) < I1.secondsInMinute ? (n = (0, b4.differenceInSeconds)(i, o), a = "second") : Math.abs(c) < I1.secondsInHour ? (n = (0, Am.differenceInMinutes)(i, o), a = "minute") : Math.abs(c) < I1.secondsInDay && Math.abs(
      (0, g4.differenceInCalendarDays)(i, o)
    ) < 1 ? (n = (0, hm.differenceInHours)(i, o), a = "hour") : Math.abs(c) < I1.secondsInWeek && (n = (0, g4.differenceInCalendarDays)(
      i,
      o
    )) && Math.abs(n) < 7 ? a = "day" : Math.abs(c) < I1.secondsInMonth ? (n = (0, dm.differenceInCalendarWeeks)(i, o), a = "week") : Math.abs(c) < I1.secondsInQuarter ? (n = (0, fm.differenceInCalendarMonths)(i, o), a = "month") : Math.abs(c) < I1.secondsInYear && (0, m4.differenceInCalendarQuarters)(i, o) < 4 ? (n = (0, m4.differenceInCalendarQuarters)(
      i,
      o
    ), a = "quarter") : (n = (0, C4.differenceInCalendarYears)(i, o), a = "year");
  }
  return new Intl.RelativeTimeFormat(r == null ? void 0 : r.locale, {
    numeric: "auto",
    ...r
  }).format(n, a);
}
var WD = {};
WD.isAfter = ffe;
var pm = ae;
function ffe(e, t) {
  return +(0, pm.toDate)(e) > +(0, pm.toDate)(t);
}
var QD = {};
QD.isBefore = dfe;
var vm = ae;
function dfe(e, t) {
  return +(0, vm.toDate)(e) < +(0, vm.toDate)(t);
}
var UD = {};
UD.isEqual = hfe;
var gm = ae;
function hfe(e, t) {
  return +(0, gm.toDate)(e) == +(0, gm.toDate)(t);
}
var ZD = {};
ZD.isExists = Afe;
function Afe(e, t, r) {
  const n = new Date(e, t, r);
  return n.getFullYear() === e && n.getMonth() === t && n.getDate() === r;
}
var zD = {};
zD.isFirstDayOfMonth = vfe;
var pfe = ae;
function vfe(e, t) {
  return (0, pfe.toDate)(e, t == null ? void 0 : t.in).getDate() === 1;
}
var KD = {};
KD.isFriday = mfe;
var gfe = ae;
function mfe(e, t) {
  return (0, gfe.toDate)(e, t == null ? void 0 : t.in).getDay() === 5;
}
var qD = {};
qD.isFuture = bfe;
var Cfe = ae;
function bfe(e) {
  return +(0, Cfe.toDate)(e) > Date.now();
}
var XD = {}, z8 = {}, s1 = {}, K8 = {};
K8.transpose = wfe;
var yfe = me;
function wfe(e, t) {
  const r = xfe(t) ? new t(0) : (0, yfe.constructFrom)(t, 0);
  return r.setFullYear(e.getFullYear(), e.getMonth(), e.getDate()), r.setHours(
    e.getHours(),
    e.getMinutes(),
    e.getSeconds(),
    e.getMilliseconds()
  ), r;
}
function xfe(e) {
  var t;
  return typeof e == "function" && ((t = e.prototype) == null ? void 0 : t.constructor) === e;
}
s1.ValueSetter = s1.Setter = s1.DateTimezoneSetter = void 0;
var mm = me, Ofe = K8;
const Dfe = 10;
class q8 {
  constructor() {
    fe(this, "subPriority", 0);
  }
  validate(t, r) {
    return !0;
  }
}
s1.Setter = q8;
class Mfe extends q8 {
  constructor(t, r, n, a, i) {
    super(), this.value = t, this.validateValue = r, this.setValue = n, this.priority = a, i && (this.subPriority = i);
  }
  validate(t, r) {
    return this.validateValue(t, this.value, r);
  }
  set(t, r, n) {
    return this.setValue(t, r, this.value, n);
  }
}
s1.ValueSetter = Mfe;
class Efe extends q8 {
  constructor(r, n) {
    super();
    fe(this, "priority", Dfe);
    fe(this, "subPriority", -1);
    this.context = r || ((a) => (0, mm.constructFrom)(n, a));
  }
  set(r, n) {
    return n.timestampIsSet ? r : (0, mm.constructFrom)(
      r,
      (0, Ofe.transpose)(r, this.context)
    );
  }
}
s1.DateTimezoneSetter = Efe;
var X8 = {}, J8 = {}, Ve = {};
Ve.Parser = void 0;
var Pfe = s1;
class jfe {
  run(t, r, n, a) {
    const i = this.parse(t, r, n, a);
    return i ? {
      setter: new Pfe.ValueSetter(
        i.value,
        this.validate,
        this.set,
        this.priority,
        this.subPriority
      ),
      rest: i.rest
    } : null;
  }
  validate(t, r, n) {
    return !0;
  }
}
Ve.Parser = jfe;
J8.EraParser = void 0;
var Sfe = Ve;
class Ife extends Sfe.Parser {
  constructor() {
    super(...arguments);
    fe(this, "priority", 140);
    fe(this, "incompatibleTokens", ["R", "u", "t", "T"]);
  }
  parse(r, n, a) {
    switch (n) {
      case "G":
      case "GG":
      case "GGG":
        return a.era(r, { width: "abbreviated" }) || a.era(r, { width: "narrow" });
      case "GGGGG":
        return a.era(r, { width: "narrow" });
      case "GGGG":
      default:
        return a.era(r, { width: "wide" }) || a.era(r, { width: "abbreviated" }) || a.era(r, { width: "narrow" });
    }
  }
  set(r, n, a) {
    return n.era = a, r.setFullYear(a, 0, 1), r.setHours(0, 0, 0, 0), r;
  }
}
J8.EraParser = Ife;
var ef = {}, Le = {}, _t = {};
_t.timezonePatterns = _t.numericPatterns = void 0;
_t.numericPatterns = {
  month: /^(1[0-2]|0?\d)/,
  // 0 to 12
  date: /^(3[0-1]|[0-2]?\d)/,
  // 0 to 31
  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
  // 0 to 366
  week: /^(5[0-3]|[0-4]?\d)/,
  // 0 to 53
  hour23h: /^(2[0-3]|[0-1]?\d)/,
  // 0 to 23
  hour24h: /^(2[0-4]|[0-1]?\d)/,
  // 0 to 24
  hour11h: /^(1[0-1]|0?\d)/,
  // 0 to 11
  hour12h: /^(1[0-2]|0?\d)/,
  // 0 to 12
  minute: /^[0-5]?\d/,
  // 0 to 59
  second: /^[0-5]?\d/,
  // 0 to 59
  singleDigit: /^\d/,
  // 0 to 9
  twoDigits: /^\d{1,2}/,
  // 0 to 99
  threeDigits: /^\d{1,3}/,
  // 0 to 999
  fourDigits: /^\d{1,4}/,
  // 0 to 9999
  anyDigitsSigned: /^-?\d+/,
  singleDigitSigned: /^-?\d/,
  // 0 to 9, -0 to -9
  twoDigitsSigned: /^-?\d{1,2}/,
  // 0 to 99, -0 to -99
  threeDigitsSigned: /^-?\d{1,3}/,
  // 0 to 999, -0 to -999
  fourDigitsSigned: /^-?\d{1,4}/
  // 0 to 9999, -0 to -9999
};
_t.timezonePatterns = {
  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
  basic: /^([+-])(\d{2})(\d{2})|Z/,
  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
  extended: /^([+-])(\d{2}):(\d{2})|Z/,
  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};
Le.dayPeriodEnumToHours = Rfe;
Le.isLeapYearIndex = Ffe;
Le.mapValue = Bfe;
Le.normalizeTwoDigitYear = $fe;
Le.parseAnyDigitsSigned = _fe;
Le.parseNDigits = Lfe;
Le.parseNDigitsSigned = Tfe;
Le.parseNumericPattern = Er;
Le.parseTimezonePattern = Nfe;
var y4 = ce, xn = _t;
function Bfe(e, t) {
  return e && {
    value: t(e.value),
    rest: e.rest
  };
}
function Er(e, t) {
  const r = t.match(e);
  return r ? {
    value: parseInt(r[0], 10),
    rest: t.slice(r[0].length)
  } : null;
}
function Nfe(e, t) {
  const r = t.match(e);
  if (!r)
    return null;
  if (r[0] === "Z")
    return {
      value: 0,
      rest: t.slice(1)
    };
  const n = r[1] === "+" ? 1 : -1, a = r[2] ? parseInt(r[2], 10) : 0, i = r[3] ? parseInt(r[3], 10) : 0, o = r[5] ? parseInt(r[5], 10) : 0;
  return {
    value: n * (a * y4.millisecondsInHour + i * y4.millisecondsInMinute + o * y4.millisecondsInSecond),
    rest: t.slice(r[0].length)
  };
}
function _fe(e) {
  return Er(
    xn.numericPatterns.anyDigitsSigned,
    e
  );
}
function Lfe(e, t) {
  switch (e) {
    case 1:
      return Er(
        xn.numericPatterns.singleDigit,
        t
      );
    case 2:
      return Er(
        xn.numericPatterns.twoDigits,
        t
      );
    case 3:
      return Er(
        xn.numericPatterns.threeDigits,
        t
      );
    case 4:
      return Er(
        xn.numericPatterns.fourDigits,
        t
      );
    default:
      return Er(new RegExp("^\\d{1," + e + "}"), t);
  }
}
function Tfe(e, t) {
  switch (e) {
    case 1:
      return Er(
        xn.numericPatterns.singleDigitSigned,
        t
      );
    case 2:
      return Er(
        xn.numericPatterns.twoDigitsSigned,
        t
      );
    case 3:
      return Er(
        xn.numericPatterns.threeDigitsSigned,
        t
      );
    case 4:
      return Er(
        xn.numericPatterns.fourDigitsSigned,
        t
      );
    default:
      return Er(new RegExp("^-?\\d{1," + e + "}"), t);
  }
}
function Rfe(e) {
  switch (e) {
    case "morning":
      return 4;
    case "evening":
      return 17;
    case "pm":
    case "noon":
    case "afternoon":
      return 12;
    case "am":
    case "midnight":
    case "night":
    default:
      return 0;
  }
}
function $fe(e, t) {
  const r = t > 0, n = r ? t : 1 - t;
  let a;
  if (n <= 50)
    a = e || 100;
  else {
    const i = n + 50, o = Math.trunc(i / 100) * 100, s = e >= i % 100;
    a = e + o - (s ? 100 : 0);
  }
  return r ? a : 1 - a;
}
function Ffe(e) {
  return e % 400 === 0 || e % 4 === 0 && e % 100 !== 0;
}
ef.YearParser = void 0;
var Hfe = Ve, Na = Le;
class Yfe extends Hfe.Parser {
  constructor() {
    super(...arguments);
    fe(this, "priority", 130);
    fe(this, "incompatibleTokens", ["Y", "R", "u", "w", "I", "i", "e", "c", "t", "T"]);
  }
  parse(r, n, a) {
    const i = (o) => ({
      year: o,
      isTwoDigitYear: n === "yy"
    });
    switch (n) {
      case "y":
        return (0, Na.mapValue)(
          (0, Na.parseNDigits)(4, r),
          i
        );
      case "yo":
        return (0, Na.mapValue)(
          a.ordinalNumber(r, {
            unit: "year"
          }),
          i
        );
      default:
        return (0, Na.mapValue)(
          (0, Na.parseNDigits)(n.length, r),
          i
        );
    }
  }
  validate(r, n) {
    return n.isTwoDigitYear || n.year > 0;
  }
  set(r, n, a) {
    const i = r.getFullYear();
    if (a.isTwoDigitYear) {
      const s = (0, Na.normalizeTwoDigitYear)(
        a.year,
        i
      );
      return r.setFullYear(s, 0, 1), r.setHours(0, 0, 0, 0), r;
    }
    const o = !("era" in n) || n.era === 1 ? a.year : 1 - a.year;
    return r.setFullYear(o, 0, 1), r.setHours(0, 0, 0, 0), r;
  }
}
ef.YearParser = Yfe;
var tf = {};
tf.LocalWeekYearParser = void 0;
var Vfe = f3, Cm = Kr, kfe = Ve, _a = Le;
class Gfe extends kfe.Parser {
  constructor() {
    super(...arguments);
    fe(this, "priority", 130);
    fe(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "Q",
      "q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "i",
      "t",
      "T"
    ]);
  }
  parse(r, n, a) {
    const i = (o) => ({
      year: o,
      isTwoDigitYear: n === "YY"
    });
    switch (n) {
      case "Y":
        return (0, _a.mapValue)(
          (0, _a.parseNDigits)(4, r),
          i
        );
      case "Yo":
        return (0, _a.mapValue)(
          a.ordinalNumber(r, {
            unit: "year"
          }),
          i
        );
      default:
        return (0, _a.mapValue)(
          (0, _a.parseNDigits)(n.length, r),
          i
        );
    }
  }
  validate(r, n) {
    return n.isTwoDigitYear || n.year > 0;
  }
  set(r, n, a, i) {
    const o = (0, Vfe.getWeekYear)(r, i);
    if (a.isTwoDigitYear) {
      const c = (0, _a.normalizeTwoDigitYear)(
        a.year,
        o
      );
      return r.setFullYear(
        c,
        0,
        i.firstWeekContainsDate
      ), r.setHours(0, 0, 0, 0), (0, Cm.startOfWeek)(r, i);
    }
    const s = !("era" in n) || n.era === 1 ? a.year : 1 - a.year;
    return r.setFullYear(s, 0, i.firstWeekContainsDate), r.setHours(0, 0, 0, 0), (0, Cm.startOfWeek)(r, i);
  }
}
tf.LocalWeekYearParser = Gfe;
var rf = {};
rf.ISOWeekYearParser = void 0;
var Wfe = An, Qfe = me, Ufe = Ve, bm = Le;
class Zfe extends Ufe.Parser {
  constructor() {
    super(...arguments);
    fe(this, "priority", 130);
    fe(this, "incompatibleTokens", [
      "G",
      "y",
      "Y",
      "u",
      "Q",
      "q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(r, n) {
    return n === "R" ? (0, bm.parseNDigitsSigned)(4, r) : (0, bm.parseNDigitsSigned)(n.length, r);
  }
  set(r, n, a) {
    const i = (0, Qfe.constructFrom)(r, 0);
    return i.setFullYear(a, 0, 4), i.setHours(0, 0, 0, 0), (0, Wfe.startOfISOWeek)(i);
  }
}
rf.ISOWeekYearParser = Zfe;
var nf = {};
nf.ExtendedYearParser = void 0;
var zfe = Ve, ym = Le;
class Kfe extends zfe.Parser {
  constructor() {
    super(...arguments);
    fe(this, "priority", 130);
    fe(this, "incompatibleTokens", ["G", "y", "Y", "R", "w", "I", "i", "e", "c", "t", "T"]);
  }
  parse(r, n) {
    return n === "u" ? (0, ym.parseNDigitsSigned)(4, r) : (0, ym.parseNDigitsSigned)(n.length, r);
  }
  set(r, n, a) {
    return r.setFullYear(a, 0, 1), r.setHours(0, 0, 0, 0), r;
  }
}
nf.ExtendedYearParser = Kfe;
var af = {};
af.QuarterParser = void 0;
var qfe = Ve, Xfe = Le;
class Jfe extends qfe.Parser {
  constructor() {
    super(...arguments);
    fe(this, "priority", 120);
    fe(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(r, n, a) {
    switch (n) {
      case "Q":
      case "QQ":
        return (0, Xfe.parseNDigits)(n.length, r);
      case "Qo":
        return a.ordinalNumber(r, { unit: "quarter" });
      case "QQQ":
        return a.quarter(r, {
          width: "abbreviated",
          context: "formatting"
        }) || a.quarter(r, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQQ":
        return a.quarter(r, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return a.quarter(r, {
          width: "wide",
          context: "formatting"
        }) || a.quarter(r, {
          width: "abbreviated",
          context: "formatting"
        }) || a.quarter(r, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  validate(r, n) {
    return n >= 1 && n <= 4;
  }
  set(r, n, a) {
    return r.setMonth((a - 1) * 3, 1), r.setHours(0, 0, 0, 0), r;
  }
}
af.QuarterParser = Jfe;
var of = {};
of.StandAloneQuarterParser = void 0;
var ede = Ve, tde = Le;
class rde extends ede.Parser {
  constructor() {
    super(...arguments);
    fe(this, "priority", 120);
    fe(this, "incompatibleTokens", [
      "Y",
      "R",
      "Q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(r, n, a) {
    switch (n) {
      case "q":
      case "qq":
        return (0, tde.parseNDigits)(n.length, r);
      case "qo":
        return a.ordinalNumber(r, { unit: "quarter" });
      case "qqq":
        return a.quarter(r, {
          width: "abbreviated",
          context: "standalone"
        }) || a.quarter(r, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqqq":
        return a.quarter(r, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return a.quarter(r, {
          width: "wide",
          context: "standalone"
        }) || a.quarter(r, {
          width: "abbreviated",
          context: "standalone"
        }) || a.quarter(r, {
          width: "narrow",
          context: "standalone"
        });
    }
  }
  validate(r, n) {
    return n >= 1 && n <= 4;
  }
  set(r, n, a) {
    return r.setMonth((a - 1) * 3, 1), r.setHours(0, 0, 0, 0), r;
  }
}
of.StandAloneQuarterParser = rde;
var sf = {};
sf.MonthParser = void 0;
var nde = _t, ade = Ve, Pi = Le;
class ide extends ade.Parser {
  constructor() {
    super(...arguments);
    fe(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "L",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
    fe(this, "priority", 110);
  }
  parse(r, n, a) {
    const i = (o) => o - 1;
    switch (n) {
      case "M":
        return (0, Pi.mapValue)(
          (0, Pi.parseNumericPattern)(
            nde.numericPatterns.month,
            r
          ),
          i
        );
      case "MM":
        return (0, Pi.mapValue)(
          (0, Pi.parseNDigits)(2, r),
          i
        );
      case "Mo":
        return (0, Pi.mapValue)(
          a.ordinalNumber(r, {
            unit: "month"
          }),
          i
        );
      case "MMM":
        return a.month(r, {
          width: "abbreviated",
          context: "formatting"
        }) || a.month(r, { width: "narrow", context: "formatting" });
      case "MMMMM":
        return a.month(r, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return a.month(r, { width: "wide", context: "formatting" }) || a.month(r, {
          width: "abbreviated",
          context: "formatting"
        }) || a.month(r, { width: "narrow", context: "formatting" });
    }
  }
  validate(r, n) {
    return n >= 0 && n <= 11;
  }
  set(r, n, a) {
    return r.setMonth(a, 1), r.setHours(0, 0, 0, 0), r;
  }
}
sf.MonthParser = ide;
var lf = {};
lf.StandAloneMonthParser = void 0;
var ode = _t, sde = Ve, ji = Le;
class lde extends sde.Parser {
  constructor() {
    super(...arguments);
    fe(this, "priority", 110);
    fe(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "M",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(r, n, a) {
    const i = (o) => o - 1;
    switch (n) {
      case "L":
        return (0, ji.mapValue)(
          (0, ji.parseNumericPattern)(
            ode.numericPatterns.month,
            r
          ),
          i
        );
      case "LL":
        return (0, ji.mapValue)(
          (0, ji.parseNDigits)(2, r),
          i
        );
      case "Lo":
        return (0, ji.mapValue)(
          a.ordinalNumber(r, {
            unit: "month"
          }),
          i
        );
      case "LLL":
        return a.month(r, {
          width: "abbreviated",
          context: "standalone"
        }) || a.month(r, { width: "narrow", context: "standalone" });
      case "LLLLL":
        return a.month(r, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return a.month(r, { width: "wide", context: "standalone" }) || a.month(r, {
          width: "abbreviated",
          context: "standalone"
        }) || a.month(r, { width: "narrow", context: "standalone" });
    }
  }
  validate(r, n) {
    return n >= 0 && n <= 11;
  }
  set(r, n, a) {
    return r.setMonth(a, 1), r.setHours(0, 0, 0, 0), r;
  }
}
lf.StandAloneMonthParser = lde;
var cf = {}, uf = {};
uf.setWeek = ude;
var cde = xl, wm = ae;
function ude(e, t, r) {
  const n = (0, wm.toDate)(e, r == null ? void 0 : r.in), a = (0, cde.getWeek)(n, r) - t;
  return n.setDate(n.getDate() - a * 7), (0, wm.toDate)(n, r == null ? void 0 : r.in);
}
cf.LocalWeekParser = void 0;
var fde = uf, dde = Kr, hde = _t, Ade = Ve, xm = Le;
class pde extends Ade.Parser {
  constructor() {
    super(...arguments);
    fe(this, "priority", 100);
    fe(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "i",
      "t",
      "T"
    ]);
  }
  parse(r, n, a) {
    switch (n) {
      case "w":
        return (0, xm.parseNumericPattern)(
          hde.numericPatterns.week,
          r
        );
      case "wo":
        return a.ordinalNumber(r, { unit: "week" });
      default:
        return (0, xm.parseNDigits)(n.length, r);
    }
  }
  validate(r, n) {
    return n >= 1 && n <= 53;
  }
  set(r, n, a, i) {
    return (0, dde.startOfWeek)(
      (0, fde.setWeek)(r, a, i),
      i
    );
  }
}
cf.LocalWeekParser = pde;
var ff = {}, df = {};
df.setISOWeek = mde;
var vde = wl, gde = ae;
function mde(e, t, r) {
  const n = (0, gde.toDate)(e, r == null ? void 0 : r.in), a = (0, vde.getISOWeek)(n, r) - t;
  return n.setDate(n.getDate() - a * 7), n;
}
ff.ISOWeekParser = void 0;
var Cde = df, bde = An, yde = _t, wde = Ve, Om = Le;
class xde extends wde.Parser {
  constructor() {
    super(...arguments);
    fe(this, "priority", 100);
    fe(this, "incompatibleTokens", [
      "y",
      "Y",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(r, n, a) {
    switch (n) {
      case "I":
        return (0, Om.parseNumericPattern)(
          yde.numericPatterns.week,
          r
        );
      case "Io":
        return a.ordinalNumber(r, { unit: "week" });
      default:
        return (0, Om.parseNDigits)(n.length, r);
    }
  }
  validate(r, n) {
    return n >= 1 && n <= 53;
  }
  set(r, n, a) {
    return (0, bde.startOfISOWeek)((0, Cde.setISOWeek)(r, a));
  }
}
ff.ISOWeekParser = xde;
var hf = {};
hf.DateParser = void 0;
var Ode = _t, Dde = Ve, w4 = Le;
const Mde = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], Ede = [
  31,
  29,
  31,
  30,
  31,
  30,
  31,
  31,
  30,
  31,
  30,
  31
];
class Pde extends Dde.Parser {
  constructor() {
    super(...arguments);
    fe(this, "priority", 90);
    fe(this, "subPriority", 1);
    fe(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(r, n, a) {
    switch (n) {
      case "d":
        return (0, w4.parseNumericPattern)(
          Ode.numericPatterns.date,
          r
        );
      case "do":
        return a.ordinalNumber(r, { unit: "date" });
      default:
        return (0, w4.parseNDigits)(n.length, r);
    }
  }
  validate(r, n) {
    const a = r.getFullYear(), i = (0, w4.isLeapYearIndex)(a), o = r.getMonth();
    return i ? n >= 1 && n <= Ede[o] : n >= 1 && n <= Mde[o];
  }
  set(r, n, a) {
    return r.setDate(a), r.setHours(0, 0, 0, 0), r;
  }
}
hf.DateParser = Pde;
var Af = {};
Af.DayOfYearParser = void 0;
var jde = _t, Sde = Ve, x4 = Le;
class Ide extends Sde.Parser {
  constructor() {
    super(...arguments);
    fe(this, "priority", 90);
    fe(this, "subpriority", 1);
    fe(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "E",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(r, n, a) {
    switch (n) {
      case "D":
      case "DD":
        return (0, x4.parseNumericPattern)(
          jde.numericPatterns.dayOfYear,
          r
        );
      case "Do":
        return a.ordinalNumber(r, { unit: "date" });
      default:
        return (0, x4.parseNDigits)(n.length, r);
    }
  }
  validate(r, n) {
    const a = r.getFullYear();
    return (0, x4.isLeapYearIndex)(a) ? n >= 1 && n <= 366 : n >= 1 && n <= 365;
  }
  set(r, n, a) {
    return r.setMonth(0, a), r.setHours(0, 0, 0, 0), r;
  }
}
Af.DayOfYearParser = Ide;
var pf = {}, A3 = {};
A3.setDay = Lde;
var Bde = Gt, Nde = hn, _de = ae;
function Lde(e, t, r) {
  var h, A, p, m;
  const n = (0, Bde.getDefaultOptions)(), a = (r == null ? void 0 : r.weekStartsOn) ?? ((A = (h = r == null ? void 0 : r.locale) == null ? void 0 : h.options) == null ? void 0 : A.weekStartsOn) ?? n.weekStartsOn ?? ((m = (p = n.locale) == null ? void 0 : p.options) == null ? void 0 : m.weekStartsOn) ?? 0, i = (0, _de.toDate)(e, r == null ? void 0 : r.in), o = i.getDay(), c = (t % 7 + 7) % 7, u = 7 - a, d = t < 0 || t > 6 ? t - (o + u) % 7 : (c + u) % 7 - (o + u) % 7;
  return (0, Nde.addDays)(i, d, r);
}
pf.DayParser = void 0;
var Tde = A3, Rde = Ve;
class $de extends Rde.Parser {
  constructor() {
    super(...arguments);
    fe(this, "priority", 90);
    fe(this, "incompatibleTokens", ["D", "i", "e", "c", "t", "T"]);
  }
  parse(r, n, a) {
    switch (n) {
      case "E":
      case "EE":
      case "EEE":
        return a.day(r, {
          width: "abbreviated",
          context: "formatting"
        }) || a.day(r, { width: "short", context: "formatting" }) || a.day(r, { width: "narrow", context: "formatting" });
      case "EEEEE":
        return a.day(r, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return a.day(r, { width: "short", context: "formatting" }) || a.day(r, { width: "narrow", context: "formatting" });
      case "EEEE":
      default:
        return a.day(r, { width: "wide", context: "formatting" }) || a.day(r, {
          width: "abbreviated",
          context: "formatting"
        }) || a.day(r, { width: "short", context: "formatting" }) || a.day(r, { width: "narrow", context: "formatting" });
    }
  }
  validate(r, n) {
    return n >= 0 && n <= 6;
  }
  set(r, n, a, i) {
    return r = (0, Tde.setDay)(r, a, i), r.setHours(0, 0, 0, 0), r;
  }
}
pf.DayParser = $de;
var vf = {};
vf.LocalDayParser = void 0;
var Fde = A3, Hde = Ve, O4 = Le;
class Yde extends Hde.Parser {
  constructor() {
    super(...arguments);
    fe(this, "priority", 90);
    fe(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "E",
      "i",
      "c",
      "t",
      "T"
    ]);
  }
  parse(r, n, a, i) {
    const o = (s) => {
      const c = Math.floor((s - 1) / 7) * 7;
      return (s + i.weekStartsOn + 6) % 7 + c;
    };
    switch (n) {
      case "e":
      case "ee":
        return (0, O4.mapValue)(
          (0, O4.parseNDigits)(n.length, r),
          o
        );
      case "eo":
        return (0, O4.mapValue)(
          a.ordinalNumber(r, {
            unit: "day"
          }),
          o
        );
      case "eee":
        return a.day(r, {
          width: "abbreviated",
          context: "formatting"
        }) || a.day(r, { width: "short", context: "formatting" }) || a.day(r, { width: "narrow", context: "formatting" });
      case "eeeee":
        return a.day(r, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return a.day(r, { width: "short", context: "formatting" }) || a.day(r, { width: "narrow", context: "formatting" });
      case "eeee":
      default:
        return a.day(r, { width: "wide", context: "formatting" }) || a.day(r, {
          width: "abbreviated",
          context: "formatting"
        }) || a.day(r, { width: "short", context: "formatting" }) || a.day(r, { width: "narrow", context: "formatting" });
    }
  }
  validate(r, n) {
    return n >= 0 && n <= 6;
  }
  set(r, n, a, i) {
    return r = (0, Fde.setDay)(r, a, i), r.setHours(0, 0, 0, 0), r;
  }
}
vf.LocalDayParser = Yde;
var gf = {};
gf.StandAloneLocalDayParser = void 0;
var Vde = A3, kde = Ve, D4 = Le;
class Gde extends kde.Parser {
  constructor() {
    super(...arguments);
    fe(this, "priority", 90);
    fe(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "E",
      "i",
      "e",
      "t",
      "T"
    ]);
  }
  parse(r, n, a, i) {
    const o = (s) => {
      const c = Math.floor((s - 1) / 7) * 7;
      return (s + i.weekStartsOn + 6) % 7 + c;
    };
    switch (n) {
      case "c":
      case "cc":
        return (0, D4.mapValue)(
          (0, D4.parseNDigits)(n.length, r),
          o
        );
      case "co":
        return (0, D4.mapValue)(
          a.ordinalNumber(r, {
            unit: "day"
          }),
          o
        );
      case "ccc":
        return a.day(r, {
          width: "abbreviated",
          context: "standalone"
        }) || a.day(r, { width: "short", context: "standalone" }) || a.day(r, { width: "narrow", context: "standalone" });
      case "ccccc":
        return a.day(r, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return a.day(r, { width: "short", context: "standalone" }) || a.day(r, { width: "narrow", context: "standalone" });
      case "cccc":
      default:
        return a.day(r, { width: "wide", context: "standalone" }) || a.day(r, {
          width: "abbreviated",
          context: "standalone"
        }) || a.day(r, { width: "short", context: "standalone" }) || a.day(r, { width: "narrow", context: "standalone" });
    }
  }
  validate(r, n) {
    return n >= 0 && n <= 6;
  }
  set(r, n, a, i) {
    return r = (0, Vde.setDay)(r, a, i), r.setHours(0, 0, 0, 0), r;
  }
}
gf.StandAloneLocalDayParser = Gde;
var mf = {}, Cf = {};
Cf.setISODay = Zde;
var Wde = hn, Qde = U8, Ude = ae;
function Zde(e, t, r) {
  const n = (0, Ude.toDate)(e, r == null ? void 0 : r.in), a = (0, Qde.getISODay)(n, r), i = t - a;
  return (0, Wde.addDays)(n, i, r);
}
mf.ISODayParser = void 0;
var zde = Cf, Kde = Ve, Si = Le;
class qde extends Kde.Parser {
  constructor() {
    super(...arguments);
    fe(this, "priority", 90);
    fe(this, "incompatibleTokens", [
      "y",
      "Y",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "E",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(r, n, a) {
    const i = (o) => o === 0 ? 7 : o;
    switch (n) {
      case "i":
      case "ii":
        return (0, Si.parseNDigits)(n.length, r);
      case "io":
        return a.ordinalNumber(r, { unit: "day" });
      case "iii":
        return (0, Si.mapValue)(
          a.day(r, {
            width: "abbreviated",
            context: "formatting"
          }) || a.day(r, {
            width: "short",
            context: "formatting"
          }) || a.day(r, {
            width: "narrow",
            context: "formatting"
          }),
          i
        );
      case "iiiii":
        return (0, Si.mapValue)(
          a.day(r, {
            width: "narrow",
            context: "formatting"
          }),
          i
        );
      case "iiiiii":
        return (0, Si.mapValue)(
          a.day(r, {
            width: "short",
            context: "formatting"
          }) || a.day(r, {
            width: "narrow",
            context: "formatting"
          }),
          i
        );
      case "iiii":
      default:
        return (0, Si.mapValue)(
          a.day(r, {
            width: "wide",
            context: "formatting"
          }) || a.day(r, {
            width: "abbreviated",
            context: "formatting"
          }) || a.day(r, {
            width: "short",
            context: "formatting"
          }) || a.day(r, {
            width: "narrow",
            context: "formatting"
          }),
          i
        );
    }
  }
  validate(r, n) {
    return n >= 1 && n <= 7;
  }
  set(r, n, a) {
    return r = (0, zde.setISODay)(r, a), r.setHours(0, 0, 0, 0), r;
  }
}
mf.ISODayParser = qde;
var bf = {};
bf.AMPMParser = void 0;
var Xde = Ve, Jde = Le;
class ehe extends Xde.Parser {
  constructor() {
    super(...arguments);
    fe(this, "priority", 80);
    fe(this, "incompatibleTokens", ["b", "B", "H", "k", "t", "T"]);
  }
  parse(r, n, a) {
    switch (n) {
      case "a":
      case "aa":
      case "aaa":
        return a.dayPeriod(r, {
          width: "abbreviated",
          context: "formatting"
        }) || a.dayPeriod(r, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaaa":
        return a.dayPeriod(r, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return a.dayPeriod(r, {
          width: "wide",
          context: "formatting"
        }) || a.dayPeriod(r, {
          width: "abbreviated",
          context: "formatting"
        }) || a.dayPeriod(r, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(r, n, a) {
    return r.setHours((0, Jde.dayPeriodEnumToHours)(a), 0, 0, 0), r;
  }
}
bf.AMPMParser = ehe;
var yf = {};
yf.AMPMMidnightParser = void 0;
var the = Ve, rhe = Le;
class nhe extends the.Parser {
  constructor() {
    super(...arguments);
    fe(this, "priority", 80);
    fe(this, "incompatibleTokens", ["a", "B", "H", "k", "t", "T"]);
  }
  parse(r, n, a) {
    switch (n) {
      case "b":
      case "bb":
      case "bbb":
        return a.dayPeriod(r, {
          width: "abbreviated",
          context: "formatting"
        }) || a.dayPeriod(r, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbbb":
        return a.dayPeriod(r, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return a.dayPeriod(r, {
          width: "wide",
          context: "formatting"
        }) || a.dayPeriod(r, {
          width: "abbreviated",
          context: "formatting"
        }) || a.dayPeriod(r, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(r, n, a) {
    return r.setHours((0, rhe.dayPeriodEnumToHours)(a), 0, 0, 0), r;
  }
}
yf.AMPMMidnightParser = nhe;
var wf = {};
wf.DayPeriodParser = void 0;
var ahe = Ve, ihe = Le;
class ohe extends ahe.Parser {
  constructor() {
    super(...arguments);
    fe(this, "priority", 80);
    fe(this, "incompatibleTokens", ["a", "b", "t", "T"]);
  }
  parse(r, n, a) {
    switch (n) {
      case "B":
      case "BB":
      case "BBB":
        return a.dayPeriod(r, {
          width: "abbreviated",
          context: "formatting"
        }) || a.dayPeriod(r, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBBB":
        return a.dayPeriod(r, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return a.dayPeriod(r, {
          width: "wide",
          context: "formatting"
        }) || a.dayPeriod(r, {
          width: "abbreviated",
          context: "formatting"
        }) || a.dayPeriod(r, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(r, n, a) {
    return r.setHours((0, ihe.dayPeriodEnumToHours)(a), 0, 0, 0), r;
  }
}
wf.DayPeriodParser = ohe;
var xf = {};
xf.Hour1to12Parser = void 0;
var she = _t, lhe = Ve, Dm = Le;
class che extends lhe.Parser {
  constructor() {
    super(...arguments);
    fe(this, "priority", 70);
    fe(this, "incompatibleTokens", ["H", "K", "k", "t", "T"]);
  }
  parse(r, n, a) {
    switch (n) {
      case "h":
        return (0, Dm.parseNumericPattern)(
          she.numericPatterns.hour12h,
          r
        );
      case "ho":
        return a.ordinalNumber(r, { unit: "hour" });
      default:
        return (0, Dm.parseNDigits)(n.length, r);
    }
  }
  validate(r, n) {
    return n >= 1 && n <= 12;
  }
  set(r, n, a) {
    const i = r.getHours() >= 12;
    return i && a < 12 ? r.setHours(a + 12, 0, 0, 0) : !i && a === 12 ? r.setHours(0, 0, 0, 0) : r.setHours(a, 0, 0, 0), r;
  }
}
xf.Hour1to12Parser = che;
var Of = {};
Of.Hour0to23Parser = void 0;
var uhe = _t, fhe = Ve, Mm = Le;
class dhe extends fhe.Parser {
  constructor() {
    super(...arguments);
    fe(this, "priority", 70);
    fe(this, "incompatibleTokens", ["a", "b", "h", "K", "k", "t", "T"]);
  }
  parse(r, n, a) {
    switch (n) {
      case "H":
        return (0, Mm.parseNumericPattern)(
          uhe.numericPatterns.hour23h,
          r
        );
      case "Ho":
        return a.ordinalNumber(r, { unit: "hour" });
      default:
        return (0, Mm.parseNDigits)(n.length, r);
    }
  }
  validate(r, n) {
    return n >= 0 && n <= 23;
  }
  set(r, n, a) {
    return r.setHours(a, 0, 0, 0), r;
  }
}
Of.Hour0to23Parser = dhe;
var Df = {};
Df.Hour0To11Parser = void 0;
var hhe = _t, Ahe = Ve, Em = Le;
class phe extends Ahe.Parser {
  constructor() {
    super(...arguments);
    fe(this, "priority", 70);
    fe(this, "incompatibleTokens", ["h", "H", "k", "t", "T"]);
  }
  parse(r, n, a) {
    switch (n) {
      case "K":
        return (0, Em.parseNumericPattern)(
          hhe.numericPatterns.hour11h,
          r
        );
      case "Ko":
        return a.ordinalNumber(r, { unit: "hour" });
      default:
        return (0, Em.parseNDigits)(n.length, r);
    }
  }
  validate(r, n) {
    return n >= 0 && n <= 11;
  }
  set(r, n, a) {
    return r.getHours() >= 12 && a < 12 ? r.setHours(a + 12, 0, 0, 0) : r.setHours(a, 0, 0, 0), r;
  }
}
Df.Hour0To11Parser = phe;
var Mf = {};
Mf.Hour1To24Parser = void 0;
var vhe = _t, ghe = Ve, Pm = Le;
class mhe extends ghe.Parser {
  constructor() {
    super(...arguments);
    fe(this, "priority", 70);
    fe(this, "incompatibleTokens", ["a", "b", "h", "H", "K", "t", "T"]);
  }
  parse(r, n, a) {
    switch (n) {
      case "k":
        return (0, Pm.parseNumericPattern)(
          vhe.numericPatterns.hour24h,
          r
        );
      case "ko":
        return a.ordinalNumber(r, { unit: "hour" });
      default:
        return (0, Pm.parseNDigits)(n.length, r);
    }
  }
  validate(r, n) {
    return n >= 1 && n <= 24;
  }
  set(r, n, a) {
    const i = a <= 24 ? a % 24 : a;
    return r.setHours(i, 0, 0, 0), r;
  }
}
Mf.Hour1To24Parser = mhe;
var Ef = {};
Ef.MinuteParser = void 0;
var Che = _t, bhe = Ve, jm = Le;
class yhe extends bhe.Parser {
  constructor() {
    super(...arguments);
    fe(this, "priority", 60);
    fe(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(r, n, a) {
    switch (n) {
      case "m":
        return (0, jm.parseNumericPattern)(
          Che.numericPatterns.minute,
          r
        );
      case "mo":
        return a.ordinalNumber(r, { unit: "minute" });
      default:
        return (0, jm.parseNDigits)(n.length, r);
    }
  }
  validate(r, n) {
    return n >= 0 && n <= 59;
  }
  set(r, n, a) {
    return r.setMinutes(a, 0, 0), r;
  }
}
Ef.MinuteParser = yhe;
var Pf = {};
Pf.SecondParser = void 0;
var whe = _t, xhe = Ve, Sm = Le;
class Ohe extends xhe.Parser {
  constructor() {
    super(...arguments);
    fe(this, "priority", 50);
    fe(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(r, n, a) {
    switch (n) {
      case "s":
        return (0, Sm.parseNumericPattern)(
          whe.numericPatterns.second,
          r
        );
      case "so":
        return a.ordinalNumber(r, { unit: "second" });
      default:
        return (0, Sm.parseNDigits)(n.length, r);
    }
  }
  validate(r, n) {
    return n >= 0 && n <= 59;
  }
  set(r, n, a) {
    return r.setSeconds(a, 0), r;
  }
}
Pf.SecondParser = Ohe;
var jf = {};
jf.FractionOfSecondParser = void 0;
var Dhe = Ve, Im = Le;
class Mhe extends Dhe.Parser {
  constructor() {
    super(...arguments);
    fe(this, "priority", 30);
    fe(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(r, n) {
    const a = (i) => Math.trunc(i * Math.pow(10, -n.length + 3));
    return (0, Im.mapValue)(
      (0, Im.parseNDigits)(n.length, r),
      a
    );
  }
  set(r, n, a) {
    return r.setMilliseconds(a), r;
  }
}
jf.FractionOfSecondParser = Mhe;
var Sf = {};
Sf.ISOTimezoneWithZParser = void 0;
var Ehe = me, Phe = Tn, Ii = _t, jhe = Ve, Bi = Le;
class She extends jhe.Parser {
  constructor() {
    super(...arguments);
    fe(this, "priority", 10);
    fe(this, "incompatibleTokens", ["t", "T", "x"]);
  }
  parse(r, n) {
    switch (n) {
      case "X":
        return (0, Bi.parseTimezonePattern)(
          Ii.timezonePatterns.basicOptionalMinutes,
          r
        );
      case "XX":
        return (0, Bi.parseTimezonePattern)(
          Ii.timezonePatterns.basic,
          r
        );
      case "XXXX":
        return (0, Bi.parseTimezonePattern)(
          Ii.timezonePatterns.basicOptionalSeconds,
          r
        );
      case "XXXXX":
        return (0, Bi.parseTimezonePattern)(
          Ii.timezonePatterns.extendedOptionalSeconds,
          r
        );
      case "XXX":
      default:
        return (0, Bi.parseTimezonePattern)(
          Ii.timezonePatterns.extended,
          r
        );
    }
  }
  set(r, n, a) {
    return n.timestampIsSet ? r : (0, Ehe.constructFrom)(
      r,
      r.getTime() - (0, Phe.getTimezoneOffsetInMilliseconds)(r) - a
    );
  }
}
Sf.ISOTimezoneWithZParser = She;
var If = {};
If.ISOTimezoneParser = void 0;
var Ihe = me, Bhe = Tn, Ni = _t, Nhe = Ve, _i = Le;
class _he extends Nhe.Parser {
  constructor() {
    super(...arguments);
    fe(this, "priority", 10);
    fe(this, "incompatibleTokens", ["t", "T", "X"]);
  }
  parse(r, n) {
    switch (n) {
      case "x":
        return (0, _i.parseTimezonePattern)(
          Ni.timezonePatterns.basicOptionalMinutes,
          r
        );
      case "xx":
        return (0, _i.parseTimezonePattern)(
          Ni.timezonePatterns.basic,
          r
        );
      case "xxxx":
        return (0, _i.parseTimezonePattern)(
          Ni.timezonePatterns.basicOptionalSeconds,
          r
        );
      case "xxxxx":
        return (0, _i.parseTimezonePattern)(
          Ni.timezonePatterns.extendedOptionalSeconds,
          r
        );
      case "xxx":
      default:
        return (0, _i.parseTimezonePattern)(
          Ni.timezonePatterns.extended,
          r
        );
    }
  }
  set(r, n, a) {
    return n.timestampIsSet ? r : (0, Ihe.constructFrom)(
      r,
      r.getTime() - (0, Bhe.getTimezoneOffsetInMilliseconds)(r) - a
    );
  }
}
If.ISOTimezoneParser = _he;
var Bf = {};
Bf.TimestampSecondsParser = void 0;
var Lhe = me, The = Ve, Rhe = Le;
class $he extends The.Parser {
  constructor() {
    super(...arguments);
    fe(this, "priority", 40);
    fe(this, "incompatibleTokens", "*");
  }
  parse(r) {
    return (0, Rhe.parseAnyDigitsSigned)(r);
  }
  set(r, n, a) {
    return [
      (0, Lhe.constructFrom)(r, a * 1e3),
      { timestampIsSet: !0 }
    ];
  }
}
Bf.TimestampSecondsParser = $he;
var Nf = {};
Nf.TimestampMillisecondsParser = void 0;
var Fhe = me, Hhe = Ve, Yhe = Le;
class Vhe extends Hhe.Parser {
  constructor() {
    super(...arguments);
    fe(this, "priority", 20);
    fe(this, "incompatibleTokens", "*");
  }
  parse(r) {
    return (0, Yhe.parseAnyDigitsSigned)(r);
  }
  set(r, n, a) {
    return [(0, Fhe.constructFrom)(r, a), { timestampIsSet: !0 }];
  }
}
Nf.TimestampMillisecondsParser = Vhe;
X8.parsers = void 0;
var khe = J8, Ghe = ef, Whe = tf, Qhe = rf, Uhe = nf, Zhe = af, zhe = of, Khe = sf, qhe = lf, Xhe = cf, Jhe = ff, eAe = hf, tAe = Af, rAe = pf, nAe = vf, aAe = gf, iAe = mf, oAe = bf, sAe = yf, lAe = wf, cAe = xf, uAe = Of, fAe = Df, dAe = Mf, hAe = Ef, AAe = Pf, pAe = jf, vAe = Sf, gAe = If, mAe = Bf, CAe = Nf;
X8.parsers = {
  G: new khe.EraParser(),
  y: new Ghe.YearParser(),
  Y: new Whe.LocalWeekYearParser(),
  R: new Qhe.ISOWeekYearParser(),
  u: new Uhe.ExtendedYearParser(),
  Q: new Zhe.QuarterParser(),
  q: new zhe.StandAloneQuarterParser(),
  M: new Khe.MonthParser(),
  L: new qhe.StandAloneMonthParser(),
  w: new Xhe.LocalWeekParser(),
  I: new Jhe.ISOWeekParser(),
  d: new eAe.DateParser(),
  D: new tAe.DayOfYearParser(),
  E: new rAe.DayParser(),
  e: new nAe.LocalDayParser(),
  c: new aAe.StandAloneLocalDayParser(),
  i: new iAe.ISODayParser(),
  a: new oAe.AMPMParser(),
  b: new sAe.AMPMMidnightParser(),
  B: new lAe.DayPeriodParser(),
  h: new cAe.Hour1to12Parser(),
  H: new uAe.Hour0to23Parser(),
  K: new fAe.Hour0To11Parser(),
  k: new dAe.Hour1To24Parser(),
  m: new hAe.MinuteParser(),
  s: new AAe.SecondParser(),
  S: new pAe.FractionOfSecondParser(),
  X: new vAe.ISOTimezoneWithZParser(),
  x: new gAe.ISOTimezoneParser(),
  t: new mAe.TimestampSecondsParser(),
  T: new CAe.TimestampMillisecondsParser()
};
(function(e) {
  Object.defineProperty(e, "longFormatters", {
    enumerable: !0,
    get: function() {
      return r.longFormatters;
    }
  }), e.parse = g, Object.defineProperty(e, "parsers", {
    enumerable: !0,
    get: function() {
      return c.parsers;
    }
  });
  var t = ha, r = Ml, n = d3, a = me, i = Q8, o = ae, s = s1, c = X8;
  const u = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, d = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, h = /^'([^]*?)'?$/, A = /''/g, p = /\S/, m = /[a-zA-Z]/;
  function g(C, y, w, O) {
    var W, te, S, I, T, E, x, $;
    const b = () => (0, a.constructFrom)((O == null ? void 0 : O.in) || w, NaN), D = (0, i.getDefaultOptions)(), M = (O == null ? void 0 : O.locale) ?? D.locale ?? t.defaultLocale, j = (O == null ? void 0 : O.firstWeekContainsDate) ?? ((te = (W = O == null ? void 0 : O.locale) == null ? void 0 : W.options) == null ? void 0 : te.firstWeekContainsDate) ?? D.firstWeekContainsDate ?? ((I = (S = D.locale) == null ? void 0 : S.options) == null ? void 0 : I.firstWeekContainsDate) ?? 1, P = (O == null ? void 0 : O.weekStartsOn) ?? ((E = (T = O == null ? void 0 : O.locale) == null ? void 0 : T.options) == null ? void 0 : E.weekStartsOn) ?? D.weekStartsOn ?? (($ = (x = D.locale) == null ? void 0 : x.options) == null ? void 0 : $.weekStartsOn) ?? 0;
    if (!y)
      return C ? b() : (0, o.toDate)(w, O == null ? void 0 : O.in);
    const H = {
      firstWeekContainsDate: j,
      weekStartsOn: P,
      locale: M
    }, F = [new s.DateTimezoneSetter(O == null ? void 0 : O.in, w)], R = y.match(d).map((_) => {
      const Q = _[0];
      if (Q in r.longFormatters) {
        const Z = r.longFormatters[Q];
        return Z(_, M.formatLong);
      }
      return _;
    }).join("").match(u), N = [];
    for (let _ of R) {
      !(O != null && O.useAdditionalWeekYearTokens) && (0, n.isProtectedWeekYearToken)(_) && (0, n.warnOrThrowProtectedError)(_, y, C), !(O != null && O.useAdditionalDayOfYearTokens) && (0, n.isProtectedDayOfYearToken)(_) && (0, n.warnOrThrowProtectedError)(_, y, C);
      const Q = _[0], Z = c.parsers[Q];
      if (Z) {
        const { incompatibleTokens: X } = Z;
        if (Array.isArray(X)) {
          const U = N.find(
            (k) => X.includes(k.token) || k.token === Q
          );
          if (U)
            throw new RangeError(
              `The format string mustn't contain \`${U.fullToken}\` and \`${_}\` at the same time`
            );
        } else if (Z.incompatibleTokens === "*" && N.length > 0)
          throw new RangeError(
            `The format string mustn't contain \`${_}\` and any other token at the same time`
          );
        N.push({ token: Q, fullToken: _ });
        const Y = Z.run(
          C,
          _,
          M.match,
          H
        );
        if (!Y)
          return b();
        F.push(Y.setter), C = Y.rest;
      } else {
        if (Q.match(m))
          throw new RangeError(
            "Format string contains an unescaped latin alphabet character `" + Q + "`"
          );
        if (_ === "''" ? _ = "'" : Q === "'" && (_ = v(_)), C.indexOf(_) === 0)
          C = C.slice(_.length);
        else
          return b();
      }
    }
    if (C.length > 0 && p.test(C))
      return b();
    const z = F.map((_) => _.priority).sort((_, Q) => Q - _).filter((_, Q, Z) => Z.indexOf(_) === Q).map(
      (_) => F.filter((Q) => Q.priority === _).sort((Q, Z) => Z.subPriority - Q.subPriority)
    ).map((_) => _[0]);
    let q = (0, o.toDate)(w, O == null ? void 0 : O.in);
    if (isNaN(+q))
      return b();
    const J = {};
    for (const _ of z) {
      if (!_.validate(q, H))
        return b();
      const Q = _.set(q, J, H);
      Array.isArray(Q) ? (q = Q[0], Object.assign(J, Q[1])) : q = Q;
    }
    return q;
  }
  function v(C) {
    return C.match(h)[1].replace(A, "'");
  }
})(z8);
XD.isMatch = wAe;
var bAe = Rn, yAe = z8;
function wAe(e, t, r) {
  return (0, bAe.isValid)(
    (0, yAe.parse)(e, t, /* @__PURE__ */ new Date(), r)
  );
}
var JD = {};
JD.isMonday = OAe;
var xAe = ae;
function OAe(e, t) {
  return (0, xAe.toDate)(e, t == null ? void 0 : t.in).getDay() === 1;
}
var eM = {};
eM.isPast = MAe;
var DAe = ae;
function MAe(e) {
  return +(0, DAe.toDate)(e) < Date.now();
}
var _f = {}, Lf = {};
Lf.startOfHour = PAe;
var EAe = ae;
function PAe(e, t) {
  const r = (0, EAe.toDate)(e, t == null ? void 0 : t.in);
  return r.setMinutes(0, 0, 0), r;
}
_f.isSameHour = SAe;
var jAe = Je, Bm = Lf;
function SAe(e, t, r) {
  const [n, a] = (0, jAe.normalizeDates)(
    r == null ? void 0 : r.in,
    e,
    t
  );
  return +(0, Bm.startOfHour)(n) == +(0, Bm.startOfHour)(a);
}
var Tf = {}, El = {};
El.isSameWeek = BAe;
var IAe = Je, Nm = Kr;
function BAe(e, t, r) {
  const [n, a] = (0, IAe.normalizeDates)(
    r == null ? void 0 : r.in,
    e,
    t
  );
  return +(0, Nm.startOfWeek)(n, r) == +(0, Nm.startOfWeek)(a, r);
}
Tf.isSameISOWeek = _Ae;
var NAe = El;
function _Ae(e, t, r) {
  return (0, NAe.isSameWeek)(e, t, {
    ...r,
    weekStartsOn: 1
  });
}
var tM = {};
tM.isSameISOWeekYear = TAe;
var _m = W2, LAe = Je;
function TAe(e, t, r) {
  const [n, a] = (0, LAe.normalizeDates)(
    r == null ? void 0 : r.in,
    e,
    t
  );
  return +(0, _m.startOfISOWeekYear)(n) == +(0, _m.startOfISOWeekYear)(a);
}
var Rf = {}, $f = {};
$f.startOfMinute = $Ae;
var RAe = ae;
function $Ae(e, t) {
  const r = (0, RAe.toDate)(e, t == null ? void 0 : t.in);
  return r.setSeconds(0, 0), r;
}
Rf.isSameMinute = FAe;
var Lm = $f;
function FAe(e, t) {
  return +(0, Lm.startOfMinute)(e) == +(0, Lm.startOfMinute)(t);
}
var Ff = {};
Ff.isSameMonth = YAe;
var HAe = Je;
function YAe(e, t, r) {
  const [n, a] = (0, HAe.normalizeDates)(
    r == null ? void 0 : r.in,
    e,
    t
  );
  return n.getFullYear() === a.getFullYear() && n.getMonth() === a.getMonth();
}
var Hf = {};
Hf.isSameQuarter = kAe;
var VAe = Je, Tm = ml;
function kAe(e, t, r) {
  const [n, a] = (0, VAe.normalizeDates)(
    r == null ? void 0 : r.in,
    e,
    t
  );
  return +(0, Tm.startOfQuarter)(n) == +(0, Tm.startOfQuarter)(a);
}
var Yf = {}, Vf = {};
Vf.startOfSecond = WAe;
var GAe = ae;
function WAe(e, t) {
  const r = (0, GAe.toDate)(e, t == null ? void 0 : t.in);
  return r.setMilliseconds(0), r;
}
Yf.isSameSecond = QAe;
var Rm = Vf;
function QAe(e, t) {
  return +(0, Rm.startOfSecond)(e) == +(0, Rm.startOfSecond)(t);
}
var kf = {};
kf.isSameYear = ZAe;
var UAe = Je;
function ZAe(e, t, r) {
  const [n, a] = (0, UAe.normalizeDates)(
    r == null ? void 0 : r.in,
    e,
    t
  );
  return n.getFullYear() === a.getFullYear();
}
var rM = {};
rM.isThisHour = XAe;
var zAe = Tt, KAe = _f, qAe = ae;
function XAe(e, t) {
  return (0, KAe.isSameHour)(
    (0, qAe.toDate)(e, t == null ? void 0 : t.in),
    (0, zAe.constructNow)((t == null ? void 0 : t.in) || e)
  );
}
var nM = {};
nM.isThisISOWeek = rpe;
var JAe = me, epe = Tt, tpe = Tf;
function rpe(e, t) {
  return (0, tpe.isSameISOWeek)(
    (0, JAe.constructFrom)((t == null ? void 0 : t.in) || e, e),
    (0, epe.constructNow)((t == null ? void 0 : t.in) || e)
  );
}
var aM = {};
aM.isThisMinute = ipe;
var npe = Tt, ape = Rf;
function ipe(e) {
  return (0, ape.isSameMinute)(e, (0, npe.constructNow)(e));
}
var iM = {};
iM.isThisMonth = cpe;
var ope = me, spe = Tt, lpe = Ff;
function cpe(e, t) {
  return (0, lpe.isSameMonth)(
    (0, ope.constructFrom)((t == null ? void 0 : t.in) || e, e),
    (0, spe.constructNow)((t == null ? void 0 : t.in) || e)
  );
}
var oM = {};
oM.isThisQuarter = hpe;
var upe = me, fpe = Tt, dpe = Hf;
function hpe(e, t) {
  return (0, dpe.isSameQuarter)(
    (0, upe.constructFrom)((t == null ? void 0 : t.in) || e, e),
    (0, fpe.constructNow)((t == null ? void 0 : t.in) || e)
  );
}
var sM = {};
sM.isThisSecond = vpe;
var Ape = Tt, ppe = Yf;
function vpe(e) {
  return (0, ppe.isSameSecond)(e, (0, Ape.constructNow)(e));
}
var lM = {};
lM.isThisWeek = bpe;
var gpe = me, mpe = Tt, Cpe = El;
function bpe(e, t) {
  return (0, Cpe.isSameWeek)(
    (0, gpe.constructFrom)((t == null ? void 0 : t.in) || e, e),
    (0, mpe.constructNow)((t == null ? void 0 : t.in) || e),
    t
  );
}
var cM = {};
cM.isThisYear = Ope;
var ype = me, wpe = Tt, xpe = kf;
function Ope(e, t) {
  return (0, xpe.isSameYear)(
    (0, ype.constructFrom)((t == null ? void 0 : t.in) || e, e),
    (0, wpe.constructNow)((t == null ? void 0 : t.in) || e)
  );
}
var uM = {};
uM.isThursday = Mpe;
var Dpe = ae;
function Mpe(e, t) {
  return (0, Dpe.toDate)(e, t == null ? void 0 : t.in).getDay() === 4;
}
var fM = {};
fM.isToday = Spe;
var Epe = me, Ppe = Tt, jpe = Q2;
function Spe(e, t) {
  return (0, jpe.isSameDay)(
    (0, Epe.constructFrom)((t == null ? void 0 : t.in) || e, e),
    (0, Ppe.constructNow)((t == null ? void 0 : t.in) || e)
  );
}
var dM = {};
dM.isTomorrow = _pe;
var Ipe = hn, Bpe = Tt, Npe = Q2;
function _pe(e, t) {
  return (0, Npe.isSameDay)(
    e,
    (0, Ipe.addDays)((0, Bpe.constructNow)((t == null ? void 0 : t.in) || e), 1),
    t
  );
}
var hM = {};
hM.isTuesday = Tpe;
var Lpe = ae;
function Tpe(e, t) {
  return (0, Lpe.toDate)(e, t == null ? void 0 : t.in).getDay() === 2;
}
var AM = {};
AM.isWednesday = $pe;
var Rpe = ae;
function $pe(e, t) {
  return (0, Rpe.toDate)(e, t == null ? void 0 : t.in).getDay() === 3;
}
var pM = {};
pM.isWithinInterval = Fpe;
var M4 = ae;
function Fpe(e, t, r) {
  const n = +(0, M4.toDate)(e, r == null ? void 0 : r.in), [a, i] = [
    +(0, M4.toDate)(t.start, r == null ? void 0 : r.in),
    +(0, M4.toDate)(t.end, r == null ? void 0 : r.in)
  ].sort((o, s) => o - s);
  return n >= a && n <= i;
}
var vM = {}, p3 = {};
p3.subDays = Ype;
var Hpe = hn;
function Ype(e, t, r) {
  return (0, Hpe.addDays)(e, -t, r);
}
vM.isYesterday = Qpe;
var Vpe = me, kpe = Tt, Gpe = Q2, Wpe = p3;
function Qpe(e, t) {
  return (0, Gpe.isSameDay)(
    (0, Vpe.constructFrom)((t == null ? void 0 : t.in) || e, e),
    (0, Wpe.subDays)((0, kpe.constructNow)((t == null ? void 0 : t.in) || e), 1)
  );
}
var gM = {};
gM.lastDayOfDecade = Upe;
var $m = ae;
function Upe(e, t) {
  const r = (0, $m.toDate)(e, t == null ? void 0 : t.in), n = r.getFullYear(), a = 9 + Math.floor(n / 10) * 10;
  return r.setFullYear(a + 1, 0, 0), r.setHours(0, 0, 0, 0), (0, $m.toDate)(r, t == null ? void 0 : t.in);
}
var mM = {}, Gf = {};
Gf.lastDayOfWeek = Kpe;
var Zpe = Gt, zpe = ae;
function Kpe(e, t) {
  var s, c, u, d;
  const r = (0, Zpe.getDefaultOptions)(), n = (t == null ? void 0 : t.weekStartsOn) ?? ((c = (s = t == null ? void 0 : t.locale) == null ? void 0 : s.options) == null ? void 0 : c.weekStartsOn) ?? r.weekStartsOn ?? ((d = (u = r.locale) == null ? void 0 : u.options) == null ? void 0 : d.weekStartsOn) ?? 0, a = (0, zpe.toDate)(e, t == null ? void 0 : t.in), i = a.getDay(), o = (i < n ? -7 : 0) + 6 - (i - n);
  return a.setHours(0, 0, 0, 0), a.setDate(a.getDate() + o), a;
}
mM.lastDayOfISOWeek = Xpe;
var qpe = Gf;
function Xpe(e, t) {
  return (0, qpe.lastDayOfWeek)(e, { ...t, weekStartsOn: 1 });
}
var CM = {};
CM.lastDayOfISOWeekYear = rve;
var Jpe = me, eve = w1, tve = An;
function rve(e, t) {
  const r = (0, eve.getISOWeekYear)(e, t), n = (0, Jpe.constructFrom)((t == null ? void 0 : t.in) || e, 0);
  n.setFullYear(r + 1, 0, 4), n.setHours(0, 0, 0, 0);
  const a = (0, tve.startOfISOWeek)(n, t);
  return a.setDate(a.getDate() - 1), a;
}
var bM = {};
bM.lastDayOfQuarter = ave;
var nve = ae;
function ave(e, t) {
  const r = (0, nve.toDate)(e, t == null ? void 0 : t.in), n = r.getMonth(), a = n - n % 3 + 3;
  return r.setMonth(a, 0), r.setHours(0, 0, 0, 0), r;
}
var yM = {};
yM.lastDayOfYear = ove;
var ive = ae;
function ove(e, t) {
  const r = (0, ive.toDate)(e, t == null ? void 0 : t.in), n = r.getFullYear();
  return r.setFullYear(n + 1, 0, 0), r.setHours(0, 0, 0, 0), r;
}
var wM = {};
(function(e) {
  e.lightFormat = c, Object.defineProperty(e, "lightFormatters", {
    enumerable: !0,
    get: function() {
      return t.lightFormatters;
    }
  });
  var t = Dl, r = Rn, n = ae;
  const a = /(\w)\1*|''|'(''|[^'])+('|$)|./g, i = /^'([^]*?)'?$/, o = /''/g, s = /[a-zA-Z]/;
  function c(d, h) {
    const A = (0, n.toDate)(d);
    if (!(0, r.isValid)(A))
      throw new RangeError("Invalid time value");
    const p = h.match(a);
    return p ? p.map((g) => {
      if (g === "''")
        return "'";
      const v = g[0];
      if (v === "'")
        return u(g);
      const C = t.lightFormatters[v];
      if (C)
        return C(A, g);
      if (v.match(s))
        throw new RangeError(
          "Format string contains an unescaped latin alphabet character `" + v + "`"
        );
      return g;
    }).join("") : "";
  }
  function u(d) {
    const h = d.match(i);
    return h ? h[1].replace(o, "'") : d;
  }
})(wM);
var xM = {};
xM.milliseconds = sve;
var Fm = ce;
function sve({ years: e, months: t, weeks: r, days: n, hours: a, minutes: i, seconds: o }) {
  let s = 0;
  e && (s += e * Fm.daysInYear), t && (s += t * (Fm.daysInYear / 12)), r && (s += r * 7), n && (s += n);
  let c = s * 24 * 60 * 60;
  return a && (c += a * 60 * 60), i && (c += i * 60), o && (c += o), Math.trunc(c * 1e3);
}
var OM = {};
OM.millisecondsToHours = cve;
var lve = ce;
function cve(e) {
  const t = e / lve.millisecondsInHour;
  return Math.trunc(t);
}
var DM = {};
DM.millisecondsToMinutes = fve;
var uve = ce;
function fve(e) {
  const t = e / uve.millisecondsInMinute;
  return Math.trunc(t);
}
var MM = {};
MM.millisecondsToSeconds = hve;
var dve = ce;
function hve(e) {
  const t = e / dve.millisecondsInSecond;
  return Math.trunc(t);
}
var EM = {};
EM.minutesToHours = pve;
var Ave = ce;
function pve(e) {
  const t = e / Ave.minutesInHour;
  return Math.trunc(t);
}
var PM = {};
PM.minutesToMilliseconds = gve;
var vve = ce;
function gve(e) {
  return Math.trunc(e * vve.millisecondsInMinute);
}
var jM = {};
jM.minutesToSeconds = Cve;
var mve = ce;
function Cve(e) {
  return Math.trunc(e * mve.secondsInMinute);
}
var SM = {};
SM.monthsToQuarters = yve;
var bve = ce;
function yve(e) {
  const t = e / bve.monthsInQuarter;
  return Math.trunc(t);
}
var IM = {};
IM.monthsToYears = xve;
var wve = ce;
function xve(e) {
  const t = e / wve.monthsInYear;
  return Math.trunc(t);
}
var Fn = {};
Fn.nextDay = Mve;
var Ove = hn, Dve = h3;
function Mve(e, t, r) {
  let n = t - (0, Dve.getDay)(e, r);
  return n <= 0 && (n += 7), (0, Ove.addDays)(e, n, r);
}
var BM = {};
BM.nextFriday = Pve;
var Eve = Fn;
function Pve(e, t) {
  return (0, Eve.nextDay)(e, 5, t);
}
var NM = {};
NM.nextMonday = Sve;
var jve = Fn;
function Sve(e, t) {
  return (0, jve.nextDay)(e, 1, t);
}
var _M = {};
_M.nextSaturday = Bve;
var Ive = Fn;
function Bve(e, t) {
  return (0, Ive.nextDay)(e, 6, t);
}
var LM = {};
LM.nextSunday = _ve;
var Nve = Fn;
function _ve(e, t) {
  return (0, Nve.nextDay)(e, 0, t);
}
var TM = {};
TM.nextThursday = Tve;
var Lve = Fn;
function Tve(e, t) {
  return (0, Lve.nextDay)(e, 4, t);
}
var RM = {};
RM.nextTuesday = $ve;
var Rve = Fn;
function $ve(e, t) {
  return (0, Rve.nextDay)(e, 2, t);
}
var $M = {};
$M.nextWednesday = Hve;
var Fve = Fn;
function Hve(e, t) {
  return (0, Fve.nextDay)(e, 3, t);
}
var FM = {};
FM.parseISO = Vve;
var f0 = ce, Yve = me, Hm = ae;
function Vve(e, t) {
  const r = () => (0, Yve.constructFrom)(t == null ? void 0 : t.in, NaN), n = (t == null ? void 0 : t.additionalDigits) ?? 2, a = Qve(e);
  let i;
  if (a.date) {
    const u = Uve(a.date, n);
    i = Zve(u.restDateString, u.year);
  }
  if (!i || isNaN(+i))
    return r();
  const o = +i;
  let s = 0, c;
  if (a.time && (s = zve(a.time), isNaN(s)))
    return r();
  if (a.timezone) {
    if (c = Kve(a.timezone), isNaN(c))
      return r();
  } else {
    const u = new Date(o + s), d = (0, Hm.toDate)(0, t == null ? void 0 : t.in);
    return d.setFullYear(
      u.getUTCFullYear(),
      u.getUTCMonth(),
      u.getUTCDate()
    ), d.setHours(
      u.getUTCHours(),
      u.getUTCMinutes(),
      u.getUTCSeconds(),
      u.getUTCMilliseconds()
    ), d;
  }
  return (0, Hm.toDate)(o + s + c, t == null ? void 0 : t.in);
}
const V3 = {
  dateTimeDelimiter: /[T ]/,
  timeZoneDelimiter: /[Z ]/i,
  timezone: /([Z+-].*)$/
}, kve = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/, Gve = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/, Wve = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function Qve(e) {
  const t = {}, r = e.split(V3.dateTimeDelimiter);
  let n;
  if (r.length > 2)
    return t;
  if (/:/.test(r[0]) ? n = r[0] : (t.date = r[0], n = r[1], V3.timeZoneDelimiter.test(t.date) && (t.date = e.split(V3.timeZoneDelimiter)[0], n = e.substr(
    t.date.length,
    e.length
  ))), n) {
    const a = V3.timezone.exec(n);
    a ? (t.time = n.replace(a[1], ""), t.timezone = a[1]) : t.time = n;
  }
  return t;
}
function Uve(e, t) {
  const r = new RegExp(
    "^(?:(\\d{4}|[+-]\\d{" + (4 + t) + "})|(\\d{2}|[+-]\\d{" + (2 + t) + "})$)"
  ), n = e.match(r);
  if (!n)
    return { year: NaN, restDateString: "" };
  const a = n[1] ? parseInt(n[1]) : null, i = n[2] ? parseInt(n[2]) : null;
  return {
    year: i === null ? a : i * 100,
    restDateString: e.slice((n[1] || n[2]).length)
  };
}
function Zve(e, t) {
  if (t === null)
    return /* @__PURE__ */ new Date(NaN);
  const r = e.match(kve);
  if (!r)
    return /* @__PURE__ */ new Date(NaN);
  const n = !!r[4], a = Li(r[1]), i = Li(r[2]) - 1, o = Li(r[3]), s = Li(r[4]), c = Li(r[5]) - 1;
  if (n)
    return tge(t, s, c) ? qve(t, s, c) : /* @__PURE__ */ new Date(NaN);
  {
    const u = /* @__PURE__ */ new Date(0);
    return !Jve(t, i, o) || !ege(t, a) ? /* @__PURE__ */ new Date(NaN) : (u.setUTCFullYear(t, i, Math.max(a, o)), u);
  }
}
function Li(e) {
  return e ? parseInt(e) : 1;
}
function zve(e) {
  const t = e.match(Gve);
  if (!t)
    return NaN;
  const r = E4(t[1]), n = E4(t[2]), a = E4(t[3]);
  return rge(r, n, a) ? r * f0.millisecondsInHour + n * f0.millisecondsInMinute + a * 1e3 : NaN;
}
function E4(e) {
  return e && parseFloat(e.replace(",", ".")) || 0;
}
function Kve(e) {
  if (e === "Z")
    return 0;
  const t = e.match(Wve);
  if (!t)
    return 0;
  const r = t[1] === "+" ? -1 : 1, n = parseInt(t[2]), a = t[3] && parseInt(t[3]) || 0;
  return nge(n, a) ? r * (n * f0.millisecondsInHour + a * f0.millisecondsInMinute) : NaN;
}
function qve(e, t, r) {
  const n = /* @__PURE__ */ new Date(0);
  n.setUTCFullYear(e, 0, 4);
  const a = n.getUTCDay() || 7, i = (t - 1) * 7 + r + 1 - a;
  return n.setUTCDate(n.getUTCDate() + i), n;
}
const Xve = [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
function HM(e) {
  return e % 400 === 0 || e % 4 === 0 && e % 100 !== 0;
}
function Jve(e, t, r) {
  return t >= 0 && t <= 11 && r >= 1 && r <= (Xve[t] || (HM(e) ? 29 : 28));
}
function ege(e, t) {
  return t >= 1 && t <= (HM(e) ? 366 : 365);
}
function tge(e, t, r) {
  return t >= 1 && t <= 53 && r >= 0 && r <= 6;
}
function rge(e, t, r) {
  return e === 24 ? t === 0 && r === 0 : r >= 0 && r < 60 && t >= 0 && t < 60 && e >= 0 && e < 25;
}
function nge(e, t) {
  return t >= 0 && t <= 59;
}
var YM = {};
YM.parseJSON = age;
var Ym = ae;
function age(e, t) {
  const r = e.match(
    /(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2}):(\d{2})(?:\.(\d{0,7}))?(?:Z|(.)(\d{2}):?(\d{2})?)?/
  );
  return r ? (0, Ym.toDate)(
    Date.UTC(
      +r[1],
      +r[2] - 1,
      +r[3],
      +r[4] - (+r[9] || 0) * (r[8] == "-" ? -1 : 1),
      +r[5] - (+r[10] || 0) * (r[8] == "-" ? -1 : 1),
      +r[6],
      +((r[7] || "0") + "00").substring(0, 3)
    ),
    t == null ? void 0 : t.in
  ) : (0, Ym.toDate)(NaN, t == null ? void 0 : t.in);
}
var Hn = {};
Hn.previousDay = sge;
var ige = h3, oge = p3;
function sge(e, t, r) {
  let n = (0, ige.getDay)(e, r) - t;
  return n <= 0 && (n += 7), (0, oge.subDays)(e, n, r);
}
var VM = {};
VM.previousFriday = cge;
var lge = Hn;
function cge(e, t) {
  return (0, lge.previousDay)(e, 5, t);
}
var kM = {};
kM.previousMonday = fge;
var uge = Hn;
function fge(e, t) {
  return (0, uge.previousDay)(e, 1, t);
}
var GM = {};
GM.previousSaturday = hge;
var dge = Hn;
function hge(e, t) {
  return (0, dge.previousDay)(e, 6, t);
}
var WM = {};
WM.previousSunday = pge;
var Age = Hn;
function pge(e, t) {
  return (0, Age.previousDay)(e, 0, t);
}
var QM = {};
QM.previousThursday = gge;
var vge = Hn;
function gge(e, t) {
  return (0, vge.previousDay)(e, 4, t);
}
var UM = {};
UM.previousTuesday = Cge;
var mge = Hn;
function Cge(e, t) {
  return (0, mge.previousDay)(e, 2, t);
}
var ZM = {};
ZM.previousWednesday = yge;
var bge = Hn;
function yge(e, t) {
  return (0, bge.previousDay)(e, 3, t);
}
var zM = {};
zM.quartersToMonths = xge;
var wge = ce;
function xge(e) {
  return Math.trunc(e * wge.monthsInQuarter);
}
var KM = {};
KM.quartersToYears = Dge;
var Oge = ce;
function Dge(e) {
  const t = e / Oge.quartersInYear;
  return Math.trunc(t);
}
var qM = {};
qM.roundToNearestHours = jge;
var Mge = $n, Ege = me, Pge = ae;
function jge(e, t) {
  const r = (t == null ? void 0 : t.nearestTo) ?? 1;
  if (r < 1 || r > 12)
    return (0, Ege.constructFrom)((t == null ? void 0 : t.in) || e, NaN);
  const n = (0, Pge.toDate)(e, t == null ? void 0 : t.in), a = n.getMinutes() / 60, i = n.getSeconds() / 60 / 60, o = n.getMilliseconds() / 1e3 / 60 / 60, s = n.getHours() + a + i + o, c = (t == null ? void 0 : t.roundingMethod) ?? "round", d = (0, Mge.getRoundingMethod)(c)(s / r) * r;
  return n.setHours(d, 0, 0, 0), n;
}
var XM = {};
XM.roundToNearestMinutes = Nge;
var Sge = $n, Ige = me, Bge = ae;
function Nge(e, t) {
  const r = (t == null ? void 0 : t.nearestTo) ?? 1;
  if (r < 1 || r > 30)
    return (0, Ige.constructFrom)(e, NaN);
  const n = (0, Bge.toDate)(e, t == null ? void 0 : t.in), a = n.getSeconds() / 60, i = n.getMilliseconds() / 1e3 / 60, o = n.getMinutes() + a + i, s = (t == null ? void 0 : t.roundingMethod) ?? "round", u = (0, Sge.getRoundingMethod)(s)(o / r) * r;
  return n.setMinutes(u, 0, 0), n;
}
var JM = {};
JM.secondsToHours = Lge;
var _ge = ce;
function Lge(e) {
  const t = e / _ge.secondsInHour;
  return Math.trunc(t);
}
var eE = {};
eE.secondsToMilliseconds = Rge;
var Tge = ce;
function Rge(e) {
  return e * Tge.millisecondsInSecond;
}
var tE = {};
tE.secondsToMinutes = Fge;
var $ge = ce;
function Fge(e) {
  const t = e / $ge.secondsInMinute;
  return Math.trunc(t);
}
var rE = {}, Pl = {};
Pl.setMonth = kge;
var Hge = me, Yge = G8, Vge = ae;
function kge(e, t, r) {
  const n = (0, Vge.toDate)(e, r == null ? void 0 : r.in), a = n.getFullYear(), i = n.getDate(), o = (0, Hge.constructFrom)((r == null ? void 0 : r.in) || e, 0);
  o.setFullYear(a, t, 15), o.setHours(0, 0, 0, 0);
  const s = (0, Yge.getDaysInMonth)(o);
  return n.setMonth(t, Math.min(i, s)), n;
}
rE.set = Uge;
var Gge = me, Wge = Pl, Qge = ae;
function Uge(e, t, r) {
  let n = (0, Qge.toDate)(e, r == null ? void 0 : r.in);
  return isNaN(+n) ? (0, Gge.constructFrom)((r == null ? void 0 : r.in) || e, NaN) : (t.year != null && n.setFullYear(t.year), t.month != null && (n = (0, Wge.setMonth)(n, t.month)), t.date != null && n.setDate(t.date), t.hours != null && n.setHours(t.hours), t.minutes != null && n.setMinutes(t.minutes), t.seconds != null && n.setSeconds(t.seconds), t.milliseconds != null && n.setMilliseconds(t.milliseconds), n);
}
var nE = {};
nE.setDate = zge;
var Zge = ae;
function zge(e, t, r) {
  const n = (0, Zge.toDate)(e, r == null ? void 0 : r.in);
  return n.setDate(t), n;
}
var aE = {};
aE.setDayOfYear = qge;
var Kge = ae;
function qge(e, t, r) {
  const n = (0, Kge.toDate)(e, r == null ? void 0 : r.in);
  return n.setMonth(0), n.setDate(t), n;
}
var iE = {};
iE.setDefaultOptions = Xge;
var Vm = Gt;
function Xge(e) {
  const t = {}, r = (0, Vm.getDefaultOptions)();
  for (const n in r)
    Object.prototype.hasOwnProperty.call(r, n) && (t[n] = r[n]);
  for (const n in e)
    Object.prototype.hasOwnProperty.call(e, n) && (e[n] === void 0 ? delete t[n] : t[n] = e[n]);
  (0, Vm.setDefaultOptions)(t);
}
var oE = {};
oE.setHours = eme;
var Jge = ae;
function eme(e, t, r) {
  const n = (0, Jge.toDate)(e, r == null ? void 0 : r.in);
  return n.setHours(t), n;
}
var sE = {};
sE.setMilliseconds = rme;
var tme = ae;
function rme(e, t, r) {
  const n = (0, tme.toDate)(e, r == null ? void 0 : r.in);
  return n.setMilliseconds(t), n;
}
var lE = {};
lE.setMinutes = ame;
var nme = ae;
function ame(e, t, r) {
  const n = (0, nme.toDate)(e, r == null ? void 0 : r.in);
  return n.setMinutes(t), n;
}
var cE = {};
cE.setQuarter = sme;
var ime = Pl, ome = ae;
function sme(e, t, r) {
  const n = (0, ome.toDate)(e, r == null ? void 0 : r.in), a = Math.trunc(n.getMonth() / 3) + 1, i = t - a;
  return (0, ime.setMonth)(n, n.getMonth() + i * 3);
}
var uE = {};
uE.setSeconds = cme;
var lme = ae;
function cme(e, t, r) {
  const n = (0, lme.toDate)(e, r == null ? void 0 : r.in);
  return n.setSeconds(t), n;
}
var fE = {};
fE.setWeekYear = Ame;
var ume = Gt, fme = me, dme = Ln, km = Ol, hme = ae;
function Ame(e, t, r) {
  var c, u, d, h;
  const n = (0, ume.getDefaultOptions)(), a = (r == null ? void 0 : r.firstWeekContainsDate) ?? ((u = (c = r == null ? void 0 : r.locale) == null ? void 0 : c.options) == null ? void 0 : u.firstWeekContainsDate) ?? n.firstWeekContainsDate ?? ((h = (d = n.locale) == null ? void 0 : d.options) == null ? void 0 : h.firstWeekContainsDate) ?? 1, i = (0, dme.differenceInCalendarDays)(
    (0, hme.toDate)(e, r == null ? void 0 : r.in),
    (0, km.startOfWeekYear)(e, r),
    r
  ), o = (0, fme.constructFrom)((r == null ? void 0 : r.in) || e, 0);
  o.setFullYear(t, 0, a), o.setHours(0, 0, 0, 0);
  const s = (0, km.startOfWeekYear)(o, r);
  return s.setDate(s.getDate() + i), s;
}
var dE = {};
dE.setYear = gme;
var pme = me, vme = ae;
function gme(e, t, r) {
  const n = (0, vme.toDate)(e, r == null ? void 0 : r.in);
  return isNaN(+n) ? (0, pme.constructFrom)((r == null ? void 0 : r.in) || e, NaN) : (n.setFullYear(t), n);
}
var hE = {};
hE.startOfDecade = Cme;
var mme = ae;
function Cme(e, t) {
  const r = (0, mme.toDate)(e, t == null ? void 0 : t.in), n = r.getFullYear(), a = Math.floor(n / 10) * 10;
  return r.setFullYear(a, 0, 1), r.setHours(0, 0, 0, 0), r;
}
var AE = {};
AE.startOfToday = yme;
var bme = o3;
function yme(e) {
  return (0, bme.startOfDay)(Date.now(), e);
}
var pE = {};
pE.startOfTomorrow = Ome;
var wme = me, xme = Tt;
function Ome(e) {
  const t = (0, xme.constructNow)(e == null ? void 0 : e.in), r = t.getFullYear(), n = t.getMonth(), a = t.getDate(), i = (0, wme.constructFrom)(e == null ? void 0 : e.in, 0);
  return i.setFullYear(r, n, a + 1), i.setHours(0, 0, 0, 0), i;
}
var vE = {};
vE.startOfYesterday = Dme;
var Gm = Tt;
function Dme(e) {
  const t = (0, Gm.constructNow)(e == null ? void 0 : e.in), r = t.getFullYear(), n = t.getMonth(), a = t.getDate(), i = (0, Gm.constructNow)(e == null ? void 0 : e.in);
  return i.setFullYear(r, n, a - 1), i.setHours(0, 0, 0, 0), i;
}
var gE = {}, Wf = {};
Wf.subMonths = Eme;
var Mme = G2;
function Eme(e, t, r) {
  return (0, Mme.addMonths)(e, -t, r);
}
gE.sub = Ime;
var Pme = me, jme = p3, Sme = Wf;
function Ime(e, t, r) {
  const {
    years: n = 0,
    months: a = 0,
    weeks: i = 0,
    days: o = 0,
    hours: s = 0,
    minutes: c = 0,
    seconds: u = 0
  } = t, d = (0, Sme.subMonths)(
    e,
    a + n * 12,
    r
  ), h = (0, jme.subDays)(
    d,
    o + i * 7,
    r
  ), A = c + s * 60, m = (u + A * 60) * 1e3;
  return (0, Pme.constructFrom)((r == null ? void 0 : r.in) || e, +h - m);
}
var mE = {};
mE.subBusinessDays = Nme;
var Bme = d8;
function Nme(e, t, r) {
  return (0, Bme.addBusinessDays)(e, -t, r);
}
var CE = {};
CE.subHours = Lme;
var _me = p8;
function Lme(e, t, r) {
  return (0, _me.addHours)(e, -t, r);
}
var bE = {};
bE.subMilliseconds = Rme;
var Tme = i3;
function Rme(e, t, r) {
  return (0, Tme.addMilliseconds)(e, -t, r);
}
var yE = {};
yE.subMinutes = Fme;
var $me = sl;
function Fme(e, t, r) {
  return (0, $me.addMinutes)(e, -t, r);
}
var wE = {};
wE.subQuarters = Yme;
var Hme = ll;
function Yme(e, t, r) {
  return (0, Hme.addQuarters)(e, -t, r);
}
var xE = {};
xE.subSeconds = kme;
var Vme = m8;
function kme(e, t, r) {
  return (0, Vme.addSeconds)(e, -t, r);
}
var OE = {};
OE.subWeeks = Wme;
var Gme = s3;
function Wme(e, t, r) {
  return (0, Gme.addWeeks)(e, -t, r);
}
var DE = {};
DE.subYears = Ume;
var Qme = C8;
function Ume(e, t, r) {
  return (0, Qme.addYears)(e, -t, r);
}
var ME = {};
ME.weeksToDays = zme;
var Zme = ce;
function zme(e) {
  return Math.trunc(e * Zme.daysInWeek);
}
var EE = {};
EE.yearsToDays = qme;
var Kme = ce;
function qme(e) {
  return Math.trunc(e * Kme.daysInYear);
}
var PE = {};
PE.yearsToMonths = Jme;
var Xme = ce;
function Jme(e) {
  return Math.trunc(e * Xme.monthsInYear);
}
var jE = {};
jE.yearsToQuarters = tCe;
var eCe = ce;
function tCe(e) {
  return Math.trunc(e * eCe.quartersInYear);
}
(function(e) {
  var t = f8;
  Object.keys(t).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === t[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return t[l];
      }
    });
  });
  var r = d8;
  Object.keys(r).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === r[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return r[l];
      }
    });
  });
  var n = hn;
  Object.keys(n).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === n[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return n[l];
      }
    });
  });
  var a = p8;
  Object.keys(a).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === a[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return a[l];
      }
    });
  });
  var i = v8;
  Object.keys(i).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === i[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return i[l];
      }
    });
  });
  var o = i3;
  Object.keys(o).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === o[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return o[l];
      }
    });
  });
  var s = sl;
  Object.keys(s).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === s[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return s[l];
      }
    });
  });
  var c = G2;
  Object.keys(c).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === c[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return c[l];
      }
    });
  });
  var u = ll;
  Object.keys(u).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === u[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return u[l];
      }
    });
  });
  var d = m8;
  Object.keys(d).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === d[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return d[l];
      }
    });
  });
  var h = s3;
  Object.keys(h).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === h[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return h[l];
      }
    });
  });
  var A = C8;
  Object.keys(A).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === A[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return A[l];
      }
    });
  });
  var p = LO;
  Object.keys(p).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === p[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return p[l];
      }
    });
  });
  var m = TO;
  Object.keys(m).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === m[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return m[l];
      }
    });
  });
  var g = w8;
  Object.keys(g).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === g[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return g[l];
      }
    });
  });
  var v = RO;
  Object.keys(v).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === v[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return v[l];
      }
    });
  });
  var C = da;
  Object.keys(C).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === C[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return C[l];
      }
    });
  });
  var y = $O;
  Object.keys(y).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === y[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return y[l];
      }
    });
  });
  var w = me;
  Object.keys(w).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === w[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return w[l];
      }
    });
  });
  var O = Tt;
  Object.keys(O).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === O[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return O[l];
      }
    });
  });
  var b = FO;
  Object.keys(b).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === b[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return b[l];
      }
    });
  });
  var D = HO;
  Object.keys(D).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === D[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return D[l];
      }
    });
  });
  var M = Ln;
  Object.keys(M).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === M[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return M[l];
      }
    });
  });
  var j = O8;
  Object.keys(j).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === j[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return j[l];
      }
    });
  });
  var P = YO;
  Object.keys(P).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === P[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return P[l];
      }
    });
  });
  var H = cl;
  Object.keys(H).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === H[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return H[l];
      }
    });
  });
  var F = D8;
  Object.keys(F).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === F[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return F[l];
      }
    });
  });
  var R = ul;
  Object.keys(R).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === R[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return R[l];
      }
    });
  });
  var N = fl;
  Object.keys(N).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === N[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return N[l];
      }
    });
  });
  var z = dl;
  Object.keys(z).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === z[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return z[l];
      }
    });
  });
  var q = hl;
  Object.keys(q).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === q[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return q[l];
      }
    });
  });
  var J = VO;
  Object.keys(J).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === J[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return J[l];
      }
    });
  });
  var W = Al;
  Object.keys(W).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === W[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return W[l];
      }
    });
  });
  var te = pl;
  Object.keys(te).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === te[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return te[l];
      }
    });
  });
  var S = l3;
  Object.keys(S).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === S[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return S[l];
      }
    });
  });
  var I = kO;
  Object.keys(I).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === I[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return I[l];
      }
    });
  });
  var T = c3;
  Object.keys(T).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === T[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return T[l];
      }
    });
  });
  var E = GO;
  Object.keys(E).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === E[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return E[l];
      }
    });
  });
  var x = j8;
  Object.keys(x).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === x[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return x[l];
      }
    });
  });
  var $ = S8;
  Object.keys($).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === $[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return $[l];
      }
    });
  });
  var _ = WO;
  Object.keys(_).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === _[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return _[l];
      }
    });
  });
  var Q = QO;
  Object.keys(Q).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === Q[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return Q[l];
      }
    });
  });
  var Z = UO;
  Object.keys(Z).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === Z[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return Z[l];
      }
    });
  });
  var X = ZO;
  Object.keys(X).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === X[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return X[l];
      }
    });
  });
  var Y = zO;
  Object.keys(Y).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === Y[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return Y[l];
      }
    });
  });
  var U = Cl;
  Object.keys(U).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === U[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return U[l];
      }
    });
  });
  var k = KO;
  Object.keys(k).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === k[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return k[l];
      }
    });
  });
  var L = qO;
  Object.keys(L).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === L[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return L[l];
      }
    });
  });
  var ee = XO;
  Object.keys(ee).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === ee[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return ee[l];
      }
    });
  });
  var V = vl;
  Object.keys(V).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === V[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return V[l];
      }
    });
  });
  var ne = JO;
  Object.keys(ne).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === ne[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return ne[l];
      }
    });
  });
  var ie = eD;
  Object.keys(ie).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === ie[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return ie[l];
      }
    });
  });
  var le = tD;
  Object.keys(le).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === le[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return le[l];
      }
    });
  });
  var de = rD;
  Object.keys(de).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === de[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return de[l];
      }
    });
  });
  var ve = nD;
  Object.keys(ve).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === ve[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return ve[l];
      }
    });
  });
  var Ee = gl;
  Object.keys(Ee).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === Ee[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return Ee[l];
      }
    });
  });
  var Ne = aD;
  Object.keys(Ne).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === Ne[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return Ne[l];
      }
    });
  });
  var je = iD;
  Object.keys(je).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === je[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return je[l];
      }
    });
  });
  var $e = oD;
  Object.keys($e).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === $e[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return $e[l];
      }
    });
  });
  var ft = sD;
  Object.keys(ft).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === ft[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return ft[l];
      }
    });
  });
  var yt = B8;
  Object.keys(yt).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === yt[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return yt[l];
      }
    });
  });
  var sr = I8;
  Object.keys(sr).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === sr[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return sr[l];
      }
    });
  });
  var zt = lD;
  Object.keys(zt).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === zt[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return zt[l];
      }
    });
  });
  var Z2 = N8;
  Object.keys(Z2).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === Z2[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return Z2[l];
      }
    });
  });
  var va = Y8;
  Object.keys(va).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === va[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return va[l];
      }
    });
  });
  var ga = V8;
  Object.keys(ga).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === ga[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return ga[l];
      }
    });
  });
  var x1 = AD;
  Object.keys(x1).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === x1[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return x1[l];
      }
    });
  });
  var z2 = pD;
  Object.keys(z2).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === z2[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return z2[l];
      }
    });
  });
  var K2 = vD;
  Object.keys(K2).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === K2[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return K2[l];
      }
    });
  });
  var q2 = gD;
  Object.keys(q2).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === q2[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return q2[l];
      }
    });
  });
  var X2 = mD;
  Object.keys(X2).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === X2[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return X2[l];
      }
    });
  });
  var J2 = CD;
  Object.keys(J2).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === J2[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return J2[l];
      }
    });
  });
  var ei = bD;
  Object.keys(ei).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === ei[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return ei[l];
      }
    });
  });
  var ti = yD;
  Object.keys(ti).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === ti[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return ti[l];
      }
    });
  });
  var O1 = wD;
  Object.keys(O1).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === O1[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return O1[l];
      }
    });
  });
  var ma = xD;
  Object.keys(ma).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === ma[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return ma[l];
      }
    });
  });
  var Xr = k8;
  Object.keys(Xr).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === Xr[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return Xr[l];
      }
    });
  });
  var D1 = h3;
  Object.keys(D1).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === D1[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return D1[l];
      }
    });
  });
  var M1 = H8;
  Object.keys(M1).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === M1[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return M1[l];
      }
    });
  });
  var Ca = G8;
  Object.keys(Ca).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === Ca[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return Ca[l];
      }
    });
  });
  var ri = OD;
  Object.keys(ri).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === ri[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return ri[l];
      }
    });
  });
  var ba = DD;
  Object.keys(ba).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === ba[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return ba[l];
      }
    });
  });
  var ni = Q8;
  Object.keys(ni).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === ni[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return ni[l];
      }
    });
  });
  var ya = MD;
  Object.keys(ya).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === ya[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return ya[l];
      }
    });
  });
  var wa = U8;
  Object.keys(wa).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === wa[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return wa[l];
      }
    });
  });
  var ai = wl;
  Object.keys(ai).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === ai[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return ai[l];
      }
    });
  });
  var ii = w1;
  Object.keys(ii).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === ii[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return ii[l];
      }
    });
  });
  var xa = ED;
  Object.keys(xa).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === xa[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return xa[l];
      }
    });
  });
  var oi = PD;
  Object.keys(oi).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === oi[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return oi[l];
      }
    });
  });
  var si = jD;
  Object.keys(si).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === si[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return si[l];
      }
    });
  });
  var li = SD;
  Object.keys(li).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === li[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return li[l];
      }
    });
  });
  var ci = ID;
  Object.keys(ci).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === ci[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return ci[l];
      }
    });
  });
  var G = M8;
  Object.keys(G).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === G[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return G[l];
      }
    });
  });
  var oe = BD;
  Object.keys(oe).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === oe[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return oe[l];
      }
    });
  });
  var ue = ND;
  Object.keys(ue).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === ue[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return ue[l];
      }
    });
  });
  var xe = _D;
  Object.keys(xe).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === xe[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return xe[l];
      }
    });
  });
  var Re = xl;
  Object.keys(Re).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === Re[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return Re[l];
      }
    });
  });
  var Ge = LD;
  Object.keys(Ge).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === Ge[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return Ge[l];
      }
    });
  });
  var _e = f3;
  Object.keys(_e).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === _e[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return _e[l];
      }
    });
  });
  var Be = TD;
  Object.keys(Be).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === Be[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return Be[l];
      }
    });
  });
  var jt = RD;
  Object.keys(jt).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === jt[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return jt[l];
      }
    });
  });
  var dt = $D;
  Object.keys(dt).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === dt[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return dt[l];
      }
    });
  });
  var mt = FD;
  Object.keys(mt).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === mt[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return mt[l];
      }
    });
  });
  var Wt = HD;
  Object.keys(Wt).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === Wt[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return Wt[l];
      }
    });
  });
  var Jr = YD;
  Object.keys(Jr).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === Jr[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return Jr[l];
      }
    });
  });
  var Oa = VD;
  Object.keys(Oa).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === Oa[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return Oa[l];
      }
    });
  });
  var lr = kD;
  Object.keys(lr).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === lr[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return lr[l];
      }
    });
  });
  var Rl = GD;
  Object.keys(Rl).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === Rl[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return Rl[l];
      }
    });
  });
  var $l = WD;
  Object.keys($l).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === $l[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return $l[l];
      }
    });
  });
  var Fl = QD;
  Object.keys(Fl).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === Fl[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return Fl[l];
      }
    });
  });
  var Hl = x8;
  Object.keys(Hl).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === Hl[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return Hl[l];
      }
    });
  });
  var Yl = UD;
  Object.keys(Yl).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === Yl[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return Yl[l];
      }
    });
  });
  var Vl = ZD;
  Object.keys(Vl).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === Vl[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return Vl[l];
      }
    });
  });
  var kl = zD;
  Object.keys(kl).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === kl[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return kl[l];
      }
    });
  });
  var Gl = KD;
  Object.keys(Gl).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === Gl[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return Gl[l];
      }
    });
  });
  var Wl = qD;
  Object.keys(Wl).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === Wl[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return Wl[l];
      }
    });
  });
  var Ql = P8;
  Object.keys(Ql).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === Ql[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return Ql[l];
      }
    });
  });
  var Ul = W8;
  Object.keys(Ul).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === Ul[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return Ul[l];
      }
    });
  });
  var Zl = XD;
  Object.keys(Zl).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === Zl[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return Zl[l];
      }
    });
  });
  var zl = JD;
  Object.keys(zl).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === zl[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return zl[l];
      }
    });
  });
  var Kl = eM;
  Object.keys(Kl).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === Kl[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return Kl[l];
      }
    });
  });
  var ql = Q2;
  Object.keys(ql).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === ql[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return ql[l];
      }
    });
  });
  var Xl = _f;
  Object.keys(Xl).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === Xl[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return Xl[l];
      }
    });
  });
  var Jl = Tf;
  Object.keys(Jl).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === Jl[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return Jl[l];
      }
    });
  });
  var ec = tM;
  Object.keys(ec).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === ec[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return ec[l];
      }
    });
  });
  var tc = Rf;
  Object.keys(tc).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === tc[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return tc[l];
      }
    });
  });
  var rc = Ff;
  Object.keys(rc).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === rc[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return rc[l];
      }
    });
  });
  var nc = Hf;
  Object.keys(nc).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === nc[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return nc[l];
      }
    });
  });
  var ac = Yf;
  Object.keys(ac).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === ac[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return ac[l];
      }
    });
  });
  var ic = El;
  Object.keys(ic).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === ic[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return ic[l];
      }
    });
  });
  var oc = kf;
  Object.keys(oc).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === oc[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return oc[l];
      }
    });
  });
  var sc = h8;
  Object.keys(sc).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === sc[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return sc[l];
      }
    });
  });
  var lc = A8;
  Object.keys(lc).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === lc[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return lc[l];
      }
    });
  });
  var cc = rM;
  Object.keys(cc).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === cc[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return cc[l];
      }
    });
  });
  var uc = nM;
  Object.keys(uc).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === uc[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return uc[l];
      }
    });
  });
  var fc = aM;
  Object.keys(fc).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === fc[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return fc[l];
      }
    });
  });
  var dc = iM;
  Object.keys(dc).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === dc[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return dc[l];
      }
    });
  });
  var hc = oM;
  Object.keys(hc).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === hc[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return hc[l];
      }
    });
  });
  var Ac = sM;
  Object.keys(Ac).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === Ac[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return Ac[l];
      }
    });
  });
  var pc = lM;
  Object.keys(pc).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === pc[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return pc[l];
      }
    });
  });
  var vc = cM;
  Object.keys(vc).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === vc[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return vc[l];
      }
    });
  });
  var gc = uM;
  Object.keys(gc).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === gc[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return gc[l];
      }
    });
  });
  var mc = fM;
  Object.keys(mc).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === mc[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return mc[l];
      }
    });
  });
  var Cc = dM;
  Object.keys(Cc).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === Cc[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return Cc[l];
      }
    });
  });
  var bc = hM;
  Object.keys(bc).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === bc[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return bc[l];
      }
    });
  });
  var yc = Rn;
  Object.keys(yc).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === yc[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return yc[l];
      }
    });
  });
  var wc = AM;
  Object.keys(wc).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === wc[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return wc[l];
      }
    });
  });
  var xc = a3;
  Object.keys(xc).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === xc[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return xc[l];
      }
    });
  });
  var Oc = pM;
  Object.keys(Oc).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === Oc[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return Oc[l];
      }
    });
  });
  var Dc = vM;
  Object.keys(Dc).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === Dc[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return Dc[l];
      }
    });
  });
  var Mc = gM;
  Object.keys(Mc).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === Mc[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return Mc[l];
      }
    });
  });
  var Ec = mM;
  Object.keys(Ec).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === Ec[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return Ec[l];
      }
    });
  });
  var Pc = CM;
  Object.keys(Pc).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === Pc[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return Pc[l];
      }
    });
  });
  var jc = Z8;
  Object.keys(jc).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === jc[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return jc[l];
      }
    });
  });
  var Sc = bM;
  Object.keys(Sc).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === Sc[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return Sc[l];
      }
    });
  });
  var Ic = Gf;
  Object.keys(Ic).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === Ic[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return Ic[l];
      }
    });
  });
  var Bc = yM;
  Object.keys(Bc).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === Bc[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return Bc[l];
      }
    });
  });
  var Nc = wM;
  Object.keys(Nc).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === Nc[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return Nc[l];
      }
    });
  });
  var _c = b8;
  Object.keys(_c).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === _c[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return _c[l];
      }
    });
  });
  var Lc = xM;
  Object.keys(Lc).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === Lc[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return Lc[l];
      }
    });
  });
  var Tc = OM;
  Object.keys(Tc).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === Tc[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return Tc[l];
      }
    });
  });
  var Rc = DM;
  Object.keys(Rc).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === Rc[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return Rc[l];
      }
    });
  });
  var $c = MM;
  Object.keys($c).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === $c[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return $c[l];
      }
    });
  });
  var Fc = y8;
  Object.keys(Fc).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === Fc[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return Fc[l];
      }
    });
  });
  var Hc = EM;
  Object.keys(Hc).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === Hc[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return Hc[l];
      }
    });
  });
  var Yc = PM;
  Object.keys(Yc).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === Yc[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return Yc[l];
      }
    });
  });
  var Vc = jM;
  Object.keys(Vc).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === Vc[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return Vc[l];
      }
    });
  });
  var kc = SM;
  Object.keys(kc).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === kc[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return kc[l];
      }
    });
  });
  var Gc = IM;
  Object.keys(Gc).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === Gc[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return Gc[l];
      }
    });
  });
  var Wc = Fn;
  Object.keys(Wc).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === Wc[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return Wc[l];
      }
    });
  });
  var Qc = BM;
  Object.keys(Qc).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === Qc[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return Qc[l];
      }
    });
  });
  var Uc = NM;
  Object.keys(Uc).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === Uc[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return Uc[l];
      }
    });
  });
  var Zc = _M;
  Object.keys(Zc).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === Zc[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return Zc[l];
      }
    });
  });
  var zc = LM;
  Object.keys(zc).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === zc[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return zc[l];
      }
    });
  });
  var Kc = TM;
  Object.keys(Kc).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === Kc[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return Kc[l];
      }
    });
  });
  var qc = RM;
  Object.keys(qc).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === qc[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return qc[l];
      }
    });
  });
  var Xc = $M;
  Object.keys(Xc).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === Xc[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return Xc[l];
      }
    });
  });
  var Jc = z8;
  Object.keys(Jc).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === Jc[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return Jc[l];
      }
    });
  });
  var eu = FM;
  Object.keys(eu).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === eu[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return eu[l];
      }
    });
  });
  var tu = YM;
  Object.keys(tu).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === tu[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return tu[l];
      }
    });
  });
  var ru = Hn;
  Object.keys(ru).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === ru[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return ru[l];
      }
    });
  });
  var nu = VM;
  Object.keys(nu).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === nu[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return nu[l];
      }
    });
  });
  var au = kM;
  Object.keys(au).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === au[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return au[l];
      }
    });
  });
  var iu = GM;
  Object.keys(iu).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === iu[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return iu[l];
      }
    });
  });
  var ou = WM;
  Object.keys(ou).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === ou[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return ou[l];
      }
    });
  });
  var su = QM;
  Object.keys(su).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === su[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return su[l];
      }
    });
  });
  var lu = UM;
  Object.keys(lu).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === lu[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return lu[l];
      }
    });
  });
  var cu = ZM;
  Object.keys(cu).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === cu[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return cu[l];
      }
    });
  });
  var uu = zM;
  Object.keys(uu).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === uu[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return uu[l];
      }
    });
  });
  var fu = KM;
  Object.keys(fu).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === fu[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return fu[l];
      }
    });
  });
  var du = qM;
  Object.keys(du).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === du[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return du[l];
      }
    });
  });
  var hu = XM;
  Object.keys(hu).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === hu[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return hu[l];
      }
    });
  });
  var Au = JM;
  Object.keys(Au).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === Au[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return Au[l];
      }
    });
  });
  var pu = eE;
  Object.keys(pu).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === pu[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return pu[l];
      }
    });
  });
  var vu = tE;
  Object.keys(vu).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === vu[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return vu[l];
      }
    });
  });
  var gu = rE;
  Object.keys(gu).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === gu[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return gu[l];
      }
    });
  });
  var mu = nE;
  Object.keys(mu).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === mu[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return mu[l];
      }
    });
  });
  var Cu = A3;
  Object.keys(Cu).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === Cu[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return Cu[l];
      }
    });
  });
  var bu = aE;
  Object.keys(bu).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === bu[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return bu[l];
      }
    });
  });
  var yu = iE;
  Object.keys(yu).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === yu[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return yu[l];
      }
    });
  });
  var wu = oE;
  Object.keys(wu).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === wu[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return wu[l];
      }
    });
  });
  var xu = Cf;
  Object.keys(xu).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === xu[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return xu[l];
      }
    });
  });
  var Ou = df;
  Object.keys(Ou).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === Ou[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return Ou[l];
      }
    });
  });
  var Du = g8;
  Object.keys(Du).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === Du[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return Du[l];
      }
    });
  });
  var Mu = sE;
  Object.keys(Mu).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === Mu[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return Mu[l];
      }
    });
  });
  var Eu = lE;
  Object.keys(Eu).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === Eu[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return Eu[l];
      }
    });
  });
  var Pu = Pl;
  Object.keys(Pu).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === Pu[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return Pu[l];
      }
    });
  });
  var ju = cE;
  Object.keys(ju).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === ju[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return ju[l];
      }
    });
  });
  var Su = uE;
  Object.keys(Su).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === Su[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return Su[l];
      }
    });
  });
  var Iu = uf;
  Object.keys(Iu).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === Iu[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return Iu[l];
      }
    });
  });
  var Bu = fE;
  Object.keys(Bu).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === Bu[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return Bu[l];
      }
    });
  });
  var Nu = dE;
  Object.keys(Nu).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === Nu[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return Nu[l];
      }
    });
  });
  var _u = o3;
  Object.keys(_u).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === _u[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return _u[l];
      }
    });
  });
  var Lu = hE;
  Object.keys(Lu).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === Lu[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return Lu[l];
      }
    });
  });
  var Tu = Lf;
  Object.keys(Tu).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === Tu[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return Tu[l];
      }
    });
  });
  var Ru = An;
  Object.keys(Ru).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === Ru[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return Ru[l];
      }
    });
  });
  var $u = W2;
  Object.keys($u).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === $u[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return $u[l];
      }
    });
  });
  var Fu = $f;
  Object.keys(Fu).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === Fu[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return Fu[l];
      }
    });
  });
  var Hu = u3;
  Object.keys(Hu).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === Hu[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return Hu[l];
      }
    });
  });
  var Yu = ml;
  Object.keys(Yu).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === Yu[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return Yu[l];
      }
    });
  });
  var Vu = Vf;
  Object.keys(Vu).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === Vu[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return Vu[l];
      }
    });
  });
  var ku = AE;
  Object.keys(ku).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === ku[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return ku[l];
      }
    });
  });
  var Gu = pE;
  Object.keys(Gu).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === Gu[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return Gu[l];
      }
    });
  });
  var Wu = Kr;
  Object.keys(Wu).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === Wu[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return Wu[l];
      }
    });
  });
  var Qu = Ol;
  Object.keys(Qu).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === Qu[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return Qu[l];
      }
    });
  });
  var Uu = bl;
  Object.keys(Uu).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === Uu[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return Uu[l];
      }
    });
  });
  var Zu = vE;
  Object.keys(Zu).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === Zu[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return Zu[l];
      }
    });
  });
  var zu = gE;
  Object.keys(zu).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === zu[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return zu[l];
      }
    });
  });
  var Ku = mE;
  Object.keys(Ku).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === Ku[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return Ku[l];
      }
    });
  });
  var qu = p3;
  Object.keys(qu).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === qu[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return qu[l];
      }
    });
  });
  var Xu = CE;
  Object.keys(Xu).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === Xu[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return Xu[l];
      }
    });
  });
  var Ju = E8;
  Object.keys(Ju).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === Ju[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return Ju[l];
      }
    });
  });
  var e6 = bE;
  Object.keys(e6).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === e6[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return e6[l];
      }
    });
  });
  var t6 = yE;
  Object.keys(t6).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === t6[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return t6[l];
      }
    });
  });
  var r6 = Wf;
  Object.keys(r6).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === r6[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return r6[l];
      }
    });
  });
  var n6 = wE;
  Object.keys(n6).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === n6[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return n6[l];
      }
    });
  });
  var a6 = xE;
  Object.keys(a6).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === a6[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return a6[l];
      }
    });
  });
  var i6 = OE;
  Object.keys(i6).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === i6[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return i6[l];
      }
    });
  });
  var o6 = DE;
  Object.keys(o6).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === o6[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return o6[l];
      }
    });
  });
  var s6 = ae;
  Object.keys(s6).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === s6[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return s6[l];
      }
    });
  });
  var l6 = K8;
  Object.keys(l6).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === l6[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return l6[l];
      }
    });
  });
  var c6 = ME;
  Object.keys(c6).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === c6[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return c6[l];
      }
    });
  });
  var u6 = EE;
  Object.keys(u6).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === u6[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return u6[l];
      }
    });
  });
  var f6 = PE;
  Object.keys(f6).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === f6[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return f6[l];
      }
    });
  });
  var d6 = jE;
  Object.keys(d6).forEach(function(l) {
    l === "default" || l === "__esModule" || l in e && e[l] === d6[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return d6[l];
      }
    });
  });
})(y1);
Object.defineProperty(In, "__esModule", {
  value: !0
});
In.rangeShape = In.default = void 0;
var B1 = rCe(B), Fe = SE(un), P4 = SE(fa), qt = y1;
function SE(e) {
  return e && e.__esModule ? e : { default: e };
}
function IE(e) {
  if (typeof WeakMap != "function")
    return null;
  var t = /* @__PURE__ */ new WeakMap(), r = /* @__PURE__ */ new WeakMap();
  return (IE = function(n) {
    return n ? r : t;
  })(e);
}
function rCe(e, t) {
  if (!t && e && e.__esModule)
    return e;
  if (e === null || typeof e != "object" && typeof e != "function")
    return { default: e };
  var r = IE(t);
  if (r && r.has(e))
    return r.get(e);
  var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var i in e)
    if (i !== "default" && Object.prototype.hasOwnProperty.call(e, i)) {
      var o = a ? Object.getOwnPropertyDescriptor(e, i) : null;
      o && (o.get || o.set) ? Object.defineProperty(n, i, o) : n[i] = e[i];
    }
  return n.default = e, r && r.set(e, n), n;
}
function O7() {
  return O7 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, O7.apply(this, arguments);
}
function Ti(e, t, r) {
  return t = nCe(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function nCe(e) {
  var t = aCe(e, "string");
  return typeof t == "symbol" ? t : String(t);
}
function aCe(e, t) {
  if (typeof e != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (typeof n != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
class Qf extends B1.Component {
  constructor(t, r) {
    super(t, r), Ti(this, "handleKeyEvent", (n) => {
      const {
        day: a,
        onMouseDown: i,
        onMouseUp: o
      } = this.props;
      [
        13,
        32
        /* enter */
      ].includes(n.keyCode) && (n.type === "keydown" ? i(a) : o(a));
    }), Ti(this, "handleMouseEvent", (n) => {
      const {
        day: a,
        disabled: i,
        onPreviewChange: o,
        onMouseEnter: s,
        onMouseDown: c,
        onMouseUp: u
      } = this.props, d = {};
      if (i) {
        o();
        return;
      }
      switch (n.type) {
        case "mouseenter":
          s(a), o(a), d.hover = !0;
          break;
        case "blur":
        case "mouseleave":
          d.hover = !1;
          break;
        case "mousedown":
          d.active = !0, c(a);
          break;
        case "mouseup":
          n.stopPropagation(), d.active = !1, u(a);
          break;
        case "focus":
          o(a);
          break;
      }
      Object.keys(d).length && this.setState(d);
    }), Ti(this, "getClassNames", () => {
      const {
        isPassive: n,
        isToday: a,
        isWeekend: i,
        isStartOfWeek: o,
        isEndOfWeek: s,
        isStartOfMonth: c,
        isEndOfMonth: u,
        disabled: d,
        styles: h
      } = this.props;
      return (0, P4.default)(h.day, {
        [h.dayPassive]: n,
        [h.dayDisabled]: d,
        [h.dayToday]: a,
        [h.dayWeekend]: i,
        [h.dayStartOfWeek]: o,
        [h.dayEndOfWeek]: s,
        [h.dayStartOfMonth]: c,
        [h.dayEndOfMonth]: u,
        [h.dayHovered]: this.state.hover,
        [h.dayActive]: this.state.active
      });
    }), Ti(this, "renderPreviewPlaceholder", () => {
      const {
        preview: n,
        day: a,
        styles: i
      } = this.props;
      if (!n)
        return null;
      const o = n.startDate ? (0, qt.endOfDay)(n.startDate) : null, s = n.endDate ? (0, qt.startOfDay)(n.endDate) : null, c = (!o || (0, qt.isAfter)(a, o)) && (!s || (0, qt.isBefore)(a, s)), u = !c && (0, qt.isSameDay)(a, o), d = !c && (0, qt.isSameDay)(a, s);
      return /* @__PURE__ */ B1.default.createElement("span", {
        className: (0, P4.default)({
          [i.dayStartPreview]: u,
          [i.dayInPreview]: c,
          [i.dayEndPreview]: d
        }),
        style: {
          color: n.color
        }
      });
    }), Ti(this, "renderSelectionPlaceholders", () => {
      const {
        styles: n,
        ranges: a,
        day: i
      } = this.props;
      return this.props.displayMode === "date" ? (0, qt.isSameDay)(this.props.day, this.props.date) ? /* @__PURE__ */ B1.default.createElement("span", {
        className: n.selected,
        style: {
          color: this.props.color
        }
      }) : null : a.reduce((s, c) => {
        let u = c.startDate, d = c.endDate;
        u && d && (0, qt.isBefore)(d, u) && ([u, d] = [d, u]), u = u ? (0, qt.endOfDay)(u) : null, d = d ? (0, qt.startOfDay)(d) : null;
        const h = (!u || (0, qt.isAfter)(i, u)) && (!d || (0, qt.isBefore)(i, d)), A = !h && (0, qt.isSameDay)(i, u), p = !h && (0, qt.isSameDay)(i, d);
        return h || A || p ? [...s, {
          isStartEdge: A,
          isEndEdge: p,
          isInRange: h,
          ...c
        }] : s;
      }, []).map((s, c) => /* @__PURE__ */ B1.default.createElement("span", {
        key: c,
        className: (0, P4.default)({
          [n.startEdge]: s.isStartEdge,
          [n.endEdge]: s.isEndEdge,
          [n.inRange]: s.isInRange
        }),
        style: {
          color: s.color || this.props.color
        }
      }));
    }), this.state = {
      hover: !1,
      active: !1
    };
  }
  render() {
    const {
      dayContentRenderer: t
    } = this.props;
    return /* @__PURE__ */ B1.default.createElement("button", O7({
      type: "button",
      onMouseEnter: this.handleMouseEvent,
      onMouseLeave: this.handleMouseEvent,
      onFocus: this.handleMouseEvent,
      onMouseDown: this.handleMouseEvent,
      onMouseUp: this.handleMouseEvent,
      onBlur: this.handleMouseEvent,
      onPauseCapture: this.handleMouseEvent,
      onKeyDown: this.handleKeyEvent,
      onKeyUp: this.handleKeyEvent,
      className: this.getClassNames(this.props.styles)
    }, this.props.disabled || this.props.isPassive ? {
      tabIndex: -1
    } : {}, {
      style: {
        color: this.props.color
      }
    }), this.renderSelectionPlaceholders(), this.renderPreviewPlaceholder(), /* @__PURE__ */ B1.default.createElement("span", {
      className: this.props.styles.dayNumber
    }, (t == null ? void 0 : t(this.props.day)) || /* @__PURE__ */ B1.default.createElement("span", null, (0, qt.format)(this.props.day, this.props.dayDisplayFormat))));
  }
}
Qf.defaultProps = {};
const iCe = In.rangeShape = Fe.default.shape({
  startDate: Fe.default.object,
  endDate: Fe.default.object,
  color: Fe.default.string,
  key: Fe.default.string,
  autoFocus: Fe.default.bool,
  disabled: Fe.default.bool,
  showDateDisplay: Fe.default.bool
});
Qf.propTypes = {
  day: Fe.default.object.isRequired,
  dayDisplayFormat: Fe.default.string,
  date: Fe.default.object,
  ranges: Fe.default.arrayOf(iCe),
  preview: Fe.default.shape({
    startDate: Fe.default.object,
    endDate: Fe.default.object,
    color: Fe.default.string
  }),
  onPreviewChange: Fe.default.func,
  previewColor: Fe.default.string,
  disabled: Fe.default.bool,
  isPassive: Fe.default.bool,
  isToday: Fe.default.bool,
  isWeekend: Fe.default.bool,
  isStartOfWeek: Fe.default.bool,
  isEndOfWeek: Fe.default.bool,
  isStartOfMonth: Fe.default.bool,
  isEndOfMonth: Fe.default.bool,
  color: Fe.default.string,
  displayMode: Fe.default.oneOf(["dateRange", "date"]),
  styles: Fe.default.object,
  onMouseDown: Fe.default.func,
  onMouseUp: Fe.default.func,
  onMouseEnter: Fe.default.func,
  dayContentRenderer: Fe.default.func
};
In.default = Qf;
var jl = {}, Yn = {};
Object.defineProperty(Yn, "__esModule", {
  value: !0
});
Yn.calcFocusDate = lCe;
Yn.findNextRangeIndex = cCe;
Yn.generateStyles = fCe;
Yn.getMonthDisplayRange = uCe;
var oCe = sCe(fa), Cn = y1;
function sCe(e) {
  return e && e.__esModule ? e : { default: e };
}
function lCe(e, t) {
  const {
    shownDate: r,
    date: n,
    months: a,
    ranges: i,
    focusedRange: o,
    displayMode: s
  } = t;
  let c;
  if (s === "dateRange") {
    const d = i[o[0]] || {};
    c = {
      start: d.startDate,
      end: d.endDate
    };
  } else
    c = {
      start: n,
      end: n
    };
  c.start = (0, Cn.startOfMonth)(c.start || /* @__PURE__ */ new Date()), c.end = (0, Cn.endOfMonth)(c.end || c.start);
  const u = c.start || c.end || r || /* @__PURE__ */ new Date();
  return e ? (0, Cn.differenceInCalendarMonths)(c.start, c.end) > a ? e : u : r || u;
}
function cCe(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : -1;
  const r = e.findIndex((n, a) => a > t && n.autoFocus !== !1 && !n.disabled);
  return r !== -1 ? r : e.findIndex((n) => n.autoFocus !== !1 && !n.disabled);
}
function uCe(e, t, r) {
  const n = (0, Cn.startOfMonth)(e, t), a = (0, Cn.endOfMonth)(e, t), i = (0, Cn.startOfWeek)(n, t);
  let o = (0, Cn.endOfWeek)(a, t);
  return r && (0, Cn.differenceInCalendarDays)(o, i) <= 34 && (o = (0, Cn.addDays)(o, 7)), {
    start: i,
    end: o,
    startDateOfMonth: n,
    endDateOfMonth: a
  };
}
function fCe(e) {
  return e.length ? e.filter((r) => !!r).reduce((r, n) => (Object.keys(n).forEach((a) => {
    r[a] = (0, oCe.default)(r[a], n[a]);
  }), r), {}) : {};
}
Object.defineProperty(jl, "__esModule", {
  value: !0
});
jl.default = void 0;
var G1 = _E(B), at = hCe(un), BE = _E(In), Dt = y1, dCe = Yn;
function hCe(e) {
  return e && e.__esModule ? e : { default: e };
}
function NE(e) {
  if (typeof WeakMap != "function")
    return null;
  var t = /* @__PURE__ */ new WeakMap(), r = /* @__PURE__ */ new WeakMap();
  return (NE = function(n) {
    return n ? r : t;
  })(e);
}
function _E(e, t) {
  if (!t && e && e.__esModule)
    return e;
  if (e === null || typeof e != "object" && typeof e != "function")
    return { default: e };
  var r = NE(t);
  if (r && r.has(e))
    return r.get(e);
  var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var i in e)
    if (i !== "default" && Object.prototype.hasOwnProperty.call(e, i)) {
      var o = a ? Object.getOwnPropertyDescriptor(e, i) : null;
      o && (o.get || o.set) ? Object.defineProperty(n, i, o) : n[i] = e[i];
    }
  return n.default = e, r && r.set(e, n), n;
}
function D7() {
  return D7 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, D7.apply(this, arguments);
}
function ACe(e, t, r) {
  const n = /* @__PURE__ */ new Date();
  return /* @__PURE__ */ G1.default.createElement("div", {
    className: e.weekDays
  }, (0, Dt.eachDayOfInterval)({
    start: (0, Dt.startOfWeek)(n, t),
    end: (0, Dt.endOfWeek)(n, t)
  }).map((a, i) => /* @__PURE__ */ G1.default.createElement("span", {
    className: e.weekDay,
    key: i
  }, (0, Dt.format)(a, r, t))));
}
class Uf extends G1.PureComponent {
  render() {
    const t = /* @__PURE__ */ new Date(), {
      displayMode: r,
      focusedRange: n,
      drag: a,
      styles: i,
      disabledDates: o,
      disabledDay: s
    } = this.props, c = this.props.minDate && (0, Dt.startOfDay)(this.props.minDate), u = this.props.maxDate && (0, Dt.endOfDay)(this.props.maxDate), d = (0, dCe.getMonthDisplayRange)(this.props.month, this.props.dateOptions, this.props.fixedHeight);
    let h = this.props.ranges;
    if (r === "dateRange" && a.status) {
      let {
        startDate: p,
        endDate: m
      } = a.range;
      h = h.map((g, v) => v !== n[0] ? g : {
        ...g,
        startDate: p,
        endDate: m
      });
    }
    const A = this.props.showPreview && !a.disablePreview;
    return /* @__PURE__ */ G1.default.createElement("div", {
      className: i.month,
      style: this.props.style
    }, this.props.showMonthName ? /* @__PURE__ */ G1.default.createElement("div", {
      className: i.monthName
    }, (0, Dt.format)(this.props.month, this.props.monthDisplayFormat, this.props.dateOptions)) : null, this.props.showWeekDays && ACe(i, this.props.dateOptions, this.props.weekdayDisplayFormat), /* @__PURE__ */ G1.default.createElement("div", {
      className: i.days,
      onMouseLeave: this.props.onMouseLeave
    }, (0, Dt.eachDayOfInterval)({
      start: d.start,
      end: d.end
    }).map((p, m) => {
      const g = (0, Dt.isSameDay)(p, d.startDateOfMonth), v = (0, Dt.isSameDay)(p, d.endDateOfMonth), C = c && (0, Dt.isBefore)(p, c) || u && (0, Dt.isAfter)(p, u), y = o.some((O) => (0, Dt.isSameDay)(O, p)), w = s(p);
      return /* @__PURE__ */ G1.default.createElement(BE.default, D7({}, this.props, {
        ranges: h,
        day: p,
        preview: A ? this.props.preview : null,
        isWeekend: (0, Dt.isWeekend)(p, this.props.dateOptions),
        isToday: (0, Dt.isSameDay)(p, t),
        isStartOfWeek: (0, Dt.isSameDay)(p, (0, Dt.startOfWeek)(p, this.props.dateOptions)),
        isEndOfWeek: (0, Dt.isSameDay)(p, (0, Dt.endOfWeek)(p, this.props.dateOptions)),
        isStartOfMonth: g,
        isEndOfMonth: v,
        key: m,
        disabled: C || y || w,
        isPassive: !(0, Dt.isWithinInterval)(p, {
          start: d.startDateOfMonth,
          end: d.endDateOfMonth
        }),
        styles: i,
        onMouseDown: this.props.onDragSelectionStart,
        onMouseUp: this.props.onDragSelectionEnd,
        onMouseEnter: this.props.onDragSelectionMove,
        dragRange: a.range,
        drag: a.status
      }));
    })));
  }
}
Uf.defaultProps = {};
Uf.propTypes = {
  style: at.default.object,
  styles: at.default.object,
  month: at.default.object,
  drag: at.default.object,
  dateOptions: at.default.object,
  disabledDates: at.default.array,
  disabledDay: at.default.func,
  preview: at.default.shape({
    startDate: at.default.object,
    endDate: at.default.object
  }),
  showPreview: at.default.bool,
  displayMode: at.default.oneOf(["dateRange", "date"]),
  minDate: at.default.object,
  maxDate: at.default.object,
  ranges: at.default.arrayOf(BE.rangeShape),
  focusedRange: at.default.arrayOf(at.default.number),
  onDragSelectionStart: at.default.func,
  onDragSelectionEnd: at.default.func,
  onDragSelectionMove: at.default.func,
  onMouseLeave: at.default.func,
  monthDisplayFormat: at.default.string,
  weekdayDisplayFormat: at.default.string,
  dayDisplayFormat: at.default.string,
  showWeekDays: at.default.bool,
  showMonthName: at.default.bool,
  fixedHeight: at.default.bool
};
jl.default = Uf;
var Sl = {};
Object.defineProperty(Sl, "__esModule", {
  value: !0
});
Sl.default = void 0;
var k3 = vCe(B), en = LE(un), pCe = LE(fa), Ri = y1;
function LE(e) {
  return e && e.__esModule ? e : { default: e };
}
function TE(e) {
  if (typeof WeakMap != "function")
    return null;
  var t = /* @__PURE__ */ new WeakMap(), r = /* @__PURE__ */ new WeakMap();
  return (TE = function(n) {
    return n ? r : t;
  })(e);
}
function vCe(e, t) {
  if (!t && e && e.__esModule)
    return e;
  if (e === null || typeof e != "object" && typeof e != "function")
    return { default: e };
  var r = TE(t);
  if (r && r.has(e))
    return r.get(e);
  var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var i in e)
    if (i !== "default" && Object.prototype.hasOwnProperty.call(e, i)) {
      var o = a ? Object.getOwnPropertyDescriptor(e, i) : null;
      o && (o.get || o.set) ? Object.defineProperty(n, i, o) : n[i] = e[i];
    }
  return n.default = e, r && r.set(e, n), n;
}
function j4(e, t, r) {
  return t = gCe(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function gCe(e) {
  var t = mCe(e, "string");
  return typeof t == "symbol" ? t : String(t);
}
function mCe(e, t) {
  if (typeof e != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (typeof n != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
class Zf extends k3.PureComponent {
  constructor(t, r) {
    super(t, r), j4(this, "onKeyDown", (n) => {
      const {
        value: a
      } = this.state;
      n.key === "Enter" && this.update(a);
    }), j4(this, "onChange", (n) => {
      this.setState({
        value: n.target.value,
        changed: !0,
        invalid: !1
      });
    }), j4(this, "onBlur", () => {
      const {
        value: n
      } = this.state;
      this.update(n);
    }), this.state = {
      invalid: !1,
      changed: !1,
      value: this.formatDate(t)
    };
  }
  componentDidUpdate(t) {
    const {
      value: r
    } = t;
    (0, Ri.isEqual)(r, this.props.value) || this.setState({
      value: this.formatDate(this.props)
    });
  }
  formatDate(t) {
    let {
      value: r,
      dateDisplayFormat: n,
      dateOptions: a
    } = t;
    return r && (0, Ri.isValid)(r) ? (0, Ri.format)(r, n, a) : "";
  }
  update(t) {
    const {
      invalid: r,
      changed: n
    } = this.state;
    if (r || !n || !t)
      return;
    const {
      onChange: a,
      dateDisplayFormat: i,
      dateOptions: o
    } = this.props, s = (0, Ri.parse)(t, i, /* @__PURE__ */ new Date(), o);
    (0, Ri.isValid)(s) ? this.setState({
      changed: !1
    }, () => a(s)) : this.setState({
      invalid: !0
    });
  }
  render() {
    const {
      className: t,
      readOnly: r,
      placeholder: n,
      ariaLabel: a,
      disabled: i,
      onFocus: o
    } = this.props, {
      value: s,
      invalid: c
    } = this.state;
    return /* @__PURE__ */ k3.default.createElement("span", {
      className: (0, pCe.default)("rdrDateInput", t)
    }, /* @__PURE__ */ k3.default.createElement("input", {
      readOnly: r,
      disabled: i,
      value: s,
      placeholder: n,
      "aria-label": a,
      onKeyDown: this.onKeyDown,
      onChange: this.onChange,
      onBlur: this.onBlur,
      onFocus: o
    }), c && /* @__PURE__ */ k3.default.createElement("span", {
      className: "rdrWarning"
    }, "⚠"));
  }
}
Zf.propTypes = {
  value: en.default.object,
  placeholder: en.default.string,
  disabled: en.default.bool,
  readOnly: en.default.bool,
  dateOptions: en.default.object,
  dateDisplayFormat: en.default.string,
  ariaLabel: en.default.string,
  className: en.default.string,
  onFocus: en.default.func.isRequired,
  onChange: en.default.func.isRequired
};
Zf.defaultProps = {
  readOnly: !0,
  disabled: !1,
  dateDisplayFormat: "MMM D, YYYY"
};
Sl.default = Zf;
var RE = {};
(function(e) {
  (function(t, r) {
    r(e, B, f);
  })(typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : $i, function(t, r, n) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    function a(E) {
      "@babel/helpers - typeof";
      return a = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(x) {
        return typeof x;
      } : function(x) {
        return x && typeof Symbol == "function" && x.constructor === Symbol && x !== Symbol.prototype ? "symbol" : typeof x;
      }, a(E);
    }
    function i(E, x) {
      if (!(E instanceof x))
        throw new TypeError("Cannot call a class as a function");
    }
    function o(E, x) {
      for (var $ = 0; $ < x.length; $++) {
        var _ = x[$];
        _.enumerable = _.enumerable || !1, _.configurable = !0, "value" in _ && (_.writable = !0), Object.defineProperty(E, y(_.key), _);
      }
    }
    function s(E, x, $) {
      return x && o(E.prototype, x), $ && o(E, $), Object.defineProperty(E, "prototype", { writable: !1 }), E;
    }
    function c(E, x, $) {
      return x = A(x), u(E, h() ? Reflect.construct(x, $ || [], A(E).constructor) : x.apply(E, $));
    }
    function u(E, x) {
      if (x && (a(x) == "object" || typeof x == "function"))
        return x;
      if (x !== void 0)
        throw new TypeError("Derived constructors may only return object or undefined");
      return d(E);
    }
    function d(E) {
      if (E === void 0)
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return E;
    }
    function h() {
      try {
        var E = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
        }));
      } catch {
      }
      return (h = function() {
        return !!E;
      })();
    }
    function A(E) {
      return A = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(x) {
        return x.__proto__ || Object.getPrototypeOf(x);
      }, A(E);
    }
    function p(E, x) {
      if (typeof x != "function" && x !== null)
        throw new TypeError("Super expression must either be null or a function");
      E.prototype = Object.create(x && x.prototype, { constructor: { value: E, writable: !0, configurable: !0 } }), Object.defineProperty(E, "prototype", { writable: !1 }), x && m(E, x);
    }
    function m(E, x) {
      return m = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function($, _) {
        return $.__proto__ = _, $;
      }, m(E, x);
    }
    function g(E, x) {
      var $ = Object.keys(E);
      if (Object.getOwnPropertySymbols) {
        var _ = Object.getOwnPropertySymbols(E);
        x && (_ = _.filter(function(Q) {
          return Object.getOwnPropertyDescriptor(E, Q).enumerable;
        })), $.push.apply($, _);
      }
      return $;
    }
    function v(E) {
      for (var x = 1; x < arguments.length; x++) {
        var $ = arguments[x] != null ? arguments[x] : {};
        x % 2 ? g(Object($), !0).forEach(function(_) {
          C(E, _, $[_]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(E, Object.getOwnPropertyDescriptors($)) : g(Object($)).forEach(function(_) {
          Object.defineProperty(E, _, Object.getOwnPropertyDescriptor($, _));
        });
      }
      return E;
    }
    function C(E, x, $) {
      return (x = y(x)) in E ? Object.defineProperty(E, x, { value: $, enumerable: !0, configurable: !0, writable: !0 }) : E[x] = $, E;
    }
    function y(E) {
      var x = w(E, "string");
      return a(x) == "symbol" ? x : x + "";
    }
    function w(E, x) {
      if (a(E) != "object" || !E)
        return E;
      var $ = E[Symbol.toPrimitive];
      if ($ !== void 0) {
        var _ = $.call(E, x || "default");
        if (a(_) != "object")
          return _;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return (x === "string" ? String : Number)(E);
    }
    var O = {
      x: "clientWidth",
      y: "clientHeight"
    }, b = {
      x: "clientTop",
      y: "clientLeft"
    }, D = {
      x: "innerWidth",
      y: "innerHeight"
    }, M = {
      x: "offsetWidth",
      y: "offsetHeight"
    }, j = {
      x: "offsetLeft",
      y: "offsetTop"
    }, P = {
      x: "overflowX",
      y: "overflowY"
    }, H = {
      x: "scrollWidth",
      y: "scrollHeight"
    }, F = {
      x: "scrollLeft",
      y: "scrollTop"
    }, R = {
      x: "width",
      y: "height"
    }, N = function() {
    }, z = function() {
      if (typeof window > "u")
        return !1;
      var E = !1;
      try {
        document.createElement("div").addEventListener("test", N, {
          get passive() {
            return E = !0, !1;
          }
        });
      } catch {
      }
      return E;
    }() ? {
      passive: !0
    } : !1, q = "ReactList failed to reach a stable state.", J = 40, W = function(x, $) {
      for (var _ in $)
        if (x[_] !== $[_])
          return !1;
      return !0;
    }, te = function(x) {
      for (var $ = x.props.axis, _ = x.getEl(), Q = P[$]; _ = _.parentElement; )
        switch (window.getComputedStyle(_)[Q]) {
          case "auto":
          case "scroll":
          case "overlay":
            return _;
        }
      return window;
    }, S = function(x) {
      var $ = x.props.axis, _ = x.scrollParent;
      return _ === window ? window[D[$]] : _[O[$]];
    }, I = function(x, $) {
      var _ = x.length, Q = x.minSize, Z = x.type, X = $.from, Y = $.size, U = $.itemsPerRow;
      Y = Math.max(Y, Q);
      var k = Y % U;
      return k && (Y += U - k), Y > _ && (Y = _), X = Z === "simple" || !X ? 0 : Math.max(Math.min(X, _ - Y), 0), (k = X % U) && (X -= k, Y += k), X === $.from && Y === $.size ? $ : v(v({}, $), {}, {
        from: X,
        size: Y
      });
    }, T = t.default = /* @__PURE__ */ function(E) {
      function x($) {
        var _;
        return i(this, x), _ = c(this, x, [$]), _.state = I($, {
          itemsPerRow: 1,
          from: $.initialIndex,
          size: 0
        }), _.cache = {}, _.cachedScrollPosition = null, _.prevPrevState = {}, _.unstable = !1, _.updateCounter = 0, _;
      }
      return p(x, E), s(x, [{
        key: "componentDidMount",
        value: function() {
          this.updateFrameAndClearCache = this.updateFrameAndClearCache.bind(this), window.addEventListener("resize", this.updateFrameAndClearCache), this.updateFrame(this.scrollTo.bind(this, this.props.initialIndex));
        }
      }, {
        key: "componentDidUpdate",
        value: function(_) {
          var Q = this;
          if (this.props.axis !== _.axis && this.clearSizeCache(), !this.unstable) {
            if (++this.updateCounter > J)
              return this.unstable = !0, console.error(q);
            this.updateCounterTimeoutId || (this.updateCounterTimeoutId = setTimeout(function() {
              Q.updateCounter = 0, delete Q.updateCounterTimeoutId;
            }, 0)), this.updateFrame();
          }
        }
      }, {
        key: "maybeSetState",
        value: function(_, Q) {
          if (W(this.state, _))
            return Q();
          this.setState(_, Q);
        }
      }, {
        key: "componentWillUnmount",
        value: function() {
          window.removeEventListener("resize", this.updateFrameAndClearCache), this.scrollParent.removeEventListener("scroll", this.updateFrameAndClearCache, z), this.scrollParent.removeEventListener("mousewheel", N, z);
        }
      }, {
        key: "getOffset",
        value: function(_) {
          var Q = this.props.axis, Z = _[b[Q]] || 0, X = j[Q];
          do
            Z += _[X] || 0;
          while (_ = _.offsetParent);
          return Z;
        }
      }, {
        key: "getEl",
        value: function() {
          return this.el || this.items;
        }
      }, {
        key: "getScrollPosition",
        value: function() {
          if (typeof this.cachedScrollPosition == "number")
            return this.cachedScrollPosition;
          var _ = this.scrollParent, Q = this.props.axis, Z = F[Q], X = _ === window ? (
            // Firefox always returns document.body[scrollKey] as 0 and Chrome/Safari
            // always return document.documentElement[scrollKey] as 0, so take
            // whichever has a value.
            document.body[Z] || document.documentElement[Z]
          ) : _[Z], Y = this.getScrollSize() - this.props.scrollParentViewportSizeGetter(this), U = Math.max(0, Math.min(X, Y)), k = this.getEl();
          return this.cachedScrollPosition = this.getOffset(_) + U - this.getOffset(k), this.cachedScrollPosition;
        }
      }, {
        key: "setScroll",
        value: function(_) {
          var Q = this.scrollParent, Z = this.props.axis;
          if (_ += this.getOffset(this.getEl()), Q === window)
            return window.scrollTo(0, _);
          _ -= this.getOffset(this.scrollParent), Q[F[Z]] = _;
        }
      }, {
        key: "getScrollSize",
        value: function() {
          var _ = this.scrollParent, Q = document, Z = Q.body, X = Q.documentElement, Y = H[this.props.axis];
          return _ === window ? Math.max(Z[Y], X[Y]) : _[Y];
        }
      }, {
        key: "hasDeterminateSize",
        value: function() {
          var _ = this.props, Q = _.itemSizeGetter, Z = _.type;
          return Z === "uniform" || Q;
        }
      }, {
        key: "getStartAndEnd",
        value: function() {
          var _ = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.props.threshold, Q = this.getScrollPosition(), Z = Math.max(0, Q - _), X = Q + this.props.scrollParentViewportSizeGetter(this) + _;
          return this.hasDeterminateSize() && (X = Math.min(X, this.getSpaceBefore(this.props.length))), {
            start: Z,
            end: X
          };
        }
      }, {
        key: "getItemSizeAndItemsPerRow",
        value: function() {
          var _ = this.props, Q = _.axis, Z = _.useStaticSize, X = this.state, Y = X.itemSize, U = X.itemsPerRow;
          if (Z && Y && U)
            return {
              itemSize: Y,
              itemsPerRow: U
            };
          var k = this.items.children;
          if (!k.length)
            return {};
          var L = k[0], ee = L[M[Q]], V = Math.abs(ee - Y);
          if ((isNaN(V) || V >= 1) && (Y = ee), !Y)
            return {};
          var ne = j[Q], ie = L[ne];
          U = 1;
          for (var le = k[U]; le && le[ne] === ie; le = k[U])
            ++U;
          return {
            itemSize: Y,
            itemsPerRow: U
          };
        }
      }, {
        key: "clearSizeCache",
        value: function() {
          this.cachedScrollPosition = null;
        }
        // Called by 'scroll' and 'resize' events, clears scroll position cache.
      }, {
        key: "updateFrameAndClearCache",
        value: function(_) {
          return this.clearSizeCache(), this.updateFrame(_);
        }
      }, {
        key: "updateFrame",
        value: function(_) {
          switch (this.updateScrollParent(), typeof _ != "function" && (_ = N), this.props.type) {
            case "simple":
              return this.updateSimpleFrame(_);
            case "variable":
              return this.updateVariableFrame(_);
            case "uniform":
              return this.updateUniformFrame(_);
          }
        }
      }, {
        key: "updateScrollParent",
        value: function() {
          var _ = this.scrollParent;
          this.scrollParent = this.props.scrollParentGetter(this), _ !== this.scrollParent && (_ && (_.removeEventListener("scroll", this.updateFrameAndClearCache), _.removeEventListener("mousewheel", N)), this.clearSizeCache(), this.scrollParent.addEventListener("scroll", this.updateFrameAndClearCache, z), this.scrollParent.addEventListener("mousewheel", N, z));
        }
      }, {
        key: "updateSimpleFrame",
        value: function(_) {
          var Q = this.getStartAndEnd(), Z = Q.end, X = this.items.children, Y = 0;
          if (X.length) {
            var U = this.props.axis, k = X[0], L = X[X.length - 1];
            Y = this.getOffset(L) + L[M[U]] - this.getOffset(k);
          }
          if (Y > Z)
            return _();
          var ee = this.props, V = ee.pageSize, ne = ee.length, ie = Math.min(this.state.size + V, ne);
          this.maybeSetState({
            size: ie
          }, _);
        }
      }, {
        key: "updateVariableFrame",
        value: function(_) {
          this.props.itemSizeGetter || this.cacheSizes();
          for (var Q = this.getStartAndEnd(), Z = Q.start, X = Q.end, Y = this.props, U = Y.length, k = Y.pageSize, L = 0, ee = 0, V = 0, ne = U - 1; ee < ne; ) {
            var ie = this.getSizeOfItem(ee);
            if (ie == null || L + ie > Z)
              break;
            L += ie, ++ee;
          }
          for (var le = U - ee; V < le && L < X; ) {
            var de = this.getSizeOfItem(ee + V);
            if (de == null) {
              V = Math.min(V + k, le);
              break;
            }
            L += de, ++V;
          }
          this.maybeSetState(I(this.props, {
            from: ee,
            itemsPerRow: 1,
            size: V
          }), _);
        }
      }, {
        key: "updateUniformFrame",
        value: function(_) {
          var Q = this.getItemSizeAndItemsPerRow(), Z = Q.itemSize, X = Q.itemsPerRow;
          if (!Z || !X)
            return _();
          var Y = this.getStartAndEnd(), U = Y.start, k = Y.end, L = I(this.props, {
            from: Math.floor(U / Z) * X,
            size: (Math.ceil((k - U) / Z) + 1) * X,
            itemsPerRow: X
          }), ee = L.from, V = L.size;
          return this.maybeSetState({
            itemsPerRow: X,
            from: ee,
            itemSize: Z,
            size: V
          }, _);
        }
      }, {
        key: "getSpaceBefore",
        value: function(_) {
          var Q = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
          if (Q[_] != null)
            return Q[_];
          var Z = this.state, X = Z.itemSize, Y = Z.itemsPerRow;
          if (X)
            return Q[_] = Math.floor(_ / Y) * X;
          for (var U = _; U > 0 && Q[--U] == null; )
            ;
          for (var k = Q[U] || 0, L = U; L < _; ++L) {
            Q[L] = k;
            var ee = this.getSizeOfItem(L);
            if (ee == null)
              break;
            k += ee;
          }
          return Q[_] = k;
        }
      }, {
        key: "cacheSizes",
        value: function() {
          for (var _ = this.cache, Q = this.state.from, Z = this.items.children, X = M[this.props.axis], Y = 0, U = Z.length; Y < U; ++Y)
            _[Q + Y] = Z[Y][X];
        }
      }, {
        key: "getSizeOfItem",
        value: function(_) {
          var Q = this.cache, Z = this.items, X = this.props, Y = X.axis, U = X.itemSizeGetter, k = X.itemSizeEstimator, L = X.type, ee = this.state, V = ee.from, ne = ee.itemSize, ie = ee.size;
          if (ne)
            return ne;
          if (U)
            return U(_);
          if (_ in Q)
            return Q[_];
          if (L === "simple" && _ >= V && _ < V + ie && Z) {
            var le = Z.children[_ - V];
            if (le)
              return le[M[Y]];
          }
          if (k)
            return k(_, Q);
        }
      }, {
        key: "scrollTo",
        value: function(_) {
          _ != null && this.setScroll(this.getSpaceBefore(_));
        }
      }, {
        key: "scrollAround",
        value: function(_) {
          var Q = this.getScrollPosition(), Z = this.getSpaceBefore(_), X = Z - this.props.scrollParentViewportSizeGetter(this) + this.getSizeOfItem(_), Y = Math.min(X, Z), U = Math.max(X, Z);
          if (Q <= Y)
            return this.setScroll(Y);
          if (Q > U)
            return this.setScroll(U);
        }
      }, {
        key: "getVisibleRange",
        value: function() {
          for (var _ = this.state, Q = _.from, Z = _.size, X = this.getStartAndEnd(0), Y = X.start, U = X.end, k = {}, L, ee, V = Q; V < Q + Z; ++V) {
            var ne = this.getSpaceBefore(V, k), ie = ne + this.getSizeOfItem(V);
            L == null && ie > Y && (L = V), L != null && ne < U && (ee = V);
          }
          return [L, ee];
        }
      }, {
        key: "renderItems",
        value: function() {
          for (var _ = this, Q = this.props, Z = Q.itemRenderer, X = Q.itemsRenderer, Y = this.state, U = Y.from, k = Y.size, L = [], ee = 0; ee < k; ++ee)
            L.push(Z(U + ee, ee));
          return X(L, function(V) {
            return _.items = V;
          });
        }
      }, {
        key: "render",
        value: function() {
          var _ = this, Q = this.props, Z = Q.axis, X = Q.length, Y = Q.type, U = Q.useTranslate3d, k = this.state, L = k.from, ee = k.itemsPerRow, V = this.renderItems();
          if (Y === "simple")
            return V;
          var ne = {
            position: "relative"
          }, ie = {}, le = Math.ceil(X / ee) * ee, de = this.getSpaceBefore(le, ie);
          de && (ne[R[Z]] = de, Z === "x" && (ne.overflowX = "hidden"));
          var ve = this.getSpaceBefore(L, ie), Ee = Z === "x" ? ve : 0, Ne = Z === "y" ? ve : 0, je = U ? "translate3d(".concat(Ee, "px, ").concat(Ne, "px, 0)") : "translate(".concat(Ee, "px, ").concat(Ne, "px)"), $e = {
            msTransform: je,
            WebkitTransform: je,
            transform: je
          };
          return /* @__PURE__ */ (0, n.jsx)("div", {
            style: ne,
            ref: function(yt) {
              return _.el = yt;
            },
            children: /* @__PURE__ */ (0, n.jsx)("div", {
              style: $e,
              children: V
            })
          });
        }
      }], [{
        key: "getDerivedStateFromProps",
        value: function(_, Q) {
          var Z = I(_, Q);
          return Z === Q ? null : Z;
        }
      }]);
    }(r.Component);
    C(T, "displayName", "ReactList"), C(T, "defaultProps", {
      axis: "y",
      itemRenderer: function(x, $) {
        return /* @__PURE__ */ (0, n.jsx)("div", {
          children: x
        }, $);
      },
      itemsRenderer: function(x, $) {
        return /* @__PURE__ */ (0, n.jsx)("div", {
          ref: $,
          children: x
        });
      },
      length: 0,
      minSize: 1,
      pageSize: 10,
      scrollParentGetter: te,
      scrollParentViewportSizeGetter: S,
      threshold: 100,
      type: "simple",
      useStaticSize: !1,
      useTranslate3d: !1
    });
  });
})(RE);
function CCe(e, t) {
  if (e === t)
    return !0;
  if (!e || !t)
    return !1;
  var r = Object.keys(e), n = Object.keys(t), a = r.length;
  if (n.length !== a)
    return !1;
  for (var i = 0; i < a; i++) {
    var o = r[i];
    if (e[o] !== t[o] || !Object.prototype.hasOwnProperty.call(t, o))
      return !1;
  }
  return !0;
}
function bCe(e, t) {
  if (e === t)
    return !0;
  if (!e || !t)
    return !1;
  var r = e.length;
  if (t.length !== r)
    return !1;
  for (var n = 0; n < r; n++)
    if (e[n] !== t[n])
      return !1;
  return !0;
}
const yCe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  shallowEqualArrays: bCe,
  shallowEqualObjects: CCe
}, Symbol.toStringTag, { value: "Module" })), wCe = /* @__PURE__ */ oP(yCe);
var pa = {};
Object.defineProperty(pa, "__esModule", {
  value: !0
});
pa.default = void 0;
pa.default = {
  dateRangeWrapper: "rdrDateRangeWrapper",
  calendarWrapper: "rdrCalendarWrapper",
  dateDisplay: "rdrDateDisplay",
  dateDisplayItem: "rdrDateDisplayItem",
  dateDisplayItemActive: "rdrDateDisplayItemActive",
  monthAndYearWrapper: "rdrMonthAndYearWrapper",
  monthAndYearPickers: "rdrMonthAndYearPickers",
  nextPrevButton: "rdrNextPrevButton",
  month: "rdrMonth",
  weekDays: "rdrWeekDays",
  weekDay: "rdrWeekDay",
  days: "rdrDays",
  day: "rdrDay",
  dayNumber: "rdrDayNumber",
  dayPassive: "rdrDayPassive",
  dayToday: "rdrDayToday",
  dayStartOfWeek: "rdrDayStartOfWeek",
  dayEndOfWeek: "rdrDayEndOfWeek",
  daySelected: "rdrDaySelected",
  dayDisabled: "rdrDayDisabled",
  dayStartOfMonth: "rdrDayStartOfMonth",
  dayEndOfMonth: "rdrDayEndOfMonth",
  dayWeekend: "rdrDayWeekend",
  dayStartPreview: "rdrDayStartPreview",
  dayInPreview: "rdrDayInPreview",
  dayEndPreview: "rdrDayEndPreview",
  dayHovered: "rdrDayHovered",
  dayActive: "rdrDayActive",
  inRange: "rdrInRange",
  endEdge: "rdrEndEdge",
  startEdge: "rdrStartEdge",
  prevButton: "rdrPprevButton",
  nextButton: "rdrNextButton",
  selected: "rdrSelected",
  months: "rdrMonths",
  monthPicker: "rdrMonthPicker",
  yearPicker: "rdrYearPicker",
  dateDisplayWrapper: "rdrDateDisplayWrapper",
  definedRangesWrapper: "rdrDefinedRangesWrapper",
  staticRanges: "rdrStaticRanges",
  staticRange: "rdrStaticRange",
  inputRanges: "rdrInputRanges",
  inputRange: "rdrInputRange",
  inputRangeInput: "rdrInputRangeInput",
  dateRangePickerWrapper: "rdrDateRangePickerWrapper",
  staticRangeLabel: "rdrStaticRangeLabel",
  staticRangeSelected: "rdrStaticRangeSelected",
  monthName: "rdrMonthName",
  infiniteMonths: "rdrInfiniteMonths",
  monthsVertical: "rdrMonthsVertical",
  monthsHorizontal: "rdrMonthsHorizontal"
};
var Il = {};
Object.defineProperty(Il, "__esModule", {
  value: !0
});
Il.ariaLabelsShape = void 0;
var gn = xCe(un);
function xCe(e) {
  return e && e.__esModule ? e : { default: e };
}
Il.ariaLabelsShape = gn.default.shape({
  dateInput: gn.default.objectOf(gn.default.shape({
    startDate: gn.default.string,
    endDate: gn.default.string
  })),
  monthPicker: gn.default.string,
  yearPicker: gn.default.string,
  prevButton: gn.default.string,
  nextButton: gn.default.string
});
Object.defineProperty(n3, "__esModule", {
  value: !0
});
n3.default = void 0;
var rt = SCe(B), Ce = U2(un), OCe = In, Wm = U2(jl), Qm = U2(Sl), G3 = Yn, N1 = U2(fa), DCe = U2(RE), MCe = wCe, ht = y1, ECe = yl, PCe = U2(pa), jCe = Il;
function U2(e) {
  return e && e.__esModule ? e : { default: e };
}
function $E(e) {
  if (typeof WeakMap != "function")
    return null;
  var t = /* @__PURE__ */ new WeakMap(), r = /* @__PURE__ */ new WeakMap();
  return ($E = function(n) {
    return n ? r : t;
  })(e);
}
function SCe(e, t) {
  if (!t && e && e.__esModule)
    return e;
  if (e === null || typeof e != "object" && typeof e != "function")
    return { default: e };
  var r = $E(t);
  if (r && r.has(e))
    return r.get(e);
  var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var i in e)
    if (i !== "default" && Object.prototype.hasOwnProperty.call(e, i)) {
      var o = a ? Object.getOwnPropertyDescriptor(e, i) : null;
      o && (o.get || o.set) ? Object.defineProperty(n, i, o) : n[i] = e[i];
    }
  return n.default = e, r && r.set(e, n), n;
}
function d0() {
  return d0 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, d0.apply(this, arguments);
}
function Or(e, t, r) {
  return t = ICe(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function ICe(e) {
  var t = BCe(e, "string");
  return typeof t == "symbol" ? t : String(t);
}
function BCe(e, t) {
  if (typeof e != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (typeof n != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
class M2 extends rt.PureComponent {
  constructor(t, r) {
    var n;
    super(t, r), n = this, Or(this, "focusToDate", function(a) {
      let i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : n.props, o = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0;
      if (!i.scroll.enabled) {
        if (o && i.preventSnapRefocus) {
          const u = (0, ht.differenceInCalendarMonths)(a, n.state.focusedDate), d = i.calendarFocus === "forwards" && u >= 0, h = i.calendarFocus === "backwards" && u <= 0;
          if ((d || h) && Math.abs(u) < i.months)
            return;
        }
        n.setState({
          focusedDate: a
        });
        return;
      }
      const s = (0, ht.differenceInCalendarMonths)(a, i.minDate, n.dateOptions), c = n.list.getVisibleRange();
      o && c.includes(s) || (n.isFirstRender = !0, n.list.scrollTo(s), n.setState({
        focusedDate: a
      }));
    }), Or(this, "updateShownDate", function() {
      let a = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : n.props;
      const i = a.scroll.enabled ? {
        ...a,
        months: n.list.getVisibleRange().length
      } : a, o = (0, G3.calcFocusDate)(n.state.focusedDate, i);
      n.focusToDate(o, i);
    }), Or(this, "updatePreview", (a) => {
      if (!a) {
        this.setState({
          preview: null
        });
        return;
      }
      const i = {
        startDate: a,
        endDate: a,
        color: this.props.color
      };
      this.setState({
        preview: i
      });
    }), Or(this, "changeShownDate", function(a) {
      let i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "set";
      const {
        focusedDate: o
      } = n.state, {
        onShownDateChange: s,
        minDate: c,
        maxDate: u
      } = n.props, d = {
        monthOffset: () => (0, ht.addMonths)(o, a),
        setMonth: () => (0, ht.setMonth)(o, a),
        setYear: () => (0, ht.setYear)(o, a),
        set: () => a
      }, h = (0, ht.min)([(0, ht.max)([d[i](), c]), u]);
      n.focusToDate(h, n.props, !1), s && s(h);
    }), Or(this, "handleRangeFocusChange", (a, i) => {
      this.props.onRangeFocusChange && this.props.onRangeFocusChange([a, i]);
    }), Or(this, "handleScroll", () => {
      const {
        onShownDateChange: a,
        minDate: i
      } = this.props, {
        focusedDate: o
      } = this.state, {
        isFirstRender: s
      } = this, c = this.list.getVisibleRange();
      if (c[0] === void 0)
        return;
      const u = (0, ht.addMonths)(i, c[0] || 0);
      !(0, ht.isSameMonth)(u, o) && !s && (this.setState({
        focusedDate: u
      }), a && a(u)), this.isFirstRender = !1;
    }), Or(this, "renderMonthAndYear", (a, i, o) => {
      const {
        showMonthArrow: s,
        minDate: c,
        maxDate: u,
        showMonthAndYearPickers: d,
        ariaLabels: h
      } = o, A = (u || M2.defaultProps.maxDate).getFullYear(), p = (c || M2.defaultProps.minDate).getFullYear(), m = this.styles;
      return /* @__PURE__ */ rt.default.createElement("div", {
        onMouseUp: (g) => g.stopPropagation(),
        className: m.monthAndYearWrapper
      }, s ? /* @__PURE__ */ rt.default.createElement("button", {
        type: "button",
        className: (0, N1.default)(m.nextPrevButton, m.prevButton),
        onClick: () => i(-1, "monthOffset"),
        "aria-label": h.prevButton
      }, /* @__PURE__ */ rt.default.createElement("i", null)) : null, d ? /* @__PURE__ */ rt.default.createElement("span", {
        className: m.monthAndYearPickers
      }, /* @__PURE__ */ rt.default.createElement("span", {
        className: m.monthPicker
      }, /* @__PURE__ */ rt.default.createElement("select", {
        value: a.getMonth(),
        onChange: (g) => i(g.target.value, "setMonth"),
        "aria-label": h.monthPicker
      }, this.state.monthNames.map((g, v) => /* @__PURE__ */ rt.default.createElement("option", {
        key: v,
        value: v
      }, g)))), /* @__PURE__ */ rt.default.createElement("span", {
        className: m.monthAndYearDivider
      }), /* @__PURE__ */ rt.default.createElement("span", {
        className: m.yearPicker
      }, /* @__PURE__ */ rt.default.createElement("select", {
        value: a.getFullYear(),
        onChange: (g) => i(g.target.value, "setYear"),
        "aria-label": h.yearPicker
      }, new Array(A - p + 1).fill(A).map((g, v) => {
        const C = g - v;
        return /* @__PURE__ */ rt.default.createElement("option", {
          key: C,
          value: C
        }, C);
      })))) : /* @__PURE__ */ rt.default.createElement("span", {
        className: m.monthAndYearPickers
      }, this.state.monthNames[a.getMonth()], " ", a.getFullYear()), s ? /* @__PURE__ */ rt.default.createElement("button", {
        type: "button",
        className: (0, N1.default)(m.nextPrevButton, m.nextButton),
        onClick: () => i(1, "monthOffset"),
        "aria-label": h.nextButton
      }, /* @__PURE__ */ rt.default.createElement("i", null)) : null);
    }), Or(this, "renderDateDisplay", () => {
      const {
        focusedRange: a,
        color: i,
        ranges: o,
        rangeColors: s,
        dateDisplayFormat: c,
        editableDateInputs: u,
        startDatePlaceholder: d,
        endDatePlaceholder: h,
        ariaLabels: A
      } = this.props, p = s[a[0]] || i, m = this.styles;
      return /* @__PURE__ */ rt.default.createElement("div", {
        className: m.dateDisplayWrapper
      }, o.map((g, v) => g.showDateDisplay === !1 || g.disabled && !g.showDateDisplay ? null : /* @__PURE__ */ rt.default.createElement("div", {
        className: m.dateDisplay,
        key: v,
        style: {
          color: g.color || p
        }
      }, /* @__PURE__ */ rt.default.createElement(Qm.default, {
        className: (0, N1.default)(m.dateDisplayItem, {
          [m.dateDisplayItemActive]: a[0] === v && a[1] === 0
        }),
        readOnly: !u,
        disabled: g.disabled,
        value: g.startDate,
        placeholder: d,
        dateOptions: this.dateOptions,
        dateDisplayFormat: c,
        ariaLabel: A.dateInput && A.dateInput[g.key] && A.dateInput[g.key].startDate,
        onChange: this.onDragSelectionEnd,
        onFocus: () => this.handleRangeFocusChange(v, 0)
      }), /* @__PURE__ */ rt.default.createElement(Qm.default, {
        className: (0, N1.default)(m.dateDisplayItem, {
          [m.dateDisplayItemActive]: a[0] === v && a[1] === 1
        }),
        readOnly: !u,
        disabled: g.disabled,
        value: g.endDate,
        placeholder: h,
        dateOptions: this.dateOptions,
        dateDisplayFormat: c,
        ariaLabel: A.dateInput && A.dateInput[g.key] && A.dateInput[g.key].endDate,
        onChange: this.onDragSelectionEnd,
        onFocus: () => this.handleRangeFocusChange(v, 1)
      }))));
    }), Or(this, "onDragSelectionStart", (a) => {
      const {
        onChange: i,
        dragSelectionEnabled: o
      } = this.props;
      o ? this.setState({
        drag: {
          status: !0,
          range: {
            startDate: a,
            endDate: a
          },
          disablePreview: !0
        }
      }) : i && i(a);
    }), Or(this, "onDragSelectionEnd", (a) => {
      const {
        updateRange: i,
        displayMode: o,
        onChange: s,
        dragSelectionEnabled: c
      } = this.props;
      if (!c)
        return;
      if (o === "date" || !this.state.drag.status) {
        s && s(a);
        return;
      }
      const u = {
        startDate: this.state.drag.range.startDate,
        endDate: a
      };
      o !== "dateRange" || (0, ht.isSameDay)(u.startDate, a) ? this.setState({
        drag: {
          status: !1,
          range: {}
        }
      }, () => s && s(a)) : this.setState({
        drag: {
          status: !1,
          range: {}
        }
      }, () => {
        i && i(u);
      });
    }), Or(this, "onDragSelectionMove", (a) => {
      const {
        drag: i
      } = this.state;
      !i.status || !this.props.dragSelectionEnabled || this.setState({
        drag: {
          status: i.status,
          range: {
            startDate: i.range.startDate,
            endDate: a
          },
          disablePreview: !0
        }
      });
    }), Or(this, "estimateMonthSize", (a, i) => {
      const {
        direction: o,
        minDate: s
      } = this.props, {
        scrollArea: c
      } = this.state;
      if (i && (this.listSizeCache = i, i[a]))
        return i[a];
      if (o === "horizontal")
        return c.monthWidth;
      const u = (0, ht.addMonths)(s, a), {
        start: d,
        end: h
      } = (0, G3.getMonthDisplayRange)(u, this.dateOptions);
      return (0, ht.differenceInDays)(h, d, this.dateOptions) + 1 > 7 * 5 ? c.longMonthHeight : c.monthHeight;
    }), this.dateOptions = {
      locale: t.locale
    }, t.weekStartsOn !== void 0 && (this.dateOptions.weekStartsOn = t.weekStartsOn), this.styles = (0, G3.generateStyles)([PCe.default, t.classNames]), this.listSizeCache = {}, this.isFirstRender = !0, this.state = {
      monthNames: this.getMonthNames(),
      focusedDate: (0, G3.calcFocusDate)(null, t),
      drag: {
        status: !1,
        range: {
          startDate: null,
          endDate: null
        },
        disablePreview: !1
      },
      scrollArea: this.calcScrollArea(t)
    };
  }
  getMonthNames() {
    return [...Array(12).keys()].map((t) => this.props.locale.localize.month(t));
  }
  calcScrollArea(t) {
    const {
      direction: r,
      months: n,
      scroll: a
    } = t;
    if (!a.enabled)
      return {
        enabled: !1
      };
    const i = a.longMonthHeight || a.monthHeight;
    return r === "vertical" ? {
      enabled: !0,
      monthHeight: a.monthHeight || 220,
      longMonthHeight: i || 260,
      calendarWidth: "auto",
      calendarHeight: (a.calendarHeight || i || 240) * n
    } : {
      enabled: !0,
      monthWidth: a.monthWidth || 332,
      calendarWidth: (a.calendarWidth || a.monthWidth || 332) * n,
      monthHeight: i || 300,
      calendarHeight: i || 300
    };
  }
  componentDidMount() {
    this.props.scroll.enabled && setTimeout(() => this.focusToDate(this.state.focusedDate));
  }
  componentDidUpdate(t) {
    const n = {
      dateRange: "ranges",
      date: "date"
    }[this.props.displayMode];
    this.props[n] !== t[n] && this.updateShownDate(this.props), (t.locale !== this.props.locale || t.weekStartsOn !== this.props.weekStartsOn) && (this.dateOptions = {
      locale: this.props.locale
    }, this.props.weekStartsOn !== void 0 && (this.dateOptions.weekStartsOn = this.props.weekStartsOn), this.setState({
      monthNames: this.getMonthNames()
    })), (0, MCe.shallowEqualObjects)(t.scroll, this.props.scroll) || this.setState({
      scrollArea: this.calcScrollArea(this.props)
    });
  }
  renderWeekdays() {
    const t = /* @__PURE__ */ new Date();
    return /* @__PURE__ */ rt.default.createElement("div", {
      className: this.styles.weekDays
    }, (0, ht.eachDayOfInterval)({
      start: (0, ht.startOfWeek)(t, this.dateOptions),
      end: (0, ht.endOfWeek)(t, this.dateOptions)
    }).map((r, n) => /* @__PURE__ */ rt.default.createElement("span", {
      className: this.styles.weekDay,
      key: n
    }, (0, ht.format)(r, this.props.weekdayDisplayFormat, this.dateOptions))));
  }
  render() {
    const {
      showDateDisplay: t,
      onPreviewChange: r,
      scroll: n,
      direction: a,
      disabledDates: i,
      disabledDay: o,
      maxDate: s,
      minDate: c,
      rangeColors: u,
      color: d,
      navigatorRenderer: h,
      className: A,
      preview: p
    } = this.props, {
      scrollArea: m,
      focusedDate: g
    } = this.state, v = a === "vertical", C = h || this.renderMonthAndYear, y = this.props.ranges.map((w, O) => ({
      ...w,
      color: w.color || u[O] || d
    }));
    return /* @__PURE__ */ rt.default.createElement("div", {
      className: (0, N1.default)(this.styles.calendarWrapper, A),
      onMouseUp: () => this.setState({
        drag: {
          status: !1,
          range: {}
        }
      }),
      onMouseLeave: () => {
        this.setState({
          drag: {
            status: !1,
            range: {}
          }
        });
      }
    }, t && this.renderDateDisplay(), C(g, this.changeShownDate, this.props), n.enabled ? /* @__PURE__ */ rt.default.createElement("div", null, v && this.renderWeekdays(this.dateOptions), /* @__PURE__ */ rt.default.createElement("div", {
      className: (0, N1.default)(this.styles.infiniteMonths, v ? this.styles.monthsVertical : this.styles.monthsHorizontal),
      onMouseLeave: () => r && r(),
      style: {
        width: m.calendarWidth + 11,
        height: m.calendarHeight + 11
      },
      onScroll: this.handleScroll
    }, /* @__PURE__ */ rt.default.createElement(DCe.default, {
      length: (0, ht.differenceInCalendarMonths)((0, ht.endOfMonth)(s), (0, ht.addDays)((0, ht.startOfMonth)(c), -1), this.dateOptions),
      treshold: 500,
      type: "variable",
      ref: (w) => this.list = w,
      itemSizeEstimator: this.estimateMonthSize,
      axis: v ? "y" : "x",
      itemRenderer: (w, O) => {
        const b = (0, ht.addMonths)(c, w);
        return /* @__PURE__ */ rt.default.createElement(Wm.default, d0({}, this.props, {
          onPreviewChange: r || this.updatePreview,
          preview: p || this.state.preview,
          ranges: y,
          key: O,
          drag: this.state.drag,
          dateOptions: this.dateOptions,
          disabledDates: i,
          disabledDay: o,
          month: b,
          onDragSelectionStart: this.onDragSelectionStart,
          onDragSelectionEnd: this.onDragSelectionEnd,
          onDragSelectionMove: this.onDragSelectionMove,
          onMouseLeave: () => r && r(),
          styles: this.styles,
          style: v ? {
            height: this.estimateMonthSize(w)
          } : {
            height: m.monthHeight,
            width: this.estimateMonthSize(w)
          },
          showMonthName: !0,
          showWeekDays: !v
        }));
      }
    }))) : /* @__PURE__ */ rt.default.createElement("div", {
      className: (0, N1.default)(this.styles.months, v ? this.styles.monthsVertical : this.styles.monthsHorizontal)
    }, new Array(this.props.months).fill(null).map((w, O) => {
      let b = (0, ht.addMonths)(this.state.focusedDate, O);
      return this.props.calendarFocus === "backwards" && (b = (0, ht.subMonths)(this.state.focusedDate, this.props.months - 1 - O)), /* @__PURE__ */ rt.default.createElement(Wm.default, d0({}, this.props, {
        onPreviewChange: r || this.updatePreview,
        preview: p || this.state.preview,
        ranges: y,
        key: O,
        drag: this.state.drag,
        dateOptions: this.dateOptions,
        disabledDates: i,
        disabledDay: o,
        month: b,
        onDragSelectionStart: this.onDragSelectionStart,
        onDragSelectionEnd: this.onDragSelectionEnd,
        onDragSelectionMove: this.onDragSelectionMove,
        onMouseLeave: () => r && r(),
        styles: this.styles,
        showWeekDays: !v || O === 0,
        showMonthName: !v || O > 0
      }));
    })));
  }
}
M2.defaultProps = {
  showMonthArrow: !0,
  showMonthAndYearPickers: !0,
  disabledDates: [],
  disabledDay: () => {
  },
  classNames: {},
  locale: ECe.enUS,
  ranges: [],
  focusedRange: [0, 0],
  dateDisplayFormat: "MMM d, yyyy",
  monthDisplayFormat: "MMM yyyy",
  weekdayDisplayFormat: "E",
  dayDisplayFormat: "d",
  showDateDisplay: !0,
  showPreview: !0,
  displayMode: "date",
  months: 1,
  color: "#3d91ff",
  scroll: {
    enabled: !1
  },
  direction: "vertical",
  maxDate: (0, ht.addYears)(/* @__PURE__ */ new Date(), 20),
  minDate: (0, ht.addYears)(/* @__PURE__ */ new Date(), -100),
  rangeColors: ["#3d91ff", "#3ecf8e", "#fed14c"],
  startDatePlaceholder: "Early",
  endDatePlaceholder: "Continuous",
  editableDateInputs: !1,
  dragSelectionEnabled: !0,
  fixedHeight: !1,
  calendarFocus: "forwards",
  preventSnapRefocus: !1,
  ariaLabels: {}
};
M2.propTypes = {
  showMonthArrow: Ce.default.bool,
  showMonthAndYearPickers: Ce.default.bool,
  disabledDates: Ce.default.array,
  disabledDay: Ce.default.func,
  minDate: Ce.default.object,
  maxDate: Ce.default.object,
  date: Ce.default.object,
  onChange: Ce.default.func,
  onPreviewChange: Ce.default.func,
  onRangeFocusChange: Ce.default.func,
  classNames: Ce.default.object,
  locale: Ce.default.object,
  shownDate: Ce.default.object,
  onShownDateChange: Ce.default.func,
  ranges: Ce.default.arrayOf(OCe.rangeShape),
  preview: Ce.default.shape({
    startDate: Ce.default.object,
    endDate: Ce.default.object,
    color: Ce.default.string
  }),
  dateDisplayFormat: Ce.default.string,
  monthDisplayFormat: Ce.default.string,
  weekdayDisplayFormat: Ce.default.string,
  weekStartsOn: Ce.default.number,
  dayDisplayFormat: Ce.default.string,
  focusedRange: Ce.default.arrayOf(Ce.default.number),
  initialFocusedRange: Ce.default.arrayOf(Ce.default.number),
  months: Ce.default.number,
  className: Ce.default.string,
  showDateDisplay: Ce.default.bool,
  showPreview: Ce.default.bool,
  displayMode: Ce.default.oneOf(["dateRange", "date"]),
  color: Ce.default.string,
  updateRange: Ce.default.func,
  scroll: Ce.default.shape({
    enabled: Ce.default.bool,
    monthHeight: Ce.default.number,
    longMonthHeight: Ce.default.number,
    monthWidth: Ce.default.number,
    calendarWidth: Ce.default.number,
    calendarHeight: Ce.default.number
  }),
  direction: Ce.default.oneOf(["vertical", "horizontal"]),
  startDatePlaceholder: Ce.default.string,
  endDatePlaceholder: Ce.default.string,
  navigatorRenderer: Ce.default.func,
  rangeColors: Ce.default.arrayOf(Ce.default.string),
  editableDateInputs: Ce.default.bool,
  dragSelectionEnabled: Ce.default.bool,
  fixedHeight: Ce.default.bool,
  calendarFocus: Ce.default.string,
  preventSnapRefocus: Ce.default.bool,
  ariaLabels: jCe.ariaLabelsShape
};
n3.default = M2;
Object.defineProperty(r3, "__esModule", {
  value: !0
});
r3.default = void 0;
var Um = TCe(B), La = Bl(un), FE = Bl(n3), NCe = In, S4 = Yn, tn = y1, _Ce = Bl(fa), LCe = Bl(pa);
function Bl(e) {
  return e && e.__esModule ? e : { default: e };
}
function HE(e) {
  if (typeof WeakMap != "function")
    return null;
  var t = /* @__PURE__ */ new WeakMap(), r = /* @__PURE__ */ new WeakMap();
  return (HE = function(n) {
    return n ? r : t;
  })(e);
}
function TCe(e, t) {
  if (!t && e && e.__esModule)
    return e;
  if (e === null || typeof e != "object" && typeof e != "function")
    return { default: e };
  var r = HE(t);
  if (r && r.has(e))
    return r.get(e);
  var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var i in e)
    if (i !== "default" && Object.prototype.hasOwnProperty.call(e, i)) {
      var o = a ? Object.getOwnPropertyDescriptor(e, i) : null;
      o && (o.get || o.set) ? Object.defineProperty(n, i, o) : n[i] = e[i];
    }
  return n.default = e, r && r.set(e, n), n;
}
function M7() {
  return M7 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, M7.apply(this, arguments);
}
function W3(e, t, r) {
  return t = RCe(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function RCe(e) {
  var t = $Ce(e, "string");
  return typeof t == "symbol" ? t : String(t);
}
function $Ce(e, t) {
  if (typeof e != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (typeof n != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
class zf extends Um.Component {
  constructor(t, r) {
    var n;
    super(t, r), n = this, W3(this, "calcNewSelection", function(a) {
      let i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
      const o = n.props.focusedRange || n.state.focusedRange, {
        ranges: s,
        onChange: c,
        maxDate: u,
        moveRangeOnFirstSelection: d,
        retainEndDateOnFirstSelection: h,
        disabledDates: A
      } = n.props, p = o[0], m = s[p];
      if (!m || !c)
        return {};
      let {
        startDate: g,
        endDate: v
      } = m;
      const C = /* @__PURE__ */ new Date();
      let y;
      if (!i)
        g = a.startDate, v = a.endDate;
      else if (o[1] === 0) {
        const b = (0, tn.differenceInCalendarDays)(v || C, g), D = () => d ? (0, tn.addDays)(a, b) : h ? !v || (0, tn.isBefore)(a, v) ? v : a : a || C;
        g = a, v = D(), u && (v = (0, tn.min)([v, u])), y = [o[0], 1];
      } else
        v = a;
      let w = o[1] === 0;
      (0, tn.isBefore)(v, g) && (w = !w, [g, v] = [v, g]);
      const O = A.filter((b) => (0, tn.isWithinInterval)(b, {
        start: g,
        end: v
      }));
      return O.length > 0 && (w ? g = (0, tn.addDays)((0, tn.max)(O), 1) : v = (0, tn.addDays)((0, tn.min)(O), -1)), y || (y = [(0, S4.findNextRangeIndex)(n.props.ranges, o[0]), 0]), {
        wasValid: !(O.length > 0),
        range: {
          startDate: g,
          endDate: v
        },
        nextFocusRange: y
      };
    }), W3(this, "setSelection", (a, i) => {
      const {
        onChange: o,
        ranges: s,
        onRangeFocusChange: c
      } = this.props, d = (this.props.focusedRange || this.state.focusedRange)[0], h = s[d];
      if (!h)
        return;
      const A = this.calcNewSelection(a, i);
      o({
        [h.key || `range${d + 1}`]: {
          ...h,
          ...A.range
        }
      }), this.setState({
        focusedRange: A.nextFocusRange,
        preview: null
      }), c && c(A.nextFocusRange);
    }), W3(this, "handleRangeFocusChange", (a) => {
      this.setState({
        focusedRange: a
      }), this.props.onRangeFocusChange && this.props.onRangeFocusChange(a);
    }), W3(this, "updatePreview", (a) => {
      var u;
      if (!a) {
        this.setState({
          preview: null
        });
        return;
      }
      const {
        rangeColors: i,
        ranges: o
      } = this.props, s = this.props.focusedRange || this.state.focusedRange, c = ((u = o[s[0]]) == null ? void 0 : u.color) || i[s[0]] || c;
      this.setState({
        preview: {
          ...a.range,
          color: c
        }
      });
    }), this.state = {
      focusedRange: t.initialFocusedRange || [(0, S4.findNextRangeIndex)(t.ranges), 0],
      preview: null
    }, this.styles = (0, S4.generateStyles)([LCe.default, t.classNames]);
  }
  render() {
    return /* @__PURE__ */ Um.default.createElement(FE.default, M7({
      focusedRange: this.state.focusedRange,
      onRangeFocusChange: this.handleRangeFocusChange,
      preview: this.state.preview,
      onPreviewChange: (t) => {
        this.updatePreview(t ? this.calcNewSelection(t) : null);
      }
    }, this.props, {
      displayMode: "dateRange",
      className: (0, _Ce.default)(this.styles.dateRangeWrapper, this.props.className),
      onChange: this.setSelection,
      updateRange: (t) => this.setSelection(t, !1),
      ref: (t) => {
        this.calendar = t;
      }
    }));
  }
}
zf.defaultProps = {
  classNames: {},
  ranges: [],
  moveRangeOnFirstSelection: !1,
  retainEndDateOnFirstSelection: !1,
  rangeColors: ["#3d91ff", "#3ecf8e", "#fed14c"],
  disabledDates: []
};
zf.propTypes = {
  ...FE.default.propTypes,
  onChange: La.default.func,
  onRangeFocusChange: La.default.func,
  className: La.default.string,
  ranges: La.default.arrayOf(NCe.rangeShape),
  moveRangeOnFirstSelection: La.default.bool,
  retainEndDateOnFirstSelection: La.default.bool
};
r3.default = zf;
var Nl = {}, v3 = {}, d1 = {};
Object.defineProperty(d1, "__esModule", {
  value: !0
});
d1.createStaticRanges = YE;
d1.defaultStaticRanges = d1.defaultInputRanges = void 0;
var ot = y1;
const Rt = {
  startOfWeek: (0, ot.startOfWeek)(/* @__PURE__ */ new Date()),
  endOfWeek: (0, ot.endOfWeek)(/* @__PURE__ */ new Date()),
  startOfLastWeek: (0, ot.startOfWeek)((0, ot.addDays)(/* @__PURE__ */ new Date(), -7)),
  endOfLastWeek: (0, ot.endOfWeek)((0, ot.addDays)(/* @__PURE__ */ new Date(), -7)),
  startOfToday: (0, ot.startOfDay)(/* @__PURE__ */ new Date()),
  endOfToday: (0, ot.endOfDay)(/* @__PURE__ */ new Date()),
  startOfYesterday: (0, ot.startOfDay)((0, ot.addDays)(/* @__PURE__ */ new Date(), -1)),
  endOfYesterday: (0, ot.endOfDay)((0, ot.addDays)(/* @__PURE__ */ new Date(), -1)),
  startOfMonth: (0, ot.startOfMonth)(/* @__PURE__ */ new Date()),
  endOfMonth: (0, ot.endOfMonth)(/* @__PURE__ */ new Date()),
  startOfLastMonth: (0, ot.startOfMonth)((0, ot.addMonths)(/* @__PURE__ */ new Date(), -1)),
  endOfLastMonth: (0, ot.endOfMonth)((0, ot.addMonths)(/* @__PURE__ */ new Date(), -1))
}, FCe = {
  range: {},
  isSelected(e) {
    const t = this.range();
    return (0, ot.isSameDay)(e.startDate, t.startDate) && (0, ot.isSameDay)(e.endDate, t.endDate);
  }
};
function YE(e) {
  return e.map((t) => ({
    ...FCe,
    ...t
  }));
}
d1.defaultStaticRanges = YE([{
  label: "Today",
  range: () => ({
    startDate: Rt.startOfToday,
    endDate: Rt.endOfToday
  })
}, {
  label: "Yesterday",
  range: () => ({
    startDate: Rt.startOfYesterday,
    endDate: Rt.endOfYesterday
  })
}, {
  label: "This Week",
  range: () => ({
    startDate: Rt.startOfWeek,
    endDate: Rt.endOfWeek
  })
}, {
  label: "Last Week",
  range: () => ({
    startDate: Rt.startOfLastWeek,
    endDate: Rt.endOfLastWeek
  })
}, {
  label: "This Month",
  range: () => ({
    startDate: Rt.startOfMonth,
    endDate: Rt.endOfMonth
  })
}, {
  label: "Last Month",
  range: () => ({
    startDate: Rt.startOfLastMonth,
    endDate: Rt.endOfLastMonth
  })
}]);
d1.defaultInputRanges = [{
  label: "days up to today",
  range(e) {
    return {
      startDate: (0, ot.addDays)(Rt.startOfToday, (Math.max(Number(e), 1) - 1) * -1),
      endDate: Rt.endOfToday
    };
  },
  getCurrentValue(e) {
    return (0, ot.isSameDay)(e.endDate, Rt.endOfToday) ? e.startDate ? (0, ot.differenceInCalendarDays)(Rt.endOfToday, e.startDate) + 1 : "∞" : "-";
  }
}, {
  label: "days starting today",
  range(e) {
    const t = /* @__PURE__ */ new Date();
    return {
      startDate: t,
      endDate: (0, ot.addDays)(t, Math.max(Number(e), 1) - 1)
    };
  },
  getCurrentValue(e) {
    return (0, ot.isSameDay)(e.startDate, Rt.startOfToday) ? e.endDate ? (0, ot.differenceInCalendarDays)(e.endDate, Rt.startOfToday) + 1 : "∞" : "-";
  }
}];
var _l = {};
Object.defineProperty(_l, "__esModule", {
  value: !0
});
_l.default = void 0;
var Q3 = YCe(B), nr = HCe(un);
function HCe(e) {
  return e && e.__esModule ? e : { default: e };
}
function VE(e) {
  if (typeof WeakMap != "function")
    return null;
  var t = /* @__PURE__ */ new WeakMap(), r = /* @__PURE__ */ new WeakMap();
  return (VE = function(n) {
    return n ? r : t;
  })(e);
}
function YCe(e, t) {
  if (!t && e && e.__esModule)
    return e;
  if (e === null || typeof e != "object" && typeof e != "function")
    return { default: e };
  var r = VE(t);
  if (r && r.has(e))
    return r.get(e);
  var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var i in e)
    if (i !== "default" && Object.prototype.hasOwnProperty.call(e, i)) {
      var o = a ? Object.getOwnPropertyDescriptor(e, i) : null;
      o && (o.get || o.set) ? Object.defineProperty(n, i, o) : n[i] = e[i];
    }
  return n.default = e, r && r.set(e, n), n;
}
function VCe(e, t, r) {
  return t = kCe(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function kCe(e) {
  var t = GCe(e, "string");
  return typeof t == "symbol" ? t : String(t);
}
function GCe(e, t) {
  if (typeof e != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (typeof n != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
const Zm = 0, zm = 99999;
class Kf extends Q3.Component {
  constructor(t, r) {
    super(t, r), VCe(this, "onChange", (n) => {
      const {
        onChange: a
      } = this.props;
      let i = parseInt(n.target.value, 10);
      i = isNaN(i) ? 0 : Math.max(Math.min(zm, i), Zm), a(i);
    });
  }
  shouldComponentUpdate(t) {
    const {
      value: r,
      label: n,
      placeholder: a
    } = this.props;
    return r !== t.value || n !== t.label || a !== t.placeholder;
  }
  render() {
    const {
      label: t,
      placeholder: r,
      value: n,
      styles: a,
      onBlur: i,
      onFocus: o
    } = this.props;
    return /* @__PURE__ */ Q3.default.createElement("div", {
      className: a.inputRange
    }, /* @__PURE__ */ Q3.default.createElement("input", {
      className: a.inputRangeInput,
      placeholder: r,
      value: n,
      min: Zm,
      max: zm,
      onChange: this.onChange,
      onFocus: o,
      onBlur: i
    }), /* @__PURE__ */ Q3.default.createElement("span", {
      className: a.inputRangeLabel
    }, t));
  }
}
Kf.propTypes = {
  value: nr.default.oneOfType([nr.default.string, nr.default.number]),
  label: nr.default.oneOfType([nr.default.element, nr.default.node]).isRequired,
  placeholder: nr.default.string,
  styles: nr.default.shape({
    inputRange: nr.default.string,
    inputRangeInput: nr.default.string,
    inputRangeLabel: nr.default.string
  }).isRequired,
  onBlur: nr.default.func.isRequired,
  onFocus: nr.default.func.isRequired,
  onChange: nr.default.func.isRequired
};
Kf.defaultProps = {
  value: "",
  placeholder: "-"
};
_l.default = Kf;
Object.defineProperty(v3, "__esModule", {
  value: !0
});
v3.default = void 0;
var _1 = UCe(B), cr = Ll(un), L1 = Ll(pa), Km = d1, WCe = In, QCe = Ll(_l), qm = Ll(fa);
function Ll(e) {
  return e && e.__esModule ? e : { default: e };
}
function kE(e) {
  if (typeof WeakMap != "function")
    return null;
  var t = /* @__PURE__ */ new WeakMap(), r = /* @__PURE__ */ new WeakMap();
  return (kE = function(n) {
    return n ? r : t;
  })(e);
}
function UCe(e, t) {
  if (!t && e && e.__esModule)
    return e;
  if (e === null || typeof e != "object" && typeof e != "function")
    return { default: e };
  var r = kE(t);
  if (r && r.has(e))
    return r.get(e);
  var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var i in e)
    if (i !== "default" && Object.prototype.hasOwnProperty.call(e, i)) {
      var o = a ? Object.getOwnPropertyDescriptor(e, i) : null;
      o && (o.get || o.set) ? Object.defineProperty(n, i, o) : n[i] = e[i];
    }
  return n.default = e, r && r.set(e, n), n;
}
function ZCe(e, t, r) {
  return t = zCe(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function zCe(e) {
  var t = KCe(e, "string");
  return typeof t == "symbol" ? t : String(t);
}
function KCe(e, t) {
  if (typeof e != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (typeof n != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
class qf extends _1.Component {
  constructor(t) {
    super(t), ZCe(this, "handleRangeChange", (r) => {
      const {
        onChange: n,
        ranges: a,
        focusedRange: i
      } = this.props, o = a[i[0]];
      !n || !o || n({
        [o.key || `range${i[0] + 1}`]: {
          ...o,
          ...r
        }
      });
    }), this.state = {
      rangeOffset: 0,
      focusedInput: -1
    };
  }
  getRangeOptionValue(t) {
    const {
      ranges: r = [],
      focusedRange: n = []
    } = this.props;
    if (typeof t.getCurrentValue != "function")
      return "";
    const a = r[n[0]] || {};
    return t.getCurrentValue(a) || "";
  }
  getSelectedRange(t, r) {
    const n = t.findIndex((i) => !i.startDate || !i.endDate || i.disabled ? !1 : r.isSelected(i));
    return {
      selectedRange: t[n],
      focusedRangeIndex: n
    };
  }
  render() {
    const {
      headerContent: t,
      footerContent: r,
      onPreviewChange: n,
      inputRanges: a,
      staticRanges: i,
      ranges: o,
      renderStaticRangeLabel: s,
      rangeColors: c,
      className: u
    } = this.props;
    return /* @__PURE__ */ _1.default.createElement("div", {
      className: (0, qm.default)(L1.default.definedRangesWrapper, u)
    }, t, /* @__PURE__ */ _1.default.createElement("div", {
      className: L1.default.staticRanges
    }, i.map((d, h) => {
      const {
        selectedRange: A,
        focusedRangeIndex: p
      } = this.getSelectedRange(o, d);
      let m;
      return d.hasCustomRendering ? m = s(d) : m = d.label, /* @__PURE__ */ _1.default.createElement("button", {
        type: "button",
        className: (0, qm.default)(L1.default.staticRange, {
          [L1.default.staticRangeSelected]: !!A
        }),
        style: {
          color: A ? A.color || c[p] : null
        },
        key: h,
        onClick: () => this.handleRangeChange(d.range(this.props)),
        onFocus: () => n && n(d.range(this.props)),
        onMouseOver: () => n && n(d.range(this.props)),
        onMouseLeave: () => {
          n && n();
        }
      }, /* @__PURE__ */ _1.default.createElement("span", {
        tabIndex: -1,
        className: L1.default.staticRangeLabel
      }, m));
    })), /* @__PURE__ */ _1.default.createElement("div", {
      className: L1.default.inputRanges
    }, a.map((d, h) => /* @__PURE__ */ _1.default.createElement(QCe.default, {
      key: h,
      styles: L1.default,
      label: d.label,
      onFocus: () => this.setState({
        focusedInput: h,
        rangeOffset: 0
      }),
      onBlur: () => this.setState({
        rangeOffset: 0
      }),
      onChange: (A) => this.handleRangeChange(d.range(A, this.props)),
      value: this.getRangeOptionValue(d)
    }))), r);
  }
}
qf.propTypes = {
  inputRanges: cr.default.array,
  staticRanges: cr.default.array,
  ranges: cr.default.arrayOf(WCe.rangeShape),
  focusedRange: cr.default.arrayOf(cr.default.number),
  onPreviewChange: cr.default.func,
  onChange: cr.default.func,
  footerContent: cr.default.any,
  headerContent: cr.default.any,
  rangeColors: cr.default.arrayOf(cr.default.string),
  className: cr.default.string,
  renderStaticRangeLabel: cr.default.func
};
qf.defaultProps = {
  inputRanges: Km.defaultInputRanges,
  staticRanges: Km.defaultStaticRanges,
  ranges: [],
  rangeColors: ["#3d91ff", "#3ecf8e", "#fed14c"],
  focusedRange: [0, 0]
};
v3.default = qf;
Object.defineProperty(Nl, "__esModule", {
  value: !0
});
Nl.default = void 0;
var U3 = ebe(B), qCe = g3(un), GE = g3(r3), WE = g3(v3), Xm = Yn, XCe = g3(fa), JCe = g3(pa);
function g3(e) {
  return e && e.__esModule ? e : { default: e };
}
function QE(e) {
  if (typeof WeakMap != "function")
    return null;
  var t = /* @__PURE__ */ new WeakMap(), r = /* @__PURE__ */ new WeakMap();
  return (QE = function(n) {
    return n ? r : t;
  })(e);
}
function ebe(e, t) {
  if (!t && e && e.__esModule)
    return e;
  if (e === null || typeof e != "object" && typeof e != "function")
    return { default: e };
  var r = QE(t);
  if (r && r.has(e))
    return r.get(e);
  var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var i in e)
    if (i !== "default" && Object.prototype.hasOwnProperty.call(e, i)) {
      var o = a ? Object.getOwnPropertyDescriptor(e, i) : null;
      o && (o.get || o.set) ? Object.defineProperty(n, i, o) : n[i] = e[i];
    }
  return n.default = e, r && r.set(e, n), n;
}
function h0() {
  return h0 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, h0.apply(this, arguments);
}
class Xf extends U3.Component {
  constructor(t) {
    super(t), this.state = {
      focusedRange: [(0, Xm.findNextRangeIndex)(t.ranges), 0]
    }, this.styles = (0, Xm.generateStyles)([JCe.default, t.classNames]);
  }
  render() {
    const {
      focusedRange: t
    } = this.state;
    return /* @__PURE__ */ U3.default.createElement("div", {
      className: (0, XCe.default)(this.styles.dateRangePickerWrapper, this.props.className)
    }, /* @__PURE__ */ U3.default.createElement(WE.default, h0({
      focusedRange: t,
      onPreviewChange: (r) => this.dateRange.updatePreview(r ? this.dateRange.calcNewSelection(r, typeof r == "string") : null)
    }, this.props, {
      range: this.props.ranges[t[0]],
      className: void 0
    })), /* @__PURE__ */ U3.default.createElement(GE.default, h0({
      onRangeFocusChange: (r) => this.setState({
        focusedRange: r
      }),
      focusedRange: t
    }, this.props, {
      ref: (r) => this.dateRange = r,
      className: void 0
    })));
  }
}
Xf.defaultProps = {};
Xf.propTypes = {
  ...GE.default.propTypes,
  ...WE.default.propTypes,
  className: qCe.default.string
};
Nl.default = Xf;
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), Object.defineProperty(e, "Calendar", {
    enumerable: !0,
    get: function() {
      return r.default;
    }
  }), Object.defineProperty(e, "DateRange", {
    enumerable: !0,
    get: function() {
      return t.default;
    }
  }), Object.defineProperty(e, "DateRangePicker", {
    enumerable: !0,
    get: function() {
      return n.default;
    }
  }), Object.defineProperty(e, "DefinedRange", {
    enumerable: !0,
    get: function() {
      return a.default;
    }
  }), Object.defineProperty(e, "createStaticRanges", {
    enumerable: !0,
    get: function() {
      return i.createStaticRanges;
    }
  }), Object.defineProperty(e, "defaultInputRanges", {
    enumerable: !0,
    get: function() {
      return i.defaultInputRanges;
    }
  }), Object.defineProperty(e, "defaultStaticRanges", {
    enumerable: !0,
    get: function() {
      return i.defaultStaticRanges;
    }
  });
  var t = o(r3), r = o(n3), n = o(Nl), a = o(v3), i = d1;
  function o(s) {
    return s && s.__esModule ? s : { default: s };
  }
})(IO);
const tbe = {
  lessThanXSeconds: {
    one: "menos de un segundo",
    other: "menos de {{count}} segundos"
  },
  xSeconds: {
    one: "1 segundo",
    other: "{{count}} segundos"
  },
  halfAMinute: "medio minuto",
  lessThanXMinutes: {
    one: "menos de un minuto",
    other: "menos de {{count}} minutos"
  },
  xMinutes: {
    one: "1 minuto",
    other: "{{count}} minutos"
  },
  aboutXHours: {
    one: "alrededor de 1 hora",
    other: "alrededor de {{count}} horas"
  },
  xHours: {
    one: "1 hora",
    other: "{{count}} horas"
  },
  xDays: {
    one: "1 día",
    other: "{{count}} días"
  },
  aboutXWeeks: {
    one: "alrededor de 1 semana",
    other: "alrededor de {{count}} semanas"
  },
  xWeeks: {
    one: "1 semana",
    other: "{{count}} semanas"
  },
  aboutXMonths: {
    one: "alrededor de 1 mes",
    other: "alrededor de {{count}} meses"
  },
  xMonths: {
    one: "1 mes",
    other: "{{count}} meses"
  },
  aboutXYears: {
    one: "alrededor de 1 año",
    other: "alrededor de {{count}} años"
  },
  xYears: {
    one: "1 año",
    other: "{{count}} años"
  },
  overXYears: {
    one: "más de 1 año",
    other: "más de {{count}} años"
  },
  almostXYears: {
    one: "casi 1 año",
    other: "casi {{count}} años"
  }
}, rbe = (e, t, r) => {
  let n;
  const a = tbe[e];
  return typeof a == "string" ? n = a : t === 1 ? n = a.one : n = a.other.replace("{{count}}", t.toString()), r != null && r.addSuffix ? r.comparison && r.comparison > 0 ? "en " + n : "hace " + n : n;
};
function Wa(e) {
  return (t = {}) => {
    const r = t.width ? String(t.width) : e.defaultWidth;
    return e.formats[r] || e.formats[e.defaultWidth];
  };
}
const nbe = {
  full: "EEEE, d 'de' MMMM 'de' y",
  long: "d 'de' MMMM 'de' y",
  medium: "d MMM y",
  short: "dd/MM/y"
}, abe = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, ibe = {
  full: "{{date}} 'a las' {{time}}",
  long: "{{date}} 'a las' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, obe = {
  date: Wa({
    formats: nbe,
    defaultWidth: "full"
  }),
  time: Wa({
    formats: abe,
    defaultWidth: "full"
  }),
  dateTime: Wa({
    formats: ibe,
    defaultWidth: "full"
  })
}, sbe = {
  lastWeek: "'el' eeee 'pasado a la' p",
  yesterday: "'ayer a la' p",
  today: "'hoy a la' p",
  tomorrow: "'mañana a la' p",
  nextWeek: "eeee 'a la' p",
  other: "P"
}, lbe = {
  lastWeek: "'el' eeee 'pasado a las' p",
  yesterday: "'ayer a las' p",
  today: "'hoy a las' p",
  tomorrow: "'mañana a las' p",
  nextWeek: "eeee 'a las' p",
  other: "P"
}, cbe = (e, t, r, n) => t.getHours() !== 1 ? lbe[e] : sbe[e];
function rn(e) {
  return (t, r) => {
    const n = r != null && r.context ? String(r.context) : "standalone";
    let a;
    if (n === "formatting" && e.formattingValues) {
      const o = e.defaultFormattingWidth || e.defaultWidth, s = r != null && r.width ? String(r.width) : o;
      a = e.formattingValues[s] || e.formattingValues[o];
    } else {
      const o = e.defaultWidth, s = r != null && r.width ? String(r.width) : e.defaultWidth;
      a = e.values[s] || e.values[o];
    }
    const i = e.argumentCallback ? e.argumentCallback(t) : t;
    return a[i];
  };
}
const ube = {
  narrow: ["AC", "DC"],
  abbreviated: ["AC", "DC"],
  wide: ["antes de cristo", "después de cristo"]
}, fbe = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["T1", "T2", "T3", "T4"],
  wide: ["1º trimestre", "2º trimestre", "3º trimestre", "4º trimestre"]
}, dbe = {
  narrow: ["e", "f", "m", "a", "m", "j", "j", "a", "s", "o", "n", "d"],
  abbreviated: [
    "ene",
    "feb",
    "mar",
    "abr",
    "may",
    "jun",
    "jul",
    "ago",
    "sep",
    "oct",
    "nov",
    "dic"
  ],
  wide: [
    "enero",
    "febrero",
    "marzo",
    "abril",
    "mayo",
    "junio",
    "julio",
    "agosto",
    "septiembre",
    "octubre",
    "noviembre",
    "diciembre"
  ]
}, hbe = {
  narrow: ["d", "l", "m", "m", "j", "v", "s"],
  short: ["do", "lu", "ma", "mi", "ju", "vi", "sá"],
  abbreviated: ["dom", "lun", "mar", "mié", "jue", "vie", "sáb"],
  wide: [
    "domingo",
    "lunes",
    "martes",
    "miércoles",
    "jueves",
    "viernes",
    "sábado"
  ]
}, Abe = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mn",
    noon: "md",
    morning: "mañana",
    afternoon: "tarde",
    evening: "tarde",
    night: "noche"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "medianoche",
    noon: "mediodia",
    morning: "mañana",
    afternoon: "tarde",
    evening: "tarde",
    night: "noche"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "medianoche",
    noon: "mediodia",
    morning: "mañana",
    afternoon: "tarde",
    evening: "tarde",
    night: "noche"
  }
}, pbe = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mn",
    noon: "md",
    morning: "de la mañana",
    afternoon: "de la tarde",
    evening: "de la tarde",
    night: "de la noche"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "medianoche",
    noon: "mediodia",
    morning: "de la mañana",
    afternoon: "de la tarde",
    evening: "de la tarde",
    night: "de la noche"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "medianoche",
    noon: "mediodia",
    morning: "de la mañana",
    afternoon: "de la tarde",
    evening: "de la tarde",
    night: "de la noche"
  }
}, vbe = (e, t) => Number(e) + "º", gbe = {
  ordinalNumber: vbe,
  era: rn({
    values: ube,
    defaultWidth: "wide"
  }),
  quarter: rn({
    values: fbe,
    defaultWidth: "wide",
    argumentCallback: (e) => Number(e) - 1
  }),
  month: rn({
    values: dbe,
    defaultWidth: "wide"
  }),
  day: rn({
    values: hbe,
    defaultWidth: "wide"
  }),
  dayPeriod: rn({
    values: Abe,
    defaultWidth: "wide",
    formattingValues: pbe,
    defaultFormattingWidth: "wide"
  })
};
function UE(e) {
  return (t, r = {}) => {
    const n = t.match(e.matchPattern);
    if (!n)
      return null;
    const a = n[0], i = t.match(e.parsePattern);
    if (!i)
      return null;
    let o = e.valueCallback ? e.valueCallback(i[0]) : i[0];
    o = r.valueCallback ? r.valueCallback(o) : o;
    const s = t.slice(a.length);
    return { value: o, rest: s };
  };
}
function nn(e) {
  return (t, r = {}) => {
    const n = r.width, a = n && e.matchPatterns[n] || e.matchPatterns[e.defaultMatchWidth], i = t.match(a);
    if (!i)
      return null;
    const o = i[0], s = n && e.parsePatterns[n] || e.parsePatterns[e.defaultParseWidth], c = Array.isArray(s) ? Cbe(s, (h) => h.test(o)) : (
      // [TODO] -- I challenge you to fix the type
      mbe(s, (h) => h.test(o))
    );
    let u;
    u = e.valueCallback ? e.valueCallback(c) : c, u = r.valueCallback ? (
      // [TODO] -- I challenge you to fix the type
      r.valueCallback(u)
    ) : u;
    const d = t.slice(o.length);
    return { value: u, rest: d };
  };
}
function mbe(e, t) {
  for (const r in e)
    if (Object.prototype.hasOwnProperty.call(e, r) && t(e[r]))
      return r;
}
function Cbe(e, t) {
  for (let r = 0; r < e.length; r++)
    if (t(e[r]))
      return r;
}
const bbe = /^(\d+)(º)?/i, ybe = /\d+/i, wbe = {
  narrow: /^(ac|dc|a|d)/i,
  abbreviated: /^(a\.?\s?c\.?|a\.?\s?e\.?\s?c\.?|d\.?\s?c\.?|e\.?\s?c\.?)/i,
  wide: /^(antes de cristo|antes de la era com[uú]n|despu[eé]s de cristo|era com[uú]n)/i
}, xbe = {
  any: [/^ac/i, /^dc/i],
  wide: [
    /^(antes de cristo|antes de la era com[uú]n)/i,
    /^(despu[eé]s de cristo|era com[uú]n)/i
  ]
}, Obe = {
  narrow: /^[1234]/i,
  abbreviated: /^T[1234]/i,
  wide: /^[1234](º)? trimestre/i
}, Dbe = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, Mbe = {
  narrow: /^[efmajsond]/i,
  abbreviated: /^(ene|feb|mar|abr|may|jun|jul|ago|sep|oct|nov|dic)/i,
  wide: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i
}, Ebe = {
  narrow: [
    /^e/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^en/i,
    /^feb/i,
    /^mar/i,
    /^abr/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^ago/i,
    /^sep/i,
    /^oct/i,
    /^nov/i,
    /^dic/i
  ]
}, Pbe = {
  narrow: /^[dlmjvs]/i,
  short: /^(do|lu|ma|mi|ju|vi|s[áa])/i,
  abbreviated: /^(dom|lun|mar|mi[ée]|jue|vie|s[áa]b)/i,
  wide: /^(domingo|lunes|martes|mi[ée]rcoles|jueves|viernes|s[áa]bado)/i
}, jbe = {
  narrow: [/^d/i, /^l/i, /^m/i, /^m/i, /^j/i, /^v/i, /^s/i],
  any: [/^do/i, /^lu/i, /^ma/i, /^mi/i, /^ju/i, /^vi/i, /^sa/i]
}, Sbe = {
  narrow: /^(a|p|mn|md|(de la|a las) (mañana|tarde|noche))/i,
  any: /^([ap]\.?\s?m\.?|medianoche|mediodia|(de la|a las) (mañana|tarde|noche))/i
}, Ibe = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mn/i,
    noon: /^md/i,
    morning: /mañana/i,
    afternoon: /tarde/i,
    evening: /tarde/i,
    night: /noche/i
  }
}, Bbe = {
  ordinalNumber: UE({
    matchPattern: bbe,
    parsePattern: ybe,
    valueCallback: function(e) {
      return parseInt(e, 10);
    }
  }),
  era: nn({
    matchPatterns: wbe,
    defaultMatchWidth: "wide",
    parsePatterns: xbe,
    defaultParseWidth: "any"
  }),
  quarter: nn({
    matchPatterns: Obe,
    defaultMatchWidth: "wide",
    parsePatterns: Dbe,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: nn({
    matchPatterns: Mbe,
    defaultMatchWidth: "wide",
    parsePatterns: Ebe,
    defaultParseWidth: "any"
  }),
  day: nn({
    matchPatterns: Pbe,
    defaultMatchWidth: "wide",
    parsePatterns: jbe,
    defaultParseWidth: "any"
  }),
  dayPeriod: nn({
    matchPatterns: Sbe,
    defaultMatchWidth: "any",
    parsePatterns: Ibe,
    defaultParseWidth: "any"
  })
}, Nbe = {
  code: "es",
  formatDistance: rbe,
  formatLong: obe,
  formatRelative: cbe,
  localize: gbe,
  match: Bbe,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 1
  }
}, _be = Nbe;
const ZE = B.forwardRef((e) => {
  const { onChangeValueFilterDate: t, valueFilterDate: r } = e, n = /* @__PURE__ */ new Date(), [a, i] = De([
    {
      startDate: void 0,
      endDate: void 0,
      key: "selection"
    }
  ]), [o, s] = De(!1), c = ge(null);
  Ie(() => (document.addEventListener("keydown", u, !0), document.addEventListener("click", d, !0), () => {
    document.removeEventListener("keydown", u, !0), document.removeEventListener("click", d, !0);
  }), []);
  const u = (g) => {
    g.key === "Escape" && s(!1);
  }, d = (g) => {
    c.current != null && !c.current.contains(g.target) && s(!1);
  }, h = (g, v) => g != null && v != null ? `${g} - ${v}` : "", A = () => {
    i([
      {
        startDate: n,
        endDate: n,
        key: "selection"
      }
    ]), s(!0);
  }, p = () => {
    s(!1), t != null && t({ option: a[0] });
  }, m = () => {
    s(!1);
  };
  return /* @__PURE__ */ f.jsxs("div", { className: "block relative w-full", children: [
    /* @__PURE__ */ f.jsx(
      zn,
      {
        iconRight: "calendar",
        placeholder: "dd/mm/aaaa",
        value: r != null && r.length === 2 ? h(r[0], r[1]) : "",
        readOnly: !0,
        onClick: A
      }
    ),
    /* @__PURE__ */ f.jsx("div", { ref: c, children: o && /* @__PURE__ */ f.jsx(f.Fragment, { children: /* @__PURE__ */ f.jsxs("div", { className: "absolute mb-8 left-2/4 -translate-x-1/2 2s:right-0 2s:left-auto 2s:-translate-x-0 top-10 text-[13px] z-20", children: [
      /* @__PURE__ */ f.jsx(
        IO.DateRangePicker,
        {
          onChange: (g) => {
            i([g.selection]);
          },
          editableDateInputs: !0,
          moveRangeOnFirstSelection: !1,
          ranges: a,
          months: 1,
          direction: "horizontal",
          className: "w-[334px] sm:w-auto border rounded-tr-md rounded-tl-md",
          locale: _be
        }
      ),
      /* @__PURE__ */ f.jsxs("div", { className: "flex justify-end gap-4 p-2 border-l border-b border-r rounded-bl-md rounded-br-md bg-[#fff]", children: [
        /* @__PURE__ */ f.jsx("button", { className: "bg-neutral-300 hover:bg-neutral-200 rounded-md px-5 py-1", onClick: m, children: "Cancelar" }),
        /* @__PURE__ */ f.jsx("button", { className: "bg-secondary-500 hover:bg-secondary-600 rounded-md px-5 py-1 text-white", onClick: p, children: "Aplicar" })
      ] })
    ] }) }) })
  ] });
});
ZE.displayName = "DateRangeInput";
const Lbe = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, Tbe = (e, t, r) => {
  let n;
  const a = Lbe[e];
  return typeof a == "string" ? n = a : t === 1 ? n = a.one : n = a.other.replace("{{count}}", t.toString()), r != null && r.addSuffix ? r.comparison && r.comparison > 0 ? "in " + n : n + " ago" : n;
}, Rbe = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, $be = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, Fbe = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, Hbe = {
  date: Wa({
    formats: Rbe,
    defaultWidth: "full"
  }),
  time: Wa({
    formats: $be,
    defaultWidth: "full"
  }),
  dateTime: Wa({
    formats: Fbe,
    defaultWidth: "full"
  })
}, Ybe = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, Vbe = (e, t, r, n) => Ybe[e], kbe = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, Gbe = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, Wbe = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
}, Qbe = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
}, Ube = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, Zbe = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, zbe = (e, t) => {
  const r = Number(e), n = r % 100;
  if (n > 20 || n < 10)
    switch (n % 10) {
      case 1:
        return r + "st";
      case 2:
        return r + "nd";
      case 3:
        return r + "rd";
    }
  return r + "th";
}, Kbe = {
  ordinalNumber: zbe,
  era: rn({
    values: kbe,
    defaultWidth: "wide"
  }),
  quarter: rn({
    values: Gbe,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: rn({
    values: Wbe,
    defaultWidth: "wide"
  }),
  day: rn({
    values: Qbe,
    defaultWidth: "wide"
  }),
  dayPeriod: rn({
    values: Ube,
    defaultWidth: "wide",
    formattingValues: Zbe,
    defaultFormattingWidth: "wide"
  })
}, qbe = /^(\d+)(th|st|nd|rd)?/i, Xbe = /\d+/i, Jbe = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, eye = {
  any: [/^b/i, /^(a|c)/i]
}, tye = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, rye = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, nye = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, aye = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, iye = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, oye = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, sye = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, lye = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, cye = {
  ordinalNumber: UE({
    matchPattern: qbe,
    parsePattern: Xbe,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: nn({
    matchPatterns: Jbe,
    defaultMatchWidth: "wide",
    parsePatterns: eye,
    defaultParseWidth: "any"
  }),
  quarter: nn({
    matchPatterns: tye,
    defaultMatchWidth: "wide",
    parsePatterns: rye,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: nn({
    matchPatterns: nye,
    defaultMatchWidth: "wide",
    parsePatterns: aye,
    defaultParseWidth: "any"
  }),
  day: nn({
    matchPatterns: iye,
    defaultMatchWidth: "wide",
    parsePatterns: oye,
    defaultParseWidth: "any"
  }),
  dayPeriod: nn({
    matchPatterns: sye,
    defaultMatchWidth: "any",
    parsePatterns: lye,
    defaultParseWidth: "any"
  })
}, uye = {
  code: "en-US",
  formatDistance: Tbe,
  formatLong: Hbe,
  formatRelative: Vbe,
  localize: Kbe,
  match: cye,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
let fye = {};
function Tl() {
  return fye;
}
const zE = 6048e5, dye = 864e5, Jm = Symbol.for("constructDateFrom");
function h1(e, t) {
  return typeof e == "function" ? e(t) : e && typeof e == "object" && Jm in e ? e[Jm](t) : e instanceof Date ? new e.constructor(t) : new Date(t);
}
function qr(e, t) {
  return h1(t || e, e);
}
function eC(e) {
  const t = qr(e), r = new Date(
    Date.UTC(
      t.getFullYear(),
      t.getMonth(),
      t.getDate(),
      t.getHours(),
      t.getMinutes(),
      t.getSeconds(),
      t.getMilliseconds()
    )
  );
  return r.setUTCFullYear(t.getFullYear()), +e - +r;
}
function hye(e, ...t) {
  const r = h1.bind(
    null,
    e || t.find((n) => typeof n == "object")
  );
  return t.map(r);
}
function tC(e, t) {
  const r = qr(e, t == null ? void 0 : t.in);
  return r.setHours(0, 0, 0, 0), r;
}
function Aye(e, t, r) {
  const [n, a] = hye(
    r == null ? void 0 : r.in,
    e,
    t
  ), i = tC(n), o = tC(a), s = +i - eC(i), c = +o - eC(o);
  return Math.round((s - c) / dye);
}
function pye(e, t) {
  const r = qr(e, t == null ? void 0 : t.in);
  return r.setFullYear(r.getFullYear(), 0, 1), r.setHours(0, 0, 0, 0), r;
}
function vye(e, t) {
  const r = qr(e, t == null ? void 0 : t.in);
  return Aye(r, pye(r)) + 1;
}
function Yo(e, t) {
  var s, c, u, d;
  const r = Tl(), n = (t == null ? void 0 : t.weekStartsOn) ?? ((c = (s = t == null ? void 0 : t.locale) == null ? void 0 : s.options) == null ? void 0 : c.weekStartsOn) ?? r.weekStartsOn ?? ((d = (u = r.locale) == null ? void 0 : u.options) == null ? void 0 : d.weekStartsOn) ?? 0, a = qr(e, t == null ? void 0 : t.in), i = a.getDay(), o = (i < n ? 7 : 0) + i - n;
  return a.setDate(a.getDate() - o), a.setHours(0, 0, 0, 0), a;
}
function A0(e, t) {
  return Yo(e, { ...t, weekStartsOn: 1 });
}
function KE(e, t) {
  const r = qr(e, t == null ? void 0 : t.in), n = r.getFullYear(), a = h1(r, 0);
  a.setFullYear(n + 1, 0, 4), a.setHours(0, 0, 0, 0);
  const i = A0(a), o = h1(r, 0);
  o.setFullYear(n, 0, 4), o.setHours(0, 0, 0, 0);
  const s = A0(o);
  return r.getTime() >= i.getTime() ? n + 1 : r.getTime() >= s.getTime() ? n : n - 1;
}
function gye(e, t) {
  const r = KE(e, t), n = h1((t == null ? void 0 : t.in) || e, 0);
  return n.setFullYear(r, 0, 4), n.setHours(0, 0, 0, 0), A0(n);
}
function mye(e, t) {
  const r = qr(e, t == null ? void 0 : t.in), n = +A0(r) - +gye(r);
  return Math.round(n / zE) + 1;
}
function qE(e, t) {
  var d, h, A, p;
  const r = qr(e, t == null ? void 0 : t.in), n = r.getFullYear(), a = Tl(), i = (t == null ? void 0 : t.firstWeekContainsDate) ?? ((h = (d = t == null ? void 0 : t.locale) == null ? void 0 : d.options) == null ? void 0 : h.firstWeekContainsDate) ?? a.firstWeekContainsDate ?? ((p = (A = a.locale) == null ? void 0 : A.options) == null ? void 0 : p.firstWeekContainsDate) ?? 1, o = h1((t == null ? void 0 : t.in) || e, 0);
  o.setFullYear(n + 1, 0, i), o.setHours(0, 0, 0, 0);
  const s = Yo(o, t), c = h1((t == null ? void 0 : t.in) || e, 0);
  c.setFullYear(n, 0, i), c.setHours(0, 0, 0, 0);
  const u = Yo(c, t);
  return +r >= +s ? n + 1 : +r >= +u ? n : n - 1;
}
function Cye(e, t) {
  var s, c, u, d;
  const r = Tl(), n = (t == null ? void 0 : t.firstWeekContainsDate) ?? ((c = (s = t == null ? void 0 : t.locale) == null ? void 0 : s.options) == null ? void 0 : c.firstWeekContainsDate) ?? r.firstWeekContainsDate ?? ((d = (u = r.locale) == null ? void 0 : u.options) == null ? void 0 : d.firstWeekContainsDate) ?? 1, a = qE(e, t), i = h1((t == null ? void 0 : t.in) || e, 0);
  return i.setFullYear(a, 0, n), i.setHours(0, 0, 0, 0), Yo(i, t);
}
function bye(e, t) {
  const r = qr(e, t == null ? void 0 : t.in), n = +Yo(r, t) - +Cye(r, t);
  return Math.round(n / zE) + 1;
}
function Xe(e, t) {
  const r = e < 0 ? "-" : "", n = Math.abs(e).toString().padStart(t, "0");
  return r + n;
}
const Un = {
  // Year
  y(e, t) {
    const r = e.getFullYear(), n = r > 0 ? r : 1 - r;
    return Xe(t === "yy" ? n % 100 : n, t.length);
  },
  // Month
  M(e, t) {
    const r = e.getMonth();
    return t === "M" ? String(r + 1) : Xe(r + 1, 2);
  },
  // Day of the month
  d(e, t) {
    return Xe(e.getDate(), t.length);
  },
  // AM or PM
  a(e, t) {
    const r = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return r.toUpperCase();
      case "aaa":
        return r;
      case "aaaaa":
        return r[0];
      case "aaaa":
      default:
        return r === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h(e, t) {
    return Xe(e.getHours() % 12 || 12, t.length);
  },
  // Hour [0-23]
  H(e, t) {
    return Xe(e.getHours(), t.length);
  },
  // Minute
  m(e, t) {
    return Xe(e.getMinutes(), t.length);
  },
  // Second
  s(e, t) {
    return Xe(e.getSeconds(), t.length);
  },
  // Fraction of second
  S(e, t) {
    const r = t.length, n = e.getMilliseconds(), a = Math.trunc(
      n * Math.pow(10, r - 3)
    );
    return Xe(a, t.length);
  }
}, Ta = {
  am: "am",
  pm: "pm",
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, rC = {
  // Era
  G: function(e, t, r) {
    const n = e.getFullYear() > 0 ? 1 : 0;
    switch (t) {
      case "G":
      case "GG":
      case "GGG":
        return r.era(n, { width: "abbreviated" });
      case "GGGGG":
        return r.era(n, { width: "narrow" });
      case "GGGG":
      default:
        return r.era(n, { width: "wide" });
    }
  },
  // Year
  y: function(e, t, r) {
    if (t === "yo") {
      const n = e.getFullYear(), a = n > 0 ? n : 1 - n;
      return r.ordinalNumber(a, { unit: "year" });
    }
    return Un.y(e, t);
  },
  // Local week-numbering year
  Y: function(e, t, r, n) {
    const a = qE(e, n), i = a > 0 ? a : 1 - a;
    if (t === "YY") {
      const o = i % 100;
      return Xe(o, 2);
    }
    return t === "Yo" ? r.ordinalNumber(i, { unit: "year" }) : Xe(i, t.length);
  },
  // ISO week-numbering year
  R: function(e, t) {
    const r = KE(e);
    return Xe(r, t.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(e, t) {
    const r = e.getFullYear();
    return Xe(r, t.length);
  },
  // Quarter
  Q: function(e, t, r) {
    const n = Math.ceil((e.getMonth() + 1) / 3);
    switch (t) {
      case "Q":
        return String(n);
      case "QQ":
        return Xe(n, 2);
      case "Qo":
        return r.ordinalNumber(n, { unit: "quarter" });
      case "QQQ":
        return r.quarter(n, {
          width: "abbreviated",
          context: "formatting"
        });
      case "QQQQQ":
        return r.quarter(n, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return r.quarter(n, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(e, t, r) {
    const n = Math.ceil((e.getMonth() + 1) / 3);
    switch (t) {
      case "q":
        return String(n);
      case "qq":
        return Xe(n, 2);
      case "qo":
        return r.ordinalNumber(n, { unit: "quarter" });
      case "qqq":
        return r.quarter(n, {
          width: "abbreviated",
          context: "standalone"
        });
      case "qqqqq":
        return r.quarter(n, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return r.quarter(n, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(e, t, r) {
    const n = e.getMonth();
    switch (t) {
      case "M":
      case "MM":
        return Un.M(e, t);
      case "Mo":
        return r.ordinalNumber(n + 1, { unit: "month" });
      case "MMM":
        return r.month(n, {
          width: "abbreviated",
          context: "formatting"
        });
      case "MMMMM":
        return r.month(n, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return r.month(n, { width: "wide", context: "formatting" });
    }
  },
  // Stand-alone month
  L: function(e, t, r) {
    const n = e.getMonth();
    switch (t) {
      case "L":
        return String(n + 1);
      case "LL":
        return Xe(n + 1, 2);
      case "Lo":
        return r.ordinalNumber(n + 1, { unit: "month" });
      case "LLL":
        return r.month(n, {
          width: "abbreviated",
          context: "standalone"
        });
      case "LLLLL":
        return r.month(n, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return r.month(n, { width: "wide", context: "standalone" });
    }
  },
  // Local week of year
  w: function(e, t, r, n) {
    const a = bye(e, n);
    return t === "wo" ? r.ordinalNumber(a, { unit: "week" }) : Xe(a, t.length);
  },
  // ISO week of year
  I: function(e, t, r) {
    const n = mye(e);
    return t === "Io" ? r.ordinalNumber(n, { unit: "week" }) : Xe(n, t.length);
  },
  // Day of the month
  d: function(e, t, r) {
    return t === "do" ? r.ordinalNumber(e.getDate(), { unit: "date" }) : Un.d(e, t);
  },
  // Day of year
  D: function(e, t, r) {
    const n = vye(e);
    return t === "Do" ? r.ordinalNumber(n, { unit: "dayOfYear" }) : Xe(n, t.length);
  },
  // Day of week
  E: function(e, t, r) {
    const n = e.getDay();
    switch (t) {
      case "E":
      case "EE":
      case "EEE":
        return r.day(n, {
          width: "abbreviated",
          context: "formatting"
        });
      case "EEEEE":
        return r.day(n, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return r.day(n, {
          width: "short",
          context: "formatting"
        });
      case "EEEE":
      default:
        return r.day(n, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(e, t, r, n) {
    const a = e.getDay(), i = (a - n.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      case "e":
        return String(i);
      case "ee":
        return Xe(i, 2);
      case "eo":
        return r.ordinalNumber(i, { unit: "day" });
      case "eee":
        return r.day(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "eeeee":
        return r.day(a, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return r.day(a, {
          width: "short",
          context: "formatting"
        });
      case "eeee":
      default:
        return r.day(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(e, t, r, n) {
    const a = e.getDay(), i = (a - n.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      case "c":
        return String(i);
      case "cc":
        return Xe(i, t.length);
      case "co":
        return r.ordinalNumber(i, { unit: "day" });
      case "ccc":
        return r.day(a, {
          width: "abbreviated",
          context: "standalone"
        });
      case "ccccc":
        return r.day(a, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return r.day(a, {
          width: "short",
          context: "standalone"
        });
      case "cccc":
      default:
        return r.day(a, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(e, t, r) {
    const n = e.getDay(), a = n === 0 ? 7 : n;
    switch (t) {
      case "i":
        return String(a);
      case "ii":
        return Xe(a, t.length);
      case "io":
        return r.ordinalNumber(a, { unit: "day" });
      case "iii":
        return r.day(n, {
          width: "abbreviated",
          context: "formatting"
        });
      case "iiiii":
        return r.day(n, {
          width: "narrow",
          context: "formatting"
        });
      case "iiiiii":
        return r.day(n, {
          width: "short",
          context: "formatting"
        });
      case "iiii":
      default:
        return r.day(n, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(e, t, r) {
    const a = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return r.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return r.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return r.dayPeriod(a, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return r.dayPeriod(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(e, t, r) {
    const n = e.getHours();
    let a;
    switch (n === 12 ? a = Ta.noon : n === 0 ? a = Ta.midnight : a = n / 12 >= 1 ? "pm" : "am", t) {
      case "b":
      case "bb":
        return r.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return r.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return r.dayPeriod(a, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return r.dayPeriod(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(e, t, r) {
    const n = e.getHours();
    let a;
    switch (n >= 17 ? a = Ta.evening : n >= 12 ? a = Ta.afternoon : n >= 4 ? a = Ta.morning : a = Ta.night, t) {
      case "B":
      case "BB":
      case "BBB":
        return r.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return r.dayPeriod(a, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return r.dayPeriod(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(e, t, r) {
    if (t === "ho") {
      let n = e.getHours() % 12;
      return n === 0 && (n = 12), r.ordinalNumber(n, { unit: "hour" });
    }
    return Un.h(e, t);
  },
  // Hour [0-23]
  H: function(e, t, r) {
    return t === "Ho" ? r.ordinalNumber(e.getHours(), { unit: "hour" }) : Un.H(e, t);
  },
  // Hour [0-11]
  K: function(e, t, r) {
    const n = e.getHours() % 12;
    return t === "Ko" ? r.ordinalNumber(n, { unit: "hour" }) : Xe(n, t.length);
  },
  // Hour [1-24]
  k: function(e, t, r) {
    let n = e.getHours();
    return n === 0 && (n = 24), t === "ko" ? r.ordinalNumber(n, { unit: "hour" }) : Xe(n, t.length);
  },
  // Minute
  m: function(e, t, r) {
    return t === "mo" ? r.ordinalNumber(e.getMinutes(), { unit: "minute" }) : Un.m(e, t);
  },
  // Second
  s: function(e, t, r) {
    return t === "so" ? r.ordinalNumber(e.getSeconds(), { unit: "second" }) : Un.s(e, t);
  },
  // Fraction of second
  S: function(e, t) {
    return Un.S(e, t);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(e, t, r) {
    const n = e.getTimezoneOffset();
    if (n === 0)
      return "Z";
    switch (t) {
      case "X":
        return aC(n);
      case "XXXX":
      case "XX":
        return V1(n);
      case "XXXXX":
      case "XXX":
      default:
        return V1(n, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(e, t, r) {
    const n = e.getTimezoneOffset();
    switch (t) {
      case "x":
        return aC(n);
      case "xxxx":
      case "xx":
        return V1(n);
      case "xxxxx":
      case "xxx":
      default:
        return V1(n, ":");
    }
  },
  // Timezone (GMT)
  O: function(e, t, r) {
    const n = e.getTimezoneOffset();
    switch (t) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + nC(n, ":");
      case "OOOO":
      default:
        return "GMT" + V1(n, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(e, t, r) {
    const n = e.getTimezoneOffset();
    switch (t) {
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + nC(n, ":");
      case "zzzz":
      default:
        return "GMT" + V1(n, ":");
    }
  },
  // Seconds timestamp
  t: function(e, t, r) {
    const n = Math.trunc(+e / 1e3);
    return Xe(n, t.length);
  },
  // Milliseconds timestamp
  T: function(e, t, r) {
    return Xe(+e, t.length);
  }
};
function nC(e, t = "") {
  const r = e > 0 ? "-" : "+", n = Math.abs(e), a = Math.trunc(n / 60), i = n % 60;
  return i === 0 ? r + String(a) : r + String(a) + t + Xe(i, 2);
}
function aC(e, t) {
  return e % 60 === 0 ? (e > 0 ? "-" : "+") + Xe(Math.abs(e) / 60, 2) : V1(e, t);
}
function V1(e, t = "") {
  const r = e > 0 ? "-" : "+", n = Math.abs(e), a = Xe(Math.trunc(n / 60), 2), i = Xe(n % 60, 2);
  return r + a + t + i;
}
const iC = (e, t) => {
  switch (e) {
    case "P":
      return t.date({ width: "short" });
    case "PP":
      return t.date({ width: "medium" });
    case "PPP":
      return t.date({ width: "long" });
    case "PPPP":
    default:
      return t.date({ width: "full" });
  }
}, XE = (e, t) => {
  switch (e) {
    case "p":
      return t.time({ width: "short" });
    case "pp":
      return t.time({ width: "medium" });
    case "ppp":
      return t.time({ width: "long" });
    case "pppp":
    default:
      return t.time({ width: "full" });
  }
}, yye = (e, t) => {
  const r = e.match(/(P+)(p+)?/) || [], n = r[1], a = r[2];
  if (!a)
    return iC(e, t);
  let i;
  switch (n) {
    case "P":
      i = t.dateTime({ width: "short" });
      break;
    case "PP":
      i = t.dateTime({ width: "medium" });
      break;
    case "PPP":
      i = t.dateTime({ width: "long" });
      break;
    case "PPPP":
    default:
      i = t.dateTime({ width: "full" });
      break;
  }
  return i.replace("{{date}}", iC(n, t)).replace("{{time}}", XE(a, t));
}, wye = {
  p: XE,
  P: yye
}, xye = /^D+$/, Oye = /^Y+$/, Dye = ["D", "DD", "YY", "YYYY"];
function Mye(e) {
  return xye.test(e);
}
function Eye(e) {
  return Oye.test(e);
}
function Pye(e, t, r) {
  const n = jye(e, t, r);
  if (console.warn(n), Dye.includes(e))
    throw new RangeError(n);
}
function jye(e, t, r) {
  const n = e[0] === "Y" ? "years" : "days of the month";
  return `Use \`${e.toLowerCase()}\` instead of \`${e}\` (in \`${t}\`) for formatting ${n} to the input \`${r}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}
function Sye(e) {
  return e instanceof Date || typeof e == "object" && Object.prototype.toString.call(e) === "[object Date]";
}
function Iye(e) {
  return !(!Sye(e) && typeof e != "number" || isNaN(+qr(e)));
}
const Bye = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, Nye = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, _ye = /^'([^]*?)'?$/, Lye = /''/g, Tye = /[a-zA-Z]/;
function oC(e, t, r) {
  var d, h, A, p, m, g, v, C;
  const n = Tl(), a = (r == null ? void 0 : r.locale) ?? n.locale ?? uye, i = (r == null ? void 0 : r.firstWeekContainsDate) ?? ((h = (d = r == null ? void 0 : r.locale) == null ? void 0 : d.options) == null ? void 0 : h.firstWeekContainsDate) ?? n.firstWeekContainsDate ?? ((p = (A = n.locale) == null ? void 0 : A.options) == null ? void 0 : p.firstWeekContainsDate) ?? 1, o = (r == null ? void 0 : r.weekStartsOn) ?? ((g = (m = r == null ? void 0 : r.locale) == null ? void 0 : m.options) == null ? void 0 : g.weekStartsOn) ?? n.weekStartsOn ?? ((C = (v = n.locale) == null ? void 0 : v.options) == null ? void 0 : C.weekStartsOn) ?? 0, s = qr(e, r == null ? void 0 : r.in);
  if (!Iye(s))
    throw new RangeError("Invalid time value");
  let c = t.match(Nye).map((y) => {
    const w = y[0];
    if (w === "p" || w === "P") {
      const O = wye[w];
      return O(y, a.formatLong);
    }
    return y;
  }).join("").match(Bye).map((y) => {
    if (y === "''")
      return { isToken: !1, value: "'" };
    const w = y[0];
    if (w === "'")
      return { isToken: !1, value: Rye(y) };
    if (rC[w])
      return { isToken: !0, value: y };
    if (w.match(Tye))
      throw new RangeError(
        "Format string contains an unescaped latin alphabet character `" + w + "`"
      );
    return { isToken: !1, value: y };
  });
  a.localize.preprocessor && (c = a.localize.preprocessor(s, c));
  const u = {
    firstWeekContainsDate: i,
    weekStartsOn: o,
    locale: a
  };
  return c.map((y) => {
    if (!y.isToken)
      return y.value;
    const w = y.value;
    (!(r != null && r.useAdditionalWeekYearTokens) && Eye(w) || !(r != null && r.useAdditionalDayOfYearTokens) && Mye(w)) && Pye(w, t, String(e));
    const O = rC[w[0]];
    return O(s, w, a.localize, u);
  }).join("");
}
function Rye(e) {
  const t = e.match(_ye);
  return t ? t[1].replace(Lye, "'") : e;
}
const $ye = B.forwardRef((e) => {
  const {
    containerName: t,
    numberOfAlerts: r,
    onChangeValueFilterDate: n,
    valueFilterDate: a,
    graphicKeyName: i
  } = e, o = () => `component_${i ?? "defaultKeyName"}_hidden`, [s, c] = De(() => {
    const h = localStorage.getItem(o());
    return h !== null ? JSON.parse(h) : !1;
  }), u = () => {
    c((h) => {
      const A = !h;
      return localStorage.setItem(o(), JSON.stringify(A)), A;
    });
  }, d = (h) => {
    const A = h.option.startDate, p = h.option.endDate, m = p !== void 0 ? oC(p, "dd/MM/yyyy") : "Fecha de fin no disponible", v = [A !== void 0 ? oC(A, "dd/MM/yyyy") : "Fecha de inicio no disponible", m];
    n !== void 0 && n({ option: v });
  };
  return /* @__PURE__ */ f.jsxs("div", { className: "border rounded-md shadow-s mb-8 max-w-[1260px] mx-auto", children: [
    /* @__PURE__ */ f.jsx("div", { className: "p-4", children: /* @__PURE__ */ f.jsx("div", { className: "flex flex-col 2s:justify-between 2s:items-center gap-4 2s:flex-row", children: /* @__PURE__ */ f.jsxs(q3, { gap: 4, alignItems: "center", children: [
      /* @__PURE__ */ f.jsx("button", { className: "cursor-pointer", onClick: u, children: /* @__PURE__ */ f.jsx(
        Me,
        {
          variant: s ? "eye-hide" : "eye",
          color: "neutral-300"
        }
      ) }),
      /* @__PURE__ */ f.jsx(kr, { variant: "title-2", children: t }),
      r !== void 0 ? /* @__PURE__ */ f.jsx("div", { className: "bg-error-600 rounded-lg py-2 px-4", children: /* @__PURE__ */ f.jsxs(kr, { variant: "title-4", color: "white", children: [
        r,
        " nuevas"
      ] }) }) : void 0
    ] }) }) }),
    /* @__PURE__ */ f.jsx("div", { className: `border-1 ${s ? "hidden" : "block"}` }),
    !(e != null && e.hiddenFilter) && /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
      /* @__PURE__ */ f.jsx("div", { className: `p-4 ${s ? "hidden" : "block"}`, children: /* @__PURE__ */ f.jsxs("div", { className: "flex gap-4", children: [
        /* @__PURE__ */ f.jsx("div", { className: "flex flex-col flex-1 gap-4 2s:flex-row", children: /* @__PURE__ */ f.jsx(
          ZE,
          {
            valueFilterDate: a,
            onChangeValueFilterDate: d
          }
        ) }),
        /* @__PURE__ */ f.jsx("div", { className: "hidden", children: /* @__PURE__ */ f.jsxs(
          hC,
          {
            variant: "actions",
            button: /* @__PURE__ */ f.jsx(
              Qr,
              {
                variant: "secondary",
                size: "m",
                icon: "menu-context",
                onlyIcon: !0
              }
            ),
            children: [
              /* @__PURE__ */ f.jsx(B4, { icon: "trash", children: "Eliminar" }),
              /* @__PURE__ */ f.jsx(B4, { icon: "edit", children: "Editar" })
            ]
          }
        ) })
      ] }) }),
      /* @__PURE__ */ f.jsx("div", { className: `border-1 ${s ? "hidden" : "block"}` })
    ] }),
    /* @__PURE__ */ f.jsx("div", { className: `p-4 2s:p-8 mb-4 ${s ? "hidden" : "grid"}`, children: e.children })
  ] });
});
$ye.displayName = "GraphicContainer";
const Fye = B.forwardRef((e) => {
  const { handleLabelClick: t, data: r, chartColors: n } = e;
  if (r == null)
    return null;
  const a = r.filter((d) => d.value !== 0), i = (d) => () => {
    t !== void 0 && t({ data: d });
  }, o = n.map((d) => gt[d.colorCellChart]), s = {
    gridTemplateColumns: "8fr 2fr"
  }, c = Math.PI / 180, u = ({
    cx: d,
    cy: h,
    midAngle: A,
    innerRadius: p,
    outerRadius: m,
    index: g
  }) => {
    const v = p + (m - p) * 0.5, C = d + v * Math.cos(-A * Number(c)), y = h + v * Math.sin(-A * Number(c));
    return /* @__PURE__ */ f.jsx(
      "text",
      {
        className: "text-md s:text-l font-bold",
        x: C,
        y,
        fill: "white",
        textAnchor: C > d ? "start" : "end",
        dominantBaseline: "central",
        children: `${a[g].value}`
      }
    );
  };
  return /* @__PURE__ */ f.jsx(f.Fragment, { children: /* @__PURE__ */ f.jsxs("div", { className: "flex flex-col 2s:grid 2s:gap-8", style: s, children: [
    /* @__PURE__ */ f.jsx($2, { width: "100%", aspect: 2, children: /* @__PURE__ */ f.jsx(u8, { children: /* @__PURE__ */ f.jsx(
      zr,
      {
        dataKey: "value",
        startAngle: 180,
        endAngle: 0,
        data: a,
        labelLine: !1,
        label: u,
        cx: "50%",
        cy: "90%",
        innerRadius: "70%",
        outerRadius: "180%",
        fill: "#8884d8",
        stroke: "none",
        cursor: "pointer",
        children: a.map((d, h) => /* @__PURE__ */ f.jsx(
          Nr,
          {
            fill: o[h % o.length],
            onClick: i(d)
          },
          `cell-${h}`
        ))
      }
    ) }) }),
    /* @__PURE__ */ f.jsxs("div", { className: "flex flex-col justify-center gap-4 rounded-md text-center", children: [
      /* @__PURE__ */ f.jsxs("div", { className: "rounded-md p-4 text-center bg-success-400", children: [
        /* @__PURE__ */ f.jsx(kr, { variant: "title-3", color: "white", children: "A tiempo" }),
        /* @__PURE__ */ f.jsx(Vi, { variant: "heading-4", color: "white", children: r[2].value !== null ? r[2].value : "0" }),
        /* @__PURE__ */ f.jsx(a1, { variant: "description-4", color: "white", children: "Operaciones" })
      ] }),
      /* @__PURE__ */ f.jsxs("div", { className: "rounded-md p-4 text-center bg-warning-400", children: [
        /* @__PURE__ */ f.jsx(kr, { variant: "title-3", color: "white", children: "Críticas" }),
        /* @__PURE__ */ f.jsx(Vi, { variant: "heading-4", color: "white", children: r[1].value !== null ? r[1].value : "0" }),
        /* @__PURE__ */ f.jsx(a1, { variant: "description-4", color: "white", children: "Operaciones" })
      ] }),
      /* @__PURE__ */ f.jsxs("div", { className: "rounded-md p-4 text-center bg-error-400", children: [
        /* @__PURE__ */ f.jsx(kr, { variant: "title-3", color: "white", children: "Muy críticas" }),
        /* @__PURE__ */ f.jsx(Vi, { variant: "heading-4", color: "white", children: r[0].value !== null ? r[0].value : "0" }),
        /* @__PURE__ */ f.jsx(a1, { variant: "description-4", color: "white", children: "Operaciones" })
      ] })
    ] })
  ] }) });
});
Fye.displayName = "SemiPieChart";
const Hye = B.forwardRef((e, t) => {
  const {
    data: r,
    chartColors: n,
    domainYAxis: a,
    ticksYAxis: i,
    onActivClick: o,
    ...s
  } = e;
  if (r == null)
    return null;
  const c = r.map((C) => ({
    name: C.name,
    [C.currentDate]: C.numCurrenDate,
    [C.previousDate]: C.numPreviousDate
  })), u = Object.keys(c[0]), d = n.map((C) => gt[C.colorBar]), h = n.map((C) => gt[C.colorLine]), A = (C) => () => {
    o !== void 0 && o({ data: C });
  }, [p, m] = De(1), [g, v] = De(0);
  return Ie(() => {
    const C = () => {
      const y = document.getElementById("container-chart");
      y !== null && (y.getBoundingClientRect().width <= 650 ? (m(1), v(-45)) : (m(2), c.length >= 6 ? v(-45) : v(0)));
    };
    return C(), window.addEventListener("resize", C), () => {
      window.removeEventListener("resize", C);
    };
  }, [c]), /* @__PURE__ */ f.jsx(f.Fragment, { children: /* @__PURE__ */ f.jsx("section", { className: "w-full max-w-[1260px]", id: "container-chart", ref: t, ...s, children: /* @__PURE__ */ f.jsx($2, { width: "100%", aspect: p, children: /* @__PURE__ */ f.jsxs(
    hce,
    {
      width: 500,
      height: 800,
      data: c,
      margin: {
        top: 20,
        right: 20,
        bottom: g === 0 ? 20 : 40,
        left: -20
      },
      children: [
        /* @__PURE__ */ f.jsx(nl, { stroke: "#f5f5f5" }),
        /* @__PURE__ */ f.jsx(f1, { dataKey: "name", className: "text-xs 2s:text-s", interval: 0, angle: g, textAnchor: g === 0 ? "middle" : "end" }),
        /* @__PURE__ */ f.jsx(
          ua,
          {
            domain: a,
            ticks: i,
            className: "text-xs 2s:text-s"
          }
        ),
        /* @__PURE__ */ f.jsx(Xt, { contentStyle: { fontSize: p === 2 ? "14px" : "13px" } }),
        /* @__PURE__ */ f.jsx(
          Dn,
          {
            wrapperStyle: { bottom: 0, left: 10 },
            iconType: "circle",
            formatter: (C) => /* @__PURE__ */ f.jsx("span", { style: { fontWeight: "bold", color: "black", marginTop: "40px", fontSize: p === 2 ? "14px" : "13px" }, children: C })
          }
        ),
        /* @__PURE__ */ f.jsx(Lr, { width: 65, dataKey: u[1], barSize: 65, fill: d[0], children: r.map((C, y) => /* @__PURE__ */ f.jsx(Nr, { onClick: A(C) }, `cell-${y}`)) }),
        /* @__PURE__ */ f.jsx(t3, { type: "monotone", dataKey: u[2], stroke: h[0], strokeWidth: 2 })
      ]
    }
  ) }) }) });
});
Hye.displayName = "ComposedCharts";
const Yye = B.forwardRef((e, t) => {
  const {
    data: r,
    chartColors: n,
    domainXAxis: a,
    ticksXAxis: i,
    onClickNegativeBar: o,
    onClickPositiveBar: s,
    ...c
  } = e;
  if (r == null)
    return null;
  const u = r.map((C) => ({
    name: C.name,
    [C.positiveBarName]: C.positiveBarNumber,
    [C.negativeBarName]: C.negativeBarNumber
  })), d = Object.keys(u[0]), h = n.map((C) => gt[C.colorBarNegative]), A = n.map((C) => gt[C.colorBarPositive]), p = (C) => () => {
    o !== void 0 && o({ data: C });
  }, m = (C) => () => {
    s !== void 0 && s({ data: C });
  }, [g, v] = De(1);
  return Ie(() => {
    const C = () => {
      const y = document.getElementById("container-chart-horizontal");
      y !== null && (y.getBoundingClientRect().width <= 550 ? v(1) : v(2));
    };
    return C(), window.addEventListener("resize", C), () => {
      window.removeEventListener("resize", C);
    };
  }, []), /* @__PURE__ */ f.jsx(f.Fragment, { children: /* @__PURE__ */ f.jsx("section", { id: "container-chart-horizontal", className: "w-full max-w-[1260px]", ref: t, ...c, children: /* @__PURE__ */ f.jsx($2, { width: "100%", aspect: g, children: /* @__PURE__ */ f.jsxs(
    SO,
    {
      width: 500,
      height: 400,
      data: u,
      layout: "vertical",
      margin: {
        top: 5,
        right: 10,
        left: 0,
        bottom: 5
      },
      children: [
        /* @__PURE__ */ f.jsx(nl, { strokeDasharray: "3 3" }),
        /* @__PURE__ */ f.jsx(
          f1,
          {
            type: "number",
            domain: a,
            ticks: i,
            className: "text-xs 2s:text-s"
          }
        ),
        /* @__PURE__ */ f.jsx(ua, { dataKey: "name", type: "category", className: "text-xs 2s:text-s", width: g === 2 ? 122 : void 0 }),
        /* @__PURE__ */ f.jsx(Xt, { contentStyle: { fontSize: g === 2 ? "14px" : "13px" } }),
        /* @__PURE__ */ f.jsx(
          Dn,
          {
            iconType: "circle",
            formatter: (C) => /* @__PURE__ */ f.jsx("span", { style: { fontWeight: "bold", color: "black", marginTop: "40px", fontSize: g === 2 ? "14px" : "13px" }, children: C })
          }
        ),
        /* @__PURE__ */ f.jsx(Lr, { dataKey: d[2], barSize: 38, fill: h[0], children: r.map((C, y) => /* @__PURE__ */ f.jsx(Nr, { onClick: p(C) }, `cell-${y}`)) }),
        /* @__PURE__ */ f.jsx(Lr, { dataKey: d[1], barSize: 38, fill: A[0], children: r.map((C, y) => /* @__PURE__ */ f.jsx(Nr, { onClick: m(C) }, `cell-${y}`)) })
      ]
    }
  ) }) }) });
});
Yye.displayName = "HorizontalChart";
const Vye = B.forwardRef((e, t) => {
  const {
    data: r,
    chartColors: n,
    domainXAxis: a,
    ticksXAxis: i,
    onClickCurrentBar: o,
    onClickPreviousBar: s,
    image: c,
    ...u
  } = e;
  if (r == null || n == null || a == null || i == null || c == null)
    return null;
  const d = r.map((D) => ({
    name: D.name,
    [D.currentDate]: D.numCurrenDate,
    [D.previousDate]: D.numPreviousDate,
    url: D.url
  })), h = Object.keys(d[0]), A = n.map((D) => gt[D.colorBarCurrent]), p = n.map((D) => gt[D.colorBarPrevious]), m = (D) => () => {
    o !== void 0 && o({ data: D });
  }, g = (D) => () => {
    s !== void 0 && s({ data: D });
  }, v = ({ data: D, ...M }) => {
    const j = M.x, P = M.y, H = D == null ? void 0 : D.map((F) => F.name);
    return j == null || P == null ? null : /* @__PURE__ */ f.jsx(f.Fragment, { children: /* @__PURE__ */ f.jsxs("g", { transform: `translate(${j},${P})`, radius: "100%", children: [
      H == null ? void 0 : H.map((F, R) => /* @__PURE__ */ f.jsx("text", { x: 0, y: 10, transform: "rotate(-45)", textAnchor: "end", dominantBaseline: "middle", fontSize: 7, fontWeight: "400", fill: "#666666", children: F }, R)),
      /* @__PURE__ */ f.jsx("defs", { children: /* @__PURE__ */ f.jsx("clipPath", { id: "circleView", children: /* @__PURE__ */ f.jsx("circle", { cx: -5, cy: 65, r: 14 }) }) }),
      /* @__PURE__ */ f.jsx("image", { href: M.payload.value, clipPath: "url(#circleView)", x: -55, y: 50, height: "35px", width: "100px", radius: 100, textAnchor: "middle" })
    ] }) });
  }, [C, y] = De(1), [w, O] = De(0);
  Ie(() => {
    const D = () => {
      const M = document.getElementById("container-chart-simple-bar");
      M !== null && (M.getBoundingClientRect().width <= 650 ? (y(1), O(-45)) : (y(2), d.length >= 6 ? O(-45) : O(0)));
    };
    return D(), window.addEventListener("resize", D), () => {
      window.removeEventListener("resize", D);
    };
  }, []);
  const b = ({ active: D, payload: M }) => D == null ? null : D && M != null && M.length > 0 ? /* @__PURE__ */ f.jsx("div", { className: "bg-neutral-100 p-3 border-white border-1", children: Object.keys(M[0].payload).map((j) => {
    if (j === "name") {
      const P = String(M[0].payload[j]);
      return /* @__PURE__ */ f.jsx("p", { children: `${P}` }, j);
    }
    if (j === "Mes actual") {
      const P = String(M[0].payload[j]);
      return /* @__PURE__ */ f.jsx("p", { style: { color: A[0] }, children: `${j}: ${P}` }, j);
    }
    if (j === "Mes anterior") {
      const P = String(M[0].payload[j]);
      return /* @__PURE__ */ f.jsx("p", { style: { color: p[0] }, children: `${j}: ${P}` }, j);
    }
    return null;
  }) }) : null;
  return /* @__PURE__ */ f.jsx(f.Fragment, { children: /* @__PURE__ */ f.jsx("section", { id: "container-chart-simple-bar", className: "w-full max-w-[1260px]", ref: t, ...u, children: /* @__PURE__ */ f.jsx($2, { width: "100%", aspect: C, children: /* @__PURE__ */ f.jsxs(
    SO,
    {
      width: 500,
      height: 300,
      data: d,
      margin: {
        top: 20,
        right: 20,
        bottom: w === 0 ? 20 : 50,
        left: -20
      },
      children: [
        /* @__PURE__ */ f.jsx(nl, { stroke: "#A3A3A3", strokeWidth: 0.5, horizontal: !0, vertical: !1 }),
        c ? /* @__PURE__ */ f.jsx(f1, { dataKey: "url", interval: 0, tick: /* @__PURE__ */ f.jsx(v, { data: r }) }) : /* @__PURE__ */ f.jsx(f1, { dataKey: "name", fontSize: 12, interval: 0, angle: -45, textAnchor: "end" }),
        /* @__PURE__ */ f.jsx(
          ua,
          {
            className: "text-xs 2s:text-s",
            radius: "100%",
            domain: a,
            ticks: i
          }
        ),
        c ? /* @__PURE__ */ f.jsx(
          Xt,
          {
            contentStyle: { fontSize: C === 2 ? "14px" : "13px" },
            content: /* @__PURE__ */ f.jsx(b, {})
          }
        ) : /* @__PURE__ */ f.jsx(
          Xt,
          {
            contentStyle: { fontSize: C === 2 ? "14px" : "13px" }
          }
        ),
        /* @__PURE__ */ f.jsx(
          Dn,
          {
            wrapperStyle: { bottom: c ? -15 : 0, left: 5 },
            iconType: "circle",
            formatter: (D) => /* @__PURE__ */ f.jsx("span", { style: { fontWeight: "bold", color: "black", marginTop: "40px", fontSize: C === 2 ? "14px" : "13px" }, children: D })
          }
        ),
        /* @__PURE__ */ f.jsx(Lr, { dataKey: h[1], fill: A[0], barSize: 37, children: r.map((D, M) => /* @__PURE__ */ f.jsx(Nr, { onClick: m(D) }, `cell-${M}`)) }),
        /* @__PURE__ */ f.jsx(Lr, { dataKey: h[2], fill: p[0], barSize: 37, children: r.map((D, M) => /* @__PURE__ */ f.jsx(Nr, { onClick: g(D) }, `cell-${M}`)) })
      ]
    }
  ) }) }) });
});
Vye.displayName = "SimpleBarChart";
const kye = B.forwardRef((e, t) => {
  const {
    data: r,
    onClickCellChart: n,
    onClickIconCard: a,
    chartColors: i,
    labelOne: o,
    labelTwo: s,
    percentageMessage: c,
    columns: u,
    hiddenCenter: d,
    ...h
  } = e;
  if (r == null || o == null)
    return null;
  const A = (v) => () => {
    n !== void 0 && n({ data: v });
  }, p = i.map((v) => gt[v.colorCellChart]), m = {
    gridTemplateColumns: "5fr 5fr"
  }, g = ({
    labelTop: v,
    labelBottom: C
  }) => /* @__PURE__ */ f.jsxs("g", { children: [
    /* @__PURE__ */ f.jsx(
      "text",
      {
        x: "50%",
        y: "50%",
        textAnchor: "middle",
        dominantBaseline: "middle",
        fontSize: 30,
        fontWeight: "700",
        fill: "#292929",
        children: v
      }
    ),
    /* @__PURE__ */ f.jsx(
      "text",
      {
        x: "50%",
        y: "60%",
        textAnchor: "middle",
        dominantBaseline: "middle",
        fontSize: 14,
        fontWeight: "400",
        fill: "#292929",
        children: C
      }
    )
  ] });
  return /* @__PURE__ */ f.jsx(
    "section",
    {
      ref: t,
      className: "flex justify-center items-center",
      ...h,
      children: /* @__PURE__ */ f.jsxs(
        "div",
        {
          className: "w-full max-w-[1260px] flex flex-col gap-4 2s:grid 2s:gap-8 relative",
          style: m,
          children: [
            /* @__PURE__ */ f.jsx($2, { width: "90%", height: 300, children: /* @__PURE__ */ f.jsxs(u8, { children: [
              /* @__PURE__ */ f.jsxs(
                zr,
                {
                  dataKey: "value",
                  data: r,
                  innerRadius: d ? "0%" : "55%",
                  outerRadius: "100%",
                  cursor: "pointer",
                  children: [
                    /* @__PURE__ */ f.jsx(
                      Et,
                      {
                        content: /* @__PURE__ */ f.jsx(
                          g,
                          {
                            labelTop: o ?? "",
                            labelBottom: s ?? ""
                          }
                        ),
                        position: "center"
                      }
                    ),
                    r.map((v, C) => /* @__PURE__ */ f.jsx(
                      Nr,
                      {
                        fill: p[C % p.length],
                        onClick: A(v)
                      },
                      `cell-${C}`
                    ))
                  ]
                }
              ),
              /* @__PURE__ */ f.jsx(Xt, {})
            ] }) }),
            /* @__PURE__ */ f.jsx("div", { className: "w-full mx-auto flex flex-col items-start justify-center", children: /* @__PURE__ */ f.jsx("div", { className: "overflow-x-auto", children: /* @__PURE__ */ f.jsxs("table", { className: "border-collapse border border-slate-500 rounded-lg shadow-md mb-8 w-full table-fixed", children: [
              /* @__PURE__ */ f.jsx("thead", { children: /* @__PURE__ */ f.jsx("tr", { className: "bg-neutral-300", children: u.map((v, C) => /* @__PURE__ */ f.jsx(
                "th",
                {
                  className: "px-4 py-2 text-center border border-gray-400",
                  children: v
                },
                C
              )) }) }),
              /* @__PURE__ */ f.jsx("tbody", { children: r.map((v, C) => /* @__PURE__ */ f.jsxs("tr", { className: "border-t border-gray-200", children: [
                /* @__PURE__ */ f.jsx("td", { className: "px-4 py-2", children: v.name }),
                v.value1 !== void 0 && v.value1 !== null && /* @__PURE__ */ f.jsx("td", { className: "px-4 py-2 text-center border border-gray-300", children: v.value1 }),
                v.value2 !== void 0 && v.value2 !== null && /* @__PURE__ */ f.jsx("td", { className: "px-4 py-2 text-center border border-gray-300", children: v.value2 }),
                v.value3 !== void 0 && v.value3 !== null && /* @__PURE__ */ f.jsx("td", { className: "px-4 py-2 text-center border border-gray-300", children: v.value3 }),
                /* @__PURE__ */ f.jsx("td", { className: "px-4 py-2 text-center border border-gray-300", children: v.color ? /* @__PURE__ */ f.jsx(
                  "div",
                  {
                    className: "w-4 h-4 rounded-full mx-auto",
                    style: { backgroundColor: v.color }
                  }
                ) : "" })
              ] }, C)) })
            ] }) }) })
          ]
        }
      )
    }
  );
});
kye.displayName = "PieChartsTable";
const Gye = B.forwardRef((e, t) => {
  const {
    text: r,
    color: n,
    children: a
  } = e, i = {
    color: n !== void 0 ? gt[n] : void 0,
    fontWeight: n !== void 0 ? 600 : void 0
  }, o = {
    backgroundColor: n !== void 0 ? gt[n] : gt["neutral-300"]
  };
  return /* @__PURE__ */ f.jsxs("div", { ref: t, className: "flex flex-col 2s:flex-row 2s:justify-between gap-4 items-center", children: [
    /* @__PURE__ */ f.jsxs("div", { className: "relative text-center 2s:text-left 2s:flex-grow 2s:flex 2s:gap-4 2s:justify-between 2s:items-center", children: [
      r !== void 0 && /* @__PURE__ */ f.jsx("p", { className: "leading-[120%]", style: i, children: r }),
      /* @__PURE__ */ f.jsx("span", { className: "hidden 2s:block h-[1px] 2s:flex-grow", style: o })
    ] }),
    /* @__PURE__ */ f.jsx("div", { className: "w-full 2s:w-auto", children: a })
  ] });
});
Gye.displayName = "Divider";
function twe(e) {
  const {
    label: t,
    extFiles: r,
    multiple: n,
    disabled: a,
    maxSize: i,
    maxLengthLabelFile: o,
    limitNumberFiles: s,
    onChange: c,
    value: u
  } = e, d = E7(), h = i || 3, A = o || 16, p = [
    "ene.",
    "feb.",
    "mar.",
    "abr.",
    "may.",
    "jun.",
    "jul.",
    "ago.",
    "sep.",
    "oct.",
    "nov.",
    "dic."
  ], [m, g] = De([]), v = ge(null), C = dr(() => u ? Array.isArray(u) ? [...u] : [u] : [], [u]), y = (R) => R / (1024 * 1024), w = (R) => {
    const N = R.name.split(".").at(-1);
    return N != null && N.includes("doc") ? "word" : (N != null && N.includes("xls"), "excel");
  }, O = (R) => {
    R = R.filter((N) => {
      const z = N.name.split(".").at(-1);
      return y(N.size) > h ? !1 : r.includes(`${z}`);
    }), g((N) => {
      const z = N.length + 1, q = R.length, J = z + q;
      if (s) {
        let W = [];
        if (J > s) {
          let te = z;
          R.forEach((S) => {
            console.log(te, s), console.log(te > s), !(te > s) && (W.push(S), te++);
          });
        } else
          W = [...R];
        return c && c([...N, ...W]), [...N, ...W];
      }
      return c && c([...N, ...R]), [...N, ...R];
    });
  }, b = (R) => {
    g((N) => (N.splice(R, 1), c && c([...N]), [...N]));
  }, D = (R) => {
    R.preventDefault(), R.stopPropagation(), R.dataTransfer.dropEffect = "copy";
  }, M = (R) => {
    R.preventDefault(), R.stopPropagation(), !a && O(Array.from(R.dataTransfer.files));
  }, j = () => {
    var R;
    (R = v.current) == null || R.click();
  }, P = (R) => {
    a || O(Array.from(R.target.files || []));
  }, H = (R) => R.length <= A ? R : R.slice(0, A) + "...", F = (R) => {
    const N = new Date(R), z = N.getDate(), q = N.getMonth(), J = N.getFullYear(), W = p[q];
    return `${z > 9 ? z : "0" + z} ${W} ${J}`;
  };
  return Ie(() => {
    C.length && g([...C]);
  }, [C]), /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
    /* @__PURE__ */ f.jsxs(
      "div",
      {
        onDragOver: D,
        onDrop: M,
        onClick: j,
        style: {
          border: "2px dashed #e9edf0",
          borderRadius: "4px",
          textAlign: "center",
          margin: "20px",
          cursor: "pointer",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: 150,
          backgroundColor: "#f5f5f5"
        },
        children: [
          /* @__PURE__ */ f.jsxs(
            "p",
            {
              style: {
                color: "#9aa1ab",
                display: "flex",
                flexDirection: "column",
                alignItems: "center"
              },
              children: [
                /* @__PURE__ */ f.jsx(Me, { width: 36, variant: "uploadCLoud" }),
                t,
                /* @__PURE__ */ f.jsx("p", { children: Array.isArray(r) ? r.map((R) => R.toLocaleUpperCase()).join(",") : r.toUpperCase() })
              ]
            }
          ),
          /* @__PURE__ */ f.jsx(
            "input",
            {
              ref: v,
              type: "file",
              disabled: !!a,
              multiple: !!n,
              accept: Array.isArray(r) ? r.map((R) => "." + R).join(",") : `.${r}`,
              onChange: P,
              style: { display: "none" }
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ f.jsx("div", { className: " flex flex-row flex-wrap gap-2 mx-5", children: m.map((R, N) => /* @__PURE__ */ f.jsxs(
      "div",
      {
        className: "flex flex-row items-center",
        style: {
          borderRadius: "4px",
          backgroundColor: "#f5f5f5",
          padding: 8
        },
        children: [
          /* @__PURE__ */ f.jsx(Me, { width: 36, variant: w(R) }),
          /* @__PURE__ */ f.jsxs("div", { className: "flex flex-col", children: [
            /* @__PURE__ */ f.jsx(
              "span",
              {
                style: {
                  fontWeight: "bold",
                  fontSize: 12,
                  paddingLeft: 8
                },
                children: H(R.name)
              }
            ),
            /* @__PURE__ */ f.jsxs(
              "span",
              {
                style: {
                  fontSize: 10,
                  paddingLeft: 8,
                  color: "#9aa1ab"
                },
                children: [
                  y(R.size).toFixed(2),
                  "Mb",
                  " ",
                  F(R.lastModified)
                ]
              }
            )
          ] }),
          /* @__PURE__ */ f.jsx("button", { className: "ml-6", onClick: () => b(N), children: /* @__PURE__ */ f.jsx(
            Me,
            {
              width: 12,
              variant: "trash",
              style: { color: "#f5f5f5" }
            }
          ) })
        ]
      },
      `file_drop${d}-${N}`
    )) })
  ] });
}
function Wye(e) {
  const { columns: t, handleSelected: r, isAll: n, statusColumn: a = !1 } = e, i = !!r;
  return /* @__PURE__ */ f.jsxs("thead", { children: [
    /* @__PURE__ */ f.jsxs("tr", { className: "bg-neutral-200", children: [
      i && /* @__PURE__ */ f.jsx("th", { className: "p-2", children: /* @__PURE__ */ f.jsx(
        p0,
        {
          checked: n,
          onChange: () => {
            r && r("all", null);
          }
        }
      ) }),
      t.map(
        (o) => o.subColumnas ? /* @__PURE__ */ f.jsx(
          "th",
          {
            colSpan: o.subColumnas.length,
            className: "bg-neutral-300 p-4",
            children: o.columna
          },
          o.nombreColumna
        ) : /* @__PURE__ */ f.jsx("th", { className: "p-4", children: o.columna.includes("n/") ? o.columna.split("n/").map((s, c) => /* @__PURE__ */ f.jsx("span", { style: { display: "block" }, children: s }, c)) : o.columna }, o.nombreColumna)
      ),
      !a && /* @__PURE__ */ f.jsx("th", { className: "p-4", children: "ACCIONES" })
    ] }),
    !a && /* @__PURE__ */ f.jsxs("tr", { className: "bg-neutral-200", children: [
      i && /* @__PURE__ */ f.jsx("th", {}),
      t.map(
        (o) => o.subColumnas ? o.subColumnas.map((s) => /* @__PURE__ */ f.jsx("th", { className: "px-4", children: s.columna }, s.nombreColumna)) : /* @__PURE__ */ f.jsx("th", { className: "px-4" }, o.nombreColumna)
      ),
      /* @__PURE__ */ f.jsx("th", {})
    ] })
  ] });
}
function Qye(e) {
  const { columns: t, overrides: r, rows: n, isValidSelected: a } = e, i = (s) => {
    if (!s.sumarColumna)
      return "";
    const c = r == null ? void 0 : r[s.nombreColumna];
    if (c !== void 0)
      return c;
    let d = n.reduce((m, g) => {
      const v = o(g[s.nombreColumna]);
      return m + v;
    }, 0).toFixed(2);
    d = d.toString().replace(/\./g, ",");
    const [h, A] = d.split(","), p = new Intl.NumberFormat("de-DE").format(Number(h.replace(/\D/g, "")));
    return A !== void 0 ? `${p},${A}` : p;
  };
  function o(s) {
    if (s == null)
      return 0;
    if (typeof s == "number")
      return s;
    let c = s.toString().trim();
    return c.includes(".") && c.includes(",") ? c.lastIndexOf(",") > c.lastIndexOf(".") ? c = c.replace(/\./g, "").replace(",", ".") : c = c.replace(/,/g, "") : c.includes(",") ? c = c.replace(",", ".") : c.includes("."), Number(c) || 0;
  }
  return /* @__PURE__ */ f.jsxs("tr", { className: "bg-neutral-200", children: [
    a && /* @__PURE__ */ f.jsx("td", {}),
    t.map(
      (s) => s.subColumnas ? s.subColumnas.map((c) => /* @__PURE__ */ f.jsx(
        "td",
        {
          className: "border-b-2 border-indigo-500 p-2",
          children: c.sumarColumna ? i(c) : ""
        },
        c.nombreColumna
      )) : /* @__PURE__ */ f.jsx(
        "td",
        {
          className: "border-b-2 border-indigo-500 p-2",
          children: s.sumarColumna ? i(s) : ""
        },
        s.nombreColumna
      )
    ),
    /* @__PURE__ */ f.jsx("td", {})
  ] });
}
const rwe = ({
  columns: e,
  rows: t,
  handleChange: r,
  handleBlur: n,
  removeRow: a,
  searchFunctions: i,
  overrides: o,
  handleSelected: s,
  selectedRows: c,
  hiddenTrash: u,
  customLisActions: d,
  statusColumn: h
}) => {
  const A = !!s, [p, m] = De(t);
  Ie(() => {
    m(t);
  }, [t]);
  const [g, v] = De(() => {
    const M = {};
    return t && t.length > 0 && t.forEach((j, P) => {
      M[P] = {}, e.forEach((H) => {
        H.typeAutocomplete && j[H.nombreColumna] && (M[P][H.nombreColumna] = {
          id: j[H.nombreColumna],
          label: String(
            j[`${H.nombreColumna}_desc`] || j[H.nombreColumna]
          )
        });
      });
    }), M;
  });
  Ie(() => {
    v((M) => {
      let j = !1;
      const P = { ...M };
      return t.forEach((H, F) => {
        e.forEach((R) => {
          var q;
          if (!R.typeAutocomplete)
            return;
          const N = H[R.nombreColumna];
          if (!N)
            return;
          const z = (q = P[F]) == null ? void 0 : q[R.nombreColumna];
          (z == null ? void 0 : z.id) !== N && (P[F] = {
            ...P[F],
            [R.nombreColumna]: {
              id: N,
              label: String(
                H[`${R.nombreColumna}_desc`] || N
              )
            }
          }, j = !0);
        });
      }), j ? P : M;
    });
  }, [t, e]);
  const [C, y] = De({}), w = async (M, j, P, H) => {
    var R;
    const F = (R = e.find(
      (N) => N.nombreColumna === P
    )) == null ? void 0 : R.typeAutocomplete;
    if (F && i[F]) {
      if (M.trim() === "") {
        y((z) => ({
          ...z,
          [j]: {
            ...z[j],
            [P]: []
          }
        })), H();
        return;
      }
      const N = await i[F](M);
      y((z) => ({
        ...z,
        [j]: {
          ...z[j],
          [P]: N
        }
      }));
    }
    H();
  }, O = (M, j, P) => {
    v((H) => ({
      ...H,
      [M]: {
        ...H[M],
        [j]: { id: P.id, label: P.label }
      }
    })), r(M, j, P.id, P.label);
  }, b = (M, j) => {
    e.forEach((P) => {
      P.typeAutocomplete && D(M, P.nombreColumna), P.subColumnas && P.subColumnas.forEach((H) => {
        H.typeAutocomplete && D(M, H.nombreColumna);
      });
    }), v((P) => {
      const H = { ...P };
      delete H[M];
      const F = {};
      return Object.keys(H).forEach((R) => {
        const N = Number(R);
        N > M ? F[N - 1] = H[N] : F[N] = H[N];
      }), F;
    }), a(M, j);
  }, D = (M, j) => {
    v((P) => ({
      ...P,
      [M]: {
        ...P[M],
        [j]: null
      }
    })), r(M, j, "");
  };
  return /* @__PURE__ */ f.jsx("div", { className: "relative w-full overflow-x-auto", children: /* @__PURE__ */ f.jsxs(
    "table",
    {
      className: "table w-full border-collapse my-6",
      style: {
        borderRadius: "10px"
      },
      children: [
        /* @__PURE__ */ f.jsx(
          Wye,
          {
            columns: e,
            handleSelected: s,
            isAll: ((c == null ? void 0 : c.length) ?? 0) >= ((t == null ? void 0 : t.length) ?? 0),
            statusColumn: h
          }
        ),
        /* @__PURE__ */ f.jsxs("tbody", { className: "text-center", children: [
          p.map((M, j) => /* @__PURE__ */ f.jsxs("tr", { children: [
            A && /* @__PURE__ */ f.jsx("td", { className: "p-2", children: /* @__PURE__ */ f.jsx(
              p0,
              {
                checked: c == null ? void 0 : c.includes(j),
                onChange: () => {
                  s && s(j, M);
                }
              }
            ) }),
            e.map(
              (P) => {
                var H, F, R;
                return P.subColumnas ? P.subColumnas.map((N) => {
                  var z, q, J;
                  return /* @__PURE__ */ f.jsx(
                    "td",
                    {
                      className: "border-b border-indigo-500 py-2",
                      children: N.onlyString ? M[P.nombreColumna] || "" : N.typeinput ? /* @__PURE__ */ f.jsx(
                        zn,
                        {
                          type: "number",
                          variant: "white",
                          value: M[N.nombreColumna] || "",
                          onChange: (W) => r(
                            j,
                            N.nombreColumna,
                            W.target.value
                          ),
                          onBlur: (W) => n(W.target.value, j, N),
                          readOnly: N.typeDisable,
                          required: N.typeRequired,
                          style: N.typeNumberRight ? { textAlign: "right" } : N.typeNumberCenter ? { textAlign: "center" } : {}
                        }
                      ) : N.typeSelect ? /* @__PURE__ */ f.jsx(
                        "select",
                        {
                          className: "bg-white rounded-md p-4 pointer-events-auto",
                          value: M[N.nombreColumna] || N.defaultValue || "",
                          disabled: !!N.typeDisable,
                          onChange: (W) => {
                            const te = W.target.options[W.target.selectedIndex].text;
                            r(
                              j,
                              N.nombreColumna,
                              W.target.value,
                              te
                            );
                          },
                          onBlur: (W) => n(W.target.value, j, N),
                          required: N.typeRequired,
                          children: N.typeSelect.map((W) => /* @__PURE__ */ f.jsx("option", { value: W.value, children: W.text }, W.value))
                        }
                      ) : N.typeAutocomplete ? /* @__PURE__ */ f.jsx(
                        "div",
                        {
                          className: "z-50 top-[calc(100%+4px)] left-0 w-full pointer-events-auto min-w-[200px]",
                          children: /* @__PURE__ */ f.jsx(
                            N4,
                            {
                              variant: "white",
                              selected: ((q = (z = g[j]) == null ? void 0 : z[N.nombreColumna]) == null ? void 0 : q.label) || null,
                              placeholder: "Buscar...",
                              textLoading: "Cargando...",
                              textNoResults: "No hay resultados",
                              minLengthToSearch: 2,
                              searchResults: ((J = C[j]) == null ? void 0 : J[N.nombreColumna]) || [],
                              onChangeSearch: (W, te) => w(
                                W,
                                j,
                                N.nombreColumna,
                                te
                              ),
                              onItemClick: (W) => O(
                                j,
                                N.nombreColumna,
                                W.item
                              ),
                              onResetSelected: () => D(
                                j,
                                N.nombreColumna
                              )
                            }
                          )
                        }
                      ) : N.typetext ? /* @__PURE__ */ f.jsx(
                        zn,
                        {
                          variant: "white",
                          type: "text",
                          placeholder: "Diligenciar",
                          value: M[N.nombreColumna] || "",
                          onChange: (W) => r(
                            j,
                            N.nombreColumna,
                            W.target.value
                          ),
                          onBlur: (W) => n(W.target.value, j, N),
                          readOnly: N.typeDisable,
                          required: N.typeRequired
                        }
                      ) : N.typeDate ? /* @__PURE__ */ f.jsx(
                        zn,
                        {
                          variant: "white",
                          type: "date",
                          value: M[N.nombreColumna] || "",
                          onChange: (W) => r(
                            j,
                            N.nombreColumna,
                            W.target.value
                          ),
                          onBlur: (W) => n(W.target.value, j, N),
                          readOnly: N.typeDisable,
                          required: N.typeRequired
                        }
                      ) : /* @__PURE__ */ f.jsx("td", {})
                    },
                    N.nombreColumna
                  );
                }) : /* @__PURE__ */ f.jsx(
                  "td",
                  {
                    className: "border-b border-indigo-500 py-2",
                    children: P.onlyString ? M[P.nombreColumna] || "" : P.typeinput ? /* @__PURE__ */ f.jsx(
                      zn,
                      {
                        type: "number",
                        variant: "white",
                        value: M[P.nombreColumna] || "",
                        readOnly: P.typeDisable,
                        onChange: (N) => r(
                          j,
                          P.nombreColumna,
                          N.target.value
                        ),
                        onBlur: (N) => n(N.target.value, j, P),
                        required: P.typeRequired,
                        style: P.typeNumberRight ? { textAlign: "right" } : P.typeNumberCenter ? { textAlign: "center" } : {}
                      }
                    ) : P.typeSelect ? /* @__PURE__ */ f.jsxs(
                      "select",
                      {
                        className: "bg-white rounded-md p-2 pointer-events-auto  border",
                        value: M[P.nombreColumna] || P.defaultValue || "",
                        disabled: !!P.typeDisable,
                        onChange: (N) => {
                          const z = N.target.options[N.target.selectedIndex].text;
                          r(
                            j,
                            P.nombreColumna,
                            N.target.value,
                            z
                          );
                        },
                        required: P.typeRequired,
                        children: [
                          /* @__PURE__ */ f.jsx("option", { value: "", children: "Seleccione" }),
                          P.typeSelect.map((N) => /* @__PURE__ */ f.jsx("option", { value: N.value, children: N.text }, N.value))
                        ]
                      }
                    ) : P.typeAutocomplete ? /* @__PURE__ */ f.jsx(
                      "div",
                      {
                        className: "z-50 top-[calc(100%+4px)] left-0 w-full pointer-events-auto min-w-[200px]",
                        children: /* @__PURE__ */ f.jsx(
                          N4,
                          {
                            variant: "white",
                            selected: ((F = (H = g[j]) == null ? void 0 : H[P.nombreColumna]) == null ? void 0 : F.label) || null,
                            placeholder: "Buscar...",
                            textLoading: "Cargando...",
                            textNoResults: "No hay resultados",
                            minLengthToSearch: 2,
                            searchResults: ((R = C[j]) == null ? void 0 : R[P.nombreColumna]) || [],
                            onChangeSearch: (N, z) => w(
                              N,
                              j,
                              P.nombreColumna,
                              z
                            ),
                            onItemClick: (N) => O(
                              j,
                              P.nombreColumna,
                              N.item
                            ),
                            onResetSelected: () => D(j, P.nombreColumna)
                          }
                        )
                      }
                    ) : P.typetext ? /* @__PURE__ */ f.jsx(
                      zn,
                      {
                        variant: "white",
                        type: "text",
                        placeholder: "Diligenciar",
                        value: M[P.nombreColumna] || "",
                        readOnly: P.typeDisable,
                        onChange: (N) => r(
                          j,
                          P.nombreColumna,
                          N.target.value
                        ),
                        onBlur: (N) => n(N.target.value, j, P),
                        required: P.typeRequired
                      }
                    ) : P.typeDate ? /* @__PURE__ */ f.jsx(
                      zn,
                      {
                        variant: "white",
                        type: "date",
                        placeholder: "Diligenciar",
                        value: M[P.nombreColumna] || "",
                        readOnly: P.typeDisable,
                        onChange: (N) => r(
                          j,
                          P.nombreColumna,
                          N.target.value
                        ),
                        onBlur: (N) => n(N.target.value, j, P),
                        required: P.typeRequired
                      }
                    ) : /* @__PURE__ */ f.jsx("td", {})
                  },
                  P.nombreColumna
                );
              }
            ),
            !h && /* @__PURE__ */ f.jsxs("td", { children: [
              !u && /* @__PURE__ */ f.jsx(
                "button",
                {
                  onClick: (P) => {
                    P.preventDefault(), b(j, M);
                  },
                  children: /* @__PURE__ */ f.jsx(Me, { variant: "trash", width: 20, color: "Acento-400" })
                }
              ),
              /* @__PURE__ */ f.jsx("div", { className: "flex gap-2 justify-center items-center", children: d && d.listButtons.map((P) => {
                const H = Object.keys(P);
                let F = !1;
                return H.includes("condition") && typeof P.condition == "function" && (F = !!P.condition(M, j)), F ? null : /* @__PURE__ */ f.jsx(
                  "button",
                  {
                    onClick: (R) => {
                      R.preventDefault(), d.handle(P.action, j, M);
                    },
                    children: /* @__PURE__ */ f.jsx(
                      Me,
                      {
                        variant: P.icon || "trash",
                        width: 20,
                        color: P.color
                      }
                    )
                  },
                  P.action
                );
              }) })
            ] })
          ] }, M.id || j)),
          /* @__PURE__ */ f.jsx(
            Qye,
            {
              columns: e,
              overrides: o,
              rows: t,
              isValidSelected: A
            }
          )
        ] })
      ]
    }
  ) });
};
const Uye = [
  "¿Cómo genero un informe de ventas?",
  "¿Qué es el módulo GAN?",
  "¿Cómo registro una operación?"
], nwe = ({
  apiEndpoint: e = "/api/castor-ai/chat",
  title: t = "Asistente CASTOR",
  subtitle: r = "En línea",
  primaryColor: n = "#1a5276",
  accentColor: a = "#F39C12",
  welcomeMessage: i = "¡Hola! Soy tu asistente de CASTOR. Puedo ayudarte con informes, operaciones, ventas y más. ¿En qué te puedo ayudar?",
  suggestions: o = Uye,
  csrfToken: s = ""
}) => {
  const [c, u] = De(!0), [d, h] = De(""), [A, p] = De([]), [m, g] = De(!1), [v, C] = De(!0), y = ge(null), w = ge(null);
  Ie(() => {
    var D;
    (D = y.current) == null || D.scrollIntoView({ behavior: "smooth" });
  }, [A, m]), Ie(() => {
    var D;
    c && ((D = w.current) == null || D.focus());
  }, [c]);
  const O = async (D) => {
    if (!D.trim() || m)
      return;
    const M = { role: "user", content: D.trim() }, j = [...A, M];
    p(j), h(""), C(!1), g(!0);
    try {
      const H = await (await fetch(e, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          ...s ? { "X-CSRF-TOKEN": s } : {}
        },
        body: JSON.stringify({ messages: j })
      })).json(), F = H.error || H.reply || "Sin respuesta.";
      p((R) => [...R, { role: "assistant", content: F }]);
    } catch {
      p((P) => [
        ...P,
        { role: "assistant", content: "Error de conexión. Intenta de nuevo." }
      ]);
    } finally {
      g(!1);
    }
  }, b = (D) => {
    D.key === "Enter" && O(d);
  };
  return /* @__PURE__ */ f.jsxs("div", { className: "cai-root", children: [
    c && /* @__PURE__ */ f.jsxs("div", { className: "cai-window", style: { "--cai-primary": n, "--cai-accent": a }, children: [
      /* @__PURE__ */ f.jsxs("div", { className: "cai-header", children: [
        /* @__PURE__ */ f.jsxs("div", { className: "cai-header-left", children: [
          /* @__PURE__ */ f.jsx("div", { className: "cai-avatar", children: "IA" }),
          /* @__PURE__ */ f.jsxs("div", { children: [
            /* @__PURE__ */ f.jsx("div", { className: "cai-title", children: t }),
            /* @__PURE__ */ f.jsxs("div", { className: "cai-subtitle", children: [
              /* @__PURE__ */ f.jsx("span", { className: "cai-status-dot" }),
              r
            ] })
          ] })
        ] }),
        /* @__PURE__ */ f.jsx("button", { className: "cai-close", onClick: () => u(!1), "aria-label": "Cerrar chat", children: "✕" })
      ] }),
      /* @__PURE__ */ f.jsxs("div", { className: "cai-messages", children: [
        /* @__PURE__ */ f.jsx("div", { className: "cai-msg cai-msg--bot", children: i }),
        A.map((D, M) => /* @__PURE__ */ f.jsx("div", { className: `cai-msg cai-msg--${D.role === "user" ? "user" : "bot"}`, children: D.content }, M)),
        m && /* @__PURE__ */ f.jsxs("div", { className: "cai-msg cai-msg--bot cai-thinking", children: [
          /* @__PURE__ */ f.jsx("span", { className: "cai-dot" }),
          /* @__PURE__ */ f.jsx("span", { className: "cai-dot" }),
          /* @__PURE__ */ f.jsx("span", { className: "cai-dot" })
        ] }),
        /* @__PURE__ */ f.jsx("div", { ref: y })
      ] }),
      v && o.length > 0 && /* @__PURE__ */ f.jsx("div", { className: "cai-chips", children: o.map((D, M) => /* @__PURE__ */ f.jsx("button", { className: "cai-chip", onClick: () => O(D), children: D }, M)) }),
      /* @__PURE__ */ f.jsxs("div", { className: "cai-input-area", children: [
        /* @__PURE__ */ f.jsx(
          "input",
          {
            ref: w,
            className: "cai-input",
            type: "text",
            placeholder: "Escribe tu pregunta...",
            value: d,
            onChange: (D) => h(D.target.value),
            onKeyDown: b,
            disabled: m
          }
        ),
        /* @__PURE__ */ f.jsx(
          "button",
          {
            className: "cai-send",
            onClick: () => O(d),
            disabled: m || !d.trim(),
            "aria-label": "Enviar",
            children: "➤"
          }
        )
      ] })
    ] }),
    /* @__PURE__ */ f.jsxs("div", { className: "cai-fab-wrapper", children: [
      !c && /* @__PURE__ */ f.jsx("span", { className: "cai-label", onClick: () => u(!0), children: "¿Necesitas ayuda?" }),
      /* @__PURE__ */ f.jsx(
        "button",
        {
          className: "cai-fab",
          onClick: () => u((D) => !D),
          "aria-label": c ? "Cerrar asistente" : "Abrir asistente",
          style: { background: a },
          children: c ? "✕" : "💬"
        }
      )
    ] })
  ] });
};
export {
  N4 as Autocomplete,
  Qa as Avatar,
  C$ as Body,
  uP as Box,
  fP as BoxStatus,
  dP as Breadcrumb,
  Qr as Button,
  y$ as Cards,
  nwe as CastorAIWidget,
  pC as CastorLogo,
  p0 as Checkbox,
  Me as CodeIcon,
  Hye as ComposedChart,
  tI as Dashboard,
  rI as DashboardMain,
  a1 as Description,
  Gye as Divider,
  twe as DropInputFile,
  hC as Dropdown,
  B4 as DropdownAction,
  aI as ExportTable,
  iI as ExportTableCol,
  cI as FieldError,
  q3 as Flexbox,
  lI as FlexboxRow,
  $ye as GraphicContainer,
  wI as HeaderBoxLeft,
  xI as HeaderBoxRight,
  OI as HeaderNotificationItem,
  DI as HeaderNotifications,
  MI as HeaderOldButton,
  EI as HeaderSearch,
  PI as HeaderUser,
  jI as HeaderUserItem,
  SI as HeaderWrapper,
  Vi as Heading,
  Yye as HorizontalChart,
  zn as Input,
  CI as InputMask,
  uI as Label,
  NI as MapLogo,
  FR as MenuItems,
  HR as MenuWrapper,
  YR as Modal,
  VR as ModalBody,
  kR as ModalFocus,
  QR as ModalFocusContainer,
  WR as ModalFooter,
  GR as ModalHeader,
  Ace as PieCharts,
  kye as PieChartsTable,
  fI as Radio,
  dI as Select,
  Jye as SelectFilter,
  Xye as SelectMult,
  Fye as SemiPieChart,
  Vye as SimpleBarChart,
  UR as Spreen,
  ZR as SpreenBody,
  zR as SpreenFooter,
  XR as SpreenHeader,
  KR as SpreenLeft,
  qR as SpreenRight,
  i9 as Stack,
  JR as StackRow,
  rwe as TableBasic,
  e$ as TableEmpty,
  t$ as TableFooter,
  n$ as TableHeader,
  a$ as TableLoader,
  f$ as TableMain,
  d$ as TablePagination,
  h$ as TableShowPages,
  b$ as TextOther,
  bI as Textarea,
  kr as Title,
  m$ as Toast,
  qye as closeDropdown,
  ewe as shootToast
};
